/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_config_1 = __webpack_require__(1);
	var index_route_1 = __webpack_require__(2);
	var index_run_1 = __webpack_require__(3);
	var pusher_provider_1 = __webpack_require__(4);
	var fsTemples_constant_1 = __webpack_require__(5);
	var autocomplete_decorator_1 = __webpack_require__(6);
	var acceptInvitation_controller_1 = __webpack_require__(7);
	var apps_controller_1 = __webpack_require__(8);
	var confirmEmail_controller_1 = __webpack_require__(9);
	var create_controller_1 = __webpack_require__(10);
	var dnaProfiles_controller_1 = __webpack_require__(11);
	var dnaProfile_controller_1 = __webpack_require__(12);
	var evidences_controller_1 = __webpack_require__(13);
	var exports_controller_1 = __webpack_require__(14);
	var feed_controller_1 = __webpack_require__(15);
	var forumLogin_controller_1 = __webpack_require__(16);
	var fsRedirect_controller_1 = __webpack_require__(17);
	var fsSync_controller_1 = __webpack_require__(18);
	var graph_controller_1 = __webpack_require__(19);
	var hintSettings_controller_1 = __webpack_require__(20);
	var home_controller_1 = __webpack_require__(21);
	var homeSignedIn_controller_1 = __webpack_require__(22);
	var importFs_controller_1 = __webpack_require__(23);
	var importGedcom_controller_1 = __webpack_require__(24);
	var importScratch_controller_1 = __webpack_require__(25);
	var leads_controller_1 = __webpack_require__(26);
	var matches_controller_1 = __webpack_require__(27);
	var medias_controller_1 = __webpack_require__(28);
	var merge_controller_1 = __webpack_require__(29);
	var notes_controller_1 = __webpack_require__(30);
	var partnerHome_controller_1 = __webpack_require__(31);
	var people_controller_1 = __webpack_require__(32);
	var person_controller_1 = __webpack_require__(33);
	var register_controller_1 = __webpack_require__(34);
	var reports_controller_1 = __webpack_require__(36);
	var setPassword_controller_1 = __webpack_require__(37);
	var sources_controller_1 = __webpack_require__(38);
	var static_controller_1 = __webpack_require__(39);
	var stories_controller_1 = __webpack_require__(40);
	var researchLogs_controller_1 = __webpack_require__(41);
	var researchLog_controller_1 = __webpack_require__(42);
	var tree_controller_1 = __webpack_require__(43);
	var treeGraphics_controller_1 = __webpack_require__(44);
	var treeSettings_controller_1 = __webpack_require__(45);
	var user_controller_1 = __webpack_require__(46);
	var users_controller_1 = __webpack_require__(47);
	var userSettings_controller_1 = __webpack_require__(48);
	var video_controller_1 = __webpack_require__(49);
	var warnings_controller_1 = __webpack_require__(50);
	var addBookmark_controller_1 = __webpack_require__(51);
	var addPerson_controller_1 = __webpack_require__(52);
	var addInvitation_controller_1 = __webpack_require__(53);
	var clipperToast_controller_1 = __webpack_require__(54);
	var deleteMedia_controller_1 = __webpack_require__(55);
	var deletePerson_controller_1 = __webpack_require__(56);
	var deleteSource_controller_1 = __webpack_require__(57);
	var dnaFilter_controller_1 = __webpack_require__(58);
	var dnaImportFilter_controller_1 = __webpack_require__(59);
	var editDNAKit_controller_1 = __webpack_require__(60);
	var editDNAMatches_controller_1 = __webpack_require__(61);
	var editDNAProfile_controller_1 = __webpack_require__(62);
	var editEvidence_controller_1 = __webpack_require__(63);
	var editLead_controller_1 = __webpack_require__(64);
	var editMedia_controller_1 = __webpack_require__(65);
	var editNote_controller_1 = __webpack_require__(66);
	var editOrdinance_controller_1 = __webpack_require__(67);
	var editParentRels_controller_1 = __webpack_require__(68);
	var editPerson_controller_1 = __webpack_require__(69);
	var editResearchLog_controller_1 = __webpack_require__(70);
	var editRights_controller_1 = __webpack_require__(71);
	var editSource_controller_1 = __webpack_require__(72);
	var editStory_controller_1 = __webpack_require__(73);
	var editTags_controller_1 = __webpack_require__(74);
	var facebook_controller_1 = __webpack_require__(75);
	var forgotPassword_controller_1 = __webpack_require__(76);
	var fsAddSource_controller_1 = __webpack_require__(77);
	var fsCompareLink_controller_1 = __webpack_require__(78);
	var fsLink_controller_1 = __webpack_require__(79);
	var fsLogin_controller_1 = __webpack_require__(80);
	var fsMatch_controller_1 = __webpack_require__(81);
	var fsPrompt_controller_1 = __webpack_require__(82);
	var gedmatch_controller_1 = __webpack_require__(83);
	var hintsToast_controller_1 = __webpack_require__(84);
	var listModal_controller_1 = __webpack_require__(85);
	var loadSaveFilters_controller_1 = __webpack_require__(86);
	var media_controller_1 = __webpack_require__(87);
	var merge_controller_2 = __webpack_require__(88);
	var nestedList_controller_1 = __webpack_require__(89);
	var notification_controller_1 = __webpack_require__(90);
	var relatives_controller_1 = __webpack_require__(91);
	var selectFamilyMembers_controller_1 = __webpack_require__(92);
	var selectMedia_controller_1 = __webpack_require__(93);
	var selectNamesFacts_controller_1 = __webpack_require__(94);
	var selectPerson_controller_1 = __webpack_require__(95);
	var selectSubLength_controller_1 = __webpack_require__(96);
	var selectTree_controller_1 = __webpack_require__(97);
	var signIn_controller_1 = __webpack_require__(98);
	var treeGraphic_controller_1 = __webpack_require__(100);
	var updateProfiles_controller_1 = __webpack_require__(101);
	var videoPreview_controller_1 = __webpack_require__(102);
	var voiceover_controller_1 = __webpack_require__(103);
	var ancestorsDescendants_directive_1 = __webpack_require__(104);
	var change_directive_1 = __webpack_require__(105);
	var createdEdited_directive_1 = __webpack_require__(106);
	var chromosome_directive_1 = __webpack_require__(107);
	var force_directive_1 = __webpack_require__(108);
	var heb_directive_1 = __webpack_require__(109);
	var sankey_directive_1 = __webpack_require__(110);
	var dagD3_directive_1 = __webpack_require__(111);
	var dag_directive_1 = __webpack_require__(112);
	var descendancy_directive_1 = __webpack_require__(113);
	var descendancyD3_directive_1 = __webpack_require__(114);
	var dnaCompare_directive_1 = __webpack_require__(115);
	var dnaKit_directive_1 = __webpack_require__(116);
	var dnaKits_directive_1 = __webpack_require__(117);
	var dnaProfileForce_directive_1 = __webpack_require__(118);
	var dnaProfileHeb_directive_1 = __webpack_require__(119);
	var dnaProfileList_directive_1 = __webpack_require__(120);
	var dnaProfileSankey_directive_1 = __webpack_require__(121);
	var dnaProfileToolbar_directive_1 = __webpack_require__(122);
	var drag_directive_1 = __webpack_require__(123);
	var evidence_directive_1 = __webpack_require__(124);
	var fact_directive_1 = __webpack_require__(125);
	var family_directive_1 = __webpack_require__(126);
	var fractal_directive_1 = __webpack_require__(127);
	var fsCopy_directive_1 = __webpack_require__(128);
	var invitation_directive_1 = __webpack_require__(129);
	var jsTree_directive_1 = __webpack_require__(130);
	var lead_directive_1 = __webpack_require__(131);
	var leaflet_directive_1 = __webpack_require__(132);
	var likesComments_directive_1 = __webpack_require__(133);
	var list_directive_1 = __webpack_require__(134);
	var match_directive_1 = __webpack_require__(135);
	var media_directive_1 = __webpack_require__(136);
	var message_directive_1 = __webpack_require__(137);
	var minitree_directive_1 = __webpack_require__(138);
	var name_directive_1 = __webpack_require__(139);
	var note_directive_1 = __webpack_require__(140);
	var ordinance_directive_1 = __webpack_require__(141);
	var panzoom_directive_1 = __webpack_require__(142);
	var paste_directive_1 = __webpack_require__(143);
	var pedigree_directive_1 = __webpack_require__(144);
	var pedigreeFragment_directive_1 = __webpack_require__(145);
	var personLandscape_directive_1 = __webpack_require__(146);
	var personPortrait_directive_1 = __webpack_require__(147);
	var researchLog_directive_1 = __webpack_require__(148);
	var scrollable_directive_1 = __webpack_require__(149);
	var scrollGet_directive_1 = __webpack_require__(150);
	var scrollSetLeft_directive_1 = __webpack_require__(151);
	var setFocus_directive_1 = __webpack_require__(152);
	var sidenav_directive_1 = __webpack_require__(153);
	var source_directive_1 = __webpack_require__(154);
	var story_directive_1 = __webpack_require__(155);
	var sunburstAncestors_directive_1 = __webpack_require__(156);
	var sunburstDescendants_directive_1 = __webpack_require__(157);
	var sunburstD3_directive_1 = __webpack_require__(158);
	var treeGraphic_directive_1 = __webpack_require__(159);
	var toolbar_directive_1 = __webpack_require__(160);
	var transclude_directive_1 = __webpack_require__(161);
	var tree_directive_1 = __webpack_require__(162);
	var user_directive_1 = __webpack_require__(163);
	var username_directive_1 = __webpack_require__(164);
	var userActivity_directive_1 = __webpack_require__(165);
	var warning_directive_1 = __webpack_require__(166);
	var csv_factory_1 = __webpack_require__(167);
	var d3_factory_1 = __webpack_require__(168);
	// import DocxtemplaterFactory from './components/docxtemplater/docxtemplater.factory';
	var hammer_factory_1 = __webpack_require__(169);
	var jspdf_factory_1 = __webpack_require__(170);
	var jszip_factory_1 = __webpack_require__(171);
	var jszipUtils_factory_1 = __webpack_require__(172);
	var leaflet_factory_1 = __webpack_require__(173);
	var mediaStreamRecorder_factory_1 = __webpack_require__(174);
	var partnerToken_factory_1 = __webpack_require__(175);
	// import RecurlyFactory from './components/recurly/recurly.factory';
	var rx_factory_1 = __webpack_require__(176);
	var translate_factory_1 = __webpack_require__(177);
	var unibabel_factory_1 = __webpack_require__(178);
	var authentication_service_1 = __webpack_require__(179);
	var authToken_service_1 = __webpack_require__(181);
	var blog_service_1 = __webpack_require__(183);
	var bookmarks_service_1 = __webpack_require__(185);
	var cache_service_1 = __webpack_require__(186);
	var changes_service_1 = __webpack_require__(187);
	var cluster_service_1 = __webpack_require__(189);
	var comments_service_1 = __webpack_require__(190);
	var currentTree_service_1 = __webpack_require__(192);
	var currentTreeId_service_1 = __webpack_require__(194);
	var currentUser_service_1 = __webpack_require__(196);
	var currentUserId_service_1 = __webpack_require__(198);
	var d3worker_service_1 = __webpack_require__(200);
	var dates_service_1 = __webpack_require__(201);
	var dnaKits_service_1 = __webpack_require__(203);
	var dnaParsers_service_1 = __webpack_require__(204);
	var dnaProfiles_service_1 = __webpack_require__(205);
	var dnaProfileDatas_service_1 = __webpack_require__(206);
	// import DocxParserService from './components/docxReports/parser.service';
	// import DocxAncestorsService from './components/docxReports/ancestors.service';
	// import DocxSimpleRegisterService from './components/docxReports/simpleRegister.service';
	var easing_service_1 = __webpack_require__(207);
	var endNotes_service_1 = __webpack_require__(209);
	var evidences_service_1 = __webpack_require__(210);
	var evidenceUtils_service_1 = __webpack_require__(212);
	var families_service_1 = __webpack_require__(214);
	var familyUtils_service_1 = __webpack_require__(216);
	var feed_service_1 = __webpack_require__(218);
	var fs_service_1 = __webpack_require__(220);
	var fsImport_service_1 = __webpack_require__(222);
	var httpClient_service_1 = __webpack_require__(223);
	var indexOfNames_service_1 = __webpack_require__(224);
	var indexOfPlaces_service_1 = __webpack_require__(225);
	var invitations_service_1 = __webpack_require__(226);
	var leads_service_1 = __webpack_require__(228);
	var leadGenerators_service_1 = __webpack_require__(230);
	var likes_service_1 = __webpack_require__(232);
	var medias_service_1 = __webpack_require__(234);
	var mediaUtils_service_1 = __webpack_require__(236);
	var messageBus_service_1 = __webpack_require__(238);
	var mousewheel_service_1 = __webpack_require__(240);
	var musics_service_1 = __webpack_require__(241);
	var notes_service_1 = __webpack_require__(243);
	var notifications_service_1 = __webpack_require__(245);
	var ordinances_service_1 = __webpack_require__(247);
	var persons_service_1 = __webpack_require__(248);
	var personUtils_service_1 = __webpack_require__(250);
	var places_service_1 = __webpack_require__(252);
	var relationshipUtils_service_1 = __webpack_require__(254);
	var pedigree_service_1 = __webpack_require__(255);
	var ahnentafel_service_1 = __webpack_require__(256);
	var evidenceAnalysis_service_1 = __webpack_require__(257);
	var endOfLine_service_1 = __webpack_require__(258);
	var familyGroup_service_1 = __webpack_require__(259);
	var placeList_service_1 = __webpack_require__(260);
	var fan_service_1 = __webpack_require__(261);
	var researchLinks_service_1 = __webpack_require__(262);
	var researchLogs_service_1 = __webpack_require__(264);
	var rights_service_1 = __webpack_require__(266);
	var rightsFull_service_1 = __webpack_require__(268);
	var searchHints_service_1 = __webpack_require__(270);
	var segment_service_1 = __webpack_require__(272);
	var server_service_1 = __webpack_require__(274);
	var showAds_service_1 = __webpack_require__(276);
	var sidenav_service_1 = __webpack_require__(278);
	var social_service_1 = __webpack_require__(279);
	var sources_service_1 = __webpack_require__(281);
	var store_service_1 = __webpack_require__(283);
	var stories_service_1 = __webpack_require__(285);
	var subscriptions_service_1 = __webpack_require__(287);
	var treeGraphics_service_1 = __webpack_require__(289);
	var treeUsers_service_1 = __webpack_require__(290);
	var users_service_1 = __webpack_require__(292);
	var utils_service_1 = __webpack_require__(294);
	//import UiUtilsService from './components/utils/uiUtils.service';
	var warnings_service_1 = __webpack_require__(296);
	var toArray_filter_1 = __webpack_require__(298);
	var presentationMode_filter_1 = __webpack_require__(299);
	angular.module('client', ['ngAnimate', 'ngCookies', 'ngSanitize', 'ui.router', 'ngMaterial', 'ngMessages', 'froala', 'ngFileUpload', 'ngImgCrop', 'pascalprecht.translate',
	    'pusher-angular', 'LocalStorageModule', 'angularGrid', 'validation.match', 'dndLists', 'angularMoment', 'ngRaven'])
	    .provider('pusher', pusher_provider_1.default)
	    .config(index_config_1.default)
	    .config(index_route_1.default)
	    .run(index_run_1.default)
	    .constant('fsTemples', fsTemples_constant_1.default)
	    .decorator('mdAutocompleteDirective', autocomplete_decorator_1.default)
	    .controller('AcceptInvitationController', acceptInvitation_controller_1.default)
	    .controller('AppsController', apps_controller_1.default)
	    .controller('ConfirmEmailController', confirmEmail_controller_1.default)
	    .controller('CreateController', create_controller_1.default)
	    .controller('DNAProfilesController', dnaProfiles_controller_1.default)
	    .controller('DNAProfileController', dnaProfile_controller_1.default)
	    .controller('EvidencesController', evidences_controller_1.default)
	    .controller('ExportsController', exports_controller_1.default)
	    .controller('FeedController', feed_controller_1.default)
	    .controller('ForumLoginController', forumLogin_controller_1.default)
	    .controller('FsRedirectController', fsRedirect_controller_1.default)
	    .controller('FsSyncController', fsSync_controller_1.default)
	    .controller('GraphController', graph_controller_1.default)
	    .controller('HintSettingsController', hintSettings_controller_1.default)
	    .controller('HomeController', home_controller_1.default)
	    .controller('HomeSignedInController', homeSignedIn_controller_1.default)
	    .controller('ImportFsController', importFs_controller_1.default)
	    .controller('ImportGedcomController', importGedcom_controller_1.default)
	    .controller('ImportScratchController', importScratch_controller_1.default)
	    .controller('LeadsController', leads_controller_1.default)
	    .controller('MatchesController', matches_controller_1.default)
	    .controller('MediasController', medias_controller_1.default)
	    .controller('MergeController', merge_controller_1.default)
	    .controller('NotesController', notes_controller_1.default)
	    .controller('PartnerHomeController', partnerHome_controller_1.default)
	    .controller('PeopleController', people_controller_1.default)
	    .controller('PersonController', person_controller_1.default)
	    .controller('RegisterController', register_controller_1.default)
	    .controller('ReportsController', reports_controller_1.default)
	    .controller('ResearchLogsController', researchLogs_controller_1.default)
	    .controller('ResearchLogController', researchLog_controller_1.default)
	    .controller('SetPasswordController', setPassword_controller_1.default)
	    .controller('SourcesController', sources_controller_1.default)
	    .controller('StaticController', static_controller_1.default)
	    .controller('StoriesController', stories_controller_1.default)
	    .controller('TreeController', tree_controller_1.default)
	    .controller('TreeGraphicsController', treeGraphics_controller_1.default)
	    .controller('TreeSettingsController', treeSettings_controller_1.default)
	    .controller('UserController', user_controller_1.default)
	    .controller('UsersController', users_controller_1.default)
	    .controller('UserSettingsController', userSettings_controller_1.default)
	    .controller('VideoController', video_controller_1.default)
	    .controller('WarningsController', warnings_controller_1.default)
	    .controller('AddBookmarkController', addBookmark_controller_1.default)
	    .controller('AddPersonController', addPerson_controller_1.default)
	    .controller('AddInvitationController', addInvitation_controller_1.default)
	    .controller('ClipperToastController', clipperToast_controller_1.default)
	    .controller('DeleteMediaController', deleteMedia_controller_1.default)
	    .controller('DeletePersonController', deletePerson_controller_1.default)
	    .controller('DeleteSourceController', deleteSource_controller_1.default)
	    .controller('DNAFilterController', dnaFilter_controller_1.default)
	    .controller('DNAImportFilterController', dnaImportFilter_controller_1.default)
	    .controller('EditDNAKitController', editDNAKit_controller_1.default)
	    .controller('EditDNAMatchesController', editDNAMatches_controller_1.default)
	    .controller('EditDNAProfileController', editDNAProfile_controller_1.default)
	    .controller('EditEvidenceController', editEvidence_controller_1.default)
	    .controller('EditLeadController', editLead_controller_1.default)
	    .controller('EditMediaController', editMedia_controller_1.default)
	    .controller('EditNoteController', editNote_controller_1.default)
	    .controller('EditOrdinanceController', editOrdinance_controller_1.default)
	    .controller('EditParentRelsController', editParentRels_controller_1.default)
	    .controller('EditPersonController', editPerson_controller_1.default)
	    .controller('EditSourceController', editSource_controller_1.default)
	    .controller('EditResearchLogController', editResearchLog_controller_1.default)
	    .controller('EditRightsController', editRights_controller_1.default)
	    .controller('EditStoryController', editStory_controller_1.default)
	    .controller('EditTagsController', editTags_controller_1.default)
	    .controller('FacebookController', facebook_controller_1.default)
	    .controller('ForgotPasswordController', forgotPassword_controller_1.default)
	    .controller('FsAddSourceController', fsAddSource_controller_1.default)
	    .controller('FsCompareLinkController', fsCompareLink_controller_1.default)
	    .controller('FsLinkController', fsLink_controller_1.default)
	    .controller('FsLoginController', fsLogin_controller_1.default)
	    .controller('FsMatchController', fsMatch_controller_1.default)
	    .controller('FsPromptController', fsPrompt_controller_1.default)
	    .controller('GedmatchController', gedmatch_controller_1.default)
	    .controller('HintsToastController', hintsToast_controller_1.default)
	    .controller('ListModalController', listModal_controller_1.default)
	    .controller('LoadSaveFiltersController', loadSaveFilters_controller_1.default)
	    .controller('MediaController', media_controller_1.default)
	    .controller('MergeDlgController', merge_controller_2.default)
	    .controller('NestedListController', nestedList_controller_1.default)
	    .controller('NotificationController', notification_controller_1.default)
	    .controller('RelativesController', relatives_controller_1.default)
	    .controller('SelectFamilyMembersController', selectFamilyMembers_controller_1.default)
	    .controller('SelectMediaController', selectMedia_controller_1.default)
	    .controller('SelectNamesFactsController', selectNamesFacts_controller_1.default)
	    .controller('SelectPersonController', selectPerson_controller_1.default)
	    .controller('SelectSubLengthController', selectSubLength_controller_1.default)
	    .controller('SelectTreeController', selectTree_controller_1.default)
	    .controller('SignInController', signIn_controller_1.default)
	    .controller('TreeGraphicController', treeGraphic_controller_1.default)
	    .controller('UpdateProfilesController', updateProfiles_controller_1.default)
	    .controller('VideoPreviewController', videoPreview_controller_1.default)
	    .controller('VoiceoverController', voiceover_controller_1.default)
	    .directive('rcAncestorsDescendants', ancestorsDescendants_directive_1.default)
	    .directive('rcChange', change_directive_1.default)
	    .directive('rcCreatedEdited', createdEdited_directive_1.default)
	    .directive('rcD3Chromosome', chromosome_directive_1.default)
	    .directive('rcD3Force', force_directive_1.default)
	    .directive('rcD3Heb', heb_directive_1.default)
	    .directive('rcD3Sankey', sankey_directive_1.default)
	    .directive('rcDagD3', dagD3_directive_1.default)
	    .directive('rcDag', dag_directive_1.default)
	    .directive('rcDescendancy', descendancy_directive_1.default)
	    .directive('rcDescendancyD3', descendancyD3_directive_1.default)
	    .directive('rcDnaCompare', dnaCompare_directive_1.default)
	    .directive('rcDnaKit', dnaKit_directive_1.default)
	    .directive('rcDnaKits', dnaKits_directive_1.default)
	    .directive('rcDnaProfileForce', dnaProfileForce_directive_1.default)
	    .directive('rcDnaProfileHeb', dnaProfileHeb_directive_1.default)
	    .directive('rcDnaProfileList', dnaProfileList_directive_1.default)
	    .directive('rcDnaProfileSankey', dnaProfileSankey_directive_1.default)
	    .directive('rcDnaProfileToolbar', dnaProfileToolbar_directive_1.default)
	    .directive('rcDrag', drag_directive_1.default)
	    .directive('rcEvidence', evidence_directive_1.default)
	    .directive('rcFact', fact_directive_1.default)
	    .directive('rcFamily', family_directive_1.default)
	    .directive('rcFractal', fractal_directive_1.default)
	    .directive('rcFsCopy', fsCopy_directive_1.default)
	    .directive('rcInvitation', invitation_directive_1.default)
	    .directive('rcJsTree', jsTree_directive_1.default)
	    .directive('rcLead', lead_directive_1.default)
	    .directive('rcLeaflet', leaflet_directive_1.default)
	    .directive('rcLikesComments', likesComments_directive_1.default)
	    .directive('rcList', list_directive_1.default)
	    .directive('rcMatch', match_directive_1.default)
	    .directive('rcMedia', media_directive_1.default)
	    .directive('rcMessage', message_directive_1.default)
	    .directive('rcMinitree', minitree_directive_1.default)
	    .directive('rcName', name_directive_1.default)
	    .directive('rcNote', note_directive_1.default)
	    .directive('rcOrdinance', ordinance_directive_1.default)
	    .directive('rcPanzoom', panzoom_directive_1.default)
	    .directive('rcPaste', paste_directive_1.default)
	    .directive('rcPedigree', pedigree_directive_1.default)
	    .directive('rcPedigreeFragment', pedigreeFragment_directive_1.default)
	    .directive('rcPersonLandscape', personLandscape_directive_1.default)
	    .directive('rcPersonPortrait', personPortrait_directive_1.default)
	    .directive('rcResearchLog', researchLog_directive_1.default)
	    .directive('rcScrollable', scrollable_directive_1.default)
	    .directive('rcScrollGet', scrollGet_directive_1.default)
	    .directive('rcScrollSetLeft', scrollSetLeft_directive_1.default)
	    .directive('rcSetFocus', setFocus_directive_1.default)
	    .directive('rcSidenav', sidenav_directive_1.default)
	    .directive('rcSource', source_directive_1.default)
	    .directive('rcStory', story_directive_1.default)
	    .directive('rcSunburstAncestors', sunburstAncestors_directive_1.default)
	    .directive('rcSunburstDescendants', sunburstDescendants_directive_1.default)
	    .directive('rcSunburstD3', sunburstD3_directive_1.default)
	    .directive('rcTreeGraphic', treeGraphic_directive_1.default)
	    .directive('rcToolbar', toolbar_directive_1.default)
	    .directive('rcTransclude', transclude_directive_1.default)
	    .directive('rcTree', tree_directive_1.default)
	    .directive('rcUser', user_directive_1.default)
	    .directive('rcUsername', username_directive_1.default)
	    .directive('rcUserActivity', userActivity_directive_1.default)
	    .directive('rcWarning', warning_directive_1.default)
	    .factory('csv', csv_factory_1.default)
	    .factory('d3', d3_factory_1.default)
	    .factory('hammer', hammer_factory_1.default)
	    .factory('jsPDF', jspdf_factory_1.default)
	    .factory('jsZip', jszip_factory_1.default)
	    .factory('jsZipUtils', jszipUtils_factory_1.default)
	    .factory('leaflet', leaflet_factory_1.default)
	    .factory('mediaStreamRecorder', mediaStreamRecorder_factory_1.default)
	    .factory('partnerToken', partnerToken_factory_1.default)
	    .factory('rx', rx_factory_1.default)
	    .factory('translate', translate_factory_1.default)
	    .factory('unibabel', unibabel_factory_1.default)
	    .service('authentication', authentication_service_1.default)
	    .service('authToken', authToken_service_1.default)
	    .service('blog', blog_service_1.default)
	    .service('bookmarks', bookmarks_service_1.default)
	    .service('cache', cache_service_1.default)
	    .service('changes', changes_service_1.default)
	    .service('cluster', cluster_service_1.default)
	    .service('comments', comments_service_1.default)
	    .service('currentTree', currentTree_service_1.default)
	    .service('currentTreeId', currentTreeId_service_1.default)
	    .service('currentUser', currentUser_service_1.default)
	    .service('currentUserId', currentUserId_service_1.default)
	    .service('d3worker', d3worker_service_1.default)
	    .service('dates', dates_service_1.default)
	    .service('dnaKits', dnaKits_service_1.default)
	    .service('dnaParsers', dnaParsers_service_1.default)
	    .service('dnaProfiles', dnaProfiles_service_1.default)
	    .service('dnaProfileDatas', dnaProfileDatas_service_1.default)
	    .service('easing', easing_service_1.default)
	    .service('endNotes', endNotes_service_1.default)
	    .service('evidences', evidences_service_1.default)
	    .service('evidenceUtils', evidenceUtils_service_1.default)
	    .service('families', families_service_1.default)
	    .service('familyUtils', familyUtils_service_1.default)
	    .service('feed', feed_service_1.default)
	    .service('fs', fs_service_1.default)
	    .service('fsImport', fsImport_service_1.default)
	    .service('httpClient', httpClient_service_1.default)
	    .service('indexOfNames', indexOfNames_service_1.default)
	    .service('indexOfPlaces', indexOfPlaces_service_1.default)
	    .service('invitations', invitations_service_1.default)
	    .service('leads', leads_service_1.default)
	    .service('leadGenerators', leadGenerators_service_1.default)
	    .service('likes', likes_service_1.default)
	    .service('medias', medias_service_1.default)
	    .service('mediaUtils', mediaUtils_service_1.default)
	    .service('messageBus', messageBus_service_1.default)
	    .service('mousewheel', mousewheel_service_1.default)
	    .service('musics', musics_service_1.default)
	    .service('notes', notes_service_1.default)
	    .service('notifications', notifications_service_1.default)
	    .service('ordinances', ordinances_service_1.default)
	    .service('persons', persons_service_1.default)
	    .service('personUtils', personUtils_service_1.default)
	    .service('places', places_service_1.default)
	    .service('relationshipUtils', relationshipUtils_service_1.default)
	    .service('researchLinks', researchLinks_service_1.default)
	    .service('researchLogs', researchLogs_service_1.default)
	    .service('rights', rights_service_1.default)
	    .service('rightsFull', rightsFull_service_1.default)
	    .service('searchHints', searchHints_service_1.default)
	    .service('segment', segment_service_1.default)
	    .service('server', server_service_1.default)
	    .service('showAds', showAds_service_1.default)
	    .service('sidenav', sidenav_service_1.default)
	    .service('social', social_service_1.default)
	    .service('sources', sources_service_1.default)
	    .service('store', store_service_1.default)
	    .service('stories', stories_service_1.default)
	    .service('subscriptions', subscriptions_service_1.default)
	    .service('treeGraphics', treeGraphics_service_1.default)
	    .service('treeUsers', treeUsers_service_1.default)
	    .service('users', users_service_1.default)
	    .service('utils', utils_service_1.default)
	    .service('warnings', warnings_service_1.default)
	    .service('pedigreeReport', pedigree_service_1.default)
	    .service('evidenceAnalysisReport', evidenceAnalysis_service_1.default)
	    .service('ahnentafelReport', ahnentafel_service_1.default)
	    .service('endOfLineReport', endOfLine_service_1.default)
	    .service('familyGroupReport', familyGroup_service_1.default)
	    .service('placeListReport', placeList_service_1.default)
	    .service('fanReport', fan_service_1.default)
	    .filter('toArray', toArray_filter_1.default)
	    .filter('presentationMode', ['treeUsers', presentationMode_filter_1.default]);
	// Docx filters
	// .filter('joinBy', () => DocxFilters.joinBy)
	// .filter('capitalize', () => DocxFilters.capitalize)
	// .filter('brackets', () => DocxFilters.brackets)
	// .filter('roman', () => DocxFilters.roman)
	// .filter('romanLower', () => DocxFilters.romanLower)
	// .filter('pronoun', () => DocxFilters.pronoun)
	// .filter('child', () => DocxFilters.child)
	// .filter('eventDescription', () => DocxFilters.eventDescription)
	// .filter('datePlace', () => DocxFilters.datePlace)
	// .filter('placeDate', () => DocxFilters.placeDate);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	config.$inject = ["$logProvider", "$mdThemingProvider", "$mdIconProvider", "$provide", "$translateProvider", "$locationProvider", "pusherProvider", "localStorageServiceProvider"];
	Object.defineProperty(exports, "__esModule", { value: true });
	function config($logProvider, $mdThemingProvider, $mdIconProvider, $provide, $translateProvider, $locationProvider, pusherProvider, localStorageServiceProvider) {
	    'ngInject';
	    // these consts are set by CI
	    var __APP_VERSION__ = ''; // git commit sha1
	    var __FS_ENVIRONMENT__ = 'production'; // familysearch environment; e.g., production
	    var __FS_APP_KEY__ = 'a02f100000RMfRgAAL'; // familysearch app key
	    var __FS_REDIRECT_URI__ = 'https://trees.americanancestors.org/auth/familysearch'; // familysearch redirect uri
	    // PARTNER - customize
	    var __HOME_URL__ = 'https://trees.americanancestors.org'; // URL of the "home" page of the app; used in reports as the base for generating links
	    var __COOKIE_DOMAIN__ = 'americanancestors.org'; // client domain for reading cookies; e.g., rootscity.com
	    var __SERVER_BASE__ = 'https://www.rootsfinder.com/api'; // server base; e.g., https://www.rootsfinder.com/api
	    var __PUSHER_KEY__ = '29d5aa44a2afd9d712d1'; // pusher key; e.g., 8bc7635d6b6cc9916a6f
	    var __GOOGLE_ANALYTICS_ID__ = 'UA-26556953-4'; // google analytics id
	    var __PARTNER_ID__ = 'NEHGS'; // partner id
	    var __PARTNER_SINGLE_SIGNON__ = true;
	    var __ROUTE_BASE__ = ''; // if you're posting your code to /tree, then change this to /tree
	    // const __RECURLY_KEY__ = '';   // recurly key for billing; e.g., ewr1-2IFuKkh4g3Q9uM1dprNEPY
	    var __STRIPE_KEY__ = '';
	    var __PARTNER_LOGIN_PAGE__ = 'https://my.americanancestors.org/account/login?returnurl='; // login page for partner
	    var __PARTNER_RETURN_URL_SUFFIX__ = true; // true if partner's login page uses query fragment to return to page
	    // these consts are not set by CI
	    var froalaLicenseKey = 'qB1D1G2G1rA1C7E6B4E1D4E4E1A9C6eB-11vyowG-7aocmgg1usgB-22yC6cC-9i==';
	    var fsDefaultProd = true;
	    $provide.constant('homeURL', __HOME_URL__ || 'https://www.rootsfinder.com');
	    $provide.constant('cookieDomain', __COOKIE_DOMAIN__ || 'localhost');
	    $provide.constant('cookieExpiresDays', 3650); // ten years
	    $provide.constant('serverBase', __SERVER_BASE__ || 'http://localhost:3000/api');
	    $provide.constant('pusherBase', __SERVER_BASE__ || 'https://rootsfinder.ngrok.io/api');
	    $provide.constant('musicBase', 'http://music.rootsfinder.com');
	    $provide.constant('fsEnvironment', __FS_ENVIRONMENT__ || (fsDefaultProd ? 'production' : 'integration'));
	    $provide.constant('fsAppKey', __FS_APP_KEY__ || (fsDefaultProd ? 'a02j000000MacanAAB' : 'a02j000000LrsuyAAB'));
	    $provide.constant('fsRedirectUri', __FS_REDIRECT_URI__ || 'http://localhost:3000/auth/familysearch');
	    $provide.constant('googleAnalyticsId', __GOOGLE_ANALYTICS_ID__);
	    $provide.constant('partnerId', __PARTNER_ID__);
	    $provide.constant('partnerSingleSignon', __PARTNER_SINGLE_SIGNON__);
	    $provide.constant('routeBase', __ROUTE_BASE__);
	    $provide.constant('partnerLoginPage', __PARTNER_LOGIN_PAGE__);
	    $provide.constant('partnerReturnUrlSuffix', __PARTNER_RETURN_URL_SUFFIX__);
	    // $provide.constant('recurlyKey', __RECURLY_KEY__ || 'ewr1-2IFuKkh4g3Q9uM1dprNEPY');
	    $provide.constant('stripeKey', __STRIPE_KEY__ || 'pk_test_RT5gYw1lIgDFivYisjsYaZD3');
	    $provide.constant('stripeImage', 'https://www.rootsfinder.com/assets/images/rootsfinder-icon.png');
	    // html5Mode
	    $locationProvider.html5Mode(false);
	    // Enable debug log
	    $logProvider.debugEnabled(!__APP_VERSION__);
	    var noWarnMessages = ['403 Forbidden', 'SecurityError', 'FS_CANCEL', 'Access is denied.', 'UNAUTHORIZED'];
	    function shouldSend(message) {
	        return !noWarnMessages.includes(message);
	    }
	    // Configure sentry error handler
	    /* globals window: false */
	    /*eslint-disable angular/window-service */
	    window.Raven.setShouldSendCallback(function (err) {
	        if (!shouldSend(err.message)) {
	            return false;
	        }
	        return !!__APP_VERSION__;
	    });
	    if (!!__APP_VERSION__) {
	        window.Raven.setRelease(__APP_VERSION__);
	        //$provide.decorator('$exceptionHandler', ['$delegate', ($delegate) => {
	        //  return (exception, cause) => {
	        //    $delegate(exception, cause);
	        //    if (shouldSend(exception)) {
	        //      window.Raven.showReportDialog();
	        //    }
	        //  };
	        //}]);
	    }
	    /*eslint-enable angular/window-service */
	    // Configure pusher
	    pusherProvider.config(__PUSHER_KEY__ || '8bc7635d6b6cc9916a6f'); //eslint-disable-line
	    // Configure local storage
	    localStorageServiceProvider
	        .setPrefix('tc')
	        .setNotify(false, false);
	    // Configure vwo
	    //vwoProvider.init(280352);
	    //
	    // Theme
	    //
	    // set theme
	    $mdThemingProvider.definePalette('rootsCityPalette', {
	        '50': 'e2f2f2',
	        '100': 'd0ecee',
	        '200': 'bfe5e7',
	        '300': 'E57272',
	        '400': 'A0C8D8',
	        '500': 'BF9944',
	        '600': '87BCD6',
	        '700': '75AFD3',
	        '800': '5EA2D1',
	        '900': '488FC8',
	        'A100': '72bf43',
	        'A200': 'fdc010',
	        'A400': '612e91',
	        'A700': 'f15c46',
	        'contrastDefaultColor': 'light',
	        // on this palette should be dark or light
	        'contrastDarkColors': ['50', '100',
	            '200', '300', '400', 'A100'],
	        'contrastLightColors': undefined // could also specify this if default was 'dark'
	    });
	    // I'm sure we could just extend the default theme with the specific entries we use on the home form, but I don't know which those are
	    $mdThemingProvider.definePalette('homeFormPalette', {
	        '50': 'ffffff',
	        '100': 'ffffff',
	        '200': 'ffffff',
	        '300': 'ffffff',
	        '400': 'ffffff',
	        '500': 'ffffff',
	        '600': 'ffffff',
	        '700': 'ffffff',
	        '800': 'ffffff',
	        '900': 'ffffff',
	        'A100': 'ffffff',
	        'A200': 'ffffff',
	        'A400': 'ffffff',
	        'A700': 'ffffff',
	        'contrastDefaultColor': 'light' // whether, by default, text (contrast) on this palette should be dark or light
	    });
	    $mdThemingProvider.definePalette('homeFormAccentPalette', {
	        '50': '72bf43',
	        '100': '72bf43',
	        '200': '72bf43',
	        '300': '72bf43',
	        '400': '72bf43',
	        '500': '72bf43',
	        '600': '72bf43',
	        '700': '72bf43',
	        '800': '72bf43',
	        '900': '72bf43',
	        'A100': '72bf43',
	        'A200': '72bf43',
	        'A400': '72bf43',
	        'A700': '72bf43',
	        'contrastDefaultColor': 'light' // whether, by default, text (contrast) on this palette should be dark or light
	    });
	    $mdThemingProvider.theme('default')
	        .primaryPalette('rootsCityPalette');
	    $mdThemingProvider.theme('homeForm')
	        .primaryPalette('homeFormPalette')
	        .accentPalette('homeFormAccentPalette');
	    // set icons
	    $mdIconProvider.iconSet('rc', 'assets/icons/svgdefs.svg', 1024);
	    //
	    // Froala
	    //
	    // init froala
	    var froalaConfig = {
	        charCounterCount: false,
	        codeMirror: false,
	        placeholderText: '',
	        enter: 2,
	        //  toolbarButtons:   ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', '|', 'color', 'emoticons', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', 'insertHR', '-', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', 'undo', 'redo', 'clearFormatting', 'selectAll', 'html']
	        toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'fontSize', 'color', 'align', 'superscript', 'subscript', 'formatOL', 'formatUL', 'outdent', 'indent', 'insertLink', 'insertTable'],
	        toolbarButtonsMD: ['fullscreen', 'bold', 'italic', 'underline', 'fontSize', 'color', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'insertLink', 'insertTable'],
	        toolbarButtonsSM: ['fullscreen', 'bold', 'italic', 'underline', 'fontSize', 'align', 'outdent', 'indent', 'insertLink', 'insertTable'],
	        toolbarButtonsXS: ['bold', 'italic', 'fontSize', 'outdent', 'indent']
	    };
	    var froalaIconTemplates = {
	        materialDesign: '<i class="material-icons">[NAME]</i>',
	        fullscreen: '<i class="material-icons [NAME]"></i>'
	    };
	    var froalaIcons = {
	        fullscreen: { NAME: 'fa-expand', template: 'fullscreen' },
	        bold: { NAME: 'format_bold', template: 'materialDesign' },
	        italic: { NAME: 'format_italic', template: 'materialDesign' },
	        underline: { NAME: 'format_underlined', template: 'materialDesign' },
	        superscript: { NAME: 'fa-superscript', template: 'fullscreen' },
	        subscript: { NAME: 'fa-subscript', template: 'fullscreen' },
	        fontFamily: { NAME: 'font_download', template: 'materialDesign' },
	        fontSize: { NAME: 'format_size', template: 'materialDesign' },
	        color: { NAME: 'format_color_text', template: 'materialDesign' },
	        align: { NAME: 'format_align_left', template: 'materialDesign' },
	        'align-left': { NAME: 'format_align_left', template: 'materialDesign' },
	        'align-center': { NAME: 'format_align_center', template: 'materialDesign' },
	        'align-right': { NAME: 'format_align_right', template: 'materialDesign' },
	        'align-justify': { NAME: 'format_align_justify', template: 'materialDesign' },
	        formatOL: { NAME: 'format_list_numbered', template: 'materialDesign' },
	        formatUL: { NAME: 'format_list_bulleted', template: 'materialDesign' },
	        outdent: { NAME: 'format_indent_decrease', template: 'materialDesign' },
	        indent: { NAME: 'format_indent_increase', template: 'materialDesign' },
	        insertLink: { NAME: 'insert_link', template: 'materialDesign' },
	        //    insertImage: {NAME: 'insert_photo', template: 'materialDesign'},
	        insertTable: { NAME: 'border_all', template: 'materialDesign' }
	    };
	    // froala is imported from a 3rd-party module; otherwise we'd set up a provider and configure it that way
	    /* globals window: false */
	    /*eslint-disable angular/window-service */
	    if (!!window.jQuery && !!window.jQuery.FroalaEditor) {
	        $provide.value('froalaConfig', froalaConfig);
	        window.jQuery.FroalaEditor.DEFAULTS.key = froalaLicenseKey;
	        for (var template in froalaIconTemplates) {
	            window.jQuery.FroalaEditor.DefineIconTemplate(template, froalaIconTemplates[template]);
	        }
	        for (var icon in froalaIcons) {
	            window.jQuery.FroalaEditor.DefineIcon(icon, froalaIcons[icon]);
	        }
	    }
	    /*eslint-enable angular/window-service */
	    //
	    // Translation
	    //
	    $translateProvider.useMissingTranslationHandler('translate');
	    $translateProvider.preferredLanguage('en');
	    $translateProvider.useSanitizeValueStrategy('escape');
	    $translateProvider.translations('en', {
	        // general
	        'ABOUT': 'About',
	        'ALL': 'All',
	        'AND': 'and',
	        'ANOTHER': 'Another',
	        'DECEASED': 'Deceased',
	        'FALSE': 'False',
	        'FROM': 'from',
	        'IN': 'in',
	        'LIVING': 'Living',
	        'OF': 'of',
	        'OF_UNKNOWN_SPOUSE': 'of Unknown Spouse',
	        'OTHER': 'Other',
	        'PERSON': 'Person',
	        'PRINCIPAL': 'Principal',
	        'SUPPORTING_EVIDENCE': 'Supporting Evidence',
	        'TRUE': 'True',
	        'UNKNOWN': 'Unknown',
	        'PLEASE_WAIT': 'Please wait',
	        'PUBLIC': 'Public',
	        'PRIVATE': 'Private',
	        // genders
	        'FEMALE': 'Female',
	        'MALE': 'Male',
	        // source types
	        'AUTHORED': 'Authored work',
	        'DERIVATIVE': 'Derivative',
	        'ORIGINAL': 'Original',
	        // relationships
	        'CHILD': 'Child',
	        'FATHER': 'Father',
	        'MOTHER': 'Mother',
	        'PARENT': 'Parent',
	        'SPOUSE': 'Spouse',
	        'SIBLING': 'Sibling',
	        'ADOPTIVE_PARENT': 'Adoptive parent',
	        'STEP_PARENT': 'Step parent',
	        // parent relationships
	        'BIOLOGICAL_PARENT': 'Biological',
	        'FAMILY_MEMBER': 'Family member',
	        'FOSTER_PARENT': 'Foster parent',
	        'GUARDIAN': 'Guardian',
	        'RELATED': 'Related',
	        'SLAVE_OWNER': 'Slave owner',
	        // colors
	        'ORANGE': 'Orange',
	        'YELLOW': 'Yellow',
	        'GREEN': 'Green',
	        'AQUAMARINE': 'Aquamarine',
	        'AQUA': 'Aqua',
	        'BLUE': 'Blue',
	        'PURPLE': 'Purple',
	        'MAGENTA': 'Magenta',
	        'RED': 'Red',
	        'GREY': 'Grey',
	        'BLACK': 'Black',
	        // errors
	        'UNAUTHORIZED': 'User or password not found.',
	        'FORBIDDEN': 'You haven\'t been given permission to do that on this tree.',
	        //'NOT_LOGGED_IN': this error treated specially
	        'NOT_FOUND': 'Not found',
	        'BAD_REQUEST': 'Something went wrong - please refresh your browser',
	        'CONFLICT': 'Something isn\'t right - please refresh your browser',
	        'DUPLICATE_KEY': 'Duplicate key',
	        'USER_EMAIL_EXISTS': 'It looks like someone with this email is already registered; would you like to sign in?',
	        'USER_NAME_EXISTS': 'Someone has already taken that user name; please try again with a different one.',
	        'INTERNAL': 'Server error; please try again later.',
	        'PUSHER_ERROR': 'Error connecting to server; please try again later.',
	        'PUSHER_NO_AUTH': 'You need to log in.',
	        'UNKNOWN_ERROR': 'An error has occurred; please refresh your browser',
	        'FS_ERROR': 'Error accessing FamilySearch',
	        'ACCEPT_INVITATION_ERROR': 'Error accepting invitation (has it already been accepted)?',
	        // rights
	        'NONE': 'None',
	        'READ': 'Can view',
	        'EDIT': 'Can edit',
	        'OWNER': 'Owner',
	        // dna
	        'TOTAL': 'Total',
	        'LARGEST': 'Largest',
	        // plans
	        'PLAN_FREE': 'Standard Tree',
	        'PLAN_STANDARD': 'Advanced Tree',
	        'PLAN_PRO': 'Premium Tree',
	        'PLAN_PRO_TRIAL': 'Premium Tree Trial',
	        // facebook
	        'FB_EVERYONE': 'Everyone can view',
	        'FB_ALL_FRIENDS': 'Friends can view',
	        'FB_FRIENDS_OF_FRIENDS': 'Friends of friends can view',
	        'FB_SELF': 'Only I can view',
	        // videos
	        'ANIMATIONS': 'Animations',
	        'RANDOM': 'Random',
	        'PAN': 'Pan',
	        'PAN_UP': 'Pan up',
	        'PAN_DOWN': 'Pan down',
	        'PAN_LEFT': 'Pan left',
	        'PAN_RIGHT': 'Pan right',
	        'ZOOM': 'Zoom',
	        'ZOOM_IN': 'Zoom in',
	        'ZOOM_OUT': 'Zoom out',
	        'ZOOM_AND_PAN': 'Zoom and Pan',
	        'ZOOM_IN_AND_PAN_UP': 'Zoom in and pan up',
	        'ZOOM_IN_AND_PAN_DOWN': 'Zoom in and pan down',
	        'ZOOM_IN_AND_PAN_LEFT': 'Zoom in and pan left',
	        'ZOOM_IN_AND_PAN_RIGHT': 'Zoom in and pan right',
	        'ZOOM_OUT_AND_PAN_UP': 'Zoom out and pan up',
	        'ZOOM_OUT_AND_PAN_DOWN': 'Zoom out and pan down',
	        'ZOOM_OUT_AND_PAN_LEFT': 'Zoom out and pan left',
	        'ZOOM_OUT_AND_PAN_RIGHT': 'Zoom out and pan right',
	        'ZOOM_AND_ROTATE': 'Zoom and Rotate',
	        'ZOOM_IN_AND_ROTATE_CLOCKWISE': 'Zoom in and rotate clockwise',
	        'ZOOM_IN_AND_ROTATE_COUNTERCLOCKWISE': 'Zoom in and rotate counter-clockwise',
	        'ZOOM_OUT_AND_ROTATE_CLOCKWISE': 'Zoom out and rotate clockwise',
	        'ZOOM_OUT_AND_ROTATE_COUNTERCLOCKWISE': 'Zoom out and rotate clounter-clockwise',
	        // page titles
	        'TITLE_accept-invitation': 'Accept invitation',
	        'TITLE_create': 'Create a tree',
	        'TITLE_confirm-email': 'Confirm email',
	        'TITLE_cookies': 'Cookies',
	        'TITLE_fs-redirect': '',
	        'TITLE_home': 'Free Family Tree',
	        'TITLE_homeSignedIn': 'Home',
	        'TITLE_login': 'Login',
	        'TITLE_plans': 'Plans',
	        'TITLE_privacy': 'Privacy',
	        'TITLE_register': 'Register',
	        'TITLE_set-password': 'Set password',
	        'TITLE_terms': 'Terms',
	        'TITLE_tree': 'Free Family Tree',
	        'TITLE_tree.apps': 'Applications',
	        'TITLE_tree.dna-profiles': 'DNA Profiles',
	        'TITLE_tree.evidences': 'evidences',
	        'TITLE_tree.exports': 'GEDCOM export',
	        'TITLE_tree.feed': 'Dashboard',
	        'TITLE_tree.graph': 'Tree',
	        'TITLE_tree.hintSettings': 'Hint settings',
	        'TITLE_tree.import-fs': 'Import from FamilySearch',
	        'TITLE_tree.import-gedcom': 'Import a GEDCOM',
	        'TITLE_tree.import-scratch': 'Start your tree',
	        'TITLE_tree.infographics': 'Infographics',
	        'TITLE_tree.leads': 'Hints',
	        'TITLE_tree.media': 'Media',
	        'TITLE_tree.merge': 'Import tree',
	        'TITLE_tree.messages': 'Messages',
	        'TITLE_tree.notes': 'Notes',
	        'TITLE_tree.people': 'People',
	        'TITLE_tree.reports': 'Reports',
	        'TITLE_tree.research-logs': 'Research logs',
	        'TITLE_tree.sources': 'Sources',
	        'TITLE_tree.stories': 'Stories',
	        'TITLE_tree.treeSettings': 'Tree settings',
	        'TITLE_tree.users': 'Users',
	        'TITLE_tree.user': 'User',
	        'TITLE_tree.userSettings': 'Account',
	        'TITLE_tree.sync': 'Compare to FamilySearch',
	        'TITLE_tree.video': 'Video',
	        'TITLE_tree.warnings': 'Warnings',
	        'TITLE_userSettings': 'Account',
	        // item types
	        //'NAME': 'Name',
	        'FACT': 'Fact',
	        'EVIDENCE': 'Evidence',
	        'MEDIA': 'Media',
	        'NOTE': 'Note',
	        'STORY': 'Story',
	        'ORDINANCE': 'Ordinance',
	        // FamilySearch states
	        'FS_NOT_LOGGED_IN': 'Log into FamilySearch',
	        'FS_NOT_CONNECTED': 'Not matched to FamilySearch',
	        'FS_CONNECTED': 'Matched to FamilySearch',
	        'FS_FS_UPDATED': 'FamilySearch has changes',
	        'FS_RF_UPDATED': 'RootsFinder has changes',
	        'FS_ORDINANCES_READY': 'Ordinances ready',
	        'FS_ORDINANCES_NEEDED': 'Ordinances need more information',
	        'FS_ORDINANCES_COMPLETE': 'Ordinances completed',
	        'FS_ORDINANCES_RESERVED': 'Ordinances reserved',
	        // FamilySearch menu actions
	        'FS_VIEW': 'View on FamilySearch',
	        'FS_DOWNLOAD': 'Download more generations',
	        'FS_COMPARE': 'Compare with FamilySearch',
	        'FS_UPDATE': 'Compare with FamilySearch',
	        'FS_CONNECT': 'Match to FamilySearch',
	        'FS_DISCONNECT': 'Unmatch FamilySearch',
	        // FamilySearch Sync actions
	        'ADD_RF': 'Add {{type}} to RootsFinder',
	        'ADD_RF_ALL': 'Add all {{type}}s to RootsFinder',
	        'REPLACE_RF': 'Replace RootsFinder {{type}}',
	        'ADD_FS': 'Add {{type}} to FamilySearch',
	        'ADDALT_FS': 'Add alternate {{type}} to FamilySearch',
	        'REPLACE_FS': 'Replace FamilySearch {{type}}',
	        'ADD_RC': 'Add Using RootsFinder Web Clipper',
	        'MATCH_FS': 'Match or add to FamilySearch',
	        'MATCH_RF': 'Match or add to RootsFinder',
	        'FS_CONNECT_PAIR': 'Match this pair',
	        'MATCH_FS_OTHER': 'Match to someone else',
	        // Ordinance types
	        'http://lds.org/Baptism': 'Baptism',
	        'http://lds.org/Confirmation': 'Confirmation',
	        'http://lds.org/Initiatory': 'Initiatory',
	        'http://lds.org/Endowment': 'Endowment',
	        'http://lds.org/SealingToSpouse': 'Sealing to spouse',
	        'http://lds.org/SealingChildToParents': 'Sealing to parents',
	        // ordinance statuses
	        'http://familysearch.org/v1/Ready': 'Request',
	        'http://familysearch.org/v1/NotReady': 'Waiting',
	        'http://familysearch.org/v1/Submittable': 'Ready',
	        'http://familysearch.org/v1/Reserved': 'Not available',
	        'http://familysearch.org/v1/NeedMoreInformation': 'Not available',
	        'http://familysearch.org/v1/NotAvailable': 'Not available',
	        'http://familysearch.org/v1/Completed': 'Completed',
	        'http://familysearch.org/v1/NotNeeded': 'Not needed',
	        'http://familysearch.org/v1/NotNeededBornInCovenant': 'Not needed',
	        'http://familysearch.org/v1/Resubmittable': 'Printed',
	        'http://familysearch.org/v1/InProgress': 'Not available',
	        'http://familysearch.org/v1/NeedPermission': 'Request',
	        'http://familysearch.org/v1/Cancelled': 'Request',
	        'http://familysearch.org/v1/Deleted': 'Request',
	        'http://familysearch.org/v1/Invalid': 'Not available',
	        'http://familysearch.org/v1/Ready_detail': 'Ready',
	        'http://familysearch.org/v1/Submittable_detail': 'Not printed',
	        'http://familysearch.org/v1/Reserved_detail': 'Reserved',
	        'http://familysearch.org/v1/NeedMoreInformation_detail': 'Need more information',
	        'http://familysearch.org/v1/NotNeededBornInCovenant_detail': 'Born in covenant',
	        'http://familysearch.org/v1/InProgress_detail': 'In progress',
	        'http://familysearch.org/v1/NeedPermission_detail': 'Permission required',
	        'http://familysearch.org/v1/Cancelled_detail': 'Cancelled',
	        'http://familysearch.org/v1/Deleted_detail': 'Deleted',
	        'http://familysearch.org/v1/Invalid_detail': 'Invalid',
	        // warning levels
	        'WARNING_LEVEL1': 'Info',
	        'WARNING_LEVEL2': 'Warning',
	        'WARNING_LEVEL3': 'Error',
	        // name types
	        'NICK': 'Nickname',
	        '_MARNM': 'Married Name',
	        'ALIA': 'Alias',
	        '_VARN': 'Alternate Name',
	        '_OTHN': 'Other Name',
	        '_BIRTNM': 'Birth Name',
	        '_MAID': 'Maiden Name',
	        '_PATR': 'Patronymic Name',
	        'TITL': 'Title',
	        // event/fact types
	        'ADDR': 'Address',
	        'ADOP': 'Adoption',
	        '_AFIL': 'Affiliation',
	        '_AGE': 'Age',
	        'AFN': 'Ancestral File Number',
	        'ANUL': 'Annulment',
	        'ARVL': 'Arrival',
	        'BAPM': 'Baptism',
	        'BARM': 'Bar Mitzvah',
	        'BATM': 'Bat Mitzvah',
	        '_BIO': 'Biography',
	        'BIRT': 'Birth',
	        'BLES': 'Blessing',
	        'BURI': 'Burial',
	        'CAST': 'Cast Name',
	        'CAUS': 'Cause of Death',
	        'CENS': 'Census',
	        'CHR': 'Christening',
	        '_CIVL': 'Civil Marriage',
	        '_CLAN': 'Clan Name',
	        'CLAW': 'Common Law Marriage',
	        'CONF': 'Confirmation',
	        'CREM': 'Cremation',
	        'DEAT': 'Death',
	        '_DEG': 'Degree',
	        'DPRT': 'Departure',
	        'DSCR': 'Description',
	        'DIV': 'Divorce',
	        'DIVF': 'Divorce Filed',
	        'EDUC': 'Education',
	        '_EIGHT': 'Died before eight',
	        '_ELEC': 'Election',
	        'EMAIL': 'Email',
	        'EMIG': 'Emigration',
	        'EMPL': 'Employment',
	        'ENG': 'Engagement',
	        '_ETHN': 'Ethnicity',
	        'EXCM': 'Excommunication',
	        '_FSFTID': 'FamilySearch Id',
	        'FCOM': 'First Communion',
	        '_FUN': 'Funeral',
	        '_GENIID': 'Geni Id',
	        'GRAD': 'Graduation',
	        'ILL': 'Illness',
	        'IMMI': 'Immigration',
	        '_MSTAT': 'Marital Status',
	        'MARR': 'Marriage',
	        'MARB': 'Marriage Banns',
	        '_MBON': 'Marriage Bond',
	        'MARC': 'Marriage Contract',
	        'MARL': 'Marriage License',
	        'MARS': 'Marriage Settlement',
	        '_MDCL': 'Medical',
	        '_MILT': 'Military',
	        '_MISN': 'Mission',
	        '_MOVE': 'Move',
	        'NAME': 'Name',
	        '_NAMS': 'Namesake',
	        '_NID': 'National Idenfication',
	        'NATI': 'Nationality',
	        'NATU': 'Naturalization',
	        '_NEWS': 'Newspaper',
	        'NCHI': 'Number of Children',
	        '_OBIT': 'Obituary',
	        'OCCU': 'Occupation',
	        'ORDN': 'Ordination',
	        'PHON': 'Phone',
	        'PROB': 'Probate',
	        'PROP': 'Property',
	        '_RACE': 'Race',
	        'REFN': 'Reference Number',
	        'RELI': 'Religion',
	        'RESI': 'Residence',
	        'RETI': 'Retirement',
	        '_SEPR': 'Separation',
	        'SEX': 'Gender',
	        'SOUR': 'Source',
	        'SSN': 'Social Security Number',
	        '_STIL': 'Stillborn',
	        '_TITL': 'Title of Nobility',
	        '_TRIB': 'Tribe Name',
	        '_WIKITREEID': 'WikiTree Id',
	        'WILL': 'Will',
	        // DNA
	        'DNA_MATCH_TYPE_NOT': 'Not a match to this tree',
	        'DNA_MATCH_TYPE_SELF': 'Matches',
	        'DNA_MATCH_TYPE_DESCENDANT': 'Descendant of',
	        'DNA_MATCH_TYPE_LINE': 'In the family line of',
	        // Ordinals
	        'ORDINAL_1': 'First',
	        'ORDINAL_2': 'Second',
	        'ORDINAL_3': 'Third',
	        'ORDINAL_4': 'Fourth',
	        'ORDINAL_5': 'Fifth',
	        'ORDINAL_6': 'Sixth',
	        'ORDINAL_7': 'Seventh',
	        'ORDINAL_8': 'Eighth',
	        'ORDINAL_9': 'Ninth',
	        'ORDINAL_10': 'Tenth',
	        'ORDINAL_11': 'Eleventh',
	        'ORDINAL_12': 'Twelfth',
	        'ORDINAL_13': 'Thirteenth',
	        'ORDINAL_14': 'Fourteenth',
	        'ORDINAL_15': 'Fifteenth',
	        'ORDINAL_16': 'Sixteenth',
	        'ORDINAL_17': 'Seventeenth',
	        'ORDINAL_18': 'Eighteenth',
	        'ORDINAL_19': 'Nineteenth',
	        'ORDINAL_20': 'Twentieth'
	    });
	}
	exports.default = config;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	routerConfig.$inject = ["$stateProvider", "$urlRouterProvider", "routeBase"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function routerConfig($stateProvider, $urlRouterProvider, routeBase) {
	    'ngInject';
	    $stateProvider
	        .state('accept-invitation', {
	        url: routeBase + '/accept-invitation?code',
	        templateUrl: 'app/acceptInvitation/acceptInvitation.html',
	        controller: 'AcceptInvitationController',
	        controllerAs: 'acceptInvitation'
	    })
	        .state('create', {
	        url: routeBase + '/create-tree',
	        templateUrl: 'app/create/create.html',
	        controller: 'CreateController',
	        controllerAs: 'create'
	    })
	        .state('confirm-email', {
	        url: routeBase + '/confirm-email?key&email',
	        templateUrl: 'app/confirmEmail/confirmEmail.html',
	        controller: 'ConfirmEmailController',
	        controllerAs: 'confirmEmail'
	    })
	        .state('cookies', {
	        url: routeBase + '/cookie-policy',
	        templateUrl: 'app/static/cookies.html',
	        controller: 'StaticController',
	        controllerAs: 'static'
	    })
	        .state('login', {
	        url: routeBase + '/login?sso&sig&redirect&data',
	        templateUrl: 'app/forumLogin/forumLogin.html',
	        controller: 'ForumLoginController',
	        controllerAs: 'forumLogin'
	    })
	        .state('fs-redirect', {
	        url: routeBase + '/auth/familysearch?code',
	        templateUrl: 'app/fsRedirect/fsRedirect.html',
	        controller: 'FsRedirectController',
	        controllerAs: 'fsRedirect'
	    })
	        .state('home', {
	        url: routeBase + '/?code',
	        templateUrl: 'app/partnerHome/partnerHome.html',
	        controller: 'PartnerHomeController',
	        controllerAs: 'partnerHome'
	    })
	        .state('homeSignedIn', {
	        url: routeBase + '/home',
	        templateUrl: 'app/homeSignedIn/homeSignedIn.html',
	        controller: 'HomeSignedInController',
	        controllerAs: 'home'
	    })
	        .state('nolo', {
	        url: routeBase + '/nolo',
	        templateUrl: 'app/static/nolo.html',
	        controller: 'StaticController',
	        controllerAs: 'static'
	    })
	        .state('plans', {
	        url: routeBase + '/plans',
	        templateUrl: 'app/static/plans.html',
	        controller: 'StaticController',
	        controllerAs: 'static'
	    })
	        .state('privacy', {
	        url: routeBase + '/privacy-policy',
	        templateUrl: 'app/static/privacy.html',
	        controller: 'StaticController',
	        controllerAs: 'static'
	    })
	        .state('register', {
	        url: routeBase + '/register?code&ref',
	        templateUrl: 'app/register/register.html',
	        controller: 'RegisterController',
	        controllerAs: 'register'
	    })
	        .state('set-password', {
	        url: routeBase + '/set-password?key&email',
	        templateUrl: 'app/setPassword/setPassword.html',
	        controller: 'SetPasswordController',
	        controllerAs: 'setPassword'
	    })
	        .state('terms', {
	        url: routeBase + '/terms-of-use',
	        templateUrl: 'app/static/terms.html',
	        controller: 'StaticController',
	        controllerAs: 'static'
	    })
	        .state('tree', {
	        url: routeBase + '/tree/:treeId',
	        templateUrl: 'app/tree/tree.html',
	        controller: 'TreeController',
	        controllerAs: 'tree'
	    })
	        .state('tree.apps', {
	        url: routeBase + '/apps?init&return',
	        templateUrl: 'app/apps/apps.html',
	        controller: 'AppsController',
	        controllerAs: 'apps'
	    })
	        .state('tree.dna-profiles', {
	        url: routeBase + '/dna-profiles',
	        templateUrl: 'app/dnaProfiles/dnaProfiles.html',
	        controller: 'DNAProfilesController',
	        controllerAs: 'profiles'
	    })
	        .state('tree.dna-profile', {
	        url: routeBase + '/dna-profiles/:id?view&min&max&cm_range&include&include_pids&in_degrees&exclude&exclude_pids&ex_degrees&keywords',
	        templateUrl: 'app/dnaProfile/dnaProfile.html',
	        controller: 'DNAProfileController',
	        controllerAs: 'profile',
	        reloadOnSearch: false
	    })
	        .state('tree.evidences', {
	        url: routeBase + '/evidences/:evidenceId',
	        templateUrl: 'app/evidences/evidences.html',
	        controller: 'EvidencesController',
	        controllerAs: 'evidences',
	        params: {
	            squash: true,
	            evidenceId: ''
	        }
	    })
	        .state('tree.exports', {
	        url: routeBase + '/exports/:exportId',
	        templateUrl: 'app/exports/exports.html',
	        controller: 'ExportsController',
	        controllerAs: 'exports'
	    })
	        .state('tree.feed', {
	        url: routeBase + '/dashboard',
	        templateUrl: 'app/feed/feed.html',
	        controller: 'FeedController',
	        controllerAs: 'feed'
	    })
	        .state('tree.graph', {
	        url: routeBase + '/view?format&root',
	        templateUrl: 'app/graph/graph.html',
	        controller: 'GraphController',
	        controllerAs: 'graph'
	    })
	        .state('tree.hintSettings', {
	        url: routeBase + '/hint-settings?init',
	        templateUrl: 'app/hintSettings/hintSettings.html',
	        controller: 'HintSettingsController',
	        controllerAs: 'hint_settings'
	    })
	        .state('tree.import-fs', {
	        url: routeBase + '/import-familysearch?root',
	        templateUrl: 'app/import/importFs.html',
	        controller: 'ImportFsController',
	        controllerAs: 'importFs'
	    })
	        .state('tree.import-gedcom', {
	        url: routeBase + '/import-gedcom',
	        templateUrl: 'app/import/importGedcom.html',
	        controller: 'ImportGedcomController',
	        controllerAs: 'importGedcom'
	    })
	        .state('tree.import-scratch', {
	        url: routeBase + '/start-your-tree',
	        templateUrl: 'app/import/importScratch.html',
	        controller: 'ImportScratchController',
	        controllerAs: 'importScratch'
	    })
	        .state('tree.infographics', {
	        url: routeBase + '/infographics/:graphicId',
	        templateUrl: 'app/treeGraphics/treeGraphics.html',
	        controller: 'TreeGraphicsController',
	        controllerAs: 'treeGraphics',
	        params: {
	            squash: true,
	            graphicId: ''
	        }
	    })
	        .state('tree.leads', {
	        url: routeBase + '/hints/:leadId',
	        templateUrl: 'app/leads/leads.html',
	        controller: 'LeadsController',
	        controllerAs: 'leads',
	        params: {
	            squash: true,
	            leadId: ''
	        }
	    })
	        .state('tree.media', {
	        url: routeBase + '/media/:mediaId',
	        templateUrl: 'app/medias/medias.html',
	        controller: 'MediasController',
	        controllerAs: 'medias',
	        params: {
	            squash: true,
	            mediaId: ''
	        }
	    })
	        .state('tree.merge', {
	        url: routeBase + '/import/:mergeId',
	        templateUrl: 'app/merge/merge.html',
	        controller: 'MergeController',
	        controllerAs: 'merge'
	    })
	        .state('tree.messages', {
	        url: routeBase + '/messages',
	        templateUrl: 'app/messages/messages.html',
	        controller: 'MessagesController',
	        controllerAs: 'messages'
	    })
	        .state('tree.notes', {
	        url: routeBase + '/notes/:noteId',
	        templateUrl: 'app/notes/notes.html',
	        controller: 'NotesController',
	        controllerAs: 'notes',
	        params: {
	            squash: true,
	            noteId: ''
	        }
	    })
	        .state('tree.people', {
	        url: routeBase + '/people',
	        templateUrl: 'app/people/people.html',
	        controller: 'PeopleController',
	        controllerAs: 'people'
	    })
	        .state('tree.person', {
	        url: routeBase + '/people/:personId',
	        templateUrl: 'app/person/person.html',
	        controller: 'PersonController',
	        controllerAs: 'person'
	    })
	        .state('tree.sync', {
	        url: routeBase + '/people/:personId/compare',
	        templateUrl: 'app/fsSync/fsSync.html',
	        controller: 'FsSyncController',
	        controllerAs: 'sync'
	    })
	        .state('tree.video', {
	        url: routeBase + '/people/:personId/video',
	        templateUrl: 'app/video/video.html',
	        controller: 'VideoController',
	        controllerAs: 'video'
	    })
	        .state('tree.reports', {
	        url: routeBase + '/reports',
	        templateUrl: 'app/reports/reports.html',
	        controller: 'ReportsController',
	        controllerAs: 'reports'
	    })
	        .state('tree.research-logs', {
	        url: routeBase + '/research-logs',
	        templateUrl: 'app/researchLogs/researchLogs.html',
	        controller: 'ResearchLogsController',
	        controllerAs: 'logs'
	    })
	        .state('tree.research-log', {
	        url: routeBase + '/research-logs/:id?format',
	        templateUrl: 'app/researchLog/researchLog.html',
	        controller: 'ResearchLogController',
	        controllerAs: 'log'
	    })
	        .state('tree.sources', {
	        url: routeBase + '/sources/:sourceId',
	        templateUrl: 'app/sources/sources.html',
	        controller: 'SourcesController',
	        controllerAs: 'sources',
	        params: {
	            squash: true,
	            sourceId: ''
	        }
	    })
	        .state('tree.stories', {
	        url: routeBase + '/stories/:storyId',
	        templateUrl: 'app/stories/stories.html',
	        controller: 'StoriesController',
	        controllerAs: 'stories',
	        params: {
	            squash: true,
	            storyId: ''
	        }
	    })
	        .state('tree.treeSettings', {
	        url: routeBase + '/tree-settings',
	        templateUrl: 'app/treeSettings/treeSettings.html',
	        controller: 'TreeSettingsController',
	        controllerAs: 'tree_settings'
	    })
	        .state('tree.users', {
	        url: routeBase + '/users',
	        templateUrl: 'app/users/users.html',
	        controller: 'UsersController',
	        controllerAs: 'users'
	    })
	        .state('tree.user', {
	        url: routeBase + '/users/:userId',
	        templateUrl: 'app/user/user.html',
	        controller: 'UserController',
	        controllerAs: 'user',
	        params: {
	            squash: true,
	            userId: ''
	        }
	    })
	        .state('tree.warnings', {
	        url: routeBase + '/warnings',
	        templateUrl: 'app/warnings/warnings.html',
	        controller: 'WarningsController',
	        controllerAs: 'warnings'
	    })
	        .state('userSettings', {
	        url: routeBase + '/account',
	        templateUrl: 'app/userSettings/userSettings.html',
	        controller: 'UserSettingsController',
	        controllerAs: 'user_settings'
	    });
	    $urlRouterProvider.otherwise(routeBase + '/');
	}
	exports.default = routerConfig;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";
	runBlock.$inject = ["$window", "$location", "$http", "$templateCache", "$rootScope", "$transitions", "$state", "$log", "$timeout", "$document", "$mdDialog", "$mdToast", "googleAnalyticsId", "segment", "showAds", "partnerToken", "partnerId", "partnerSingleSignon", "partnerLoginPage", "partnerReturnUrlSuffix", "authentication", "currentUserId", "currentUser", "currentTreeId", "rightsFull", "treeUsers", "treeGraphics", "utils"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function runBlock($window, $location, $http, $templateCache, $rootScope, $transitions, $state, $log, $timeout, $document, $mdDialog, $mdToast, googleAnalyticsId, segment, showAds, partnerToken, partnerId, partnerSingleSignon, partnerLoginPage, partnerReturnUrlSuffix, authentication, currentUserId, currentUser, currentTreeId, rightsFull, treeUsers, treeGraphics, utils) {
	    'ngInject';
	    // cache icons
	    $http.get('assets/icons/svgdefs.svg', { cache: $templateCache });
	    var customTitleStates = ['tree.person', 'tree.research-log', 'tree.dna-profile'];
	    if (!!googleAnalyticsId) {
	        $window.ga('create', googleAnalyticsId, 'auto');
	    }
	    if (isIE()) {
	        $mdToast.show($mdToast.simple()
	            .textContent('AmericanAncesTREES works best on modern browsers like Chrome, Firefox, or Edge')
	            .position('top right')
	            .hideDelay(0)
	            .action('X'));
	    }
	    //the ads have not been initialized, they'll be initialized once and then refreshed on page changes
	    var adsInited = false;
	    $transitions.onBefore({}, function () {
	        // cancel any dialogs in case someone clicked on a link in the dialog
	        $mdDialog.cancel();
	    });
	    $transitions.onSuccess({}, function (trans) {
	        // redirect to user-chosen homepage
	        if (trans.$to().name === 'tree') {
	            treeUsers.stream().filter(function (tu) { return !!tu; }).take(1).subscribe(function (tu) {
	                var homepage = tu.preferences['HOMEPAGE'];
	                if (homepage === 'NEWSFEED') {
	                    $state.go('tree.feed');
	                }
	                else if (homepage === 'DNA') {
	                    $state.go('tree.dna-profiles');
	                }
	                else {
	                    $state.go('tree.graph');
	                }
	            });
	            return;
	        }
	        $rootScope.personId = !!$state.params.personId ? utils.decodeId($state.params.personId) : 0;
	        // scroll to the top of the page
	        var treeContent = $document[0].getElementById('tree__content');
	        if (!!treeContent) {
	            treeContent.scrollTop = 0;
	        }
	        // send page change and set title
	        if (!!googleAnalyticsId) {
	            $window.ga('set', 'page', $location.url());
	            $window.ga('send', 'pageview');
	        }
	        segment.page(trans.$to().name);
	        if (customTitleStates.indexOf(trans.$to().name) < 0) {
	            $timeout(function () {
	                $rootScope.title = 'TITLE_' + trans.$to().name;
	            }, 0);
	        }
	        //change the id for the ads
	        showAds.stream().take(1).subscribe(function (isShowAds) {
	            $rootScope.textAdNumber = Math.floor(Math.random() * 2);
	            if (isShowAds) {
	                $timeout(function () {
	                    if (adsInited) {
	                        if (!!$window.googletag && $window.googletag.pubadsReady) {
	                            $window.googletag.pubads().refresh();
	                        }
	                    }
	                    else if (!!$window.googletag && $window.googletag.pubadsReady) {
	                        $window.googletag.cmd.push(function () {
	                            //$window.googletag.display('div-gpt-ad-1516211917293-2');
	                            //if ($mdMedia('gt-sm')) {
	                            $window.googletag.display('div-gpt-ad-1516211917293-0');
	                            $window.googletag.display('div-gpt-ad-1516211917293-1');
	                            //}
	                        });
	                        adsInited = true;
	                    }
	                }, 100);
	            }
	        });
	    });
	    if (!!partnerId && partnerSingleSignon && !partnerToken) {
	        if (partnerLoginPage !== '') {
	            var returnUrl = partnerReturnUrlSuffix ? $window.location.href : '';
	            $window.location.assign(partnerLoginPage + returnUrl);
	        }
	    }
	    else {
	        authentication.setCurrentUser();
	    }
	    var prevUid = 0;
	    var newsPrompt = false;
	    currentUserId.stream().subscribe(function (uid) {
	        if (uid !== prevUid) {
	            prevUid = uid;
	            if (uid > 0) {
	                currentUser.stream().filter(function (u) { return !!u; }).take(1).subscribe(function (user) {
	                    // set up helpscout
	                    if (!!$window.HS) {
	                        $window.HS.beacon.ready(function () {
	                            $window.HS.beacon.identify({
	                                name: user.name,
	                                email: user.email
	                            });
	                        });
	                    }
	                    // set up gosquared
	                    // if (!!$window._gs) {
	                    //   let m = !!user.emailConfirmationDate ? user.emailConfirmationDate.match(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/) : null;
	                    //   let createdAt = !!m ? `${m[1]}-${m[2]}-${m[3]}T${m[4]}:${m[5]}:${m[6]}Z` : new Date().toISOString().substring(0,19)+'Z';
	                    //   $window._gs('identify', {
	                    //     email: user.email,
	                    //     first_name: user.given,
	                    //     last_name: user.surname,
	                    //     username: user.name,
	                    //     created_at: createdAt,
	                    //   });
	                    // }
	                    // track tree open
	                    $timeout(function () {
	                        segment.track('tree.open');
	                    });
	                    // prompt for newsletter
	                    if (!newsPrompt && !partnerId && user.preferences['RC_WEEKLY_EMAIL'] !== 'TRUE' && user.preferences['RC_WEEKLY_PROMPT'] !== 'TRUE') {
	                        currentTreeId.stream().filter(function (treeId) { return treeId > 0; }).take(1).subscribe(function () {
	                            rightsFull.streamLevel().filter(function (level) { return level >= rightsFull.LEVEL_READ; }).take(1).subscribe(function () {
	                                $timeout(function () {
	                                    treeGraphics.ready().flatMap(function () { return treeGraphics.stream(); }).take(1).subscribe(function (treeGraphicsMap) {
	                                        if (!newsPrompt && treeGraphicsMap.size > 0) {
	                                            newsPrompt = true;
	                                            var graphics = Array.from(treeGraphicsMap.values());
	                                            // get the most-recent graphic
	                                            graphics.sort(function (a, b) { return b.createdDate - a.createdDate; });
	                                            utils.dialog(null, 'TreeGraphicController', 'app/components/treeGraphic/treeGraphic.dialog.html', false, {
	                                                graphic: graphics[0],
	                                                subscribePrompt: true
	                                            }).then(function () {
	                                                user.preferences['RC_WEEKLY_EMAIL'] = 'TRUE';
	                                                user.preferences['RC_WEEKLY_PROMPT'] = 'TRUE';
	                                                currentUser.update(user).subscribe(function () {
	                                                    // ignore
	                                                }, function (err) {
	                                                    // ignore
	                                                });
	                                            }, function () {
	                                                // ignore
	                                                user.preferences['RC_WEEKLY_PROMPT'] = 'TRUE';
	                                                currentUser.update(user).subscribe(function () {
	                                                    // ignore
	                                                }, function (err) {
	                                                    // ignore
	                                                });
	                                            });
	                                        }
	                                    });
	                                }, 5000);
	                            });
	                        });
	                    }
	                });
	            }
	        }
	    });
	    function isIE() {
	        return ($window.navigator.appName === 'Microsoft Internet Explorer' && $window.navigator.userAgent.indexOf('MSIE') >= 0) || // IE6-10
	            ($window.navigator.appName === 'Netscape' && $window.navigator.appVersion.indexOf('Trident') >= 0); // IE11
	    }
	}
	exports.default = runBlock;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var PusherProvider = /** @class */ (function () {
	    function PusherProvider() {
	        this.client = null;
	        this.token = null;
	    }
	    PusherProvider.prototype.config = function (key) {
	        this.key = key;
	    };
	    PusherProvider.prototype.$get = ["$window", "$pusher", "$log", "messageBus", "pusherBase", "authToken", function ($window, $pusher, $log, messageBus, pusherBase, authToken) {
	        'ngInject';
	        var self = this;
	        function getClient(subscribe) {
	            // get a new client if we don't have a client or we are subscribing and the tokens are different
	            if (self.client === null || (subscribe && self.token !== authToken.get())) {
	                if (self.client !== null) {
	                    $log.info('pusher.getClient disconnect', self.key, self.token, subscribe);
	                    self.client.disconnect();
	                }
	                self.client = null;
	                self.token = authToken.get();
	                if (self.token === '') {
	                    // ok to be anonymous
	                    //$log.error('pusher client without auth token');
	                    //messageBus.post({msg: 'PUSHER_NO_AUTH'});
	                }
	                else {
	                    $log.debug('pusher.getClient', self.key, self.token, pusherBase);
	                    self.client = $pusher(new $window.Pusher(self.key, {
	                        encrypted: true,
	                        authEndpoint: pusherBase + '/auth/pusher?token=' + self.token
	                    }));
	                }
	            }
	            return self.client;
	        }
	        //return new Pusher();
	        return {
	            subscribe: function (channel) {
	                var client = getClient(true);
	                return !!client ? client.subscribe(channel) : null;
	            },
	            unsubscribe: function (channel) {
	                var client = getClient(false);
	                return !!client ? client.unsubscribe(channel) : null;
	            }
	        };
	    }];
	    return PusherProvider;
	}());
	exports.default = PusherProvider;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential - 2016-2017
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// https://github.com/FamilySearch/temple-codes
	var templeData = {
	    "statusCode": 200,
	    "statusMessage": "OK",
	    "deprecated": null,
	    "version": "1.7.20150306.1936",
	    "temples": {
	        "count": 150,
	        "temple": [
	            {
	                "name": "Aba Nigeria Temple",
	                "code": "ABA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Accra Ghana Temple",
	                "code": "ACCRA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Adelaide Australia Temple",
	                "code": "ADELA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Cardston Alberta Temple",
	                "code": "ALBER",
	                "oldCode": "AL",
	                "requestedCode": null
	            },
	            {
	                "name": "Albuquerque New Mexico Temple",
	                "code": "ALBUQ",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Anchorage Alaska Temple",
	                "code": "ANCHO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Apia Samoa Temple",
	                "code": "APIA",
	                "oldCode": "AP",
	                "requestedCode": null
	            },
	            {
	                "name": "Mesa Arizona Temple",
	                "code": "ARIZO",
	                "oldCode": "AZ",
	                "requestedCode": null
	            },
	            {
	                "name": "Asunción Paraguay Temple",
	                "code": "ASUNC",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Atlanta Georgia Temple",
	                "code": "ATLAN",
	                "oldCode": "AT",
	                "requestedCode": null
	            },
	            {
	                "name": "Buenos Aires Argentina Temple",
	                "code": "BAIRE",
	                "oldCode": "BA",
	                "requestedCode": null
	            },
	            {
	                "name": "Billings Montana Temple",
	                "code": "BILLI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Birmingham Alabama Temple",
	                "code": "BIRMI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Bismarck North Dakota Temple",
	                "code": "BISMA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Bogotá Colombia Temple",
	                "code": "BOGOT",
	                "oldCode": "BG",
	                "requestedCode": null
	            },
	            {
	                "name": "Boise Idaho Temple",
	                "code": "BOISE",
	                "oldCode": "BO",
	                "requestedCode": null
	            },
	            {
	                "name": "Boston Massachusetts Temple",
	                "code": "BOSTO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Bountiful Utah Temple",
	                "code": "BOUNT",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Brigham City Utah Temple",
	                "code": "BRIGH",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Brisbane Australia Temple",
	                "code": "BRISB",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Baton Rouge Louisiana Temple",
	                "code": "BROUG",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Calgary Alberta Temple",
	                "code": "CALGA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Campinas Brazil Temple",
	                "code": "CAMPI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Caracas Venezuela Temple",
	                "code": "CARAC",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Cebu Philippines Temple",
	                "code": "CEBUP",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Chicago Illinois Temple",
	                "code": "CHICA",
	                "oldCode": "CH",
	                "requestedCode": null
	            },
	            {
	                "name": "Ciudad Juárez México Temple",
	                "code": "CIUJU",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Cochabamba Bolivia Temple",
	                "code": "COCHA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Colonia Juárez Chihuahua México Temple",
	                "code": "COLJU",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Columbia South Carolina Temple",
	                "code": "COLSC",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Columbus Ohio Temple",
	                "code": "COLUM",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Concepcion Chile Temple",
	                "code": "CONCE",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Copenhagen Denmark Temple",
	                "code": "COPEN",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Cordoba Argentina Temple",
	                "code": "CORDO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Columbia River Washington Temple",
	                "code": "CRIVE",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Curitiba Brazil Temple",
	                "code": "CURIT",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Dallas Texas Temple",
	                "code": "DALLA",
	                "oldCode": "DA",
	                "requestedCode": null
	            },
	            {
	                "name": "Denver Colorado Temple",
	                "code": "DENVE",
	                "oldCode": "DV",
	                "requestedCode": null
	            },
	            {
	                "name": "Detroit Michigan Temple",
	                "code": "DETRO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Draper Utah Temple",
	                "code": "DRAPE",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Durban South Africa Temple",
	                "code": "DURBA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Edmonton Alberta Temple",
	                "code": "EDMON",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Endowment House",
	                "code": "EHOUS",
	                "oldCode": "EH",
	                "requestedCode": null
	            },
	            {
	                "name": "Fortaleza Brazil Temple",
	                "code": "FORTA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Fort Collins Colorado Temple",
	                "code": "FORTC",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Fort Lauderdale Florida Temple",
	                "code": "FORTL",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Frankfurt Germany Temple",
	                "code": "FRANK",
	                "oldCode": "FR",
	                "requestedCode": null
	            },
	            {
	                "name": "Freiberg Germany Temple",
	                "code": "FREIB",
	                "oldCode": "FD",
	                "requestedCode": null
	            },
	            {
	                "name": "Fresno California Temple",
	                "code": "FRESN",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Fukuoka Japan Temple",
	                "code": "FUKUO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "The Gila Valley Arizona Temple",
	                "code": "GILAV",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Gilbert Arizona Temple",
	                "code": "GILBE",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Guadalajara México Temple",
	                "code": "GUADA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Guatemala City Guatemala Temple",
	                "code": "GUATE",
	                "oldCode": "GA",
	                "requestedCode": null
	            },
	            {
	                "name": "Guayaquil Ecuador Temple",
	                "code": "GUAYA",
	                "oldCode": "GY",
	                "requestedCode": null
	            },
	            {
	                "name": "The Hague Netherlands Temple",
	                "code": "HAGUE",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Halifax Nova Scotia Temple",
	                "code": "HALIF",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Harrison New York Temple",
	                "code": "HARRI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Hartford Connecticut Temple",
	                "code": "HARTF",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Laie Hawaii Temple",
	                "code": "HAWAI",
	                "oldCode": "HA",
	                "requestedCode": null
	            },
	            {
	                "name": "Helsinki Finland Temple",
	                "code": "HELSI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Hermosillo Sonora México Temple",
	                "code": "HERMO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Hong Kong China Temple",
	                "code": "HKONG",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Houston Texas Temple",
	                "code": "HOUST",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Idaho Falls Idaho Temple",
	                "code": "IFALL",
	                "oldCode": "IF",
	                "requestedCode": null
	            },
	            {
	                "name": "Indianapolis Indiana Temple",
	                "code": "INDIA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Johannesburg South Africa Temple",
	                "code": "JOHAN",
	                "oldCode": "JO",
	                "requestedCode": null
	            },
	            {
	                "name": "Jordan River Utah Temple",
	                "code": "JRIVE",
	                "oldCode": "JR",
	                "requestedCode": null
	            },
	            {
	                "name": "Kansas City Missouri Temple",
	                "code": "KANSA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Kiev Ukraine Temple",
	                "code": "KIEV",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Kinshasa Democratic Republic of Congo Temple",
	                "code": "KINSH",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Kona Hawaii Temple",
	                "code": "KONA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Los Angeles California Temple",
	                "code": "LANGE",
	                "oldCode": "LA",
	                "requestedCode": null
	            },
	            {
	                "name": "Lima Peru Temple",
	                "code": "LIMA",
	                "oldCode": "LI",
	                "requestedCode": null
	            },
	            {
	                "name": "Lisbon Portugal Temple",
	                "code": "LISBO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Logan Utah Temple",
	                "code": "LOGAN",
	                "oldCode": "LG",
	                "requestedCode": null
	            },
	            {
	                "name": "London England Temple",
	                "code": "LONDO",
	                "oldCode": "LD",
	                "requestedCode": null
	            },
	            {
	                "name": "Louisville Kentucky Temple",
	                "code": "LOUIS",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Lubbock Texas Temple",
	                "code": "LUBBO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Las Vegas Nevada Temple",
	                "code": "LVEGA",
	                "oldCode": "LV",
	                "requestedCode": null
	            },
	            {
	                "name": "Madrid Spain Temple",
	                "code": "MADRI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Manaus Brazil Temple",
	                "code": "MANAU",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Manhattan New York Temple",
	                "code": "MANHA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Manila Philippines Temple",
	                "code": "MANIL",
	                "oldCode": "MA",
	                "requestedCode": null
	            },
	            {
	                "name": "Manti Utah Temple",
	                "code": "MANTI",
	                "oldCode": "MT",
	                "requestedCode": null
	            },
	            {
	                "name": "Medford Oregon Temple",
	                "code": "MEDFO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Melbourne Australia Temple",
	                "code": "MELBO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Memphis Tennessee Temple",
	                "code": "MEMPH",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Meridian Idaho Temple",
	                "code": "MERI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Mérida México Temple",
	                "code": "MERID",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "México City México Temple",
	                "code": "MEXIC",
	                "oldCode": "MX",
	                "requestedCode": null
	            },
	            {
	                "name": "Meridian Idaho",
	                "code": "MIDAH",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Montevideo Uruguay Temple",
	                "code": "MNTVD",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Monterrey México Temple",
	                "code": "MONTE",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Monticello Utah Temple",
	                "code": "MONTI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Montréal Québec Temple",
	                "code": "MONTR",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Mount Timpanogos Utah Temple",
	                "code": "MTIMP",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Nashville Tennessee Temple",
	                "code": "NASHV",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Nauvoo Illinois Temple",
	                "code": "NAUV2",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Nauvoo Temple (old)",
	                "code": "NAUVO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Newport Beach California Temple",
	                "code": "NBEAC",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Nuku'alofa Tonga Temple",
	                "code": "NUKUA",
	                "oldCode": "TG",
	                "requestedCode": null
	            },
	            {
	                "name": "Hamilton New Zealand Temple",
	                "code": "NZEAL",
	                "oldCode": "NZ",
	                "requestedCode": null
	            },
	            {
	                "name": "Oakland California Temple",
	                "code": "OAKLA",
	                "oldCode": "OK",
	                "requestedCode": null
	            },
	            {
	                "name": "Oaxaca México Temple",
	                "code": "OAXAC",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Ogden Utah Temple",
	                "code": "OGDEN",
	                "oldCode": "OG",
	                "requestedCode": null
	            },
	            {
	                "name": "Oklahoma City Oklahoma Temple",
	                "code": "OKLAH",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Oquirrh Mountain Utah Temple",
	                "code": "OQUIR",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Orlando Florida Temple",
	                "code": "ORLAN",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Porto Alegre Brazil Temple",
	                "code": "PALEG",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Palmyra New York Temple",
	                "code": "PALMY",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Panamá City Panamá Temple",
	                "code": "PANAM",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Papeete Tahiti Temple",
	                "code": "PAPEE",
	                "oldCode": "TA",
	                "requestedCode": null
	            },
	            {
	                "name": "Paris France Temple",
	                "code": "PARIS",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Payson Utah Temple",
	                "code": "PAYSO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Perth Australia Temple",
	                "code": "PERTH",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Philadelphia Pennsylvania Temple",
	                "code": "PHILA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Phoenix Arizona Temple",
	                "code": "PHOEN",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "President's Office",
	                "code": "POFFI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Port-Au-Prince Haitti Temple",
	                "code": "PORTA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Portland Oregon Temple",
	                "code": "PORTL",
	                "oldCode": "PT",
	                "requestedCode": null
	            },
	            {
	                "name": "Preston England Temple",
	                "code": "PREST",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Provo City Center",
	                "code": "PROCC",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Provo Utah Temple",
	                "code": "PROVO",
	                "oldCode": "PV",
	                "requestedCode": null
	            },
	            {
	                "name": "Quetzaltenango Guatemala Temple",
	                "code": "QUETZ",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Raleigh North Carolina Temple",
	                "code": "RALEI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Recife Brazil Temple",
	                "code": "RECIF",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Redlands California Temple",
	                "code": "REDLA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Regina Saskatchewan Temple",
	                "code": "REGIN",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Reno Nevada Temple",
	                "code": "RENO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Rexburg Idaho Temple",
	                "code": "REXBU",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Rio De Janiero Temple",
	                "code": "RIODE",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Rome Italy Temple",
	                "code": "ROMEI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Sacramento California Temple",
	                "code": "SACRA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "San Salvador El Salvador Temple",
	                "code": "SANSA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Santiago Chile Temple",
	                "code": "SANTI",
	                "oldCode": "SN",
	                "requestedCode": null
	            },
	            {
	                "name": "San Antonio Texas Temple",
	                "code": "SANTO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Sapporo Japan Temple",
	                "code": "SAPPO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "San Diego California Temple",
	                "code": "SDIEG",
	                "oldCode": "SA",
	                "requestedCode": null
	            },
	            {
	                "name": "Santo Domingo Dominican Republic Temple",
	                "code": "SDOMI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Seattle Washington Temple",
	                "code": "SEATT",
	                "oldCode": "SE",
	                "requestedCode": null
	            },
	            {
	                "name": "Seoul Korea Temple",
	                "code": "SEOUL",
	                "oldCode": "SO",
	                "requestedCode": null
	            },
	            {
	                "name": "St. George Utah Temple",
	                "code": "SGEOR",
	                "oldCode": "SG",
	                "requestedCode": null
	            },
	            {
	                "name": "San José Costa Rica Temple",
	                "code": "SJOSE",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Salt Lake Temple",
	                "code": "SLAKE",
	                "oldCode": "SL",
	                "requestedCode": null
	            },
	            {
	                "name": "St. Louis Missouri Temple",
	                "code": "SLOUI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Snowflake Arizona Temple",
	                "code": "SNOWF",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "São Paulo Brazil Temple",
	                "code": "SPAUL",
	                "oldCode": "SP",
	                "requestedCode": null
	            },
	            {
	                "name": "St. Paul Minnesota Temple",
	                "code": "SPMIN",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Spokane Washington Temple",
	                "code": "SPOKA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Star Valley Wyoming Temple",
	                "code": "STARV",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Stockholm Sweden Temple",
	                "code": "STOCK",
	                "oldCode": "ST",
	                "requestedCode": null
	            },
	            {
	                "name": "Suva Fiji Temple",
	                "code": "SUVA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Bern Switzerland Temple",
	                "code": "SWISS",
	                "oldCode": "SW",
	                "requestedCode": null
	            },
	            {
	                "name": "Sydney Australia Temple",
	                "code": "SYDNE",
	                "oldCode": "SD",
	                "requestedCode": null
	            },
	            {
	                "name": "Taipei Taiwan Temple",
	                "code": "TAIPE",
	                "oldCode": "TP",
	                "requestedCode": null
	            },
	            {
	                "name": "Tampico México Temple",
	                "code": "TAMPI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Tegucigalpa Honduras Temple",
	                "code": "TEGUC",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Tuxtla Gutiérrez México Temple",
	                "code": "TGUTI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Tijuana México Temple",
	                "code": "TIJUA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Tokyo Japan Temple",
	                "code": "TOKYO",
	                "oldCode": "TK",
	                "requestedCode": null
	            },
	            {
	                "name": "Toronto Ontario Temple",
	                "code": "TORON",
	                "oldCode": "TR",
	                "requestedCode": null
	            },
	            {
	                "name": "Trujillo Peru Temple",
	                "code": "TRUJI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Twin Falls Idaho Temple",
	                "code": "TWINF",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Urdaneta Phillipines Temple",
	                "code": "URDAN",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Vancouver British Columbia Temple",
	                "code": "VANCO",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Veracruz México Temple",
	                "code": "VERAC",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Vernal Utah Temple",
	                "code": "VERNA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Villahermosa México Temple",
	                "code": "VILLA",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Washington D.C. Temple",
	                "code": "WASHI",
	                "oldCode": "WA",
	                "requestedCode": null
	            },
	            {
	                "name": "Winnipeg Manitoba Temple",
	                "code": "WINNI",
	                "oldCode": null,
	                "requestedCode": null
	            },
	            {
	                "name": "Winter Quarters Temple",
	                "code": "WINTE",
	                "oldCode": null,
	                "requestedCode": null
	            }
	        ]
	    }
	};
	var templeCodes = new Map();
	templeData.temples.temple.forEach(function (t) {
	    templeCodes.set(t.code, t.name);
	});
	exports.default = templeCodes;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	autocomplete.$inject = ["$delegate"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function autocomplete($delegate) {
	    'ngInject';
	    var directive = $delegate[0];
	    // need to append to base compile function
	    var compile = directive.compile;
	    // add our custom attribute to the directive's scope
	    angular.extend(directive.scope, {
	        menuContainerClass: '@?mdMenuContainerClass'
	    });
	    // recompile directive and add our class to the virtual repeat container
	    directive.compile = function (element, attr) {
	        var template = compile.apply(this, arguments);
	        var menuContainerClass = attr.mdMenuContainerClass ? attr.mdMenuContainerClass : '';
	        var menuContainer = element.find('md-virtual-repeat-container');
	        menuContainer.addClass(menuContainerClass);
	        // recompile the template
	        return function () {
	            template.apply(this, arguments);
	        };
	    };
	    return $delegate;
	}
	exports.default = autocomplete;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var AcceptInvitationController = /** @class */ (function () {
	    AcceptInvitationController.$inject = ["$log", "$state", "$transition$", "$scope", "partnerId", "partnerSingleSignon", "messageBus", "segment", "currentUserId", "server", "utils"];
	    function AcceptInvitationController($log, $state, $transition$, $scope, partnerId, partnerSingleSignon, messageBus, segment, currentUserId, server, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.partnerId = partnerId;
	        this.partnerSingleSignon = partnerSingleSignon;
	        this.messageBus = messageBus;
	        this.segment = segment;
	        this.server = server;
	        this.utils = utils;
	        this.userId = 0;
	        this.code = $transition$.params().code;
	        var cuSub = currentUserId.stream().subscribe(function (userId) {
	            _this.userId = userId;
	        });
	        segment.track('invitations.open');
	        $scope.$on('$destroy', function () {
	            cuSub.unsubscribe();
	        });
	    }
	    AcceptInvitationController.prototype.accept = function () {
	        var _this = this;
	        if (this.userId > 0) {
	            this.saving = true;
	            // accept invitation
	            this.server.put('/invitations/' + this.code).subscribe(function (response) {
	                _this.saving = false;
	                _this.segment.track('invitations.accept');
	                // goto tree
	                _this.$state.go('tree', { treeId: response.treeId });
	            }, function () {
	                _this.saving = false;
	                _this.messageBus.post({ msg: 'ACCEPT_INVITATION_ERROR', op: "PUT", ctx: "invitations" });
	            });
	        }
	        else {
	            // goto partner home or register w code
	            if (!!this.partnerId && this.partnerSingleSignon) {
	                this.$state.go('home', { code: this.code });
	            }
	            else {
	                this.$state.go('register', { code: this.code });
	            }
	        }
	    };
	    AcceptInvitationController.prototype.signIn = function (ev) {
	        if (!!this.partnerId && this.partnerSingleSignon) {
	            // PARTNER redirect user to your sign-in, then redirect them back here
	        }
	        else {
	            this.utils.dialog(ev, 'SignInController', 'app/components/signIn/signIn.html');
	        }
	    };
	    return AcceptInvitationController;
	}());
	exports.default = AcceptInvitationController;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var AppsController = /** @class */ (function () {
	    AppsController.$inject = ["$state", "$transition$", "segment", "currentTree", "rightsFull", "utils"];
	    function AppsController($state, $transition$, segment, currentTree, rightsFull, utils) {
	        'ngInject';
	        this.$state = $state;
	        this.segment = segment;
	        this.currentTree = currentTree;
	        this.utils = utils;
	        var init = $transition$.params().init;
	        this.returnId = $transition$.params().return;
	        if (!!init) {
	            utils.alert('Install the Web Clipper browser extension', 'The WebClipper instantly copies records from the major genealogy websites into your tree. ' +
	                'Spend less time entering data and more time discovering!');
	        }
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            if (level < rightsFull.LEVEL_READ) {
	                $state.go('tree');
	            }
	        });
	    }
	    AppsController.prototype.click = function (app) {
	        this.segment.track('apps.' + app);
	    };
	    AppsController.prototype.go = function (ev) {
	        var _this = this;
	        this.currentTree.stream().take(1).flatMap(function (tree) {
	            tree = _this.utils.clone(tree);
	            tree.preferences.APPS_REVIEWED = 'TRUE';
	            return _this.currentTree.update(tree);
	        }).subscribe(function () {
	            if (!!_this.returnId) {
	                _this.$state.go('tree.person', { personId: _this.returnId });
	            }
	            else {
	                _this.$state.go('tree');
	            }
	        });
	    };
	    return AppsController;
	}());
	exports.default = AppsController;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var ConfirmEmailController = /** @class */ (function () {
	    ConfirmEmailController.$inject = ["$state", "$transition$", "$scope", "authentication", "messageBus"];
	    function ConfirmEmailController($state, $transition$, $scope, authentication, messageBus) {
	        'ngInject';
	        var _this = this;
	        this.$state = $state;
	        this.confirmed = false;
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        var email = $transition$.params().email;
	        var key = $transition$.params().key;
	        authentication.confirmEmail(email, key).subscribe(function () {
	            _this.msg = '';
	            _this.confirmed = true;
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    ConfirmEmailController.prototype.go = function () {
	        this.$state.go('home');
	    };
	    return ConfirmEmailController;
	}());
	exports.default = ConfirmEmailController;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var CreateController = /** @class */ (function () {
	    CreateController.$inject = ["$log", "$state", "$scope", "$rootScope", "currentTree", "segment", "subscriptions", "messageBus", "utils"];
	    function CreateController($log, $state, $scope, $rootScope, currentTree, segment, subscriptions, messageBus, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.currentTree = currentTree;
	        this.latestTreeId = $rootScope.latestTreeId;
	        this.segment = segment;
	        this.subscriptions = subscriptions;
	        this.utils = utils;
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            _this.msg = msg;
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	        this.treePrivacy = "PUBLIC";
	    }
	    CreateController.prototype.ready = function () {
	        return !!this.treeName && !!this.treePrivacy && !!this.action;
	        // return !!this.treeName && !!this.action; /* Sushil*/
	    };
	    CreateController.prototype.gedcomTip = function (ev) {
	        this.utils.alert('What is a GEDCOM?', 'A GEDCOM is a way to migrate your family tree from one platform to another. ' +
	            'Nearly every desktop and online family tree program has a way to export your tree as a GEDCOM. ' +
	            'Once you\'ve exported a GEDCOM file, you can import it here.', ev);
	    };
	    CreateController.prototype.go = function (ev) {
	        var _this = this;
	        this.msg = '';
	        if (!this.treeName) {
	            this.utils.alert('You must enter a name for your tree');
	            return;
	        }
	        if (!this.treePrivacy) {
	            this.utils.alert('You must select public or private');
	            return;
	        }
	        if (!this.action) {
	            this.utils.alert('You must choose to start with an empty tree, import a GEDCOM, or import from FamilySearch');
	            return;
	        }
	        this.saving = true;
	        this.subscriptions.stream().filter(function (sub) { return !!sub; }).take(1).subscribe(function (sub) {
	            if (_this.treePrivacy === 'PRIVATE' && !(sub.level === 'PRO' || sub.level === 'PRO_TRIAL')) {
	                _this.utils.confirm('Pro Plan required', 'You need a Pro Plan to create a private tree. Is it time to upgrade?', ev, 'Upgrade').then(function () {
	                    _this.$state.go('userSettings');
	                }, function () {
	                    _this.saving = false;
	                });
	            }
	            else {
	                var tree = {
	                    name: _this.treeName,
	                    privacy: _this.treePrivacy,
	                    preferences: {
	                        LEADS_FOR_EOL: 'TRUE',
	                        LEADS_FOR_DL: 'TRUE'
	                    }
	                };
	                switch (_this.action) {
	                    case 'GEDCOM':
	                        _this._create(tree, 'tree.import-gedcom');
	                        break;
	                    case 'FS':
	                        _this._create(tree, 'tree.import-fs');
	                        break;
	                    case 'NO':
	                        _this._create(tree, 'tree.import-scratch');
	                        break;
	                }
	            }
	        });
	    };
	    CreateController.prototype._create = function (tree, state) {
	        var _this = this;
	        this.currentTree.create(tree).subscribe(function (tree) {
	            _this.saving = false;
	            _this.$state.go(state, { treeId: tree.id });
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    return CreateController;
	}());
	exports.default = CreateController;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var warnThreshold = 100000;
	var DNAProfilesController = /** @class */ (function () {
	    DNAProfilesController.$inject = ["$log", "$scope", "$rootScope", "$state", "rx", "messageBus", "rightsFull", "dnaProfiles", "dnaProfileDatas", "dnaKits", "persons", "users", "utils", "currentTreeId", "server", "partnerId"];
	    function DNAProfilesController($log, $scope, $rootScope, $state, rx, messageBus, rightsFull, dnaProfiles, dnaProfileDatas, dnaKits, persons, users, utils, currentTreeId, server, partnerId) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.utils = utils;
	        this.headers = [
	            { label: 'Name / ID', width: 20, property: 'name', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, link: { prefix: 'tree.dna-profile', field: 'id' } },
	            { label: 'Description', width: 20, property: 'description', type: 'string', filterable: true, sortable: true, link: { prefix: 'tree.dna-profile', field: 'id' } },
	            { label: 'Source', width: 20, property: '_source', type: 'string', filterable: true, sortable: true },
	            { label: 'Person', width: 30, property: '_person', type: 'person', filterable: true, sortable: true },
	            { label: 'Archived', width: 10, property: 'archived', type: 'bool', filterable: true, sortable: true }
	        ];
	        this.showAd = !partnerId;
	        this.items = new Map();
	        var subscription = utils.readyChange(dnaProfiles, persons, users).subscribe(function (_a) {
	            var _b = __read(_a, 1), profileMap = _b[0];
	            _this.$log.debug('dnaProfiles.change');
	            server.get('/trees/' + currentTreeId.get().toString() + '/dna_kits/count').subscribe(function (response) {
	                _this.countKits = response.count;
	                if (_this.countKits > warnThreshold && !$rootScope.warnDNAKitsThreshold) {
	                    utils.alert('Consider archiving some profiles', 'You currently have ' + _this.countKits + ' unarchived DNA Kits. You may experience slow-downs with this many kits. ' +
	                        'Consider archiving profiles you aren\'t currently using.');
	                    $rootScope.warnDNAKitsThreshold = true;
	                }
	            });
	            _this.items = new Map();
	            Array.from(profileMap.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], profile = _b[1];
	                if (!!profile) {
	                    dnaProfiles.augmentDNAProfile(profile, persons, users).subscribe(function (profile) {
	                        if (!!profile) {
	                            _this.items.set(id, profile);
	                        }
	                    }, {});
	                }
	            });
	        }, {});
	        var rSub = rightsFull.stream().subscribe(function (rights) {
	            _this.ownerIsPro = (rights.ownerSubscriptionLevel === 'PRO' || rights.ownerSubscriptionLevel === 'PRO_TRIAL');
	        }, {});
	        $scope.$on('$destroy', function () {
	            subscription.unsubscribe();
	            rSub.unsubscribe();
	        });
	        $scope.$on('add', function (ev, params) {
	            utils.dialog(params.ev, 'EditDNAProfileController', 'app/components/editDNAProfile/editDNAProfile.html', false, {}).then(function (profile) {
	                $state.go('tree.dna-profile', { id: utils.encodeId(profile.id) });
	            }, {});
	        });
	        $scope.$on('save', function (ev, params) {
	            (_a = rx.Observable).forkJoin.apply(_a, __spread(params.items.map(function (item) {
	                return dnaProfiles.update(item);
	            }))).subscribe(function () {
	                dnaProfileDatas.reset();
	                dnaKits.reset();
	            }, function (err) {
	                messageBus.post({ msg: err });
	            });
	            var _a;
	        });
	    }
	    return DNAProfilesController;
	}());
	exports.default = DNAProfilesController;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	var DNAProfileController = /** @class */ (function () {
	    DNAProfileController.$inject = ["$log", "$scope", "$state", "$location", "$transition$", "$timeout", "$rootScope", "rx", "currentTree", "messageBus", "rightsFull", "dnaProfiles", "dnaProfileDatas", "dnaKits", "dnaParsers", "persons", "users", "utils"];
	    function DNAProfileController($log, $scope, $state, $location, $transition$, $timeout, $rootScope, rx, currentTree, messageBus, rightsFull, dnaProfiles, dnaProfileDatas, dnaKits, dnaParsers, persons, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$location = $location;
	        this.rx = rx;
	        this.messageBus = messageBus;
	        this.dnaProfiles = dnaProfiles;
	        this.dnaProfileDatas = dnaProfileDatas;
	        this.dnaKits = dnaKits;
	        this.dnaParsers = dnaParsers;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.id = utils.decodeId($transition$.params().id);
	        this.view = $transition$.params().view || 'list';
	        this.selectedKits = new Map();
	        this.kitMatches = new Map();
	        this.pedigree = null;
	        this.pedigreeGenerations = 6;
	        this.filters = this.decodeFilters($transition$.params());
	        this.numFilters = this.dnaProfileDatas.countFilters(this.filters);
	        this.toolbarExpanded = true;
	        this.highlighted = [];
	        this.colorLabels = new Map();
	        this.leaving = false;
	        currentTree.stream().filter(function (t) { return !!t; }).take(1).subscribe(function (tree) {
	            _this.colorLabels['1'] = tree.preferences.COLOR_LABEL_1;
	            _this.colorLabels['2'] = tree.preferences.COLOR_LABEL_2;
	            _this.colorLabels['3'] = tree.preferences.COLOR_LABEL_3;
	            _this.colorLabels['4'] = tree.preferences.COLOR_LABEL_4;
	            _this.colorLabels['5'] = tree.preferences.COLOR_LABEL_5;
	            _this.colorLabels['6'] = tree.preferences.COLOR_LABEL_6;
	        });
	        var pSub = utils.readyChange(dnaProfiles, persons, users).subscribe(function () {
	            dnaProfiles.streamId(_this.id).flatMap(function (profile) {
	                return dnaProfiles.augmentDNAProfile(profile, persons, users);
	            }).take(1).subscribe(function (profile) {
	                if (!!profile) {
	                    _this.dnaProfile = profile;
	                    if (_this.dnaProfile.archived) {
	                        $timeout(function () {
	                            if (!_this.leaving) {
	                                _this.edit();
	                            }
	                        }, 250);
	                    }
	                    dnaProfiles.getPedigree(_this.dnaProfile.personId).subscribe(function (pedigree) {
	                        _this.pedigree = pedigree;
	                    });
	                    $timeout(function () {
	                        $rootScope.title = profile.name;
	                    }, 0);
	                }
	            });
	        });
	        var rSub = rightsFull.stream().subscribe(function (rights) {
	            _this.ownerIsPro = (rights.ownerSubscriptionLevel === 'PRO' || rights.ownerSubscriptionLevel === 'PRO_TRIAL');
	        });
	        var dpdSub = dnaProfiles.streamId(this.id)
	            .flatMap(function (profile) { return _this.streamDNAProfileData().map(function (dpds) {
	            return {
	                profile: profile,
	                dpds: dpds,
	            };
	        }); })
	            .flatMap(function (data) { return dnaKits.stream().map(function (kitMap) {
	            return {
	                profile: data.profile,
	                list: data.dpds.find(function (dpd) { return dpd.type === 'LIST'; }),
	                triangulation: data.dpds.find(function (dpd) { return dpd.type === 'TRIANGULATION'; }),
	                kitMap: kitMap
	            };
	        }); }).subscribe(function (data) {
	            _this.allKits = [];
	            _this.kitCMs = new Map();
	            if (!!data.profile && !!data.list && !!data.list.tsv) {
	                var list = _this.dnaParsers.tsvToList(_this.dnaProfiles.listTSVHeaders[data.profile.source], _this.dnaProfiles.listTSVNumbers[data.profile.source], data.list.tsv);
	                var kitMap = _this.dnaProfiles.kitsByName(data.kitMap, data.profile.source);
	                try {
	                    for (var list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
	                        var item = list_1_1.value;
	                        var kit = kitMap.get(item.name);
	                        if (!!kit) {
	                            _this.allKits.push(kit);
	                            if (item.autoTotal > 0) {
	                                _this.kitCMs.set(item.name, [item.autoTotal, item.autoLargest || item.autoTotal]);
	                            }
	                        }
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	            }
	            //if (!!data.segment && !!data.segment.tsv) {
	            //  let allKitNames = new Set(this.allKits.map(kit => kit.name));
	            //  let segments = this.dnaParsers.tsvToList(this.dnaProfiles.segmentTSVHeaders[data.profile.source],
	            //                                           this.dnaProfiles.segmentTSVNumbers[data.profile.source], data.segment.tsv);
	            //  for (let segment of segments) {
	            //    if (allKitNames.has(segment.name) && !Number.isNaN(segment.chr) && !Number.isNaN(segment.start) && !Number.isNaN(segment.end) && !Number.isNaN(segment.cm)) {
	            //      let cms = this.kitCMs.get(segment.name) || 0;
	            //      this.kitCMs.set(segment.name, cms + segment.cm);
	            //    }
	            //  }
	            //}
	            _this.links = [];
	            if (!!data.triangulation && !!data.triangulation.tsv) {
	                _this.links = _this.dnaParsers.tsvToList(_this.dnaProfiles.triangulationTSVHeaders[data.profile.source], _this.dnaProfiles.triangulationTSVNumbers[data.profile.source], data.triangulation.tsv);
	            }
	            var e_1, _a;
	        });
	        $scope.$watchGroup([function () { return _this.pedigree; }, function () { return _this.allKits; }], function () {
	            if (!!_this.pedigree && !!_this.allKits) {
	                var matchStreams = _this.allKits.filter(function (kit) { return kit.personId1 || kit.personId2; }).map(function (kit) {
	                    var pids = [];
	                    if (kit.personId1) {
	                        pids.push(kit.personId1);
	                    }
	                    if (kit.personId2) {
	                        pids.push(kit.personId2);
	                    }
	                    return dnaProfiles.getMatches(_this.pedigree, pids).map(function (matches) {
	                        matches = matches.map(function (match) {
	                            // we can't match beyond what we show, so bring it down
	                            while (match >= 128) {
	                                match = match >>> 1; // jshint ignore:line
	                            }
	                            return match;
	                        });
	                        var pids = Array.from(_this.pedigree.entries())
	                            .filter(function (_a) {
	                            var _b = __read(_a, 2), id = _b[0], pos = _b[1];
	                            return matches.includes(pos);
	                        })
	                            .map(function (_a) {
	                            var _b = __read(_a, 2), id = _b[0], pos = _b[1];
	                            return id;
	                        }); //eslint-disable-line
	                        return [kit.id, pids];
	                    });
	                });
	                var matchStream = matchStreams.length > 0 ? (_a = rx.Observable).forkJoin.apply(_a, __spread(matchStreams)) : rx.Observable.of([]);
	                matchStream.subscribe(function (matches) {
	                    _this.kitMatches = new Map(matches);
	                    _this._applyFilters(_this.filters);
	                });
	            }
	            var _a;
	        });
	        $scope.$on('selected-kits', function (ev, params) {
	            _this.selectedKits = params;
	        });
	        $scope.$on('kit-edited', function (ev, params) {
	            $scope.$broadcast('edited', params);
	        });
	        $scope.$on('zoomChange', function (ev, params) {
	            $scope.$broadcast('zoom', params);
	        });
	        $scope.$on('expandChange', function (ev, params) {
	            $scope.$broadcast('expand', params);
	        });
	        $scope.$on('searchChange', function (ev, params) {
	            _this.highlighted = _this.dnaKits.search(params, _this.kits, true).map(function (kit) { return kit.name; });
	        });
	        $scope.$on('toolbarExpanded', function (ev, params) {
	            _this.toolbarExpanded = params;
	        });
	        $scope.$on('filter', function (ev, params) {
	            _this.filter(params.ev);
	        });
	        $scope.$on('showArchived', function (ev, params) {
	            _this._applyFilters(params.showArchived ? { showHidden: true } : _this.filters);
	        });
	        $scope.$on('loadFilter', function (ev, params) {
	            _this.utils.dialog(params.ev, 'LoadSaveFiltersController', 'app/components/loadSaveFilters/loadSaveFilters.html', true, {
	                save: false,
	                filenames: Array.from(_this.dnaProfile.filters.keys())
	            }).then(function (result) {
	                if (!!result.filename) {
	                    _this.filters = _this.decodeFilters(JSON.parse(_this.dnaProfile.filters.get(result.filename)));
	                    _this.applyFilters(_this.filters);
	                }
	            }, function () {
	                // pass
	            });
	        });
	        $scope.$on('saveFilter', function (ev, params) {
	            _this.utils.dialog(params.ev, 'LoadSaveFiltersController', 'app/components/loadSaveFilters/loadSaveFilters.html', true, {
	                save: true,
	                filenames: Array.from(_this.dnaProfile.filters.keys())
	            }).then(function (result) {
	                result.remove.forEach(function (filename) {
	                    _this.dnaProfile.filters.delete(filename);
	                });
	                if (!!result.filename) {
	                    _this.dnaProfile.filters.set(result.filename, JSON.stringify(_this.encodeFilters(_this.filters)));
	                }
	                _this.dnaProfiles.update(_this.dnaProfile).subscribe(function () {
	                    _this.messageBus.post({ msg: 'Filters have been saved' });
	                });
	            }, function () {
	                // pass
	            });
	        });
	        $scope.$on('match', function (ev, params) {
	            var kit = _this.allKits.find(function (kit) { return kit.id === params.item._id; });
	            _this.utils.dialog(params.ev, 'EditDNAKitController', 'app/components/editDNAKit/editDNAKit.html', false, {
	                kit: kit,
	                tab: 2,
	                dnaProfile: _this.dnaProfile,
	                pedigree: _this.pedigree
	            }).then(function (kit) {
	                $scope.$emit('kit-edited', kit);
	            });
	        });
	        $scope.$on('$destroy', function () {
	            pSub.unsubscribe();
	            rSub.unsubscribe();
	            dpdSub.unsubscribe();
	        });
	    }
	    DNAProfileController.prototype.streamDNAProfileData = function () {
	        var _this = this;
	        return this.dnaProfileDatas.stream().map(function (dpdMap) { return Array.from(dpdMap.values()).filter(function (dpd) {
	            return dpd.profileId === _this.id && (dpd.type === 'LIST' || dpd.type === 'TRIANGULATION');
	        }); });
	    };
	    DNAProfileController.prototype.switchView = function (view) {
	        this.view = view;
	        this.selectedKits = new Map();
	        this.updateState();
	    };
	    DNAProfileController.prototype.updateState = function () {
	        var params = Object.assign({ view: this.view, id: this.utils.encodeId(this.id) }, this.encodeFilters(this.filters));
	        this.$state.go('tree.dna-profile', params);
	    };
	    DNAProfileController.prototype.filter = function (ev, filters, msg) {
	        var _this = this;
	        this.utils.dialog(ev, 'DNAFilterController', 'app/components/dnaFilter/dnaFilter.html', true, {
	            source: this.dnaProfile.source,
	            kits: this.allKits,
	            kitCMs: this.kitCMs,
	            links: this.links,
	            kitMatches: this.kitMatches,
	            filters: filters || this.filters,
	            personId: this.dnaProfile.personId,
	            msg: msg
	        }).then(function (filters) {
	            _this.filters = filters;
	            _this.applyFilters(filters);
	        }, function () {
	            // ignore
	        });
	    };
	    DNAProfileController.prototype.includeKits = function (ev) {
	        var filters = this.utils.clone(this.filters);
	        try {
	            for (var _a = __values(this.selectedKits.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var id = _b.value;
	                if (!filters.includeKits.includes(id)) {
	                    filters.includeKits.push(id);
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        this.filter(ev, filters, 'Review matches to include and click Save.');
	        this.toolbarExpanded = true;
	        var e_2, _c;
	    };
	    DNAProfileController.prototype.excludeKits = function (ev) {
	        var filters = this.utils.clone(this.filters);
	        try {
	            for (var _a = __values(this.selectedKits.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var id = _b.value;
	                if (!filters.excludeKits.includes(id)) {
	                    filters.excludeKits.push(id);
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        this.filter(ev, filters, 'Review matches to exclude and click Save.');
	        this.toolbarExpanded = true;
	        var e_3, _c;
	    };
	    DNAProfileController.prototype.applyFilters = function (filters) {
	        this.numFilters = this.dnaProfileDatas.countFilters(filters);
	        this._applyFilters(filters);
	        this.updateState();
	    };
	    DNAProfileController.prototype._applyFilters = function (filters) {
	        this.kits = this.dnaProfileDatas.applyFilters(filters, this.allKits, this.kitCMs, this.links, this.kitMatches);
	        if (this.kits.length === 0 && this.allKits.length > 0 && !filters.showHidden) {
	            this.messageBus.post({ msg: 'All kits are hidden by filters.' });
	        }
	    };
	    DNAProfileController.prototype.encodeFilters = function (filters) {
	        var encoded = {};
	        if (!!filters && filters.min > 0) {
	            encoded['min'] = filters.min;
	        }
	        else {
	            encoded['min'] = null;
	        }
	        if (!!filters && filters.max < 9999) {
	            encoded['max'] = filters.max;
	        }
	        else {
	            encoded['max'] = null;
	        }
	        if (!!filters && !!filters.cmRange && filters.cmRange !== 'total') {
	            encoded['cm_range'] = filters.cmRange;
	        }
	        else {
	            encoded['cm_range'] = null;
	        }
	        if (!!filters && filters.includeKits.length > 0) {
	            encoded['include'] = filters.includeKits.join(',');
	        }
	        else {
	            encoded['include'] = null;
	        }
	        if (!!filters && filters.includeDegrees !== 1) {
	            encoded['in_degrees'] = filters.includeDegrees.toString();
	        }
	        else {
	            encoded['in_degrees'] = null;
	        }
	        if (!!filters && filters.excludeKits.length > 0) {
	            encoded['exclude'] = filters.excludeKits.join(',');
	        }
	        else {
	            encoded['exclude'] = null;
	        }
	        if (!!filters && filters.excludeDegrees !== 1) {
	            encoded['ex_degrees'] = filters.excludeDegrees.toString();
	        }
	        else {
	            encoded['ex_degrees'] = null;
	        }
	        if (!!filters && filters.includePIDs.length > 0) {
	            encoded['include_pids'] = filters.includePIDs.join(',');
	        }
	        else {
	            encoded['include_pids'] = null;
	        }
	        if (!!filters && filters.excludePIDs.length > 0) {
	            encoded['exclude_pids'] = filters.excludePIDs.join(',');
	        }
	        else {
	            encoded['exclude_pids'] = null;
	        }
	        if (!!filters) {
	            encoded['keywords'] = filters.keywords;
	        }
	        else {
	            encoded['keywords'] = null;
	        }
	        return encoded;
	    };
	    DNAProfileController.prototype.decodeFilters = function (encoded) {
	        var filters = {};
	        filters.min = !!encoded.min ? +encoded.min : 0;
	        filters.max = !!encoded.max ? +encoded.max : 9999;
	        filters.cmRange = encoded.cmRange || 'total';
	        filters.includeKits = !!encoded.include ? encoded.include.split(',').map(function (id) { return +id; }) : [];
	        filters.excludeKits = !!encoded.exclude ? encoded.exclude.split(',').map(function (id) { return +id; }) : [];
	        filters.includeDegrees = !!encoded.in_degrees ? +encoded.in_degrees : 1;
	        filters.excludeDegrees = !!encoded.ex_degrees ? +encoded.ex_degrees : 1;
	        filters.includePIDs = !!encoded.include_pids ? encoded.include_pids.split(',').map(function (id) { return +id; }) : [];
	        filters.excludePIDs = !!encoded.exclude_pids ? encoded.exclude_pids.split(',').map(function (id) { return +id; }) : [];
	        filters.keywords = encoded.keywords || '';
	        return filters;
	    };
	    DNAProfileController.prototype.addConnectedKits = function () {
	        var selectedKits = new Map();
	        try {
	            for (var _a = __values(this.selectedKits.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var k = _b.value;
	                selectedKits.set(k.id, k);
	                this.getLinkedKits(k.name).forEach(function (kit) {
	                    if (!selectedKits.has(kit.id)) {
	                        selectedKits.set(kit.id, { id: kit.id, name: kit.name, open: false });
	                    }
	                });
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        this.selectedKits = selectedKits;
	        var e_4, _c;
	    };
	    DNAProfileController.prototype.getLinkedKits = function (name) {
	        var _this = this;
	        return this.links
	            .filter(function (l) { return l.kit1 === name || l.kit2 === name; })
	            .map(function (l) { return _this.kits.find(function (kit) { return kit.name === (l.kit1 === name ? l.kit2 : l.kit1); }); })
	            .filter(function (kit) { return !!kit; });
	    };
	    DNAProfileController.prototype.matchKits = function (ev) {
	        var _this = this;
	        this.utils.dialog(ev, 'EditDNAMatchesController', 'app/components/editDNAMatches/editDNAMatches.html', false, {
	            kits: Array.from(this.selectedKits.values()).map(function (k) { return _this.allKits.find(function (kit) { return kit.id === k.id; }); }),
	            dnaProfile: this.dnaProfile,
	            pedigree: this.pedigree
	        }).then(function (kits) {
	            try {
	                for (var kits_1 = __values(kits), kits_1_1 = kits_1.next(); !kits_1_1.done; kits_1_1 = kits_1.next()) {
	                    var kit = kits_1_1.value;
	                    _this.$scope.$emit('kit-edited', kit);
	                }
	            }
	            catch (e_5_1) { e_5 = { error: e_5_1 }; }
	            finally {
	                try {
	                    if (kits_1_1 && !kits_1_1.done && (_a = kits_1.return)) _a.call(kits_1);
	                }
	                finally { if (e_5) throw e_5.error; }
	            }
	            var e_5, _a;
	        });
	    };
	    DNAProfileController.prototype.add = function (ev) {
	        this.$scope.$broadcast('add', { ev: ev });
	    };
	    DNAProfileController.prototype.edit = function (ev) {
	        var _this = this;
	        var archived = this.dnaProfile.archived;
	        this.utils.dialog(ev, 'EditDNAProfileController', 'app/components/editDNAProfile/editDNAProfile.html', false, {
	            dnaProfile: this.dnaProfile
	        }).then(function (dnaProfile) {
	            if (dnaProfile.archived) {
	                _this.leaving = true;
	                _this.$state.go('tree.dna-profiles');
	            }
	        }, function () {
	            if (_this.dnaProfile.archived) {
	                _this.leaving = true;
	                _this.$state.go('tree.dna-profiles');
	            }
	        });
	    };
	    DNAProfileController.prototype.del = function (ev) {
	        var _this = this;
	        // get all dna profiles, dna profile datas, dna kits
	        this.utils.readyChange(this.dnaProfiles, this.dnaProfileDatas, this.dnaKits).take(1).subscribe(function (_a) {
	            var _b = __read(_a, 3), profileMap = _b[0], dpdMap = _b[1], kitMap = _b[2];
	            // tell user about possibly deleted kits
	            _this.utils.confirm('Delete Profile: ' + _this.dnaProfile.name, 'All DNA Kits that are attached only to this profile will also be deleted. Are you sure?', ev).then(function () {
	                // delete this profile
	                _this.dnaProfiles.del(_this.dnaProfile.id).subscribe(function () {
	                    _this.leaving = true;
	                    _this.dnaKits.reset();
	                    _this.$state.go('tree.dna-profiles');
	                }, function () {
	                    // ignore
	                });
	            }, function () {
	                // ignore
	            });
	        });
	    };
	    return DNAProfileController;
	}());
	exports.default = DNAProfileController;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EvidencesController = /** @class */ (function () {
	    EvidencesController.$inject = ["$log", "$scope", "$transition$", "$timeout", "evidences", "sources", "persons", "users", "evidenceUtils", "utils"];
	    function EvidencesController($log, $scope, $transition$, $timeout, evidences, sources, persons, users, evidenceUtils, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.evidenceId = utils.decodeId($transition$.params().evidenceId);
	        this.evidences = evidences;
	        this.sources = sources;
	        this.persons = persons;
	        this.users = users;
	        this.evidenceUtils = evidenceUtils;
	        this.utils = utils;
	        this.headers = [
	            { label: 'Type', width: 15, property: '_type', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, show: true },
	            { label: 'Date', width: 15, property: '_date', type: 'date', filterable: true, sortable: true, sort: 2, defaultSort: true },
	            { label: 'Place', width: 20, property: '_place', type: 'string', filterable: true, sortable: true },
	            { label: 'Source', width: 25, property: '_sourceTitle', type: 'string', filterable: true, sortable: true, show: true, altType: 'source' },
	            { label: 'People', width: 25, property: '_people', type: 'people', filterable: true }
	        ];
	        this.items = new Map();
	        var pw = utils.pleaseWait();
	        var subscription = utils.readyChange(evidences, sources, persons).subscribe(function (_a) {
	            var _b = __read(_a, 1), evidenceMap = _b[0];
	            _this.$log.debug('evidences.change');
	            _this.items = new Map();
	            Array.from(evidenceMap.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], evidence = _b[1];
	                evidences.augmentEvidence(evidence, sources, persons, null).subscribe(function (evidence) {
	                    _this.items.set(id, evidence);
	                });
	            });
	            utils.pleaseWaitCancel(pw);
	        });
	        $scope.$on('$destroy', function () {
	            subscription.unsubscribe();
	        });
	        $scope.$on('add', function (ev, params) {
	            utils.dialog(params.ev, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {});
	        });
	        $scope.$on('edit', function (ev, params) {
	            _this.utils.dialog(params.ev, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	                evidence: params.item
	            });
	        });
	        $scope.$on('show', function (ev, params) {
	            switch (params.type) {
	                case 'source':
	                    _this.utils.showSource(params.ev, sources, evidences, users, params.id);
	                    break;
	            }
	        });
	        $scope.$on('delete', function (ev, params) {
	            _this.utils.confirm('Delete Supporting Evidence', 'Are you sure?', params.ev).then(function () {
	                _this.evidences.streamId(params.id).take(1).subscribe(function (evidence) {
	                    _this.evidences.augmentEvidence(evidence, _this.sources, _this.persons, _this.users).subscribe(function (evidence) {
	                        var deletedNamesFacts = _this.evidenceUtils.getDeletedNamesFacts([evidence], [], true);
	                        if (deletedNamesFacts.filter(function (nf) { return nf.principal && nf.unsupported; }).length > 0) {
	                            _this.utils.dialog(null, 'SelectNamesFactsController', 'app/components/selectNamesFacts/selectNamesFacts.html', false, {
	                                namesFacts: deletedNamesFacts
	                            }).then(function (deletedNamesFacts) {
	                                _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	                            }, function () {
	                                // ignore
	                            });
	                        }
	                        else {
	                            _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	                        }
	                    });
	                });
	            }, function () {
	                // ignore
	            });
	        });
	    }
	    return EvidencesController;
	}());
	exports.default = EvidencesController;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var ExportsController = /** @class */ (function () {
	    ExportsController.$inject = ["$log", "$transition$", "currentUserId", "server", "messageBus", "currentTreeId", "authToken"];
	    function ExportsController($log, $transition$, currentUserId, server, messageBus, currentTreeId, authToken) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        var exportId = $transition$.params().exportId;
	        this.url = '';
	        currentUserId.stream().take(1).subscribe(function (id) {
	            if (id === 0) {
	                messageBus.post({ msg: 'NOT_LOGGED_IN', op: 'GET', ctx: 'exports' });
	            }
	        });
	        currentUserId.stream().filter(function (id) { return id > 0; }).take(1).subscribe(function () {
	            server.get('/trees/' + currentTreeId.get() + '/exports/' + exportId + '?token=' + authToken.get()).subscribe(function (exp) {
	                _this.url = exp.url;
	            }, function (err) {
	                messageBus.post({ msg: err.data, op: 'GET', ctx: 'exports', warn: true });
	            });
	        });
	    }
	    return ExportsController;
	}());
	exports.default = ExportsController;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var FeedController = /** @class */ (function () {
	    FeedController.$inject = ["$log", "$scope", "$mdMedia", "$state", "rightsFull", "bookmarks", "currentTree", "evidences", "leads", "medias", "notes", "persons", "sources", "stories", "users", "feed", "evidenceUtils", "mediaUtils", "utils"];
	    function FeedController($log, $scope, $mdMedia, $state, rightsFull, bookmarks, currentTree, evidences, leads, medias, notes, persons, sources, stories, users, feed, evidenceUtils, mediaUtils, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdMedia = $mdMedia;
	        this.$state = $state;
	        this.evidencesService = evidences;
	        this.leadsService = leads;
	        this.mediasService = medias;
	        this.notesService = notes;
	        this.personsService = persons;
	        this.sourcesService = sources;
	        this.storiesService = stories;
	        this.usersService = users;
	        this.feedService = feed;
	        this.evidenceUtils = evidenceUtils;
	        this.mediaUtils = mediaUtils;
	        this.utils = utils;
	        this.pageSize = 50;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.numLoaded = this.pageSize;
	        this.expanded = new Map();
	        this.stats = {
	            countPeople: 0,
	            countMedia: 0,
	            countStories: 0,
	            countEvidences: 0,
	            countNotes: 0,
	            countHints: 0
	        };
	        var rSub = rightsFull.streamLevel().subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        var bSub = this.utils.readyChange(bookmarks, persons, users).subscribe(function (_a) {
	            var _b = __read(_a, 1), bookmarkMap = _b[0];
	            _this.bookmarks = Array.from(bookmarkMap.values()).map(function (bm) {
	                var bookmark = {
	                    createdDate: bm.createdDate
	                };
	                persons.streamId(bm.id).subscribe(function (person) {
	                    bookmark.person = person;
	                });
	                return bookmark;
	            });
	        });
	        var fSub = this.feedService.streamFullFeed(this.expanded).subscribe(function (fullFeed) {
	            _this.fullFeed = fullFeed;
	            _this.feed = _this.feedService.getFeed(_this.fullFeed, _this.numLoaded);
	        });
	        var tSub = currentTree.stream().subscribe(function (tree) {
	            _this.tree = tree;
	        });
	        persons.ready().flatMap(function () { return persons.stream(); }).take(1).subscribe(function (m) {
	            _this.stats.countPeople = m.size;
	        });
	        medias.ready().flatMap(function () { return medias.stream(); }).take(1).subscribe(function (m) {
	            _this.stats.countMedia = m.size;
	        });
	        stories.ready().flatMap(function () { return stories.stream(); }).take(1).subscribe(function (m) {
	            _this.stats.countStories = m.size;
	        });
	        evidences.ready().flatMap(function () { return evidences.stream(); }).take(1).subscribe(function (m) {
	            _this.stats.countEvidences = m.size;
	        });
	        notes.ready().flatMap(function () { return notes.stream(); }).take(1).subscribe(function (m) {
	            _this.stats.countNotes = m.size;
	        });
	        leads.ready().flatMap(function () { return leads.stream(); }).take(1).subscribe(function (m) {
	            _this.stats.countHints = Array.from(m.values()).filter(function (h) { return h.createdUser === 0 && h.state === 0; }).length;
	        });
	        $scope.$on('toggleExpand', function (ev, params) {
	            _this.expanded.set(params.id, !_this.expanded.get(params.id));
	        });
	        $scope.$on('show', function (ev, params) {
	            switch (params.type) {
	                case 'source':
	                    _this.showSource(params.ev, params.id);
	                    break;
	                case 'person':
	                    _this.utils.dialog(params.ev, 'RelativesController', 'app/components/relatives/relatives.html', true, {
	                        pid: params.id
	                    });
	                    break;
	            }
	        });
	        $scope.$on('edit', function (ev, params) {
	            switch (params.type) {
	                case 'evidence':
	                    _this.editEvidence(params.ev, params.item);
	                    break;
	                case 'lead':
	                    _this.editLead(params.ev, params.item);
	                    break;
	                case 'media':
	                    _this.editMedia(params.ev, params.item);
	                    break;
	                case 'note':
	                    _this.editNote(params.ev, params.item);
	                    break;
	                case 'story':
	                    _this.editStory(params.ev, params.item);
	                    break;
	            }
	        });
	        $scope.$on('archive', function (ev, params) {
	            switch (params.type) {
	                case 'lead':
	                    _this.archiveLead(params.ev, params.item);
	                    break;
	            }
	        });
	        $scope.$on('delete', function (ev, params) {
	            switch (params.type) {
	                case 'evidence':
	                    _this.deleteEvidence(params.ev, params.id);
	                    break;
	                case 'lead':
	                    _this.deleteLead(params.ev, params.item);
	                    break;
	                case 'media':
	                    _this.deleteMedia(params.ev, params.item);
	                    break;
	                case 'note':
	                    _this.deleteNote(params.ev, params.id);
	                    break;
	                case 'story':
	                    _this.deleteStory(params.ev, params.id);
	                    break;
	            }
	        });
	        $scope.$on('mosaic', function (ev, params) {
	            _this.mediaUtils.mosaic(params.ev, params.item);
	        });
	        $scope.$on('$destroy', function () {
	            rSub.unsubscribe();
	            bSub.unsubscribe();
	            fSub.unsubscribe();
	            tSub.unsubscribe();
	        });
	    }
	    FeedController.prototype.loadMore = function () {
	        this.numLoaded += this.pageSize;
	        this.feed = this.feedService.getFeed(this.fullFeed, this.numLoaded);
	    };
	    FeedController.prototype.selectBookmark = function (ev, person) {
	        this.utils.dialog(ev, 'RelativesController', 'app/components/relatives/relatives.html', true, {
	            pid: person.id
	        });
	    };
	    FeedController.prototype.showSource = function (ev, id) {
	        this.utils.showSource(ev, this.sourcesService, this.evidencesService, this.usersService, id);
	    };
	    FeedController.prototype.addBookmark = function () {
	        this.utils.dialog(this.menuEvent, 'AddBookmarkController', 'app/components/addBookmark/addBookmark.html', true);
	    };
	    FeedController.prototype.editEvidence = function (ev, evidence) {
	        this.utils.dialog(ev, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	            evidence: evidence
	        });
	    };
	    FeedController.prototype.deleteEvidence = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Supporting Evidence', 'Are you sure?', ev).then(function () {
	            _this.evidencesService.streamId(id).take(1).subscribe(function (evidence) {
	                _this.evidencesService.augmentEvidence(evidence, _this.sourcesService, _this.personsService, _this.usersService).subscribe(function (evidence) {
	                    var deletedNamesFacts = _this.evidenceUtils.getDeletedNamesFacts([evidence], [], true);
	                    if (deletedNamesFacts.filter(function (nf) { return nf.principal && nf.unsupported; }).length > 0) {
	                        _this.utils.dialog(null, 'SelectNamesFactsController', 'app/components/selectNamesFacts/selectNamesFacts.html', false, {
	                            namesFacts: deletedNamesFacts
	                        }).then(function (deletedNamesFacts) {
	                            _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	                        }, function () {
	                            // ignore
	                        });
	                    }
	                    else {
	                        _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	                    }
	                });
	            });
	        }, function () {
	            // ignore
	        });
	    };
	    FeedController.prototype.editLead = function (ev, lead) {
	        this.utils.dialog(ev, 'EditLeadController', 'app/components/editLead/editLead.html', false, {
	            lead: lead
	        });
	    };
	    FeedController.prototype.archiveLead = function (ev, lead) {
	        lead.state = lead.state === 0 ? 1 : 0;
	        this.leadsService.update(lead);
	    };
	    FeedController.prototype.deleteLead = function (ev, lead) {
	        var _this = this;
	        this.utils.confirm('Delete', 'Are you sure?', ev).then(function () {
	            lead.state = 2;
	            _this.leadsService.update(lead);
	        }, function () {
	            // ignore
	        });
	    };
	    FeedController.prototype.editMedia = function (ev, media) {
	        this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	            media: media
	        });
	    };
	    FeedController.prototype.deleteMedia = function (ev, media) {
	        var _this = this;
	        this.utils.dialog(ev, 'DeleteMediaController', 'app/components/deleteMedia/deleteMedia.html', false, {
	            media: media
	        }).then(function () {
	            _this.mediasService.del(media.id);
	        }, function () {
	            // ignore
	        });
	    };
	    FeedController.prototype.editNote = function (ev, note) {
	        this.utils.dialog(ev, 'EditNoteController', 'app/components/editNote/editNote.html', false, {
	            note: note
	        });
	    };
	    FeedController.prototype.deleteNote = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Note', 'Are you sure?', ev).then(function () {
	            _this.notesService.del(id);
	        }, function () {
	            // ignore
	        });
	    };
	    FeedController.prototype.editStory = function (ev, story) {
	        this.utils.dialog(ev, 'EditStoryController', 'app/components/editStory/editStory.html', false, {
	            story: story
	        });
	    };
	    FeedController.prototype.deleteStory = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Story', 'Are you sure?', ev).then(function () {
	            _this.storiesService.del(id);
	        }, function () {
	            // ignore
	        });
	    };
	    return FeedController;
	}());
	exports.default = FeedController;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var ForumLoginController = /** @class */ (function () {
	    ForumLoginController.$inject = ["$transition$", "$scope", "$timeout", "$window", "authToken", "partnerId", "partnerSingleSignon", "currentUserId", "server", "utils"];
	    function ForumLoginController($transition$, $scope, $timeout, $window, authToken, partnerId, partnerSingleSignon, currentUserId, server, utils) {
	        'ngInject';
	        var sso = $transition$.params().sso;
	        var sig = $transition$.params().sig;
	        var redirect = $transition$.params().redirect;
	        var data = $transition$.params().data;
	        var uid = 0;
	        var sub = currentUserId.stream().subscribe(function (userId) {
	            uid = userId;
	            // if the user is not logged in, pop up the login dialog (but wait awhile to see if they get logged in)
	            if (uid === 0) {
	                $timeout(function () {
	                    if (uid === 0) {
	                        if (!!partnerId && partnerSingleSignon) {
	                            // PARTNER direct the user to your login, then direct them from there back here.
	                        }
	                        else {
	                            utils.dialog(null, 'SignInController', 'app/components/signIn/signIn.html');
	                        }
	                    }
	                }, 500);
	            }
	            else if (!!redirect) {
	                if (redirect === 'https://todos.rootsfinder.com' || redirect === 'https://rootsclipper.rootsfinder.com') {
	                    $window.location = redirect + '?source=RC&days=14&token=' + encodeURIComponent(authToken.get()) + '&data=' + encodeURIComponent(data);
	                }
	            }
	            else {
	                // call the server to get the response
	                server.get('/forum/sso', { sso: sso, sig: sig }).subscribe(function (response) {
	                    // redirect
	                    $window.location = 'http://forum.rootsfinder.com/session/sso_login?sso=' + encodeURIComponent(response.sso) + '&sig=' + encodeURIComponent(response.sig);
	                }, function (response) {
	                    if (response.status === 403) {
	                        utils.alert('Email confirmation sent', 'You must confirm your email before joining the forum. Click on the link in the confirmation email you just received.', null);
	                    }
	                    else {
	                        utils.alert('Something went wrong', 'Please try again later or contact support@rootsfinder.com.', null);
	                    }
	                });
	            }
	        });
	        $scope.$on('$destroy', function () {
	            sub.unsubscribe();
	        });
	    }
	    return ForumLoginController;
	}());
	exports.default = ForumLoginController;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var FsRedirectController = /** @class */ (function () {
	    FsRedirectController.$inject = ["$timeout", "$window"];
	    function FsRedirectController($timeout, $window) {
	        'ngInject';
	        var _this = this;
	        this.$window = $window;
	        $timeout(function () {
	            _this.closable = true;
	        }, 1000);
	    }
	    FsRedirectController.prototype.close = function () {
	        this.$window.close();
	    };
	    return FsRedirectController;
	}());
	exports.default = FsRedirectController;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var FS = 'familysearch.org';
	var FsSyncController = /** @class */ (function () {
	    FsSyncController.$inject = ["$log", "$scope", "$state", "$transition$", "$timeout", "$window", "rx", "fs", "messageBus", "moment", "dates", "places", "evidences", "families", "leads", "medias", "notes", "ordinances", "persons", "sources", "stories", "users", "personUtils", "evidenceUtils", "mediaUtils", "utils"];
	    function FsSyncController($log, $scope, $state, $transition$, $timeout, $window, rx, fs, messageBus, moment, dates, places, evidences, families, leads, medias, notes, ordinances, persons, sources, stories, users, personUtils, evidenceUtils, mediaUtils, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.$window = $window;
	        this.Raven = $window.Raven;
	        this.rx = rx;
	        this.fs = fs;
	        this.messageBus = messageBus;
	        this.moment = moment;
	        this.dates = dates;
	        this.evidenceService = evidences;
	        this.noteService = notes;
	        this.mediaService = medias;
	        this.personService = persons;
	        this.familiesService = families;
	        this.ordinancesService = ordinances;
	        this.sourceService = sources;
	        this.storyService = stories;
	        this.userService = users;
	        this.personUtils = personUtils;
	        this.evidenceUtils = evidenceUtils;
	        this.mediaUtils = mediaUtils;
	        this.utils = utils;
	        this.personId = utils.decodeId($transition$.params().personId);
	        this.encodeId = utils.encodeId.bind(utils);
	        this.$log.info('personId', this.personId);
	        this.expanded = new Map();
	        this.fsPersonStream = utils.createStream(true);
	        this.fsSourcesStream = utils.createStream(true);
	        this.fsMemoriesStream = utils.createStream(true);
	        this.fsNotesStream = utils.createStream(true);
	        this.fsFamiliesStream = utils.createStream(true);
	        this.fsOrdinancesStream = utils.createStream(true);
	        this.personServiceMutex = utils.createMutex();
	        // update person with the latest versions from both sides (DWQ: results in a lot of extra updates to person - don't compare versions anymore)
	        //let fsPersonSub = rx.Observable.combineLatest(
	        //  this.utils.watch($scope, () => {
	        //    return !!this.person && !!this.person.rf && this.person.rf.externalIds.has(FS) ? this.person.rf.externalIds.get(FS).id : null;
	        //  }),
	        //  this.utils.readyChange(this.fsPersonStream) // fsPersonStream is not updated when the rf person is updated
	        //).flatMap(([{newValue}]) => {
	        //    return !!newValue ? fs.getPerson(newValue) : rx.Observable.of(null);
	        //}).subscribe(fsp => {
	        //    if (!!fsp) {
	        //      let idVer = this.person.rf.externalIds.get(FS);
	        //      let fsVer = fs.toRFPerson(fsp).externalIds.get(FS).extVersion;
	        //      if (this.person.rf.version.toString() !== idVer.rfVersion || fsVer !== idVer.extVersion) {
	        //        this.updatePerson(() => {
	        //          this.person.rf.externalIds.set(FS, {
	        //            id: idVer.id,
	        //            //rfVersion: will be set to version+1 in updatePerson
	        //            extVersion: fsVer
	        //          });
	        //          return this.person.rf;
	        //        }).subscribe(() => {
	        //          // ignore
	        //        }, err => {
	        //          //this.messageBus.post({msg: err, warn: true});
	        //          this.$log.warn('error updating person version', err);
	        //        });
	        //      }
	        //    }
	        //}, err => {
	        //  this.$log.warn('error reading fsp', err);
	        //});
	        var evidencesSub = utils.readyChange(persons, evidences, sources, stories, users, this.fsPersonStream, this.fsSourcesStream).subscribe(function (_a) {
	            var _b = __read(_a, 1), personMap = _b[0];
	            _this.evidenceMap = new Map();
	            _this.person = { rf: personMap.get(_this.personId), fs: null, state: 'FS_NOT_CONNECTED' };
	            if (!_this.person.rf) {
	                return;
	            }
	            var fsid = _this.person.rf.externalIds.has(FS) ? _this.person.rf.externalIds.get(FS).id : null;
	            if (!fsid) {
	                return;
	            }
	            _this.person.rf.facts = new Map(Array.from(_this.person.rf.facts.entries()).map(function (_a) {
	                var _b = __read(_a, 2), k = _b[0], f = _b[1];
	                f = Object.assign({}, f, {
	                    _principalFsId1: f.principalId1 > 0 && personMap.has(f.principalId1) && personMap.get(f.principalId1).externalIds.has(FS) ?
	                        personMap.get(f.principalId1).externalIds.get(FS).id : null
	                });
	                return [k, f];
	            }));
	            rx.Observable.forkJoin(evidences.streamForPerson(_this.person.rf).take(1), fs.getPerson(fsid), fs.getSources(fsid))
	                .take(1).subscribe(function (_a) {
	                var _b = __read(_a, 3), em = _b[0], fsp = _b[1], fsSources = _b[2];
	                if (!fsp) {
	                    _this.messageBus.post({ msg: 'NOT_FOUND' });
	                    return;
	                }
	                _this.person.fs = fs.toRFPerson(fsp);
	                var n = persons.getDefaultNameForm(persons.getPreferredName(_this.person.fs));
	                _this.person.fs._given = !!n ? n.given : '';
	                _this.person.fs._surname = !!n ? n.surname : '';
	                var b = persons.getPreferredBirth(_this.person.fs);
	                _this.person.fs._birthDate = !!b ? b.date : '';
	                var d = persons.getPreferredDeath(_this.person.fs);
	                _this.person.fs._deathDate = !!d ? d.date : '';
	                _this.person.state = 'FS_CONNECTED';
	                _this.$log.info('person', _this.person);
	                // augment evidences
	                var fsEvidences = fsSources.map(function (fsSource) {
	                    var rfEvidence = fs.toRFEvidence(fsSource);
	                    rfEvidence._sourceTitle = '';
	                    rfEvidence._citation = rfEvidence.citation.text;
	                    rfEvidence._people = new Map();
	                    rfEvidence._personas = new Map();
	                    return rfEvidence;
	                });
	                var rfEvidenceStreams = Array.from(em.entries()).map(function (_a) {
	                    var _b = __read(_a, 2), id = _b[0], evidence = _b[1];
	                    return evidences.augmentEvidence(evidence, sources, persons, users).map(function (evidence) {
	                        return [id, evidence];
	                    });
	                });
	                var rfEvidenceStream = rfEvidenceStreams.length > 0 ? (_c = _this.rx.Observable).forkJoin.apply(_c, __spread(rfEvidenceStreams)) : _this.rx.Observable.of([]);
	                // standardize fs facts
	                var fsFactStreams = Array.from(_this.person.fs.facts.entries()).map(function (_a) {
	                    var _b = __read(_a, 2), id = _b[0], fact = _b[1];
	                    var fspStream = !!fact.principalId1 ? _this.fs.getPerson(fact.principalId1, false) : _this.rx.Observable.of(null);
	                    return _this.rx.Observable.forkJoin(dates.standardize(fact.date), places.standardize(fact.place), fspStream).map(function (_a) {
	                        var _b = __read(_a, 3), dateStd = _b[0], placeStd = _b[1], fsp = _b[2];
	                        fact.dateSort = dateStd.dateSort || '';
	                        fact.placeStandard = placeStd.length > 0 ? placeStd[0].standardName : '';
	                        fact._principalFS1 = !!fsp ? persons.getNameText(persons.getDefaultNameForm(persons.getPreferredName(_this.fs.toRFPerson(fsp))), true) : '';
	                        return [id, fact];
	                    });
	                });
	                var fsFactStream = fsFactStreams.length > 0 ? (_d = _this.rx.Observable).forkJoin.apply(_d, __spread(fsFactStreams)) : _this.rx.Observable.of([]);
	                // go
	                rx.Observable.forkJoin(rfEvidenceStream, fsFactStream)
	                    .take(1).subscribe(function (_a) {
	                    var _b = __read(_a, 2), idEvidences = _b[0], idFacts = _b[1];
	                    _this.evidenceMap = new Map(idEvidences);
	                    _this.person.fs.facts = new Map(idFacts);
	                    var used = new Set();
	                    // vitals
	                    _this.vitals = [];
	                    // name
	                    _this.name = {
	                        rf: persons.augmentName(persons.getPreferredName(_this.person.rf), _this.person.rf, _this.evidenceMap),
	                        fs: persons.augmentName(persons.getPreferredName(_this.person.fs), _this.person.fs, new Map())
	                    };
	                    _this.name.state = _this.getState(_this.name, utils.nameEquals);
	                    _this.name.preferred = true;
	                    _this.record(_this.name, used);
	                    // gender
	                    var gender = {
	                        rf: persons.augmentFact(persons.getGenderAsFact(_this.person.rf), _this.person.rf, personMap, _this.evidenceMap),
	                        fs: persons.augmentFact(persons.getGenderAsFact(_this.person.fs), _this.person.fs, new Map(), new Map())
	                    };
	                    if (!!gender.rf || !!gender.fs) {
	                        gender.state = _this.getState(gender, function (g1, g2) { return g1.value === g2.value; });
	                        _this.record(gender, used);
	                        _this.vitals.push(gender);
	                    }
	                    // birth
	                    var birth = {
	                        rf: persons.augmentFact(persons.getPreferredBirth(_this.person.rf, 'BIRT'), _this.person.rf, personMap, _this.evidenceMap),
	                        fs: persons.augmentFact(persons.getPreferredBirth(_this.person.fs, 'BIRT'), _this.person.fs, new Map(), new Map())
	                    };
	                    if (!!birth.rf || !!birth.fs) {
	                        birth.state = _this.getState(birth, _this.utils.factTypeDatePlaceEquals.bind(_this.utils));
	                        _this.record(birth, used);
	                        _this.vitals.push(birth);
	                    }
	                    // chr
	                    var chr = {
	                        rf: persons.augmentFact(persons.getPreferredBirth(_this.person.rf, 'CHR'), _this.person.rf, personMap, _this.evidenceMap),
	                        fs: persons.augmentFact(persons.getPreferredBirth(_this.person.fs, 'CHR'), _this.person.fs, new Map(), new Map())
	                    };
	                    if (!!chr.rf || !!chr.fs) {
	                        chr.state = _this.getState(chr, _this.utils.factTypeDatePlaceEquals.bind(_this.utils));
	                        _this.record(chr, used);
	                        _this.vitals.push(chr);
	                    }
	                    // death
	                    var death = {
	                        rf: persons.augmentFact(persons.getPreferredDeath(_this.person.rf, 'DEAT'), _this.person.rf, personMap, _this.evidenceMap),
	                        fs: persons.augmentFact(persons.getPreferredDeath(_this.person.fs, 'DEAT'), _this.person.fs, new Map(), new Map())
	                    };
	                    if (!!death.rf || !!death.fs) {
	                        death.state = _this.getState(death, _this.utils.factTypeDatePlaceEquals.bind(_this.utils));
	                        _this.record(death, used);
	                        _this.vitals.push(death);
	                    }
	                    // burial
	                    var burial = {
	                        rf: persons.augmentFact(persons.getPreferredDeath(_this.person.rf, 'BURI'), _this.person.rf, personMap, _this.evidenceMap),
	                        fs: persons.augmentFact(persons.getPreferredDeath(_this.person.fs, 'BURI'), _this.person.fs, new Map(), new Map())
	                    };
	                    if (!!burial.rf || !!burial.fs) {
	                        burial.state = _this.getState(burial, _this.utils.factTypeDatePlaceEquals.bind(_this.utils));
	                        _this.record(burial, used);
	                        _this.vitals.push(burial);
	                    }
	                    _this.fixExternalIds(_this.vitals);
	                    // other facts
	                    _this.facts = [];
	                    _this.person.rf.facts.forEach(function (rfFact) {
	                        if (rfFact.principal && rfFact.type !== 'SOUR' && !used.has(rfFact._key)) {
	                            var fact = {
	                                rf: persons.augmentFact(rfFact, _this.person.rf, personMap, _this.evidenceMap),
	                                fs: persons.augmentFact(_this.findUnusedFs(_this.person.fs.facts, rfFact, used, _this.utils.factTypeDatePlaceEquals.bind(_this.utils)), _this.person.fs, new Map(), new Map())
	                            };
	                            fact.state = _this.getState(fact, _this.utils.factTypeDatePlaceEquals.bind(_this.utils));
	                            fact.other = true;
	                            _this.record(fact, used);
	                            _this.facts.push(fact);
	                        }
	                    });
	                    _this.person.fs.facts.forEach(function (fsFact) {
	                        if (!used.has(fsFact.externalIds.get(FS).id)) {
	                            var fact = {
	                                rf: null,
	                                fs: persons.augmentFact(fsFact, _this.person.fs, new Map(), new Map())
	                            };
	                            fact.state = _this.getState(fact, _this.utils.factTypeDatePlaceEquals.bind(_this.utils));
	                            fact.other = true;
	                            _this.record(fact, used);
	                            _this.facts.push(fact);
	                        }
	                    });
	                    _this.fixExternalIds(_this.facts);
	                    // sort facts
	                    _this.facts.sort(function (f1, f2) {
	                        var ds1 = !!f1.rf ? f1.rf.dateSort : f1.fs.dateSort;
	                        var ds2 = !!f2.rf ? f2.rf.dateSort : f2.fs.dateSort;
	                        if (ds1 === ds2) {
	                            return 0;
	                        }
	                        if (!ds2 || (!!ds1 && ds1 < ds2)) {
	                            return -1;
	                        }
	                        if (!ds1 || (!!ds2 && ds1 > ds2)) {
	                            return 1;
	                        }
	                        return 0;
	                    });
	                    // other names
	                    _this.names = [];
	                    _this.person.rf.names.forEach(function (rfName) {
	                        if (!used.has(rfName._key)) {
	                            var name_1 = {
	                                rf: persons.augmentName(rfName, _this.person.rf, _this.evidenceMap),
	                                fs: persons.augmentName(_this.findUnusedFs(_this.person.fs.names, rfName, used, utils.nameEquals), _this.person.fs, new Map())
	                            };
	                            name_1.state = _this.getState(name_1, utils.nameEquals);
	                            name_1.preferred = false;
	                            _this.record(name_1, used);
	                            _this.names.push(name_1);
	                        }
	                    });
	                    _this.person.fs.names.forEach(function (fsName) {
	                        if (!used.has(fsName.externalIds.get(FS).id)) {
	                            var name_2 = {
	                                rf: null,
	                                fs: persons.augmentName(fsName, _this.person.fs, new Map())
	                            };
	                            name_2.state = _this.getState(name_2, utils.nameEquals);
	                            _this.record(name_2, used);
	                            _this.names.push(name_2);
	                        }
	                    });
	                    _this.fixExternalIds(_this.names);
	                    _this.names.sort(_this.sortItems(function (i) { return (_this.personService.getNameText(_this.personService.getDefaultNameForm(i)) || '').toLowerCase(); }));
	                    // evidences
	                    var evidenceLooseEquals = function (e1, e2) {
	                        return (_this.evidenceURLEquals(e1, e2) && !_this.evidenceDateDisagrees(e1, e2)) || _this.utils.evidenceSemiEquals(e1, e2);
	                    };
	                    _this.evidences = [];
	                    _this.evidenceMap.forEach(function (rfEvidence) {
	                        if (!_this.utils.isHiddenEvidence(rfEvidence)) {
	                            var evidence = {
	                                rf: rfEvidence,
	                                fs: _this.findUnusedFs(fsEvidences, rfEvidence, used, evidenceLooseEquals.bind(_this))
	                            };
	                            evidence.state = _this.getState(evidence, _this.utils.evidenceSemiEquals);
	                            _this.record(evidence, used);
	                            _this.evidences.push(evidence);
	                        }
	                    });
	                    fsEvidences.forEach(function (fsEvidence) {
	                        if (!used.has(fsEvidence.externalIds.get(FS).id)) {
	                            var evidence = {
	                                rf: null,
	                                fs: fsEvidence
	                            };
	                            evidence.state = _this.getState(evidence, _this.utils.evidenceSemiEquals);
	                            _this.record(evidence, used);
	                            _this.evidences.push(evidence);
	                        }
	                    });
	                    _this.fixExternalIds(_this.evidences);
	                    _this.evidences.sort(_this.sortItems(function (i) { return !!i._sourceAbbr ? i._sourceAbbr.toLowerCase() : ''; }));
	                }, function (err) {
	                    _this.$log.warn('error reading rf evidences and fs facts', err);
	                });
	                var _c, _d;
	            }, function (error) {
	                _this.$log.warn('error reading inner evidences', error);
	                if (error !== 'FS_CANCEL') {
	                    _this.messageBus.post({ msg: 'Error reading data: ' + error, op: 'GET', ctx: 'fsSync', warn: true });
	                }
	            });
	        }, function (err) {
	            _this.$log.warn('error reading evidences', err);
	        });
	        // stories and media
	        var storiesMediaSub = utils.readyChange(persons, evidences, medias, sources, stories, users, this.fsMemoriesStream).subscribe(function (_a) {
	            var _b = __read(_a, 1), personMap = _b[0];
	            var rfp = personMap.get(_this.personId);
	            if (!rfp) {
	                return;
	            }
	            var fsid = !!rfp.externalIds.get(FS) ? rfp.externalIds.get(FS).id : null;
	            if (!fsid) {
	                return;
	            }
	            rx.Observable.forkJoin(stories.streamForPerson(_this.personId).take(1), medias.streamForPerson(_this.personId).take(1), fs.getMemories(fsid, true))
	                .take(1).subscribe(function (_a) {
	                var _b = __read(_a, 3), storyMap = _b[0], mediaMap = _b[1], fsMemories = _b[2];
	                // augment stories
	                var fsStories = fsMemories.stories.map(function (fsStory) {
	                    var rfStory = fs.toRFStory(fsStory, _this.personId, personMap);
	                    rfStory._people = new Map([[_this.personId, rfp]]);
	                    return rfStory;
	                });
	                var rfStoryStreams = Array.from(storyMap.values()).map(function (story) {
	                    return stories.augmentStory(story, persons, users);
	                });
	                var rfStoryStream = rfStoryStreams.length > 0 ? (_c = _this.rx.Observable).forkJoin.apply(_c, __spread(rfStoryStreams)) : _this.rx.Observable.of([]);
	                // augment media
	                var fsMedias = fsMemories.media.map(function (fsMedia) {
	                    var rfMedia = fs.toRFMedia(fsMedia, _this.personId, personMap);
	                    rfMedia._people = new Map([[_this.personId, rfp]]);
	                    rfMedia._evidences = new Map();
	                    rfMedia._sources = new Map();
	                    rfMedia._stories = new Map();
	                    return rfMedia;
	                });
	                var rfMediaStreams = Array.from(mediaMap.values()).map(function (media) {
	                    return medias.augmentMedia(media, persons, evidences, sources, stories, users);
	                });
	                var rfMediaStream = rfMediaStreams.length > 0 ? (_d = _this.rx.Observable).forkJoin.apply(_d, __spread(rfMediaStreams)) : _this.rx.Observable.of([]);
	                // go
	                rx.Observable.forkJoin(rfStoryStream, rfMediaStream)
	                    .take(1).subscribe(function (_a) {
	                    var _b = __read(_a, 2), rfStories = _b[0], rfMedias = _b[1];
	                    var used = new Set();
	                    _this.stories = [];
	                    _this.medias = [];
	                    // stories
	                    rfStories.forEach(function (rfStory) {
	                        var story = {
	                            rf: rfStory,
	                            fs: _this.findUnusedFs(fsStories, rfStory, used, _this.utils.storyEquals)
	                        };
	                        story.state = _this.getState(story, _this.utils.storyEquals);
	                        _this.record(story, used);
	                        _this.stories.push(story);
	                    });
	                    fsStories.forEach(function (fsStory) {
	                        if (!used.has(fsStory.externalIds.get(FS).id)) {
	                            var story = {
	                                rf: null,
	                                fs: fsStory
	                            };
	                            story.state = _this.getState(story, _this.utils.storyEquals);
	                            _this.record(story, used);
	                            _this.stories.push(story);
	                        }
	                    });
	                    _this.fixExternalIds(_this.stories);
	                    _this.stories.sort(_this.sortItems(function (i) { return !!i.title ? i.title.toLowerCase() : ''; }));
	                    // media
	                    rfMedias.forEach(function (rfMedia) {
	                        var media = {
	                            rf: rfMedia,
	                            fs: _this.findUnusedFs(fsMedias, rfMedia, used, function () { return false; })
	                        };
	                        media.state = _this.getState(media, _this.utils.mediaEquals);
	                        _this.record(media, used);
	                        _this.medias.push(media);
	                    });
	                    fsMedias.forEach(function (fsMedia) {
	                        if (!used.has(fsMedia.externalIds.get(FS).id)) {
	                            var media = {
	                                rf: null,
	                                fs: fsMedia
	                            };
	                            media.state = _this.getState(media, _this.utils.mediaEquals);
	                            _this.record(media, used);
	                            _this.medias.push(media);
	                        }
	                    });
	                    _this.fixExternalIds(_this.medias);
	                    _this.medias.sort(_this.sortItems(function (i) { return !!i.title ? i.title.toLowerCase() : ''; }));
	                }, function (err) {
	                    _this.$log.warn('error reading rf stories and fs media', err);
	                });
	                var _c, _d;
	            }, function (err) {
	                _this.$log.warn('error reading inner stories', err);
	            });
	        }, function (err) {
	            _this.$log.warn('error reading stories', err);
	        });
	        // notes
	        var notesSub = utils.readyChange(persons, notes, users, this.fsNotesStream).subscribe(function (_a) {
	            var _b = __read(_a, 1), personMap = _b[0];
	            var rfp = personMap.get(_this.personId);
	            if (!rfp) {
	                return;
	            }
	            var fsid = !!rfp.externalIds.get(FS) ? rfp.externalIds.get(FS).id : null;
	            if (!fsid) {
	                return;
	            }
	            rx.Observable.forkJoin(notes.streamForPerson(_this.personId).take(1), fs.getNotes(fsid))
	                .take(1).subscribe(function (_a) {
	                var _b = __read(_a, 2), noteMap = _b[0], fsNotes = _b[1];
	                // augment notes
	                fsNotes = fsNotes.map(function (fsNote) {
	                    var rfNote = fs.toRFNote(fsNote, _this.personId);
	                    rfNote._people = new Map([[_this.personId, rfp]]);
	                    return rfNote;
	                });
	                var rfNoteStreams = Array.from(noteMap.values()).map(function (note) {
	                    return notes.augmentNote(note, persons, users);
	                });
	                var rfNoteStream = rfNoteStreams.length > 0 ? (_c = _this.rx.Observable).forkJoin.apply(_c, __spread(rfNoteStreams)) : _this.rx.Observable.of([]);
	                // go
	                rfNoteStream.take(1).subscribe(function (rfNotes) {
	                    var used = new Set();
	                    _this.notes = [];
	                    rfNotes.forEach(function (rfNote) {
	                        var note = {
	                            rf: rfNote,
	                            fs: _this.findUnusedFs(fsNotes, rfNote, used, _this.utils.noteEquals)
	                        };
	                        note.state = _this.getState(note, _this.utils.noteEquals);
	                        _this.record(note, used);
	                        _this.notes.push(note);
	                    });
	                    fsNotes.forEach(function (fsNote) {
	                        if (!used.has(fsNote.externalIds.get(FS).id)) {
	                            var note = {
	                                rf: null,
	                                fs: fsNote
	                            };
	                            note.state = _this.getState(note, _this.utils.noteEquals);
	                            _this.record(note, used);
	                            _this.notes.push(note);
	                        }
	                    });
	                    _this.fixExternalIds(_this.notes);
	                    _this.notes.sort(_this.sortItems(function (i) { return !!i.title ? i.title.toLowerCase() : ''; }));
	                }, function (err) {
	                    _this.$log.warn('error reading rf notes and fs notes', err);
	                });
	                var _c;
	            }, function (err) {
	                _this.$log.warn('error reading inner notes', err);
	            });
	        }, function (err) {
	            _this.$log.warn('error reading notes', err);
	        });
	        this.isLDS = false;
	        this.ordinances = [];
	        var ordinancesSub = fs.getIsLDS().take(1).flatMap(function (isLDS) {
	            _this.isLDS = isLDS;
	            if (!isLDS) {
	                return rx.Observable.of([null]);
	            }
	            return utils.readyChange(persons, ordinances, _this.fsOrdinancesStream);
	        }).subscribe(function (_a) {
	            var _b = __read(_a, 1), personMap = _b[0];
	            if (!personMap) {
	                return;
	            }
	            var rfp = personMap.get(_this.personId);
	            if (!rfp) {
	                return;
	            }
	            var fsid = !!rfp.externalIds.get(FS) ? rfp.externalIds.get(FS).id : null;
	            if (!fsid) {
	                return;
	            }
	            rx.Observable.forkJoin(ordinances.streamId(_this.personId).take(1), fs.getOrdinances(fsid))
	                .take(1).subscribe(function (_a) {
	                var _b = __read(_a, 2), rfOrdinances = _b[0], fsOrdinances = _b[1];
	                fsOrdinances = fsOrdinances.map(function (fsOrdinance) {
	                    return fs.toRFOrdinance(fsOrdinance);
	                });
	                if (!rfOrdinances) {
	                    rfOrdinances = { ordinances: new Map() };
	                }
	                _this.ordinances = [];
	                var used = new Set();
	                rfOrdinances.ordinances.forEach(function (rfOrdinance, key) {
	                    var ordinance = {
	                        rf: Object.assign({}, rfOrdinance, { _key: key }),
	                        fs: fsOrdinances.find(function (fso) { return _this.ordinanceEquals(rfOrdinance, fso, false); })
	                    };
	                    ordinance.state = _this.getOrdinanceState(ordinance);
	                    if (!!ordinance.fs) {
	                        used.add(ordinance.fs);
	                    }
	                    _this.ordinances.push(ordinance);
	                });
	                fsOrdinances.forEach(function (fsOrdinance) {
	                    if (!used.has(fsOrdinance)) {
	                        var ordinance = {
	                            rf: null,
	                            fs: fsOrdinance
	                        };
	                        ordinance.state = _this.getOrdinanceState(ordinance);
	                        _this.ordinances.push(ordinance);
	                    }
	                });
	                _this.ordinances.sort(_this.sortItems(function (i) { return !!_this.ordinancesService.order.find(function (o) { return o.type === i.type; }) ? _this.ordinancesService.order.find(function (o) { return o.type === i.type; }).order : 0; }));
	            }, function (err) {
	                _this.$log.warn('error reading inner ordinances', err);
	            });
	        }, function (err) {
	            _this.$log.warn('error reading ordinances', err);
	        });
	        // family members
	        var familiesSub = utils.readyChange(persons, families, evidences, users, this.fsFamiliesStream).subscribe(function (_a) {
	            var _b = __read(_a, 1), personMap = _b[0];
	            var rfp = personMap.get(_this.personId);
	            if (!rfp) {
	                return;
	            }
	            var fsid = !!rfp.externalIds.get(FS) ? rfp.externalIds.get(FS).id : null;
	            if (!fsid) {
	                return;
	            }
	            rx.Observable.forkJoin(families.streamParents(_this.personId).take(1), families.streamSpouses(_this.personId).take(1), fs.getFamilies(fsid))
	                .take(1).subscribe(function (_a) {
	                var _b = __read(_a, 3), pfm = _b[0], sfm = _b[1], fsFamilies = _b[2];
	                // prepare to augment fsFamilies
	                var fsPersonIds = new Set();
	                fsPersonIds.add(fsid);
	                var fsParentFamilies = [];
	                fsFamilies.parentFamilies.forEach(function (fsFamily) {
	                    var rfFamily = fs.toRFFamily(fsFamily);
	                    fsParentFamilies.push(rfFamily);
	                    if (!!rfFamily.husbandId) {
	                        fsPersonIds.add(rfFamily.husbandId);
	                    }
	                    if (!!rfFamily.wifeId) {
	                        fsPersonIds.add(rfFamily.wifeId);
	                    }
	                    try {
	                        for (var _a = __values(rfFamily.childRels.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                            var cid = _b.value;
	                            fsPersonIds.add(cid);
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                    var e_1, _c;
	                });
	                var fsParentFamilyStream = _this.rx.Observable.of(fsParentFamilies);
	                var fsSpouseFamilies = [];
	                fsFamilies.spouseFamilies.forEach(function (fsFamily) {
	                    var rfFamily = fs.toRFFamily(fsFamily);
	                    fsSpouseFamilies.push(rfFamily);
	                    if (!!rfFamily.husbandId) {
	                        fsPersonIds.add(rfFamily.husbandId);
	                    }
	                    if (!!rfFamily.wifeId) {
	                        fsPersonIds.add(rfFamily.wifeId);
	                    }
	                    try {
	                        for (var _a = __values(rfFamily.childRels.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                            var cid = _b.value;
	                            fsPersonIds.add(cid);
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                    var e_2, _c;
	                });
	                var fsSpouseFamilyStream = _this.rx.Observable.of(fsSpouseFamilies);
	                var fsPersonStreams = Array.from(fsPersonIds.values()).map(function (pid) {
	                    return _this.fs.getPerson(pid, true).flatMap(function (fsp) {
	                        return !!fsp ? _this.augmentFSPerson(fsp) : null;
	                    });
	                });
	                var fsPersonStream = fsPersonStreams.length > 0 ? (_c = _this.rx.Observable).forkJoin.apply(_c, __spread(fsPersonStreams)) : _this.rx.Observable.of([]);
	                // augment rfFamilies
	                var rfSpouseFamilyStreams = Array.from(sfm.values()).map(function (f) {
	                    return families.augmentFamily(f, 0, persons, leads, evidences, users);
	                });
	                var rfSpouseFamilyStream = rfSpouseFamilyStreams.length > 0 ? (_d = _this.rx.Observable).forkJoin.apply(_d, __spread(rfSpouseFamilyStreams)) : _this.rx.Observable.of([]);
	                var rfParentFamilyStreams = Array.from(pfm.values()).map(function (f) {
	                    return families.augmentFamily(f, rfp.preferredParentsFamilyId, persons, leads, evidences, users);
	                });
	                var rfParentFamilyStream = rfParentFamilyStreams.length > 0 ? (_e = _this.rx.Observable).forkJoin.apply(_e, __spread(rfParentFamilyStreams)) : _this.rx.Observable.of([]);
	                // go
	                rx.Observable.forkJoin(rfParentFamilyStream, rfSpouseFamilyStream, fsParentFamilyStream, fsSpouseFamilyStream, fsPersonStream)
	                    .take(1).subscribe(function (_a) {
	                    var _b = __read(_a, 5), rfParentFamilies = _b[0], rfSpouseFamilies = _b[1], fsParentFamilies = _b[2], fsSpouseFamilies = _b[3], fsPersons = _b[4];
	                    fsPersons = fsPersons.filter(function (p) { return !!p; }); // filter out possible null (missing) persons
	                    _this.fsPersons = fsPersons;
	                    var fsSelf = fsPersons.find(function (fsp) { return fsp.externalIds.get(FS).id === fsid; });
	                    fsParentFamilies.forEach(function (f) {
	                        f.id = _this.utils.randomId();
	                        if (!!f.husbandId) {
	                            f._husband = fsPersons.find(function (p) { return p.externalIds.get(FS).id === f.husbandId; });
	                        }
	                        if (!!f.wifeId) {
	                            f._wife = fsPersons.find(function (p) { return p.externalIds.get(FS).id === f.wifeId; });
	                        }
	                        f._children = new Map();
	                        Array.from(f.childRels.keys()).forEach(function (cid) {
	                            f._children.set(cid, fsPersons.find(function (p) { return p.externalIds.get(FS).id === cid; }));
	                        });
	                    });
	                    fsSpouseFamilies.forEach(function (f) {
	                        f.id = _this.utils.randomId();
	                        if (!!f.husbandId) {
	                            f._husband = fsPersons.find(function (p) { return p.externalIds.get(FS).id === f.husbandId; });
	                        }
	                        if (!!f.wifeId) {
	                            f._wife = fsPersons.find(function (p) { return p.externalIds.get(FS).id === f.wifeId; });
	                        }
	                        f._children = new Map();
	                        Array.from(f.childRels.keys()).forEach(function (cid) {
	                            f._children.set(cid, fsPersons.find(function (p) { return p.externalIds.get(FS).id === cid; }));
	                        });
	                    });
	                    _this.rfParentFamilies = rfParentFamilies;
	                    _this.rfSpouseFamilies = rfSpouseFamilies;
	                    _this.fsParentFamilies = fsParentFamilies;
	                    _this.fsSpouseFamilies = fsSpouseFamilies;
	                    _this.parentFamilies = _this.matchFamilies(rfParentFamilies, fsParentFamilies, personMap, rfp, fsSelf, true);
	                    _this.spouseFamilies = _this.matchFamilies(rfSpouseFamilies, fsSpouseFamilies, personMap, rfp, fsSelf, false);
	                }, function (err) {
	                    _this.$log.warn('error reading rf and fs families', err);
	                });
	                var _c, _d, _e;
	            }, function (err) {
	                _this.$log.warn('error reading inner families', err);
	            });
	        }, function (err) {
	            _this.$log.warn('error reading families', err);
	        });
	        $scope.$on('toggleExpand', function (ev, params) {
	            _this.expanded.set(params.id, !_this.expanded.get(params.id));
	        });
	        $scope.$on('$destroy', function () {
	            evidencesSub.unsubscribe();
	            ordinancesSub.unsubscribe();
	            storiesMediaSub.unsubscribe();
	            notesSub.unsubscribe();
	            familiesSub.unsubscribe();
	        });
	        $scope.$on('edit', function (ev, params) {
	            switch (params.type) {
	                case 'evidence':
	                    _this.editEvidence(params.ev, params.item);
	                    break;
	                case 'note':
	                    _this.editNote(params.ev, params.item);
	                    break;
	                case 'story':
	                    _this.editStory(params.ev, params.item);
	                    break;
	                case 'media':
	                    _this.editMedia(params.ev, params.item);
	                    break;
	                case 'ordinance':
	                    _this.editOrdinance(params.ev, params.item);
	                    break;
	            }
	        });
	        $scope.$on('delete', function (ev, params) {
	            switch (params.type) {
	                case 'fact':
	                    _this.deleteFact(params.ev, params.id);
	                    break;
	                case 'evidence':
	                    _this.deleteEvidence(params.ev, params.id);
	                    break;
	                case 'name':
	                    _this.deleteName(params.ev, params.id);
	                    break;
	                case 'note':
	                    _this.deleteNote(params.ev, params.id);
	                    break;
	                case 'story':
	                    _this.deleteStory(params.ev, params.id);
	                    break;
	                case 'media':
	                    _this.deleteMedia(params.ev, params.item);
	                    break;
	                case 'ordinance':
	                    _this.deleteOrdinance(params.ev, params.id);
	                    break;
	            }
	        });
	        $scope.$on('show', function (ev, params) {
	            switch (params.type) {
	                case 'source':
	                    _this.showSource(params.ev, params.id);
	                    break;
	                case 'media':
	                    _this.showMedia(params.ev, params.item);
	                    break;
	            }
	        });
	        $scope.$on('mosaic', function (ev, params) {
	            _this.mediaUtils.mosaic(params.ev, params.item);
	        });
	    }
	    FsSyncController.prototype.getFSHref = function (ctx) {
	        return !!this.person && !!this.person.fs ? this.fs.getHref(this.person.fs._url, ctx) : '';
	    };
	    FsSyncController.prototype.clickFSHref = function (ctx) {
	        this.fs.clickHref(this.person.fs._url, ctx);
	    };
	    FsSyncController.prototype.fsRefresh = function () {
	        var _this = this;
	        this.saving = true;
	        this.fs.clearCache();
	        this.fsPersonStream.next(true);
	        this.fsSourcesStream.next(true);
	        this.fsMemoriesStream.next(true);
	        this.fsNotesStream.next(true);
	        this.fsFamiliesStream.next(true);
	        this.fsOrdinancesStream.next(true);
	        this.$timeout(function () {
	            _this.saving = false;
	        }, 1000);
	    };
	    FsSyncController.prototype.getProfilePhotoURL = function (person) {
	        return person.profilePhoto > 0 ? this.mediaService.getFileURL(person.profilePhoto, 0, '100x100') : '';
	    };
	    FsSyncController.prototype.augmentFSPerson = function (fsp) {
	        var p = this.fs.toRFPerson(fsp);
	        var nf = this.personService.getDefaultNameForm(this.personService.getPreferredName(p));
	        p._fullName = this.personService.getNameText(nf, true);
	        var birth = this.personService.getPreferredBirth(p);
	        var birthYear = this.utils.getYear(!!birth ? birth.date : null);
	        var death = this.personService.getPreferredDeath(p);
	        var deathYear = this.utils.getYear(!!death ? death.date : null);
	        p._lifespan = !!birthYear || !!deathYear ? birthYear + ' - ' + deathYear : '';
	        p._iconURL = p.profilePhoto;
	        p._fsid = p.externalIds.get(FS).id;
	        p.profilePhoto = 0;
	        if (!!birth && !!birth.date) {
	            return this.dates.standardize(birth.date).map(function (result) {
	                p._birthDateSort = result.dateSort || '';
	                return p;
	            });
	        }
	        else {
	            return this.rx.Observable.of(p);
	        }
	    };
	    FsSyncController.prototype.matchFamilies = function (rfFamilies, fsFamilies, personMap, rfSelf, fsSelf, isParentFamily) {
	        var _this = this;
	        var used = new Set();
	        var families = [];
	        rfFamilies.forEach(function (rfFamily) {
	            var fsFamily = fsFamilies.find(function (fsFamily) {
	                var hEq = (rfFamily.husbandId === 0 && !fsFamily.husbandId) ||
	                    (!!rfFamily._husband && rfFamily._husband.externalIds.has(FS) && rfFamily._husband.externalIds.get(FS).id === fsFamily.husbandId) ||
	                    (!!rfFamily._husband && !rfFamily._husband.externalIds.has(FS) && !!rfFamily._husband._fullName && !!fsFamily._husband && !!fsFamily._husband._fullName &&
	                        !rfFamily._husband.externalIds.has(FS) && rfFamily._husband._fullName.toLowerCase() === fsFamily._husband._fullName.toLowerCase());
	                var wEq = (rfFamily.wifeId === 0 && !fsFamily.wifeId) ||
	                    (!!rfFamily._wife && rfFamily._wife.externalIds.has(FS) && rfFamily._wife.externalIds.get(FS).id === fsFamily.wifeId) ||
	                    (!!rfFamily._wife && !rfFamily._wife.externalIds.has(FS) && !!rfFamily._wife._fullName && !!fsFamily._wife && !!fsFamily._wife._fullName &&
	                        !rfFamily._wife.externalIds.has(FS) && rfFamily._wife._fullName.toLowerCase() === fsFamily._wife._fullName.toLowerCase());
	                var cEq = Array.from(rfFamily._children.values()).some(function (rfc) {
	                    return rfc.externalIds.has(FS) && Array.from(fsFamily._children.values()).some(function (fsc) {
	                        return rfc.externalIds.get(FS).id === fsc.externalIds.get(FS).id;
	                    });
	                });
	                return (hEq ? 1 : 0) + (wEq ? 1 : 0) + (cEq ? 1 : 0) >= 2;
	            });
	            if (!!fsFamily) {
	                used.add(fsFamily.id);
	            }
	            families.push(_this.matchFamily(rfFamily, fsFamily, personMap, rfSelf, fsSelf, isParentFamily));
	        });
	        fsFamilies.forEach(function (fsFamily) {
	            if (!used.has(fsFamily.id)) {
	                families.push(_this.matchFamily(null, fsFamily, personMap, rfSelf, fsSelf, isParentFamily));
	            }
	        });
	        families.sort(function (f1, f2) {
	            if (f1.preferred > 0 && f2.preferred === 0) {
	                return -1;
	            }
	            if (f1.preferred === 0 && f2.preferred > 0) {
	                return 1;
	            }
	            if (f1.marriageSort > 0 && f2.marriageSort > 0) {
	                return f1.marriageSort - f2.marriageSort;
	            }
	            if (f1.marriageSort > 0) {
	                return -1;
	            }
	            if (f2.marriageSort > 0) {
	                return 1;
	            }
	            return 0;
	        });
	        return families;
	    };
	    FsSyncController.prototype.matchFamily = function (rfFamily, fsFamily, personMap, rfSelf, fsSelf, isParentFamily) {
	        var _this = this;
	        // match husbands
	        var husbands = [];
	        if (!!rfFamily && !!fsFamily && rfFamily.husbandId > 0 && !!fsFamily.husbandId && this.personEquals(rfFamily._husband, fsFamily._husband)) {
	            husbands.push({
	                rf: rfFamily._husband,
	                fs: fsFamily._husband,
	                state: rfFamily._husband.externalIds.has(FS) && rfFamily._husband.externalIds.get(FS).id === fsFamily.husbandId ? 'FS_CONNECTED' : 'FS_NOT_CONNECTED',
	                disabled: rfFamily.husbandId === this.personId
	            });
	        }
	        else {
	            if (!!rfFamily && rfFamily.husbandId > 0) {
	                husbands.push({
	                    rf: rfFamily._husband,
	                    fs: rfFamily.husbandId === this.personId ? fsSelf : null,
	                    state: rfFamily.husbandId === this.personId ? 'FS_CONNECTED' : 'FS_MATCH',
	                    disabled: rfFamily.husbandId === this.personId
	                });
	            }
	            if (!!fsFamily && !!fsFamily.husbandId) {
	                husbands.push({
	                    rf: fsFamily._husband.externalIds.get(FS).id === rfSelf.externalIds.get(FS).id ? rfSelf : null,
	                    fs: fsFamily._husband,
	                    rfFamily: rfFamily,
	                    relationship: isParentFamily ? 'FATHER' : 'SPOUSE',
	                    state: fsFamily._husband.externalIds.get(FS).id === rfSelf.externalIds.get(FS).id ? 'FS_CONNECTED' : 'RF_MATCH',
	                    disabled: fsFamily._husband.externalIds.get(FS).id === rfSelf.externalIds.get(FS).id
	                });
	            }
	        }
	        // match wives
	        var wives = [];
	        if (!!rfFamily && !!fsFamily && rfFamily.wifeId > 0 && !!fsFamily.wifeId && this.personEquals(rfFamily._wife, fsFamily._wife)) {
	            wives.push({
	                rf: rfFamily._wife,
	                fs: fsFamily._wife,
	                state: rfFamily._wife.externalIds.has(FS) && rfFamily._wife.externalIds.get(FS).id === fsFamily.wifeId ? 'FS_CONNECTED' : 'FS_NOT_CONNECTED',
	                disabled: rfFamily.wifeId === this.personId
	            });
	        }
	        else {
	            if (!!rfFamily && rfFamily.wifeId > 0) {
	                wives.push({
	                    rf: rfFamily._wife,
	                    fs: rfFamily.wifeId === this.personId ? fsSelf : null,
	                    state: rfFamily.wifeId === this.personId ? 'FS_CONNECTED' : 'FS_MATCH',
	                    disabled: rfFamily.wifeId === this.personId
	                });
	            }
	            if (!!fsFamily && !!fsFamily.wifeId) {
	                wives.push({
	                    rf: fsFamily._wife.externalIds.get(FS).id === rfSelf.externalIds.get(FS).id ? rfSelf : null,
	                    fs: fsFamily._wife,
	                    rfFamily: rfFamily,
	                    relationship: isParentFamily ? 'MOTHER' : 'SPOUSE',
	                    state: fsFamily._wife.externalIds.get(FS).id === rfSelf.externalIds.get(FS).id ? 'FS_CONNECTED' : 'RF_MATCH',
	                    disabled: fsFamily._wife.externalIds.get(FS).id === rfSelf.externalIds.get(FS).id
	                });
	            }
	        }
	        // match children
	        var used = new Set();
	        var allParentsMatched = husbands.every(function (h) { return h.state === 'FS_CONNECTED'; }) && wives.every(function (w) { return w.state === 'FS_CONNECTED'; });
	        var children = [];
	        if (!!rfFamily) {
	            rfFamily._children.forEach(function (rfChild) {
	                var child = {
	                    rf: rfChild,
	                    fs: !!fsFamily ? _this.findUnusedFs(fsFamily._children, rfChild, used, _this.personEquals.bind(_this)) : null,
	                    disabled: rfChild.id === _this.personId
	                };
	                if (child.rf.id === _this.personId && !child.fs) {
	                    child.fs = fsSelf;
	                    child.state = 'FS_CONNECTED';
	                    child.disabled = true;
	                }
	                else if (!fsFamily || !allParentsMatched) {
	                    child.state = '';
	                }
	                else if (!child.fs) {
	                    child.state = 'FS_MATCH';
	                }
	                else if (rfChild.externalIds.has(FS) && rfChild.externalIds.get(FS).id === child.fs.externalIds.get(FS).id) {
	                    child.state = 'FS_CONNECTED';
	                }
	                else {
	                    child.state = 'FS_NOT_CONNECTED';
	                }
	                _this.record(child, used);
	                children.push(child);
	            });
	        }
	        if (!!fsFamily) {
	            fsFamily._children.forEach(function (fsChild) {
	                if (!used.has(fsChild.externalIds.get(FS).id)) {
	                    var child = {
	                        rf: null,
	                        fs: fsChild,
	                        rfFamily: rfFamily,
	                        relationship: isParentFamily ? 'SIBLING' : 'CHILD',
	                        state: !!rfFamily ? 'RF_MATCH' : ''
	                    };
	                    if (child.fs.externalIds.get(FS).id === rfSelf.externalIds.get(FS).id) {
	                        child.rf = rfSelf;
	                        child.state = 'FS_CONNECTED';
	                        child.disabled = true;
	                    }
	                    _this.record(child, used);
	                    children.push(child);
	                }
	            });
	        }
	        // sort children
	        children.sort(this.sortItems(function (c) { return c._birthDateSort > 0 ? c._birthDateSort.toString() : ''; }));
	        // add missing people (don't do this because it makes it appear like these people are in existing family relationships)
	        //this.addMissingPeople(husbands, personMap);
	        //this.addMissingPeople(wives, personMap);
	        //this.addMissingPeople(children, personMap);
	        return {
	            husbands: husbands,
	            wives: wives,
	            children: children,
	            marriageSort: !!rfFamily && !!rfFamily._marriage ? rfFamily._marriage.dateSort : 0,
	            preferred: !!rfFamily ? rfFamily._preferred : 0
	        };
	    };
	    FsSyncController.prototype.getState = function (obj, eqFn) {
	        if (!obj.fs && !obj.rf) {
	            return '';
	        }
	        if (!obj.fs) {
	            return 'FS_ADD';
	        }
	        else if (!obj.rf) {
	            return 'RF_ADD';
	        }
	        else if (!eqFn(obj.rf, obj.fs)) {
	            return 'BOTH_CHANGE';
	        }
	        return 'SAME';
	    };
	    FsSyncController.prototype.getOrdinanceState = function (obj) {
	        if (!obj.fs) {
	            return '';
	        }
	        if (!obj.rf) {
	            return 'RF_ADD';
	        }
	        if (!this.ordinanceEquals(obj.rf, obj.fs, true)) {
	            return 'RF_CHANGE';
	        }
	        return 'SAME';
	    };
	    FsSyncController.prototype.ordinanceEquals = function (o1, o2, strict) {
	        if (o1.type !== o2.type) {
	            return false;
	        }
	        if (!strict && !!o1.date && !!o2.date && o1.date === o2.date &&
	            (!o1.spouseId || !o2.spouseId) &&
	            (!o1.fatherId || !o2.fatherId) &&
	            (!o1.motherId || !o2.motherId)) {
	            return true;
	        }
	        if ((o1.spouseId || '') !== (o2.spouseId || '') ||
	            (o1.fatherId || '') !== (o2.fatherId || '') ||
	            (o1.motherId || '') !== (o2.motherId || '')) {
	            return false;
	        }
	        if (!strict) {
	            return true;
	        }
	        return (o1.status || '') === (o2.status || '') && (o1.date || '') === (o2.date || '') && (o1.templeCode || '') === (o2.templeCode || '');
	    };
	    FsSyncController.prototype.record = function (obj, used) {
	        if (!!obj.fs) {
	            obj.fs._key = !!obj.rf && !!obj.rf._key ? obj.rf._key : this.utils.randomKey();
	            obj.fs.id = !!obj.rf && !!obj.rf.id ? obj.rf.id : this.utils.randomId();
	        }
	        if (!!obj.fs && obj.fs.externalIds.has(FS)) {
	            used.add(obj.fs.externalIds.get(FS).id);
	        }
	        if (!!obj.rf) {
	            used.add(!!obj.rf._key ? obj.rf._key : obj.rf.id);
	        }
	    };
	    FsSyncController.prototype.findUnusedFs = function (items, rfItem, used, eqFn) {
	        var rffsid = rfItem.externalIds.has(FS) ? rfItem.externalIds.get(FS).id : null;
	        try {
	            for (var _a = __values(items.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var item = _b.value;
	                var fsid = item.externalIds.get(FS).id;
	                if (!used.has(fsid) && (rffsid === fsid || eqFn(rfItem, item))) {
	                    return item;
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        return null;
	        var e_3, _c;
	    };
	    FsSyncController.prototype.fixExternalIds = function (items) {
	        items.forEach(function (item) {
	            if (!!item.rf && item.rf.externalIds.has(FS) && !item.fs) {
	                item.rf.externalIds.delete(FS);
	            }
	            else if (!!item.rf && !item.rf.externalIds.has(FS) && !!item.fs) {
	                item.rf.externalIds.set(FS, { id: item.fs.externalIds.get(FS).id });
	            }
	        });
	    };
	    FsSyncController.prototype.addMissingPeople = function (people, personMap) {
	        var _this = this;
	        var _loop_1 = function (person) {
	            if (!!person.fs && !person.rf) {
	                var rfp = this_1.findRFPersonByFSID(personMap, person.fs.externalIds.get(FS).id);
	                if (!!rfp) {
	                    person.rf = rfp;
	                    person.state = 'FS_CONNECTED';
	                }
	            }
	            else if (!!person.rf && !person.fs && person.rf.externalIds.has(FS)) {
	                this_1.fs.getPerson(person.rf.externalIds.get(FS).id, true).take(1).subscribe(function (fsp) {
	                    if (!!fsp) {
	                        person.fs = _this.fs.toRFPerson(fsp);
	                        person.state = 'FS_CONNECTED';
	                    }
	                });
	            }
	        };
	        var this_1 = this;
	        try {
	            for (var people_1 = __values(people), people_1_1 = people_1.next(); !people_1_1.done; people_1_1 = people_1.next()) {
	                var person = people_1_1.value;
	                _loop_1(person);
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (people_1_1 && !people_1_1.done && (_a = people_1.return)) _a.call(people_1);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        var e_4, _a;
	    };
	    FsSyncController.prototype.findRFPersonByFSID = function (personMap, fsid) {
	        try {
	            for (var _a = __values(personMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var person = _b.value;
	                if (person.externalIds.has(FS) && person.externalIds.get(FS).id === fsid) {
	                    return person;
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        return null;
	        var e_5, _c;
	    };
	    FsSyncController.prototype.sortItems = function (fn) {
	        return function (i1, i2) {
	            var k1 = (!!i1.rf ? fn(i1.rf) : '') || (!!i1.fs ? fn(i1.fs) : '');
	            var k2 = (!!i2.rf ? fn(i2.rf) : '') || (!!i2.fs ? fn(i2.fs) : '');
	            return k1 < k2 ? -1 : k2 < k1 ? 1 : 0;
	        };
	    };
	    FsSyncController.prototype.urlHasPath = function (u) {
	        var matches = u.match(/.+\..+\/(.*)/);
	        return !!matches && matches.length > 1 && !!matches[1];
	    };
	    FsSyncController.prototype.evidenceURLEquals = function (e1, e2) {
	        return !!e1.citation.url && !!e2.citation.url && e1.citation.url === e2.citation.url && this.urlHasPath(e1.citation.url);
	    };
	    FsSyncController.prototype.evidenceDateDisagrees = function (e1, e2) {
	        var d1 = (e1.text || '').match(/\b\d\d\d\d\b/);
	        var d2 = (e2.text || '').match(/\b\d\d\d\d\b/);
	        return !!d1 && !!d2 && d1[0] !== d2[0];
	    };
	    FsSyncController.prototype.personEquals = function (rfp, fsp) {
	        if (!rfp || !fsp) {
	            return false;
	        }
	        if (rfp.externalIds.has(FS) && fsp.externalIds.has(FS) &&
	            rfp.externalIds.get(FS).id === fsp.externalIds.get(FS).id) {
	            return true;
	        }
	        if (rfp.externalIds.has(FS)) {
	            return false;
	        }
	        if (!!rfp._fullName && !!fsp._fullName && rfp._fullName.toLowerCase() === fsp._fullName.toLowerCase() &&
	            (!rfp._birthDateSort || !fsp._birthDateSort || rfp._birthDateSort === fsp._birthDateSort)) {
	            return true;
	        }
	        return false;
	    };
	    FsSyncController.prototype.updatePerson = function (personFn) {
	        var _this = this;
	        var stream = new this.rx.AsyncSubject();
	        this.personServiceMutex(function () {
	            var p = personFn();
	            if (p.id === _this.personId && p.externalIds.has(FS)) {
	                // increment rf version
	                var idVer = p.externalIds.get(FS);
	                p.externalIds.set(FS, {
	                    id: idVer.id,
	                    rfVersion: (p.version + 1).toString(),
	                    extVersion: idVer.extVersion
	                });
	            }
	            return _this.personService.update(p).do(function (p) {
	                if (p.id === _this.personId) {
	                    _this.person.rf = p;
	                }
	                stream.next(p);
	                stream.complete();
	            }, function (err) {
	                stream.error(err);
	            });
	        });
	        return stream;
	    };
	    FsSyncController.prototype.copy = function (type, item, action, ev) {
	        var _this = this;
	        switch (action) {
	            case 'ADD_FS':
	            case 'ADDALT_FS':
	            case 'REPLACE_FS':
	                if (type === 'FACT' && item.rf.principalId1 > 0 && !item.rf._principalFsId1) {
	                    this.utils.alert('Need to match spouse', 'You need to scroll down and match the spouse to someone on FamilySearch before you can copy this event', ev);
	                    return;
	                }
	                else if (type === 'FACT' && item.other && ['BIRT', 'CHR', 'DEAT', 'BURI'].includes(item.rf.type)) {
	                    this.utils.alert('Can\'t copy this fact', 'FamilySearch only allows one fact for Birth, Christening, Death, and Burial. ' +
	                        'These four types of facts can only be copied from the Vitals section above.');
	                    return;
	                }
	                var fsid = this.person.rf.externalIds.get(FS).id;
	                this.fs.getSources(fsid).subscribe(function (sources) {
	                    var evidences = [];
	                    if (type === 'FACT' || type === 'NAME') {
	                        evidences = Array.from(item.rf._evidences.values())
	                            .filter(function (e) { return e._hasSource && (!e.externalIds.has(FS) || !e.externalIds.get(FS).id || !sources.some(function (src) { return src.id === e.externalIds.get(FS).id; })); })
	                            .map(function (e) {
	                            return {
	                                evidence: e,
	                                title: e._sourceAbbr || e._sourceTitle,
	                                copy: false
	                            };
	                        });
	                    }
	                    _this.utils.dialog(ev, 'FsPromptController', 'app/components/fsPrompt/fsPrompt.html', false, {
	                        action: action,
	                        type: type,
	                        item: item,
	                        evidences: evidences
	                    }).then(function (result) {
	                        _this.saveFS(action, type, item, result);
	                    }, function () {
	                        // ignore
	                    });
	                }, function (err) {
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	                break;
	            case 'ADD_RF':
	            case 'ADD_RF_ALL':
	            case 'REPLACE_RF':
	                // check that you can copy the fact
	                if (type === 'FACT' && !!item.fs.principalId1 && !this.rfSpouseFamilies.some(function (sf) {
	                    return (!!sf._husband && sf._husband.externalIds.has(FS) && sf._husband.externalIds.get(FS).id === item.fs.principalId1 && sf._husband.externalIds.get(FS).id !== _this.person.rf.externalIds.get(FS).id) ||
	                        (!!sf._wife && sf._wife.externalIds.has(FS) && sf._wife.externalIds.get(FS).id === item.fs.principalId1 && sf._wife.externalIds.get(FS).id !== _this.person.rf.externalIds.get(FS).id);
	                })) {
	                    this.utils.alert('Need to match spouse', 'You need to scroll down and match the spouse to someone on RootsFinder before you can copy this event', ev);
	                    return;
	                }
	                // prompt if this is a name, birth, or death, ask if this should be preferred
	                if ((type === 'NAME' && item.preferred && this.person.rf.preferredNameKey > 0) ||
	                    (type === 'FACT' && ((item.fs.type === 'BIRT' && this.person.rf.preferredBirthKey > 0) || (item.fs.type === 'DEAT' && this.person.rf.preferredDeathKey > 0)))) {
	                    this.utils.confirm('Update profile?', 'Do you want this to be the preferred ' + (type === 'NAME' ? 'name' : item.fs.type === 'BIRT' ? 'birth' : 'death') + '?', ev, 'Yes, update profile', 'No, add alternate').then(function () {
	                        _this.saveRF(action, type, item, true, ev);
	                    }, function () {
	                        _this.saveRF(action, type, item, false, ev);
	                    });
	                }
	                else {
	                    this.saveRF(action, type, item, false, ev);
	                }
	                break;
	            case 'ADD_RC':
	                this.$window.open(item.fs.citation.url, '_blank', '');
	                break;
	            case 'MATCH_RF':
	                this.utils.dialog(this.menuEvent, 'FsMatchController', 'app/components/fsMatch/fsMatch.html', true, {
	                    source: 'FamilySearch',
	                    target: 'RootsFinder',
	                    personId: item.fs.externalIds.get(FS).id,
	                    rfPersonId: this.personId,
	                    rfFamily: item.rfFamily,
	                    relationship: item.relationship
	                });
	                break;
	            case 'MATCH_FS':
	            case 'MATCH_FS_OTHER':
	                this.utils.dialog(this.menuEvent, 'FsMatchController', 'app/components/fsMatch/fsMatch.html', true, {
	                    source: 'RootsFinder',
	                    target: 'FamilySearch',
	                    matchingPID: item.rf.externalIds.has(FS) ? item.rf.externalIds.get(FS).id : '',
	                    personId: item.rf.id
	                }).then(function (person) {
	                    _this.addFSRelationships(person);
	                }, function () {
	                    // ignore
	                });
	                break;
	            case 'FS_CONNECT':
	            case 'FS_CONNECT_PAIR':
	                this.updatePerson(function () {
	                    item.rf.externalIds.set(FS, { id: item.fs.externalIds.get(FS).id });
	                    return item.rf;
	                }).subscribe(function (person) {
	                    _this.addFSRelationships(person);
	                }, function (err) {
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	                break;
	            case 'FS_DISCONNECT':
	                this.utils.confirm('Disconnect FamilySearch Match?', 'Unmatch this person from FamilySearch?', ev).then(function () {
	                    _this.updatePerson(function () {
	                        item.rf.externalIds.delete(FS);
	                        return item.rf;
	                    }).subscribe(function () {
	                        if (item.rf.id === _this.personId) {
	                            _this.$state.go('tree.person', { personId: _this.utils.encodeId(_this.personId) });
	                        }
	                    }, function (err) {
	                        _this.messageBus.post({ msg: err, warn: true });
	                    });
	                }, function () {
	                    // ignore
	                });
	                break;
	        }
	    };
	    FsSyncController.prototype.saveFS = function (action, type, item, promptResult) {
	        var fsid = this.person.rf.externalIds.get(FS).id;
	        if (item.rf.externalIds.has(FS) && (action === 'ADD_FS' || action === 'ADDALT_FS')) {
	            item.rf.externalIds.delete(FS);
	        }
	        switch (type) {
	            case 'NAME':
	                this.saveFSName(item, fsid, promptResult);
	                break;
	            case 'FACT':
	                this.saveFSFact(item, fsid, promptResult);
	                break;
	            case 'EVIDENCE':
	                this.saveFSEvidence(item, fsid, promptResult);
	                break;
	            case 'NOTE':
	                this.saveFSNote(item, fsid, promptResult);
	                break;
	            case 'STORY':
	                this.saveFSStory(item, fsid);
	                break;
	            case 'MEDIA':
	                this.saveFSMedia(item, fsid);
	                break;
	        }
	    };
	    FsSyncController.prototype.saveFSName = function (item, fsid, pr) {
	        var _this = this;
	        var fsName = this.fs.toFSName(item.rf);
	        this.fs.savePersonName(fsid, fsName, pr.reason, item.preferred).subscribe(function (result) {
	            if (!item.rf.externalIds.has(FS) || item.rf.externalIds.get(FS).id !== result) {
	                _this.updatePerson(function () {
	                    _this.person.rf.names.get(item.rf._key).externalIds.set(FS, { id: result });
	                    return _this.person.rf;
	                }).subscribe(function () {
	                    // ignore
	                }, function (err) {
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	            }
	            else {
	                _this.fsPersonStream.next(result);
	            }
	        }, function (err) {
	            _this.messageBus.post({ msg: err, warn: true });
	        });
	    };
	    FsSyncController.prototype.saveFSFact = function (item, fsid, pr) {
	        var _this = this;
	        var fsFact = this.fs.toFSFact(item.rf);
	        if (item.rf.principalId1 > 0 && !!item.rf._principalFsId1) {
	            // this is a couple fact where the spouse is on FS
	            // find fs couple rel
	            var fssf = this.fsSpouseFamilies.find(function (f) { return (f.husbandId === fsid && f.wifeId === item.rf._principalFsId1) || (f.wifeId === fsid && f.husbandId === item.rf._principalFsId1); });
	            if (!!fssf && !!fssf._coupleId) {
	                // did we find a coupleID? If so, save the couple fact and the evidences
	                this.fs.saveCoupleFact(fssf._coupleId, fsFact, pr.reason, fssf.husbandId, fssf.wifeId).subscribe(function (result) {
	                    _this.saveFSEvidences(fsid, pr).subscribe(function () {
	                        if (!item.rf.externalIds.has(FS) || item.rf.externalIds.get(FS).id !== result) {
	                            // TODO update spouse fact too! (do this in person.controller also)
	                            _this.updatePerson(function () {
	                                _this.person.rf.facts.get(item.rf._key).externalIds.set(FS, { id: result });
	                                return _this.person.rf;
	                            }).subscribe(function () {
	                                // ignore
	                            }, function (err) {
	                                _this.messageBus.post({ msg: err, warn: true });
	                            });
	                        }
	                        else {
	                            _this.fsPersonStream.next(result);
	                        }
	                    }, function (err) {
	                        _this.messageBus.post({ msg: err, warn: true });
	                    });
	                }, function (err) {
	                    // TODO temporary
	                    _this.Raven.captureBreadcrumb({ category: 'action', message: angular.toJson(fsFact), data: {} });
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	            }
	            else {
	                var rfsf = this.rfSpouseFamilies.find(function (f) { return (f.husbandId === _this.person.rf.id && f.wifeId === item.rf.principalId1) || (f.wifeId === _this.person.rf.id && f.husbandId === item.rf.principalId1); });
	                if (!!rfsf && !!rfsf._husband && !!rfsf._wife && rfsf._husband.externalIds.has(FS) && rfsf._wife.externalIds.has(FS)) {
	                    // otherwise create a couple relationship, then save the couple fact and evidences
	                    var coupleRel_1 = this.fs.toFSCoupleRel(rfsf, rfsf._husband, rfsf._wife);
	                    this.fs.saveCoupleRel(coupleRel_1, pr.reason).subscribe(function (coupleId) {
	                        if (!!coupleId) {
	                            _this.fs.saveCoupleFact(coupleId, fsFact, pr.reason, coupleRel_1.person1.resourceId || coupleRel_1.person1.resource, coupleRel_1.person2.resourceId || coupleRel_1.person2.resource).subscribe(function (result) {
	                                _this.saveFSEvidences(fsid, pr).subscribe(function () {
	                                    _this.fsFamiliesStream.next(coupleId);
	                                    if (!item.rf.externalIds.has(FS) || item.rf.externalIds.get(FS).id !== result) {
	                                        // TODO update spouse fact too! (do this in person.controller also)
	                                        _this.updatePerson(function () {
	                                            _this.person.rf.facts.get(item.rf._key).externalIds.set(FS, { id: result });
	                                            return _this.person.rf;
	                                        }).subscribe(function () {
	                                            // ignore
	                                        }, function (err) {
	                                            _this.messageBus.post({ msg: err, warn: true });
	                                        });
	                                    }
	                                    else {
	                                        _this.fsPersonStream.next(result);
	                                    }
	                                }, function (err) {
	                                    _this.messageBus.post({ msg: err, warn: true });
	                                });
	                            }, function (err) {
	                                _this.messageBus.post({ msg: err, warn: true });
	                            });
	                        }
	                        else {
	                            _this.messageBus.post({ msg: 'FS_ERROR', warn: true, warnParams: { coupleRel: coupleRel_1, coupleId: coupleId } });
	                        }
	                    }, function (err) {
	                        var warn = true;
	                        if (err.includes('gender conflict')) {
	                            warn = false;
	                            err = 'FamilySearch cannot store same-sex couples';
	                        }
	                        _this.messageBus.post({ msg: err, warn: warn });
	                    });
	                }
	            }
	        }
	        else {
	            // this is a personal fact, so save it and evidences
	            this.fs.savePersonFact(fsid, fsFact, pr.reason).subscribe(function (result) {
	                _this.saveFSEvidences(fsid, pr).subscribe(function () {
	                    if (!item.rf.externalIds.has(FS) || item.rf.externalIds.get(FS).id !== result) {
	                        _this.updatePerson(function () {
	                            _this.person.rf.facts.get(item.rf._key).externalIds.set(FS, { id: result });
	                            return _this.person.rf;
	                        }).subscribe(function () {
	                            // ignore
	                        }, function (err) {
	                            _this.messageBus.post({ msg: err, warn: true });
	                        });
	                    }
	                    else {
	                        _this.fsPersonStream.next(result);
	                    }
	                }, function (err) {
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	            }, function (err) {
	                // TODO temporary
	                _this.Raven.captureBreadcrumb({ category: 'action', message: angular.toJson(fsFact), data: {} });
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	        }
	    };
	    FsSyncController.prototype.saveFSEvidences = function (fsid, pr) {
	        var _this = this;
	        var evidences = pr.evidences.filter(function (e) { return e.copy; }).map(function (e) { return e.evidence; });
	        if (evidences.length === 0) {
	            return this.rx.Observable.of([]);
	        }
	        return (_a = this.rx.Observable).forkJoin.apply(_a, __spread(evidences.map(function (e) {
	            var fsSource = _this.fs.toFSSource(e);
	            return _this.fs.saveSource(fsSource, fsid, pr.reason).flatMap(function (result) {
	                e.externalIds.set(FS, { id: result });
	                return _this.evidenceService.update(e);
	            });
	        })));
	        var _a;
	    };
	    FsSyncController.prototype.saveFSEvidence = function (item, fsid, pr) {
	        var _this = this;
	        var fsSource = this.fs.toFSSource(item.rf);
	        this.fs.saveSource(fsSource, fsid, pr.reason).subscribe(function (result) {
	            if (!item.rf.externalIds.has(FS) || item.rf.externalIds.get(FS).id !== result) {
	                item.rf.externalIds.set(FS, { id: result });
	                _this.evidenceService.update(item.rf);
	            }
	            else {
	                _this.fsSourcesStream.next(result);
	            }
	        }, function (err) {
	            _this.messageBus.post({ msg: err, warn: true });
	        });
	    };
	    FsSyncController.prototype.saveFSNote = function (item, fsid, pr) {
	        var _this = this;
	        var fsNote = this.fs.toFSNote(item.rf);
	        this.fs.saveNote(fsNote, fsid, pr.reason).subscribe(function (result) {
	            if (!item.rf.externalIds.has(FS) || item.rf.externalIds.get(FS).id !== result) {
	                item.rf.externalIds.set(FS, { id: result });
	                _this.noteService.update(item.rf);
	            }
	            else {
	                _this.fsNotesStream.next(result);
	            }
	        }, function (err) {
	            _this.messageBus.post({ msg: err, warn: true });
	        });
	    };
	    FsSyncController.prototype.saveFSStory = function (item, fsid) {
	        var _this = this;
	        var fsStory = this.fs.toFSStory(item.rf);
	        this.fs.saveStory(fsStory, fsid).subscribe(function (result) {
	            if (!item.rf.externalIds.has(FS) || item.rf.externalIds.get(FS).id !== result) {
	                item.rf.externalIds.set(FS, { id: result });
	                _this.storyService.update(item.rf);
	            }
	            else {
	                _this.fsMemoriesStream.next(result);
	            }
	        }, function (err) {
	            _this.messageBus.post({ msg: err, warn: true });
	        });
	    };
	    FsSyncController.prototype.saveFSMedia = function (item, fsid) {
	        var _this = this;
	        item.rf._url = this.mediaService.getFileURL(item.rf.id, 0);
	        var fsMedia = this.fs.toFSMedia(item.rf);
	        this.fs.saveMedia(fsMedia, fsid).subscribe(function (result) {
	            if (!item.rf.externalIds.has(FS) || item.rf.externalIds.get(FS).id !== result) {
	                item.rf.externalIds.set(FS, { id: result });
	                _this.mediaService.update(item.rf);
	            }
	            else {
	                _this.fsMemoriesStream.next(result);
	            }
	        }, function (err) {
	            _this.messageBus.post({ msg: err, warn: true, warnParams: { id: item.rf.id, fsid: fsid } });
	        });
	    };
	    FsSyncController.prototype.addFSRelationships = function (rfp) {
	        var _this = this;
	        // if person added is the spouse of an rf family, and both spouses now have fs links, add couple relationship if it doesn't exist
	        this.rfSpouseFamilies.forEach(function (rfsf) {
	            if ((rfp.id === rfsf.husbandId || rfp.id === rfsf.wifeId) &&
	                (!!rfsf._husband && !!rfsf._wife && rfsf._husband.externalIds.has(FS) && rfsf._wife.externalIds.has(FS) &&
	                    (rfsf._husband.externalIds.get(FS).id === rfp.externalIds.get(FS).id ||
	                        _this.fsPersons.some(function (fsp) { return fsp.externalIds.get(FS).id === rfsf._husband.externalIds.get(FS).id; })) &&
	                    (rfsf._wife.externalIds.get(FS).id === rfp.externalIds.get(FS).id ||
	                        _this.fsPersons.some(function (fsp) { return fsp.externalIds.get(FS).id === rfsf._wife.externalIds.get(FS).id; })))) {
	                var coupleRel = _this.fs.toFSCoupleRel(rfsf, rfsf._husband, rfsf._wife);
	                // TODO check if couple relationship already exists
	                _this.fs.saveCoupleRel(coupleRel, '').subscribe(function (coupleId) {
	                    _this.fsFamiliesStream.next(coupleId);
	                }, function (err) {
	                    var warn = true;
	                    if (err.includes('gender conflict')) {
	                        warn = false;
	                        err = 'FamilySearch cannot store same-sex couples';
	                    }
	                    _this.messageBus.post({ msg: err, warn: warn });
	                });
	            }
	        });
	        // if the person added is the spouse of an rf family, and there are children with fs links, add or update cap relationships if they don't exist
	        this.rfSpouseFamilies.forEach(function (rfsf) {
	            if (rfp.id === rfsf.husbandId || rfp.id === rfsf.wifeId) {
	                Array.from(rfsf._children.values()).forEach(function (rfc) {
	                    if (rfc.externalIds.has(FS) && _this.fsPersons.some(function (fsp) { return fsp.externalIds.get(FS).id === rfc.externalIds.get(FS).id; })) {
	                        var fsf = _this.findFSChildAndParentsFamily(rfsf._husband, rfsf._wife, rfc);
	                        var capId = !!fsf ? fsf.childRels.get(rfc.externalIds.get(FS).id)._childAndParentsId : null;
	                        var capRel = _this.fs.toFSChildAndParentsRel(rfsf, rfsf._husband, rfsf._wife, rfc);
	                        if (!!capId) {
	                            capRel.id = capId;
	                        }
	                        // TODO check if cap relationship already exists
	                        _this.fs.saveChildAndParentsRel(capRel, '').subscribe(function (capId) {
	                            _this.fsFamiliesStream.next(capId);
	                        }, function (err) {
	                            _this.messageBus.post({ msg: err, warn: true });
	                        });
	                    }
	                });
	            }
	        });
	        // if the person added is a child of an rf family, and one or both parents have fs links, add or update cap relationships if they don't exist
	        this.rfParentFamilies.concat(this.rfSpouseFamilies).forEach(function (rfpf) {
	            if (rfpf.childRels.has(rfp.id) &&
	                ((!!rfpf._husband && rfpf._husband.externalIds.has(FS) &&
	                    _this.fsPersons.some(function (fsp) { return fsp.externalIds.get(FS).id === rfpf._husband.externalIds.get(FS).id; })) ||
	                    (!!rfpf._wife && rfpf._wife.externalIds.has(FS) &&
	                        _this.fsPersons.some(function (fsp) { return fsp.externalIds.get(FS).id === rfpf._wife.externalIds.get(FS).id; })))) {
	                var fsf = _this.findFSChildAndParentsFamily(rfpf._husband, rfpf._wife, rfp);
	                var capId = !!fsf ? fsf.childRels.get(rfp.externalIds.get(FS).id)._childAndParentsId : null;
	                var capRel = _this.fs.toFSChildAndParentsRel(rfpf, rfpf._husband, rfpf._wife, rfp);
	                if (!!capId) {
	                    capRel.id = capId;
	                }
	                // TODO check if cap relationship already exists
	                _this.fs.saveChildAndParentsRel(capRel, '').subscribe(function (capId) {
	                    _this.fsFamiliesStream.next(capId);
	                }, function (err) {
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	            }
	        });
	    };
	    FsSyncController.prototype.findFSChildAndParentsFamily = function (rfh, rfw, rfc) {
	        var families = this.fsParentFamilies.concat(this.fsSpouseFamilies);
	        // first look for two-parent matches
	        var fsf = families.find(function (f) {
	            return !!rfh && rfh.externalIds.has(FS) && f.husbandId === rfh.externalIds.get(FS).id &&
	                !!rfw && rfw.externalIds.has(FS) && f.wifeId === rfh.externalIds.get(FS).id &&
	                rfc.externalIds.has(FS) && f.childRels.has(rfc.externalIds.get(FS).id);
	        });
	        // then look for one-parent matches
	        if (!fsf) {
	            fsf = families.find(function (f) {
	                return ((!!rfh && rfh.externalIds.has(FS) && f.husbandId === rfh.externalIds.get(FS).id) ||
	                    (!!rfw && rfw.externalIds.has(FS) && f.wifeId === rfh.externalIds.get(FS).id)) &&
	                    rfc.externalIds.has(FS) && f.childRels.has(rfc.externalIds.get(FS).id);
	            });
	        }
	        return fsf;
	    };
	    FsSyncController.prototype.saveRF = function (action, type, item, setPreferred, ev) {
	        switch (type) {
	            case 'NAME':
	                this.saveRFName(item, setPreferred);
	                break;
	            case 'FACT':
	                this.saveRFFact(item, setPreferred);
	                break;
	            case 'EVIDENCE':
	                this.saveRFEvidence(item, ev);
	                break;
	            case 'MEDIA':
	                this.saveRFMedia(item);
	                break;
	            case 'NOTE':
	                this.saveRFNote(item);
	                break;
	            case 'STORY':
	                this.saveRFStory(item);
	                break;
	            case 'ORDINANCE':
	                if (action === 'ADD_RF_ALL') {
	                    this.saveRFOrdinances();
	                }
	                else {
	                    this.saveRFOrdinance(item);
	                }
	                break;
	        }
	    };
	    FsSyncController.prototype.saveRFName = function (item, setPreferred) {
	        var _this = this;
	        // add a name to person
	        var key = this.utils.randomKey();
	        var name = {
	            externalIds: new Map([[FS, { id: item.fs.externalIds.get(FS).id }]]),
	            nameForms: new Map(Array.from(item.fs.nameForms.entries())),
	            type: item.fs.type,
	            evidencePersonas: new Map()
	        };
	        this.updatePerson(function () {
	            _this.person.rf.names.set(key, name);
	            // set preferred?
	            if (setPreferred || _this.person.rf.preferredNameKey === 0) {
	                _this.person.rf.preferredNameKey = key;
	            }
	            return _this.person.rf;
	        }).subscribe(function () {
	            // ignore
	        }, function (err) {
	            _this.messageBus.post({ msg: err, warn: true });
	        });
	    };
	    FsSyncController.prototype.saveRFFact = function (item, setPreferred) {
	        var _this = this;
	        // add a fact to person
	        var fact = {
	            externalIds: new Map([[FS, { id: item.fs.externalIds.get(FS).id }]]),
	            type: item.fs.type,
	            principal: true,
	            value: item.fs.value,
	            date: item.fs.date,
	            dateSort: item.fs.dateSort,
	            place: item.fs.place,
	            placeDetails: item.fs.placeDetails,
	            placeStandard: item.fs.placeStandard,
	            evidencePersonas: new Map()
	        };
	        if (!!item.fs.principalId1) {
	            var sf = this.rfSpouseFamilies.find(function (sf) {
	                return (!!sf._husband && sf._husband.externalIds.has(FS) && sf._husband.externalIds.get(FS).id === item.fs.principalId1 && sf._husband.externalIds.get(FS).id !== _this.person.rf.externalIds.get(FS).id) ||
	                    (!!sf._wife && sf._wife.externalIds.has(FS) && sf._wife.externalIds.get(FS).id === item.fs.principalId1 && sf._wife.externalIds.get(FS).id !== _this.person.rf.externalIds.get(FS).id);
	            });
	            var spouse_1 = sf.husbandId === this.person.rf.id ? sf._wife : sf._husband;
	            var e = this.createRFEvidence(fact, this.person.fs.externalIds.get(FS).id, this.person.fs._url);
	            e.personas.set(2, { names: new Map(), facts: new Map(), principal: true, relatedToKey: 1, relationshipType: 'SPOUSE' });
	            this.evidenceService.create(e).subscribe(function (e) {
	                var key = _this.utils.randomKey();
	                fact.evidencePersonas.set(e.id, 1);
	                fact.principalId1 = spouse_1.id;
	                _this.updatePerson(function () {
	                    _this.person.rf.facts.set(key, fact);
	                    return _this.person.rf;
	                }).subscribe(function () {
	                    // ignore
	                }, function (err) {
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	                key = _this.utils.randomKey();
	                fact = _this.utils.clone(fact);
	                fact.evidencePersonas.set(e.id, 2);
	                fact.principalId1 = _this.person.rf.id;
	                _this.updatePerson(function () {
	                    spouse_1.facts.set(key, fact);
	                    return spouse_1;
	                }).subscribe(function () {
	                    // ignore
	                }, function (err) {
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	            }, function (err) {
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	        }
	        else {
	            this.updatePerson(function () {
	                var key = _this.utils.randomKey();
	                _this.person.rf.facts.set(key, fact);
	                if (item.fs.type === 'BIRT' && (setPreferred || _this.person.rf.preferredBirthKey === 0)) {
	                    _this.person.rf.preferredBirthKey = key;
	                }
	                else if (item.fs.type === 'DEAT' && (setPreferred || _this.person.rf.preferredDeathKey === 0)) {
	                    _this.person.rf.preferredDeathKey = key;
	                    if (_this.person.rf.living !== 'FALSE') {
	                        _this.person.rf.living = 'FALSE';
	                    }
	                }
	                return _this.person.rf;
	            }).subscribe(function () {
	                // ignore
	            }, function (err) {
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	        }
	    };
	    FsSyncController.prototype.saveRFEvidence = function (item, ev) {
	        var _this = this;
	        if (!!item.rf) {
	            item.rf.text = item.fs.text;
	            item.rf.citation.url = item.fs.citation.url;
	            item.rf.citation.text = item.fs.citation.text;
	            item.rf.externalIds.set(FS, { id: item.fs.externalIds.get(FS).id });
	            this.evidenceService.update(item.rf).subscribe(function () {
	                // ignore
	            }, function (err) {
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	        }
	        else {
	            this.utils.dialog(ev, 'FsAddSourceController', 'app/components/fsAddSource/fsAddSource.html', false, {
	                evidence: item.fs,
	                person: this.person.rf
	            }).then(function (updatePerson) {
	                _this.updatePerson(function () {
	                    updatePerson(_this.person.rf);
	                    return _this.person.rf;
	                }).subscribe(function () {
	                    // ignore
	                }, function (err) {
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	            }, function () {
	                // ignore
	            });
	        }
	    };
	    FsSyncController.prototype.saveRFMedia = function (item) {
	        var _this = this;
	        if (!!item.rf) {
	            item.rf.text = item.fs.text;
	            item.rf.title = item.fs.title;
	            item.rf.externalIds.set(FS, { id: item.fs.externalIds.get(FS).id });
	            this.mediaService.update(item.rf);
	        }
	        else {
	            this.mediaService.stream().take(1).subscribe(function (mediaMap) {
	                var media = null;
	                try {
	                    for (var _a = __values(mediaMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var m = _b.value;
	                        if (m.externalIds.has(FS) && item.fs.externalIds.get(FS).id === m.externalIds.get(FS).id) {
	                            media = m;
	                            break;
	                        }
	                    }
	                }
	                catch (e_6_1) { e_6 = { error: e_6_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_6) throw e_6.error; }
	                }
	                ;
	                if (!!media) {
	                    var target = _this.utils.clone(media);
	                    try {
	                        for (var _d = __values(item.fs.personIds.keys()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                            var pid = _e.value;
	                            target.personIds.set(pid, true);
	                        }
	                    }
	                    catch (e_7_1) { e_7 = { error: e_7_1 }; }
	                    finally {
	                        try {
	                            if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
	                        }
	                        finally { if (e_7) throw e_7.error; }
	                    }
	                    _this.mediaService.update(target);
	                }
	                else {
	                    var target = _this.utils.clone(item.fs);
	                    target.url = item.fs._url + (item.fs._url.indexOf('?') >= 0 ? '&' : '?') + 'sessionId=' + _this.fs.getAccessToken();
	                    target.fileInfos.set(0, {
	                        contentType: 'URL',
	                        fileName: item.fs._fileName || 'media'
	                    });
	                    _this.mediaService.create(target);
	                }
	                var e_6, _c, e_7, _f;
	            });
	        }
	    };
	    FsSyncController.prototype.saveRFNote = function (item) {
	        if (!!item.rf) {
	            item.rf.text = item.fs.text;
	            item.rf.title = item.fs.title;
	            item.rf.externalIds.set(FS, { id: item.fs.externalIds.get(FS).id });
	            this.noteService.update(item.rf);
	        }
	        else {
	            this.noteService.create(item.fs);
	        }
	    };
	    FsSyncController.prototype.saveRFStory = function (item) {
	        var _this = this;
	        var mediaSaver = this.rx.Observable.of(true);
	        this.storyService.stream().take(1).subscribe(function (storyMap) {
	            // find an existing story
	            var story = null;
	            if (!item.rf) {
	                try {
	                    for (var _a = __values(storyMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var s = _b.value;
	                        if (s.externalIds.has(FS) && item.fs.externalIds.get(FS).id === s.externalIds.get(FS).id) {
	                            story = s;
	                            break;
	                        }
	                    }
	                }
	                catch (e_8_1) { e_8 = { error: e_8_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_8) throw e_8.error; }
	                }
	                ;
	            }
	            var target = item.rf || _this.utils.clone(story) || _this.utils.clone(item.fs);
	            // create media?
	            var pw = null;
	            if (!!item.fs._url && target.mediaIds.size === 0) {
	                var m = {
	                    id: _this.utils.randomId(),
	                    title: item.fs.title,
	                    externalIds: new Map(),
	                    url: item.fs._url + (item.fs._url.indexOf('?') >= 0 ? '&' : '?') + 'sessionId=' + _this.fs.getAccessToken(),
	                    fileInfos: new Map([[0, {
	                                contentType: 'URL',
	                                fileName: 'story media'
	                            }]]),
	                    personIds: new Map()
	                };
	                target.mediaIds.set(m.id, true);
	                pw = _this.utils.pleaseWait(); // uploading the image takes a long time
	                mediaSaver = _this.mediaService.create(m);
	            }
	            mediaSaver.subscribe(function () {
	                if (!!pw) {
	                    _this.utils.pleaseWaitCancel(pw);
	                }
	                if (!!item.rf) {
	                    // update existing story
	                    target.text = item.fs.text;
	                    target.title = item.fs.title;
	                    target.externalIds.set(FS, { id: item.fs.externalIds.get(FS).id });
	                    _this.storyService.update(target);
	                }
	                else if (!!story) {
	                    try {
	                        // add person to story
	                        for (var _a = __values(item.fs.personIds.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                            var pid = _b.value;
	                            target.personIds.set(pid, true);
	                        }
	                    }
	                    catch (e_9_1) { e_9 = { error: e_9_1 }; }
	                    finally {
	                        try {
	                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                        }
	                        finally { if (e_9) throw e_9.error; }
	                    }
	                    _this.storyService.update(target);
	                }
	                else {
	                    // create new story
	                    _this.storyService.create(target);
	                }
	                var e_9, _c;
	            }, function (err) {
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	            var e_8, _c;
	        });
	    };
	    FsSyncController.prototype.saveRFOrdinance = function (item) {
	        var _this = this;
	        var target = item.rf || this.utils.clone(item.fs);
	        target.status = item.fs.status;
	        target.date = item.fs.date;
	        target.templeCode = item.fs.templeCode;
	        // read ordinances for person
	        this.ordinancesService.streamId(this.personId).take(1).subscribe(function (ords) {
	            var add = false;
	            if (!ords) {
	                ords = {
	                    id: _this.personId,
	                    ordinances: new Map()
	                };
	                add = true;
	            }
	            // add/update this ordinance
	            var key = Array.from(ords.ordinances.keys()).find(function (k) { return _this.ordinanceEquals(ords.ordinances.get(k), target); });
	            if (!key) {
	                key = _this.utils.randomKey();
	            }
	            ords.ordinances.set(key, target);
	            // create or update
	            if (add) {
	                _this.ordinancesService.create(ords);
	            }
	            else {
	                _this.ordinancesService.update(ords);
	            }
	        });
	    };
	    FsSyncController.prototype.saveRFOrdinances = function () {
	        var _this = this;
	        // read ordinances for person
	        this.ordinancesService.streamId(this.personId).take(1).subscribe(function (ords) {
	            var add = false;
	            if (!ords) {
	                ords = {
	                    id: _this.personId,
	                    ordinances: new Map()
	                };
	                add = true;
	            }
	            // add all missing ordinances
	            _this.ordinances.forEach(function (item) {
	                if (!!item.fs && !item.rf) {
	                    ords.ordinances.set(_this.utils.randomKey(), item.fs);
	                }
	            });
	            // create or update
	            if (add) {
	                _this.ordinancesService.create(ords);
	            }
	            else {
	                _this.ordinancesService.update(ords);
	            }
	        });
	    };
	    FsSyncController.prototype.createRFEvidence = function (fact, fsid, url, name) {
	        // let date = this.moment(Date.now()).format('DD MMM YYYY');
	        // let text = 'FamilySearch, ';
	        // if (!!url) {
	        //   text += '<a href="' + url + '">' + fsid + '</a>, ';
	        // }
	        // text += date;
	        var e = {
	            id: this.utils.randomId(),
	            fact: {
	                type: fact.type,
	                value: fact.value,
	                date: fact.date,
	                place: fact.place
	            },
	            mediaIds: new Map(),
	            citation: {},
	            personas: new Map([[1, {
	                        names: new Map(),
	                        facts: new Map(),
	                        principal: true,
	                        relatedToKey: 0,
	                        relationshipType: ''
	                    }]]),
	            externalIds: new Map()
	        };
	        if (!!name) {
	            e.personas.get(1).names.set(1, {
	                type: name.type,
	                nameForms: this.utils.clone(name.nameForms)
	            });
	        }
	        return e;
	    };
	    FsSyncController.prototype.deleteFact = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete', 'Are you sure?', ev).then(function () {
	            _this.personUtils.deleteFact(_this.person.rf, id).subscribe(function () {
	                // ignore
	            }, function (err) {
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	        }, function () {
	            // ignore
	        });
	    };
	    FsSyncController.prototype.deleteName = function (ev, id) {
	        var _this = this;
	        if (this.person.rf.names.size === 1) {
	            this.utils.alert('Sorry...', 'The software requires everyone to have a name. If you don\'t know the name, you can change it to "Unknown".', ev);
	        }
	        else {
	            this.utils.confirm('Delete', 'Are you sure?', ev).then(function () {
	                _this.personUtils.deleteName(_this.person.rf, id).subscribe(function () {
	                    // ignore
	                }, function (err) {
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	            }, function () {
	                // ignore
	            });
	        }
	    };
	    FsSyncController.prototype.addEvidence = function (ev) {
	        this.utils.dialog(ev, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	            personId: this.personId
	        });
	    };
	    FsSyncController.prototype.editEvidence = function (ev, evidence) {
	        this.utils.dialog(ev, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	            personId: this.personId,
	            evidence: evidence
	        });
	    };
	    FsSyncController.prototype.deleteEvidence = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Supporting Evidence', 'Are you sure?', ev).then(function () {
	            var evidence = _this.evidenceMap.get(id);
	            var deletedNamesFacts = _this.evidenceUtils.getDeletedNamesFacts([evidence], [], true);
	            _this.$log.debug('person.deleteEvidence', deletedNamesFacts);
	            if (deletedNamesFacts.filter(function (nf) { return !nf.primary && nf.principal && nf.unsupported; }).length > 0) {
	                _this.utils.dialog(null, 'SelectNamesFactsController', 'app/components/selectNamesFacts/selectNamesFacts.html', false, {
	                    namesFacts: deletedNamesFacts
	                }).then(function (deletedNamesFacts) {
	                    _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe(function () {
	                        // ignore
	                    }, function (err) {
	                        _this.messageBus.post({ msg: err, warn: true });
	                    });
	                }, function () {
	                    // ignore
	                });
	            }
	            else {
	                _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe(function () {
	                    // ignore
	                }, function (err) {
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	            }
	        }, function () {
	            // ignore
	        });
	    };
	    FsSyncController.prototype.addStory = function (ev) {
	        this.utils.dialog(ev, 'EditStoryController', 'app/components/editStory/editStory.html', false, {
	            personId: this.personId
	        });
	    };
	    FsSyncController.prototype.editStory = function (ev, story) {
	        this.utils.dialog(ev, 'EditStoryController', 'app/components/editStory/editStory.html', false, {
	            story: story
	        });
	    };
	    FsSyncController.prototype.deleteStory = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Story', 'Are you sure?', ev).then(function () {
	            _this.storyService.del(id);
	        }, function () {
	            // ignore
	        });
	    };
	    FsSyncController.prototype.addNote = function (ev) {
	        this.utils.dialog(ev, 'EditNoteController', 'app/components/editNote/editNote.html', false, {
	            personId: this.personId
	        });
	    };
	    FsSyncController.prototype.editNote = function (ev, note) {
	        this.utils.dialog(ev, 'EditNoteController', 'app/components/editNote/editNote.html', false, {
	            note: note
	        });
	    };
	    FsSyncController.prototype.deleteNote = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Note', 'Are you sure?', ev).then(function () {
	            _this.noteService.del(id);
	        }, function () {
	            // ignore
	        });
	    };
	    FsSyncController.prototype.showMedia = function (ev, item) {
	        var _this = this;
	        this.utils.dialog(ev, 'MediaController', 'app/components/media/media.dialog.html', true, {
	            media: item
	        }).then(function (response) {
	            if (!!response) {
	                if (response === 'edit') {
	                    _this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	                        media: item
	                    });
	                }
	                else if (response === 'delete') {
	                    _this.utils.dialog(ev, 'DeleteMediaController', 'app/components/deleteMedia/deleteMedia.html', false, {
	                        media: item
	                    }).then(function () {
	                        _this.mediaService.del(item.id);
	                    }, function () {
	                        // ignore
	                    });
	                }
	                else if (response === 'mosaic') {
	                    _this.mediaUtils.mosaic(ev, item);
	                }
	            }
	        }, function () {
	            // ignore
	        });
	    };
	    FsSyncController.prototype.addMedia = function (ev) {
	        this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	            personId: this.personId
	        });
	    };
	    FsSyncController.prototype.editMedia = function (ev, media) {
	        this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	            media: media
	        });
	    };
	    FsSyncController.prototype.deleteMedia = function (ev, media) {
	        var _this = this;
	        this.utils.dialog(ev, 'DeleteMediaController', 'app/components/deleteMedia/deleteMedia.html', false, {
	            media: media
	        }).then(function () {
	            _this.mediaService.del(media.id);
	        }, function () {
	            // ignore
	        });
	    };
	    FsSyncController.prototype.editOrdinance = function (ev, ordinance) {
	        this.utils.dialog(ev, 'EditOrdinanceController', 'app/components/editOrdinance/editOrdinance.html', false, {
	            personId: this.personId,
	            ordinance: ordinance
	        });
	    };
	    FsSyncController.prototype.deleteOrdinance = function (ev, key) {
	        var _this = this;
	        this.utils.confirm('Delete Ordinance', 'Are you sure?', ev).then(function () {
	            _this.ordinancesService.streamId(_this.personId).take(1).subscribe(function (ords) {
	                // delete this ordinance
	                ords.ordinances.delete(key);
	                _this.ordinancesService.update(ords);
	            });
	        }, function () {
	            // ignore
	        });
	    };
	    FsSyncController.prototype.showSource = function (ev, id) {
	        this.utils.showSource(ev, this.sourceService, this.evidenceService, this.userService, id);
	    };
	    return FsSyncController;
	}());
	exports.default = FsSyncController;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var GraphController = /** @class */ (function () {
	    GraphController.$inject = ["$log", "$scope", "$state", "$transition$", "$rootScope", "$timeout", "$mdToast", "rx", "currentTree", "rightsFull", "treeUsers", "utils"];
	    function GraphController($log, $scope, $state, $transition$, $rootScope, $timeout, $mdToast, rx, currentTree, rightsFull, treeUsers, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.$rootScope = $rootScope;
	        this.$mdToast = $mdToast;
	        this.utils = utils;
	        // at present, the formats can't be used in an ng-repeat in the fab due to a bug, so they have been copied onto the html page
	        var formats = [{
	                id: 'pedigree',
	                icon: 'rc:icon-pedigree',
	                label: 'Ancestors Pedigree'
	            }, {
	                id: 'fan',
	                icon: 'rc:icon-fan-tree',
	                label: 'Ancestors Fan'
	            }, {
	                id: 'fractal',
	                icon: 'rc:icon-fractal',
	                label: 'Ancestors Fractal'
	            }, {
	                id: 'ancestors-descendants',
	                icon: 'rc:icon-family-view',
	                label: 'Ancestors and Descendants'
	            }, {
	                id: 'descendants',
	                icon: 'rc:icon-descendancy',
	                label: 'Descendants List'
	            }, {
	                id: 'sunburst',
	                icon: 'rc:icon-sunburst',
	                label: 'Descendants Sunburst'
	            }, {
	                id: 'mcguire',
	                icon: 'clear_all',
	                label: 'McGuire'
	            }];
	        // listen for emitted dnaMatchesMap updated events and broadcast a different event
	        $scope.$on('dna-matches', function (ev, matches) {
	            $scope.$broadcast('dna-matches-update', matches);
	        });
	        var tuSub = treeUsers.stream().subscribe(function (tu) {
	            var format = ($transition$.params().format || tu.preferences['TREEVIEW'] || 'pedigree').toLowerCase();
	            _this.format = formats.find(function (v) { return v.id === format; });
	            if (!!$transition$.params().root) {
	                _this.root = utils.decodeId($transition$.params().root);
	            }
	            else if (!!tu.preferences['ROOT']) {
	                var root = parseInt(tu.preferences['ROOT'], 10);
	                _this.$state.go('tree.graph', { format: $transition$.params().format, root: utils.encodeId(root) }, { location: 'replace' });
	            }
	            else {
	                // TODO if root is still 0, ask who to display as root
	            }
	            if (!!_this.root) {
	                treeUsers.setGuestRoot($rootScope, _this.root);
	                $log.info('graph', _this.format.id, 'personId=', _this.root);
	            }
	        });
	        var treeRightsSub = rx.Observable.combineLatest(currentTree.stream(), rightsFull.streamLevel()).subscribe(function (_a) {
	            var _b = __read(_a, 2), tree = _b[0], level = _b[1];
	            if (!!tree && tree.preferences.HINT_SETTINGS_REVIEWED !== 'TRUE' && level === rightsFull.LEVEL_OWNER && !_this.$rootScope.hintsToastPosted) {
	                _this.$rootScope.hintsToastPosted = true;
	                _this.showHintsToast();
	            }
	        });
	        $scope.$on('$destroy', function () {
	            tuSub.unsubscribe();
	            treeRightsSub.unsubscribe();
	        });
	    }
	    GraphController.prototype.switchFormat = function (format) {
	        this.$log.info('switchFormat', format);
	        this.$state.go('tree.graph', { format: format, root: this.utils.encodeId(this.root) });
	    };
	    GraphController.prototype.showHintsToast = function () {
	        var _this = this;
	        this.$mdToast.show({
	            hideDelay: 0,
	            position: 'top right',
	            controller: 'HintsToastController',
	            controllerAs: 'hintsToast',
	            bindToController: true,
	            locals: {},
	            templateUrl: 'app/components/hintsToast/hintsToast.html'
	        }).then(function () {
	            _this.$state.go('tree.hintSettings');
	        }).catch(function () {
	            // ignore
	        });
	    };
	    return GraphController;
	}());
	exports.default = GraphController;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var HintSettingsController = /** @class */ (function () {
	    HintSettingsController.$inject = ["$scope", "$state", "$transition$", "authToken", "messageBus", "rx", "rightsFull", "currentTree", "currentTreeId", "fs", "treeUsers", "persons", "leads", "server", "utils"];
	    function HintSettingsController($scope, $state, $transition$, authToken, messageBus, rx, rightsFull, currentTree, currentTreeId, fs, treeUsers, persons, leads, server, utils) {
	        'ngInject';
	        var _this = this;
	        this.$state = $state;
	        this.authToken = authToken;
	        this.messageBus = messageBus;
	        this.rx = rx;
	        this.currentTree = currentTree;
	        this.currentTreeId = currentTreeId;
	        this.fs = fs;
	        this.leads = leads;
	        this.server = server;
	        this.utils = utils;
	        this.init = $transition$.params().init;
	        this.tree = null;
	        this.tu = null;
	        this.isFeatured = false;
	        this.isOwner = false;
	        var sub = utils.readyChange(persons, currentTree).subscribe(function (_a) {
	            var _b = __read(_a, 2), pm = _b[0], tree = _b[1];
	            _this.numPersons = pm.size;
	            _this.tree = utils.clone(tree);
	            var first = !!tree && tree.preferences.HINT_SETTINGS_REVIEWED !== 'TRUE';
	            if (first) {
	                _this.utils.alert('Sign up for hints', 'Hints help you find information about your ancestors. ' +
	                    'We recommend signing up for all hints. ' +
	                    'The FamilySearch hints in particular are excellent and free. ' +
	                    'After signing up for the hints you want, click "Save" at the bottom.');
	            }
	            _this.leadsForDL = _this.tree.preferences.LEADS_FOR_DL === 'TRUE';
	            _this.leadsForEOL = _this.tree.preferences.LEADS_FOR_EOL === 'TRUE';
	            _this.leadsForAll = _this.tree.preferences.LEADS_FOR_ALL === 'TRUE';
	            _this.leadsFromFS = _this.tree.preferences.LEADS_FROM_FS === 'TRUE' || first;
	            _this.leadsFromFMP = _this.tree.preferences.LEADS_FROM_FMP === 'TRUE' || first;
	            _this.leadsFromNEHGS = _this.tree.preferences.LEADS_FROM_NEHGS === 'TRUE' || first;
	            _this.leadsFromGENI = _this.tree.preferences.LEADS_FROM_GENI === 'TRUE' || first;
	            _this.leadsFromFSFT = _this.tree.preferences.LEADS_FROM_FSFT === 'TRUE' || first;
	            _this.leadsFromWeRelate = _this.tree.preferences.LEADS_FROM_WERELATE === 'TRUE' || first;
	            _this.leadsFromWikiTree = _this.tree.preferences.LEADS_FROM_WIKITREE === 'TRUE' || first;
	            _this.leadsFromRootsPoint = _this.tree.preferences.LEADS_FROM_ROOTSPOINT === 'TRUE' || first;
	            _this.leadsFromOpenArch = _this.tree.preferences.LEADS_FROM_OPENARCH === 'TRUE' || first;
	            _this.leadsFromGonl = _this.tree.preferences.LEADS_FROM_GONL === 'TRUE' || first;
	            _this.fsAgree = _this.tree.preferences.LEADS_FROM_FS === 'TRUE';
	            _this.setLeadsFromAll();
	        });
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            if (level < rightsFull.LEVEL_READ) {
	                $state.go('tree');
	            }
	            _this.isOwner = (level === rightsFull.LEVEL_OWNER);
	        });
	        $scope.$on('$destroy', function () {
	            sub.unsubscribe();
	        });
	    }
	    HintSettingsController.prototype.toggleLeadsForAll = function () {
	        if (this.leadsForAll) {
	            this.leadsForDL = true;
	            this.leadsForEOL = true;
	        }
	    };
	    HintSettingsController.prototype.setLeadsForAll = function () {
	    };
	    HintSettingsController.prototype.toggleLeadsFromAll = function () {
	        this.leadsFromFS = this.leadsFromAll;
	        this.leadsFromFMP = this.leadsFromAll;
	        this.leadsFromNEHGS = this.leadsFromAll;
	        this.leadsFromGENI = this.leadsFromAll;
	        this.leadsFromFSFT = this.leadsFromAll;
	        this.leadsFromWeRelate = this.leadsFromAll;
	        this.leadsFromWikiTree = this.leadsFromAll;
	        this.leadsFromRootsPoint = this.leadsFromAll;
	        this.leadsFromOpenArch = this.leadsFromAll;
	        this.leadsFromGonl = this.leadsFromAll;
	    };
	    HintSettingsController.prototype.setLeadsFromAll = function () {
	        this.leadsFromAll = (this.leadsFromFS &&
	            this.leadsFromFMP &&
	            this.leadsFromNEHGS &&
	            this.leadsFromGENI &&
	            this.leadsFromWeRelate &&
	            this.leadsFromWikiTree &&
	            this.leadsFromRootsPoint &&
	            this.leadsFromOpenArch &&
	            this.leadsFromGonl &&
	            this.leadsFromFSFT);
	    };
	    HintSettingsController.prototype.setLeadsFromFS = function () {
	        if (!this.leadsFromFS) {
	            this.fsAgree = false;
	        }
	        this.setLeadsFromAll();
	    };
	    HintSettingsController.prototype.save = function (ev) {
	        var _this = this;
	        if (this.tree.preferences.LEADS_FOR_ALL !== 'TRUE' && this.leadsForAll && this.numPersons > 2000) {
	            this.utils.alert('Can\'t request hints for more than 2,000 people', 'This would place too much of a burden on our hinting partners. You can check the other boxes, or turn on hints for specific individuals by clicking the star on their profile page.');
	        }
	        else if (this.leadsFromFS && !this.fsAgree) {
	            this.utils.confirm('FamilySearch agreement', 'FamilySearch will give you the most hints, and best of all, they\'re FREE. ' +
	                'To get hints from FamilySearch, a copy of your tree will be kept on FamilySearch. ' +
	                'The deceased people in your tree will be visible to, but not editable by, FamilySearch users. ' +
	                'Do you agree?')
	                .then(function () {
	                _this._continueSave(ev);
	            }, function () {
	                _this.leadsFromFS = false;
	                _this._continueSave(ev);
	            });
	        }
	        else {
	            this._continueSave(ev);
	        }
	    };
	    HintSettingsController.prototype._continueSave = function (ev) {
	        var _this = this;
	        if (this.leadsFromFS && !this.tree.externalIds.has('familysearch.org')) {
	            this.utils.dialog(ev, 'FsLoginController', 'app/components/fsLogin/fsLogin.html', true, {
	                text: 'Getting hints from FamilySearch requires a one-time login to FamilySearch. You can create a FamilySearch account if you do not already have one.'
	            }).then(function (token) {
	                if (token != null) {
	                    _this.checkDelete(ev, token);
	                }
	            }, function () {
	                // ignore
	            });
	        }
	        else if (!this.leadsFromFS && this.tree.preferences.LEADS_FROM_FS === 'TRUE') {
	            //this.utils.confirm('Remove tree from FamilySearch Genealogies?', 'You have turned off the free FamilySearch hints. ' +
	            //  'Do you also want to remove your tree from the FamilySearch Genealogies archive?', ev, 'Yes', 'No').then(() => {
	            this.utils.dialog(ev, 'FsLoginController', 'app/components/fsLogin/fsLogin.html', true, {
	                text: 'Removing your tree from FamilySearch Genealogies requires you to log into FamilySearch.'
	            }).then(function (token) {
	                _this.tree.externalIds.delete('familysearch.org');
	                _this.checkDelete(ev, token);
	            }, function () {
	                _this.utils.alert('Save cancelled', 'Changes were not saved', ev);
	            });
	            //}, () => {
	            //  this.checkDelete(ev);
	            //});
	        }
	        else {
	            this.checkDelete(ev, null);
	        }
	    };
	    HintSettingsController.prototype.checkDelete = function (ev, token) {
	        var _this = this;
	        var deleteFrom = [];
	        if ((this.tree.preferences.LEADS_FROM_FS === 'TRUE' && !this.leadsFromFS)) {
	            deleteFrom.push({ name: 'FamilySearch Historical Records', keys: ['FamilySearch Historical Records', 'familysearch.org'] });
	        }
	        if ((this.tree.preferences.LEADS_FROM_FMP === 'TRUE' && !this.leadsFromFMP)) {
	            deleteFrom.push({ name: 'Findmypast', keys: ['Findmypast'] });
	        }
	        if ((this.tree.preferences.LEADS_FROM_NEHGS === 'TRUE' && !this.leadsFromNEHGS)) {
	            deleteFrom.push({ name: 'AmericanAncestors', keys: ['AmericanAncestors'] });
	        }
	        if ((this.tree.preferences.LEADS_FROM_GENI === 'TRUE' && !this.leadsFromGENI)) {
	            deleteFrom.push({ name: 'Geni', keys: ['Geni'] });
	        }
	        if ((this.tree.preferences.LEADS_FROM_FSFT === 'TRUE' && !this.leadsFromFSFT)) {
	            deleteFrom.push({ name: 'FamilySearch Family Tree', keys: ['FamilyTree'] });
	        }
	        if ((this.tree.preferences.LEADS_FROM_WERELATE === 'TRUE' && !this.leadsFromWeRelate)) {
	            deleteFrom.push({ name: 'WeRelate', keys: ['weRelate'] });
	        }
	        if ((this.tree.preferences.LEADS_FROM_WIKITREE === 'TRUE' && !this.leadsFromWikiTree)) {
	            deleteFrom.push({ name: 'WikiTree', keys: ['wikiTrees'] });
	        }
	        if ((this.tree.preferences.LEADS_FROM_ROOTSPOINT === 'TRUE' && !this.leadsFromRootsPoint)) {
	            deleteFrom.push({ name: 'RootsPoint', keys: ['RootsPoint'] });
	        }
	        if ((this.tree.preferences.LEADS_FROM_OPENARCH === 'TRUE' && !this.leadsFromOpenArch)) {
	            deleteFrom.push({ name: 'OpenArch.nl', keys: ['OpenArch'] });
	        }
	        if ((this.tree.preferences.LEADS_FROM_GONL === 'TRUE' && !this.leadsFromGonl)) {
	            deleteFrom.push({ name: 'GenealogieOnline.nl', keys: ['gonl'] });
	        }
	        if (deleteFrom.length > 0) {
	            var hintSources = deleteFrom.map(function (df) { return df.name; }).join(', ');
	            var sourceRef = deleteFrom.length === 1 ? 'this source' : 'these sources';
	            this.utils.confirm('Remove existing hints?', 'You have turned off hints from ' + hintSources +
	                '. Do you also want to remove any existing hints from ' + sourceRef + '?', ev, 'Yes', 'No').then(function () {
	                _this.saving = true;
	                var pw = _this.utils.pleaseWait();
	                console.log('before delete', deleteFrom);
	                _this.deleteLeads([].concat.apply([], deleteFrom.map(function (df) { return df.keys; }))).subscribe(function () {
	                    console.log('after delete');
	                    _this.utils.pleaseWaitCancel(pw);
	                    _this._save(token);
	                }, function (err) {
	                    // not sure why this is necessary - why isn't error already posted?
	                    _this.utils.pleaseWaitCancel(pw);
	                    _this.messageBus.post({ msg: err, op: 'DELETE', ctx: 'leads' });
	                    _this.saving = false;
	                });
	            }, function () {
	                _this._save(token);
	            });
	        }
	        else {
	            this._save(token);
	        }
	    };
	    HintSettingsController.prototype.deleteLeads = function (keys) {
	        var _this = this;
	        console.log('deleteLeads.keys', keys);
	        return keys.length === 0 ? this.rx.Observable.of([]) : (_a = this.rx.Observable).forkJoin.apply(_a, __spread(keys.map(function (key) {
	            console.log('deleteLeads.key', key);
	            return _this.leads.delSource(key);
	        })));
	        var _a;
	        // return this.leads.ready().flatMap(() => this.leads.stream()).take(1).flatMap(leads => {
	        //   let ids = Array.from(leads.values()).filter(lead => keys.some(key => lead.externalIds.has(key))).map(lead => lead.id);
	        //   console.log('deleteLeads.ids', ids);
	        //   return ids.length === 0 ? this.rx.Observable.of([]) : this.rx.Observable.forkJoin(...ids.map(id => {
	        //     let delay = Math.floor(Math.random() * ids.length * 100);
	        //     // spread out requests
	        //     return this.rx.Observable.of(null).pipe(this.rx.operators.delay(delay)).flatMap(() => {
	        //       return this.leads.del(id);
	        //     });
	        //   }));
	        // });
	    };
	    HintSettingsController.prototype._save = function (token) {
	        var _this = this;
	        this.saving = true;
	        this.tree.preferences.HINT_SETTINGS_REVIEWED = 'TRUE';
	        this.tree.preferences.LEADS_FOR_ALL = this.leadsForAll ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FOR_DL = this.leadsForDL ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FOR_EOL = this.leadsForEOL ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FROM_FS = this.leadsFromFS ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FROM_FMP = this.leadsFromFMP ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FROM_NEHGS = this.leadsFromNEHGS ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FROM_GENI = this.leadsFromGENI ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FROM_FSFT = this.leadsFromFSFT ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FROM_WERELATE = this.leadsFromWeRelate ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FROM_WIKITREE = this.leadsFromWikiTree ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FROM_ROOTSPOINT = this.leadsFromRootsPoint ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FROM_OPENARCH = this.leadsFromOpenArch ? 'TRUE' : 'FALSE';
	        this.tree.preferences.LEADS_FROM_GONL = this.leadsFromGonl ? 'TRUE' : 'FALSE';
	        this.currentTree.update(this.tree, { fsToken: token }).subscribe(function () {
	            if (!!_this.init) {
	                _this.$state.go('tree.apps', { init: _this.init });
	            }
	            else {
	                _this.saving = false;
	                _this.utils.alert('Hint Settings have been saved', 'If you signed up for new hints, they will usually arrive in under an hour.').then(function () {
	                    _this.$state.go('tree');
	                });
	            }
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    return HintSettingsController;
	}());
	exports.default = HintSettingsController;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var HomeController = /** @class */ (function () {
	    HomeController.$inject = ["$log", "$mdMedia", "$state", "$scope", "utils", "currentUserId"];
	    function HomeController($log, $mdMedia, $state, $scope, utils, currentUserId) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdMedia = $mdMedia;
	        this.$state = $state;
	        this.utils = utils;
	        //vwo.trackPage();
	        var cuSub = currentUserId.stream().subscribe(function (userId) {
	            if (userId !== 0) {
	                _this.$state.go('homeSignedIn');
	            }
	        });
	        $scope.$on('$destroy', function () {
	            cuSub.unsubscribe();
	        });
	    }
	    HomeController.prototype.getStarted = function () {
	        //this.vwo.trackConversion(201);
	        this.$state.go('register');
	    };
	    HomeController.prototype.login = function (ev) {
	        this.utils.dialog(ev, 'SignInController', 'app/components/signIn/signIn.html');
	    };
	    return HomeController;
	}());
	exports.default = HomeController;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2018
	 */
	var HomeSignedInController = /** @class */ (function () {
	    HomeSignedInController.$inject = ["$log", "$scope", "$state", "$mdMedia", "rx", "blog", "currentUserId", "currentUser", "subscriptions", "showAds", "server", "moment", "messageBus", "utils"];
	    function HomeSignedInController($log, $scope, $state, $mdMedia, rx, blog, currentUserId, currentUser, subscriptions, showAds, server, moment, messageBus, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.$mdMedia = $mdMedia;
	        this.trees = [];
	        this.posts = [];
	        var rfSub = showAds.stream().subscribe(function (sa) {
	            _this.showAds = sa;
	        });
	        // keep in sync with selectTree
	        var cuSub = currentUserId.stream().subscribe(function (userId) {
	            if (userId > 0) {
	                // keep in sync with userSettings
	                // server.get('/billing/'+userId).subscribe(billing => {
	                //   billing = utils.fromServer(billing);
	                //   this.billing = !!billing.cardType ? billing : null;
	                // });
	                // keep in sync with selectTree
	                rx.Observable.forkJoin([currentUser.readTrees(userId), currentUser.readCurrentTreeId(userId)])
	                    .take(1).subscribe(function (_a) {
	                    var _b = __read(_a, 2), trees = _b[0], treeId = _b[1];
	                    _this.trees = Array.from(trees.values());
	                    // sort trees by name
	                    _this.trees.sort(function (a, b) {
	                        var n1 = a.name.toLowerCase();
	                        var n2 = b.name.toLowerCase();
	                        if (n1 < n2) {
	                            return -1;
	                        }
	                        else if (n1 > n2) {
	                            return 1;
	                        }
	                        return a.id - b.id;
	                    });
	                    // put current tree at top
	                    var pos = _this.trees.findIndex(function (tree) { return tree.id === treeId; });
	                    if (pos >= 0) {
	                        var tree = _this.trees.splice(pos, 1);
	                        _this.trees.unshift(tree[0]);
	                    }
	                }, function (err) {
	                    messageBus.post({ msg: err.data, op: "READ", ctx: "users_trees" });
	                });
	            }
	        });
	        // keep in sync with userSettings
	        this.plan = 'FREE';
	        var subSub = subscriptions.stream().subscribe(function (subscription) {
	            _this.subscription = subscription;
	            if (!!subscription) {
	                _this.plan = subscription.level || 'FREE';
	                _this.autoRenew = false; // subscription.autoRenew;
	                _this.endDate = moment(subscription.endDate).format('D MMM YYYY');
	            }
	            else {
	                _this.plan = 'FREE';
	                _this.autoRenew = false;
	                _this.endDate = '';
	            }
	        });
	        blog.read('news').take(1).subscribe(function (posts) {
	            _this.posts = posts;
	        });
	        $scope.$on('$destroy', function () {
	            rfSub.unsubscribe();
	            cuSub.unsubscribe();
	            subSub.unsubscribe();
	        });
	    }
	    HomeSignedInController.prototype.showRightAds = function () {
	        return this.showAds && this.$mdMedia('gt-sm'); // keep in sync with index.run.js
	    };
	    HomeSignedInController.prototype.selectTree = function (tree) {
	        this.$state.go('tree', { treeId: tree.id });
	    };
	    HomeSignedInController.prototype.createTree = function () {
	        this.$state.go('create');
	    };
	    return HomeSignedInController;
	}());
	exports.default = HomeSignedInController;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var ImportFsController = /** @class */ (function () {
	    ImportFsController.$inject = ["$log", "$rootScope", "$scope", "$state", "$transition$", "fs", "fsImport", "messageBus", "segment", "persons", "medias", "stories", "rightsFull", "utils"];
	    function ImportFsController($log, $rootScope, $scope, $state, $transition$, fs, fsImport, messageBus, segment, persons, medias, stories, rightsFull, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.$rootScope = $rootScope;
	        this.fs = fs;
	        this.fsImport = fsImport;
	        this.messageBus = messageBus;
	        this.segment = segment;
	        this.persons = persons;
	        this.medias = medias;
	        this.stories = stories;
	        this.utils = utils;
	        this.root = $transition$.params().root;
	        this.hasRoot = !!this.root;
	        this.iSub = null;
	        this.ancGenerations = 4;
	        this.descGenerations = 1;
	        this.progress = { currentGen: 0, percent: 0, name: 'Importing...' };
	        this.importErrors = 0;
	        this.importComplete = false;
	        this.hasPeople = false;
	        this.fsLoggedIn = false;
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            if (level < rightsFull.LEVEL_EDIT) {
	                $state.go('tree');
	            }
	        });
	        if (this.isImporting()) {
	            this.utils.alert('Import in progress', 'An import is currently in progress.');
	            this.monitorProgress();
	        }
	        else if (!fs.isLoggedIn()) {
	            this.fsLogin();
	        }
	        else {
	            this.fsLoginSuccess();
	        }
	        $scope.$on('$destroy', function () {
	            if (!!_this.iSub) {
	                _this.iSub.unsubscribe();
	            }
	        });
	    }
	    ImportFsController.prototype.fsLogin = function (ev) {
	        var _this = this;
	        this.utils.dialog(ev, 'FsLoginController', 'app/components/fsLogin/fsLogin.html', true, {
	            text: 'Log into FamilySearch.'
	        }).then(function () {
	            _this.fsLoginSuccess();
	        }, function () {
	            // ignore
	        });
	    };
	    ImportFsController.prototype.fsLoginSuccess = function () {
	        this.fs.clearCache();
	        this.fsLoggedIn = true;
	        if (!!this.root) {
	            this.setName();
	        }
	        else {
	            this.setRoot();
	        }
	    };
	    ImportFsController.prototype.isValidGenerations = function () {
	        return (this.ancGenerations <= 8 && this.descGenerations === 0) ||
	            (this.ancGenerations <= 4 && this.descGenerations <= 1) ||
	            (this.ancGenerations <= 2 && this.descGenerations <= 2) ||
	            (this.ancGenerations === 0 && this.descGenerations <= 3);
	    };
	    ImportFsController.prototype.isLoggedIn = function () {
	        return this.fs.isLoggedIn();
	    };
	    ImportFsController.prototype.setRoot = function () {
	        var _this = this;
	        this.fs.getCurrentUsersPID().take(1).subscribe(function (pid) {
	            _this.root = pid;
	            _this.setName();
	        });
	    };
	    ImportFsController.prototype.setName = function () {
	        var _this = this;
	        this.rootName = '';
	        if (!!this.root && this.root.trim().length === 8) {
	            this.root = this.root.toUpperCase().trim();
	            this.fs.getPerson(this.root, false).take(1).subscribe(function (p) {
	                _this.rootName = !!p && !!p.display ? (p.display.name + ' (' + p.display.lifespan + ')') : '';
	            }, function (err) {
	                _this.messageBus.post({ msg: 'Error reading FamilySearch ID:' + _this.root + ': ' + err, op: 'GET', ctx: 'fsImport', warn: true });
	                _this.utils.alert('Can\'t read FamilySearch ID', 'A FamilySearch ID is 4 uppercase letters or numbers, followed by a hyphen, followed by 3 uppercase letters or numbers.');
	            });
	        }
	    };
	    ImportFsController.prototype.isReady = function () {
	        return !!this.root && this.isValidGenerations() && this.isLoggedIn() && this.rootName && this.canImport();
	    };
	    ImportFsController.prototype.isImporting = function () {
	        return !!this.$rootScope.fsImportStream;
	    };
	    ImportFsController.prototype.isImportComplete = function () {
	        return this.importComplete;
	    };
	    ImportFsController.prototype.canImport = function () {
	        return !this.isImporting() && !this.hasPeople;
	    };
	    ImportFsController.prototype.import = function (ev) {
	        var _this = this;
	        this.utils.readyChange(this.persons).take(1).subscribe(function (_a) {
	            var _b = __read(_a, 1), personMap = _b[0];
	            var count = 0;
	            try {
	                for (var _c = __values(personMap.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                    var p = _d.value;
	                    if (!p.externalIds.has('familysearch.org') || !p.externalIds.get('familysearch.org').id) {
	                        count++;
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            if (count === 0) {
	                _this._import();
	            }
	            else {
	                _this.utils.confirm('Continue?', 'There are ' + count + ' people in your tree who are not matched to FamilySearch. ' +
	                    'You may get duplicates if any of these people are in the generations you want to download. ' +
	                    'It\'s a good idea to match all the people in your tree to FamilySearch before downloading more generations. ' +
	                    'You can see who hasn\'t been matched by clicking on "People" in the left-hand menu. ' +
	                    'Are you sure you want to continue?', ev).then(function () {
	                    _this._import();
	                }, function () {
	                    // ignore
	                });
	            }
	            var e_1, _e;
	        });
	    };
	    ImportFsController.prototype._import = function () {
	        var _this = this;
	        this.segment.track('fs.import');
	        this.cancelled = false;
	        this.saving = true;
	        this.utils.readyChange(this.persons, this.medias, this.stories).take(1).subscribe(function (_a) {
	            var _b = __read(_a, 3), personMap = _b[0], mediaMap = _b[1], storyMap = _b[2];
	            var alreadyDownloadedPIDs = new Map();
	            try {
	                for (var _c = __values(personMap.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                    var p = _d.value;
	                    if (p.externalIds.has('familysearch.org')) {
	                        alreadyDownloadedPIDs.set(p.externalIds.get('familysearch.org').id, p.id);
	                    }
	                }
	            }
	            catch (e_2_1) { e_2 = { error: e_2_1 }; }
	            finally {
	                try {
	                    if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                }
	                finally { if (e_2) throw e_2.error; }
	            }
	            var alreadyDownloadedMIDs = new Map();
	            try {
	                for (var _f = __values(mediaMap.values()), _g = _f.next(); !_g.done; _g = _f.next()) {
	                    var m = _g.value;
	                    if (m.externalIds.has('familysearch.org')) {
	                        alreadyDownloadedMIDs.set(m.externalIds.get('familysearch.org').id, m.id);
	                    }
	                }
	            }
	            catch (e_3_1) { e_3 = { error: e_3_1 }; }
	            finally {
	                try {
	                    if (_g && !_g.done && (_h = _f.return)) _h.call(_f);
	                }
	                finally { if (e_3) throw e_3.error; }
	            }
	            var alreadyDownloadedSIDs = new Map();
	            try {
	                for (var _j = __values(storyMap.values()), _k = _j.next(); !_k.done; _k = _j.next()) {
	                    var s = _k.value;
	                    if (s.externalIds.has('familysearch.org')) {
	                        alreadyDownloadedSIDs.set(s.externalIds.get('familysearch.org').id, s.id);
	                    }
	                }
	            }
	            catch (e_4_1) { e_4 = { error: e_4_1 }; }
	            finally {
	                try {
	                    if (_k && !_k.done && (_l = _j.return)) _l.call(_j);
	                }
	                finally { if (e_4) throw e_4.error; }
	            }
	            _this.$rootScope.fsImportStream = _this.fsImport.doImport(_this.root, _this.ancGenerations, _this.descGenerations, alreadyDownloadedPIDs, alreadyDownloadedMIDs, alreadyDownloadedSIDs);
	            _this.monitorProgress();
	            _this.saving = false;
	            var e_2, _e, e_3, _h, e_4, _l;
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    ImportFsController.prototype.monitorProgress = function () {
	        var _this = this;
	        this.iSub = this.$rootScope.fsImportStream.subscribe(function (progress) {
	            if (progress.error === 'FS_CANCEL') {
	                _this.cancelled = true;
	            }
	            else if (!!progress.error) {
	                _this.importErrors++;
	                _this.messageBus.post({ msg: 'Error importing from FamilySearch: ' + progress.error, op: 'POST', ctx: 'fsImport', warn: true });
	            }
	            else if (progress.requests > 0) {
	                _this.progress = {
	                    name: progress.name,
	                    percent: progress.responses / progress.requests
	                };
	            }
	        }, function (error) {
	            _this.$rootScope.fsImportStream = null;
	            _this.iSub = null;
	            _this.messageBus.post({ msg: 'FamilySearch import error: ' + error + ' Please contact support@rootsfinder.com', op: 'POST', ctx: 'fsImport', warn: true });
	        }, function () {
	            _this.$rootScope.fsImportStream = null;
	            _this.iSub = null;
	            if (!_this.cancelled) {
	                _this.importComplete = true;
	                if (_this.importErrors === 0) {
	                    _this.messageBus.post({ msg: 'FamilySearch import complete!', op: 'POST', ctx: 'fsimport' });
	                }
	                else {
	                    _this.messageBus.post({ msg: 'FamilySearch import complete with errors. Please contact support@rootsfinder.com', op: 'POST', ctx: 'fsimport' });
	                }
	            }
	        });
	    };
	    ImportFsController.prototype.go = function () {
	        var _this = this;
	        if (this.hasRoot) {
	            this.persons.ready().subscribe(function () {
	                var pm = _this.persons.getMap();
	                var found = false;
	                try {
	                    for (var _a = __values(pm.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var p = _b.value;
	                        if (p.externalIds.has('familysearch.org') && p.externalIds.get('familysearch.org').id === _this.root) {
	                            _this.$state.go('tree.person', { personId: _this.utils.encodeId(p.id) });
	                            found = true;
	                            break;
	                        }
	                    }
	                }
	                catch (e_5_1) { e_5 = { error: e_5_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_5) throw e_5.error; }
	                }
	                if (!found) {
	                    _this.$state.go('tree');
	                }
	                var e_5, _c;
	            });
	        }
	        else {
	            this.$state.go('tree.hintSettings', { init: 'familysearch' });
	        }
	    };
	    return ImportFsController;
	}());
	exports.default = ImportFsController;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var ImportGedcomController = /** @class */ (function () {
	    ImportGedcomController.$inject = ["$log", "$scope", "$state", "$window", "$timeout", "$interval", "serverBase", "server", "currentTree", "currentTreeId", "notifications", "segment", "authToken", "utils"];
	    function ImportGedcomController($log, $scope, $state, $window, $timeout, $interval, serverBase, server, currentTree, currentTreeId, notifications, segment, authToken, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.$window = $window;
	        this.$timeout = $timeout;
	        this.$interval = $interval;
	        this.serverBase = serverBase;
	        this.server = server;
	        this.currentTree = currentTree;
	        this.currentTreeId = currentTreeId;
	        this.segment = segment;
	        this.authToken = authToken;
	        this.utils = utils;
	        this.isLocked = false;
	        this.isImporting = false;
	        this.isImportable = false;
	        this.nSub = null;
	        this.importMsg = 'Your tree is ready!';
	        this.interval = null;
	        var nSub = this.utils.readyChange(notifications).subscribe(function (_a) {
	            var _b = __read(_a, 1), m = _b[0];
	            var gedcomNotifs = Array.from(m.values()).filter(function (m) { return m.type === 'GEDCOM'; }).sort(function (a, b) { return b.createdDate - a.createdDate; }); // newest first
	            if (gedcomNotifs.length > 0) {
	                _this.importMsg = gedcomNotifs[0].text;
	            }
	        });
	        $scope.$on('$destroy', function () {
	            nSub.unsubscribe();
	            if (!!_this.interval) {
	                $interval.cancel(_this.interval);
	            }
	        });
	    }
	    ImportGedcomController.prototype.setupCheck = function () {
	        var _this = this;
	        // set a timer to poll every 30 seconds
	        var count = 0;
	        this.interval = this.$interval(function () {
	            if (count >= 2) {
	                _this.server.get('/trees/' + _this.currentTreeId.get().toString()).subscribe(function (tree) {
	                    _this.isLocked = tree.locked;
	                    if (!_this.isLocked) {
	                        _this.server.decRequests();
	                        _this.$interval.cancel(_this.interval);
	                        _this.interval = null;
	                    }
	                });
	            }
	            count++;
	        }, 30000);
	    };
	    ImportGedcomController.prototype.ready = function () {
	        return !!this.file && !!this.gedcomName;
	    };
	    ImportGedcomController.prototype.importing = function () {
	        return this.isImporting && !this.imported();
	    };
	    ImportGedcomController.prototype.imported = function () {
	        return this.isImportable && !this.isLocked;
	    };
	    ImportGedcomController.prototype.go = function () {
	        var _this = this;
	        if (this.imported()) {
	            // reload at tree view
	            this.utils.pleaseWait();
	            this.$window.location.href = this.$state.href('tree.hintSettings', { init: 'gedcom' }, { absolute: true });
	            return;
	        }
	        this.gedcomError = '';
	        var token = this.authToken.get();
	        var treeId = this.currentTreeId.get();
	        this.server.incRequests();
	        this.isImporting = true;
	        this.utils.upload({
	            url: this.serverBase + '/trees/' + treeId + '/gedcoms?token=' + token,
	            data: { file: this.file, name: this.gedcomName, birth: this.gedcomBirth }
	        }).subscribe(function () {
	            _this.segment.track('gedcom.import');
	            _this.isLocked = true;
	            _this.isImportable = true;
	            _this.setupCheck();
	        }, function (response) {
	            _this.server.decRequests();
	            _this.isImporting = false;
	            _this.isImportable = false;
	            _this.isLocked = false;
	            _this.gedcomError = 'Error uploading GEDCOM: ' + (response.status === 413 ? 'File is too large' : response.status + ' - please try again later or contact support@rootsfinder.com');
	        });
	    };
	    return ImportGedcomController;
	}());
	exports.default = ImportGedcomController;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var ImportScratchController = /** @class */ (function () {
	    ImportScratchController.$inject = ["$log", "$state", "$timeout", "rx", "segment", "families", "treeUsers", "places", "utils", "personUtils"];
	    function ImportScratchController($log, $state, $timeout, rx, segment, families, treeUsers, places, utils, personUtils) {
	        'ngInject';
	        this.$log = $log;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.rx = rx;
	        this.segment = segment;
	        this.families = families;
	        this.treeUsers = treeUsers;
	        this.places = places;
	        this.utils = utils;
	        this.personUtils = personUtils;
	        this.tabIndex = 0;
	        this.gender = Array(6).fill('');
	        this.gender[1] = 'MALE';
	        this.gender[2] = 'FEMALE';
	        this.gender[3] = 'MALE';
	        this.gender[4] = 'FEMALE';
	        this.gender[5] = 'MALE';
	        this.gender[6] = 'FEMALE';
	        this.nameGiven = Array(6).fill('');
	        this.nameSurname = Array(6).fill('');
	        this.birthDate = Array(6).fill('');
	        this.birthPlace = Array(6).fill('');
	        this.birthPlaceText = Array(6).fill('');
	        this.deathDate = Array(6).fill('');
	        this.deathPlace = Array(6).fill('');
	        this.deathPlaceText = Array(6).fill('');
	    }
	    ImportScratchController.prototype.queryPlace = function (text) {
	        return !!text ? this.places.autocomplete(text) : [];
	    };
	    ImportScratchController.prototype.ready = function (ix) {
	        return !!this.nameGiven[ix];
	    };
	    ImportScratchController.prototype.skip = function (ix) {
	        this.nameGiven[ix] = '';
	        this.next(ix);
	    };
	    ImportScratchController.prototype.prev = function (ix) {
	        this.tabIndex = ix - 1;
	    };
	    ImportScratchController.prototype.next = function (ix) {
	        if (ix < 2) {
	            if (ix === 0 && !this.nameSurname[1]) {
	                this.nameSurname[1] = this.nameSurname[0];
	            }
	            if (ix === 2 && !this.nameSurname[3]) {
	                this.nameSurname[3] = this.nameSurname[1];
	            }
	            if (ix === 4 && !this.nameSurname[5]) {
	                this.nameSurname[5] = this.nameSurname[2];
	            }
	            this.tabIndex = ix + 1;
	        }
	        else {
	            this.go();
	        }
	    };
	    ImportScratchController.prototype.go = function () {
	        var _this = this;
	        this.saving = true;
	        var pw = this.utils.pleaseWait();
	        var personForms = [];
	        if (!this.ready(1) && (this.ready(3) || this.ready(4))) {
	            this.nameGiven[1] = 'Unknown';
	        }
	        if (!this.ready(2) && (this.ready(5) || this.ready(6))) {
	            this.nameGiven[2] = 'Unknown';
	        }
	        for (var ix = 0; ix <= 6; ix++) {
	            personForms[ix] = this.getForm(ix);
	        }
	        // add people
	        this.$timeout(function () {
	            (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(personForms.map(function (form) {
	                return !!form ? _this.personUtils.add(form, '', 0, null) : _this.rx.Observable.of(null);
	            }))).flatMap(function (paramsArray) {
	                // set root person to paramsArray[0].person.id
	                return _this.treeUsers.stream().filter(function (tu) { return !!tu; }).take(1)
	                    .flatMap(function (tu) {
	                    tu.preferences['ROOT'] = !!paramsArray[0] ? paramsArray[0].person.id.toString() : '0';
	                    return _this.treeUsers.update(tu).map(function () { return paramsArray; });
	                });
	            }).flatMap(function (paramsArray) {
	                // add families
	                var families = [];
	                if (!!paramsArray[0] && (!!paramsArray[1] || !!paramsArray[2])) {
	                    families.push({
	                        husbandId: !!paramsArray[1] && !!paramsArray[1].person ? paramsArray[1].person.id : 0,
	                        wifeId: !!paramsArray[2] && !!paramsArray[2].person ? paramsArray[2].person.id : 0,
	                        childRels: new Map([[paramsArray[0].person.id, { fatherRel: '', motherRel: '' }]])
	                    });
	                }
	                if (!!paramsArray[1] && (!!paramsArray[3] || !!paramsArray[4])) {
	                    families.push({
	                        husbandId: !!paramsArray[3] && !!paramsArray[3].person ? paramsArray[3].person.id : 0,
	                        wifeId: !!paramsArray[4] && !!paramsArray[4].person ? paramsArray[4].person.id : 0,
	                        childRels: new Map([[paramsArray[1].person.id, { fatherRel: '', motherRel: '' }]])
	                    });
	                }
	                if (!!paramsArray[2] && (!!paramsArray[5] || !!paramsArray[6])) {
	                    families.push({
	                        husbandId: !!paramsArray[5] && !!paramsArray[5].person ? paramsArray[5].person.id : 0,
	                        wifeId: !!paramsArray[6] && !!paramsArray[6].person ? paramsArray[6].person.id : 0,
	                        childRels: new Map([[paramsArray[2].person.id, { fatherRel: '', motherRel: '' }]])
	                    });
	                }
	                return families.length === 0 ? _this.rx.Observable.of([]) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(families.map(function (family) {
	                    return _this.families.create(family);
	                })));
	                var _a;
	            }).subscribe(function (response) {
	                _this.segment.track('scratch.import');
	                // go
	                _this.saving = false;
	                _this.utils.pleaseWaitCancel(pw);
	                //this.$state.go('tree.hintSettings', {init: 'start'});
	                _this.$state.go('tree');
	            }, function () {
	                _this.saving = false;
	                _this.utils.pleaseWaitCancel(pw);
	            });
	            var _a;
	        }, 0);
	    };
	    ImportScratchController.prototype.getForm = function (ix) {
	        if (!this.nameGiven[ix]) {
	            return null;
	        }
	        this.deathDate[ix] = (this.deathDate[ix] || '').trim();
	        this.deathPlaceText[ix] = (this.deathPlaceText[ix] || '').trim();
	        var form = {
	            living: !!this.deathDate[ix] || !!this.deathPlace[ix] || !!this.deathPlaceText[ix] ? 'FALSE' : 'TRUE',
	            gender: this.gender[ix] || ''
	        };
	        if (!!this.nameGiven[ix] || !!this.nameSurname[ix]) {
	            form.name = {
	                given: this.nameGiven[ix],
	                surname: this.nameSurname[ix]
	            };
	        }
	        if (!!this.birthDate[ix] || !!this.birthPlace[ix] || !!this.birthPlaceText[ix]) {
	            form.birth = {
	                type: 'BIRT',
	                date: this.birthDate[ix],
	                place: this.birthPlace[ix],
	                placeText: this.birthPlaceText[ix]
	            };
	        }
	        if (!!this.deathDate[ix] || !!this.deathPlace[ix] || !!this.deathPlaceText[ix]) {
	            form.death = {
	                type: 'DEAT',
	                date: this.deathDate[ix],
	                place: this.deathPlace[ix],
	                placeText: this.deathPlaceText[ix]
	            };
	        }
	        return form;
	    };
	    return ImportScratchController;
	}());
	exports.default = ImportScratchController;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var LeadsController = /** @class */ (function () {
	    LeadsController.$inject = ["$log", "$scope", "$transition$", "rx", "messageBus", "leads", "persons", "researchLogs", "users", "utils"];
	    function LeadsController($log, $scope, $transition$, rx, messageBus, leads, persons, researchLogs, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.leads = leads;
	        this.persons = persons;
	        this.users = users;
	        this.leadId = utils.decodeId($transition$.params().leadId);
	        this.showArchived = false;
	        this.normalHeaders = [
	            { label: 'Type', width: 10, property: '_type', type: 'string', filterable: true, sortable: true },
	            { label: 'Title', width: 40, property: 'title', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, show: true },
	            { label: 'Status', width: 15, property: 'status', type: 'string', filterable: true, sortable: true },
	            { label: 'Research Log', width: 15, property: '_researchLog', type: 'researchLog', sortable: true, filterable: true },
	            { label: 'People', width: 20, property: '_people', type: 'people', filterable: true }
	        ];
	        this.archiveHeaders = [
	            { label: 'Type', width: 10, property: '_type', type: 'string', filterable: true, sortable: true },
	            { label: 'Title', width: 30, property: 'title', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, show: true },
	            { label: 'Status', width: 15, property: 'status', type: 'string', filterable: true, sortable: true },
	            { label: 'Research Log', width: 15, property: '_researchLog', type: 'researchLog', sortable: true, filterable: true },
	            { label: 'People', width: 20, property: '_people', type: 'people', filterable: true },
	            { label: 'Archived', width: 10, property: '_archived', type: 'bool', filterable: true, sortable: true }
	        ];
	        this.headers = this.normalHeaders;
	        this.items = new Map();
	        var subscription = utils.readyChange(leads, researchLogs, persons, users).subscribe(function (_a) {
	            var _b = __read(_a, 2), leadMap = _b[0], researchLogMap = _b[1];
	            _this.$log.debug('leads.change');
	            _this.leadMap = leadMap;
	            _this.researchLogMap = researchLogMap;
	            _this.setItems();
	        });
	        $scope.$on('$destroy', function () {
	            subscription.unsubscribe();
	        });
	        $scope.$on('showArchived', function (ev, params) {
	            _this.showArchived = !params.showArchived;
	            _this.headers = _this.showArchived ? _this.archiveHeaders : _this.normalHeaders;
	            _this.setItems();
	        });
	        $scope.$on('add', function (ev, params) {
	            utils.dialog(params.ev, 'EditLeadController', 'app/components/editLead/editLead.html', false, {});
	        });
	        $scope.$on('edit', function (ev, params) {
	            utils.dialog(params.ev, 'EditLeadController', 'app/components/editLead/editLead.html', false, {
	                lead: params.item
	            });
	        });
	        $scope.$on('archive', function (ev, params) {
	            var lead = params.item;
	            lead.state = lead.state === 0 ? 1 : 0;
	            leads.update(lead);
	        });
	        $scope.$on('delete', function (ev, params) {
	            var lead = params.item;
	            ev = params.ev;
	            utils.confirm('Delete', 'Are you sure?', ev).then(function () {
	                lead.state = 2;
	                leads.update(lead);
	            }, function () {
	                // ignore
	            });
	        });
	        $scope.$on('save', function (ev, params) {
	            (_a = rx.Observable).forkJoin.apply(_a, __spread(params.items.map(function (item) {
	                item.state = item._archived ? 1 : 0;
	                return leads.update(item);
	            }))).subscribe(function () {
	                // nothing to do
	            }, function (err) {
	                messageBus.post({ msg: err });
	            });
	            var _a;
	        });
	    }
	    LeadsController.prototype.setItems = function () {
	        var _this = this;
	        this.items = new Map();
	        Array.from(this.leadMap.entries()).filter(function (_a) {
	            var _b = __read(_a, 2), lead = _b[1];
	            return lead.state === 0 || (_this.showArchived && lead.state === 1);
	        }).forEach(function (_a) {
	            var _b = __read(_a, 2), id = _b[0], lead = _b[1];
	            _this.leads.augmentLead(lead, _this.persons, _this.users).subscribe(function (lead) {
	                lead._archived = lead.state > 0;
	                if (lead.researchLogId > 0 && _this.researchLogMap.has(lead.researchLogId)) {
	                    lead._researchLog = _this.researchLogMap.get(lead.researchLogId).title;
	                }
	                _this.items.set(id, lead);
	            });
	        });
	    };
	    return LeadsController;
	}());
	exports.default = LeadsController;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var MatchesController = /** @class */ (function () {
	    MatchesController.$inject = ["$log"];
	    function MatchesController($log) {
	        'ngInject';
	        this.$log = $log;
	        this.headers = [
	            { label: 'Your Person', width: 25, property: 'lhsPerson', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, link: 'pref' },
	            { label: 'Other Person', width: 25, property: 'rhsPerson', type: 'string', filterable: true, sortable: true, link: 'cpref' },
	            { label: 'Stars', width: 10, property: 'stars', type: 'stars', sortable: true },
	            { label: 'Other Tree', width: 20, property: 'tree', type: 'string', filterable: true, sortable: true, link: 'cpref' },
	            { label: 'Quality', width: 10, property: 'quality', type: 'quality', sortable: true },
	            { label: 'Following', width: 10, property: 'following', type: 'following', sortable: true }
	        ];
	        var trees = ['BEdwards/Edwards Family Tree', 'JDoe/Movie Stars', 'UncleHenry/My Ancestors'];
	        var people = ['Andrew Samuel Griffith', 'Andrew Samuel Griffith', 'Carl Lee Griffith'];
	        this.items = [];
	        for (var i = 0; i < 3; i++) {
	            this.items.push({
	                pref: 'tree.person({personId: ' + i + '})',
	                cpref: 'tree.compare({personId: ' + i + '})',
	                tree: trees[i],
	                quality: Math.floor(4 * Math.random()),
	                lhsPerson: people[i],
	                rhsPerson: people[i],
	                stars: Math.floor(4 * Math.random()),
	                following: Math.random() > 0.5
	            });
	        }
	    }
	    return MatchesController;
	}());
	exports.default = MatchesController;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var MediasController = /** @class */ (function () {
	    MediasController.$inject = ["$log", "$scope", "$timeout", "$interval", "$transition$", "rx", "angularGridInstance", "comments", "rightsFull", "medias", "persons", "evidences", "likes", "sources", "stories", "social", "users", "evidenceUtils", "mediaUtils", "utils"];
	    function MediasController($log, $scope, $timeout, $interval, $transition$, rx, angularGridInstance, comments, rightsFull, medias, persons, evidences, likes, sources, stories, social, users, evidenceUtils, mediaUtils, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$timeout = $timeout;
	        this.$interval = $interval;
	        this.rx = rx;
	        this.angularGridInstance = angularGridInstance;
	        this.mediasService = medias;
	        this.persons = persons;
	        this.evidences = evidences;
	        this.sources = sources;
	        this.stories = stories;
	        this.social = social;
	        this.users = users;
	        this.evidenceUtils = evidenceUtils;
	        this.mediaUtils = mediaUtils;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.showMediaId = utils.decodeId($transition$.params().mediaId);
	        this.MEDIA_TO_LOAD = 100;
	        this.maxMedia = this.MEDIA_TO_LOAD;
	        this.allMedias = [];
	        this.medias = new Map();
	        this.loading = true;
	        var rSub = rightsFull.streamLevel().subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        var subscription = utils.readyChange(medias, persons, evidences, sources, stories, users, likes, comments).subscribe(function (_a) {
	            var _b = __read(_a, 1), mediaMap = _b[0];
	            _this.$log.debug('medias.change', mediaMap);
	            _this.allMedias = Array.from(mediaMap.entries()).sort(function (a, b) {
	                return (b[1].editedDate || b[1].createdDate) - (a[1].editedDate || a[1].createdDate);
	            });
	            _this.medias = new Map();
	            _this.showMedias();
	        });
	        var stop = null;
	        if (!!this.showMediaId && parseInt(this.showMediaId, 10) > 0) {
	            stop = $interval(function () {
	                var media = _this.medias.get(_this.showMediaId);
	                if (!!media) {
	                    _this.show(null, media);
	                    _this.$interval.cancel(stop);
	                    _this.showMediaId = null;
	                    stop = null;
	                }
	            }, 100);
	        }
	        $scope.$on('share', function (ev, params) {
	            _this.share(params.ev, params.platform, params.item, params.url);
	            ev.stopPropagation();
	        });
	        $scope.$on('resize', function (ev) {
	            _this.refresh();
	            ev.stopPropagation();
	        });
	        $scope.$on('$destroy', function () {
	            if (!!stop) {
	                _this.$interval.cancel(stop);
	            }
	            rSub.unsubscribe();
	            subscription.unsubscribe();
	        });
	    }
	    MediasController.prototype.getMediaImageURL = function (m) {
	        return this.mediasService.getMediaImageURL(m, '200');
	    };
	    MediasController.prototype.getTwitterUrl = function (m) {
	        return this.social.getTwitterUrl({ mediaId: m.id, text: m.title, personIds: m.personIds });
	    };
	    MediasController.prototype.getText = function (m) {
	        return this.utils.removeHtml(m.text, 200);
	    };
	    MediasController.prototype.loadMore = function () {
	        this.loading = true;
	        this.maxMedia += this.MEDIA_TO_LOAD;
	        this.showMedias();
	    };
	    MediasController.prototype.showMedias = function () {
	        var _this = this;
	        var streams = [];
	        this.allMedias.forEach(function (_a, ix) {
	            var _b = __read(_a, 2), id = _b[0], media = _b[1];
	            if ((ix < _this.maxMedia || _this.showMediaId === id) && !_this.medias.has(id)) {
	                streams.push(_this.mediasService.augmentMedia(media, _this.persons, _this.evidences, _this.sources, _this.stories, _this.users).do(function (media) {
	                    _this.medias.set(id, media);
	                }));
	            }
	        });
	        (streams.length === 0 ? this.rx.Observable.of(true) : (_a = this.rx.Observable).forkJoin.apply(_a, __spread(streams))).subscribe(function () {
	            _this.refresh();
	        });
	        var _a;
	    };
	    MediasController.prototype.refresh = function () {
	        var _this = this;
	        var stop = this.$interval(function () {
	            if (!!_this.angularGridInstance && !!_this.angularGridInstance.gallery && !!_this.angularGridInstance.gallery.refresh) {
	                _this.$interval.cancel(stop);
	                _this.angularGridInstance.gallery.refresh();
	                _this.loading = false;
	            }
	        }, 100);
	    };
	    MediasController.prototype.share = function (ev, platform, media, url) {
	        this.social.post(platform, {
	            url: url,
	            title: media.title,
	            mediaId: media.id,
	            description: this.utils.removeHtml(media.text),
	            personIds: media.personIds
	        }, ev);
	    };
	    MediasController.prototype.add = function (ev) {
	        this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {});
	    };
	    MediasController.prototype.getSourceAbbr = function (sid) {
	        var obj = { value: '' };
	        if (sid > 0) {
	            this.sources.streamId(sid).map(function (source) { return !!source ? source.abbr : ''; }).take(1).subscribe(function (v) {
	                obj.value = v;
	            });
	        }
	        return obj;
	    };
	    MediasController.prototype.show = function (ev, media) {
	        var _this = this;
	        this.utils.dialog(ev, 'MediaController', 'app/components/media/media.dialog.html', true, {
	            media: media
	        }).then(function (response) {
	            if (!!response) {
	                if (response === 'edit') {
	                    _this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	                        media: media
	                    });
	                }
	                else if (response === 'delete') {
	                    _this.utils.dialog(ev, 'DeleteMediaController', 'app/components/deleteMedia/deleteMedia.html', false, {
	                        media: media
	                    }).then(function () {
	                        _this.mediasService.del(media.id);
	                    }, function () {
	                        // ignore
	                    });
	                }
	                else if (response === 'mosaic') {
	                    _this.mediaUtils.mosaic(ev, media);
	                }
	            }
	        }, function () {
	            // ignore
	        });
	    };
	    MediasController.prototype.showEvidence = function (ev, id) {
	        this.utils.showEvidence(ev, this.evidences, this.sources, this.persons, this.users, this.evidenceUtils, id);
	    };
	    MediasController.prototype.showSource = function (ev, id) {
	        this.utils.showSource(ev, this.sources, this.evidences, this.users, id);
	    };
	    MediasController.prototype.showStory = function (ev, id) {
	        this.utils.showStory(ev, this.stories, this.persons, this.users, id);
	    };
	    return MediasController;
	}());
	exports.default = MediasController;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2019
	 */
	var MergeController = /** @class */ (function () {
	    MergeController.$inject = ["$log", "$scope", "$document", "$window", "$timeout", "$interval", "$transition$", "$mdMenu", "rx", "persons", "families", "evidences", "notes", "sources", "server", "utils"];
	    function MergeController($log, $scope, $document, $window, $timeout, $interval, $transition$, $mdMenu, rx, persons, families, evidences, notes, sources, server, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$document = $document;
	        this.$window = $window;
	        this.rx = rx;
	        this.persons = persons;
	        this.families = families;
	        this.evidences = evidences;
	        this.notes = notes;
	        this.sources = sources;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.rows = [];
	        this.matches = new Map();
	        this.ready = false;
	        var pw = utils.pleaseWait();
	        this.mergeId = $transition$.params().mergeId;
	        this.actionIcon = {
	            'replace': 'arrow_right_alt',
	            'add': 'add',
	            'ignore': 'block',
	            'same': 'done'
	        };
	        this.actionText = {
	            'replace': 'Replace person in tree',
	            'add': 'Add person to tree',
	            'ignore': 'Nothing to import',
	            'same': 'Identical'
	        };
	        rx.Observable.combineLatest(server.get('/trees/' + this.mergeId + '/persons'), server.get('/trees/' + this.mergeId + '/families'), server.get('/trees/' + this.mergeId + '/evidences'), server.get('/trees/' + this.mergeId + '/notes'), server.get('/trees/' + this.mergeId + '/sources'), persons.ready().flatMap(function () { return persons.stream(); }), families.ready().flatMap(function () { return families.stream(); }), evidences.ready().flatMap(function () { return evidences.stream(); }), notes.ready().flatMap(function () { return notes.stream(); }), sources.ready().flatMap(function () { return sources.stream(); })).debounceTime(1000)
	            .subscribe(function (_a) {
	            var _b = __read(_a, 10), otherPersons = _b[0], otherFamilies = _b[1], otherEvidences = _b[2], otherNotes = _b[3], otherSources = _b[4], personMap = _b[5], familyMap = _b[6], evidenceMap = _b[7], noteMap = _b[8], sourceMap = _b[9];
	            _this.personMap = personMap;
	            _this.familyMap = familyMap;
	            _this.evidenceMap = evidenceMap;
	            _this.noteMap = _this.mapByPersonId(noteMap, null);
	            _this.sourceMap = sourceMap;
	            _this.otherPersonMap = new Map(otherPersons.map(function (p) { return [p.id, _this.utils.fromServer(p)]; }));
	            otherPersons = null;
	            _this.otherFamilyMap = new Map(otherFamilies.map(function (f) { return [f.id, _this.utils.fromServer(f)]; }));
	            otherFamilies = null;
	            _this.otherEvidenceMap = new Map(otherEvidences.map(function (e) { return [e.id, _this.utils.fromServer(e)]; }));
	            otherEvidences = null;
	            _this.otherNoteMap = _this.mapByPersonId(otherNotes, function (it) { return _this.utils.fromServer(it); });
	            otherNotes = null;
	            _this.otherSourceMap = new Map(otherSources.map(function (s) { return [s.id, _this.utils.fromServer(s)]; }));
	            otherSources = null;
	            // generate sorted arrays
	            _this.titleIds = _this.generateSortedTitleIDs(personMap);
	            _this.otherTitleIds = _this.generateSortedTitleIDs(_this.otherPersonMap);
	            // get matches
	            var matches = _this.getMatches(personMap, _this.otherPersonMap);
	            _this.matches = _this.utils.mergeMaps(_this.matches, matches);
	            // generate rows
	            $timeout(function () {
	                _this.rows = _this.generateRows(_this.otherTitleIds, _this.titleIds, _this.matches);
	            }, 0);
	            if (!!pw) {
	                utils.pleaseWaitCancel(pw);
	                pw = null;
	            }
	            _this.ready = true;
	        });
	        var heightSetter = function () {
	            _this.setHeight();
	        };
	        $window.addEventListener('resize', heightSetter);
	        var sub = utils.watch($scope, function () { return _this.ready; }).subscribe(function () {
	            if (_this.ready) {
	                // give things time to paint before setting height
	                $timeout(function () {
	                    heightSetter();
	                }, 300);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            sub.unsubscribe();
	            $window.removeEventListener('resize', heightSetter);
	        });
	    }
	    MergeController.prototype.mapByPersonId = function (m, fn) {
	        var result = new Map();
	        try {
	            for (var _a = __values(m.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var item = _b.value;
	                if (!!fn) {
	                    item = fn(item);
	                }
	                try {
	                    for (var _c = __values(item.personIds.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                        var personId = _d.value;
	                        var pid = parseInt(personId, 10);
	                        if (!result.has(pid)) {
	                            result.set(pid, []);
	                        }
	                        result.get(pid).push(item);
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_f = _a.return)) _f.call(_a);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        return result;
	        var e_2, _f, e_1, _e;
	    };
	    MergeController.prototype.setHeight = function () {
	        var elems = this.$document.find('md-virtual-repeat-container');
	        if (elems.length > 0) {
	            var rect = elems[0].getBoundingClientRect();
	            var height = this.$window.innerHeight - rect.top;
	            height -= 16;
	            elems.css('height', height + 'px');
	        }
	    };
	    MergeController.prototype.isSelectAll = function () {
	        var isRowSelected = false;
	        try {
	            for (var _a = __values(this.rows), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var row = _b.value;
	                if (row.action !== 'ignore' && row.action !== 'same') {
	                    if (row.selected) {
	                        isRowSelected = true;
	                    }
	                    else {
	                        return false;
	                    }
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        return isRowSelected;
	        var e_3, _c;
	    };
	    MergeController.prototype.isSelectSomeNotAll = function () {
	        var isRowSelected = false;
	        var isRowUnselected = false;
	        try {
	            for (var _a = __values(this.rows), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var row = _b.value;
	                if (row.action !== 'ignore' && row.action !== 'same') {
	                    if (row.selected) {
	                        isRowSelected = true;
	                    }
	                    else {
	                        isRowUnselected = true;
	                    }
	                }
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        return isRowSelected && isRowUnselected;
	        var e_4, _c;
	    };
	    MergeController.prototype.isSelectNone = function () {
	        try {
	            for (var _a = __values(this.rows), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var row = _b.value;
	                if (row.selected) {
	                    return false;
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        return true;
	        var e_5, _c;
	    };
	    MergeController.prototype.toggleSelectAll = function () {
	        var select = !this.isSelectAll();
	        try {
	            for (var _a = __values(this.rows), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var row = _b.value;
	                if (row.action !== 'ignore' && row.action !== 'same') {
	                    row.selected = select;
	                }
	            }
	        }
	        catch (e_6_1) { e_6 = { error: e_6_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_6) throw e_6.error; }
	        }
	        var e_6, _c;
	    };
	    MergeController.prototype.openMenu = function ($mdMenu, ev) {
	        this.menuEvent = ev;
	        $mdMenu.open(ev);
	    };
	    MergeController.prototype.setAction = function (row, action, ev) {
	        var _this = this;
	        if (action === 'replace') {
	            this.utils.dialog(ev, 'SelectPersonController', 'app/components/selectPerson/selectPerson.html', false).then(function (id) {
	                try {
	                    for (var _a = __values(_this.rows), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var r = _b.value;
	                        if (r.rhsId === id) {
	                            if (r.lhsId > 0 && r.lhsId != row.lhsId) {
	                                _this.utils.alert('Need to un-match', 'Sorry, ' + r.rhsTitle + ' is already matched with ' + r.lhsTitle + '. You need to un-match them first', ev);
	                            }
	                            else {
	                                _this.matches.set(id, row.lhsId);
	                                _this.rows = _this.generateRows(_this.otherTitleIds, _this.titleIds, _this.matches);
	                                break;
	                            }
	                        }
	                    }
	                }
	                catch (e_7_1) { e_7 = { error: e_7_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_7) throw e_7.error; }
	                }
	                var e_7, _c;
	            });
	        }
	        else {
	            if (row.rhsId > 0) {
	                this.matches.delete(row.rhsId);
	                this.rows = this.generateRows(this.otherTitleIds, this.titleIds, this.matches);
	            }
	        }
	    };
	    MergeController.prototype.generateSortedTitleIDs = function (personMap) {
	        var _this = this;
	        var result = [];
	        personMap.forEach(function (p) {
	            result.push({
	                title: _this.getTitle(p),
	                id: p.id,
	            });
	        });
	        return result.sort(function (a, b) {
	            var titleA = a.title.toLowerCase();
	            var titleB = b.title.toLowerCase();
	            if (titleA < titleB) {
	                return -1;
	            }
	            if (titleB < titleA) {
	                return 1;
	            }
	            return 0;
	        });
	    };
	    MergeController.prototype.getTitle = function (p) {
	        var nf = this.persons.getDefaultNameForm(this.persons.getPreferredName(p));
	        if (nf === null) {
	            nf = {
	                surname: 'Unknown',
	            };
	        }
	        var birth = this.persons.getPreferredBirth(p);
	        var birthYear = this.utils.getYear(!!birth ? birth.date : null, true);
	        var death = this.persons.getPreferredDeath(p);
	        var deathYear = this.utils.getYear(!!death ? death.date : null, true);
	        var lifespan = !!birthYear || !!deathYear ? birthYear + ' - ' + deathYear : '';
	        return nf.surname + "," + (!!nf.prefix ? ' ' + nf.prefix : '') + (!!nf.given ? ' ' + nf.given : '') + (!!nf.suffix ? ' ' + nf.suffix : '') + (!!lifespan ? ' (' + lifespan + ')' : '');
	    };
	    MergeController.prototype.getMatches = function (personMap, otherPersonMap) {
	        var otherKeyMap = new Map();
	        otherPersonMap.forEach(function (p) {
	            try {
	                for (var _a = __values(p.externalIds), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var _c = __read(_b.value, 2), key = _c[0], value = _c[1];
	                    var kv = key + ':' + value;
	                    otherKeyMap.set(kv, p.id);
	                }
	            }
	            catch (e_8_1) { e_8 = { error: e_8_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                }
	                finally { if (e_8) throw e_8.error; }
	            }
	            var e_8, _d;
	        });
	        var matches = new Map();
	        personMap.forEach(function (p) {
	            if (otherPersonMap.has(p.id)) {
	                matches.set(p.id, p.id);
	            }
	            try {
	                for (var _a = __values(p.externalIds), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var _c = __read(_b.value, 2), key = _c[0], value = _c[1];
	                    var kv = key + ':' + value;
	                    if (otherKeyMap.has(kv)) {
	                        matches.set(p.id, otherKeyMap.get(kv));
	                    }
	                }
	            }
	            catch (e_9_1) { e_9 = { error: e_9_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                }
	                finally { if (e_9) throw e_9.error; }
	            }
	            var e_9, _d;
	        });
	        return matches;
	    };
	    MergeController.prototype.generateRows = function (otherTitleIds, titleIds, matches) {
	        var rows = [];
	        var matchedIds = new Set(matches.values());
	        var otherIxs = new Map(otherTitleIds.map(function (v, ix) { return [v.id, ix]; }));
	        for (var ix = 0, otherIx = 0; ix < titleIds.length || otherIx < otherTitleIds.length;) {
	            var lhs = otherIx < otherTitleIds.length ? otherTitleIds[otherIx] : null;
	            var rhs = ix < titleIds.length ? titleIds[ix] : null;
	            if (!!rhs && (!lhs || lhs.title > rhs.title)) {
	                var matchId = matches.get(rhs.id);
	                var otherIx_1 = !!matchId ? otherIxs.get(matchId) : -1;
	                rows.push({
	                    lhsId: otherIx_1 >= 0 ? otherTitleIds[otherIx_1].id : 0,
	                    lhsTitle: otherIx_1 >= 0 ? otherTitleIds[otherIx_1].title : '',
	                    rhsId: rhs.id,
	                    rhsTitle: rhs.title,
	                    action: otherIx_1 >= 0 ? (this.isIdentical(rhs.id, otherTitleIds[otherIx_1].id) ? 'same' : 'replace') : 'ignore'
	                });
	                ix++;
	            }
	            else {
	                if (!!lhs && !matchedIds.has(lhs.id)) {
	                    rows.push({
	                        lhsId: lhs.id,
	                        lhsTitle: lhs.title,
	                        rhsId: 0,
	                        rhsTitle: '',
	                        action: 'add'
	                    });
	                }
	                otherIx++;
	            }
	        }
	        return rows;
	    };
	    MergeController.prototype.isIdentical = function (id, otherId) {
	        var p1 = this.otherPersonMap.get(otherId);
	        var p2 = this.personMap.get(id);
	        if (!this.isPersonIdentical(p1, p2)) {
	            return false;
	        }
	        var evidences1 = this.getEvidences(p1, this.otherEvidenceMap);
	        var evidences2 = this.getEvidences(p2, this.evidenceMap);
	        if (!this.areEvidencesIdentical(evidences1, evidences2)) {
	            return false;
	        }
	        var notes1 = this.otherNoteMap.get(otherId) || [];
	        var notes2 = this.noteMap.get(id) || [];
	        if (!this.areNotesIdentical(notes1, notes2)) {
	            return false;
	        }
	        return true;
	    };
	    MergeController.prototype.isPersonIdentical = function (p1, p2) {
	        if (p1.gender !== p2.gender || p1.living !== p2.living) {
	            return false;
	        }
	        if (p1.names.size !== p2.names.size) {
	            return false;
	        }
	        try {
	            for (var _a = __values(p1.names.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var n1 = _b.value;
	                var found = false;
	                try {
	                    for (var _c = __values(p2.names.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                        var n2 = _d.value;
	                        if (this.isNameIdentical(n1, n2, false)) {
	                            found = true;
	                            break;
	                        }
	                    }
	                }
	                catch (e_10_1) { e_10 = { error: e_10_1 }; }
	                finally {
	                    try {
	                        if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                    }
	                    finally { if (e_10) throw e_10.error; }
	                }
	                if (!found) {
	                    return false;
	                }
	            }
	        }
	        catch (e_11_1) { e_11 = { error: e_11_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_f = _a.return)) _f.call(_a);
	            }
	            finally { if (e_11) throw e_11.error; }
	        }
	        if (p1.facts.size !== p2.facts.size) {
	            return false;
	        }
	        try {
	            for (var _g = __values(p1.facts.values()), _h = _g.next(); !_h.done; _h = _g.next()) {
	                var f1 = _h.value;
	                var found = false;
	                try {
	                    for (var _j = __values(p2.facts.values()), _k = _j.next(); !_k.done; _k = _j.next()) {
	                        var f2 = _k.value;
	                        if (this.isFactIdentical(f1, f2, false)) {
	                            found = true;
	                            break;
	                        }
	                    }
	                }
	                catch (e_12_1) { e_12 = { error: e_12_1 }; }
	                finally {
	                    try {
	                        if (_k && !_k.done && (_l = _j.return)) _l.call(_j);
	                    }
	                    finally { if (e_12) throw e_12.error; }
	                }
	                if (!found) {
	                    return false;
	                }
	            }
	        }
	        catch (e_13_1) { e_13 = { error: e_13_1 }; }
	        finally {
	            try {
	                if (_h && !_h.done && (_m = _g.return)) _m.call(_g);
	            }
	            finally { if (e_13) throw e_13.error; }
	        }
	        return true;
	        var e_11, _f, e_10, _e, e_13, _m, e_12, _l;
	    };
	    MergeController.prototype.isNameIdentical = function (n1, n2, isEvidence) {
	        if (n1.type !== n2.type || n1.date !== n2.date || n1.nameForms.size !== n2.nameForms.size) {
	            return false;
	        }
	        try {
	            for (var _a = __values(n1.nameForms), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var _c = __read(_b.value, 2), key = _c[0], nf1 = _c[1];
	                var nf2 = n2.nameForms.get(key);
	                if (!nf2 || nf1.prefix != nf2.prefix || nf1.given != nf2.given || nf1.surname != nf2.surname || nf1.suffix != nf2.suffix) {
	                    return false;
	                }
	            }
	        }
	        catch (e_14_1) { e_14 = { error: e_14_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	            }
	            finally { if (e_14) throw e_14.error; }
	        }
	        if (!isEvidence && n1.evidencePersonas.size !== n2.evidencePersonas.size) {
	            return false;
	        }
	        return true;
	        var e_14, _d;
	    };
	    MergeController.prototype.isFactIdentical = function (f1, f2, isEvidence) {
	        if (f1.type !== f2.type || f1.value !== f2.value || f1.date !== f2.date || f1.place !== f2.place) {
	            return false;
	        }
	        if (!isEvidence && (f1.principal !== f2.principal || f1.evidencePersonas.size !== f2.evidencePersonas.size)) {
	            return false;
	        }
	        return true;
	    };
	    MergeController.prototype.getEvidences = function (person, evidenceMap) {
	        var ids = new Set();
	        try {
	            for (var _a = __values(person.names.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var name_1 = _b.value;
	                try {
	                    for (var _c = __values(name_1.evidencePersonas.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                        var eid = _d.value;
	                        ids.add(eid);
	                    }
	                }
	                catch (e_15_1) { e_15 = { error: e_15_1 }; }
	                finally {
	                    try {
	                        if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                    }
	                    finally { if (e_15) throw e_15.error; }
	                }
	            }
	        }
	        catch (e_16_1) { e_16 = { error: e_16_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_f = _a.return)) _f.call(_a);
	            }
	            finally { if (e_16) throw e_16.error; }
	        }
	        try {
	            for (var _g = __values(person.facts.values()), _h = _g.next(); !_h.done; _h = _g.next()) {
	                var fact = _h.value;
	                try {
	                    for (var _j = __values(fact.evidencePersonas.keys()), _k = _j.next(); !_k.done; _k = _j.next()) {
	                        var eid = _k.value;
	                        ids.add(eid);
	                    }
	                }
	                catch (e_17_1) { e_17 = { error: e_17_1 }; }
	                finally {
	                    try {
	                        if (_k && !_k.done && (_l = _j.return)) _l.call(_j);
	                    }
	                    finally { if (e_17) throw e_17.error; }
	                }
	            }
	        }
	        catch (e_18_1) { e_18 = { error: e_18_1 }; }
	        finally {
	            try {
	                if (_h && !_h.done && (_m = _g.return)) _m.call(_g);
	            }
	            finally { if (e_18) throw e_18.error; }
	        }
	        return Array.from(ids.values()).map(function (id) { return evidenceMap.get(id); });
	        var e_16, _f, e_15, _e, e_18, _m, e_17, _l;
	    };
	    MergeController.prototype.areEvidencesIdentical = function (evidences1, evidences2) {
	        if (evidences1.length !== evidences2.length) {
	            return false;
	        }
	        try {
	            for (var evidences1_1 = __values(evidences1), evidences1_1_1 = evidences1_1.next(); !evidences1_1_1.done; evidences1_1_1 = evidences1_1.next()) {
	                var evidence1 = evidences1_1_1.value;
	                var found = false;
	                try {
	                    for (var evidences2_1 = __values(evidences2), evidences2_1_1 = evidences2_1.next(); !evidences2_1_1.done; evidences2_1_1 = evidences2_1.next()) {
	                        var evidence2 = evidences2_1_1.value;
	                        if (this.isEvidenceIdentical(evidence1, evidence2)) {
	                            found = true;
	                            break;
	                        }
	                    }
	                }
	                catch (e_19_1) { e_19 = { error: e_19_1 }; }
	                finally {
	                    try {
	                        if (evidences2_1_1 && !evidences2_1_1.done && (_a = evidences2_1.return)) _a.call(evidences2_1);
	                    }
	                    finally { if (e_19) throw e_19.error; }
	                }
	                if (!found) {
	                    return false;
	                }
	            }
	        }
	        catch (e_20_1) { e_20 = { error: e_20_1 }; }
	        finally {
	            try {
	                if (evidences1_1_1 && !evidences1_1_1.done && (_b = evidences1_1.return)) _b.call(evidences1_1);
	            }
	            finally { if (e_20) throw e_20.error; }
	        }
	        return true;
	        var e_20, _b, e_19, _a;
	    };
	    MergeController.prototype.isEvidenceIdentical = function (e1, e2) {
	        if (e1.text !== e2.text || e1.externalImageURL !== e2.externalImageURL) {
	            return false;
	        }
	        if (e1.fact.type !== e2.fact.type || e1.fact.value !== e2.fact.value || e1.fact.date !== e2.fact.date || e1.fact.place !== e2.fact.place) {
	            return false;
	        }
	        if (e1.citation.sourceId !== e2.citation.sourceId || e1.citation.url !== e2.citation.url || e1.citation.page !== e2.citation.page || e1.citation.date !== e2.citation.date || e1.citation.text !== e2.citation.text) {
	            return false;
	        }
	        if (e1.personas.size !== e2.personas.size) {
	            return false;
	        }
	        try {
	            for (var _a = __values(e1.personas.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var k = _b.value;
	                var p1 = e1.personas.get(k);
	                var p2 = e2.personas.get(k);
	                if (!p1 || !p2) {
	                    return false;
	                }
	                if (p1.principal !== p2.principal || p1.relatedToKey !== p2.relatedToKey || p1.relationshipType !== p2.relationshipType) {
	                    return false;
	                }
	                if (p1.names.size !== p2.names.size) {
	                    return false;
	                }
	                try {
	                    for (var _c = __values(p1.names.keys), _d = _c.next(); !_d.done; _d = _c.next()) {
	                        var nk = _d.value;
	                        var n1 = p1.names.get(nk);
	                        var n2 = p2.names.get(nk);
	                        if (!n1 || !n2 || !this.isNameIdentical(n1, n2, true)) {
	                            return false;
	                        }
	                    }
	                }
	                catch (e_21_1) { e_21 = { error: e_21_1 }; }
	                finally {
	                    try {
	                        if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                    }
	                    finally { if (e_21) throw e_21.error; }
	                }
	                if (p1.facts.size !== p2.facts.size) {
	                    return false;
	                }
	                try {
	                    for (var _f = __values(p1.facts.keys), _g = _f.next(); !_g.done; _g = _f.next()) {
	                        var fk = _g.value;
	                        var f1 = p1.facts.get(fk);
	                        var f2 = p2.facts.get(fk);
	                        if (!f1 || !f2 || !this.isFactIdentical(f1, f2, true)) {
	                            return false;
	                        }
	                    }
	                }
	                catch (e_22_1) { e_22 = { error: e_22_1 }; }
	                finally {
	                    try {
	                        if (_g && !_g.done && (_h = _f.return)) _h.call(_f);
	                    }
	                    finally { if (e_22) throw e_22.error; }
	                }
	            }
	        }
	        catch (e_23_1) { e_23 = { error: e_23_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_j = _a.return)) _j.call(_a);
	            }
	            finally { if (e_23) throw e_23.error; }
	        }
	        return true;
	        var e_23, _j, e_21, _e, e_22, _h;
	    };
	    MergeController.prototype.areNotesIdentical = function (notes1, notes2) {
	        if (notes1.length !== notes2.length) {
	            return false;
	        }
	        try {
	            for (var notes1_1 = __values(notes1), notes1_1_1 = notes1_1.next(); !notes1_1_1.done; notes1_1_1 = notes1_1.next()) {
	                var note1 = notes1_1_1.value;
	                var found = false;
	                try {
	                    for (var notes2_1 = __values(notes2), notes2_1_1 = notes2_1.next(); !notes2_1_1.done; notes2_1_1 = notes2_1.next()) {
	                        var note2 = notes2_1_1.value;
	                        if (this.isNoteIdentical(note1, note2)) {
	                            found = true;
	                            break;
	                        }
	                    }
	                }
	                catch (e_24_1) { e_24 = { error: e_24_1 }; }
	                finally {
	                    try {
	                        if (notes2_1_1 && !notes2_1_1.done && (_a = notes2_1.return)) _a.call(notes2_1);
	                    }
	                    finally { if (e_24) throw e_24.error; }
	                }
	                if (!found) {
	                    return false;
	                }
	            }
	        }
	        catch (e_25_1) { e_25 = { error: e_25_1 }; }
	        finally {
	            try {
	                if (notes1_1_1 && !notes1_1_1.done && (_b = notes1_1.return)) _b.call(notes1_1);
	            }
	            finally { if (e_25) throw e_25.error; }
	        }
	        return true;
	        var e_25, _b, e_24, _a;
	    };
	    MergeController.prototype.isNoteIdentical = function (n1, n2) {
	        if (n1.title !== n2.title || n1.text !== n2.text) {
	            return false;
	        }
	        return true;
	    };
	    MergeController.prototype.import = function () {
	        var _this = this;
	        // calc what to import
	        var importSrcTar = new Map();
	        try {
	            for (var _a = __values(this.rows), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var row = _b.value;
	                if (row.selected) {
	                    importSrcTar.set(row.lhsId, row.action === 'add' ? row.lhsId : row.rhsId);
	                }
	            }
	        }
	        catch (e_26_1) { e_26 = { error: e_26_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_26) throw e_26.error; }
	        }
	        // calc all matches from src to tar
	        var matchSrcTar = new Map();
	        try {
	            for (var _d = __values(this.matches), _e = _d.next(); !_e.done; _e = _d.next()) {
	                var _f = __read(_e.value, 2), tar = _f[0], src = _f[1];
	                matchSrcTar.set(src, tar);
	            }
	        }
	        catch (e_27_1) { e_27 = { error: e_27_1 }; }
	        finally {
	            try {
	                if (_e && !_e.done && (_g = _d.return)) _g.call(_d);
	            }
	            finally { if (e_27) throw e_27.error; }
	        }
	        matchSrcTar = this.utils.mergeMaps(matchSrcTar, importSrcTar);
	        // calc import requests
	        var importRequests = [];
	        try {
	            for (var _h = __values(this.rows), _j = _h.next(); !_j.done; _j = _h.next()) {
	                var row = _j.value;
	                if (row.selected) {
	                    var p1 = this.otherPersonMap.get(row.lhsId);
	                    if (row.action === 'add') {
	                        importRequests.push(this.addPerson(p1, matchSrcTar));
	                    }
	                    else if (row.action === 'replace') {
	                        var p2 = this.personMap.get(row.rhsId);
	                        importRequests.push(this.replacePerson(p1, p2, matchSrcTar));
	                    }
	                }
	            }
	        }
	        catch (e_28_1) { e_28 = { error: e_28_1 }; }
	        finally {
	            try {
	                if (_j && !_j.done && (_k = _h.return)) _k.call(_h);
	            }
	            finally { if (e_28) throw e_28.error; }
	        }
	        // import people
	        (importRequests.length === 0 ? this.rx.Observable.of([]) : this.rx.Observable.forkJoin(importRequests))
	            .flatMap(function () {
	            var familyRequestMap = new Map();
	            try {
	                for (var importSrcTar_1 = __values(importSrcTar), importSrcTar_1_1 = importSrcTar_1.next(); !importSrcTar_1_1.done; importSrcTar_1_1 = importSrcTar_1.next()) {
	                    var _a = __read(importSrcTar_1_1.value, 2), src = _a[0], tar = _a[1];
	                    try {
	                        // add/update families
	                        for (var _b = __values(_this.getFamilies(src, _this.otherFamilyMap)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                            var otherFamily = _c.value;
	                            if (familyRequestMap.has(otherFamily.id)) {
	                                continue;
	                            }
	                            var mappedFamily = _this.mapFamily(otherFamily, matchSrcTar);
	                            if ((mappedFamily.husbandId === 0 && mappedFamily.wifeId === 0) ||
	                                (mappedFamily.childRels.size === 0 && (mappedFamily.husbandId === 0 || mappedFamily.wifeId === 0))) {
	                                continue;
	                            }
	                            var targetFamily = _this.findFamily(mappedFamily, _this.familyMap);
	                            var request = void 0;
	                            if (!targetFamily) {
	                                request = _this.families.create(mappedFamily);
	                            }
	                            else if (!_this.isContainedFamily(mappedFamily, targetFamily)) {
	                                targetFamily = _this.addFamilyMembers(mappedFamily, targetFamily);
	                                request = _this.families.update(targetFamily);
	                            }
	                            else {
	                                request = _this.rx.Observable.of(targetFamily);
	                            }
	                            familyRequestMap.set(otherFamily.id, request);
	                        }
	                    }
	                    catch (e_29_1) { e_29 = { error: e_29_1 }; }
	                    finally {
	                        try {
	                            if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
	                        }
	                        finally { if (e_29) throw e_29.error; }
	                    }
	                }
	            }
	            catch (e_30_1) { e_30 = { error: e_30_1 }; }
	            finally {
	                try {
	                    if (importSrcTar_1_1 && !importSrcTar_1_1.done && (_e = importSrcTar_1.return)) _e.call(importSrcTar_1);
	                }
	                finally { if (e_30) throw e_30.error; }
	            }
	            return familyRequestMap.size === 0 ? _this.rx.Observable.of([]) : _this.rx.Observable.forkJoin(Array.from(familyRequestMap.values()));
	            var e_30, _e, e_29, _d;
	        }).subscribe(function () {
	        });
	        var e_26, _c, e_27, _g, e_28, _k;
	    };
	    MergeController.prototype.getFamilies = function (id, familyMap) {
	        var families = [];
	        try {
	            for (var _a = __values(familyMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var family = _b.value;
	                if (family.husbandId === id || family.wifeId === id || family.childRels.has(id)) {
	                    families.push(family);
	                }
	            }
	        }
	        catch (e_31_1) { e_31 = { error: e_31_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_31) throw e_31.error; }
	        }
	        return families;
	        var e_31, _c;
	    };
	    MergeController.prototype.mapFamily = function (family, matchSrcTar) {
	        var _this = this;
	        return {
	            husbandId: this.mapId(family.husbandId, matchSrcTar),
	            wifeId: this.mapId(family.wifeId, matchSrcTar),
	            childRels: new Map(Array.from(family.childRels.entries()).map(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], parentRels = _b[1];
	                return [_this.mapId(id, matchSrcTar), parentRels];
	            }).filter(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], parentRels = _b[1];
	                return id > 0;
	            }))
	        };
	    };
	    MergeController.prototype.mapId = function (id, matchSrcTar) {
	        return matchSrcTar.has(id) ? matchSrcTar.get(id) : 0;
	    };
	    MergeController.prototype.findFamily = function (family, familyMap) {
	        try {
	            for (var _a = __values(familyMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var f = _b.value;
	                if (this.isCompatibleFamily(family, f)) {
	                    return f;
	                }
	            }
	        }
	        catch (e_32_1) { e_32 = { error: e_32_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_32) throw e_32.error; }
	        }
	        return null;
	        var e_32, _c;
	    };
	    MergeController.prototype.isCompatibleFamily = function (src, tar) {
	        var matches = 0;
	        if (src.husbandId > 0 && tar.husbandId > 0) {
	            if (src.husbandId !== tar.husbandId) {
	                return false;
	            }
	            matches++;
	        }
	        if (src.wifeId > 0 && tar.wifeId > 0) {
	            if (src.wifeId !== tar.wifeId) {
	                return false;
	            }
	            matches++;
	        }
	        try {
	            for (var _a = __values(src.childRels.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var cid = _b.value;
	                if (tar.childRels.has(cid)) {
	                    matches++;
	                }
	            }
	        }
	        catch (e_33_1) { e_33 = { error: e_33_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_33) throw e_33.error; }
	        }
	        return matches >= 2;
	        var e_33, _c;
	    };
	    MergeController.prototype.isContainedFamily = function (srcFamily, tarFamily) {
	        if ((srcFamily.husbandId > 0 && tarFamily.husbandId === 0) || (srcFamily.wifeId > 0 && tarFamily.wifeId === 0)) {
	            return false;
	        }
	        try {
	            for (var _a = __values(srcFamily.childRels.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var id = _b.value;
	                if (!tarFamily.childRels.has(id)) {
	                    return false;
	                }
	            }
	        }
	        catch (e_34_1) { e_34 = { error: e_34_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_34) throw e_34.error; }
	        }
	        return true;
	        var e_34, _c;
	    };
	    MergeController.prototype.addFamilyMembers = function (srcFamily, tarFamily) {
	        if (srcFamily.husbandId > 0 && tarFamily.husbandId === 0) {
	            tarFamily.husbandId = srcFamily.husbandId;
	        }
	        if (srcFamily.wifeId > 0 && tarFamily.wifeId === 0) {
	            tarFamily.wifeId = srcFamily.wifeId;
	        }
	        try {
	            for (var _a = __values(srcFamily.childRels), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var _c = __read(_b.value, 2), id = _c[0], parentRels = _c[1];
	                if (!tarFamily.childRels.has(id)) {
	                    tarFamily.childRels.set(id, parentRels);
	                }
	            }
	        }
	        catch (e_35_1) { e_35 = { error: e_35_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	            }
	            finally { if (e_35) throw e_35.error; }
	        }
	        return tarFamily;
	        var e_35, _d;
	    };
	    MergeController.prototype.addPerson = function (p, matchSrcTar) {
	        var _this = this;
	        // get evidences and sources
	        var otherEvidences = this.getEvidences(p, this.otherEvidenceMap);
	        var sourceIds = otherEvidences.map(function (e) { return e.citation.sourceId; }).filter(function (id) { return id > 0; });
	        // source create requests
	        var sourceRequests = this.getSourceRequests(sourceIds);
	        return (sourceRequests.length === 0 ? this.rx.Observable.of([]) : this.rx.Observable.forkJoin(sourceRequests))
	            .flatMap(function () {
	            var evidenceRequests = _this.getEvidenceCreateRequests(otherEvidences, []);
	            return evidenceRequests.length === 0 ? _this.rx.Observable.of([]) : _this.rx.Observable.forkJoin(evidenceRequests);
	        }).flatMap(function (evidenceResults) {
	            var person = {
	                id: p.id,
	                preferredNameKey: p.preferredNameKey,
	                preferredBirthKey: p.preferredBirthKey,
	                preferredDeathKey: p.preferredDeathKey,
	                living: p.living,
	                gender: p.gender,
	                externalIds: p.externalIds,
	                tags: p.tags,
	                names: _this.mapEvidencePersonas(p.names, otherEvidences, evidenceResults),
	                facts: _this.mapEvidencePersonas(_this.mapPrincipalIds(p.facts, matchSrcTar), otherEvidences, evidenceResults),
	            };
	            return _this.persons.create(person);
	        }).flatMap(function () {
	            var noteRequests = _this.getNoteRequests(p.id, _this.otherNoteMap.get(p.id) || [], []);
	            return noteRequests.length === 0 ? _this.rx.Observable.of([]) : _this.rx.Observable.forkJoin(noteRequests);
	        });
	    };
	    MergeController.prototype.getSourceRequests = function (sourceIds) {
	        var _this = this;
	        return sourceIds.filter(function (sid) { return _this.otherSourceMap.has(sid) && !_this.sourceMap.has(sid); }).map(function (sid) {
	            var otherSource = _this.otherSourceMap.get(sid);
	            var source = {
	                id: otherSource.id,
	                abbr: otherSource.abbr,
	                title: otherSource.title,
	                subtitle: otherSource.subtitle,
	                creator: otherSource.creator,
	                publisher: otherSource.publisher,
	                dateIssued: otherSource.dateIssued,
	                placeIssued: otherSource.placeIssued,
	                type: otherSource.type,
	                periodicalSeries: otherSource.periodicalSeries,
	                numVolumes: otherSource.numVolumes,
	                volumeFilmPages: otherSource.volumeFilmPages,
	                repository: otherSource.repository,
	                callNumber: otherSource.callNumber,
	                url: otherSource.url,
	                shortFootnote: otherSource.shortFootnote,
	                bibCitation: otherSource.bibCitation,
	                text: otherSource.text
	            };
	            return _this.sources.create(source);
	        });
	    };
	    MergeController.prototype.getEvidenceCreateRequests = function (otherEvidences, evidences) {
	        var evidenceRequests = [];
	        try {
	            for (var _a = __values(otherEvidences || []), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var e1 = _b.value;
	                var found = null;
	                try {
	                    for (var evidences_1 = __values(evidences), evidences_1_1 = evidences_1.next(); !evidences_1_1.done; evidences_1_1 = evidences_1.next()) {
	                        var e2 = evidences_1_1.value;
	                        if (this.isEvidenceIdentical(e1, e2)) {
	                            found = e2;
	                            break;
	                        }
	                    }
	                }
	                catch (e_36_1) { e_36 = { error: e_36_1 }; }
	                finally {
	                    try {
	                        if (evidences_1_1 && !evidences_1_1.done && (_c = evidences_1.return)) _c.call(evidences_1);
	                    }
	                    finally { if (e_36) throw e_36.error; }
	                }
	                if (!found) {
	                    var evidence = {
	                        fact: e1.fact,
	                        externalImageURL: e1.externalImageURL,
	                        text: e1.text,
	                        citation: e1.citation,
	                        personas: e1.personas
	                    };
	                    evidenceRequests.push(this.evidences.create(evidence));
	                }
	                else {
	                    evidenceRequests.push(this.rx.Observable.of(found));
	                }
	            }
	        }
	        catch (e_37_1) { e_37 = { error: e_37_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	            }
	            finally { if (e_37) throw e_37.error; }
	        }
	        return evidenceRequests;
	        var e_37, _d, e_36, _c;
	    };
	    MergeController.prototype.getEvidenceDeleteRequests = function (otherEvidences, evidences) {
	        var evidenceRequests = [];
	        try {
	            for (var evidences_2 = __values(evidences), evidences_2_1 = evidences_2.next(); !evidences_2_1.done; evidences_2_1 = evidences_2.next()) {
	                var e1 = evidences_2_1.value;
	                var found = null;
	                try {
	                    for (var otherEvidences_1 = __values(otherEvidences), otherEvidences_1_1 = otherEvidences_1.next(); !otherEvidences_1_1.done; otherEvidences_1_1 = otherEvidences_1.next()) {
	                        var e2 = otherEvidences_1_1.value;
	                        if (this.isEvidenceIdentical(e1, e2)) {
	                            found = e2;
	                            break;
	                        }
	                    }
	                }
	                catch (e_38_1) { e_38 = { error: e_38_1 }; }
	                finally {
	                    try {
	                        if (otherEvidences_1_1 && !otherEvidences_1_1.done && (_a = otherEvidences_1.return)) _a.call(otherEvidences_1);
	                    }
	                    finally { if (e_38) throw e_38.error; }
	                }
	                if (!found && e1.personas.size === 1) {
	                    evidenceRequests.push(this.evidences.del(e1.id));
	                }
	                else {
	                    evidenceRequests.push(this.rx.Observable.of(e1));
	                }
	            }
	        }
	        catch (e_39_1) { e_39 = { error: e_39_1 }; }
	        finally {
	            try {
	                if (evidences_2_1 && !evidences_2_1.done && (_b = evidences_2.return)) _b.call(evidences_2);
	            }
	            finally { if (e_39) throw e_39.error; }
	        }
	        return evidenceRequests;
	        var e_39, _b, e_38, _a;
	    };
	    MergeController.prototype.getNoteRequests = function (personId, otherNotes, notes) {
	        var noteRequests = [];
	        try {
	            for (var otherNotes_1 = __values(otherNotes), otherNotes_1_1 = otherNotes_1.next(); !otherNotes_1_1.done; otherNotes_1_1 = otherNotes_1.next()) {
	                var n1 = otherNotes_1_1.value;
	                var found = null;
	                try {
	                    for (var notes_1 = __values(notes), notes_1_1 = notes_1.next(); !notes_1_1.done; notes_1_1 = notes_1.next()) {
	                        var n2 = notes_1_1.value;
	                        if (this.isNoteIdentical(n1, n2)) {
	                            found = n2;
	                            break;
	                        }
	                    }
	                }
	                catch (e_40_1) { e_40 = { error: e_40_1 }; }
	                finally {
	                    try {
	                        if (notes_1_1 && !notes_1_1.done && (_a = notes_1.return)) _a.call(notes_1);
	                    }
	                    finally { if (e_40) throw e_40.error; }
	                }
	                if (!found) {
	                    var note = {
	                        title: n1.title,
	                        text: n1.text,
	                        private: n1.private,
	                        personIds: new Map([[personId, true]])
	                    };
	                    noteRequests.push(this.notes.create(note));
	                }
	                else {
	                    noteRequests.push(this.rx.Observable.of(found));
	                }
	            }
	        }
	        catch (e_41_1) { e_41 = { error: e_41_1 }; }
	        finally {
	            try {
	                if (otherNotes_1_1 && !otherNotes_1_1.done && (_b = otherNotes_1.return)) _b.call(otherNotes_1);
	            }
	            finally { if (e_41) throw e_41.error; }
	        }
	        try {
	            for (var notes_2 = __values(notes), notes_2_1 = notes_2.next(); !notes_2_1.done; notes_2_1 = notes_2.next()) {
	                var n1 = notes_2_1.value;
	                var found = false;
	                try {
	                    for (var otherNotes_2 = __values(otherNotes), otherNotes_2_1 = otherNotes_2.next(); !otherNotes_2_1.done; otherNotes_2_1 = otherNotes_2.next()) {
	                        var n2 = otherNotes_2_1.value;
	                        if (this.isNoteIdentical(n1, n2)) {
	                            found = true;
	                            break;
	                        }
	                    }
	                }
	                catch (e_42_1) { e_42 = { error: e_42_1 }; }
	                finally {
	                    try {
	                        if (otherNotes_2_1 && !otherNotes_2_1.done && (_c = otherNotes_2.return)) _c.call(otherNotes_2);
	                    }
	                    finally { if (e_42) throw e_42.error; }
	                }
	                if (!found) {
	                    n1.personIds.delete(personId);
	                    if (n1.personIds.size === 0) {
	                        noteRequests.push(this.notes.del(n1.id));
	                    }
	                    else {
	                        noteRequests.push(this.notes.update(n1));
	                    }
	                }
	                else {
	                    noteRequests.push(this.rx.Observable.of(n1));
	                }
	            }
	        }
	        catch (e_43_1) { e_43 = { error: e_43_1 }; }
	        finally {
	            try {
	                if (notes_2_1 && !notes_2_1.done && (_d = notes_2.return)) _d.call(notes_2);
	            }
	            finally { if (e_43) throw e_43.error; }
	        }
	        return noteRequests;
	        var e_41, _b, e_40, _a, e_43, _d, e_42, _c;
	    };
	    MergeController.prototype.mapEvidencePersonas = function (items, otherEvidences, evidenceResults) {
	        var resultMap = new Map();
	        try {
	            for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
	                var _a = __read(items_1_1.value, 2), key = _a[0], item = _a[1];
	                var result = void 0;
	                if (item.evidencePersonas.size > 0) {
	                    result = this.utils.clone(item);
	                    result.evidencePersonas = new Map();
	                    var _loop_1 = function (eid, paid) {
	                        var ix = otherEvidences.findIndex(function (e) { return e.id === eid; });
	                        if (ix >= 0) {
	                            result.evidencePersonas.set(evidenceResults[ix].id, paid);
	                        }
	                    };
	                    try {
	                        for (var _b = __values(item.evidencePersonas), _c = _b.next(); !_c.done; _c = _b.next()) {
	                            var _d = __read(_c.value, 2), eid = _d[0], paid = _d[1];
	                            _loop_1(eid, paid);
	                        }
	                    }
	                    catch (e_44_1) { e_44 = { error: e_44_1 }; }
	                    finally {
	                        try {
	                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
	                        }
	                        finally { if (e_44) throw e_44.error; }
	                    }
	                }
	                else {
	                    result = item;
	                }
	                resultMap.set(key, result);
	            }
	        }
	        catch (e_45_1) { e_45 = { error: e_45_1 }; }
	        finally {
	            try {
	                if (items_1_1 && !items_1_1.done && (_f = items_1.return)) _f.call(items_1);
	            }
	            finally { if (e_45) throw e_45.error; }
	        }
	        return resultMap;
	        var e_45, _f, e_44, _e;
	    };
	    MergeController.prototype.mapPrincipalIds = function (facts, matchSrcTar) {
	        var resultMap = new Map();
	        try {
	            for (var facts_1 = __values(facts), facts_1_1 = facts_1.next(); !facts_1_1.done; facts_1_1 = facts_1.next()) {
	                var _a = __read(facts_1_1.value, 2), key = _a[0], fact = _a[1];
	                if (fact.principalId1 > 0 || fact.principalId2 > 0) {
	                    fact = this.utils.clone(fact);
	                    if (fact.principalId1 > 0 && matchSrcTar.has(fact.principalId1)) {
	                        fact.principalId1 = matchSrcTar.get(fact.principalId1);
	                    }
	                    else {
	                        fact.principalId1 = 0;
	                    }
	                    if (fact.principalId2 > 0 && matchSrcTar.has(fact.principalId2)) {
	                        fact.principalId2 = matchSrcTar.get(fact.principalId2);
	                    }
	                    else {
	                        fact.principalId2 = 0;
	                    }
	                }
	                resultMap.set(key, fact);
	            }
	        }
	        catch (e_46_1) { e_46 = { error: e_46_1 }; }
	        finally {
	            try {
	                if (facts_1_1 && !facts_1_1.done && (_b = facts_1.return)) _b.call(facts_1);
	            }
	            finally { if (e_46) throw e_46.error; }
	        }
	        return resultMap;
	        var e_46, _b;
	    };
	    MergeController.prototype.replacePerson = function (src, tar, matchSrcTar) {
	        var _this = this;
	        // get evidences and sources
	        var evidences = this.getEvidences(tar, this.evidenceMap);
	        var otherEvidences = this.getEvidences(src, this.otherEvidenceMap);
	        var sourceIds = otherEvidences.map(function (e) { return e.citation.sourceId; }).filter(function (id) { return id > 0; });
	        // source create requests
	        var sourceRequests = this.getSourceRequests(sourceIds);
	        return (sourceRequests.length === 0 ? this.rx.Observable.of([]) : this.rx.Observable.forkJoin(sourceRequests))
	            .flatMap(function () {
	            var evidenceRequests = _this.getEvidenceCreateRequests(otherEvidences, evidences);
	            return evidenceRequests.length === 0 ? _this.rx.Observable.of([]) : _this.rx.Observable.forkJoin(evidenceRequests);
	        }).flatMap(function (evidenceResults) {
	            var person = _this.utils.clone(tar);
	            person.preferredNameKey = src.preferredNameKey;
	            person.preferredBirthKey = src.preferredBirthKey;
	            person.preferredDeathKey = src.preferredDeathKey;
	            person.living = src.living;
	            person.gender = src.gender;
	            person.tags = _this.utils.mergeMaps(src.tags, tar.tags);
	            person.externalIds = _this.utils.mergeMaps(src.externalIds, tar.externalIds);
	            person.names = _this.mapEvidencePersonas(src.names, otherEvidences, evidenceResults);
	            person.facts = _this.mapEvidencePersonas(_this.mapPrincipalIds(src.facts, matchSrcTar), otherEvidences, evidenceResults);
	            return _this.persons.update(person);
	        }).flatMap(function () {
	            var evidenceRequests = _this.getEvidenceDeleteRequests(otherEvidences, evidences);
	            return evidenceRequests.length === 0 ? _this.rx.Observable.of([]) : _this.rx.Observable.forkJoin(evidenceRequests);
	        }).flatMap(function () {
	            var noteRequests = _this.getNoteRequests(tar.id, _this.otherNoteMap.get(src.id) || [], _this.noteMap.get(tar.id) || []);
	            return noteRequests.length === 0 ? _this.rx.Observable.of([]) : _this.rx.Observable.forkJoin(noteRequests);
	        });
	    };
	    return MergeController;
	}());
	exports.default = MergeController;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var NotesController = /** @class */ (function () {
	    NotesController.$inject = ["$log", "$scope", "$transition$", "notes", "persons", "users", "utils"];
	    function NotesController($log, $scope, $transition$, notes, persons, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.noteId = utils.decodeId($transition$.params().noteId);
	        this.headers = [
	            { label: 'Title', width: 50, property: 'title', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, show: true },
	            { label: 'Private', width: 10, property: 'private', type: 'check', sortable: true },
	            { label: 'People', width: 40, property: '_people', type: 'people', filterable: true }
	        ];
	        this.items = new Map();
	        var pw = utils.pleaseWait();
	        var subscription = utils.readyChange(notes, persons, users).subscribe(function (_a) {
	            var _b = __read(_a, 1), noteMap = _b[0];
	            _this.$log.debug('notes.change');
	            _this.items = new Map();
	            Array.from(noteMap.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], note = _b[1];
	                notes.augmentNote(note, persons, users).subscribe(function (note) {
	                    _this.items.set(id, note);
	                });
	            });
	            utils.pleaseWaitCancel(pw);
	        });
	        $scope.$on('$destroy', function () {
	            subscription.unsubscribe();
	        });
	        $scope.$on('add', function (ev, params) {
	            utils.dialog(params.ev, 'EditNoteController', 'app/components/editNote/editNote.html', false, {});
	        });
	        $scope.$on('edit', function (ev, params) {
	            utils.dialog(params.ev, 'EditNoteController', 'app/components/editNote/editNote.html', false, {
	                note: params.item
	            });
	        });
	        $scope.$on('delete', function (ev, params) {
	            utils.confirm('Delete Note', 'Are you sure?', params.ev).then(function () {
	                notes.del(params.id);
	            }, function () {
	                // ignore
	            });
	        });
	    }
	    return NotesController;
	}());
	exports.default = NotesController;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2017
	 */
	var PartnerHomeController = /** @class */ (function () {
	    PartnerHomeController.$inject = ["$log", "$scope", "$state", "$transition$", "rx", "partnerId", "partnerToken", "authentication", "currentUser", "currentUserId", "messageBus", "segment", "server", "utils"];
	    function PartnerHomeController($log, $scope, $state, $transition$, rx, partnerId, partnerToken, authentication, currentUser, currentUserId, messageBus, segment, server, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.rx = rx;
	        this.partnerId = partnerId;
	        this.partnerToken = partnerToken;
	        this.authentication = authentication;
	        this.currentUser = currentUser;
	        this.messageBus = messageBus;
	        this.segment = segment;
	        this.server = server;
	        this.utils = utils;
	        this.code = $transition$.params().code; // invitation code in case this user was invited
	        this.weeklyEmail = true;
	        this.notRegistered = false;
	        this.acceptTerms = false;
	        var cuSub = currentUserId.stream().subscribe(function (userId) {
	            if (userId > 0) {
	                _this.notRegistered = false;
	                _this.go(userId);
	            }
	            else {
	                _this.notRegistered = true;
	            }
	        });
	        if (!!this.code) {
	            server.get('/invitations/' + this.code).subscribe(function (response) {
	                _this.given = response.given;
	                _this.surname = response.surname;
	            });
	        }
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            cuSub.unsubscribe();
	            mbSub.unsubscribe();
	        });
	    }
	    PartnerHomeController.prototype.register = function () {
	        var _this = this;
	        this.msg = '';
	        if (!this.acceptTerms) {
	            this.utils.alert('You must accept the terms of use and the privacy policy');
	            return;
	        }
	        this.saving = true;
	        var user = {
	            given: this.given,
	            surname: this.surname,
	            name: this.userName,
	            source: this.partnerId,
	            sourceKey: this.partnerToken,
	            preferences: {
	                RC_NOTIFY_ME: 'TRUE',
	                RC_WEEKLY_EMAIL: this.weeklyEmail ? 'TRUE' : 'FALSE'
	            }
	        };
	        this.authentication.register(user, false).subscribe(function () {
	            // currentUserId subscription will call go
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    PartnerHomeController.prototype.go = function (userId) {
	        var _this = this;
	        if (!!this.code) {
	            this.server.put('/invitations/' + this.code).subscribe(function (response) {
	                _this.saving = false;
	                _this.segment.track('invitations.accept');
	                // goto tree
	                _this.$state.go('tree', { treeId: response.treeId });
	            }, function () {
	                _this.saving = false;
	                _this.messageBus.post({ msg: 'ACCEPT_INVITATION_ERROR', op: "PUT", ctx: "invitations" });
	            });
	        }
	        else {
	            // once the user is logged in, go to their last visited tree, or create if they don't have any trees
	            this.rx.Observable.forkJoin([this.currentUser.readTrees(userId), this.currentUser.readCurrentTreeId(userId)])
	                .take(1).subscribe(function (_a) {
	                var _b = __read(_a, 2), trees = _b[0], treeId = _b[1];
	                _this.saving = false;
	                var treesArr = Array.from(trees.values());
	                // does the user not have a tree
	                if (treesArr.length === 0) {
	                    _this.$state.go('create');
	                }
	                else {
	                    // get last-visited tree, or get the last one
	                    var tree = treesArr.find(function (t) { return t.id === treeId; }) || treesArr[treesArr.length - 1];
	                    // redirect
	                    _this.$state.go('tree', { treeId: tree.id });
	                }
	            }, function (err) {
	                _this.saving = false;
	                _this.messageBus.post({ msg: err.data, op: "READ", ctx: "users_trees" });
	            });
	        }
	    };
	    return PartnerHomeController;
	}());
	exports.default = PartnerHomeController;


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var PeopleController = /** @class */ (function () {
	    PeopleController.$inject = ["$log", "$scope", "persons", "leads", "evidences", "utils"];
	    function PeopleController($log, $scope, persons, leads, evidences, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.headers = [
	            { label: 'First Name(s)', width: 25, property: '_given', type: 'string', filterable: true, sortable: true, sort: 2, defaultSort: true, link: { prefix: 'tree.person', field: 'personId' } },
	            { label: 'Last Name', width: 25, property: '_surname', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, link: { prefix: 'tree.person', field: 'personId' } },
	            { label: 'Birth', width: 10, property: '_birthDate', type: 'date', filterable: true, sortable: true },
	            { label: 'Death', width: 10, property: '_deathDate', type: 'date', filterable: true, sortable: true },
	            { label: 'Stars', width: 10, property: '_stars', type: 'stars', sortable: true },
	            { label: 'Hints', width: 10, property: '_hints', type: 'leads', sortable: true },
	            { label: 'Tags & FamilySearch', width: 10, property: '_tagsfs', type: 'tagsfs', title: 'Tags / FamilySearch ID', filterable: true, sortable: true }
	        ];
	        this.items = new Map();
	        var pw = utils.pleaseWait();
	        var subscription = utils.readyChange(persons, leads, evidences).subscribe(function (_a) {
	            var _b = __read(_a, 1), personMap = _b[0];
	            _this.$log.debug('people.change');
	            _this.items = new Map();
	            Array.from(personMap.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], p = _b[1];
	                persons.augmentPerson(p, leads, evidences).subscribe(function (p) {
	                    p._tagsfs = (!!p.tags ? Array.from(p.tags.keys()).join(', ') : '') + ';' +
	                        (p.externalIds.has('familysearch.org') ? p.externalIds.get('familysearch.org').id : '');
	                    _this.items.set(id, p);
	                });
	            });
	            utils.pleaseWaitCancel(pw);
	        });
	        $scope.$on('$destroy', function () {
	            subscription.unsubscribe();
	        });
	        $scope.$on('add', function (evt, props) {
	            utils.dialog(props.event, 'AddPersonController', 'app/components/addPerson/addPerson.html');
	        });
	    }
	    return PeopleController;
	}());
	exports.default = PeopleController;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var FS = 'familysearch.org';
	var PersonController = /** @class */ (function () {
	    PersonController.$inject = ["$log", "$rootScope", "$mdToast", "$state", "$transition$", "$scope", "$filter", "$mdMedia", "$window", "$timeout", "rx", "fs", "messageBus", "researchLinks", "searchHints", "bookmarks", "currentTree", "leadGenerators", "rightsFull", "persons", "families", "evidences", "stories", "notes", "leads", "medias", "ordinances", "researchLogs", "dates", "places", "segment", "sources", "social", "treeUsers", "users", "warnings", "personUtils", "familyUtils", "evidenceUtils", "mediaUtils", "utils", "evidenceAnalysisReport"];
	    function PersonController($log, $rootScope, $mdToast, $state, $transition$, $scope, $filter, $mdMedia, $window, $timeout, rx, fs, messageBus, researchLinks, searchHints, bookmarks, currentTree, leadGenerators, rightsFull, persons, families, evidences, stories, notes, leads, medias, ordinances, researchLogs, dates, places, segment, sources, social, treeUsers, users, warnings, personUtils, familyUtils, evidenceUtils, mediaUtils, utils, evidenceAnalysisReport) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$rootScope = $rootScope;
	        this.$mdToast = $mdToast;
	        this.$state = $state;
	        this.$filter = $filter;
	        this.$mdMedia = $mdMedia;
	        this.$window = $window;
	        this.rx = rx;
	        this.fs = fs;
	        this.messageBus = messageBus;
	        this.searchHints = searchHints;
	        this.currentTree = currentTree;
	        this.bookmarks = bookmarks;
	        this.leadGenerators = leadGenerators;
	        this.rightsFull = rightsFull;
	        this.persons = persons;
	        this.families = families;
	        this.evidences = evidences;
	        this.stories = stories;
	        this.notes = notes;
	        this.leads = leads;
	        this.medias = medias;
	        this.ordinances = ordinances;
	        this.dates = dates;
	        this.places = places;
	        this.segment = segment;
	        this.sources = sources;
	        this.social = social;
	        this.users = users;
	        this.warnings = warnings;
	        this.personUtils = personUtils;
	        this.familyUtils = familyUtils;
	        this.evidenceUtils = evidenceUtils;
	        this.mediaUtils = mediaUtils;
	        this.utils = utils;
	        this.evidenceAnalysisReport = evidenceAnalysisReport;
	        this.personServiceMutex = utils.createMutex();
	        this.encodeId = utils.encodeId.bind(utils);
	        this.encodedId = $transition$.params().personId;
	        this.personId = utils.decodeId(this.encodedId);
	        this.translations = persons.translations;
	        this.$log.info('personId', this.personId);
	        this.mediaPerRow = 4;
	        this.showHiddenTimeline = false;
	        this.resLinks = [];
	        this.researchHasGuides = false;
	        this.researchHasLinks = false;
	        this.archivedLeadsCount = 0;
	        this.archivedWarningsCount = 0;
	        // TODO compliments
	        this.complimented = false;
	        this.numCompliments = 2;
	        this.fsSignedIn = false;
	        this.isVisibleFilter = this.isVisibleTimeline.bind(this);
	        this.expanded = new Map();
	        treeUsers.setGuestRoot($rootScope, this.personId);
	        this.easySyncFSStream = new this.rx.AsyncSubject();
	        this.fsidStream = new this.rx.AsyncSubject();
	        this.appsReviewed = false;
	        this.rightsLevel = 0;
	        this.clipperToastPosted = false;
	        var pw = this.utils.pleaseWait();
	        utils.readyChange(evidences, families, leads, medias, notes, persons, sources, stories, treeUsers, users, warnings).take(1).subscribe(function () {
	            utils.pleaseWaitCancel(pw);
	        });
	        var rSub = rightsFull.streamLevel().subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        var treeRightsSub = rx.Observable.combineLatest(currentTree.stream(), rightsFull.streamLevel()).subscribe(function (_a) {
	            var _b = __read(_a, 2), tree = _b[0], level = _b[1];
	            _this.appsReviewed = tree.preferences.APPS_REVIEWED;
	            _this.rightsLevel = level;
	        });
	        currentTree.stream().take(1).subscribe(function (tree) {
	            _this.hideShare = (tree.privacy !== 'PUBLIC' && tree.privacy !== 'FEATURED');
	            _this.tagColorMap = utils.getTagColorMap(tree);
	        });
	        treeUsers.stream().take(1).subscribe(function (tu) {
	            _this.showRelativesEvents = (tu.preferences['SHOW_RELATIVES_EVENTS'] || 'FALSE') === 'TRUE';
	            _this.easySyncFSStream.next((tu.preferences['EASY_SYNC_FS'] || 'FALSE') === 'TRUE');
	            _this.easySyncFSStream.complete();
	        });
	        this.person = {};
	        this.fsid = 'unitialized';
	        var personSub = persons.streamId(this.personId).filter(function (p) { return p !== null; }).subscribe(function (person) {
	            _this.$log.debug('person.change', person);
	            $timeout(function () {
	                $rootScope.title = person._fullName;
	                _this.tagColor = utils.getTagColor(_this.tagColorMap, person.tags);
	            }, 0);
	            _this.person = person;
	            $log.info('person', person);
	            _this.twitterUrl = social.getTwitterUrl({ text: person._fullName });
	            var extId = _this.person.externalIds.get(FS);
	            var fsid = !!extId ? extId.id : null;
	            if (_this.fsid !== fsid) {
	                _this.fsid = fsid;
	                if (_this.fsidStream.isStopped) {
	                    _this.fsidStream = new _this.rx.AsyncSubject();
	                }
	                _this.fsidStream.next(fsid);
	                _this.fsidStream.complete();
	                _this.setFsMenuActions();
	            }
	            // is FS redirected?
	            if (!!fsid && _this.fs.isLoggedIn()) {
	                $timeout(function () {
	                    _this.fs.getPerson(fsid, false).subscribe(function (fsPerson) {
	                        if (!!fsPerson._redirected) {
	                            _this.person.externalIds.set(FS, { id: fsPerson._redirected });
	                            _this.persons.update(_this.person);
	                        }
	                    });
	                }, 2000);
	            }
	            // get research links
	            _this.resLinks = [];
	            researchLinks.get(Array.from(person.facts.values()).map(function (f) { return f.placeStandard || f.place; })).take(1).subscribe(function (links) {
	                _this.resLinks = links;
	                _this.researchHasGuides = _this.getResearchLinks('guide', false).length > 0;
	                _this.researchHasLinks = _this.getResearchLinks('link', false).length > 0;
	            });
	        });
	        var bSub = bookmarks.streamId(this.personId).subscribe(function (bookmark) {
	            _this.bookmark = bookmark;
	        });
	        var lgSub = leadGenerators.streamId(this.personId).subscribe(function (leadGen) {
	            _this.leadGen = leadGen;
	        });
	        this.numStars = 0;
	        this.numHints = 0;
	        this.evidenceMap = new Map();
	        this.nameMap = new Map();
	        this.timelineMap = new Map();
	        this.timelessMap = new Map();
	        this.otherSourcesMap = new Map();
	        var evidencesSub = utils.readyChange(persons, evidences, sources, stories, users).subscribe(function (_a) {
	            var _b = __read(_a, 1), personMap = _b[0];
	            _this.$log.debug('person.timeline.change', personMap);
	            var person = personMap.get(_this.personId);
	            if (!person) {
	                return;
	            }
	            _this.numStars = 0;
	            _this.evidenceMap = new Map();
	            _this.nameMap = new Map();
	            _this.timelineMap = new Map();
	            _this.timelessMap = new Map();
	            _this.otherSourcesMap = new Map();
	            evidences.streamForPerson(person).take(1).subscribe(function (evidenceMap) {
	                _this.numStars = Array.from(evidenceMap.values()).filter(function (e) { return !!e && e._hasSource; }).length;
	                var stream = evidenceMap.size === 0 ? _this.rx.Observable.of([]) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(evidenceMap.entries()).map(function (_a) {
	                    var _b = __read(_a, 2), id = _b[0], evidence = _b[1];
	                    return evidences.augmentEvidence(evidence, sources, persons, users).map(function (evidence) {
	                        return [id, evidence];
	                    });
	                })));
	                stream.subscribe(function (idEvidences) {
	                    _this.evidenceMap = new Map(idEvidences);
	                    try {
	                        for (var _a = __values(person.facts), _b = _a.next(); !_b.done; _b = _a.next()) {
	                            var _c = __read(_b.value, 2), key = _c[0], fact = _c[1];
	                            if ((fact.principalId1 > 0 && !personMap.has(fact.principalId1)) ||
	                                (fact.principalId2 > 0 && !personMap.has(fact.principalId2))) {
	                                // fact principal may be living and we don't have rights
	                                continue;
	                                //console.log('MISSING');
	                            }
	                            fact = persons.augmentFact(fact, person, personMap, _this.evidenceMap);
	                            fact._key = key;
	                            if (!!fact.dateSort) {
	                                _this.timelineMap.set(key, fact);
	                            }
	                            else if (fact.type === 'SOUR') {
	                                _this.otherSourcesMap.set(key, fact);
	                            }
	                            else {
	                                _this.timelessMap.set(key, fact);
	                            }
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                    try {
	                        for (var _e = __values(person.names), _f = _e.next(); !_f.done; _f = _e.next()) {
	                            var _g = __read(_f.value, 2), key = _g[0], name_1 = _g[1];
	                            name_1 = persons.augmentName(name_1, person, _this.evidenceMap);
	                            name_1._key = key;
	                            _this.nameMap.set(key, name_1);
	                            if (!!name_1.dateSort) {
	                                _this.timelineMap.set(key, name_1);
	                            }
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_f && !_f.done && (_h = _e.return)) _h.call(_e);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                    _this.fsNamesFactsSync();
	                    var e_1, _d, e_2, _h;
	                });
	                var _a;
	            });
	            stories.streamForPerson(_this.personId).take(1).subscribe(function (storyMap) {
	                (storyMap.size === 0 ? _this.rx.Observable.of([]) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(storyMap.values()).map(function (story) {
	                    return stories.augmentStory(story, persons, users).do(function (story) {
	                        if (!!story.dateSort) {
	                            _this.timelineMap.set(story.id, story);
	                        }
	                        else {
	                            _this.timelessMap.set(story.id, story);
	                        }
	                    });
	                })))).subscribe(function () {
	                    _this.fsStoriesSync();
	                });
	                var _a;
	            });
	        });
	        this.noteMap = new Map();
	        var notesSub = utils.readyChange(notes, persons, users).subscribe(function () {
	            _this.$log.debug('person.notes.change');
	            _this.noteMap = new Map();
	            notes.streamForPerson(_this.personId).take(1).subscribe(function (noteMap) {
	                (noteMap.size === 0 ? _this.rx.Observable.of([]) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(noteMap.values()).map(function (note) {
	                    return notes.augmentNote(note, persons, users).do(function (note) {
	                        _this.noteMap.set(note.id, note);
	                    });
	                })))).subscribe(function () {
	                    _this.fsNotesSync();
	                });
	                var _a;
	                //Array.from(noteMap.entries()).forEach(([id,note]) => {
	                //  notes.augmentNote(note, persons, users).subscribe(note => {
	                //    this.noteMap.set(id, note);
	                //  });
	                //});
	            });
	        });
	        this.logMap = new Map();
	        var logsSub = utils.readyChange(researchLogs, persons, users).subscribe(function () {
	            _this.$log.debug('person.researchLogs.change');
	            _this.logMap = new Map();
	            researchLogs.streamForPerson(_this.personId).take(1).subscribe(function (logMap) {
	                Array.from(logMap.entries()).forEach(function (_a) {
	                    var _b = __read(_a, 2), id = _b[0], log = _b[1];
	                    researchLogs.augmentResearchLog(log, persons, users).subscribe(function (log) {
	                        _this.logMap.set(id, log);
	                    });
	                });
	            });
	        });
	        this.mediaMap = new Map();
	        var mediasSub = utils.readyChange(medias, persons, evidences, sources, stories, users).subscribe(function () {
	            _this.$log.debug('person.medias.change');
	            _this.mediaMap = new Map();
	            medias.streamForPerson(_this.personId).take(1).subscribe(function (mediaMap) {
	                (mediaMap.size === 0 ? _this.rx.Observable.of([]) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(mediaMap.values()).map(function (media) {
	                    return medias.augmentMedia(media, persons, evidences, sources, stories, users).do(function (media) {
	                        _this.mediaMap.set(media.id, media);
	                    });
	                })))).subscribe(function () {
	                    _this.fsMediaSync();
	                });
	                var _a;
	            });
	        });
	        this.numHints = 0;
	        this.showArchivedLeads = false;
	        this.leadMap = new Map();
	        var leadsSub = utils.readyChange(leads, persons, users).subscribe(function () {
	            _this.$log.debug('person.leads.change');
	            _this.leadMap = new Map();
	            leads.streamForPerson(_this.personId, true).take(1).subscribe(function (leadMap) {
	                _this.numHints = 0;
	                _this.archivedLeadsCount = 0;
	                (leadMap.size === 0 ? _this.rx.Observable.of([]) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(leadMap.values()).map(function (lead) {
	                    if (lead.createdUser === 0 && lead.state === 0) {
	                        _this.numHints++;
	                    }
	                    if (lead.state === 1) {
	                        _this.archivedLeadsCount++;
	                    }
	                    return leads.augmentLead(lead, persons, users).do(function (lead) {
	                        _this.leadMap.set(lead.id, lead);
	                    });
	                })))).subscribe(function () {
	                    _this.fsLeadsSync();
	                });
	                var _a;
	            });
	        });
	        this.showArchivedWarnings = false;
	        this.warningMap = new Map();
	        var warningsSub = utils.readyChange(warnings, persons).subscribe(function () {
	            _this.$log.debug('person.warnings.change');
	            _this.warningMap = new Map();
	            warnings.streamForPerson(_this.personId, true).take(1).subscribe(function (warningMap) {
	                _this.archivedWarningsCount = 0;
	                Array.from(warningMap.entries()).forEach(function (_a) {
	                    var _b = __read(_a, 2), id = _b[0], warning = _b[1];
	                    if (warning.state === 1) {
	                        _this.archivedWarningsCount++;
	                    }
	                    warnings.augmentWarning(warning, persons).subscribe(function (warning) {
	                        _this.warningMap.set(id, warning);
	                    });
	                });
	            });
	        });
	        this.father = null;
	        this.mother = null;
	        this.parentFamilyMap = new Map();
	        this.spouseFamilyMap = new Map();
	        this.spouseRelativeTypes = [];
	        this.parentsRelativeTypes = [];
	        var familiesSub = utils.readyChange(persons, families, leads, evidences, users).subscribe(function (_a) {
	            var _b = __read(_a, 1), personMap = _b[0];
	            _this.$log.debug('person.families.change');
	            _this.father = null;
	            _this.mother = null;
	            _this.parentFamilyMap = new Map();
	            _this.spouseFamilyMap = new Map();
	            _this.spouseRelativeTypes = [];
	            _this.parentsRelativeTypes = [];
	            var person = personMap.get(_this.personId);
	            if (!person) {
	                return;
	            }
	            families.streamParents(_this.personId).take(1).subscribe(function (fm) {
	                var stream;
	                if (fm.size === 0) {
	                    stream = _this.rx.Observable.of([]);
	                }
	                else {
	                    stream = (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(fm.values()).map(function (f) {
	                        return families.augmentFamily(f, person.preferredParentsFamilyId, persons, leads, evidences, users);
	                    })));
	                }
	                _this.parentFamilyMap = new Map();
	                stream.subscribe(function (fs) {
	                    fs.forEach(function (f) {
	                        _this.parentFamilyMap.set(f.id, f);
	                    });
	                    // set parentsRelativeTypes
	                    _this.parentsRelativeTypes = ['FATHER', 'MOTHER', 'SIBLING'].map(function (r) {
	                        return {
	                            value: r,
	                            disabled: r === 'SIBLING' && _this.parentFamilyMap.size === 0
	                        };
	                    });
	                });
	                var pf = families.getPreferredFamily(fm, person.preferredParentsFamilyId);
	                if (!!pf && pf.husbandId > 0) {
	                    persons.streamId(pf.husbandId).take(1).subscribe(function (h) {
	                        _this.father = h;
	                    });
	                }
	                if (!!pf && pf.wifeId > 0) {
	                    persons.streamId(pf.wifeId).take(1).subscribe(function (w) {
	                        _this.mother = w;
	                    });
	                }
	                var _a;
	            });
	            families.streamSpouses(_this.personId).take(1).subscribe(function (fm) {
	                var stream;
	                if (fm.size === 0) {
	                    stream = _this.rx.Observable.of([]);
	                }
	                else {
	                    stream = (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(fm.values()).map(function (f) {
	                        return families.augmentFamily(f, -1, persons, leads, evidences, users);
	                    })));
	                }
	                _this.spouseFamilyMap = new Map();
	                stream.subscribe(function (fs) {
	                    fs.forEach(function (f) {
	                        _this.spouseFamilyMap.set(f.id, f);
	                    });
	                    // set spouseRelativeTypes
	                    _this.spouseRelativeTypes.push({
	                        value: 'SPOUSE',
	                        display: ((_this.spouseFamilyMap.size > 0 ? _this.translations.find(function (t) { return t.value === 'ANOTHER'; }).display + ' ' : '') + _this.translations.find(function (t) { return t.value === 'SPOUSE'; }).display)
	                    });
	                    var foundUnknownSpouse = false;
	                    _this.getSpouseFamilies().forEach(function (sf, i) {
	                        _this.spouseRelativeTypes.push({
	                            value: 'CHILD_' + i.toString(),
	                            display: (_this.translations.find(function (t) { return t.value === 'CHILD'; }).display + ' ' + _this.translations.find(function (t) { return t.value === 'OF'; }).display + ' ') + _this.getSpouseName(sf)
	                        });
	                        if (sf.husbandId === 0 || sf.wifeId === 0) {
	                            foundUnknownSpouse = true;
	                        }
	                    });
	                    if (!foundUnknownSpouse) {
	                        _this.spouseRelativeTypes.push({
	                            value: 'CHILD',
	                            display: (_this.translations.find(function (t) { return t.value === 'CHILD'; }).display + ' ' + _this.translations.find(function (t) { return t.value === 'OF_UNKNOWN_SPOUSE'; }).display)
	                        });
	                    }
	                });
	                var _a;
	            });
	        });
	        $scope.$on('$destroy', function () {
	            utils.pleaseWaitCancel(pw);
	            rSub.unsubscribe();
	            treeRightsSub.unsubscribe();
	            personSub.unsubscribe();
	            bSub.unsubscribe();
	            lgSub.unsubscribe();
	            evidencesSub.unsubscribe();
	            notesSub.unsubscribe();
	            logsSub.unsubscribe();
	            mediasSub.unsubscribe();
	            leadsSub.unsubscribe();
	            familiesSub.unsubscribe();
	            warningsSub.unsubscribe();
	        });
	        $scope.$on('toggleExpand', function (ev, params) {
	            var expand = !_this.expanded.get(params.id);
	            _this.expanded.set(params.id, expand);
	            if (params.type === 'lead' && expand) {
	                _this.hintShown();
	            }
	        });
	        $scope.$on('add', function (ev, params) {
	            switch (params.type) {
	                case 'evidence':
	                    _this.addEvidence(params.ev, params.item);
	                    break;
	                case 'family':
	                    // look for params.familyId in parent families or spouse families
	                    var family = Array.from(_this.parentFamilyMap.values()).find(function (pf) { return pf.id === params.id; });
	                    if (!!family) {
	                        _this.addRelative(params.ev, 'parent', params.relationshipType, family);
	                    }
	                    else {
	                        var spouseFamilies = _this.getSpouseFamilies();
	                        var ix = spouseFamilies.findIndex(function (sf) { return sf.id === params.id; });
	                        var relationshipType = params.relationshipType || 'SPOUSE';
	                        if (relationshipType === 'CHILD' && ix >= 0) {
	                            relationshipType += '_' + ix.toString();
	                        }
	                        _this.addRelative(params.ev, 'spouse', relationshipType, ix >= 0 ? spouseFamilies[ix] : null, spouseFamilies);
	                    }
	                    break;
	            }
	        });
	        $scope.$on('edit', function (ev, params) {
	            switch (params.type) {
	                case 'evidence':
	                    _this.editEvidence(params.ev, params.item);
	                    break;
	                case 'lead':
	                    _this.editLead(params.ev, params.item);
	                    break;
	                case 'note':
	                    _this.editNote(params.ev, params.item);
	                    break;
	                case 'story':
	                    _this.editStory(params.ev, params.item);
	                    break;
	                case 'family':
	                    _this.editParentRels(params.ev, params.item, params.personId);
	                    break;
	            }
	        });
	        $scope.$on('archive', function (ev, params) {
	            switch (params.type) {
	                case 'lead':
	                    _this.archiveLead(params.ev, params.item);
	                    break;
	                case 'warning':
	                    _this.archiveWarning(params.ev, params.item);
	                    break;
	            }
	        });
	        $scope.$on('delete', function (ev, params) {
	            switch (params.type) {
	                case 'fact':
	                    _this.deleteFact(params.ev, params.id);
	                    break;
	                case 'evidence':
	                    _this.deleteEvidence(params.ev, params.id);
	                    break;
	                case 'name':
	                    _this.deleteName(params.ev, params.id);
	                    break;
	                case 'lead':
	                    _this.deleteLead(params.ev, params.item);
	                    break;
	                case 'note':
	                    _this.deleteNote(params.ev, params.id);
	                    break;
	                case 'story':
	                    _this.deleteStory(params.ev, params.id);
	                    break;
	                case 'family':
	                    _this.removeFamilyMember(params.ev, params.item, params.personId);
	                    break;
	                case 'warning':
	                    _this.deleteWarning(params.ev, params.item);
	                    break;
	            }
	        });
	        $scope.$on('move', function (ev, params) {
	            switch (params.type) {
	                case 'family':
	                    _this.moveChild(params.ev, params.personId, params.sourceId, params.targetId);
	                    break;
	                case 'evidence':
	                    _this.moveEvidence(params.ev, params.evidenceId, params.sourceId, params.targetId);
	                    break;
	            }
	        });
	        $scope.$on('show', function (ev, params) {
	            switch (params.type) {
	                case 'source':
	                    _this.showSource(params.ev, params.id);
	                    break;
	                case 'hint':
	                    _this.showHint(params.ev, params.item);
	                    break;
	            }
	        });
	    }
	    //
	    // header functions
	    //
	    PersonController.prototype.colorStyle = function (color) {
	        if (!color) {
	            return {};
	        }
	        return { 'border-color': this.utils.colors[color][3], 'border-style': 'solid', 'border-width': '4px' };
	    };
	    PersonController.prototype.getTagString = function (tags) {
	        return !!tags && tags.size > 0 ? Array.from(tags.keys()).join(', ') : '';
	    };
	    PersonController.prototype.getStarsArray = function (max, numStars) {
	        return this.utils.asArray(Math.min(max, numStars));
	    };
	    PersonController.prototype.getProfilePhotoURL = function (person) {
	        return person.profilePhoto > 0 ? this.medias.getFileURL(person.profilePhoto, 0, '200x200') : '';
	    };
	    PersonController.prototype.getCoverPhotoURL = function (person) {
	        return person.coverPhoto > 0 ? this.medias.getFileURL(person.coverPhoto, 0, '600') : '';
	    };
	    PersonController.prototype.getMediaImageURL = function (m) {
	        return this.medias.getMediaImageURL(m, '100x100');
	    };
	    PersonController.prototype.toggleLeadGen = function (ev) {
	        var _this = this;
	        // if (this.person.living !== 'FALSE' && !this.leadGen) {
	        //   this.utils.alert('Hints not available on living', 'You can only get hints on deceased people. Please mark this person deceased.', ev);
	        // }
	        if (!!this.leadGen) {
	            this.savingLeadGen = true;
	            this.leadGenerators.del(this.personId).subscribe(function () {
	                _this.savingLeadGen = false;
	            }, function () {
	                _this.savingLeadGen = false;
	            });
	        }
	        else {
	            this.savingLeadGen = true;
	            this.leadGenerators.create({ id: this.personId }).subscribe(function () {
	                _this.savingLeadGen = false;
	            }, function () {
	                _this.savingLeadGen = false;
	            });
	        }
	    };
	    PersonController.prototype.toggleBookmark = function () {
	        var _this = this;
	        this.savingBookmark = true;
	        if (!!this.bookmark) {
	            this.bookmarks.del(this.personId).subscribe(function () {
	                _this.savingBookmark = false;
	            }, function () {
	                _this.savingBookmark = false;
	            });
	        }
	        else {
	            this.bookmarks.create({ id: this.personId }).subscribe(function () {
	                _this.savingBookmark = false;
	            }, function () {
	                _this.savingBookmark = false;
	            });
	        }
	    };
	    PersonController.prototype.toggleCompliment = function () {
	        this.complimented = !this.complimented;
	        if (this.complimented) {
	            this.numCompliments++;
	        }
	        else {
	            this.numCompliments--;
	        }
	    };
	    PersonController.prototype.getSearchHints = function (ev) {
	        var _this = this;
	        this.searchHints.getHints(this.personId).subscribe(function (result) {
	            _this.segment.track('research.search_hints');
	            _this.utils.dialog(ev, 'NestedListController', 'app/components/nestedList/nestedList.html', true, {
	                title: 'Search Hints',
	                eventPrefix: 'search_hints',
	                lists: result
	            }).then(function () {
	                // ignore
	            }, function () {
	                // ignore
	            });
	        }, function (err) {
	            _this.messageBus.post({ msg: err.data || err, warn: true });
	        });
	    };
	    PersonController.prototype.researchGuides = function (ev) {
	        this.segment.track('research.guides');
	        this.utils.dialog(ev, 'NestedListController', 'app/components/nestedList/nestedList.html', true, {
	            title: 'Research Guides',
	            eventPrefix: 'research',
	            lists: this.getResearchLinks('guide', true)
	        }).then(function () {
	            // ignore
	        }, function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.researchLinks = function (ev) {
	        this.segment.track('research.links');
	        this.utils.dialog(ev, 'NestedListController', 'app/components/nestedList/nestedList.html', true, {
	            title: 'Links',
	            eventPrefix: 'research',
	            lists: this.getResearchLinks('link', true)
	        }).then(function () {
	            // ignore
	        }, function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.researchHelp = function (ev) {
	        var lists = [];
	        lists.push({
	            title: 'Hire a Researcher',
	            items: [{
	                    title: 'Legacy Tree Genealogists',
	                    url: 'https://www.legacytree.com/rootsfinder',
	                    text: 'Hire the world\'s highest-rated genealogy research firm! We help clients all over the globe discover their family history through records, narratives and DNA.'
	                }, {
	                    title: 'American Ancestors',
	                    url: 'https://www.americanancestors.org/services/getting-started',
	                    text: 'Hire the Most Respected Experts in Genealogy.'
	                }]
	        });
	        lists.push({
	            title: 'Ask a Question',
	            items: [{
	                    title: 'Genealogy & Family History Stack Exchange',
	                    url: 'https://genealogy.stackexchange.com/',
	                    text: 'Genealogy & Family History Stack Exchange is a question and answer site for expert genealogists and people interested in genealogy or family history.'
	                }]
	        });
	        var groups = this.getResearchLinks('group', false);
	        if (groups.length > 0) {
	            lists.push({
	                title: 'Join a Group',
	                items: groups
	            });
	        }
	        this.segment.track('research.help');
	        this.utils.dialog(ev, 'NestedListController', 'app/components/nestedList/nestedList.html', true, {
	            title: 'Get Help',
	            eventPrefix: 'research',
	            lists: lists
	        }).then(function () {
	            // ignore
	        }, function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.getResearchLinks = function (t, groupByPlace) {
	        var items = this.resLinks.filter(function (l) { return l.type === t; });
	        if (!groupByPlace) {
	            // remove duplicates
	            var m_1 = new Map();
	            items.forEach(function (item) {
	                m_1.set(item.url, item);
	            });
	            items = Array.from(m_1.values());
	        }
	        else {
	            items = this.utils.arrayGroupBy(items, 'place').map(function (keyValues) {
	                keyValues.values.sort(function (a, b) { return a.title < b.title ? -1 : a.title > b.title ? 1 : 0; });
	                return {
	                    title: keyValues.key,
	                    items: keyValues.values
	                };
	            });
	        }
	        items.sort(function (a, b) { return a.title < b.title ? -1 : a.title > b.title ? 1 : 0; });
	        return items;
	    };
	    PersonController.prototype.evidenceReport = function (ev) {
	        var _this = this;
	        this.segment.track('reports.create', { name: 'Evidence Analysis' });
	        this.evidenceAnalysisReport.create(this.person).subscribe(function (data) {
	            _this.utils.saveReport(data, ev).subscribe(function () {
	                //
	            }, function (err) {
	                _this.messageBus.post({ msg: 'Error saving report: ' + err.data, warn: true });
	            });
	        }, function (err) {
	            _this.messageBus.post({ msg: err, warn: err !== 'NOT_FOUND' });
	        });
	    };
	    PersonController.prototype.isFsLoggedIn = function () {
	        return this.fs.isLoggedIn();
	    };
	    PersonController.prototype.fsMenu = function ($mdMenu, ev) {
	        var _this = this;
	        this.menuEvent = ev;
	        if (this.fs.isLoggedIn()) {
	            this.setFsMenuActions().subscribe(function () {
	                $mdMenu.open(ev);
	            });
	        }
	        else {
	            this.utils.dialog(this.menuEvent, 'FsLoginController', 'app/components/fsLogin/fsLogin.html', true, {
	                text: 'You need to log into FamilySearch to perform this action'
	            }).then(function () {
	                _this.setFsMenuActions().subscribe(function () {
	                    $mdMenu.open(ev);
	                });
	            }, function () {
	                // ignore
	            });
	        }
	    };
	    PersonController.prototype.setFsMenuActions = function () {
	        var _this = this;
	        var subject = new this.rx.AsyncSubject();
	        this.fsStatus = 'FS_NOT_LOGGED_IN';
	        if (this.fs.isLoggedIn()) {
	            var idVer_1 = !!this.person && !!this.person.externalIds && this.person.externalIds.get(FS);
	            if (!!idVer_1 && idVer_1.id) {
	                // read fs person and ordinances
	                this.rx.Observable.forkJoin(this.rightsFull.streamLevel().take(1), this.fs.getPerson(idVer_1.id, false), this.fs.getIsLDS()).subscribe(function (_a) {
	                    var _b = __read(_a, 3), level = _b[0], fsPerson = _b[1], isLDS = _b[2];
	                    if (!!fsPerson) {
	                        _this.fsStatus = 'FS_CONNECTED';
	                        var rfPerson = _this.fs.toRFPerson(fsPerson);
	                        _this.fsPersonURL = rfPerson._url;
	                        _this.fsMenuActions = [{ mdicon: 'open_in_new', id: 'FS_VIEW' }];
	                        if (level >= _this.rightsFull.LEVEL_EDIT) {
	                            _this.fsMenuActions.push({ mdicon: 'cloud_download', id: 'FS_DOWNLOAD' });
	                        }
	                        _this.fsMenuActions.push({ rcicon: 'rc:icon-brokenlink', id: 'FS_DISCONNECT' });
	                        // fs person version changed? (DWQ: don't compare versions anymore)
	                        //if (idVer.extVersion !== rfPerson.externalIds.get(FS).extVersion) {
	                        //  this.fsStatus = 'FS_FS_UPDATED';
	                        //  this.fsMenuActions.unshift({mdicon: 'swap_horiz', id: 'FS_UPDATE'});
	                        //}
	                        //// rf person version changed?
	                        //else if (idVer.rfVersion !== this.person.version.toString()) {
	                        //  this.fsStatus = 'FS_RF_UPDATED';
	                        //  this.fsMenuActions.unshift({mdicon: 'swap_horiz', id: 'FS_UPDATE'});
	                        //}
	                        //else {
	                        _this.fsMenuActions.unshift({ mdicon: 'swap_horiz', id: 'FS_COMPARE' });
	                        //}
	                        _this.fsMenuOrdinances = [];
	                        // set ordinance menu items
	                        if (isLDS) {
	                            _this.rx.Observable.forkJoin(_this.fs.getOrdinances(idVer_1.id), _this.fs.getOrdinancesStatus(idVer_1.id)).subscribe(function (_a) {
	                                var _b = __read(_a, 2), fsOrdinances = _b[0], fsStatus = _b[1];
	                                _this.fsMenuOrdinances = fsOrdinances.map(function (fsOrdinance) {
	                                    return _this.fs.toRFOrdinance(fsOrdinance);
	                                }).sort(function (a, b) {
	                                    var x = _this.ordinances.order.find(function (o) { return o.type === a.type; });
	                                    var y = _this.ordinances.order.find(function (o) { return o.type === b.type; });
	                                    if (!!x && !!y) {
	                                        return x.order - y.order;
	                                    }
	                                    else if (!!x) {
	                                        return 1;
	                                    }
	                                    else if (!!y) {
	                                        return -1;
	                                    }
	                                    else {
	                                        return 0;
	                                    }
	                                });
	                                if (_this.fsStatus !== 'FS_FS_UPDATED' && _this.fsStatus !== 'FS_RF_UPDATED') {
	                                    switch (fsStatus) {
	                                        case 'http://familysearch.org/v1/Ready':
	                                        case 'http://familysearch.org/v1/Submittable':
	                                        case 'http://familysearch.org/v1/Resubmittable':
	                                        case 'http://familysearch.org/v1/Cancelled':
	                                        case 'http://familysearch.org/v1/Deleted':
	                                            _this.fsStatus = 'FS_ORDINANCES_READY';
	                                            break;
	                                        case 'http://familysearch.org/v1/InProgress':
	                                        case 'http://familysearch.org/v1/Reserved':
	                                        case 'http://familysearch.org/v1/NeedPermission':
	                                            _this.fsStatus = 'FS_ORDINANCES_RESERVED';
	                                            break;
	                                        case 'http://familysearch.org/v1/Completed':
	                                        case 'http://familysearch.org/v1/NotNeeded':
	                                        case 'http://familysearch.org/v1/NotNeededBornInCovenant':
	                                            _this.fsStatus = 'FS_ORDINANCES_COMPLETE';
	                                            break;
	                                        case 'http://familysearch.org/v1/NotReady':
	                                        case 'http://familysearch.org/v1/NeedMoreInformation':
	                                        case 'http://familysearch.org/v1/NotAvailable':
	                                        case 'http://familysearch.org/v1/Invalid':
	                                            _this.fsStatus = 'FS_ORDINANCES_NEEDED';
	                                            break;
	                                    }
	                                }
	                                subject.next(true);
	                                subject.complete();
	                            });
	                        }
	                        else {
	                            subject.next(true);
	                            subject.complete();
	                        }
	                    }
	                    else {
	                        _this.fsStatus = 'FS_NOT_CONNECTED';
	                        _this.fsMenuActions = [
	                            { mdicon: 'link', id: 'FS_CONNECT' }
	                        ];
	                        _this.fsMenuOrdinances = [];
	                        subject.next(true);
	                        subject.complete();
	                    }
	                }, function () {
	                    // ignore
	                });
	            }
	            else {
	                this.fsStatus = 'FS_NOT_CONNECTED';
	                this.fsMenuActions = [
	                    { mdicon: 'link', id: 'FS_CONNECT' }
	                ];
	                this.fsMenuOrdinances = [];
	                subject.next(true);
	                subject.complete();
	            }
	        }
	        else {
	            this.fsMenuActions = [];
	            this.fsMenuOrdinances = [];
	            subject.next(true);
	            subject.complete();
	        }
	        return subject;
	    };
	    PersonController.prototype.fsMenuActionHidden = function (action, hideAdd) {
	        return hideAdd && !['FS_COMPARE', 'FS_VIEW'].includes(action.id);
	    };
	    PersonController.prototype.fsMenuAction = function (action) {
	        var _this = this;
	        switch (action.id) {
	            case 'FS_CONNECT':
	                this.utils.dialog(this.menuEvent, 'FsMatchController', 'app/components/fsMatch/fsMatch.html', true, {
	                    source: 'RootsFinder',
	                    target: 'FamilySearch',
	                    personId: this.personId
	                });
	                break;
	            case 'FS_COMPARE':
	            case 'FS_UPDATE':
	                this.$state.go('tree.sync', { personId: this.utils.encodeId(this.person.id) });
	                break;
	            case 'FS_DOWNLOAD':
	                this.$state.go('tree.import-fs', { root: this.person.externalIds.get(FS).id });
	                break;
	            case 'FS_VIEW':
	                var url = this.fs.getHref(this.fsPersonURL, 'detail');
	                if (!!url) {
	                    this.$window.open(url, '_blank');
	                }
	                else {
	                    this.fs.clickHref(this.fsPersonURL, 'detail');
	                }
	                break;
	            case 'FS_DISCONNECT':
	                this.utils.confirm('Disconnect FamilySearch Match?', 'Unmatch this person from FamilySearch?', this.menuEvent).then(function () {
	                    _this.utils.syncMutex(_this.personServiceMutex, function () {
	                        _this.person.externalIds.delete(FS);
	                        _this.person.names.forEach(function (name) {
	                            name.externalIds.delete(FS);
	                        });
	                        _this.person.facts.forEach(function (fact) {
	                            fact.externalIds.delete(FS);
	                        });
	                        return _this.persons.update(_this.person);
	                    }).subscribe(function (p) {
	                        _this.person = p;
	                    });
	                }, function () {
	                    // ignore
	                });
	                break;
	        }
	    };
	    PersonController.prototype.fsOrdinanceAction = function () {
	        var url = this.fs.getHref(this.fsPersonURL, 'ordinances');
	        if (!!url) {
	            this.$window.open(url, '_blank');
	        }
	        else {
	            this.fs.clickHref(this.fsPersonURL, 'ordinances');
	        }
	    };
	    PersonController.prototype.editPerson = function (ev, tabIndex) {
	        if (tabIndex === void 0) { tabIndex = 0; }
	        ev.stopPropagation();
	        var items = Array.from(this.timelineMap.entries()).concat(Array.from(this.timelessMap.entries())).filter(function (entry) { return entry[0] > 0; }).map(function (entry) { return entry[1]; });
	        this.utils.dialog(ev, 'EditPersonController', 'app/components/editPerson/editPerson.html', false, {
	            tabIndex: tabIndex,
	            person: this.person,
	            names: Array.from(this.nameMap.entries()).filter(function (entry) { return entry[0] > 0; }).map(function (entry) { return entry[1]; }),
	            births: items.filter(function (i) { return i.principal && (i.type === 'BIRT' || i.type === 'CHR' || i.type === 'BAPM'); }),
	            deaths: items.filter(function (i) { return i.principal && (i.type === 'DEAT' || i.type === 'BURI'); }),
	            genders: items.filter(function (i) { return i.principal && i.type === 'SEX'; })
	        });
	    };
	    PersonController.prototype.mergePerson = function (ev) {
	        this.utils.dialog(ev, 'MergeDlgController', 'app/components/merge/merge.html', false, {
	            pid: this.person.id
	        });
	    };
	    PersonController.prototype.deletePerson = function (ev) {
	        var _this = this;
	        this.personUtils.getDeletedEvidences(this.person).subscribe(function (evidences) {
	            var evidenceMap = new Map();
	            Array.from(evidences.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], e = _b[1];
	                _this.evidences.augmentEvidence(e, _this.sources, _this.persons, _this.users).subscribe(function (e) {
	                    evidenceMap.set(id, e);
	                });
	            });
	            _this.utils.dialog(ev, 'DeletePersonController', 'app/components/deletePerson/deletePerson.html', true, {
	                person: _this.person,
	                evidenceMap: evidenceMap
	            }).then(function () {
	                // get the deleted names and facts from the evidences, but remove the ones for this person
	                var namesFacts = _this.evidenceUtils.getDeletedNamesFacts(Array.from(evidenceMap.values()), [], true).filter(function (nf) { return nf.personId !== _this.person.id; });
	                // If there are any to show, show them and let the user choose which to remove
	                if (namesFacts.filter(function (nf) { return nf.principal && nf.unsupported; }).length > 0) {
	                    _this.utils.dialog(ev, 'SelectNamesFactsController', 'app/components/selectNamesFacts/selectNamesFacts.html', false, {
	                        namesFacts: namesFacts
	                    }).then(function (namesFacts) {
	                        _this.personUtils.del(_this.person, evidences, namesFacts).subscribe(function () {
	                            _this.$state.go('tree.graph');
	                        });
	                    }, function () {
	                        // ignore
	                    });
	                }
	                else {
	                    _this.personUtils.del(_this.person, evidences, namesFacts).subscribe(function () {
	                        _this.$state.go('tree.graph');
	                    });
	                }
	            }, function () {
	                // ignore
	            });
	        });
	    };
	    PersonController.prototype.share = function (platform) {
	        this.social.post(platform, {
	            title: this.person._fullName,
	            mediaId: this.person.profilePhoto,
	            description: 'Born: ' + this.person._birthDate + ' ' + this.person._deathDate + '\n' +
	                'Died: ' + this.person._deathDate + ' ' + this.person._deathPlace
	        }, this.menuEvent);
	    };
	    PersonController.prototype.showCompliments = function (ev) {
	        this.utils.alert('List users who have complimented this person', 'Coming Later', ev);
	    };
	    PersonController.prototype.editTags = function (ev) {
	        var self = this;
	        this.utils.dialog(ev, 'EditTagsController', 'app/components/editTags/editTags.html').then(function (response) {
	            self.$log.info('response', response);
	        }, function () {
	            self.$log.info('cancel');
	        });
	    };
	    //
	    // body functions
	    //
	    PersonController.prototype.toggleExpandAll = function (m, type) {
	        var anyExpanded = this.anyExpanded(m);
	        try {
	            for (var m_2 = __values(m), m_2_1 = m_2.next(); !m_2_1.done; m_2_1 = m_2.next()) {
	                var _a = __read(m_2_1.value, 1), id = _a[0];
	                this.expanded.set(id, !anyExpanded);
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (m_2_1 && !m_2_1.done && (_b = m_2.return)) _b.call(m_2);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        if (type === 'lead' && m.size > 0 && !anyExpanded) {
	            this.hintShown();
	        }
	        var e_3, _b;
	    };
	    PersonController.prototype.anyExpanded = function (m) {
	        var _this = this;
	        return Array.from(m.keys()).some(function (id) { return _this.expanded.get(id); });
	    };
	    PersonController.prototype.openMenu = function ($mdMenu, ev) {
	        this.menuEvent = ev;
	        $mdMenu.open(ev);
	    };
	    PersonController.prototype.getTimelineKey = function (item) {
	        return item._key || item.id;
	    };
	    PersonController.prototype.isVisibleTimeline = function (item) {
	        return !item.hidden || this.showHiddenTimeline;
	    };
	    PersonController.prototype.toggleShowHiddenTimeline = function () {
	        this.showHiddenTimeline = !this.showHiddenTimeline;
	    };
	    PersonController.prototype.anyExpandedTimeline = function () {
	        return this.anyExpanded(this.timelineMap) || this.anyExpanded(this.timelessMap) || this.anyExpanded(this.nameMap) || this.anyExpanded(this.otherSourcesMap);
	    };
	    PersonController.prototype.toggleExpandTimeline = function () {
	        var _this = this;
	        var anyExpanded = this.anyExpandedTimeline();
	        [].concat(Array.from(this.timelineMap.keys()), Array.from(this.timelessMap.keys()), Array.from(this.nameMap.keys()), Array.from(this.otherSourcesMap.keys())).forEach(function (id) {
	            _this.expanded.set(id, !anyExpanded);
	        });
	    };
	    PersonController.prototype.visibleTimelineSize = function () {
	        var _this = this;
	        return Array.from(this.timelineMap.values()).filter(function (f) { return _this.isVisibleTimeline(f); }).length +
	            Array.from(this.timelessMap.values()).filter(function (f) { return _this.isVisibleTimeline(f); }).length +
	            Array.from(this.nameMap.values()).filter(function (f) { return _this.isVisibleTimeline(f); }).length +
	            Array.from(this.otherSourcesMap.values()).filter(function (f) { return _this.isVisibleTimeline(f); }).length;
	    };
	    PersonController.prototype.hasHiddenTimeline = function () {
	        return [].concat(Array.from(this.timelineMap.values()), Array.from(this.timelessMap.values()), Array.from(this.nameMap.values()), Array.from(this.otherSourcesMap.values())).some(function (f) { return f.hidden; });
	    };
	    PersonController.prototype.getAgeInStory = function (story) {
	        var birth = this.persons.getPreferredBirth(this.person);
	        var age = '';
	        if (!!birth) {
	            age = this.utils.yearDiff(story.dateSort, birth.dateSort);
	            if (isNaN(age) || age <= 0) {
	                age = '';
	            }
	        }
	        return age;
	    };
	    PersonController.prototype.deleteFact = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete', 'Are you sure?', ev).then(function () {
	            _this.utils.syncMutex(_this.personServiceMutex, function () {
	                return _this.personUtils.deleteFact(_this.person, id);
	            }).subscribe(function (p) {
	                _this.person = p;
	            });
	        }, function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.deleteName = function (ev, id) {
	        var _this = this;
	        if (this.person.names.size === 1) {
	            this.utils.alert('Sorry...', 'The software requires everyone to have a name. If you don\'t know the name, you can change it to "Unknown".', ev);
	        }
	        else {
	            this.utils.confirm('Delete', 'Are you sure?', ev).then(function () {
	                _this.utils.syncMutex(_this.personServiceMutex, function () {
	                    return _this.personUtils.deleteName(_this.person, id);
	                }).subscribe(function (p) {
	                    _this.person = p;
	                });
	            }, function () {
	                // ignore
	            });
	        }
	    };
	    PersonController.prototype.addEvidence = function (ev, nameFact) {
	        this.utils.dialog(ev, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	            personId: this.personId,
	            fact: !!nameFact && !nameFact.nameForms ? nameFact : null,
	            name: !!nameFact && !!nameFact.nameForms ? nameFact : null
	        });
	    };
	    PersonController.prototype.editEvidence = function (ev, evidence) {
	        this.utils.dialog(ev, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	            personId: this.personId,
	            evidence: evidence
	        });
	    };
	    PersonController.prototype.deleteEvidence = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Supporting Evidence', 'Are you sure?', ev).then(function () {
	            var evidence = _this.evidenceMap.get(id);
	            var deletedNamesFacts = _this.evidenceUtils.getDeletedNamesFacts([evidence], [], true);
	            _this.$log.debug('person.deleteEvidence', deletedNamesFacts);
	            if (deletedNamesFacts.filter(function (nf) { return !nf.primary && nf.principal && nf.unsupported; }).length > 0) {
	                _this.utils.dialog(null, 'SelectNamesFactsController', 'app/components/selectNamesFacts/selectNamesFacts.html', false, {
	                    namesFacts: deletedNamesFacts
	                }).then(function (deletedNamesFacts) {
	                    _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	                }, function () {
	                    // ignore
	                });
	            }
	            else {
	                _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	            }
	        }, function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.addStory = function (ev) {
	        this.utils.dialog(ev, 'EditStoryController', 'app/components/editStory/editStory.html', false, {
	            personId: this.personId
	        });
	    };
	    PersonController.prototype.editStory = function (ev, story) {
	        this.utils.dialog(ev, 'EditStoryController', 'app/components/editStory/editStory.html', false, {
	            story: story
	        });
	    };
	    PersonController.prototype.deleteStory = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Story', 'Are you sure?', ev).then(function () {
	            _this.stories.del(id);
	        }, function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.addNote = function (ev) {
	        this.utils.dialog(ev, 'EditNoteController', 'app/components/editNote/editNote.html', false, {
	            personId: this.personId
	        });
	    };
	    PersonController.prototype.editNote = function (ev, note) {
	        this.utils.dialog(ev, 'EditNoteController', 'app/components/editNote/editNote.html', false, {
	            note: note
	        });
	    };
	    PersonController.prototype.deleteNote = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Note', 'Are you sure?', ev).then(function () {
	            _this.notes.del(id);
	        }, function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.addLog = function (ev) {
	        var _this = this;
	        this.utils.dialog(ev, 'EditResearchLogController', 'app/components/editResearchLog/editResearchLog.html', false, {
	            personId: this.personId
	        }).then(function (rl) {
	            _this.$state.go('tree.research-log', { id: _this.utils.encodeId(rl.id) });
	        }, {});
	    };
	    PersonController.prototype.showMedia = function (ev, item) {
	        var _this = this;
	        this.utils.dialog(ev, 'MediaController', 'app/components/media/media.dialog.html', true, {
	            media: item,
	            hideTools: item.id < 0
	        }).then(function (response) {
	            if (!!response) {
	                if (response === 'edit') {
	                    _this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	                        media: item
	                    });
	                }
	                else if (response === 'delete') {
	                    _this.utils.dialog(ev, 'DeleteMediaController', 'app/components/deleteMedia/deleteMedia.html', false, {
	                        media: item
	                    }).then(function () {
	                        _this.medias.del(item.id);
	                    }, function () {
	                        // ignore
	                    });
	                }
	                else if (response === 'mosaic') {
	                    _this.mediaUtils.mosaic(ev, item);
	                }
	            }
	        }, function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.addMedia = function (ev) {
	        this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	            personId: this.personId
	        });
	    };
	    PersonController.prototype.addLead = function (ev) {
	        this.utils.dialog(ev, 'EditLeadController', 'app/components/editLead/editLead.html', false, {
	            personId: this.personId
	        });
	    };
	    PersonController.prototype.editLead = function (ev, lead) {
	        this.utils.dialog(ev, 'EditLeadController', 'app/components/editLead/editLead.html', false, {
	            lead: lead
	        });
	    };
	    PersonController.prototype.archiveLead = function (ev, lead) {
	        lead.state = lead.state === 0 ? 1 : 0;
	        this.leads.update(lead);
	    };
	    PersonController.prototype.deleteLead = function (ev, lead) {
	        var _this = this;
	        this.utils.confirm('Delete', 'Are you sure?', ev).then(function () {
	            lead.state = 2;
	            _this.leads.update(lead);
	        }, function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.archiveWarning = function (ev, warning) {
	        warning.state = warning.state === 0 ? 1 : 0;
	        this.warnings.update(warning);
	    };
	    PersonController.prototype.deleteWarning = function (ev, warning) {
	        var _this = this;
	        this.utils.confirm('Delete', 'Are you sure?', ev).then(function () {
	            warning.state = 2;
	            _this.warnings.update(warning);
	        }, function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.setPreferredParents = function (family) {
	        var _this = this;
	        if (this.person.preferredParentsFamilyId !== family.id) {
	            this.utils.syncMutex(this.personServiceMutex, function () {
	                _this.person.preferredParentsFamilyId = family.id;
	                return _this.persons.update(_this.person);
	            }).subscribe(function (p) {
	                _this.person = p;
	            });
	        }
	    };
	    PersonController.prototype.addParentsRelative = function (ev, relative) {
	        this.addRelative(ev, 'parent-siblings', relative, this.families.getPreferredFamily(this.parentFamilyMap, this.person.preferredParentsFamilyId));
	    };
	    PersonController.prototype.addSpouseRelative = function (ev, relative) {
	        this.addRelative(ev, 'spouse-children', relative, null, this.getSpouseFamilies());
	    };
	    PersonController.prototype.getSpouseFamilies = function () {
	        return this.$filter('toArray')(this.spouseFamilyMap, '_marriage/dateSort');
	    };
	    PersonController.prototype.getSpouseName = function (sf) {
	        if (sf.husbandId > 0 && sf.husbandId !== this.personId) {
	            return !!sf._husband ? sf._husband._given : '';
	        }
	        if (sf.wifeId > 0 && sf.wifeId !== this.personId) {
	            return !!sf._wife ? sf._wife._given : '';
	        }
	        return 'Unknown Spouse';
	    };
	    PersonController.prototype.addRelative = function (ev, mode, relationshipType, family, spouseFamilies) {
	        if (spouseFamilies === void 0) { spouseFamilies = []; }
	        this.utils.dialog(ev, 'AddPersonController', 'app/components/addPerson/addPerson.html', false, {
	            mode: mode,
	            relationshipType: relationshipType,
	            relatedToPersonId: this.personId,
	            family: family,
	            spouseFamilies: spouseFamilies
	        });
	    };
	    PersonController.prototype.editParentRels = function (ev, family, personId) {
	        this.utils.dialog(ev, 'EditParentRelsController', 'app/components/editParentRels/editParentRels.html', false, {
	            family: family,
	            childId: personId
	        });
	    };
	    PersonController.prototype.removeFamilyMember = function (ev, family, personId) {
	        var _this = this;
	        if (family.childRels.size > 1 && (family.husbandId === 0 || family.husbandId === personId) && (family.wifeId === 0 || family.wifeId === personId)) {
	            this.utils.alert('Can\'t Be Done', 'The software requires a family to have at least one parent', ev);
	        }
	        else {
	            this.utils.confirm('Remove Person from Family', 'Are you sure?', ev).then(function () {
	                _this.familyUtils.removeFamilyMember(family, personId);
	            }, function () {
	                // ignore
	            });
	        }
	    };
	    PersonController.prototype.showSource = function (ev, id) {
	        this.utils.showSource(ev, this.sources, this.evidences, this.users, id);
	    };
	    PersonController.prototype.hintShown = function () {
	        if (this.appsReviewed !== 'TRUE' && this.rightsLevel === this.rightsFull.LEVEL_OWNER && !this.$rootScope.clipperToastPosted) {
	            this.$rootScope.clipperToastPosted = true;
	            this.showClipperToast();
	        }
	    };
	    PersonController.prototype.showClipperToast = function () {
	        var _this = this;
	        this.$mdToast.show({
	            hideDelay: 0,
	            position: 'top right',
	            controller: 'ClipperToastController',
	            controllerAs: 'clipperToast',
	            bindToController: true,
	            locals: {},
	            templateUrl: 'app/components/clipperToast/clipperToast.html'
	        }).then(function (result) {
	            if (result === 'YES') {
	                _this.$state.go('tree.apps', { return: _this.encodedId });
	            }
	            else {
	                _this.currentTree.stream().take(1).flatMap(function (tree) {
	                    tree = _this.utils.clone(tree);
	                    tree.preferences.APPS_REVIEWED = 'TRUE';
	                    return _this.currentTree.update(tree);
	                }).subscribe(function () {
	                    // ignore
	                });
	            }
	        }).catch(function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.moveChild = function (ev, personId, sourceId, targetId) {
	        var _this = this;
	        this.utils.confirm('Move child to a different family', 'Are you sure?', ev).then(function () {
	            _this.familyUtils.moveChild(personId, sourceId, targetId).subscribe();
	        }, function () {
	            // ignore
	        });
	    };
	    PersonController.prototype.moveEvidence = function (ev, evidenceId, sourceKey, targetKey) {
	        var _this = this;
	        this.utils.confirm('Move evidence to this fact', 'Are you sure?', ev).then(function () {
	            _this.personUtils.moveEvidence(_this.personId, evidenceId, sourceKey, targetKey).subscribe();
	        }, function () {
	            // ignore
	        });
	    };
	    //
	    // fs sync functions
	    //
	    PersonController.prototype.syncFS = function (item, type, ev) {
	        var _this = this;
	        if (type === 'ITEM') {
	            if (!item.type && !item.nameForms) {
	                type = 'STORY';
	            }
	            else if (!!item.nameForms) {
	                type = 'NAME';
	            }
	            else if (!!item.type && !item.nameForms) {
	                type = 'FACT';
	            }
	        }
	        if (item._rfdiffer) {
	            this.utils.dialog(ev, 'FsCompareLinkController', 'app/components/fsCompareLink/fsCompareLink.html', true, {
	                id: this.personId
	            });
	            return;
	        }
	        if (item._rfonly) {
	            var spouseStream = item.type === 'FACT' && item.principalId1 > 0 ? this.persons.streamId(item.principalId1).take(1) : this.rx.Observable.of(null);
	            this.rx.Observable.forkJoin(this.fs.getSources(this.fsid), spouseStream).subscribe(function (_a) {
	                var _b = __read(_a, 2), sources = _b[0], spouse = _b[1];
	                if (item.type === 'FACT' && item.principalId1 > 0 && (!spouse || !spouse.externalIds.has(FS) || !spouse.externalIds.get(FS).id)) {
	                    _this.utils.alert('Need to match spouse first', 'Before you can copy this fact to FamilySearch, you need to match the spouse to someone on FamilySearch.', ev);
	                    return;
	                }
	                var evidences = [];
	                if (type === 'FACT' || type === 'NAME') {
	                    evidences = Array.from(item._evidences.values())
	                        .filter(function (e) { return e._hasSource && (!e.externalIds.has(FS) || !e.externalIds.get(FS).id || !sources.some(function (src) { return src.id === e.externalIds.get(FS).id; })); })
	                        .map(function (e) {
	                        e.externalIds.delete(FS); // in case it points to a source that's been deleted/detached
	                        return {
	                            evidence: e,
	                            title: e._sourceAbbr || e._sourceTitle,
	                            copy: false
	                        };
	                    });
	                }
	                _this.utils.dialog(ev, 'FsPromptController', 'app/components/fsPrompt/fsPrompt.html', false, {
	                    action: '',
	                    type: type,
	                    item: { rf: item },
	                    exists: item._fsexists,
	                    evidences: evidences
	                }).then(function (promptResult) {
	                    switch (type) {
	                        case 'NOTE':
	                            var fsNote = _this.fs.toFSNote(item);
	                            _this.fs.saveNote(fsNote, _this.fsid, promptResult.reason).subscribe(function (result) {
	                                item.externalIds.set(FS, { id: result });
	                                _this.notes.update(item);
	                            }, function (err) {
	                                _this.messageBus.post({ msg: err, warn: true });
	                            });
	                            break;
	                        case 'MEDIA':
	                            item._url = _this.medias.getFileURL(item.id, 0);
	                            var fsMedia = _this.fs.toFSMedia(item);
	                            _this.fs.saveMedia(fsMedia, _this.fsid).subscribe(function (result) {
	                                item.externalIds.set(FS, { id: result });
	                                _this.medias.update(item);
	                            }, function (err) {
	                                _this.messageBus.post({ msg: err, warn: true, warnParams: { id: item.id, fsid: _this.fsid } });
	                            });
	                            break;
	                        case 'STORY':
	                            var fsStory = _this.fs.toFSStory(item);
	                            _this.fs.saveStory(fsStory, _this.fsid).subscribe(function (result) {
	                                item.externalIds.set(FS, { id: result });
	                                _this.stories.update(item);
	                            }, function (err) {
	                                _this.messageBus.post({ msg: err, warn: true });
	                            });
	                            break;
	                        case 'NAME':
	                            var fsName = _this.fs.toFSName(item);
	                            _this.fs.savePersonName(_this.fsid, fsName, promptResult.reason).subscribe(function (result) {
	                                _this.person.names.get(item._key).externalIds.set(FS, { id: result });
	                                _this.persons.update(_this.person);
	                            }, function (err) {
	                                _this.messageBus.post({ msg: err, warn: true });
	                            });
	                            break;
	                        case 'FACT':
	                            var fsFact_1 = _this.fs.toFSFact(item);
	                            var factSaver = void 0;
	                            if (item.principalId1 > 0) {
	                                // couple fact
	                                factSaver = _this.fs.getFamilies(_this.fsid)
	                                    .flatMap(function (families) {
	                                    if (!families || !spouse) {
	                                        return _this.rx.Observable.of(null);
	                                    }
	                                    var family = families.spouseFamilies.find(function (family) { return !!family.coupleRel &&
	                                        ((family.coupleRel.person1.resourceId === _this.fsid && family.coupleRel.person2.resourceId === spouse.externalIds.get(FS).id) ||
	                                            (family.coupleRel.person1.resourceId === spouse.externalIds.get(FS).id && family.coupleRel.person2.resourceId === _this.fsid)); });
	                                    if (!!family) {
	                                        return _this.rx.Observable.of(family.coupleRel);
	                                    }
	                                    var husband, wife;
	                                    if (_this.person.gender === 'FEMALE' || spouse.gender === 'MALE') {
	                                        wife = _this.person;
	                                        husband = spouse;
	                                    }
	                                    else {
	                                        husband = _this.person;
	                                        wife = spouse;
	                                    }
	                                    var coupleRel = _this.fs.toFSCoupleRel(null, husband, wife);
	                                    coupleRel.facts = [];
	                                    return _this.fs.saveCoupleRel(coupleRel, promptResult.reason).map(function (coupleId) {
	                                        return {
	                                            id: coupleId,
	                                            person1: {
	                                                resourceId: husband.externalIds.get(FS).id
	                                            },
	                                            person2: {
	                                                resourceId: wife.externalIds.get(FS).id
	                                            }
	                                        };
	                                    });
	                                }).flatMap(function (coupleRel) {
	                                    if (!coupleRel) {
	                                        return _this.rx.Observable.of(null);
	                                    }
	                                    return _this.fs.saveCoupleFact(coupleRel.id, fsFact_1, promptResult.reason, coupleRel.person1.resourceId, coupleRel.person2.resourceId);
	                                });
	                            }
	                            else {
	                                factSaver = _this.fs.savePersonFact(_this.fsid, fsFact_1, promptResult.reason);
	                            }
	                            factSaver.flatMap(function (factId) {
	                                var evidences = promptResult.evidences.filter(function (e) { return e.copy; }).map(function (e) { return e.evidence; });
	                                if (evidences.length === 0) {
	                                    return _this.rx.Observable.of(factId);
	                                }
	                                return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(evidences.map(function (e) {
	                                    var fsSource = _this.fs.toFSSource(e);
	                                    return _this.fs.saveSource(fsSource, _this.fsid, promptResult.reason).flatMap(function (result) {
	                                        e.externalIds.set(FS, { id: result });
	                                        return _this.evidences.update(e);
	                                    });
	                                }))).map(function () { return factId; });
	                                var _a;
	                            }).flatMap(function (factId) {
	                                _this.person.facts.get(item._key).externalIds.set(FS, { id: factId });
	                                return _this.persons.update(_this.person);
	                            }).subscribe(function () {
	                                // ignore
	                            }, function (err) {
	                                _this.messageBus.post({ msg: err, warn: true });
	                            });
	                            break;
	                    }
	                }, function () {
	                    // ignore
	                });
	            }, function (err) {
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	            return;
	        }
	        if (item.id < 0 || item._key < 0) {
	            item.id = 0;
	            var target_1;
	            switch (type) {
	                case 'NOTE':
	                    this.notes.create(item);
	                    break;
	                case 'LEAD':
	                    this.leads.create(item);
	                    break;
	                case 'MEDIA':
	                    target_1 = this.utils.clone(item);
	                    target_1.url = item._url + (item._url.indexOf('?') >= 0 ? '&' : '?') + 'sessionId=' + this.fs.getAccessToken();
	                    target_1.fileInfos.set(0, {
	                        contentType: 'URL',
	                        fileName: item._fileName || 'media'
	                    });
	                    this.medias.create(target_1);
	                    break;
	                case 'STORY':
	                    target_1 = this.utils.clone(item);
	                    var mediaSaver = this.rx.Observable.of(true);
	                    // create media?
	                    if (!!item._url && target_1.mediaIds.size === 0) {
	                        var m = {
	                            id: this.utils.randomId(),
	                            title: item.title,
	                            externalIds: new Map(),
	                            url: item._url + (item._url.indexOf('?') >= 0 ? '&' : '?') + 'sessionId=' + this.fs.getAccessToken(),
	                            fileInfos: new Map([[0, {
	                                        contentType: 'URL',
	                                        fileName: 'story media'
	                                    }]]),
	                            personIds: new Map()
	                        };
	                        target_1.mediaIds.set(m.id, true);
	                        mediaSaver = this.medias.create(m);
	                    }
	                    mediaSaver.subscribe(function () {
	                        _this.stories.create(target_1);
	                    }, function (err) {
	                        _this.messageBus.post({ msg: err, warn: true });
	                    });
	                    break;
	                case 'NAME':
	                    this.person.names.set(this.utils.randomKey(), item);
	                    this.persons.update(this.person);
	                    break;
	                case 'FACT':
	                    if (item.type === 'SOUR') {
	                        var evidence = this.utils.first(item._evidences);
	                        evidence.id = 0;
	                        this.evidences.create(evidence).subscribe(function (evidence) {
	                            item.evidencePersonas = new Map([[evidence.id, 1]]);
	                            _this.person.facts.set(_this.utils.randomKey(), item);
	                            _this.persons.update(_this.person);
	                        });
	                    }
	                    else {
	                        this.person.facts.set(this.utils.randomKey(), item);
	                        this.persons.update(this.person);
	                    }
	                    break;
	            }
	        }
	    };
	    PersonController.prototype.fsNotesSync = function () {
	        var _this = this;
	        this.rx.Observable.combineLatest(this.easySyncFSStream, this.fsidStream).take(1).subscribe(function (_a) {
	            var _b = __read(_a, 2), easySync = _b[0], fsid = _b[1];
	            if (!easySync || !fsid || _this.$rootScope.fsTokenRejected) {
	                return;
	            }
	            // read fs
	            _this.fs.getNotes(_this.fsid).take(1).subscribe(function (fsNotes) {
	                try {
	                    // set unmatched
	                    for (var _a = __values(_this.noteMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var note = _b.value;
	                        note._rfonly = true;
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	                if (!!fsNotes) {
	                    fsNotes.forEach(function (fsNote) {
	                        var rfNote = _this.fs.toRFNote(fsNote, _this.personId);
	                        // find matching rf item
	                        var found = false;
	                        try {
	                            for (var _a = __values(_this.noteMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                                var note = _b.value;
	                                if (note._rfonly && note.externalIds.has(FS) && note.externalIds.get(FS).id === fsNote.id) {
	                                    note._rfonly = false;
	                                    note._rfdiffer = !_this.utils.noteEquals(note, rfNote);
	                                    found = true;
	                                    break;
	                                }
	                            }
	                        }
	                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	                        finally {
	                            try {
	                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                            }
	                            finally { if (e_5) throw e_5.error; }
	                        }
	                        if (!found) {
	                            try {
	                                for (var _d = __values(_this.noteMap.values()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                                    var note = _e.value;
	                                    if (note._rfonly && _this.utils.noteEquals(note, rfNote)) {
	                                        note._rfonly = false;
	                                        found = true;
	                                        break;
	                                    }
	                                }
	                            }
	                            catch (e_6_1) { e_6 = { error: e_6_1 }; }
	                            finally {
	                                try {
	                                    if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
	                                }
	                                finally { if (e_6) throw e_6.error; }
	                            }
	                        }
	                        // insert item if none found
	                        if (!found) {
	                            rfNote.id = -_this.utils.randomId();
	                            _this.notes.augmentNote(rfNote, _this.persons, _this.users).subscribe(function (note) {
	                                _this.noteMap.set(note.id, note);
	                            });
	                        }
	                        var e_5, _c, e_6, _f;
	                    });
	                }
	                var e_4, _c;
	            }, function (err) {
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	        });
	    };
	    PersonController.prototype.fsLeadsSync = function () {
	        var _this = this;
	        this.rx.Observable.combineLatest(this.easySyncFSStream, this.fsidStream).take(1).subscribe(function (_a) {
	            var _b = __read(_a, 2), easySync = _b[0], fsid = _b[1];
	            if (!easySync || !fsid || _this.$rootScope.fsTokenRejected) {
	                return;
	            }
	            // read fs
	            _this.fs.getHints(_this.fsid).take(1).subscribe(function (fsLeads) {
	                if (!!fsLeads) {
	                    fsLeads.forEach(function (fsLead) {
	                        var rfLead = _this.fs.toRFLead(fsLead, _this.personId);
	                        // find matching rf item
	                        var found = false;
	                        try {
	                            for (var _a = __values(_this.leadMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                                var lead = _b.value;
	                                if ((lead.externalIds.has(FS) && lead.externalIds.get(FS).id === fsLead.id) || _this.utils.leadEquals(lead, rfLead)) {
	                                    found = true;
	                                    break;
	                                }
	                            }
	                        }
	                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
	                        finally {
	                            try {
	                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                            }
	                            finally { if (e_7) throw e_7.error; }
	                        }
	                        // insert item if none found
	                        if (!found) {
	                            rfLead.id = -_this.utils.randomId();
	                            _this.leads.augmentLead(rfLead, _this.persons, _this.users).subscribe(function (lead) {
	                                _this.leadMap.set(lead.id, lead);
	                            });
	                        }
	                        var e_7, _c;
	                    });
	                }
	            }, function (err) {
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	        });
	    };
	    PersonController.prototype.fsMediaSync = function () {
	        var _this = this;
	        this.rx.Observable.combineLatest(this.easySyncFSStream, this.fsidStream).take(1).subscribe(function (_a) {
	            var _b = __read(_a, 2), easySync = _b[0], fsid = _b[1];
	            if (!easySync || !fsid || _this.$rootScope.fsTokenRejected) {
	                return;
	            }
	            // read fs
	            _this.fs.getMemories(_this.fsid).take(1).subscribe(function (fsMemories) {
	                try {
	                    // set unmatched
	                    for (var _a = __values(_this.mediaMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var media = _b.value;
	                        media._rfonly = !(media.fileInfos.has(0) && media.fileInfos.get(0).fileName === 'profile photo');
	                    }
	                }
	                catch (e_8_1) { e_8 = { error: e_8_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_8) throw e_8.error; }
	                }
	                if (!!fsMemories && !!fsMemories.media) {
	                    fsMemories.media.forEach(function (fsMedia) {
	                        var rfMedia = _this.fs.toRFMedia(fsMedia, _this.personId);
	                        // find matching rf item
	                        var found = false;
	                        try {
	                            for (var _a = __values(_this.mediaMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                                var media = _b.value;
	                                if (media._rfonly && media.externalIds.has(FS) && media.externalIds.get(FS).id === fsMedia.id) {
	                                    media._rfonly = false;
	                                    found = true;
	                                    break;
	                                }
	                            }
	                        }
	                        catch (e_9_1) { e_9 = { error: e_9_1 }; }
	                        finally {
	                            try {
	                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                            }
	                            finally { if (e_9) throw e_9.error; }
	                        }
	                        // insert item if none found
	                        if (!found) {
	                            rfMedia.id = -_this.utils.randomId();
	                            _this.medias.augmentMedia(rfMedia, _this.persons, _this.evidences, _this.sources, _this.stories, _this.users).subscribe(function (media) {
	                                _this.mediaMap.set(media.id, media);
	                            });
	                        }
	                        var e_9, _c;
	                    });
	                }
	                var e_8, _c;
	            }, function (err) {
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	        });
	    };
	    PersonController.prototype.fsStoriesSync = function () {
	        var _this = this;
	        this.rx.Observable.combineLatest(this.easySyncFSStream, this.fsidStream).take(1).subscribe(function (_a) {
	            var _b = __read(_a, 2), easySync = _b[0], fsid = _b[1];
	            if (!easySync || !fsid || _this.$rootScope.fsTokenRejected) {
	                return;
	            }
	            // read fs
	            _this.fs.getMemories(_this.fsid).take(1).subscribe(function (fsMemories) {
	                // set unmatched
	                var stories = Array.from(_this.timelineMap.values()).concat(Array.from(_this.timelessMap.values())).filter(function (item) { return !item.type && !item.nameForms; });
	                try {
	                    for (var stories_1 = __values(stories), stories_1_1 = stories_1.next(); !stories_1_1.done; stories_1_1 = stories_1.next()) {
	                        var story = stories_1_1.value;
	                        story._rfonly = true;
	                    }
	                }
	                catch (e_10_1) { e_10 = { error: e_10_1 }; }
	                finally {
	                    try {
	                        if (stories_1_1 && !stories_1_1.done && (_a = stories_1.return)) _a.call(stories_1);
	                    }
	                    finally { if (e_10) throw e_10.error; }
	                }
	                if (!!fsMemories && !!fsMemories.stories) {
	                    fsMemories.stories.forEach(function (fsStory) {
	                        var rfStory = _this.fs.toRFStory(fsStory, _this.personId);
	                        // find matching rf item
	                        var found = false;
	                        try {
	                            for (var stories_2 = __values(stories), stories_2_1 = stories_2.next(); !stories_2_1.done; stories_2_1 = stories_2.next()) {
	                                var story = stories_2_1.value;
	                                if (story._rfonly && story.externalIds.has(FS) && story.externalIds.get(FS).id === fsStory.id) {
	                                    story._rfonly = false;
	                                    story._rfdiffer = !_this.utils.storyEquals(story, rfStory);
	                                    found = true;
	                                    break;
	                                }
	                            }
	                        }
	                        catch (e_11_1) { e_11 = { error: e_11_1 }; }
	                        finally {
	                            try {
	                                if (stories_2_1 && !stories_2_1.done && (_a = stories_2.return)) _a.call(stories_2);
	                            }
	                            finally { if (e_11) throw e_11.error; }
	                        }
	                        if (!found) {
	                            try {
	                                for (var stories_3 = __values(stories), stories_3_1 = stories_3.next(); !stories_3_1.done; stories_3_1 = stories_3.next()) {
	                                    var story = stories_3_1.value;
	                                    if (story._rfonly && _this.utils.storyEquals(story, rfStory)) {
	                                        story._rfonly = false;
	                                        found = true;
	                                        break;
	                                    }
	                                }
	                            }
	                            catch (e_12_1) { e_12 = { error: e_12_1 }; }
	                            finally {
	                                try {
	                                    if (stories_3_1 && !stories_3_1.done && (_b = stories_3.return)) _b.call(stories_3);
	                                }
	                                finally { if (e_12) throw e_12.error; }
	                            }
	                        }
	                        // insert item if none found
	                        if (!found) {
	                            rfStory.id = -_this.utils.randomId();
	                            _this.stories.augmentStory(rfStory, _this.persons, _this.users).subscribe(function (story) {
	                                if (!!story.dateSort) {
	                                    _this.timelineMap.set(story.id, story);
	                                }
	                                else {
	                                    _this.timelessMap.set(story.id, story);
	                                }
	                            });
	                        }
	                        var e_11, _a, e_12, _b;
	                    });
	                }
	                var e_10, _a;
	            }, function (err) {
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	        });
	    };
	    PersonController.prototype.fsNamesFactsSync = function () {
	        var _this = this;
	        this.rx.Observable.combineLatest(this.easySyncFSStream, this.fsidStream).take(1).subscribe(function (_a) {
	            var _b = __read(_a, 2), easySync = _b[0], fsid = _b[1];
	            if (!easySync || !fsid || _this.$rootScope.fsTokenRejected) {
	                return;
	            }
	            // read fs
	            _this.rx.Observable.forkJoin(_this.fs.getPerson(_this.fsid), _this.fs.getSources(_this.fsid)).subscribe(function (_a) {
	                var _b = __read(_a, 2), fsp = _b[0], fsSources = _b[1];
	                var fsPerson = _this.fs.toRFPerson(fsp);
	                // convert fs sources to rf evidences
	                var rfEvidences = fsSources.map(function (fsSource) {
	                    var rfEvidence = _this.fs.toRFEvidence(fsSource);
	                    rfEvidence._sourceTitle = '';
	                    rfEvidence._citation = rfEvidence.citation.text;
	                    rfEvidence._people = new Map();
	                    rfEvidence._personas = new Map();
	                    return rfEvidence;
	                });
	                // standardize fs facts
	                var fsFactStreams = Array.from(fsPerson.facts.values()).map(function (fact) {
	                    return _this.rx.Observable.forkJoin(_this.dates.standardize(fact.date), _this.places.standardize(fact.place)).map(function (_a) {
	                        var _b = __read(_a, 2), dateStd = _b[0], placeStd = _b[1];
	                        fact.dateSort = dateStd.dateSort || '';
	                        fact.placeStandard = placeStd.length > 0 ? placeStd[0].standardName : '';
	                        return fact;
	                    });
	                });
	                (fsFactStreams.length === 0 ? _this.rx.Observable.of([]) : (_c = _this.rx.Observable).forkJoin.apply(_c, __spread(fsFactStreams))).subscribe(function (rfFacts) {
	                    var namesFacts = Array.from(_this.timelineMap.values()).concat(Array.from(_this.timelessMap.values()), Array.from(_this.nameMap.values()))
	                        .filter(function (item) { return !!item.type || !!item.nameForms; });
	                    var names = namesFacts.filter(function (item) { return !!item.nameForms; });
	                    var facts = namesFacts.filter(function (item) { return !!item.type && !item.nameForms && item.type !== 'SOUR' && item.principal; });
	                    try {
	                        for (var names_1 = __values(names), names_1_1 = names_1.next(); !names_1_1.done; names_1_1 = names_1.next()) {
	                            var n = names_1_1.value;
	                            n._rfonly = true;
	                        }
	                    }
	                    catch (e_13_1) { e_13 = { error: e_13_1 }; }
	                    finally {
	                        try {
	                            if (names_1_1 && !names_1_1.done && (_a = names_1.return)) _a.call(names_1);
	                        }
	                        finally { if (e_13) throw e_13.error; }
	                    }
	                    try {
	                        for (var facts_1 = __values(facts), facts_1_1 = facts_1.next(); !facts_1_1.done; facts_1_1 = facts_1.next()) {
	                            var f = facts_1_1.value;
	                            f._rfonly = true;
	                        }
	                    }
	                    catch (e_14_1) { e_14 = { error: e_14_1 }; }
	                    finally {
	                        try {
	                            if (facts_1_1 && !facts_1_1.done && (_b = facts_1.return)) _b.call(facts_1);
	                        }
	                        finally { if (e_14) throw e_14.error; }
	                    }
	                    try {
	                        for (var _c = __values(_this.evidenceMap.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                            var e = _d.value;
	                            e._rfonly = !_this.utils.isHiddenEvidence(e);
	                        }
	                    }
	                    catch (e_15_1) { e_15 = { error: e_15_1 }; }
	                    finally {
	                        try {
	                            if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                        }
	                        finally { if (e_15) throw e_15.error; }
	                    }
	                    try {
	                        // match names
	                        for (var _f = __values(fsPerson.names.values()), _g = _f.next(); !_g.done; _g = _f.next()) {
	                            var rfName = _g.value;
	                            var found = false;
	                            try {
	                                for (var names_2 = __values(names), names_2_1 = names_2.next(); !names_2_1.done; names_2_1 = names_2.next()) {
	                                    var name_2 = names_2_1.value;
	                                    if (name_2._rfonly && name_2.externalIds.has(FS) && name_2.externalIds.get(FS).id === rfName.externalIds.get(FS).id) {
	                                        name_2._rfonly = false;
	                                        name_2._rfdiffer = !_this.utils.nameEquals(name_2, rfName);
	                                        found = true;
	                                        break;
	                                    }
	                                }
	                            }
	                            catch (e_16_1) { e_16 = { error: e_16_1 }; }
	                            finally {
	                                try {
	                                    if (names_2_1 && !names_2_1.done && (_h = names_2.return)) _h.call(names_2);
	                                }
	                                finally { if (e_16) throw e_16.error; }
	                            }
	                            if (!found) {
	                                try {
	                                    for (var names_3 = __values(names), names_3_1 = names_3.next(); !names_3_1.done; names_3_1 = names_3.next()) {
	                                        var name_3 = names_3_1.value;
	                                        if (name_3._rfonly && _this.utils.nameEquals(name_3, rfName)) {
	                                            name_3._rfonly = false;
	                                            found = true;
	                                            break;
	                                        }
	                                    }
	                                }
	                                catch (e_17_1) { e_17 = { error: e_17_1 }; }
	                                finally {
	                                    try {
	                                        if (names_3_1 && !names_3_1.done && (_j = names_3.return)) _j.call(names_3);
	                                    }
	                                    finally { if (e_17) throw e_17.error; }
	                                }
	                            }
	                            if (!found) {
	                                rfName._key = -_this.utils.randomKey();
	                                _this.nameMap.set(rfName._key, _this.persons.augmentName(rfName, _this.person, new Map()));
	                            }
	                        }
	                    }
	                    catch (e_18_1) { e_18 = { error: e_18_1 }; }
	                    finally {
	                        try {
	                            if (_g && !_g.done && (_k = _f.return)) _k.call(_f);
	                        }
	                        finally { if (e_18) throw e_18.error; }
	                    }
	                    try {
	                        // match facts
	                        for (var rfFacts_1 = __values(rfFacts), rfFacts_1_1 = rfFacts_1.next(); !rfFacts_1_1.done; rfFacts_1_1 = rfFacts_1.next()) {
	                            var rfFact = rfFacts_1_1.value;
	                            var found = false;
	                            try {
	                                for (var facts_2 = __values(facts), facts_2_1 = facts_2.next(); !facts_2_1.done; facts_2_1 = facts_2.next()) {
	                                    var fact = facts_2_1.value;
	                                    if (fact._rfonly && fact.externalIds.has(FS) && fact.externalIds.get(FS).id === rfFact.externalIds.get(FS).id) {
	                                        fact._rfonly = false;
	                                        fact._rfdiffer = !_this.utils.factTypeDatePlaceEquals(fact, rfFact);
	                                        found = true;
	                                        break;
	                                    }
	                                }
	                            }
	                            catch (e_19_1) { e_19 = { error: e_19_1 }; }
	                            finally {
	                                try {
	                                    if (facts_2_1 && !facts_2_1.done && (_l = facts_2.return)) _l.call(facts_2);
	                                }
	                                finally { if (e_19) throw e_19.error; }
	                            }
	                            if (!found) {
	                                try {
	                                    for (var facts_3 = __values(facts), facts_3_1 = facts_3.next(); !facts_3_1.done; facts_3_1 = facts_3.next()) {
	                                        var fact = facts_3_1.value;
	                                        if (fact._rfonly && _this.utils.factTypeDatePlaceEquals(fact, rfFact)) {
	                                            fact._rfonly = false;
	                                            found = true;
	                                            break;
	                                        }
	                                    }
	                                }
	                                catch (e_20_1) { e_20 = { error: e_20_1 }; }
	                                finally {
	                                    try {
	                                        if (facts_3_1 && !facts_3_1.done && (_m = facts_3.return)) _m.call(facts_3);
	                                    }
	                                    finally { if (e_20) throw e_20.error; }
	                                }
	                            }
	                            if (!found) {
	                                rfFact._key = -_this.utils.randomKey();
	                                _this.timelineMap.set(rfFact._key, _this.persons.augmentFact(rfFact, _this.person, new Map(), new Map()));
	                            }
	                        }
	                    }
	                    catch (e_21_1) { e_21 = { error: e_21_1 }; }
	                    finally {
	                        try {
	                            if (rfFacts_1_1 && !rfFacts_1_1.done && (_o = rfFacts_1.return)) _o.call(rfFacts_1);
	                        }
	                        finally { if (e_21) throw e_21.error; }
	                    }
	                    try {
	                        for (var facts_4 = __values(facts), facts_4_1 = facts_4.next(); !facts_4_1.done; facts_4_1 = facts_4.next()) {
	                            var fact = facts_4_1.value;
	                            if (fact._rfonly && _this.utils.vitalTypes.includes(fact.type)) {
	                                try {
	                                    for (var rfFacts_2 = __values(rfFacts), rfFacts_2_1 = rfFacts_2.next(); !rfFacts_2_1.done; rfFacts_2_1 = rfFacts_2.next()) {
	                                        var rfFact = rfFacts_2_1.value;
	                                        if (rfFact.type === fact.type) {
	                                            fact._rfonly = false;
	                                            fact._rfdiffer = true;
	                                            break;
	                                        }
	                                    }
	                                }
	                                catch (e_22_1) { e_22 = { error: e_22_1 }; }
	                                finally {
	                                    try {
	                                        if (rfFacts_2_1 && !rfFacts_2_1.done && (_p = rfFacts_2.return)) _p.call(rfFacts_2);
	                                    }
	                                    finally { if (e_22) throw e_22.error; }
	                                }
	                            }
	                        }
	                    }
	                    catch (e_23_1) { e_23 = { error: e_23_1 }; }
	                    finally {
	                        try {
	                            if (facts_4_1 && !facts_4_1.done && (_q = facts_4.return)) _q.call(facts_4);
	                        }
	                        finally { if (e_23) throw e_23.error; }
	                    }
	                    try {
	                        // match evidences
	                        for (var rfEvidences_1 = __values(rfEvidences), rfEvidences_1_1 = rfEvidences_1.next(); !rfEvidences_1_1.done; rfEvidences_1_1 = rfEvidences_1.next()) {
	                            var rfEvidence = rfEvidences_1_1.value;
	                            var found = false;
	                            try {
	                                for (var _r = __values(_this.evidenceMap.values()), _s = _r.next(); !_s.done; _s = _r.next()) {
	                                    var evidence = _s.value;
	                                    if (evidence._rfonly && evidence.externalIds.has(FS) && evidence.externalIds.get(FS).id === rfEvidence.externalIds.get(FS).id) {
	                                        evidence._rfonly = false;
	                                        evidence._rfdiffer = !_this.utils.evidenceSemiEquals(evidence, rfEvidence);
	                                        found = true;
	                                        break;
	                                    }
	                                }
	                            }
	                            catch (e_24_1) { e_24 = { error: e_24_1 }; }
	                            finally {
	                                try {
	                                    if (_s && !_s.done && (_t = _r.return)) _t.call(_r);
	                                }
	                                finally { if (e_24) throw e_24.error; }
	                            }
	                            if (!found) {
	                                try {
	                                    for (var _u = __values(_this.evidenceMap.values()), _v = _u.next(); !_v.done; _v = _u.next()) {
	                                        var evidence = _v.value;
	                                        if (evidence._rfonly && _this.utils.evidenceSemiEquals(evidence, rfEvidence)) {
	                                            evidence._rfonly = false;
	                                            found = true;
	                                            break;
	                                        }
	                                    }
	                                }
	                                catch (e_25_1) { e_25 = { error: e_25_1 }; }
	                                finally {
	                                    try {
	                                        if (_v && !_v.done && (_w = _u.return)) _w.call(_u);
	                                    }
	                                    finally { if (e_25) throw e_25.error; }
	                                }
	                            }
	                            if (!found) {
	                                rfEvidence.id = -_this.utils.randomId();
	                                _this.evidenceMap.set(rfEvidence.id, rfEvidence);
	                                var fact = _this.evidenceToFact(rfEvidence);
	                                fact._key = -_this.utils.randomKey();
	                                fact = _this.persons.augmentFact(fact, _this.person, new Map(), _this.evidenceMap);
	                                _this.otherSourcesMap.set(fact._key, fact);
	                            }
	                        }
	                    }
	                    catch (e_26_1) { e_26 = { error: e_26_1 }; }
	                    finally {
	                        try {
	                            if (rfEvidences_1_1 && !rfEvidences_1_1.done && (_x = rfEvidences_1.return)) _x.call(rfEvidences_1);
	                        }
	                        finally { if (e_26) throw e_26.error; }
	                    }
	                    try {
	                        // propagate missing evidences up to names and facts
	                        for (var namesFacts_1 = __values(namesFacts), namesFacts_1_1 = namesFacts_1.next(); !namesFacts_1_1.done; namesFacts_1_1 = namesFacts_1.next()) {
	                            var nf = namesFacts_1_1.value;
	                            try {
	                                for (var _y = __values(nf.evidencePersonas.keys()), _z = _y.next(); !_z.done; _z = _y.next()) {
	                                    var eid = _z.value;
	                                    if (_this.evidenceMap.has(eid) && _this.evidenceMap.get(eid)._rfonly) {
	                                        if (!nf._rfonly) {
	                                            nf._fsexists = true;
	                                        }
	                                        nf._rfonly = true;
	                                        break;
	                                    }
	                                }
	                            }
	                            catch (e_27_1) { e_27 = { error: e_27_1 }; }
	                            finally {
	                                try {
	                                    if (_z && !_z.done && (_0 = _y.return)) _0.call(_y);
	                                }
	                                finally { if (e_27) throw e_27.error; }
	                            }
	                        }
	                    }
	                    catch (e_28_1) { e_28 = { error: e_28_1 }; }
	                    finally {
	                        try {
	                            if (namesFacts_1_1 && !namesFacts_1_1.done && (_1 = namesFacts_1.return)) _1.call(namesFacts_1);
	                        }
	                        finally { if (e_28) throw e_28.error; }
	                    }
	                    var e_13, _a, e_14, _b, e_15, _e, e_18, _k, e_16, _h, e_17, _j, e_21, _o, e_19, _l, e_20, _m, e_23, _q, e_22, _p, e_26, _x, e_24, _t, e_25, _w, e_28, _1, e_27, _0;
	                }, function (err) {
	                    _this.messageBus.post({ msg: err, warn: true });
	                });
	                var _c;
	            }, function (err) {
	                _this.messageBus.post({ msg: err, warn: true });
	            });
	        });
	    };
	    //
	    // general functions
	    //
	    PersonController.prototype.evidenceToFact = function (e) {
	        return {
	            type: 'SOUR',
	            principal: true,
	            principalId1: 0,
	            principalId2: 0,
	            value: '',
	            date: e.fact.date,
	            dateSort: e.fact.dateSort,
	            place: e.fact.place,
	            placeDetails: e.fact.placeDetails,
	            placeStandard: e.fact.placeStandard,
	            latitude: e.fact.latitude,
	            longitude: e.fact.longitude,
	            evidencePersonas: new Map([[e.id, 1]]),
	            externalIds: new Map()
	        };
	    };
	    return PersonController;
	}());
	exports.default = PersonController;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var register_controller_1 = __webpack_require__(35);
	var RegisterController = /** @class */ (function () {
	    // public notifyMe;
	    // public acceptTerms;
	    // public drip;
	    // public weeklyEmail;
	    // public given: string;
	    // public surname: string;
	    // public userName: string;
	    // public email: string;
	    // public password: string;
	    // public password2: string;
	    RegisterController.$inject = ["$log", "$scope", "$state", "$transition$", "authentication", "messageBus", "segment", "server", "currentTree", "utils"];
	    function RegisterController($log, $scope, $state, $transition$, authentication, messageBus, segment, server, currentTree, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.authentication = authentication;
	        this.messageBus = messageBus;
	        this.segment = segment;
	        this.server = server;
	        this.currentTree = currentTree;
	        this.utils = utils;
	        var ref = $transition$.params().ref;
	        var code = $transition$.params().code;
	        this._registerController = new register_controller_1.RegisterController($log, authentication, messageBus, segment, server, utils, ref, code);
	        $scope.$on('$destroy', function () {
	            _this._registerController.unsubscribe();
	        });
	    }
	    RegisterController.prototype.gedcomTip = function (ev) {
	        this.utils.alert('What is a GEDCOM?', 'A GEDCOM is a way to migrate your family tree from one platform to another. ' +
	            'Nearly every desktop and online family tree program has a way to export your tree as a GEDCOM. ' +
	            'Once you\'ve exported a GEDCOM file, you can import it here.', ev);
	    };
	    RegisterController.prototype.signIn = function (ev) {
	        this.utils.dialog(ev, 'SignInController', 'app/components/signIn/signIn.html', false, { code: this.code });
	    };
	    RegisterController.prototype.register = function (ev) {
	        var _this = this;
	        this.submitted = true;
	        var goToTree = function (treeId) {
	            _this.$state.go('tree', { treeId: treeId });
	        };
	        var goToCreate = function (action) {
	            var tree = {
	                name: 'My Tree',
	                privacy: 'PUBLIC',
	                preferences: {
	                    LEADS_FOR_ALL: 'TRUE',
	                }
	            };
	            switch (action) {
	                case 'GEDCOM':
	                    _this._create(tree, 'tree.import-gedcom');
	                    break;
	                case 'FS':
	                    _this._create(tree, 'tree.import-fs');
	                    break;
	                case 'NO':
	                    _this._create(tree, 'tree.import-scratch');
	                    break;
	            }
	        };
	        var cancelSaving = function () {
	            _this._registerController.saving = false;
	        };
	        var doSignIn = function () {
	            _this.utils.dialog(null, 'SignInController', 'app/components/signIn/signIn.html').then(function () {
	                _this._registerController._register(goToTree, goToCreate, cancelSaving);
	            }, function () {
	                _this._registerController.saving = false;
	            });
	        };
	        this._registerController.register(ev, doSignIn, goToTree, goToCreate, cancelSaving);
	    };
	    RegisterController.prototype._create = function (tree, state) {
	        var _this = this;
	        this.currentTree.create(tree).subscribe(function (tree) {
	            _this._registerController.saving = false;
	            _this.$state.go(state, { treeId: tree.id });
	        }, function () {
	            _this._registerController.saving = false;
	        });
	    };
	    return RegisterController;
	}());
	exports.default = RegisterController;
	// class RegisterController {
	//   constructor ($log, $scope, $state, $transition$, authentication, messageBus, segment, server, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.$state = $state;
	//     this.authentication = authentication;
	//     this.messageBus = messageBus;
	//     this.segment = segment;
	//     this.server = server;
	//     this.utils = utils;
	//     this.ref = $transition$.params().ref;
	//     this.code = $transition$.params().code;
	//     this.notifyMe = true;
	//     this.acceptTerms = false;
	//     this.drip = true;
	//     this.weeklyEmail = true;
	//     if (!!this.code) {
	//       server.get('/invitations/'+this.code).subscribe(response => {
	//         this.given = response.given;
	//         this.surname = response.surname;
	//         this.email = response.email;
	//       });
	//     }
	//     let mbSub = messageBus.stream().subscribe(msg => {
	//       if (!!msg) {
	//         this.msg = msg;
	//         messageBus.post(null);
	//       }
	//     });
	//     $scope.$on('$destroy', () => {
	//       mbSub.unsubscribe();
	//     });
	//   }
	//   signIn(ev) {
	//     this.utils.dialog(ev, 'SignInController', 'app/components/signIn/signIn.html', false, {code: this.code});
	//   }
	//   register(ev) {
	//     this.msg = '';
	//     if (!this.acceptTerms) {
	//       this.utils.alert('You must accept the terms of use and the privacy policy');
	//       return;
	//     }
	//     if (this.password !== this.password2) {
	//       this.utils.alert('The two passwords must match');
	//       return;
	//     }
	//     this.saving = true;
	//     let user = {
	//       given: this.given,
	//       surname: this.surname,
	//       email: this.email,
	//       name: this.userName,
	//       password: this.password,
	//       preferences: {
	//         RC_DRIP: this.drip ? 'TRUE' : 'FALSE',
	//         RC_WEEKLY_EMAIL: this.weeklyEmail ? 'TRUE' : 'FALSE'
	//       }
	//     };
	//     this.authentication.register(user, false).subscribe(() => {
	//       this.utils.alert('Confirmation email sent',
	//         'Please click on the link in the email to confirm your email address.',
	//         ev).then(() => {
	//           this._register();
	//         }, () => {
	//           this._register();
	//         });
	//     }, response => {
	//       if (response.data === 'USER_EMAIL_EXISTS') {
	//         this.utils.confirm('Your email already exists', 'Would you like to log in instead?').then(() => {
	//           this.utils.dialog(null, 'SignInController', 'app/components/signIn/signIn.html').then(() => {
	//             this._register();
	//           }, () => {
	//             this.saving = false;
	//           });
	//         }, () => {
	//           this.saving = false;
	//         });
	//       }
	//       else {
	//         this.saving = false;
	//       }
	//     });
	//   }
	//   _register() {
	//     if (!!this.code) {
	//       this.server.put('/invitations/'+this.code).subscribe(response => {
	//         this.saving = false;
	//         this.segment.track('invitations.accept');
	//         // goto tree
	//         this.$state.go('tree', {treeId: response.treeId});
	//       }, () => {
	//         this.saving = false;
	//         this.messageBus.post({msg: 'ACCEPT_INVITATION_ERROR', op: "PUT", ctx: "invitations"});
	//       });
	//     }
	//     else if (this.ref === 'nolo') {
	//       this.utils.alert('Congratulations from Nolo!',
	//         'Contact support@rootsfinder.com to receive your free 1-year subscrtiption to our Pro Plan!',
	//         null).then(() => {
	//           this.saving = false;
	//           this.$state.go('create');
	//         }, () => {
	//           this.saving = false;
	//           this.$state.go('create');
	//         });
	//     }
	//     else {
	//       this.saving = false;
	//       this.$state.go('create');
	//     }
	//   }
	// }
	// export default RegisterController;


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Subscription } from '../node_modules/rxjs';
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var RegisterController = /** @class */ (function () {
	    function RegisterController(log, authentication, messageBus, segment, server, utils, ref, code) {
	        var _this = this;
	        this.log = log;
	        this.authentication = authentication;
	        this.messageBus = messageBus;
	        this.segment = segment;
	        this.server = server;
	        this.utils = utils;
	        this.ref = ref;
	        this.code = code;
	        this.notifyMe = true;
	        this.action = 'NO';
	        this.acceptTerms = false;
	        this.weeklyEmail = true;
	        if (!!this.code) {
	            server.get('/invitations/' + this.code).subscribe(function (response) {
	                _this.given = response.given;
	                _this.surname = response.surname;
	                _this.email = response.email;
	            });
	        }
	        this.mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	    }
	    RegisterController.prototype.register = function (ev, doSignIn, goToTree, goToCreate, cancelSaving) {
	        var _this = this;
	        this.msg = '';
	        if (!this.email || !this.userName || !this.password || !this.action) {
	            return;
	        }
	        if (this.password !== this.password2) {
	            this.utils.alert('The two passwords must match');
	            return true;
	        }
	        if (!this.acceptTerms) {
	            this.utils.alert('You must accept the terms of use and the privacy policy');
	            return true;
	        }
	        this.saving = true;
	        var user = {
	            given: this.given,
	            surname: this.surname,
	            email: this.email,
	            name: this.userName,
	            password: this.password,
	            preferences: {
	                RC_DRIP: 'FALSE',
	                RC_WEEKLY_EMAIL: this.weeklyEmail ? 'TRUE' : 'FALSE'
	            }
	        };
	        this.authentication.register(user, true).subscribe(function () {
	            _this._register(goToTree, goToCreate, cancelSaving);
	        }, function (response) {
	            if (response.data === 'USER_EMAIL_EXISTS') {
	                _this.utils.confirm('Your email already exists', 'Would you like to log in instead?').then(function () {
	                    doSignIn();
	                    // this.utils.dialog(null, 'SignInController', 'app/components/signIn/signIn.html').then(() => {
	                    //   this._register();
	                    // }, () => {
	                    //   this.saving = false;
	                    // });
	                }, function () {
	                    //this.saving = false;
	                    cancelSaving();
	                });
	            }
	            else {
	                //this.saving = false;
	                cancelSaving();
	            }
	        });
	    };
	    RegisterController.prototype._register = function (goToTree, goToCreate, cancelSaving) {
	        var _this = this;
	        if (!!this.code) {
	            this.server.put('/invitations/' + this.code).subscribe(function (response) {
	                _this.saving = false;
	                _this.segment.track('invitations.accept');
	                // goto tree
	                //this.state.go('tree', {treeId: response.treeId});
	                goToTree(response.treeId);
	            }, function () {
	                //this.saving = false;
	                cancelSaving();
	                _this.messageBus.post({ msg: 'ACCEPT_INVITATION_ERROR', op: "PUT", ctx: "invitations" });
	            });
	        }
	        else if (this.ref === 'nolo') {
	            this.utils.alert('Congratulations from Nolo!', 'Contact support@rootsfinder.com to receive your free 1-year subscrtiption to our Pro Plan!', null).then(function () {
	                //this.saving = false;
	                cancelSaving();
	                //this.state.go('create');
	                goToCreate();
	            }, function () {
	                //this.saving = false;
	                cancelSaving();
	                //this.state.go('create');
	                goToCreate(_this.action);
	            });
	        }
	        else {
	            //this.saving = false;
	            cancelSaving();
	            //this.state.go('create');
	            goToCreate(this.action);
	        }
	    };
	    RegisterController.prototype.unsubscribe = function () {
	        this.mbSub.unsubscribe();
	    };
	    RegisterController.prototype.setFormValues = function (given, surname, email, userName, password, password2, acceptTerms, drip, weeklyEmail) {
	        this.given = given;
	        this.surname = surname;
	        this.email = email;
	        this.userName = userName;
	        this.password = password;
	        this.password2 = password2;
	        this.acceptTerms = acceptTerms;
	        this.weeklyEmail = weeklyEmail;
	    };
	    return RegisterController;
	}());
	exports.RegisterController = RegisterController;
	exports.default = RegisterController;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var ReportsController = /** @class */ (function () {
	    ReportsController.$inject = ["jsPDF", "$log", "$scope", "$state", "$window", "rx", "places", "segment", "utils", "rightsFull", "treeUsers", "pedigreeReport", "ahnentafelReport", "familyGroupReport", "placeListReport", "endOfLineReport", "fanReport", "endNotes", "indexOfNames", "indexOfPlaces", "evidenceAnalysisReport", "server", "persons", "families", "evidences", "sources", "medias", "notes", "stories", "messageBus"];
	    function ReportsController(jsPDF, $log, $scope, $state, $window, rx, places, segment, utils, rightsFull, treeUsers, pedigreeReport, ahnentafelReport, familyGroupReport, placeListReport, endOfLineReport, fanReport, endNotes, indexOfNames, indexOfPlaces, evidenceAnalysisReport, server, // docxSimpleRegister, docxAncestors, server,
	        persons, families, evidences, sources, medias, notes, stories, messageBus) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$window = $window;
	        this.persons = persons;
	        this.places = places;
	        this.segment = segment;
	        this.utils = utils;
	        this.pedigreeReport = pedigreeReport;
	        this.ahnentafelReport = ahnentafelReport;
	        this.familyGroupReport = familyGroupReport;
	        this.placeListReport = placeListReport;
	        this.endOfLineReport = endOfLineReport;
	        this.fanReport = fanReport;
	        this.evidenceAnalysisReport = evidenceAnalysisReport;
	        // this.docxSimpleRegister = docxSimpleRegister;
	        // this.docxAncestors = docxAncestors;
	        this.server = server;
	        this.families = families;
	        this.evidences = evidences;
	        this.endNotes = endNotes;
	        this.indexOfNames = indexOfNames;
	        this.indexOfPlaces = indexOfPlaces;
	        this.jsPDF = jsPDF;
	        this.sources = sources;
	        this.messageBus = messageBus;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.ready = false;
	        this.utils.readyChange(persons, families, evidences, sources, medias, notes, stories).take(1)
	            .subscribe(function (_a) {
	            var _b = __read(_a, 7), personMap = _b[0], familyMap = _b[1], evidenceMap = _b[2], sourceMap = _b[3], mediaMap = _b[4], noteMap = _b[5], storyMap = _b[6];
	            _this.personMap = personMap;
	            _this.familyMap = familyMap;
	            _this.evidenceMap = evidenceMap;
	            _this.sourceMap = sourceMap;
	            _this.mediaMap = mediaMap;
	            _this.noteMap = noteMap;
	            _this.storyMap = storyMap;
	            _this.ready = true;
	        });
	        this.rootId = 0;
	        this.root = null;
	        this.rootFamilyId = 0;
	        this.place = null;
	        this.numGenerations = 4;
	        this.type = 0;
	        this.types = [
	            {
	                value: '1',
	                label: 'ahnentafel',
	                name: 'Ahnentafel',
	                thumbnail: 'ahnantafel.jpg'
	            },
	            // {
	            //   value: '8',
	            //   label: 'ancestors',
	            //   name: 'Ancestors (including media)',
	            //   thumbnail: 'ancestors.jpg'
	            // },
	            // {
	            //   value: '7',
	            //   label: 'descendants',
	            //   name: 'Descendants (register format)',
	            //   thumbnail: 'register.jpg'
	            // },
	            {
	                value: '3',
	                label: 'family',
	                name: 'Family Group',
	                thumbnail: 'family-group-sheet.jpg'
	            },
	            {
	                value: '6',
	                label: 'fan',
	                name: 'Fan chart',
	                thumbnail: 'fan-chart-600px.jpg'
	            },
	            {
	                value: '2',
	                label: 'pedigree',
	                name: 'Pedigree',
	                thumbnail: 'pedigree.jpg'
	            },
	            {
	                value: '5',
	                label: 'noparents',
	                name: 'People Without Parents',
	                thumbnail: 'people-without-parents.jpg'
	            },
	            {
	                value: '4',
	                label: 'places',
	                name: 'Place List',
	                thumbnail: 'place-list.jpg'
	            },
	            {
	                value: '9',
	                label: 'evidence',
	                name: 'Evidence Analysis',
	                thumbnail: 'evidence.jpg'
	            }
	        ];
	        treeUsers.stream().flatMap(function (tu) {
	            _this.rootId = _this.rootId || _this.nvl(parseInt(tu.preferences.ROOT, 10));
	            if (_this.rootId !== 0) {
	                return persons.streamId(_this.rootId);
	            }
	            return rx.Observable.of(null);
	        }).take(1).subscribe(function (person) {
	            _this.root = person;
	        });
	        var sub = utils.watch($scope, 'reports.root').subscribe(function (_a) {
	            var newValue = _a.newValue;
	            _this.spouseArr = [];
	            if (!!newValue) {
	                //this.$log.debug("newValue", newValue);
	                families.streamSpouses(newValue.id).take(1).subscribe(function (fm) {
	                    if (fm.size > 0) {
	                        fm.forEach(function (f) {
	                            var spouseId = (f.husbandId === newValue.id ? f.wifeId : f.husbandId);
	                            if (spouseId === 0) {
	                                _this.spouseArr.push({ familyId: f.id, family: f, spouseName: 'Unknown Spouse' });
	                                _this.rootFamilyId = f.id;
	                            }
	                            else {
	                                persons.streamId(spouseId).take(1).subscribe(function (person) {
	                                    _this.spouseArr.push({ familyId: f.id, family: f, spouseName: person._fullName });
	                                    _this.rootFamilyId = f.id;
	                                });
	                            }
	                        });
	                    }
	                    else {
	                        var f = {
	                            id: 0,
	                            husbandId: newValue.gender !== 'FEMALE' ? newValue.id : 0,
	                            wifeId: newValue.gender === 'FEMALE' ? newValue.id : 0,
	                            childRels: new Map()
	                        };
	                        _this.spouseArr.push({
	                            familyId: 0,
	                            family: f,
	                            spouseName: 'Unknown Spouse'
	                        });
	                        _this.rootFamilyId = 0;
	                    }
	                });
	            }
	        });
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            if (level < rightsFull.LEVEL_READ) {
	                $state.go('tree');
	            }
	        });
	        $scope.$on('$destroy', function () {
	            sub.unsubscribe();
	        });
	    }
	    ReportsController.prototype.requiresPerson = function (type) {
	        return ['1', '2', '3', '6', '7', '8', '9'].includes(type);
	    };
	    ReportsController.prototype.requiresGenerations = function (type) {
	        return ['1', '2', '7', '8'].includes(type);
	    };
	    ReportsController.prototype.getReportThumbnail = function () {
	        var _this = this;
	        var type = this.types.find(function (item) { return item.value === _this.type; });
	        return type ? type.thumbnail : null;
	    };
	    ReportsController.prototype.queryPlace = function (text) {
	        return !!text ? this.places.autocomplete(text) : [];
	    };
	    ReportsController.prototype.queryPerson = function (query) {
	        return !query ? [] : this.persons.nameAutocomplete(query);
	    };
	    ReportsController.prototype.nvl = function (val) {
	        if (!(!val)) {
	            return val;
	        }
	        else {
	            return 0;
	        }
	    };
	    ReportsController.prototype.go = function (ev) {
	        var _this = this;
	        //this.utils.alert('Reports', 'root ' + this.root.get("id") + ' numGenerations ' + this.numGenerations + ' type ' + this.type, ev);
	        //this.$log.debug("place", this.rootSpouse);
	        //this.$log.debug("Spouse!!!!!!",this.personMap.get(parseInt(this.rootSpouse,10)));
	        this.server.incRequests();
	        this.altURL = '';
	        this.saving = true;
	        var sub = null;
	        switch (this.type) {
	            case '1':
	                sub = this.ahnentafelReport.create(this.jsPDF, this.$log, this.root, this.families, this.persons, this.evidences, this.utils, this.indexOfNames, this.indexOfPlaces, this.numGenerations, this.personMap, this.familyMap, this.evidenceMap, this.sourceMap);
	                break;
	            case '2':
	                sub = this.pedigreeReport.create(this.jsPDF, this.root, this.families, this.persons, this.utils, this.endNotes, this.indexOfNames, this.indexOfPlaces, this.numGenerations, this.personMap, this.familyMap, this.evidenceMap, this.sourceMap);
	                break;
	            case '3':
	                var rootFamily = this.spouseArr.find(function (s) { return s.familyId === parseInt(_this.rootFamilyId, 10); }).family;
	                sub = this.familyGroupReport.create(this.jsPDF, this.$log, rootFamily, this.families, this.persons, this.evidences, this.utils, this.endNotes, this.indexOfNames, this.indexOfPlaces, this.personMap, this.familyMap, this.evidenceMap, this.sourceMap);
	                break;
	            case '4':
	                sub = this.placeListReport.create(this.jsPDF, this.$log, this.evidences, this.utils, this.PlaceText, this.personMap, this.familyMap, this.evidenceMap);
	                break;
	            case '5':
	                sub = this.endOfLineReport.create(this.jsPDF, this.$log, this.families, this.persons, this.evidences, this.utils, this.endNotes, this.indexOfPlaces, this.personMap, this.familyMap, this.evidenceMap, this.sourceMap);
	                break;
	            case '6':
	                sub = this.fanReport.create(this.root, this.families, this.persons, this.evidences, this.utils, this.personMap, this.familyMap);
	                break;
	            // case '7':
	            //   sub = this.docxSimpleRegister.create(this.root, this.numGenerations,
	            //     this.families, this.persons, this.evidences, this.personMap, this.familyMap, this.evidenceMap, this.sourceMap);
	            //   break;
	            // case '8':
	            //   sub = this.docxAncestors.create(this.root, this.numGenerations,
	            //     this.families, this.persons, this.evidences, this.personMap, this.familyMap, this.evidenceMap, this.sourceMap, this.mediaMap, this.noteMap, this.storyMap);
	            //   break;
	            case '9':
	                sub = this.evidenceAnalysisReport.create(this.root);
	                break;
	        }
	        this.segment.track('reports.' + this.types.find(function (t) { return t.value === _this.type; }).label);
	        if (!!sub) {
	            sub.subscribe(function (data) {
	                if (!!data) {
	                    _this.utils.saveReport(data, ev, _this.type === '8').subscribe(function (_a) {
	                        var name = _a.name, blob = _a.blob;
	                        if (_this.type !== '6') {
	                            _this.altURL = URL.createObjectURL(blob);
	                            _this.altName = name;
	                        }
	                        _this.server.decRequests();
	                        _this.saving = false;
	                    }, function (err) {
	                        _this.server.decRequests();
	                        _this.saving = false;
	                        _this.messageBus.post({ msg: 'Error saving report: ' + err.data || err, warn: true });
	                    });
	                }
	                else {
	                    _this.server.decRequests();
	                    _this.saving = false;
	                }
	            }, function (err) {
	                _this.messageBus.post({ msg: 'Error generating report: ' + err.data || err, warn: true });
	                _this.server.decRequests();
	                _this.saving = false;
	            });
	        }
	        else {
	            this.server.decRequests();
	            this.saving = false;
	        }
	    };
	    return ReportsController;
	}());
	exports.default = ReportsController;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var SetPasswordController = /** @class */ (function () {
	    SetPasswordController.$inject = ["$log", "$scope", "$state", "$transition$", "authentication", "messageBus", "utils"];
	    function SetPasswordController($log, $scope, $state, $transition$, authentication, messageBus, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.authentication = authentication;
	        this.messageBus = messageBus;
	        this.utils = utils;
	        this.key = $transition$.params().key;
	        this.email = $transition$.params().email;
	        this.ready = false;
	        if (!this.key || !this.email || this.key.length !== 32) {
	            this.utils.alert('This URL doesn\'t look right', 'Please copy and paste the complete link from the email into your browser.');
	        }
	        else {
	            this.ready = true;
	        }
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg + ' Please copy and paste the complete link from the email into your browser';
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    SetPasswordController.prototype.save = function (ev) {
	        var _this = this;
	        this.saving = true;
	        // call auth setPassword w email, password, and key
	        this.authentication.setPassword(this.email, this.password, this.key).subscribe(function () {
	            _this.saving = false;
	            // if successful, alert and redirect to home
	            _this.utils.alert('Password Set', 'You will now be taken to the homepage. Click the "Log In" button in the upper right corner to log in.', ev).then(function () {
	                _this.$state.go('home');
	            }, function () {
	                _this.$state.go('home');
	            });
	        }, function () {
	            _this.saving = false;
	            _this.$log.debug('login failure');
	        });
	    };
	    return SetPasswordController;
	}());
	exports.default = SetPasswordController;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var SourcesController = /** @class */ (function () {
	    SourcesController.$inject = ["$log", "$scope", "$transition$", "evidences", "sources", "users", "utils"];
	    function SourcesController($log, $scope, $transition$, evidences, sources, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.sourceId = utils.decodeId($transition$.params().sourceId);
	        this.headers = [
	            { label: 'Source', width: 40, property: 'abbr', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, show: true },
	            { label: 'Author', width: 20, property: 'creator', type: 'string', filterable: true, sortable: true, show: true },
	            { label: 'Title', width: 40, property: 'title', type: 'string', filterable: true, sortable: true, show: true }
	        ];
	        this.items = new Map();
	        var pw = utils.pleaseWait();
	        var subscription = utils.readyChange(sources, users).subscribe(function (_a) {
	            var _b = __read(_a, 1), sourceMap = _b[0];
	            _this.$log.debug('sources.change');
	            _this.items = new Map();
	            Array.from(sourceMap.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], source = _b[1];
	                sources.augmentSource(source, users).subscribe(function (source) {
	                    _this.items.set(id, source);
	                });
	            });
	            utils.pleaseWaitCancel(pw);
	        });
	        $scope.$on('$destroy', function () {
	            subscription.unsubscribe();
	        });
	        $scope.$on('add', function (ev, params) {
	            utils.dialog(params.ev, 'EditSourceController', 'app/components/editSource/editSource.html', false, {});
	        });
	        $scope.$on('edit', function (ev, params) {
	            utils.dialog(params.ev, 'EditSourceController', 'app/components/editSource/editSource.html', false, {
	                source: params.item
	            });
	        });
	        $scope.$on('delete', function (ev, params) {
	            evidences.streamForSource(params.id).take(1).subscribe(function (em) {
	                if (em.size > 0) {
	                    utils.dialog(params.ev, 'DeleteSourceController', 'app/components/deleteSource/deleteSource.html', true, {
	                        evidenceMap: em
	                    });
	                }
	                else {
	                    utils.confirm('Delete Source', 'Are you sure?', params.ev).then(function () {
	                        sources.del(params.id);
	                    }, function () {
	                        // ignore
	                    });
	                }
	            });
	        });
	    }
	    return SourcesController;
	}());
	exports.default = SourcesController;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var StaticController = /** @class */ (function () {
	    function StaticController() {
	        'ngInject';
	    }
	    return StaticController;
	}());
	exports.default = StaticController;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var StoriesController = /** @class */ (function () {
	    StoriesController.$inject = ["$log", "$scope", "$transition$", "stories", "persons", "users", "utils"];
	    function StoriesController($log, $scope, $transition$, stories, persons, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.storyId = utils.decodeId($transition$.params().storyId);
	        this.headers = [
	            { label: 'Title', width: 60, property: 'title', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, show: true },
	            { label: 'People', width: 40, property: '_people', type: 'people', filterable: true }
	        ];
	        this.items = new Map();
	        var pw = utils.pleaseWait();
	        var subscription = utils.readyChange(stories, persons, users).subscribe(function (_a) {
	            var _b = __read(_a, 1), storyMap = _b[0];
	            _this.$log.debug('stories.change');
	            _this.items = new Map();
	            Array.from(storyMap.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], story = _b[1];
	                stories.augmentStory(story, persons, users).subscribe(function (story) {
	                    _this.items.set(id, story);
	                });
	            });
	            utils.pleaseWaitCancel(pw);
	        });
	        $scope.$on('$destroy', function () {
	            subscription.unsubscribe();
	        });
	        $scope.$on('add', function (ev, params) {
	            utils.dialog(params.ev, 'EditStoryController', 'app/components/editStory/editStory.html', false, {});
	        });
	        $scope.$on('edit', function (ev, params) {
	            utils.dialog(params.ev, 'EditStoryController', 'app/components/editStory/editStory.html', false, {
	                story: params.item
	            });
	        });
	        $scope.$on('delete', function (ev, params) {
	            utils.confirm('Delete Story', 'Are you sure?', params.ev).then(function () {
	                stories.del(params.id);
	            }, function () {
	                // ignore
	            });
	        });
	    }
	    return StoriesController;
	}());
	exports.default = StoriesController;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var ResearchLogsController = /** @class */ (function () {
	    ResearchLogsController.$inject = ["$log", "$scope", "$state", "researchLogs", "persons", "users", "utils"];
	    function ResearchLogsController($log, $scope, $state, researchLogs, persons, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.headers = [
	            { label: 'Title', width: 55, property: 'title', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, link: { prefix: 'tree.research-log', field: 'id' } },
	            { label: 'People', width: 35, property: '_people', type: 'people', filterable: true },
	            { label: 'Private', width: 10, property: '_private', type: 'string' }
	        ];
	        this.items = new Map();
	        var subscription = utils.readyChange(researchLogs, persons, users).subscribe(function (_a) {
	            var _b = __read(_a, 1), logMap = _b[0];
	            _this.$log.debug('researchLogs.change');
	            _this.items = new Map();
	            Array.from(logMap.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], log = _b[1];
	                researchLogs.augmentResearchLog(log, persons, users).subscribe(function (log) {
	                    log._private = log.private ? '\u2611' : '\u2610';
	                    _this.items.set(id, log);
	                });
	            });
	        });
	        $scope.$on('$destroy', function () {
	            subscription.unsubscribe();
	        });
	        $scope.$on('add', function (ev, params) {
	            utils.dialog(params.ev, 'EditResearchLogController', 'app/components/editResearchLog/editResearchLog.html', false, {}).then(function (rl) {
	                $state.go('tree.research-log', { id: utils.encodeId(rl.id) });
	            }, {});
	        });
	    }
	    return ResearchLogsController;
	}());
	exports.default = ResearchLogsController;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	var ResearchLogController = /** @class */ (function () {
	    ResearchLogController.$inject = ["$log", "$state", "$scope", "$transition$", "$timeout", "$rootScope", "$compile", "rx", "researchLogs", "leads", "evidences", "medias", "notes", "stories", "persons", "places", "users", "sources", "evidenceUtils", "utils"];
	    function ResearchLogController($log, $state, $scope, $transition$, $timeout, $rootScope, $compile, rx, researchLogs, leads, evidences, medias, notes, stories, persons, places, users, sources, evidenceUtils, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.rx = rx;
	        this.$scope = $scope;
	        this.$timeout = $timeout;
	        this.$compile = $compile;
	        this.evidencesService = evidences;
	        this.leadsService = leads;
	        this.mediasService = medias;
	        this.notesService = notes;
	        this.storiesService = stories;
	        this.usersService = users;
	        this.researchLogService = researchLogs;
	        this.evidenceUtils = evidenceUtils;
	        this.utils = utils;
	        this.sourcesService = sources;
	        this.personsService = persons;
	        this.placesService = places;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.id = utils.decodeId($transition$.params().id);
	        this.expanded = new Map();
	        this.items = new Map();
	        this.refItems = new Map();
	        this.archivedLeads = new Map();
	        this.draggingColumn = -1;
	        this.isDeleted = false;
	        this.waitToUpdate = true;
	        this.selectedMarkers = new Map();
	        var formats = [{
	                id: 'columns',
	                icon: 'view_columns',
	                label: 'Research Log Columns'
	            }, {
	                id: 'map',
	                icon: 'place',
	                label: 'Research Log Map'
	            }];
	        this.format = formats.find(function (v) { return v.id === ($transition$.params().format || 'columns'); });
	        this.refMapPoints = [];
	        this.mapPoints = [];
	        var rlSub = utils.readyChange(researchLogs, persons, users).subscribe(function () {
	            if (_this.isDeleted) {
	                return; //causes an error saying Cannot read property 'personIds' of null otherwise
	            }
	            researchLogs.streamId(_this.id).take(1).flatMap(function (log) { return researchLogs.augmentResearchLog(log, persons, users); }).subscribe(function (log) {
	                if (_this.isDeleted) {
	                    return;
	                }
	                // set the researchLog
	                _this.researchLog = log;
	                $timeout(function () {
	                    $rootScope.title = log.title;
	                }, 0);
	                //First check if they have ever stored anything in the researchLog
	                var isNew = (_this.researchLog.columns.size === 0);
	                if (isNew) {
	                    _this.researchLog.columns = new Map();
	                    _this.researchLog.columns.set(1, {
	                        name: "Inbox",
	                        position: 0,
	                        items: new Map()
	                    });
	                    _this.researchLog.columns.set(2, {
	                        name: "Done",
	                        position: 1,
	                        items: new Map()
	                    });
	                }
	                // set the columns
	                _this.waitToUpdate = false;
	                _this.setDisplay();
	            });
	        });
	        var itemsSub = utils.readyChange(persons, users, leads, evidences, medias, notes, stories, sources).subscribe(function () {
	            if (_this.isDeleted) {
	                return;
	            }
	            // fetch items in parallel
	            _this.rx.Observable.forkJoin(leads.streamForResearchLog(_this.id).take(1), notes.streamForResearchLog(_this.id).take(1), stories.streamForResearchLog(_this.id).take(1), evidences.streamForResearchLog(_this.id).take(1), medias.streamForResearchLog(_this.id).take(1)).subscribe(function (_a) {
	                var _b = __read(_a, 5), leadMap = _b[0], noteMap = _b[1], storyMap = _b[2], evidenceMap = _b[3], mediaMap = _b[4];
	                // clear refItems
	                _this.refItems = new Map();
	                var augments = [];
	                // add leads
	                Array.from(leadMap.values()).forEach(function (lead) {
	                    augments.push(leads.augmentLead(lead, persons, users).do(function (lead) {
	                        lead._type = 'LEAD';
	                        _this.refItems.set(lead.id, lead);
	                        // if (lead.state > 0) { //reference the hidden/archived leads so we can move them to the done inbox/hide them in the display
	                        //   this.archivedLeads.set(lead.id, lead);
	                        // }
	                    }));
	                });
	                // add notes
	                Array.from(noteMap.values()).forEach(function (note) {
	                    augments.push(notes.augmentNote(note, persons, users).do(function (note) {
	                        note._type = 'NOTE';
	                        _this.refItems.set(note.id, note);
	                    }));
	                });
	                // add stories
	                Array.from(storyMap.values()).forEach(function (story) {
	                    augments.push(stories.augmentStory(story, persons, users).do(function (story) {
	                        story._type = 'STORY';
	                        _this.refItems.set(story.id, story);
	                    }));
	                });
	                // add evidences
	                Array.from(evidenceMap.values()).forEach(function (evidence) {
	                    augments.push(evidences.augmentEvidence(evidence, sources, persons, users).do(function (evidence) {
	                        evidence._type = 'EVIDENCE';
	                        _this.refItems.set(evidence.id, evidence);
	                    }));
	                });
	                // add media
	                Array.from(mediaMap.values()).forEach(function (media) {
	                    augments.push(medias.augmentMedia(media, persons, evidences, sources, stories, users).do(function (media) {
	                        media._type = 'MEDIA';
	                        _this.refItems.set(media.id, media);
	                    }));
	                });
	                (augments.length === 0 ? _this.rx.Observable.of([]) : (_c = _this.rx.Observable).forkJoin.apply(_c, __spread(augments))).subscribe(function () {
	                    // at this point we're certain that refItems has been updated, so we can set the columns
	                    _this.setDisplay();
	                });
	                var _c;
	            });
	        });
	        $scope.$on('toggleExpand', function (ev, params) {
	            _this.expanded.set(params.id, !_this.expanded.get(params.id));
	        });
	        $scope.$on('edit', function (ev, params) {
	            switch (params.type) {
	                case 'research-log':
	                    _this.editResearchLog(params.ev, params.item);
	                    break;
	                case 'evidence':
	                    _this.editEvidence(params.ev, params.item);
	                    break;
	                case 'lead':
	                    _this.editLead(params.ev, params.item);
	                    break;
	                case 'media':
	                    _this.editMedia(params.ev, params.item);
	                    break;
	                case 'note':
	                    _this.editNote(params.ev, params.item);
	                    break;
	                case 'story':
	                    _this.editStory(params.ev, params.item);
	                    break;
	            }
	        });
	        $scope.$on('archive', function (ev, params) {
	            _this.$log.debug('researchLogController.archive', params);
	            switch (params.type) {
	                case 'lead':
	                    _this.archiveLead(params.ev, params.item);
	                    break;
	            }
	        });
	        $scope.$on('delete', function (ev, params) {
	            _this.$log.debug('researchLogController.delete', params);
	            switch (params.type) {
	                case 'research-log':
	                    _this.deleteResearchLog(params.ev, params.item);
	                    break;
	                case 'evidence':
	                    _this.deleteEvidence(params.ev, params.id);
	                    break;
	                case 'lead':
	                    _this.deleteLead(params.ev, params.item);
	                    break;
	                case 'media':
	                    _this.deleteMedia(params.ev, params.item);
	                    break;
	                case 'note':
	                    _this.deleteNote(params.ev, params.id);
	                    break;
	                case 'story':
	                    _this.deleteStory(params.ev, params.id);
	                    break;
	            }
	        });
	        /*$scope.$on('map-box-zoom', (ev, bounds) => {
	          this.$log.debug(ev, bounds);
	          //console.log(ev,bounds);
	    
	          $timeout(() => {
	            this.mapPoints.forEach((p) => {
	              let latLng = L.latLng(p.latitude, p.longitude);
	              if (bounds.contains(latLng)) {
	                this.selectedMarkers.set(p.id, true);
	              }
	            });
	          }, 0);
	        });
	    
	        $scope.$on('map-click', (ev, params) => {
	          this.$log.debug(ev, params);
	          //console.log(ev, params);
	          $timeout(() => {
	            this.selectedMarkers.clear();
	            this.selectedMarkers.set(params.id, true);
	          }, 0);
	        });
	    
	        $scope.$on('map-ctrl-click', (ev, params) => {
	          this.$log.debug(ev, params);
	          //console.log(ev, params);
	          $timeout(() => {
	            if (this.selectedMarkers.has(params.id)) {
	              this.selectedMarkers.delete(params.id);
	            } else {
	              this.selectedMarkers.set(params.id, true);
	            }
	          }, 0);
	        });*/
	        $scope.$on('$destroy', function () {
	            rlSub.unsubscribe();
	            itemsSub.unsubscribe();
	        });
	        $scope.onFilterCards = function (item) {
	            if ($scope.searchText === '' || $scope.searchText === null || $scope.searchText === undefined) {
	                return true;
	            }
	            var searchText = $scope.searchText.toLowerCase();
	            switch (item.item._type) {
	                case 'EVIDENCE':
	                    return evidences.hasWord(item.item, searchText);
	                case 'LEAD':
	                    return leads.hasWord(item.item, searchText);
	                case 'MEDIA':
	                    return medias.hasWord(item.item, searchText);
	                case 'NOTE':
	                    return notes.hasWord(item.item, searchText);
	                case 'STORY':
	                    return stories.hasWord(item.item, searchText);
	            }
	        };
	        $scope.onMapMarkerClick = (function (id) {
	            if (_this.format.id === 'map') {
	                _this.showItem(null, _this.refItems.get(id));
	            }
	        });
	    }
	    ResearchLogController.prototype.filterMap = function (searchText) {
	        var _this = this;
	        if (this.format.id === 'columns') {
	            return;
	        }
	        else if (searchText === '' || searchText === null || searchText === undefined) {
	            this.mapPoints = this.refMapPoints; //this.utils.clone(this.refMapPoints);
	            return;
	        }
	        else {
	            var text_1 = searchText.toLowerCase();
	            this.mapPoints = this.refMapPoints.filter(function (point) {
	                switch (point.item._type) {
	                    case 'EVIDENCE':
	                        return _this.evidencesService.hasWord(point.item, text_1);
	                    case 'LEAD':
	                        return _this.leadsService.hasWord(point.item, text_1); //shouldn't happen
	                    case 'MEDIA':
	                        return _this.mediasService.hasWord(point.item, text_1);
	                    case 'NOTE':
	                        return _this.notesService.hasWord(point.item, text_1); //shouldn't happen
	                    case 'STORY':
	                        return _this.storiesService.hasWord(point.item, text_1);
	                }
	            });
	        }
	    };
	    ResearchLogController.prototype.switchFormat = function (format) {
	        this.$log.info('switchFormat', format);
	        this.$state.go('tree.research-log', { format: format, id: this.utils.encodeId(this.id) /*, root: this.utils.encodeId(this.root)*/ });
	    };
	    ResearchLogController.prototype.showItem = function (ev, item, altType) {
	        var _this = this;
	        if (!!altType) {
	            this.$scope.$emit('show', { type: altType, item: item });
	        }
	        else {
	            this.utils.dialog(ev, 'ListModalController', 'app/components/list/listModal.html', true, { itemType: item._type.toLowerCase(), item: item }).then(function (response) {
	                _this.$log.info('response', response);
	                if (!!response) {
	                    response.params.ev = ev; // override with original event
	                    _this.$scope.$emit(response.action, response.params);
	                }
	            }, function () {
	                // ignore
	            });
	        }
	        if (!!ev) {
	            ev.stopPropagation();
	        }
	    };
	    ResearchLogController.prototype.getInbox = function (columns) {
	        try {
	            for (var columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
	                var column = columns_1_1.value;
	                if (column[0] === 1) {
	                    return column[1]; //return the inbox column
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return null; //should never happen
	        var e_1, _a;
	    };
	    ResearchLogController.prototype.setDisplay = function () {
	        if (this.waitToUpdate) {
	            // setDisplay was called before the researchLog has been updated
	            return;
	        }
	        else if (this.format.id === 'map') {
	            this.setMapDisplay();
	        }
	        else {
	            this.setColumnDisplay();
	        }
	    };
	    ResearchLogController.prototype.setMapDisplay = function () {
	        var _this = this;
	        if (!this.refItems.size) {
	            return;
	        }
	        var streams = [];
	        Array.from(this.refItems).forEach(function (_a) {
	            var _b = __read(_a, 2), id = _b[0], item = _b[1];
	            switch (item._type) {
	                case 'EVIDENCE':
	                    _this.standardizeEvidenceLocations(id, item, streams);
	                    break;
	                case 'LEAD':
	                    break; //no locations to extract
	                case 'MEDIA':
	                    _this.standardizeOtherLocations(id, item, streams);
	                    break;
	                case 'NOTE':
	                    break; //no locations to extract
	                case 'STORY':
	                    _this.standardizeOtherLocations(id, item, streams);
	                    break;
	                default:
	                    break;
	            }
	        });
	        (streams.length === 0 ? this.rx.Observable.of([]) : (_a = this.rx.Observable).forkJoin.apply(_a, __spread(streams))).subscribe(function (placesArr) {
	            var placesMap = new Map(placesArr.filter(function (place) {
	                return !!place && !!place[0] && place[0].name;
	            }).map(function (place) { return [place[0].name, place[0]]; }));
	            _this.refMapPoints = [];
	            Array.from(_this.refItems).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], item = _b[1];
	                switch (item._type) {
	                    case 'EVIDENCE':
	                        _this.addLocationEvidence(id, item, placesMap);
	                        break;
	                    case 'LEAD':
	                        break; //no locations to extract
	                    case 'MEDIA':
	                        _this.addLocationOther(id, item, placesMap);
	                        break;
	                    case 'NOTE':
	                        break; //no locations to extract
	                    case 'STORY':
	                        _this.addLocationOther(id, item, placesMap);
	                        break;
	                    default:
	                        break;
	                }
	            });
	            _this.mapPoints = _this.refMapPoints;
	        }, function () {
	            //ignore
	        });
	        var _a;
	    };
	    ResearchLogController.prototype.standardizeEvidenceLocations = function (id, item, streams) {
	        var _this = this;
	        if (!!item.fact) {
	            if (!!item.fact.place) {
	                streams.push(this.placesService.standardize(item.fact.place));
	            }
	        }
	        if (!!item.personas) {
	            Array.from(item.personas.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), personaId = _b[0], persona = _b[1];
	                if (!!persona && !!persona.facts) {
	                    Array.from(persona.facts.entries()).forEach(function (_a) {
	                        var _b = __read(_a, 2), pFactId = _b[0], fact = _b[1];
	                        if (!!fact && !!fact.place) {
	                            streams.push(_this.placesService.standardize(fact.place));
	                        }
	                    });
	                }
	            });
	        }
	    };
	    ResearchLogController.prototype.standardizeOtherLocations = function (id, item, streams) {
	        if (!!item.place) {
	            streams.push(this.placesService.standardize(item.place));
	        }
	    };
	    ResearchLogController.prototype.addLocationEvidence = function (id, item, placesMap) {
	        var _this = this;
	        if (!!item.fact) {
	            if (!!item.fact.place) {
	                this.refMapPoints.push({
	                    latitude: placesMap.get(item.fact.place).latitude,
	                    longitude: placesMap.get(item.fact.place).longitude,
	                    shape: 'place',
	                    color: this.getColor(/*fact.type*/ item._type),
	                    desc: this.formatMarkerText(id, item, item.fact),
	                    id: id,
	                    item: item,
	                    fact: item.fact
	                });
	            }
	        }
	        if (!!item.personas) {
	            Array.from(item.personas.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), personaId = _b[0], persona = _b[1];
	                if (!!persona && !!persona.facts) {
	                    Array.from(persona.facts.entries()).forEach(function (_a) {
	                        var _b = __read(_a, 2), pFactId = _b[0], fact = _b[1];
	                        if (!!fact.latitude && !!fact.longitude) {
	                            _this.refMapPoints.push({
	                                latitude: placesMap.get(fact.place).latitude,
	                                longitude: placesMap.get(fact.place).longitude,
	                                shape: 'place',
	                                color: _this.getColor(/*fact.type*/ item._type),
	                                desc: _this.formatMarkerText(id, item, fact),
	                                id: id,
	                                item: item,
	                                fact: fact
	                            });
	                        }
	                    });
	                }
	            });
	        }
	    };
	    ResearchLogController.prototype.addLocationOther = function (id, item, placesMap) {
	        if (!!item.place && !!item.latitude && item.longitude) {
	            this.refMapPoints.push({
	                latitude: placesMap.get(item.place).latitude,
	                longitude: placesMap.get(item.place).longitude,
	                shape: 'place',
	                color: this.getColor(item._type),
	                desc: this.formatMarkerText(id, item),
	                id: id,
	                item: item
	            });
	        }
	    };
	    ResearchLogController.prototype.formatMarkerText = function (id, item, fact) {
	        var title, place, date;
	        switch (item._type) {
	            case 'STORY':
	            case 'MEDIA':
	                title = (item.title || item._type[0] + item._type.substring(1).toLowerCase());
	                place = (item.place || "");
	                date = (item.date || "");
	                break;
	            case 'EVIDENCE':
	                title = this.getEvidencePrincipalName(item);
	                place = (fact.place || "");
	                date = (fact.date || "");
	                break;
	        }
	        var html = '<div>' + this.getMarkerIcon(item._type.toLowerCase(), item.fact) +
	            '<div class="leaflet__popup-inner">' +
	            '<a href class="link leaflet__popup-title" ng-click="onMapMarkerClick(' + id + ')">' + title + '</a>' +
	            '<span class="truncate-text card__text">' + place + '</span>' +
	            '<span class="truncate-text card__text">' + date + '</span>' +
	            '</div>' +
	            '</div>';
	        return this.$compile(angular.element(html))(this.$scope)[0];
	    };
	    ResearchLogController.prototype.getMarkerIcon = function (type, fact) {
	        var iconName;
	        switch (type) {
	            case 'story':
	                iconName = 'import_contacts';
	                break;
	            case 'media':
	                iconName = 'photo';
	                break;
	            case 'evidence':
	                var ft = this.utils.factTypes.find(function (ft) { return ft.value === fact.type; });
	                iconName = 'rc:icon-' + ((!!ft && ft.icon) || 'publication');
	                return '<md-icon class="material-icons card__icon card__icon_fact" role="img" aria-label="' + iconName + '" md-svg-icon="' + iconName + '"></md-icon>';
	        }
	        return '<md-icon class="material-icons card__icon card__icon_' + type + '" role="img" aria-label="' + iconName + '">' + iconName + '</md-icon>';
	    };
	    ResearchLogController.prototype.getColor = function (type) {
	        switch (type) {
	            case 'STORY':
	                return 'green';
	            case 'MEDIA':
	                return 'blue';
	            case 'EVIDENCE':
	                return 'purple';
	            default:
	                return 'black';
	        }
	    };
	    ResearchLogController.prototype.getEvidencePrincipalName = function (e) {
	        try {
	            for (var _a = __values(e._personas.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var pa = _b.value;
	                if (pa.principal && pa.relatedToKey === 0 && pa.relationshipType === '') {
	                    return pa._fullName;
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        try {
	            for (var _d = __values(e._personas.values()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                var pa = _e.value;
	                return pa._fullName;
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        return 'Evidence';
	        var e_2, _c, e_3, _f;
	    };
	    ResearchLogController.prototype.setColumnDisplay = function () {
	        var _this = this;
	        this.items = new Map(this.refItems);
	        var display = Array.from(this.utils.clone(this.researchLog.columns).entries());
	        display.forEach(function (_a) {
	            var _b = __read(_a, 2), cid = _b[0], column = _b[1];
	            var arr = [];
	            Array.from(column.items.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], index = _b[1];
	                if (_this.items.has(id) && (cid === 2 || !_this.archivedLeads.has(id))) {
	                    var itemCopy = _this.utils.clone(_this.items.get(id));
	                    arr.push({
	                        index: index,
	                        item: itemCopy
	                    });
	                    if (_this.archivedLeads.has(id)) {
	                        _this.archivedLeads.delete(id); //we placed the id in the done column so remove it
	                    }
	                }
	                _this.items.delete(id);
	            });
	            arr.sort(function (a, b) {
	                return a.index - b.index;
	            });
	            column.items = arr;
	        });
	        display.sort(function (a, b) {
	            return a[1].position - b[1].position;
	        });
	        var doneBox = this.researchLog.columns.get(2);
	        if (!!doneBox) {
	            var displayDone_1 = display[doneBox.position][1].items;
	            Array.from(this.archivedLeads.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], lead = _b[1];
	                displayDone_1.push({
	                    index: displayDone_1.length,
	                    item: _this.utils.clone(lead)
	                });
	                _this.archivedLeads.delete(id);
	                _this.items.delete(id);
	            });
	        }
	        else {
	            Array.from(this.archivedLeads.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], lead = _b[1];
	                _this.items.delete(id); //remove these items so that they don't show up in the inbox
	            });
	        }
	        var column = this.getInbox(display);
	        Array.from(this.items.entries()).forEach(function (_a) {
	            var _b = __read(_a, 2), id = _b[0], item = _b[1];
	            // if (!item.state) { // if not hidden/archived
	            column.items.push({
	                index: column.items.length,
	                item: _this.utils.clone(item)
	            });
	            // }
	        });
	        this.displayColumns = display;
	    };
	    ResearchLogController.prototype.openMenu = function ($mdMenu, ev) {
	        this.menuEvent = ev;
	        $mdMenu.open(ev);
	    };
	    ResearchLogController.prototype.formatMapAndUpdate = function () {
	        var map = new Map();
	        this.displayColumns.forEach(function (_a, index) {
	            var _b = __read(_a, 2), id = _b[0], column = _b[1];
	            var iMap = new Map();
	            column.position = index;
	            column.items.forEach(function (item, index) {
	                if (!!item.item.id) {
	                    iMap.set(item.item.id, index);
	                }
	            });
	            map.set(id, {
	                name: column.name,
	                position: index,
	                items: iMap
	            });
	        });
	        this.researchLog.columns = map;
	        this.researchLogService.update(this.researchLog);
	    };
	    ResearchLogController.prototype.columnDragStart = function (index) {
	        this.draggingColumn = index;
	    };
	    ResearchLogController.prototype.dropColumn = function (index, list) {
	        this.dropColumnLocation = index;
	        list.splice(index, 0, list[this.draggingColumn]);
	        return true;
	    };
	    ResearchLogController.prototype.moveColumn = function (index, list) {
	        this.draggingColumn = -1;
	        var offset = 0;
	        if (this.dropColumnLocation < index) {
	            offset += 1;
	        }
	        list.splice(index + offset, 1);
	        this.formatMapAndUpdate();
	    };
	    ResearchLogController.prototype.dragStart = function (id) {
	        this.draggingItem = id;
	    };
	    ResearchLogController.prototype.moveItem = function (index, list, position) {
	        var offset = 0;
	        if (this.dropLocation.colIndex === position && this.dropLocation.cardIndex < index) {
	            offset += 1;
	        }
	        list.splice(index + offset, 1);
	        this.formatMapAndUpdate();
	    };
	    ResearchLogController.prototype.dropCard = function (colIndex, cardIndex) {
	        var item = this.refItems.get(this.draggingItem);
	        // this is too clever
	        // if (item._type === 'LEAD') { //if the item is a lead, set it to hidden/not hidden based on whether it's in the done column or not
	        //   item.state = (this.displayColumns[colIndex][0] === 2) ? 1 : 0;
	        //   this.refItems.set(this.draggingItem, item);
	        // }
	        this.dropLocation = { colIndex: colIndex, cardIndex: cardIndex };
	        this.displayColumns[colIndex][1].items.splice(cardIndex, 0, {
	            index: cardIndex,
	            item: item
	        });
	        return true;
	    };
	    ResearchLogController.prototype.editResearchLog = function (ev, item) {
	        this.utils.dialog(ev, 'EditResearchLogController', 'app/components/editResearchLog/editResearchLog.html', false, {
	            researchLog: item
	        });
	    };
	    ResearchLogController.prototype.deleteResearchLog = function (ev) {
	        var _this = this;
	        this.utils.confirm('Delete research log', 'Are you sure?', ev).then(function () {
	            _this.isDeleted = true;
	            var streams = [];
	            Array.from(_this.refItems.values()).forEach(function (item) {
	                item.researchLogId = 0;
	                switch (item._type) {
	                    case 'EVIDENCE':
	                        streams.push(_this.evidencesService.update(item));
	                        break;
	                    case 'LEAD':
	                        streams.push(_this.leadsService.update(item));
	                        break;
	                    case 'MEDIA':
	                        streams.push(_this.mediasService.update(item));
	                        break;
	                    case 'NOTE':
	                        streams.push(_this.notesService.update(item));
	                        break;
	                    case 'STORY':
	                        streams.push(_this.storiesService.update(item));
	                        break;
	                }
	            });
	            _this.researchLog.columns = new Map();
	            (streams.length === 0 ? _this.rx.Observable.of([]) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(streams))).flatMap(function () {
	                return _this.researchLogService.del(_this.researchLog.id);
	            }).subscribe(function () {
	                _this.$state.go('tree.research-logs');
	            }, function () {
	                //ignore
	            });
	            var _a;
	        }, function () {
	            //ignore
	        });
	    };
	    ResearchLogController.prototype.updateResearchLog = function (columnId, item) {
	        var items = this.researchLog.columns.get(columnId).items;
	        items.set(item.id, items.size);
	        this.researchLogService.update(this.researchLog);
	    };
	    ResearchLogController.prototype.add = function (type) {
	        var inboxId = 1;
	        switch (type) {
	            case 'COLUMN':
	                this.addColumn(inboxId);
	                break;
	            case 'EVIDENCE':
	                this.addEvidence(inboxId);
	                break;
	            case 'LEAD':
	                this.addLead(inboxId);
	                break;
	            case 'MEDIA':
	                this.addMedia(inboxId);
	                break;
	            case 'NOTE':
	                this.addNote(inboxId);
	                break;
	            case 'STORY':
	                this.addStory(inboxId);
	                break;
	        }
	    };
	    ResearchLogController.prototype.addToColumn = function (type, columnId) {
	        switch (type) {
	            case 'EVIDENCE':
	                this.addEvidence(columnId);
	                break;
	            case 'LEAD':
	                this.addLead(columnId);
	                break;
	            case 'MEDIA':
	                this.addMedia(columnId);
	                break;
	            case 'NOTE':
	                this.addNote(columnId);
	                break;
	            case 'STORY':
	                this.addStory(columnId);
	                break;
	        }
	    };
	    ResearchLogController.prototype.addColumn = function () {
	        var _this = this;
	        this.utils.prompt('Add Column', '', 'Enter Name', '', '', '').then(function (value) {
	            if (value === '' || value === undefined) {
	                _this.utils.alert('Column not added', 'Invalid name', '');
	            }
	            else {
	                var length_1 = Math.max(_this.researchLog.columns.size, 3); //2 is reserved for done, so make sure it is at least 3
	                var unique = (_this.researchLog.columns.get(length_1) === undefined);
	                while (!unique) {
	                    length_1++;
	                    unique = (_this.researchLog.columns.get(length_1) === undefined);
	                }
	                _this.researchLog.columns.set(length_1, {
	                    name: value,
	                    position: _this.displayColumns.length - 1,
	                    items: new Map()
	                });
	                _this.researchLogService.update(_this.researchLog);
	            }
	        }, function () {
	            //ignore
	        });
	    };
	    ResearchLogController.prototype.editColumnName = function (ev, column) {
	        var _this = this;
	        this.utils.prompt('Edit Column Name', '', 'Enter Name', column[1].name, '', '').then(function (value) {
	            if (value === '' || value === undefined) {
	                _this.utils.alert('Column not changed', 'Invalid name', '');
	            }
	            else {
	                _this.researchLog.columns.get(column[0]).name = value;
	                _this.researchLogService.update(_this.researchLog);
	            }
	        }, function () {
	            //ignore
	        });
	    };
	    ResearchLogController.prototype.deleteColumn = function (ev, column, index) {
	        var _this = this;
	        this.utils.confirm('Delete ' + column[1].name + '?', 'This will move all cards currently in this column to the inbox', ev).then(function () {
	            var inboxItems = _this.displayColumns[_this.researchLog.columns.get(1).position][1].items;
	            column[1].items.forEach(function (item) {
	                // if (!item.item.state) {  // if item isn't hidden/archived
	                inboxItems.push({
	                    index: inboxItems.length,
	                    item: item.item
	                });
	                // }
	            });
	            _this.displayColumns.splice(index, 1);
	            _this.formatMapAndUpdate();
	        }, function () {
	            //ignore
	        });
	    };
	    ResearchLogController.prototype.addEvidence = function (columnId) {
	        var _this = this;
	        this.waitToUpdate = true;
	        this.utils.dialog(this.menuEvent, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	            researchLogId: this.id
	        }).then(function (evidence) {
	            _this.waitToUpdate = false;
	            _this.updateResearchLog(columnId, evidence);
	        }, function () {
	            _this.waitToUpdate = false;
	        });
	    };
	    ResearchLogController.prototype.editEvidence = function (ev, evidence) {
	        this.utils.dialog(ev, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	            evidence: evidence
	        });
	    };
	    ResearchLogController.prototype.deleteEvidence = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Supporting Evidence', 'Are you sure?', ev).then(function () {
	            _this.evidencesService.streamId(id).take(1).subscribe(function (evidence) {
	                _this.evidencesService.augmentEvidence(evidence, _this.sourcesService, _this.personsService, _this.usersService).subscribe(function (evidence) {
	                    var deletedNamesFacts = _this.evidenceUtils.getDeletedNamesFacts([evidence], [], true);
	                    if (deletedNamesFacts.filter(function (nf) { return nf.principal && nf.unsupported; }).length > 0) {
	                        _this.utils.dialog(null, 'SelectNamesFactsController', 'app/components/selectNamesFacts/selectNamesFacts.html', false, {
	                            namesFacts: deletedNamesFacts
	                        }).then(function (deletedNamesFacts) {
	                            _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	                        }, function () {
	                            // ignore
	                        });
	                    }
	                    else {
	                        _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	                    }
	                });
	            });
	        }, function () {
	            // ignore
	        });
	    };
	    ResearchLogController.prototype.addLead = function (columnId) {
	        var _this = this;
	        this.waitToUpdate = true;
	        this.utils.dialog(this.menuEvent, 'EditLeadController', 'app/components/editLead/editLead.html', false, {
	            researchLogId: this.id
	        }).then(function (lead) {
	            _this.waitToUpdate = false;
	            // too clever
	            // if (columnId === 2) {
	            //   lead.state = 1;
	            //   if (this.refItems.has(lead.id)) {
	            //     this.refItems.get(lead.id). = 1;
	            //   }
	            // }
	            _this.updateResearchLog(columnId, lead);
	        }, function () {
	            _this.waitToUpdate = false;
	        });
	    };
	    ResearchLogController.prototype.editLead = function (ev, lead) {
	        var _this = this;
	        this.waitToUpdate = true;
	        this.utils.dialog(ev, 'EditLeadController', 'app/components/editLead/editLead.html', false, {
	            lead: lead
	        }).then(function () {
	            _this.waitToUpdate = false;
	            _this.researchLogService.update(_this.researchLog);
	        }, function () {
	            _this.waitToUpdate = false;
	        });
	    };
	    ResearchLogController.prototype.archiveLead = function (ev, lead) {
	        lead.state = lead.state === 0 ? 1 : 0;
	        this.leadsService.update(lead);
	    };
	    ResearchLogController.prototype.deleteLead = function (ev, lead) {
	        var _this = this;
	        this.utils.confirm('Delete', 'Are you sure?', ev).then(function () {
	            lead.state = 2;
	            _this.leadsService.update(lead);
	        }, function () {
	            // ignore
	        });
	    };
	    ResearchLogController.prototype.addMedia = function (columnId) {
	        var _this = this;
	        this.waitToUpdate = true;
	        this.utils.dialog(this.menuEvent, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	            researchLogId: this.id
	        }).then(function (media) {
	            _this.waitToUpdate = false;
	            _this.updateResearchLog(columnId, media);
	        }, function () {
	            _this.waitToUpdate = false;
	        });
	    };
	    ResearchLogController.prototype.editMedia = function (ev, media) {
	        this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	            media: media
	        });
	    };
	    ResearchLogController.prototype.deleteMedia = function (ev, media) {
	        var _this = this;
	        this.utils.dialog(ev, 'DeleteMediaController', 'app/components/deleteMedia/deleteMedia.html', false, {
	            media: media
	        }).then(function () {
	            _this.mediasService.del(media.id);
	        }, function () {
	            // ignore
	        });
	    };
	    ResearchLogController.prototype.addNote = function (columnId) {
	        var _this = this;
	        this.waitToUpdate = true;
	        this.utils.dialog(this.menuEvent, 'EditNoteController', 'app/components/editNote/editNote.html', false, {
	            researchLogId: this.id
	        }).then(function (note) {
	            _this.waitToUpdate = false;
	            _this.updateResearchLog(columnId, note);
	        }, function () {
	            _this.waitToUpdate = false;
	        });
	    };
	    ResearchLogController.prototype.editNote = function (ev, note) {
	        this.utils.dialog(ev, 'EditNoteController', 'app/components/editNote/editNote.html', false, {
	            note: note
	        });
	    };
	    ResearchLogController.prototype.deleteNote = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Note', 'Are you sure?', ev).then(function () {
	            _this.notesService.del(id);
	        }, function () {
	            // ignore
	        });
	    };
	    ResearchLogController.prototype.addStory = function (columnId) {
	        var _this = this;
	        this.waitToUpdate = true;
	        this.utils.dialog(this.menuEvent, 'EditStoryController', 'app/components/editStory/editStory.html', false, {
	            researchLogId: this.id
	        }).then(function (story) {
	            _this.updateResearchLog(columnId, story);
	            _this.waitToUpdate = false;
	        }, function () {
	            _this.waitToUpdate = false;
	        });
	    };
	    ResearchLogController.prototype.editStory = function (ev, story) {
	        this.utils.dialog(ev, 'EditStoryController', 'app/components/editStory/editStory.html', false, {
	            story: story
	        });
	    };
	    ResearchLogController.prototype.deleteStory = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Story', 'Are you sure?', ev).then(function () {
	            _this.storiesService.del(id);
	        }, function () {
	            // ignore
	        });
	    };
	    return ResearchLogController;
	}());
	exports.default = ResearchLogController;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var TreeController = /** @class */ (function () {
	    TreeController.$inject = ["$log", "$scope", "$rootScope", "$transition$", "$mdMedia", "$state", "partnerId", "sidenav", "currentTreeId", "currentUserId", "currentUser", "showAds", "utils"];
	    function TreeController($log, $scope, $rootScope, $transition$, $mdMedia, $state, partnerId, sidenav, currentTreeId, currentUserId, currentUser, showAds, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$rootScope = $rootScope;
	        this.partnerId = partnerId;
	        this.treeId = parseInt($transition$.params().treeId, 10);
	        this.$mdMedia = $mdMedia;
	        this.$state = $state;
	        this.sidenav = sidenav;
	        this.utils = utils;
	        this.showAds = false;
	        var rfSub = showAds.stream().subscribe(function (sa) {
	            _this.showAds = sa;
	        });
	        $scope.$on('$destroy', function () {
	            rfSub.unsubscribe();
	        });
	        this.tallAdStates = ['tree.person', 'tree.compare'];
	        this.noAdStates = ['tree.import-scratch', 'tree.import-gedcom', 'tree.import-fs'];
	        if (this.treeId !== currentTreeId.get()) {
	            currentTreeId.set(this.treeId);
	            currentUserId.stream().filter(function (userId) { return userId !== 0; }).take(1).subscribe(function (userId) {
	                currentUser.updateCurrentTreeId(userId, _this.treeId).take(1).subscribe();
	            });
	        }
	    }
	    TreeController.prototype.isSidenavLockedOpen = function () {
	        return this.sidenav.isLockedOpen();
	    };
	    TreeController.prototype.showSidenav = function () {
	        return this.utils.showSidenav(this.$state);
	    };
	    TreeController.prototype.showTopAd = function () {
	        return false;
	    };
	    TreeController.prototype.showRightAds = function () {
	        var _this = this;
	        return this.showAds && this.$mdMedia('gt-sm') && !this.noAdStates.some(function (state) { return _this.$state.is(state); }); // keep in sync with index.run.js
	    };
	    TreeController.prototype.showTallAds = function () {
	        var _this = this;
	        return this.showAds && this.tallAdStates.some(function (state) { return _this.$state.is(state); });
	    };
	    TreeController.prototype.showTextAds = function () {
	        return this.showTallAds() && !this.partnerId && false;
	    };
	    TreeController.prototype.textAdNumber = function () {
	        return this.$rootScope.textAdNumber;
	    };
	    return TreeController;
	}());
	exports.default = TreeController;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var TreeGraphicsController = /** @class */ (function () {
	    TreeGraphicsController.$inject = ["$log", "$scope", "$interval", "$transition$", "angularGridInstance", "treeGraphics", "social", "utils"];
	    function TreeGraphicsController($log, $scope, $interval, $transition$, angularGridInstance, treeGraphics, social, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$interval = $interval;
	        this.angularGridInstance = angularGridInstance;
	        this.social = social;
	        this.utils = utils;
	        var graphicId = utils.decodeId($transition$.params().graphicId);
	        this.treeGraphics = new Map();
	        this.loading = true;
	        var subscription = utils.readyChange(treeGraphics).subscribe(function (_a) {
	            var _b = __read(_a, 1), treeGraphicsMap = _b[0];
	            _this.$log.debug('treeGraphics.change', treeGraphicsMap);
	            _this.treeGraphics = treeGraphicsMap;
	            _this.refresh();
	        });
	        var stop = null;
	        if (!!graphicId && parseInt(graphicId, 10) > 0) {
	            stop = $interval(function () {
	                var graphic = _this.treeGraphics.get(graphicId);
	                if (!!graphic) {
	                    _this.show(null, graphic);
	                    _this.$interval.cancel(stop);
	                    stop = null;
	                }
	            }, 100);
	        }
	        $scope.$on('share', function (ev, params) {
	            _this.share(params.ev, params.platform, params.item);
	            ev.stopPropagation();
	        });
	        $scope.$on('resize', function (ev) {
	            _this.refresh();
	            ev.stopPropagation();
	        });
	        $scope.$on('$destroy', function () {
	            if (!!stop) {
	                _this.$interval.cancel(stop);
	            }
	            subscription.unsubscribe();
	        });
	    }
	    TreeGraphicsController.prototype.share = function (ev, platform, graphic) {
	        this.social.post(platform, {
	            title: graphic.title,
	            graphicId: graphic.id,
	            url: graphic.url,
	            description: ''
	        }, ev);
	    };
	    TreeGraphicsController.prototype.refresh = function () {
	        var _this = this;
	        var stop = this.$interval(function () {
	            if (!!_this.angularGridInstance && !!_this.angularGridInstance.gallery && !!_this.angularGridInstance.gallery.refresh) {
	                _this.$interval.cancel(stop);
	                _this.angularGridInstance.gallery.refresh();
	                _this.loading = false;
	            }
	        }, 100);
	    };
	    TreeGraphicsController.prototype.getTwitterUrl = function (tg) {
	        return this.social.getTwitterUrl({ text: tg.title, graphicId: tg.id });
	    };
	    TreeGraphicsController.prototype.show = function (ev, tg) {
	        this.utils.dialog(ev, 'TreeGraphicController', 'app/components/treeGraphic/treeGraphic.dialog.html', true, {
	            graphic: tg
	        }).then(function () {
	            // ignore
	        }, function () {
	            // ignore
	        });
	    };
	    return TreeGraphicsController;
	}());
	exports.default = TreeGraphicsController;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var TreeSettingsController = /** @class */ (function () {
	    TreeSettingsController.$inject = ["$scope", "$state", "authToken", "messageBus", "rightsFull", "currentTree", "currentTreeId", "subscriptions", "fs", "treeUsers", "persons", "segment", "server", "utils"];
	    function TreeSettingsController($scope, $state, authToken, messageBus, rightsFull, currentTree, currentTreeId, subscriptions, fs, treeUsers, persons, segment, server, utils) {
	        'ngInject';
	        var _this = this;
	        this.$state = $state;
	        this.authToken = authToken;
	        this.messageBus = messageBus;
	        this.currentTree = currentTree;
	        this.currentTreeId = currentTreeId;
	        this.subscriptions = subscriptions;
	        this.fs = fs;
	        this.treeUsers = treeUsers;
	        this.persons = persons;
	        this.segment = segment;
	        this.server = server;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.tree = null;
	        this.tu = null;
	        this.isFeatured = false;
	        this.isOwner = false;
	        this.colorNames = Object.keys(utils.colors);
	        this.overrideColors = [];
	        var sub = utils.readyChange(currentTree, treeUsers, persons).subscribe(function () {
	            currentTree.stream().filter(function (t) { return !!t; }).take(1).subscribe(function (tree) {
	                _this.tree = utils.clone(tree);
	                if (_this.tree.privacy === 'FEATURED') {
	                    _this.tree.privacy = 'PUBLIC';
	                    _this.isFeatured = true;
	                }
	                _this.colorPGF = _this.tree.preferences.COLOR_PGF;
	                _this.colorPGM = _this.tree.preferences.COLOR_PGM;
	                _this.colorMGF = _this.tree.preferences.COLOR_MGF;
	                _this.colorMGM = _this.tree.preferences.COLOR_MGM;
	                _this.overrideColors = [];
	                _this.overrideColors.push({ label: _this.tree.preferences.COLOR_LABEL_1, value: _this.tree.preferences.COLOR_1 });
	                _this.overrideColors.push({ label: _this.tree.preferences.COLOR_LABEL_2, value: _this.tree.preferences.COLOR_2 });
	                _this.overrideColors.push({ label: _this.tree.preferences.COLOR_LABEL_3, value: _this.tree.preferences.COLOR_3 });
	                _this.overrideColors.push({ label: _this.tree.preferences.COLOR_LABEL_4, value: _this.tree.preferences.COLOR_4 });
	                _this.overrideColors.push({ label: _this.tree.preferences.COLOR_LABEL_5, value: _this.tree.preferences.COLOR_5 });
	                _this.overrideColors.push({ label: _this.tree.preferences.COLOR_LABEL_6, value: _this.tree.preferences.COLOR_6 });
	                _this.colorNOT = _this.tree.preferences.COLOR_NOT;
	            });
	            treeUsers.stream().filter(function (tu) { return !!tu; }).take(1).subscribe(function (tu) {
	                _this.tu = utils.clone(tu);
	                _this.homepage = tu.preferences['HOMEPAGE'] || 'TREE';
	                _this.treeview = tu.preferences['TREEVIEW'] || 'PEDIGREE';
	                var id = parseInt(tu.preferences['ROOT'] || '0', 10);
	                _this.showRelativesEvents = (tu.preferences['SHOW_RELATIVES_EVENTS'] || 'FALSE') === 'TRUE';
	                _this.easySyncFS = (tu.preferences['EASY_SYNC_FS'] || 'FALSE') === 'TRUE';
	                _this.presentationMode = (tu.preferences['PRESENTATION_MODE'] || 'FALSE') === 'TRUE';
	                if (id > 0) {
	                    persons.streamId(id).take(1).subscribe(function (person) {
	                        _this.root = person;
	                    });
	                }
	            });
	        });
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            if (level < rightsFull.LEVEL_READ) {
	                $state.go('tree');
	            }
	            _this.isOwner = (level === rightsFull.LEVEL_OWNER);
	        });
	        $scope.$on('$destroy', function () {
	            sub.unsubscribe();
	        });
	    }
	    TreeSettingsController.prototype.colorStyle = function (color) {
	        if (!color) {
	            return {};
	        }
	        return { 'background-color': this.utils.colors[color][3] };
	    };
	    TreeSettingsController.prototype.queryPerson = function (query) {
	        return !query ? [] : this.persons.nameAutocomplete(query);
	    };
	    TreeSettingsController.prototype.queryTag = function (text) {
	        return !!text ? this.persons.tagAutocomplete(text) : [];
	    };
	    TreeSettingsController.prototype.saveTree = function (ev) {
	        var _this = this;
	        this.savingTree = true;
	        if (this.tree.privacy === 'PUBLIC' && this.isFeatured) {
	            this.tree.privacy = 'FEATURED';
	        }
	        this.subscriptions.stream().filter(function (sub) { return !!sub; }).take(1).subscribe(function (sub) {
	            if (_this.tree.privacy === 'PRIVATE' && !(sub.level === 'PRO' || sub.level === 'PRO_TRIAL')) {
	                _this.utils.confirm('Pro Plan required', 'You need a Pro Plan to create a private tree. Is it time to upgrade?', ev, 'Upgrade').then(function () {
	                    _this.$state.go('userSettings');
	                }, function () {
	                    _this.savingTree = false;
	                });
	            }
	            else {
	                _this.tree.preferences.COLOR_PGF = _this.colorPGF;
	                _this.tree.preferences.COLOR_PGM = _this.colorPGM;
	                _this.tree.preferences.COLOR_MGF = _this.colorMGF;
	                _this.tree.preferences.COLOR_MGM = _this.colorMGM;
	                _this.tree.preferences.COLOR_1 = _this.overrideColors[0].value;
	                _this.tree.preferences.COLOR_2 = _this.overrideColors[1].value;
	                _this.tree.preferences.COLOR_3 = _this.overrideColors[2].value;
	                _this.tree.preferences.COLOR_4 = _this.overrideColors[3].value;
	                _this.tree.preferences.COLOR_5 = _this.overrideColors[4].value;
	                _this.tree.preferences.COLOR_6 = _this.overrideColors[5].value;
	                _this.tree.preferences.COLOR_LABEL_1 = _this.overrideColors[0].label || _this.overrideColors[0].searchText;
	                _this.tree.preferences.COLOR_LABEL_2 = _this.overrideColors[1].label || _this.overrideColors[1].searchText;
	                _this.tree.preferences.COLOR_LABEL_3 = _this.overrideColors[2].label || _this.overrideColors[2].searchText;
	                _this.tree.preferences.COLOR_LABEL_4 = _this.overrideColors[3].label || _this.overrideColors[3].searchText;
	                _this.tree.preferences.COLOR_LABEL_5 = _this.overrideColors[4].label || _this.overrideColors[4].searchText;
	                _this.tree.preferences.COLOR_LABEL_6 = _this.overrideColors[5].label || _this.overrideColors[5].searchText;
	                _this.tree.preferences.COLOR_NOT = _this.colorNOT;
	                _this.currentTree.update(_this.tree).subscribe(function () {
	                    _this.savingTree = false;
	                    _this.messageBus.post({ msg: 'Your settings have been saved' });
	                }, function () {
	                    _this.savingTree = false;
	                });
	            }
	        });
	    };
	    TreeSettingsController.prototype.saveUser = function (ev) {
	        var _this = this;
	        if (!this.root || !this.root.id) {
	            this.utils.alert('Root person cannot be empty', 'Please enter a root person for your tree (typically this is you).', ev);
	            return;
	        }
	        this.savingUser = true;
	        this.tu.preferences['ROOT'] = this.root.id.toString();
	        this.tu.preferences['HOMEPAGE'] = this.homepage;
	        this.tu.preferences['TREEVIEW'] = this.treeview;
	        this.tu.preferences['SHOW_RELATIVES_EVENTS'] = this.showRelativesEvents ? 'TRUE' : 'FALSE';
	        this.tu.preferences['EASY_SYNC_FS'] = this.easySyncFS ? 'TRUE' : 'FALSE';
	        this.tu.preferences['PRESENTATION_MODE'] = this.presentationMode ? 'TRUE' : 'FALSE';
	        this.treeUsers.update(this.tu).subscribe(function () {
	            _this.savingUser = false;
	            _this.messageBus.post({ msg: 'Your settings have been saved' });
	        }, function () {
	            _this.savingUser = false;
	        });
	    };
	    TreeSettingsController.prototype.mergeTree = function (ev) {
	        var _this = this;
	        this.utils.dialog(ev, 'SelectTreeController', 'app/components/selectTree/selectTree.html', true, { selectForMerge: true }).then(function (result) {
	            if (result.action === 'open') {
	                _this.$state.go('tree.merge', { mergeId: result.id });
	            }
	        });
	    };
	    TreeSettingsController.prototype.exportGedcom = function (ev) {
	        var _this = this;
	        this.exportingGedcom = true;
	        this.server.post('/trees/' + this.currentTreeId.get() + '/exports?media=false&token=' + this.authToken.get()).subscribe(function () {
	            _this.segment.track('gedcom.export');
	            _this.exportingGedcom = false;
	            _this.utils.alert('Your request is being processed', 'You should receive an email in a few minutes with a link to your GEDCOM.', ev);
	        }, function () {
	            _this.exportingGedcom = false;
	            _this.messageBus.post({ msg: 'BAD_REQUEST', op: 'export', ctx: 'settings', warn: true });
	        });
	    };
	    TreeSettingsController.prototype.exportGedcomWithMedia = function (ev) {
	        var _this = this;
	        this.exportingGedcom = true;
	        this.server.post('/trees/' + this.currentTreeId.get() + '/exports?media=true&token=' + this.authToken.get()).subscribe(function () {
	            _this.segment.track('gedcom.export');
	            _this.exportingGedcom = false;
	            _this.utils.alert('Your request is being processed', 'You should receive an email in a few minutes with a link to your GEDCOM.', ev);
	        }, function () {
	            _this.exportingGedcom = false;
	            _this.messageBus.post({ msg: 'BAD_REQUEST', op: 'export', ctx: 'settings', warn: true });
	        });
	    };
	    TreeSettingsController.prototype.deleteTree = function (ev) {
	        var _this = this;
	        this.utils.prompt('Delete Tree ' + this.tree.name, 'Are you sure? This action cannot be undone!', 'Enter your Tree name to confirm', '', ev, 'Delete My Tree').then(function (value) {
	            if (value === _this.tree.name) {
	                _this.deletingTree = true;
	                if (_this.tree.externalIds.has('familysearch.org')) {
	                    //        this.utils.confirm('Remove tree from FamilySearch Genealogies?', 'Do you also want to remove your tree from the FamilySearch Genealogies archive?', ev, 'Yes', 'No').then(() => {
	                    _this.utils.dialog(ev, 'FsLoginController', 'app/components/fsLogin/fsLogin.html', true, {
	                        //            text: 'Removing your tree from FamilySearch requires you to log into FamilySearch.'
	                        text: 'Removing your tree from RootsFinder also removes it from FamilySearch Genealogies, which requires you to log into FamilySearch.'
	                    }).then(function (token) {
	                        var tree = _this.utils.clone(_this.tree);
	                        tree.externalIds.delete('familysearch.org');
	                        tree.preferences['LEADS_FROM_FS'] = 'FALSE';
	                        _this.currentTree.update(tree, { fsToken: token }).subscribe(function () {
	                            _this._deleteTree();
	                        }, function () {
	                            _this.deletingTree = false;
	                        });
	                    }, function () {
	                        _this.deletingTree = false;
	                        _this.utils.alert('Delete cancelled', 'Tree was not deleted', ev);
	                    });
	                    //}, () => {
	                    //  this._deleteTree();
	                    //});
	                }
	                else {
	                    _this._deleteTree();
	                }
	            }
	            else {
	                _this.utils.alert('Tree not deleted', 'Your tree name is ' + _this.tree.name, ev);
	            }
	        }, function () {
	            // ignore
	        });
	    };
	    TreeSettingsController.prototype._deleteTree = function () {
	        var _this = this;
	        this.currentTree.del(this.tree.id).subscribe(function () {
	            _this.deletingTree = false;
	            _this.$state.go('homeSignedIn');
	        }, function () {
	            _this.deletingTree = false;
	        });
	    };
	    return TreeSettingsController;
	}());
	exports.default = TreeSettingsController;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var UserController = /** @class */ (function () {
	    UserController.$inject = ["$log", "$scope", "$transition$", "currentUser", "rightsFull", "evidences", "leads", "medias", "notes", "persons", "sources", "stories", "users", "feed", "evidenceUtils", "utils"];
	    function UserController($log, $scope, $transition$, currentUser, rightsFull, evidences, leads, medias, notes, persons, sources, stories, users, feed, evidenceUtils, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.evidencesService = evidences;
	        this.leadsService = leads;
	        this.mediasService = medias;
	        this.notesService = notes;
	        this.personsService = persons;
	        this.sourcesService = sources;
	        this.storiesService = stories;
	        this.usersService = users;
	        this.feedService = feed;
	        this.evidenceUtils = evidenceUtils;
	        this.utils = utils;
	        this.userId = parseInt($transition$.params().userId, 10);
	        this.pageSize = 50;
	        this.numLoaded = this.pageSize;
	        this.expanded = new Map();
	        this.hideAdd = true;
	        this.loading = true;
	        var uSub = utils.readyChange(currentUser, rightsFull).subscribe(function () {
	            currentUser.stream().take(1).subscribe(function (cu) {
	                if (!!cu && _this.userId === cu.id) {
	                    _this.hideAdd = false;
	                    _this.user = cu;
	                    _this.showEmail = true;
	                }
	                else {
	                    _this.hideAdd = true;
	                    rightsFull.streamLevel().take(1).subscribe(function (level) {
	                        _this.showEmail = level >= rightsFull.LEVEL_READ;
	                        var userStreamFn = _this.showEmail ? users.streamId.bind(users) : users.streamSummaryId.bind(users);
	                        userStreamFn(_this.userId).take(1).subscribe(function (user) {
	                            _this.user = user;
	                        });
	                    });
	                }
	            });
	        });
	        var fSub = this.feedService.streamFullFeed(this.expanded, this.userId).subscribe(function (fullFeed) {
	            _this.fullFeed = fullFeed;
	            _this.feed = _this.feedService.getFeed(_this.fullFeed, _this.numLoaded);
	            _this.countMedia = fullFeed.filter(function (i) { return i.type === 'MEDIA'; }).length;
	            _this.countStories = fullFeed.filter(function (i) { return i.type === 'STORY'; }).length;
	            _this.countEvidences = fullFeed.filter(function (i) { return i.type === 'EVIDENCE'; }).length;
	            _this.countNotes = fullFeed.filter(function (i) { return i.type === 'NOTE'; }).length;
	            _this.loading = false;
	        });
	        $scope.$on('toggleExpand', function (ev, params) {
	            _this.expanded.set(params.id, !_this.expanded.get(params.id));
	        });
	        $scope.$on('show', function (ev, params) {
	            switch (params.type) {
	                case 'source':
	                    _this.showSource(params.ev, params.id);
	                    break;
	            }
	        });
	        $scope.$on('edit', function (ev, params) {
	            switch (params.type) {
	                case 'evidence':
	                    _this.editEvidence(params.ev, params.item);
	                    break;
	                case 'lead':
	                    _this.editLead(params.ev, params.item);
	                    break;
	                case 'media':
	                    _this.editMedia(params.ev, params.item);
	                    break;
	                case 'note':
	                    _this.editNote(params.ev, params.item);
	                    break;
	                case 'story':
	                    _this.editStory(params.ev, params.item);
	                    break;
	            }
	        });
	        $scope.$on('archive', function (ev, params) {
	            switch (params.type) {
	                case 'lead':
	                    _this.archiveLead(params.ev, params.item);
	                    break;
	            }
	        });
	        $scope.$on('delete', function (ev, params) {
	            switch (params.type) {
	                case 'evidence':
	                    _this.deleteEvidence(params.ev, params.id);
	                    break;
	                case 'lead':
	                    _this.deleteLead(params.ev, params.item);
	                    break;
	                case 'media':
	                    _this.deleteMedia(params.ev, params.item);
	                    break;
	                case 'note':
	                    _this.deleteNote(params.ev, params.id);
	                    break;
	                case 'story':
	                    _this.deleteStory(params.ev, params.id);
	                    break;
	            }
	        });
	        $scope.$on('$destroy', function () {
	            uSub.unsubscribe();
	            fSub.unsubscribe();
	        });
	    }
	    UserController.prototype.getAvatarURL = function (user) {
	        return this.usersService.getAvatarURL(user);
	    };
	    UserController.prototype.loadMore = function () {
	        this.loading = true;
	        this.numLoaded += this.pageSize;
	        this.feed = this.feedService.getFeed(this.fullFeed, this.numLoaded);
	        this.loading = false;
	    };
	    UserController.prototype.openMenu = function ($mdMenu, ev) {
	        this.menuEvent = ev;
	        $mdMenu.open(ev);
	    };
	    UserController.prototype.showSource = function (ev, id) {
	        this.utils.showSource(ev, this.sourcesService, this.evidencesService, this.usersService, id);
	    };
	    UserController.prototype.addEvidence = function () {
	        this.utils.dialog(this.menuEvent, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false);
	    };
	    UserController.prototype.editEvidence = function (ev, evidence) {
	        this.utils.dialog(ev, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	            evidence: evidence
	        });
	    };
	    UserController.prototype.deleteEvidence = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Supporting Evidence', 'Are you sure?', ev).then(function () {
	            _this.evidencesService.streamId(id).take(1).subscribe(function (evidence) {
	                _this.evidencesService.augmentEvidence(evidence, _this.sourcesService, _this.personsService, _this.usersService).subscribe(function (evidence) {
	                    var deletedNamesFacts = _this.evidenceUtils.getDeletedNamesFacts([evidence], [], true);
	                    if (deletedNamesFacts.filter(function (nf) { return nf.principal && nf.unsupported; }).length > 0) {
	                        _this.utils.dialog(null, 'SelectNamesFactsController', 'app/components/selectNamesFacts/selectNamesFacts.html', false, {
	                            namesFacts: deletedNamesFacts
	                        }).then(function (deletedNamesFacts) {
	                            _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	                        }, function () {
	                            // ignore
	                        });
	                    }
	                    else {
	                        _this.evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	                    }
	                });
	            });
	        }, function () {
	            // ignore
	        });
	    };
	    UserController.prototype.addLead = function (ev) {
	        this.utils.dialog(ev, 'EditLeadController', 'app/components/editLead/editLead.html', false);
	    };
	    UserController.prototype.editLead = function (ev, lead) {
	        this.utils.dialog(ev, 'EditLeadController', 'app/components/editLead/editLead.html', false, {
	            lead: lead
	        });
	    };
	    UserController.prototype.archiveLead = function (ev, lead) {
	        lead.state = lead.state === 0 ? 1 : 0;
	        this.leadsService.update(lead);
	    };
	    UserController.prototype.deleteLead = function (ev, lead) {
	        var _this = this;
	        this.utils.confirm('Delete', 'Are you sure?', ev).then(function () {
	            lead.state = 2;
	            _this.leadsService.update(lead);
	        }, function () {
	            // ignore
	        });
	    };
	    UserController.prototype.addMedia = function (ev) {
	        this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false);
	    };
	    UserController.prototype.editMedia = function (ev, media) {
	        this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	            media: media
	        });
	    };
	    UserController.prototype.deleteMedia = function (ev, media) {
	        var _this = this;
	        this.utils.dialog(ev, 'DeleteMediaController', 'app/components/deleteMedia/deleteMedia.html', false, {
	            media: media
	        }).then(function () {
	            _this.mediasService.del(media.id);
	        }, function () {
	            // ignore
	        });
	    };
	    UserController.prototype.addNote = function (ev) {
	        this.utils.dialog(ev, 'EditNoteController', 'app/components/editNote/editNote.html', false);
	    };
	    UserController.prototype.editNote = function (ev, note) {
	        this.utils.dialog(ev, 'EditNoteController', 'app/components/editNote/editNote.html', false, {
	            note: note
	        });
	    };
	    UserController.prototype.deleteNote = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Note', 'Are you sure?', ev).then(function () {
	            _this.notesService.del(id);
	        }, function () {
	            // ignore
	        });
	    };
	    UserController.prototype.addStory = function () {
	        this.utils.dialog(this.menuEvent, 'EditStoryController', 'app/components/editStory/editStory.html', false);
	    };
	    UserController.prototype.editStory = function (ev, story) {
	        this.utils.dialog(ev, 'EditStoryController', 'app/components/editStory/editStory.html', false, {
	            story: story
	        });
	    };
	    UserController.prototype.deleteStory = function (ev, id) {
	        var _this = this;
	        this.utils.confirm('Delete Story', 'Are you sure?', ev).then(function () {
	            _this.storiesService.del(id);
	        }, function () {
	            // ignore
	        });
	    };
	    return UserController;
	}());
	exports.default = UserController;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var UsersController = /** @class */ (function () {
	    UsersController.$inject = ["$log", "$scope", "rightsFull", "invitations", "rights", "users", "utils"];
	    function UsersController($log, $scope, rightsFull, invitations, rights, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.invitations = invitations;
	        this.utils = utils;
	        this.rightsLabels = rightsFull.levelLabels;
	        this.invitationMap = new Map();
	        this.userRightsMap = new Map();
	        var iSub, rSub;
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	            _this.isOwner = (level === rightsFull.LEVEL_OWNER);
	            if (level >= rightsFull.LEVEL_READ) {
	                iSub = invitations.stream().subscribe(function (invs) {
	                    _this.invitationMap = new Map();
	                    try {
	                        for (var invs_1 = __values(invs), invs_1_1 = invs_1.next(); !invs_1_1.done; invs_1_1 = invs_1.next()) {
	                            var _a = __read(invs_1_1.value, 2), id = _a[0], invitation = _a[1];
	                            _this.invitationMap.set(id, invitation);
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (invs_1_1 && !invs_1_1.done && (_b = invs_1.return)) _b.call(invs_1);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                    var e_1, _b;
	                });
	            }
	            var userStreamFn = level >= rightsFull.LEVEL_READ ? users.streamId.bind(users) : users.streamSummaryId.bind(users);
	            rSub = rights.stream().subscribe(function (rs) {
	                _this.userRightsMap = new Map();
	                var _loop_1 = function (userId, right) {
	                    var userRight = {
	                        userId: userId,
	                        right: right
	                    };
	                    _this.userRightsMap.set(userId, userRight);
	                    userStreamFn(userId).take(1).subscribe(function (user) {
	                        userRight.name = user.name;
	                        userRight.user = user;
	                    });
	                };
	                try {
	                    for (var rs_1 = __values(rs), rs_1_1 = rs_1.next(); !rs_1_1.done; rs_1_1 = rs_1.next()) {
	                        var _a = __read(rs_1_1.value, 2), userId = _a[0], right = _a[1];
	                        _loop_1(userId, right);
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (rs_1_1 && !rs_1_1.done && (_b = rs_1.return)) _b.call(rs_1);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	                var e_2, _b;
	            });
	        });
	        $scope.$on('$destroy', function () {
	            if (!!iSub) {
	                iSub.unsubscribe();
	            }
	            if (!!rSub) {
	                rSub.unsubscribe();
	            }
	        });
	        $scope.$on('delete', function (ev, params) {
	            _this.utils.confirm('Delete Invitation', 'Are you sure?', params.ev).then(function () {
	                _this.invitations.del(params.id).subscribe();
	            }, function () {
	                // ignore
	            });
	        });
	    }
	    UsersController.prototype.addInvitation = function (ev) {
	        this.utils.dialog(ev, 'AddInvitationController', 'app/components/addInvitation/addInvitation.html', false, {});
	    };
	    UsersController.prototype.editRights = function (userRight, ev) {
	        this.utils.dialog(ev, 'EditRightsController', 'app/components/editRights/editRights.html', false, {
	            right: userRight.right
	        });
	    };
	    return UsersController;
	}());
	exports.default = UsersController;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var UserSettingsController = /** @class */ (function () {
	    UserSettingsController.$inject = ["$log", "$scope", "$timeout", "$state", "$window", "stripeKey", "stripeImage", "rx", "moment", "partnerId", "messageBus", "authentication", "medias", "currentUser", "rightsFull", "subscriptions", "users", "server", "utils"];
	    function UserSettingsController($log, $scope, $timeout, $state, $window, stripeKey, stripeImage, rx, moment, partnerId, messageBus, authentication, medias, currentUser, rightsFull, subscriptions, users, server, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$timeout = $timeout;
	        this.$state = $state;
	        this.$window = $window;
	        this.rx = rx;
	        this.partnerId = partnerId;
	        this.messageBus = messageBus;
	        this.authentication = authentication;
	        this.mediaService = medias;
	        this.currentUser = currentUser;
	        this.subscriptions = subscriptions;
	        this.users = users;
	        this.server = server;
	        this.utils = utils;
	        this.plan = 'FREE';
	        this.billing = null;
	        this.user = null;
	        this.signInShown = false;
	        var cuSub = currentUser.stream().subscribe(function (user) {
	            if (!!user) {
	                _this.user = user;
	                _this.email = user.email;
	                _this.given = user.given;
	                _this.surname = user.surname;
	                _this.name = user.name;
	                _this.hasAvatar = user.hasAvatar;
	                _this.notifyMe = user.preferences['RC_NOTIFY_ME'] === 'TRUE';
	                _this.weeklyEmail = user.preferences['RC_WEEKLY_EMAIL'] === 'TRUE';
	                //this.getBilling();
	            }
	            else {
	                $timeout(function () {
	                    if (!_this.user && !_this.signInShown) {
	                        _this.signInShown = true;
	                        utils.dialog(null, 'SignInController', 'app/components/signIn/signIn.html');
	                    }
	                }, 2000);
	            }
	        });
	        this.ownerTotalMediaSize = 0;
	        var rfSub = rightsFull.stream().subscribe(function (rf) {
	            _this.ownerTotalMediaSize = rf.ownerTotalMediaSize;
	        });
	        // keep in sync with homeSignedIn
	        this.plan = 'FREE';
	        this.ownerMaxMediaGb = 2;
	        var subSub = subscriptions.stream().subscribe(function (subscription) {
	            _this.subscription = subscription;
	            if (!!subscription) {
	                _this.plan = subscription.level || 'FREE';
	                _this.autoRenew = false; //subscription.autoRenew;
	                _this.endDate = moment(subscription.endDate).format('D MMM YYYY');
	            }
	            else {
	                _this.plan = 'FREE';
	                _this.autoRenew = false;
	                _this.endDate = '';
	            }
	            if (_this.plan === 'STANDARD') {
	                _this.ownerMaxMediaGb = 10;
	            }
	            else if (_this.plan === 'PRO' || _this.plan === 'PRO_TRIAL') {
	                _this.ownerMaxMediaGb = 100;
	            }
	            else {
	                _this.ownerMaxMediaGb = 2;
	            }
	        });
	        this.fileTypes = medias.fileTypes;
	        this.fileModelOptions = medias.fileModelOptions;
	        this.fileValidation = medias.fileValidation;
	        this.fileDragover = medias.fileDragover;
	        this.fileStatus = '';
	        this.cropped = false;
	        this.savingUser = false;
	        this.handler = $window.StripeCheckout.configure({
	            key: stripeKey,
	            image: stripeImage,
	            locale: 'auto',
	            zipCode: true,
	        });
	        $scope.$on('$destroy', function () {
	            cuSub.unsubscribe();
	            rfSub.unsubscribe();
	            subSub.unsubscribe();
	            _this.handler.close();
	        });
	    }
	    UserSettingsController.prototype.back = function () {
	        this.$window.history.back();
	    };
	    //
	    // profile
	    //
	    UserSettingsController.prototype.reconfirmEmail = function (ev) {
	        var _this = this;
	        this.users.reconfirmEmail(this.user.id).subscribe(function () {
	            _this.utils.alert('Email Confirmation Sent', 'If you don\'t see the email, please check your spam folders', ev);
	        }, function (err) {
	            _this.messageBus.post({ msg: err.data || err.name, status: err.status, op: 'CONFIRM', ctx: 'userSettings', warn: true });
	        });
	    };
	    //
	    // media
	    //
	    UserSettingsController.prototype.isImageFile = function (file) {
	        return this.mediaService.isImageFile(file);
	    };
	    UserSettingsController.prototype.getImageFormat = function (file) {
	        return this.mediaService.getImageFormat(file);
	    };
	    UserSettingsController.prototype.fileChange = function (files) {
	        this.$log.debug('fileChange', files);
	        if (!!files && files.length > 0) {
	            this.fileName = files[0].name;
	            this.fileDataURI = '';
	            this.cropped = false;
	            this.profileMediaId = 0;
	            if (!!files[0] && this.isImageFile(files[0])) {
	                this.fileStatus = 'loading';
	            }
	            else {
	                this.fileStatus = 'noimage';
	            }
	        }
	    };
	    UserSettingsController.prototype.fileLoadDone = function () {
	        var _this = this;
	        if (this.fileStatus === 'loading') {
	            this.$timeout(function () {
	                _this.fileStatus = 'loaded';
	            });
	        }
	        // spurious fileChange events get sent for 1-2 seconds after file loaded
	        this.$timeout(function () {
	            _this.cropped = false;
	        }, 1500);
	    };
	    UserSettingsController.prototype.fileChangeCrop = function () {
	        this.cropped = true;
	    };
	    UserSettingsController.prototype.getMediaFileType = function (media) {
	        return Array.from(media.fileInfos.values())[0].contentType;
	    };
	    UserSettingsController.prototype.getAvatarURL = function (user) {
	        return this.users.getAvatarURL(user);
	    };
	    UserSettingsController.prototype.removeAvatar = function () {
	        this.hasAvatar = false;
	    };
	    //
	    // plan
	    //
	    // keep in sync with homeSignedIn
	    // getBilling() {
	    //   this.server.get('/billing/'+this.user.id).subscribe(billing => {
	    //     billing = this.utils.fromServer(billing);
	    //     this.billing = !!billing.cardType ? billing : null;
	    //   });
	    // }
	    // upgradePlan(ev) {
	    //   this.utils.dialog(ev, 'RecurlyController', 'app/components/recurly/recurly.html', false, {}).then(() => {
	    //     this.getBilling();
	    //   }, () => {
	    //     // ignore
	    //   });
	    // }
	    UserSettingsController.prototype.upgradePlan = function (ev) {
	        var _this = this;
	        this.utils.dialog(ev, 'SelectSubLengthController', 'app/components/selectSubLength/selectSubLength.html', true).then(function (length) {
	            _this.handler.open({
	                name: 'RootsFinder, Inc',
	                description: length === 'YEAR' ? 'Annual Pro Plan' : '1-Month Pro Plan',
	                amount: length === 'YEAR' ? 3495 : 500,
	                token: function (token, args) {
	                    _this.server.post('/billing', { userId: _this.user.id, token: token.id, length: length }).subscribe(function () {
	                        _this.utils.alert('Success!', _this.plan === 'PRO' ? 'Subscription extension successful.' : 'Subscription upgrade successful.').then(function () {
	                            _this.$window.location.reload(); // force reload after subscribe
	                        }, function () {
	                            _this.$window.location.reload();
	                        });
	                    }, function () {
	                        _this.utils.alert('Failed', 'We were unable to ' + (_this.plan === 'PRO' ? 'extend' : 'upgrade') + ' your subscription. Please contact support@rootsfinder.com.');
	                    });
	                }
	            });
	        });
	    };
	    // cancelPlan(ev) {
	    //   this.utils.confirm('Cancel plan', 'Are you sure?', ev).then(() => {
	    //     let sub = this.utils.clone(this.subscription);
	    //     sub.autoRenew = false;
	    //     this.subscriptions.update(sub).subscribe(() => {
	    //       this.getBilling();
	    //     }, () => {
	    //       // ignore
	    //     });
	    //   }, () => {
	    //     // ignore
	    //   });
	    // }
	    // updateBilling(ev) {
	    //   this.utils.dialog(ev, 'RecurlyController', 'app/components/recurly/recurly.html', false, {updateBilling: true}).then(() => {
	    //     this.getBilling();
	    //   }, () => {
	    //     // ignore
	    //   });
	    // }
	    //
	    // delete and save user
	    //
	    UserSettingsController.prototype.deleteUser = function (ev) {
	        var _this = this;
	        this.utils.prompt(this.user.name + ', are you sure you want to delete your account?', 'This will delete ALL of the trees that you own. This cannot be undone!', 'Enter your User name to confirm', '', ev, 'Delete My Account').then(function (value) {
	            if (value === _this.user.name) {
	                _this.deletingUser = true;
	                _this.currentUser.del(_this.user.id).flatMap(function () {
	                    return _this.authentication.logout();
	                }).subscribe(function () {
	                    _this.$window.location.href = _this.$state.href('home', {}, { absolute: true });
	                }, function () {
	                    _this.deletingUser = false;
	                });
	            }
	            else {
	                _this.utils.alert('Account not deleted', 'Your user name is ' + _this.user.name, ev);
	            }
	        });
	    };
	    UserSettingsController.prototype.saveUser = function () {
	        var _this = this;
	        if (!!this.password && this.password !== this.password2) {
	            this.utils.alert('The two new passwords don\'t match');
	            return;
	        }
	        if (!!this.password && !this.oldPassword) {
	            this.utils.alert('You must enter your current password in order to change it to a new one.');
	            return;
	        }
	        this.savingUser = true;
	        var user = this.utils.clone(this.user);
	        user.profileMediaId = +this.profileMediaId;
	        user.given = this.given;
	        user.surname = this.surname;
	        user.name = this.name;
	        user.email = this.email;
	        user.password = this.password;
	        user.hasAvatar = this.hasAvatar;
	        var resendConfirmation = !!user.emailConfirmationDate && this.email !== user.email;
	        user.email = this.email;
	        user.preferences['RC_NOTIFY_ME'] = this.notifyMe ? 'TRUE' : 'FALSE';
	        if (user.preferences['RC_WEEKLY_EMAIL'] === 'TRUE' && !this.weeklyEmail) {
	            user.preferences['RC_WEEKLY_PROMPT'] = 'TRUE';
	        }
	        user.preferences['RC_WEEKLY_EMAIL'] = this.weeklyEmail ? 'TRUE' : 'FALSE';
	        // load file
	        var passwordCheck = !user.password ? this.rx.Observable.of(true) : this.server.post('/auth/login', { email: this.user.email, password: this.oldPassword, source: this.partnerId });
	        passwordCheck.subscribe(function () {
	            if (!!_this.file) {
	                _this.users.uploadAvatar(_this.user, {
	                    file: _this.file,
	                    cropped: _this.cropped,
	                    fileDataURI: _this.fileDataURI
	                }).subscribe(function () {
	                    user.hasAvatar = true;
	                    _this.currentUser.update(user).subscribe(function () {
	                        _this.saving = false;
	                        _this._success(resendConfirmation);
	                    }, function () {
	                        _this.savingUser = false;
	                    });
	                }, function () {
	                    _this.savingUser = false;
	                });
	            }
	            else {
	                _this.currentUser.update(user).subscribe(function () {
	                    _this.savingUser = false;
	                    _this._success(resendConfirmation);
	                }, function () {
	                    _this.savingUser = false;
	                });
	            }
	        }, function (err) {
	            if (err.status === 401) {
	                _this.utils.alert('Your current password is incorrect.');
	            }
	            else {
	                _this.messageBus.post({ msg: err.data || err.name, status: err.status, op: 'UPDATE', ctx: 'userSettings', warn: true });
	            }
	            _this.savingUser = false;
	        });
	    };
	    UserSettingsController.prototype._success = function (resendConfirmation) {
	        this.messageBus.post({ msg: 'Your settings have been saved' });
	        this.password = '';
	        this.password2 = '';
	        this.oldPassword = '';
	        this.showPassword = false;
	        if (resendConfirmation) {
	            this.utils.alert('Confirmation email re-sent', 'Please click on the link in the email to re-confirm your email address.');
	        }
	    };
	    return UserSettingsController;
	}());
	exports.default = UserSettingsController;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var VideoController = /** @class */ (function () {
	    VideoController.$inject = ["$log", "$scope", "$transition$", "$sce", "$state", "$window", "musicBase", "messageBus", "persons", "evidences", "sources", "stories", "users", "medias", "musics", "mediaUtils", "utils"];
	    function VideoController($log, $scope, $transition$, $sce, $state, $window, musicBase, messageBus, persons, evidences, sources, stories, users, medias, musics, mediaUtils, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$sce = $sce;
	        this.$state = $state;
	        this.$window = $window;
	        this.musicBase = musicBase;
	        this.messageBus = messageBus;
	        this.persons = persons;
	        this.evidences = evidences;
	        this.sources = sources;
	        this.stories = stories;
	        this.users = users;
	        this.medias = medias;
	        this.mediaUtils = mediaUtils;
	        this.utils = utils;
	        this.defaultDuration = 3.0;
	        this.maxCaptionSize = 200;
	        this.defaultAnimation = 'RANDOM';
	        this.song = { id: 0, title: 'No music selected' };
	        this.voiceover = null;
	        this.voiceoverURL = '';
	        this.voiceoverMimeType = '';
	        this.musicArr = [];
	        var mSub = musics.stream().subscribe(function (music) {
	            _this.musicArr = [{ name: '', songs: [_this.song] }].concat(music);
	        });
	        this.animations = [
	            {
	                name: 'ANIMATIONS',
	                animations: [
	                    'NONE',
	                    'RANDOM'
	                ]
	            },
	            {
	                name: 'PAN',
	                animations: [
	                    'PAN_UP',
	                    'PAN_DOWN',
	                    'PAN_LEFT',
	                    'PAN_RIGHT'
	                ]
	            },
	            {
	                name: 'ZOOM',
	                animations: [
	                    'ZOOM_IN',
	                    'ZOOM_OUT'
	                ]
	            },
	            {
	                name: 'ZOOM_AND_PAN',
	                animations: [
	                    'ZOOM_IN_AND_PAN_UP',
	                    'ZOOM_IN_AND_PAN_DOWN',
	                    'ZOOM_IN_AND_PAN_LEFT',
	                    'ZOOM_IN_AND_PAN_RIGHT',
	                    'ZOOM_OUT_AND_PAN_UP',
	                    'ZOOM_OUT_AND_PAN_DOWN',
	                    'ZOOM_OUT_AND_PAN_LEFT',
	                    'ZOOM_OUT_AND_PAN_RIGHT'
	                ]
	            },
	            {
	                name: 'ZOOM_AND_ROTATE',
	                animations: [
	                    'ZOOM_IN_AND_ROTATE_CLOCKWISE',
	                    'ZOOM_IN_AND_ROTATE_COUNTERCLOCKWISE',
	                    'ZOOM_OUT_AND_ROTATE_CLOCKWISE',
	                    'ZOOM_OUT_AND_ROTATE_COUNTERCLOCKWISE'
	                ]
	            }
	        ];
	        this.encodedPersonId = $transition$.params().personId;
	        this.personId = utils.decodeId(this.encodedPersonId);
	        this.$log.info('personId', this.personId);
	        this.voiceoverEnabled = false;
	        if (!!$window.navigator && !!$window.navigator.mediaDevices && !!$window.navigator.mediaDevices.enumerateDevices) {
	            $window.navigator.mediaDevices.enumerateDevices().then(function (devices) {
	                try {
	                    for (var devices_1 = __values(devices), devices_1_1 = devices_1.next(); !devices_1_1.done; devices_1_1 = devices_1.next()) {
	                        var device = devices_1_1.value;
	                        if (device.kind === 'audioinput') {
	                            _this.voiceoverEnabled = true;
	                        }
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (devices_1_1 && !devices_1_1.done && (_a = devices_1.return)) _a.call(devices_1);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                var e_1, _a;
	            });
	        }
	        this.mediaArr = [];
	        utils.readyChange(persons, evidences, stories, medias).take(1).subscribe(function () {
	            persons.streamId(_this.personId).subscribe(function (person) {
	                _this.title = person._fullName;
	                evidences.streamForPerson(person).take(1).subscribe(function (evidenceMap) {
	                    evidenceMap.forEach(function (evidence) {
	                        evidence.mediaIds.forEach(function (v, mid) {
	                            medias.streamId(mid).take(1).subscribe(function (media) {
	                                _this.insertMedia(media);
	                            });
	                        });
	                    });
	                });
	            });
	            medias.streamForPerson(_this.personId).take(1).subscribe(function (mediaMap) {
	                mediaMap.forEach(function (media) {
	                    _this.insertMedia(media);
	                });
	            });
	            stories.streamForPerson(_this.personId).take(1).subscribe(function (storyMap) {
	                storyMap.forEach(function (story) {
	                    story.mediaIds.forEach(function (v, mid) {
	                        medias.streamId(mid).take(1).subscribe(function (media) {
	                            _this.insertMedia(media);
	                        });
	                    });
	                });
	            });
	        });
	        $scope.$on('$destroy', function () {
	            mSub.unsubscribe();
	        });
	    }
	    VideoController.prototype.getAudioURL = function (song) {
	        return this.$sce.trustAsResourceUrl(this.musicBase + '/' + song.id + '.mp3');
	    };
	    VideoController.prototype.getTotalLength = function (format) {
	        var seconds = 0;
	        try {
	            for (var _a = __values(this.mediaArr), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var m = _b.value;
	                seconds += +m.duration;
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        if (format) {
	            var minutes = Math.floor(seconds / 60);
	            seconds = Math.round(seconds % 60);
	            return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
	        }
	        else {
	            return seconds;
	        }
	        var e_2, _c;
	    };
	    VideoController.prototype.getVoiceoverURL = function () {
	        return this.$sce.trustAsResourceUrl(this.voiceoverURL);
	    };
	    VideoController.prototype.deleteVoiceover = function () {
	        this.voiceover = null;
	        this.voiceoverURL = '';
	        this.voiceoverMimeType = '';
	    };
	    VideoController.prototype.recordVoiceover = function (ev) {
	        var _this = this;
	        if (this.voiceoverEnabled) {
	            this.utils.dialog(ev, 'VoiceoverController', 'app/components/voiceover/voiceover.html', false, {
	                mediaArr: this.mediaArr
	            }).then(function (response) {
	                for (var i = 0; i < _this.mediaArr.length; i++) {
	                    _this.mediaArr[i].duration = response.timings[i];
	                }
	                _this.voiceover = response.blob;
	                _this.voiceoverURL = _this.$window.URL.createObjectURL(_this.voiceover);
	                _this.voiceoverMimeType = response.mimeType;
	            }, function () {
	                // ignore
	            });
	        }
	        else {
	            this.utils.alert('Not available', 'Your browser does not support audio recording.', ev);
	        }
	    };
	    VideoController.prototype.preview = function (ev) {
	        if (this.getTotalLength() > 300) {
	            this.utils.alert('Too long', 'Videos cannot be more than 5 minutes in length', ev);
	            return;
	        }
	        this.utils.dialog(ev, 'VideoPreviewController', 'app/components/videoPreview/videoPreview.html', false, {
	            data: this.toData(true)
	        });
	    };
	    VideoController.prototype.create = function (ev) {
	        var _this = this;
	        if (this.getTotalLength() > 300) {
	            this.utils.alert('Too long', 'Videos cannot be more than 5 minutes in length', ev);
	            return;
	        }
	        this.saving = true;
	        // call create
	        this.medias.createSlideshow(this.toData(false)).subscribe(function () {
	            _this.saving = false;
	            // show alert and go back to person
	            _this.utils.alert('Your video is being created', 'This takes 1-10 minutes depending upon the length of the video. You will be notified as soon as your video is ready.', ev)
	                .then(function () {
	                _this.$state.go('tree.person', { personId: _this.encodedPersonId });
	            });
	        }, function (e) {
	            _this.saving = false;
	            _this.messageBus.post({ msg: 'Error creating video: ' + e.name || e, op: 'POST', ctx: 'slideshow-create' });
	        });
	    };
	    VideoController.prototype.toData = function (preview) {
	        var data = {
	            form: {
	                title: this.title,
	                personId: this.personId,
	                images: this.mediaArr.map(function (m) {
	                    return {
	                        id: m.media.id,
	                        caption: m.caption,
	                        animation: m.animation,
	                        duration: parseFloat(m.duration)
	                    };
	                }),
	                musicId: this.song.id,
	                preview: preview
	            }
	        };
	        if (!!this.voiceover) {
	            data.file = this.voiceover;
	            data.form.voiceoverMimeType = this.voiceoverMimeType;
	        }
	        return data;
	    };
	    VideoController.prototype.insertMedia = function (media) {
	        if (this.medias.isImage(media, false, true)) {
	            var ix = this.utils.sortedIndex(this.mediaArr, media, function (m) { return m.dateSort || '99999999'; });
	            this.mediaArr.splice(ix, 0, this.getMediaItem(media, this.defaultDuration, this.defaultAnimation));
	        }
	    };
	    VideoController.prototype.dropMedia = function (ev, dropTarget, media) {
	        var dropSource = this.mediaArr.findIndex(function (m) { return m.media.id === media.media.id; });
	        this.mediaArr.splice(dropTarget, 0, this.mediaArr[dropSource]);
	        if (dropTarget <= dropSource) {
	            dropSource++;
	        }
	        this.mediaArr.splice(dropSource, 1);
	        return true;
	    };
	    VideoController.prototype.openMenu = function ($mdMenu, ev) {
	        this.menuEvent = ev;
	        $mdMenu.open(ev);
	    };
	    VideoController.prototype.addExistingMedia = function (ev) {
	        var _this = this;
	        this.utils.dialog(ev, 'SelectMediaController', 'app/components/selectMedia/selectMedia.html', true, {}).then(function (selectedMediaIds) {
	            try {
	                for (var selectedMediaIds_1 = __values(selectedMediaIds), selectedMediaIds_1_1 = selectedMediaIds_1.next(); !selectedMediaIds_1_1.done; selectedMediaIds_1_1 = selectedMediaIds_1.next()) {
	                    var id = selectedMediaIds_1_1.value;
	                    _this.medias.streamId(id).take(1).subscribe(function (media) {
	                        _this.mediaArr.unshift(_this.getMediaItem(media, _this.defaultDuration, _this.defaultAnimation));
	                    });
	                }
	            }
	            catch (e_3_1) { e_3 = { error: e_3_1 }; }
	            finally {
	                try {
	                    if (selectedMediaIds_1_1 && !selectedMediaIds_1_1.done && (_a = selectedMediaIds_1.return)) _a.call(selectedMediaIds_1);
	                }
	                finally { if (e_3) throw e_3.error; }
	            }
	            var e_3, _a;
	        }, function () {
	            // ignore
	        });
	    };
	    VideoController.prototype.addNewMedia = function (ev) {
	        var _this = this;
	        this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	            personId: this.personId
	        }).then(function (media) {
	            _this.mediaArr.unshift(_this.getMediaItem(media, _this.defaultDuration, _this.defaultAnimation));
	        }, function () {
	            // ignore
	        });
	    };
	    VideoController.prototype.removeMedia = function (ix) {
	        this.mediaArr.splice(ix, 1);
	    };
	    VideoController.prototype.moveMedia = function (ix, dir) {
	        if ((ix === 0 && dir < 0) || (ix === this.mediaArr.length - 1 && dir > 0)) {
	            return;
	        }
	        _a = __read([this.mediaArr[ix], this.mediaArr[ix + dir]], 2), this.mediaArr[ix + dir] = _a[0], this.mediaArr[ix] = _a[1];
	        var _a;
	    };
	    VideoController.prototype.showMedia = function (ev, media) {
	        var _this = this;
	        this.medias.augmentMedia(media, this.persons, this.evidences, this.sources, this.stories, this.users).subscribe(function (media) {
	            _this.utils.dialog(ev, 'MediaController', 'app/components/media/media.dialog.html', true, {
	                media: media
	            }).then(function (response) {
	                if (!!response) {
	                    if (response === 'edit') {
	                        _this.utils.dialog(ev, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	                            media: media
	                        }).then(function (media) {
	                            // update media
	                            var ix = _this.mediaArr.findIndex(function (m) { return m.media.id === media.id; });
	                            _this.mediaArr[ix] = _this.getMediaItem(media, _this.mediaArr[ix].duration, _this.mediaArr[ix].animation);
	                        }, function () {
	                            // ignore
	                        });
	                    }
	                    else if (response === 'delete') {
	                        _this.utils.dialog(ev, 'DeleteMediaController', 'app/components/deleteMedia/deleteMedia.html', false, {
	                            media: media
	                        }).then(function () {
	                            // remove media
	                            var ix = _this.mediaArr.findIndex(function (m) { return m.media.id === media.id; });
	                            _this.mediaArr.splice(ix, 1);
	                        }, function () {
	                            // ignore
	                        });
	                    }
	                    else if (response === 'mosaic') {
	                        _this.mediaUtils.mosaic(ev, media);
	                    }
	                }
	            }, function () {
	                // ignore
	            });
	        });
	    };
	    VideoController.prototype.getMediaItem = function (media, duration, animation) {
	        return {
	            media: media,
	            caption: this.utils.removeHtml(media.text, this.maxCaptionSize),
	            duration: duration,
	            animation: animation,
	            url: this.medias.getMediaImageURL(media),
	            thumbUrl: this.medias.getMediaImageURL(media, '100x100')
	        };
	    };
	    return VideoController;
	}());
	exports.default = VideoController;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var WarningsController = /** @class */ (function () {
	    WarningsController.$inject = ["$log", "$scope", "$transition$", "rx", "messageBus", "warnings", "persons", "utils"];
	    function WarningsController($log, $scope, $transition$, rx, messageBus, warnings, persons, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.warnings = warnings;
	        this.persons = persons;
	        this.warningId = utils.decodeId($transition$.params().warningId);
	        this.showArchived = false;
	        this.normalHeaders = [
	            { label: 'Level', width: 10, property: 'level', type: 'warning_level', filterable: true, sortable: true, sort: 1, defaultSort: true, show: true },
	            { label: 'Title', width: 60, property: 'title', type: 'string', filterable: true, sortable: true, sort: 2, defaultSort: true, show: true },
	            { label: 'People', width: 30, property: '_people', type: 'people', filterable: true }
	        ];
	        this.archiveHeaders = [
	            { label: 'Level', width: 10, property: 'level', type: 'warning_level', filterable: true, sortable: true, sort: 1, defaultSort: true, show: true },
	            { label: 'Title', width: 50, property: 'title', type: 'string', filterable: true, sortable: true, sort: 2, defaultSort: true, show: true },
	            { label: 'People', width: 30, property: '_people', type: 'people', filterable: true },
	            { label: 'Archived', width: 10, property: '_archived', type: 'bool', filterable: true, sortable: true }
	        ];
	        this.headers = this.normalHeaders;
	        this.items = new Map();
	        var pw = utils.pleaseWait();
	        var subscription = utils.readyChange(warnings, persons).subscribe(function (_a) {
	            var _b = __read(_a, 1), warningMap = _b[0];
	            _this.$log.debug('warnings.change');
	            _this.warningMap = warningMap;
	            _this.setItems();
	            utils.pleaseWaitCancel(pw);
	        });
	        $scope.$on('$destroy', function () {
	            subscription.unsubscribe();
	        });
	        $scope.$on('showArchived', function (ev, params) {
	            _this.showArchived = !params.showArchived;
	            _this.headers = _this.showArchived ? _this.archiveHeaders : _this.normalHeaders;
	            _this.setItems();
	        });
	        $scope.$on('archive', function (ev, params) {
	            var warning = params.item;
	            warning.state = warning.state === 0 ? 1 : 0;
	            warnings.update(warning);
	        });
	        $scope.$on('delete', function (ev, params) {
	            var warning = params.item;
	            ev = params.ev;
	            utils.confirm('Delete Warning', 'Are you sure?', ev).then(function () {
	                warning.state = 2;
	                warnings.update(warning);
	            }, function () {
	                // ignore
	            });
	        });
	        $scope.$on('save', function (ev, params) {
	            (_a = rx.Observable).forkJoin.apply(_a, __spread(params.items.map(function (item) {
	                item.state = item._archived ? 1 : 0;
	                return warnings.update(item);
	            }))).subscribe(function () {
	                // nothing to do
	            }, function (err) {
	                messageBus.post({ msg: err });
	            });
	            var _a;
	        });
	    }
	    WarningsController.prototype.setItems = function () {
	        var _this = this;
	        this.items = new Map();
	        Array.from(this.warningMap.entries()).filter(function (_a) {
	            var _b = __read(_a, 2), warning = _b[1];
	            return warning.state === 0 || (_this.showArchived && warning.state === 1);
	        }).forEach(function (_a) {
	            var _b = __read(_a, 2), id = _b[0], warning = _b[1];
	            _this.warnings.augmentWarning(warning, _this.persons).subscribe(function (warning) {
	                warning._archived = warning.state > 0;
	                _this.items.set(id, warning);
	            });
	        });
	    };
	    return WarningsController;
	}());
	exports.default = WarningsController;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var AddBookmarkController = /** @class */ (function () {
	    AddBookmarkController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus", "bookmarks", "persons", "utils"];
	    function AddBookmarkController($log, $mdDialog, $mdMedia, $scope, messageBus, bookmarks, persons, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.bookmarks = bookmarks;
	        this.persons = persons;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.person = null;
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    AddBookmarkController.prototype.queryPerson = function (query) {
	        var _this = this;
	        return this.persons.ready().toPromise().then(function () {
	            return !query ? _this.rx.Observable.of([]).toPromise() : _this.persons.nameAutocomplete(query);
	        });
	    };
	    AddBookmarkController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        this.bookmarks.streamId(this.person.id).take(1).subscribe(function (bookmark) {
	            if (!!bookmark) {
	                _this.saving = false;
	                _this.msg = 'This person is already bookmarked';
	            }
	            else {
	                _this.bookmarks.create({ id: _this.person.id }).subscribe(function () {
	                    _this.saving = false;
	                    _this.$mdDialog.hide();
	                }, function () {
	                    _this.saving = false;
	                });
	            }
	        });
	    };
	    AddBookmarkController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return AddBookmarkController;
	}());
	exports.default = AddBookmarkController;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var AddPersonController = /** @class */ (function () {
	    AddPersonController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus", "places", "persons", "personUtils", "utils"];
	    function AddPersonController($log, $mdDialog, $mdMedia, $scope, messageBus, places, persons, personUtils, utils) {
	        'ngInject';
	        var _this = this;
	        // passed in: mode, relationshipType, relatedToPersonId, family, nameGiven, nameSurname, spouseFamilies
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.places = places;
	        this.persons = persons;
	        this.personUtils = personUtils;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        //this.tags = [];
	        this.gender = '';
	        this.living = '';
	        // if we're trying to add a parent to a family that already has that parent, null out the family
	        if (!!this.family && ((this.relationshipType === 'FATHER' && this.family.husbandId > 0) || (this.relationshipType === 'MOTHER' && this.family.wifeId > 0))) {
	            this.family = null;
	        }
	        this.tabIndex = !this.mode || this.mode === 'parent' || this.mode === 'spouse' || !!this.relationshipType ? 1 : 0;
	        this.isSubmitted = false;
	        if (this.relationshipType === 'CHILD' && !!this.family) {
	            var ix = this.spouseFamilies.findIndex(function (f) { return f.id === _this.family.id; });
	            if (ix >= 0) {
	                this.relationshipType = this.relationshipType + '_' + ix.toString();
	            }
	        }
	        this.changeRelationshipType();
	        this.birthType = 'BIRT';
	        this.deathType = 'DEAT';
	        this.marriageType = 'MARR';
	        this.birthTypes = ['BIRT', 'CHR', 'BAPM'];
	        this.marriageTypes = ['MARR', 'MARB', 'MBON', 'MARC', 'MARL', 'MARS'];
	        this.deathTypes = ['DEAT', 'BURI'];
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        if (this.relatedToPersonId > 0) {
	            persons.streamId(this.relatedToPersonId).take(1).subscribe(function (p) {
	                // save for use in changeRelationshipType
	                _this.person = p;
	                if (_this.mode === 'parent' && _this.relationshipType === 'FATHER' && !_this.nameSurname) {
	                    var nf = _this.persons.getDefaultNameForm(_this.persons.getPreferredName(p));
	                    if (!!nf && !!nf.surname) {
	                        _this.nameSurname = nf.surname;
	                    }
	                }
	                _this.changeRelationshipType();
	            });
	        }
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    //
	    // relationship
	    //
	    AddPersonController.prototype.getSpouseName = function (sf) {
	        if (sf.husbandId > 0 && sf.husbandId !== this.relatedToPersonId) {
	            return !!sf._husband ? sf._husband._given : '';
	        }
	        if (sf.wifeId > 0 && sf.wifeId !== this.relatedToPersonId) {
	            return !!sf._wife ? sf._wife._given : '';
	        }
	        return 'Unknown Spouse';
	    };
	    AddPersonController.prototype.showUnknownSpouse = function (spouseFamilies) {
	        var _this = this;
	        return spouseFamilies != null &&
	            !spouseFamilies.some(function (sf) { return !(sf.husbandId > 0 && sf.husbandId !== _this.relatedToPersonId) && !(sf.wifeId > 0 && sf.wifeId !== _this.relatedToPersonId); });
	    };
	    AddPersonController.prototype.changeRelationshipType = function () {
	        if (!!this.person) {
	            if (!this.living) {
	                var relAdjust = 0;
	                if (this.relationshipType === 'FATHER' || this.relationshipType === 'MOTHER') {
	                    relAdjust = -20;
	                }
	                else if (this.relationshipType.startsWith('CHILD')) {
	                    relAdjust = 30;
	                }
	                var year = this.utils.getYear(this.person._birthDate);
	                if (!year) {
	                    year = this.utils.getYear(this.person._deathDate);
	                }
	                if (!!year && new Date().getFullYear() - parseInt(year, 10) - relAdjust > 125) {
	                    this.living = 'FALSE';
	                }
	            }
	            if (this.relationshipType === 'SPOUSE') {
	                if (this.person.gender === 'MALE') {
	                    this.gender = 'FEMALE';
	                }
	                else if (this.person.gender === 'FEMALE') {
	                    this.gender = 'MALE';
	                }
	            }
	        }
	        if (this.relationshipType === 'FATHER') {
	            this.gender = 'MALE';
	        }
	        else if (this.relationshipType === 'MOTHER') {
	            this.gender = 'FEMALE';
	        }
	    };
	    //
	    // existing
	    //
	    AddPersonController.prototype.toggleAddExisting = function () {
	        this.isAddExisting = !this.isAddExisting;
	    };
	    AddPersonController.prototype.queryPerson = function (query) {
	        var _this = this;
	        return !query ? [] : this.persons.nameAutocomplete(query).then(function (persons) { return persons.filter(function (p) { return p.id !== _this.relatedToPersonId; }); });
	    };
	    //
	    // name
	    //
	    //
	    // tags
	    //
	    //queryTag(text) {
	    //  return !!text ? this.persons.tagAutocomplete(text) : [];
	    //}
	    //
	    // place
	    //
	    AddPersonController.prototype.queryPlace = function (text) {
	        return !!text ? this.places.autocomplete(text) : [];
	    };
	    //
	    // navigation
	    //
	    AddPersonController.prototype.showMarriage = function () {
	        return this.relationshipType === 'SPOUSE' ||
	            (!!this.family && (this.family.husbandId > 0 || this.family.wifeId > 0) && (this.relationshipType === 'FATHER' || this.relationshipType === 'MOTHER' || this.relationshipType === 'PARENT'));
	    };
	    AddPersonController.prototype.readyToSave = function () {
	        return this.tabIndex === 2 || (this.tabIndex === 1 && this.isAddExisting && !this.showMarriage());
	    };
	    AddPersonController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    AddPersonController.prototype.back = function () {
	        if (this.tabIndex > 0) {
	            this.tabIndex--;
	        }
	    };
	    AddPersonController.prototype.next = function () {
	        if (this.readyToSave()) {
	            this.submit();
	        }
	        else {
	            this.tabIndex++;
	        }
	    };
	    AddPersonController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        this.isSubmitted = true;
	        var family = this.family;
	        if (this.relationshipType === 'CHILD') {
	            family = null;
	        }
	        else if (!!this.relationshipType && this.relationshipType.startsWith('CHILD')) {
	            family = this.spouseFamilies[parseInt(this.relationshipType.substr(6), 10)];
	            this.relationshipType = 'CHILD';
	        }
	        var form = {};
	        if (!!this.relative) {
	            form.person = this.relative;
	            form.living = this.relative.living;
	            form.gender = this.relative.gender;
	            var nf = this.persons.getDefaultNameForm(this.persons.getPreferredName(this.relative));
	            if (!!nf) {
	                form.name = this.utils.clone(nf);
	            }
	            var f = this.persons.getPreferredBirth(this.relative);
	            if (!!f) {
	                form.birth = {
	                    type: f.type,
	                    date: f.date,
	                    place: !!f.placeStandard ? {
	                        name: f.place,
	                        standardName: f.placeStandard,
	                        latitude: f.latitude,
	                        longitude: f.longitude
	                    } : null,
	                    placeText: f.place
	                };
	            }
	            f = this.persons.getPreferredDeath(this.relative);
	            if (!!f) {
	                form.death = {
	                    type: f.type,
	                    date: f.date,
	                    place: !!f.placeStandard ? {
	                        name: f.place,
	                        standardName: f.placeStandard,
	                        latitude: f.latitude,
	                        longitude: f.longitude
	                    } : null,
	                    placeText: f.place
	                };
	            }
	        }
	        else {
	            form.living = this.living;
	            form.gender = this.gender;
	            if (!!this.namePrefix || !!this.nameGiven || !!this.nameSurname || !!this.nameSuffix) {
	                form.name = {
	                    given: this.nameGiven,
	                    surname: this.nameSurname,
	                    prefix: this.namePrefix,
	                    suffix: this.nameSuffix
	                };
	            }
	            if (!!this.birthDate || !!this.birthPlace || !!this.birthPlaceText) {
	                form.birth = {
	                    type: this.birthType,
	                    date: this.birthDate,
	                    place: this.birthPlace,
	                    placeText: this.birthPlaceText
	                };
	            }
	            if (!!this.deathDate || !!this.deathPlace || !!this.deathPlaceText) {
	                form.death = {
	                    type: this.deathType,
	                    date: this.deathDate,
	                    place: this.deathPlace,
	                    placeText: this.deathPlaceText
	                };
	            }
	        }
	        if (!!this.marriageDate || !!this.marriagePlace || !!this.marriagePlaceText) {
	            form.marriage = {
	                type: this.marriageType,
	                date: this.marriageDate,
	                place: this.marriagePlace,
	                placeText: this.marriagePlaceText
	            };
	        }
	        //this.tags.forEach(tag => {
	        //  person.tags[tag] = true;
	        //});
	        this.personUtils.add(form, this.relationshipType, this.relatedToPersonId, family).subscribe(function () {
	            _this.saving = false;
	            _this.$mdDialog.hide(form);
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    return AddPersonController;
	}());
	exports.default = AddPersonController;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var AddInvitationController = /** @class */ (function () {
	    AddInvitationController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus", "invitations"];
	    function AddInvitationController($log, $mdDialog, $mdMedia, $scope, messageBus, invitations) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.invitations = invitations;
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    AddInvitationController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var invitation = {
	            email: this.email,
	            given: this.given,
	            surname: this.surname,
	            level: parseInt(this.rights)
	        };
	        this.invitations.create(invitation).subscribe(function () {
	            _this.saving = false;
	            _this.$mdDialog.hide();
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    AddInvitationController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return AddInvitationController;
	}());
	exports.default = AddInvitationController;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ClipperToastController = /** @class */ (function () {
	    ClipperToastController.$inject = ["$mdToast"];
	    function ClipperToastController($mdToast) {
	        'ngInject';
	        this.$mdToast = $mdToast;
	    }
	    ClipperToastController.prototype.closeToast = function (result) {
	        this.$mdToast.hide(result);
	    };
	    return ClipperToastController;
	}());
	exports.default = ClipperToastController;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var DeleteMediaController = /** @class */ (function () {
	    DeleteMediaController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus", "sources"];
	    function DeleteMediaController($log, $mdDialog, $mdMedia, $scope, messageBus, sources) {
	        'ngInject';
	        var _this = this;
	        // passed in: media
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.sources = sources;
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    DeleteMediaController.prototype.getSourceAbbr = function (sid) {
	        var obj = { value: '' };
	        if (sid > 0) {
	            this.sources.streamId(sid).map(function (source) { return !!source ? source.abbr : ''; }).take(1).subscribe(function (v) {
	                obj.value = v;
	            });
	        }
	        return obj;
	    };
	    DeleteMediaController.prototype.del = function () {
	        this.msg = '';
	        this.$mdDialog.hide();
	    };
	    DeleteMediaController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return DeleteMediaController;
	}());
	exports.default = DeleteMediaController;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var DeletePersonController = /** @class */ (function () {
	    DeletePersonController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus"];
	    function DeletePersonController($log, $mdDialog, $mdMedia, $scope, messageBus) {
	        'ngInject';
	        var _this = this;
	        // passed in: person, evidenceMap
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    DeletePersonController.prototype.del = function () {
	        this.msg = '';
	        this.$mdDialog.hide();
	    };
	    DeletePersonController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return DeletePersonController;
	}());
	exports.default = DeletePersonController;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var DeleteSourceController = /** @class */ (function () {
	    DeleteSourceController.$inject = ["$log", "$mdDialog", "$scope", "messageBus", "persons", "utils"];
	    function DeleteSourceController($log, $mdDialog, $scope, messageBus, persons, utils) {
	        'ngInject';
	        var _this = this;
	        // passed in: evidenceMap
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.persons = persons;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.evidencePersons = new Map();
	        Array.from(this.evidenceMap.values()).forEach(function (evidence) {
	            persons.streamForEvidence(evidence.id).take(1).subscribe(function (pm) {
	                _this.evidencePersons.set(evidence.id, Array.from(pm.values()));
	            });
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    DeleteSourceController.prototype.getPersons = function (evidence) {
	        return this.evidencePersons.get(evidence.id);
	    };
	    DeleteSourceController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return DeleteSourceController;
	}());
	exports.default = DeleteSourceController;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	var DNAFilterController = /** @class */ (function () {
	    DNAFilterController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "$timeout", "messageBus", "dnaKits", "dnaProfileDatas", "utils"];
	    function DNAFilterController($log, $mdDialog, $mdMedia, $scope, $timeout, messageBus, dnaKits, dnaProfileDatas, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.$timeout = $timeout;
	        this.messageBus = messageBus;
	        this.dnaKits = dnaKits;
	        this.dnaProfileDatas = dnaProfileDatas;
	        this.utils = utils;
	        // source, kits, kitCMs, links, kitMatches, filters, personId, msg
	        this.lowest = Math.floor(Array.from(this.kitCMs.values()).reduce(function (min, cms) { return Math.min(min, cms[0], cms[1]); }, 9999));
	        this.highest = Math.ceil(Array.from(this.kitCMs.values()).reduce(function (max, cms) { return Math.max(max, cms[0], cms[1]); }, 0));
	        this.minMax = Math.min(this.highest, this.lowest + 80);
	        this.hasCMs = this.kitCMs.size > 0;
	        if (!this.hasCMs) {
	            this.lowest = 0;
	        }
	        this.changeTimeout = null;
	        if (!this.filters) {
	            this.clear();
	        }
	        else {
	            this.min = Math.max(this.lowest, this.filters.min);
	            this.max = Math.min(this.highest, this.filters.max);
	            this.cmRange = this.filters.cmRange || 'total';
	            this.includeKits = this.filters.includeKits.map(function (id) { return _this.kits.find(function (k) { return k.id === id; }); });
	            this.includeDegrees = this.filters.includeDegrees;
	            this.excludeKits = this.filters.excludeKits.map(function (id) { return _this.kits.find(function (k) { return k.id === id; }); });
	            this.excludeDegrees = this.filters.excludeDegrees;
	            this.includePIDs = this.filters.includePIDs || [];
	            this.excludePIDs = this.filters.excludePIDs || [];
	            this.keywords = this.filters.keywords || '';
	            this.setCount();
	        }
	        $scope.$on('click-person', function (ev, data) {
	            var ancestors = _this.getAncestors(data.person);
	            if (data.submode === 'INCLUDE') {
	                var ix = _this.includePIDs.findIndex(function (id) { return id === data.person.id; });
	                if (ix >= 0 && !_this.includesAll(_this.includePIDs, ancestors)) {
	                    _this.addAll(_this.includePIDs, ancestors);
	                }
	                else if (ix >= 0) {
	                    // remove this + ancestors
	                    _this.includePIDs.splice(ix, 1);
	                    _this.removeAll(_this.includePIDs, ancestors);
	                }
	                else {
	                    // add this
	                    _this.includePIDs.push(data.person.id);
	                }
	            }
	            else {
	                var ix = _this.excludePIDs.findIndex(function (id) { return id === data.person.id; });
	                if (ix >= 0 && !_this.includesAll(_this.excludePIDs, ancestors)) {
	                    _this.addAll(_this.excludePIDs, ancestors);
	                }
	                else if (ix >= 0) {
	                    // remove this + ancestors
	                    _this.excludePIDs.splice(ix, 1);
	                    _this.removeAll(_this.excludePIDs, ancestors);
	                }
	                else {
	                    // add this
	                    _this.excludePIDs.push(data.person.id);
	                }
	            }
	            _this.setCount();
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    DNAFilterController.prototype.getAncestors = function (p) {
	        var results = [];
	        if (!!p.children) {
	            try {
	                for (var _a = __values(p.children), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var child = _b.value;
	                    results.push(child.id);
	                    results.push.apply(results, __spread(this.getAncestors(child)));
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        return results;
	        var e_1, _c;
	    };
	    DNAFilterController.prototype.includesAll = function (pids, ancestors) {
	        return ancestors.every(function (a) { return pids.includes(a); });
	    };
	    DNAFilterController.prototype.addAll = function (pids, ancestors) {
	        try {
	            for (var ancestors_1 = __values(ancestors), ancestors_1_1 = ancestors_1.next(); !ancestors_1_1.done; ancestors_1_1 = ancestors_1.next()) {
	                var a = ancestors_1_1.value;
	                if (!pids.includes(a)) {
	                    pids.push(a);
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (ancestors_1_1 && !ancestors_1_1.done && (_a = ancestors_1.return)) _a.call(ancestors_1);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        var e_2, _a;
	    };
	    DNAFilterController.prototype.removeAll = function (pids, ancestors) {
	        var _loop_1 = function (a) {
	            var ix = pids.findIndex(function (pid) { return pid === a; });
	            if (ix >= 0) {
	                pids.splice(ix, 1);
	            }
	        };
	        try {
	            for (var ancestors_2 = __values(ancestors), ancestors_2_1 = ancestors_2.next(); !ancestors_2_1.done; ancestors_2_1 = ancestors_2.next()) {
	                var a = ancestors_2_1.value;
	                _loop_1(a);
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (ancestors_2_1 && !ancestors_2_1.done && (_a = ancestors_2.return)) _a.call(ancestors_2);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        var e_3, _a;
	    };
	    DNAFilterController.prototype.queryKits = function (query) {
	        return !query ? [] : this.dnaKits.autocomplete(query, this.kits);
	    };
	    DNAFilterController.prototype.change = function (n) {
	        var _this = this;
	        if (this.changeTimeout === null) {
	            this.changeTimeout = this.$timeout(function () {
	                _this.setCount();
	                _this.changeTimeout = null;
	            }, 200);
	        }
	    };
	    DNAFilterController.prototype.setCount = function () {
	        this.count = this.dnaProfileDatas.applyFilters(this.getFilters(), this.kits, this.kitCMs, this.links, this.kitMatches).length;
	    };
	    DNAFilterController.prototype.clear = function () {
	        this.min = this.lowest;
	        this.max = this.highest;
	        this.cmRange = 'total';
	        this.includeKits = [];
	        this.includeDegrees = 1;
	        this.excludeKits = [];
	        this.excludeDegrees = 1;
	        this.includePIDs = [];
	        this.excludePIDs = [];
	        this.keywords = '';
	        this.setCount();
	    };
	    DNAFilterController.prototype.getFilters = function () {
	        return {
	            min: this.min === this.lowest ? 0 : this.min,
	            max: this.max === this.highest ? 9999 : this.max,
	            cmRange: this.cmRange,
	            includeKits: this.includeKits.map(function (k) { return k.id; }),
	            includeDegrees: +this.includeDegrees,
	            excludeKits: this.excludeKits.map(function (k) { return k.id; }),
	            excludeDegrees: +this.excludeDegrees,
	            includePIDs: this.includePIDs,
	            excludePIDs: this.excludePIDs,
	            keywords: this.keywords,
	        };
	    };
	    DNAFilterController.prototype.submit = function () {
	        this.$mdDialog.hide(this.getFilters());
	    };
	    DNAFilterController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return DNAFilterController;
	}());
	exports.default = DNAFilterController;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	var DNAImportFilterController = /** @class */ (function () {
	    DNAImportFilterController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus", "utils"];
	    function DNAImportFilterController($log, $mdDialog, $mdMedia, $scope, messageBus, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.messageBus = messageBus;
	        this.utils = utils;
	        // list, kits
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        this.lowest = Math.floor(this.list.reduce(function (min, obj) { return Math.min(min, obj.autoTotal); }, 7500));
	        this.highest = Math.ceil(this.list.reduce(function (max, obj) { return Math.max(max, obj.autoTotal); }, 0));
	        this.min = this.lowest;
	        this.max = this.highest;
	        this.setCount();
	        var mmSub = utils.watch($scope, function () { return _this.min * 10000 + _this.max; }).subscribe(function () {
	            _this.setCount();
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	            mmSub.unsubscribe();
	        });
	    }
	    DNAImportFilterController.prototype.setCount = function () {
	        var _this = this;
	        this.count = this.list.filter(function (obj) { return obj.autoTotal >= _this.min && obj.autoTotal <= _this.max; }).length;
	    };
	    DNAImportFilterController.prototype.submit = function () {
	        var _this = this;
	        var listMap = new Map(this.list.filter(function (obj) { return obj.autoTotal >= _this.min && obj.autoTotal <= _this.max; }).map(function (obj) { return [obj.name, obj]; }));
	        var kits = this.kits.filter(function (obj) { return listMap.has(obj.name); });
	        this.$mdDialog.hide([Array.from(listMap.values()), kits]);
	    };
	    DNAImportFilterController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return DNAImportFilterController;
	}());
	exports.default = DNAImportFilterController;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditDNAKitController = /** @class */ (function () {
	    EditDNAKitController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "$timeout", "$filter", "currentTree", "dnaKits", "dnaParsers", "dnaProfiles", "persons", "families", "users", "treeUsers", "rights", "currentTreeId", "messageBus", "server", "utils"];
	    function EditDNAKitController($log, $mdDialog, $mdMedia, $scope, $timeout, $filter, currentTree, dnaKits, dnaParsers, dnaProfiles, persons, families, users, treeUsers, rights, currentTreeId, messageBus, server, utils) {
	        'ngInject';
	        var _this = this;
	        // passed in: kit, dnaProfile
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.$timeout = $timeout;
	        this.dnaKits = dnaKits;
	        this.dnaParsers = dnaParsers;
	        this.dnaProfiles = dnaProfiles;
	        this.persons = persons;
	        this.families = families;
	        this.messageBus = messageBus;
	        this.server = server;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        // passed in: kit, pedigree, dnaProfile, tab
	        this.numTabs = 4;
	        this.tabIndex = this.tab || 0;
	        this.spouses = [];
	        this.treeList = [];
	        this.wikiTree = null;
	        this.gedmatchTree = null;
	        this.minitree = null;
	        this.isProcessing = false;
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        if (!!this.kit) {
	            treeUsers.stream().take(1).subscribe(function (tu) {
	                if ((tu.preferences['PRESENTATION_MODE'] || 'FALSE') === 'TRUE') {
	                    _this.name = $filter('presentationMode')(_this.kit.name);
	                    _this._user = $filter('presentationMode')(_this.kit._user);
	                    _this.user = $filter('presentationMode')(_this.kit.user);
	                    _this.email = $filter('presentationMode')(_this.kit.email);
	                    _this.managerName = $filter('presentationMode')(_this.kit.managerName);
	                    _this.contactURL = $filter('presentationMode')(_this.kit.ncontactURL);
	                    _this.url = $filter('presentationMode')(_this.kit.url);
	                }
	                else {
	                    _this.name = _this.kit.name;
	                    _this._user = _this.kit._user;
	                    _this.user = _this.kit.user;
	                    _this.email = _this.kit.email;
	                    _this.managerName = _this.kit.managerName;
	                    _this.contactURL = _this.kit.contactURL;
	                    _this.url = _this.kit.url;
	                }
	            });
	            this.minitree = this.kit.minitree;
	            this.sex = this.kit.sex;
	            this.ageRange = this.kit.ageRange;
	            this.haploMt = this.kit.haploMt;
	            this.haploY = this.kit.haploY;
	            this.hidden = this.kit.hidden;
	            this.text = this.kit.text;
	            this.surnames = this.kit.surnames;
	            this.locations = this.kit.locations;
	            this.matchType = this.kit.matchType || '';
	            this.trees = Array.from(this.kit.treeURLs.keys()).join('\n');
	            this.treeList = this.getTrees();
	            this.wikiTree = this.treeList.find(function (url) { return url.includes('wikitree.com'); });
	            this.gedmatchTree = this.treeList.find(function (url) { return url.includes('gedmatch.com'); });
	            if ((this.kit.matchType === 'SELF' || this.kit.matchType === 'DESCENDANT' || this.kit.matchType === 'LINE') && !!this.kit.personId1) {
	                persons.streamId(this.kit.personId1).take(1).subscribe(function (person) {
	                    _this.relative1 = person;
	                    _this.setDefaultColor();
	                });
	            }
	            if (this.kit.matchType === 'DESCENDANT') {
	                this.relativeId2 = this.kit.personId2;
	                if (!!this.kit.personId2) {
	                    persons.streamId(this.kit.personId2).take(1).subscribe(function (person) {
	                        if (!!person) {
	                            _this.spouses.push(person);
	                        }
	                    });
	                }
	                else {
	                    this.spouses.push({ id: 0, _fullName: 'Unknown', _lifespan: '' });
	                }
	            }
	            this.colorOverride = this.kit.colorOverride ? this.kit.colorOverride.toString() : '';
	        }
	        this.colors = {};
	        this.colorLabels = {};
	        currentTree.stream().filter(function (t) { return !!t; }).take(1).subscribe(function (tree) {
	            _this.colors['PGF'] = tree.preferences.COLOR_PGF;
	            _this.colors['PGM'] = tree.preferences.COLOR_PGM;
	            _this.colors['MGF'] = tree.preferences.COLOR_MGF;
	            _this.colors['MGM'] = tree.preferences.COLOR_MGM;
	            _this.colors['1'] = tree.preferences.COLOR_1;
	            _this.colors['2'] = tree.preferences.COLOR_2;
	            _this.colors['3'] = tree.preferences.COLOR_3;
	            _this.colors['4'] = tree.preferences.COLOR_4;
	            _this.colors['5'] = tree.preferences.COLOR_5;
	            _this.colors['6'] = tree.preferences.COLOR_6;
	            _this.colors['NOT'] = tree.preferences.COLOR_NOT;
	            _this.colorLabel['1'] = tree.preferences.COLOR_LABEL_1;
	            _this.colorLabel['2'] = tree.preferences.COLOR_LABEL_2;
	            _this.colorLabel['3'] = tree.preferences.COLOR_LABEL_3;
	            _this.colorLabel['4'] = tree.preferences.COLOR_LABEL_4;
	            _this.colorLabel['5'] = tree.preferences.COLOR_LABEL_5;
	            _this.colorLabel['6'] = tree.preferences.COLOR_LABEL_6;
	            if (!!_this.kit) {
	                _this.setDefaultColor();
	            }
	        });
	        this.froalaTextOptions = utils.froalaOptions(utils.atConfigUser(users, rights, currentTreeId), function () {
	            // ignore
	        });
	        $scope.$on('paste', function (ev, params) {
	            _this.isProcessing = true;
	            _this.server.incRequests();
	            $timeout(function () {
	                _this.paste(params);
	            }, 100);
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    EditDNAKitController.prototype.setDefaultColor = function () {
	        var _this = this;
	        this.defaultColor = '';
	        if (this.matchType === 'NOT') {
	            this.defaultColor = 'NOT';
	        }
	        else if (!!this.relative1) {
	            this.dnaProfiles.getMatches(this.pedigree, [this.relative1.id]).take(1).subscribe(function (matches) {
	                if (matches.length > 0) {
	                    var match = matches[0];
	                    if (match < 4) {
	                        match *= 4;
	                    }
	                    while (match >= 8) {
	                        match = match >>> 1; // jshint ignore:line
	                    }
	                    switch (match) {
	                        case 4:
	                            _this.defaultColor = 'PGF';
	                            break;
	                        case 5:
	                            _this.defaultColor = 'PGM';
	                            break;
	                        case 6:
	                            _this.defaultColor = 'MGF';
	                            break;
	                        case 7:
	                            _this.defaultColor = 'MGM';
	                            break;
	                    }
	                }
	            });
	        }
	    };
	    EditDNAKitController.prototype.colorStyle = function (ix) {
	        var color;
	        if (!!ix) {
	            color = this.utils.colors[this.colors[ix]][3];
	        }
	        else if (this.defaultColor) {
	            color = this.utils.colors[this.colors[this.defaultColor]][3];
	        }
	        else {
	            color = '#ffffff';
	        }
	        return { 'background-color': color };
	    };
	    EditDNAKitController.prototype.colorLabel = function (ix) {
	        return this.colorLabel[ix];
	    };
	    EditDNAKitController.prototype.changeMatchType = function () {
	        if (this.matchType !== 'SELF' && this.matchType !== 'DESCENDANT' && this.matchType !== 'LINE') {
	            this.relative1 = null;
	            this.relativeText1 = '';
	            this.relativeId2 = 0;
	        }
	        this.setDefaultColor();
	    };
	    EditDNAKitController.prototype.queryPerson = function (query) {
	        return !query ? [] : this.persons.nameAutocomplete(query);
	    };
	    EditDNAKitController.prototype.selectedPersonChange = function (person) {
	        var _this = this;
	        this.spouses = [];
	        this.relativeId2 = 0;
	        if (!!person) {
	            if (!this.matchType) {
	                this.matchType = 'SELF';
	            }
	            this.families.streamSpouses(person.id).take(1).subscribe(function (fm) {
	                fm.forEach(function (f) {
	                    var spouseId = (f.husbandId === person.id ? f.wifeId : f.husbandId);
	                    if (spouseId > 0) {
	                        if (_this.relativeId2 === 0) {
	                            _this.relativeId2 = spouseId;
	                        }
	                        _this.persons.streamId(spouseId).take(1).subscribe(function (person) {
	                            _this.spouses.push(person);
	                        });
	                    }
	                });
	                _this.spouses.push({ id: 0, _fullName: 'Unknown', _lifespan: '' });
	            });
	        }
	        this.setDefaultColor();
	    };
	    EditDNAKitController.prototype.paste = function (params) {
	        var tree;
	        if (params.html.includes('COPYRIGHTED BY WIKITREE')) {
	            tree = this.dnaParsers.parseWikiTree(params.html);
	        }
	        else {
	            tree = this.dnaParsers.parseGedMatchPedigree(params.html);
	        }
	        if (!!tree) {
	            this.cleanTree(tree);
	            this.minitree = angular.toJson(tree);
	            var cntPeople = this.countPeople(tree);
	            this.messageBus.post({ msg: 'Mini-tree imported successfully (' + cntPeople + ' people). Click Save to save the tree.' });
	        }
	        else {
	            this.messageBus.post({ msg: 'Error importing mini-tree; please try again or contact support@rootsfinder.com' });
	        }
	        this.isProcessing = false;
	        this.server.decRequests();
	    };
	    EditDNAKitController.prototype.cleanTree = function (tree) {
	        delete tree.offset;
	        delete tree.url;
	        delete tree.id;
	        if (!!tree.father) {
	            this.cleanTree(tree.father);
	        }
	        if (!!tree.mother) {
	            this.cleanTree(tree.mother);
	        }
	    };
	    EditDNAKitController.prototype.countPeople = function (tree) {
	        return !!tree ? 1 + this.countPeople(tree.father) + this.countPeople(tree.mother) : 0;
	    };
	    EditDNAKitController.prototype.deleteMinitree = function () {
	        this.minitree = null;
	        this.messageBus.post({ msg: 'Mini-tree deleted; click Save.' });
	    };
	    EditDNAKitController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    EditDNAKitController.prototype.back = function () {
	        if (this.tabIndex > 0) {
	            this.tabIndex--;
	        }
	    };
	    EditDNAKitController.prototype.next = function () {
	        if (this.tabIndex < this.numTabs - 1) {
	            this.tabIndex++;
	        }
	    };
	    EditDNAKitController.prototype.treesChanged = function () {
	        this.treeList = this.getTrees();
	        this.wikiTree = this.treeList.find(function (url) { return url.includes('wikitree.com'); });
	        this.gedmatchTree = this.treeList.find(function (url) { return url.includes('gedmatch.com'); });
	    };
	    EditDNAKitController.prototype.getTrees = function () {
	        return this.trees.trim().length > 0 ? this.trees.trim().split('\n') : [];
	    };
	    EditDNAKitController.prototype.save = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var kit = this.utils.clone(this.kit);
	        kit.user = this.user;
	        kit.email = this.email;
	        kit.managerName = this.managerName;
	        kit.contactURL = this.contactURL;
	        kit.sex = this.sex;
	        kit.ageRange = this.ageRange;
	        kit.haploMt = this.haploMt;
	        kit.haploY = this.haploY;
	        kit.hidden = this.hidden;
	        kit.url = this.url;
	        kit.text = this.text;
	        kit.surnames = this.surnames;
	        kit.locations = this.locations;
	        kit.treeURLs = new Map(this.getTrees().map(function (v) { return [v, true]; }));
	        kit.minitree = this.minitree || '';
	        kit.matchType = this.matchType;
	        kit.colorOverride = +this.colorOverride;
	        if (this.matchType === 'SELF' || this.matchType === 'DESCENDANT' || this.matchType === 'LINE') {
	            if (!!this.relative1) {
	                kit.personId1 = this.relative1.id || 0;
	            }
	            else {
	                kit.matchType = '';
	                kit.personId1 = 0;
	            }
	        }
	        else {
	            kit.personId1 = 0;
	        }
	        if (this.matchType === 'DESCENDANT') {
	            kit.personId2 = +this.relativeId2 || 0;
	        }
	        else {
	            kit.personId2 = 0;
	        }
	        this.dnaKits.update(kit).subscribe(function (kit) {
	            _this.saving = false;
	            _this.$mdDialog.hide(kit);
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    return EditDNAKitController;
	}());
	exports.default = EditDNAKitController;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditDNAMatchesController = /** @class */ (function () {
	    EditDNAMatchesController.$inject = ["$log", "$mdDialog", "$scope", "rx", "currentTree", "dnaKits", "dnaProfiles", "persons", "families", "messageBus", "utils"];
	    function EditDNAMatchesController($log, $mdDialog, $scope, rx, currentTree, dnaKits, dnaProfiles, persons, families, messageBus, utils) {
	        'ngInject';
	        var _this = this;
	        // passed in: kit, dnaProfile
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.rx = rx;
	        this.dnaKits = dnaKits;
	        this.dnaProfiles = dnaProfiles;
	        this.persons = persons;
	        this.families = families;
	        this.messageBus = messageBus;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        // passed in: kits, pedigree, dnaProfile
	        this.spouses = [];
	        this.matchType = '';
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        this.colors = {};
	        this.colorLabels = {};
	        currentTree.stream().filter(function (t) { return !!t; }).take(1).subscribe(function (tree) {
	            _this.colors['PGF'] = tree.preferences.COLOR_PGF;
	            _this.colors['PGM'] = tree.preferences.COLOR_PGM;
	            _this.colors['MGF'] = tree.preferences.COLOR_MGF;
	            _this.colors['MGM'] = tree.preferences.COLOR_MGM;
	            _this.colors['1'] = tree.preferences.COLOR_1;
	            _this.colors['2'] = tree.preferences.COLOR_2;
	            _this.colors['3'] = tree.preferences.COLOR_3;
	            _this.colors['4'] = tree.preferences.COLOR_4;
	            _this.colors['5'] = tree.preferences.COLOR_5;
	            _this.colors['6'] = tree.preferences.COLOR_6;
	            _this.colors['NOT'] = tree.preferences.COLOR_NOT;
	            _this.colorLabel['1'] = tree.preferences.COLOR_LABEL_1;
	            _this.colorLabel['2'] = tree.preferences.COLOR_LABEL_2;
	            _this.colorLabel['3'] = tree.preferences.COLOR_LABEL_3;
	            _this.colorLabel['4'] = tree.preferences.COLOR_LABEL_4;
	            _this.colorLabel['5'] = tree.preferences.COLOR_LABEL_5;
	            _this.colorLabel['6'] = tree.preferences.COLOR_LABEL_6;
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    EditDNAMatchesController.prototype.setDefaultColor = function () {
	        var _this = this;
	        this.defaultColor = '';
	        if (this.matchType === 'NOT') {
	            this.defaultColor = 'NOT';
	        }
	        else if (!!this.relative1) {
	            this.dnaProfiles.getMatches(this.pedigree, [this.relative1.id]).take(1).subscribe(function (matches) {
	                if (matches.length > 0) {
	                    var match = matches[0];
	                    if (match < 4) {
	                        match *= 4;
	                    }
	                    while (match >= 8) {
	                        match = match >>> 1; // jshint ignore:line
	                    }
	                    switch (match) {
	                        case 4:
	                            _this.defaultColor = 'PGF';
	                            break;
	                        case 5:
	                            _this.defaultColor = 'PGM';
	                            break;
	                        case 6:
	                            _this.defaultColor = 'MGF';
	                            break;
	                        case 7:
	                            _this.defaultColor = 'MGM';
	                            break;
	                    }
	                }
	            });
	        }
	    };
	    EditDNAMatchesController.prototype.colorStyle = function (ix) {
	        var color;
	        if (!!ix) {
	            color = this.utils.colors[this.colors[ix]][3];
	        }
	        else if (this.defaultColor) {
	            color = this.utils.colors[this.colors[this.defaultColor]][3];
	        }
	        else {
	            color = '#ffffff';
	        }
	        return { 'background-color': color };
	    };
	    EditDNAMatchesController.prototype.colorLabel = function (ix) {
	        return this.colorLabel[ix];
	    };
	    EditDNAMatchesController.prototype.changeMatchType = function () {
	        if (this.matchType !== 'SELF' && this.matchType !== 'DESCENDANT' && this.matchType !== 'LINE') {
	            this.relative1 = null;
	            this.relativeText1 = '';
	            this.relativeId2 = 0;
	        }
	        this.setDefaultColor();
	    };
	    EditDNAMatchesController.prototype.queryPerson = function (query) {
	        return !query ? [] : this.persons.nameAutocomplete(query);
	    };
	    EditDNAMatchesController.prototype.selectedPersonChange = function (person) {
	        var _this = this;
	        this.spouses = [];
	        this.relativeId2 = 0;
	        if (!!person) {
	            if (!this.matchType) {
	                this.matchType = 'SELF';
	            }
	            this.families.streamSpouses(person.id).take(1).subscribe(function (fm) {
	                fm.forEach(function (f) {
	                    var spouseId = (f.husbandId === person.id ? f.wifeId : f.husbandId);
	                    if (spouseId > 0) {
	                        if (_this.relativeId2 === 0) {
	                            _this.relativeId2 = spouseId;
	                        }
	                        _this.persons.streamId(spouseId).take(1).subscribe(function (person) {
	                            _this.spouses.push(person);
	                        });
	                    }
	                });
	                _this.spouses.push({ id: 0, _fullName: 'Unknown', _lifespan: '' });
	            });
	        }
	        this.setDefaultColor();
	    };
	    EditDNAMatchesController.prototype.matchKit = function (kit) {
	        kit = this.utils.clone(kit);
	        kit.matchType = this.matchType;
	        kit.colorOverride = +this.colorOverride;
	        if (this.matchType === 'SELF' || this.matchType === 'DESCENDANT' || this.matchType === 'LINE') {
	            if (!!this.relative1) {
	                kit.personId1 = this.relative1.id || 0;
	            }
	            else {
	                kit.matchType = '';
	                kit.personId1 = 0;
	            }
	        }
	        else {
	            kit.personId1 = 0;
	        }
	        if (this.matchType === 'DESCENDANT') {
	            kit.personId2 = +this.relativeId2 || 0;
	        }
	        else {
	            kit.personId2 = 0;
	        }
	        return kit;
	    };
	    EditDNAMatchesController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    EditDNAMatchesController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        this.rx.Observable.forkJoin(this.kits.map(function (kit) {
	            return _this.dnaKits.update(_this.matchKit(kit));
	        })).subscribe(function (kits) {
	            _this.saving = false;
	            _this.$mdDialog.hide(kits);
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    return EditDNAMatchesController;
	}());
	exports.default = EditDNAMatchesController;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	var EditDNAProfileController = /** @class */ (function () {
	    EditDNAProfileController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "$timeout", "messageBus", "dnaProfiles", "dnaProfileDatas", "dnaKits", "persons", "utils"];
	    function EditDNAProfileController($log, $mdDialog, $mdMedia, $scope, $timeout, messageBus, dnaProfiles, dnaProfileDatas, dnaKits, persons, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.$timeout = $timeout;
	        this.messageBus = messageBus;
	        this.dnaProfiles = dnaProfiles;
	        this.dnaProfileDatas = dnaProfileDatas;
	        this.dnaKits = dnaKits;
	        this.persons = persons;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        // if updating, this.dnaProfile is passed in
	        this.sources = dnaProfiles.sources;
	        var personId = 0;
	        this.source = '';
	        this.updating = !!this.dnaProfile;
	        if (this.updating) {
	            this.name = this.dnaProfile.name;
	            this.description = this.dnaProfile.description || '';
	            this.source = this.dnaProfile.source;
	            this.archived = this.dnaProfile.archived;
	            personId = this.dnaProfile.personId;
	            if (this.archived) {
	                messageBus.post({ msg: 'You need to unarchive this profile to see matching kits.' });
	            }
	        }
	        this.person = null;
	        if (personId > 0) {
	            persons.streamId(personId).take(1).subscribe(function (person) {
	                _this.person = person;
	            });
	        }
	        this.focusField = '';
	        this.froalaOptions = utils.froalaOptions(null, function () {
	            $timeout(function () {
	                _this.focusField = 'text';
	            });
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    EditDNAProfileController.prototype.focus = function (fld) {
	        this.focusField = fld;
	    };
	    EditDNAProfileController.prototype.queryPerson = function (query) {
	        return !query ? [] : this.persons.nameAutocomplete(query);
	    };
	    EditDNAProfileController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        if (!this.person) {
	            this.messageBus.post({ msg: 'You need to attach this kit to someone in your tree. Cancel this dialog, add this person to your tree, then return here.' });
	            return;
	        }
	        var dnaProfile = this.updating ? this.utils.clone(this.dnaProfile) : { id: 0 };
	        var archived = dnaProfile.archived;
	        dnaProfile.name = this.name;
	        dnaProfile.description = this.description;
	        dnaProfile.source = this.source;
	        dnaProfile.archived = this.archived;
	        dnaProfile.personId = this.person.id;
	        this.saving = true;
	        var stream = this.updating ? this.dnaProfiles.update(dnaProfile) : this.dnaProfiles.create(dnaProfile);
	        stream.subscribe(function (dnaProfile) {
	            if (_this.updating && archived !== dnaProfile.archived) {
	                _this.dnaProfileDatas.reset();
	                _this.dnaKits.reset();
	            }
	            _this.saving = false;
	            _this.$log.debug('editDNAProfile.submit', dnaProfile);
	            _this.$mdDialog.hide(dnaProfile);
	        }, function (err) {
	            if (!_this.updating && err.data === 'DUPLICATE_KEY') {
	                _this.$timeout(function () {
	                    _this.messageBus.post({ msg: 'You already have a profile with this name.' });
	                });
	            }
	            _this.saving = false;
	        });
	    };
	    EditDNAProfileController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditDNAProfileController;
	}());
	exports.default = EditDNAProfileController;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditEvidenceController = /** @class */ (function () {
	    EditEvidenceController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "$timeout", "rx", "messageBus", "currentTreeId", "evidences", "places", "sources", "persons", "families", "medias", "researchLogs", "rights", "users", "evidenceUtils", "utils"];
	    function EditEvidenceController($log, $mdDialog, $mdMedia, $scope, $timeout, rx, messageBus, currentTreeId, evidences, places, sources, persons, families, medias, researchLogs, rights, users, evidenceUtils, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.$timeout = $timeout;
	        this.rx = rx;
	        this.messageBus = messageBus;
	        this.currentTreeIdService = currentTreeId;
	        this.evidences = evidences;
	        this.places = places;
	        this.sources = sources;
	        this.persons = persons;
	        this.families = families;
	        this.mediaService = medias;
	        this.evidenceUtils = evidenceUtils;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.vitalTypes = ['BIRT', 'CHR', 'BAPM', 'MARR', 'DIV', 'DEAT', 'BURI', 'SOUR'];
	        this.nameType = '';
	        this.isSubmitted = false;
	        this.source = null;
	        this.citationOverridden = true;
	        this.saving = false;
	        // passed in: personId (and maybe evidence, fact, or name) or nothing, and also maybe tabIndex and researchLogId
	        this.tabIndex = this.tabIndex || 0;
	        this.focusField = '';
	        this.froalaTextOptions = utils.froalaOptions(utils.atConfigUser(users, rights, currentTreeId), function () {
	            $timeout(function () {
	                _this.focusField = 'text';
	            });
	        });
	        this.froalaCitationOptions = utils.froalaOptions(null, function () {
	            $timeout(function () {
	                _this.focusField = 'citation';
	            });
	        });
	        this.relationshipTypes = utils.relationshipTypes;
	        this.nameTypes = utils.nameTypes;
	        this.personas = [];
	        this.medias = [];
	        users.streamAllUsers(rights).take(1).subscribe(function (allUsers) {
	            _this.allUsers = allUsers;
	        });
	        // if we are editing an evidence
	        if (!!this.evidence) {
	            this.tabIndex = this.tabIndex || 1;
	            // set name or fact
	            if (this.evidence.fact.type === 'NAME') {
	                var name_1 = null;
	                var persona = this.utils.first(this.evidence.personas);
	                if (!!persona && !!persona.names) {
	                    name_1 = this.utils.first(persona.names);
	                }
	                this.setName(name_1 || {});
	                this.date = this.evidence.fact.date || '';
	                this.dateSort = this.evidence.fact.dateSort || '';
	            }
	            else {
	                if (!this.evidence.fact.type) {
	                    this.evidence.fact.type = 'Other';
	                }
	                this.setFact(this.evidence.fact);
	            }
	            // set medias, text, source
	            this.text = this.evidence.text;
	            this.researchLogId = this.evidence.researchLogId || '';
	            var citation = this.evidence.citation;
	            if (!!citation) {
	                this.url = citation.url;
	                this.page = citation.page;
	                this.sourceDate = citation.date;
	                this.citation = citation.text || '';
	                if (citation.sourceId > 0) {
	                    if (!this.citation) {
	                        this.citationOverridden = false;
	                    }
	                    sources.streamId(citation.sourceId).take(1).subscribe(function (source) {
	                        if (!source) {
	                            _this.source = null;
	                            _this.citationOverridden = false;
	                            _this.citation = '';
	                        }
	                        else {
	                            _this.source = utils.clone(source);
	                            if (!_this.citationOverridden) {
	                                _this.citation = _this.utils.getCitation(_this.source, _this.url, _this.page, _this.sourceDate);
	                            }
	                        }
	                    });
	                }
	            }
	            var mediaIds = Array.from(this.evidence.mediaIds.keys());
	            if (mediaIds.length > 0) {
	                medias.streamIds(mediaIds).take(1).subscribe(function (mediaMap) {
	                    _this.medias = Array.from(mediaMap.values());
	                });
	            }
	            // set personas
	            this.personas = Array.from(this.evidence._personas.entries()).sort(function (_a, _b) {
	                var _c = __read(_a, 1), k1 = _c[0];
	                var _d = __read(_b, 1), k2 = _d[0];
	                return k1 - k2;
	            }).map(function (_a) {
	                var _b = __read(_a, 2), persona = _b[1];
	                var relType = _this.relationshipTypes.find(function (rt) { return rt.value === persona.relationshipType; });
	                var pa = {
	                    key: persona._key,
	                    relationshipType: !!relType ? relType.value : !persona.relationshipType ? '' : 'OTHER',
	                    role: !relType ? persona.relationshipType : '',
	                    relatedToKey: persona.relatedToKey.toString(),
	                    principal: persona.principal,
	                    facts: new Map(),
	                    person: null
	                };
	                if (persona._id > 0) {
	                    _this.persons.streamId(persona._id).take(1).subscribe(function (person) {
	                        pa.person = person;
	                    });
	                }
	                // set persona name
	                if (_this.evidence.type !== 'NAME' && persona.names.size > 0) {
	                    var nf = _this.persons.getDefaultNameForm(_this.utils.first(persona.names));
	                    if (!!nf) {
	                        pa.nameGiven = nf.given;
	                        pa.nameSurname = nf.surname;
	                        pa.namePrefix = nf.prefix;
	                        pa.nameSuffix = nf.suffix;
	                    }
	                }
	                // set persona facts
	                Array.from(persona.facts.entries()).sort(function (_a, _b) {
	                    var _c = __read(_a, 1), k1 = _c[0];
	                    var _d = __read(_b, 1), k2 = _d[0];
	                    return k1 - k2;
	                }).forEach(function (_a) {
	                    var _b = __read(_a, 2), key = _b[0], fact = _b[1];
	                    var typ = _this.utils.factTypes.find(function (ft) { return ft.value === fact.type; });
	                    pa.facts.set(key, {
	                        key: key,
	                        type: !!typ ? typ : '',
	                        typeText: !typ ? fact.type : '',
	                        date: fact.date,
	                        value: fact.value,
	                        placeText: fact.place,
	                        place: !!fact.placeStandard ? {
	                            name: fact.place,
	                            standardName: fact.placeStandard,
	                            latitude: fact.latitude,
	                            longitude: fact.longitude
	                        } : ''
	                    });
	                });
	                return pa;
	            });
	            this.personas.forEach(function (pa, ix) {
	                _this.updatePersonaSettings(_this.personas, ix);
	            });
	        }
	        else if (!!this.fact) {
	            this.setFact(this.fact);
	            this.principalId = this.fact.principalId; // needed to set spouse in updatePersona
	            this.tabIndex = 1;
	        }
	        else if (!!this.name) {
	            this.setName(this.name);
	            this.tabIndex = 1;
	        }
	        this.typeChange(true);
	        this.fileTypes = medias.fileTypes;
	        this.fileModelOptions = medias.fileModelOptions;
	        this.fileValidation = medias.fileValidation;
	        this.fileDragover = medias.fileDragover;
	        this.mediaSlots = [];
	        this.addMediaSlot();
	        this.logs = [];
	        var rlSub = utils.watch($scope, function () { return _this.people; }, true)
	            .flatMap(function () { return researchLogs.ready(); })
	            .flatMap(function () { return researchLogs.stream(); })
	            .subscribe(function (logMap) {
	            _this.logs = _this.utils.getResearchLogTitles(logMap, _this.people);
	        });
	        var tiSub = utils.watch($scope, function () { return _this.tabIndex; }).subscribe(function (_a) {
	            var oldValue = _a.oldValue;
	            if (oldValue === 3) {
	                _this.setPeople();
	            }
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            if (!!rlSub) {
	                rlSub.unsubscribe();
	            }
	            mbSub.unsubscribe();
	            tiSub.unsubscribe();
	        });
	    }
	    EditEvidenceController.prototype.setFact = function (fact) {
	        var _this = this;
	        this.type = fact.type;
	        var typ = this.utils.factTypes.find(function (ft) { return ft.value === _this.type; });
	        if (!!typ) {
	            if (typ.common) {
	                if (this.vitalTypes.indexOf(this.type) >= 0) {
	                    this.vitalEventType = this.type;
	                }
	                else {
	                    this.otherEventType = this.type;
	                }
	            }
	            else {
	                this.vitalEventType = '';
	                this.otherEventType = 'OTHER';
	                this.selectedType = typ;
	            }
	        }
	        else {
	            this.typeText = this.type;
	        }
	        this.value = fact.value;
	        this.date = fact.date;
	        this.dateSort = fact.dateSort;
	        this.placeText = fact.place;
	        this.placeDetails = fact.placeDetails;
	        if (!!fact.placeStandard) {
	            this.place = {
	                name: fact.place,
	                standardName: fact.placeStandard,
	                latitude: fact.latitude,
	                longitude: fact.longitude
	            };
	        }
	    };
	    EditEvidenceController.prototype.setName = function (name) {
	        this.type = 'NAME';
	        this.otherEventType = this.type;
	        this.nameType = name.type;
	        var nf = this.persons.getDefaultNameForm(name);
	        if (!!nf) {
	            this.nameGiven = nf.given;
	            this.nameSurname = nf.surname;
	            this.namePrefix = nf.prefix;
	            this.nameSuffix = nf.suffix;
	        }
	    };
	    //
	    // type
	    //
	    EditEvidenceController.prototype.vitalEventChange = function () {
	        delete this.otherEventType;
	        this.type = this.vitalEventType;
	        this.typeChange();
	    };
	    EditEvidenceController.prototype.otherEventChange = function () {
	        delete this.vitalEventType;
	        this.type = this.otherEventType === 'OTHER' ? this.getOtherType() : this.otherEventType;
	        this.typeChange();
	    };
	    EditEvidenceController.prototype.typeTextChange = function () {
	        delete this.vitalEventType;
	        this.otherEventType = 'OTHER';
	        this.type = this.getOtherType();
	        this.typeChange();
	    };
	    EditEvidenceController.prototype.typeSelectedChange = function () {
	        this.type = this.getOtherType();
	        this.typeChange();
	    };
	    EditEvidenceController.prototype.getOtherType = function () {
	        return !!this.selectedType ? this.selectedType.value : this.typeText;
	    };
	    EditEvidenceController.prototype.queryType = function (query) {
	        query = query.trim().toLowerCase();
	        if (!query) {
	            return this.rx.Observable.of(null);
	        }
	        return this.utils.factTypes.filter(function (ft) { return !ft.common && ft.display.toLowerCase().startsWith(query); });
	    };
	    EditEvidenceController.prototype.typeChange = function (initial) {
	        var _this = this;
	        if (initial === void 0) { initial = false; }
	        if (!!this.evidence) {
	            return;
	        }
	        var typ = this.utils.factTypes.find(function (ft) { return ft.value === _this.type; });
	        if (this.personas.length === 0) {
	            this.addPersona(this.personas);
	            if (this.personId > 0) {
	                this.persons.streamId(this.personId).take(1).subscribe(function (person) {
	                    _this.personas[0].person = person;
	                    _this.updatePersonaSettings(_this.personas, 0);
	                });
	            }
	        }
	        this.updatePersona('FATHER', !!typ && typ.parents, initial, 'husbandId');
	        this.updatePersona('MOTHER', !!typ && typ.parents, initial, 'wifeId');
	        this.updatePersona('SPOUSE', !!typ && typ.spouse, initial);
	        this.personas.forEach(function (pa, ix) {
	            _this.updatePersonaSettings(_this.personas, ix);
	        });
	    };
	    EditEvidenceController.prototype.updatePersona = function (rel, add, initial, parentField) {
	        var _this = this;
	        if (add && !this.personas.some(function (pa) { return pa.relationshipType === rel && parseInt(pa.relatedToKey, 10) === _this.personas[0].key; })) {
	            var ix_1 = 0;
	            if (!this.personas.some(function (pa) { return pa.relationshipType === rel && parseInt(pa.relatedToKey, 10) === _this.personas[0].key; })) {
	                this.addPersona(this.personas);
	                ix_1 = this.personas.length - 1;
	                this.personas[ix_1].relationshipType = rel;
	                this.personas[ix_1].relatedToKey = this.personas[0].key.toString();
	            }
	            if (!!parentField && this.personId > 0 && ix_1 > 0) {
	                this.persons.streamId(this.personId).take(1).subscribe(function (person) {
	                    _this.families.streamParents(_this.personId).take(1).subscribe(function (fm) {
	                        var pf = _this.families.getPreferredFamily(fm, person.preferredParentsFamilyId);
	                        if (!!pf && pf[parentField] > 0) {
	                            _this.persons.streamId(pf[parentField]).take(1).subscribe(function (p) {
	                                _this.personas[ix_1].person = p;
	                                _this.updatePersonaSettings(_this.personas, ix_1);
	                            });
	                        }
	                    });
	                });
	            }
	            if (!parentField && this.principalId > 0 && ix_1 > 0) {
	                this.persons.streamId(this.principalId).take(1).subscribe(function (p) {
	                    _this.personas[ix_1].person = p;
	                    _this.updatePersonaSettings(_this.personas, ix_1);
	                });
	            }
	        }
	        if (!add && !initial) {
	            var ix = this.personas.findIndex(function (pa) { return pa.relationshipType === rel && parseInt(pa.relatedToKey, 10) === _this.personas[0].key; });
	            if (ix > 0 && this.personas[ix].facts.size === 0 && !this.personas[ix].nameGiven && !this.personas[ix].nameSurname) {
	                this.removePersona(this.personas, ix);
	            }
	        }
	    };
	    //
	    // details
	    //
	    EditEvidenceController.prototype.queryPlace = function (text) {
	        return !!text ? this.places.autocomplete(text) : [];
	    };
	    //
	    // media
	    //
	    EditEvidenceController.prototype.hasEmptyMediaSlot = function () {
	        return this.mediaSlots.some(function (ms) { return !ms.fileStatus; });
	    };
	    EditEvidenceController.prototype.addMediaSlot = function () {
	        this.mediaSlots.push({
	            fileStatus: '',
	            cropped: false
	        });
	    };
	    EditEvidenceController.prototype.isImageFile = function (file) {
	        return this.mediaService.isImageFile(file);
	    };
	    EditEvidenceController.prototype.getImageFormat = function (file) {
	        return this.mediaService.getImageFormat(file);
	    };
	    EditEvidenceController.prototype.fileChange = function (mediaSlot, files) {
	        this.$log.debug('fileChange', files);
	        if (!!files && files.length > 0) {
	            mediaSlot.fileName = files[0].name;
	            mediaSlot.fileDataURI = '';
	            mediaSlot.cropped = false;
	            this.focus('file');
	            if (!!files[0] && this.isImageFile(files[0])) {
	                mediaSlot.fileStatus = 'loading';
	            }
	            else {
	                mediaSlot.fileStatus = 'noimage';
	            }
	        }
	    };
	    EditEvidenceController.prototype.fileLoadDone = function (mediaSlot) {
	        if (mediaSlot.fileStatus === 'loading') {
	            this.$timeout(function () {
	                mediaSlot.fileStatus = 'loaded';
	            });
	        }
	        // spurious fileChange events get sent for 1-2 seconds after file loaded
	        this.$timeout(function () {
	            mediaSlot.cropped = false;
	        }, 1500);
	    };
	    EditEvidenceController.prototype.fileChangeCrop = function (mediaSlot) {
	        mediaSlot.cropped = true;
	    };
	    EditEvidenceController.prototype.removeMedia = function (medias, ix) {
	        medias.splice(ix, 1);
	    };
	    EditEvidenceController.prototype.removeMediaSlot = function (mediaSlots, ix) {
	        mediaSlots.splice(ix, 1);
	    };
	    EditEvidenceController.prototype.getMediaFileType = function (media) {
	        return Array.from(media.fileInfos.values())[0].contentType;
	    };
	    EditEvidenceController.prototype.getMediaFileURL = function (media) {
	        return this.mediaService.getFileURL(media.id, Array.from(media.fileInfos.keys())[0], '100x100');
	    };
	    //
	    // source
	    //
	    EditEvidenceController.prototype.querySource = function (text) {
	        return !!text ? this.sources.autocomplete(text) : [];
	    };
	    EditEvidenceController.prototype.sourceSelect = function () {
	        if (!!this.source && !this.citation) {
	            this.citationOverridden = false;
	            this.citationUpdate();
	        }
	        else if (!this.source) {
	            this.citationOverridden = true;
	        }
	        this.sourceChange();
	    };
	    EditEvidenceController.prototype.sourceChange = function () {
	        this.citationUpdate();
	    };
	    EditEvidenceController.prototype.citationUpdate = function () {
	        if (!this.citationOverridden) {
	            this.citation = !!this.source ? this.utils.getCitation(this.source, this.url, this.page, this.sourceDate) : '';
	        }
	    };
	    EditEvidenceController.prototype.citationOverride = function (overridden) {
	        this.citationOverridden = overridden;
	        this.citationUpdate();
	    };
	    //
	    // people
	    //
	    EditEvidenceController.prototype.addPersona = function (personas) {
	        personas.push({
	            key: this.utils.nextKey(personas.map(function (pa) { return pa.key; })),
	            facts: new Map()
	        });
	        this.updatePersonaSettings(this.personas, personas.length - 1);
	        this.$timeout(function () {
	            // YUCK - I'm too lazy right now to do this in a directive
	            var container = angular.element('#edit-evidence md-tab-content.md-active');
	            var scrollTo = angular.element('#edit-evidence__persona-add');
	            if (!!scrollTo.offset() && !!container.offset()) {
	                container.animate({
	                    scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()
	                }, 300);
	            }
	        }, 100);
	    };
	    EditEvidenceController.prototype.removePersona = function (personas, i) {
	        personas.splice(i, 1);
	    };
	    EditEvidenceController.prototype.queryPerson = function (query) {
	        var _this = this;
	        query = this.cleanPersonText(query);
	        return !query ? [] : this.persons.nameAutocomplete(query).then(function (people) {
	            people.push(_this.createPerson(query));
	            return people;
	        });
	    };
	    EditEvidenceController.prototype.setPeople = function () {
	        var _this = this;
	        this.personas.forEach(function (pa, ix) {
	            if (!pa.person && !!pa.searchText) {
	                pa.searchText = _this.cleanPersonText(pa.searchText);
	                pa.person = _this.createPerson(pa.searchText);
	                _this.updatePersonaSettings(_this.personas, ix);
	            }
	        });
	    };
	    EditEvidenceController.prototype.createPerson = function (query) {
	        var _a = this.utils.getNamePieces(query), given = _a.given, surname = _a.surname, prefix = _a.prefix, suffix = _a.suffix;
	        return {
	            id: 0,
	            _fullName: query,
	            _given: given,
	            _surname: surname,
	            _prefix: prefix,
	            _suffix: suffix,
	            _lifespan: '',
	            names: new Map([[1, {
	                        nameForms: new Map([['default', {
	                                    given: given,
	                                    surname: surname,
	                                    prefix: prefix,
	                                    suffix: suffix
	                                }]]),
	                        type: '',
	                        evidencePersonas: new Map()
	                    }]]),
	            facts: new Map()
	        };
	    };
	    EditEvidenceController.prototype.cleanPersonText = function (searchText) {
	        return searchText.endsWith(' (NEW)') || searchText.match(/ \([- 0-9]+\)$/) ? searchText.substr(0, searchText.lastIndexOf('(') - 1) : searchText;
	    };
	    EditEvidenceController.prototype.selectedPersonChange = function (ix) {
	        var _this = this;
	        // if this is a new person, copy the name
	        var persona = this.personas[ix];
	        if (!!persona.person && persona.person.id === 0 && !persona.nameGiven && !persona.nameSurname && !persona.namePrefix && !persona.nameSuffix) {
	            this.copyPersonaName(persona);
	        }
	        if (!!persona.person && persona.person.id > 0 && !persona.person.version) {
	            // we just have a summary, get a full person
	            this.persons.streamId(persona.person.id).take(1).subscribe(function (person) {
	                persona.person = person;
	                _this.updatePersonaSettings(_this.personas, ix);
	            });
	        }
	        else {
	            this.updatePersonaSettings(this.personas, ix);
	        }
	    };
	    EditEvidenceController.prototype.relationshipTypeChange = function (ix) {
	        this.updatePersonaSettings(this.personas, ix);
	    };
	    EditEvidenceController.prototype.relatedToKeyChange = function (ix) {
	        this.updatePersonaSettings(this.personas, ix);
	    };
	    EditEvidenceController.prototype.isMissingRelationships = function () {
	        var _this = this;
	        return this.personas.some(function (pa, ix) { return ix > 0 && (_this.isMissingRelationship(pa) || _this.isMissingRelatedToKey(pa)); });
	    };
	    EditEvidenceController.prototype.isMissingRelationship = function (pa) {
	        return this.isSubmitted && !pa.relationshipType;
	    };
	    EditEvidenceController.prototype.isMissingRelatedToKey = function (pa) {
	        return this.isSubmitted && !!pa.relationshipType && pa.relationshipType !== 'OTHER' && !pa.relatedToKey;
	    };
	    EditEvidenceController.prototype.samePerson = function () {
	        var _this = this;
	        return this.personas.some(function (pa1, ix1) { return !!pa1.person && pa1.person.id > 0 &&
	            _this.personas.some(function (pa2, ix2) { return ix1 !== ix2 && !!pa2.person && pa2.person.id > 0 && pa1.person.id === pa2.person.id; }); });
	    };
	    EditEvidenceController.prototype.getRelationshipLabel = function (persona, ix) {
	        if (ix === 0) {
	            return 'PERSON';
	        }
	        if (!!persona.relationshipType && persona.relationshipType !== 'OTHER') {
	            return persona.relationshipType;
	        }
	        if (!!persona.role) {
	            return persona.role;
	        }
	        return 'PERSON';
	    };
	    EditEvidenceController.prototype.getRelatedPersonas = function (personas, persona) {
	        var _this = this;
	        return personas.filter(function (pa) { return !_this.isEmptyPersona(pa) && pa.key !== persona.key && (!persona.person || !pa.person || pa.person.id === 0 || pa.person.id !== persona.person.id); });
	    };
	    EditEvidenceController.prototype.getSelectedPersona = function (personas, key) {
	        var k = parseInt(key, 10);
	        var persona = personas.find(function (pa) { return pa.key === k; });
	        if (!!persona && !!persona.person && (!!persona.person._given || !!persona.person._surname)) {
	            return (persona.person._given || persona.person._surname).split(' ')[0];
	        }
	        if (!!persona && (!!persona.nameGiven || !!persona.nameSurname)) {
	            return (persona.nameGiven || persona.nameSurname).split(' ')[0];
	        }
	        return '';
	    };
	    EditEvidenceController.prototype.relatedToName = function (relative) {
	        return this.getPersonaName(relative);
	    };
	    EditEvidenceController.prototype.getPersonaName = function (pa) {
	        return !!pa.person ? pa.person._fullName : this.utils.getFullName({ prefix: pa.namePrefix, given: pa.nameGiven, surname: pa.nameSurname, suffix: pa.nameSuffix });
	    };
	    EditEvidenceController.prototype.addFact = function (factMap) {
	        var key = this.utils.nextKey(Array.from(factMap.keys()), Math.floor(Math.random() * 256));
	        factMap.set(key, {
	            key: key,
	            _setFocus: true
	        });
	    };
	    EditEvidenceController.prototype.removeFact = function (factMap, k) {
	        factMap.delete(k);
	    };
	    EditEvidenceController.prototype.queryFactType = function (query) {
	        query = query.trim().toLowerCase();
	        if (!query) {
	            return this.rx.Observable.of(null);
	        }
	        return this.utils.factTypes.filter(function (ft) { return !ft.nopersona && (!query || ft.display.toLowerCase().startsWith(query)); });
	    };
	    EditEvidenceController.prototype.copyPersonaName = function (pa) {
	        if (!!pa.person) {
	            pa.nameGiven = pa.person._given;
	            pa.nameSurname = pa.person._surname;
	            pa.namePrefix = pa.person._prefix;
	            pa.nameSuffix = pa.person._suffix;
	        }
	    };
	    // must be called when type, pa.person, pa.relationshipType, and pa.relatedToKey change
	    EditEvidenceController.prototype.updatePersonaSettings = function (personas, ix) {
	        var _this = this;
	        var pa = personas[ix];
	        if (!pa.person || pa.person.id === 0) {
	            pa.updateProfileName = true;
	            pa.updateProfileBirth = true;
	            pa.updateProfileDeath = true;
	        }
	        else {
	            pa.updateProfileName = !this.persons.getPreferredName(pa.person) || (this.type === 'NAME' && this.isProfileNameUnsupported(pa.person));
	            pa.updateProfileBirth = this.isProfileBirthUnsupported(pa.person) && this.type !== 'BAPM';
	            pa.updateProfileDeath = this.isProfileDeathUnsupported(pa.person);
	        }
	        var typ = this.utils.factTypes.find(function (ft) { return ft.value === _this.type; });
	        if (!!pa.relationshipType && pa.relationshipType !== 'OTHER' && pa.relatedToKey == null) {
	            pa.relatedToKey = personas[0].key.toString();
	        }
	        pa.principal = ((ix === 0) ||
	            (!!typ && !!typ.spouse && pa.relationshipType === 'SPOUSE' && parseInt(pa.relatedToKey, 10) === personas[0].key) ||
	            (!!typ && !!typ.family));
	    };
	    EditEvidenceController.prototype.isProfileNameUnsupported = function (person) {
	        var x = this.persons.getPreferredName(person);
	        return !x || x.evidencePersonas.size === 0 ||
	            (x.evidencePersonas.size === 1 && !!this.evidence && x.evidencePersonas.has(this.evidence.id));
	    };
	    EditEvidenceController.prototype.isProfileBirthUnsupported = function (person) {
	        var x = this.persons.getPreferredBirth(person);
	        return !x || x.evidencePersonas.size === 0 ||
	            (x.evidencePersonas.size === 1 && !!this.evidence && x.evidencePersonas.has(this.evidence.id));
	    };
	    EditEvidenceController.prototype.isProfileDeathUnsupported = function (person) {
	        var x = this.persons.getPreferredDeath(person);
	        return !x || x.evidencePersonas.size === 0 ||
	            (x.evidencePersonas.size === 1 && !!this.evidence && x.evidencePersonas.has(this.evidence.id));
	    };
	    //
	    // update profiles
	    //
	    EditEvidenceController.prototype.getProfilePersonas = function (personas) {
	        return personas.filter(function (pa) { return !!pa.person; });
	    };
	    EditEvidenceController.prototype.showProfileName = function (pa) {
	        if (!pa.person || pa.person.id === 0) {
	            return false;
	        }
	        var en = this.getEvidenceName(pa);
	        if (!en) {
	            return false;
	        }
	        if (pa.updateProfileName) {
	            return true;
	        }
	        var pn = this.getProfileName(pa);
	        return !this.utils.nameEquals(en, pn);
	    };
	    EditEvidenceController.prototype.showProfileFact = function (pa, typ) {
	        if (!pa.person || pa.person.id === 0) {
	            return false;
	        }
	        return !!this.getEvidenceFact(pa, typ);
	    };
	    EditEvidenceController.prototype.isProfileNew = function (pa) {
	        return !!pa.person && pa.person.id === 0;
	    };
	    EditEvidenceController.prototype.isIdenticalProfileName = function (pa) {
	        var en = this.getEvidenceName(pa);
	        var pn = this.getProfileName(pa);
	        return this.utils.nameEquals(en, pn);
	    };
	    EditEvidenceController.prototype.isIdenticalProfileFact = function (pa, typ) {
	        //if ((typ === 'BIRT' && pa.updateProfileBirth) || (typ === 'DEAT' && pa.updateProfileDeath)) {
	        //  return false;
	        //}
	        var ef = this.getEvidenceFact(pa, typ);
	        var pf = this.getProfileFact(pa, typ);
	        return this.utils.factTypeDatePlaceEquals(ef, pf);
	    };
	    EditEvidenceController.prototype.getProfileName = function (pa) {
	        //if (pa.updateProfileName) {
	        //  return this.getEvidenceName(pa);
	        //}
	        if (!pa.person || pa.person.id === 0) {
	            return { given: '', surname: '', prefix: '', suffix: '' };
	        }
	        return { given: pa.person._given, surname: pa.person._surname, prefix: pa.person._prefix, suffix: pa.person._suffix };
	    };
	    EditEvidenceController.prototype.getProfileFact = function (pa, typ) {
	        //if ((typ === 'BIRT' && pa.updateProfileBirth) || (typ === 'DEAT' && pa.updateProfileDeath)) {
	        //  return this.getEvidenceFact(pa, typ);
	        //}
	        var prefFact = typ === 'BIRT' ? this.persons.getPreferredBirth(pa.person) : this.persons.getPreferredDeath(pa.person);
	        if (!pa.person || pa.person.id === 0 || !prefFact) {
	            return { date: '', place: '' };
	        }
	        return { date: prefFact.date, place: prefFact.place };
	    };
	    EditEvidenceController.prototype.getEvidenceName = function (pa) {
	        if (this.type === 'NAME') {
	            return { given: this.nameGiven, surname: this.nameSurname, prefix: this.namePrefix, suffix: this.nameSuffix };
	        }
	        if (!!pa.nameGiven || !!pa.nameSurname) {
	            return { given: pa.nameGiven, surname: pa.nameSurname, prefix: pa.namePrefix, suffix: pa.nameSuffix };
	        }
	        //if (!!pa.person) {
	        //  return {given: pa.person._given, surname: pa.person._surname, prefix: pa.person._prefix, suffix: pa.person._suffix};
	        //}
	        return null;
	    };
	    EditEvidenceController.prototype.getEvidenceFact = function (pa, typ) {
	        // copy primary event?
	        if (pa.principal) {
	            if ((typ === 'BIRT' && this.type === 'BIRT') ||
	                (typ === 'BIRT' && this.type === 'CHR' && !Array.from(pa.facts.values()).some(function (f) { return !!f.type && f.type.value === 'BIRT'; }) &&
	                    (!pa.person || (!pa.person._birthDate && !pa.person._birthPlace))) ||
	                (typ === 'BIRT' && this.type === 'BAPM' && !Array.from(pa.facts.values()).some(function (f) { return !!f.type && f.type.value === 'BIRT'; }) &&
	                    (!pa.person || (!pa.person._birthDate && !pa.person._birthPlace))) ||
	                (typ === 'DEAT' && this.type === 'DEAT') ||
	                (typ === 'DEAT' && this.type === 'BURI' && !Array.from(pa.facts.values()).some(function (f) { return !!f.type && f.type.value === 'DEAT'; }) &&
	                    (!pa.person || (!pa.person._deathDate && !pa.person._deathPlace)))) {
	                return { type: this.type, date: this.date, place: !!this.place ? this.place.name : this.placeText };
	            }
	        }
	        // copy event from persona?
	        var date = '';
	        var place = '';
	        var fact = Array.from(pa.facts.values()).find(function (f) { return !!f.type && f.type.value === typ; });
	        if (!fact) {
	            if (typ === 'BIRT') {
	                fact = Array.from(pa.facts.values()).find(function (f) { return !!f.type && (f.type.value === 'CHR' || f.type.value === 'BAPM'); });
	            }
	            else {
	                fact = Array.from(pa.facts.values()).find(function (f) { return !!f.type && f.type.value === 'BURI'; });
	            }
	        }
	        if (!!fact) {
	            date = fact.date;
	            place = !!fact.place ? fact.place.name : fact.placeText;
	        }
	        if (typ === 'BIRT' && !date && Array.from(pa.facts.values()).some(function (f) { return !!f.type && f.type.value === '_AGE'; })) {
	            var ageFact = Array.from(pa.facts.values()).find(function (f) { return !!f.type && f.type.value === '_AGE'; });
	            var year = this.utils.getYear(this.date);
	            if (!!ageFact && !!year) {
	                var results = this.utils.getBirthdateFromEventAge(year + '0000', ageFact.value || ageFact.date);
	                if (!!results) {
	                    date = results.date;
	                }
	            }
	            if (!!ageFact && !place) {
	                place = !!ageFact.place ? ageFact.place.name : ageFact.placeText;
	            }
	        }
	        return (!!date || !!place) ? { type: !!fact ? fact.type.value : typ, date: date, place: place } : null;
	    };
	    EditEvidenceController.prototype.getFinalName = function (pa) {
	        return pa.updateProfileName ? this.getEvidenceName(pa) : this.getProfileName(pa);
	    };
	    EditEvidenceController.prototype.getFinalBirth = function (pa) {
	        return pa.updateProfileBirth ? this.getEvidenceFact(pa, 'BIRT') : this.getProfileFact(pa, 'BIRT');
	    };
	    EditEvidenceController.prototype.getFinalDeath = function (pa) {
	        return pa.updateProfileDeath ? this.getEvidenceFact(pa, 'DEAT') : this.getProfileFact(pa, 'DEAT');
	    };
	    EditEvidenceController.prototype.getFullName = function (n) {
	        return this.utils.getFullName(n);
	    };
	    //
	    // general
	    //
	    EditEvidenceController.prototype.focus = function (fld) {
	        this.focusField = fld;
	    };
	    EditEvidenceController.prototype.save = function () {
	        this.focus('');
	        this.submit();
	    };
	    EditEvidenceController.prototype.back = function () {
	        this.focus('');
	        if (this.tabIndex === 4 && this.type === 'NAME') {
	            this.tabIndex -= 2;
	        }
	        else if (this.tabIndex > 0) {
	            this.tabIndex--;
	        }
	    };
	    EditEvidenceController.prototype.next = function () {
	        this.focus('');
	        if (this.tabIndex === 0 && !this.type) {
	            // do nothing
	        }
	        else if (this.tabIndex === 2 && this.type === 'NAME') {
	            this.tabIndex += 2;
	        }
	        else if (this.tabIndex < 4) {
	            this.tabIndex++;
	        }
	        else {
	            this.submit();
	        }
	    };
	    EditEvidenceController.prototype.removeEmptyPersonas = function () {
	        var _this = this;
	        this.personas = this.personas.filter(function (pa) { return !_this.isEmptyPersona(pa); });
	    };
	    EditEvidenceController.prototype.isEmptyPersona = function (pa) {
	        return !(pa.facts.size > 0 || !!pa.person || !!pa.searchText || !!pa.relationshipType || !!pa.role || !!pa.relatedToKey ||
	            !!pa.nameGiven || !!pa.nameSurname || pa.namePrefix || !!pa.nameSuffix);
	    };
	    EditEvidenceController.prototype.fillMissingRelationships = function () {
	        this.personas.forEach(function (pa) {
	            if (!pa.relationshipType) {
	                pa.relationshipType = 'OTHER';
	            }
	        });
	    };
	    EditEvidenceController.prototype.submit = function () {
	        var _this = this;
	        this.$log.info('editEvidence.submit');
	        this.isSubmitted = true;
	        this.removeEmptyPersonas();
	        this.fillMissingRelationships();
	        if (this.isMissingRelationships()) {
	            this.msg = 'Please fill in missing relationships';
	            this.tabIndex = 3;
	            return;
	        }
	        if (this.samePerson()) {
	            this.msg = 'The same person cannot be tagged to two different people in the record';
	            this.tabIndex = 3;
	            return;
	        }
	        this.msg = '';
	        this.saving = true;
	        var form = {
	            evidence: this.evidence,
	            type: this.type,
	            value: this.type !== 'NAME' && this.type !== 'SOUR' ? this.value : '',
	            date: this.type !== 'SOUR' ? this.date : '',
	            place: this.type !== 'NAME' && this.type !== 'SOUR' ? this.place : '',
	            placeText: this.type !== 'NAME' && this.type !== 'SOUR' ? this.placeText : '',
	            placeDetails: this.type !== 'NAME' && this.type !== 'SOUR' ? this.placeDetails : '',
	            text: this.utils.expandMentions(this.currentTreeIdService, this.allUsers, this.text),
	            researchLogId: +this.researchLogId,
	            url: this.url,
	            page: this.page,
	            sourceDate: this.sourceDate,
	            citation: this.citationOverridden ? this.citation : '',
	            nameGiven: this.type === 'NAME' ? this.nameGiven : '',
	            nameSurname: this.type === 'NAME' ? this.nameSurname : '',
	            namePrefix: this.type === 'NAME' ? this.namePrefix : '',
	            nameSuffix: this.type === 'NAME' ? this.nameSuffix : '',
	            nameType: this.type === 'NAME' ? this.nameType : '',
	            mediaIds: new Map()
	        };
	        this.personas.forEach(function (pa, ix) {
	            // convert relatedToKey to numbers
	            pa.relatedToKey = pa.relatedToKey == null ? 0 : parseInt(pa.relatedToKey, 10);
	            // if we are editing a name/fact on a person, record name/fact key so we can remove the edited name/fact if needed
	            if (ix === 0 && !!_this.name) {
	                pa.nameKey = _this.name._key;
	            }
	            if (ix === 0 && !!_this.fact) {
	                pa.factKey = _this.fact._key;
	            }
	            // fix up names of new people in case the user updated the name fields
	            if (!!pa.person && pa.person.id === 0) {
	                var nf = _this.persons.getDefaultNameForm(_this.persons.getPreferredName(pa.person));
	                nf.given = pa.nameGiven;
	                nf.surname = pa.nameSurname;
	                nf.prefix = pa.namePrefix;
	                nf.suffix = pa.nameSuffix;
	            }
	            if (pa.updateProfileName && _this.isIdenticalProfileName(pa)) {
	                pa.updateProfileName = false;
	            }
	            if (pa.updateProfileBirth && _this.isIdenticalProfileFact(pa, 'BIRT')) {
	                pa.updateProfileBirth = false;
	            }
	            if (pa.updateProfileDeath && _this.isIdenticalProfileFact(pa, 'DEAT')) {
	                pa.updateProfileDeath = false;
	            }
	            // We can't do this because if someone adds a burial to a person with a death, it sets pa.updateProfileDeath = true; likewise for birth and christening
	            // if evidence doesn't have a name/fact, then update profile in case the evidence used to have this fact and user marks to delete it
	            //if (!this.getEvidenceName(pa)) {
	            //  pa.updateProfileName = true;
	            //}
	            //if (!this.getEvidenceFact(pa, 'BIRT')) {
	            //  pa.updateProfileBirth = true;
	            //}
	            //if (!this.getEvidenceFact(pa, 'DEAT')) {
	            //  pa.updateProfileDeath = true;
	            //}
	        });
	        this.medias.forEach(function (media) {
	            form.mediaIds.set(media.id, true);
	        });
	        var deletedNamesFacts = this.evidenceUtils.getDeletedNamesFacts(!!this.evidence ? [this.evidence] : [], this.personas, true);
	        if (deletedNamesFacts.filter(function (nf) { return !nf.primary && nf.principal && nf.unsupported; }).length > 0) {
	            this.$mdDialog.hide();
	            this.utils.dialog(null, 'SelectNamesFactsController', 'app/components/selectNamesFacts/selectNamesFacts.html', false, {
	                namesFacts: deletedNamesFacts
	            }).then(function (deletedNamesFacts) {
	                _this.createMediasAndPostEvidence(_this.mediaSlots, form, _this.personas, _this.source, _this.sourceText, deletedNamesFacts).subscribe(function () {
	                    // nothing to do
	                }, function () {
	                    _this.saving = false;
	                });
	            }, function () {
	                // ignore
	            });
	        }
	        else {
	            // keep deletedNamesFacts whose personas have been removed
	            deletedNamesFacts = deletedNamesFacts.filter(function (nf) { return !_this.personas.some(function (pa) { return !!pa.person && pa.person.id === nf.personId; }); });
	            this.createMediasAndPostEvidence(this.mediaSlots, form, this.personas, this.source, this.sourceText, deletedNamesFacts).subscribe(function (evidence) {
	                _this.$mdDialog.hide(evidence);
	            }, function () {
	                _this.saving = false;
	            });
	        }
	    };
	    EditEvidenceController.prototype.createMediasAndPostEvidence = function (mediaSlots, form, personas, source, sourceText, deletedNamesFacts) {
	        var _this = this;
	        return this.createMediasFromFiles(this.getMediaTitle(form, personas), mediaSlots).flatMap(function (medias) {
	            medias.forEach(function (media) {
	                form.mediaIds.set(media.id, true);
	            });
	            return _this.evidenceUtils.post(form, personas, source, sourceText, deletedNamesFacts);
	        });
	    };
	    EditEvidenceController.prototype.getMediaTitle = function (form, personas) {
	        var _this = this;
	        var typ = this.utils.factTypes.find(function (ft) { return ft.value === form.type; });
	        var mediaTitle = (!!typ ? typ.display : form.type) + ', ' + (!!form.date ? (form.date + ', ') : '');
	        var principals = personas.filter(function (pa) { return !!pa.person && pa.principal; });
	        if (principals.length === 2) {
	            mediaTitle += principals.map(function (pa) { return _this.getPersonaName(pa); }).join(' & ');
	        }
	        else if (principals.length > 0) {
	            mediaTitle += this.getPersonaName(principals.find(function () { return true; }));
	        }
	        return mediaTitle;
	    };
	    EditEvidenceController.prototype.createMediasFromFiles = function (title, mediaSlots) {
	        var _this = this;
	        var filledSlots = mediaSlots.filter(function (ms) { return !!ms.fileStatus; });
	        if (filledSlots.length === 0) {
	            return this.rx.Observable.of([]);
	        }
	        return (_a = this.rx.Observable).forkJoin.apply(_a, __spread(filledSlots.map(function (ms) {
	            return _this.mediaService.createMediaFromFile({ title: title }, ms);
	        })));
	        var _a;
	    };
	    EditEvidenceController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditEvidenceController;
	}());
	exports.default = EditEvidenceController;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditLeadController = /** @class */ (function () {
	    EditLeadController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "$timeout", "messageBus", "currentTreeId", "leads", "persons", "researchLogs", "rights", "users", "utils"];
	    function EditLeadController($log, $mdDialog, $mdMedia, $scope, $timeout, messageBus, currentTreeId, leads, persons, researchLogs, rights, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.currentTreeIdService = currentTreeId;
	        this.leads = leads;
	        this.persons = persons;
	        this.utils = utils;
	        // passed in: lead or personId or neither and maybe researchLogId
	        var personIds = [];
	        if (!!this.lead) {
	            this.title = this.lead.title;
	            this.text = this.lead.text;
	            this.url = this.lead.url;
	            this.status = this.lead.status;
	            this.archived = this.lead.state > 0;
	            this.isHint = this.lead.createdUser === 0;
	            this.researchLogId = this.lead.researchLogId || '';
	            personIds = Array.from(this.lead.personIds.keys());
	        }
	        else if (this.personId > 0) {
	            personIds = [this.personId];
	        }
	        this.people = [];
	        if (personIds.length > 0) {
	            persons.streamIds(personIds).take(1).subscribe(function (personMap) {
	                _this.people = Array.from(personMap.values()).map(_this.toPersonObject);
	            });
	        }
	        this.logs = [];
	        var rlSub = utils.watch($scope, function () { return _this.people; }, true).flatMap(function () { return researchLogs.ready(); }).flatMap(function () { return researchLogs.stream(); }).subscribe(function (logMap) {
	            _this.logs = _this.utils.getResearchLogTitles(logMap, _this.people);
	        });
	        this.focusField = '';
	        this.froalaOptions = utils.froalaOptions(utils.atConfigUser(users, rights, currentTreeId), function () {
	            $timeout(function () {
	                _this.focusField = 'text';
	            });
	        });
	        users.streamAllUsers(rights).take(1).subscribe(function (allUsers) {
	            _this.allUsers = allUsers;
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            rlSub.unsubscribe();
	            mbSub.unsubscribe();
	        });
	    }
	    EditLeadController.prototype.focus = function (fld) {
	        this.focusField = fld;
	    };
	    EditLeadController.prototype.addPerson = function (id) {
	        var _this = this;
	        this.persons.streamId(id).take(1).subscribe(function (person) {
	            if (!_this.people.find(function (p) { return p.id === person.id; })) {
	                _this.people.push(_this.toPersonObject(person));
	            }
	        });
	    };
	    EditLeadController.prototype.querySearch = function (query) {
	        var _this = this;
	        return !query ? [] : this.persons.nameAutocomplete(query).then(function (people) { return people.map(_this.toPersonObject); });
	    };
	    EditLeadController.prototype.queryStatus = function (text) {
	        return !!text ? this.leads.statusAutocomplete(text) : [];
	    };
	    EditLeadController.prototype.toPersonObject = function (p) {
	        return {
	            id: p.id,
	            name: p._fullName,
	            email: p._lifespan,
	            image: p._iconURL
	        };
	    };
	    EditLeadController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var lead = !!this.lead ? this.utils.clone(this.lead) : { id: 0 };
	        lead.title = this.title;
	        lead.text = this.utils.expandMentions(this.currentTreeIdService, this.allUsers, this.text);
	        lead.url = this.utils.fixURL(this.url);
	        lead.state = this.archived ? 1 : 0;
	        lead.status = this.status || this.statusText;
	        lead.researchLogId = +this.researchLogId;
	        lead.personIds = new Map();
	        this.people.forEach(function (p) {
	            lead.personIds.set(p.id, true);
	        });
	        (!!this.lead ? this.leads.update : this.leads.create).bind(this.leads)(lead).subscribe(function (lead) {
	            _this.saving = false;
	            _this.$log.debug('editLead.submit', lead);
	            _this.$mdDialog.hide(lead);
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    EditLeadController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditLeadController;
	}());
	exports.default = EditLeadController;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditMediaController = /** @class */ (function () {
	    EditMediaController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "$timeout", "messageBus", "currentTreeId", "server", "medias", "persons", "places", "researchLogs", "rights", "users", "utils"];
	    function EditMediaController($log, $mdDialog, $mdMedia, $scope, $timeout, messageBus, currentTreeId, server, medias, persons, places, researchLogs, rights, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.$timeout = $timeout;
	        this.messageBus = messageBus;
	        this.currentTreeIdService = currentTreeId;
	        this.server = server;
	        this.medias = medias;
	        this.persons = persons;
	        this.places = places;
	        this.utils = utils;
	        // passed in: media or personId or neither and maybe researchLogId
	        this.fileTypes = medias.fileTypes;
	        this.fileModelOptions = medias.fileModelOptions;
	        this.fileValidation = medias.fileValidation;
	        this.fileDragover = medias.fileDragover;
	        this.fileStatus = '';
	        this.cropped = false;
	        // TODO using dataUri is slow on mobile; img-crop should get a blob, not a dataUri: https://github.com/CrackerakiUA/ngImgCropFullExtended http://dev.mobify.com/blog/data-uris-are-slow-on-mobile/
	        var personIds = [];
	        this.fileId = 0;
	        this.existingFiles = [];
	        if (!!this.media) {
	            this.title = this.media.title;
	            this.text = this.media.text;
	            this.date = this.media.date;
	            this.placeText = this.media.place;
	            if (!!this.media.placeStandard) {
	                this.place = {
	                    name: this.media.place,
	                    standardName: this.media.placeStandard,
	                    latitude: this.media.latitude,
	                    longitude: this.media.longitude
	                };
	            }
	            this.researchLogId = this.media.researchLogId || '';
	            personIds = Array.from(this.media.personIds.keys());
	            this.existingFiles = Array.from(this.media.fileInfos.entries()).map(function (_a) {
	                var _b = __read(_a, 2), fileId = _b[0], fileInfo = _b[1];
	                return { fileId: fileId, fileInfo: fileInfo };
	            });
	        }
	        else if (this.personId > 0) {
	            personIds = [this.personId];
	        }
	        this.people = [];
	        if (personIds.length > 0) {
	            persons.streamIds(personIds).take(1).subscribe(function (personMap) {
	                _this.people = Array.from(personMap.values()).map(_this.toPersonObject);
	            });
	        }
	        this.logs = [];
	        var rlSub = utils.watch($scope, function () { return _this.people; }, true).flatMap(function () { return researchLogs.ready(); }).flatMap(function () { return researchLogs.stream(); }).subscribe(function (logMap) {
	            _this.logs = _this.utils.getResearchLogTitles(logMap, _this.people);
	        });
	        this.focusField = '';
	        this.froalaOptions = utils.froalaOptions(utils.atConfigUser(users, rights, currentTreeId), function () {
	            $timeout(function () {
	                _this.focusField = 'text';
	            });
	        });
	        users.streamAllUsers(rights).take(1).subscribe(function (allUsers) {
	            _this.allUsers = allUsers;
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            rlSub.unsubscribe();
	            mbSub.unsubscribe();
	        });
	    }
	    EditMediaController.prototype.focus = function (fld) {
	        this.focusField = fld;
	    };
	    EditMediaController.prototype.addPerson = function (id) {
	        var _this = this;
	        this.persons.streamId(id).take(1).subscribe(function (person) {
	            if (!_this.people.find(function (p) { return p.id === person.id; })) {
	                _this.people.push(_this.toPersonObject(person));
	            }
	        });
	    };
	    EditMediaController.prototype.queryPeople = function (query) {
	        var _this = this;
	        return !query ? [] : this.persons.nameAutocomplete(query).then(function (people) { return people.map(_this.toPersonObject); });
	    };
	    EditMediaController.prototype.toPersonObject = function (p) {
	        return {
	            id: p.id,
	            name: p._fullName,
	            email: p._lifespan,
	            image: p._iconURL
	        };
	    };
	    EditMediaController.prototype.queryPlace = function (text) {
	        return !!text ? this.places.autocomplete(text) : [];
	    };
	    EditMediaController.prototype.getFileURL = function (fileId) {
	        return this.medias.getFileURL(this.media.id, fileId, '100x100');
	    };
	    EditMediaController.prototype.canSubmit = function () {
	        return this.existingFiles.length > 0 || !!this.file;
	    };
	    //
	    // file
	    //
	    EditMediaController.prototype.isImageFile = function (file) {
	        return this.medias.isImageFile(file);
	    };
	    EditMediaController.prototype.getImageFormat = function (file) {
	        return this.medias.getImageFormat(file);
	    };
	    EditMediaController.prototype.fileChange = function (files) {
	        this.$log.debug('fileChange', files);
	        if (!!files && files.length > 0) {
	            this.fileName = files[0].name;
	            this.fileDataURI = '';
	            this.cropped = false;
	            this.focus('file');
	            if (!!files[0] && this.isImageFile(files[0])) {
	                this.existingFiles = [];
	                this.fileStatus = 'loading';
	            }
	            else {
	                this.existingFiles = [];
	                this.fileStatus = 'noimage';
	            }
	        }
	    };
	    EditMediaController.prototype.fileLoadDone = function () {
	        var _this = this;
	        if (this.fileStatus === 'loading') {
	            this.$timeout(function () {
	                _this.fileStatus = 'loaded';
	            });
	        }
	        // spurious fileChange events get sent for 1-2 seconds after file loaded
	        this.$timeout(function () {
	            _this.cropped = false;
	        }, 1500);
	    };
	    EditMediaController.prototype.fileChangeCrop = function () {
	        this.cropped = true;
	    };
	    //
	    // actions
	    //
	    EditMediaController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var media = !!this.media ? this.utils.clone(this.media) : { id: this.utils.randomId() };
	        media.title = this.title || '';
	        media.date = this.date || '';
	        media.dateSort = '';
	        media.place = !!this.place ? this.place.name : !!this.placeText ? this.placeText : '';
	        media.placeStandard = !!this.place ? this.place.standardName : '';
	        media.latitude = !!this.place ? this.place.latitude : 0;
	        media.longitude = !!this.place ? this.place.longitude : 0;
	        media.text = this.utils.expandMentions(this.currentTreeIdService, this.allUsers, this.text);
	        media.researchLogId = +this.researchLogId;
	        media.personIds = new Map();
	        media.fileInfos = new Map();
	        this.people.forEach(function (person) {
	            media.personIds.set(person.id, true);
	        });
	        this.existingFiles.forEach(function (_a) {
	            var fileId = _a.fileId, fileInfo = _a.fileInfo;
	            media.fileInfos.set(fileId, fileInfo);
	        });
	        // load file
	        if (!!this.file) {
	            this.medias.uploadMediaFile(media.id, this.fileId, {
	                fileName: this.fileName,
	                file: this.file,
	                cropped: this.cropped,
	                fileDataURI: this.fileDataURI
	            }).subscribe(function (fileType) {
	                media.fileInfos.set(_this.fileId, { contentType: fileType, fileName: _this.fileName });
	                _this.postMedia(media);
	            });
	        }
	        else {
	            this.postMedia(media);
	        }
	    };
	    EditMediaController.prototype.postMedia = function (media) {
	        var _this = this;
	        (!!this.media ? this.medias.update(media) : this.medias.create(media)).subscribe(function (media) {
	            _this.saving = false;
	            _this.$mdDialog.hide(media);
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    EditMediaController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditMediaController;
	}());
	exports.default = EditMediaController;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditNoteController = /** @class */ (function () {
	    EditNoteController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "$timeout", "messageBus", "currentTreeId", "notes", "persons", "researchLogs", "rights", "users", "utils"];
	    function EditNoteController($log, $mdDialog, $mdMedia, $scope, $timeout, messageBus, currentTreeId, notes, persons, researchLogs, rights, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.notes = notes;
	        this.persons = persons;
	        this.currentTreeIdService = currentTreeId;
	        this.utils = utils;
	        // passed in: note or personId or neither and maybe researchLogId
	        this.private = false;
	        var personIds = [];
	        if (!!this.note) {
	            this.title = this.note.title;
	            this.text = this.note.text;
	            this.private = this.note.private || false;
	            this.researchLogId = this.note.researchLogId || '';
	            personIds = Array.from(this.note.personIds.keys());
	        }
	        else if (this.personId > 0) {
	            personIds = [this.personId];
	        }
	        this.people = [];
	        if (personIds.length > 0) {
	            persons.streamIds(personIds).take(1).subscribe(function (personMap) {
	                _this.people = Array.from(personMap.values()).map(_this.toPersonObject);
	            });
	        }
	        this.logs = [];
	        var rlSub = utils.watch($scope, function () { return _this.people; }, true).flatMap(function () { return researchLogs.ready(); }).flatMap(function () { return researchLogs.stream(); }).subscribe(function (logMap) {
	            _this.logs = _this.utils.getResearchLogTitles(logMap, _this.people);
	        });
	        this.focusField = '';
	        this.froalaOptions = utils.froalaOptions(utils.atConfigUser(users, rights, currentTreeId), function () {
	            $timeout(function () {
	                _this.focusField = 'text';
	            });
	        });
	        users.streamAllUsers(rights).take(1).subscribe(function (allUsers) {
	            _this.allUsers = allUsers;
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            rlSub.unsubscribe();
	            mbSub.unsubscribe();
	        });
	    }
	    EditNoteController.prototype.focus = function (fld) {
	        this.focusField = fld;
	    };
	    EditNoteController.prototype.addPerson = function (id) {
	        var _this = this;
	        this.persons.streamId(id).take(1).subscribe(function (person) {
	            if (!_this.people.find(function (p) { return p.id === person.id; })) {
	                _this.people.push(_this.toPersonObject(person));
	            }
	        });
	    };
	    EditNoteController.prototype.querySearch = function (query) {
	        var _this = this;
	        return !query ? [] : this.persons.nameAutocomplete(query).then(function (people) { return people.map(_this.toPersonObject); });
	    };
	    EditNoteController.prototype.toPersonObject = function (p) {
	        return {
	            id: p.id,
	            name: p._fullName,
	            email: p._lifespan,
	            image: p._iconURL
	        };
	    };
	    EditNoteController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var note = !!this.note ? this.utils.clone(this.note) : { id: 0 };
	        note.title = this.title;
	        note.text = this.utils.expandMentions(this.currentTreeIdService, this.allUsers, this.text);
	        note.private = this.private;
	        note.researchLogId = +this.researchLogId;
	        note.personIds = new Map();
	        this.people.forEach(function (p) {
	            note.personIds.set(p.id, true);
	        });
	        (!!this.note ? this.notes.update : this.notes.create).bind(this.notes)(note).subscribe(function (note) {
	            _this.saving = false;
	            _this.$log.debug('editNote.submit', note);
	            _this.$mdDialog.hide(note);
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    EditNoteController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditNoteController;
	}());
	exports.default = EditNoteController;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2017
	 */
	var EditOrdinanceController = /** @class */ (function () {
	    EditOrdinanceController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus", "fsTemples", "ordinances", "utils"];
	    function EditOrdinanceController($log, $mdDialog, $mdMedia, $scope, messageBus, fsTemples, ordinances, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.ordinances = ordinances;
	        this.utils = utils;
	        // passed in: personId and ordinance
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        this.statuses = __spread(ordinances.statuses).sort(function (a, b) { return a.display + a.detail < b.display + b.detail ? -1 : a.display + a.detail > b.display + b.detail ? 1 : 0; });
	        this.templeCodes = Array.from(fsTemples.entries()).map(function (entry) {
	            return {
	                code: entry[0],
	                name: entry[1]
	            };
	        }).sort(function (a, b) { return a.name < b.name ? -1 : a.name > b.name ? 1 : 0; });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    EditOrdinanceController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        this.ordinances.streamId(this.personId).take(1).subscribe(function (ords) {
	            ords.ordinances.set(_this.ordinance._key, _this.ordinance);
	            _this.ordinances.update(ords).subscribe(function () {
	                _this.saving = false;
	                _this.$mdDialog.hide(ords);
	            }, function () {
	                _this.saving = false;
	            });
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    EditOrdinanceController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditOrdinanceController;
	}());
	exports.default = EditOrdinanceController;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditParentRelsController = /** @class */ (function () {
	    EditParentRelsController.$inject = ["$log", "$mdDialog", "$scope", "messageBus", "families", "persons", "utils"];
	    function EditParentRelsController($log, $mdDialog, $scope, messageBus, families, persons, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.families = families;
	        this.utils = utils;
	        // passed in: family, childId
	        _a = __read(this.getType(this.family.childRels.get(this.childId).fatherRel || ''), 2), this.fatherRel = _a[0], this.fatherRelText = _a[1];
	        _b = __read(this.getType(this.family.childRels.get(this.childId).motherRel || ''), 2), this.motherRel = _b[0], this.motherRelText = _b[1];
	        this.person = null;
	        persons.streamId(this.childId).take(1).subscribe(function (person) {
	            _this.person = person;
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	        var _a, _b;
	    }
	    EditParentRelsController.prototype.getType = function (typ) {
	        var t = this.utils.parentRelTypes.find(function (prt) { return prt.value === typ; });
	        return [t, !!t ? '' : typ];
	    };
	    EditParentRelsController.prototype.queryType = function (query) {
	        query = query.toLowerCase();
	        return this.utils.parentRelTypes.filter(function (prt) { return (!query || prt.display.toLowerCase().startsWith(query)); });
	    };
	    EditParentRelsController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var family = this.utils.clone(this.family);
	        family.childRels.set(this.childId, {
	            fatherRel: !!this.fatherRel ? this.fatherRel.value : this.fatherRelText || '',
	            motherRel: !!this.motherRel ? this.motherRel.value : this.motherRelText || ''
	        });
	        this.families.update(family).subscribe(function (family) {
	            _this.saving = false;
	            _this.$log.debug('editParentRels.submit', family);
	            _this.$mdDialog.hide(family);
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    EditParentRelsController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditParentRelsController;
	}());
	exports.default = EditParentRelsController;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditPersonController = /** @class */ (function () {
	    EditPersonController.$inject = ["$log", "$mdConstant", "$mdDialog", "$mdMedia", "$scope", "$timeout", "rx", "messageBus", "currentTree", "rightsFull", "evidences", "medias", "persons", "places", "personUtils", "utils"];
	    function EditPersonController($log, $mdConstant, $mdDialog, $mdMedia, $scope, $timeout, rx, messageBus, currentTree, rightsFull, evidences, medias, persons, places, personUtils, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.$timeout = $timeout;
	        this.rx = rx;
	        this.messageBus = messageBus;
	        this.evidences = evidences;
	        this.mediaService = medias;
	        this.personsService = persons;
	        this.places = places;
	        this.personUtils = personUtils;
	        this.utils = utils;
	        // incoming: tabIndex, person, names, births, deaths, genders
	        this.tabIndex = this.tabIndex || 0;
	        this.isSubmitted = false;
	        this.tagSeparatorKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, 186]; // semicolon
	        this.fileTypes = medias.fileTypes;
	        this.fileModelOptions = medias.fileModelOptions;
	        this.fileValidation = medias.fileValidation;
	        this.fileDragover = medias.fileDragover;
	        this.profileMediaSlot = {
	            fileStatus: '',
	            cropped: false
	        };
	        this.coverMediaSlot = {
	            fileStatus: '',
	            cropped: false
	        };
	        this.treeTags = [];
	        currentTree.stream().take(1).subscribe(function (tree) {
	            var p = tree.preferences;
	            _this.treeTags = [p.COLOR_LABEL_1, p.COLOR_LABEL_2, p.COLOR_LABEL_3, p.COLOR_LABEL_4, p.COLOR_LABEL_5, p.COLOR_LABEL_6]
	                .filter(function (color) { return !color.toLowerCase().startsWith('custom #'); });
	        });
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.medias = [];
	        medias.streamForPerson(this.person.id).take(1).subscribe(function (mediaMap) {
	            _this.medias = Array.from(mediaMap.values());
	        });
	        var genders = this.utils.genders.map(function (g) { return Object.assign({}, g, { evidences: [] }); });
	        this.genders.forEach(function (genderFact) {
	            var gnd = _this.utils.findGender(genders, genderFact.value);
	            if (!!gnd) {
	                gnd.evidences = Array.from(genderFact._evidences.values());
	            }
	        });
	        this.form = {
	            preferredNameKey: this.person.preferredNameKey,
	            preferredBirthKey: this.person.preferredBirthKey,
	            preferredDeathKey: this.person.preferredDeathKey,
	            profilePhoto: this.person.profilePhoto,
	            coverPhoto: this.person.coverPhoto,
	            gender: this.person.gender || 'UNKNOWN',
	            living: this.person.living,
	            genders: genders,
	            tags: !!this.person.tags ? Array.from(this.person.tags.keys()) : [],
	            names: this.names.map(function (name) {
	                var nf = persons.getDefaultNameForm(name);
	                return {
	                    key: name._key,
	                    given: nf.given,
	                    surname: nf.surname,
	                    prefix: nf.prefix,
	                    suffix: nf.suffix,
	                    fullName: persons.getNameText(nf),
	                    evidences: Array.from(name._evidences.values())
	                };
	            }),
	            births: this.births.map(function (fact) {
	                return {
	                    key: fact._key,
	                    type: fact.type,
	                    date: fact.date,
	                    placeText: fact.place,
	                    place: !!fact.placeStandard ? {
	                        name: fact.place,
	                        standardName: fact.placeStandard,
	                        latitude: fact.latitude,
	                        longitude: fact.longitude
	                    } : '',
	                    evidences: Array.from(fact._evidences.values())
	                };
	            }),
	            deaths: this.deaths.map(function (fact) {
	                return {
	                    key: fact._key,
	                    type: fact.type,
	                    date: fact.date,
	                    placeText: fact.place,
	                    place: !!fact.placeStandard ? {
	                        name: fact.place,
	                        standardName: fact.placeStandard,
	                        latitude: fact.latitude,
	                        longitude: fact.longitude
	                    } : '',
	                    evidences: Array.from(fact._evidences.values())
	                };
	            })
	        };
	        if (!this.form.names.some(function (name) { return name.evidences.length === 0; })) {
	            this.form.names.push({
	                isNew: true,
	                key: this.utils.randomKey(),
	                evidences: []
	            });
	        }
	        if (!this.form.births.some(function (fact) { return fact.evidences.length === 0; })) {
	            this.form.births.push({
	                isNew: true,
	                key: this.utils.randomKey(),
	                type: 'BIRT',
	                evidences: []
	            });
	        }
	        if (!this.form.deaths.some(function (fact) { return fact.evidences.length === 0; })) {
	            this.form.deaths.push({
	                isNew: true,
	                key: this.utils.randomKey(),
	                type: 'DEAT',
	                evidences: []
	            });
	        }
	        $log.debug('editPerson.form', this.form);
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    EditPersonController.prototype.transformTag = function (tag) {
	        return tag;
	    };
	    EditPersonController.prototype.queryTag = function (text) {
	        return !!text ? this.personsService.tagAutocomplete(text, this.treeTags) : [];
	    };
	    EditPersonController.prototype.isImageFile = function (file) {
	        return this.mediaService.isImageFile(file);
	    };
	    EditPersonController.prototype.getImageFormat = function (file) {
	        return this.mediaService.getImageFormat(file);
	    };
	    EditPersonController.prototype.fileChange = function (mediaSlot, files) {
	        this.$log.debug('fileChange', files);
	        if (!!files && files.length > 0) {
	            mediaSlot.fileName = files[0].name;
	            mediaSlot.fileDataURI = '';
	            mediaSlot.cropped = false;
	            if (mediaSlot === this.profileMediaSlot) {
	                this.form.profilePhoto = 0;
	            }
	            else {
	                this.form.coverPhoto = 0;
	            }
	            if (!!files[0] && this.isImageFile(files[0])) {
	                mediaSlot.fileStatus = 'loading';
	            }
	            else {
	                mediaSlot.fileStatus = 'noimage';
	            }
	        }
	    };
	    EditPersonController.prototype.fileLoadDone = function (mediaSlot) {
	        if (mediaSlot.fileStatus === 'loading') {
	            this.$timeout(function () {
	                mediaSlot.fileStatus = 'loaded';
	            });
	        }
	        // spurious fileChange events get sent for 1-2 seconds after file loaded
	        this.$timeout(function () {
	            mediaSlot.cropped = false;
	        }, 1500);
	    };
	    EditPersonController.prototype.fileChangeCrop = function (mediaSlot) {
	        mediaSlot.cropped = true;
	    };
	    EditPersonController.prototype.getMediaFileType = function (media) {
	        return Array.from(media.fileInfos.values())[0].contentType;
	    };
	    EditPersonController.prototype.getMediaFileURL = function (media) {
	        return this.mediaService.getFileURL(media.id, Array.from(media.fileInfos.keys())[0], '100x100');
	    };
	    EditPersonController.prototype.queryPlace = function (text) {
	        return !!text ? this.places.autocomplete(text) : [];
	    };
	    EditPersonController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        this.isSubmitted = true;
	        var p = this.utils.clone(this.person);
	        p.preferredNameKey = +this.form.preferredNameKey;
	        p.preferredBirthKey = +this.form.preferredBirthKey;
	        p.preferredDeathKey = +this.form.preferredDeathKey;
	        p.profilePhoto = +this.form.profilePhoto;
	        p.coverPhoto = +this.form.coverPhoto;
	        p.gender = this.form.gender === 'UNKNOWN' ? '' : this.form.gender;
	        p.living = this.form.living;
	        p.tags = new Map(this.form.tags.map(function (tag) { return [tag, true]; }));
	        if (!!this.searchTag) {
	            p.tags.set(this.searchTag, true);
	        }
	        var namesCount = this.person.names.size;
	        this.form.names.forEach(function (n) {
	            if (n.evidences.length === 0) {
	                if (n.isNew && p.preferredNameKey !== n.key) {
	                    // ignore new name that is not preferred
	                }
	                else if (!n.isNew && !n.given && !n.surname && !n.prefix && !n.suffix && namesCount > 1) {
	                    // delete existing name that is empty if there is another name
	                    p.names.delete(n.key);
	                    if (p.preferredNameKey === n.key) {
	                        p.preferredNameKey = 0;
	                    }
	                    namesCount--;
	                }
	                else if (!!n.given || !!n.surname || !!n.prefix || !!n.suffix) {
	                    // add/update name
	                    if (n.isNew) {
	                        p.names.set(n.key, {
	                            nameForms: new Map([['default', {}]]),
	                            type: '',
	                            date: '',
	                            dateSort: '',
	                            evidencePersonas: new Map()
	                        });
	                    }
	                    p.names.get(n.key).nameForms.set('default', {
	                        given: n.given,
	                        surname: n.surname,
	                        prefix: n.prefix,
	                        suffix: n.suffix
	                    });
	                }
	            }
	        });
	        this.form.births.forEach(function (f) {
	            if (f.evidences.length === 0) {
	                if (f.isNew && p.preferredBirthKey !== f.key) {
	                    // ignore new fact that is not preferred
	                }
	                else if (!f.isNew && !f.date && !f.place) {
	                    // delete existing fact that is empty
	                    p.facts.delete(f.key);
	                    if (p.preferredBirthKey === f.key) {
	                        p.preferredBirthKey = 0;
	                    }
	                }
	                else if (!!f.date || !!f.place || !!f.placeText) {
	                    // add/update fact
	                    if (f.isNew) {
	                        p.facts.set(f.key, {
	                            principal: true,
	                            evidencePersonas: new Map()
	                        });
	                    }
	                    p.facts.get(f.key).type = f.type;
	                    if (p.facts.get(f.key).date !== f.date) {
	                        p.facts.get(f.key).date = f.date;
	                        p.facts.get(f.key).dateSort = '';
	                    }
	                    var place = !!f.place ? f.place.name : !!f.placeText ? f.placeText : '';
	                    if (p.facts.get(f.key).place !== place) {
	                        p.facts.get(f.key).place = place;
	                        p.facts.get(f.key).placeStandard = !!f.place ? f.place.standardName : '';
	                        p.facts.get(f.key).latitude = !!f.place ? f.place.latitude : 0;
	                        p.facts.get(f.key).longitude = !!f.place ? f.place.longitude : 0;
	                    }
	                }
	            }
	        });
	        this.form.deaths.forEach(function (f) {
	            if (f.evidences.length === 0) {
	                if (f.isNew && p.preferredDeathKey !== f.key) {
	                    // ignore new fact that is not preferred
	                }
	                else if (!f.isNew && !f.date && !f.place) {
	                    // delete existing fact that is empty
	                    p.facts.delete(f.key);
	                    if (p.preferredDeathKey === f.key) {
	                        p.preferredDeathKey = 0;
	                    }
	                }
	                else if (!!f.date || !!f.place || !!f.placeText) {
	                    // add/update fact
	                    if (f.isNew) {
	                        p.facts.set(f.key, {
	                            principal: true,
	                            evidencePersonas: new Map()
	                        });
	                    }
	                    p.facts.get(f.key).type = f.type;
	                    if (p.facts.get(f.key).date !== f.date) {
	                        p.facts.get(f.key).date = f.date;
	                        p.facts.get(f.key).dateSort = '';
	                    }
	                    var place = !!f.place ? f.place.name : !!f.placeText ? f.placeText : '';
	                    if (p.facts.get(f.key).place !== place) {
	                        p.facts.get(f.key).place = place;
	                        p.facts.get(f.key).placeStandard = !!f.place ? f.place.standardName : '';
	                        p.facts.get(f.key).latitude = !!f.place ? f.place.latitude : 0;
	                        p.facts.get(f.key).longitude = !!f.place ? f.place.longitude : 0;
	                    }
	                }
	            }
	        });
	        if (p.preferredNameKey > 0 && !p.names.has(p.preferredNameKey)) {
	            if (p.names.size > 0) {
	                this.messageBus.post({ msg: 'Please choose a preferred name' });
	                this.saving = false;
	                return;
	            }
	            else {
	                p.preferredNameKey = 0;
	            }
	        }
	        if (p.preferredBirthKey > 0 && !p.facts.has(p.preferredBirthKey)) {
	            if (Array.from(p.facts.keys()).some(function (k) { return p.facts.get(k).principal && (p.facts.get(k).type === 'BIRT' || p.facts.get(k).type === 'CHR' || p.facts.get(k).type === 'BAPM'); })) {
	                this.messageBus.post({ msg: 'Please choose a preferred birth' });
	                this.saving = false;
	                return;
	            }
	            else {
	                p.preferredBirthKey = 0;
	            }
	        }
	        if (p.preferredDeathKey > 0 && !p.facts.has(p.preferredDeathKey)) {
	            if (Array.from(p.facts.keys()).some(function (k) { return p.facts.get(k).principal && (p.facts.get(k).type === 'DEAT' || p.facts.get(k).type === 'BURI'); })) {
	                this.messageBus.post({ msg: 'Please choose a preferred death' });
	                this.saving = false;
	                return;
	            }
	            else {
	                p.preferredDeathKey = 0;
	            }
	        }
	        if (p.preferredNameKey === 0 && p.names.size > 0) {
	            p.preferredNameKey = Array.from(p.names.keys())[0];
	        }
	        if (p.preferredBirthKey === 0 && Array.from(p.facts.keys()).some(function (k) { return p.facts.get(k).principal && (p.facts.get(k).type === 'BIRT' || p.facts.get(k).type === 'CHR' || p.facts.get(k).type === 'BAPM'); })) {
	            p.preferredBirthKey = Array.from(p.facts.keys()).find(function (k) { return p.facts.get(k).principal && (p.facts.get(k).type === 'BIRT' || p.facts.get(k).type === 'CHR' || p.facts.get(k).type === 'BAPM'); });
	        }
	        if (p.preferredDeathKey === 0 && Array.from(p.facts.keys()).some(function (k) { return p.facts.get(k).principal && (p.facts.get(k).type === 'DEAT' || p.facts.get(k).type === 'BURI'); })) {
	            p.preferredDeathKey = Array.from(p.facts.keys()).find(function (k) { return p.facts.get(k).principal && (p.facts.get(k).type === 'DEAT' || p.facts.get(k).type === 'BURI'); });
	        }
	        var title = this.personsService.getNameText(this.personsService.getDefaultNameForm(this.personsService.getPreferredName(p)));
	        this.createMediasFromFiles(title, p.profilePhoto, this.profileMediaSlot, p.coverPhoto, this.coverMediaSlot).subscribe(function (medias) {
	            if (p.profilePhoto === 0 && !!_this.profileMediaSlot.fileStatus) {
	                p.profilePhoto = medias.shift().id;
	            }
	            if (p.coverPhoto === 0 && !!_this.coverMediaSlot.fileStatus) {
	                p.coverPhoto = medias.shift().id;
	            }
	            _this.personUtils.update(p).subscribe(function (p) {
	                _this.saving = false;
	                _this.$mdDialog.hide();
	            }, function () {
	                _this.saving = false;
	            });
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    EditPersonController.prototype.createMediasFromFiles = function (title, profilePhoto, profileMediaSlot, coverPhoto, coverMediaSlot) {
	        var _this = this;
	        var filledSlots = [];
	        if (profilePhoto === 0 && !!profileMediaSlot.fileStatus) {
	            filledSlots.push(profileMediaSlot);
	        }
	        if (coverPhoto === 0 && !!coverMediaSlot.fileStatus) {
	            filledSlots.push(coverMediaSlot);
	        }
	        if (filledSlots.length === 0) {
	            return this.rx.Observable.of([]);
	        }
	        var personIds = new Map([[this.person.id, true]]);
	        return (_a = this.rx.Observable).forkJoin.apply(_a, __spread(filledSlots.map(function (ms) {
	            return _this.mediaService.createMediaFromFile({ title: title, personIds: personIds }, ms);
	        })));
	        var _a;
	    };
	    EditPersonController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditPersonController;
	}());
	exports.default = EditPersonController;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	var EditResearchLogController = /** @class */ (function () {
	    EditResearchLogController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "$timeout", "messageBus", "researchLogs", "persons", "utils"];
	    function EditResearchLogController($log, $mdDialog, $mdMedia, $scope, $timeout, messageBus, researchLogs, persons, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.researchLogs = researchLogs;
	        this.persons = persons;
	        this.utils = utils;
	        // if updating, this.researchLog is passed in
	        // if adding from a person page, personId is passed in
	        // TODO add private checkbox
	        var personIds = [];
	        this.private = false;
	        if (!!this.researchLog) {
	            this.title = this.researchLog.title;
	            this.text = this.researchLog.text;
	            this.private = this.researchLog.private;
	            personIds = Array.from(this.researchLog.personIds.keys());
	        }
	        else if (this.personId > 0) {
	            personIds = [this.personId];
	        }
	        this.people = [];
	        if (personIds.length > 0) {
	            persons.streamIds(personIds).take(1).subscribe(function (personMap) {
	                _this.people = Array.from(personMap.values()).map(_this.toPersonObject);
	            });
	        }
	        /*this.private = null;
	        if (this.researchLog.private != null) {
	          this.private = this.researchLog.private;
	        }*/
	        this.focusField = '';
	        this.froalaOptions = utils.froalaOptions(null, function () {
	            $timeout(function () {
	                _this.focusField = 'text';
	            });
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    EditResearchLogController.prototype.focus = function (fld) {
	        this.focusField = fld;
	    };
	    EditResearchLogController.prototype.addPerson = function (id) {
	        var _this = this;
	        this.persons.streamId(id).take(1).subscribe(function (person) {
	            if (!_this.people.find(function (p) { return p.id === person.id; })) {
	                _this.people.push(_this.toPersonObject(person));
	            }
	        });
	    };
	    EditResearchLogController.prototype.querySearch = function (query) {
	        var _this = this;
	        return !query ? [] : this.persons.nameAutocomplete(query).then(function (people) { return people.map(_this.toPersonObject); });
	    };
	    EditResearchLogController.prototype.toPersonObject = function (p) {
	        return {
	            id: p.id,
	            name: p._fullName,
	            email: p._lifespan,
	            image: p._iconURL
	        };
	    };
	    EditResearchLogController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var researchLog = !!this.researchLog ? this.utils.clone(this.researchLog) : { id: 0 };
	        researchLog.title = this.title;
	        researchLog.text = this.text;
	        researchLog.private = this.private;
	        researchLog.personIds = new Map();
	        this.people.forEach(function (p) {
	            researchLog.personIds.set(p.id, true);
	        });
	        (!!this.researchLog ? this.researchLogs.update : this.researchLogs.create).bind(this.researchLogs)(researchLog).subscribe(function (researchLog) {
	            _this.saving = false;
	            _this.$log.debug('editResearchLog.submit', researchLog);
	            _this.$mdDialog.hide(researchLog);
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    EditResearchLogController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditResearchLogController;
	}());
	exports.default = EditResearchLogController;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditRightsController = /** @class */ (function () {
	    EditRightsController.$inject = ["$log", "$mdDialog", "$scope", "messageBus", "rights", "segment", "utils"];
	    function EditRightsController($log, $mdDialog, $scope, messageBus, rights, segment, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.rights = rights;
	        this.segment = segment;
	        this.utils = utils;
	        this.level = this.right.level;
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    EditRightsController.prototype.del = function (ev) {
	        var _this = this;
	        this.$mdDialog.hide();
	        this.utils.confirm('Remove user', 'Are you sure?', ev).then(function () {
	            _this.rights.del(_this.right.id).subscribe();
	        }, function () {
	            // ignore
	        });
	    };
	    EditRightsController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var right = {
	            treeId: this.right.treeId,
	            id: this.right.id,
	            level: parseInt(this.level, 10),
	            version: this.right.version
	        };
	        this.rights.update(right).subscribe(function () {
	            _this.saving = false;
	            _this.segment.track('rights.update');
	            _this.$mdDialog.hide();
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    EditRightsController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditRightsController;
	}());
	exports.default = EditRightsController;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditSourceController = /** @class */ (function () {
	    EditSourceController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "$timeout", "rx", "messageBus", "sources", "medias", "utils"];
	    function EditSourceController($log, $mdDialog, $mdMedia, $scope, $timeout, rx, messageBus, sources, medias, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.$timeout = $timeout;
	        this.rx = rx;
	        this.sources = sources;
	        this.mediaService = medias;
	        this.utils = utils;
	        //this.types = [
	        //  'Article',
	        //  'Book',
	        //  'Government / Church records',
	        //  'Newspaper',
	        //  'Periodical',
	        //  'Website',
	        //  'Other'
	        //];
	        // passed in: source (optional)
	        this.medias = [];
	        if (!!this.source) {
	            this.abbr = this.source.abbr;
	            this.title = this.source.title;
	            this.subtitle = this.source.subtitle;
	            this.creator = this.source.creator;
	            this.publisher = this.source.publisher;
	            this.dateIssued = this.source.dateIssued;
	            this.placeIssued = this.source.placeIssued;
	            this.periodicalSeries = this.source.periodicalSeries;
	            this.numVolumes = this.source.numVolumes;
	            this.volumeFilmPages = this.source.volumeFilmPages;
	            this.url = this.source.url;
	            this.repository = this.source.repository;
	            this.callNumber = this.source.callNumber;
	            this.bibCitation = this.source.bibCitation;
	            this.shortFootnote = this.source.shortFootnote;
	            this.text = this.source.text;
	            this.type = this.source.type;
	            var mediaIds = Array.from(this.source.mediaIds.keys());
	            if (mediaIds.length > 0) {
	                medias.streamIds(mediaIds).take(1).subscribe(function (mediaMap) {
	                    _this.medias = Array.from(mediaMap.values());
	                });
	            }
	        }
	        this.focusField = '';
	        this.froalaBibCitationOptions = utils.froalaOptions(null, function () {
	            $timeout(function () {
	                _this.focusField = 'bibCitation';
	            });
	        });
	        this.froalaShortFootnoteOptions = utils.froalaOptions(null, function () {
	            $timeout(function () {
	                _this.focusField = 'shortFootnote';
	            });
	        });
	        this.froalaTextOptions = utils.froalaOptions(null, function () {
	            $timeout(function () {
	                _this.focusField = 'text';
	            });
	        });
	        this.fileTypes = medias.fileTypes;
	        this.fileModelOptions = medias.fileModelOptions;
	        this.fileValidation = medias.fileValidation;
	        this.fileDragover = medias.fileDragover;
	        this.mediaSlots = [];
	        this.addMediaSlot();
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    //
	    // media
	    //
	    EditSourceController.prototype.hasEmptyMediaSlot = function () {
	        return this.mediaSlots.some(function (ms) { return !ms.fileStatus; });
	    };
	    EditSourceController.prototype.addMediaSlot = function () {
	        this.mediaSlots.push({
	            fileStatus: '',
	            cropped: false
	        });
	    };
	    EditSourceController.prototype.isImageFile = function (file) {
	        return this.mediaService.isImageFile(file);
	    };
	    EditSourceController.prototype.getImageFormat = function (file) {
	        return this.mediaService.getImageFormat(file);
	    };
	    EditSourceController.prototype.fileChange = function (mediaSlot, files) {
	        this.$log.debug('fileChange', files);
	        if (!!files && files.length > 0) {
	            mediaSlot.fileName = files[0].name;
	            mediaSlot.fileDataURI = '';
	            mediaSlot.cropped = false;
	            this.focus('file');
	            if (!!files[0] && this.isImageFile(files[0])) {
	                mediaSlot.fileStatus = 'loading';
	            }
	            else {
	                mediaSlot.fileStatus = 'noimage';
	            }
	        }
	    };
	    EditSourceController.prototype.fileLoadDone = function (mediaSlot) {
	        if (mediaSlot.fileStatus === 'loading') {
	            this.$timeout(function () {
	                mediaSlot.fileStatus = 'loaded';
	            });
	        }
	        // spurious fileChange events get sent for 1-2 seconds after file loaded
	        this.$timeout(function () {
	            mediaSlot.cropped = false;
	        }, 1500);
	    };
	    EditSourceController.prototype.fileChangeCrop = function (mediaSlot) {
	        mediaSlot.cropped = true;
	    };
	    EditSourceController.prototype.removeMedia = function (medias, ix) {
	        medias.splice(ix, 1);
	    };
	    EditSourceController.prototype.removeMediaSlot = function (mediaSlots, ix) {
	        mediaSlots.splice(ix, 1);
	    };
	    EditSourceController.prototype.getMediaFileType = function (media) {
	        return Array.from(media.fileInfos.values())[0].contentType;
	    };
	    EditSourceController.prototype.getMediaFileURL = function (media) {
	        return this.mediaService.getFileURL(media.id, Array.from(media.fileInfos.keys())[0], '100x100');
	    };
	    //
	    // general
	    //
	    EditSourceController.prototype.focus = function (fld) {
	        this.focusField = fld;
	    };
	    EditSourceController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var source = !!this.source ? this.utils.clone(this.source) : { id: 0 };
	        source.abbr = this.abbr;
	        source.title = this.title;
	        source.subtitle = this.subtitle;
	        source.creator = this.creator;
	        source.publisher = this.publisher;
	        source.dateIssued = this.dateIssued;
	        source.placeIssued = this.placeIssued;
	        source.periodicalSeries = this.periodicalSeries;
	        source.numVolumes = this.numVolumes;
	        source.volumeFilmPages = this.volumeFilmPages;
	        source.url = this.utils.fixURL(this.url);
	        source.repository = this.repository;
	        source.callNumber = this.callNumber;
	        source.bibCitation = this.bibCitation;
	        source.shortFootnote = this.shortFootnote;
	        source.text = this.text;
	        source.type = this.type;
	        source.mediaIds = new Map();
	        this.medias.forEach(function (media) {
	            source.mediaIds.set(media.id, true);
	        });
	        // create new media for each mediaSlot
	        this.createMediasFromFiles(source.abbr, this.mediaSlots).subscribe(function (medias) {
	            medias.forEach(function (media) {
	                source.mediaIds.set(media.id, true);
	            });
	            (!!_this.source ? _this.sources.update : _this.sources.create).bind(_this.sources)(source).subscribe(function (source) {
	                _this.saving = false;
	                _this.$log.debug('editSource.submit', source);
	                _this.$mdDialog.hide(source);
	            }, function () {
	                _this.saving = false;
	            });
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    EditSourceController.prototype.createMediasFromFiles = function (title, mediaSlots) {
	        var _this = this;
	        var filledSlots = mediaSlots.filter(function (ms) { return !!ms.fileStatus; });
	        if (filledSlots.length === 0) {
	            return this.rx.Observable.of([]);
	        }
	        return (_a = this.rx.Observable).forkJoin.apply(_a, __spread(filledSlots.map(function (ms) {
	            return _this.mediaService.createMediaFromFile({ title: title }, ms);
	        })));
	        var _a;
	    };
	    EditSourceController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditSourceController;
	}());
	exports.default = EditSourceController;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditStoryController = /** @class */ (function () {
	    EditStoryController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "$timeout", "rx", "messageBus", "currentTreeId", "medias", "persons", "places", "researchLogs", "stories", "rights", "users", "utils"];
	    function EditStoryController($log, $mdDialog, $mdMedia, $scope, $timeout, rx, messageBus, currentTreeId, medias, persons, places, researchLogs, stories, rights, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.$timeout = $timeout;
	        this.rx = rx;
	        this.currentTreeIdService = currentTreeId;
	        this.mediaService = medias;
	        this.persons = persons;
	        this.places = places;
	        this.stories = stories;
	        this.utils = utils;
	        // passed in: story or personId or neither and maybe researchLogId
	        var personIds = [];
	        this.medias = [];
	        if (!!this.story) {
	            this.title = this.story.title;
	            this.text = this.story.text;
	            this.date = this.story.date;
	            this.placeText = this.story.place;
	            if (!!this.story.placeStandard) {
	                this.place = {
	                    name: this.story.place,
	                    standardName: this.story.placeStandard,
	                    latitude: this.story.latitude,
	                    longitude: this.story.longitude
	                };
	            }
	            this.researchLogId = this.story.researchLogId || '';
	            personIds = Array.from(this.story.personIds.keys());
	            var mediaIds = Array.from(this.story.mediaIds.keys());
	            if (mediaIds.length > 0) {
	                medias.streamIds(mediaIds).take(1).subscribe(function (mediaMap) {
	                    _this.medias = Array.from(mediaMap.values());
	                });
	            }
	        }
	        else if (this.personId > 0) {
	            personIds = [this.personId];
	        }
	        this.people = [];
	        if (personIds.length > 0) {
	            persons.streamIds(personIds).take(1).subscribe(function (personMap) {
	                _this.people = Array.from(personMap.values()).map(_this.toPersonObject);
	            });
	        }
	        this.logs = [];
	        var rlSub = utils.watch($scope, function () { return _this.people; }, true).flatMap(function () { return researchLogs.ready(); }).flatMap(function () { return researchLogs.stream(); }).subscribe(function (logMap) {
	            _this.logs = _this.utils.getResearchLogTitles(logMap, _this.people);
	        });
	        this.focusField = '';
	        this.froalaOptions = utils.froalaOptions(utils.atConfigUser(users, rights, currentTreeId), function () {
	            $timeout(function () {
	                _this.focusField = 'text';
	            });
	        });
	        users.streamAllUsers(rights).take(1).subscribe(function (allUsers) {
	            _this.allUsers = allUsers;
	        });
	        this.fileTypes = medias.fileTypes;
	        this.fileModelOptions = medias.fileModelOptions;
	        this.fileValidation = medias.fileValidation;
	        this.fileDragover = medias.fileDragover;
	        this.mediaSlots = [];
	        this.addMediaSlot();
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            rlSub.unsubscribe();
	            mbSub.unsubscribe();
	        });
	    }
	    //
	    // media
	    //
	    EditStoryController.prototype.hasEmptyMediaSlot = function () {
	        return this.mediaSlots.some(function (ms) { return !ms.fileStatus; });
	    };
	    EditStoryController.prototype.addMediaSlot = function () {
	        this.mediaSlots.push({
	            fileStatus: '',
	            cropped: false
	        });
	    };
	    EditStoryController.prototype.isImageFile = function (file) {
	        return this.mediaService.isImageFile(file);
	    };
	    EditStoryController.prototype.getImageFormat = function (file) {
	        return this.mediaService.getImageFormat(file);
	    };
	    EditStoryController.prototype.fileChange = function (mediaSlot, files) {
	        this.$log.debug('fileChange', files);
	        if (!!files && files.length > 0) {
	            mediaSlot.fileName = files[0].name;
	            mediaSlot.fileDataURI = '';
	            mediaSlot.cropped = false;
	            this.focus('file');
	            if (!!files[0] && this.isImageFile(files[0])) {
	                mediaSlot.fileStatus = 'loading';
	            }
	            else {
	                mediaSlot.fileStatus = 'noimage';
	            }
	        }
	    };
	    EditStoryController.prototype.fileLoadDone = function (mediaSlot) {
	        if (mediaSlot.fileStatus === 'loading') {
	            this.$timeout(function () {
	                mediaSlot.fileStatus = 'loaded';
	            });
	        }
	        // spurious fileChange events get sent for 1-2 seconds after file loaded
	        this.$timeout(function () {
	            mediaSlot.cropped = false;
	        }, 1500);
	    };
	    EditStoryController.prototype.fileChangeCrop = function (mediaSlot) {
	        mediaSlot.cropped = true;
	    };
	    EditStoryController.prototype.removeMedia = function (medias, ix) {
	        medias.splice(ix, 1);
	    };
	    EditStoryController.prototype.removeMediaSlot = function (mediaSlots, ix) {
	        mediaSlots.splice(ix, 1);
	    };
	    EditStoryController.prototype.getMediaFileType = function (media) {
	        return Array.from(media.fileInfos.values())[0].contentType;
	    };
	    EditStoryController.prototype.getMediaFileURL = function (media) {
	        return this.mediaService.getFileURL(media.id, Array.from(media.fileInfos.keys())[0], '100x100');
	    };
	    //
	    // general
	    //
	    EditStoryController.prototype.focus = function (fld) {
	        this.focusField = fld;
	    };
	    EditStoryController.prototype.queryPlace = function (text) {
	        return !!text ? this.places.autocomplete(text) : [];
	    };
	    EditStoryController.prototype.addPerson = function (id) {
	        var _this = this;
	        this.persons.streamId(id).take(1).subscribe(function (person) {
	            if (!_this.people.find(function (p) { return p.id === person.id; })) {
	                _this.people.push(_this.toPersonObject(person));
	            }
	        });
	    };
	    EditStoryController.prototype.querySearch = function (query) {
	        var _this = this;
	        return !query ? [] : this.persons.nameAutocomplete(query).then(function (people) { return people.map(_this.toPersonObject); });
	    };
	    EditStoryController.prototype.toPersonObject = function (p) {
	        return {
	            id: p.id,
	            name: p._fullName,
	            email: p._lifespan,
	            image: p._iconURL
	        };
	    };
	    EditStoryController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var story = !!this.story ? this.utils.clone(this.story) : { id: 0 };
	        story.title = this.title;
	        story.text = this.utils.expandMentions(this.currentTreeIdService, this.allUsers, this.text);
	        story.date = this.date || '';
	        story.dateSort = '';
	        story.place = !!this.place ? this.place.name : !!this.placeText ? this.placeText : '';
	        story.placeStandard = !!this.place ? this.place.standardName : '';
	        story.latitude = !!this.place ? this.place.latitude : 0;
	        story.longitude = !!this.place ? this.place.longitude : 0;
	        story.researchLogId = +this.researchLogId;
	        story.personIds = new Map();
	        this.people.forEach(function (p) {
	            story.personIds.set(p.id, true);
	        });
	        story.mediaIds = new Map();
	        this.medias.forEach(function (media) {
	            story.mediaIds.set(media.id, true);
	        });
	        // create new media for each mediaSlot
	        this.createMediasFromFiles(story.title, this.mediaSlots).subscribe(function (medias) {
	            medias.forEach(function (media) {
	                story.mediaIds.set(media.id, true);
	            });
	            (!!_this.story ? _this.stories.update : _this.stories.create).bind(_this.stories)(story).subscribe(function (story) {
	                _this.saving = false;
	                _this.$log.debug('editStory.submit', story);
	                _this.$mdDialog.hide(story);
	            }, function () {
	                _this.saving = false;
	            });
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    EditStoryController.prototype.createMediasFromFiles = function (title, mediaSlots) {
	        var _this = this;
	        var filledSlots = mediaSlots.filter(function (ms) { return !!ms.fileStatus; });
	        if (filledSlots.length === 0) {
	            return this.rx.Observable.of([]);
	        }
	        return (_a = this.rx.Observable).forkJoin.apply(_a, __spread(filledSlots.map(function (ms) {
	            return _this.mediaService.createMediaFromFile({ title: title }, ms);
	        })));
	        var _a;
	    };
	    EditStoryController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditStoryController;
	}());
	exports.default = EditStoryController;


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var EditTagsController = /** @class */ (function () {
	    EditTagsController.$inject = ["$log", "$mdDialog", "$scope", "messageBus"];
	    function EditTagsController($log, $mdDialog, $scope, messageBus) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.allTags = ['paternalLine', 'maternalLine', 'famous', ''];
	        this.tags = [];
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    EditTagsController.prototype.queryTags = function (query) {
	        return query ? this.allTags.filter(this.createFilterForTags(query)) : [];
	    };
	    EditTagsController.prototype.createFilterForTags = function (query) {
	        //query = this.cleanTag(query);
	        var lowercaseQuery = angular.lowercase(query);
	        return function filterFn(tag) {
	            return (tag.toLowerCase().indexOf(lowercaseQuery) !== -1);
	        };
	    };
	    EditTagsController.prototype.searchTagChanged = function (text) {
	        this.allTags[this.allTags.length - 1] = text;
	    };
	    EditTagsController.prototype.addTag = function (tag) {
	        //tag = this.cleanTag(tag);
	        this.allTags.splice(-1, 0, tag);
	        return tag;
	    };
	    EditTagsController.prototype.submit = function () {
	        this.msg = '';
	        this.saving = true;
	        this.saving = false;
	        this.$mdDialog.hide();
	    };
	    EditTagsController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return EditTagsController;
	}());
	exports.default = EditTagsController;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var FacebookController = /** @class */ (function () {
	    FacebookController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus", "social"];
	    function FacebookController($log, $mdDialog, $mdMedia, $scope, messageBus, social) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.social = social;
	        this.msg = '';
	        // passed in: link, title, description, picture, thumbnail
	        this.privacies = ['FB_EVERYONE', 'FB_FRIENDS_OF_FRIENDS', 'FB_ALL_FRIENDS', 'FB_SELF'];
	        this.privacy = 'FB_EVERYONE';
	        this.caption = 'rootsfinder.com';
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    FacebookController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var item = {
	            message: this.message,
	            link: this.link,
	            picture: this.picture,
	            name: this.title,
	            caption: this.caption,
	            description: this.description,
	            privacy: this.privacy.substr(3)
	        };
	        this.social.postFacebook(item).subscribe(function () {
	            _this.saving = false;
	            _this.$mdDialog.cancel();
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    FacebookController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return FacebookController;
	}());
	exports.default = FacebookController;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var ForgotPasswordController = /** @class */ (function () {
	    ForgotPasswordController.$inject = ["$log", "$mdDialog", "$scope", "authentication", "messageBus", "utils"];
	    function ForgotPasswordController($log, $mdDialog, $scope, authentication, messageBus, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$scope = $scope;
	        this.authentication = authentication;
	        this.messageBus = messageBus;
	        this.utils = utils;
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    ForgotPasswordController.prototype.submit = function (ev) {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        this.authentication.forgotPassword(this.email).subscribe(function (response) {
	            _this.saving = false;
	            if (response.status === 'OK') {
	                _this.$mdDialog.hide();
	                _this.utils.alert('Email Sent', 'An email has been sent to ' + _this.email + '. If you don\'t see it in a couple minutes, please check your spam folders.', ev);
	            }
	            else if (response.status === 'NOT_FOUND') {
	                _this.msg = 'Email not found';
	            }
	        }, function () {
	            _this.saving = false;
	            _this.$log.debug('login failure');
	        });
	    };
	    ForgotPasswordController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return ForgotPasswordController;
	}());
	exports.default = ForgotPasswordController;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var FsAddSourceController = /** @class */ (function () {
	    FsAddSourceController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "rx", "messageBus", "evidences", "persons", "sources", "utils"];
	    function FsAddSourceController($log, $mdDialog, $mdMedia, $scope, rx, messageBus, evidences, persons, sources, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.rx = rx;
	        this.messageBus = messageBus;
	        this.evidences = evidences;
	        this.persons = persons;
	        this.sources = sources;
	        this.utils = utils;
	        // passed in: person, evidence
	        var facts = Array.from(this.person.facts.values())
	            .filter(function (f) { return f.principal && f.type !== 'SOUR'; })
	            .map(function (f) {
	            var ft = utils.factTypes.find(function (ft) { return ft.value === f.type; });
	            var text = f.value || '';
	            if (!!f.date) {
	                text += f.date;
	            }
	            if (!!f.place) {
	                text += ' in ' + f.place;
	            }
	            return {
	                key: f._key,
	                fact: f,
	                primary: false,
	                other: false,
	                type: !!ft ? ft.display : f.type,
	                text: text
	            };
	        });
	        facts.sort(function (a, b) {
	            return !!a.fact.dateSort && !!b.fact.dateSort ? a.fact.dateSort - b.fact.dateSort : !!a.fact.dateSort ? -1 : !!b.fact.dateSort ? 1 : 0;
	        });
	        var names = Array.from(this.person.names.values())
	            .map(function (n) {
	            return {
	                key: n._key,
	                name: n,
	                primary: false,
	                other: false,
	                type: persons.getNameText(persons.getDefaultNameForm(n)),
	                text: ''
	            };
	        });
	        names.sort(function (a, b) {
	            return a.type < b.type ? -1 : a.type > b.type ? 1 : 0;
	        });
	        this.facts = facts.concat(names);
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    FsAddSourceController.prototype.setPrimary = function (fact) {
	        this.facts.forEach(function (f) {
	            if (f.key !== fact.key) {
	                f.primary = false;
	                if (!!f.name && !!fact.name) {
	                    f.other = false;
	                }
	            }
	        });
	        fact.other = false;
	    };
	    FsAddSourceController.prototype.setOther = function (fact) {
	        this.facts.forEach(function (f) {
	            if (!!f.name && !!fact.name && f.key !== fact.key) {
	                f.primary = false;
	                f.other = false;
	            }
	        });
	    };
	    FsAddSourceController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    FsAddSourceController.prototype.submit = function () {
	        var _this = this;
	        var factKeys = [];
	        var nameKeys = [];
	        var target = this.utils.clone(this.evidence);
	        var persona = target.personas.get(1);
	        var primary = this.facts.find(function (f) { return f.primary; });
	        if (!!primary) {
	            if (!!primary.name) {
	                target.fact = {
	                    type: 'NAME'
	                };
	                persona.names.set(this.utils.randomKey(), {
	                    nameForms: primary.name.nameForms,
	                    type: primary.name.type
	                });
	                nameKeys.push(primary.name._key);
	            }
	            else {
	                target.fact = {
	                    type: primary.fact.type,
	                    value: primary.fact.value,
	                    date: primary.fact.date,
	                    dateSort: primary.fact.dateSort,
	                    place: primary.fact.place,
	                    placeDetails: primary.fact.placeDetails,
	                    placeStandard: primary.fact.placeStandard,
	                    latitude: primary.fact.latitude,
	                    longitude: primary.fact.longitude
	                };
	                factKeys.push(primary.fact._key);
	            }
	        }
	        this.facts.filter(function (f) { return f.other; }).forEach(function (f) {
	            if (!!f.name) {
	                persona.names.set(_this.utils.randomKey(), {
	                    nameForms: f.name.nameForms,
	                    type: f.name.type
	                });
	                nameKeys.push(f.name._key);
	            }
	            else {
	                persona.facts.set(_this.utils.randomKey(), {
	                    type: f.fact.type,
	                    value: f.fact.value,
	                    date: f.fact.date,
	                    dateSort: f.fact.dateSort,
	                    place: f.fact.place,
	                    placeDetails: f.fact.placeDetails,
	                    placeStandard: f.fact.placeStandard,
	                    latitude: f.fact.latitude,
	                    longitude: f.fact.longitude
	                });
	                factKeys.push(f.fact._key);
	            }
	        });
	        this.sources.stream().take(1).flatMap(function (sourceMap) {
	            var sourceId = 0;
	            if (!!target._sourceAbbr) {
	                try {
	                    for (var sourceMap_1 = __values(sourceMap), sourceMap_1_1 = sourceMap_1.next(); !sourceMap_1_1.done; sourceMap_1_1 = sourceMap_1.next()) {
	                        var _a = __read(sourceMap_1_1.value, 2), k = _a[0], v = _a[1];
	                        if (v.abbr === target._sourceAbbr) {
	                            sourceId = k;
	                            break;
	                        }
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (sourceMap_1_1 && !sourceMap_1_1.done && (_b = sourceMap_1.return)) _b.call(sourceMap_1);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	            }
	            if (sourceId === 0 && !!target._sourceAbbr) {
	                return _this.sources.create({
	                    id: 0,
	                    abbr: target._sourceAbbr,
	                    title: target._sourceAbbr,
	                    externalIds: new Map(),
	                    mediaIds: new Map()
	                }).map(function (source) { return source.id; });
	            }
	            return _this.rx.Observable.of(sourceId);
	            var e_1, _b;
	        }).flatMap(function (sourceId) {
	            target.citation.sourceId = sourceId;
	            return _this.evidences.create(target);
	        }).subscribe(function (evidence) {
	            // return an update function that takes a person and updates it in memory
	            _this.$mdDialog.hide(function (person) {
	                if (target.fact.type === 'SOUR') {
	                    person.facts.set(_this.utils.randomKey(), {
	                        type: 'SOUR',
	                        principal: true,
	                        evidencePersonas: new Map([[evidence.id, 1]]),
	                        externalIds: new Map()
	                    });
	                }
	                factKeys.forEach(function (key) {
	                    person.facts.get(key).evidencePersonas.set(evidence.id, 1);
	                });
	                nameKeys.forEach(function (key) {
	                    person.names.get(key).evidencePersonas.set(evidence.id, 1);
	                });
	            });
	        });
	    };
	    return FsAddSourceController;
	}());
	exports.default = FsAddSourceController;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var FsCompareLinkController = /** @class */ (function () {
	    FsCompareLinkController.$inject = ["$log", "$mdDialog", "utils"];
	    function FsCompareLinkController($log, $mdDialog, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.encodedId = utils.encodeId(this.id);
	    }
	    FsCompareLinkController.prototype.click = function () {
	        this.$mdDialog.hide();
	    };
	    FsCompareLinkController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return FsCompareLinkController;
	}());
	exports.default = FsCompareLinkController;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var FsLinkController = /** @class */ (function () {
	    FsLinkController.$inject = ["$log", "$mdDialog"];
	    function FsLinkController($log, $mdDialog) {
	        'ngInject';
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	    }
	    FsLinkController.prototype.click = function () {
	        this.$mdDialog.hide();
	    };
	    FsLinkController.prototype.save = function () {
	        this.$mdDialog.hide();
	    };
	    FsLinkController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return FsLinkController;
	}());
	exports.default = FsLinkController;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var FsLoginController = /** @class */ (function () {
	    FsLoginController.$inject = ["$log", "$mdDialog", "fs"];
	    function FsLoginController($log, $mdDialog, fs) {
	        'ngInject';
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.fs = fs;
	    }
	    FsLoginController.prototype.save = function () {
	        var _this = this;
	        this.fs.deleteAccessToken();
	        this.fs.streamAccessToken().take(1).subscribe(function (token) {
	            _this.$mdDialog.hide(token);
	        }, function () {
	            _this.$mdDialog.cancel();
	        });
	    };
	    FsLoginController.prototype.cancel = function () {
	        this.$mdDialog.hide(null);
	        // this.$mdDialog.cancel();
	    };
	    return FsLoginController;
	}());
	exports.default = FsLoginController;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var FS = 'familysearch.org';
	var FsMatchController = /** @class */ (function () {
	    FsMatchController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "rx", "messageBus", "fs", "persons", "families", "evidences", "utils"];
	    function FsMatchController($log, $mdDialog, $mdMedia, $scope, rx, messageBus, fs, persons, families, evidences, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.rx = rx;
	        this.messageBus = messageBus;
	        this.fs = fs;
	        this.persons = persons;
	        this.families = families;
	        this.evidences = evidences;
	        this.utils = utils;
	        // passed in: source, target (FamilySearch and RootsFinder)
	        // if source is RF: personId (RF), matchingPID (FS)
	        // if source is FS: personId (FS), rfPersonId, rfFamily, and relationship
	        this.person = null;
	        this.rf = null;
	        this.ext = null;
	        this.matches = [];
	        this.matchesReady = false;
	        this.spouses = [];
	        this.extSource = this.source === 'RootsFinder' ? this.target : this.source;
	        // read person
	        if (this.source === 'RootsFinder') {
	            this.readRFPerson(this.personId).subscribe(function (p) {
	                _this.person = p;
	                _this.rf = _this.person;
	                // get matches
	                _this.getMatches(_this.matchingPID);
	            });
	        }
	        else {
	            this.readFSPerson(this.personId).subscribe(function (p) {
	                _this.person = p;
	                _this.ext = _this.person;
	                // get matches
	                _this.getMatches();
	            });
	        }
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                if (msg.includes('person not having required conclusions')) {
	                    msg = 'Can\'t add: People without complete names can only be added on FamilySearch.org';
	                }
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    FsMatchController.prototype.getMatches = function (pid) {
	        var _this = this;
	        this.matchesReady = false;
	        this.matches = [];
	        this.msg = '';
	        if (this.source === 'RootsFinder') {
	            if (!pid) {
	                this.getFSMatches();
	            }
	            else {
	                this.readFSPerson(pid).subscribe(function (match) {
	                    _this.matches = [match];
	                    _this.matchesReady = true;
	                }, function () {
	                    _this.getFSMatches();
	                });
	            }
	        }
	        else {
	            if (!pid) {
	                this.getRFMatches();
	            }
	            else {
	                this.readRFPerson(this.utils.decodeId(pid)).subscribe(function (match) {
	                    _this.matches = [match];
	                    _this.matchesReady = true;
	                }, function (err) {
	                    _this.messageBus.post({ msg: err });
	                });
	            }
	        }
	    };
	    FsMatchController.prototype.readRFPerson = function (pid) {
	        var _this = this;
	        var subject = new this.rx.AsyncSubject();
	        this.rx.Observable.forkJoin(this.persons.streamId(pid).take(1), this.families.streamParents(pid).take(1), this.families.streamSpouses(pid).take(1)).take(1).subscribe(function (_a) {
	            var _b = __read(_a, 3), p = _b[0], pfm = _b[1], sfm = _b[2];
	            if (!p) {
	                subject.error('NOT_FOUND');
	                return;
	            }
	            var pf = _this.families.getPreferredFamily(pfm, p.preferredParentsFamilyId);
	            var spouseIds = [];
	            sfm.forEach(function (sf) {
	                var sid = sf.husbandId === pid ? sf.wifeId : sf.husbandId;
	                if (sid > 0) {
	                    spouseIds.push(sid);
	                }
	            });
	            var childIds = [];
	            sfm.forEach(function (sf) {
	                childIds = childIds.concat(Array.from(sf.childRels.keys()));
	            });
	            var waitCount = (!!pf && pf.husbandId > 0 ? 1 : 0) + (!!pf && pf.wifeId > 0 ? 1 : 0) + (spouseIds.length > 0 ? 1 : 0) + (childIds.length > 0 ? 1 : 0);
	            var person = {
	                person: p,
	                id: p.id,
	                PID: p.externalIds.has(FS) ? p.externalIds.get(FS).id : '',
	                name: p._fullName,
	                gender: p.gender,
	                birthType: p._birthType,
	                birthDate: p._birthDate,
	                birthPlace: p._birthPlace,
	                deathType: p._deathType,
	                deathDate: p._deathDate,
	                deathPlace: p._deathPlace,
	                spouses: [],
	                children: []
	            };
	            if (waitCount === 0) {
	                subject.next(person);
	                subject.complete();
	            }
	            if (!!pf && pf.husbandId > 0) {
	                _this.persons.streamId(pf.husbandId).take(1).subscribe(function (p) {
	                    person.father = p;
	                    person.fatherPID = p.externalIds.has(FS) ? p.externalIds.get(FS).id : '';
	                    person.fatherName = p._fullName;
	                    person.fatherBirthDate = p._birthDate;
	                    person.fatherDeathDate = p._deathDate;
	                    if (--waitCount === 0) {
	                        subject.next(person);
	                        subject.complete();
	                    }
	                });
	            }
	            if (!!pf && pf.wifeId > 0) {
	                _this.persons.streamId(pf.wifeId).take(1).subscribe(function (p) {
	                    person.mother = p;
	                    person.motherPID = p.externalIds.has(FS) ? p.externalIds.get(FS).id : '';
	                    person.motherName = p._fullName;
	                    person.motherBirthDate = p._birthDate;
	                    person.motherDeathDate = p._deathDate;
	                    if (--waitCount === 0) {
	                        subject.next(person);
	                        subject.complete();
	                    }
	                });
	            }
	            if (spouseIds.length > 0) {
	                (_c = _this.rx.Observable).forkJoin.apply(_c, __spread(spouseIds.map(function (sid) { return _this.persons.streamId(sid).take(1); }))).subscribe(function (spouses) {
	                    person.spouses = spouses.map(function (p) {
	                        return {
	                            person: p,
	                            PID: p.externalIds.has(FS) ? p.externalIds.get(FS).id : '',
	                            name: p._fullName,
	                            birthDate: p._birthDate,
	                            deathDate: p._deathDate
	                        };
	                    });
	                    if (--waitCount === 0) {
	                        subject.next(person);
	                        subject.complete();
	                    }
	                });
	            }
	            if (childIds.length > 0) {
	                (_d = _this.rx.Observable).forkJoin.apply(_d, __spread(childIds.map(function (cid) { return _this.persons.streamId(cid).take(1); }))).subscribe(function (children) {
	                    person.children = children.map(function (p) {
	                        return {
	                            person: p,
	                            PID: p.externalIds.has(FS) ? p.externalIds.get(FS).id : '',
	                            name: p._fullName,
	                            _birthDateSort: p._birthDateSort,
	                            birthDate: p._birthDate,
	                            deathDate: p._deathDate
	                        };
	                    });
	                    if (--waitCount === 0) {
	                        subject.next(person);
	                        subject.complete();
	                    }
	                });
	            }
	            var _c, _d;
	        }, function (err) {
	            subject.error(err);
	        });
	        return subject;
	    };
	    FsMatchController.prototype.getFSMatches = function () {
	        var _this = this;
	        this.fs.getMatches(this.person.person, this.person.father, this.person.mother, this.person.spouses.length > 0 ? this.person.spouses[0].person : null).subscribe(function (matches) {
	            _this.matches = matches.map(function (match) {
	                var father = match.parents.find(function (p) { return p.gender === 'Male'; });
	                var mother = match.parents.find(function (p) { return p.gender === 'Female'; });
	                return {
	                    id: match.id,
	                    PID: match.id,
	                    name: match.person.name,
	                    birthDate: match.person.birthDate,
	                    birthPlace: match.person.birthPlace,
	                    deathDate: match.person.deathDate,
	                    deathPlace: match.person.deathPlace,
	                    gender: match.person.gender,
	                    fatherPID: !!father ? father.PID : '',
	                    fatherName: !!father ? father.name : '',
	                    fatherBirthDate: !!father ? father.birthDate : '',
	                    fatherDeathDate: !!father ? father.deathDate : '',
	                    motherPID: !!mother ? mother.PID : '',
	                    motherName: !!mother ? mother.name : '',
	                    motherBirthDate: !!mother ? mother.birthDate : '',
	                    motherDeathDate: !!mother ? mother.deathDate : '',
	                    spouses: match.spouses.map(function (spouse) {
	                        return {
	                            PID: spouse.PID,
	                            name: spouse.name,
	                            birthDate: spouse.birthDate,
	                            deathDate: spouse.deathDate
	                        };
	                    }),
	                    children: match.children.map(function (child) {
	                        return {
	                            PID: child.PID,
	                            name: child.name,
	                            birthDate: child.birthDate,
	                            deathDate: child.deathDate
	                        };
	                    })
	                };
	            });
	            _this.matchesReady = true;
	        }, function (error) {
	            if (error.startsWith('400 FamilySearch')) {
	                _this.messageBus.post({ msg: 'There isn\'t enough information about this person to match. Do you know the FamilySearch PID of the person you want to match to?' });
	            }
	        });
	    };
	    FsMatchController.prototype.readFSPerson = function (pid) {
	        var _this = this;
	        var subject = new this.rx.AsyncSubject();
	        this.rx.Observable.forkJoin(this.fs.getPerson(pid), this.fs.getFamilies(pid)).subscribe(function (_a) {
	            var _b = __read(_a, 2), fsp = _b[0], families = _b[1];
	            if (!fsp) {
	                subject.error('Not found');
	                return;
	            }
	            var rfp = _this.fs.toRFPerson(fsp);
	            var birth = _this.persons.getPreferredBirth(rfp);
	            var death = _this.persons.getPreferredDeath(rfp);
	            var person = {
	                id: rfp.externalIds.get(FS).id,
	                PID: rfp.externalIds.get(FS).id,
	                person: rfp,
	                name: _this.persons.getFullName(rfp),
	                gender: rfp.gender,
	                birthType: !!birth ? birth.type : '',
	                birthDate: !!birth ? birth.date : '',
	                birthPlace: !!birth ? birth.place : '',
	                deathType: !!death ? death.type : '',
	                deathDate: !!death ? death.date : '',
	                deathPlace: !!death ? death.place : '',
	                spouses: [],
	                children: []
	            };
	            families.parentFamilies.forEach(function (fsf) {
	                var rff = _this.fs.toRFFamily(fsf);
	                if (!rfp.preferredParentsFamilyId || (rff.husbandId + ':' + rff.wifeId) === rfp.preferredParentsFamilyId) {
	                    if (!!rff.husbandId) {
	                        _this.fs.getPerson(rff.husbandId, false).subscribe(function (fsp) {
	                            if (!!fsp) {
	                                var rfp_1 = _this.fs.toRFPerson(fsp);
	                                person.father = rfp_1;
	                                person.fatherPID = rfp_1.externalIds.get(FS).id;
	                                person.fatherName = _this.persons.getFullName(rfp_1);
	                                person.fatherBirthDate = _this.persons.getPreferredBirthDate(rfp_1);
	                                person.fatherDeatDate = _this.persons.getPreferredDeathDate(rfp_1);
	                            }
	                        });
	                    }
	                    if (!!rff.wifeId) {
	                        _this.fs.getPerson(rff.wifeId, false).subscribe(function (fsp) {
	                            if (!!fsp) {
	                                var rfp_2 = _this.fs.toRFPerson(fsp);
	                                person.mother = rfp_2;
	                                person.motherPID = rfp_2.externalIds.get(FS).id;
	                                person.motherName = _this.persons.getFullName(rfp_2);
	                                person.motherBirthDate = _this.persons.getPreferredBirthDate(rfp_2);
	                                person.motherDeatDate = _this.persons.getPreferredDeathDate(rfp_2);
	                            }
	                        });
	                    }
	                }
	            });
	            families.spouseFamilies.forEach(function (fsf) {
	                var rff = _this.fs.toRFFamily(fsf);
	                // get spouse
	                var spouseId = rff.husbandId === pid ? rff.wifeId : rff.husbandId;
	                if (!!spouseId) {
	                    _this.fs.getPerson(spouseId, false).subscribe(function (fsp) {
	                        if (!!fsp) {
	                            var rfp_3 = _this.fs.toRFPerson(fsp);
	                            person.spouses.push({
	                                person: rfp_3,
	                                PID: rfp_3.externalIds.get(FS).id,
	                                name: _this.persons.getFullName(rfp_3),
	                                birthDate: _this.persons.getPreferredBirthDate(rfp_3),
	                                deathDate: _this.persons.getPreferredDeathDate(rfp_3)
	                            });
	                        }
	                    });
	                }
	                // get children
	                rff.childRels.forEach(function (v, childId) {
	                    _this.fs.getPerson(childId, false).subscribe(function (fsp) {
	                        if (!!fsp) {
	                            var rfp_4 = _this.fs.toRFPerson(fsp);
	                            var birth_1 = _this.persons.getPreferredBirth(rfp_4);
	                            person.children.push({
	                                person: rfp_4,
	                                PID: rfp_4.externalIds.get(FS).id,
	                                name: _this.persons.getFullName(rfp_4),
	                                _birthDateSort: !!birth_1 ? birth_1._dateFormal : '',
	                                birthDate: !!birth_1 ? birth_1.date : '',
	                                deathDate: _this.persons.getPreferredDeathDate(rfp_4)
	                            });
	                        }
	                    });
	                });
	            });
	            subject.next(person);
	            subject.complete();
	        }, function (err) {
	            subject.error(err);
	        });
	        return subject;
	    };
	    FsMatchController.prototype.getRFMatches = function () {
	        var _this = this;
	        var matchData = this.getFSMatchData(this.ext);
	        this.matches = [];
	        switch (this.relationship) {
	            case 'FATHER':
	            case 'MOTHER':
	            case 'SIBLING':
	                this.rx.Observable.forkJoin(this.families.streamParents(this.rfPersonId).take(1), this.persons.streamMatches(matchData).take(1)).subscribe(function (_a) {
	                    var _b = __read(_a, 2), fm = _b[0], pids = _b[1];
	                    var ids = [];
	                    fm.forEach(function (f) {
	                        if (!_this.rfFamily || _this.rfFamily.id === f.id) {
	                            if (_this.relationship === 'FATHER' && f.husbandId > 0) {
	                                ids.push(f.husbandId);
	                            }
	                            else if (_this.relationship === 'MOTHER' && f.wifeId > 0) {
	                                ids.push(f.wifeId);
	                            }
	                            else if (_this.relationship === 'SIBLING') {
	                                f.childRels.forEach(function (v, cid) {
	                                    ids.push(cid);
	                                });
	                            }
	                        }
	                    });
	                    ids = ids.concat(pids);
	                    var stream = ids.length === 0 ? _this.rx.Observable.of([]) : (_c = _this.rx.Observable).forkJoin.apply(_c, __spread(ids.map(function (id) { return _this.persons.streamId(id).take(1); })));
	                    stream.subscribe(function (persons) {
	                        _this.matches = persons.filter(function (p) { return !p.externalIds.has(FS) && _this.persons.isCompatibleGender(p.gender, matchData.gender); }).map(function (p) { return _this.getRFMatch(p); });
	                        _this.matchesReady = true;
	                    });
	                    var _c;
	                });
	                break;
	            case 'SPOUSE':
	            case 'CHILD':
	                this.rx.Observable.forkJoin(this.families.streamSpouses(this.rfPersonId).take(1), this.persons.streamMatches(matchData).take(1)).subscribe(function (_a) {
	                    var _b = __read(_a, 2), fm = _b[0], pids = _b[1];
	                    var ids = [];
	                    fm.forEach(function (f) {
	                        if (!_this.rfFamily || _this.rfFamily.id === f.id) {
	                            if (_this.relationship === 'SPOUSE' && f.husbandId > 0 && f.husbandId !== _this.rfPersonId) {
	                                ids.push(f.husbandId);
	                            }
	                            else if (_this.relationship === 'SPOUSE' && f.wifeId > 0 && f.wifeId !== _this.rfPersonId) {
	                                ids.push(f.wifeId);
	                            }
	                            else if (_this.relationship === 'CHILD') {
	                                f.childRels.forEach(function (v, cid) {
	                                    ids.push(cid);
	                                });
	                            }
	                        }
	                    });
	                    ids = ids.concat(pids);
	                    var stream = ids.length === 0 ? _this.rx.Observable.of([]) : (_c = _this.rx.Observable).forkJoin.apply(_c, __spread(ids.map(function (id) { return _this.persons.streamId(id).take(1); })));
	                    stream.subscribe(function (persons) {
	                        _this.matches = persons.filter(function (p) { return !p.externalIds.has(FS) && _this.persons.isCompatibleGender(p.gender, matchData.gender); }).map(function (p) { return _this.getRFMatch(p); });
	                        _this.matchesReady = true;
	                    });
	                    var _c;
	                });
	                break;
	        }
	    };
	    FsMatchController.prototype.getFSMatchData = function (fsm) {
	        var given = '';
	        var surname = '';
	        var birthDateSort = '';
	        var deathDateSort = '';
	        var prefName = this.persons.getPreferredName(fsm.person);
	        var prefBirth = this.persons.getPreferredBirth(fsm.person);
	        var prefDeath = this.persons.getPreferredDeath(fsm.person);
	        if (!!prefName) {
	            var nf = this.persons.getDefaultNameForm(prefName);
	            if (!!nf) {
	                given = nf.given;
	                surname = nf.surname;
	            }
	        }
	        if (!!prefBirth && !!prefBirth._dateFormal) {
	            birthDateSort = prefBirth._dateFormal.replace(/[^0-9]/g, '');
	        }
	        if (!!prefDeath && !!prefDeath._dateFormal) {
	            deathDateSort = prefDeath._dateFormal.replace(/[^0-9]/g, '');
	        }
	        return {
	            gender: fsm.person.gender,
	            given: given,
	            surname: surname,
	            birthDateSort: birthDateSort,
	            deathDateSort: deathDateSort
	        };
	    };
	    FsMatchController.prototype.getRFMatch = function (p) {
	        var _this = this;
	        var birth = this.persons.getPreferredBirth(p);
	        var death = this.persons.getPreferredDeath(p);
	        var match = {
	            person: p,
	            id: p.id,
	            PID: p.externalIds.has(FS) ? p.externalIds.get(FS).id : '',
	            name: this.persons.getFullName(p),
	            birthDate: !!birth ? birth.date : '',
	            birthPlace: !!birth ? birth.place : '',
	            deathDate: !!death ? death.date : '',
	            deathPlace: !!death ? death.place : '',
	            gender: p.gender,
	            spouses: [],
	            children: []
	        };
	        this.families.streamParents(p.id).take(1).subscribe(function (fm) {
	            var f = _this.families.getPreferredFamily(fm, p.preferredParentsFamilyId);
	            if (!!f) {
	                if (f.husbandId > 0) {
	                    _this.persons.streamId(f.husbandId).take(1).subscribe(function (p) {
	                        match.motherPID = p.externalIds.has(FS) ? p.externalIds.get(FS).id : '';
	                        match.fatherName = _this.persons.getFullName(p);
	                        match.fatherBirthDate = _this.persons.getPreferredBirthDate(p);
	                        match.fatherDeathDate = _this.persons.getPreferredDeathDate(p);
	                    });
	                }
	                if (f.wifeId > 0) {
	                    _this.persons.streamId(f.wifeId).take(1).subscribe(function (p) {
	                        match.motherPID = p.externalIds.has(FS) ? p.externalIds.get(FS).id : '';
	                        match.motherName = _this.persons.getFullName(p);
	                        match.motherBirthDate = _this.persons.getPreferredBirthDate(p);
	                        match.motherDeathDate = _this.persons.getPreferredDeathDate(p);
	                    });
	                }
	            }
	        });
	        this.families.streamSpouses(p.id).take(1).subscribe(function (fm) {
	            fm.forEach(function (f) {
	                var spouseId = f.husbandId === p.id ? f.wifeId : f.husbandId;
	                if (!!spouseId) {
	                    _this.persons.streamId(spouseId).take(1).subscribe(function (p) {
	                        match.spouses.push({
	                            PID: p.externalIds.has(FS) ? p.externalIds.get(FS).id : '',
	                            name: _this.persons.getFullName(p),
	                            birthDate: _this.persons.getPreferredBirthDate(p),
	                            deathDate: _this.persons.getPreferredDeathDate(p)
	                        });
	                    });
	                }
	                f.childRels.forEach(function (v, cid) {
	                    _this.persons.streamId(cid).take(1).subscribe(function (p) {
	                        var birth = _this.persons.getPreferredBirth(p);
	                        match.children.push({
	                            PID: p.externalIds.has(FS) ? p.externalIds.get(FS).id : '',
	                            name: _this.persons.getFullName(p),
	                            _birthDateSort: !!birth ? birth.dateSort : '',
	                            birthDate: !!birth ? birth.date : '',
	                            deathDate: _this.persons.getPreferredDeathDate(p)
	                        });
	                    });
	                });
	            });
	        });
	        return match;
	    };
	    FsMatchController.prototype.selectMatch = function () {
	        var _this = this;
	        var match = this.matches.find(function (m) { return m.id === _this.selectedMatchId; });
	        if (this.source === 'RootsFinder') {
	            this.ext = match;
	        }
	        else {
	            this.rf = match;
	        }
	        this.setSpousesChildren();
	    };
	    FsMatchController.prototype.setSpousesChildren = function () {
	        var _this = this;
	        this.spouses = [];
	        this.children = [];
	        for (var i = 0; (!!this.rf && i < this.rf.spouses.length) || (!!this.ext && i < this.ext.spouses.length); i++) {
	            this.spouses.push({
	                rf: !!this.rf && i < this.rf.spouses.length ? this.rf.spouses[i] : null,
	                ext: !!this.ext && i < this.ext.spouses.length ? this.ext.spouses[i] : null
	            });
	        }
	        // sort rfChildren and extChildren
	        var rfChildren = !!this.rf ? __spread(this.rf.children) : [];
	        rfChildren.sort(function (a, b) { return _this.utils.compareDateSorts(a._birthDateSort, b._birthDateSort); });
	        var extChildren = !!this.ext ? __spread(this.ext.children) : [];
	        extChildren.sort(function (a, b) { return _this.utils.compareDateSorts(a._birthDateSort, b._birthDateSort); });
	        for (var i = 0; i < rfChildren.length || i < extChildren.length; i++) {
	            this.children.push({
	                rf: i < rfChildren.length ? rfChildren[i] : null,
	                ext: i < extChildren.length ? extChildren[i] : null
	            });
	        }
	    };
	    FsMatchController.prototype.cleanID = function (id) {
	        return id.replace(/^(-|\s)+/, '').replace(/(-|\s)+$/, '').toUpperCase();
	    };
	    FsMatchController.prototype.matchPID = function (ev) {
	        if (ev.which === 13) {
	            var matchingPID = this.cleanID(this.matchingPID);
	            if (this.target === 'FamilySearch' && !/^[A-Z0-9]{4}-[A-Z0-9]{3}$/.test(matchingPID)) {
	                this.utils.alert('Can\'t read FamilySearch ID', 'A FamilySearch ID is 4 uppercase letters or numbers, followed by a hyphen, followed by 3 uppercase letters or numbers.', ev);
	            }
	            else if (this.target === 'RootsFinder' && !/^[A-Z0-9]{3}-[A-Z0-9]{4}-[A-Z0-9]{4}$/.test(matchingPID)) {
	                this.utils.alert('Can\'t read RootsFinder ID', 'A RootsFinder ID is 3 uppercase letters or numbers, followed by a hyphen, followed by 4 uppercase letters or numbers, ' +
	                    'another hyphen, and 4 more uppercase letters or numbers. You will find it in the URL at the top of the page.', ev);
	            }
	            else {
	                this.matchingPID = matchingPID;
	                this.getMatches(this.matchingPID);
	            }
	        }
	    };
	    FsMatchController.prototype.add = function () {
	        this.msg = '';
	        this.saving = true;
	        if (this.source === 'RootsFinder') {
	            this.addFS();
	        }
	        else {
	            this.addRF();
	        }
	    };
	    FsMatchController.prototype.addFS = function () {
	        var _this = this;
	        var fsp = this.fs.toFSPerson(this.person.person);
	        this.fs.savePerson(fsp, '').subscribe(function (fsid) {
	            _this.person.person.externalIds.set(FS, { id: fsid });
	            _this.persons.update(_this.person.person).subscribe(function (person) {
	                _this.saving = false;
	                _this.$mdDialog.hide(person);
	            }, function () {
	                _this.saving = false;
	            });
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    FsMatchController.prototype.addRF = function () {
	        var _this = this;
	        this.updateIds(this.person.person).subscribe(function (_a) {
	            var _b = __read(_a, 2), person = _b[0], spouseFactsMap = _b[1];
	            _this.addCoupleEvidences(spouseFactsMap).subscribe(function () {
	                _this.persons.create(person).subscribe(function (person) {
	                    _this.updateSpouseFacts(spouseFactsMap, person.id).subscribe(function () {
	                        _this.createUpdateFamily(person).subscribe(function () {
	                            _this.saving = false;
	                            _this.$mdDialog.hide(person);
	                        }, function () {
	                            _this.saving = false;
	                        });
	                    }, function () {
	                        _this.saving = false;
	                    });
	                }, function () {
	                    _this.saving = false;
	                });
	            }, function () {
	                _this.saving = false;
	            });
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    FsMatchController.prototype.addCoupleEvidences = function (spouseFactsMap) {
	        var _this = this;
	        var evidences = [];
	        spouseFactsMap.forEach(function (facts) {
	            facts.forEach(function (fact) {
	                var evidence = {
	                    id: _this.utils.randomId(),
	                    fact: {
	                        type: fact.type,
	                        value: fact.value,
	                        date: fact.date,
	                        dateSort: fact.dateSort,
	                        place: fact.place,
	                        placeDetails: fact.placeDetails,
	                        placeStandard: fact.placeStandard,
	                        latitude: fact.latitude,
	                        longitude: fact.longitude
	                    },
	                    citation: {},
	                    mediaIds: new Map(),
	                    externalIds: new Map(),
	                    personas: new Map([[1, { names: new Map(), facts: new Map(), principal: true, relatedToKey: 0, relationshipType: '' }],
	                        [2, { names: new Map(), facts: new Map(), principal: true, relatedToKey: 1, relationshipType: 'SPOUSE' }]])
	                };
	                evidences.push(evidence);
	                fact.evidencePersonas.set(evidence.id, 1);
	            });
	        });
	        return evidences.length === 0 ? this.rx.Observable.of(null) : (_a = this.rx.Observable).forkJoin.apply(_a, __spread(evidences.map(function (evidence) {
	            return _this.evidences.create(evidence);
	        })));
	        var _a;
	    };
	    FsMatchController.prototype.updateSpouseFacts = function (spouseFactsMap, pid) {
	        var _this = this;
	        return spouseFactsMap.size === 0 ? this.rx.Observable.of(null) : (_a = this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(spouseFactsMap.entries()).map(function (_a) {
	            var _b = __read(_a, 2), sid = _b[0], facts = _b[1];
	            return _this.persons.streamId(sid).take(1).flatMap(function (spouse) {
	                facts.forEach(function (fact) {
	                    fact.principalId1 = pid;
	                    fact.evidencePersonas.set(_this.utils.firstKey(fact.evidencePersonas), 2);
	                    spouse.facts.set(_this.utils.randomKey(), fact);
	                });
	                return _this.persons.update(spouse);
	            });
	        })));
	        var _a;
	    };
	    FsMatchController.prototype.updateIds = function (p) {
	        // TODO set profile photo, preferredParentsFamilyId
	        p.preferredParentsFamilyId = 0;
	        p.profilePhoto = 0;
	        var spouseFactsMap = new Map();
	        return this.persons.stream().take(1).map(function (pm) {
	            p.facts.forEach(function (fact) {
	                if (!!fact.principalId1) {
	                    var principalId1 = fact.principalId1;
	                    fact.principalId1 = 'DELETEME';
	                    try {
	                        for (var _a = __values(pm.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                            var p_1 = _b.value;
	                            if (p_1.externalIds.has(FS) && p_1.externalIds.get(FS).id === principalId1) {
	                                fact.principalId1 = p_1.id;
	                                if (!spouseFactsMap.has(p_1.id)) {
	                                    spouseFactsMap.set(p_1.id, []);
	                                }
	                                spouseFactsMap.get(p_1.id).push(fact);
	                                break;
	                            }
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                }
	                if (!!fact.principalId2) {
	                    var principalId2 = fact.principalId2;
	                    fact.principalId2 = 'DELETEME';
	                    try {
	                        for (var _d = __values(pm.values()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                            var p_2 = _e.value;
	                            if (p_2.externalIds.has(FS) && p_2.externalIds.get(FS).id === principalId2) {
	                                fact.principalId2 = p_2.id;
	                                break;
	                            }
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                }
	                var e_1, _c, e_2, _f;
	            });
	            p.facts = new Map(Array.from(p.facts.entries()).filter(function (_a) {
	                var _b = __read(_a, 2), key = _b[0], fact = _b[1];
	                return fact.principalId1 !== 'DELETEME' && fact.principalId2 !== 'DELETEME';
	            }));
	            return [p, spouseFactsMap];
	        });
	    };
	    FsMatchController.prototype.match = function () {
	        this.msg = '';
	        this.saving = true;
	        if (this.source === 'RootsFinder') {
	            this.matchFS();
	        }
	        else {
	            this.matchRF();
	        }
	    };
	    FsMatchController.prototype.matchFS = function () {
	        var _this = this;
	        this.selectedMatchId = this.cleanID(this.selectedMatchId);
	        this.person.person.externalIds.set(FS, { id: this.selectedMatchId });
	        this.persons.update(this.person.person).subscribe(function (person) {
	            _this.saving = false;
	            _this.$mdDialog.hide(person);
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    FsMatchController.prototype.matchRF = function () {
	        var _this = this;
	        this.rf.person.externalIds.set(FS, { id: this.person.person.externalIds.get(FS).id });
	        this.persons.update(this.rf.person).subscribe(function (person) {
	            _this.createUpdateFamily(person).subscribe(function () {
	                _this.saving = false;
	                _this.$mdDialog.hide(person);
	            }, function () {
	                _this.saving = false;
	            });
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    FsMatchController.prototype.createUpdateFamily = function (p) {
	        var _this = this;
	        if (!!this.rfFamily) {
	            var changed = false;
	            switch (this.relationship) {
	                case 'FATHER':
	                    if (this.rfFamily.husbandId !== p.id) {
	                        this.rfFamily.husbandId = p.id;
	                        changed = true;
	                    }
	                    break;
	                case 'MOTHER':
	                    if (this.rfFamily.wifeId !== p.id) {
	                        this.rfFamily.wifeId = p.id;
	                        changed = true;
	                    }
	                    break;
	                case 'SPOUSE':
	                    if (this.rfFamily.husbandId === this.rfPersonId) {
	                        if (this.rfFamily.wifeId !== p.id) {
	                            this.rfFamily.wifeId = p.id;
	                            changed = true;
	                        }
	                    }
	                    else {
	                        if (this.rfFamily.husbandId !== p.id) {
	                            this.rfFamily.husbandId = p.id;
	                            changed = true;
	                        }
	                    }
	                    break;
	                case 'CHILD':
	                case 'SIBLING':
	                    // TODO get relationship types from FS
	                    if (!this.rfFamily.childRels.has(p.id)) {
	                        this.rfFamily.childRels.set(p.id, { fatherRel: '', motherRel: '' });
	                        changed = true;
	                    }
	                    break;
	            }
	            if (!changed) {
	                return this.rx.Observable.of(this.rfFamily);
	            }
	            else {
	                return this.families.update(this.rfFamily);
	            }
	        }
	        else {
	            return this.persons.streamId(this.rfPersonId).take(1).flatMap(function (rfPerson) {
	                var f = {
	                    id: 0,
	                    husbandId: 0,
	                    wifeId: 0,
	                    externalIds: new Map(),
	                    childRels: new Map()
	                };
	                // TODO get relationship types from FS
	                switch (_this.relationship) {
	                    case 'FATHER':
	                    case 'MOTHER':
	                        if (_this.relationship === 'FATHER') {
	                            f.husbandId = p.id;
	                        }
	                        else {
	                            f.wifeId = p.id;
	                        }
	                        f.childRels.set(_this.rfPersonId, { fatherRel: '', motherRel: '' });
	                        return _this.families.streamParents(_this.rfPersonId).take(1).flatMap(function (fm) {
	                            return _this.createFamily(fm, f);
	                        });
	                    case 'SPOUSE':
	                        if (p.gender === 'FEMALE' || rfPerson === 'MALE') {
	                            f.husbandId = _this.rfPersonId;
	                            f.wifeId = p.id;
	                        }
	                        else {
	                            f.husbandId = p.id;
	                            f.wifeId = _this.rfPersonId;
	                        }
	                        return _this.families.streamSpouses(_this.rfPersonId).take(1).flatMap(function (fm) {
	                            return _this.createFamily(fm, f);
	                        });
	                }
	            });
	        }
	    };
	    FsMatchController.prototype.createFamily = function (fm, f) {
	        // update existing family if the parents are the same
	        var ef = Array.from(fm.values()).find(function (ef) { return (f.husbandId === 0 || f.husbandId === ef.husbandId) && (f.wifeId === 0 || f.wifeId === ef.wifeId); });
	        if (!!ef) {
	            if (ef.husbandId === 0 && f.husbandId > 0) {
	                ef.husbandId = f.husbandId;
	            }
	            if (ef.wifeId === 0 && f.wifeId > 0) {
	                ef.wifeId = f.wifeId;
	            }
	            return this.families.update(ef);
	        }
	        else {
	            return this.families.create(f);
	        }
	    };
	    FsMatchController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return FsMatchController;
	}());
	exports.default = FsMatchController;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var FsPromptController = /** @class */ (function () {
	    FsPromptController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus", "currentUser"];
	    function FsPromptController($log, $mdDialog, $mdMedia, $scope, messageBus, currentUser) {
	        'ngInject';
	        var _this = this;
	        // passed in: action, type, item, evidences, exists
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.currentUser = currentUser;
	        this.expanded = false;
	        this.needsMediaAgree = true;
	        this.mediaAgree = false;
	        if (this.type === 'MEDIA') {
	            this.expanded = true;
	        }
	        if (this.type === 'MEDIA' || this.type === 'STORY') {
	            this.currentUser.stream().filter(function (u) { return u != null; }).take(1).subscribe(function (user) {
	                _this.user = user;
	                _this.needsMediaAgree = _this.user.preferences['FS_MEDIA_AGREE'] !== 'TRUE';
	            });
	        }
	        else {
	            this.needsMediaAgree = false;
	        }
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	        $scope.$on('toggleExpand', function () {
	            _this.expanded = !_this.expanded;
	        });
	    }
	    FsPromptController.prototype.save = function () {
	        this.msg = '';
	        if (this.needsMediaAgree && !this.mediaAgree) {
	            return;
	        }
	        if (this.needsMediaAgree) {
	            this.user.preferences['FS_MEDIA_AGREE'] = 'TRUE';
	            this.currentUser.update(this.user).subscribe();
	        }
	        this.$mdDialog.hide({ reason: this.reason, evidences: this.evidences });
	    };
	    FsPromptController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return FsPromptController;
	}());
	exports.default = FsPromptController;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var GedmatchController = /** @class */ (function () {
	    GedmatchController.$inject = ["$log", "$mdDialog"];
	    function GedmatchController($log, $mdDialog) {
	        'ngInject';
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	    }
	    GedmatchController.prototype.save = function () {
	        this.$mdDialog.hide();
	    };
	    GedmatchController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return GedmatchController;
	}());
	exports.default = GedmatchController;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var HintsToastController = /** @class */ (function () {
	    HintsToastController.$inject = ["$mdToast"];
	    function HintsToastController($mdToast) {
	        'ngInject';
	        this.$mdToast = $mdToast;
	    }
	    HintsToastController.prototype.closeToast = function () {
	        this.$mdToast.hide('GO');
	    };
	    return HintsToastController;
	}());
	exports.default = HintsToastController;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var ListModalController = /** @class */ (function () {
	    ListModalController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus"];
	    function ListModalController($log, $mdDialog, $mdMedia, $scope, messageBus) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.expanded = true;
	        $scope.$on('edit', function (ev, params) {
	            $mdDialog.hide({ action: 'edit', params: params });
	        });
	        $scope.$on('archive', function (ev, params) {
	            $mdDialog.hide({ action: 'archive', params: params });
	        });
	        $scope.$on('delete', function (ev, params) {
	            $mdDialog.hide({ action: 'delete', params: params });
	        });
	        $scope.$on('mosaic', function (ev, params) {
	            $mdDialog.hide({ action: 'mosaic', params: params });
	        });
	        $scope.$on('toggleExpand', function () {
	            _this.expanded = !_this.expanded;
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	        $scope.$on('show', function (ev, params) {
	            $mdDialog.hide({ action: 'show', params: params });
	        });
	    }
	    ListModalController.prototype.getTitle = function () {
	        return this.itemType === 'evidence' ? 'Supporting Evidence' : this.itemType[0].toUpperCase() + this.itemType.substr(1);
	    };
	    ListModalController.prototype.submit = function () {
	        this.msg = '';
	        this.$mdDialog.hide();
	    };
	    ListModalController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return ListModalController;
	}());
	exports.default = ListModalController;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var LoadSaveFiltersController = /** @class */ (function () {
	    LoadSaveFiltersController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus"];
	    function LoadSaveFiltersController($log, $mdDialog, $mdMedia, $scope, messageBus) {
	        'ngInject';
	        var _this = this;
	        // passed in: save, filenames
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.remove = {};
	        this.filenames.forEach(function (filename) {
	            _this.remove[filename] = false;
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    LoadSaveFiltersController.prototype.select = function (filename) {
	        console.log('select', filename);
	        this.filename = filename;
	    };
	    LoadSaveFiltersController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        var removeKeys = Object.keys(this.remove).filter(function (key) { return _this.remove[key]; });
	        console.log('removeKeys', removeKeys);
	        this.$mdDialog.hide({ filename: this.filename, remove: removeKeys });
	    };
	    LoadSaveFiltersController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return LoadSaveFiltersController;
	}());
	exports.default = LoadSaveFiltersController;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var MediaController = /** @class */ (function () {
	    MediaController.$inject = ["$log", "$scope", "$mdDialog", "$mdMedia"];
	    function MediaController($log, $scope, $mdDialog, $mdMedia) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$scope = $scope;
	        this.$mdMedia = $mdMedia;
	        this.expanded = true;
	        // passed in: media, hideTools
	        $scope.$on('edit', function () {
	            _this.$mdDialog.hide('edit');
	        });
	        $scope.$on('delete', function () {
	            _this.$mdDialog.hide('delete');
	        });
	        $scope.$on('toggleExpand', function () {
	            _this.expanded = !_this.expanded;
	        });
	        $scope.$on('mosaic', function () {
	            _this.$mdDialog.hide('mosaic');
	        });
	    }
	    MediaController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return MediaController;
	}());
	exports.default = MediaController;


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var MergeDlgController = /** @class */ (function () {
	    MergeDlgController.$inject = ["$log", "$mdDialog", "$scope", "$mdMedia", "messageBus", "rx", "persons", "leads", "evidences", "personUtils", "utils"];
	    function MergeDlgController($log, $mdDialog, $scope, $mdMedia, messageBus, rx, persons, leads, evidences, personUtils, utils) {
	        'ngInject';
	        var _this = this;
	        // passed in: pid
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.rx = rx;
	        this.persons = persons;
	        this.personUtils = personUtils;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        $log.debug('merge.pid', this.pid);
	        this.person = null;
	        this.mergePerson = null;
	        var pSub = persons.streamId(this.pid).subscribe(function (p) {
	            persons.augmentPerson(p, leads, evidences).subscribe(function (person) {
	                _this.person = person;
	            });
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        var mergeSub = utils.watch($scope, function () { return _this.mp; }).subscribe(function (_a) {
	            var newValue = _a.newValue;
	            if (!!newValue) {
	                persons.augmentPerson(newValue, leads, evidences).subscribe(function (person) {
	                    _this.mergePerson = person;
	                });
	            }
	            else {
	                _this.mergePerson = null;
	            }
	        });
	        $scope.$on('$destroy', function () {
	            pSub.unsubscribe();
	            mbSub.unsubscribe();
	            mergeSub.unsubscribe();
	        });
	    }
	    MergeDlgController.prototype.queryPerson = function (query) {
	        var _this = this;
	        return this.persons.ready().toPromise().then(function () {
	            return !query ? _this.rx.Observable.of([]).toPromise() : _this.persons.nameAutocomplete(query, _this.pid);
	        });
	    };
	    MergeDlgController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    MergeDlgController.prototype.submit = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        this.personUtils.merge(this.person, this.mergePerson).subscribe(function () {
	            _this.saving = false;
	            _this.$mdDialog.hide();
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    return MergeDlgController;
	}());
	exports.default = MergeDlgController;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var NestedListController = /** @class */ (function () {
	    NestedListController.$inject = ["$log", "$mdDialog", "segment", "utils"];
	    function NestedListController($log, $mdDialog, segment, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.segment = segment;
	        this.utils = utils;
	        // title, lists:[{title, items:[{title, url, text, linkEnd, icons:[{name, title}], items:[{url, title, linkEnd, items:[{title}]}]}]}]
	    }
	    NestedListController.prototype.clickUrl = function (url) {
	        if (!!this.eventPrefix && !!url) {
	            var parsed = this.utils.parseURL(url);
	            this.segment.track(this.eventPrefix + '.click', { domain: parsed.host });
	        }
	    };
	    NestedListController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return NestedListController;
	}());
	exports.default = NestedListController;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var NotificationController = /** @class */ (function () {
	    NotificationController.$inject = ["$log", "$mdDialog", "$scope", "messageBus", "notifications", "utils"];
	    function NotificationController($log, $mdDialog, $scope, messageBus, notifications, utils) {
	        'ngInject';
	        var _this = this;
	        // passed in: notification
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.notifications = notifications;
	        this.utils = utils;
	        if (!this.notification.read) {
	            var notif = utils.clone(this.notification);
	            notif.read = true;
	            this.notifications.update(notif).subscribe(function (n) {
	                _this.notification = n;
	            }, function (err) {
	                messageBus.post({ msg: err, warn: true });
	            });
	        }
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    NotificationController.prototype.markUnread = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        var notif = this.utils.clone(this.notification);
	        notif.read = false;
	        this.notifications.update(notif).subscribe(function () {
	            _this.saving = false;
	            _this.$mdDialog.hide();
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    NotificationController.prototype.del = function () {
	        var _this = this;
	        this.msg = '';
	        this.saving = true;
	        this.notifications.del(this.notification.id).subscribe(function () {
	            _this.saving = false;
	            _this.$mdDialog.hide();
	        }, function () {
	            _this.saving = false;
	        });
	    };
	    NotificationController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return NotificationController;
	}());
	exports.default = NotificationController;


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var RelativesController = /** @class */ (function () {
	    RelativesController.$inject = ["$log", "$mdDialog", "$scope", "$state", "$filter", "$mdMedia", "rx", "messageBus", "rightsFull", "persons", "evidences", "leads", "sources", "users", "families", "familyUtils", "utils"];
	    function RelativesController($log, $mdDialog, $scope, $state, $filter, $mdMedia, rx, messageBus, rightsFull, persons, evidences, leads, sources, users, families, familyUtils, utils) {
	        'ngInject';
	        var _this = this;
	        // passed in: pid
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$state = $state;
	        this.$filter = $filter;
	        this.$mdMedia = $mdMedia;
	        this.rx = rx;
	        this.persons = persons;
	        this.families = families;
	        this.familyUtils = familyUtils;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.translations = persons.translations;
	        $log.debug('relatives.pid', this.pid);
	        this.person = null;
	        this.expanded = new Map();
	        this.parentFamilyMap = new Map();
	        this.spouseFamilyMap = new Map();
	        this.nameMap = new Map();
	        this.factMap = new Map();
	        this.parentsRelativeTypes = [];
	        this.spouseRelativeTypes = [];
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        var subscription = utils.readyChange(persons, families, leads, evidences, users).subscribe(function (_a) {
	            var _b = __read(_a, 1), personMap = _b[0];
	            _this.$log.debug('relatives.change', _this.pid);
	            var p = personMap.get(_this.pid);
	            if (!p) {
	                messageBus.post({ msg: 'Relative not found', warn: true, warnParams: { pid: _this.pid, p: p } });
	                return;
	            }
	            persons.augmentPerson(p, leads, evidences).subscribe(function (person) {
	                _this.person = person;
	                // set parent and spouse families
	                _this.parentFamilyMap = new Map();
	                _this.spouseFamilyMap = new Map();
	                families.streamParents(_this.pid).take(1).subscribe(function (fm) {
	                    Array.from(fm.entries()).forEach(function (_a) {
	                        var _b = __read(_a, 2), id = _b[0], f = _b[1];
	                        families.augmentFamily(f, _this.person.preferredParentsFamilyId, persons, leads, evidences, users).subscribe(function (f) {
	                            _this.parentFamilyMap.set(id, f);
	                        });
	                    });
	                    // set parentsRelativeTypes
	                    _this.parentsRelativeTypes = ['FATHER', 'MOTHER', 'SIBLING'].map(function (r) {
	                        return {
	                            value: r,
	                            disabled: r === 'SIBLING' && fm.size === 0
	                        };
	                    });
	                });
	                families.streamSpouses(_this.pid).take(1).subscribe(function (fm) {
	                    var stream;
	                    if (fm.size === 0) {
	                        stream = _this.rx.Observable.of([]);
	                    }
	                    else {
	                        stream = (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(fm.values()).map(function (f) {
	                            return families.augmentFamily(f, -1, persons, leads, evidences, users);
	                        })));
	                    }
	                    stream.subscribe(function (fs) {
	                        fs.forEach(function (f) {
	                            _this.spouseFamilyMap.set(f.id, f);
	                        });
	                        // set spouseRelativeTypes
	                        _this.spouseRelativeTypes.push({
	                            value: 'SPOUSE',
	                            display: ((_this.spouseFamilyMap.size > 0 ? _this.translations.find(function (t) { return t.value === 'ANOTHER'; }).display + ' ' : '') + _this.translations.find(function (t) { return t.value === 'SPOUSE'; }).display)
	                        });
	                        var foundUnknownSpouse = false;
	                        _this.getSpouseFamilies().forEach(function (sf, i) {
	                            _this.spouseRelativeTypes.push({
	                                value: 'CHILD_' + i.toString(),
	                                display: (_this.translations.find(function (t) { return t.value === 'CHILD'; }).display + ' ' + _this.translations.find(function (t) { return t.value === 'OF'; }).display + ' ') + _this.getSpouseName(sf)
	                            });
	                            if (sf.husbandId === 0 || sf.wifeId === 0) {
	                                foundUnknownSpouse = true;
	                            }
	                        });
	                        if (!foundUnknownSpouse) {
	                            _this.spouseRelativeTypes.push({
	                                value: 'CHILD',
	                                display: (_this.translations.find(function (t) { return t.value === 'CHILD'; }).display + ' ' + _this.translations.find(function (t) { return t.value === 'OF_UNKNOWN_SPOUSE'; }).display)
	                            });
	                        }
	                    });
	                    var _a;
	                });
	                // set up for edit person
	                _this.factMap = new Map();
	                _this.nameMap = new Map();
	                evidences.streamForPerson(_this.person).take(1).subscribe(function (em) {
	                    (em.size === 0 ? _this.rx.Observable.of([]) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(em.entries()).map(function (_a) {
	                        var _b = __read(_a, 2), id = _b[0], evidence = _b[1];
	                        return evidences.augmentEvidence(evidence, sources, persons, users).map(function (evidence) {
	                            return [id, evidence];
	                        });
	                    })))).subscribe(function (idEvidences) {
	                        var evidenceMap = new Map(idEvidences);
	                        try {
	                            for (var _a = __values(_this.person.facts), _b = _a.next(); !_b.done; _b = _a.next()) {
	                                var _c = __read(_b.value, 2), key = _c[0], fact = _c[1];
	                                if ((fact.principalId1 > 0 && !personMap.has(fact.principalId1)) ||
	                                    (fact.principalId2 > 0 && !personMap.has(fact.principalId2))) {
	                                    // fact principal may be living and we don't have rights
	                                    continue;
	                                }
	                                _this.factMap.set(key, _this.persons.augmentFact(fact, _this.person, personMap, evidenceMap));
	                            }
	                        }
	                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                        finally {
	                            try {
	                                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                            }
	                            finally { if (e_1) throw e_1.error; }
	                        }
	                        try {
	                            for (var _e = __values(_this.person.names), _f = _e.next(); !_f.done; _f = _e.next()) {
	                                var _g = __read(_f.value, 2), key = _g[0], name_1 = _g[1];
	                                name_1 = _this.persons.augmentName(name_1, _this.person, evidenceMap);
	                                name_1._key = key;
	                                _this.nameMap.set(key, name_1);
	                            }
	                        }
	                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                        finally {
	                            try {
	                                if (_f && !_f.done && (_h = _e.return)) _h.call(_e);
	                            }
	                            finally { if (e_2) throw e_2.error; }
	                        }
	                        var e_1, _d, e_2, _h;
	                    });
	                    var _a;
	                });
	            });
	        });
	        $scope.$on('goto', function (ev, params) {
	            $log.info('goto', params);
	            _this.cancel();
	        });
	        $scope.$on('add', function (ev, params) {
	            switch (params.type) {
	                case 'family':
	                    // look for params.familyId in parent families or spouse families
	                    var family = Array.from(_this.parentFamilyMap.values()).find(function (pf) { return pf.id === params.id; });
	                    if (!!family) {
	                        _this.addRelative(params.ev, 'parent', params.relationshipType, family);
	                    }
	                    else {
	                        family = Array.from(_this.spouseFamilyMap.values()).find(function (sf) { return sf.id === params.id; });
	                        if (!!family) {
	                            _this.addRelative(params.ev, 'spouse', params.relationshipType || 'SPOUSE', family);
	                        }
	                    }
	                    break;
	            }
	        });
	        $scope.$on('edit', function (ev, params) {
	            switch (params.type) {
	                case 'family':
	                    _this.editParentRels(params.ev, params.item, params.personId);
	                    break;
	            }
	        });
	        $scope.$on('delete', function (ev, params) {
	            switch (params.type) {
	                case 'family':
	                    _this.removeFamilyMember(params.ev, params.item, params.personId);
	                    break;
	            }
	        });
	        $scope.$on('move', function (ev, params) {
	            switch (params.type) {
	                case 'family':
	                    _this.moveChild(params.ev, params.personId, params.sourceId, params.targetId);
	                    break;
	            }
	        });
	        $scope.$on('toggleExpand', function (ev, params) {
	            _this.expanded.set(params.id, !_this.expanded.get(params.id));
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            subscription.unsubscribe();
	            mbSub.unsubscribe();
	        });
	    }
	    RelativesController.prototype.toggleExpandAll = function (m) {
	        var anyExpanded = this.anyExpanded(m);
	        try {
	            for (var m_1 = __values(m), m_1_1 = m_1.next(); !m_1_1.done; m_1_1 = m_1.next()) {
	                var _a = __read(m_1_1.value, 1), id = _a[0];
	                this.expanded.set(id, !anyExpanded);
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (m_1_1 && !m_1_1.done && (_b = m_1.return)) _b.call(m_1);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        var e_3, _b;
	    };
	    RelativesController.prototype.anyExpanded = function (m) {
	        var _this = this;
	        return Array.from(m.keys()).some(function (id) { return _this.expanded.get(id); });
	    };
	    RelativesController.prototype.openMenu = function ($mdMenu, ev) {
	        this.menuEvent = ev;
	        $mdMenu.open(ev);
	    };
	    RelativesController.prototype.addParentsRelative = function (ev, relative) {
	        this.addRelative(ev, 'parent-siblings', relative, this.families.getPreferredFamily(this.parentFamilyMap, this.person.preferredParentsFamilyId));
	    };
	    RelativesController.prototype.addSpouseRelative = function (ev, relative) {
	        this.addRelative(ev, 'spouse-children', relative, null, this.getSpouseFamilies());
	    };
	    RelativesController.prototype.getSpouseFamilies = function () {
	        return this.$filter('toArray')(this.spouseFamilyMap, '_marriage/dateSort');
	    };
	    RelativesController.prototype.getSpouseName = function (sf) {
	        if (sf.husbandId > 0 && sf.husbandId !== this.pid) {
	            return sf._husband._given || '';
	        }
	        if (sf.wifeId > 0 && sf.wifeId !== this.pid) {
	            return sf._wife._given || '';
	        }
	        return 'Unknown Spouse';
	    };
	    RelativesController.prototype.addRelative = function (ev, mode, relationshipType, family, spouseFamilies) {
	        if (spouseFamilies === void 0) { spouseFamilies = []; }
	        this.$mdDialog.cancel();
	        this.utils.dialog(ev, 'AddPersonController', 'app/components/addPerson/addPerson.html', false, {
	            mode: mode,
	            relationshipType: relationshipType,
	            relatedToPersonId: this.pid,
	            family: family,
	            spouseFamilies: spouseFamilies
	        });
	    };
	    RelativesController.prototype.editParentRels = function (ev, family, personId) {
	        this.utils.dialog(ev, 'EditParentRelsController', 'app/components/editParentRels/editParentRels.html', false, {
	            family: family,
	            childId: personId
	        });
	    };
	    RelativesController.prototype.removeFamilyMember = function (ev, family, personId) {
	        var _this = this;
	        this.$mdDialog.cancel();
	        if (family.childRels.size > 1 && (family.husbandId === 0 || family.husbandId === personId) && (family.wifeId === 0 || family.wifeId === personId)) {
	            this.utils.alert('Can\'t Be Done', 'The software requires a family to have at least one parent', ev);
	        }
	        else {
	            this.utils.confirm('Remove Person from Family', 'Are you sure?', ev).then(function () {
	                _this.familyUtils.removeFamilyMember(family, personId);
	            }, function () {
	                // ignore
	            });
	        }
	    };
	    RelativesController.prototype.editPerson = function (ev) {
	        this.$mdDialog.cancel();
	        var facts = Array.from(this.factMap.values());
	        this.utils.dialog(ev, 'EditPersonController', 'app/components/editPerson/editPerson.html', false, {
	            tabIndex: 0,
	            person: this.person,
	            names: Array.from(this.nameMap.values()),
	            births: facts.filter(function (f) { return f.principal && (f.type === 'BIRT' || f.type === 'CHR' || f.type === 'BAPM'); }),
	            deaths: facts.filter(function (f) { return f.principal && (f.type === 'DEAT' || f.type === 'BURI'); }),
	            genders: facts.filter(function (i) { return i.principal && i.type === 'SEX'; })
	        });
	    };
	    RelativesController.prototype.moveChild = function (ev, personId, sourceId, targetId) {
	        var _this = this;
	        this.$mdDialog.cancel();
	        this.utils.confirm('Move child to a different family', 'Are you sure?', ev).then(function () {
	            _this.familyUtils.moveChild(personId, sourceId, targetId).subscribe();
	        }, function () {
	            // ignore
	        });
	    };
	    RelativesController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return RelativesController;
	}());
	exports.default = RelativesController;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var SelectFamilyMembersController = /** @class */ (function () {
	    SelectFamilyMembersController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus", "places", "persons", "personUtils", "utils"];
	    function SelectFamilyMembersController($log, $mdDialog, $mdMedia, $scope, messageBus, places, persons, personUtils, utils) {
	        'ngInject';
	        var _this = this;
	        //passed in father: Person, mother: Person, children: Person[]
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.places = places;
	        this.persons = persons;
	        this.personUtils = personUtils;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.selected = {};
	        if (!!this.father) {
	            this.selected[this.father.id] = this.currentlySelected.has(this.father.id);
	        }
	        if (!!this.mother) {
	            this.selected[this.mother.id] = this.currentlySelected.has(this.mother.id);
	        }
	        this.children.forEach(function (child) {
	            _this.selected[child.id] = _this.currentlySelected.has(child.id);
	        });
	    }
	    SelectFamilyMembersController.prototype.update = function () {
	        var _this = this;
	        var peopleAdded = new Map();
	        var peopleRemoved = new Map();
	        Array.from(Object.entries(this.selected)).forEach(function (_a) {
	            var _b = __read(_a, 2), id = _b[0], isSelected = _b[1];
	            if (isSelected && !_this.currentlySelected.has(+id)) {
	                peopleAdded.set(+id, true);
	            }
	            else if (!isSelected && _this.currentlySelected.has(+id)) {
	                peopleRemoved.set(+id, true);
	            }
	        });
	        this.$mdDialog.hide([peopleAdded, peopleRemoved]);
	    };
	    SelectFamilyMembersController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return SelectFamilyMembersController;
	}());
	exports.default = SelectFamilyMembersController;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var SelectMediaController = /** @class */ (function () {
	    SelectMediaController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "medias", "persons", "evidences", "sources", "stories", "users", "messageBus"];
	    function SelectMediaController($log, $mdDialog, $mdMedia, $scope, medias, persons, evidences, sources, stories, users, messageBus) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.medias = medias;
	        this.selected = {};
	        this.mediaMap = new Map();
	        this.hiddenMap = new Map();
	        this.selectedMap = new Map();
	        var mSub = medias.stream().subscribe(function (mediaMap) {
	            mediaMap.forEach(function (media) {
	                _this.medias.augmentMedia(media, persons, evidences, sources, stories, users).subscribe(function (media) {
	                    _this.mediaMap.set(media.id, media);
	                });
	            });
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mSub.unsubscribe();
	            mbSub.unsubscribe();
	        });
	    }
	    SelectMediaController.prototype.getMediaURL = function (media) {
	        return this.medias.getMediaImageURL(media, '100x100');
	    };
	    SelectMediaController.prototype.isSelected = function (id) {
	        return this.selectedMap.get(id) === true;
	    };
	    SelectMediaController.prototype.toggleSelected = function (id) {
	        if (this.isSelected(id)) {
	            this.selectedMap.delete(id);
	        }
	        else {
	            this.selectedMap.set(id, true);
	        }
	    };
	    SelectMediaController.prototype.isAllSelected = function () {
	        try {
	            for (var _a = __values(this.mediaMap), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var _c = __read(_b.value, 1), id = _c[0];
	                if (!this.isHidden(id) && !this.isSelected(id)) {
	                    return false;
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return true;
	        var e_1, _d;
	    };
	    SelectMediaController.prototype.isIndeterminate = function () {
	        var foundSelected = false;
	        var foundUnselected = false;
	        try {
	            for (var _a = __values(this.mediaMap), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var _c = __read(_b.value, 1), id = _c[0];
	                if (!this.isHidden(id)) {
	                    if (this.isSelected(id)) {
	                        foundSelected = true;
	                    }
	                    else {
	                        foundUnselected = true;
	                    }
	                    if (foundSelected && foundUnselected) {
	                        return true;
	                    }
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        return false;
	        var e_2, _d;
	    };
	    SelectMediaController.prototype.toggleAllSelected = function () {
	        var isAllSelected = this.isAllSelected();
	        try {
	            for (var _a = __values(this.mediaMap), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var _c = __read(_b.value, 1), id = _c[0];
	                if (!this.isHidden(id)) {
	                    if (isAllSelected) {
	                        this.selectedMap.delete(id);
	                    }
	                    else {
	                        this.selectedMap.set(id, true);
	                    }
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        var e_3, _d;
	    };
	    SelectMediaController.prototype.isHidden = function (id) {
	        return this.hiddenMap.get(id) === true;
	    };
	    SelectMediaController.prototype.search = function () {
	        if (this.searchText.trim().length === 0) {
	            this.hiddenMap.clear();
	            return;
	        }
	        var words = this.searchText.toLowerCase().trim().split(' ');
	        try {
	            for (var _a = __values(this.mediaMap), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var _c = __read(_b.value, 2), id = _c[0], media = _c[1];
	                var found = true;
	                try {
	                    for (var words_1 = __values(words), words_1_1 = words_1.next(); !words_1_1.done; words_1_1 = words_1.next()) {
	                        var word = words_1_1.value;
	                        if (!!word && !this.medias.hasWord(media, word)) {
	                            found = false;
	                            break;
	                        }
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (words_1_1 && !words_1_1.done && (_d = words_1.return)) _d.call(words_1);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	                if (found) {
	                    this.hiddenMap.delete(id);
	                }
	                else {
	                    this.hiddenMap.set(id, true);
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        var e_5, _e, e_4, _d;
	    };
	    SelectMediaController.prototype.save = function () {
	        this.msg = '';
	        this.$mdDialog.hide(Array.from(this.selectedMap.keys()));
	    };
	    SelectMediaController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return SelectMediaController;
	}());
	exports.default = SelectMediaController;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var SelectNamesFactsController = /** @class */ (function () {
	    SelectNamesFactsController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus"];
	    function SelectNamesFactsController($log, $mdDialog, $mdMedia, $scope, messageBus) {
	        'ngInject';
	        var _this = this;
	        // passed in: namesFacts
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    SelectNamesFactsController.prototype.save = function () {
	        this.msg = '';
	        this.$mdDialog.hide(this.namesFacts);
	    };
	    SelectNamesFactsController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return SelectNamesFactsController;
	}());
	exports.default = SelectNamesFactsController;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var MergeDlgController = /** @class */ (function () {
	    MergeDlgController.$inject = ["$log", "$mdDialog", "$scope", "$mdMedia", "messageBus", "rx", "persons", "leads", "evidences", "personUtils", "utils"];
	    function MergeDlgController($log, $mdDialog, $scope, $mdMedia, messageBus, rx, persons, leads, evidences, personUtils, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.rx = rx;
	        this.persons = persons;
	        this.personUtils = personUtils;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.person = null;
	        this.selectedPerson = null;
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        var selectSub = utils.watch($scope, function () { return _this.person; }).subscribe(function (_a) {
	            var newValue = _a.newValue;
	            if (!!newValue) {
	                persons.augmentPerson(newValue, leads, evidences).subscribe(function (person) {
	                    _this.selectedPerson = person;
	                });
	            }
	            else {
	                _this.selectedPerson = null;
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	            selectSub.unsubscribe();
	        });
	    }
	    MergeDlgController.prototype.queryPerson = function (query) {
	        var _this = this;
	        return this.persons.ready().toPromise().then(function () {
	            return !query ? _this.rx.Observable.of([]).toPromise() : _this.persons.nameAutocomplete(query, 0);
	        });
	    };
	    MergeDlgController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    MergeDlgController.prototype.submit = function () {
	        this.$mdDialog.hide(this.selectedPerson.id);
	    };
	    return MergeDlgController;
	}());
	exports.default = MergeDlgController;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2019
	 */
	var SelectSubLengthController = /** @class */ (function () {
	    SelectSubLengthController.$inject = ["$log", "$mdDialog"];
	    function SelectSubLengthController($log, $mdDialog) {
	        'ngInject';
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	    }
	    SelectSubLengthController.prototype.month = function () {
	        this.$mdDialog.hide('MONTH');
	    };
	    SelectSubLengthController.prototype.year = function () {
	        this.$mdDialog.hide('YEAR');
	    };
	    SelectSubLengthController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return SelectSubLengthController;
	}());
	exports.default = SelectSubLengthController;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var SelectTreeController = /** @class */ (function () {
	    SelectTreeController.$inject = ["$log", "$mdDialog", "$state", "$scope", "$window", "rx", "messageBus", "currentTreeId", "currentUserId", "currentUser", "utils"];
	    function SelectTreeController($log, $mdDialog, $state, $scope, $window, rx, messageBus, currentTreeId, currentUserId, currentUser, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$state = $state;
	        this.$window = $window;
	        this.utils = utils;
	        // selectForMerge
	        this.trees = [];
	        this.currentTreeId = 0;
	        this.title = this.selectForMerge ? 'Select a tree to import into this tree' : 'Open or Create a Tree';
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        // keep in sync with homeSignedIn
	        var cuSub = currentUserId.stream().subscribe(function (userId) {
	            if (userId !== 0) {
	                rx.Observable.forkJoin([currentUser.readTrees(userId), currentTreeId.stream().take(1)])
	                    .take(1).subscribe(function (_a) {
	                    var _b = __read(_a, 2), trees = _b[0], treeId = _b[1];
	                    _this.currentTreeId = treeId;
	                    _this.trees = Array.from(trees.values());
	                    // sort trees by name
	                    _this.trees.sort(function (a, b) {
	                        var n1 = a.name.toLowerCase();
	                        var n2 = b.name.toLowerCase();
	                        if (n1 < n2) {
	                            return -1;
	                        }
	                        else if (n1 > n2) {
	                            return 1;
	                        }
	                        return a.id - b.id;
	                    });
	                    // put current tree at top or remove it
	                    var pos = _this.trees.findIndex(function (tree) { return tree.id === treeId; });
	                    if (pos >= 0) {
	                        var tree = _this.trees.splice(pos, 1);
	                        if (!_this.selectForMerge) {
	                            _this.trees.unshift(tree[0]);
	                        }
	                    }
	                });
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	            cuSub.unsubscribe();
	        });
	    }
	    SelectTreeController.prototype.select = function (tree) {
	        this.$mdDialog.hide({ action: 'open', id: tree.id });
	    };
	    SelectTreeController.prototype.create = function () {
	        this.$mdDialog.hide({ action: 'create' });
	        //this.utils.dialog(ev, 'AddTreeController', 'app/components/addTree/addTree.html', true, {});
	    };
	    SelectTreeController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return SelectTreeController;
	}());
	exports.default = SelectTreeController;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var signIn_controller_1 = __webpack_require__(99);
	var SignInController = /** @class */ (function () {
	    SignInController.$inject = ["$log", "$mdDialog", "$scope", "$state", "$window", "authentication", "messageBus", "segment", "server", "utils"];
	    function SignInController($log, $mdDialog, $scope, $state, $window, authentication, messageBus, segment, server, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$window = $window;
	        this.authentication = authentication;
	        this.messageBus = messageBus;
	        this.segment = segment;
	        this.server = server;
	        this.utils = utils;
	        // passed in: code
	        this._signInController = new signIn_controller_1.SignInController($log, authentication, messageBus, segment, server, utils, this.code);
	        $scope.$on('$destroy', function () {
	            _this._signInController.unsubscribe();
	        });
	    }
	    SignInController.prototype.forgot = function (ev) {
	        this._signInController.forgot(ev);
	        this.$mdDialog.hide();
	        this.utils.dialog(ev, 'ForgotPasswordController', 'app/components/forgotPassword/forgotPassword.html');
	    };
	    SignInController.prototype.submit = function () {
	        var _this = this;
	        this._signInController.submit(this.email, this.password).subscribe(function () {
	            if (!!_this._signInController.code) {
	                _this.server.put('/invitations/' + _this._signInController.code).subscribe(function (response) {
	                    _this._signInController.saving = false;
	                    _this.segment.track('invitations.accept');
	                    // goto tree
	                    _this.$state.go('tree', { treeId: response.treeId });
	                }, function () {
	                    _this._signInController.saving = false;
	                    _this.messageBus.post({ msg: 'ACCEPT_INVITATION_ERROR', op: "PUT", ctx: "invitations" });
	                });
	            }
	            else if (_this.$state.is('register')) {
	                _this.$window.location.href = _this.$state.href('home', {}, { absolute: true });
	            }
	            else if (_this.$state.is('home')) {
	                _this.$mdDialog.hide();
	            }
	            else {
	                _this.$window.location.reload();
	            }
	        }, function () {
	            _this._signInController.saving = false;
	            _this.$log.debug('login failure');
	        });
	    };
	    SignInController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return SignInController;
	}());
	exports.default = SignInController;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Subject } from '../node_modules/rxjs';
	var SignInController = /** @class */ (function () {
	    function SignInController(log, authentication, messageBus, segment, server, utils, code) {
	        var _this = this;
	        this.log = log;
	        this.authentication = authentication;
	        this.messageBus = messageBus;
	        this.segment = segment;
	        this.server = server;
	        this.utils = utils;
	        this.code = code;
	        this.mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	    }
	    SignInController.prototype.forgot = function (ev) {
	        this.msg = '';
	    };
	    SignInController.prototype.submit = function (email, password) {
	        this.msg = '';
	        this.saving = true;
	        return this.authentication.login(email, password, true);
	    };
	    SignInController.prototype.unsubscribe = function () {
	        this.mbSub.unsubscribe();
	    };
	    return SignInController;
	}());
	exports.SignInController = SignInController;
	exports.default = SignInController;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2018
	 */
	var TreeGraphicController = /** @class */ (function () {
	    TreeGraphicController.$inject = ["$log", "$scope", "$mdDialog", "$mdMedia"];
	    function TreeGraphicController($log, $scope, $mdDialog, $mdMedia) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$scope = $scope;
	        this.$mdMedia = $mdMedia;
	        this.expanded = true;
	        // passed in: graphic, subscribePrompt
	        $scope.$on('toggleExpand', function () {
	            _this.expanded = !_this.expanded;
	        });
	    }
	    TreeGraphicController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    TreeGraphicController.prototype.subscribe = function () {
	        this.$mdDialog.hide(true);
	    };
	    return TreeGraphicController;
	}());
	exports.default = TreeGraphicController;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var UpdateProfilesController = /** @class */ (function () {
	    UpdateProfilesController.$inject = ["$log", "$mdDialog", "$mdMedia", "$scope", "messageBus"];
	    function UpdateProfilesController($log, $mdDialog, $mdMedia, $scope, messageBus) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.persons = [{
	                facts: [{
	                        label: 'Name',
	                        eventValue: 'Andrew Samuel Griffith',
	                        profileValue: 'Andrew Samuel Griffith'
	                    }, {
	                        label: 'Birth Date',
	                        eventValue: '1 June 1926',
	                        profileValue: '1926'
	                    }, {
	                        label: 'Birth Place',
	                        eventValue: 'Mount Airy, Surry, North Carolina, United States',
	                        profileValue: ''
	                    }]
	            }, {
	                facts: [{
	                        label: 'Name',
	                        eventValue: 'Barbara Bray Edwards',
	                        profileValue: 'Barbara Bray Edwards'
	                    }, {
	                        label: 'Birth Date',
	                        eventValue: '1927',
	                        profileValue: '1928'
	                    }]
	            }];
	        this.persons.forEach(function (p) {
	            try {
	                for (var _a = __values(p.facts), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var _c = __read(_b.value, 2), v = _c[1];
	                    v.targetValue = v.profileValue;
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            var e_1, _d;
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    UpdateProfilesController.prototype.updateProfile = function (fact) {
	        if (fact.targetValue === fact.profileValue) {
	            fact.targetValue = fact.eventValue;
	        }
	        else {
	            fact.targetValue = fact.profileValue;
	        }
	    };
	    UpdateProfilesController.prototype.submit = function (save) {
	        this.msg = '';
	        this.saving = true;
	        this.saving = false;
	        this.$mdDialog.hide(save);
	    };
	    UpdateProfilesController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return UpdateProfilesController;
	}());
	exports.default = UpdateProfilesController;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var VideoPreviewController = /** @class */ (function () {
	    VideoPreviewController.$inject = ["$log", "$mdDialog", "$mdMedia", "$sce", "$scope", "medias", "messageBus"];
	    function VideoPreviewController($log, $mdDialog, $mdMedia, $sce, $scope, medias, messageBus) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.$sce = $sce;
	        // passed in: data
	        this.url = '';
	        medias.createSlideshow(this.data).subscribe(function (change) {
	            _this.url = change.url;
	        }, function (e) {
	            messageBus.post({ msg: 'Error: ' + e.name || e, op: 'POST', ctx: 'slideshow-preview' });
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            mbSub.unsubscribe();
	        });
	    }
	    VideoPreviewController.prototype.getPreviewURL = function (url) {
	        return this.$sce.trustAsResourceUrl(url);
	    };
	    VideoPreviewController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    return VideoPreviewController;
	}());
	exports.default = VideoPreviewController;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var VoiceoverController = /** @class */ (function () {
	    VoiceoverController.$inject = ["$log", "$mdDialog", "$mdMedia", "$interval", "$timeout", "$scope", "$window", "mediaStreamRecorder", "messageBus"];
	    function VoiceoverController($log, $mdDialog, $mdMedia, $interval, $timeout, $scope, $window, mediaStreamRecorder, messageBus) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$mdDialog = $mdDialog;
	        this.$mdMedia = $mdMedia;
	        this.$interval = $interval;
	        this.$timeout = $timeout;
	        this.mediaStreamRecorder = mediaStreamRecorder;
	        this.messageBus = messageBus;
	        // passed in: mediaArr
	        this.maxLength = 3600000; // enough for 60 minutes in 1 blob, which should be plenty
	        this.isRecording = false;
	        this.isPaused = false;
	        this.isReady = false;
	        this.pos = 0;
	        this.tenths = 0;
	        this.prevTenths = 0;
	        this.timer = null;
	        this.recorder = null;
	        this.timings = this.mediaArr.map(function () { return 0; });
	        $window.navigator.mediaDevices.getUserMedia({ audio: true })
	            .then(function (stream) {
	            _this.recorder = new _this.mediaStreamRecorder(stream);
	            _this.recorder.stream = stream;
	            _this.recorder.audioChannels = 1;
	            _this.recorder.ondataavailable = function (blob) {
	                if (_this.isRecording) {
	                    _this.$mdDialog.hide({
	                        timings: _this.timings,
	                        blob: blob,
	                        mimeType: _this.recorder.mimeType
	                    });
	                }
	            };
	        })
	            .catch(function (e) {
	            _this.messageBus.post({ msg: 'Error: ' + e.name || e, op: 'GET', ctx: 'voiceover' });
	        });
	        var mbSub = messageBus.stream().subscribe(function (msg) {
	            if (!!msg) {
	                _this.msg = msg;
	                messageBus.post(null);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            //if (!!this.recorder && !!this.recorder.stream && this.recorder.stream.getTracks().length > 0) {
	            //  this.recorder.stream.getTracks()[0].stop();
	            //}
	            _this.stopTimer();
	            mbSub.unsubscribe();
	        });
	    }
	    VoiceoverController.prototype.record = function () {
	        if (!this.recorder) {
	            this.msg = 'We\'re sorry. Voiceovers don\'t appear to be available in your browser. Please try Chrome or Firefox.';
	            return;
	        }
	        if (!this.isRecording) {
	            this.isRecording = true;
	            this.pos = 0;
	            this.tenths = 0;
	            this.prevTenths = 0;
	            this.isReady = false;
	            this.recorder.start(this.maxLength);
	        }
	        else {
	            this.recorder.resume();
	        }
	        this.isPaused = false;
	        this.startTimer();
	    };
	    VoiceoverController.prototype.pause = function () {
	        this.isPaused = true;
	        if (this.pos === this.mediaArr.length - 1) {
	            this.timings[this.pos] = (this.tenths - this.prevTenths) / 10;
	            this.isReady = true;
	        }
	        this.stopTimer();
	        this.recorder.pause();
	    };
	    VoiceoverController.prototype.next = function () {
	        var _this = this;
	        this.timings[this.pos] = (this.tenths - this.prevTenths) / 10;
	        this.prevTenths = this.tenths;
	        if (this.pos < this.mediaArr.length - 1) {
	            this.pos++;
	        }
	        else {
	            this.$timeout(function () {
	                _this.submit();
	            }, 200);
	        }
	    };
	    VoiceoverController.prototype.startTimer = function () {
	        var _this = this;
	        this.timer = this.$interval(function () {
	            _this.tenths++;
	        }, 100);
	    };
	    VoiceoverController.prototype.stopTimer = function () {
	        if (!!this.timer) {
	            this.$interval.cancel(this.timer);
	            this.timer = null;
	        }
	    };
	    VoiceoverController.prototype.getTime = function () {
	        var minutes = Math.floor(this.tenths / 600);
	        var seconds = Math.floor(this.tenths / 10) % 60;
	        var tenths = this.tenths % 10;
	        return minutes + ':' + (seconds < 10 ? '0' : '') + seconds + '.' + tenths;
	    };
	    VoiceoverController.prototype.submit = function () {
	        this.msg = '';
	        if (this.isRecording) {
	            this.recorder.stop(); // exit dialog from ondataavailable
	            this.recorder.stream.stop();
	        }
	    };
	    VoiceoverController.prototype.cancel = function () {
	        if (this.isRecording) {
	            this.isRecording = false;
	            this.recorder.stop();
	            this.recorder.stream.stop();
	        }
	        this.$mdDialog.cancel();
	    };
	    return VoiceoverController;
	}());
	exports.default = VoiceoverController;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcAncestorsDescendantsDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/ancestorsDescendants/ancestorsDescendants.html',
	        controller: AncestorsDescendantsController,
	        controllerAs: 'ancestorsDescendants',
	        bindToController: true,
	        scope: {
	            root: '='
	        }
	    };
	}
	var personHeight = 160;
	var personWidth = 96;
	var personMarginX = 16;
	var personMarginY = 48;
	// TODO calc these from screen size (or let panzoom do this)
	var yOffset = 500;
	var xOffset = 150;
	var initialZoom = 0.6;
	var AncestorsDescendantsController = /** @class */ (function () {
	    AncestorsDescendantsController.$inject = ["$log", "$scope", "$timeout", "utils", "easing", "rx", "persons", "families", "leads", "evidences", "currentUser", "users", "$window"];
	    function AncestorsDescendantsController($log, $scope, $timeout, utils, easing, rx, persons, families, leads, evidences, currentUser, users, $window) {
	        'ngInject';
	        var _this = this;
	        this.$window = $window;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.utils = utils;
	        this.families = families;
	        this.persons = persons;
	        this.leads = leads;
	        this.evidences = evidences;
	        this.currentUser = currentUser;
	        this.users = users;
	        this.$scope.fragment = {};
	        // TODO To avoid the Error in utils encode have to pass idCoding. Find a workarund.
	        this.idCoding = utils.idCoding;
	        this.encodeId = utils.encodeId.bind(this);
	        this.personsMap = null;
	        this.ready = false;
	        var pw = this.utils.pleaseWait();
	        this.$onInit = function () {
	            $timeout(function () {
	                _this.zoom(initialZoom);
	            }, 400);
	            _this.$scope.fragment.root = _this.root;
	            var subscription = rx.Observable.combineLatest(_this.utils.watch($scope, 'fragment.root'), _this.utils.readyChange(persons, families, leads, evidences)).subscribe(function (_a) {
	                var _b = __read(_a, 2), e = _b[0], _c = __read(_b[1], 1), personMap = _c[0];
	                $log.debug('pf.ready', e.newValue);
	                if (!!e.newValue && !!personMap && !!personMap.get(e.newValue)) {
	                    _this.personsMap = personMap;
	                    _this.parentsMap = families.getParentsMap();
	                    _this.spousesMap = families.getSpousesMap();
	                    _this.fillAncestorsDescendants(e.newValue);
	                    _this.ready = true;
	                }
	                _this.utils.pleaseWaitCancel(pw);
	            });
	            $scope.$on('$destroy', function () {
	                _this.utils.pleaseWaitCancel(pw);
	                subscription.unsubscribe();
	            });
	        };
	    }
	    AncestorsDescendantsController.prototype.fillAncestorsDescendants = function (pid) {
	        this._p = [];
	        this._f = [];
	        // TODO REMOVE. Development only use;
	        // window.pp = this._p;
	        // window.ff = this._f;
	        this.fillParents(0, 0, pid, null, null, 0);
	        // Move children according to the root.
	        var rootPos = this._p.find(function (p) { return p.person.id === pid; }).pos - 1;
	        this._p.forEach(function (p) {
	            if (p.gen <= 0)
	                p.pos -= rootPos;
	        });
	        this.fillParentFamilyLines(pid, 0);
	        this.fillChildren(0, 0, pid, null, null, 0);
	        var first_gen_positions = this._p.filter(function (p) { return p.gen === 1; }).map(function (o) { return o.pos; });
	        var maxPos = Math.max.apply(Math, __spread(first_gen_positions));
	        var minPos = Math.min.apply(Math, __spread(first_gen_positions));
	        var position = minPos + Math.ceil((maxPos - minPos) / 2);
	        this._p.forEach(function (p) {
	            if (p.gen > 0)
	                p.pos -= position;
	        });
	        this.fillChildrenFamilyLines(pid, 1);
	        // TODO should be changed.
	        this._persons = this._p;
	        this._families = this._f;
	        console.log(this);
	    };
	    AncestorsDescendantsController.prototype.addPerson = function (generation, position, person, isAncestor, hiddenAncestors, hiddenDescendants) {
	        this._p.push({
	            gen: generation,
	            pos: position,
	            isSelf: (person.id === this.$scope.fragment.root),
	            isAncestor: isAncestor,
	            hiddenAncestors: hiddenAncestors,
	            hiddenDescendants: hiddenDescendants,
	            person: person
	        });
	        return position;
	    };
	    // Helper method to check for hidden Ancestors.
	    AncestorsDescendantsController.prototype.isHiddenAncestors = function (rootPid, pid) {
	        var hasAncestors;
	        if (!pid)
	            return hasAncestors;
	        var p = this.personsMap.get(pid);
	        var f = this.families.getPreferredFamily(this.parentsMap.get(pid) || new Map(), p.preferredParentsFamilyId);
	        // Return false if it is a sibling.
	        if (f && !this.getSiblings(rootPid).find(function (p) { return p.id === pid; }))
	            return hasAncestors = true;
	        return hasAncestors;
	    };
	    // Helper method to check for hidden Descendants.
	    AncestorsDescendantsController.prototype.isHiddenDescendants = function (pid) {
	        var hasAtLeastOneChild = false;
	        Array.from((this.spousesMap.get(pid) || new Map()).entries()).forEach(function (_a) {
	            var _b = __read(_a, 2), f = _b[1];
	            if (f.childRels.toJSON().length)
	                return hasAtLeastOneChild = true;
	        });
	        return hasAtLeastOneChild;
	    };
	    AncestorsDescendantsController.prototype.addFamilyParent = function (gen, hiddenAncestors, father, mother, marriageNumber, marriageTotal, ancestorChild, children) {
	        this._f.push({
	            gen: gen,
	            hiddenAncestors: hiddenAncestors,
	            marriageNumber: marriageNumber,
	            marriageTotal: marriageTotal,
	            father: father,
	            mother: mother,
	            ancestorChild: ancestorChild,
	            children: children
	        });
	    };
	    // Get Siblings
	    AncestorsDescendantsController.prototype.getSiblings = function (pid, f) {
	        var _this = this;
	        var siblings = [];
	        var family = f;
	        if (!pid)
	            return siblings;
	        if (!family) {
	            family = this.families.getPreferredFamily(this.parentsMap.get(pid) || new Map(), this.personsMap.get(pid).preferredParentsFamilyId);
	        }
	        if (!family)
	            return siblings;
	        // Get siblings with current person inclusive.
	        Array.from(family.childRels.entries()).forEach(function (_a) {
	            var _b = __read(_a, 1), id = _b[0];
	            siblings.push(_this.personsMap.get(id));
	        });
	        // Sort Siblings from 'left' to 'right' in descending order(older goes left). (Unknown goes right)
	        siblings.sort(function (a, b) { return _this.utils.compareDateSorts(a._birthDateSort, b._birthDateSort); });
	        return siblings;
	    };
	    // Get Spouses
	    AncestorsDescendantsController.prototype.getSpouses = function (pid, spousesType) {
	        var _this = this;
	        var spouses = [];
	        Array.from((this.spousesMap.get(pid) || new Map()).entries()).forEach(function (_a) {
	            var _b = __read(_a, 2), f = _b[1];
	            var spouseId = f[spousesType + "Id"];
	            if (spouseId > 0) {
	                spouses.push(_this.personsMap.get(spouseId));
	            }
	            else if (spouseId === 0) {
	                spouses.push("unknown");
	            }
	        });
	        spouses.sort(function (a, b) { return _this.utils.compareDateSorts(a._birthDateSort, b._birthDateSort); });
	        return spouses;
	    };
	    AncestorsDescendantsController.prototype.getSpousesWithChildren = function (pid, spousesType) {
	        var _this = this;
	        var data = [];
	        // Iterate over each family from each spouse
	        Array.from((this.spousesMap.get(pid) || new Map()).entries()).forEach(function (_a) {
	            var _b = __read(_a, 2), f = _b[1];
	            var tmp = { children: [] };
	            // Get Spouse
	            var spouseId = f[spousesType + "Id"];
	            if (spouseId > 0) {
	                tmp.spouse = _this.personsMap.get(spouseId);
	            }
	            else {
	                tmp.spouse = "unknown";
	            }
	            // Get children
	            Array.from(f.childRels.entries()).forEach(function (_a) {
	                var _b = __read(_a, 1), id = _b[0];
	                tmp.children.push(_this.personsMap.get(id));
	            });
	            tmp.children.sort(function (a, b) { return _this.utils.compareDateSorts(a._birthDateSort, b._birthDateSort); });
	            data.push(tmp);
	        });
	        // Sort spouses in descending or ascending order depending of a spouse type.
	        data.sort(function (a, b) { return _this.utils.compareDateSorts(!!a.spouse ? a.spouse._birthDateSort : '', !!b.spouse ? b._birthDateSort : ''); });
	        return data;
	    };
	    AncestorsDescendantsController.prototype.getParents = function (pid) {
	        var family = this.families.getPreferredFamily(this.parentsMap.get(pid) || new Map(), this.personsMap.get(pid).preferredParentsFamilyId);
	        var father;
	        var mother;
	        if (!family) {
	            this._p.filter(function (p) { return p.person._unknown && p.person._childId === pid; }).forEach(function (p) {
	                if (p.person._relationshipType === "FATHER") {
	                    father = p;
	                }
	                else {
	                    mother = p;
	                }
	            });
	        }
	        else {
	            if (family.husbandId) {
	                father = this._p.find(function (p) { return p.person.id === family.husbandId; });
	            }
	            else {
	                father = this._p.filter(function (p) { return p.person._unknown && p.person._childId === pid && p.person._mode === "parent"; })[0];
	            }
	            if (family.wifeId) {
	                mother = this._p.find(function (p) { return p.person.id === family.wifeId; });
	            }
	            else {
	                mother = this._p.filter(function (p) { return p.person._unknown && p.person._childId === pid && p.person._mode === "parent"; })[0];
	            }
	        }
	        return { father: father, mother: mother };
	    };
	    AncestorsDescendantsController.prototype.isParentOfRootPerson = function (pid, gen) {
	        var _this = this;
	        if (gen === void 0) { gen = 0; }
	        var parents = this.getParents(this.$scope.fragment.root);
	        if (!parents)
	            return false;
	        var isDirectAncestor = ((parents.father && parents.father.person && parents.father.person.id === pid) || (parents.mother && parents.mother.person && parents.mother.person.id === pid));
	        if (isDirectAncestor) {
	            return true;
	        }
	        else {
	            if (gen > 1) {
	                return false;
	            }
	            else {
	                var person = this.personsMap.get(pid);
	                if (!person)
	                    return false;
	                //let f = this.families.getPreferredFamily(this.parentsMap.get(person.id) || new Map(), person.preferredParentsFamilyId);
	                var children_1 = [];
	                this.getSpousesWithChildren(person.id, person.gender === "MALE" ? "wife" : "husband").forEach(function (s) {
	                    children_1 = children_1.concat(s.children);
	                });
	                return children_1.some(function (child) { return _this.isParentOfRootPerson(child.id, gen + 1); });
	            }
	        }
	    };
	    AncestorsDescendantsController.prototype.fillChildrenFamilyLines = function (pid, gen) {
	        var _this = this;
	        if (!pid || gen > 2)
	            return;
	        var person = this.personsMap.get(pid);
	        // Get spousesType for root person only
	        var spousesType = person.gender === "MALE" ? "wife" : "husband";
	        // Get root Family.
	        //let f = this.families.getPreferredFamily(this.parentsMap.get(pid) || new Map(), person.preferredParentsFamilyId);
	        // Get children for each spouse
	        var spousesWithChildren = this.getSpousesWithChildren(pid, spousesType);
	        spousesWithChildren.forEach(function (o, index) {
	            var mother = 0;
	            var father = 0;
	            var childrenPositons = [];
	            if (spousesType === 'wife') {
	                father = _this._p.find(function (p) { return p.person.id === person.id; }).pos;
	                if (!!o.spouse) {
	                    if (o.spouse === "unknown") {
	                        // One of the console log errors happens here. find() doesn't find anyone, so null.pos is an error
	                        // I modified the code to require !! before accessing m.pos
	                        var m = _this._p.find(function (p) { return p.person._childId === pid && p.person._mode === "spouse"; });
	                        mother = !!m ? m.pos : 0;
	                    }
	                    else {
	                        mother = _this._p.find(function (p) { return p.person.id === o.spouse.id; }).pos;
	                    }
	                }
	            }
	            else {
	                mother = _this._p.find(function (p) { return p.person.id === person.id; }).pos;
	                if (!!o.spouse) {
	                    if (o.spouse === "unknown") {
	                        // same here
	                        var f = _this._p.find(function (p) { return p.person._childId === pid && p.person._mode === "spouse"; });
	                        father = !!f ? f.pos : 0;
	                    }
	                    else {
	                        father = _this._p.find(function (p) { return p.person.id === o.spouse.id; }).pos;
	                    }
	                }
	            }
	            o.children.forEach(function (child) {
	                childrenPositons.push(_this._p.find(function (p) { return child.id === p.person.id; }).pos);
	                _this.fillChildrenFamilyLines(child.id, gen + 1);
	            });
	            _this.addFamilyParent(gen, null, father, mother, 1 + index, spousesWithChildren.length, _this.getMedian(childrenPositons), childrenPositons);
	        });
	    };
	    AncestorsDescendantsController.prototype.fillChildrenSlots = function (pid, gen, pos, lastPosition, person, spousesWithChildren, spousesType) {
	        var _this = this;
	        var data = [];
	        var position = pos;
	        // Don't display grandchildren's spouses in the last row.
	        if (gen !== 2)
	            spousesWithChildren.forEach(function (o) { return data.push(o.spouse); });
	        // "+ADD" block for at least one Spouse for children.
	        if (gen === 1 && !data.length && this.personHasChild(pos, gen)) {
	            data.push("unknown");
	        }
	        (spousesType === 'wife') ? data.unshift(person) : data.push(person);
	        // Add person and it's spouses if It's not the root person.
	        if (pid !== this.$scope.fragment.root) {
	            if (data.length > 1) {
	                if (lastPosition > position)
	                    position = position + Math.ceil((lastPosition - position) / 2) - Math.floor(data.length / 2);
	                if (this.isPositionOccupied(gen, position - 1))
	                    position++;
	                data.forEach(function (p, index) {
	                    if (p === "unknown") {
	                        _this.addPerson(gen, position + index, {
	                            _unknown: true,
	                            _mode: 'spouse',
	                            _root: false,
	                            _family: null,
	                            _childId: pid,
	                            _relationshipType: 'SPOUSE'
	                        }, true, false);
	                    }
	                    else {
	                        _this.addPerson(gen, position + index, p, null, p.id !== person.id ? _this.isHiddenAncestors(pid, p.id) : null);
	                    }
	                });
	            }
	            else {
	                return this.addPerson(gen, position, person) + 1;
	            }
	        }
	        return Math.max(lastPosition, position + data.length + 1);
	    };
	    AncestorsDescendantsController.prototype.fillChildren = function (gen, pos, pid, family, relationshipType) {
	        var _this = this;
	        var endPosition = pos;
	        // Get Person
	        var p = this.personsMap.get(pid);
	        // Get spousesType for root person only
	        var spousesType = p.gender === "MALE" ? "wife" : "husband";
	        // Get root Family.
	        var f = this.families.getPreferredFamily(this.parentsMap.get(pid) || new Map(), p.preferredParentsFamilyId);
	        // Get children for each spouse
	        var spousesWithChildren = this.getSpousesWithChildren(pid, spousesType);
	        // Shows the last x postion of the person was set
	        var lastPosition = pos;
	        if (gen < 2) {
	            spousesWithChildren.forEach(function (obj) {
	                obj.children.forEach(function (child) {
	                    lastPosition = _this.fillChildren(gen + 1, lastPosition, child.id, f, relationshipType, pid);
	                });
	                if (obj.children.length && _this.isPositionOccupied(gen + 1, lastPosition - 1))
	                    lastPosition++;
	            });
	        }
	        // Add the current person with all spouses
	        endPosition = this.fillChildrenSlots(pid, gen, pos, lastPosition, p, spousesWithChildren, spousesType);
	        return endPosition;
	    };
	    AncestorsDescendantsController.prototype.fillParentFamilyLines = function (pid, gen) {
	        var _this = this;
	        if (!pid)
	            return;
	        // Get Person
	        var p = this.personsMap.get(pid);
	        var f = this.families.getPreferredFamily(this.parentsMap.get(pid) || new Map(), p.preferredParentsFamilyId);
	        var parents = { father: {}, mother: {} };
	        var hiddenAncestors;
	        var ancestorChild;
	        var childrenPositons = [];
	        if (gen > -3) {
	            parents = this.getParents(pid, p);
	            this.fillParentFamilyLines(parents.father.person && parents.father.person.id, gen - 1);
	            this.fillParentFamilyLines(parents.mother.person && parents.mother.person.id, gen - 1);
	        }
	        if (gen === -3 && f) {
	            hiddenAncestors = true;
	        }
	        this.getSiblings(pid).forEach(function (sibling) { return childrenPositons.push(_this._p.find(function (p) { return p.person.id === sibling.id; }).pos); });
	        ancestorChild = this._p.find(function (p) { return p.person.id === pid; }).pos;
	        this.addFamilyParent(gen, hiddenAncestors, parents.father.pos, parents.mother.pos, 1, 1, ancestorChild, childrenPositons.indexOf(ancestorChild) === -1 ? [ancestorChild] : childrenPositons);
	    };
	    // Fill Slot containing Siblings and/or Spouses
	    AncestorsDescendantsController.prototype.fillSlot = function (pid, gen, pos, person, family, spousesType) {
	        var _this = this;
	        var siblings = this.getSiblings(pid, family);
	        // In case Person does't have parents make sure to include his/her to siblings list.
	        if (siblings.length === 0)
	            siblings.push(person);
	        var spouses = this.getSpouses(pid, spousesType);
	        var position = pos.min;
	        var index;
	        var rootPosition;
	        var diff = pos.max - pos.min;
	        if (spousesType) {
	            // Get the index of root person
	            index = siblings.findIndex(function (p) { return p.id === pid; });
	            // Cosider the position of spouses depending on spousesType.
	            index = (spousesType === "wife") ? index + 1 : index - 1;
	            // "+ADD" block for at least one Spouse for Root.
	            if (gen === 0 && !spouses.length) {
	                spouses.push("unknown");
	            }
	            // To combine two arrays specifying the index of insertion please use JS splice combined with some apply trickery.
	            // Special Thanks to -> http://stackoverflow.com/questions/7032550/javascript-insert-an-array-inside-another-array
	            siblings.splice.apply(siblings, [index, 0].concat(spouses));
	        }
	        rootPosition = siblings.findIndex(function (p) { return p.id === pid; }) + 1;
	        if (diff - rootPosition >= 0) {
	            position += diff - rootPosition;
	        }
	        if (siblings.length > 1) {
	            // Fill persons Array with person data
	            siblings.forEach(function (p, i) {
	                if (p === "unknown") {
	                    _this.addPerson(gen, position + i, {
	                        _unknown: true,
	                        _mode: 'spouse',
	                        _root: true,
	                        _family: null,
	                        _childId: pid,
	                        _relationshipType: 'SPOUSE'
	                    }, true, false);
	                }
	                else {
	                    var _isHiddenDescendants = (p.id === pid || !!spouses.find(function (sp) { return sp.id === p.id; })) ? null : _this.isHiddenDescendants(p.id);
	                    _this.addPerson(gen, position + i, p, p.id === pid, p.id !== pid ? _this.isHiddenAncestors(pid, p.id) : null, _isHiddenDescendants);
	                }
	            });
	        }
	        else {
	            if (this.isPositionOccupied(gen, position - 1))
	                position++;
	            this.addPerson(gen, position, person, true);
	        }
	        rootPosition = this._p.find(function (p) { return p.person.id === pid; }).pos;
	        return { min: position, rootPos: rootPosition + 1, max: position + siblings.length };
	    };
	    AncestorsDescendantsController.prototype.fillParents = function (gen, pos, pid, family, relationshipType, childId) {
	        var position = { min: pos, max: pos };
	        if (pid === 0) {
	            if (gen >= -3) {
	                position.max = this.addPerson(gen, pos, {
	                    _unknown: true,
	                    _mode: 'parent',
	                    _root: pid === this.$scope.fragment.root,
	                    _family: family || { id: 0, childRels: new Map([[childId, { fatherRel: '', motherRel: '' }]]) },
	                    _childId: childId,
	                    _relationshipType: relationshipType
	                }, true, false);
	                if (relationshipType === "MOTHER")
	                    position.max++;
	            }
	            return position;
	        }
	        // Get Person
	        var p = this.personsMap.get(pid);
	        // Get spousesType for root person only
	        var spousesType = this.$scope.fragment.root === pid ? p.gender === "MALE" ? "wife" : "husband" : null;
	        // Get root Family.
	        var f = this.families.getPreferredFamily(this.parentsMap.get(pid) || new Map(), p.preferredParentsFamilyId);
	        var fatherPosition;
	        var motherPosition;
	        if (gen === -3)
	            return this.fillSlot(pid, gen, { min: pos, max: pos }, p, f, spousesType);
	        fatherPosition = this.fillParents(gen - 1, pos, f ? f.husbandId : 0, f, "FATHER", pid);
	        position = this.fillSlot(pid, gen, { min: fatherPosition.min, max: fatherPosition.max }, p, f, spousesType);
	        motherPosition = this.fillParents(gen - 1, position.rootPos + 1, f ? f.wifeId : 0, f, "MOTHER", pid);
	        return { min: fatherPosition.min, max: Math.max(position.max, motherPosition.max) };
	    };
	    AncestorsDescendantsController.prototype.home = function () {
	        this.$scope.$emit('home', {
	            zoom: initialZoom
	        });
	    };
	    AncestorsDescendantsController.prototype.zoom = function (multiplier) {
	        this.$scope.$emit('zoom', multiplier);
	    };
	    AncestorsDescendantsController.prototype.getPosX = function (pos, gen) {
	        return pos * (personWidth + personMarginX) + (personWidth + personMarginX) / 2 * gen + xOffset;
	    };
	    AncestorsDescendantsController.prototype.getPersonX = function (person) {
	        return this.getPosX(person.pos, person.gen);
	    };
	    AncestorsDescendantsController.prototype.getPosY = function (gen) {
	        return gen * (personHeight + personMarginY) + yOffset;
	    };
	    AncestorsDescendantsController.prototype.getPersonY = function (person) {
	        return this.getPosY(person.gen);
	    };
	    AncestorsDescendantsController.prototype.getMarriageOffset = function (family) {
	        return (family.marriageNumber - 0.5 - family.marriageTotal / 2) * 8;
	    };
	    AncestorsDescendantsController.prototype.getMarriageHeight = function (family) {
	        if (family.marriageTotal === 1) {
	            return 16;
	        }
	        else if (family.marriageTotal <= 3) {
	            return (family.marriageTotal - family.marriageNumber + 1) * 8;
	        }
	        return (family.marriageTotal - family.marriageNumber + 1) * 4;
	    };
	    AncestorsDescendantsController.prototype.isDescendantsChildrenFarFromParents = function (family) {
	        if (family.gen > 0 && family.children.length) {
	            if (this.getFamilyStemX(family) > this.getFamilyMotherX(family) || this.getFamilyStemX(family) < this.getFamilyParentsX(family))
	                return true;
	        }
	    };
	    AncestorsDescendantsController.prototype.getDescendantsChildrenFarFromParentsX = function (family) {
	        if (this.getFamilyStemX(family) > this.getFamilyMotherX(family)) {
	            return this.getFamilyMotherX(family);
	        }
	        else if (this.getFamilyStemX(family) < this.getFamilyParentsX(family)) {
	            return this.getFamilyStemX(family);
	        }
	    };
	    AncestorsDescendantsController.prototype.getDescendantsChildrenFarFromParentsWidth = function (family) {
	        if (this.getFamilyStemX(family) > this.getFamilyMotherX(family)) {
	            return this.getFamilyStemX(family) - this.getFamilyMotherX(family);
	        }
	        else if (this.getFamilyStemX(family) < this.getFamilyParentsX(family)) {
	            return this.getFamilyParentsX(family) - this.getFamilyStemX(family);
	        }
	    };
	    AncestorsDescendantsController.prototype.getFamilyMotherX = function (family) {
	        return this.getPosX(family.mother, family.gen - 1) + personWidth / 2 + this.getMarriageOffset(family);
	    };
	    AncestorsDescendantsController.prototype.getFamilyParentsX = function (family) {
	        return this.getPosX(family.father, family.gen - 1) + personWidth / 2 + this.getMarriageOffset(family);
	    };
	    AncestorsDescendantsController.prototype.getFamilyParentsY = function (family) {
	        return this.getPosY(family.gen) - 48;
	    };
	    AncestorsDescendantsController.prototype.getFamilyParentsWidth = function (family) {
	        return this.getPosX(family.mother, family.gen - 1) - this.getPosX(family.father, family.gen - 1);
	    };
	    AncestorsDescendantsController.prototype.getFamilyParentsHeight = function (family) {
	        return this.getMarriageHeight(family);
	    };
	    AncestorsDescendantsController.prototype.getFamilyStemX = function (family) {
	        if (family.gen === -3) {
	            return (this.getFamilyChildX(family, family.children[0]) + this.getFamilyChildX(family, family.children[family.children.length - 1])) / 2;
	        }
	        if (family.ancestorChild !== undefined) {
	            return this.getFamilyChildX(family, family.ancestorChild);
	        }
	        var pos = (this.getPosX(family.father, family.gen - 1) + this.getPosX(family.mother, family.gen - 1)) / 2 + personWidth / 2;
	        var firstChildPos = this.getFamilyChildX(family, family.children[0]);
	        var lastChildPos = this.getFamilyChildX(family, family.children[family.children.length - 1]);
	        if (pos < firstChildPos) {
	            pos = firstChildPos;
	        }
	        if (pos > lastChildPos) {
	            pos = lastChildPos;
	        }
	        return pos;
	    };
	    AncestorsDescendantsController.prototype.getFamilyStemY = function (family) {
	        return this.getFamilyParentsY(family) + this.getMarriageHeight(family);
	    };
	    AncestorsDescendantsController.prototype.getFamilyChildrenX = function (family) {
	        return this.getFamilyChildX(family, family.children[0]);
	    };
	    AncestorsDescendantsController.prototype.getFamilyChildrenY = function (family) {
	        return this.getFamilyStemY(family) + 16;
	    };
	    AncestorsDescendantsController.prototype.getFamilyChildrenWidth = function (family) {
	        return this.getPosX(family.children[family.children.length - 1], family.gen) - this.getPosX(family.children[0], family.gen);
	    };
	    AncestorsDescendantsController.prototype.getFamilyChildX = function (family, child) {
	        return this.getPosX(child, family.gen) + personWidth / 2;
	    };
	    AncestorsDescendantsController.prototype.getFamilyChildY = function (family) {
	        return this.getPosY(family.gen) - this.getFamilyChildHeight(family);
	    };
	    AncestorsDescendantsController.prototype.getFamilyChildButtonX = function (family, child) {
	        return this.getFamilyChildX(family, child) - 25;
	    };
	    AncestorsDescendantsController.prototype.getFamilyChildButtonY = function (family) {
	        return this.getPosY(family.gen) + personHeight + personMarginY / 3;
	    };
	    AncestorsDescendantsController.prototype.getFamilyChildHeight = function (family) {
	        return 48 - 16 - this.getMarriageHeight(family);
	    };
	    AncestorsDescendantsController.prototype.getFamilyButtonY = function (family) {
	        return this.getPosY(family.gen) - 72;
	    };
	    AncestorsDescendantsController.prototype.getFamilyButtonX = function (family) {
	        return this.getFamilyStemX(family) - 25;
	    };
	    AncestorsDescendantsController.prototype.isPositionOccupied = function (gen, pos) {
	        return !!this._p.find(function (p) { return p.pos === pos && p.gen === gen; });
	    };
	    AncestorsDescendantsController.prototype.getPersonByPosition = function (pos, gen) {
	        return this._p.find(function (p) { return p.pos === pos && p.gen === gen; });
	    };
	    AncestorsDescendantsController.prototype.personHasChild = function (pos, gen) {
	        var person = this.getPersonByPosition(pos, gen);
	        if (person)
	            person = person.person;
	        else
	            return false;
	        //let f = this.families.getPreferredFamily(this.parentsMap.get(person.id) || new Map(), person.preferredParentsFamilyId);
	        var spousesType = person.gender === "MALE" ? "wife" : "husband";
	        var spousesWithChildren = this.getSpousesWithChildren(person.id, spousesType);
	        var childrenCount = 0;
	        spousesWithChildren.forEach(function (s) {
	            childrenCount += s.children.length;
	        });
	        return !!childrenCount;
	    };
	    AncestorsDescendantsController.prototype.getMedian = function (args) {
	        if (!args.length)
	            return;
	        var numbers = args.slice(0).sort(function (a, b) { return a - b; });
	        var middle = Math.floor(numbers.length / 2);
	        return numbers[middle];
	    };
	    AncestorsDescendantsController.prototype.select = function (ev, p) {
	        var _this = this;
	        var person = p.person;
	        if (person === null) {
	            return;
	        }
	        if (person._unknown) {
	            this.currentUser.stream().filter(function (u) { return !!u; }).take(1).subscribe(function (user) {
	                _this.$log.debug('pf.select', person._childId, person._root, person._family, person._relationshipType);
	                _this.utils.dialog(ev, 'AddPersonController', 'app/components/addPerson/addPerson.html', false, {
	                    mode: person._mode,
	                    relationshipType: person._relationshipType,
	                    relatedToPersonId: person._childId,
	                    family: !!person._family && person._family.id > 0 ? person._family : null,
	                    nameGiven: person._root ? user.given : '',
	                    nameSurname: person._root ? user.surname : ''
	                });
	            });
	        }
	        else {
	            this.utils.dialog(ev, 'RelativesController', 'app/components/relatives/relatives.html', true, {
	                pid: person.id
	            });
	        }
	    };
	    return AncestorsDescendantsController;
	}());
	exports.default = rcAncestorsDescendantsDirective;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcChangeDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/change/change.html',
	        controller: ChangeController,
	        controllerAs: 'change',
	        bindToController: true,
	        scope: {
	            change: '='
	        }
	    };
	}
	var ChangeController = /** @class */ (function () {
	    ChangeController.$inject = ["$log", "$scope", "utils"];
	    function ChangeController($log, $scope, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.$scope = $scope;
	        this.utils = utils;
	    }
	    return ChangeController;
	}());
	exports.default = rcChangeDirective;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcCreatedEditedDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/createdEdited/createdEdited.html',
	        controller: CreatedEditedController,
	        controllerAs: 'createdEdited',
	        bindToController: true,
	        scope: {
	            obj: '=',
	            omitEdited: '@'
	        }
	    };
	}
	var CreatedEditedController = /** @class */ (function () {
	    CreatedEditedController.$inject = ["fs"];
	    function CreatedEditedController(fs) {
	        'ngInject';
	        var _this = this;
	        this.$onInit = function () {
	            _this.showEdited = !!_this.obj.editedDate && (_this.obj.editedDate - _this.obj.createdDate) > 86400 && !_this.omitEdited;
	            if (!!_this.obj._contribUser) {
	                fs.getUser(_this.obj._contribUser).take(1).subscribe(function (user) {
	                    _this.contribUser = user;
	                });
	            }
	        };
	    }
	    return CreatedEditedController;
	}());
	exports.default = rcCreatedEditedDirective;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	"use strict";
	rcD3ChromosomeDirective.$inject = ["$log", "$document", "$timeout", "d3"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcD3ChromosomeDirective($log, $document, $timeout, d3) {
	    'ngInject';
	    //let $scope;
	    var height = 0;
	    var width = 0;
	    function renderChromosomeChart() {
	        // Exposed variables
	        var attrs = {
	            id: "ID" + Math.floor(Math.random() * 1000000),
	            svgWidth: null,
	            svgHeight: null,
	            marginTop: 0,
	            marginBottom: 0,
	            marginRight: 16,
	            marginLeft: 20,
	            minWidth: 3,
	            container: 'body',
	            createSvg: false,
	            barPadding: 5,
	            barFill: '#488FC8',
	            font: 'Helvetica',
	            textFill: '#000000',
	            dividerFill: '#fafafa',
	            centromedeWidthProportion: 27.916,
	            data: null
	        };
	        //InnerFunctions which will update visuals
	        var updateData;
	        var drawBars;
	        //Main chart object
	        var main = function (elem) {
	            //################################  Container settings  ##########################
	            //Drawing containers
	            var container = d3.select(elem);
	            // Declaring some variables
	            var svg, chartParent;
	            // Checking if we should create svg or this graph is rendered already in svg
	            if (attrs.createSvg) {
	                // Get container bounding rect
	                var boundingRect = elem.getBoundingClientRect();
	                // Set dimensions if not already set
	                if (!attrs.svgWidth) {
	                    attrs.svgWidth = boundingRect.width;
	                }
	                if (!attrs.svgHeight) {
	                    attrs.svgHeight = boundingRect.height;
	                }
	                //Add svg
	                svg = container.patternify({ tag: 'svg', selector: 'svg-chart-container' })
	                    .attr('width', attrs.svgWidth)
	                    .attr('height', attrs.svgHeight)
	                    .attr('font-family', attrs.font)
	                    .style('fill', 'currentColor')
	                    .style('overflow', 'visible');
	                // Setting chartparent for wrapper g element
	                chartParent = svg;
	            }
	            else {
	                chartParent = container;
	                attrs.svgWidth = 600;
	                attrs.svgHeight = 700;
	            }
	            //################################  Calculations  ##########################
	            //Calculated properties
	            var calc = {};
	            calc.id = "ID" + Math.floor(Math.random() * 1000000); // id for event handlings
	            calc.chartLeftMargin = attrs.marginLeft;
	            calc.chartTopMargin = attrs.marginTop;
	            calc.chartWidth = attrs.svgWidth - attrs.marginRight - calc.chartLeftMargin;
	            calc.chartHeight = attrs.svgHeight - attrs.marginBottom - calc.chartTopMargin;
	            calc.maxChromosomeWidth = d3.max(attrs.data.chromosomes, function (d) { return d.basepair; });
	            calc.barHeight = calc.chartHeight / attrs.data.chromosomes.length - attrs.barPadding;
	            calc.dividerWidth = calc.chartWidth / attrs.centromedeWidthProportion;
	            //################################  Scales  ##########################
	            var scales = {};
	            scales.barWidth = d3.scaleLinear()
	                .domain([0, calc.maxChromosomeWidth])
	                .range([0, calc.chartWidth]);
	            scales.rangeBarWidth = d3.scaleLinear()
	                .domain([0, calc.maxChromosomeWidth])
	                .range([0, calc.chartWidth]);
	            //################################  DRAWING  ##########################
	            //Add container g element
	            var chart = chartParent.patternify({ tag: 'g', selector: 'chart' })
	                .attr('transform', 'translate(' + (calc.chartLeftMargin) + ',' + calc.chartTopMargin + ')')
	                .style('fill', 'currentColor');
	            //Initialize tooltip
	            var tooltip = d3.componentsTooltip()
	                .container(chart);
	            //--------------------------------  DRAWING  --------------------------------
	            // Bars container
	            var barsContainer = chart.patternify({ tag: 'g', selector: 'bars-container' })
	                .style('fill', 'currentColor');
	            //Range bar containers
	            var rangeBarsContainers = chart.patternify({ tag: 'g', selector: 'range-bars-container' })
	                .style('fill', 'currentColor');
	            var dividersContainer = chart.patternify({ tag: 'g', selector: 'dividers-container' })
	                .style('fill', 'currentColor');
	            var eachDividersContainer = dividersContainer.patternify({ tag: 'g', selector: 'divider', data: attrs.data.chromosomes })
	                .attr('transform', function (d, i) { return "translate(" + 0 + "," + i * (calc.barHeight + attrs.barPadding) + ")"; });
	            // Each bar container
	            var eachBarsContainer = barsContainer.patternify({ tag: 'g', selector: 'bar', data: attrs.data.chromosomes })
	                .attr('transform', function (d, i) { return "translate(" + 0 + "," + i * (calc.barHeight + attrs.barPadding) + ")"; });
	            //Each bar  rects
	            eachBarsContainer.patternify({ tag: 'rect', selector: 'bar', data: function (d) { return [d]; } })
	                .attr('fill', attrs.barFill)
	                .attr('height', calc.barHeight)
	                .attr('width', function (d) { return scales.barWidth(d.basepair); })
	                .attr('rx', calc.barHeight / 2.2);
	            //Each bar texts
	            eachBarsContainer.patternify({ tag: 'text', selector: 'bar-text', data: function (d) { return [d]; } })
	                .attr('fill', attrs.textFill)
	                .attr('x', -13)
	                .text(function (d) { return d.chr; })
	                .attr('text-anchor', 'middle')
	                .attr('alignment-baseline', 'middle')
	                .attr('font-size', 13)
	                .attr('y', calc.barHeight / 2 + 1);
	            // Centromede divider positioning
	            var dividerWrapper = eachDividersContainer.patternify({ tag: 'g', selector: 'divider-wrapper', data: function (d) { return [d]; } })
	                .attr('transform', function (d) {
	                var result = scales.barWidth(d.centromede * 1000000);
	                return "translate(" + result + ")";
	            });
	            //Centromede custom path creation - top path
	            dividerWrapper.patternify({ tag: 'path', selector: 'top-divider' })
	                .attr('d', function () {
	                var trHeight = calc.barHeight / 2 - 1;
	                var topWidth = calc.dividerWidth;
	                var bottomWidth = 1;
	                return "M 0 0 L " + topWidth + " 0 L " + (topWidth / 2 + bottomWidth / 2) + " " + trHeight + " L " + (topWidth / 2 - bottomWidth / 2) + " " + trHeight + " L 0 0";
	            })
	                .attr('fill', attrs.dividerFill)
	                .attr('stroke', attrs.dividerFill);
	            //Centromede custom path creation - bottom path
	            dividerWrapper.patternify({ tag: 'path', selector: 'bottom-divider' })
	                .attr('d', function () {
	                var trHeight = calc.barHeight / 2 - 1;
	                var topWidth = calc.dividerWidth;
	                var bottomWidth = 1;
	                return "M 0 " + (calc.barHeight + 0.5) + " l " + (topWidth / 2 - bottomWidth / 2) + " " + -trHeight + " l " + bottomWidth + "  0  l " + (topWidth / 2 - bottomWidth / 2) + " " + trHeight + " l  -" + topWidth + " 0";
	            })
	                .attr('fill', attrs.dividerFill)
	                .attr('stroke', attrs.dividerFill);
	            // #####################   Event handlers  ###################
	            // Range bar mouse enter handler
	            function rangeBarMouseEnter(d) {
	                // If range bar does not have tooltip defined, then we don't have to do anything here
	                if (!d.tooltip)
	                    return;
	                // Trying to optimize tooltip direction
	                var direction = 'bottom';
	                var y = d.y + calc.barHeight;
	                var x = d.x + d.width / 2;
	                var color = d3.hsl(d.color).darker(1);
	                var tooltipContent = d.tooltip;
	                if (x < 60) {
	                    direction = 'left';
	                    y -= calc.barHeight / 2;
	                    //x += 4;
	                }
	                if (x > calc.chartWidth - 60) {
	                    direction = 'right';
	                    y -= calc.barHeight / 2;
	                    //x -= 4;
	                }
	                // Show tooltip
	                tooltip
	                    .content(tooltipContent)
	                    .x(x)
	                    .y(y)
	                    .direction(direction)
	                    .textColor('white')
	                    .tooltipFill(color)
	                    .show(d);
	                // Making current rect darker
	                d3.select(this).style('fill', color);
	            }
	            // Range bar mouse leave handler
	            function rangeBarMouseLeave(d) {
	                // Return to previous state
	                tooltip.hide();
	                d3.select(this).style('fill', d.color);
	            }
	            // Smoothly handle data updating
	            updateData = function () {
	            };
	            drawBars = function (rangeBarsData) {
	                //Generate id for each bar
	                // Change ranges in case of expansion multiples
	                // Set some reusable properties
	                rangeBarsData.bars.forEach(function (d) {
	                    d.id = uuidv4();
	                    d.x = scales.rangeBarWidth(d.range[0]);
	                    d.y = (d.chr - 1) * (calc.barHeight + attrs.barPadding);
	                    d.width = scales.rangeBarWidth(d.range[1]) - scales.rangeBarWidth(d.range[0]);
	                    // don't go below a min width
	                    if (d.width < attrs.minWidth) {
	                        var newWidth = attrs.minWidth;
	                        var change = newWidth - d.width;
	                        d.width = newWidth;
	                        d.x -= (change / 2);
	                    }
	                    d.tooltip = rangeBarsData.tooltip;
	                });
	                // Append range bars
	                rangeBarsContainers.selectAll('.range-bars')
	                    .data(rangeBarsData.bars, function (d) { return d.id; })
	                    .enter()
	                    .append('rect')
	                    .attr('class', 'range-bars')
	                    .attr('height', calc.barHeight)
	                    .attr('width', function (d) { return d.width; })
	                    .attr('x', function (d) { return d.x; })
	                    .attr('fill', function (d) { return d.color; })
	                    .attr('y', function (d) { return d.y; })
	                    .on('mouseenter', rangeBarMouseEnter)
	                    .on('mouseleave', rangeBarMouseLeave);
	            };
	            // Generated GUID
	            //https://stackoverflow.com/a/2117523
	            function uuidv4() {
	                return "R" + Math.floor(Math.random() * 1000000);
	                //return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
	                //    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
	                //);
	            }
	            //#########################################  UTIL FUNCS ##################################
	        };
	        //----------- PROTOTYEPE FUNCTIONS  ----------------------
	        d3.selection.prototype.patternify = function (params) {
	            var container = this;
	            var selector = params.selector;
	            var elementTag = params.tag;
	            var data = params.data || [selector];
	            // Pattern in action
	            var selection = container.selectAll('.' + selector).data(data, function (d, i) {
	                /*eslint-disable angular/typecheck-object */
	                if (typeof d === "object") {
	                    if (d.id) {
	                        return d.id;
	                    }
	                }
	                /*eslint-enable angular/typecheck-object */
	                return i;
	            });
	            selection.exit().remove();
	            selection = selection.enter().append(elementTag).merge(selection);
	            selection.attr('class', selector);
	            return selection;
	        };
	        //Dynamic keys functions
	        Object.keys(attrs).forEach(function (key) {
	            // Attach variables to main function
	            return main[key] = function (_) {
	                var string = "attrs['" + key + "'] = _";
	                if (!arguments.length) {
	                    return eval(" attrs['" + key + "'];");
	                }
	                eval(string);
	                return main;
	            };
	        });
	        //Set attrs as property
	        main.attrs = attrs;
	        //Exposed update functions
	        main.data = function (value) {
	            if (!arguments.length)
	                return attrs.data;
	            attrs.data = value;
	            if (!!updateData) {
	                updateData();
	            }
	            return main;
	        };
	        // Run  visual
	        main.run = function (elem) {
	            main(elem);
	            return main;
	        };
	        main.drawBars = function (barsData) {
	            drawBars(barsData);
	        };
	        return main;
	    }
	    function getChromosomeData() {
	        return {
	            "chromosomes": [
	                {
	                    "chr": 1,
	                    "basepair": 248956422,
	                    "centromede": 125
	                },
	                {
	                    "chr": 2,
	                    "basepair": 242193529,
	                    "centromede": 93.3
	                },
	                {
	                    "chr": 3,
	                    "basepair": 198295559,
	                    "centromede": 91
	                },
	                {
	                    "chr": 4,
	                    "basepair": 190214555,
	                    "centromede": 50.4
	                },
	                {
	                    "chr": 5,
	                    "basepair": 181538259,
	                    "centromede": 48.4
	                },
	                {
	                    "chr": 6,
	                    "basepair": 170805979,
	                    "centromede": 61
	                },
	                {
	                    "chr": 7,
	                    "basepair": 159345973,
	                    "centromede": 59.9
	                },
	                {
	                    "chr": 8,
	                    "basepair": 145138636,
	                    "centromede": 45.6
	                },
	                {
	                    "chr": 9,
	                    "basepair": 138394717,
	                    "centromede": 49
	                },
	                {
	                    "chr": 10,
	                    "basepair": 133797422,
	                    "centromede": 40.2
	                },
	                {
	                    "chr": 11,
	                    "basepair": 135086622,
	                    "centromede": 53.7
	                },
	                {
	                    "chr": 12,
	                    "basepair": 133275309,
	                    "centromede": 35.8
	                },
	                {
	                    "chr": 13,
	                    "basepair": 114364328,
	                    "centromede": 17.9
	                },
	                {
	                    "chr": 14,
	                    "basepair": 107043718,
	                    "centromede": 17.6
	                },
	                {
	                    "chr": 15,
	                    "basepair": 101991189,
	                    "centromede": 19
	                },
	                {
	                    "chr": 16,
	                    "basepair": 90338345,
	                    "centromede": 36.6
	                },
	                {
	                    "chr": 17,
	                    "basepair": 83257441,
	                    "centromede": 24
	                },
	                {
	                    "chr": 18,
	                    "basepair": 80373285,
	                    "centromede": 17.2
	                },
	                {
	                    "chr": 19,
	                    "basepair": 58617616,
	                    "centromede": 26.5
	                },
	                {
	                    "chr": 20,
	                    "basepair": 64444167,
	                    "centromede": 27.5
	                },
	                {
	                    "chr": 21,
	                    "basepair": 46709983,
	                    "centromede": 13.2
	                },
	                {
	                    "chr": 22,
	                    "basepair": 50818468,
	                    "centromede": 14.7
	                },
	                {
	                    "chr": 'X',
	                    "basepair": 156040895,
	                    "centromede": 60.6
	                }
	            ]
	        };
	    }
	    function getGrayBarsData() {
	        //Adding Gray Bars
	        var greyBars = {
	            bars: [
	                {
	                    color: '#c2c2c2',
	                    chr: 1,
	                    range: [126897807.11077844, 140675283.31137726]
	                }, {
	                    color: '#c2c2c2',
	                    chr: 1,
	                    range: [144300934.94311377, 145026065.26946107]
	                }, {
	                    color: '#c2c2c2',
	                    chr: 9,
	                    range: [40629583.64397906, 45533154.083769634]
	                }, {
	                    color: '#c2c2c2',
	                    chr: 13,
	                    range: [4143627.793548387, 11049674.116129031]
	                }, {
	                    color: '#c2c2c2',
	                    chr: 14,
	                    range: [4834232.425806452, 11049674.116129031]
	                }, {
	                    color: '#c2c2c2',
	                    chr: 15,
	                    range: [4834232.425806452, 11049674.116129031]
	                }, {
	                    color: '#c2c2c2',
	                    chr: 16,
	                    range: [30386603.81935484, 32458417.71612903]
	                }, {
	                    color: '#c2c2c2',
	                    chr: 21,
	                    range: [4834232.425806452, 10359069.483870968]
	                }, {
	                    color: '#c2c2c2',
	                    chr: 22,
	                    range: [5389837.515151516, 11549651.818181818]
	                }
	            ]
	        };
	        return greyBars;
	    }
	    //
	    // setup
	    //
	    function setup(elem, data, height, width) {
	        //let e = $document[0].createElement('div');
	        //elem.appendChild(e);
	        if (width === 0 || height === 0) {
	            return;
	        }
	        var chromosomeData = getChromosomeData();
	        //Drawing chart
	        var chromosomeChart = renderChromosomeChart()
	            .createSvg(true)
	            .svgWidth(width)
	            .svgHeight(height)
	            .data(chromosomeData)
	            .run(elem);
	        // Draw Gray bars after main chart is drew
	        var greyBars = getGrayBarsData();
	        chromosomeChart.drawBars(greyBars);
	        // Draw Orange Bars
	        var tooltip = [
	            {
	                left: "cM: {cm}",
	                right: ""
	            }, {
	                left: "{startText}",
	                right: ""
	            }, {
	                left: " - {endText}",
	                right: ""
	            }
	        ];
	        chromosomeChart.drawBars({ tooltip: tooltip, bars: data });
	    }
	    function link(scope, elem) {
	        //$scope = scope;
	        width = elem[0].getBoundingClientRect().width;
	        height = width * 1.62;
	        scope.$watch('data', function () {
	            elem.empty();
	            setup(elem[0], scope.data, height, width);
	        });
	    }
	    return {
	        restrict: 'E',
	        link: link,
	        template: '<div></div>',
	        scope: {
	            data: '='
	        }
	    };
	}
	exports.default = rcD3ChromosomeDirective;


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";
	rcD3ForceDirective.$inject = ["$log", "$window", "$document", "$rootScope", "$timeout", "d3", "d3worker", "sidenav", "utils"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcD3ForceDirective($log, $window, $document, $rootScope, $timeout, d3, d3worker, sidenav, utils) {
	    'ngInject';
	    var resizeThreshold = 8;
	    var maxLinks = 25000; // don't allow clicks on links if >25k links
	    var $scope;
	    var height = 0;
	    var width = 0;
	    var main = null;
	    function renderForceChart() {
	        // Exposed variables
	        var attrs = {
	            id: "ID" + Math.floor(Math.random() * 1000000),
	            initialGravity: 0.025,
	            tickRatio: 1500,
	            svgWidth: 400,
	            svgHeight: 400,
	            marginTop: 0,
	            marginBottom: 0,
	            marginRight: 0,
	            marginLeft: 0,
	            linkStrokeWidth: 1,
	            linkStrokeOpacity: 0.2,
	            linkStrokeOpacityColored: 0.6,
	            linkStrokeHoverOpacity: 1.0,
	            nodeSmallSize: 20.0,
	            nodeMediumSize: 200.0,
	            nodeSmallRadius: 4,
	            nodeMediumRadius: 6,
	            nodeLargeRadius: 8,
	            nodeFontSize: 13,
	            nodeDefaultFill: '#2AB4C0',
	            nodeHoverFill: '#5E738B',
	            linkStroke: '#000',
	            nodeCircleStroke: '#2C3E50',
	            nodeCircleStrokeWidth: 5,
	            container: 'body',
	            lastTransform: { x: 1, y: 1, k: 1 },
	            selectedKitName: '',
	            selectedLink: null,
	            linkedKitNames: new Set(),
	            data: null
	        };
	        var extHandlers = {
	            onNodeClick: function () { return 0; },
	            onBrushEnd: function () { return 0; },
	            onNodesDeselection: function () { return 0; }
	        };
	        // worker
	        var worker = new Worker(d3worker.getForceBlobURL());
	        var deregZoom = null;
	        var deregExpand = null;
	        //InnerFunctions which will update visuals
	        var updateData;
	        var updateSelection;
	        //Main chart object
	        var main = function (elem) {
	            //Calculated properties
	            var calc = {};
	            calc.id = "ID" + Math.floor(Math.random() * 1000000); // id for event handlings
	            calc.chartLeftMargin = attrs.marginLeft;
	            calc.chartTopMargin = attrs.marginTop;
	            calc.chartWidth = attrs.svgWidth - attrs.marginRight - calc.chartLeftMargin;
	            calc.chartHeight = attrs.svgHeight - attrs.marginBottom - calc.chartTopMargin;
	            calc.nodesMap = {};
	            calc.extraTicksPerTick = attrs.data.nodes.length * Math.log(attrs.data.nodes.length) / attrs.tickRatio;
	            calc.gravity = attrs.initialGravity;
	            // Binding links and nodes
	            attrs.data.nodes.forEach(function (node) {
	                calc.nodesMap[node.id] = node;
	            });
	            //##################  BEHAVIORS  #####################
	            var behaviors = {};
	            behaviors.zoom = d3.zoom().on('zoom', zoomed);
	            behaviors.drag = d3.drag()
	                .on("start", nodeClicked);
	            //###################  BRUSHES  #######################
	            var brushes = {};
	            brushes.nodeSelector = d3.brush()
	                .extent([[0, 0], [calc.chartWidth, calc.chartHeight]])
	                .on("start", brushstarted)
	                .on("brush", brushed)
	                .on("end", brushended);
	            //##################  CONTAINERS  #####################
	            //Drawing containers
	            var container = d3.select(elem);
	            //Add svg
	            var svg = container.patternify({ tag: 'svg', selector: 'svg-chart-container' })
	                .attr('width', attrs.svgWidth)
	                .attr('height', attrs.svgHeight)
	                .call(behaviors.zoom);
	            deregZoom = $scope.$on('zoom', function (ev, params) {
	                behaviors.zoom.scaleBy(svg.transition().duration(200), params);
	            });
	            deregExpand = $scope.$on('expand', function (ev, params) {
	                calc.gravity *= params;
	                worker.postMessage({
	                    cmd: 'restart',
	                    attrs: {
	                        chartWidth: calc.chartWidth,
	                        chartHeight: calc.chartHeight,
	                        gravity: calc.gravity,
	                        alpha: 1,
	                        alphaTarget: 0,
	                        extraTicksPerTick: calc.extraTicksPerTick
	                    }
	                });
	            });
	            // Deselect nodes on background click
	            svg.patternify({ tag: 'rect', select: 'outside-click-handler-rect' })
	                .attr('width', attrs.svgWidth)
	                .attr('height', attrs.svgHeight)
	                .attr('fill', 'none')
	                .attr('pointer-events', 'all')
	                .on('click', backgrondClicked);
	            // Initialize tooltip
	            var tooltip = d3
	                .componentsTooltip()
	                .container(svg);
	            var showTooltip = function (d) {
	                var content = [], x = 0, y = 0;
	                if (!!d.name) {
	                    x = d.x;
	                    y = d.y;
	                    content = [{ left: '{_user}', right: '' }, { left: 'Matches {profileName}', right: 'Total {totalcm}' }];
	                }
	                else if (!!d.source && !!d.target) {
	                    x = (d.source_x + d.target_x) >>> 1; // jshint ignore:line
	                    y = (d.source_y + d.target_y) >>> 1; // jshint ignore:line
	                    content = [{ left: '{_user1}', right: '{_user2}' }];
	                }
	                if (content.length > 0) {
	                    d.matches.forEach(function (match, i) {
	                        content.push({ left: 'Chr {chr' + i + '}: {start' + i + '} - {end' + i + '}', right: 'cM {cm' + i + '}' });
	                        d['chr' + i] = match.chr === 23 ? 'X' : match.chr;
	                        d['start' + i] = numberWithCommas(match.start);
	                        d['end' + i] = numberWithCommas(match.end);
	                        d['cm' + i] = match.cm;
	                    });
	                    // adjust for zoom
	                    x = (x * attrs.lastTransform.k) + attrs.lastTransform.x;
	                    y = (y * attrs.lastTransform.k) + attrs.lastTransform.y;
	                    tooltip
	                        .content(content)
	                        .x(x > attrs.svgWidth / 2 ? x - 4 : x + 4)
	                        .y(y)
	                        .direction(x > attrs.svgWidth / 2 ? 'right' : 'left')
	                        .textColor('white')
	                        .tooltipFill('#488FC8')
	                        .show(d);
	                }
	            };
	            var numberWithCommas = function (x) {
	                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	            };
	            //Add container g element
	            var chart = svg.patternify({ tag: 'g', selector: 'chart' })
	                .attr('transform', 'translate(' + (calc.chartLeftMargin) + ',' + calc.chartTopMargin + ')');
	            // Brush wrapper
	            var brushWrapper = chart.patternify({ tag: 'g', selector: 'brush-wrapper' });
	            // Links wrapper
	            var linksWrapper = chart.patternify({ tag: 'g', selector: 'links-wrapper' });
	            //Nodes wrapper
	            var nodesWrapper = chart.patternify({ tag: 'g', selector: 'nodes-wrapper' });
	            //Links
	            var links = linksWrapper.patternify({ tag: 'line', selector: 'link', data: attrs.data.links })
	                .attr("stroke-width", function (d) { return linkStrokeWidth(d) / attrs.lastTransform.k; });
	            if (attrs.data.links.length < maxLinks) {
	                links = links
	                    .on('click', function (d) { return linkClicked(d); })
	                    .on('mouseenter', function (d) {
	                    d3.select(this).attr('stroke-opacity', attrs.linkStrokeHoverOpacity);
	                    showTooltip(d);
	                })
	                    .on('mouseleave', function () {
	                    d3.select(this).attr('stroke-opacity', function (d) { return linkStrokeOpacity(d); });
	                    tooltip.hide();
	                });
	            }
	            //Nodes
	            var nodes = nodesWrapper.patternify({ tag: 'g', selector: 'node', data: attrs.data.nodes })
	                .attr('cursor', 'pointer')
	                .call(behaviors.drag);
	            //Node circles
	            var nodeCircles = nodes.patternify({ tag: 'circle', selector: 'node-circle', data: function (d) { return [d]; } })
	                .attr('r', nodeSize)
	                .attr('stroke', attrs.nodeCircleStroke)
	                .on('mouseenter', function (d) {
	                var color = d3.hsl(d.color).darker(1);
	                d3.select(this).attr('fill', color);
	                showTooltip(d);
	            })
	                .on('mouseleave', function () {
	                d3.select(this).attr('fill', function (d) { return d.color; });
	                tooltip.hide();
	            });
	            // text
	            var nodeTexts = nodes
	                .append('text')
	                .attr("transform", "translate(4,0)")
	                .attr('font-size', attrs.nodeFontSize / attrs.lastTransform.k)
	                .attr('display', function (d) { return nodeTextDisplay(d); });
	            // Smoothly handle data updating
	            updateData = function () {
	                //Links
	                if (links) {
	                    links
	                        .attr('stroke', function (d) {
	                        if (d.sourceColor === attrs.nodeDefaultFill && d.targetColor === attrs.nodeDefaultFill) {
	                            return attrs.linkStroke;
	                        }
	                        else if (d.sourceColor === attrs.nodeDefaultFill) {
	                            return d.targetColor;
	                        }
	                        else if (d.targetColor === attrs.nodeDefaultFill) {
	                            return d.sourceColor;
	                        }
	                        else {
	                            return utils.averageColor([d.sourceColor, d.targetColor], attrs.linkStroke);
	                        }
	                    })
	                        .attr('stroke-opacity', function (d) { return linkStrokeOpacity(d); });
	                }
	                //Nodes
	                if (nodes) {
	                    nodeCircles
	                        .attr('fill', function (d) { return d.color; });
	                    nodeTexts
	                        .text(function (d) { return d._user; });
	                }
	            };
	            updateData();
	            worker.postMessage({
	                cmd: 'start',
	                attrs: {
	                    chartWidth: calc.chartWidth,
	                    chartHeight: calc.chartHeight,
	                    gravity: calc.gravity,
	                    alphaTarget: 0,
	                    extraTicksPerTick: calc.extraTicksPerTick,
	                },
	                nodes: attrs.data.nodes,
	                links: attrs.data.links
	            });
	            //Brush helper variables
	            var gBrush;
	            var brushing = false;
	            var shiftKey = false;
	            var brushMode = false;
	            var isDragging = false;
	            //#####################   EVENT BINDINGS   #####################
	            d3.select('body').on('keydown', keydown);
	            d3.select('body').on('keyup', keyup);
	            //########################################  EVENT HANDLER FUNCS ######################
	            var drag_handler = d3.drag()
	                .on("start", drag_start)
	                .on("drag", drag_drag)
	                .on("end", drag_end);
	            //same as using .call on the nodes variable as in https://bl.ocks.org/mbostock/4062045
	            drag_handler(nodes);
	            function drag_start(d) {
	                if (d.fx != null && d.fy != null) {
	                    delete d.fx;
	                    delete d.fy;
	                    d.dragging = false;
	                    worker.postMessage({
	                        cmd: 'restart',
	                        attrs: {
	                            chartWidth: calc.chartWidth,
	                            chartHeight: calc.chartHeight,
	                            gravity: calc.gravity,
	                            alpha: 1,
	                            alphaTarget: 0,
	                            extraTicksPerTick: calc.extraTicksPerTick,
	                        },
	                        nodes: [d]
	                    });
	                }
	                nodeClicked(d);
	            }
	            function drag_drag(d) {
	                d.fx = d3.event.x;
	                d.fy = d3.event.y;
	                d.dragging = true;
	                if (!isDragging) {
	                    worker.postMessage({
	                        cmd: 'restart',
	                        attrs: {
	                            chartWidth: calc.chartWidth,
	                            chartHeight: calc.chartHeight,
	                            gravity: calc.gravity,
	                            alpha: 1,
	                            alphaTarget: 2,
	                            extraTicksPerTick: calc.extraTicksPerTick / 4,
	                        },
	                        nodes: [d],
	                    });
	                    isDragging = true;
	                }
	                else {
	                    worker.postMessage({
	                        cmd: 'update',
	                        nodes: [d],
	                    });
	                }
	            }
	            function drag_end(d) {
	                if (d.dragging) {
	                    d.fx = d.x;
	                    d.fy = d.y;
	                    d.dragging = false;
	                    updateSelection();
	                }
	                if (isDragging) {
	                    worker.postMessage({
	                        cmd: 'update',
	                        attrs: {
	                            alphaTarget: 0,
	                            extraTicksPerTick: calc.extraTicksPerTick,
	                        },
	                        nodes: [d]
	                    });
	                    isDragging = false;
	                }
	            }
	            //Node click handler
	            function nodeClicked(d) {
	                var deselected = [];
	                var ctrlKey = false;
	                if (!(d3.event.sourceEvent.metaKey || d3.event.sourceEvent.ctrlKey)) {
	                    nodes.each(function (d) {
	                        if (d.selected) {
	                            deselected.push(d);
	                            d.selected = false;
	                        }
	                    });
	                    d.selected = true;
	                }
	                else {
	                    ctrlKey = true;
	                    d.selected = !d.selected;
	                }
	                updateSelection();
	                /*eslint-disable angular/typecheck-function */
	                if (typeof extHandlers.onNodesDeselection === 'function' && deselected.length > 0 && !(d.selected && !ctrlKey)) {
	                    extHandlers.onNodesDeselection(deselected, false);
	                }
	                if (typeof extHandlers.onNodeClick === 'function' && d.selected) {
	                    extHandlers.onNodeClick(d, ctrlKey);
	                }
	                else if (typeof extHandlers.onNodesDeselection === 'function' && !d.selected) {
	                    extHandlers.onNodesDeselection([d], false);
	                }
	                /*eslint-enable angular/typecheck-function */
	            }
	            // Zoom event handler
	            function zoomed() {
	                // Save lastTransform and apply translation and scaling
	                attrs.lastTransform = d3.event.transform;
	                chart.attr('transform', attrs.lastTransform);
	                nodes.select('circle')
	                    .attr('r', function (d) { return nodeSize(d) / attrs.lastTransform.k; })
	                    .classed('pulse', function (d) { return d.highlighted; })
	                    .attr('stroke-width', function (d) { return nodeStrokeWidth(d) / attrs.lastTransform.k; });
	                nodes.select('text')
	                    .attr('font-size', attrs.nodeFontSize / attrs.lastTransform.k);
	                links.attr('stroke-width', function (d) { return linkStrokeWidth(d) / attrs.lastTransform.k; });
	            }
	            //Tick event handler
	            worker.addEventListener('message', function (e) {
	                for (var i = 0; i < attrs.data.nodes.length; i++) {
	                    var node = attrs.data.nodes[i];
	                    var nodePosition = e.data.nodePositions[node.name];
	                    node.x = nodePosition[0];
	                    node.y = nodePosition[1];
	                    var len = nodePosition.length;
	                    node.fx = len > 2 ? nodePosition[2] : null;
	                    node.fy = len > 2 ? nodePosition[3] : null;
	                }
	                for (var i = 0; i < attrs.data.links.length; i++) {
	                    var link_1 = attrs.data.links[i];
	                    var sourcePosition = e.data.nodePositions[link_1.source];
	                    var targetPosition = e.data.nodePositions[link_1.target];
	                    link_1.source_x = sourcePosition[0];
	                    link_1.source_y = sourcePosition[1];
	                    link_1.target_x = targetPosition[0];
	                    link_1.target_y = targetPosition[1];
	                }
	                //Updating positions
	                links
	                    .attr("x1", function (d) { return d.source_x; })
	                    .attr("y1", function (d) { return d.source_y; })
	                    .attr("x2", function (d) { return d.target_x; })
	                    .attr("y2", function (d) { return d.target_y; });
	                nodes.attr("transform", function (d) {
	                    return "translate(" + d.x + "," + d.y + ")";
	                });
	            });
	            function keydown() {
	                shiftKey = d3.event.shiftKey;
	                if (shiftKey) {
	                    // if we already have a brush, don't do anything
	                    if (gBrush)
	                        return;
	                    brushMode = true;
	                    if (!gBrush) {
	                        gBrush = brushWrapper.append('g');
	                        gBrush.call(brushes.nodeSelector);
	                    }
	                }
	            }
	            //Keyup event handling
	            function keyup() {
	                shiftKey = false;
	                brushMode = false;
	                if (!gBrush)
	                    return;
	                if (!brushing) {
	                    // only remove the brush if we're not actively brushing
	                    // otherwise it'll be removed when the brushing ends
	                    gBrush.remove();
	                    gBrush = null;
	                }
	            }
	            // Brush started event handling
	            function brushstarted() {
	                // keep track of whether we're actively brushing so that we
	                // don't remove the brush on keyup in the middle of a selection
	                brushing = true;
	                nodes.each(function (d) {
	                    d.previouslySelected = shiftKey && d.selected;
	                });
	            }
	            // Brushed event handler
	            function brushed() {
	                if (!d3.event.sourceEvent)
	                    return;
	                if (!d3.event.selection)
	                    return;
	                var extent = d3.event.selection;
	                nodes.each(function (d) {
	                    return d.selected = d.previouslySelected ||
	                        (extent[0][0] <= d.x && d.x < extent[1][0]
	                            && extent[0][1] <= d.y && d.y < extent[1][1]);
	                });
	                updateSelection();
	            }
	            function backgrondClicked() {
	                nodes.each(function (d) {
	                    d.selected = false;
	                    d.previouslySelected = false;
	                });
	                updateSelection();
	                extHandlers.onNodesDeselection([], true);
	            }
	            //Brush ended event handler
	            function brushended() {
	                //   debugger;
	                if (!d3.event.sourceEvent)
	                    return;
	                if (!d3.event.selection)
	                    return;
	                if (!gBrush)
	                    return;
	                gBrush.call(brushes.nodeSelector.move, null);
	                if (!brushMode) {
	                    // the shift key has been release before we ended our brushing
	                    gBrush.remove();
	                    gBrush = null;
	                }
	                brushing = false;
	                var result = [];
	                nodes.each(function (d) {
	                    if (d.selected) {
	                        result.push(d);
	                    }
	                });
	                extHandlers.onBrushEnd(result);
	            }
	            //#########################################  UTIL FUNCS ##################################
	            function nodeSize(d) {
	                return d.totalcm === 0 ? attrs.nodeMediumRadius : d.totalcm < attrs.nodeSmallSize ? attrs.nodeSmallRadius : d.totalcm < attrs.nodeMediumSize ? attrs.nodeMediumRadius : attrs.nodeLargeRadius;
	            }
	            function nodeStrokeWidth(d) {
	                return (d.selected ? 3 : d.fx || d.fy ? 2 : 1) * attrs.nodeCircleStrokeWidth;
	            }
	            function nodeTextDisplay(d) {
	                return attrs.linkedKitNames.has(d.name) ? 'block' : 'none';
	            }
	            function linkStrokeWidth(d) {
	                return d.kit1 === attrs.selectedKitName || d.kit2 === attrs.selectedKitName || d.kit1 + d.kit2 === attrs.selectedLink ? attrs.linkStrokeWidth * 1.5 : attrs.linkStrokeWidth;
	            }
	            function linkStrokeOpacity(d) {
	                if (d.kit1 === attrs.selectedKitName || d.kit2 === attrs.selectedKitName || d.kit1 + d.kit2 === attrs.selectedLink) {
	                    return attrs.linkStrokeHoverOpacity;
	                }
	                return d.sourceColor === attrs.nodeDefaultFill && d.targetColor === attrs.nodeDefaultFill ? attrs.linkStrokeOpacity : attrs.linkStrokeOpacityColored;
	            }
	            function linkClicked(d) {
	                backgrondClicked();
	                attrs.linkedKitNames = new Set([d.kit1, d.kit2]);
	                attrs.selectedLink = d.kit1 + d.kit2;
	                // set attributes
	                links
	                    .attr("stroke-width", function (d) { return linkStrokeWidth(d) / attrs.lastTransform.k; })
	                    .attr('stroke-opacity', function (d) { return linkStrokeOpacity(d); });
	                nodes.select('text')
	                    .attr('display', function (d) { return nodeTextDisplay(d); });
	            }
	            updateSelection = function () {
	                var selectedNode = null;
	                var count = 0;
	                nodes.each(function (d) {
	                    if (d.selected) {
	                        selectedNode = d;
	                        count++;
	                    }
	                });
	                attrs.selectedKitName = (count === 1 ? selectedNode.name : '');
	                attrs.linkedKitNames = new Set();
	                attrs.selectedLink = null;
	                if (count === 1) {
	                    links.each(function (l) {
	                        if (l.kit1 === attrs.selectedKitName) {
	                            attrs.linkedKitNames.add(l.kit2);
	                        }
	                        else if (l.kit2 === attrs.selectedKitName) {
	                            attrs.linkedKitNames.add(l.kit1);
	                        }
	                    });
	                }
	                // set link attributes
	                links
	                    .attr("stroke-width", function (d) { return linkStrokeWidth(d) / attrs.lastTransform.k; })
	                    .attr('stroke-opacity', function (d) { return linkStrokeOpacity(d); });
	                // set node attributes
	                nodes.select('circle')
	                    .classed('pulse', function (d) { return d.highlighted; })
	                    .attr('stroke-width', function (d) { return nodeStrokeWidth(d) / attrs.lastTransform.k; });
	                nodes.select('text')
	                    .attr('display', function (d) { return nodeTextDisplay(d); });
	            };
	        };
	        //----------- PROTOTYEPE FUNCTIONS  ----------------------
	        d3.selection.prototype.patternify = function (params) {
	            var container = this;
	            var selector = params.selector;
	            var elementTag = params.tag;
	            var data = params.data || [selector];
	            // Pattern in action
	            var selection = container.selectAll('.' + selector).data(data, function (d, i) {
	                if (typeof d === "object") {
	                    if (d.id) {
	                        return d.id;
	                    }
	                }
	                return i;
	            });
	            selection.exit().remove();
	            selection = selection.enter().append(elementTag).merge(selection);
	            selection.attr('class', selector);
	            return selection;
	        };
	        //Dynamic keys functions
	        Object.keys(attrs).forEach(function (key) {
	            // Attach variables to main function
	            return main[key] = function (_) {
	                var string = "attrs['" + key + "'] = _";
	                if (!arguments.length) {
	                    return eval(" attrs['" + key + "'];");
	                }
	                eval(string);
	                return main;
	            };
	        });
	        //Set attrs as property
	        main.attrs = attrs;
	        //Exposed update functions
	        main.data = function (value) {
	            if (!arguments.length)
	                return attrs.data;
	            if (!attrs.data) {
	                attrs.data = value;
	            }
	            else {
	                var nodeMap_1 = new Map(value.nodes.map(function (n) { return [n.name, n]; }));
	                attrs.data.nodes.forEach(function (node) {
	                    var newNode = nodeMap_1.get(node.name) || node;
	                    node.color = newNode.color;
	                    node._user = newNode._user;
	                });
	                var linkMap_1 = new Map(value.links.map(function (l) { return [l.kit1 + '|' + l.kit2, l]; }));
	                attrs.data.links.forEach(function (link) {
	                    var newLink = linkMap_1.get(link.kit1 + '|' + link.kit2) || link;
	                    link.sourceColor = newLink.sourceColor;
	                    link.targetColor = newLink.targetColor;
	                });
	            }
	            if (typeof updateData === 'function') {
	                updateData();
	            }
	            return main;
	        };
	        main.highlight = function (highlighted) {
	            attrs.data.nodes.forEach(function (d) {
	                d.highlighted = highlighted(d);
	            });
	            if (!!updateSelection) {
	                updateSelection();
	            }
	            return main;
	        };
	        main.onNodeClick = function (nodeClickHandler) {
	            if (!arguments.length)
	                return attrs.data;
	            extHandlers.onNodeClick = nodeClickHandler;
	            return main;
	        };
	        main.onBrushEnd = function (brushEndHandler) {
	            if (!arguments.length)
	                return attrs.data;
	            extHandlers.onBrushEnd = brushEndHandler;
	            return main;
	        };
	        main.onNodesDeselection = function (nodeDeselectionHandler) {
	            if (!arguments.length)
	                return attrs.data;
	            extHandlers.onNodesDeselection = nodeDeselectionHandler;
	            return main;
	        };
	        // Run  visual
	        main.run = function (elem) {
	            main(elem);
	            return main;
	        };
	        main.terminate = function () {
	            if (!!worker) {
	                worker.terminate();
	                worker = null;
	            }
	            if (!!deregZoom) {
	                deregZoom();
	                deregZoom = null;
	            }
	            if (!!deregExpand) {
	                deregExpand();
	                deregExpand = null;
	            }
	        };
	        return main;
	    }
	    //
	    // setup
	    //
	    function setup(elem, nodes, links, defaultColor, height, width) {
	        var e = $document[0].createElement('div');
	        e.id = 'd3force';
	        elem.appendChild(e);
	        if (width === 0 || height === 0 || !nodes || !links) {
	            return;
	        }
	        main = renderForceChart()
	            .svgHeight(height)
	            .svgWidth(width)
	            .linkStrokeWidth(5)
	            .nodeSmallRadius(4)
	            .nodeMediumRadius(6)
	            .nodeLargeRadius(9)
	            .nodeDefaultFill(defaultColor)
	            .nodeCircleStroke('#000')
	            .nodeCircleStrokeWidth(1)
	            .container('d3force')
	            .data({ nodes: nodes, links: links })
	            .onNodeClick(function (d, ctrlKey) {
	            $timeout(function () {
	                $scope.$emit('show', { add: ctrlKey, nodes: [d], event: d3.event });
	            }, 0);
	        })
	            .onBrushEnd(function (arr) {
	            $timeout(function () {
	                $scope.$emit('show', { nodes: arr, event: d3.event });
	            }, 0);
	        })
	            .onNodesDeselection(function (arr, removeAll) {
	            $timeout(function () {
	                $scope.$emit('show', { remove: true, removeAll: removeAll, nodes: arr, event: d3.event });
	            }, 0);
	        })
	            .run(elem);
	        //function click(d) {
	        //  d3.selectAll(".sankey__group")
	        //    .attr("stroke-width", function(node) { return node === d ? 3 : 1; });
	        //
	        //  $scope.$apply(() => {
	        //    $scope.$emit('click', {node: d, event: d3.event});
	        //  });
	        //}
	        //
	        //function mouseEnter(d) {
	        //  let content = d.level === 1 ? [{left: 'Chromosome {chr}', right: ''}, {left: '0 - {value}', right: ''}] :
	        //    [{left: 'Chromosome {chr}', right: 'Kits {numItems}'}, {left: '{start} - {end}', right: ''}];
	        //  tooltip
	        //    .content(content)
	        //    .x((d.x0 + d.x1) >>> 1) // jshint ignore:line
	        //    .y((d.y0 + d.y1) >>> 1) // jshint ignore:line
	        //    .direction(d.x1 > width - 200 ? 'right' : 'left')
	        //    .textColor('white')
	        //    .tooltipFill('#488FC8')
	        //    .show(d);
	        //}
	        //
	        //function mouseLeave() {
	        //  tooltip.hide();
	        //}
	        $timeout(function () {
	            $rootScope.$broadcast('resetHeight');
	        }, 0);
	    }
	    function link(scope, elem) {
	        var nodeCount = 0;
	        var linkCount = 0;
	        $scope = scope;
	        function reset() {
	            // delete svg
	            elem.empty();
	            // terminate worker
	            if (!!main) {
	                main.terminate();
	            }
	        }
	        function resize() {
	            var h = $window.innerHeight - elem[0].getBoundingClientRect().top - 8;
	            var w = elem[0].getBoundingClientRect().width;
	            if (width === 0 || Math.abs(width - w) >= resizeThreshold || height === 0 || Math.abs(height - h) >= resizeThreshold) {
	                height = h;
	                width = w;
	                reset();
	                // start over
	                setup(elem[0], scope.nodes, scope.links, scope.defaultColor, height, width);
	                highlight();
	            }
	        }
	        angular.element($window).on('resize', resize);
	        elem.on('$destroy', function () {
	            angular.element($window).off('resize', resize);
	            reset();
	        });
	        scope.$watchGroup(['nodes', 'links'], function () {
	            if (!scope.nodes || scope.nodes.length !== nodeCount || !scope.links || scope.links.length !== linkCount) {
	                reset();
	                // give a bit of time for garbage collection
	                $timeout(function () {
	                    // start over
	                    setup(elem[0], scope.nodes, scope.links, scope.defaultColor, height, width);
	                    highlight();
	                    nodeCount = !!scope.nodes ? scope.nodes.length : 0;
	                    linkCount = !!scope.links ? scope.links.length : 0;
	                }, 100);
	            }
	            else if (!!main) {
	                main.data({ nodes: scope.nodes, links: scope.links });
	                highlight();
	            }
	        });
	        scope.$watch('highlighted', function () {
	            highlight();
	        });
	        function highlight() {
	            var s = new Set(scope.highlighted);
	            if (!!main) {
	                main.highlight(function (d) {
	                    return s.has(d.name);
	                });
	            }
	        }
	        scope.$watch(function () { return sidenav.isLockedOpen(); }, function () { $timeout(resize, 1000); });
	    }
	    return {
	        restrict: 'E',
	        link: link,
	        scope: {
	            nodes: '=',
	            links: '=',
	            defaultColor: '=',
	            highlighted: '='
	        }
	    };
	}
	exports.default = rcD3ForceDirective;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	"use strict";
	rcD3HebDirective.$inject = ["$window", "$document", "$rootScope", "$timeout", "d3", "sidenav", "utils"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcD3HebDirective($window, $document, $rootScope, $timeout, d3, sidenav, utils) {
	    'ngInject';
	    var resizeThreshold = 8;
	    var innerRadiusRatio = .85;
	    var fontSizeRatio = 5;
	    var circleSize = 3;
	    var nodeSmallSize = 20.0;
	    var nodeMediumSize = 200.0;
	    var linkStrokeWidth = 2;
	    var linkOpacity = 0.6;
	    var linkDefaultColor = '#666666';
	    var $scope;
	    var height = 0;
	    var width = 0;
	    var chart = null;
	    var HebChart = /** @class */ (function () {
	        function HebChart(opts) {
	            this.opts = opts;
	            this.container = null;
	            this.svg = null;
	            this.nodes = null;
	            this.links = null;
	            this.nodeFontSizeBase = 0;
	            this.lastTransform = { x: 0, y: 0, k: 1 };
	            this.selected = null;
	        }
	        HebChart.prototype.render = function (elem) {
	            var _this = this;
	            this.linksCm = new Map();
	            this.opts.links.forEach(function (l) {
	                _this.linksCm.set(l.kit1 + l.kit2, l.sum);
	                _this.linksCm.set(l.kit2 + l.kit1, l.sum);
	            });
	            var diameter = Math.min(this.opts.width, this.opts.height), radius = diameter / 2, innerRadius = radius * innerRadiusRatio;
	            this.nodeFontSizeBase = Math.min(16, radius * fontSizeRatio / (this.opts.nodes.length + 10));
	            var cluster = d3.cluster()
	                .size([360, innerRadius]);
	            var line = d3.radialLine()
	                .curve(d3.curveBundle.beta(0.7))
	                .radius(function (d) { return d.y; })
	                .angle(function (d) { return d.x / 180 * Math.PI; });
	            var behaviors = {};
	            behaviors.zoom = d3.zoom()
	                .on('zoom', this.zoomed.bind(this));
	            this.container = d3.select(elem)
	                .call(behaviors.zoom)
	                .attr('pointer-events', 'all')
	                .on('click', function () {
	                _this.deselect();
	            });
	            this.svg = this.container.append("svg")
	                .attr("width", this.opts.width)
	                .attr("height", this.opts.height)
	                .append("g")
	                .attr("transform", "translate(" + this.opts.width / 2 + "," + this.opts.height / 2 + ")");
	            this.deregZoom = $scope.$on('zoom', function (ev, params) {
	                behaviors.zoom.scaleBy(_this.container.transition().duration(200), params);
	            });
	            this.links = this.svg.append("g").selectAll(".link");
	            this.nodes = this.svg.append("g").selectAll(".node");
	            this.root = d3.hierarchy(this.opts.tree)
	                .sum(function (d) {
	                return d.totalcm || 1;
	            });
	            cluster(this.root);
	            this.links = this.links
	                .data(this.constructPaths(this.root.leaves(), this.opts.links))
	                .enter().append("path")
	                .each(function (d) {
	                d.source = d[0];
	                d.target = d[d.length - 1];
	            })
	                .attr("class", "dna-profile-heb__link")
	                .attr('stroke-width', 1)
	                .attr("d", line);
	            this.nodes = this.nodes
	                .data(this.root.leaves())
	                .enter()
	                .append("g")
	                .attr("class", "dna-profile-heb__node")
	                .attr('cursor', 'pointer')
	                .attr("transform", function (d) {
	                return "rotate(" + (d.x - 90) + ")translate(" + (d.x < 180 ? ((d.y + 2) + ",-1.5)") : ((d.y + 5) + ",1.5)rotate(180)"));
	            })
	                .on("mouseover", function (d) { return _this.mouseovered(d); })
	                .on("mouseout", function (d) { return _this.mouseouted(d); })
	                .on('click', function (d) { return _this.clicked(d); });
	            this.nodeCircles = this.nodes
	                .append("rect")
	                .attr('height', function () { return circleSize / _this.lastTransform.k; })
	                .attr('width', function () { return circleSize / _this.lastTransform.k; });
	            this.nodeTexts = this.nodes
	                .append("text")
	                .attr("dy", 2.5)
	                .attr("dx", function (d) { return d.x < 180 ? 5 : -2; })
	                .attr("text-anchor", function (d) { return d.x < 180 ? "start" : "end"; })
	                .attr('font-size', function (d) { return _this.nodeFontSize(d) / _this.lastTransform.k; });
	            this.updateData();
	            // set initial translate
	            this.container
	                .call(behaviors.zoom.transform, d3.zoomIdentity.translate(this.opts.width / 2, this.opts.height / 2).scale(1));
	        };
	        HebChart.prototype.updateData = function (nodes) {
	            var _this = this;
	            if (nodes === void 0) { nodes = null; }
	            if (!!nodes) {
	                var nodeMap_1 = new Map(nodes.map(function (n) { return [n.name, n]; }));
	                this.opts.nodes.forEach(function (node) {
	                    var newNode = nodeMap_1.get(node.name) || node;
	                    node.color = newNode.color;
	                    node._user = newNode._user;
	                });
	                this.root.leaves().forEach(function (leaf) {
	                    var newNode = nodeMap_1.get(leaf.data.name);
	                    if (newNode) {
	                        leaf.data.color = newNode.color;
	                        leaf.data._user = newNode._user;
	                    }
	                });
	            }
	            this.nodeCircles
	                .attr('fill', function (d) { return d.data.color; });
	            this.nodeTexts
	                .text(function (d) { return _this.nodeText(d, null); });
	            this.links
	                .attr('stroke', function (d) {
	                if (d.source.data.color === _this.opts.defaultColor && d.target.data.color === _this.opts.defaultColor) {
	                    return linkDefaultColor;
	                }
	                else if (d.source.data.color === _this.opts.defaultColor) {
	                    return d.target.data.color;
	                }
	                else if (d.target.data.color === _this.opts.defaultColor) {
	                    return d.source.data.color;
	                }
	                else {
	                    return utils.averageColor([d.source.data.color, d.target.data.color], linkDefaultColor);
	                }
	            });
	        };
	        HebChart.prototype.zoomed = function () {
	            var _this = this;
	            // Save lastTransform and apply translation and scaling
	            this.lastTransform = d3.event.transform;
	            this.svg.attr('transform', this.lastTransform);
	            //nodes.select('circle')
	            //  .attr('r', d => nodeSize(d) / attrs.lastTransform.k)
	            //  .classed('pulse', d => d.highlighted)
	            //  .attr('stroke-width', d => nodeStrokeWidth(d) / attrs.lastTransform.k);
	            this.nodeTexts.select('text')
	                .attr('font-size', function (d) { return _this.nodeFontSize(d) / _this.lastTransform.k; });
	            //this.nodeCircles.select('circle')
	            //  .attr('r', () => circleSize / this.lastTransform.k);
	            this.nodeCircles.select('rect')
	                .attr('height', function () { return circleSize / _this.lastTransform.k; })
	                .attr('width', function () { return circleSize / _this.lastTransform.k; });
	            this.links
	                .attr('opacity', linkOpacity)
	                .attr('stroke-width', linkStrokeWidth / this.lastTransform.k);
	        };
	        HebChart.prototype.nodeText = function (d, linkedNode) {
	            var linkCm = !!linkedNode && this.linksCm.has(d.data.name + linkedNode.data.name) ? this.linksCm.get(d.data.name + linkedNode.data.name) : '';
	            return d.x < 180 ?
	                (!!linkCm ? linkCm + ' - ' : '') + d.data._user + (d.data.totalcm ? ' ' + d.data.totalcm : '') :
	                (d.data.totalcm ? d.data.totalcm + ' ' : '') + d.data._user + (!!linkCm ? ' - ' + linkCm : '');
	        };
	        HebChart.prototype.nodeFontSize = function (d) {
	            var multiplier = d.data.totalcm < nodeSmallSize ? 0.6 : d.data.totalcm < nodeMediumSize ? 0.8 : 1;
	            return this.nodeFontSizeBase * multiplier;
	        };
	        HebChart.prototype.clicked = function (d) {
	            if (this.selected === d) {
	                this.deselect();
	            }
	            else {
	                this.selected = d;
	                this.select(d);
	                d3.event.stopPropagation();
	                $timeout(function () {
	                    $scope.$emit('show', { add: false, nodes: [d.data], event: d3.event });
	                }, 0);
	            }
	        };
	        HebChart.prototype.mouseovered = function (d) {
	            if (!this.selected) {
	                this.select(d);
	            }
	        };
	        HebChart.prototype.select = function (d) {
	            var _this = this;
	            this.nodeTexts
	                .each(function (n) { n.highlight = n === d; });
	            this.links
	                .attr('opacity', function (l) { return l.target === d || l.source === d ? 1 : linkOpacity; })
	                .attr('stroke-width', function (l) {
	                var multiplier = 1;
	                if (l.target === d || l.source === d) {
	                    l.source.highlight = true;
	                    l.target.highlight = true;
	                    multiplier = 2;
	                }
	                return linkStrokeWidth * multiplier / _this.lastTransform.k;
	            })
	                .filter(function (l) { return l.target === d || l.source === d; })
	                .raise();
	            this.nodeTexts
	                .classed('dna-profile-heb__node-select', function (n) { return n === d; })
	                .classed("dna-profile-heb__node-highlight", function (n) { return n.highlight; })
	                .text(function (n) { return _this.nodeText(n, n.highlight && n !== d ? d : null); });
	        };
	        HebChart.prototype.mouseouted = function () {
	            if (!this.selected) {
	                this.deselect();
	            }
	        };
	        HebChart.prototype.deselect = function () {
	            var _this = this;
	            if (this.selected) {
	                this.selected = null;
	                $timeout(function () {
	                    $scope.$emit('show', { add: false, nodes: [], event: d3.event });
	                }, 0);
	            }
	            this.links
	                .attr('opacity', linkOpacity)
	                .attr('stroke-width', linkStrokeWidth / this.lastTransform.k);
	            this.nodeTexts
	                .classed("dna-profile-heb__node-select", false)
	                .classed("dna-profile-heb__node-highlight", false)
	                .text(function (d) {
	                d.highlight = false;
	                return _this.nodeText(d, null);
	            });
	        };
	        HebChart.prototype.constructPaths = function (nodes, links) {
	            var nodeMap = new Map(nodes.map(function (n) { return [n.data.name, n]; }));
	            return links.map(function (l) {
	                return nodeMap.get(l.kit1).path(nodeMap.get(l.kit2));
	            });
	        };
	        HebChart.prototype.highlight = function (fn) {
	            this.nodeTexts.classed('pulse', fn);
	        };
	        HebChart.prototype.destroy = function () {
	            if (!!this.deregZoom) {
	                this.deregZoom();
	                this.deregZoom = null;
	            }
	        };
	        return HebChart;
	    }());
	    //
	    // setup
	    //
	    function setup(elem, tree, nodes, links, defaultColor, height, width) {
	        var e = $document[0].createElement('div');
	        e.id = 'd3heb';
	        elem.appendChild(e);
	        if (width === 0 || height === 0 || !tree || !nodes || !links || nodes.length === 0) {
	            return;
	        }
	        // construct chart
	        chart = new HebChart({
	            height: height,
	            width: width,
	            tree: tree,
	            nodes: nodes,
	            links: links,
	            defaultColor: defaultColor,
	        });
	        // render chart
	        chart.render(elem);
	        $timeout(function () {
	            $rootScope.$broadcast('resetHeight');
	        }, 0);
	    }
	    function link(scope, elem) {
	        var nodeCount = 0;
	        var linkCount = 0;
	        $scope = scope;
	        function reset() {
	            // delete svg
	            elem.empty();
	            // clean up
	            if (!!chart) {
	                chart.destroy();
	                chart = null;
	            }
	        }
	        function resize() {
	            var h = $window.innerHeight - elem[0].getBoundingClientRect().top - 8;
	            var w = elem[0].getBoundingClientRect().width;
	            if (width === 0 || Math.abs(width - w) >= resizeThreshold || height === 0 || Math.abs(height - h) >= resizeThreshold) {
	                height = h;
	                width = w;
	                reset();
	                // start over
	                setup(elem[0], scope.tree, scope.nodes, scope.links, scope.defaultColor, height, width);
	                highlight();
	            }
	        }
	        angular.element($window).on('resize', resize);
	        elem.on('$destroy', function () {
	            angular.element($window).off('resize', resize);
	        });
	        scope.$watchGroup(['tree', 'nodes', 'links'], function () {
	            if (!scope.nodes || scope.nodes.length !== nodeCount || !scope.links || scope.links.length !== linkCount) {
	                reset();
	                // give a bit of time for garbage collection
	                $timeout(function () {
	                    setup(elem[0], scope.tree, scope.nodes, scope.links, scope.defaultColor, height, width);
	                    highlight();
	                    nodeCount = !!scope.nodes ? scope.nodes.length : 0;
	                    linkCount = !!scope.links ? scope.links.length : 0;
	                }, 100);
	            }
	            else if (!!chart) {
	                chart.updateData(scope.nodes);
	            }
	        });
	        scope.$watch('highlighted', function () {
	            highlight();
	        });
	        function highlight() {
	            var s = new Set(scope.highlighted);
	            if (!!chart) {
	                chart.highlight(function (d) {
	                    return s.has(d.data.name);
	                });
	            }
	        }
	        scope.$watch(function () { return sidenav.isLockedOpen(); }, function () { $timeout(resize, 1000); });
	    }
	    return {
	        restrict: 'E',
	        link: link,
	        scope: {
	            tree: '=',
	            nodes: '=',
	            links: '=',
	            defaultColor: '=',
	            highlighted: '='
	        }
	    };
	}
	exports.default = rcD3HebDirective;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	"use strict";
	rcD3SankeyDirective.$inject = ["$log", "$window", "$rootScope", "$timeout", "d3", "sidenav"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcD3SankeyDirective($log, $window, $rootScope, $timeout, d3, sidenav) {
	    'ngInject';
	    var resizeThreshold = 8;
	    var minWidth = 40;
	    var maxValue = 248956422;
	    var nodeWidth = 40;
	    var nodeCircleStroke = '#2C3E50';
	    var maxCircleRadius = 10;
	    var circleRadiusReduction = 0.75;
	    function link(scope, elem) {
	        var $scope = scope;
	        var svg = null;
	        var rect = null;
	        var main = null;
	        function _setup(elem, data) {
	            var width = Math.max(minWidth, rect.width * (data.nodes.length > 0 ? data.nodes[0].value : maxValue) / maxValue);
	            var height = d3.max(data.nodes, function (d) { return d.level * nodeWidth * 1.5; });
	            svg = d3.select(elem).append("svg")
	                .attr("width", width)
	                .attr("height", height);
	            //Initialize tooltip
	            var tooltip = d3
	                .componentsTooltip({ tooltipRowHeight: nodeWidth / 2 + 2 })
	                .container(svg);
	            //var formatNumber = d3.format(",.0f");
	            //var format = function(d) { console.log('format', d); return formatNumber(d) + " TWh"; };
	            //var color = d3.scaleOrdinal(d3.schemeCategory10);
	            var sankey = d3.sankey()
	                .nodeAlign(d3.sankeyLeft)
	                .nodeWidth(nodeWidth)
	                .nodePadding(0)
	                .extent([[1, 1], [height - 1, width - 1]]);
	            var path = d3.sankeyLinkHorizontal();
	            var link = svg.append("g")
	                .attr("class", "links")
	                .attr("fill", "none")
	                .attr("stroke", "#000")
	                .attr("stroke-opacity", 0.2)
	                .selectAll("path");
	            var node = svg.append("g")
	                .attr("class", "nodes")
	                .attr("font-family", "sans-serif")
	                .attr("font-size", 10)
	                .selectAll("g");
	            sankey(data);
	            svg.attr('height', d3.max(data.nodes, function (d) { return d.x1; }) + 6);
	            svg.attr('width', Math.max(minWidth, rect.width));
	            link = link
	                .data(data.links)
	                .enter().append("path")
	                .attr("d", function (d) { return rotatePath(path(d)); })
	                .attr("stroke-width", function (d) {
	                return Math.max(1, d.width);
	            });
	            //link.append("title")
	            //  .text(function(d) { return d.source.name + " → " + d.target.name + "\n" + format(d.value); });
	            node = node
	                .data(data.nodes)
	                .enter().append("g")
	                .classed("sankey__group", true)
	                .attr('cursor', 'pointer')
	                .on('mouseenter', mouseEnter)
	                .on('mouseleave', mouseLeave)
	                .on("click", click);
	            var rects = node.append("rect")
	                .attr("x", function (d) {
	                return d.y0;
	            })
	                .attr("y", function (d) {
	                return d.x0;
	            })
	                .attr("height", function (d) {
	                return d.x1 - d.x0;
	            })
	                .attr("width", function (d) {
	                return d.y1 - d.y0;
	            })
	                .attr("fill", function (d) { return d.color; })
	                .attr("stroke", "#000");
	            // add circles
	            data.nodes.filter(function (node) { return node.items.length > 0; }).forEach(function (node) {
	                var width = node.y1 - node.y0;
	                var height = node.x1 - node.x0;
	                var r = Math.max(2, Math.min((width - 2) / 2, maxCircleRadius, Math.round(Math.sqrt((width - 2) * (height - 2) / node.items.length) / 2.0 * circleRadiusReduction)));
	                var x = 1;
	                var y = 1;
	                node.items.forEach(function (item) {
	                    item.r = r;
	                    item.cx = x + node.y0 + r;
	                    item.cy = y + node.x0 + r;
	                    x += 2 * r;
	                    if (x + 2 * r > width) {
	                        x = 1;
	                        y += 2 * r;
	                    }
	                });
	            });
	            node.selectAll('circle')
	                .data(function (d) { return d.items; })
	                .enter().append('circle')
	                .attr('cx', function (d) { return d.cx; })
	                .attr('cy', function (d) { return d.cy; })
	                .attr('r', function (d) { return d.r; })
	                .attr('stroke', nodeCircleStroke)
	                .attr('stroke-width', 1)
	                .attr('fill', function (d) { return d.color; });
	            //Array.from({length: maxColors}, (v, i) => i).forEach(i => {
	            //  node.append("rect")
	            //    .attr("x", function (d) {
	            //      return d.y0;
	            //    })
	            //    .attr("y", function (d) {
	            //      return d.x0 + i * colorWidth;
	            //    })
	            //    .attr("width", function (d) {
	            //      return d.y1 - d.y0;
	            //    })
	            //    .attr("height", function () {
	            //      return colorWidth;
	            //    })
	            //    .attr("stroke-width", 0)
	            //    .attr("fill", function (d) {
	            //      return d.colors[i];
	            //    });
	            //});
	            //node.append("text")
	            //  .attr("x", function(d) { return d.x0 - 6; })
	            //  .attr("y", function(d) { return (d.y1 + d.y0) / 2; })
	            //  .attr("dy", "0.35em")
	            //  .attr("text-anchor", "end")
	            //  .text(function(d) { return d.name; })
	            //  .filter(function(d) { return d.x0 < width / 2; })
	            //  .attr("x", function(d) { return d.x1 + 6; })
	            //  .attr("text-anchor", "start");
	            node.append('text')
	                .filter(function (d) { return !!d.name; })
	                .attr('x', 24)
	                .attr('y', function (d) { return (d.x0 + d.x1) / 2 + 6; })
	                .attr('font-size', 16)
	                .text(function (d) { return d.name; });
	            //node.append("title")
	            //  .text(function(d) { return d.name; });
	            update();
	            function update() {
	                rects
	                    .classed('pulse-stroke', function (d) { return d.highlighted; });
	            }
	            function rotatePath(p) {
	                var parts = p.substr(1).split('C');
	                var mParts = parts[0].split(',');
	                var cParts = parts[1].split(',');
	                var path = ['M', mParts[1], ',', mParts[0], 'C', cParts[1], ',', cParts[0], ',', cParts[3], ',', cParts[2], ',', cParts[5], ',', cParts[4]].join('');
	                return path;
	            }
	            function click(d) {
	                d3.selectAll(".sankey__group")
	                    .attr("stroke-width", function (node) {
	                    return node === d ? 3 : 1;
	                });
	                $scope.$apply(function () {
	                    $scope.$emit('show', { node: d, event: d3.event });
	                });
	            }
	            function mouseEnter(d) {
	                if (d.level === 1) {
	                    d.valueCommas = numberWithCommas(d.value);
	                }
	                else {
	                    d.startCommas = numberWithCommas(d.start);
	                    d.endCommas = numberWithCommas(d.end);
	                }
	                var content = d.level === 1 ? [{ left: 'Chromosome {name}', right: '' }, { left: '0 - {valueCommas}', right: '' }] :
	                    [{ left: 'Kits {numItems}', right: '' }, { left: '{startCommas} - {endCommas}', right: '' }];
	                var x = (d.y0 + d.y1) >>> 1; // jshint ignore:line
	                tooltip
	                    .content(content)
	                    .x(x > rect.width - 200 ? x - 8 : x + 8)
	                    .y((d.x0 + d.x1) >>> 1) // jshint ignore:line
	                    .direction(x > rect.width - 200 ? 'right' : 'left')
	                    .textColor('white')
	                    .tooltipFill('#488FC8')
	                    .show(d);
	            }
	            function numberWithCommas(x) {
	                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	            }
	            function mouseLeave() {
	                tooltip.hide();
	            }
	            $timeout(function () {
	                $rootScope.$broadcast('resetHeight');
	            }, 0);
	            return {
	                highlight: function (highlighted) {
	                    var s = new Set(highlighted);
	                    data.nodes.forEach(function (d) {
	                        d.highlighted = !!d.items && d.items.some(function (i) { return s.has(i.name); });
	                    });
	                    update();
	                }
	            };
	        }
	        function setup(elem, data) {
	            rect = elem.getBoundingClientRect();
	            if (!!rect && rect.width > 100) {
	                // create a new div
	                main = _setup(elem, data);
	                main.highlight($scope.highlighted);
	            }
	            else {
	                $timeout(function () {
	                    setup(elem, data);
	                }, 500);
	            }
	        }
	        function resize() {
	            var r = elem[0].getBoundingClientRect();
	            if (!rect || Math.abs(r.width - rect.width) >= resizeThreshold) {
	                // delete svg
	                elem.empty();
	                // start over
	                setup(elem[0], scope.data);
	            }
	        }
	        angular.element($window).on('resize', resize);
	        elem.on('$destroy', function () {
	            angular.element($window).off('resize', resize);
	        });
	        scope.$watch('data', function () {
	            elem.empty();
	            setup(elem[0], scope.data);
	        });
	        scope.$watch('highlighted', function () {
	            if (!!main) {
	                main.highlight(scope.highlighted);
	            }
	        });
	        scope.$watch(function () {
	            return sidenav.isLockedOpen();
	        }, function () {
	            $timeout(resize, 1000);
	        });
	    }
	    return {
	        restrict: 'E',
	        link: link,
	        template: '<div></div>',
	        scope: {
	            data: '=',
	            highlighted: '='
	        }
	    };
	}
	exports.default = rcD3SankeyDirective;


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	rcDagD3Directive.$inject = ["$log", "$window", "$rootScope", "$timeout", "d3", "sidenav"];
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	function rcDagD3Directive($log, $window, $rootScope, $timeout, d3, sidenav) {
	    'ngInject';
	    function link(scope, elem) {
	        var $scope = scope;
	        var svg = null;
	        var rect = null;
	        var main = null;
	        var resizeThreshold = 20;
	        var peopleSeen = new Map();
	        var partitions = new Map();
	        var corePartitions = new Map();
	        var ID = 0;
	        function _setup(elem, data, personHasKits) {
	            ID = 0;
	            peopleSeen = new Map();
	            partitions = new Map();
	            corePartitions = new Map();
	            var bound = elem.getBoundingClientRect();
	            var width = bound.width;
	            var height = bound.height - 4;
	            var _svg = d3.select(elem).append("svg")
	                .attr("width", width)
	                .attr("height", height)
	                .attr("class", "dag__outer");
	            var _defs = _svg.append("defs");
	            _defs.append("filter")
	                .attr("id", "boxShadow")
	                .append("feDropShadow")
	                .attr("dx", 0)
	                .attr("dy", 1)
	                .attr("stdDeviation", 1)
	                .attr("flood-color", "#000000")
	                .attr("flood-opacity", 0.4);
	            _defs.append("filter")
	                .attr("id", "circleShadow")
	                .append("feDropShadow")
	                .attr("dx", 0)
	                .attr("dy", 1)
	                .attr("stdDeviation", 1)
	                .attr("flood-color", "#000000")
	                .attr("flood-opacity", 0.4);
	            svg = _svg.append("g")
	                .attr("class", "dag__inner")
	                .attr("transform", "translate(100,80) scale(0.8)")
	                .attr("stroke", "#999")
	                .attr("fill", "#ffffff");
	            var links = svg.append("g").attr("class", "links");
	            var nodes = svg.append("g").attr("class", "nodes");
	            var cores = svg.append("g").attr("class", "cores");
	            var layout = dagLayout(data, width, height);
	            // emit the order of the nodes so the dnakits can be displayed in the correct order
	            emitOrderByXCoord(scope, layout.nodes);
	            // Nodes
	            var nodesGroup = nodes
	                .selectAll('g.node')
	                .data(layout.nodes)
	                .enter()
	                .append('g')
	                .classed('node', true)
	                .attr('transform', function (d) { return "translate(" + d.x + ", " + d.y + ")"; });
	            var rectangleGroup = nodesGroup.append("g");
	            rectangleGroup.append('rect')
	                .attr("width", 200)
	                .attr("height", 50)
	                .attr("style", "filter:url(#boxShadow); stroke-width: 0px");
	            rectangleGroup.append("image")
	                .attr("width", 40)
	                .attr("height", 40)
	                .attr("x", 5)
	                .attr("y", 5)
	                .attr("xlink:href", function (d) { return d.iconURL; });
	            rectangleGroup.append("text").append("tspan")
	                .text(function (d) { return (d.name.length > 18 ? d.name.substring(0, 15) + "..." : d.name); })
	                .attr("x", 50)
	                .attr("y", 15)
	                .attr("class", "person-name");
	            rectangleGroup.append("text")
	                .text(function (d) { return d.lifespan; })
	                .attr("x", 50)
	                .attr("y", 30)
	                .attr("class", "person-lifespan");
	            rectangleGroup.filter(function (d) { return personHasKits.has(d.id); })
	                .append("image")
	                .attr("width", 20)
	                .attr("height", 20)
	                .attr("x", 170)
	                .attr("y", 24)
	                .attr("xlink:href", function (d) { return "assets/icons/icon-dna.svg"; });
	            // Cores
	            var coresGroup = cores
	                .selectAll('g.node')
	                .data(layout.cores)
	                .enter()
	                .append('g')
	                .classed('core', true)
	                .attr('transform', function (d) { return "translate(" + d.x + ", " + d.y + ")"; })
	                .on("click", function (d) {
	                d3.event.stopPropagation();
	                scope.$emit('display-family', {
	                    fatherId: d.fatherId,
	                    motherId: d.motherId,
	                    level: d.level
	                });
	            });
	            var circleGroup = coresGroup.append("g");
	            circleGroup.append("circle")
	                .attr("r", 20)
	                .attr("class", "family-core")
	                .attr("style", "filter:url(#circleShadow); stroke-width: 0px");
	            circleGroup.append("text")
	                .text("+")
	                .attr("text-anchor", "middle")
	                .attr("class", "circle-plus");
	            // Links
	            var linksGroup = links
	                .selectAll('line.link')
	                .data(layout.links)
	                .enter()
	                .append('line')
	                .classed('link', true)
	                .attr('x1', function (d) { return d.source.x; })
	                .attr('y1', function (d) { return d.source.y; })
	                .attr('x2', function (d) { return d.target.x; })
	                .attr('y2', function (d) { return d.target.y; });
	        }
	        function searchParents(person, parents) {
	            if (!parents) {
	                return;
	            }
	            if (!parents.father && !parents.mother) {
	            }
	            else if (!!parents.father && parents.father.hidePerson && !!parents.mother && parents.mother.hidePerson) {
	                var fatherId = !!parents.father.person ? parents.father.person.id : 0;
	                var motherId = !!parents.mother.person ? parents.mother.person.id : 0;
	                if (!corePartitions.has(person.level + 1)) {
	                    corePartitions.set(person.level + 1, []);
	                }
	                corePartitions.get(person.level + 1).push({
	                    fatherId: fatherId,
	                    motherId: motherId,
	                    childrenIds: [person.person.id],
	                    level: person.level + 1,
	                    hideFather: true,
	                    hideMother: true,
	                    coreId: ID++
	                });
	                peopleSeen.set(fatherId, true);
	                peopleSeen.set(motherId, true);
	                if (true) {
	                    //TODO check to see if person has been added; if not add them to their partition and set seen to true so that
	                }
	            }
	            else {
	                Array.from(Object.values(parents)).forEach(function (parent) {
	                    if (!!parent && !peopleSeen.has(parent.person.id) && !parent.hidePerson) {
	                        peopleSeen.set(parent.person.id, true);
	                        if (!partitions.has(parent.level)) {
	                            partitions.set(parent.level, []);
	                        }
	                        partitions.get(parent.level).push(parent);
	                        searchFamilies(parent, parent.families);
	                        searchParents(parent, parent.parents);
	                    }
	                });
	            }
	        }
	        function searchFamilies(person, families) {
	            if (!families) {
	                return;
	            }
	            families.forEach(function (family, index) {
	                if (!corePartitions.has(person.level)) {
	                    corePartitions.set(person.level, []);
	                }
	                var father = person.person.gender === "MALE" ? person : family.spouse;
	                var mother = person.person.gender === "FEMALE" ? person : family.spouse;
	                corePartitions.get(person.level).push({
	                    fatherId: !!father.person ? father.person.id : 0,
	                    motherId: !!mother.person ? mother.person.id : 0,
	                    childrenIds: family.children.map(function (child) { return child.person.id; }),
	                    level: person.level,
	                    hideFather: father.hidePerson,
	                    hideMother: mother.hidePerson,
	                    coreId: ID++,
	                    familyId: family.familyId
	                });
	                if (!!family.spouse && !!family.spouse.person && !family.spouse.hidePerson && !peopleSeen.has(family.spouse.person.id)) {
	                    peopleSeen.set(family.spouse.person.id, true);
	                    if (!partitions.has(family.spouse.level)) {
	                        partitions.set(family.spouse.level, []);
	                    }
	                    partitions.get(family.spouse.level).push(family.spouse);
	                    searchFamilies(family.spouse, family.spouse.families);
	                    searchParents(family.spouse, family.spouse.parents);
	                }
	                if (!!family.children) {
	                    family.children.forEach(function (child) {
	                        peopleSeen.set(child.person.id, true);
	                        if (!partitions.has(child.level)) {
	                            partitions.set(child.level, []);
	                        }
	                        var levelPartition = partitions.get(child.level);
	                        var index = levelPartition.findIndex(function (p) {
	                            return p.person.id !== 0 && p.person.id === child.person.id;
	                        });
	                        if (index == -1) {
	                            levelPartition.push(child);
	                        }
	                        else {
	                            levelPartition[index].suborder = child.suborder;
	                        }
	                        searchFamilies(child, child.families);
	                    });
	                }
	            });
	        }
	        function dagLayout(data, width, height) {
	            var attrs = {
	                nodeWidth: 200,
	                nodeSpace: 240,
	                nodeHeight: 50,
	                circleRadius: 20,
	                levelHeight: 200
	            };
	            var nodes = [];
	            var links = [];
	            var cores = [];
	            var nodeMap = new Map();
	            // Search through the families and parents of the root person to create the various nodes and cores
	            searchFamilies(data, data.families);
	            searchParents(data, data.parents);
	            // If we never added the root person, because neither of their parents are in the dag, then add them as a node
	            checkRootAdded(data);
	            var keys = Array.from(partitions.keys());
	            var min = Math.min.apply(Math, __spread(keys));
	            var max = Math.max.apply(Math, __spread(keys));
	            var left = 0;
	            var top = 0;
	            var right = width;
	            var bottom = height;
	            var center = {
	                x: right / 2,
	                y: bottom / 2
	            };
	            var elevations = {};
	            Array.from(partitions.keys()).map(function (level) {
	                elevations[level] = center.y - (attrs.levelHeight * level);
	            });
	            Array.from(partitions.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), level = _b[0], _persons = _b[1];
	                var persons = _persons.filter(function (p) { return !p.hidePerson; }).sort(function (p1, p2) {
	                    var personOrder = getPersonOrder(p1, p2);
	                    if (personOrder !== 0) {
	                        return personOrder;
	                    }
	                    else {
	                        return parseInt(p1.person._birthDateSort) - parseInt(p2.person._birthDateSort);
	                    }
	                });
	                var total = 0;
	                var _loop_1 = function (i) {
	                    var currPerson = persons[i];
	                    var spouseShift = currPerson.person.gender === "MALE" ? 1 : 0;
	                    currPerson.families.forEach(function (family) {
	                        var spouseIndex = persons.findIndex(function (person) {
	                            if (!!family.spouse && !!family.spouse.person) {
	                                return family.spouse.person.id === person.person.id;
	                            }
	                            else {
	                                return false;
	                            }
	                        });
	                        if (spouseIndex !== -1 && spouseIndex !== i + 1) {
	                            var _a = __read(persons.splice(spouseIndex, 1), 1), removedSpouse = _a[0];
	                            if (spouseIndex < i) {
	                                i--; //We removed behind it so decrement the index by one
	                            }
	                            persons.splice(i + spouseShift, 0, removedSpouse);
	                            if (spouseShift !== 1) {
	                                i++; //We inserted behind it so increment the index by one
	                            }
	                        }
	                    });
	                    total++;
	                    if (total > 10000) {
	                        return out_i_1 = i, "break";
	                    }
	                    out_i_1 = i;
	                };
	                var out_i_1;
	                for (var i = 0; i < persons.length; i++) {
	                    var state_1 = _loop_1(i);
	                    i = out_i_1;
	                    if (state_1 === "break")
	                        break;
	                }
	                var middle = Math.fround(persons.length / 2);
	                persons.forEach(function (person, i) {
	                    var node = {
	                        x: center.x - ((middle - i) * attrs.nodeSpace),
	                        y: elevations[level],
	                        name: person.person._fullName,
	                        id: person.person.id,
	                        lifespan: person.person._lifespan,
	                        iconURL: person.person._iconURL || (person.person.gender === "MALE" ? "assets/icons/icon-man.svg" : (person.person.gender === "FEMALE" ? "assets/icons/icon-woman.svg" : "assets/icons/icon-unknowngender.svg"))
	                    };
	                    nodeMap.set(person.person.id, node);
	                    nodes.push(node);
	                });
	            });
	            Array.from(corePartitions.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), level = _b[0], familyCores = _b[1];
	                var tempCores = [];
	                var linkDatas = [];
	                familyCores.forEach(function (core) {
	                    //TODO get each coreData pass them into a temporary array, take that temporary array and sort according to x value, then according to other details such as whether it's a family core, a single person, parent, child, etc.
	                    // Then, if any cores overlap, run a "nudge" algorithm repeatedly until there are no overlapping cores
	                    if (core.hideFather && core.hideMother) {
	                        var childId = core.childrenIds[0];
	                        var child = nodeMap.get(childId);
	                        var coreData = {
	                            x: child.x + (attrs.nodeWidth / 2),
	                            y: getCoreYFromChild(child.y, attrs),
	                            fatherId: core.fatherId,
	                            motherId: core.motherId,
	                            childrenIds: core.childrenIds,
	                            level: level,
	                            coreId: core.coreId
	                        };
	                        tempCores.push(coreData);
	                        linkDatas.push({
	                            father: undefined,
	                            mother: undefined,
	                            hideFather: core.hideFather,
	                            hideMother: core.hideMother,
	                            children: [child],
	                            coreId: core.coreId
	                        });
	                        //addLinks(undefined, undefined, core.hideFather, core.hideMother, [child], coreData, links, attrs);
	                    }
	                    else {
	                        var father = nodeMap.get(core.fatherId) || {};
	                        var mother = nodeMap.get(core.motherId) || {};
	                        var coreData = {
	                            x: mean(father.x + (attrs.nodeWidth / 2), mother.x + (attrs.nodeWidth / 2)),
	                            y: getCoreYFromParents(father.y, mother.y, attrs),
	                            fatherId: core.fatherId,
	                            motherId: core.motherId,
	                            childrenIds: core.childrenIds,
	                            level: level,
	                            coreId: core.coreId
	                        };
	                        var children = !!core.childrenIds ? core.childrenIds.map(function (childId) {
	                            return nodeMap.get(childId);
	                        }) : [];
	                        tempCores.push(coreData);
	                        linkDatas.push({
	                            father: father,
	                            mother: mother,
	                            hideFather: core.hideFather,
	                            hideMother: core.hideMother,
	                            children: children,
	                            coreId: core.coreId
	                        });
	                        //addLinks(father, mother, core.hideFather, core.hideMother, children, coreData, links, attrs);
	                    }
	                });
	                var stableSort = function (arr, compare) { return arr
	                    .map(function (item, index) { return ({ item: item, index: index }); })
	                    .sort(function (a, b) { return compare(a.item, b.item) || a.index - b.index; })
	                    .map(function (_a) {
	                    var item = _a.item;
	                    return item;
	                }); };
	                var compare = function (c1, c2) {
	                    if (c1.x !== c2.x) {
	                        return c1.x - c2.x;
	                    }
	                    else if (!!c1.childrenIds.length && !c2.childrenIds.length) {
	                        return -1;
	                    }
	                    else {
	                        return 0;
	                    }
	                };
	                var sortedCores = stableSort(tempCores, compare);
	                removeAllOverlappingCores(sortedCores, attrs);
	                linkDatas.forEach(function (lD) {
	                    var coreData = sortedCores.find(function (_coreData) {
	                        return _coreData.coreId === lD.coreId;
	                    });
	                    addLinks(lD.father, lD.mother, lD.hideFather, lD.hideMother, lD.children, coreData, links, attrs);
	                });
	                cores.push.apply(cores, __spread(sortedCores));
	            });
	            return { nodes: nodes, links: links, cores: cores };
	        }
	        function checkRootAdded(data) {
	            var rootPid = data.person.id;
	            var mainLevel = partitions.get(0);
	            if (!mainLevel) {
	                partitions.set(0, []);
	                mainLevel = partitions.get(0);
	            }
	            var index = mainLevel.findIndex(function (dagInfo) {
	                return dagInfo.person.id === rootPid;
	            });
	            if (index === -1) {
	                peopleSeen.set(rootPid, true);
	                mainLevel.push(data);
	            }
	            else {
	                mainLevel[index] = data;
	            }
	        }
	        function addLinks(father, mother, hideFather, hideMother, children, coreData, links, attrs) {
	            if (!!father && !hideFather) {
	                links.push({
	                    source: {
	                        x: coreData.x,
	                        y: coreData.y
	                    },
	                    target: {
	                        x: father.x + (attrs.nodeWidth / 2),
	                        y: father.y + attrs.nodeHeight
	                    }
	                });
	            }
	            if (!!mother && !hideMother) {
	                links.push({
	                    source: {
	                        x: coreData.x,
	                        y: coreData.y
	                    },
	                    target: {
	                        x: mother.x + (attrs.nodeWidth / 2),
	                        y: mother.y + attrs.nodeHeight
	                    }
	                });
	            }
	            children.forEach(function (person) {
	                if (!!person) {
	                    links.push({
	                        source: {
	                            x: coreData.x,
	                            y: coreData.y
	                        },
	                        target: {
	                            x: person.x + (attrs.nodeWidth / 2),
	                            y: person.y
	                        }
	                    });
	                }
	            });
	        }
	        // calculate the mean while taking into account undefined values
	        function mean() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var res = args.filter(function (a) { return !!a; }).reduce(function (state, curr) {
	                state.sum += curr;
	                state.count += 1;
	                return state;
	            }, { sum: 0, count: 0 });
	            return res.sum / res.count;
	        }
	        function getCoreYFromParents(y1, y2, attrs) {
	            if (!!y1) {
	                return y1 + (attrs.levelHeight / 2);
	            }
	            else if (!!y2) {
	                return y2 + (attrs.levelHeight / 2);
	            }
	            else {
	                console.error("parent nodes have no y value");
	                return 0;
	            }
	        }
	        function getCoreYFromChild(y, attrs) {
	            return y - (attrs.levelHeight / 2);
	        }
	        function wrap(width, padding) {
	            var self = d3.select(this), textLength = self.node().getComputedTextLength(), text = self.text();
	            while (textLength > (width - 2 * padding) && text.length > 0) {
	                text = text.slice(0, -1);
	                self.text(text + '...');
	                textLength = self.node().getComputedTextLength();
	            }
	        }
	        function coresOverlap(c1, c2, attrs) {
	            return Math.abs(c1.x - c2.x) < (attrs.circleRadius * 3); //are they overlapping or just too close?
	        }
	        function removeAllOverlappingCores(sortedCores, attrs) {
	            var changed = removeOverlappingCores(sortedCores, attrs);
	            while (changed) {
	                changed = removeOverlappingCores(sortedCores, attrs);
	            }
	        }
	        function removeOverlappingCores(sortedCores, attrs) {
	            var changed = false;
	            for (var i = 0; i < sortedCores.length - 1; i++) {
	                var c1 = sortedCores[i];
	                var c2 = sortedCores[i + 1];
	                if (coresOverlap(c1, c2, attrs)) {
	                    changed = true;
	                    var j = i + 2;
	                    var currCore = c2;
	                    var nextCore = sortedCores[j];
	                    while (!!nextCore && coresOverlap(currCore, nextCore, attrs)) {
	                        j++;
	                        currCore = nextCore;
	                        nextCore = sortedCores[j];
	                    }
	                    var numOverlapping = j - i;
	                    var middle = i + (numOverlapping / 2) - 0.5;
	                    for (var k = i; k < j; k++) {
	                        sortedCores[k].x += (k - middle) * (attrs.circleRadius * 3);
	                    }
	                    //c1.x -= (attrs.circleRadius * 2);
	                    //c2.x += (attrs.circleRadius * 2);
	                }
	            }
	            return changed;
	        }
	        function areSpouses(p1, p2) {
	        }
	        function haveSameSpouse(p1, p2) {
	        }
	        function haveSameParents(p1, p2) {
	        }
	        function areSiblings(p1, p2) {
	        }
	        function areCousins(p1, p2) {
	        }
	        function getPersonOrder(p1, p2) {
	            if (p1.order === p2.order) {
	                if (p1.suborder === p2.suborder) {
	                    return 0;
	                }
	                else {
	                    return (p1.suborder < p2.suborder) ? -1 : 1;
	                }
	            }
	            else {
	                return p1.order - p2.order;
	            }
	        }
	        function emitOrderByXCoord(scope, _nodes) {
	            var nodes = __spread(_nodes).sort();
	            scope.$emit('ordered-ids', nodes);
	        }
	        function setup(elem, data, personHasKits) {
	            rect = elem.getBoundingClientRect();
	            if (!!rect && rect.width > 100) {
	                // create a new div
	                main = _setup(elem, data, personHasKits);
	            }
	            else {
	                $timeout(function () {
	                    setup(elem, data, personHasKits);
	                }, 500);
	            }
	        }
	        function resize() {
	            var r = elem[0].getBoundingClientRect();
	            if (!rect || Math.abs(r.width - rect.width) >= resizeThreshold) {
	                // delete svg
	                elem.empty();
	                // start over
	                setup(elem[0], scope.data, scope.personHasKits);
	            }
	        }
	        angular.element($window).on('resize', resize);
	        elem.on('$destroy', function () {
	            angular.element($window).off('resize', resize);
	        });
	        scope.$watch('data', function () {
	            elem.empty();
	            setup(elem[0], scope.data, scope.personHasKits);
	        });
	        scope.$watch(function () {
	            return sidenav.isLockedOpen();
	        }, function () {
	            $timeout(resize, 1000);
	        });
	    }
	    return {
	        restrict: 'E',
	        link: link,
	        template: '<div></div>',
	        scope: {
	            data: '=',
	            personHasKits: '='
	        }
	    };
	}
	exports.default = rcDagD3Directive;


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	function rcDagDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/dag/dag.html',
	        controller: DagController,
	        controllerAs: 'dag',
	        bindToController: true,
	        scope: {
	            root: '='
	        }
	    };
	}
	var DagController = /** @class */ (function () {
	    DagController.$inject = ["$log", "$scope", "rx", "families", "persons", "utils", "dnaKits", "dnaProfiles"];
	    function DagController($log, $scope, rx, families, persons, utils, dnaKits, dnaProfiles) {
	        'ngInject';
	        var _this = this;
	        this.kits = new Map();
	        this.profiles = new Map();
	        this.personKits = new Map();
	        this.dagInitialized = false;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.rx = rx;
	        this.families = families;
	        this.persons = persons;
	        this.utils = utils;
	        this.dnaKits = dnaKits;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.data = null;
	        this.personsMap = null;
	        this.ready = false;
	        var pw = this.utils.pleaseWait();
	        this.$onInit = function () {
	            var subscription = rx.Observable.combineLatest(_this.utils.watch($scope, 'fragment.root'), _this.utils.readyChange(persons, families), _this.utils.readyChange(dnaKits, dnaProfiles)).subscribe(function (_a) {
	                var _b = __read(_a, 3), e = _b[0], _c = __read(_b[1], 1), personMap = _c[0], _d = __read(_b[2], 2), kits = _d[0], profiles = _d[1];
	                e.newValue = _this.root;
	                $log.debug('pf.ready', e.newValue);
	                //console.log('DAG', e, personMap, kits, profiles);
	                if (!!e.newValue && !!personMap && !!personMap.get(e.newValue)) {
	                    _this.kits = kits;
	                    _this.profiles = profiles;
	                    _this.personsMap = personMap;
	                    _this.parentsMap = families.getParentsMap();
	                    _this.spousesMap = families.getSpousesMap();
	                    _this.fillDag(e.newValue);
	                    _this.ready = true;
	                }
	                _this.utils.pleaseWaitCancel(pw);
	            });
	            $scope.$on('$destroy', function () {
	                _this.utils.pleaseWaitCancel(pw);
	                subscription.unsubscribe();
	            });
	            $scope.$on('display-family', function (ev, _a) {
	                var fatherId = _a.fatherId, motherId = _a.motherId, level = _a.level, familyId = _a.familyId;
	                var family;
	                if (!!familyId) {
	                    if (!!fatherId) {
	                        family = (_this.spousesMap.has(fatherId) ? Array.from(_this.spousesMap.get(fatherId).values()) : []).find(function (family) {
	                            return family.id === familyId;
	                        });
	                    }
	                    else {
	                        family = (_this.spousesMap.has(motherId) ? Array.from(_this.spousesMap.get(motherId).values()) : []).find(function (family) {
	                            return family.id === familyId;
	                        });
	                    }
	                }
	                else {
	                    if (!!fatherId) {
	                        family = (_this.spousesMap.has(fatherId) ? Array.from(_this.spousesMap.get(fatherId).values()) : []).find(function (family) {
	                            return family.wifeId === motherId;
	                        });
	                    }
	                    else {
	                        family = (_this.spousesMap.has(motherId) ? Array.from(_this.spousesMap.get(motherId).values()) : []).find(function (family) {
	                            return family.husbandId === fatherId;
	                        });
	                    }
	                }
	                // family = (this.spousesMap.has(fatherId) ? Array.from(this.spousesMap.get(fatherId).values()) : []).find((family) => {
	                //   return family.wifeId === motherId;
	                // });
	                _this.utils.dialog(ev, 'SelectFamilyMembersController', 'app/components/selectFamilyMembers/selectFamilyMembers.html', true, {
	                    father: _this.personsMap.get(fatherId),
	                    mother: _this.personsMap.get(motherId),
	                    children: Array.from(!!family.childRels ? family.childRels.keys() : []).map(function (id) {
	                        return _this.personsMap.get(id);
	                    }),
	                    currentlySelected: _this.peopleInDag,
	                    rootPid: _this.root
	                }).then(function (_a) {
	                    var _b = __read(_a, 2), peopleAdded = _b[0], peopleRemoved = _b[1];
	                    Array.from(peopleAdded.entries()).forEach(function (_a) {
	                        var _b = __read(_a, 1), id = _b[0];
	                        _this.peopleInDag.set(id, !!family.childRels.has(id) ? level - 1 : level);
	                    });
	                    Array.from(peopleRemoved.entries()).forEach(function (_a) {
	                        var _b = __read(_a, 1), id = _b[0];
	                        _this.peopleInDag.delete(id);
	                    });
	                    if (!!peopleAdded.size || !!peopleRemoved.size) {
	                        _this.fillDag(!!_this.peopleInDag.has(_this.root) ? _this.root : _this.peopleInDag.keys().next().value, true, peopleAdded, peopleRemoved); //The first should be the root, but if they are no longer shown, then just use the first person in the map
	                    }
	                }, function () {
	                    //Do nothing
	                });
	            });
	            $scope.$on('ordered-ids', function (ev, orderedIds) {
	                var personKits = new Map();
	                orderedIds.forEach(function (_a) {
	                    var id = _a.id;
	                    if (_this.personKits.has(id)) {
	                        personKits.set(id, _this.personKits.get(id));
	                    }
	                });
	                _this.$scope.$emit('dna-matches', personKits);
	            });
	        };
	    }
	    DagController.prototype.fillDag = function (pid, fromDialog, peopleAdded, peopleRemoved) {
	        if (!this.dagInitialized) {
	            this.initPeopleInDag(pid);
	            this.dagInitialized = true;
	        }
	        if (fromDialog) {
	            this.addRemovePersonDNAKitMap(peopleAdded, peopleRemoved);
	        }
	        else {
	            this.fillPersonDNAKitMap();
	        }
	        this.initPeopleAddedToDag(pid);
	        this.createDag(pid);
	        if (fromDialog) {
	            this.removePeopleNotInDag(); //If someone being removed caused others to no longer be connected to the root, remove them
	        }
	    };
	    DagController.prototype.fillPersonDNAKitMap = function () {
	        var _this = this;
	        this.personKits.clear();
	        Array.from(this.peopleInDag.keys()).forEach(function (id) {
	            var matches = _this.dnaKits.getDNAMatches(_this.kits, _this.profiles, id);
	            if (matches.kits.length > 0 || matches.profiles.length > 0) {
	                _this.personKits.set(id, matches);
	            }
	        });
	    };
	    DagController.prototype.addRemovePersonDNAKitMap = function (peopleAdded, peopleRemoved) {
	        var _this = this;
	        if (!!peopleAdded) {
	            Array.from(peopleAdded.keys()).forEach(function (id) {
	                var matches = _this.dnaKits.getDNAMatches(_this.kits, _this.profiles, id);
	                if (matches.kits.length > 0 || matches.profiles.length > 0) {
	                    _this.personKits.set(id, matches);
	                }
	            });
	        }
	        if (!!peopleRemoved) {
	            Array.from(peopleRemoved.keys()).forEach(function (id) {
	                _this.personKits.delete(id);
	            });
	        }
	    };
	    DagController.prototype.removePeopleNotInDag = function () {
	        var _this = this;
	        Array.from(this.peopleInDag.keys()).forEach(function (id) {
	            if (!_this.peopleAddedToDag.has(id)) {
	                _this.peopleInDag.delete(id);
	                _this.personKits.delete(id); // delete the kits here as well because we cannot reach this person
	            }
	        });
	    };
	    DagController.prototype.initPeopleInDag = function (pid) {
	        var _this = this;
	        this.peopleInDag = new Map();
	        var p = this.personsMap.get(pid);
	        var parentFamily = this.families.getPreferredFamily(this.parentsMap.get(pid) || new Map(), p.preferredParentsFamilyId);
	        this.peopleInDag.set(parentFamily.husbandId, 1);
	        this.peopleInDag.set(parentFamily.wifeId, 1);
	        Array.from(parentFamily.childRels.keys()).forEach(function (childId) {
	            _this.peopleInDag.set(childId, 0);
	        });
	        var spousesType = p.gender === "MALE" ? "wife" : "husband";
	        (this.spousesMap.has(pid) ? Array.from(this.spousesMap.get(pid).entries()) : []).forEach(function (_a) {
	            var _b = __read(_a, 2), f = _b[1];
	            var spouseId = f[spousesType + "Id"];
	            _this.peopleInDag.set(spouseId, 0);
	            Array.from(f.childRels.keys()).forEach(function (childId) {
	                _this.peopleInDag.set(childId, -1);
	            });
	        });
	    };
	    DagController.prototype.initPeopleAddedToDag = function (pid) {
	        this.peopleAddedToDag = new Map();
	        this.peopleAddedToDag.set(pid, true);
	    };
	    DagController.prototype.createDag = function (rootPid) {
	        var order = 1;
	        var suborder = "0";
	        var rootPerson = this.personsMap.get(rootPid);
	        var parents = this.addParents(rootPerson, order, suborder);
	        var families = this.addFamilies(rootPerson, order, suborder);
	        this.data = {
	            person: rootPerson,
	            level: this.peopleInDag.get(rootPid),
	            families: families,
	            parents: parents,
	            order: order,
	            suborder: suborder
	        };
	        console.debug("dag data", this.data);
	    };
	    DagController.prototype.addFamilies = function (p, order, suborder, noAddParents) {
	        var _this = this;
	        if (!p) {
	            return [];
	        }
	        var families = [];
	        var spousesType = p.gender === "MALE" ? "wife" : "husband";
	        if (!this.spousesMap.has(p.id)) {
	            return families;
	        }
	        (this.spousesMap.has(p.id) ? Array.from(this.spousesMap.get(p.id).entries()) : []).forEach(function (_a, index) {
	            var _b = __read(_a, 2), f = _b[1];
	            var spouseId = f[spousesType + "Id"];
	            var spouse = _this.personsMap.get(spouseId);
	            var spouseOrder = order + 1 * ((spousesType === "husband") ? -1 : 1);
	            var spouseSubOrder = suborder + index;
	            if (!spouse || (_this.peopleInDag.has(spouseId) && !_this.peopleAddedToDag.has(spouseId))) {
	                if (!!spouse) {
	                    _this.peopleAddedToDag.set(spouseId, true);
	                }
	                var children_1 = [];
	                var childOrder_1 = Math.floor(order / 2);
	                var sortedChildIds = Array.from(f.childRels.keys()).map(function (childId) { return _this.personsMap.get(childId); })
	                    .filter(function (person) { return !!person; })
	                    .sort(function (p1, p2) {
	                    return parseInt(p1._birthDateSort) - parseInt(p2._birthDateSort);
	                })
	                    .map(function (person) { return person.id; });
	                sortedChildIds.forEach(function (childId, j) {
	                    var childSubOrder = spouseSubOrder + j;
	                    if (_this.peopleInDag.has(childId)) {
	                        var added = _this.peopleAddedToDag.has(childId);
	                        if (!added) {
	                            _this.peopleAddedToDag.set(childId, true);
	                        }
	                        else {
	                            //childSubOrder = suborder;
	                        }
	                        var child = _this.personsMap.get(childId);
	                        children_1.push({
	                            person: child,
	                            level: _this.peopleInDag.get(childId),
	                            families: added ? [] : _this.addFamilies(child, childOrder_1, childSubOrder, true),
	                            parents: undefined,
	                            order: childOrder_1,
	                            suborder: childSubOrder
	                        });
	                    }
	                });
	                families.push({
	                    spouse: {
	                        person: spouse,
	                        level: _this.peopleInDag.get(p.id),
	                        families: _this.addFamilies(spouse, spouseOrder, spouseSubOrder),
	                        parents: _this.addParents(spouse, spouseOrder, spouseSubOrder),
	                        hidePerson: !spouse,
	                        order: spouseOrder,
	                        suborder: spouseSubOrder
	                    },
	                    children: children_1,
	                    familyId: f.id
	                });
	            }
	            else if (!_this.peopleInDag.has(spouseId)) {
	                var children_2 = [];
	                var childOrder_2 = Math.floor(order / 2);
	                var sortedChildIds = Array.from(f.childRels.keys()).map(function (childId) { return _this.personsMap.get(childId); })
	                    .filter(function (person) { return !!person; })
	                    .sort(function (p1, p2) {
	                    return parseInt(p1._birthDateSort) - parseInt(p2._birthDateSort);
	                })
	                    .map(function (person) { return person.id; });
	                sortedChildIds.forEach(function (childId, j) {
	                    var childSubOrder = spouseSubOrder + j;
	                    if (_this.peopleInDag.has(childId)) {
	                        var added = _this.peopleAddedToDag.has(childId);
	                        if (!added) {
	                            _this.peopleAddedToDag.set(childId, true);
	                        }
	                        else {
	                            //childSubOrder = suborder;
	                        }
	                        var child = _this.personsMap.get(childId);
	                        children_2.push({
	                            person: child,
	                            level: _this.peopleInDag.get(childId),
	                            families: added ? [] : _this.addFamilies(child, childOrder_2, childSubOrder, true),
	                            parents: undefined,
	                            order: childOrder_2,
	                            suborder: childSubOrder
	                        });
	                    }
	                });
	                families.push({
	                    spouse: {
	                        person: spouse,
	                        level: _this.peopleInDag.get(p.id),
	                        families: undefined,
	                        parents: undefined,
	                        hidePerson: true,
	                        order: spouseOrder,
	                        suborder: spouseSubOrder
	                    },
	                    children: children_2,
	                    familyId: f.id
	                });
	            }
	        });
	        return families;
	    };
	    DagController.prototype.addParents = function (p, order, suborder) {
	        if (!p) {
	            return null;
	        }
	        var parentFamily = this.families.getPreferredFamily(this.parentsMap.get(p.id) || new Map(), p.preferredParentsFamilyId);
	        if (!parentFamily) {
	            return null;
	        }
	        var fatherOrder = order * 2;
	        var motherOrder = order * 2 + 1;
	        var husband = this.personsMap.get(parentFamily.husbandId) || { id: 0 };
	        var wife = this.personsMap.get(parentFamily.wifeId) || { id: 0 };
	        var father;
	        var mother;
	        if (!!husband && this.peopleInDag.has(husband.id) && !this.peopleAddedToDag.has(husband.id)) {
	            this.peopleAddedToDag.set(husband.id, true);
	            father = {
	                person: husband,
	                level: this.peopleInDag.get(husband.id),
	                families: this.addFamilies(husband, fatherOrder, suborder),
	                parents: this.addParents(husband, fatherOrder, suborder),
	                order: fatherOrder,
	                suborder: suborder
	            };
	        }
	        else if (!!husband) {
	            father = {
	                person: husband,
	                level: this.peopleInDag.get(p.id) + 1,
	                families: undefined,
	                parents: undefined,
	                hidePerson: true,
	                order: fatherOrder,
	                suborder: suborder
	            };
	        }
	        if (!!wife && this.peopleInDag.has(wife.id)) {
	            this.peopleAddedToDag.set(wife.id, true);
	            mother = {
	                person: wife,
	                level: this.peopleInDag.get(wife.id),
	                families: this.addFamilies(wife, motherOrder, suborder),
	                parents: this.addParents(wife, motherOrder, suborder),
	                order: motherOrder,
	                suborder: suborder
	            };
	        }
	        else if (!!wife) {
	            mother = {
	                person: wife,
	                level: this.peopleInDag.get(p.id) + 1,
	                families: undefined,
	                parents: undefined,
	                hidePerson: true,
	                order: motherOrder,
	                suborder: suborder
	            };
	        }
	        // if (this.peopleInDag.has(husband.id) && !this.peopleInDag.has(wife.id)) { 
	        //   father = {
	        //     person: husband,
	        //     level: this.peopleInDag.get(p.id) + 1,
	        //     families: undefined,
	        //     parents: undefined,
	        //     hidePerson: true
	        //   }
	        // } else if (!this.peopleInDag.has(wife.id)) {
	        //   mother = {
	        //     person: wife,
	        //     level: this.peopleInDag.get(p.id) + 1,
	        //     families: undefined,
	        //     parents: undefined,
	        //     hidePerson: true
	        //   }
	        // }
	        return {
	            father: father,
	            mother: mother
	        };
	    };
	    return DagController;
	}());
	exports.default = rcDagDirective;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcDescendancyDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/descendancy/descendancy.html',
	        controller: DescendancyController,
	        controllerAs: 'descendancy',
	        bindToController: true,
	        scope: {
	            root: '='
	        }
	    };
	}
	var DescendancyController = /** @class */ (function () {
	    DescendancyController.$inject = ["$log", "$scope", "$sanitize", "rx", "persons", "families", "leads", "evidences", "utils"];
	    function DescendancyController($log, $scope, $sanitize, rx, persons, families, leads, evidences, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.$sanitize = $sanitize;
	        this.rx = rx;
	        this.persons = persons;
	        this.families = families;
	        this.leads = leads;
	        this.evidences = evidences;
	        this.utils = utils;
	        this.jstree = null;
	        this.root = this.root;
	        this.init = this.initFn.bind(this);
	        this.select = this.selectFn.bind(this);
	        this.data = this.dataFn.bind(this);
	        this.config = {
	            core: {
	                animation: 200,
	                check_callback: false,
	                data: this.data,
	                dblclick_toggle: false,
	                multiple: false,
	                themes: {
	                    icons: false
	                },
	                worker: false,
	                error: function (error) {
	                    $log.error('jsTree', error);
	                }
	            }
	        };
	        this.$onInit = function () {
	            // readyChange on persons, families, leads, evidences
	            var subscription = utils.readyChange(persons, families, leads, evidences).subscribe(function () {
	                if (!!_this.jstree) {
	                    _this.jstree.refresh();
	                }
	            });
	            $scope.$on('$destroy', function () {
	                subscription.unsubscribe();
	            });
	        };
	    }
	    DescendancyController.prototype.dataFn = function (obj, cb) {
	        var _this = this;
	        var id = obj.id === '#' ? this.root : parseInt(obj.id, 10);
	        if (id === 0) {
	            cb.call(this, []);
	        }
	        else {
	            // get person
	            this.persons.streamId(id).take(1).flatMap(function (person) {
	                // augment person (not needed for non-root, but it's not too expensive)
	                return _this.persons.augmentPerson(person, _this.leads, _this.evidences).map(function (person) {
	                    return {
	                        person: person,
	                        data: {
	                            id: id.toString(),
	                            text: obj.id === '#' ? _this.getText(person, false) : '',
	                            state: {
	                                opened: true
	                            },
	                            children: []
	                        }
	                    };
	                });
	            }).flatMap(function (_a) {
	                var person = _a.person, data = _a.data;
	                if (person === null) {
	                    return _this.rx.Observable.of(data);
	                }
	                // get spouses for person
	                return _this.families.streamSpouses(person.id).take(1).flatMap(function (fm) {
	                    if (fm.size === 0) {
	                        return _this.rx.Observable.of(data);
	                    }
	                    // forkjoin getting spouse families - each returns an object that we append to the children object
	                    return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(fm.values()).map(function (f) {
	                        return _this.getFamilyData(person.id, f);
	                    }))).map(function (familyDatas) {
	                        // order spouses by marriage date
	                        familyDatas.forEach(function (fd) {
	                            fd.marriage = !!fd.person ? _this.persons.getMarriage(person, fd.person) : null;
	                        });
	                        familyDatas.sort(function (fd1, fd2) {
	                            return _this.getFamilySort(fd1) - _this.getFamilySort(fd2);
	                        });
	                        familyDatas.forEach(function (fd) {
	                            delete fd.person;
	                            delete fd.marriage;
	                        });
	                        data.children = familyDatas;
	                        return data;
	                    });
	                    var _a;
	                });
	            }).subscribe(function (data) {
	                cb.call(_this, obj.id === '#' ? [data] : data.children);
	            });
	        }
	    };
	    DescendancyController.prototype.getFamilyData = function (pid, f) {
	        var _this = this;
	        var sid = f.husbandId === pid ? f.wifeId : f.husbandId;
	        // get spouse
	        return this.persons.streamId(sid).take(1).flatMap(function (spouse) {
	            // augment spouse
	            return _this.persons.augmentPerson(spouse, _this.leads, _this.evidences).map(function (spouse) {
	                return {
	                    id: sid > 0 ? sid.toString() : 'f' + f.id,
	                    person: spouse,
	                    text: _this.getText(spouse, true),
	                    state: {
	                        opened: true
	                    },
	                    children: []
	                };
	            });
	        }).flatMap(function (data) {
	            // get children
	            if (f.childRels.size === 0) {
	                return _this.rx.Observable.of(data);
	            }
	            return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(f.childRels.keys()).map(function (cid) {
	                return _this.getChildData(cid);
	            }))).map(function (childDatas) {
	                // order children by birth date
	                childDatas.sort(function (cd1, cd2) {
	                    return _this.getChildSort(cd1) - _this.getChildSort(cd2);
	                });
	                childDatas.forEach(function (cd) {
	                    delete cd.person;
	                });
	                data.children = childDatas;
	                return data;
	            });
	            var _a;
	        });
	    };
	    DescendancyController.prototype.getChildData = function (cid) {
	        var _this = this;
	        // get child
	        return this.persons.streamId(cid).take(1).flatMap(function (child) {
	            // augment child
	            return _this.persons.augmentPerson(child, _this.leads, _this.evidences);
	        }).flatMap(function (child) {
	            // check if child has spouse/children
	            return _this.families.streamSpouses(cid).take(1).map(function (fm) {
	                return {
	                    id: cid.toString(),
	                    person: child,
	                    text: _this.getText(child, false),
	                    children: fm.size > 0,
	                    data: fm.size > 0 ? _this.data : null
	                };
	            });
	        });
	    };
	    DescendancyController.prototype.getChildSort = function (cd) {
	        var birth = this.persons.getPreferredBirth(cd.person);
	        return !!birth && !!birth.dateSort ? parseInt(birth.dateSort, 10) : 0;
	    };
	    DescendancyController.prototype.getFamilySort = function (fd) {
	        return !!fd.marriage && !!fd.marriage.dateSort ? parseInt(fd.marriage.dateSort, 10) : 0;
	    };
	    DescendancyController.prototype.getText = function (person, isSpouse) {
	        var text = '';
	        if (person === null) {
	            text += '<span class="descendancy__name' + (isSpouse ? ' descendancy__spouse' : '') + '">' + (this.persons.translations.find(function (t) { return t.value === 'UNKNOWN'; }).display || '') + '</span>';
	            return text;
	        }
	        if (!!person._iconURL) {
	            text += '<img class="descendancy__icon" img="' + person._iconURL + '"/>';
	        }
	        text += '<span class="descendancy__name' + (isSpouse ? ' descendancy__spouse' : '') + '">' + this.$sanitize(person._fullName) + '</span>';
	        text += '<span class="descendancy__lifespan">' + this.$sanitize(person._lifespan) + '</span>';
	        if (person._stars > 0) {
	            for (var i = 0; i < person._stars && i < 5; i++) {
	                text += '<i class="material-icons star">star</i>';
	            }
	        }
	        if (person._stars > 5) {
	            text += '<i class="material-icons star">add</i>';
	        }
	        if (person._hints > 0) {
	            text += '<span class="leads descendancy__leads">' + person._hints + '</span>';
	        }
	        return text;
	    };
	    DescendancyController.prototype.initFn = function (instance) {
	        this.jstree = instance;
	    };
	    DescendancyController.prototype.selectFn = function (ev, node) {
	        this.jstree.deselect_node(node);
	        if (!node.id.startsWith('f')) {
	            this.utils.dialog(ev, 'RelativesController', 'app/components/relatives/relatives.html', true, {
	                pid: parseInt(node.id, 10)
	            });
	        }
	    };
	    return DescendancyController;
	}());
	exports.default = rcDescendancyDirective;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	rcDescendancyD3Directive.$inject = ["d3"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcDescendancyD3Directive(d3) {
	    'ngInject';
	    var margin = {
	        top: 10,
	        bottom: 10,
	        left: 10,
	        right: 10
	    };
	    var barHeight = 24;
	    var indentWidth = 24;
	    var spouseOutdent = -24;
	    var duration = 250;
	    var minHeight = 100;
	    var width = 600;
	    var showGenerations = 1;
	    var $scope;
	    var svg, svgg;
	    var tree;
	    var root;
	    var nodeIndex = 0;
	    function setup(elem, data) {
	        tree = d3.layout.tree()
	            .nodeSize([0, indentWidth]);
	        svg = d3.select(elem).append("svg")
	            .attr("width", width + margin.left + margin.right);
	        svgg = svg
	            .append("g")
	            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
	        // set initial coordinates
	        data.x0 = 0;
	        data.y0 = 0;
	        root = data;
	        prepare(data, 0, '');
	        update(data);
	    }
	    function prepare(d, level, path) {
	        d.level = level;
	        d.path = path;
	        if (d.children) {
	            d.numOfChildren = d.children.length;
	            d.children.forEach(function (e, i) {
	                var childPath = level % 2 === 0 ? path : (!!path ? path + '.' : '') + (i + 1);
	                prepare(e, level + 1, childPath);
	            });
	            if (level > showGenerations) {
	                d._children = d.children;
	                d.children = null;
	            }
	        }
	        else {
	            d.numOfChildren = 0;
	        }
	    }
	    function countVisibleDescendants(d) {
	        var cnt = 1;
	        if (d.children) {
	            d.children.forEach(function (c) {
	                cnt += countVisibleDescendants(c);
	            });
	        }
	        return cnt;
	    }
	    function update(source) {
	        // Compute the flattened node list. TODO use d3.layout.hierarchy.
	        var nodes = tree.nodes(root);
	        var height = Math.max(minHeight, countVisibleDescendants(root) * barHeight + margin.top + margin.bottom);
	        svg
	            .attr("id", "foo")
	            .transition()
	            .duration(duration)
	            .attr("height", height);
	        // Compute the "layout".
	        nodes.forEach(function (n, i) {
	            n.x = i * barHeight;
	        });
	        // Update the nodes…
	        var node = svgg.selectAll("g.node")
	            .data(nodes, function (d) {
	            return d.index || (d.index = ++nodeIndex);
	        });
	        var nodeEnter = node.enter().append("g")
	            .attr("class", "node")
	            .style("opacity", 0)
	            .attr("transform", "translate(" + source.y0 + "," + source.x0 + ")");
	        // Enter any new nodes at the parent's previous position.
	        nodeEnter.append("path").filter(function (d) { return d.numOfChildren > 0 && d.level % 2 === 0; })
	            .attr("width", 9)
	            .attr("height", 9)
	            .attr("d", "M -5,-7, L -5,7, L 7,0 Z")
	            .attr("class", "descendancy-d3__triangle")
	            .on("click", toggle);
	        node.select("path").attr("transform", function (d) {
	            if (d.children) {
	                return "translate(0, 0)rotate(90)";
	            }
	            else {
	                return "translate(0, 0)rotate(0)";
	            }
	        });
	        // Enter any new nodes at the parent's previous position.
	        var textEnter = nodeEnter.append("text")
	            .attr("dy", 5)
	            .attr("dx", 14)
	            .attr("transform", function (d) { return "translate(" + (d.level % 2 === 1 ? spouseOutdent : 0) + ",0)"; });
	        textEnter.append('tspan')
	            .attr("class", "descendancy-d3__text")
	            .text(function (d) { return ( false ? d.path + '  ' : '') + (d.level % 2 === 1 ? 'sp: ' : '') + d.name; })
	            .on('click', click);
	        textEnter.append("tspan").filter(function (d) { return d.id % 4 > 0; })
	            .attr('dx', 8)
	            .classed('descendancy-d3__stars', true)
	            .text(function (d) {
	            var a = [];
	            var numStars = d.id % 4;
	            for (var i = 0; i < numStars; i++) {
	                a.push('\u2605');
	            }
	            return a.join('');
	        });
	        textEnter.append('tspan').filter(function (d) { return d.id % 3 === 1; })
	            .attr('dx', 5)
	            .attr('dy', 2)
	            .classed('descendancy-d3__leads', true)
	            .text('\u2460');
	        textEnter.append('tspan').filter(function (d) { return d.id % 4 > 0; })
	            .classed('descendancy-d3__tooltip_stars', true)
	            .attr('dx', 5)
	            .text('Number of events with sources');
	        textEnter.append('tspan').filter(function (d) { return d.id % 3 === 1; })
	            .classed('descendancy-d3__tooltip_leads', true)
	            .attr('dx', function (d) { return d.id % 4 > 0 ? -185 : 15; })
	            .text('Number of hints available');
	        // Transition nodes to their new position.
	        nodeEnter.transition()
	            .duration(duration)
	            .attr("transform", function (d) { return "translate(" + d.y + "," + d.x + ")"; })
	            .style("opacity", 1);
	        node.transition()
	            .duration(duration)
	            .attr("transform", function (d) { return "translate(" + d.y + "," + d.x + ")"; })
	            .style("opacity", 1)
	            .select("rect");
	        // Transition exiting nodes to the parent's new position.
	        node.exit().transition()
	            .duration(duration)
	            .attr("transform", function () { return "translate(" + source.y + "," + source.x + ")"; })
	            .style("opacity", 0)
	            .remove();
	        // Stash the old positions for transition.
	        nodes.forEach(function (d) {
	            d.x0 = d.x;
	            d.y0 = d.y;
	        });
	    }
	    function open(d) {
	        if (!!d._children) {
	            d.children = d._children;
	            d._children = null;
	        }
	    }
	    function closeAll(d) {
	        if (!!d.children) {
	            d.children.forEach(closeAll);
	            d._children = d.children;
	            d.children = null;
	        }
	    }
	    // Toggle children on click.
	    function toggle(d) {
	        if (!!d.children) {
	            closeAll(d);
	        }
	        else if (!!d._children) {
	            open(d);
	            // open spouses as well
	            if (d.level % 2 === 0) {
	                d.children.forEach(open);
	            }
	        }
	        update(d);
	    }
	    function click(d) {
	        $scope.$apply(function () {
	            $scope.$emit('click', { family: d, event: d3.event });
	        });
	    }
	    function link(scope, elem) {
	        $scope = scope;
	        setup(elem[0], scope.data);
	    }
	    return {
	        restrict: 'E',
	        link: link,
	        template: '<div></div>',
	        scope: {
	            data: '='
	        }
	    };
	}
	exports.default = rcDescendancyD3Directive;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	function rcDNACompareDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/dnaCompare/dnaCompare.html',
	        controller: DNACompareController,
	        controllerAs: 'dnaCompare',
	        bindToController: true,
	        scope: {}
	    };
	}
	var DNACompareController = /** @class */ (function () {
	    DNACompareController.$inject = ["$log", "$scope", "rx", "dnaKits", "dnaProfiles", "dnaProfileDatas", "dnaParsers", "persons", "families", "relationshipUtils", "utils"];
	    function DNACompareController($log, $scope, rx, dnaKits, dnaProfiles, dnaProfileDatas, dnaParsers, persons, families, relationshipUtils, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.utils = utils;
	        this.dnaMatchesMap = new Map();
	        this.dnaMatchesMapVersion = 0; // update every time you get new dna matches
	        // listen for dnaMatchesMap change events and update dnaMatchesMap
	        $scope.$on('dna-matches-update', function (ev, matches) {
	            _this.dnaMatchesMap = matches;
	            _this.dnaMatchesMapVersion++;
	        });
	        this.$onInit = function () {
	            var sub = rx.Observable.combineLatest(utils.watch($scope, function () { return _this.dnaMatchesMapVersion; }), utils.readyChange(dnaKits, dnaProfiles, dnaProfileDatas, persons, families)).subscribe(function (_a) {
	                var _b = __read(_a, 2), _ = _b[0], _c = __read(_b[1], 4), kitMap = _c[0], profileMap = _c[1], profileDatasMap = _c[2], personMap = _c[3];
	                var parentsMap = families.getParentsMap();
	                // calculate the set of dna profiles and kits that we're interested in
	                var targetProfilesMap = new Map();
	                var targetKitsMap = new Map();
	                try {
	                    for (var _d = __values(_this.dnaMatchesMap.values()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                        var match = _e.value;
	                        try {
	                            for (var _f = __values(match.profiles), _g = _f.next(); !_g.done; _g = _f.next()) {
	                                var profile = _g.value;
	                                targetProfilesMap.set(profile.id, profile);
	                            }
	                        }
	                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                        finally {
	                            try {
	                                if (_g && !_g.done && (_h = _f.return)) _h.call(_f);
	                            }
	                            finally { if (e_1) throw e_1.error; }
	                        }
	                        try {
	                            for (var _j = __values(match.kits), _k = _j.next(); !_k.done; _k = _j.next()) {
	                                var kit = _k.value;
	                                targetKitsMap.set(kit.id, kit);
	                            }
	                        }
	                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                        finally {
	                            try {
	                                if (_k && !_k.done && (_l = _j.return)) _l.call(_j);
	                            }
	                            finally { if (e_2) throw e_2.error; }
	                        }
	                    }
	                }
	                catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                finally {
	                    try {
	                        if (_e && !_e.done && (_m = _d.return)) _m.call(_d);
	                    }
	                    finally { if (e_3) throw e_3.error; }
	                }
	                // calculate profile kits by name for each profile
	                var profileKitsByNameMap = new Map();
	                var _loop_1 = function (profile) {
	                    kitMap = new Map(Array.from(kitMap.values()).filter(function (kit) { return kit.source === profile.source && targetKitsMap.has(kit.id); }).map(function (kit) { return [kit.name, kit]; }));
	                    profileKitsByNameMap.set(profile.id, kitMap);
	                };
	                try {
	                    for (var _o = __values(targetProfilesMap.values()), _p = _o.next(); !_p.done; _p = _o.next()) {
	                        var profile = _p.value;
	                        _loop_1(profile);
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (_p && !_p.done && (_q = _o.return)) _q.call(_o);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	                // calculate profile list and triangulation matches for each profile
	                var listMatchesMap = new Map();
	                var triangulationMatchesMap = new Map();
	                var _loop_2 = function (profile) {
	                    try {
	                        for (var _a = __values(profileDatasMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                            var dpd = _b.value;
	                            if (dpd.profileId === profile.id && dpd.type === 'LIST') {
	                                // parse dpd to get kit matches
	                                var m = dnaParsers.tsvToList(dnaProfiles.listTSVHeaders[profile.source], dnaProfiles.listTSVNumbers[profile.source], dpd.tsv).filter(function (match) {
	                                    return profileKitsByNameMap.get(profile.id).has(match.name);
	                                });
	                                listMatchesMap.set(profile.id, m);
	                            }
	                            if (dpd.profileId === profile.id && dpd.type === 'TRIANGULATION') {
	                                var m = dnaParsers.tsvToList(dnaProfiles.triangulationTSVHeaders[profile.source], dnaProfiles.triangulationTSVNumbers[profile.source], dpd.tsv).filter(function (match) {
	                                    var kitsByName = profileKitsByNameMap.get(profile.id);
	                                    return kitsByName.has(match.kit1) && kitsByName.has(match.kit2);
	                                });
	                                triangulationMatchesMap.set(profile.id, m);
	                            }
	                        }
	                    }
	                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
	                    finally {
	                        try {
	                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                        }
	                        finally { if (e_5) throw e_5.error; }
	                    }
	                    var e_5, _c;
	                };
	                try {
	                    for (var _r = __values(targetProfilesMap.values()), _s = _r.next(); !_s.done; _s = _r.next()) {
	                        var profile = _s.value;
	                        _loop_2(profile);
	                    }
	                }
	                catch (e_6_1) { e_6 = { error: e_6_1 }; }
	                finally {
	                    try {
	                        if (_s && !_s.done && (_t = _r.return)) _t.call(_r);
	                    }
	                    finally { if (e_6) throw e_6.error; }
	                }
	                // calculate pairs
	                var pairs = [];
	                try {
	                    for (var _u = __values(_this.dnaMatchesMap.keys()), _v = _u.next(); !_v.done; _v = _u.next()) {
	                        var pid = _v.value;
	                        var person = personMap.get(pid);
	                        var personMatches = _this.dnaMatchesMap.get(person.id);
	                        try {
	                            // get person -> profile -> kit -> person matches
	                            for (var _w = __values(personMatches.profiles), _x = _w.next(); !_x.done; _x = _w.next()) {
	                                var profile = _x.value;
	                                var matches = listMatchesMap.get(profile.id) || new Map();
	                                try {
	                                    for (var _y = __values(matches.values()), _z = _y.next(); !_z.done; _z = _y.next()) {
	                                        var listMatch = _z.value;
	                                        var kit = profileKitsByNameMap.get(profile.id).get(listMatch.name);
	                                        if (!!kit && kit.matchType === 'SELF' && kit.personId1 !== person.id) {
	                                            var person2 = personMap.get(kit.personId1);
	                                            if (!!person2) {
	                                                pairs.push({ p1: person, p2: person2, cm: listMatch.autoTotal });
	                                            }
	                                        }
	                                    }
	                                }
	                                catch (e_7_1) { e_7 = { error: e_7_1 }; }
	                                finally {
	                                    try {
	                                        if (_z && !_z.done && (_0 = _y.return)) _0.call(_y);
	                                    }
	                                    finally { if (e_7) throw e_7.error; }
	                                }
	                            }
	                        }
	                        catch (e_8_1) { e_8 = { error: e_8_1 }; }
	                        finally {
	                            try {
	                                if (_x && !_x.done && (_1 = _w.return)) _1.call(_w);
	                            }
	                            finally { if (e_8) throw e_8.error; }
	                        }
	                        try {
	                            // get person -> kit -> matching kit -> person matches
	                            for (var _2 = __values(personMatches.kits), _3 = _2.next(); !_3.done; _3 = _2.next()) {
	                                var kit = _3.value;
	                                try {
	                                    for (var _4 = __values(targetProfilesMap.values()), _5 = _4.next(); !_5.done; _5 = _4.next()) {
	                                        var profile = _5.value;
	                                        if (kit.source === profile.source) {
	                                            var matches = triangulationMatchesMap.get(profile.id) || new Map();
	                                            var matchTotals = new Map();
	                                            try {
	                                                for (var _6 = __values(matches.values()), _7 = _6.next(); !_7.done; _7 = _6.next()) {
	                                                    var triangulationMatch = _7.value;
	                                                    var matchingKitName = triangulationMatch.kit1 === kit.name ? triangulationMatch.kit2 :
	                                                        triangulationMatch.kit2 === kit.name ? triangulationMatch.kit1 : null;
	                                                    if (!!matchingKitName) {
	                                                        var matchTotal = matchTotals.get(matchingKitName) || 0;
	                                                        matchTotal += triangulationMatch.cm;
	                                                        matchTotals.set(matchingKitName, matchTotal);
	                                                    }
	                                                }
	                                            }
	                                            catch (e_9_1) { e_9 = { error: e_9_1 }; }
	                                            finally {
	                                                try {
	                                                    if (_7 && !_7.done && (_8 = _6.return)) _8.call(_6);
	                                                }
	                                                finally { if (e_9) throw e_9.error; }
	                                            }
	                                            try {
	                                                for (var _9 = __values(matchTotals.keys()), _10 = _9.next(); !_10.done; _10 = _9.next()) {
	                                                    var matchingKitName = _10.value;
	                                                    var kit_1 = profileKitsByNameMap.get(profile.id).get(matchingKitName);
	                                                    if (!!kit_1 && kit_1.matchType === 'SELF' && kit_1.personId1 !== person.id) {
	                                                        var person2 = personMap.get(kit_1.personId1);
	                                                        if (!!person2) {
	                                                            pairs.push({ p1: person, p2: person2, cm: matchTotals.get(matchingKitName) });
	                                                        }
	                                                    }
	                                                }
	                                            }
	                                            catch (e_10_1) { e_10 = { error: e_10_1 }; }
	                                            finally {
	                                                try {
	                                                    if (_10 && !_10.done && (_11 = _9.return)) _11.call(_9);
	                                                }
	                                                finally { if (e_10) throw e_10.error; }
	                                            }
	                                        }
	                                    }
	                                }
	                                catch (e_11_1) { e_11 = { error: e_11_1 }; }
	                                finally {
	                                    try {
	                                        if (_5 && !_5.done && (_12 = _4.return)) _12.call(_4);
	                                    }
	                                    finally { if (e_11) throw e_11.error; }
	                                }
	                            }
	                        }
	                        catch (e_12_1) { e_12 = { error: e_12_1 }; }
	                        finally {
	                            try {
	                                if (_3 && !_3.done && (_13 = _2.return)) _13.call(_2);
	                            }
	                            finally { if (e_12) throw e_12.error; }
	                        }
	                    }
	                }
	                catch (e_13_1) { e_13 = { error: e_13_1 }; }
	                finally {
	                    try {
	                        if (_v && !_v.done && (_14 = _u.return)) _14.call(_u);
	                    }
	                    finally { if (e_13) throw e_13.error; }
	                }
	                // generate people array
	                _this.pairPeople = [];
	                var _loop_3 = function (pair) {
	                    var ix1 = _this.pairPeople.findIndex(function (pp) { return pp.id === pair.p1.id; });
	                    if (ix1 < 0) {
	                        ix1 = _this.pairPeople.length;
	                        _this.pairPeople.push(pair.p1);
	                    }
	                    var ix2 = _this.pairPeople.findIndex(function (pp) { return pp.id === pair.p2.id; });
	                    if (ix2 < 0) {
	                        ix2 = _this.pairPeople.length;
	                        _this.pairPeople.push(pair.p2);
	                    }
	                };
	                try {
	                    for (var pairs_1 = __values(pairs), pairs_1_1 = pairs_1.next(); !pairs_1_1.done; pairs_1_1 = pairs_1.next()) {
	                        var pair = pairs_1_1.value;
	                        _loop_3(pair);
	                    }
	                }
	                catch (e_14_1) { e_14 = { error: e_14_1 }; }
	                finally {
	                    try {
	                        if (pairs_1_1 && !pairs_1_1.done && (_15 = pairs_1.return)) _15.call(pairs_1);
	                    }
	                    finally { if (e_14) throw e_14.error; }
	                }
	                //
	                _this.pairPeople.sort(function (a, b) {
	                    return a._birthDateSort > b._birthDateSort || (a._birthDateSort === b._birthDateSort && a.id > b.id);
	                });
	                // generate boxes
	                _this.boxes = [];
	                var _loop_4 = function (i) {
	                    var xPid = _this.pairPeople[i].id;
	                    var _loop_5 = function (j) {
	                        var yPid = _this.pairPeople[j].id;
	                        var pair = pairs.find(function (pair) {
	                            return (pair.p1.id === xPid && pair.p2.id === yPid) ||
	                                (pair.p2.id === xPid && pair.p1.id === yPid);
	                        });
	                        var cm = !!pair ? pair.cm : 'Unknown';
	                        var relationship = relationshipUtils.getRelationship(xPid, yPid, parentsMap);
	                        var cmInfo = relationshipUtils.getSharedCMInfo(relationship);
	                        var avg = !!cmInfo ? cmInfo.avg : 0;
	                        var range = !!cmInfo ? cmInfo.range : '';
	                        _this.boxes.push({ x: j, y: _this.pairPeople.length - i - 1, cm: cm, rel: relationship, avg: avg, range: range });
	                    };
	                    for (var j = 0; j < i; j++) {
	                        _loop_5(j);
	                    }
	                };
	                for (var i = 1; i < _this.pairPeople.length; i++) {
	                    _loop_4(i);
	                }
	                var e_3, _m, e_1, _h, e_2, _l, e_4, _q, e_6, _t, e_13, _14, e_8, _1, e_7, _0, e_12, _13, e_11, _12, e_9, _8, e_10, _11, e_14, _15;
	            });
	            $scope.$on('$destroy', function () {
	                sub.unsubscribe();
	            });
	        };
	    }
	    return DNACompareController;
	}());
	exports.default = rcDNACompareDirective;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcDNAKitDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/dnaKit/dnaKit.html',
	        controller: DNAKitController,
	        controllerAs: 'kit',
	        bindToController: true,
	        scope: {
	            id: '=',
	            dnaProfile: '=',
	            pedigree: '=',
	            expanded: '='
	        }
	    };
	}
	var DNAKitController = /** @class */ (function () {
	    DNAKitController.$inject = ["$log", "$scope", "treeUsers", "currentTree", "dnaKits", "dnaParsers", "dnaProfiles", "dnaProfileDatas", "persons", "rightsFull", "utils"];
	    function DNAKitController($log, $scope, treeUsers, currentTree, dnaKits, dnaParsers, dnaProfiles, dnaProfileDatas, persons, rightsFull, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.utils = utils;
	        this.highlight = [];
	        this.matches = [];
	        this.segments = null;
	        this.minitree = null;
	        this.dnaProfiles = dnaProfiles;
	        this.ready = false;
	        this.encodeId = utils.encodeId.bind(utils);
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        currentTree.stream().filter(function (t) { return !!t; }).take(1).subscribe(function (tree) {
	            _this.treePrefs = tree.preferences;
	        });
	        treeUsers.stream().take(1).subscribe(function () {
	            _this.ready = true;
	        });
	        this.$onInit = function () {
	            var p1Sub;
	            var p2Sub;
	            var dpdSub;
	            var dkSub = dnaKits.streamId(_this.id).subscribe(function (kit) {
	                _this.dnaKit = kit;
	                if (!!kit.minitree) {
	                    _this.minitree = angular.fromJson(kit.minitree);
	                }
	                var pids = [];
	                if (!!kit.personId1) {
	                    pids.push(kit.personId1);
	                    if (!!p1Sub) {
	                        p1Sub.unsubscribe();
	                    }
	                    p1Sub = persons.streamId(kit.personId1).subscribe(function (person) {
	                        _this.person1 = person;
	                    });
	                }
	                if (!!kit.personId2) {
	                    pids.push(kit.personId2);
	                    if (!!p2Sub) {
	                        p2Sub.unsubscribe();
	                    }
	                    p2Sub = persons.streamId(kit.personId2).subscribe(function (person) {
	                        _this.person2 = person;
	                    });
	                }
	                _this.highlight = [];
	                _this.matches = [];
	                if (kit.colorOverride) {
	                    _this.matches.push(_this.utils.colorOverrideBase + kit.colorOverride);
	                    _this.matches.push(_this.utils.colorOverrideBase + kit.colorOverride);
	                }
	                else if (kit.matchType === 'NOT') {
	                    _this.matches.push(_this.utils.colorNOT);
	                    _this.matches.push(_this.utils.colorNOT);
	                }
	                if (pids.length > 0) {
	                    dnaProfiles.getMatches(_this.pedigree, pids).take(1).subscribe(function (matches) {
	                        if (matches.length === 1) {
	                            matches.push(matches[0]);
	                        }
	                        matches = matches.map(function (match) {
	                            // we can't match beyond what we show, so bring it down
	                            while (match >= 128) {
	                                match = match >>> 1; // jshint ignore:line
	                            }
	                            return match;
	                        });
	                        _this.highlight = Array.from(_this.pedigree.entries())
	                            .filter(function (_a) {
	                            var _b = __read(_a, 2), id = _b[0], pos = _b[1];
	                            return matches.includes(pos);
	                        })
	                            .map(function (_a) {
	                            var _b = __read(_a, 2), id = _b[0], pos = _b[1];
	                            return id;
	                        }); //eslint-disable-line
	                        if (!kit.colorOverride && kit.matchType !== 'NOT') {
	                            _this.matches = matches;
	                        }
	                    });
	                }
	                _this.segments = null;
	                if (!!dpdSub) {
	                    dpdSub.unsubscribe();
	                }
	                dpdSub = dnaProfileDatas.stream().map(function (dpdMap) { return Array.from(dpdMap.values())
	                    .filter(function (dpd) { return dpd.profileId === _this.dnaProfile.id && dpd.type === 'SEGMENT'; }); }).subscribe(function (dpd) {
	                    if (!!dpd && dpd.length > 0) {
	                        var list = dnaParsers.tsvToList(dnaProfiles.segmentTSVHeaders[kit.source], dnaProfiles.segmentTSVNumbers[kit.source], dpd[0].tsv);
	                        _this.segments = list.filter(function (item) { return item.name === kit.name; }).map(function (item) {
	                            return {
	                                chr: item.chr,
	                                color: '#fdc010',
	                                range: [item.start, item.end],
	                                cm: item.cm,
	                                startText: utils.formatCommas(item.start),
	                                endText: utils.formatCommas(item.end)
	                            };
	                        });
	                    }
	                });
	            });
	            $scope.$on('$destroy', function () {
	                dkSub.unsubscribe();
	                dpdSub.unsubscribe();
	                if (!!p1Sub) {
	                    p1Sub.unsubscribe();
	                }
	                if (!!p2Sub) {
	                    p2Sub.unsubscribe();
	                }
	            });
	        };
	    }
	    DNAKitController.prototype.asArray = function (m) {
	        return Array.from(m.keys());
	    };
	    DNAKitController.prototype.getMatchBackground = function (ahnentafel) {
	        return this.utils.getAhnentafelColor(this.treePrefs, ahnentafel, false);
	    };
	    DNAKitController.prototype.gedmatchLink = function (mode, ev) {
	        this.utils.dialog(ev, 'GedmatchController', 'app/components/gedmatch/gedmatch.html', true, {
	            mode: mode,
	            kitId: this.dnaKit.name
	        });
	    };
	    DNAKitController.prototype.isGedmatchURL = function (url) {
	        return url.startsWith('https://www.gedmatch.com');
	    };
	    DNAKitController.prototype.formatTreeURL = function (url) {
	        return url.replace(/^http:\/\/trees\.ancestry\.com\/pt\/pedigree\.aspx\?tid=(.*)$/, 'https://www.ancestry.com/family-tree/tree/$1/family/pedigree');
	    };
	    DNAKitController.prototype.toggleExpand = function () {
	        this.$scope.$emit('toggleExpand', { type: 'dna-kit', id: this.id });
	    };
	    DNAKitController.prototype.edit = function (ev) {
	        this.$scope.$emit('edit', { ev: ev, type: 'dna-kit', item: this.dnaKit, tab: 0 });
	    };
	    DNAKitController.prototype.setColor = function (ev) {
	        this.$scope.$emit('edit', { ev: ev, type: 'dna-kit', item: this.dnaKit, tab: 2 });
	    };
	    return DNAKitController;
	}());
	exports.default = rcDNAKitDirective;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

	"use strict";
	rcDNAKitsDirective.$inject = ["$window", "$interval"];
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcDNAKitsDirective($window, $interval) {
	    'ngInject';
	    var bottomMargin = 16;
	    function link(scope, elem) {
	        //let offset = elem.find('md-virtual-repeat-container')[0].getBoundingClientRect().top - elem[0].getBoundingClientRect().top;
	        function setHeight() {
	            //let totalHeight = $window.innerHeight;
	            var kits = elem.find('.dna-kits')[0];
	            var height = $window.innerHeight - kits.getBoundingClientRect().top - bottomMargin;
	            //let viewElement = angular.element('.dna-kits__inner')[0];
	            //if (!!viewElement) {
	            //  height = Math.max(height, viewElement.scrollHeight);
	            //}
	            if (!!kits) {
	                //let height = totalHeight - bottomMargin;
	                //height = Math.max(height - bottomMargin, rightAdHeight - offset);
	                elem.find('.dna-kits').css('height', height + 'px');
	            }
	        }
	        $interval(function () {
	            setHeight();
	        }, 1000);
	        //scope.$on('resetHeight', setHeight);
	        //
	        //angular.element($window).on('resize', setHeight);
	        //elem.on('$destroy', function() {
	        //  angular.element($window).off('resize', setHeight);
	        //});
	    }
	    return {
	        restrict: 'E',
	        link: link,
	        templateUrl: 'app/components/dnaKits/dnaKits.html',
	        controller: DNAKitsController,
	        controllerAs: 'kits',
	        bindToController: true,
	        scope: {
	            selectedKits: '=',
	            pedigree: '=',
	            dnaProfile: '='
	        }
	    };
	}
	var DNAKitsController = /** @class */ (function () {
	    DNAKitsController.$inject = ["$log", "$scope", "utils"];
	    function DNAKitsController($log, $scope, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.utils = utils;
	        this.expanded = new Set();
	        this.ids = [];
	        this.expandDefault = false;
	        // TODO drop expanded and use selectedKits.get(id).open everywhere
	        this.$onInit = function () {
	            var kSub = utils.watch($scope, function () { return _this.selectedKits; }).subscribe(function () {
	                _this.expanded.clear();
	                _this.ids = [];
	                if (!!_this.selectedKits) {
	                    try {
	                        for (var _a = __values(_this.selectedKits.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                            var kit = _b.value;
	                            _this.ids.push(kit.id);
	                            if (kit.open) {
	                                _this.expanded.add(kit.id);
	                            }
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                }
	                var e_1, _c;
	            });
	            $scope.$on('edit', function (ev, params) {
	                utils.dialog(params.ev, 'EditDNAKitController', 'app/components/editDNAKit/editDNAKit.html', false, {
	                    kit: params.item,
	                    tab: params.tab,
	                    dnaProfile: _this.dnaProfile,
	                    pedigree: _this.pedigree
	                }).then(function (kit) {
	                    $scope.$emit('kit-edited', kit);
	                });
	            });
	            $scope.$on('toggleExpand', function (ev, params) {
	                var open;
	                if (_this.expanded.has(params.id)) {
	                    open = false;
	                    _this.expanded.delete(params.id);
	                }
	                else {
	                    open = true;
	                    _this.expanded.add(params.id);
	                }
	                var selectedKits = new Map(_this.selectedKits);
	                var kit = selectedKits.get(params.id);
	                if (!!kit) {
	                    kit.open = open;
	                }
	                $scope.$emit('selected-kits', selectedKits);
	            });
	            $scope.$on('$destroy', function () {
	                kSub.unsubscribe();
	            });
	        };
	    }
	    DNAKitsController.prototype.isExpanded = function (id) {
	        return this.expanded.has(id);
	    };
	    return DNAKitsController;
	}());
	exports.default = rcDNAKitsDirective;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcDNAProfileForceDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/dnaProfile/dnaProfileForce.html',
	        controller: DNAProfileForceController,
	        controllerAs: 'force',
	        bindToController: true,
	        scope: {
	            dnaProfile: '=',
	            ownerIsPro: '=',
	            pedigree: '=',
	            kits: '=',
	            selectedKits: '=',
	            highlighted: '='
	        }
	    };
	}
	var linkMultiplier = 1200;
	var icwLinkValue = 200;
	var defaultColor = '#eeeeee';
	var maxLinks = 25000;
	var DNAProfileForceController = /** @class */ (function () {
	    DNAProfileForceController.$inject = ["$log", "$scope", "$state", "$timeout", "$filter", "rx", "treeUsers", "currentTree", "dnaProfileDatas", "dnaParsers", "dnaKits", "dnaProfiles", "messageBus", "server", "subscriptions", "utils"];
	    function DNAProfileForceController($log, $scope, $state, $timeout, $filter, rx, treeUsers, currentTree, dnaProfileDatas, dnaParsers, dnaKits, dnaProfiles, messageBus, server, subscriptions, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.$timeout = $timeout;
	        this.$filter = $filter;
	        this.rx = rx;
	        this.dnaProfileDatas = dnaProfileDatas;
	        this.dnaParsers = dnaParsers;
	        this.dnaKits = dnaKits;
	        this.dnaProfiles = dnaProfiles;
	        this.messageBus = messageBus;
	        this.server = server;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.showInput = false;
	        this.hasData = false;
	        this.nodes = null;
	        this.links = null;
	        this.defaultColor = defaultColor;
	        this.dpdId = 0;
	        this.isProcessing = false;
	        this.kitMap = new Map();
	        this.rangeTimeout = null;
	        this.maxLinksAnnounced = false;
	        this.presentationMode = false;
	        currentTree.stream().filter(function (t) { return !!t; }).take(1).subscribe(function (tree) {
	            _this.treePrefs = tree.preferences;
	        });
	        subscriptions.stream().filter(function (x) { return !!x; }).take(1).subscribe(function (sub) {
	            if (sub.level !== 'PRO_TRIAL' && sub.level !== 'PRO') {
	                utils.confirm('Triangulation view requires a Premium Plan', 'Would you like to check out a Premium plan subscription?')
	                    .then(function () {
	                    window.location = 'https://my.americanancestors.org/donate/i/38';
	                    //$state.go('userSettings');
	                }, function () {
	                    $state.go('tree.dna-profile', { view: 'list' }, { reload: true });
	                });
	            }
	        });
	        this.$onInit = function () {
	            _this.source = _this.dnaProfile.source;
	            var dpdSub = treeUsers.stream().take(1).flatMap(function (tu) {
	                _this.presentationMode = (tu.preferences['PRESENTATION_MODE'] || 'FALSE') === 'TRUE';
	                return _this.streamDNAProfileData();
	            }).flatMap(function (dpds) { return utils.watch($scope, function () { return _this.kits; }).map(function () {
	                return {
	                    dpd: dpds.find(function (dpd) { return dpd.type === 'TRIANGULATION'; }),
	                    segment: dpds.find(function (dpd) { return dpd.type === 'SEGMENT'; }),
	                    list: dpds.find(function (dpd) { return dpd.type === 'LIST'; }),
	                    kits: _this.kits
	                };
	            }); }).subscribe(function (data) {
	                if (!!data.dpd && !!data.kits) {
	                    _this.showInput = false;
	                    _this.hasData = true;
	                    _this.dpdId = data.dpd.id;
	                    _this.kitMap = new Map(data.kits.map(function (kit) { return [kit.name, kit]; }));
	                    // construct data
	                    _this.constructData(data.dpd, data.segment, data.list, _this.kitMap).take(1).subscribe(function (data) {
	                        _this.allData = data;
	                        if (data.nodes.length === 0) {
	                            _this.utils.alert('No DNA matches found', 'Please re-import your DNA matches by clicking on the + near the upper-right.');
	                            _this.nodes = [];
	                            _this.links = [];
	                        }
	                        else if (data.links.length > maxLinks) {
	                            if (!_this.maxLinksAnnounced) {
	                                _this.utils.alert('Too many links to show', 'There are over 25,000 links between matches, which is too many to show. ' +
	                                    'Please click on "Filters" to add a filter.');
	                                _this.maxLinksAnnounced = true;
	                            }
	                            _this.nodes = [];
	                            _this.links = [];
	                        }
	                        else {
	                            _this.nodes = data.nodes;
	                            _this.links = data.links;
	                        }
	                    });
	                }
	                else if (!data.dpd) {
	                    _this.showInput = true;
	                }
	            });
	            $scope.$on('show', function (ev, params) {
	                var selectedKits = new Map(_this.selectedKits);
	                if (params.removeAll) {
	                    selectedKits.clear();
	                }
	                else if (params.remove) {
	                    params.nodes.forEach(function (node) {
	                        var kit = Array.from(selectedKits.values()).find(function (kit) { return kit.name === node.name; });
	                        if (!!kit) {
	                            selectedKits.delete(kit.id);
	                        }
	                        //this.getLinkedNodes(node.name).forEach(n => {
	                        //  this.selectedKits.delete(n.name);
	                        //});
	                    });
	                }
	                else {
	                    if (!params.add) {
	                        selectedKits.clear();
	                    }
	                    params.nodes.forEach(function (node) {
	                        var kit = _this.kitMap.get(node.name);
	                        if (!!kit && !selectedKits.has(kit.id)) {
	                            selectedKits.set(kit.id, {
	                                id: kit.id,
	                                name: kit.name,
	                                open: selectedKits.size === 0 && params.nodes.length === 1
	                            });
	                        }
	                        //if (params.nodes.length === 1) {
	                        //  this.getLinkedNodes(node.name).forEach(n => {
	                        //    this.selectedKits.set(n.name, false);
	                        //  });
	                        //}
	                    });
	                }
	                $scope.$emit('selected-kits', selectedKits);
	                //let kits = [];
	                //for (let [name, open] of this.selectedKits) {
	                //  console.log('show', name, open);
	                //  let kit = this.kitMap.get(name);
	                //  if (!!kit) {
	                //    kits.push({id: kit.id, name: kit.name, open: open});
	                //  }
	                //}
	                //$scope.$emit('selected-kits', kits);
	            });
	            $scope.$on('add', function () {
	                _this.showInput = !_this.showInput;
	            });
	            $scope.$on('paste', function (ev, params) {
	                //if (!this.ownerIsPro) {
	                //  this.utils.alert('Pro Plan Required',
	                //    'DNA features require a Pro plan. To upgrade to a Pro plan, click on your name in the upper-right corner, then select "Account".', params.ev);
	                //  return;
	                //}
	                _this.isProcessing = true;
	                _this.server.incRequests();
	                $timeout(function () {
	                    _this.paste(params);
	                }, 100);
	            });
	            $scope.$on('$destroy', function () {
	                dpdSub.unsubscribe();
	            });
	        };
	    }
	    DNAProfileForceController.prototype.streamDNAProfileData = function () {
	        var _this = this;
	        return this.dnaProfileDatas.stream().map(function (dpdMap) { return Array.from(dpdMap.values()).filter(function (dpd) {
	            return dpd.profileId === _this.dnaProfile.id && (dpd.type === 'TRIANGULATION' || dpd.type === 'SEGMENT' || dpd.type === 'LIST');
	        }); });
	    };
	    DNAProfileForceController.prototype.normalizeUser = function (user) {
	        return (user || '').toLowerCase().replace(/^mrs?\b/, '').replace('.', '').trim();
	    };
	    DNAProfileForceController.prototype.upload = function (file) {
	        var _this = this;
	        var reader = new FileReader();
	        reader.onload = function () {
	            var text = reader.result;
	            console.log('dnaProfileForce.upload', text.length);
	            _this.$timeout(function () {
	                _this.server.incRequests();
	                // read existing kits
	                _this.dnaKits.stream().take(1).subscribe(function (kitMap) {
	                    var rawData = _this.dnaParsers.parseTriangulationCSV(text, _this.source);
	                    _this.processData(rawData);
	                });
	            });
	        };
	        reader.readAsText(file);
	    };
	    DNAProfileForceController.prototype.paste = function (params) {
	        if (!params || !params.html) {
	            this.messageBus.post({ msg: 'Text not found; please go back and press Control-A and Control-C to re-copy.' });
	            this.isProcessing = false;
	            this.server.decRequests();
	            return;
	        }
	        var rawData;
	        try {
	            rawData = this.dnaParsers.parseGedMatchTriangulation(params.html);
	        }
	        catch (err) {
	            this.$log.error('Error parsing triangulation: ', err);
	            this.messageBus.post({ msg: 'Error importing triangulation data; please contact support@rootsfinder.com', warn: true, warnParams: { err: err, text: params.text.substr(0, 500) } });
	            throw new Error(err);
	        }
	        this.processData(rawData);
	    };
	    DNAProfileForceController.prototype.processData = function (rawData) {
	        var _this = this;
	        var pw = this.utils.pleaseWait();
	        var _a = __read(!!rawData ? this.dnaParsers.processTriangulationData(rawData, this.source) : [[], []], 2), list = _a[0], kits = _a[1];
	        var missingMatchesCount = 0;
	        if (list.length === 0 || kits.length === 0) {
	            this.utils.pleaseWaitCancel(pw);
	            this.messageBus.post({ msg: 'This import is not recognized. Please contact support@rootsfinder.com' });
	            this.isProcessing = false;
	            this.server.decRequests();
	            return;
	        }
	        // read existing kits
	        this.dnaKits.stream().take(1).map(function (kitMap) {
	            // group by name
	            kitMap = _this.dnaProfiles.kitsByName(kitMap, _this.source);
	            var missingKits = new Set();
	            // for each new kit: add or update?
	            kits.forEach(function (kit) {
	                if (!kitMap.has(kit.name)) {
	                    missingMatchesCount++;
	                    missingKits.add(kit.name);
	                }
	            });
	            console.log('missing', Array.from(missingKits.values()));
	            // remove entries from list where either kit is missing
	            list = list.filter(function (item) { return !(missingKits.has(item.kit1) || missingKits.has(item.kit2)); });
	        }).flatMap(function () {
	            console.log('list', list.length);
	            return _this.streamDNAProfileData().take(1).map(function (dpds) { return dpds.find(function (dpd) { return dpd.type === 'TRIANGULATION'; }); });
	        }).flatMap(function (existing) {
	            console.log('existing', !!existing);
	            // convert list to tsv
	            var tsv = _this.dnaParsers.listToTSV(_this.dnaProfiles.triangulationTSVHeaders[_this.source], list);
	            // do we have existing data ?
	            if (!!existing) {
	                var dpd = _this.utils.clone(existing);
	                if (_this.reset) {
	                    dpd.tsv = tsv;
	                }
	                else {
	                    // convert existing data to map
	                    var oldMap = _this.dnaParsers.tsvToMap(_this.dnaProfiles.triangulationTSVHeaders[_this.source], _this.dnaProfiles.triangulationTSVNumbers[_this.source], _this.mapKeyFn, existing.tsv);
	                    // convert new data to map
	                    var newMap = _this.dnaParsers.tsvToMap(_this.dnaProfiles.triangulationTSVHeaders[_this.source], _this.dnaProfiles.triangulationTSVNumbers[_this.source], _this.mapKeyFn, tsv);
	                    try {
	                        // merge maps
	                        for (var _a = __values(newMap.entries()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                            var _c = __read(_b.value, 2), key = _c[0], value = _c[1];
	                            oldMap.set(key, value);
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                    // convert merged map to tsv
	                    dpd.tsv = _this.dnaParsers.listToTSV(_this.dnaProfiles.triangulationTSVHeaders[_this.source], oldMap.values());
	                }
	                // update existing dpd
	                return _this.dnaProfileDatas.update(dpd).map(function () { return list.length; });
	            }
	            else {
	                // add segment data
	                var dpd = {
	                    profileId: _this.dnaProfile.id,
	                    type: 'TRIANGULATION',
	                    tsvHeaders: _this.dnaProfiles.triangulationTSVHeaders[_this.source].join('\t'),
	                    tsv: tsv
	                };
	                return _this.dnaProfileDatas.create(dpd).map(function () { return list.length; });
	            }
	            var e_1, _d;
	        }).subscribe(function (cnt) {
	            console.log('success', cnt);
	            _this.utils.pleaseWaitCancel(pw);
	            _this.isProcessing = false;
	            _this.server.decRequests();
	            if (cnt > 0) {
	                _this.utils.alert('Success!', cnt + ' Triangulation/ICW matches successfully imported.' +
	                    (missingMatchesCount > 0 ? ' ' + missingMatchesCount + ' matches in this import were ignored because the kits were not in your matches list.' : ''));
	            }
	            else {
	                _this.utils.alert('Failure', 'No triangulations found. Did you import the correct file?');
	            }
	        }, function (err) {
	            console.log('error', err);
	            _this.utils.pleaseWaitCancel(pw);
	            _this.$log.error('Error importing', err);
	            _this.messageBus.post({ msg: 'Error importing: ' + err, warn: true });
	            _this.isProcessing = false;
	            _this.server.decRequests();
	        });
	    };
	    DNAProfileForceController.prototype.constructData = function (dpd, dpdSegment, dpdList, kitMap) {
	        var _this = this;
	        var nodes = new Map();
	        var links = new Map();
	        // add triangulation data
	        var list = this.dnaParsers.tsvToList(this.dnaProfiles.triangulationTSVHeaders[this.source], this.dnaProfiles.triangulationTSVNumbers[this.source], dpd.tsv);
	        list.forEach(function (item) {
	            if (!kitMap.has(item.kit1) || !kitMap.has(item.kit2) || kitMap.get(item.kit1).hidden || kitMap.get(item.kit2).hidden) {
	                return;
	            }
	            if (!nodes.has(item.kit1)) {
	                var kit = kitMap.get(item.kit1);
	                nodes.set(item.kit1, { name: item.kit1, _user: _this.getUser(kit), profileName: _this.dnaProfile.name, matches: [] });
	            }
	            if (!nodes.has(item.kit2)) {
	                var kit = kitMap.get(item.kit2);
	                nodes.set(item.kit2, { name: item.kit2, _user: _this.getUser(kit), profileName: _this.dnaProfile.name, matches: [] });
	            }
	            var linkKey = item.kit1 + '/' + item.kit2;
	            var link = links.get(linkKey);
	            if (!link) {
	                var kit1 = kitMap.get(item.kit1);
	                var kit2 = kitMap.get(item.kit2);
	                link = { source: item.kit1, target: item.kit2, kit1: item.kit1, _user1: _this.getUser(kit1), kit2: item.kit2, _user2: _this.getUser(kit2),
	                    matches: [], sourceColor: defaultColor, targetColor: defaultColor };
	                links.set(linkKey, link);
	            }
	            if (item.chr) {
	                link.matches.push({ chr: item.chr, start: item.start, end: item.end, cm: item.cm });
	            }
	        });
	        // add segment matches to nodes if available
	        if (!!dpdSegment) {
	            list = this.dnaParsers.tsvToList(this.dnaProfiles.segmentTSVHeaders[this.source], this.dnaProfiles.segmentTSVNumbers[this.source], dpdSegment.tsv);
	            list.forEach(function (item) {
	                var node = nodes.get(item.name);
	                if (!!node && !Number.isNaN(item.chr) && !Number.isNaN(item.start) && !Number.isNaN(item.end) && !Number.isNaN(item.cm)) {
	                    node.matches.push({ chr: item.chr, start: item.start, end: item.end, cm: item.cm });
	                }
	            });
	        }
	        // calculate link values
	        // calculate node total cM and color, and set link source and target colors
	        var listList = this.dnaParsers.tsvToList(this.dnaProfiles.listTSVHeaders[this.source], this.dnaProfiles.listTSVNumbers[this.source], dpdList.tsv);
	        var nodesArr = Array.from(nodes.values());
	        return nodesArr.length === 0 ?
	            this.rx.Observable.of({ nodes: [], links: [], defaultColor: defaultColor }) :
	            (_a = this.rx.Observable).forkJoin.apply(_a, __spread(nodesArr.map(function (node) {
	                if (node.matches.length > 0) {
	                    node.totalcm = Math.round(node.matches.reduce(function (acc, match) { return acc + match.cm; }, 0) * 10) / 10;
	                }
	                else {
	                    var listItem = listList.find(function (item) { return item.name === node.name; });
	                    node.totalcm = !!listItem ? listItem.autoTotal : 0;
	                }
	                var kit = kitMap.get(node.name);
	                if (kit.colorOverride) {
	                    node.color = _this.utils.getAhnentafelColor(_this.treePrefs, _this.utils.colorOverrideBase + kit.colorOverride);
	                    return _this.rx.Observable.of(null);
	                }
	                else if (kit.matchType === 'NOT') {
	                    node.color = _this.utils.getAhnentafelColor(_this.treePrefs, _this.utils.colorNOT);
	                    return _this.rx.Observable.of(null);
	                }
	                else if (!kit.personId1) {
	                    node.color = defaultColor;
	                    return _this.rx.Observable.of(null);
	                }
	                else {
	                    var pids = [kit.personId1];
	                    if (!!kit.personId2) {
	                        pids.push(kit.personId2);
	                    }
	                    return _this.dnaProfiles.getMatches(_this.pedigree, pids).take(1).do(function (matches) {
	                        var colors = matches.map(function (match) { return _this.utils.getAhnentafelColor(_this.treePrefs, match, false); });
	                        node.color = _this.utils.averageColor(colors, defaultColor);
	                    });
	                }
	            }))).map(function () {
	                try {
	                    // update link value and colors now
	                    for (var _a = __values(links.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var link = _b.value;
	                        var sum = link.matches.reduce(function (acc, match) { return acc + match.cm; }, 0);
	                        link.value = sum > 0 ? linkMultiplier / sum : icwLinkValue;
	                        if (nodes.has(link.source)) {
	                            link.sourceColor = nodes.get(link.source).color;
	                        }
	                        if (nodes.has(link.target)) {
	                            link.targetColor = nodes.get(link.target).color;
	                        }
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	                return { nodes: nodesArr, links: Array.from(links.values()).filter(function (link) { return link.value > 0; }), defaultColor: defaultColor };
	                var e_2, _c;
	            });
	        var _a;
	    };
	    DNAProfileForceController.prototype.getUser = function (kit) {
	        if (!this.presentationMode) {
	            return kit._user;
	        }
	        return this.$filter('presentationMode')(kit._user);
	    };
	    DNAProfileForceController.prototype.mapKeyFn = function (fields) {
	        return fields[0] + '/' + fields[1].toString() + '/' + fields[2].toString() + '/' + fields[3].toString();
	    };
	    return DNAProfileForceController;
	}());
	exports.default = rcDNAProfileForceDirective;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcDNAProfileHebDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/dnaProfile/dnaProfileHeb.html',
	        controller: DNAProfileHebController,
	        controllerAs: 'heb',
	        bindToController: true,
	        scope: {
	            dnaProfile: '=',
	            ownerIsPro: '=',
	            pedigree: '=',
	            kits: '=',
	            selectedKits: '=',
	            highlighted: '='
	        }
	    };
	}
	var linkMultiplier = 1200;
	var icwLinkValue = 200;
	//const clusterUpperThreshold = 0.7;
	//const clusterLowerThreshold = 0.1;
	var defaultColor = '#eeeeee';
	var maxLinks = 25000;
	var DNAProfileHebController = /** @class */ (function () {
	    DNAProfileHebController.$inject = ["$log", "$rootScope", "$scope", "$state", "$timeout", "$filter", "rx", "treeUsers", "cluster", "currentTree", "dnaProfileDatas", "dnaParsers", "dnaKits", "dnaProfiles", "messageBus", "server", "subscriptions", "utils"];
	    function DNAProfileHebController($log, $rootScope, $scope, $state, $timeout, $filter, rx, treeUsers, cluster, currentTree, dnaProfileDatas, dnaParsers, dnaKits, dnaProfiles, messageBus, server, subscriptions, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.$timeout = $timeout;
	        this.$filter = $filter;
	        this.rx = rx;
	        this.cluster = cluster;
	        this.dnaProfileDatas = dnaProfileDatas;
	        this.dnaParsers = dnaParsers;
	        this.dnaKits = dnaKits;
	        this.dnaProfiles = dnaProfiles;
	        this.messageBus = messageBus;
	        this.server = server;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.showInput = false;
	        this.hasData = false;
	        this.tree = null;
	        this.nodes = null;
	        this.links = null;
	        this.defaultColor = defaultColor;
	        this.dpdId = 0;
	        this.isProcessing = false;
	        this.kitMap = new Map();
	        this.rangeTimeout = null;
	        this.presentationMode = false;
	        currentTree.stream().filter(function (t) { return !!t; }).take(1).subscribe(function (tree) {
	            _this.treePrefs = tree.preferences;
	        });
	        subscriptions.stream().filter(function (x) { return !!x; }).take(1).subscribe(function (sub) {
	            if (sub.level !== 'PRO_TRIAL' && sub.level !== 'PRO') {
	                utils.confirm('Circle view requires a Premium Plan', 'Would you like to check out a Premium plan subscription?')
	                    .then(function () {
	                    window.location = 'https://my.americanancestors.org/donate/i/38';
	                    //$state.go('userSettings');
	                }, function () {
	                    $state.go('tree.dna-profile', { view: 'list' }, { reload: true });
	                });
	            }
	        });
	        this.$onInit = function () {
	            _this.source = _this.dnaProfile.source;
	            var dpdSub = treeUsers.stream().take(1).flatMap(function (tu) {
	                _this.presentationMode = (tu.preferences['PRESENTATION_MODE'] || 'FALSE') === 'TRUE';
	                return _this.streamDNAProfileData();
	            }).flatMap(function (dpds) { return utils.watch($scope, function () { return _this.kits; }).map(function () {
	                return {
	                    dpd: dpds.find(function (dpd) { return dpd.type === 'TRIANGULATION'; }),
	                    segment: dpds.find(function (dpd) { return dpd.type === 'SEGMENT'; }),
	                    list: dpds.find(function (dpd) { return dpd.type === 'LIST'; }),
	                    kits: _this.kits
	                };
	            }); }).subscribe(function (data) {
	                if (!!data.dpd && !!data.kits) {
	                    $timeout(function () {
	                        _this.showInput = false;
	                        _this.hasData = true;
	                        _this.dpdId = data.dpd.id;
	                        _this.kitMap = new Map(data.kits.map(function (kit) { return [kit.name, kit]; }));
	                        // construct data
	                        _this.constructData(data.dpd, data.segment, data.list, _this.kitMap).take(1).subscribe(function (data) {
	                            _this.allData = data;
	                            if (data.nodes.length === 0) {
	                                _this.messageBus.post({ msg: 'NO_DNA_NODES' });
	                                _this.nodes = [];
	                                _this.links = [];
	                            }
	                            else if (data.links.length > maxLinks) {
	                                _this.messageBus.post({ msg: 'MAX_DNA_LINKS_EXCEEDED' });
	                                _this.maxLinksAnnounced = true;
	                                _this.nodes = [];
	                                _this.links = [];
	                            }
	                            else {
	                                _this.constructTree(data.nodes, data.links).subscribe(function (tree) {
	                                    _this.tree = tree;
	                                    _this.nodes = data.nodes;
	                                    _this.links = data.links;
	                                });
	                            }
	                        });
	                    }, 200);
	                }
	                else if (!data.dpd) {
	                    _this.showInput = true;
	                }
	            });
	            $scope.$on('show', function (ev, params) {
	                var selectedKits = new Map(_this.selectedKits);
	                if (params.remove) {
	                    params.nodes.forEach(function (node) {
	                        var kit = Array.from(selectedKits.values()).find(function (kit) { return kit.name === node.name; });
	                        if (!!kit) {
	                            selectedKits.delete(kit.id);
	                        }
	                        //this.getLinkedNodes(node.name).forEach(n => {
	                        //  this.selectedKits.delete(n.name);
	                        //});
	                    });
	                }
	                else {
	                    if (!params.add) {
	                        selectedKits.clear();
	                    }
	                    params.nodes.forEach(function (node) {
	                        var kit = _this.kitMap.get(node.name);
	                        if (!!kit && !selectedKits.has(kit.id)) {
	                            selectedKits.set(kit.id, {
	                                id: kit.id,
	                                name: kit.name,
	                                open: selectedKits.size === 0 && params.nodes.length === 1
	                            });
	                        }
	                        //if (params.nodes.length === 1) {
	                        //  this.getLinkedNodes(node.name).forEach(n => {
	                        //    this.selectedKits.set(n.name, false);
	                        //  });
	                        //}
	                    });
	                }
	                $scope.$emit('selected-kits', selectedKits);
	                //let kits = [];
	                //for (let [name, open] of this.selectedKits) {
	                //  console.log('show', name, open);
	                //  let kit = this.kitMap.get(name);
	                //  if (!!kit) {
	                //    kits.push({id: kit.id, name: kit.name, open: open});
	                //  }
	                //}
	                //$scope.$emit('selected-kits', kits);
	            });
	            $scope.$on('add', function () {
	                _this.showInput = !_this.showInput;
	            });
	            $scope.$on('$destroy', function () {
	                dpdSub.unsubscribe();
	            });
	        };
	    }
	    DNAProfileHebController.prototype.streamDNAProfileData = function () {
	        var _this = this;
	        return this.dnaProfileDatas.stream().map(function (dpdMap) { return Array.from(dpdMap.values()).filter(function (dpd) {
	            return dpd.profileId === _this.dnaProfile.id && (dpd.type === 'TRIANGULATION' || dpd.type === 'SEGMENT' || dpd.type === 'LIST');
	        }); });
	    };
	    DNAProfileHebController.prototype.constructData = function (dpd, dpdSegment, dpdList, kitMap) {
	        var _this = this;
	        var nodes = new Map();
	        var links = new Map();
	        // add triangulation data
	        var list = this.dnaParsers.tsvToList(this.dnaProfiles.triangulationTSVHeaders[this.source], this.dnaProfiles.triangulationTSVNumbers[this.source], dpd.tsv);
	        list.forEach(function (item) {
	            if (!kitMap.has(item.kit1) || !kitMap.has(item.kit2) || kitMap.get(item.kit1).hidden || kitMap.get(item.kit2).hidden) {
	                return;
	            }
	            if (!nodes.has(item.kit1)) {
	                var kit = kitMap.get(item.kit1);
	                nodes.set(item.kit1, { name: item.kit1, _user: _this.getUser(kit), profileName: _this.dnaProfile.name, matches: [] });
	            }
	            if (!nodes.has(item.kit2)) {
	                var kit = kitMap.get(item.kit2);
	                nodes.set(item.kit2, { name: item.kit2, _user: _this.getUser(kit), profileName: _this.dnaProfile.name, matches: [] });
	            }
	            var linkKey = item.kit1 + '/' + item.kit2;
	            var link = links.get(linkKey);
	            if (!link) {
	                link = { source: item.kit1, target: item.kit2, kit1: item.kit1, kit2: item.kit2, matches: [], sourceColor: defaultColor, targetColor: defaultColor };
	                links.set(linkKey, link);
	            }
	            if (item.chr) {
	                link.matches.push({ chr: item.chr, start: item.start, end: item.end, cm: item.cm });
	            }
	        });
	        // add segment matches to nodes if available
	        if (!!dpdSegment) {
	            list = this.dnaParsers.tsvToList(this.dnaProfiles.segmentTSVHeaders[this.source], this.dnaProfiles.segmentTSVNumbers[this.source], dpdSegment.tsv);
	            list.forEach(function (item) {
	                var node = nodes.get(item.name);
	                if (!!node && !Number.isNaN(item.chr) && !Number.isNaN(item.start) && !Number.isNaN(item.end) && !Number.isNaN(item.cm)) {
	                    node.matches.push({ chr: item.chr, start: item.start, end: item.end, cm: item.cm });
	                }
	            });
	        }
	        // calculate link values
	        // calculate node total cM and color, and set link source and target colors
	        var listList = this.dnaParsers.tsvToList(this.dnaProfiles.listTSVHeaders[this.source], this.dnaProfiles.listTSVNumbers[this.source], dpdList.tsv);
	        var nodesArr = Array.from(nodes.values());
	        return nodesArr.length === 0 ?
	            this.rx.Observable.of({ nodes: [], links: [], defaultColor: defaultColor }) :
	            (_a = this.rx.Observable).forkJoin.apply(_a, __spread(nodesArr.map(function (node) {
	                if (node.matches.length > 0) {
	                    node.totalcm = Math.round(node.matches.reduce(function (acc, match) { return acc + match.cm; }, 0) * 10) / 10;
	                }
	                else {
	                    var listItem = listList.find(function (item) { return item.name === node.name; });
	                    node.totalcm = !!listItem ? listItem.autoTotal : 0;
	                }
	                var kit = kitMap.get(node.name);
	                if (kit.colorOverride) {
	                    node.color = _this.utils.getAhnentafelColor(_this.treePrefs, _this.utils.colorOverrideBase + kit.colorOverride);
	                    return _this.rx.Observable.of(null);
	                }
	                else if (kit.matchType === 'NOT') {
	                    node.color = _this.utils.getAhnentafelColor(_this.treePrefs, _this.utils.colorNOT);
	                    return _this.rx.Observable.of(null);
	                }
	                else if (!kit.personId1) {
	                    node.color = defaultColor;
	                    return _this.rx.Observable.of(null);
	                }
	                else {
	                    var pids = [kit.personId1];
	                    if (!!kit.personId2) {
	                        pids.push(kit.personId2);
	                    }
	                    return _this.dnaProfiles.getMatches(_this.pedigree, pids).take(1).do(function (matches) {
	                        var colors = matches.map(function (match) { return _this.utils.getAhnentafelColor(_this.treePrefs, match, false); });
	                        node.color = _this.utils.averageColor(colors, defaultColor);
	                    });
	                }
	            }))).map(function () {
	                try {
	                    // update link value and colors now
	                    for (var _a = __values(links.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var link = _b.value;
	                        var sum = link.matches.reduce(function (acc, match) { return acc + match.cm; }, 0);
	                        link.sum = sum;
	                        link.value = sum > 0 ? linkMultiplier / sum : icwLinkValue;
	                        if (nodes.has(link.source)) {
	                            link.sourceColor = nodes.get(link.source).color;
	                        }
	                        if (nodes.has(link.target)) {
	                            link.targetColor = nodes.get(link.target).color;
	                        }
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                return { nodes: nodesArr, links: Array.from(links.values()).filter(function (link) { return link.value > 0; }), defaultColor: defaultColor };
	                var e_1, _c;
	            });
	        var _a;
	    };
	    DNAProfileHebController.prototype.getUser = function (kit) {
	        if (!this.presentationMode) {
	            return kit._user;
	        }
	        return this.$filter('presentationMode')(kit._user);
	    };
	    DNAProfileHebController.prototype.mapKeyFn = function (fields) {
	        return fields[0] + '/' + fields[1].toString() + '/' + fields[2].toString() + '/' + fields[3].toString();
	    };
	    DNAProfileHebController.prototype.constructTree = function (nodes, links) {
	        var subject = new this.rx.AsyncSubject();
	        var worker = new Worker(this.cluster.getBlobURL());
	        worker.addEventListener('message', function (e) {
	            subject.next({
	                children: e.data
	            });
	            subject.complete();
	            worker.terminate();
	        }, false);
	        worker.postMessage({ nodes: nodes, links: links });
	        return subject;
	        //console.time('hcluster');
	        //let distances = new Map();
	        //for (let link of links) {
	        //  distances.set(link.kit1+link.kit2, link.value);
	        //  distances.set(link.kit2+link.kit1, link.value);
	        //}
	        //let hcl = this.hcluster()
	        //  .distance((a,b) => {
	        //    return distances.get(a.name+b.name) || linkMultiplier;
	        //  })
	        //  .linkage('avg')
	        //  .data(nodes);
	        //let root = hcl.tree();
	        //console.timeEnd('hcluster');
	        //let children = [];
	        //this.processClusters(root, linkMultiplier * clusterUpperThreshold, linkMultiplier * clusterLowerThreshold, children);
	        //root.children = children;
	        //console.log('root', root);
	        //return root;
	    };
	    return DNAProfileHebController;
	}());
	exports.default = rcDNAProfileHebDirective;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcDNAProfileListDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/dnaProfile/dnaProfileList.html',
	        controller: DNAProfileListController,
	        controllerAs: 'list',
	        bindToController: true,
	        scope: {
	            dnaProfile: '=',
	            ownerIsPro: '=',
	            pedigree: '=',
	            colorLabels: '=',
	            kits: '=',
	            selectedKits: '=',
	            numFilters: '='
	        }
	    };
	}
	var DNAProfileListController = /** @class */ (function () {
	    DNAProfileListController.$inject = ["$log", "$scope", "$timeout", "rx", "dnaProfileDatas", "dnaKits", "dnaParsers", "dnaProfiles", "currentTree", "persons", "messageBus", "server", "utils"];
	    function DNAProfileListController($log, $scope, $timeout, rx, dnaProfileDatas, dnaKits, dnaParsers, dnaProfiles, currentTree, persons, messageBus, server, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.$timeout = $timeout;
	        this.rx = rx;
	        this.dnaProfileDatas = dnaProfileDatas;
	        this.dnaKits = dnaKits;
	        this.dnaParsers = dnaParsers;
	        this.dnaProfiles = dnaProfiles;
	        this.persons = persons;
	        this.messageBus = messageBus;
	        this.server = server;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        var headers = {
	            'GEDMATCH': [
	                { label: 'Name', title: 'Name (Kit): * => Alias', width: 30, property: '_user', type: 'string_present', filterable: true, sortable: true, show: true, altType: 'dnaKit' },
	                { label: 'atDNA Total', title: 'Autosomal total match', width: 10, property: 'autoTotal', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, sortReverse: true },
	                { label: 'atDNA Largest', title: 'Autosomal largest match', width: 10, property: 'autoLargest', type: 'string', filterable: true, sortable: true, sortReverse: true },
	                { label: 'atDNA Gen ', title: 'Generations', width: 10, property: 'autoGen', type: 'string', filterable: true, sortable: true, sortReverse: false },
	                { label: 'X-DNA Total', title: 'X-DNA total match', width: 10, property: 'xTotal', type: 'string', filterable: true, sortable: true, sortReverse: true },
	                { label: 'X-DNA Largest', title: 'X-DNA largest match', width: 10, property: 'xLargest', type: 'string', filterable: true, sortable: true, sortReverse: true },
	                { label: 'Age days', title: 'Age of the upload in days', width: 5, property: 'age', type: 'string', hideZero: true, filterable: true, sortable: true, sortReverse: false },
	                { label: 'Notes', title: 'Has notes', width: 5, property: '_hasNotes', type: 'md-icon', sortable: true, sortReverse: true },
	                { label: 'Tree', title: 'Has a tree', width: 5, property: '_hasTree', type: 'rc-icon', sortable: true, sortReverse: true },
	                { label: 'Match', title: 'Has been matched to your RootsFinder tree', width: 5, property: '_matches', type: 'matches', sortable: true }
	            ],
	            'FTDNA': [
	                { label: 'Name', title: 'Name', width: 35, property: '_user', type: 'string_present', filterable: true, sortable: true, show: true, altType: 'dnaKit' },
	                { label: 'atDNA Total', title: 'Autosomal total match', width: 10, property: 'autoTotal', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, sortReverse: true },
	                { label: 'atDNA Largest', title: 'Autosomal largest match', width: 10, property: 'autoLargest', type: 'string', filterable: true, sortable: true, sortReverse: true },
	                { label: 'Relationship', title: 'Relationship range', width: 30, property: 'relRange', type: 'string', filterable: true, sortable: false },
	                { label: 'Notes', title: 'Has notes', width: 5, property: '_hasNotes', type: 'md-icon', sortable: true, sortReverse: true },
	                { label: 'Tree', title: 'Has a tree', width: 5, property: '_hasTree', type: 'rc-icon', sortable: true, sortReverse: true },
	                { label: 'Match', title: 'Has been matched to your RootsFinder tree', width: 5, property: '_matches', type: 'matches', sortable: true }
	            ],
	            'MYHERITAGE': [
	                { label: 'Name', title: 'Name', width: 35, property: '_user', type: 'string_present', filterable: true, sortable: true, show: true, altType: 'dnaKit' },
	                { label: 'atDNA Total', title: 'Autosomal total match', width: 10, property: 'autoTotal', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, sortReverse: true },
	                { label: 'atDNA Count', title: 'Autosomal segments matched', width: 10, property: 'autoCount', type: 'string', filterable: true, sortable: true, sortReverse: true },
	                { label: 'atDNA Largest', title: 'Autosomal largest match', width: 10, property: 'autoLargest', type: 'string', filterable: true, sortable: true, sortReverse: true },
	                { label: 'Relationship', title: 'Relationship range', width: 20, property: 'relRange', type: 'string', filterable: true, sortable: false },
	                { label: 'Notes', title: 'Has notes', width: 5, property: '_hasNotes', type: 'md-icon', sortable: true, sortReverse: true },
	                { label: 'Tree', title: 'Has a tree', width: 5, property: '_hasTree', type: 'rc-icon', sortable: true, sortReverse: true },
	                { label: 'Match', title: 'Has been matched to your RootsFinder tree', width: 5, property: '_matches', type: 'matches', sortable: true }
	            ],
	            '23ANDME': [
	                { label: 'Name', title: 'Name', width: 35, property: '_user', type: 'string_present', filterable: true, sortable: true, show: true, altType: 'dnaKit' },
	                { label: 'atDNA Total', title: 'Autosomal total match', width: 10, property: 'autoTotal', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, sortReverse: true },
	                { label: 'atDNA Count', title: 'Autosomal segments matched', width: 10, property: 'autoCount', type: 'string', filterable: true, sortable: true, sortReverse: true },
	                { label: 'Relationship', title: 'Relationship range', width: 30, property: 'relRange', type: 'string', filterable: true, sortable: false },
	                { label: 'Notes', title: 'Has notes', width: 5, property: '_hasNotes', type: 'md-icon', sortable: true, sortReverse: true },
	                { label: 'Tree', title: 'Has a tree', width: 5, property: '_hasTree', type: 'rc-icon', sortable: true, sortReverse: true },
	                { label: 'Match', title: 'Has been matched to your RootsFinder tree', width: 5, property: '_matches', type: 'matches', sortable: true }
	            ],
	            'ANCESTRY': [
	                { label: 'Name', title: 'Name', width: 40, property: '_user', type: 'string_present', filterable: true, sortable: true, show: true, altType: 'dnaKit' },
	                { label: 'atDNA Total', title: 'Autosomal total match', width: 10, property: 'autoTotal', type: 'string', filterable: true, sortable: true, sort: 1, defaultSort: true, sortReverse: true },
	                { label: 'atDNA Count', title: 'Autosomal segments matched', width: 10, property: 'autoCount', type: 'string', filterable: true, sortable: true, sortReverse: true },
	                { label: 'Relationship', title: 'Relationship range', width: 25, property: 'relRange', type: 'string', filterable: true, sortable: false },
	                { label: 'Notes', title: 'Has notes', width: 5, property: '_hasNotes', type: 'md-icon', sortable: true, sortReverse: true },
	                { label: 'Tree', title: 'Has a tree', width: 5, property: '_hasTree', type: 'rc-icon', sortable: true, sortReverse: true },
	                { label: 'Match', title: 'Has been matched to your RootsFinder tree', width: 5, property: '_matches', type: 'matches', sortable: true }
	            ]
	        };
	        this.showInput = false;
	        this.hasData = false;
	        this.items = new Map();
	        this.dpd = null;
	        this.isProcessing = false;
	        this.showHidden = false;
	        this.kitMap = new Map();
	        this.$onInit = function () {
	            _this.source = _this.dnaProfile.source;
	            _this.headers = headers[_this.source];
	            var dpdSub = _this.streamDNAProfileData()
	                .flatMap(function (dpd) { return utils.watch($scope, function () { return _this.kits; }).map(function () {
	                return { dpd: dpd, kits: _this.kits };
	            }); }).subscribe(function (data) {
	                if (!!data.dpd && !!data.kits) {
	                    _this.showInput = false;
	                    _this.hasData = true;
	                    _this.dpd = data.dpd;
	                    _this.kitMap = new Map(data.kits.map(function (kit) { return [kit.name, kit]; }));
	                    _this.items = _this.constructItems(_this.dpd, _this.kitMap);
	                    $timeout(function () {
	                        $scope.$broadcast('resetHeight');
	                    }, 0);
	                }
	                else if (!data.dpd) {
	                    _this.showInput = true;
	                }
	            });
	            $scope.$on('showArchived', function (ev, params) {
	                _this.showHidden = !params.showArchived;
	                params.showArchived = _this.showHidden;
	            });
	            $scope.$on('show', function (ev, params) {
	                if (_this.kitMap.has(params.item.name)) {
	                    var kit = _this.kitMap.get(params.item.name);
	                    $scope.$emit('selected-kits', new Map([[kit.id, { id: kit.id, name: kit.name, open: true }]]));
	                }
	            });
	            $scope.$on('edited', function (ev, kit) {
	                // if we no longer show this kit, remove it from the kit list
	                if ((kit.hidden && !_this.showHidden) || (!kit.hidden && _this.showHidden)) {
	                    $scope.$emit('selected-kits', new Map());
	                }
	            });
	            $scope.$on('add', function () {
	                _this.showInput = !_this.showInput;
	            });
	            $scope.$on('paste', function (ev, params) {
	                //if (!this.ownerIsPro) {
	                //  this.utils.alert('Pro Plan Required',
	                //    'DNA features require a Pro plan. To upgrade to a Pro plan, click on your name in the upper-right corner, then select "Account".', params.ev);
	                //  return;
	                //}
	                _this.isProcessing = true;
	                _this.server.incRequests();
	                $timeout(function () {
	                    _this.paste(params);
	                }, 100);
	            });
	            $scope.$on('$destroy', function () {
	                dpdSub.unsubscribe();
	            });
	        };
	    }
	    DNAProfileListController.prototype.streamDNAProfileData = function () {
	        var _this = this;
	        return this.dnaProfileDatas.stream().map(function (dpdMap) { return Array.from(dpdMap.values()).find(function (dpd) { return dpd.profileId === _this.dnaProfile.id && dpd.type === 'LIST'; }); });
	    };
	    DNAProfileListController.prototype.upload = function (file) {
	        var _this = this;
	        var reader = new FileReader();
	        reader.onload = function () {
	            var text = reader.result;
	            _this.$timeout(function () {
	                _this.server.incRequests();
	                var rawData = _this.dnaParsers.parseListCSV(text, _this.source);
	                _this.processData(rawData);
	            });
	        };
	        reader.readAsText(file);
	    };
	    DNAProfileListController.prototype.paste = function (params) {
	        if (!params || !params.html) {
	            this.messageBus.post({ msg: 'Text not found; please go back and press Control-A and Control-C to re-copy.' });
	            this.isProcessing = false;
	            this.server.decRequests();
	            return;
	        }
	        var rawData;
	        try {
	            if (params.html.indexOf('Testing Company') > 0 && params.html.indexOf('1:1') > 0) {
	                console.log('parseGedMatchOneToManyC');
	                rawData = this.dnaParsers.parseGedMatchOneToManyC(params.html);
	            }
	            else if (params.html.indexOf('Kit Nbr') > 0) {
	                console.log('parseGedMatchOneToManyA');
	                rawData = this.dnaParsers.parseGedMatchOneToManyA(params.html);
	            }
	            else if (params.html.indexOf('tablesorter-wrapper') > 0) {
	                console.log('parseGedMatchOneToManyE');
	                rawData = this.dnaParsers.parseGedMatchOneToManyE(params.html);
	            }
	        }
	        catch (err) {
	            this.$log.error('Error parsing list: ', err);
	            this.messageBus.post({
	                msg: 'Error importing DNA matches; please contact support@rootsfinder.com',
	                warn: true,
	                warnParams: { err: err, text: params.text.substr(0, 500) }
	            });
	            throw new Error(err);
	        }
	        this.processData(rawData);
	    };
	    DNAProfileListController.prototype.processData = function (rawData) {
	        var _this = this;
	        var _a = __read(!!rawData ? this.dnaParsers.processListData(rawData, this.source) : [[], []], 2), list = _a[0], kits = _a[1];
	        if (list.length === 0 || kits.length === 0) {
	            this.messageBus.post({ msg: 'This import is not recognized. Please contact support@rootsfinder.com' });
	            this.isProcessing = false;
	            this.server.decRequests();
	            return;
	        }
	        // filter kits
	        this.utils.dialog(null, 'DNAImportFilterController', 'app/components/dnaImportFilter/dnaImportFilter.html', false, {
	            list: list,
	            kits: kits,
	        }).then(function (_a) {
	            var _b = __read(_a, 2), list = _b[0], kits = _b[1];
	            var pw = _this.utils.pleaseWait();
	            // read existing kits
	            _this.dnaKits.stream().take(1).map(function (kitMap) {
	                // group by name
	                kitMap = _this.dnaProfiles.kitsByName(kitMap, _this.source);
	                var kitsToPost = new Map();
	                // for each new kit: add or update?
	                kits.forEach(function (kit) {
	                    var exKit = kitMap.get(kit.name);
	                    if (!exKit) {
	                        kitsToPost.set(kit.name, kit);
	                    }
	                    else if (!!exKit &&
	                        (!_this.dnaProfiles.kitsEqual(['source', 'type', 'url', 'sex', 'haploMt', 'haploY', 'email', 'contactURL',
	                            'managerName', 'ageRange', 'surnames', 'locations', 'text'], exKit, kit) ||
	                            (!!exKit.text && exKit.text.trim().toLowerCase() === 'false') || // TODO remove old "false" notes
	                            _this.treeURLsExtra(exKit.treeURLs, kit.treeURLs))) {
	                        exKit = _this.utils.clone(exKit);
	                        // TODO remove old "false" notes
	                        if (!!exKit.text && exKit.text.trim().toLowerCase() === 'false') {
	                            exKit.text = '';
	                        }
	                        // update fields that are not empty
	                        // TODO don't update if user-edited?
	                        exKit = _this.dnaProfiles.merge(kit, exKit);
	                        kitsToPost.set(exKit.name, exKit);
	                    }
	                });
	                return kitsToPost;
	            }).flatMap(function (kitsToPost) {
	                // process posts in batches of 50
	                var batches = [];
	                var batch = [];
	                kitsToPost.forEach(function (kit) {
	                    if (batch.length === 50) {
	                        batches.push(batch);
	                        batch = [];
	                    }
	                    batch.push(kit);
	                });
	                if (batch.length > 0) {
	                    batches.push(batch);
	                }
	                return batches.length === 0 ? _this.rx.Observable.of(true) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(batches.map(function (batch) { return _this.dnaKits.createBatch(batch); })));
	                var _a;
	            }).flatMap(function () {
	                return _this.streamDNAProfileData().take(1);
	            }).flatMap(function (existing) {
	                // convert list to tsv
	                var tsv = _this.dnaParsers.listToTSV(_this.dnaProfiles.listTSVHeaders[_this.source], list);
	                // do we have existing data ?
	                if (!!existing) {
	                    var dpd = _this.utils.clone(existing);
	                    if (_this.reset) {
	                        dpd.tsv = tsv;
	                    }
	                    else {
	                        // convert existing data to map
	                        var oldMap = _this.dnaParsers.tsvToMap(_this.dnaProfiles.listTSVHeaders[_this.source], _this.dnaProfiles.listTSVNumbers[_this.source], function (fields) { return fields[0]; }, existing.tsv);
	                        // convert new data to map
	                        var newMap = _this.dnaParsers.tsvToMap(_this.dnaProfiles.listTSVHeaders[_this.source], _this.dnaProfiles.listTSVNumbers[_this.source], function (fields) { return fields[0]; }, tsv);
	                        try {
	                            // merge maps
	                            for (var _a = __values(newMap.entries()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                                var _c = __read(_b.value, 2), key = _c[0], value = _c[1];
	                                oldMap.set(key, value);
	                            }
	                        }
	                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                        finally {
	                            try {
	                                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                            }
	                            finally { if (e_1) throw e_1.error; }
	                        }
	                        // convert merged map to tsv
	                        dpd.tsv = _this.dnaParsers.listToTSV(_this.dnaProfiles.listTSVHeaders[_this.source], oldMap.values());
	                    }
	                    // update existing dpd
	                    return _this.dnaProfileDatas.update(dpd).map(function () { return list.length; });
	                }
	                else {
	                    // add list data
	                    var dpd = {
	                        profileId: _this.dnaProfile.id,
	                        type: 'LIST',
	                        tsvHeaders: _this.dnaProfiles.listTSVHeaders[_this.source].join('\t'),
	                        tsv: tsv
	                    };
	                    return _this.dnaProfileDatas.create(dpd).map(function () { return list.length; });
	                }
	                var e_1, _d;
	            }).subscribe(function (cnt) {
	                console.log('success', cnt);
	                _this.utils.pleaseWaitCancel(pw);
	                _this.isProcessing = false;
	                _this.server.decRequests();
	                _this.utils.alert('Success!', 'Matches successfully imported: ' + cnt);
	            }, function (err) {
	                console.log('error', err);
	                _this.utils.pleaseWaitCancel(pw);
	                _this.$log.error('Error importing', err);
	                _this.messageBus.post({ msg: 'Error importing: ' + err, warn: true });
	                _this.isProcessing = false;
	                _this.server.decRequests();
	            });
	        }, function () {
	            // ignore
	        });
	    };
	    DNAProfileListController.prototype.uploadSurnamesLocations = function (file) {
	        var _this = this;
	        var reader = new FileReader();
	        reader.onload = function () {
	            var text = reader.result;
	            _this.$timeout(function () {
	                _this.server.incRequests();
	                var kitSLs = _this.dnaParsers.parseAncestryTreesCSV(text);
	                _this.processSurnamesLocations(kitSLs);
	            });
	        };
	        reader.readAsText(file);
	    };
	    DNAProfileListController.prototype.processSurnamesLocations = function (kitSLs) {
	        var _this = this;
	        if (kitSLs.length === 0) {
	            this.messageBus.post({ msg: 'This import is not recognized. Please contact support@rootsfinder.com' });
	            this.isProcessing = false;
	            this.server.decRequests();
	            return;
	        }
	        var pw = this.utils.pleaseWait();
	        // read existing kits
	        this.dnaKits.stream().take(1).map(function (kitMap) {
	            // group by name
	            kitMap = _this.dnaProfiles.kitsByName(kitMap, _this.source);
	            var kitsToPost = new Map();
	            // for each new kit: add or update?
	            kitSLs.forEach(function (kit) {
	                var exKit = kitMap.get(kit.name);
	                if (!!exKit && ((exKit.surnames || '') !== (kit.surnames || '') || (exKit.locations || '') !== (kit.locations || ''))) {
	                    exKit = _this.utils.clone(exKit);
	                    exKit.surnames = kit.surnames;
	                    exKit.locations = kit.locations;
	                    kitsToPost.set(exKit.name, exKit);
	                }
	            });
	            return kitsToPost;
	        }).flatMap(function (kitsToPost) {
	            // process posts in batches of 50
	            var batches = [];
	            var batch = [];
	            kitsToPost.forEach(function (kit) {
	                if (batch.length === 50) {
	                    batches.push(batch);
	                    batch = [];
	                }
	                batch.push(kit);
	            });
	            if (batch.length > 0) {
	                batches.push(batch);
	            }
	            return batches.length === 0 ? _this.rx.Observable.of(0) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(batches.map(function (batch) { return _this.dnaKits.createBatch(batch); }))).map(function () { return kitsToPost.length; });
	            var _a;
	        }).subscribe(function (cnt) {
	            console.log('success', cnt);
	            _this.utils.pleaseWaitCancel(pw);
	            _this.isProcessing = false;
	            _this.server.decRequests();
	            _this.utils.alert('Success!', 'Surnames and locations successfully updated: ' + cnt);
	        }, function (err) {
	            console.log('error', err);
	            _this.utils.pleaseWaitCancel(pw);
	            _this.$log.error('Error importing', err);
	            _this.messageBus.post({ msg: 'Error importing: ' + err, warn: true });
	            _this.isProcessing = false;
	            _this.server.decRequests();
	        });
	    };
	    DNAProfileListController.prototype.constructItems = function (dpd, kitMap) {
	        var map = this.dnaParsers.tsvToMap(this.dnaProfiles.listTSVHeaders[this.source], this.dnaProfiles.listTSVNumbers[this.source], function (fields) { return fields[0]; }, dpd.tsv);
	        try {
	            for (var _a = __values(map.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var item = _b.value;
	                var kit = kitMap.get(item.name);
	                if (!kit) {
	                    map.delete(item.name);
	                    continue;
	                }
	                if (!!kit) {
	                    item._kit = kit;
	                    item._id = kit.id;
	                    item._user = kit._user || '';
	                    item._hasNotes = !!kit.text ? 'chat' : '';
	                    item._hasTree = !!kit.minitree ? 'tree-generic' : kit.treeURLs.size > 0 ? 'tree-generic-unfilled' : '';
	                    item._hasTreeTitle = !!kit.minitree ? 'Tree imported' : kit.treeURLs.size > 0 ? 'Tree available' : '';
	                    item._matches = 0;
	                    item._matchesTitle = '';
	                    this.augmentItem(kit, item);
	                }
	                else {
	                    item._kit = null;
	                    item._id = 0;
	                    item._user = '';
	                    item._hasNotes = '';
	                    item._hasTree = '';
	                    item._hastreeTitle = '';
	                    item._matches = 0;
	                    item._matchesTitle = '';
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        return map;
	        var e_2, _c;
	    };
	    DNAProfileListController.prototype.augmentItem = function (kit, item) {
	        var _this = this;
	        if (kit.colorOverride) {
	            item._matches = (this.utils.colorOverrideBase + kit.colorOverride) * this.utils.colorMultiplier + (this.utils.colorOverrideBase + kit.colorOverride);
	            item._matchesTitle = this.colorLabels[kit.colorOverride];
	        }
	        else if (kit.matchType === 'NOT') {
	            item._matches = this.utils.colorNOT * this.utils.colorMultiplier + this.utils.colorNOT;
	            item._matchesTitle = 'Not in tree';
	            return;
	        }
	        if (!kit.personId1) {
	            return;
	        }
	        var pids = [kit.personId1];
	        if (!!kit.personId2) {
	            pids.push(kit.personId2);
	        }
	        if (!kit.colorOverride) {
	            this.dnaProfiles.getMatches(this.pedigree, pids).take(1).subscribe(function (matches) {
	                // map into 16..31 so sorting works
	                matches = matches.map(function (ahnentafel) {
	                    while (ahnentafel >= 32) {
	                        ahnentafel = ahnentafel >>> 1; // jshint ignore:line
	                    }
	                    while (ahnentafel < 16) {
	                        ahnentafel *= 2;
	                    }
	                    return ahnentafel;
	                });
	                if (matches.length === 1) {
	                    item._matches = matches[0] * _this.utils.colorMultiplier + matches[0];
	                }
	                else if (matches.length > 0) {
	                    item._matches = matches[0] * _this.utils.colorMultiplier + matches[1];
	                }
	            });
	        }
	        this.persons.streamIds(pids).subscribe(function (pm) {
	            if (pm.has(kit.personId1)) {
	                item._matchesTitle = pm.get(kit.personId1)._fullName;
	            }
	            if (pm.has(kit.personId2)) {
	                item._matchesTitle += '; ' + pm.get(kit.personId2)._fullName;
	            }
	        });
	    };
	    DNAProfileListController.prototype.treeURLsExtra = function (exURLs, URLs) {
	        try {
	            for (var _a = __values(URLs.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var key = _b.value;
	                if (!exURLs.has(key)) {
	                    return true;
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        return false;
	        var e_3, _c;
	    };
	    return DNAProfileListController;
	}());
	exports.default = rcDNAProfileListDirective;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcDNAProfileSankeyDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/dnaProfile/dnaProfileSankey.html',
	        controller: DNAProfileSankeyController,
	        controllerAs: 'sankey',
	        bindToController: true,
	        scope: {
	            dnaProfile: '=',
	            ownerIsPro: '=',
	            pedigree: '=',
	            kits: '=',
	            selectedKits: '=',
	            highlighted: '='
	        }
	    };
	}
	var chromoColor = '#cccccc';
	var defaultNodeColor = '#ffffff';
	var defaultCircleColor = '#ffffff';
	var outsideThreshold = 5000000;
	var insideThreshold = 5000000;
	var overlapThreshold = 5000000;
	var DNAProfileSankeyController = /** @class */ (function () {
	    DNAProfileSankeyController.$inject = ["$log", "$scope", "$state", "$timeout", "rx", "currentTree", "dnaProfileDatas", "dnaParsers", "dnaKits", "dnaProfiles", "messageBus", "server", "subscriptions", "utils"];
	    function DNAProfileSankeyController($log, $scope, $state, $timeout, rx, currentTree, dnaProfileDatas, dnaParsers, dnaKits, dnaProfiles, messageBus, server, subscriptions, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$timeout = $timeout;
	        this.rx = rx;
	        this.dnaProfileDatas = dnaProfileDatas;
	        this.dnaParsers = dnaParsers;
	        this.dnaKits = dnaKits;
	        this.dnaProfiles = dnaProfiles;
	        this.messageBus = messageBus;
	        this.server = server;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.showInput = false;
	        this.hasData = false;
	        this.chromosomes = null;
	        this.dpdId = 0;
	        this.isProcessing = false;
	        this.kitMap = new Map();
	        currentTree.stream().filter(function (t) { return !!t; }).take(1).subscribe(function (tree) {
	            _this.treePrefs = tree.preferences;
	        });
	        subscriptions.stream().filter(function (x) { return !!x; }).take(1).subscribe(function (sub) {
	            if (sub.level !== 'PRO_TRIAL' && sub.level !== 'PRO') {
	                utils.confirm('Segment view requires a Premium Plan', 'Would you like to check out a Premium plan subscription?')
	                    .then(function () {
	                    window.location = 'https://my.americanancestors.org/donate/i/38';
	                    //$state.go('userSettings');
	                }, function () {
	                    $state.go('tree.dna-profile', { view: 'list' }, { reload: true });
	                });
	            }
	        });
	        this.$onInit = function () {
	            _this.source = _this.dnaProfile.source;
	            var dpdSub = _this.streamDNAProfileData()
	                .flatMap(function (dpd) { return utils.watch($scope, function () { return _this.kits; }).map(function () {
	                return { dpd: dpd, kits: _this.kits };
	            }); }).subscribe(function (data) {
	                if (!!data.dpd && !!data.kits) {
	                    _this.showInput = false;
	                    _this.hasData = true;
	                    _this.dpdId = data.dpd.id;
	                    _this.kitMap = new Map(data.kits.map(function (kit) { return [kit.name, kit]; }));
	                    _this.chromosomes = _this.constructData(data.dpd, _this.kitMap);
	                }
	                else if (!data.dpd) {
	                    _this.showInput = true;
	                }
	            });
	            $scope.$on('show', function (ev, params) {
	                var selectedKits = new Map();
	                try {
	                    for (var _a = __values(params.node.items), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var item = _b.value;
	                        var kit = _this.kitMap.get(item.name);
	                        if (!!kit && !selectedKits.has(kit.id)) {
	                            selectedKits.set(kit.id, {
	                                id: kit.id,
	                                name: kit.name,
	                                open: params.node.items.length === 1
	                            });
	                        }
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                $scope.$emit('selected-kits', selectedKits);
	                var e_1, _c;
	            });
	            $scope.$on('add', function () {
	                _this.showInput = !_this.showInput;
	            });
	            $scope.$on('paste', function (ev, params) {
	                //if (!this.ownerIsPro) {
	                //  this.utils.alert('Pro Plan Required',
	                //    'DNA features require a Pro plan. To upgrade to a Pro plan, click on your name in the upper-right corner, then select "Account".', params.ev);
	                //  return;
	                //}
	                _this.isProcessing = true;
	                _this.server.incRequests();
	                $timeout(function () {
	                    _this.paste(params);
	                }, 100);
	            });
	            $scope.$on('$destroy', function () {
	                dpdSub.unsubscribe();
	            });
	        };
	    }
	    DNAProfileSankeyController.prototype.streamDNAProfileData = function () {
	        var _this = this;
	        return this.dnaProfileDatas.stream().map(function (dpdMap) { return Array.from(dpdMap.values()).find(function (dpd) { return dpd.profileId === _this.dnaProfile.id && dpd.type === 'SEGMENT'; }); });
	    };
	    DNAProfileSankeyController.prototype.upload = function (file) {
	        var _this = this;
	        var reader = new FileReader();
	        reader.onload = function () {
	            var text = reader.result;
	            _this.$timeout(function () {
	                _this.server.incRequests();
	                var rawData = _this.dnaParsers.parseSegmentCSV(text, _this.source);
	                _this.dnaKits.stream().take(1).subscribe(function (kitMap) {
	                    // group by user
	                    if (_this.source === 'MYHERITAGE' || _this.source === '23ANDME') {
	                        if (_this.source === 'MYHERITAGE') {
	                            kitMap = new Map(Array.from(kitMap.values()).filter(function (kit) { return kit.source === _this.source; }).map(function (kit) { return [kit.user, kit]; }));
	                        }
	                        else {
	                            kitMap = new Map(Array.from(kitMap.values()).filter(function (kit) { return kit.source === _this.source; }).map(function (kit) {
	                                return [!!kit.url && kit.url.includes('remote_id=') ? kit.url.substring(kit.url.indexOf('remote_id=') + 'remote_id='.length) : '', kit];
	                            }));
	                        }
	                        rawData = rawData.map(function (row) {
	                            // if we have a kit, it is not a MH Kit ID, and we found a match
	                            if (!!row['kit'] && !(_this.source === 'MYHERITAGE' && row['kit'].length === 38) && kitMap.has(row['kit'])) {
	                                row['kit'] = kitMap.get(row['kit'])['name'];
	                            }
	                            return row;
	                        });
	                    }
	                    rawData = rawData.filter(function (row) { return !!row['kit']; });
	                    _this.processData(rawData);
	                });
	            });
	        };
	        reader.readAsText(file);
	    };
	    DNAProfileSankeyController.prototype.paste = function (params) {
	        if (!params || !params.html) {
	            this.messageBus.post({ msg: 'Text not found; please go back and press Control-A and Control-C to re-copy.' });
	            this.isProcessing = false;
	            this.server.decRequests();
	            return;
	        }
	        var rawData;
	        try {
	            rawData = this.dnaParsers.parseGedMatchSegment(params.html);
	        }
	        catch (err) {
	            this.$log.error('Error parsing segments: ', err);
	            this.messageBus.post({ msg: 'Error importing segment matches; please contact support@rootsfinder.com', warn: true, warnParams: { err: err, text: params.text.substr(0, 500) } });
	            throw new Error(err);
	        }
	        this.processData(rawData);
	    };
	    DNAProfileSankeyController.prototype.toggleAll = function (chromosomes) {
	        var allExpanded = this.allExpanded(chromosomes);
	        chromosomes.forEach(function (c) { return c.expanded = !allExpanded; });
	    };
	    DNAProfileSankeyController.prototype.allExpanded = function (chromosomes) {
	        return (chromosomes || []).every(function (c) { return c.expanded; });
	    };
	    DNAProfileSankeyController.prototype.processData = function (rawData) {
	        var _this = this;
	        var pw = this.utils.pleaseWait();
	        var _a = __read(!!rawData ? this.dnaParsers.processSegmentData(rawData, this.source) : [[], []], 2), list = _a[0], kits = _a[1];
	        var missingSegmentsCount = 0;
	        if (list.length === 0 || kits.length === 0) {
	            this.utils.pleaseWaitCancel(pw);
	            this.messageBus.post({ msg: 'This import is not recognized. Please contact support@rootsfinder.com' });
	            this.isProcessing = false;
	            this.server.decRequests();
	            return;
	        }
	        // read existing kits
	        this.dnaKits.stream().take(1).map(function (kitMap) {
	            // group by name
	            kitMap = _this.dnaProfiles.kitsByName(kitMap, _this.source);
	            var missingKits = new Set();
	            // for each new kit: add or update?
	            kits.forEach(function (kit) {
	                if (!kitMap.has(kit.name)) {
	                    missingSegmentsCount++;
	                    missingKits.add(kit.name);
	                }
	            });
	            console.log('missing', Array.from(missingKits.values()));
	            // remove entries from list where the kit is missing
	            list = list.filter(function (item) { return !missingKits.has(item.name); });
	        }).flatMap(function () {
	            console.log('list', list.length);
	            return _this.streamDNAProfileData().take(1);
	        }).flatMap(function (existing) {
	            console.log('existing', !!existing);
	            // convert list to tsv
	            var tsv = _this.dnaParsers.listToTSV(_this.dnaProfiles.segmentTSVHeaders[_this.source], list);
	            // do we have existing data ?
	            if (!!existing) {
	                var dpd = _this.utils.clone(existing);
	                if (_this.reset) {
	                    dpd.tsv = tsv;
	                }
	                else {
	                    // convert existing data to map
	                    var oldMap = _this.dnaParsers.tsvToMap(_this.dnaProfiles.segmentTSVHeaders[_this.source], _this.dnaProfiles.segmentTSVNumbers[_this.source], _this.mapKeyFn, existing.tsv);
	                    // convert new data to map
	                    var newMap = _this.dnaParsers.tsvToMap(_this.dnaProfiles.segmentTSVHeaders[_this.source], _this.dnaProfiles.segmentTSVNumbers[_this.source], _this.mapKeyFn, tsv);
	                    try {
	                        // merge maps
	                        for (var _a = __values(newMap.entries()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                            var _c = __read(_b.value, 2), key = _c[0], value = _c[1];
	                            oldMap.set(key, value);
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                    // convert merged map to tsv
	                    dpd.tsv = _this.dnaParsers.listToTSV(_this.dnaProfiles.segmentTSVHeaders[_this.source], oldMap.values());
	                }
	                // update existing dpd
	                return _this.dnaProfileDatas.update(dpd).map(function () { return list.length; });
	            }
	            else {
	                // add segment data
	                var dpd = {
	                    profileId: _this.dnaProfile.id,
	                    type: 'SEGMENT',
	                    tsvHeaders: _this.dnaProfiles.segmentTSVHeaders[_this.source].join('\t'),
	                    tsv: tsv
	                };
	                return _this.dnaProfileDatas.create(dpd).map(function () { return list.length; });
	            }
	            var e_2, _d;
	        }).subscribe(function (cnt) {
	            console.log('success', cnt);
	            _this.utils.pleaseWaitCancel(pw);
	            _this.isProcessing = false;
	            _this.server.decRequests();
	            _this.utils.alert('Success!', cnt + ' Segment matches successfully imported.' +
	                (missingSegmentsCount > 0 ? ' ' + missingSegmentsCount + ' segments in this import were ignored because the kits were not in your matches list.' : ''));
	        }, function (err) {
	            console.log('error', err);
	            _this.utils.pleaseWaitCancel(pw);
	            _this.$log.error('Error importing', err);
	            _this.messageBus.post({ msg: 'Error importing: ' + err, warn: true });
	            _this.isProcessing = false;
	            _this.server.decRequests();
	        });
	    };
	    DNAProfileSankeyController.prototype.constructData = function (dpd, kitMap) {
	        var _this = this;
	        var list = this.dnaParsers.tsvToList(this.dnaProfiles.segmentTSVHeaders[this.source], this.dnaProfiles.segmentTSVNumbers[this.source], dpd.tsv);
	        list = list.filter(function (item) { return item.chr > 0; });
	        // set up initial chromosome chromosome nodes w basic color and value
	        var chromosomes = this.getChromosomes(list);
	        // sort list by largest cm
	        list.sort(function (a, b) {
	            return b.cm - a.cm;
	        });
	        // for each element in list
	        list.forEach(function (item) {
	            // skip invalid segments
	            if (Number.isNaN(item.chr) || item.chr < 1 || item.chr > 23) {
	                return;
	            }
	            var nodes = chromosomes[item.chr - 1].nodes;
	            var links = chromosomes[item.chr - 1].links;
	            // skip hidden
	            if (!kitMap.has(item.name) || kitMap.get(item.name).hidden) {
	                return;
	            }
	            // get matching nodes: o < to and i < ti on both sides
	            var matchingNode = _this.getMatchingNode(nodes, item);
	            // if there is a matching node
	            if (!!matchingNode) {
	                if (!matchingNode.items.some(function (i) { return i.name === item.name; })) {
	                    matchingNode.items.push(item);
	                }
	            }
	            else {
	                var node = _this.createNode(nodes.length, item.start, item.end, 0, item);
	                var unmatched = [{ start: item.start, end: item.end }];
	                var parents = [];
	                // calc parent links starting with highest-level nodes first
	                var others = nodes.slice();
	                others.sort(function (a, b) {
	                    return b.level - a.level;
	                });
	                try {
	                    for (var others_1 = __values(others), others_1_1 = others_1.next(); !others_1_1.done; others_1_1 = others_1.next()) {
	                        var other = others_1_1.value;
	                        var overlap = _this.getOverlap(item, unmatched, other, overlapThreshold);
	                        if (!!overlap) {
	                            parents.push(other);
	                            // remove matched range
	                            unmatched = _this.subtractOverlap(unmatched, overlap);
	                            // create parent link
	                            links.push(_this.createLink(other, node, overlap));
	                            // stop if no more unmatched
	                            if (unmatched.length === 0) {
	                                break;
	                            }
	                        }
	                    }
	                }
	                catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                finally {
	                    try {
	                        if (others_1_1 && !others_1_1.done && (_a = others_1.return)) _a.call(others_1);
	                    }
	                    finally { if (e_3) throw e_3.error; }
	                }
	                if (parents.length === 0) {
	                    parents.push(nodes[0]);
	                }
	                node.level = Math.max.apply(Math, __spread(parents.map(function (p) { return p.level; }))) + 1;
	                nodes.push(node);
	            }
	            var e_3, _a;
	        });
	        // calc color
	        //let reSegment = /[0-9a-f]{2}/gi;
	        chromosomes.forEach(function (chromosome) {
	            chromosome.nodes.forEach(function (node) {
	                if (node.level === 1) {
	                    return;
	                }
	                node.items.forEach(function (item) {
	                    var kit = kitMap.get(item.name);
	                    item.color = defaultCircleColor;
	                    if (kit.colorOverride) {
	                        item.color = _this.utils.getAhnentafelColor(_this.treePrefs, _this.utils.colorOverrideBase + kit.colorOverride);
	                    }
	                    else if (kit.matchType === 'NOT') {
	                        item.color = _this.utils.getAhnentafelColor(_this.treePrefs, _this.utils.colorNOT);
	                    }
	                    else if (!!kit.personId1) {
	                        var pids = [kit.personId1];
	                        if (!!kit.personId2) {
	                            pids.push(kit.personId2);
	                        }
	                        _this.dnaProfiles.getMatches(_this.pedigree, pids).take(1).subscribe(function (matches) {
	                            var colors = matches.map(function (match) { return _this.utils.getAhnentafelColor(_this.treePrefs, match, false); });
	                            item.color = _this.utils.averageColor(colors, defaultCircleColor);
	                        });
	                    }
	                });
	            });
	            // add some useful attributes
	            chromosome.nodes.forEach(function (node) {
	                if (node.items.length > 0) {
	                    var min_1 = 999999999;
	                    var max_1 = 0;
	                    node.items.forEach(function (item) {
	                        if (item.start < min_1) {
	                            min_1 = item.start;
	                        }
	                        if (item.end > max_1) {
	                            max_1 = item.end;
	                        }
	                    });
	                    node.start = min_1;
	                    node.end = max_1;
	                }
	                node.numItems = node.items.length;
	            });
	        });
	        return chromosomes;
	    };
	    DNAProfileSankeyController.prototype.getOverlap = function (item, unmatched, node, threshold) {
	        try {
	            for (var unmatched_1 = __values(unmatched), unmatched_1_1 = unmatched_1.next(); !unmatched_1_1.done; unmatched_1_1 = unmatched_1.next()) {
	                var range = unmatched_1_1.value;
	                var start = Math.max(node.start, range.start);
	                var end = Math.min(node.end, range.end);
	                var overlap = end - start;
	                if (overlap >= Math.min(threshold, (item.end - item.start) >>> 1)) {
	                    return { start: start, end: end };
	                }
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (unmatched_1_1 && !unmatched_1_1.done && (_a = unmatched_1.return)) _a.call(unmatched_1);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        return null;
	        var e_4, _a;
	    };
	    DNAProfileSankeyController.prototype.subtractOverlap = function (unmatched, overlap) {
	        var result = [];
	        try {
	            for (var unmatched_2 = __values(unmatched), unmatched_2_1 = unmatched_2.next(); !unmatched_2_1.done; unmatched_2_1 = unmatched_2.next()) {
	                var range = unmatched_2_1.value;
	                if (overlap.start < range.end && overlap.end > range.start) {
	                    if (overlap.start - range.start >= overlapThreshold) {
	                        result.push({ start: range.start, end: overlap.start });
	                    }
	                    if (range.end - overlap.end >= overlapThreshold) {
	                        result.push({ start: overlap.end, end: range.end });
	                    }
	                }
	                else {
	                    result.push(range);
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (unmatched_2_1 && !unmatched_2_1.done && (_a = unmatched_2.return)) _a.call(unmatched_2);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        return result;
	        var e_5, _a;
	    };
	    DNAProfileSankeyController.prototype.createLink = function (source, target, overlap) {
	        var sourceStart = Math.max(0, overlap.start - source.start);
	        var targetStart = Math.max(0, overlap.start - target.start);
	        var size = Math.min(overlap.end - overlap.start, source.end - sourceStart, target.end - targetStart);
	        return {
	            source: source.ix,
	            target: target.ix,
	            sourcePos: sourceStart,
	            targetPos: targetStart,
	            value: size
	        };
	    };
	    DNAProfileSankeyController.prototype.getMatchingNode = function (nodes, item) {
	        var matchingNodes = nodes.filter(function (node) {
	            if (node.level === 1) {
	                return false;
	            }
	            if (item.start < node.start) {
	                if (node.start - item.start > outsideThreshold) {
	                    return false;
	                }
	            }
	            else {
	                if (item.start > node.end || item.start - node.start > insideThreshold) {
	                    return false;
	                }
	            }
	            if (item.end > node.end) {
	                if (item.end - node.end > outsideThreshold) {
	                    return false;
	                }
	            }
	            else {
	                if (item.end < node.start || node.end - item.end > insideThreshold) {
	                    return false;
	                }
	            }
	            return true;
	        });
	        // return node with largest overlap
	        if (matchingNodes.length > 1) {
	            matchingNodes.sort(function (a, b) {
	                var overlapA = Math.min(a.end, item.end) - Math.max(a.start, item.start);
	                var overlapB = Math.min(b.end, item.end) - Math.max(b.start, item.start);
	                return overlapB - overlapA;
	            });
	        }
	        return matchingNodes[0];
	    };
	    // TODO get rid of colors
	    DNAProfileSankeyController.prototype.createNode = function (ix, start, end, level, item, color) {
	        return {
	            ix: ix,
	            start: start,
	            end: end,
	            value: end - start,
	            level: level,
	            color: color || defaultNodeColor,
	            items: !!item ? [item] : []
	        };
	    };
	    DNAProfileSankeyController.prototype.createChromoNode = function (name, len) {
	        var node = this.createNode(0, 0, len, 1, null, chromoColor);
	        node.name = name;
	        return node;
	    };
	    DNAProfileSankeyController.prototype.getChromosomes = function (list) {
	        var chromosomes = [];
	        chromosomes.push({ nodes: [this.createChromoNode('1', 248956422)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('2', 242193529)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('3', 198295559)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('4', 190214555)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('5', 181538259)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('6', 170805979)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('7', 159345973)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('8', 145138636)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('9', 138394717)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('10', 133797422)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('11', 135086622)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('12', 133275309)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('13', 114364328)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('14', 107043718)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('15', 101991189)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('16', 90338345)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('17', 83257441)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('18', 80373285)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('19', 58617616)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('20', 64444167)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('21', 46709983)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('22', 50818468)], links: [] });
	        chromosomes.push({ nodes: [this.createChromoNode('X', 156040895)], links: [] });
	        // resize chromosomes
	        list.forEach(function (item) {
	            var chr = chromosomes[item.chr - 1];
	            if (!!chr && item.end > chr.nodes[0].end) {
	                chr.nodes[0].end = chr.nodes[0].value = item.end;
	            }
	        });
	        return chromosomes;
	    };
	    DNAProfileSankeyController.prototype.mapKeyFn = function (fields) {
	        return fields[0] + '/' + fields[1].toString() + '/' + fields[2].toString();
	    };
	    return DNAProfileSankeyController;
	}());
	exports.default = rcDNAProfileSankeyDirective;


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcDNAProfileToolbarDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/dnaProfile/dnaProfileToolbar.html',
	        controller: DNAProfileToolbarController,
	        controllerAs: 'toolbar',
	        bindToController: true,
	        scope: {
	            view: '=',
	            numFilters: '=',
	            disableLoadFilter: '=',
	            disableSaveFilter: '=',
	            expanded: '='
	        }
	    };
	}
	var DNAProfileToolbarController = /** @class */ (function () {
	    DNAProfileToolbarController.$inject = ["$rootScope", "$scope", "$timeout"];
	    function DNAProfileToolbarController($rootScope, $scope, $timeout) {
	        'ngInject';
	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.$timeout = $timeout;
	        this.$onInit = function () {
	            // pass
	        };
	    }
	    DNAProfileToolbarController.prototype.isToolbarExpanded = function () {
	        return this.expanded;
	    };
	    DNAProfileToolbarController.prototype.toggleToolbarExpanded = function () {
	        this.$scope.$emit('toolbarExpanded', !this.expanded);
	    };
	    DNAProfileToolbarController.prototype.searchChange = function () {
	        this.$scope.$emit('searchChange', this.search);
	    };
	    DNAProfileToolbarController.prototype.loadFilter = function ($event) {
	        this.$scope.$emit('loadFilter', { ev: $event });
	    };
	    DNAProfileToolbarController.prototype.saveFilter = function ($event) {
	        this.$scope.$emit('saveFilter', { ev: $event });
	    };
	    DNAProfileToolbarController.prototype.zoom = function (multiplier) {
	        this.$scope.$emit('zoomChange', multiplier);
	    };
	    DNAProfileToolbarController.prototype.expand = function (multiplier) {
	        this.$scope.$emit('expandChange', multiplier);
	    };
	    DNAProfileToolbarController.prototype.filter = function ($event) {
	        this.$scope.$emit('filter', { ev: $event });
	    };
	    return DNAProfileToolbarController;
	}());
	exports.default = rcDNAProfileToolbarDirective;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	"use strict";
	rcDragDirective.$inject = ["$window", "$document"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcDragDirective($window, $document) {
	    'ngInject';
	    var moveThreshold = 100;
	    var documentListenersActive = false;
	    var rAFPending = false;
	    var mouseStart = null;
	    var mouseLast = null;
	    var mouseDelta = { x: 0, y: 0 };
	    var offset = { x: 0, y: 0 };
	    var target;
	    function setupDocumentListeners() {
	        if (!documentListenersActive) {
	            $document.on('mousemove', mousemove);
	            $document.on('mouseup', mouseup);
	            documentListenersActive = true;
	        }
	    }
	    function takedownDocumentListeners() {
	        if (documentListenersActive) {
	            $document.off('mousemove', mousemove);
	            $document.off('mouseup', mouseup);
	            documentListenersActive = false;
	        }
	    }
	    function updateViewport() {
	        if (!!target) {
	            target.css('transform', 'translate(' + (offset.x + mouseDelta.x) + 'px,' + (offset.y + mouseDelta.y) + 'px)');
	        }
	    }
	    function requestUpdateViewport() {
	        if (!rAFPending) {
	            $window.requestAnimationFrame(function () {
	                updateViewport();
	                rAFPending = false;
	            });
	            rAFPending = true;
	        }
	    }
	    function mousedown(ev) {
	        mouseStart = { x: ev.pageX, y: ev.pageY };
	        mouseLast = mouseStart;
	        setupDocumentListeners();
	    }
	    function mousemove(ev) {
	        if (mouseLast === null || Math.abs(ev.pageX - mouseLast.x) > moveThreshold || Math.abs(ev.pageY - mouseLast.y) > moveThreshold) {
	            mouseStart = null;
	            mouseup();
	        }
	        else {
	            mouseLast = { x: ev.pageX, y: ev.pageY };
	            mouseDelta = { x: (ev.pageX - mouseStart.x), y: (ev.pageY - mouseStart.y) };
	            requestUpdateViewport();
	        }
	    }
	    function mouseup() {
	        if (mouseStart !== null) {
	            offset.x += mouseDelta.x;
	            offset.y += mouseDelta.y;
	            mouseDelta = { x: 0, y: 0 };
	        }
	        mouseStart = null;
	        mouseLast = null;
	        takedownDocumentListeners();
	    }
	    function link(scope, elem, attrs) {
	        target = elem;
	        angular.element(elem[0].querySelector(attrs.rcDrag)).bind('mousedown', mousedown);
	        scope.$on('$destroy', function () {
	            takedownDocumentListeners();
	        });
	    }
	    return {
	        restrict: 'A',
	        link: link
	    };
	}
	exports.default = rcDragDirective;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcEvidenceDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/evidence/evidence.html',
	        controller: EvidenceController,
	        controllerAs: 'evidence',
	        bindToController: true,
	        scope: {
	            evidence: '=',
	            fact: '=',
	            name: '=',
	            sync: '=',
	            expanded: '=',
	            hideTools: '=',
	            forceCreatedEdited: '='
	        }
	    };
	}
	var EvidenceController = /** @class */ (function () {
	    EvidenceController.$inject = ["$log", "$scope", "rightsFull", "evidences", "persons", "medias", "researchLogs", "sources", "social", "users", "utils"];
	    function EvidenceController($log, $scope, rightsFull, evidences, persons, medias, researchLogs, sources, social, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.evidences = evidences;
	        this.persons = persons;
	        this.medias = medias;
	        this.social = social;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.mediasList = [];
	        this.viewableFileTypes = ['video/mp4', 'application/pdf', 'image/tiff', 'image/jpeg', 'image/png', 'image/bmp', 'image/gif'];
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.$onInit = function () {
	            _this.source = null;
	            if (_this.evidence.citation.sourceId > 0) {
	                sources.streamId(_this.evidence.citation.sourceId).take(1).subscribe(function (source) {
	                    _this.source = source;
	                });
	            }
	            if ((_this.evidence.createdUser > 0 && !_this.evidence._createdUser) || (_this.evidence.editedUser > 0 && !_this.evidence._editedUser)) {
	                utils.addCreateEditUsers(_this.evidence, users).subscribe(function () {
	                    // nothing to do
	                });
	            }
	            _this.twitterUrl = social.getTwitterUrl({
	                text: _this.evidence._sourceTitle,
	                personIds: new Map(Array.from(_this.evidence._personas.values()).map(function (p) { return [p._id, true]; }))
	            });
	            $scope.$on('share', function (ev, params) {
	                _this.share(params.ev, params.platform);
	                ev.stopPropagation();
	            });
	        };
	        var rlSub = utils.watch($scope, function () { return _this.evidence.researchLogId; }).flatMap(function () { return researchLogs.streamId(_this.evidence.researchLogId); }).subscribe(function (log) {
	            _this.researchLogTitle = !!log ? log.title : '';
	        });
	        var mSub = utils.watch($scope, function () { return _this.evidence.mediaIds; }).flatMap(function () { return medias.streamIds(_this.evidence.mediaIds.keys()); }).subscribe(function (ms) {
	            var mediasList = Array.from(ms.values());
	            _this.mediasList = mediasList;
	        });
	        $scope.$on('$destroy', function () {
	            rlSub.unsubscribe();
	            mSub.unsubscribe();
	        });
	    }
	    EvidenceController.prototype.getFullName = function (n) {
	        return this.persons.getNameText(this.persons.getDefaultNameForm(n));
	    };
	    EvidenceController.prototype.toggleExpand = function () {
	        this.$scope.$emit('toggleExpand', { type: 'evidence', id: this.evidence.id });
	    };
	    EvidenceController.prototype.edit = function (ev) {
	        this.$scope.$emit('edit', { ev: ev, type: 'evidence', item: this.evidence });
	    };
	    EvidenceController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'evidence', id: this.evidence.id });
	    };
	    EvidenceController.prototype.showSource = function (ev) {
	        if (this.evidence.citation.sourceId > 0) {
	            this.$scope.$emit('show', { ev: ev, type: 'source', id: this.evidence.citation.sourceId });
	        }
	        else {
	            this.edit(ev);
	        }
	    };
	    EvidenceController.prototype.share = function (ev, platform) {
	        this.social.post(platform, {
	            title: this.evidence._sourceTitle,
	            mediaId: this.evidence.mediaIds.size > 0 ? Array.from(this.evidence.mediaIds.keys())[0] : 0,
	            description: this.utils.removeHtml(this.evidence.text),
	            personIds: new Map(Array.from(this.evidence._personas.values()).map(function (p) { return [p._id, true]; }))
	        }, ev);
	    };
	    EvidenceController.prototype.getMediaIds = function (o) {
	        // can be called with a null evidence.source so we must check
	        return !!o ? Array.from(o.mediaIds.keys()) : [];
	    };
	    EvidenceController.prototype.getMedias = function (o) {
	        return this.mediasList;
	    };
	    EvidenceController.prototype.getMediaURL = function (m) {
	        return this.medias.getMediaURL(m);
	    };
	    EvidenceController.prototype.getMediaImageURL = function (m, size) {
	        return this.medias.getMediaImageURL(m, size);
	    };
	    EvidenceController.prototype.getMediaFilename = function (m) {
	        return m.fileInfos.size > 0 ? this.utils.first(m.fileInfos).fileName : '';
	    };
	    EvidenceController.prototype.isViewableType = function (m) {
	        if (!m || m.fileInfos.size === 0) {
	            return false;
	        }
	        var contentType = this.utils.first(m.fileInfos).contentType.toLowerCase();
	        return this.viewableFileTypes.includes(contentType);
	    };
	    EvidenceController.prototype.getThumbURL = function (u) {
	        return this.utils.getThumbURL(u);
	    };
	    EvidenceController.prototype.isValidURL = function (u) {
	        return this.utils.isValidURL(u);
	    };
	    EvidenceController.prototype.getIcon = function (f) {
	        var ft = this.utils.factTypes.find(function (ft) { return ft.value === f.type; });
	        return (!!ft && ft.icon) || 'publication';
	    };
	    EvidenceController.prototype.getYear = function (e) {
	        if (!e.fact || !e.fact.dateSort) {
	            return '';
	        }
	        return e.fact.dateSort.substr(0, 4);
	    };
	    EvidenceController.prototype.getPlaceLink = function (e) {
	        if (!e.fact || !e.fact.placeStandard) {
	            return '';
	        }
	        return 'http://www.werelate.org/wiki/Place:' + encodeURI(e.fact.placeStandard.replace(' ', '_'));
	    };
	    EvidenceController.prototype.getPrincipalName = function (e) {
	        try {
	            for (var _a = __values(e._personas.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var pa = _b.value;
	                if (pa.principal && pa.relatedToKey === 0 && pa.relationshipType === '') {
	                    return pa._fullName;
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        try {
	            for (var _d = __values(e._personas.values()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                var pa = _e.value;
	                return pa._fullName;
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        return '';
	        var e_1, _c, e_2, _f;
	    };
	    return EvidenceController;
	}());
	exports.default = rcEvidenceDirective;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcFactDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/fact/fact.html',
	        controller: FactController,
	        controllerAs: 'fact',
	        bindToController: true,
	        scope: {
	            fact: '=',
	            expanded: '=',
	            hideTools: '=',
	            forceCreatedEdited: '=',
	            hideEvidences: '='
	        }
	    };
	}
	var FactController = /** @class */ (function () {
	    FactController.$inject = ["$log", "$rootScope", "$scope", "rightsFull", "evidences", "utils"];
	    function FactController($log, $rootScope, $scope, rightsFull, evidences, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.evidences = evidences;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.$onInit = function () {
	            _this.expandedEvidences = new Map();
	            var expandedSub = utils.watch($scope, 'fact.expanded').subscribe(function (_a) {
	                var newValue = _a.newValue;
	                try {
	                    for (var _b = __values(_this.fact._evidences), _c = _b.next(); !_c.done; _c = _b.next()) {
	                        var _d = __read(_c.value, 1), id = _d[0];
	                        _this.expandedEvidences.set(id, newValue);
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                var e_1, _e;
	            });
	            $scope.$on('$destroy', function () {
	                expandedSub.unsubscribe();
	            });
	            $scope.$on('toggleExpand', function (ev, params) {
	                if (params.type === 'evidence') {
	                    _this.expandedEvidences.set(params.id, !_this.expandedEvidences.get(params.id));
	                    ev.stopPropagation();
	                }
	            });
	        };
	    }
	    FactController.prototype.showValueInTitle = function (typ) {
	        return ['OCCU', 'SEX', 'RELI'].includes(typ);
	    };
	    FactController.prototype.dragstart = function (evidence) {
	        this.$rootScope.dragEvidence = evidence;
	    };
	    FactController.prototype.dragend = function () {
	        this.$rootScope.dragEvidence = null;
	    };
	    FactController.prototype.dragtype = function (evidence) {
	        return [this.fact._key.toString(), evidence.id.toString(), this.fact.evidencePersonas.get(evidence.id).toString()].join('#');
	    };
	    FactController.prototype.dragover = function (event, index, type) {
	        var _a = __read(type.split('#'), 3), factKey = _a[0], evidenceId = _a[1], personaKey = _a[2];
	        return this.isCompatible(+evidenceId, this.$rootScope.dragEvidence, +personaKey, factKey);
	    };
	    FactController.prototype.drop = function (ev, index, item, type) {
	        var _a = __read(type.split('#'), 3), factKey = _a[0], evidenceId = _a[1], personaKey = _a[2];
	        if (this.isCompatible(+evidenceId, this.$rootScope.dragEvidence, +personaKey)) {
	            this.$scope.$emit('move', { ev: ev, type: 'evidence', evidenceId: +evidenceId, sourceId: +factKey, targetId: this.fact._key });
	        }
	        return true;
	    };
	    FactController.prototype.isCompatible = function (eid, evidence, personaKey) {
	        // require evidence to have a "compatible" fact; and not be in this fact. fact must be principal and fact cannot be SOUR
	        if (eid !== evidence.id || !evidence.personas.has(personaKey) || this.fact.evidencePersonas.has(eid) || !this.fact.principal || this.fact.type === 'SOUR') {
	            return false;
	        }
	        if (this.utils.factCompatible(this.fact, evidence.fact, true)) {
	            return true;
	        }
	        try {
	            for (var _a = __values(evidence.personas.get(personaKey).facts.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var f = _b.value;
	                if (this.utils.factCompatible(this.fact, f, true)) {
	                    return true;
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        return false;
	        var e_2, _c;
	    };
	    FactController.prototype.getBioValue = function (v) {
	        return v.replace(new RegExp('\n', 'g'), '<br>');
	    };
	    FactController.prototype.getIcon = function (f) {
	        var ft = this.utils.factTypes.find(function (ft) { return ft.value === f.type; });
	        return (!!ft && ft.icon) || 'publication';
	    };
	    FactController.prototype.getYear = function (f) {
	        return !!f.dateSort ? f.dateSort.substr(0, 4) : '';
	    };
	    FactController.prototype.getPlaceLink = function (f) {
	        var ps = f.placeStandard;
	        if (!ps) {
	            return '';
	        }
	        return 'http://www.werelate.org/wiki/Place:' + encodeURI(ps.replace(' ', '_'));
	    };
	    FactController.prototype.toggleHidden = function () {
	        // TODO hide facts
	    };
	    FactController.prototype.toggleExpand = function () {
	        this.$scope.$emit('toggleExpand', { id: this.fact._key });
	    };
	    FactController.prototype.addEvidence = function (ev) {
	        this.$scope.$emit('add', { ev: ev, type: 'evidence', item: this.fact });
	    };
	    FactController.prototype.edit = function (ev) {
	        this.$scope.$emit('add', { ev: ev, type: 'evidence', item: this.fact });
	    };
	    FactController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'fact', id: this.fact._key });
	    };
	    return FactController;
	}());
	exports.default = rcFactDirective;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcFamilyDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/family/family.html',
	        controller: FamilyController,
	        controllerAs: 'family',
	        bindToController: true,
	        scope: {
	            family: '=',
	            expanded: '=',
	            isDraggable: '=',
	            self: '=',
	            mode: '@'
	        }
	    };
	}
	var FamilyController = /** @class */ (function () {
	    FamilyController.$inject = ["$log", "$scope", "rightsFull"];
	    function FamilyController($log, $scope, rightsFull) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.hasIdFilter = this.hasId.bind(this);
	        this.showChildren = true;
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.$onInit = function () {
	            $scope.$on('remove', function (ev, params) {
	                _this.$scope.$emit('delete', { ev: params.ev, type: 'family', item: _this.family, personId: params.id });
	            });
	            $scope.$on('editRel', function (ev, params) {
	                _this.$scope.$emit('edit', { ev: params.ev, type: 'family', item: _this.family, personId: params.id });
	            });
	        };
	    }
	    FamilyController.prototype.hasId = function (item) {
	        return !!item && !!item.id;
	    };
	    FamilyController.prototype.dragover = function (event, index, type) {
	        return type !== this.family.id.toString();
	    };
	    FamilyController.prototype.drop = function (ev, index, item, type) {
	        if (type !== this.family.id.toString()) {
	            this.$scope.$emit('move', { ev: ev, type: 'family', personId: item.id, sourceId: parseInt(type, 10), targetId: this.family.id });
	        }
	        return true;
	    };
	    FamilyController.prototype.select = function (ev, personId, relationshipType) {
	        if (personId === 0) {
	            this.$scope.$emit('add', { ev: ev, type: 'family', id: this.family.id, relationshipType: this.mode === 'spouse-children' ? 'SPOUSE' : relationshipType });
	        }
	    };
	    FamilyController.prototype.addChild = function (ev) {
	        this.$scope.$emit('add', { ev: ev, type: 'family', id: this.family.id, relationshipType: this.mode === 'spouse-children' ? 'CHILD' : 'SIBLING' });
	    };
	    return FamilyController;
	}());
	exports.default = rcFamilyDirective;


/***/ }),
/* 127 */
/***/ (function(module, exports) {

	"use strict";
	rcFractalDirective.$inject = ["$log", "$window", "$document", "$timeout", "hammer", "rightsFull", "mousewheel", "sidenav", "utils", "easing", "rx", "persons", "families", "leads", "evidences", "currentUser"];
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcFractalDirective($log, $window, $document, $timeout, hammer, rightsFull, mousewheel, sidenav, utils, easing, rx, persons, families, leads, evidences, currentUser) {
	    'ngInject';
	    // constants
	    var personWidth = 96;
	    var personHeight = 160;
	    var baseOffset = 140;
	    var toolbarWidth = 350;
	    var toolbarHeight = 60;
	    var leftPadding = 0;
	    var bottomPadding = 150;
	    var maxYOffset = 620;
	    var scaleMultiplier = 0.6;
	    var wheelMultiplier = 1.1;
	    var minWheelMillis = 20;
	    var minScale = 0.5;
	    var maxScale = 20;
	    var initialScale = 1.6;
	    var epsilon = 0.000001;
	    var rotateAnimMillis = 250;
	    //const showPersonCnt = 32;
	    //const showPersonInterval = 400;
	    var parentElementQuerySelector = '.fractal__inner';
	    var maxPos = Math.pow(2, 20);
	    var centerTransform = {
	        tx: -personWidth / 2,
	        ty: -personHeight / 2,
	        scale: 1,
	        rot: 0
	    };
	    // static
	    var transformMap = {};
	    // instance variables
	    var prevWheelMillis = 0;
	    var rootElement, parentElement;
	    var scope;
	    var personData;
	    var documentListenersActive, rAFPending;
	    var rootTransform, mouseStart, mouseTransform;
	    var sinCos = {};
	    var rotateStartMillis, rotateStartTransform, rotateRect, rotateDeg, rotatePending;
	    var hammertime;
	    var startScale;
	    function normalizeRotation(rot) {
	        return rot > 180 ? rot - 360 : rot <= -180 ? rot + 360 : rot;
	    }
	    function zeroEps(n) {
	        return Math.abs(n) < epsilon ? 0 : n;
	    }
	    function getSinCos(rot) {
	        if (!!sinCos[rot]) {
	            return sinCos[rot];
	        }
	        var rad = rot * Math.PI / 180;
	        var result = {
	            sin: zeroEps(Math.sin(rad)),
	            cos: zeroEps(Math.cos(rad))
	        };
	        sinCos[rot] = result;
	        return result;
	    }
	    function composeTransform(t1, t2) {
	        var sinCos = getSinCos(t1.rot);
	        return {
	            tx: t1.tx + (t2.tx * sinCos.cos - t2.ty * sinCos.sin) * t1.scale,
	            ty: t1.ty + (t2.ty * sinCos.cos + t2.tx * sinCos.sin) * t1.scale,
	            scale: t1.scale * t2.scale,
	            rot: normalizeRotation(t1.rot + t2.rot)
	        };
	    }
	    function getPathTransform(path) {
	        if (path === '') {
	            return {
	                tx: 0,
	                ty: 0,
	                scale: 1,
	                rot: 0
	            };
	        }
	        var result = transformMap[path];
	        if (!!result) {
	            return result;
	        }
	        result = getPathTransform(path.substr(0, path.length - 1));
	        var rotation = normalizeRotation(result.rot + (path.charAt(path.length - 1) === '0' ? -45 : +45));
	        var sinCos = getSinCos(-rotation);
	        result = {
	            tx: result.tx + sinCos.sin * baseOffset * result.scale,
	            ty: result.ty + sinCos.cos * baseOffset * result.scale,
	            scale: result.scale * scaleMultiplier,
	            rot: rotation
	        };
	        transformMap[path] = result;
	        return result;
	    }
	    function getTransform(id) {
	        var p = personData[id];
	        var transform = composeTransform(composeTransform(composeTransform(centerTransform, mouseTransform), rootTransform), getPathTransform(p.path));
	        //$log.info('getTransform', id, 'mouse', mouseTransform, 'root', rootTransform, 'path', getPathTransform(p.path), 'final', transform);
	        return 'translate(' + transform.tx + 'px,' + transform.ty + 'px) scale(' + transform.scale + ')';
	    }
	    function getFatherLineTransform(id) {
	        var p = personData[id];
	        var transform = composeTransform(composeTransform(mouseTransform, rootTransform), getPathTransform(p.path));
	        var rot = normalizeRotation(transform.rot - 45);
	        //$log.info('getFatherLineTransform', id, 'root', rootTransform, 'path', getPathTransform(p.path), 'final', transform, 'rot', rot);
	        return 'translate(' + transform.tx + 'px,' + transform.ty + 'px) rotate(' + rot + 'deg) scale(' + transform.scale + ')';
	    }
	    function getMotherLineTransform(id) {
	        var p = personData[id];
	        var transform = composeTransform(composeTransform(mouseTransform, rootTransform), getPathTransform(p.path));
	        var rot = normalizeRotation(transform.rot + 45);
	        //$log.info('getMotherLineTransform', id, 'root', rootTransform, 'path', getPathTransform(p.path), 'final', transform, 'rot', rot);
	        return 'translate(' + transform.tx + 'px,' + transform.ty + 'px) rotate(' + rot + 'deg) scale(' + transform.scale + ')';
	    }
	    function mousedown(ev) {
	        mouseStart = { x: ev.pageX, y: ev.pageY };
	        setupDocumentListeners();
	    }
	    function mousemove(ev) {
	        mouseTransform.tx = ev.pageX - mouseStart.x;
	        mouseTransform.ty = ev.pageY - mouseStart.y;
	        requestUpdateViewport();
	    }
	    function mouseup() {
	        rootTransform.tx += mouseTransform.tx;
	        rootTransform.ty += mouseTransform.ty;
	        mouseTransform.tx = 0;
	        mouseTransform.ty = 0;
	        takedownDocumentListeners();
	    }
	    function panstart() {
	        setupDocumentListeners();
	    }
	    function panmove(ev) {
	        mouseTransform.tx = ev.deltaX;
	        mouseTransform.ty = ev.deltaY;
	        requestUpdateViewport();
	    }
	    function panend() {
	        rootTransform.tx += mouseTransform.tx;
	        rootTransform.ty += mouseTransform.ty;
	        mouseTransform.tx = 0;
	        mouseTransform.ty = 0;
	        takedownDocumentListeners();
	    }
	    function wheel(ev) {
	        var currTime = Date.now();
	        if (currTime - prevWheelMillis < minWheelMillis) {
	            return;
	        }
	        prevWheelMillis = currTime;
	        // get mouse position
	        var rect = rootElement[0].getBoundingClientRect();
	        var mouseX = ev.pageX - rect.left;
	        var mouseY = ev.pageY - rect.top;
	        // ignore probably-accidental mousewheel movement over toolbar
	        if (mouseX <= toolbarWidth && mouseY <= toolbarHeight) {
	            return;
	        }
	        var multiplier;
	        if (ev.deltaY > 0) {
	            multiplier = 1 / wheelMultiplier;
	        }
	        else {
	            multiplier = wheelMultiplier;
	        }
	        scale(multiplier, mouseX, mouseY); //, true);
	    }
	    function scale(multiplier, x, y) {
	        // update scale
	        var oldScale = rootTransform.scale;
	        rootTransform.scale *= multiplier;
	        if (rootTransform.scale < minScale) {
	            rootTransform.scale = minScale;
	        }
	        else if (rootTransform.scale > maxScale) {
	            rootTransform.scale = maxScale;
	        }
	        // update translate so point under mouse does not move
	        rootTransform.tx = (rootTransform.tx - x) / oldScale * rootTransform.scale + x;
	        rootTransform.ty = (rootTransform.ty - y) / oldScale * rootTransform.scale + y;
	        requestUpdateViewport();
	    }
	    function zoom(multiplier) {
	        var rect = rootElement[0].getBoundingClientRect();
	        scale(multiplier, rect.width / 2, rect.height / 2); //, false);
	    }
	    function pinchstart() {
	        startScale = rootTransform.scale;
	        setupDocumentListeners();
	    }
	    function pinchmove(ev) {
	        if (startScale * ev.scale >= minScale && startScale * ev.scale <= maxScale) {
	            var oldScale = rootTransform.scale;
	            rootTransform.scale = startScale * ev.scale;
	            var rect = rootElement[0].getBoundingClientRect();
	            var mouseX = ev.center.x - rect.left;
	            var mouseY = ev.center.y - rect.top;
	            // update translate so center does not move
	            rootTransform.tx = (rootTransform.tx - mouseX) / oldScale * rootTransform.scale + mouseX;
	            rootTransform.ty = (rootTransform.ty - mouseY) / oldScale * rootTransform.scale + mouseY;
	            requestUpdateViewport();
	        }
	    }
	    function pinchend() {
	        takedownDocumentListeners();
	    }
	    //function focus(ev, person) {
	    //  // get mouse position
	    //  let rect = rootElement[0].getBoundingClientRect();
	    //  let mouseX = ev.pageX - rect.left;
	    //  let mouseY = ev.pageY - rect.top;
	    //
	    //  // get current person scale
	    //  let personScale = getPathTransform(person.path).scale * rootTransform.scale;
	    //
	    //  scale(1/personScale, mouseX, mouseY); //, false);
	    //}
	    function select(ev, p) {
	        if (p === null) {
	            return;
	        }
	        var person = p.person;
	        if (person._unknown) {
	            currentUser.stream().filter(function (u) { return !!u; }).take(1).subscribe(function (user) {
	                $log.debug('pf.select', person._childId, person._root, person._family, person._relationshipType);
	                utils.dialog(ev, 'AddPersonController', 'app/components/addPerson/addPerson.html', false, {
	                    mode: !!person._family ? 'parent' : '',
	                    relationshipType: person._relationshipType,
	                    relatedToPersonId: person._childId,
	                    family: !!person._family && person._family.id > 0 ? person._family : null,
	                    nameGiven: person._root ? user.given : '',
	                    nameSurname: person._root ? user.surname : ''
	                }).then(function (response) {
	                    $log.info('response', response);
	                }, function () {
	                    $log.info('cancel');
	                });
	            });
	        }
	        else {
	            utils.dialog(ev, 'RelativesController', 'app/components/relatives/relatives.html', true, {
	                pid: person.id
	            }).then(function (response) {
	                $log.info('response', response);
	            }, function () {
	                $log.info('cancel');
	            });
	        }
	    }
	    var cachedParentUnknowns = new Map();
	    function isParentUnknown(person, parentPath, persons) {
	        var path = person.path + parentPath;
	        if (cachedParentUnknowns.has(path)) {
	            return cachedParentUnknowns.get(path);
	        }
	        var parent = persons.find(function (p) { return p.path === path; });
	        var unknown = !parent || parent.unknown;
	        cachedParentUnknowns.set(path, unknown);
	        return unknown;
	    }
	    function dblclick(ev) {
	        var rect = rootElement[0].getBoundingClientRect();
	        var mouseX = ev.pageX - rect.left;
	        var mouseY = ev.pageY - rect.top;
	        scale(3, mouseX, mouseY);
	    }
	    //function updateHideContents() {
	    //  let cnt = 0;
	    //  Object.keys(persons).forEach(function(key) {
	    //    let person = persons[key];
	    //    if (person.person._hideContents) {
	    //      cnt++;
	    //      if (cnt <= showPersonCnt) {
	    //        person.person._hideContents = false;
	    //      }
	    //    }
	    //  });
	    //  if (cnt > showPersonCnt) {
	    //    $timeout(updateHideContents, showPersonInterval);
	    //  }
	    //}
	    function requestRotateAnimationFrame() {
	        $window.requestAnimationFrame(function () {
	            var t = Math.min(1, Math.max(0, (Date.now() - rotateStartMillis) / rotateAnimMillis));
	            t = easing.easeInOutQuad(t);
	            var deg = Math.round(rotateDeg * t);
	            // update translate so center point does not move
	            var replace = {
	                tx: rotateRect.width / 2,
	                ty: rotateRect.height / 2,
	                scale: 1,
	                rot: 0
	            };
	            var reverse = {
	                tx: -rotateRect.width / 2,
	                ty: -rotateRect.height / 2,
	                scale: 1,
	                rot: 0
	            };
	            var rot = {
	                tx: 0,
	                ty: 0,
	                scale: 1,
	                rot: deg
	            };
	            rootTransform = composeTransform(replace, composeTransform(rot, composeTransform(reverse, rotateStartTransform)));
	            updateViewport();
	            if (deg !== rotateDeg) {
	                requestRotateAnimationFrame();
	            }
	            else {
	                rotatePending = false;
	            }
	        });
	    }
	    function rotate(deg) {
	        rotateRect = rootElement[0].getBoundingClientRect();
	        rotateStartMillis = Date.now();
	        if (rotatePending) {
	            rotateDeg += deg - (rootTransform.rot - rotateStartTransform.rot);
	        }
	        else {
	            rotateDeg = deg;
	        }
	        rotateStartTransform = angular.copy(rootTransform);
	        if (!rotatePending) {
	            rotatePending = true;
	            requestRotateAnimationFrame();
	        }
	    }
	    function reset() {
	        var rect = rootElement[0].getBoundingClientRect();
	        rootTransform.tx = rect.width / 2 + leftPadding;
	        rootTransform.ty = Math.min(maxYOffset, rect.height - bottomPadding);
	        rootTransform.scale = initialScale; // TODO calculate scale based upon rect.width
	        rootTransform.rot = 180;
	    }
	    function home() {
	        reset();
	        requestUpdateViewport();
	    }
	    function updateViewport() {
	        if (!parentElement) {
	            parentElement = rootElement[0].querySelector(parentElementQuerySelector);
	            if (!parentElement) {
	                $log.info('try again later', parentElement);
	                // not set up yet - try again later
	                $timeout(updateViewport, 25);
	                return;
	            }
	            reset();
	        }
	        var personData = parentElement.children;
	        //$log.info('updateViewport', rootTransform);
	        for (var i = 0, len = personData.length; i < len; i++) {
	            var person = personData[i];
	            var id = person.getAttribute('person-id');
	            var per = void 0, fLine = void 0, mLine = void 0;
	            var children = person.children;
	            for (var j = 0, lenChildren = children.length; j < lenChildren; j++) {
	                var child = children[j];
	                var cls = child.getAttribute('class');
	                if (cls) {
	                    if (cls.indexOf('fractal__person') >= 0) {
	                        per = child;
	                    }
	                    else if (cls.indexOf('fractal__line_father') >= 0) {
	                        fLine = child;
	                    }
	                    else if (cls.indexOf('fractal__line_mother') >= 0) {
	                        mLine = child;
	                    }
	                }
	            }
	            if (!!per) {
	                per.setAttribute('style', 'transform: ' + getTransform(id));
	            }
	            if (!!mLine) {
	                mLine.setAttribute('style', 'transform: ' + getMotherLineTransform(id));
	            }
	            if (!!fLine) {
	                fLine.setAttribute('style', 'transform: ' + getFatherLineTransform(id));
	            }
	        }
	    }
	    function requestUpdateViewport() {
	        if (!rAFPending) {
	            $window.requestAnimationFrame(function () {
	                updateViewport();
	                rAFPending = false;
	            });
	            rAFPending = true;
	        }
	    }
	    function setupDocumentListeners() {
	        if (!documentListenersActive) {
	            $document.on('mousemove', mousemove);
	            $document.on('mouseup', mouseup);
	            hammertime.on('pinchmove', pinchmove);
	            hammertime.on('pinchend pinchcancel', pinchend);
	            hammertime.on('panmove', panmove);
	            hammertime.on('panend pancancel', panend);
	            documentListenersActive = true;
	        }
	    }
	    function takedownDocumentListeners() {
	        if (documentListenersActive) {
	            $document.off('mousemove', mousemove);
	            $document.off('mouseup', mouseup);
	            hammertime.off('pinchmove', pinchmove);
	            hammertime.off('pinchend pinchcancel', pinchend);
	            hammertime.off('panmove', panmove);
	            hammertime.off('panend pancancel', panend);
	            documentListenersActive = false;
	        }
	    }
	    /********************************/
	    /*** HELPER PRIVATE FUNCTIONS ***/
	    /********************************/
	    function tempAdjusttPersonRealDataWithTestdata(personMap) {
	        var result = [];
	        personMap.forEach(function (p, key) {
	            var gender = p.gender || (p._relationshipType === "FATHER" ? "MALE" : "FEMALE");
	            result.push({
	                path: key.toString(2).substring(1),
	                unknown: p._unknown,
	                gender: gender,
	                person: p
	            });
	        });
	        return result;
	    }
	    function link(s, elem) {
	        $log.info('fractal');
	        scope = s;
	        personData = [];
	        scope.fragment = {};
	        scope.slots = new Map();
	        scope.parents = new Map();
	        scope.persons = [];
	        var rSub = rightsFull.streamLevel().subscribe(function (level) {
	            scope.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        scope.fragment.root = scope.root;
	        var pw = utils.pleaseWait();
	        var subscription = rx.Observable.combineLatest(utils.watch(scope, 'fragment.root'), utils.readyChange(persons, families, leads, evidences)).subscribe(function (_a) {
	            var _b = __read(_a, 2), e = _b[0], _c = __read(_b[1], 1), personMap = _c[0];
	            $log.debug('pf.ready', e.newValue);
	            utils.pleaseWaitCancel(pw);
	            if (e.newValue === 0 || !!personMap.get(e.newValue)) {
	                fillFractial(1, e.newValue, null, null, true);
	                // TODO make sure to keep only one persons data instead of having both personData and scope.personse.
	                // Update local personData
	                personData = tempAdjusttPersonRealDataWithTestdata(scope.slots);
	                // Update scope data
	                scope.persons = personData;
	                // Make sure requestUpdateViewport is called after ng-repeat rendering is complete.
	                $timeout(function () { requestUpdateViewport(); });
	            }
	        });
	        function fillFractial(pos, pid, family, relationshipType, childId) {
	            if (!childId) {
	                return;
	            }
	            if (pos > maxPos) {
	                return;
	            }
	            // if this slot is unknown(0) or empty(-1)
	            if (pid <= 0) {
	                if (pid === 0) {
	                    scope.slots.set(pos, {
	                        _unknown: true,
	                        _root: pos === 1 && scope.fragment.position === 0,
	                        _family: family,
	                        _childId: childId,
	                        _relationshipType: relationshipType // used in add person
	                    });
	                }
	                else {
	                    scope.slots.delete(pos);
	                }
	                scope.parents.set(pos, false);
	                fillFractial(pos * 2, -1, null, null, pid);
	                fillFractial(pos * 2 + 1, -1, null, null, pid);
	                return;
	            }
	            // get person
	            persons.streamId(pid).take(1).subscribe(function (p) {
	                persons.augmentPerson(p, leads, evidences).subscribe(function (p) {
	                    scope.slots.set(pos, p);
	                });
	                // get parents
	                families.streamParents(pid).take(1).subscribe(function (fm) {
	                    var f = families.getPreferredFamily(fm, p.preferredParentsFamilyId);
	                    if (!!f) {
	                        scope.parents.set(pos, f.husbandId > 0 || f.wifeId > 0);
	                        fillFractial(pos * 2, f.husbandId, f, 'FATHER', pid);
	                        fillFractial(pos * 2 + 1, f.wifeId, f, 'MOTHER', pid);
	                    }
	                    else {
	                        var f_1 = { id: 0, childRels: new Map([[p.id, { fatherRel: '', motherRel: '' }]]) };
	                        scope.parents.set(pos, false);
	                        fillFractial(pos * 2, 0, f_1, 'FATHER', pid);
	                        fillFractial(pos * 2 + 1, 0, f_1, 'MOTHER', pid);
	                    }
	                });
	            });
	        }
	        // initialize variables
	        rootElement = elem;
	        parentElement = null;
	        documentListenersActive = false;
	        rAFPending = false;
	        rootTransform = {
	            tx: 0,
	            ty: 0,
	            scale: 1,
	            rot: 0
	        };
	        mouseStart = { x: 0, y: 0 };
	        mouseTransform = {
	            tx: 0,
	            ty: 0,
	            scale: 1,
	            rot: 0
	        };
	        // set up scope
	        scope.persons = personData;
	        scope.isSidenavLockedOpen = function () {
	            return sidenav.isLockedOpen();
	        };
	        scope.rotate = rotate;
	        scope.zoom = zoom;
	        scope.home = home;
	        scope.select = select;
	        scope.isParentUnknown = isParentUnknown;
	        // set up event listeners
	        hammertime = new hammer(elem[0]);
	        hammertime.get('pinch').set({ enable: true });
	        elem.on('mousedown', mousedown);
	        elem.on('dblclick', dblclick);
	        mousewheel.addListener(elem[0], wheel);
	        // listen for touch
	        hammertime.on('pinchstart', pinchstart);
	        hammertime.on('panstart', panstart);
	        scope.$on('$destroy', function () {
	            utils.pleaseWaitCancel(pw);
	            rSub.unsubscribe();
	            subscription.unsubscribe();
	            takedownDocumentListeners();
	        });
	    }
	    return {
	        restrict: 'E',
	        link: link,
	        templateUrl: 'app/components/fractal/fractal.html',
	        scope: {
	            root: '='
	        }
	    };
	}
	exports.default = rcFractalDirective;


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcFsCopyDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/fsCopy/fsCopy.html',
	        controller: FsCopyController,
	        controllerAs: 'fsCopy',
	        bindToController: true,
	        scope: {
	            type: '@',
	            item: '=',
	            action: '&'
	        }
	    };
	}
	var FsCopyController = /** @class */ (function () {
	    FsCopyController.$inject = ["$log", "$scope", "$translate", "$rootScope", "rightsFull", "utils"];
	    function FsCopyController($log, $scope, $translate, $rootScope, rightsFull, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.$translate = $translate;
	        this.$rootScope = $rootScope;
	        this.disabledMenuItems = [{ id: 'PLEASE_WAIT', mdicon: 'hourglass_empty' }];
	        this.menuItems = [];
	        var rSub = rightsFull.streamLevel().subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.$onInit = function () {
	            utils.watch($scope, 'fsCopy.item.state').subscribe(function (_a) {
	                var newValue = _a.newValue;
	                _this.menuItems = [];
	                switch (newValue) {
	                    case 'RF_ADD':
	                        if (_this.type === 'NAME' || _this.type === 'FACT' || _this.type === 'EVIDENCE' || !_this.item.rf) {
	                            _this.menuItems.push({ id: 'ADD_RF', mdicon: 'arrow_back' });
	                            if (_this.type === 'ORDINANCE') {
	                                _this.menuItems.push({ id: 'ADD_RF_ALL', mdicon: 'fast_rewind' });
	                            }
	                        }
	                        else {
	                            _this.menuItems.push({ id: 'REPLACE_RF', mdicon: 'arrow_back' });
	                        }
	                        if (_this.type === 'EVIDENCE' && !!_this.item && !!_this.item.fs && !!_this.item.fs.citation && !!_this.item.fs.citation.url) {
	                            _this.menuItems.push({ id: 'ADD_RC', mdicon: 'open_in_new' });
	                        }
	                        break;
	                    case 'FS_ADD':
	                        _this.menuItems.push({ id: 'ADD_FS', mdicon: 'arrow_forward' });
	                        break;
	                    case 'RF_CHANGE':
	                        _this.menuItems.push({ id: 'REPLACE_RF', mdicon: 'arrow_back' });
	                        break;
	                    case 'BOTH_CHANGE':
	                        _this.menuItems.push({ id: 'REPLACE_FS', mdicon: 'arrow_forward' });
	                        //this.menuItems.push({id: 'ADDALT_FS', mdicon: 'add'});
	                        _this.menuItems.push({ id: 'REPLACE_RF', mdicon: 'arrow_back' });
	                        break;
	                    case 'RF_MATCH':
	                        _this.menuItems.push({ id: 'MATCH_RF', mdicon: 'arrow_back' });
	                        break;
	                    case 'FS_MATCH':
	                        _this.menuItems.push({ id: 'MATCH_FS', mdicon: 'arrow_forward' });
	                        break;
	                    case 'FS_CONNECTED':
	                        _this.menuItems.push({ id: 'FS_DISCONNECT', rcicon: 'rc:icon-brokenlink' });
	                        break;
	                    case 'FS_NOT_CONNECTED':
	                        _this.menuItems.push({ id: 'FS_CONNECT_PAIR', mdicon: 'link' });
	                        _this.menuItems.push({ id: 'MATCH_FS_OTHER', mdicon: 'arrow_forward' });
	                        break;
	                }
	            });
	        };
	    }
	    FsCopyController.prototype.openMenu = function ($mdMenu, ev) {
	        this.menuEvent = ev;
	        $mdMenu.open(ev);
	    };
	    FsCopyController.prototype.getMenuItems = function () {
	        return this.$rootScope.loading ? this.disabledMenuItems : this.menuItems;
	    };
	    FsCopyController.prototype.click = function (menuItem) {
	        this.action({ type: this.type, item: this.item, action: menuItem.id, $event: this.menuEvent });
	    };
	    return FsCopyController;
	}());
	exports.default = rcFsCopyDirective;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcInvitationDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/invitation/invitation.html',
	        controller: InvitationController,
	        controllerAs: 'invitation',
	        bindToController: true,
	        scope: {
	            invitation: '='
	        }
	    };
	}
	var InvitationController = /** @class */ (function () {
	    InvitationController.$inject = ["$log", "$scope", "rightsFull", "utils"];
	    function InvitationController($log, $scope, rightsFull, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.utils = utils;
	        this.rightsLabels = rightsFull.levelLabels;
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.isOwner = level === rightsFull.LEVEL_OWNER;
	        });
	        this.$onInit = function () {
	            _this.invitation = utils.addCreateEditDates(_this.invitation);
	        };
	    }
	    InvitationController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'invitation', id: this.invitation.id });
	    };
	    return InvitationController;
	}());
	exports.default = rcInvitationDirective;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcJsTreeDirective() {
	    'ngInject';
	    function link(scope, elem) {
	        // set up listeners
	        if (!!scope.init) {
	            elem.on('init.jstree', function (e, data) {
	                scope.init({ instance: data.instance });
	            });
	        }
	        if (!!scope.select) {
	            elem.on('select_node.jstree', function (e, data) {
	                scope.select({ $event: data.event, node: data.node });
	            });
	        }
	        // set up tree
	        elem.jstree(scope.config);
	        scope.$on('$destroy', function () {
	            elem.jstree('destroy');
	        });
	    }
	    return {
	        restrict: 'E',
	        link: link,
	        scope: {
	            config: '=',
	            select: '&',
	            init: '&'
	        }
	    };
	}
	exports.default = rcJsTreeDirective;


/***/ }),
/* 131 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcLeadDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/lead/lead.html',
	        controller: LeadController,
	        controllerAs: 'lead',
	        bindToController: true,
	        scope: {
	            lead: '=',
	            hideTools: '=',
	            forceCreatedEdited: '=',
	            showPeople: '=',
	            expanded: '='
	        }
	    };
	}
	var LeadController = /** @class */ (function () {
	    LeadController.$inject = ["$log", "$scope", "researchLogs", "rightsFull", "social", "segment", "currentTreeId", "server", "utils"];
	    function LeadController($log, $scope, researchLogs, rightsFull, social, segment, currentTreeId, server, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.social = social;
	        this.segment = segment;
	        this.currentTreeId = currentTreeId;
	        this.server = server;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.$onInit = function () {
	            _this.twitterUrl = social.getTwitterUrl({ text: _this.lead.title, personIds: _this.lead.personIds });
	            $scope.$on('share', function (ev, params) {
	                _this.share(params.ev, params.platform);
	                ev.stopPropagation();
	            });
	        };
	        var rlSub = utils.watch($scope, function () { return _this.lead.researchLogId; }).flatMap(function () { return researchLogs.streamId(_this.lead.researchLogId); }).subscribe(function (log) {
	            _this.researchLogTitle = !!log ? log.title : '';
	        });
	        $scope.$on('$destroy', function () {
	            rlSub.unsubscribe();
	        });
	    }
	    LeadController.prototype.clickUrl = function () {
	        var _this = this;
	        this.currentTreeId.stream().take(1).subscribe(function (treeId) {
	            var personId = _this.utils.firstKey(_this.lead.personIds);
	            if (personId > 0) {
	                var url = '/trees/' + treeId + '/current_person/' + personId;
	                _this.server.put(url).subscribe(function () { });
	            }
	        });
	        if (this.lead.createdUser === 0) {
	            var parsed = this.utils.parseURL(this.lead.url);
	            this.segment.track('leads.click', { domain: parsed.host });
	        }
	    };
	    LeadController.prototype.toggleExpand = function () {
	        this.$scope.$emit('toggleExpand', { id: this.lead.id, type: 'lead' });
	    };
	    LeadController.prototype.share = function (ev, platform) {
	        this.social.post(platform, {
	            title: this.lead.title,
	            mediaId: 0,
	            description: this.utils.removeHtml(this.lead.text),
	            personIds: this.lead.personIds
	        }, ev);
	    };
	    LeadController.prototype.edit = function (ev) {
	        this.$scope.$emit('edit', { ev: ev, type: 'lead', item: this.lead });
	    };
	    LeadController.prototype.archive = function (ev) {
	        this.$scope.$emit('archive', { ev: ev, type: 'lead', item: this.lead });
	    };
	    LeadController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'lead', item: this.lead, id: this.lead.id });
	    };
	    LeadController.prototype.isValidURL = function (u) {
	        return this.utils.isValidURL(u);
	    };
	    LeadController.prototype.isFMPURL = function (u) {
	        return this.utils.isValidURL(u) && u.includes('findmypast.com');
	    };
	    LeadController.prototype.getUKURL = function (u) {
	        return u.replace(/findmypast\.com/, 'findmypast.co.uk');
	    };
	    return LeadController;
	}());
	exports.default = rcLeadDirective;


/***/ }),
/* 132 */
/***/ (function(module, exports) {

	"use strict";
	rcLeafletDirective.$inject = ["$log", "$window", "$timeout", "leaflet"];
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcLeafletDirective($log, $window, $timeout, leaflet) {
	    'ngInject';
	    var L = leaflet;
	    var ICON_PLACE = "<g id=\"icon-place\" viewBox=\"0 0 1024 1024\">\n    <title>place</title>\n    <path d=\"M512 102.4c-159.744 0-286.72 126.976-286.72 286.72 0 217.088 286.72 532.48 286.72 532.48s286.72-319.488 286.72-532.48c0-159.744-126.976-286.72-286.72-286.72zM512 491.52c-57.344 0-102.4-45.056-102.4-102.4s45.056-102.4 102.4-102.4 102.4 45.056 102.4 102.4-45.056 102.4-102.4 102.4z\"></path>\n    </g>";
	    var ICON_OTHER_TREE_PLACE = "<g id=\"icon-other-tree-place\" viewBox=\"0 0 1024 1024\">\n    <title>other-tree-place</title>\n    <path d=\"M798.72 102.4h-573.44c-45.056 0-81.92 36.864-81.92 81.92v573.44c0 45.056 36.864 81.92 81.92 81.92h163.84l122.88 122.88 122.88-122.88h163.84c45.056 0 81.92-36.864 81.92-81.92v-573.44c0-45.056-36.864-81.92-81.92-81.92zM589.824 548.864l-77.824 167.936-77.824-167.936-167.936-77.824 167.936-77.824 77.824-167.936 77.824 167.936 167.936 77.824-167.936 77.824z\"></path>\n    </g>";
	    var PlaceIcon = L.Icon.extend({
	        options: {
	            iconSize: [40, 40],
	            shadowSize: [50, 64],
	            iconAnchor: [34, 36],
	            shadowAnchor: [4, 0],
	            popupAnchor: [-13, -30]
	        }
	    });
	    var isMac = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;
	    var HL_COLOR = '#ff0000';
	    //_this is used to store global values within function
	    var _this = {
	        map: null,
	        layerGroup: null,
	        mapMarkers: null,
	        shiftClickInProgress: false,
	        selectEnabled: false,
	        boxSelectEnabled: false
	    };
	    function addBoxSelectFunctionality() {
	        //Extend the box-zoom feature while maintaining most of leaflet's default code
	        L.Map.BoxPrinter = L.Map.BoxZoom.extend({
	            _onMouseDown: function (e) {
	                if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) {
	                    return false;
	                }
	                _this.shiftClickInProgress = true;
	                this._resetState();
	                L.DomUtil.disableTextSelection();
	                L.DomUtil.disableImageDrag();
	                this._startPoint = this._map.mouseEventToContainerPoint(e);
	                L.DomEvent.on(document, {
	                    contextmenu: L.DomEvent.stop,
	                    mousemove: this._onMouseMove,
	                    mouseup: this._onMouseUp,
	                    keydown: this._onKeyDown
	                }, this);
	            },
	            _onMouseUp: function (e) {
	                if ((e.which !== 1) && (e.button !== 1)) {
	                    return;
	                }
	                _this.shiftClickInProgress = false;
	                this._finish();
	                if (!this._moved) {
	                    return;
	                }
	                setTimeout(L.bind(this._resetState, this), 0); // eslint-disable-line
	                var bounds = new L.LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
	                //This is where we emit the bounds we highlighted
	                //The bound has several founctions as well as _northEast and _southWest,
	                //each of which contains .lat and .lng
	                _this.scope.$emit('map-box-zoom', bounds);
	                this._map.fire('boxzoomend', { boxZoomBounds: bounds });
	            },
	            _finish: function () {
	                if (this._moved) {
	                    L.DomUtil.remove(this._box);
	                    L.DomUtil.removeClass(this._container, 'leaflet-crosshair');
	                }
	                L.DomUtil.enableTextSelection();
	                L.DomUtil.enableImageDrag();
	                L.DomEvent.off(document, {
	                    contextmenu: L.DomEvent.stop,
	                    mousemove: this._onMouseMove,
	                    mouseup: this._onMouseUp,
	                    keydown: this._onKeyDown
	                }, this);
	                _this.shiftClickInProgress = false;
	            }
	        });
	        L.Map.mergeOptions({ boxPrinter: true });
	        L.Map.addInitHook('addHandler', 'boxPrinter', L.Map.BoxPrinter);
	        L.Map.mergeOptions({ boxZoom: false });
	    }
	    function setIcon(shape, color) {
	        var icon;
	        switch (shape) {
	            case 'aol':
	                icon = ICON_OTHER_TREE_PLACE;
	                break;
	            default:
	                icon = ICON_PLACE;
	        }
	        // encode the svg as base 64 data image so leaflet will use it as an image
	        var svg = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" enable-background=\"new 0 0 1024 1024\"><g fill=\"" + color + "\">" + icon + "</g></svg>";
	        return 'data:image/svg+xml;base64,' + btoa(svg);
	    }
	    function ctrlIsClicked(e) {
	        if (!_this.selectEnabled) {
	            return false;
	        }
	        return (e.ctrlKey || (e.metaKey && isMac));
	    }
	    function setSelectedMarker(marker) {
	        if (!!marker._icon) {
	            setMarkerIconSelected(marker);
	        }
	    }
	    function removeSelectedMarker(marker) {
	        if (!!marker._icon) {
	            removeMarkerSelectedIcon(marker);
	        }
	    }
	    function setMarkerIconSelected(marker) {
	        if (!!marker && !!marker._icon) {
	            marker._icon.src = setIcon(marker.shape, HL_COLOR);
	        }
	    }
	    function removeMarkerSelectedIcon(marker) {
	        if (!!marker && !!marker._icon) {
	            marker._icon.src = setIcon(marker.shape, marker.color);
	        }
	    }
	    function getIcon(shape, color) {
	        var url = setIcon(shape, color);
	        switch (shape) {
	            case 'otherTree':
	            default:
	                return new PlaceIcon({ iconUrl: url });
	        }
	    }
	    function removeMarkers() {
	        _this.layerGroup.clearLayers();
	    }
	    function markerOnCtrlClick(marker) {
	        _this.map.closePopup();
	        _this.scope.$emit('map-ctrl-click', {
	            id: marker.id
	        });
	    }
	    function markerOnClick(marker) {
	        _this.scope.$emit('map-click', {
	            id: marker.id
	        });
	    }
	    function setMarkerSelections(selectedMarkers) {
	        if (!!selectedMarkers) {
	            Array.from(_this.mapMarkers.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), id = _b[0], marker = _b[1];
	                if (selectedMarkers.has(id)) {
	                    setMarkerIconSelected(marker);
	                }
	                else {
	                    removeSelectedMarker(marker);
	                }
	            });
	        }
	    }
	    function getRandomFloat(min, max) {
	        return Math.random() * (max - min) + min;
	    }
	    function getRandomSign() {
	        return (Math.random() > 0.5) ? 1 : -1;
	    }
	    function jitterLatLng(latitude, longitude) {
	        var latJitter = getRandomFloat(0, 0.05) * getRandomSign();
	        var longJitter = getRandomFloat(0, 0.05) * getRandomSign();
	        return [latitude + latJitter, longitude + longJitter];
	    }
	    function addPoints(scope) {
	        removeMarkers();
	        scope.points.forEach(function (p) {
	            var markerIcon = getIcon(p.shape, p.color);
	            var latLng = jitterLatLng(p.latitude, p.longitude);
	            var marker = (!markerIcon) ? (new L.marker(latLng)) : (new L.marker(latLng, { icon: markerIcon }));
	            marker.desc = p.desc;
	            marker.id = p.id;
	            marker.shape = p.shape;
	            marker.color = p.color;
	            _this.layerGroup.addLayer(marker);
	            marker.addTo(_this.map).bindPopup(marker.desc);
	            if (_this.selectEnabled && !!scope.selectedMarkers) {
	                if (scope.selectedMarkers.has(marker.id)) {
	                    setSelectedMarker(marker);
	                }
	            }
	            marker.on('click', function (e) {
	                var ctrlClickInProgress = ctrlIsClicked(e.originalEvent);
	                if (ctrlClickInProgress) {
	                    markerOnCtrlClick(e.target);
	                }
	                else {
	                    markerOnClick(e.target);
	                }
	            });
	            _this.mapMarkers.set(marker.id, marker);
	        });
	    }
	    function link(scope, elem) {
	        _this.scope = scope;
	        _this.selectEnabled = scope.selectEnabled;
	        _this.boxSelectEnabled = scope.boxSelectEnabled;
	        _this.mapMarkers = new Map();
	        //set only if box zoom select option is enabled
	        if (_this.boxSelectEnabled) {
	            addBoxSelectFunctionality();
	        }
	        _this.map = L.map('leafletMap', { zoomControl: false }).fitWorld();
	        L.control.zoom({ position: 'topright' }).addTo(_this.map); //add zoom to top right to avoid clashing with FAB
	        L.tileLayer('https://{s}.tile.thunderforest.com/pioneer/{z}/{x}/{y}.png?apikey=e3a6ea1b8922467cbbc93e231485ec20', {
	            attribution: '&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	            apikey: 'e3a6ea1b8922467cbbc93e231485ec20',
	            maxZoom: 22
	        }).addTo(_this.map);
	        _this.layerGroup = L.layerGroup().addTo(_this.map);
	        addPoints(scope);
	        $timeout(function () {
	            _this.map.invalidateSize();
	            //the tiles only partially load unless this is present
	        }, 10);
	        angular.element($window).on('resize', function () {
	            _this.map.invalidateSize();
	        });
	        elem.on('$destroy', function () {
	            //destroy
	        });
	        $timeout(function () {
	            scope.$watchCollection(function () { return (!!scope.selectedMarkers) ? __spread(scope.selectedMarkers.keys()) : null; }, function () {
	                if (!!scope.selectedMarkers) {
	                    setMarkerSelections(scope.selectedMarkers);
	                }
	            });
	            scope.$watchCollection('points', function () {
	                if (!!scope.points) {
	                    addPoints(scope);
	                    //set map bounds to fit markers, but only once
	                    if (!!scope.points.length && !_this.isMapScaled) {
	                        _this.isMapScaled = true;
	                        var markerArray = Array.from(_this.mapMarkers.values());
	                        var group = new L.featureGroup(markerArray);
	                        _this.map.fitBounds(group.getBounds(), { padding: L.point(20, 20) });
	                    }
	                }
	            });
	        }, 0);
	    }
	    return {
	        restrict: 'E',
	        link: link,
	        templateUrl: 'app/components/leaflet/leaflet.html',
	        scope: {
	            points: '=',
	            selectedMarkers: '=',
	            selectEnabled: '=',
	            boxSelectEnabled: '='
	        }
	    };
	}
	exports.default = rcLeafletDirective;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcLikesCommentsDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/likesComments/likesComments.html',
	        controller: LikesCommentsController,
	        controllerAs: 'lc',
	        bindToController: true,
	        scope: {
	            obj: '=',
	            expanded: '=',
	            twitterUrl: '=',
	            type: '@',
	            format: '@'
	        }
	    };
	}
	var LikesCommentsController = /** @class */ (function () {
	    LikesCommentsController.$inject = ["$log", "$scope", "$timeout", "comments", "currentTree", "currentTreeId", "currentUserId", "likes", "rights", "rightsFull", "medias", "users", "utils"];
	    function LikesCommentsController($log, $scope, $timeout, comments, currentTree, currentTreeId, currentUserId, likes, rights, rightsFull, medias, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.commentsService = comments;
	        this.currentTreeIdService = currentTreeId;
	        this.likesService = likes;
	        this.mediasService = medias;
	        this.utils = utils;
	        this.likes = null;
	        this.comments = null;
	        this.url = null;
	        this.froalaOptions = utils.froalaOptions(utils.atConfigUser(users, rights, currentTreeId), null, null, function (text) {
	            $timeout(function () {
	                _this.addComment(text);
	            });
	            return false;
	        });
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_READ);
	            if (!_this.hideAdd) {
	                users.streamAllUsers(rights).take(1).subscribe(function (allUsers) {
	                    _this.allUsers = allUsers;
	                });
	            }
	        });
	        this.$onInit = function () {
	            currentTree.stream().take(1).subscribe(function (tree) {
	                _this.hideShare = (tree.privacy !== 'PUBLIC' && tree.privacy !== 'FEATURED');
	            });
	            var eSub = utils.watch($scope, 'lc.expanded').subscribe(function (_a) {
	                var newValue = _a.newValue;
	                _this.isExpanded = newValue;
	            });
	            var cuSub = currentUserId.stream().subscribe(function (cuid) {
	                _this.cuid = cuid;
	            });
	            var lSub = _this.likesService.streamId(_this.obj.id).subscribe(function (like) {
	                _this.likesService.augmentLike(like, users, currentUserId).subscribe(function (like) {
	                    _this.likes = like;
	                });
	            });
	            var cSub = _this.commentsService.streamId(_this.obj.id).subscribe(function (cmt) {
	                _this.commentsService.augmentComment(cmt, users).subscribe(function (cmt) {
	                    _this.comments = cmt;
	                });
	            });
	            $scope.$on('$destroy', function () {
	                eSub.unsubscribe();
	                cuSub.unsubscribe();
	                lSub.unsubscribe();
	                cSub.unsubscribe();
	            });
	        };
	    }
	    LikesCommentsController.prototype.getSlice = function (arr, isExpanded, max, last) {
	        return !arr ? [] : last ? arr.slice(-Math.min(arr.length, isExpanded ? arr.length : max)) : arr.slice(0, Math.min(arr.length, isExpanded ? arr.length : max));
	    };
	    LikesCommentsController.prototype.getName = function (user) {
	        return user.id === this.cuid ? 'you' : user.name;
	    };
	    LikesCommentsController.prototype.isLiked = function () {
	        return !!this.likes && this.likes.likes.has(this.cuid);
	    };
	    LikesCommentsController.prototype.toggleExpand = function () {
	        this.isExpanded = !this.isExpanded;
	        this.likesExpanded = this.isExpanded;
	        this.commentsExpanded = this.isExpanded;
	        this.$scope.$emit('resize');
	    };
	    LikesCommentsController.prototype.toggleExpandLikes = function () {
	        this.likesExpanded = !this.likesExpanded;
	        this.$scope.$emit('resize');
	    };
	    LikesCommentsController.prototype.toggleExpandComments = function () {
	        this.commentsExpanded = !this.commentsExpanded;
	        this.$scope.$emit('resize');
	    };
	    LikesCommentsController.prototype.toggleShowComment = function () {
	        this.showComment = !this.showComment;
	        this.$scope.$emit('resize');
	    };
	    LikesCommentsController.prototype.addComment = function (text) {
	        var _this = this;
	        if (!!text) {
	            this.comments.comments.set(Date.now(), { user: this.cuid, text: this.utils.expandMentions(this.currentTreeIdService, this.allUsers, text) });
	            if (this.comments.version === 0) {
	                this.comments.type = this.type;
	                this.commentsService.create(this.comments).subscribe(function () {
	                    _this.showComment = false;
	                    _this.comment = '';
	                });
	            }
	            else {
	                this.commentsService.update(this.comments).subscribe(function () {
	                    _this.showComment = false;
	                    _this.comment = '';
	                });
	            }
	        }
	    };
	    LikesCommentsController.prototype.deleteComment = function (date) {
	        this.comments.comments.delete(date);
	        if (this.comments.comments.size === 0) {
	            this.commentsService.del(this.comments.id);
	        }
	        else {
	            this.commentsService.update(this.comments);
	        }
	    };
	    LikesCommentsController.prototype.toggleLike = function () {
	        if (this.isLiked()) {
	            this.likes.likes.delete(this.cuid);
	        }
	        else {
	            this.likes.likes.set(this.cuid, true);
	        }
	        if (this.likes.likes.size === 0) {
	            if (this.likes.version === 0) {
	                // ignore - impossible
	            }
	            else {
	                // delete
	                this.likesService.del(this.likes.id);
	            }
	        }
	        else {
	            if (this.likes.version === 0) {
	                // add
	                this.likes.type = this.type;
	                this.likesService.create(this.likes);
	            }
	            else {
	                // update
	                this.likesService.update(this.likes);
	            }
	        }
	    };
	    LikesCommentsController.prototype.openMenu = function ($mdMenu, ev) {
	        var _this = this;
	        this.menuEvent = ev;
	        // jump through hoops so we don't get a blocked popup - ask for the download URL now and pass it back below
	        if (!!this.obj.fileInfos && !this.url) {
	            this.mediasService.getDownloadURL(this.obj, '600').take(1).subscribe(function (url) {
	                _this.url = url;
	                $mdMenu.open(ev);
	            });
	        }
	        else {
	            $mdMenu.open(ev);
	        }
	    };
	    LikesCommentsController.prototype.share = function (platform) {
	        this.$scope.$emit('share', { ev: this.menuEvent, platform: platform, item: this.obj, url: this.url });
	    };
	    return LikesCommentsController;
	}());
	exports.default = rcLikesCommentsDirective;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	"use strict";
	rcListDirective.$inject = ["$window", "$timeout"];
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcListDirective($window, $timeout) {
	    'ngInject';
	    //const rightAdHeight = 600;
	    var bottomMargin = 16;
	    function link(scope, elem) {
	        //let offset = elem.find('md-virtual-repeat-container')[0].getBoundingClientRect().top - elem[0].getBoundingClientRect().top;
	        function setHeight() {
	            var elems = elem.find('md-virtual-repeat-container');
	            if (elems.length > 0) {
	                var rect = elems[0].getBoundingClientRect();
	                var height = $window.innerHeight - rect.top;
	                // 16 =
	                // 600 = length of right ad
	                //height = Math.max(height - bottomMargin, rightAdHeight - offset);
	                height -= bottomMargin;
	                elems.css('height', height + 'px');
	            }
	        }
	        // there's a bug somewhere; set the height before and after everything paints
	        //setHeight();
	        $timeout(function () {
	            setHeight();
	        }, 300);
	        scope.$on('resetHeight', setHeight);
	        angular.element($window).on('resize', setHeight);
	        elem.on('$destroy', function () {
	            angular.element($window).off('resize', setHeight);
	        });
	    }
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/list/list.html',
	        link: link,
	        controller: ListController,
	        controllerAs: 'list',
	        bindToController: true,
	        scope: {
	            showArchived: '=',
	            showFilter: '=',
	            numFilters: '=',
	            title: '@',
	            subtitle: '@',
	            subtitleTitle: '@',
	            hideAdd: '@',
	            headers: '=',
	            items: '=',
	            show: '@',
	            itemType: '@',
	            iconClass: '@'
	        }
	    };
	}
	var ListController = /** @class */ (function () {
	    ListController.$inject = ["$log", "$scope", "$state", "$window", "currentTree", "fs", "treeUsers", "rightsFull", "dnaProfiles", "dnaKits", "evidences", "leads", "notes", "persons", "researchLogs", "sources", "stories", "warnings", "utils"];
	    function ListController($log, $scope, $state, $window, currentTree, fs, treeUsers, rightsFull, dnaProfiles, dnaKits, evidences, leads, notes, persons, researchLogs, sources, stories, warnings, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$window = $window;
	        this.fs = fs;
	        this.dnaProfiles = dnaProfiles;
	        this.dnaKits = dnaKits;
	        this.evidences = evidences;
	        this.leads = leads;
	        this.notes = notes;
	        this.persons = persons;
	        this.researchLogs = researchLogs;
	        this.sources = sources;
	        this.stories = stories;
	        this.warnings = warnings;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.itemArray = [];
	        this.search = '';
	        this.searchTerms = [];
	        this.fsSignedIn = false;
	        this.sortValue = this.mySortValue.bind(this);
	        this.ready = false;
	        this.changedItems = [];
	        currentTree.stream().filter(function (t) { return !!t; }).take(1).subscribe(function (tree) {
	            _this.treePrefs = tree.preferences;
	        });
	        treeUsers.stream().take(1).subscribe(function () {
	            _this.ready = true;
	        });
	        this.$onInit = function () {
	            $scope.$watch(function () { return Array.from(_this.items.values()); }, function () {
	                _this.itemArray = _this.getItemArray();
	            }, true);
	            $scope.$watch(function () { return _this.search; }, function () {
	                _this.itemArray = _this.getItemArray();
	            });
	            var rSub;
	            if (!_this.hideAdd) {
	                rSub = rightsFull.streamLevel().subscribe(function (level) {
	                    _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	                });
	            }
	            _this.sortIndex = -1;
	            _this.sortReverse = false;
	            for (var i = 0; i < _this.headers.length; i++) {
	                if (_this.headers[i].sort === 1) {
	                    _this.sortIndex = i;
	                    _this.sortReverse = _this.headers[i].sortReverse;
	                    break;
	                }
	            }
	            _this.updateSortProperties(_this.sortIndex);
	            var sub;
	            if (!!_this.show && parseInt(_this.show, 10) > 0) {
	                sub = utils.watch($scope, function () { return _this.items.size; }).subscribe(function () {
	                    var item = _this.items.get(parseInt(_this.show, 10));
	                    if (!!item) {
	                        _this.showItem(null, item);
	                        sub.unsubscribe();
	                        sub = null;
	                    }
	                });
	            }
	            _this.fsFilters = [
	                { rcicon: 'rc:icon-brokenlink', label: 'FS_NOT_CONNECTED' },
	                { mdicon: 'link', label: 'FS_CONNECTED' },
	                { mdicon: 'swap_horiz', label: 'FS_FS_UPDATED' },
	                { mdicon: 'swap_horiz', label: 'FS_RF_UPDATED' },
	                { rcicon: 'rc:icon-fs-ready', label: 'FS_ORDINANCES_READY' },
	                { rcicon: 'rc:icon-fs-needs-work', label: 'FS_ORDINANCES_NEEDED' },
	                { rcicon: 'rc:icon-fs-temple', label: 'FS_ORDINANCES_RESERVED' },
	                { mdicon: 'check', label: 'FS_ORDINANCES_COMPLETE' }
	            ];
	            $scope.$on('$destroy', function () {
	                if (!!rSub) {
	                    rSub.unsubscribe();
	                }
	                if (!!sub) {
	                    sub.unsubscribe();
	                }
	            });
	        };
	    }
	    ListController.prototype.getFsMdIcon = function (status) {
	        return this.fsFilters.find(function (filter) { return filter.label === status; }).mdicon;
	    };
	    ListController.prototype.getFsRcIcon = function (status) {
	        return this.fsFilters.find(function (filter) { return filter.label === status; }).rcicon;
	    };
	    ListController.prototype.getStarsArray = function (max, numStars) {
	        return this.utils.asArray(Math.min(max, numStars));
	    };
	    ListController.prototype.add = function ($event) {
	        this.$scope.$emit('add', { ev: $event });
	    };
	    ListController.prototype.toggleShowArchived = function ($event) {
	        this.$scope.$emit('showArchived', { ev: $event, showArchived: this.showArchived });
	    };
	    ListController.prototype.doFilter = function ($event) {
	        this.$scope.$emit('filter', { ev: $event });
	    };
	    ListController.prototype.splitTagsFS = function (text, part) {
	        var pos = (text || ';').indexOf(';');
	        return part === 0 ? text.substring(0, pos) : text.substring(pos + 1);
	    };
	    ListController.prototype.fsClick = function (id) {
	        var purl = 'https://familysearch.org/ark:/61903/4:1:' + id;
	        var url = this.fs.getHref(purl, 'detail');
	        if (!!url) {
	            this.$window.open(url, '_blank');
	        }
	        else {
	            this.fs.clickHref(purl, 'detail');
	        }
	    };
	    ListController.prototype.boolChanged = function ($event, item, hdr) {
	        var ix = this.changedItems.indexOf(item);
	        if (ix >= 0) {
	            this.changedItems.splice(ix, 1);
	        }
	        else {
	            this.changedItems.push(item);
	        }
	    };
	    ListController.prototype.save = function ($event) {
	        this.$scope.$emit('save', { ev: $event, items: this.changedItems });
	        this.changedItems = [];
	    };
	    ListController.prototype.loadFilter = function ($event) {
	        this.$scope.$emit('loadFilter', { ev: $event });
	    };
	    ListController.prototype.saveFilter = function ($event) {
	        this.$scope.$emit('saveFilter', { ev: $event });
	    };
	    ListController.prototype.openMenu = function ($mdMenu, ev) {
	        this.menuEvent = ev;
	        $mdMenu.open(ev);
	    };
	    ListController.prototype.fsMenu = function ($mdMenu, ev) {
	        var _this = this;
	        if (this.fsSignedIn) {
	            $mdMenu.open(ev);
	            return;
	        }
	        this.utils.confirm('Sign into FamilySearch', 'You need to sign into FamilySearch to perform this action', ev).then(function () {
	            _this.fsSignIn();
	            $mdMenu.open(ev);
	        }, function () {
	            // ignore
	        });
	    };
	    ListController.prototype.fsMenuItem = function (filter) {
	        this.fsFilter = !!filter ? filter.label : '';
	    };
	    ListController.prototype.fsSignIn = function () {
	        var _this = this;
	        this.items = new Map(Array.from(this.items.entries()).map(function (_a) {
	            var _b = __read(_a, 2), k = _b[0], item = _b[1];
	            return [k, Object.assign({}, item, { _fsStatus: _this.fsFilters[Math.floor(Math.random() * 6)].label })];
	        }));
	        this.fsSignedIn = true;
	    };
	    ListController.prototype.fsAction = function (item, ev) {
	        if (item._fsStatus === 'FS_NOT_CONNECTED') {
	            this.utils.dialog(ev, 'FsMatchController', 'app/components/fsMatch/fsMatch.html');
	        }
	        else {
	            this.$state.go('tree.sync', { personId: this.utils.encodeId(item.id) });
	        }
	    };
	    ListController.prototype.matchesClick = function (item, ev) {
	        this.$scope.$emit('match', { ev: ev, item: item });
	    };
	    ListController.prototype.getMatches = function (mm) {
	        return [Math.floor(mm / this.utils.colorMultiplier), mm % this.utils.colorMultiplier];
	    };
	    ListController.prototype.getMatchBackground = function (ahnentafel) {
	        return this.utils.getAhnentafelColor(this.treePrefs, ahnentafel, false);
	    };
	    ListController.prototype.getItemArray = function () {
	        var _this = this;
	        var itemArray = Array.from(this.items.values());
	        var terms = !this.search ? [] : this.itemType === 'dnaList' ? this.dnaKits.getSearchTerms(this.search) : this.search.toLowerCase().split(' ');
	        if (terms.length > 0 || !!this.fsFilter) {
	            itemArray = itemArray.filter(function (item) { return _this.hasTerms(item, terms); });
	        }
	        return itemArray;
	    };
	    ListController.prototype.hasTerms = function (item, terms) {
	        if (!!this.fsFilter && item._fsStatus !== this.fsFilter) {
	            if (this.fsFilter === 'FS_CONNECTED' &&
	                (item._fsStatus === 'FS_FS_UPDATED' || item._fsStatus === 'FS_RF_UPDATED' ||
	                    item._fsStatus === 'FS_ORDINANCES_READY' || item._fsStatus === 'FS_ORDINANCES_NEEDED' || item._fsStatus === 'FS_ORDINANCES_COMPLETE')) {
	                return true;
	            }
	            return false;
	        }
	        try {
	            for (var terms_1 = __values(terms), terms_1_1 = terms_1.next(); !terms_1_1.done; terms_1_1 = terms_1.next()) {
	                var term = terms_1_1.value;
	                if (!!term) {
	                    var found = void 0;
	                    switch (this.itemType) {
	                        case 'person':
	                            found = this.persons.hasWord(item, term);
	                            break;
	                        case 'evidence':
	                            found = this.evidences.hasWord(item, term);
	                            break;
	                        case 'lead':
	                            found = this.leads.hasWord(item, term);
	                            break;
	                        case 'note':
	                            found = this.notes.hasWord(item, term);
	                            break;
	                        case 'source':
	                            found = this.sources.hasWord(item, term);
	                            break;
	                        case 'story':
	                            found = this.stories.hasWord(item, term);
	                            break;
	                        case 'warning':
	                            found = this.warnings.hasWord(item, term);
	                            break;
	                        case 'researchLog':
	                            found = this.researchLogs.hasWord(item, term);
	                            break;
	                        case 'dnaProfile':
	                            found = this.dnaProfiles.hasWord(item, term);
	                            break;
	                        case 'dnaList':
	                            found = this.dnaKits.hasTerm(item._kit, term);
	                            break;
	                        default:
	                            found = false;
	                    }
	                    if (!found) {
	                        return false;
	                    }
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (terms_1_1 && !terms_1_1.done && (_a = terms_1.return)) _a.call(terms_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return true;
	        var e_1, _a;
	    };
	    ListController.prototype.sort = function (index) {
	        if (this.headers[index].sortable) {
	            if (this.sortIndex === index) {
	                this.sortReverse = !this.sortReverse;
	            }
	            else {
	                this.sortReverse = this.headers[index].sortReverse;
	            }
	            this.updateSortProperties(index);
	            this.sortIndex = index;
	        }
	    };
	    ListController.prototype.mySortValue = function (item) {
	        if (this.sortProperties.length === 1) {
	            return item[this.sortProperties[0]];
	        }
	        var sortValue = this.sortProperties.map(function (p) {
	            var v = item[p];
	            return (typeof v === 'number') ? v.toFixed(4).padStart(15, '0') : v;
	        }).join(' ');
	        return sortValue;
	    };
	    ListController.prototype.updateSortProperties = function (index) {
	        this.sortProperties = [];
	        if (index >= 0) {
	            this.sortProperties.push(this.headers[index].property + (this.headers[index].type === 'date' ? 'Sort' : ''));
	        }
	        // add default sort properties
	        for (var i = 1; i <= 2; i++) {
	            for (var ix = 0; ix < this.headers.length; ix++) {
	                if (this.headers[ix].sort === i && this.headers[ix].defaultSort && ix !== index) {
	                    this.sortProperties.push(this.headers[ix].property + (this.headers[ix].type === 'date' ? 'Sort' : ''));
	                }
	            }
	        }
	    };
	    ListController.prototype.getLink = function (hdr, item) {
	        var params = {};
	        params[hdr.link.field] = this.utils.encodeId(item.id);
	        return this.$state.href(hdr.link.prefix, params);
	    };
	    ListController.prototype.showItem = function (ev, item, altType) {
	        var _this = this;
	        if (!!altType) {
	            this.$scope.$emit('show', { type: altType, item: item });
	        }
	        else {
	            this.utils.dialog(ev, 'ListModalController', 'app/components/list/listModal.html', true, { itemType: this.itemType, item: item }).then(function (response) {
	                _this.$log.info('response', response);
	                if (!!response) {
	                    response.params.ev = ev; // override with original event
	                    _this.$scope.$emit(response.action, response.params);
	                }
	            }, function () {
	                // ignore
	            });
	        }
	        if (!!ev) {
	            ev.stopPropagation();
	        }
	    };
	    return ListController;
	}());
	exports.default = rcListDirective;


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcMatchDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/match/match.html',
	        controller: MatchController,
	        controllerAs: 'match',
	        bindToController: true,
	        scope: {
	            match: '='
	        }
	    };
	}
	var MatchController = /** @class */ (function () {
	    MatchController.$inject = ["$log", "$scope", "utils"];
	    function MatchController($log, $scope, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.$scope = $scope;
	        this.utils = utils;
	    }
	    MatchController.prototype.getStars = function () {
	        return this.utils.asArray(Math.min(5, this.match.stars));
	    };
	    MatchController.prototype.getQuality = function () {
	        return this.utils.asArray(this.match.quality);
	    };
	    MatchController.prototype.moreStars = function () {
	        return this.match.stars > 5;
	    };
	    MatchController.prototype.archive = function (ev) {
	        this.$scope.$emit('archivematch', { ev: ev });
	    };
	    return MatchController;
	}());
	exports.default = rcMatchDirective;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcMediaDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/media/media.html',
	        controller: MediaController,
	        controllerAs: 'media',
	        bindToController: true,
	        scope: {
	            media: '=',
	            hideTools: '=',
	            expanded: '=',
	            forceCreatedEdited: '=',
	            autoplay: '='
	        }
	    };
	}
	var MediaController = /** @class */ (function () {
	    MediaController.$inject = ["$log", "$scope", "medias", "researchLogs", "rightsFull", "social", "sources", "utils"];
	    function MediaController($log, $scope, medias, researchLogs, rightsFull, social, sources, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.medias = medias;
	        this.social = social;
	        this.sources = sources;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.viewableFileTypes = ['video/mp4', 'application/pdf', 'image/tiff', 'image/jpeg', 'image/png', 'image/bmp', 'image/gif'];
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.download = { url: '' };
	        this.downloadURLRequested = false;
	        this.$onInit = function () {
	            _this.twitterUrl = social.getTwitterUrl({ mediaId: _this.media.id, text: _this.media.title, personIds: _this.media.personIds });
	            $scope.$on('share', function (ev, params) {
	                _this.share(params.ev, params.platform, params.item, params.url);
	                ev.stopPropagation();
	            });
	        };
	        var rlSub = utils.watch($scope, function () { return _this.media.researchLogId; }).flatMap(function () { return researchLogs.streamId(_this.media.researchLogId); }).subscribe(function (log) {
	            _this.researchLogTitle = !!log ? log.title : '';
	        });
	        $scope.$on('$destroy', function () {
	            rlSub.unsubscribe();
	        });
	    }
	    MediaController.prototype.isVideo = function (m) {
	        return m.fileInfos.size > 0 && this.utils.first(m.fileInfos).contentType.toLowerCase() === "video/mp4";
	    };
	    MediaController.prototype.isViewableType = function (m) {
	        if (!m || m.fileInfos.size === 0) {
	            return false;
	        }
	        var contentType = this.utils.first(m.fileInfos).contentType.toLowerCase();
	        return this.viewableFileTypes.includes(contentType);
	    };
	    MediaController.prototype.isTIFF = function (m) {
	        if (m.fileInfos.size === 0) {
	            return false;
	        }
	        return this.utils.first(m.fileInfos).contentType.toLowerCase() === 'image/tiff';
	    };
	    MediaController.prototype.isPDF = function (m) {
	        if (m.fileInfos.size === 0) {
	            return false;
	        }
	        return this.utils.first(m.fileInfos).contentType.toLowerCase() === 'application/pdf';
	    };
	    MediaController.prototype.getDownload = function () {
	        var _this = this;
	        if (!this.downloadURLRequested) {
	            this.downloadURLRequested = true;
	            this.medias.getDownloadURL(this.media).subscribe(function (url) {
	                _this.download.url = url;
	            });
	        }
	        return this.download;
	    };
	    MediaController.prototype.getMediaURL = function (m) {
	        return this.medias.getMediaURL(m);
	    };
	    MediaController.prototype.getMediaImageURL = function (m, size) {
	        return this.medias.getMediaImageURL(m, size);
	    };
	    MediaController.prototype.getMediaFilename = function (m) {
	        return m.fileInfos.size > 0 ? this.utils.first(m.fileInfos).fileName : '';
	    };
	    MediaController.prototype.getSourceAbbr = function (sid) {
	        var obj = { value: '' };
	        if (sid > 0) {
	            this.sources.streamId(sid).map(function (source) { return !!source ? source.abbr : ''; }).take(1).subscribe(function (v) {
	                obj.value = v;
	            });
	        }
	        return obj;
	    };
	    MediaController.prototype.toggleExpand = function () {
	        this.$scope.$emit('toggleExpand', { id: this.media.id });
	    };
	    MediaController.prototype.share = function (ev, platform, media, url) {
	        this.social.post(platform, {
	            url: url,
	            title: media.title,
	            mediaId: media.id,
	            description: this.utils.removeHtml(media.text),
	            personIds: media.personIds
	        }, ev);
	    };
	    MediaController.prototype.edit = function (ev) {
	        this.$scope.$emit('edit', { ev: ev, type: 'media', item: this.media });
	    };
	    MediaController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'media', item: this.media, id: this.media.id });
	    };
	    MediaController.prototype.mosaic = function (ev) {
	        this.$scope.$emit('mosaic', { ev: ev, type: 'media', item: this.media });
	    };
	    return MediaController;
	}());
	exports.default = rcMediaDirective;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcMessageDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/message/message.html',
	        controller: MessageController,
	        controllerAs: 'message',
	        bindToController: true,
	        scope: {
	            message: '='
	        }
	    };
	}
	var MessageController = /** @class */ (function () {
	    MessageController.$inject = ["$log", "$scope", "utils"];
	    function MessageController($log, $scope, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.$scope = $scope;
	        this.utils = utils;
	    }
	    MessageController.prototype.toggleExpand = function () {
	        this.utils.toggleExpand(this.message);
	    };
	    MessageController.prototype.del = function (ev) {
	        this.$scope.$emit('deletemessage', { ev: ev });
	    };
	    return MessageController;
	}());
	exports.default = rcMessageDirective;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcMinitreeDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/minitree/minitree.html',
	        controller: MinitreeController,
	        controllerAs: 'minitree',
	        bindToController: true,
	        scope: {
	            tree: '='
	        }
	    };
	}
	var MinitreeController = /** @class */ (function () {
	    MinitreeController.$inject = ["$log", "utils"];
	    function MinitreeController($log, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.personMap = new Map();
	        this.$onInit = function () {
	            _this.setPersonMap(1, _this.tree);
	        };
	    }
	    MinitreeController.prototype.setPersonMap = function (ahnentafel, person) {
	        this.personMap.set(ahnentafel, person);
	        if (!!person.father) {
	            this.setPersonMap(ahnentafel * 2, person.father);
	        }
	        if (!!person.mother) {
	            this.setPersonMap(ahnentafel * 2 + 1, person.mother);
	        }
	    };
	    MinitreeController.prototype.getYear = function (date) {
	        var re = new RegExp('\\d{4}s?', '');
	        var match = re.exec(date);
	        return !!match ? match[0] : '';
	    };
	    return MinitreeController;
	}());
	exports.default = rcMinitreeDirective;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcNameDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/name/name.html',
	        controller: NameController,
	        controllerAs: 'name',
	        bindToController: true,
	        scope: {
	            name: '=',
	            expanded: '=',
	            hideTools: '=',
	            forceCreatedEdited: '=',
	            hideEvidences: '='
	        }
	    };
	}
	var NameController = /** @class */ (function () {
	    NameController.$inject = ["$log", "$scope", "rightsFull", "persons", "evidences", "utils"];
	    function NameController($log, $scope, rightsFull, persons, evidences, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.persons = persons;
	        this.evidences = evidences;
	        this.utils = utils;
	        this.expandedEvidences = new Map();
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.$onInit = function () {
	            var expandedSub = utils.watch($scope, 'name.expanded').subscribe(function (_a) {
	                var newValue = _a.newValue;
	                try {
	                    for (var _b = __values(_this.name._evidences), _c = _b.next(); !_c.done; _c = _b.next()) {
	                        var _d = __read(_c.value, 1), id = _d[0];
	                        _this.expandedEvidences.set(id, newValue);
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                var e_1, _e;
	            });
	            $scope.$on('$destroy', function () {
	                expandedSub.unsubscribe();
	            });
	            $scope.$on('toggleExpand', function (ev, params) {
	                if (params.type === 'evidence') {
	                    _this.expandedEvidences.set(params.id, !_this.expandedEvidences.get(params.id));
	                    ev.stopPropagation();
	                }
	            });
	        };
	    }
	    NameController.prototype.getFullname = function (n) {
	        return this.persons.getNameText(this.persons.getDefaultNameForm(n));
	    };
	    NameController.prototype.getYear = function (n) {
	        return !!n.dateSort ? n.dateSort.substr(0, 4) : '';
	    };
	    NameController.prototype.toggleHidden = function () {
	        // TODO hide facts
	    };
	    NameController.prototype.toggleExpand = function () {
	        this.$scope.$emit('toggleExpand', { id: this.name._key });
	    };
	    NameController.prototype.addEvidence = function (ev) {
	        this.$scope.$emit('add', { ev: ev, type: 'evidence', item: this.name });
	    };
	    NameController.prototype.edit = function (ev) {
	        this.$scope.$emit('add', { ev: ev, type: 'evidence', item: this.name });
	    };
	    NameController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'name', id: this.name._key });
	    };
	    return NameController;
	}());
	exports.default = rcNameDirective;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcNoteDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/note/note.html',
	        controller: NoteController,
	        controllerAs: 'note',
	        bindToController: true,
	        scope: {
	            note: '=',
	            expanded: '=',
	            hideTools: '=',
	            forceCreatedEdited: '='
	        }
	    };
	}
	var NoteController = /** @class */ (function () {
	    NoteController.$inject = ["$log", "$scope", "researchLogs", "rightsFull", "social", "utils"];
	    function NoteController($log, $scope, researchLogs, rightsFull, social, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.social = social;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.$onInit = function () {
	            _this.twitterUrl = social.getTwitterUrl({ text: _this.note.title, personIds: _this.note.personIds });
	            $scope.$on('share', function (ev, params) {
	                _this.share(params.ev, params.platform);
	                ev.stopPropagation();
	            });
	        };
	        var rlSub = utils.watch($scope, function () { return _this.note.researchLogId; }).flatMap(function () { return researchLogs.streamId(_this.note.researchLogId); }).subscribe(function (log) {
	            _this.researchLogTitle = !!log ? log.title : '';
	        });
	        $scope.$on('$destroy', function () {
	            rlSub.unsubscribe();
	        });
	    }
	    NoteController.prototype.toggleExpand = function () {
	        this.$scope.$emit('toggleExpand', { id: this.note.id });
	    };
	    NoteController.prototype.share = function (ev, platform) {
	        this.social.post(platform, {
	            title: this.note.title,
	            mediaId: 0,
	            description: this.utils.removeHtml(this.note.text),
	            personIds: this.note.personIds
	        }, ev);
	    };
	    NoteController.prototype.edit = function (ev) {
	        this.$scope.$emit('edit', { ev: ev, type: 'note', item: this.note });
	    };
	    NoteController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'note', id: this.note.id });
	    };
	    return NoteController;
	}());
	exports.default = rcNoteDirective;


/***/ }),
/* 141 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcOrdinanceDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/ordinance/ordinance.html',
	        controller: OrdinanceController,
	        controllerAs: 'ordinance',
	        bindToController: true,
	        scope: {
	            ordinance: '=',
	            expanded: '=',
	            hideTools: '='
	        }
	    };
	}
	var OrdinanceController = /** @class */ (function () {
	    OrdinanceController.$inject = ["$log", "$scope", "rightsFull", "ordinances", "fsTemples", "utils"];
	    function OrdinanceController($log, $scope, rightsFull, ordinances, fsTemples, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.ordinances = ordinances;
	        this.fsTemples = fsTemples;
	        this.utils = utils;
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	    }
	    OrdinanceController.prototype.getYear = function (o) {
	        return !!o.dateSort ? o.dateSort.substr(0, 4) : '';
	    };
	    OrdinanceController.prototype.getTempleName = function (code) {
	        return this.fsTemples.get(code);
	    };
	    OrdinanceController.prototype.getDetail = function (status) {
	        var s = this.ordinances.statuses.find(function (s) { return s.value === status; });
	        return s ? s.detail : '';
	    };
	    OrdinanceController.prototype.toggleExpand = function () {
	        this.$scope.$emit('toggleExpand', { id: this.ordinance._key });
	    };
	    OrdinanceController.prototype.edit = function (ev) {
	        this.$scope.$emit('edit', { ev: ev, type: 'ordinance', item: this.ordinance });
	    };
	    OrdinanceController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'ordinance', id: this.ordinance._key });
	    };
	    return OrdinanceController;
	}());
	exports.default = rcOrdinanceDirective;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	"use strict";
	rcPanzoomDirective.$inject = ["$window", "$log", "$document", "$timeout", "hammer", "mousewheel"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcPanzoomDirective($window, $log, $document, $timeout, hammer, mousewheel) {
	    'ngInject';
	    var documentListenersActive = false;
	    var rAFPending = false;
	    var wheelMultiplier = 1.05;
	    var minWheelMillis = 15;
	    var minScale = 0.2;
	    var maxScale = 2;
	    var marginX = 0;
	    var marginY = 0;
	    var prevWheelMillis = 0;
	    var translate = { x: 0, y: 0 };
	    var scale = 1;
	    var startScale;
	    var mouseStart = { x: 0, y: 0 };
	    var mouseDelta = { x: 0, y: 0 };
	    var rootElement;
	    var target;
	    var hammertime;
	    function mousedown(ev) {
	        mouseStart = { x: ev.pageX, y: ev.pageY };
	        setupDocumentListeners();
	    }
	    function dblclick(ev) {
	        // set mouse position
	        var mousePos = getMousePos(ev.pageX, ev.pageY);
	        scaleview(3, mousePos.x, mousePos.y);
	    }
	    function getMousePos(x, y) {
	        var rect = rootElement[0].getBoundingClientRect();
	        var viewX = x - rect.left;
	        var viewY = y - rect.top;
	        return { x: viewX / scale - translate.x, y: viewY / scale - translate.y };
	    }
	    function mousemove(ev) {
	        mouseDelta = { x: (ev.pageX - mouseStart.x) / scale, y: (ev.pageY - mouseStart.y) / scale };
	        requestUpdateViewport();
	    }
	    function mouseup() {
	        translate = { x: translate.x + mouseDelta.x, y: translate.y + mouseDelta.y };
	        mouseDelta = { x: 0, y: 0 };
	        takedownDocumentListeners();
	    }
	    function panstart() {
	        setupDocumentListeners();
	    }
	    function panmove(ev) {
	        mouseDelta = { x: ev.deltaX / scale, y: ev.deltaY / scale };
	        requestUpdateViewport();
	    }
	    function panend() {
	        translate = { x: translate.x + mouseDelta.x, y: translate.y + mouseDelta.y };
	        mouseDelta = { x: 0, y: 0 };
	        takedownDocumentListeners();
	    }
	    function wheel(ev) {
	        var currTime = Date.now();
	        if (currTime - prevWheelMillis < minWheelMillis ||
	            (ev.deltaY > 0 && scale < minScale) ||
	            (ev.deltaY < 0 && scale > maxScale)) {
	            return;
	        }
	        prevWheelMillis = currTime;
	        // set mouse position
	        var mousePos = getMousePos(ev.pageX, ev.pageY);
	        var multiplier;
	        if (ev.deltaY > 0) {
	            multiplier = 1 / wheelMultiplier;
	        }
	        else {
	            multiplier = wheelMultiplier;
	        }
	        scaleview(multiplier, mousePos.x, mousePos.y);
	    }
	    function scaleview(multiplier, centerX, centerY) {
	        if (scale * multiplier >= minScale && scale * multiplier <= maxScale) {
	            var prevScale = scale;
	            scale *= multiplier;
	            // update translate so point under mouse does not move
	            translate.x = (centerX + translate.x) * prevScale / scale - centerX;
	            translate.y = (centerY + translate.y) * prevScale / scale - centerY;
	            requestUpdateViewport();
	        }
	    }
	    function pinchstart() {
	        startScale = scale;
	        // set center
	        setupDocumentListeners();
	    }
	    function pinchmove(ev) {
	        if (startScale * ev.scale >= minScale && startScale * ev.scale <= maxScale) {
	            var mousePos = getMousePos(ev.center.x, ev.center.y);
	            var prevScale = scale;
	            scale = startScale * ev.scale;
	            // update translate so center does not move
	            translate.x = (mousePos.x + translate.x) * prevScale / scale - mousePos.x;
	            translate.y = (mousePos.y + translate.y) * prevScale / scale - mousePos.y;
	            requestUpdateViewport();
	        }
	    }
	    function pinchend() {
	        takedownDocumentListeners();
	    }
	    function reset() {
	        // move everything over if we're locked open
	        translate.x = marginX;
	        translate.y = marginY;
	        // TODO calc scale based upon rect.width; set translate based upon scale
	        // the whole idea of using css abs pos to center is bad
	        // let rect = rootElement[0].getBoundingClientRect();
	        scale = 1;
	    }
	    function home(params) {
	        reset();
	        if (!!params && !!params.zoom) {
	            zoom(params.zoom);
	        }
	        requestUpdateViewport();
	    }
	    function zoom(multiplier) {
	        var rect = rootElement[0].getBoundingClientRect();
	        scaleview(multiplier, rect.width / 2, rect.height / 2);
	    }
	    function updateViewport() {
	        if (!!target) {
	            target.css('transform', 'scale(' + scale + ',' + scale + ') translate(' + (translate.x + mouseDelta.x) + 'px,' + (translate.y + mouseDelta.y) + 'px)');
	        }
	    }
	    function requestUpdateViewport() {
	        if (!rAFPending) {
	            $window.requestAnimationFrame(function () {
	                updateViewport();
	                rAFPending = false;
	            });
	            rAFPending = true;
	        }
	    }
	    function setupDocumentListeners() {
	        if (!documentListenersActive) {
	            hammertime.on('pinchmove', pinchmove);
	            hammertime.on('pinchend pinchcancel', pinchend);
	            hammertime.on('panmove', panmove);
	            hammertime.on('panend pancancel', panend);
	            $document.on('mousemove', mousemove);
	            $document.on('mouseup', mouseup);
	            documentListenersActive = true;
	        }
	    }
	    function takedownDocumentListeners() {
	        if (documentListenersActive) {
	            hammertime.off('pinchmove', pinchmove);
	            hammertime.off('pinchend pinchcancel', pinchend);
	            hammertime.off('panmove', panmove);
	            hammertime.off('panend pancancel', panend);
	            $document.off('mousemove', mousemove);
	            $document.off('mouseup', mouseup);
	            documentListenersActive = false;
	        }
	    }
	    function setup(elem, attr) {
	        rootElement = elem;
	        hammertime = new hammer(elem[0]);
	        hammertime.get('pinch').set({ enable: true });
	        $timeout(function () {
	            var e = elem[0].querySelector(attr);
	            if (!!e) {
	                target = angular.element(e);
	                target.css('transform-origin', 'top left');
	                // listen for mousedown and dblclick
	                elem.on('mousedown', mousedown);
	                elem.on('dblclick', dblclick);
	                // listen for mouse wheel
	                mousewheel.addListener(elem[0], wheel);
	                // listen for touch
	                hammertime.on('pinchstart', pinchstart);
	                hammertime.on('panstart', panstart);
	                reset();
	                requestUpdateViewport();
	            }
	            else {
	                setup(elem, attr);
	            }
	        }, 25);
	    }
	    function link(scope, elem, attrs) {
	        setup(elem, attrs.target);
	        scope.$on('zoom', function (ev, multiplier) {
	            zoom(multiplier);
	        });
	        scope.$on('home', function (ev, params) {
	            home(params);
	        });
	        scope.$on('$destroy', function () {
	            takedownDocumentListeners();
	        });
	    }
	    return {
	        restrict: 'E',
	        transclude: true,
	        link: link,
	        templateUrl: 'app/components/panzoom/panzoom.html'
	    };
	}
	exports.default = rcPanzoomDirective;


/***/ }),
/* 143 */
/***/ (function(module, exports) {

	"use strict";
	rcPasteDirective.$inject = ["$window", "$document", "$timeout"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcPasteDirective($window, $document, $timeout) {
	    'ngInject';
	    /* jshint ignore:start */
	    var isSafari = navigator.appVersion.search('Safari') !== -1 &&
	        navigator.appVersion.search('Chrome') === -1 &&
	        navigator.appVersion.search('CrMo') === -1 &&
	        navigator.appVersion.search('CriOS') === -1;
	    var isIe = (navigator.userAgent.toLowerCase().indexOf("msie") !== -1 ||
	        navigator.userAgent.toLowerCase().indexOf("trident") !== -1);
	    /* jshint ignore:end */
	    var textToCopy = 'RootsFinder';
	    var htmlToCopy = '<div hiddenContent="RootsFinder">RootsFinder</div>';
	    var scope;
	    var ieClipboardDiv;
	    var hiddenInput;
	    var userInput;
	    var hiddenInputListener = function () { };
	    var focusHiddenArea = function () {
	        // In order to ensure that the browser will fire clipboard events, we always need to have something selected
	        hiddenInput.val(' ');
	        hiddenInput.focus().select();
	    };
	    // Focuses an element to be ready for copy/paste (used exclusively for IE)
	    var focusIeClipboardDiv = function () {
	        ieClipboardDiv.focus();
	        var range = $document[0].createRange();
	        range.selectNodeContents((ieClipboardDiv.get(0)));
	        var selection = $window[0].getSelection();
	        selection.removeAllRanges();
	        selection.addRange(range);
	    };
	    // For IE, we can get/set Text or URL just as we normally would, but to get HTML, we need to let the browser perform the copy or paste
	    // in a contenteditable div.
	    var ieClipboardEvent = function (clipboardEvent) {
	        var clipboardData = $window[0].clipboardData;
	        if (clipboardEvent === 'cut' || clipboardEvent === 'copy') {
	            clipboardData.setData('Text', textToCopy);
	            ieClipboardDiv.html(htmlToCopy);
	            focusIeClipboardDiv();
	            $timeout(function () {
	                focusHiddenArea();
	                ieClipboardDiv.empty();
	            }, 0);
	        }
	        if (clipboardEvent === 'paste') {
	            var clipboardText = clipboardData.getData('Text');
	            ieClipboardDiv.empty();
	            $timeout(function () {
	                scope.$emit('paste', { text: clipboardText, html: ieClipboardDiv.html() });
	                ieClipboardDiv.empty();
	                focusHiddenArea();
	            }, 0);
	        }
	    };
	    // For every broswer except IE, we can easily get and set data on the clipboard
	    var standardClipboardEvent = function (clipboardEvent, event) {
	        var clipboardData = event.clipboardData;
	        if (clipboardEvent === 'cut' || clipboardEvent === 'copy') {
	            clipboardData.setData('text/plain', textToCopy);
	            clipboardData.setData('text/html', htmlToCopy);
	        }
	        if (clipboardEvent === 'paste') {
	            var text_1 = clipboardData.getData('text/plain');
	            var html_1 = clipboardData.getData('text/html');
	            $timeout(function () {
	                scope.$emit('paste', { text: text_1, html: html_1 });
	            }, 0);
	        }
	    };
	    var ieEventListener = function () {
	        if (hiddenInput.is(':focus')) {
	            focusIeClipboardDiv();
	        }
	    };
	    var cutEventListener = function (e) {
	        if (isIe) {
	            ieClipboardEvent('cut');
	        }
	        else {
	            standardClipboardEvent('cut', e);
	            focusHiddenArea();
	            e.preventDefault();
	        }
	    };
	    var copyEventListener = function (e) {
	        if (isIe) {
	            ieClipboardEvent('copy');
	        }
	        else {
	            standardClipboardEvent('copy', e);
	            focusHiddenArea();
	            e.preventDefault();
	        }
	    };
	    var pasteEventListener = function (e) {
	        if (isIe) {
	            ieClipboardEvent('paste');
	        }
	        else {
	            standardClipboardEvent('paste', e);
	            focusHiddenArea();
	            e.preventDefault();
	        }
	    };
	    var setup = function (s) {
	        scope = s;
	        ieClipboardDiv = angular.element('#ie-clipboard-contenteditable');
	        hiddenInput = angular.element("#hidden-input");
	        userInput = "";
	        // For IE, the browser will only paste HTML if a contenteditable div is selected before paste. Luckily, the browser fires
	        // a before paste event which lets us switch the focuse to the appropraite element
	        if (isIe) {
	            $document[0].addEventListener('beforepaste', ieEventListener, true);
	        }
	        // We need the hidden input to constantly be selected in case there is a copy or paste event. It also recieves and dispatches input events
	        hiddenInput.on('input', function () {
	            var value = hiddenInput.val();
	            userInput += value;
	            hiddenInputListener(userInput);
	            // There is a bug (sometimes) with Safari and the input area can't be updated during
	            // the input event, so we update the input area after the event is done being processed
	            if (isSafari) {
	                hiddenInput.focus();
	                $timeout(focusHiddenArea, 0);
	            }
	            else {
	                focusHiddenArea();
	            }
	        });
	        // Set clipboard event listeners on the document.
	        if (!scope.onlyPaste) {
	            $document[0].addEventListener('cut', cutEventListener);
	            $document[0].addEventListener('copy', copyEventListener);
	        }
	        $document[0].addEventListener('paste', pasteEventListener);
	        // Keep the hidden text area selected
	        $document.mouseup(focusHiddenArea);
	    };
	    var link = function (scope) {
	        setup(scope);
	        scope.$on('$destroy', function () {
	            $document.off('mouseup');
	            if (!scope.onlyPaste) {
	                $document[0].removeEventListener('cut', cutEventListener);
	                $document[0].removeEventListener('copy', copyEventListener);
	            }
	            $document[0].removeEventListener('paste', pasteEventListener);
	            hiddenInput.off('input');
	            $document[0].removeEventListener('beforepaste', ieEventListener, true);
	        });
	    };
	    return {
	        restrict: 'E',
	        link: link,
	        templateUrl: 'app/components/paste/paste.html',
	        scope: {
	            onlyPaste: '@'
	        }
	    };
	}
	exports.default = rcPasteDirective;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcPedigreeDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/pedigree/pedigree.html',
	        controller: PedigreeController,
	        controllerAs: 'pedigree',
	        bindToController: true,
	        scope: {
	            root: '='
	        }
	    };
	}
	var PedigreeController = /** @class */ (function () {
	    PedigreeController.$inject = ["$log", "$scope", "rx", "families", "persons", "utils"];
	    function PedigreeController($log, $scope, rx, families, persons, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.rx = rx;
	        this.families = families;
	        this.persons = persons;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.fragments = [];
	        this.offsets = [-236, -172, -100, -36, 36, 100, 172, 236];
	        this.fragmentWidth = 792;
	        this.children = [];
	        this.childrenSub = null;
	        this.$onInit = function () {
	            _this.$log.debug('pedigree', _this.root);
	            console.log('pedigree', _this.root);
	            var ix = _this.fragments.findIndex(function (f) { return f.position === 0; });
	            if (ix === -1) {
	                ix = _this.fragments.push({
	                    position: 0,
	                    style: _this.getStyle(0)
	                }) - 1;
	            }
	            _this.fragments[ix].root = _this.root;
	            _this.setChildren(_this.fragments[ix].root);
	            // add fragment
	            $scope.$on('expand', function (ev, _a) {
	                var position = _a.position, root = _a.root;
	                _this.$log.debug('pedigree.expand', position, _this.getStyle(position), root, _this.fragments);
	                var top = position - ((position - 1) % 8);
	                var ix = _this.fragments.findIndex(function (f) { return f.position === position; });
	                _this.fragments = _this.fragments.filter(function (f) { return f.position < top; });
	                if (ix < 0) {
	                    _this.fragments.push({
	                        position: position,
	                        style: _this.getStyle(position),
	                        root: root
	                    });
	                }
	            });
	            $scope.$on('$destroy', function () {
	                if (!!_this.childrenSub) {
	                    _this.childrenSub.unsubscribe();
	                }
	            });
	        };
	    }
	    PedigreeController.prototype.setChildren = function (id) {
	        var _this = this;
	        if (!!this.childrenSub) {
	            this.childrenSub.unsubscribe();
	        }
	        if (id > 0) {
	            this.children = [];
	            this.childrenSub = this.families.streamSpouses(id).flatMap(function (fm) {
	                var cids = [];
	                try {
	                    for (var fm_1 = __values(fm), fm_1_1 = fm_1.next(); !fm_1_1.done; fm_1_1 = fm_1.next()) {
	                        var _a = __read(fm_1_1.value, 2), f = _a[1];
	                        try {
	                            for (var _b = __values(f.childRels), _c = _b.next(); !_c.done; _c = _b.next()) {
	                                var _d = __read(_c.value, 1), cid = _d[0];
	                                if (!cids.includes(cid)) {
	                                    cids.push(cid);
	                                }
	                            }
	                        }
	                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                        finally {
	                            try {
	                                if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
	                            }
	                            finally { if (e_1) throw e_1.error; }
	                        }
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (fm_1_1 && !fm_1_1.done && (_f = fm_1.return)) _f.call(fm_1);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	                return (_g = _this.rx.Observable).forkJoin.apply(_g, __spread(cids.map(function (cid) { return _this.persons.streamId(cid).take(1); })));
	                var e_2, _f, e_1, _e, _g;
	            }).subscribe(function (children) {
	                _this.children = children.sort(function (c1, c2) {
	                    return c1._birthDateSort > c2._birthDateSort ? 1 : c1._birthDateSort < c2._birthDateSort ? -1 : 0;
	                });
	            });
	        }
	    };
	    PedigreeController.prototype.getStyle = function (id) {
	        var top = 0;
	        var left = 52;
	        while (id > 0) {
	            left += this.fragmentWidth;
	            top += this.offsets[(id - 1) % 8];
	            id = (id - 1) >>> 3; // jshint ignore:line
	        }
	        return {
	            top: top + 'px',
	            left: left + 'px'
	        };
	    };
	    PedigreeController.prototype.home = function () {
	        this.$scope.$emit('home');
	    };
	    PedigreeController.prototype.zoom = function (multiplier) {
	        this.$scope.$emit('zoom', multiplier);
	    };
	    return PedigreeController;
	}());
	exports.default = rcPedigreeDirective;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcPedigreeFragmentDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/pedigree/pedigreeFragment.html',
	        controller: PedigreeFragmentController,
	        controllerAs: 'fragment',
	        bindToController: true,
	        scope: {
	            root: '=',
	            position: '='
	        }
	    };
	}
	var PedigreeFragmentController = /** @class */ (function () {
	    PedigreeFragmentController.$inject = ["$log", "$scope", "rx", "rightsFull", "currentUser", "persons", "families", "leads", "evidences", "utils"];
	    function PedigreeFragmentController($log, $scope, rx, rightsFull, currentUser, persons, families, leads, evidences, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.rx = rx;
	        this.currentUser = currentUser;
	        this.persons = persons;
	        this.families = families;
	        this.leads = leads;
	        this.evidences = evidences;
	        this.utils = utils;
	        this.slots = [];
	        this.parentFamilies = new Map();
	        this.unknown = this.persons.translations.find(function (t) { return t.value === 'UNKNOWN'; }).display;
	        var pw = this.utils.pleaseWait();
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.$onInit = function () {
	            _this.$log.debug('pf.root position', _this.root, _this.position);
	            var subscription = rx.Observable.combineLatest(utils.watch($scope, 'fragment.root'), utils.readyChange(persons, families)).subscribe(function (_a) {
	                var _b = __read(_a, 2), e = _b[0], _c = __read(_b[1], 1), personMap = _c[0];
	                var root = e.newValue;
	                _this.$log.debug('pf.ready', root);
	                _this.utils.pleaseWaitCancel(pw);
	                if (root === 0 || !!personMap.get(root)) {
	                    _this.fillPedigree(1, root, null, null, 0);
	                }
	            });
	            $scope.$on('$destroy', function () {
	                _this.utils.pleaseWaitCancel(pw);
	                subscription.unsubscribe();
	            });
	        };
	    }
	    PedigreeFragmentController.prototype.fillPedigree = function (pos, pid, family, relationshipType, childId) {
	        var _this = this;
	        if (pos > 15) {
	            return;
	        }
	        // if this slot is unknown(0) or empty(-1)
	        if (pid <= 0) {
	            if (pid === 0) {
	                this.setSlot(pos, {
	                    _unknown: true,
	                    _root: pos === 1 && this.position === 0,
	                    _family: family,
	                    _childId: childId,
	                    _relationshipType: relationshipType // used in add person
	                });
	            }
	            else {
	                this.deleteSlot(pos);
	            }
	            this.parentFamilies.delete(pos);
	            this.fillPedigree(pos * 2, -1, null, null, pid);
	            this.fillPedigree(pos * 2 + 1, -1, null, null, pid);
	            return;
	        }
	        // get person
	        this.persons.streamId(pid).take(1).subscribe(function (p) {
	            _this.setSlot(pos, p);
	            // get parents
	            _this.families.streamParents(pid).take(1).subscribe(function (fm) {
	                var prefFamily = _this.families.getPreferredFamily(fm, p.preferredParentsFamilyId);
	                var families = Array.from(fm.values()).map(function (family) {
	                    return {
	                        id: family.id,
	                        husbandId: family.husbandId,
	                        wifeId: family.wifeId,
	                        husbandName: _this.unknown,
	                        wifeName: _this.unknown
	                    };
	                });
	                if (families.length > 1) {
	                    families.forEach(function (family) {
	                        if (family.husbandId > 0) {
	                            _this.persons.streamId(family.husbandId).take(1).subscribe(function (p) {
	                                family.husbandName = !!p ? p._fullName : '';
	                            });
	                        }
	                        if (family.wifeId > 0) {
	                            _this.persons.streamId(family.wifeId).take(1).subscribe(function (p) {
	                                family.wifeName = !!p ? p._fullName : '';
	                            });
	                        }
	                        family.isPreferred = (family.id === prefFamily.id);
	                    });
	                }
	                _this.parentFamilies.set(pos, families);
	                if (!!prefFamily) {
	                    _this.fillPedigree(pos * 2, prefFamily.husbandId, prefFamily, 'FATHER', pid);
	                    _this.fillPedigree(pos * 2 + 1, prefFamily.wifeId, prefFamily, 'MOTHER', pid);
	                }
	                else {
	                    var f = { id: 0, childRels: new Map([[p.id, { fatherRel: '', motherRel: '' }]]) };
	                    _this.fillPedigree(pos * 2, 0, f, 'FATHER', pid);
	                    _this.fillPedigree(pos * 2 + 1, 0, f, 'MOTHER', pid);
	                }
	            });
	        });
	    };
	    PedigreeFragmentController.prototype.setSlot = function (pos, person) {
	        var ix = this.slots.findIndex(function (slot) { return slot.pos === pos; });
	        if (ix >= 0) {
	            this.slots[ix] = { pos: pos, person: person };
	        }
	        else {
	            this.slots.push({ pos: pos, person: person });
	        }
	    };
	    PedigreeFragmentController.prototype.deleteSlot = function (pos) {
	        var ix = this.slots.findIndex(function (slot) { return slot.pos === pos; });
	        if (ix >= 0) {
	            this.slots.splice(ix, 1);
	        }
	    };
	    PedigreeFragmentController.prototype.getSlot = function (pos) {
	        return this.slots.find(function (slot) { return slot.pos === pos; });
	    };
	    PedigreeFragmentController.prototype.showPerson = function (pos, person) {
	        return (pos > 1 || this.position === 0) && !(person._unknown && this.hideAdd);
	    };
	    PedigreeFragmentController.prototype.showBox = function (pos, person) {
	        return (pos === 0 ? this.position > 0 : pos < 8 && !person._unknown) && !(this.hideAdd && ((!!person && person._unknown) || (!!this.getSlot(pos * 2) && this.getSlot(pos * 2)._unknown && !!this.getSlot(pos * 2 + 1) && this.getSlot(pos * 2 + 1)._unknown)));
	    };
	    PedigreeFragmentController.prototype.showButton = function (pos, person) {
	        return pos >= 8 && !person._unknown;
	    };
	    PedigreeFragmentController.prototype.select = function (ev, person) {
	        var _this = this;
	        if (person === null) {
	            return;
	        }
	        if (person._unknown) {
	            this.currentUser.stream().filter(function (u) { return !!u; }).take(1).subscribe(function (user) {
	                _this.$log.debug('pf.select', person._childId, person._root, person._family, person._relationshipType);
	                _this.utils.dialog(ev, 'AddPersonController', 'app/components/addPerson/addPerson.html', false, {
	                    mode: !!person._family ? 'parent' : '',
	                    relationshipType: person._relationshipType,
	                    relatedToPersonId: person._childId,
	                    family: !!person._family && person._family.id > 0 ? person._family : null,
	                    nameGiven: person._root ? user.given : '',
	                    nameSurname: person._root ? user.surname : ''
	                });
	            });
	        }
	        else {
	            this.utils.dialog(ev, 'RelativesController', 'app/components/relatives/relatives.html', true, {
	                pid: person.id
	            });
	        }
	    };
	    PedigreeFragmentController.prototype.expand = function (pos, person) {
	        this.$scope.$emit('expand', { position: this.position * 8 + pos - 7, root: person.id });
	    };
	    PedigreeFragmentController.prototype.hasParents = function (pos) {
	        var fs = this.parentFamilies.get(pos);
	        return !!fs && fs.length > 0;
	    };
	    PedigreeFragmentController.prototype.setPreferredParents = function (person, family) {
	        if (person.preferredParentsFamilyId !== family.id) {
	            person.preferredParentsFamilyId = family.id;
	            this.persons.update(person);
	        }
	    };
	    return PedigreeFragmentController;
	}());
	exports.default = rcPedigreeFragmentDirective;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcPersonLandscapeDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/person/personLandscape.html',
	        controller: PersonLandscapeController,
	        controllerAs: 'person',
	        bindToController: true,
	        scope: {
	            person: '=',
	            marriage: '=',
	            format: '@',
	            isDraggable: '=',
	            isChild: '=',
	            isUnknown: '=',
	            isLink: '=',
	            isSelf: '=',
	            showMarriage: '=',
	            showTools: '=',
	            showStars: '=',
	            fatherRel: '=',
	            motherRel: '='
	        }
	    };
	}
	var PersonLandscapeController = /** @class */ (function () {
	    PersonLandscapeController.$inject = ["$log", "$scope", "fs", "persons", "currentTree", "leads", "evidences", "users", "utils"];
	    function PersonLandscapeController($log, $scope, fs, persons, currentTree, leads, evidences, users, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.fs = fs;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.addMessage = '';
	        this.$onInit = function () {
	            if (!!_this.person && !_this.person._unknown) {
	                currentTree.stream().take(1).subscribe(function (tree) {
	                    var tagColorMap = utils.getTagColorMap(tree);
	                    persons.augmentPerson(_this.person, leads, evidences, users).subscribe(function (p) {
	                        _this.person = p;
	                        _this.encodedId = utils.encodeId(p.id);
	                        _this.tagColor = utils.getTagColor(tagColorMap, p.tags);
	                    });
	                });
	            }
	            if (!!_this.person && _this.isUnknown) {
	                if (['FATHER', 'MOTHER', 'SPOUSE', 'CHILD'].includes(_this.person._relationshipType)) {
	                    _this.addMessage = _this.person._relationshipType;
	                }
	            }
	        };
	    }
	    PersonLandscapeController.prototype.colorStyle = function (color) {
	        if (!color) {
	            return {};
	        }
	        return { 'background-color': this.utils.colors[color][5] };
	    };
	    PersonLandscapeController.prototype.getTagString = function (tags) {
	        return !!tags ? Array.from(tags.keys()).join(', ') : '';
	    };
	    PersonLandscapeController.prototype.getFSHref = function (ctx) {
	        return !!this.person ? this.fs.getHref(this.person._url, ctx) : '';
	    };
	    PersonLandscapeController.prototype.clickFSHref = function (ctx) {
	        this.fs.clickHref(this.person._url, ctx);
	    };
	    PersonLandscapeController.prototype.getStars = function (p) {
	        if (!p) {
	            return [];
	        }
	        return this.utils.asArray(Math.min(5, p._stars));
	    };
	    PersonLandscapeController.prototype.moreStars = function (p) {
	        if (!p) {
	            return false;
	        }
	        return p._stars > 5;
	    };
	    PersonLandscapeController.prototype.getCompliments = function () {
	        return 0;
	        // TODO compliments
	    };
	    PersonLandscapeController.prototype.editRelationship = function (ev) {
	        this.$scope.$emit('editRel', { ev: ev, id: this.person.id });
	    };
	    PersonLandscapeController.prototype.remove = function (ev) {
	        this.$scope.$emit('remove', { ev: ev, id: this.person.id });
	    };
	    PersonLandscapeController.prototype.select = function (ev) {
	        this.$scope.$emit('show', { type: 'person', ev: ev, id: this.person.id });
	    };
	    //editMarriage(ev) {
	    //  this.$scope.$emit('editmarriage', {event: ev, person: this.person});
	    //}
	    PersonLandscapeController.prototype.toggleCompliment = function () {
	        this.complimented = !this.complimented;
	        if (this.complimented) {
	            this.person.compliments++;
	        }
	        else {
	            this.person.compliments--;
	        }
	    };
	    return PersonLandscapeController;
	}());
	exports.default = rcPersonLandscapeDirective;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcPersonPortraitDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/person/personPortrait.html',
	        controller: PersonPortraitController,
	        controllerAs: 'person',
	        bindToController: true,
	        scope: {
	            person: '=',
	            isUnknown: '='
	        }
	    };
	}
	var PersonPortraitController = /** @class */ (function () {
	    PersonPortraitController.$inject = ["$log", "$scope", "currentTree", "utils"];
	    function PersonPortraitController($log, $scope, currentTree, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.addMessage = '';
	        this.$onInit = function () {
	            if (!!_this.person && !_this.person._unknown) {
	                currentTree.stream().take(1).subscribe(function (tree) {
	                    var tagColorMap = utils.getTagColorMap(tree);
	                    _this.tagColor = utils.getTagColor(tagColorMap, _this.person.tags);
	                });
	            }
	            if (!!_this.person && _this.isUnknown) {
	                if (['FATHER', 'MOTHER', 'SPOUSE', 'CHILD'].includes(_this.person._relationshipType)) {
	                    _this.addMessage = _this.person._relationshipType;
	                }
	            }
	        };
	    }
	    PersonPortraitController.prototype.colorStyle = function (color) {
	        if (!color) {
	            return {};
	        }
	        return { 'background-color': this.utils.colors[color][5] };
	    };
	    PersonPortraitController.prototype.getStars = function (p) {
	        if (!p) {
	            return [];
	        }
	        return this.utils.asArray(Math.min(5, p._stars));
	    };
	    PersonPortraitController.prototype.moreStars = function (p) {
	        if (!p) {
	            return false;
	        }
	        return p._stars > 5;
	    };
	    PersonPortraitController.prototype.remove = function (ev) {
	        this.$scope.$emit('remove', { event: ev, person: this.person });
	    };
	    return PersonPortraitController;
	}());
	exports.default = rcPersonPortraitDirective;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	function rcResearchLogDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/researchLog/researchLog.html',
	        controller: ResearchLogController,
	        controllerAs: 'log',
	        bindToController: true,
	        scope: {
	            researchLog: '=',
	            expanded: '=',
	            hideTools: '=',
	            forceCreatedEdited: '=',
	            expandGo: '='
	        }
	    };
	}
	var ResearchLogController = /** @class */ (function () {
	    ResearchLogController.$inject = ["$log", "$scope", "$state", "rightsFull", "utils"];
	    function ResearchLogController($log, $scope, $state, rightsFull, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.$onInit = function () {
	            // TODO initialization code that relies upon this.researchLog being set goes here
	        };
	    }
	    ResearchLogController.prototype.toggleExpand = function () {
	        if (this.expandGo) {
	            this.$state.go('tree.research-log', { id: this.researchLog.id });
	        }
	        else {
	            this.expanded = !this.expanded;
	        }
	    };
	    ResearchLogController.prototype.edit = function (ev) {
	        this.$scope.$emit('edit', { ev: ev, type: 'research-log', item: this.researchLog });
	    };
	    ResearchLogController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'research-log', id: this.researchLog.id });
	    };
	    return ResearchLogController;
	}());
	exports.default = rcResearchLogDirective;


/***/ }),
/* 149 */
/***/ (function(module, exports) {

	"use strict";
	rcScrollableDirective.$inject = ["$timeout"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcScrollableDirective($timeout) {
	    'ngInject';
	    var threshold = 12;
	    function link(scope, elem) {
	        var wasScrollable;
	        function isScrollable() {
	            return elem[0].scrollHeight - (elem[0].scrollTop + elem[0].offsetHeight) > threshold;
	        }
	        $timeout(function () {
	            wasScrollable = isScrollable();
	            scope.callback({ scrollable: wasScrollable });
	        });
	        elem.bind('scroll', function () {
	            if (isScrollable() !== wasScrollable) {
	                wasScrollable = !wasScrollable;
	                scope.$apply(function () {
	                    scope.callback({ scrollable: wasScrollable });
	                });
	            }
	        });
	    }
	    return {
	        restrict: 'A',
	        link: link,
	        scope: {
	            callback: '&rcScrollable'
	        }
	    };
	}
	exports.default = rcScrollableDirective;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcScrollGetDirective() {
	    'ngInject';
	    function link(scope, elem) {
	        scope.callback({ left: elem[0].scrollLeft, top: elem[0].scrollTop });
	        elem.bind('scroll', function () {
	            scope.$apply(function () {
	                scope.callback({ left: elem[0].scrollLeft, top: elem[0].scrollTop });
	            });
	        });
	    }
	    return {
	        restrict: 'A',
	        link: link,
	        scope: {
	            callback: '&rcScrollGet'
	        }
	    };
	}
	exports.default = rcScrollGetDirective;


/***/ }),
/* 151 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcScrollSetLeftDirective() {
	    'ngInject';
	    function link(scope, elem, attrs) {
	        attrs.$observe('rcScrollSetLeft', function (value) {
	            elem[0].scrollLeft = value;
	        });
	    }
	    return {
	        restrict: 'A',
	        link: link
	    };
	}
	exports.default = rcScrollSetLeftDirective;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

	"use strict";
	rcSetFocusDirective.$inject = ["$timeout"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcSetFocusDirective($timeout) {
	    'ngInject';
	    return {
	        restrict: 'A',
	        link: function ($scope, $element, $attr) {
	            var timeout = +$attr.rcSetFocusTimeout;
	            $scope.$watch($attr.rcSetFocus, function (focusVal) {
	                if (focusVal) {
	                    $timeout(function () {
	                        if (!!$element.froalaEditor && $attr.froala) {
	                            $element.froalaEditor('events.focus');
	                        }
	                        else {
	                            var elm = $element;
	                            if (elm.find('input').length > 0) {
	                                elm = elm.find('input');
	                            }
	                            elm.focus();
	                        }
	                    }, timeout);
	                }
	            });
	        }
	    };
	}
	exports.default = rcSetFocusDirective;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcSidenavDirective() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/sidenav/sidenav.html',
	        controller: SidenavController,
	        controllerAs: 'sidenav',
	        bindToController: true
	    };
	}
	var SidenavController = /** @class */ (function () {
	    SidenavController.$inject = ["$log", "$window", "$state", "$scope", "sidenav", "rightsFull", "currentTree", "utils"];
	    function SidenavController($log, $window, $state, $scope, sidenav, rightsFull, currentTree, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$window = $window;
	        this.$state = $state;
	        this.sidenav = sidenav;
	        this.utils = utils;
	        var sub = currentTree.stream().subscribe(function (tree) {
	            _this.currentTree = tree;
	        });
	        this.views = [
	            { button: true, id: 'tree', label: 'Tree', sref: 'tree.graph', params: { root: null }, rc_icon: 'tree-generic' },
	            { button: true, id: 'newsfeed', label: 'Dashboard', sref: 'tree.feed', md_icon: 'dashboard' },
	            { button: true, id: 'people', label: 'People', sref: 'tree.people', md_icon: 'person' },
	            { button: true, id: 'media', label: 'Media', sref: 'tree.media', md_icon: 'photo' },
	            { button: true, id: 'research-logs', label: 'Research Logs', sref: 'tree.research-logs', md_icon: 'view_week' },
	            //      {button: true, label: 'Matches', sref: 'tree.matches', rc_icon: 'match'},
	            { button: true, id: 'users', label: 'Invitations', sref: 'tree.users', md_icon: 'group' },
	            { menu: true, id: 'lists', label: 'Content Lists', md_icon: 'list', children: [
	                    { label: 'Evidences', sref: 'tree.evidences', md_icon: 'event' },
	                    { label: 'Notes', sref: 'tree.notes', md_icon: 'chat' },
	                    { label: 'Sources', sref: 'tree.sources', md_icon: 'star' },
	                    { label: 'Stories', sref: 'tree.stories', md_icon: 'import_contacts' },
	                    { label: 'Warnings', sref: 'tree.warnings', md_icon: 'warning' }
	                ] },
	            { menu: true, id: 'help', label: 'Help', md_icon: 'help_outline', children: [
	                    { label: 'Support Center', href: 'https://americanancestrees.helpscoutdocs.com' },
	                    { label: 'Help Videos', href: '/#!/home' },
	                    { label: 'American Ancestors Home', href: 'https://www.americanancestors.org' },
	                    { label: 'Hire a Researcher', href: 'https://www.americanancestors.org/services/which-service' }
	                ] }
	            //      {button: true, label: 'Messages', sref: 'tree.messages', md_icon: 'forum'},
	            //      {button: true, label: 'Changes', sref: 'tree.changes', md_icon: 'new_releases'},
	        ];
	        var pushed = false;
	        var rSub = rightsFull.streamLevel().subscribe(function (level) {
	            if (level >= rightsFull.LEVEL_READ && !pushed) {
	                // this.views[6].children.splice(1, 0,
	                //   {label: 'Infographics', sref: 'tree.infographics', md_icon: 'insert_chart_outline'}
	                // );
	                _this.views.splice(4, 0, { button: true, id: 'leads', label: 'Hints & ToDos', sref: 'tree.leads', md_icon: 'star_border' });
	                _this.views.splice(6, 0, { button: true, id: 'dna-profiles', label: 'DNA', sref: 'tree.dna-profiles', rc_icon: 'dna' });
	                _this.views.splice(9, 0, { divider: true }, { button: true, id: 'apps', label: 'Apps', sref: 'tree.apps', md_icon: 'apps' }, { button: true, id: 'reports', label: 'Reports', sref: 'tree.reports', md_icon: 'print' }, { button: true, id: 'hintSettings', label: 'Hint Settings', sref: 'tree.hintSettings', md_icon: 'stars' }, { button: true, id: 'treeSettings', label: 'Tree Settings', sref: 'tree.treeSettings', md_icon: 'settings' });
	                pushed = true;
	            }
	        });
	        $scope.$on('$destroy', function () {
	            sub.unsubscribe();
	            rSub.unsubscribe();
	        });
	    }
	    SidenavController.prototype.trees = function (ev) {
	        var _this = this;
	        this.utils.dialog(ev, 'SelectTreeController', 'app/components/selectTree/selectTree.html', true, {}).then(function (result) {
	            if (result.action === 'open') {
	                if (!!_this.currentTree && result.id === _this.currentTree.id) {
	                    _this.$window.location.reload();
	                }
	                else {
	                    _this.$state.go('tree', { treeId: result.id });
	                }
	            }
	            else if (result.action === 'create') {
	                _this.$state.go('create');
	            }
	        });
	    };
	    SidenavController.prototype.isLockedOpen = function () {
	        return this.sidenav.isLockedOpen();
	    };
	    SidenavController.prototype.isCurrentView = function (view) {
	        return view.sref === this.$state.current.name && (!view.params || view.params.id == null || view.params.id === this.$state.params.id);
	    };
	    SidenavController.prototype.isHighlighted = function (view) {
	        return view.id === 'hintSettings' && !!this.currentTree && this.currentTree.preferences.HINT_SETTINGS_REVIEWED !== 'TRUE';
	    };
	    SidenavController.prototype.go = function (sref, params) {
	        if (!this.sidenav.isLockedOpen()) {
	            this.sidenav.toggle();
	        }
	        this.$state.go(sref, params);
	    };
	    return SidenavController;
	}());
	exports.default = rcSidenavDirective;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcSourceDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/source/source.html',
	        controller: SourceController,
	        controllerAs: 'source',
	        bindToController: true,
	        scope: {
	            source: '='
	        }
	    };
	}
	var SourceController = /** @class */ (function () {
	    SourceController.$inject = ["$log", "$scope", "rightsFull", "medias", "utils"];
	    function SourceController($log, $scope, rightsFull, medias, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.medias = medias;
	        this.utils = utils;
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.$onInit = function () {
	            $log.debug('source', _this.source);
	        };
	    }
	    SourceController.prototype.edit = function (ev) {
	        this.$scope.$emit('edit', { ev: ev, type: 'source', item: this.source });
	    };
	    SourceController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'source', id: this.source.id });
	    };
	    SourceController.prototype.getMediaIds = function (o) {
	        return Array.from(o.mediaIds.keys());
	    };
	    SourceController.prototype.getMediaURL = function (mid, small) {
	        return this.medias.getFileURL(mid, 0, (small ? '600' : ''));
	    };
	    SourceController.prototype.getLink = function (s) {
	        if (s.externalIds.has('werelate.org')) {
	            return 'http://www.werelate.org/wiki/Source:' + s.externalIds.get('werelate.org').id;
	        }
	        return '';
	    };
	    SourceController.prototype.getThumbURL = function (u) {
	        return this.utils.getThumbURL(u);
	    };
	    SourceController.prototype.isValidURL = function (u) {
	        return this.utils.isValidURL(u);
	    };
	    return SourceController;
	}());
	exports.default = rcSourceDirective;


/***/ }),
/* 155 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcStoryDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/story/story.html',
	        controller: StoryController,
	        controllerAs: 'story',
	        bindToController: true,
	        scope: {
	            story: '=',
	            expanded: '=',
	            hideTools: '=',
	            forceCreatedEdited: '=',
	            age: '@'
	        }
	    };
	}
	var StoryController = /** @class */ (function () {
	    StoryController.$inject = ["$log", "$scope", "researchLogs", "rightsFull", "medias", "social", "utils"];
	    function StoryController($log, $scope, researchLogs, rightsFull, medias, social, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.medias = medias;
	        this.utils = utils;
	        this.social = social;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.mediasList = [];
	        this.viewableFileTypes = ['video/mp4', 'application/pdf', 'image/tiff', 'image/jpeg', 'image/png', 'image/bmp', 'image/gif'];
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	        this.$onInit = function () {
	            _this.twitterUrl = social.getTwitterUrl({ text: _this.story.title, personIds: _this.story.personIds });
	            $scope.$on('share', function (ev, params) {
	                _this.share(params.ev, params.platform);
	                ev.stopPropagation();
	            });
	        };
	        var rlSub = utils.watch($scope, function () { return _this.story.researchLogId; }).flatMap(function () { return researchLogs.streamId(_this.story.researchLogId); }).subscribe(function (log) {
	            _this.researchLogTitle = !!log ? log.title : '';
	        });
	        var mSub = utils.watch($scope, function () { return _this.story.mediaIds; }).flatMap(function () { return medias.streamIds(_this.story.mediaIds.keys()); }).subscribe(function (ms) {
	            var mediasList = Array.from(ms.values());
	            _this.mediasList = mediasList;
	        });
	        $scope.$on('$destroy', function () {
	            rlSub.unsubscribe();
	            mSub.unsubscribe();
	        });
	    }
	    StoryController.prototype.toggleExpand = function () {
	        this.$scope.$emit('toggleExpand', { id: this.story.id });
	    };
	    StoryController.prototype.share = function (ev, platform) {
	        this.social.post(platform, {
	            title: this.story.title,
	            mediaId: this.story.mediaIds.size > 0 ? Array.from(this.story.mediaIds.keys())[0] : 0,
	            description: this.utils.removeHtml(this.story.text),
	            personIds: this.story.personIds
	        }, ev);
	    };
	    StoryController.prototype.getMediaIds = function (o) {
	        return Array.from(o.mediaIds.keys());
	    };
	    StoryController.prototype.getMedias = function (o) {
	        return this.mediasList;
	    };
	    StoryController.prototype.getMediaURL = function (m) {
	        return this.medias.getMediaURL(m);
	    };
	    StoryController.prototype.getMediaImageURL = function (m, size) {
	        return this.medias.getMediaImageURL(m, size);
	    };
	    StoryController.prototype.getMediaFilename = function (m) {
	        return m.fileInfos.size > 0 ? this.utils.first(m.fileInfos).fileName : '';
	    };
	    StoryController.prototype.isViewableType = function (m) {
	        if (!m || m.fileInfos.size === 0) {
	            return false;
	        }
	        var contentType = this.utils.first(m.fileInfos).contentType.toLowerCase();
	        return this.viewableFileTypes.includes(contentType);
	    };
	    StoryController.prototype.getYear = function (s) {
	        return !!s.dateSort ? s.dateSort.substr(0, 4) : '';
	    };
	    StoryController.prototype.getPlaceLink = function (s) {
	        var ps = s.placeStandard;
	        if (!ps) {
	            return '';
	        }
	        return 'http://www.werelate.org/wiki/Place:' + encodeURI(ps.replace(' ', '_'));
	    };
	    StoryController.prototype.edit = function (ev) {
	        this.$scope.$emit('edit', { ev: ev, type: 'story', item: this.story });
	    };
	    StoryController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'story', id: this.story.id });
	    };
	    return StoryController;
	}());
	exports.default = rcStoryDirective;


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcSunburstAncestorsDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/sunburst/sunburstAncestors.html',
	        controller: SunburstAncestorsController,
	        controllerAs: 'sunburstAncestors',
	        bindToController: true,
	        scope: {
	            root: '=',
	            tree: '=',
	            position: '=',
	            highlight: '=',
	            mode: '@',
	            submode: '@',
	            id: '@'
	        }
	    };
	}
	var timerMillis = 1000;
	var totalSunburstAncestorSize = 1536;
	var SunburstAncestorsController = /** @class */ (function () {
	    SunburstAncestorsController.$inject = ["$log", "$scope", "$timeout", "sidenav", "rx", "currentTree", "persons", "leads", "evidences", "families", "utils"];
	    function SunburstAncestorsController($log, $scope, $timeout, sidenav, rx, currentTree, persons, leads, evidences, families, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.rx = rx;
	        this.$timeout = $timeout;
	        this.utils = utils;
	        this.sidenav = sidenav;
	        this.$scope.fragment = {};
	        this.persons = persons;
	        this.leads = leads;
	        this.evidences = evidences;
	        this.families = families;
	        this.data = {};
	        this._data = {};
	        this.path = [];
	        this.numFanGenerations = 5;
	        var pw = null;
	        var hSub = null;
	        currentTree.stream().filter(function (t) { return !!t; }).take(1).subscribe(function (tree) {
	            _this.treePrefs = tree.preferences;
	        });
	        this.$onInit = function () {
	            if (_this.mode === 'TREE') {
	                pw = _this.utils.pleaseWait();
	                _this.config = {
	                    mode: _this.mode,
	                    fan: true,
	                    mouseEvents: true,
	                    text: true,
	                    leads: true,
	                    id: 'sunburst-d3-' + (_this.id || 'TREE')
	                };
	            }
	            else if (_this.mode === 'DNAKIT' || _this.mode === 'DNAFILTER') {
	                _this.numFanGenerations = 6;
	                hSub = utils.watch($scope, function () { return _this.highlight; }, true).subscribe(function () {
	                    _this.config = {
	                        mode: _this.mode,
	                        fan: true,
	                        highlight: _this.highlight,
	                        id: 'sunburst-d3-' + _this.id
	                    };
	                });
	            }
	            $scope.$on('click', function (e, data) {
	                if (_this.mode === 'DNAFILTER') {
	                    $scope.$emit('click-person', { submode: _this.submode, person: data.family });
	                }
	                else if (data.family._unknown) {
	                    _this.showRelatives(null, e, data.family);
	                }
	                else {
	                    _this.showRelatives(data.family.id);
	                }
	            });
	            $scope.$on('hover', function (evt, path) {
	                if ((!path || path.length === 0) && _this.path.length > 0) {
	                    _this.startTimer();
	                }
	                else {
	                    _this.path = path.slice().reverse();
	                    _this.path.forEach(function (item) {
	                        if (item._unknown || !_this.personsMap) {
	                            return;
	                        }
	                        item.person = _this.personsMap.get(item.id);
	                    });
	                }
	            });
	            rx.Observable.combineLatest(_this.utils.watch($scope, 'fragment.root'), _this.utils.readyChange(persons, families)).subscribe(function (_a) {
	                var _b = __read(_a, 2), e = _b[0], _c = __read(_b[1], 2), personMap = _c[0], familiesMap = _c[1];
	                $log.debug('pf.ready', e.newValue);
	                if (!!pw) {
	                    _this.utils.pleaseWaitCancel(pw);
	                }
	                if (e.newValue === 0 || !!personMap.get(e.newValue)) {
	                    _this.personsMap = personMap;
	                    _this.familiesMap = familiesMap;
	                    _this.fillFan(e.newValue);
	                }
	            });
	            _this.$scope.fragment.root = _this.root;
	            $scope.$on('$destroy', function () {
	                if (!!_this.timer) {
	                    $timeout.cancel(_this.timer);
	                }
	                if (!!pw) {
	                    _this.utils.pleaseWaitCancel(pw);
	                }
	                if (!!hSub) {
	                    hSub.unsubscribe();
	                }
	            });
	        };
	    }
	    SunburstAncestorsController.prototype.startTimer = function () {
	        var _this = this;
	        this.timer = this.$timeout(function () {
	            _this.path = [];
	            _this.timer = null;
	        }, timerMillis);
	    };
	    SunburstAncestorsController.prototype.mouseEnterPath = function () {
	        if (!!this.timer) {
	            this.$timeout.cancel(this.timer);
	            this.timer = null;
	        }
	    };
	    SunburstAncestorsController.prototype.mouseLeavePath = function () {
	        this.path = [];
	    };
	    SunburstAncestorsController.prototype.getNumber = function (n) {
	        return new Array(n);
	    };
	    SunburstAncestorsController.prototype.isSidenavLockedOpen = function () {
	        return this.sidenav.isLockedOpen();
	    };
	    SunburstAncestorsController.prototype.handlePersonClick = function (pid, e, person) {
	        if (pid) {
	            this.showRelatives(pid);
	        }
	        else {
	            this.showRelatives(null, e, person);
	        }
	    };
	    SunburstAncestorsController.prototype.showRelatives = function (pid, ev, person) {
	        var _this = this;
	        if (pid) {
	            this.utils.dialog(null, 'RelativesController', 'app/components/relatives/relatives.html', true, {
	                pid: pid
	            }).then(function (response) {
	                _this.$log.info('response', response);
	            }, function () {
	                _this.$log.info('cancel');
	            });
	        }
	        else {
	            if (!person)
	                return;
	            this.utils.dialog(ev, 'AddPersonController', 'app/components/addPerson/addPerson.html', false, {
	                mode: 'parent',
	                relationshipType: person.gender === 'male' ? 'FATHER' : 'MOTHER',
	                relatedToPersonId: !!person.parent ? person.parent.id : 0,
	                family: person._family,
	                nameGiven: '',
	                nameSurname: ''
	            });
	        }
	    };
	    SunburstAncestorsController.prototype.createAddButton = function (pos, parent, gender, family) {
	        if (pos > this.numFanGenerations) {
	            return;
	        }
	        if (!parent.children)
	            parent.children = [];
	        parent.children.push({
	            _unknown: true,
	            nameFirst: '+',
	            nameLast: 'Add',
	            gender: gender,
	            lifespan: null,
	            stars: 0,
	            leads: 0,
	            size: pos === 1 ? 512 : parent.size / 2,
	            ix: parent.children.length || 0,
	            _family: family
	        });
	    };
	    SunburstAncestorsController.prototype.createPerson = function (pos, pid, parent, subjects) {
	        if (pos > this.numFanGenerations) {
	            return subjects;
	        }
	        var isRoot = (pos === 0);
	        var subject = new this.rx.AsyncSubject();
	        var p = this.personsMap.get(pid);
	        var f = this.families.getPreferredFamily(this.families.getParentsMap().get(pid) || new Map(), p.preferredParentsFamilyId);
	        var pData = {
	            id: p.id,
	            nameFirst: p._given,
	            nameLast: p._surname,
	            gender: p.gender.toLowerCase(),
	            lifespan: p._lifespan,
	            stars: 0,
	            leads: 0,
	            children: [],
	            size: isRoot ? totalSunburstAncestorSize : pos === 1 ? totalSunburstAncestorSize / 3 : (parent.size / 2),
	            ix: !!parent && !!parent.children ? parent.children.length : 0
	        };
	        this.persons.augmentPerson(p, this.leads, this.evidences).subscribe(function (p) {
	            pData.stars = p._stars;
	            pData.leads = p._hints;
	            subject.next(p);
	            subject.complete();
	        });
	        if (isRoot) {
	            this._data = pData;
	        }
	        else {
	            if (!parent.children)
	                parent.children = [];
	            parent.children.push(pData);
	        }
	        if (!f) {
	            if (isRoot) {
	                this.createAddButton(pos + 1, pData, 'female');
	                this._data.children.push({
	                    empty: true,
	                    size: totalSunburstAncestorSize / 3,
	                    ix: this._data.children.length
	                });
	                this.createAddButton(pos + 1, pData, 'male');
	            }
	            else {
	                this.createAddButton(pos + 1, pData, 'male');
	                this.createAddButton(pos + 1, pData, 'female');
	            }
	        }
	        else if (isRoot) {
	            if (f.wifeId)
	                this.createPerson(pos + 1, f.wifeId, pData, subjects);
	            else
	                this.createAddButton(pos + 1, pData, 'female', f);
	            this._data.children.push({
	                empty: true,
	                size: 512,
	                ix: this._data.children.length
	            });
	            if (f.husbandId)
	                this.createPerson(pos + 1, f.husbandId, pData, subjects);
	            else
	                this.createAddButton(pos + 1, pData, 'male', f);
	        }
	        else {
	            if (f.husbandId)
	                this.createPerson(pos + 1, f.husbandId, pData, subjects);
	            else
	                this.createAddButton(pos + 1, pData, 'male', f);
	            if (f.wifeId)
	                this.createPerson(pos + 1, f.wifeId, pData, subjects);
	            else
	                this.createAddButton(pos + 1, pData, 'female', f);
	        }
	        subjects.push(subject);
	        return subjects;
	    };
	    SunburstAncestorsController.prototype.augmentData = function (data, depth, x, y, dy, totalSize, ahnentafel, parent) {
	        var _this = this;
	        data.depth = depth;
	        data.x = x;
	        data.y = y;
	        data.dx = data.size / totalSize;
	        data.dy = dy;
	        data.value = data.size;
	        data.fill = this.utils.getAhnentafelColor(this.treePrefs, ahnentafel, this.mode === 'TREE');
	        data.fillOpacity = 0.6;
	        if (!!parent) {
	            data.parent = parent;
	        }
	        if (!!data.children) {
	            var totalSiblingSize_1 = 0;
	            data.children.forEach(function (child, ix) {
	                if (ahnentafel === 1) {
	                    if (ix === 0) {
	                        ix = 1;
	                    }
	                    else if (ix === 2) {
	                        ix = 0;
	                    }
	                }
	                _this.augmentData(child, depth + 1, x + (totalSiblingSize_1 / totalSize), y + dy, dy, totalSize, ahnentafel * 2 + ix, data);
	                totalSiblingSize_1 += child.size;
	            });
	        }
	    };
	    SunburstAncestorsController.prototype.removeUnknown = function (node) {
	        if (!!node.children) {
	            try {
	                for (var _a = __values(node.children), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var child = _b.value;
	                    if (!child._unknown) {
	                        this.removeUnknown(child);
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            node.children = node.children.filter(function (child) { return !child._unknown; });
	        }
	        var e_1, _c;
	    };
	    SunburstAncestorsController.prototype.fillFan = function (pid) {
	        var _this = this;
	        if (!pid) {
	            var parent_1 = {};
	            this.createAddButton(0, parent_1, '');
	            this.data = parent_1.children[0];
	            this.data.fan = true;
	        }
	        else {
	            (_a = this.rx.Observable).combineLatest.apply(_a, __spread(this.createPerson(0, pid, null, []))).subscribe(function () {
	                _this.augmentData(_this._data, 0, 0, 0, 0.2, totalSunburstAncestorSize, 1, null);
	                if (_this.mode !== 'TREE') {
	                    _this.removeUnknown(_this._data);
	                }
	                _this.data = _this._data;
	            });
	        }
	        var _a;
	    };
	    return SunburstAncestorsController;
	}());
	exports.default = rcSunburstAncestorsDirective;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcSunburstDescendantsDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/sunburst/sunburstDescendants.html',
	        controller: SunburstDescendantsController,
	        controllerAs: 'sunburstDescendants',
	        bindToController: true,
	        scope: {
	            root: '=',
	            tree: '=',
	            position: '='
	        }
	    };
	}
	var timerMillis = 1000;
	var SunburstDescendantsController = /** @class */ (function () {
	    SunburstDescendantsController.$inject = ["$log", "$scope", "$timeout", "utils", "sidenav", "rx", "persons", "leads", "evidences", "families"];
	    function SunburstDescendantsController($log, $scope, $timeout, utils, sidenav, rx, persons, leads, evidences, families) {
	        'ngInject';
	        var _this = this;
	        var self = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.$timeout = $timeout;
	        this.utils = utils;
	        this.sidenav = sidenav;
	        this.rx = rx;
	        this.$scope.fragment = {};
	        this.persons = persons;
	        this.leads = leads;
	        this.evidences = evidences;
	        this.families = families;
	        this.path = [];
	        this.data = {};
	        this.config = {
	            mouseEvents: true,
	            text: true,
	            leads: true
	        };
	        var pw = this.utils.pleaseWait();
	        this.$onInit = function () {
	            $scope.$on('click', function (e, data) {
	                self.showRelatives(data.family.id);
	            });
	            $scope.$on('hover', function (evt, path) {
	                if ((!path || path.length === 0) && self.path.length > 0) {
	                    self.startTimer();
	                }
	                else {
	                    self.path = path;
	                    self.path.forEach(function (item) {
	                        item.person = self.personsMap.get(item.id);
	                    });
	                }
	            });
	            rx.Observable.combineLatest(_this.utils.watch($scope, 'fragment.root'), _this.utils.readyChange(persons, families, leads, evidences)).subscribe(function (_a) {
	                var _b = __read(_a, 2), e = _b[0], _c = __read(_b[1], 2), personMap = _c[0], familiesMap = _c[1];
	                $log.debug('pf.ready', e.newValue);
	                _this.utils.pleaseWaitCancel(pw);
	                if (e.newValue === 0 || !!personMap.get(e.newValue)) {
	                    self.personsMap = personMap;
	                    self.familiesMap = familiesMap;
	                    self.spousesMap = self.families.getSpousesMap();
	                    _this.fillChart(e.newValue);
	                }
	            });
	            _this.$scope.fragment.root = _this.root;
	            $scope.$on('$destroy', function () {
	                if (!!self.timer) {
	                    $timeout.cancel(self.timer);
	                }
	                _this.utils.pleaseWaitCancel(pw);
	            });
	        };
	    }
	    SunburstDescendantsController.prototype.createPerson = function (pos, pid, parent, subjects) {
	        var _this = this;
	        if (pos > 4)
	            return subjects;
	        var p = this.personsMap.get(pid);
	        var subject = new this.rx.AsyncSubject();
	        var pData = {
	            id: p.id,
	            noHorizontal: true,
	            nameFirst: p._given,
	            nameLast: p._surname,
	            gender: p.gender.toLowerCase(),
	            lifespan: p._lifespan,
	            stars: 0,
	            leads: 0,
	            children: []
	        };
	        this.persons.augmentPerson(p, this.leads, this.evidences).subscribe(function (p) {
	            pData.stars = p._stars;
	            pData.leads = p._hints;
	            subject.next(p);
	            subject.complete();
	        });
	        if (!parent) {
	            this._data = pData;
	        }
	        else {
	            parent.children.push(pData);
	        }
	        Array.from((this.spousesMap.get(pid) || new Map()).entries()).forEach(function (_a) {
	            var _b = __read(_a, 2), f = _b[1];
	            var childrenArray = Array.from(f.childRels.entries());
	            childrenArray.forEach(function (_a) {
	                var _b = __read(_a, 1), childId = _b[0];
	                _this.createPerson(pos + 1, childId, pData, subjects);
	            });
	        });
	        var size = 0;
	        pData.children.forEach(function (child) {
	            size += child.size;
	        });
	        pData.size = Math.max(1, size);
	        subjects.push(subject);
	        return subjects;
	    };
	    SunburstDescendantsController.prototype.augmentData = function (data, depth, x, y, dy, totalSize, parent) {
	        var _this = this;
	        data.depth = depth;
	        data.x = x;
	        data.y = y;
	        data.dx = data.size / totalSize;
	        data.dy = dy;
	        data.value = data.size;
	        if (!!parent) {
	            data.parent = parent;
	        }
	        if (!!data.children) {
	            var totalSiblingSize_1 = 0;
	            data.children.forEach(function (child) {
	                _this.augmentData(child, depth + 1, x + (totalSiblingSize_1 / totalSize), y + dy, dy, totalSize, data);
	                totalSiblingSize_1 += child.size;
	            });
	        }
	    };
	    SunburstDescendantsController.prototype.fillChart = function (pid) {
	        var _this = this;
	        if (!pid) {
	            this.data = null;
	        }
	        else {
	            (_a = this.rx.Observable).combineLatest.apply(_a, __spread(this.createPerson(0, pid, null, []))).subscribe(function () {
	                _this.augmentData(_this._data, 0, 0, 0, 0.20, _this._data.size, null);
	                _this.data = _this._data;
	            });
	        }
	        var _a;
	    };
	    SunburstDescendantsController.prototype.startTimer = function () {
	        var self = this;
	        this.timer = this.$timeout(function () {
	            self.path = [];
	            self.timer = null;
	        }, timerMillis);
	    };
	    SunburstDescendantsController.prototype.mouseEnterPath = function () {
	        if (!!this.timer) {
	            this.$timeout.cancel(this.timer);
	            this.timer = null;
	        }
	    };
	    SunburstDescendantsController.prototype.mouseLeavePath = function () {
	        this.path = [];
	    };
	    SunburstDescendantsController.prototype.getNumber = function (n) {
	        return new Array(n);
	    };
	    SunburstDescendantsController.prototype.isSidenavLockedOpen = function () {
	        return this.sidenav.isLockedOpen();
	    };
	    SunburstDescendantsController.prototype.showRelatives = function (pid) {
	        var self = this;
	        this.utils.dialog(null, 'RelativesController', 'app/components/relatives/relatives.html', true, {
	            pid: pid
	        }).then(function (response) {
	            self.$log.info('response', response);
	        }, function () {
	            self.$log.info('cancel');
	        });
	    };
	    return SunburstDescendantsController;
	}());
	exports.default = rcSunburstDescendantsDirective;


/***/ }),
/* 158 */
/***/ (function(module, exports) {

	"use strict";
	rcSunburstD3Directive.$inject = ["$log", "$window", "$timeout", "d3", "sidenav"];
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcSunburstD3Directive($log, $window, $timeout, d3, sidenav) {
	    'ngInject';
	    var padding = 8;
	    var resizeThreshold = 8;
	    var angleMargin = 0;
	    function link(scope, elem) {
	        var $scope = scope;
	        var rect = null;
	        var svg = null;
	        var containerId = !!scope.config && !!scope.config.id ? scope.config.id : 'sunburst-d3-container';
	        function calculateMaxDepth(data, depth) {
	            if (data.children && data.children.length) {
	                var depths_1 = [];
	                data.children.forEach(function (item) {
	                    depths_1.push(calculateMaxDepth(item, depth + 1));
	                });
	                return Math.max.apply(Math, __spread(depths_1));
	            }
	            else {
	                return depth;
	            }
	        }
	        function setup(elem, data, config) {
	            if (!rect)
	                return;
	            var width = rect.width;
	            var multiplier = config.mode === 'DNAKIT' || config.mode === 'DNAFILTER' ? 0.67 : 0.75;
	            var height = Math.min(rect.width * multiplier, $window.jQuery($window).height() - $window.jQuery('rc-toolbar').height());
	            var radius = Math.min(width, height) / 2;
	            var maxDepth = calculateMaxDepth(data, 0);
	            if (radius > maxDepth * 150) {
	                radius = Math.max(1, maxDepth) * 150;
	            }
	            var offset = config.fan && maxDepth > 0 ? radius / maxDepth : 0;
	            if (config.mode === 'DNAKIT' || config.mode === 'DNAFILTER') {
	                offset = height * 0.2;
	            }
	            var x = d3.scaleLinear()
	                .range([0, 2 * Math.PI]);
	            var y = d3.scaleLinear().range([0, radius]);
	            svg = d3.select(elem).append("svg")
	                .attr("width", width)
	                .attr("height", height)
	                .append("g")
	                .attr("id", containerId)
	                .attr("transform", "translate(" + (width / 2) + "," + (height / 2 + offset) + ")");
	            // attach to mouseleave on circle
	            svg.append("circle")
	                .attr("r", radius)
	                .style("opacity", 0);
	            if (config.mouseEvents) {
	                d3.select('#' + containerId).on("mouseleave", mouseleave);
	            }
	            var root = d3.hierarchy(data)
	                .sum(function (d) { return d.size; })
	                .sort(function (a, b) { return a.ix - b.ix; });
	            var partition = d3.partition();
	            var arc = d3.arc()
	                .startAngle(function (d) {
	                var eps = (d.dx === 1) ? 0 : angleMargin;
	                return Math.max(0, Math.min(2 * Math.PI, x(d.x) + eps));
	            })
	                .endAngle(function (d) {
	                var eps = (d.dx === 1) ? 0 : angleMargin;
	                return Math.max(0, Math.min(2 * Math.PI, x(d.x + d.dx) - eps));
	            })
	                .innerRadius(function (d) { return Math.max(0, y(d.y)); })
	                .outerRadius(function (d) { return Math.max(0, y(d.y + d.dy)); })
	                .cornerRadius(function () { return 4; });
	            var nodes = partition(root).descendants().map(function (x) { return x.data; });
	            svg.append('defs')
	                .selectAll("clipPath")
	                .data(nodes)
	                .enter()
	                .append('clipPath').filter(function (d) { return !d.empty; })
	                .attr('id', function (d, i) { return containerId + "-sunburst-d3-clip" + i; })
	                .append('path').attr('d', arc);
	            var group = svg.selectAll("g")
	                .data(nodes)
	                .enter()
	                .append('g').filter(function (d) { return !d.empty; })
	                .classed("sunburst-d3__group", true)
	                .attr('clip-path', function (d, i) { return 'url(#' + containerId + '-sunburst-d3-clip' + i + ')'; })
	                .attr('cursor', 'pointer')
	                .on("click", click);
	            if (config.mouseEvents) {
	                group = group.on("mouseover", mouseover);
	            }
	            group.append("path")
	                .attr("d", arc)
	                .attr("fill", function (d) { return d.fill || '#d2d2d2'; })
	                .attr("fill-opacity", function (d) { return !!config.highlight && config.highlight.includes(d.id) ? 1.0 : (d.fillOpacity || 1.0); })
	                .style("opacity", function (d) { return !!config.highlight && !config.highlight.includes(d.id) ? 0.8 : 1.0; })
	                .style("stroke-width", 2)
	                .style("stroke", function (d) { return !!config.highlight && config.highlight.includes(d.id) ? 'black' : 'white'; })
	                .classed('sunburst-d3__path', true);
	            if (config.leads) {
	                group.append('circle').filter(function (d) { return d.leads > 0; })
	                    .classed('sunburst-d3__lead', true)
	                    .attr('r', '6px')
	                    .attr('transform', function (d) {
	                    var angle = x(d.x + d.dx / 2) * 180 / Math.PI - 90;
	                    var rotate = angle + (angle > 90 ? 1 : -1);
	                    var yIndex = (angle >= 0 && angle <= 180) ? -1 : 1;
	                    //let xIndex = (angle < 0 || angle > 180) ? 1 : -1;
	                    var flag = x(d.x + d.dx / 2) > Math.PI ? 1 : -1;
	                    var translateX = y(d.y + d.dy / 2) + flag * y(d.dy / 2) - flag * (12 + (d.stars > 5 ? 5 : d.stars) * 7 + (d.stars > 0 ? d.stars > 5 ? 11 : 6 : 8));
	                    var translateY = 17 * (angle > 90 ? -1 : 1);
	                    if (!d.depth) {
	                        rotate = 0;
	                        translateX = d.stars ? (-10 + (d.stars > 5 ? 5 : d.stars) * 7 + (d.stars > 5 ? 5 : 0)) : -7;
	                    }
	                    else if (!d.noHorizontal && d.depth < 3) {
	                        translateX = y(d.y + d.dy / 2) - 17 * yIndex;
	                        translateY = yIndex * (-16 + (d.stars > 5 ? 5 : d.stars) * 7 + (d.stars > 0 ? d.stars > 5 ? 11 : 6 : 8));
	                    }
	                    return "rotate(" + rotate + ")translate(" + translateX + ',' + translateY + ")rotate(" + (angle > 90 ? -180 : 0) + ")";
	                });
	            }
	            if (config.text) {
	                var textEnter = group.append("text")
	                    .style("fill", function () { return "#000"; })
	                    .attr('font-size', '12px')
	                    .attr("text-anchor", "start")
	                    .attr("dy", "0px") // vertical align
	                    .attr("transform", function (d) {
	                    var angle = x(d.x + d.dx / 2) * 180 / Math.PI - 90;
	                    var rotate = angle + (angle > 90 ? 1 : -1);
	                    var translate = x(d.x + d.dx / 2) > Math.PI ? y(d.y + d.dy) - padding : y(d.y) + padding;
	                    var secondRotation = (angle > 90 ? -180 : 0);
	                    var secondTranslate = "";
	                    if (!d.depth) {
	                        rotate = 0;
	                        translate = -20;
	                    }
	                    else if (!d.noHorizontal && d.depth < 3) {
	                        translate = x(d.x + d.dx / 2) >= Math.PI ? (y(d.y + d.dy) - y(d.dy) / 2 + 28) : (y(d.y) + y(d.dy) / 2 - 28);
	                        var xIndex = (angle >= 0 && angle <= 180) ? 1 : -1;
	                        var yIndex = angle > 90 ? -1 : 1;
	                        var i = (secondRotation < 0 ? -1 : 1);
	                        var flag = -1;
	                        if ((angle >= 0 && angle < 90) || (angle > 180 && angle < 270)) {
	                            flag = 1;
	                        }
	                        secondRotation = xIndex * yIndex * i * -90;
	                        var xOffset = -20;
	                        var yOffset = flag * 28;
	                        // don't rotate 0
	                        if (angle === 0) {
	                            secondRotation = 90;
	                            xOffset = -40;
	                            yOffset = -28;
	                        }
	                        secondTranslate = "translate(" + xOffset + ", " + yOffset + ")";
	                    }
	                    return "rotate(" + rotate + ")translate(" + translate + ")rotate(" + secondRotation + ")" + secondTranslate;
	                });
	                textEnter.append("tspan")
	                    .attr("x", 0)
	                    .text(function (d) { return d.nameFirst; });
	                textEnter.append("tspan")
	                    .attr("x", 0)
	                    .attr("dy", "10px")
	                    .text(function (d) { return d.nameLast; });
	                textEnter.append("tspan")
	                    .attr("x", 0)
	                    .attr('font-size', '8px')
	                    .attr("dy", "10px")
	                    .attr("fill", "#fdc010")
	                    .attr("stroke", "#fdc010")
	                    .text(function (d) {
	                    var a = [];
	                    for (var i = 0; i < d.stars; i++) {
	                        a.push('\u2605');
	                    }
	                    return a.length > 0 ? a.length > 5 ? a.slice(0, 5).join('') + ' +' : a.join('') : ' ';
	                });
	                textEnter.append('tspan').filter(function (d) { return d.leads > 0; })
	                    .attr('fill', 'white')
	                    .attr('font-size', '8px')
	                    .attr('dx', '8px')
	                    .text(function (d) { return '' + d.leads; });
	            }
	        }
	        function click(d) {
	            $scope.$apply(function () {
	                $scope.$emit('click', { family: d, event: d3.event });
	            });
	        }
	        function mouseover(d) {
	            var sequenceArray = getAncestors(d);
	            // Fade all the segments.
	            d3.selectAll("#" + containerId + " .sunburst-d3__group")
	                .style("opacity", 0.3);
	            // Then highlight only those that are an ancestor of the current segment.
	            svg.selectAll("#" + containerId + " .sunburst-d3__group")
	                .filter(function (node) {
	                return (sequenceArray.indexOf(node) >= 0);
	            })
	                .style("opacity", 1);
	            // TODO don't emit if it hasn't changed
	            $scope.$apply(function () {
	                $scope.$emit('hover', sequenceArray);
	            });
	        }
	        function mouseleave() {
	            // Deactivate all segments during transition
	            d3.selectAll("#" + containerId + " .sunburst-d3__group").on("mouseover", null);
	            // Transition each segment to full opacity and then reactivate
	            d3.selectAll("#" + containerId + " .sunburst-d3__group")
	                .transition()
	                .duration(400)
	                .style("opacity", 1)
	                .on("end", function () {
	                d3.select(this).on("mouseover", mouseover);
	            });
	            $scope.$apply(function () {
	                $scope.$emit('hover', []);
	            });
	        }
	        function getAncestors(node) {
	            var path = [];
	            var current = node;
	            while (current) {
	                path.unshift(current);
	                current = current.parent;
	            }
	            return path;
	        }
	        function resize() {
	            var r = elem[0].getBoundingClientRect();
	            if (!rect || Math.abs(r.width - rect.width) >= resizeThreshold || Math.abs(r.height - rect.height) >= resizeThreshold) {
	                rect = r;
	                // delete svg
	                elem.empty();
	                // start over
	                setup(elem[0], scope.data, scope.config);
	            }
	        }
	        // TODO why is the delay necessary?
	        $timeout(resize, 1000);
	        angular.element($window).on('resize', resize);
	        elem.on('$destroy', function () {
	            angular.element($window).off('resize', resize);
	        });
	        scope.$watchGroup(['data', 'config'], function () {
	            elem.empty();
	            setup(elem[0], scope.data, scope.config);
	        });
	        scope.$watch(function () { return sidenav.isLockedOpen(); }, function () { $timeout(resize, 1000); });
	    }
	    return {
	        restrict: 'E',
	        link: link,
	        template: '<div></div>',
	        scope: {
	            data: '=',
	            config: '='
	        }
	    };
	}
	exports.default = rcSunburstD3Directive;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2018
	 */
	function rcTreeGraphicDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/treeGraphic/treeGraphic.html',
	        controller: TreeGraphicCtrl,
	        controllerAs: 'treeGraphic',
	        bindToController: true,
	        scope: {
	            graphic: '=',
	            expanded: '=',
	            hideTools: '=',
	        }
	    };
	}
	var TreeGraphicCtrl = /** @class */ (function () {
	    TreeGraphicCtrl.$inject = ["$log", "$scope", "social", "utils"];
	    function TreeGraphicCtrl($log, $scope, social, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.social = social;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.$onInit = function () {
	            _this.twitterUrl = social.getTwitterUrl({ text: _this.graphic.title, graphicId: _this.graphic.id });
	            $scope.$on('share', function (ev, params) {
	                _this.share(params.ev, params.platform);
	                ev.stopPropagation();
	            });
	        };
	    }
	    TreeGraphicCtrl.prototype.toggleExpand = function () {
	        this.$scope.$emit('toggleExpand', { id: this.graphic.id });
	    };
	    TreeGraphicCtrl.prototype.share = function (ev, platform) {
	        this.social.post(platform, {
	            title: this.graphic.title,
	            graphicId: this.graphic.id,
	            url: this.graphic.url,
	            description: '',
	        }, ev);
	    };
	    return TreeGraphicCtrl;
	}());
	exports.default = rcTreeGraphicDirective;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcToolbarDirective() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/toolbar/toolbar.html',
	        controller: ToolbarController,
	        controllerAs: 'toolbar',
	        bindToController: true,
	        scope: {
	            mode: '@'
	        }
	    };
	}
	var ToolbarController = /** @class */ (function () {
	    ToolbarController.$inject = ["$log", "$state", "$mdToast", "$scope", "$rootScope", "$timeout", "$document", "$mdMedia", "$window", "$q", "rx", "partnerId", "partnerSingleSignon", "sidenav", "authentication", "notifications", "currentUser", "currentTreeId", "rightsFull", "messageBus", "persons", "evidences", "leads", "medias", "notes", "sources", "stories", "researchLogs", "users", "server", "utils"];
	    function ToolbarController($log, $state, $mdToast, $scope, $rootScope, $timeout, $document, $mdMedia, $window, $q, rx, partnerId, partnerSingleSignon, sidenav, authentication, notifications, currentUser, currentTreeId, rightsFull, messageBus, persons, evidences, leads, medias, notes, sources, stories, researchLogs, users, server, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$state = $state;
	        this.$rootScope = $rootScope;
	        this.$mdMedia = $mdMedia;
	        this.$window = $window;
	        this.$q = $q;
	        this.rx = rx;
	        this.partnerId = partnerId;
	        this.partnerSingleSignon = partnerSingleSignon;
	        this.sidenav = sidenav;
	        this.currentTreeId = currentTreeId;
	        this.persons = persons;
	        this.evidences = evidences;
	        this.leads = leads;
	        this.medias = medias;
	        this.notes = notes;
	        this.sources = sources;
	        this.stories = stories;
	        this.researchLogs = researchLogs;
	        this.users = users;
	        this.server = server;
	        this.utils = utils;
	        this.authentication = authentication;
	        this.encodeId = utils.encodeId.bind(utils);
	        this.pendingRequests = 0;
	        this.user = null;
	        this.loading = false;
	        this.loadingTimeout = null;
	        this.notifications = new Map();
	        this.toastShowing = false;
	        this.searchType = 'person';
	        this.searchTypeText = {
	            'person': 'Search people in this tree',
	            'list': 'Search all items in this tree',
	            'group': 'Search people in all my trees'
	        };
	        var locked = false;
	        this.$onInit = function () {
	            var cuSub = currentUser.stream().subscribe(function (user) {
	                _this.$log.debug('toolbar.currentUser', user);
	                _this.user = user;
	            });
	            var mbSub = messageBus.stream().subscribe(function (msg) {
	                if (!msg) {
	                    return;
	                }
	                if (msg === 'NOT_LOGGED_IN') {
	                    _this.utils.alert('Not logged in', 'Log in to see this tree.').then(function () {
	                        messageBus.post(null);
	                        _this.signIn(null);
	                    });
	                }
	                else if (_this.toastShowing) {
	                    // ignore
	                }
	                else if (angular.element($document).find('md-backdrop').length === 0 || $document[0].getElementsByClassName('please_wait').length === 1) {
	                    $mdToast.show($mdToast.simple()
	                        .textContent(msg)
	                        .position('top right')
	                        .hideDelay(4000));
	                    _this.toastShowing = true;
	                    $timeout(function () {
	                        _this.toastShowing = false;
	                    }, 5000);
	                    messageBus.post(null);
	                }
	            });
	            var modeSub = utils.watch($scope, function () { return _this.mode; }).subscribe(function () {
	                console.log('toolbar.mode', _this.mode);
	                if (_this.mode === 'home-signed-in' && _this.searchType !== 'group') {
	                    _this.setSearchType('group');
	                }
	                else if (_this.mode == 'tree' && _this.searchtype === 'group') {
	                    _this.setSearchType('person');
	                }
	            });
	            var ntSub = null;
	            locked = false;
	            var rfSub = rightsFull.stream().subscribe(function (rights) {
	                _this.hideAdd = (rights.level < rightsFull.LEVEL_EDIT);
	                // alert if newly-locked or unlocked
	                if (rights.locked && !locked) {
	                    locked = true;
	                    var reason_1 = '';
	                    var solution_1 = '';
	                    var gigabyte = 1000 * 1000 * 1000;
	                    if (rights.ownerTotalMediaSize > 100 * gigabyte) {
	                        reason_1 = 'You have ' + parseFloat(Math.ceil(rights.ownerTotalMediaSize / gigabyte * 10) / 10).toFixed(1) +
	                            ' gigabytes of media in your trees, which is more than the maximum allowed 100 gigabytes of media storage.';
	                        solution_1 = 'remove some of the media from your trees, or contact support@rootsfinder.com to request additional storage.';
	                    }
	                    else if ((rights.ownerSubscriptionLevel === 'STANDARD' && rights.ownerTotalMediaSize > 10 * gigabyte) ||
	                        (rights.ownerSubscriptionLevel === '' && rights.ownerTotalMediaSize > 2 * gigabyte)) {
	                        reason_1 = 'You have ' + parseFloat(Math.ceil(rights.ownerTotalMediaSize / gigabyte * 10) / 10).toFixed(1) +
	                            ' gigabytes of media in your trees, which is more than the maximum allowed media storage for this plan';
	                        solution_1 = 'either remove some of the media from your trees';
	                        if (rights.treePrivacy === 'PRIVATE') {
	                            reason_1 += ', and your tree is private, which is available only on PRO plans';
	                            solution_1 += ' and make your tree public in Tree Settings';
	                        }
	                        reason_1 += '.';
	                        solution_1 += ', or upgrade to a PRO plan by clicking on your user name in the upper-right corner, then on Account.';
	                    }
	                    else if (rights.ownerSubscriptionLevel !== 'PRO' && rights.treePrivacy === 'PRIVATE') {
	                        reason_1 = 'Your tree is private, which is available only on PRO plans';
	                        solution_1 = 'you can either make your tree public in Tree Settings, or upgrade to a PRO plan by clicking on your user name in the upper-right corner, then on Account.';
	                    }
	                    $timeout(function () {
	                        _this.utils.alert('This tree is Locked', 'We\'re sorry - your tree has been locked. ' + reason_1 + ' To unlock your tree, ' + solution_1);
	                    }, 5000);
	                }
	                else if (!rights.locked && locked) {
	                    locked = false;
	                    $timeout(function () {
	                        _this.utils.alert('Tree has been unlocked', 'Congratulations! Your tree is now unlocked and ready to use.');
	                    }, 2500);
	                }
	                // subscribe to notifications
	                if (ntSub != null) {
	                    ntSub.unsubscribe();
	                }
	                ntSub = null;
	                _this.notifications.clear();
	                if (rights.level >= rightsFull.LEVEL_READ) {
	                    ntSub = notifications.stream().subscribe(function (notifications) {
	                        _this.notifications = notifications;
	                    });
	                }
	            });
	            var svrSub = server.stream().subscribe(function (numPending) {
	                _this.pendingRequests = numPending;
	                // don't bother showing loading indicator if the response is really quick
	                if (_this.loadingTimeout === null) {
	                    _this.loadingTimeout = $timeout(function () {
	                        _this.loading = (_this.pendingRequests > 0);
	                        _this.loadingTimeout = null;
	                    }, 200);
	                }
	            });
	            $scope.$on('$destroy', function () {
	                modeSub.unsubscribe();
	                cuSub.unsubscribe();
	                mbSub.unsubscribe();
	                rfSub.unsubscribe();
	                if (ntSub != null) {
	                    ntSub.unsubscribe();
	                }
	                svrSub.unsubscribe();
	            });
	        };
	    }
	    ToolbarController.prototype.getMenuTooltip = function () {
	        return (this.sidenav.isSidenavLockedOpen() ? 'Hide' : 'Show') + ' menu';
	    };
	    ToolbarController.prototype.showSidenav = function () {
	        return this.mode === 'tree' && this.utils.showSidenav(this.$state);
	    };
	    ToolbarController.prototype.toggleSidenav = function () {
	        this.sidenav.toggle();
	    };
	    ToolbarController.prototype.isSidenavLockedOpen = function () {
	        return this.sidenav.isSidenavLockedOpen();
	    };
	    ToolbarController.prototype.numUnreadNotifications = function (notifications) {
	        return Array.from(notifications.values()).filter(function (n) { return !n.read; }).length;
	    };
	    ToolbarController.prototype.showNotification = function (ev, notification) {
	        this.utils.dialog(ev, 'NotificationController', 'app/components/notification/notification.html', true, {
	            notification: notification
	        });
	    };
	    ToolbarController.prototype.getAvatarURL = function (user) {
	        return this.users.getAvatarURL(user);
	    };
	    ToolbarController.prototype.query = function (query) {
	        var _this = this;
	        var terms = !query ? [] : query.toLowerCase().split(' ');
	        if (terms.length === 0) {
	            return this.rx.Observable.of([]).toPromise();
	        }
	        if (this.searchType === 'person') {
	            return this.persons.ready().toPromise().then(function () {
	                return _this.persons.nameAutocomplete(query);
	            });
	        }
	        else if (this.searchType === 'list') {
	            var items = [].concat(this.getItemArray(this.personMap, 'person', terms), this.getItemArray(this.evidenceMap, 'evidence', terms), this.getItemArray(this.leadMap, 'lead', terms), this.getItemArray(this.mediaMap, 'media', terms), this.getItemArray(this.noteMap, 'note', terms), this.getItemArray(this.sourceMap, 'source', terms), this.getItemArray(this.storyMap, 'story', terms), this.getItemArray(this.researchLogMap, 'researchLog', terms));
	            var deferred = this.$q.defer();
	            deferred.resolve(items);
	            return deferred.promise;
	        }
	        else {
	            return this.server.get('/users/' + this.user.id + '/persons', { prefix: query }).map(function (response) {
	                var currentTreeId = _this.currentTreeId.get();
	                return response.map(function (p) {
	                    var birthYear = _this.utils.getYear(p.birthDate, true);
	                    var deathYear = _this.utils.getYear(p.deathDate, true);
	                    return Object.assign(p, {
	                        '_fullName': _this.persons.getNameText(p.nameParts, true) || 'Unknown',
	                        '_lifespan': !!birthYear || !!deathYear ? birthYear + ' - ' + deathYear : '',
	                        '_iconURL': p.treeId === currentTreeId && p.profilePhoto > 0 ? _this.medias.getFileURL(p.profilePhoto, 0, '100x100') : ''
	                    });
	                });
	            }).toPromise();
	        }
	    };
	    ToolbarController.prototype.setSearchType = function (v) {
	        var _this = this;
	        this.searchType = v;
	        this.personMap = new Map();
	        this.evidenceMap = new Map();
	        this.leadMap = new Map();
	        this.mediaMap = new Map();
	        this.noteMap = new Map();
	        this.sourceMap = new Map();
	        this.storyMap = new Map();
	        this.researchLogMap = new Map();
	        if (v === 'list') {
	            var pw_1 = this.utils.pleaseWait();
	            this.utils.readyChange(this.persons, this.evidences, this.leads, this.medias, this.notes, this.sources, this.stories, this.researchLogs)
	                .take(1)
	                .subscribe(function (_a) {
	                var _b = __read(_a, 8), personMap = _b[0], evidenceMap = _b[1], leadMap = _b[2], mediaMap = _b[3], noteMap = _b[4], sourceMap = _b[5], storyMap = _b[6], researchLogMap = _b[7];
	                try {
	                    for (var _c = __values(personMap.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                        var obj = _d.value;
	                        _this.persons.augmentPerson(obj, _this.leads, _this.evidences, _this.users).subscribe(function (obj) {
	                            _this.personMap.set(obj.id, obj);
	                        });
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                try {
	                    for (var _f = __values(evidenceMap.values()), _g = _f.next(); !_g.done; _g = _f.next()) {
	                        var obj = _g.value;
	                        _this.evidences.augmentEvidence(obj, _this.sources, _this.persons, _this.users).subscribe(function (obj) {
	                            _this.evidenceMap.set(obj.id, obj);
	                        });
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_g && !_g.done && (_h = _f.return)) _h.call(_f);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	                try {
	                    for (var _j = __values(leadMap.values()), _k = _j.next(); !_k.done; _k = _j.next()) {
	                        var obj = _k.value;
	                        _this.leads.augmentLead(obj, _this.persons, _this.users).subscribe(function (obj) {
	                            _this.leadMap.set(obj.id, obj);
	                        });
	                    }
	                }
	                catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                finally {
	                    try {
	                        if (_k && !_k.done && (_l = _j.return)) _l.call(_j);
	                    }
	                    finally { if (e_3) throw e_3.error; }
	                }
	                try {
	                    for (var _m = __values(mediaMap.values()), _o = _m.next(); !_o.done; _o = _m.next()) {
	                        var obj = _o.value;
	                        _this.medias.augmentMedia(obj, _this.persons, _this.evidences, _this.sources, _this.stories, _this.users).subscribe(function (obj) {
	                            _this.mediaMap.set(obj.id, obj);
	                        });
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (_o && !_o.done && (_p = _m.return)) _p.call(_m);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	                try {
	                    for (var _q = __values(noteMap.values()), _r = _q.next(); !_r.done; _r = _q.next()) {
	                        var obj = _r.value;
	                        _this.notes.augmentNote(obj, _this.persons, _this.users).subscribe(function (obj) {
	                            _this.noteMap.set(obj.id, obj);
	                        });
	                    }
	                }
	                catch (e_5_1) { e_5 = { error: e_5_1 }; }
	                finally {
	                    try {
	                        if (_r && !_r.done && (_s = _q.return)) _s.call(_q);
	                    }
	                    finally { if (e_5) throw e_5.error; }
	                }
	                try {
	                    for (var _t = __values(sourceMap.values()), _u = _t.next(); !_u.done; _u = _t.next()) {
	                        var obj = _u.value;
	                        _this.sources.augmentSource(obj, _this.users).subscribe(function (obj) {
	                            _this.sourceMap.set(obj.id, obj);
	                        });
	                    }
	                }
	                catch (e_6_1) { e_6 = { error: e_6_1 }; }
	                finally {
	                    try {
	                        if (_u && !_u.done && (_v = _t.return)) _v.call(_t);
	                    }
	                    finally { if (e_6) throw e_6.error; }
	                }
	                try {
	                    for (var _w = __values(storyMap.values()), _x = _w.next(); !_x.done; _x = _w.next()) {
	                        var obj = _x.value;
	                        _this.stories.augmentStory(obj, _this.persons, _this.users).subscribe(function (obj) {
	                            _this.storyMap.set(obj.id, obj);
	                        });
	                    }
	                }
	                catch (e_7_1) { e_7 = { error: e_7_1 }; }
	                finally {
	                    try {
	                        if (_x && !_x.done && (_y = _w.return)) _y.call(_w);
	                    }
	                    finally { if (e_7) throw e_7.error; }
	                }
	                try {
	                    for (var _z = __values(researchLogMap.values()), _0 = _z.next(); !_0.done; _0 = _z.next()) {
	                        var obj = _0.value;
	                        _this.researchLogs.augmentResearchLog(obj, _this.persons, _this.users).subscribe(function (obj) {
	                            _this.researchLogMap.set(obj.id, obj);
	                        });
	                    }
	                }
	                catch (e_8_1) { e_8 = { error: e_8_1 }; }
	                finally {
	                    try {
	                        if (_0 && !_0.done && (_1 = _z.return)) _1.call(_z);
	                    }
	                    finally { if (e_8) throw e_8.error; }
	                }
	                _this.utils.pleaseWaitCancel(pw_1);
	                var e_1, _e, e_2, _h, e_3, _l, e_4, _p, e_5, _s, e_6, _v, e_7, _y, e_8, _1;
	            });
	        }
	    };
	    ToolbarController.prototype.search = function () {
	        if (!!this.searchItem) {
	            if (this.searchType === 'person') {
	                this.$state.go('tree.person', { personId: this.utils.encodeId(this.searchItem.id) });
	            }
	            else if (this.searchType === 'list') {
	                switch (this.searchItem.type) {
	                    case 'person':
	                        this.$state.go('tree.person', { personId: this.utils.encodeId(this.searchItem.id) });
	                        break;
	                    case 'evidence':
	                        this.$state.go('tree.evidences', { evidenceId: this.utils.encodeId(this.searchItem.id) });
	                        break;
	                    case 'lead':
	                        this.$state.go('tree.leads', { leadId: this.utils.encodeId(this.searchItem.id) });
	                        break;
	                    case 'media':
	                        this.$state.go('tree.media', { mediaId: this.utils.encodeId(this.searchItem.id) });
	                        break;
	                    case 'note':
	                        this.$state.go('tree.notes', { noteId: this.utils.encodeId(this.searchItem.id) });
	                        break;
	                    case 'source':
	                        this.$state.go('tree.sources', { sourceId: this.utils.encodeId(this.searchItem.id) });
	                        break;
	                    case 'story':
	                        this.$state.go('tree.stories', { storyId: this.utils.encodeId(this.searchItem.id) });
	                        break;
	                    case 'researchLog':
	                        this.$state.go('tree.research-log', { id: this.utils.encodeId(this.searchItem.id) });
	                        break;
	                }
	            }
	            else {
	                var currentTreeId = this.currentTreeId.get();
	                if (currentTreeId <= 0 || this.searchItem.treeId === currentTreeId) {
	                    this.$state.go('tree.person', { treeId: this.searchItem.treeId, personId: this.utils.encodeId(this.searchItem.id) });
	                }
	                else {
	                    var url = this.$state.href('tree.person', { treeId: this.searchItem.treeId, personId: this.utils.encodeId(this.searchItem.id) });
	                    this.$window.open(url, '_blank');
	                }
	            }
	        }
	        this.searchText = '';
	        this.searchItem = null;
	    };
	    ToolbarController.prototype.getItemArray = function (itemMap, itemType, terms) {
	        var items = [];
	        try {
	            for (var _a = __values(itemMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var item = _b.value;
	                if (this.hasTerms(item, itemType, terms)) {
	                    var it = null;
	                    switch (itemType) {
	                        case 'person':
	                            it = { type: itemType, id: item.id, icon: 'person', title: item._fullName, subtitle: item._lifespan };
	                            break;
	                        case 'evidence':
	                            it = { type: itemType, id: item.id, icon: 'event', title: item._type + ' ' + item._date + ' ' + item._place, subtitle: item._sourceTitle };
	                            break;
	                        case 'lead':
	                            it = { type: itemType, id: item.id, icon: 'star_border', title: item.title, subtitle: item._type + ' ' + item.status };
	                            break;
	                        case 'media':
	                            it = { type: itemType, id: item.id, icon: 'photo', title: item.title, subtitle: item.date + ' ' + item.place };
	                            break;
	                        case 'note':
	                            it = { type: itemType, id: item.id, icon: 'chat', title: item.title, subtitle: '' };
	                            break;
	                        case 'source':
	                            it = { type: itemType, id: item.id, icon: 'star', title: item.abbr, subtitle: item.creator + ' ' + item.title };
	                            break;
	                        case 'story':
	                            it = { type: itemType, id: item.id, icon: 'import_contacts', title: item.title, subtitle: '' };
	                            break;
	                        case 'researchLog':
	                            it = { type: itemType, id: item.id, icon: 'view_week', title: item.title, subtitle: '' };
	                            break;
	                    }
	                    if (!!it) {
	                        items.push(it);
	                    }
	                }
	            }
	        }
	        catch (e_9_1) { e_9 = { error: e_9_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_9) throw e_9.error; }
	        }
	        return items;
	        var e_9, _c;
	    };
	    ToolbarController.prototype.hasTerms = function (item, itemType, terms) {
	        try {
	            for (var terms_1 = __values(terms), terms_1_1 = terms_1.next(); !terms_1_1.done; terms_1_1 = terms_1.next()) {
	                var term = terms_1_1.value;
	                if (!!term) {
	                    var found = void 0;
	                    switch (itemType) {
	                        case 'person':
	                            found = this.persons.hasWord(item, term);
	                            break;
	                        case 'evidence':
	                            found = this.evidences.hasWord(item, term);
	                            break;
	                        case 'lead':
	                            found = this.leads.hasWord(item, term);
	                            break;
	                        case 'media':
	                            found = this.medias.hasWord(item, term);
	                            break;
	                        case 'note':
	                            found = this.notes.hasWord(item, term);
	                            break;
	                        case 'source':
	                            found = this.sources.hasWord(item, term);
	                            break;
	                        case 'story':
	                            found = this.stories.hasWord(item, term);
	                            break;
	                        case 'researchLog':
	                            found = this.researchLogs.hasWord(item, term);
	                            break;
	                        default:
	                            found = false;
	                    }
	                    if (!found) {
	                        return false;
	                    }
	                }
	            }
	        }
	        catch (e_10_1) { e_10 = { error: e_10_1 }; }
	        finally {
	            try {
	                if (terms_1_1 && !terms_1_1.done && (_a = terms_1.return)) _a.call(terms_1);
	            }
	            finally { if (e_10) throw e_10.error; }
	        }
	        return true;
	        var e_10, _a;
	    };
	    ToolbarController.prototype.openMenu = function ($mdMenu, ev) {
	        this.menuEvent = ev;
	        $mdMenu.open(ev);
	    };
	    ToolbarController.prototype.addPerson = function () {
	        this.utils.dialog(this.menuEvent, 'AddPersonController', 'app/components/addPerson/addPerson.html', false);
	    };
	    ToolbarController.prototype.addMedia = function () {
	        this.utils.dialog(this.menuEvent, 'EditMediaController', 'app/components/editMedia/editMedia.html', false, {
	            personId: this.$rootScope.personId
	        });
	    };
	    ToolbarController.prototype.addEvidence = function () {
	        this.utils.dialog(this.menuEvent, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	            personId: this.$rootScope.personId
	        });
	    };
	    ToolbarController.prototype.addStory = function () {
	        this.utils.dialog(this.menuEvent, 'EditStoryController', 'app/components/editStory/editStory.html', false, {
	            personId: this.$rootScope.personId
	        });
	    };
	    ToolbarController.prototype.addLead = function () {
	        this.utils.dialog(this.menuEvent, 'EditLeadController', 'app/components/editLead/editLead.html', false, {
	            personId: this.$rootScope.personId
	        });
	    };
	    ToolbarController.prototype.addNote = function () {
	        this.utils.dialog(this.menuEvent, 'EditNoteController', 'app/components/editNote/editNote.html', false, {
	            personId: this.$rootScope.personId
	        });
	    };
	    ToolbarController.prototype.showMessages = function (ev) {
	        this.$state.go('tree.messages', ev);
	    };
	    ToolbarController.prototype.account = function () {
	        this.$state.go('userSettings');
	    };
	    ToolbarController.prototype.signIn = function (ev) {
	        if (!!this.partnerId && this.partnerSingleSignon) {
	            // PARTNER redirect the user to your login page, then redirect them back to RootsFinder
	        }
	        else {
	            this.utils.dialog(ev, 'SignInController', 'app/components/signIn/signIn.html');
	        }
	    };
	    ToolbarController.prototype.signOut = function () {
	        var _this = this;
	        this.authentication.logout().subscribe(function () {
	            _this.$state.go('home');
	        }, function (err) {
	            console.log('signOut', err);
	            _this.$state.go('home'); // go home even in case of error
	        });
	    };
	    ToolbarController.prototype.home = function (ev) {
	        if (!ev.ctrlKey) {
	            this.$window.location.href = this.$state.href('homeSignedIn', {}, { absolute: true });
	        }
	    };
	    return ToolbarController;
	}());
	exports.default = rcToolbarDirective;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	// allows transclusion inside ng-repeat; doesn't work inside md-virtual-repeat
	// not currently used
	function rcTranscludeDirective() {
	    return {
	        link: {
	            pre: function (scope, element, attr, ctrl, transclude) {
	                if (transclude) {
	                    transclude(scope, function (clone) {
	                        element.append(clone);
	                    });
	                }
	            }
	        }
	    };
	}
	exports.default = rcTranscludeDirective;


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcTreeDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/tree/tree.html',
	        controller: TreeController,
	        controllerAs: 'tree',
	        bindToController: true,
	        scope: {
	            tree: '=',
	            stats: '='
	        }
	    };
	}
	var TreeController = /** @class */ (function () {
	    TreeController.$inject = ["$log"];
	    function TreeController($log) {
	        'ngInject';
	        this.$log = $log;
	    }
	    return TreeController;
	}());
	exports.default = rcTreeDirective;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcUserDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/user/user.html',
	        controller: UserController,
	        controllerAs: 'user',
	        bindToController: true,
	        scope: {
	            user: '=',
	            showEmail: '@'
	        }
	    };
	}
	var UserController = /** @class */ (function () {
	    UserController.$inject = ["$log", "users"];
	    function UserController($log, users) {
	        'ngInject';
	        this.$log = $log;
	        this.users = users;
	    }
	    UserController.prototype.getAvatarURL = function (user) {
	        return this.users.getAvatarURL(user);
	    };
	    return UserController;
	}());
	exports.default = rcUserDirective;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

	"use strict";
	rcUsernameDirective.$inject = ["$q", "messageBus", "server"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcUsernameDirective($q, messageBus, server) {
	    'ngInject';
	    function link(scope, elem, attrs, ctrl) {
	        ctrl.$asyncValidators.username = function (modelValue, viewValue) {
	            var value = modelValue || viewValue;
	            if (ctrl.$isEmpty(value)) {
	                // consider empty model valid
	                return $q.when(true);
	            }
	            var def = $q.defer();
	            if (attrs.rcUsername === value) {
	                def.resolve();
	            }
	            else {
	                server.get('/userexists', { name: value }).subscribe(function (response) {
	                    if (response.exists) {
	                        def.reject();
	                    }
	                    else {
	                        def.resolve();
	                    }
	                }, function (err) {
	                    messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'userexists' });
	                });
	            }
	            return def.promise;
	        };
	    }
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: link
	    };
	}
	exports.default = rcUsernameDirective;


/***/ }),
/* 165 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcUserActivityDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/userActivity/userActivity.html',
	        controller: UserActivityController,
	        controllerAs: 'userActivity',
	        bindToController: true,
	        scope: {
	            userActivity: '='
	        }
	    };
	}
	var UserActivityController = /** @class */ (function () {
	    UserActivityController.$inject = ["$log", "$scope", "utils"];
	    function UserActivityController($log, $scope, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.$scope = $scope;
	        this.utils = utils;
	    }
	    UserActivityController.prototype.showUser = function (ev) {
	        this.utils.alert('User information', 'Coming later', ev);
	    };
	    return UserActivityController;
	}());
	exports.default = rcUserActivityDirective;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rcWarningDirective() {
	    'ngInject';
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/warning/warning.html',
	        controller: WarningController,
	        controllerAs: 'warning',
	        bindToController: true,
	        scope: {
	            warning: '=',
	            expanded: '='
	        }
	    };
	}
	var WarningController = /** @class */ (function () {
	    WarningController.$inject = ["$log", "$scope", "rightsFull", "utils"];
	    function WarningController($log, $scope, rightsFull, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$scope = $scope;
	        this.utils = utils;
	        this.encodeId = utils.encodeId.bind(utils);
	        rightsFull.streamLevel().take(1).subscribe(function (level) {
	            _this.hideAdd = (level < rightsFull.LEVEL_EDIT);
	        });
	    }
	    WarningController.prototype.toggleExpand = function () {
	        this.$scope.$emit('toggleExpand', { id: this.warning.id });
	    };
	    WarningController.prototype.archive = function (ev) {
	        this.$scope.$emit('archive', { ev: ev, type: 'warning', item: this.warning });
	    };
	    WarningController.prototype.del = function (ev) {
	        this.$scope.$emit('delete', { ev: ev, type: 'warning', item: this.warning, id: this.warning.id });
	    };
	    return WarningController;
	}());
	exports.default = rcWarningDirective;


/***/ }),
/* 167 */
/***/ (function(module, exports) {

	"use strict";
	csv.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function csv($window) {
	    'ngInject';
	    return $window.CSV;
	}
	exports.default = csv;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

	"use strict";
	d3.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	/* eslint-disable */
	function d3($window) {
	    'ngInject';
	    //
	    // sankey
	    //
	    // https://github.com/d3/d3-sankey Version 0.7.1. Copyright 2018 Mike Bostock.
	    (function (global, factory) {
	        //typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('d3-array'), require('d3-collection'), require('d3-shape')) :
	        //  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-shape'], factory) :
	        (factory((global.d3 = global.d3 || {}), global.d3, global.d3, global.d3));
	    }($window, (function (exports, d3Array, d3Collection, d3Shape) {
	        'use strict';
	        function targetDepth(d) {
	            return d.target.depth;
	        }
	        function left(node) {
	            return node.depth;
	        }
	        function right(node, n) {
	            return n - 1 - node.height;
	        }
	        function justify(node, n) {
	            return node.sourceLinks.length ? node.depth : n - 1;
	        }
	        function center(node) {
	            return node.targetLinks.length ? node.depth
	                : node.sourceLinks.length ? d3Array.min(node.sourceLinks, targetDepth) - 1
	                    : 0;
	        }
	        function constant(x) {
	            return function () {
	                return x;
	            };
	        }
	        function ascendingSourceBreadth(a, b) {
	            return ascendingBreadth(a.source, b.source) || a.index - b.index;
	        }
	        function ascendingTargetBreadth(a, b) {
	            return ascendingBreadth(a.target, b.target) || a.index - b.index;
	        }
	        function ascendingBreadth(a, b) {
	            return a.y0 - b.y0;
	        }
	        function value(d) {
	            return d.value;
	        }
	        function nodeCenter(node) {
	            return (node.y0 + node.y1) / 2;
	        }
	        function weightedSource(link) {
	            return nodeCenter(link.source) * link.value;
	        }
	        function defaultId(d) {
	            return d.index;
	        }
	        function defaultNodes(graph) {
	            return graph.nodes;
	        }
	        function defaultLinks(graph) {
	            return graph.links;
	        }
	        function find(nodeById, id) {
	            var node = nodeById.get(id);
	            if (!node)
	                throw new Error("missing: " + id);
	            return node;
	        }
	        var sankey = function () {
	            var x0 = 0, y0 = 0, x1 = 1, y1 = 1, // extent
	            dx = 24, // nodeWidth
	            py = 8, // nodePadding
	            //firstLevelNodePadding = 0,
	            id = defaultId, align = justify, nodes = defaultNodes, links = defaultLinks, iterations = 32;
	            function sankey() {
	                var graph = { nodes: nodes.apply(null, arguments), links: links.apply(null, arguments) };
	                setGeneratedIds(graph); //added
	                computeNodeLinks(graph);
	                computeNodeValues(graph);
	                computeNodeDepths(graph);
	                computeNodeBreadths(graph, iterations);
	                //setOrderedPositions(graph);  //added
	                computeLinkBreadths(graph);
	                recomputeLinkPosAndArrangeNodes(graph); // added
	                return graph;
	            }
	            function setGeneratedIds(graph) {
	                graph.nodes.forEach(function (d, i) {
	                    d.generatedID = 'ID' + i;
	                });
	            }
	            //Apply custom recomputations and reorder nodes
	            function recomputeLinkPosAndArrangeNodes(graph) {
	                var chromosomes = {};
	                // Structurise nodes per chromosome and per level
	                graph.nodes.forEach(function (node) {
	                    if (!chromosomes[node.chr]) {
	                        chromosomes[node.chr] = {};
	                    }
	                    if (!chromosomes[node.chr][node.level]) {
	                        chromosomes[node.chr][node.level] = [];
	                    }
	                    chromosomes[node.chr][node.level].push(node);
	                });
	                // Order nodes based on startAbs property
	                Object.keys(chromosomes).forEach(function (index) {
	                    var chromosome = chromosomes[index];
	                    var levels = Object.keys(chromosome);
	                    levels.forEach(function (level) {
	                        if (+level === 1) {
	                            return;
	                        }
	                        var levelNodes = chromosome[level];
	                        var startChromoY = chromosome[1][0].y0;
	                        var endChromoY = chromosome[1][0].y1;
	                        var multiplier = (endChromoY - startChromoY) / chromosome[1][0].value;
	                        levelNodes.forEach(function (d) {
	                            d.y0 = startChromoY + d.start * multiplier;
	                            d.y1 = d.y0 + d.value * multiplier;
	                        });
	                        //var startNodeY = $window.d3.min(levelNodes, d => d.y0);
	                        //levelNodes.$orderBy(d => d.startAbs);
	                        //
	                        ////Replace positions
	                        //levelNodes.forEach(d => {
	                        //  var height = d.y1 - d.y0;
	                        //  var change = startNodeY - d.y0;
	                        //  d.y0 = startNodeY;
	                        //  d.y1 = startNodeY + height;
	                        //  startNodeY += (py + height);
	                        //});
	                    });
	                });
	                // Re set link positions
	                graph.links.forEach(function (l) {
	                    l.y0 = (l.source.y1 - l.source.y0) / l.source.value * l.sourcePos + l.source.y0 + Math.max(1, l.width) / 2; // TODO why?
	                    l.y1 = (l.target.y1 - l.target.y0) / l.target.value * l.targetPos + l.target.y0 + Math.max(1, l.width) / 2;
	                });
	                ////Update first level node paddings
	                //var nodes = graph.nodes
	                //  .filter(d => d.level === 1);
	                //var diff = 0;
	                //nodes.forEach((d, i) => {
	                //  var posIncrease = i * (firstLevelNodePadding);
	                //  var diff = 10;
	                //  if (d.sourceLinks) {
	                //    var link = d.sourceLinks.filter(s => s.target.level == 2)[0];
	                //    if (link && link.target) {
	                //      diff += (link.target.y0 - d.y0) - firstLevelNodePadding / 2;
	                //    }
	                //  }
	                //  if (i < 3) {
	                //    diff = 0;
	                //  }
	                //  d.sourceLinks.map(s => s.target)
	                //    .forEach(t => {
	                //      updatePosition(t, posIncrease - diff)
	                //    })
	                //  // Update child positions as well
	                //  d.positionUpdated = true;
	                //  d.y0 += posIncrease;
	                //  d.y1 += posIncrease;
	                //  d.sourceLinks.forEach(s => {
	                //    s.y0 += posIncrease;
	                //  });
	                //});
	                //
	                ////Recursive function which updates child node positions
	                //function updatePosition(d, posIncrease) {
	                //  if (d.positionUpdated) return;
	                //  d.positionUpdated = true;
	                //  d.y0 += posIncrease;
	                //  d.y1 += posIncrease;
	                //  d.sourceLinks.forEach(s => {
	                //    s.y0 += posIncrease;
	                //  });
	                //  d.targetLinks.forEach(s => {
	                //    s.y1 += posIncrease;
	                //  });
	                //  d.sourceLinks.map(s => s.target)
	                //    .forEach(t => {
	                //      updatePosition(t, posIncrease - diff)
	                //    });
	                //}
	            }
	            // not needed if we not relax from right to left
	            sankey.update = function (graph) {
	                computeLinkBreadths(graph);
	                return graph;
	            };
	            sankey.nodeId = function (_) {
	                return arguments.length ? (id = typeof _ === "function" ? _ : constant(_), sankey) : id;
	            };
	            sankey.nodeAlign = function (_) {
	                return arguments.length ? (align = typeof _ === "function" ? _ : constant(_), sankey) : align;
	            };
	            sankey.nodeWidth = function (_) {
	                return arguments.length ? (dx = +_, sankey) : dx;
	            };
	            sankey.nodePadding = function (_) {
	                return arguments.length ? (py = +_, sankey) : py;
	            };
	            //sankey.firstLevelNodePadding = function (_) {
	            //  return arguments.length ? (firstLevelNodePadding = +_, sankey) : firstLevelNodePadding;
	            //};
	            sankey.nodes = function (_) {
	                return arguments.length ? (nodes = typeof _ === "function" ? _ : constant(_), sankey) : nodes;
	            };
	            sankey.links = function (_) {
	                return arguments.length ? (links = typeof _ === "function" ? _ : constant(_), sankey) : links;
	            };
	            sankey.size = function (_) {
	                return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankey) : [x1 - x0, y1 - y0];
	            };
	            sankey.extent = function (_) {
	                return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankey) : [[x0, y0], [x1, y1]];
	            };
	            sankey.iterations = function (_) {
	                return arguments.length ? (iterations = +_, sankey) : iterations;
	            };
	            // Populate the sourceLinks and targetLinks for each node.
	            // Also, if the source and target are not objects, assume they are indices.
	            function computeNodeLinks(graph) {
	                graph.nodes.forEach(function (node, i) {
	                    node.index = i;
	                    node.sourceLinks = [];
	                    node.targetLinks = [];
	                });
	                var nodeById = d3Collection.map(graph.nodes, id);
	                graph.links.forEach(function (link, i) {
	                    link.index = i;
	                    var source = link.source, target = link.target;
	                    if (typeof source !== "object")
	                        source = link.source = find(nodeById, source);
	                    if (typeof target !== "object")
	                        target = link.target = find(nodeById, target);
	                    source.sourceLinks.push(link);
	                    target.targetLinks.push(link);
	                });
	            }
	            // Compute the value (size) of each node by summing the associated links.
	            function computeNodeValues(graph) {
	                graph.nodes.forEach(function (node) {
	                    node.value = Math.max(d3Array.sum(node.sourceLinks, value), d3Array.sum(node.targetLinks, value), typeof node.value !== 'undefined' ? node.value : 0);
	                });
	            }
	            // Iteratively assign the depth (x-position) for each node.
	            // Nodes are assigned the maximum depth of incoming neighbors plus one;
	            // nodes with no incoming links are assigned depth zero, while
	            // nodes with no outgoing links are assigned the maximum depth.
	            function computeNodeDepths(graph) {
	                var nodes, next, x;
	                for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
	                    nodes.forEach(function (node) {
	                        node.depth = x;
	                        node.sourceLinks.forEach(function (link) {
	                            if (next.indexOf(link.target) < 0) {
	                                next.push(link.target);
	                            }
	                        });
	                    });
	                }
	                for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
	                    nodes.forEach(function (node) {
	                        node.height = x;
	                        node.targetLinks.forEach(function (link) {
	                            if (next.indexOf(link.source) < 0) {
	                                next.push(link.source);
	                            }
	                        });
	                    });
	                }
	                var kx = (x1 - x0 - dx) / Math.max(1, x - 1);
	                graph.nodes.forEach(function (node) {
	                    node.x1 = (node.x0 = x0 + Math.max(0, Math.min(x - 1, Math.floor(align.call(null, node, x)))) * kx) + dx;
	                });
	            }
	            function computeNodeBreadths(graph) {
	                var columns = d3Collection.nest()
	                    .key(function (d) { return d.x0; })
	                    .sortKeys(d3Array.ascending)
	                    .entries(graph.nodes)
	                    .map(function (d) { return d.values; });
	                //
	                initializeNodeBreadth();
	                resolveCollisions();
	                for (var alpha = 1, n = iterations; n > 0; --n) {
	                    //relaxRightToLeft(alpha *= 0.99);
	                    resolveCollisions();
	                    relaxLeftToRight(alpha);
	                    resolveCollisions();
	                }
	                function initializeNodeBreadth() {
	                    var ky = d3Array.min(columns, function (nodes) {
	                        return (y1 - y0 - (nodes.length - 1) * py) / d3Array.sum(nodes, value);
	                    });
	                    columns.forEach(function (nodes) {
	                        nodes.forEach(function (node, i) {
	                            node.y1 = (node.y0 = i) + node.value * ky;
	                        });
	                    });
	                    graph.links.forEach(function (link) {
	                        link.width = link.value * ky;
	                    });
	                }
	                function relaxLeftToRight(alpha) {
	                    columns.forEach(function (nodes) {
	                        nodes.forEach(function (node) {
	                            if (node.targetLinks.length) {
	                                var dy = (d3Array.sum(node.targetLinks, weightedSource) / d3Array.sum(node.targetLinks, value) - nodeCenter(node)) * alpha;
	                                node.y0 += dy, node.y1 += dy;
	                            }
	                        });
	                    });
	                }
	                function resolveCollisions() {
	                    columns.forEach(function (nodes) {
	                        var node, dy, y = y0, n = nodes.length, i;
	                        // Push any overlapping nodes down.
	                        nodes.sort(ascendingBreadth);
	                        for (i = 0; i < n; ++i) {
	                            node = nodes[i];
	                            dy = y - node.y0;
	                            if (dy > 0)
	                                node.y0 += dy, node.y1 += dy;
	                            y = node.y1 + py;
	                        }
	                        // If the bottommost node goes outside the bounds, push it back up.
	                        dy = y - py - y1;
	                        if (dy > 0) {
	                            y = (node.y0 -= dy), node.y1 -= dy;
	                            // Push any overlapping nodes back up.
	                            for (i = n - 2; i >= 0; --i) {
	                                node = nodes[i];
	                                dy = node.y1 + py - y;
	                                if (dy > 0)
	                                    node.y0 -= dy, node.y1 -= dy;
	                                y = node.y0;
	                            }
	                        }
	                    });
	                }
	            }
	            function computeLinkBreadths(graph) {
	                graph.nodes.forEach(function (node) {
	                    node.sourceLinks.sort(ascendingTargetBreadth);
	                    node.targetLinks.sort(ascendingSourceBreadth);
	                });
	                graph.nodes.forEach(function (node) {
	                    var y0 = node.y0, y1 = y0;
	                    node.sourceLinks.forEach(function (link) {
	                        link.y0 = y0 + link.width / 2, y0 += link.width;
	                    });
	                    node.targetLinks.forEach(function (link) {
	                        link.y1 = y1 + link.width / 2, y1 += link.width;
	                    });
	                });
	            }
	            Array.prototype.$orderBy = function (func) {
	                this.sort(function (a, b) {
	                    var a = func(a);
	                    var b = func(b);
	                    if (typeof a === 'string' || a instanceof String) {
	                        return a.localeCompare(b);
	                    }
	                    return a - b;
	                });
	                return this;
	            };
	            return sankey;
	        };
	        function horizontalSource(d) {
	            return [d.source.x1, d.y0];
	        }
	        function horizontalTarget(d) {
	            return [d.target.x0, d.y1];
	        }
	        var sankeyLinkHorizontal = function () {
	            return d3Shape.linkHorizontal()
	                .source(horizontalSource)
	                .target(horizontalTarget);
	        };
	        exports.sankey = sankey;
	        exports.sankeyCenter = center;
	        exports.sankeyLeft = left;
	        exports.sankeyRight = right;
	        exports.sankeyJustify = justify;
	        exports.sankeyLinkHorizontal = sankeyLinkHorizontal;
	        Object.defineProperty(exports, '__esModule', { value: true });
	    })));
	    //
	    // brush (modified)
	    //
	    (function (global, factory) {
	        //typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('d3-dispatch'), require('d3-drag'), require('d3-interpolate'), require('d3-selection'), require('d3-transition')) :
	        //  typeof define === 'function' && define.amd ? define(['exports', 'd3-dispatch', 'd3-drag', 'd3-interpolate', 'd3-selection', 'd3-transition'], factory) :
	        (factory((global.d3 = global.d3 || {}), global.d3, global.d3, global.d3, global.d3, global.d3));
	    }($window, (function (exports, d3Dispatch, d3Drag, d3Interpolate, d3Selection, d3Transition) {
	        'use strict';
	        var constant = function (x) {
	            return function () {
	                return x;
	            };
	        };
	        var BrushEvent = function (target, type, selection) {
	            this.target = target;
	            this.type = type;
	            this.selection = selection;
	        };
	        function nopropagation() {
	            d3Selection.event.stopImmediatePropagation();
	        }
	        var noevent = function () {
	            d3Selection.event.preventDefault();
	            d3Selection.event.stopImmediatePropagation();
	        };
	        var MODE_DRAG = { name: "drag" };
	        var MODE_SPACE = { name: "space" };
	        var MODE_HANDLE = { name: "handle" };
	        var MODE_CENTER = { name: "center" };
	        var X = {
	            name: "x",
	            handles: ["e", "w"].map(type),
	            input: function (x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
	            output: function (xy) { return xy && [xy[0][0], xy[1][0]]; }
	        };
	        var Y = {
	            name: "y",
	            handles: ["n", "s"].map(type),
	            input: function (y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
	            output: function (xy) { return xy && [xy[0][1], xy[1][1]]; }
	        };
	        var XY = {
	            name: "xy",
	            handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
	            input: function (xy) { return xy; },
	            output: function (xy) { return xy; }
	        };
	        var cursors = {
	            overlay: "crosshair",
	            selection: "move",
	            n: "ns-resize",
	            e: "ew-resize",
	            s: "ns-resize",
	            w: "ew-resize",
	            nw: "nwse-resize",
	            ne: "nesw-resize",
	            se: "nwse-resize",
	            sw: "nesw-resize"
	        };
	        var flipX = {
	            e: "w",
	            w: "e",
	            nw: "ne",
	            ne: "nw",
	            se: "sw",
	            sw: "se"
	        };
	        var flipY = {
	            n: "s",
	            s: "n",
	            nw: "sw",
	            ne: "se",
	            se: "ne",
	            sw: "nw"
	        };
	        var signsX = {
	            overlay: +1,
	            selection: +1,
	            n: null,
	            e: +1,
	            s: null,
	            w: -1,
	            nw: -1,
	            ne: +1,
	            se: +1,
	            sw: -1
	        };
	        var signsY = {
	            overlay: +1,
	            selection: +1,
	            n: -1,
	            e: null,
	            s: +1,
	            w: null,
	            nw: -1,
	            ne: -1,
	            se: +1,
	            sw: +1
	        };
	        function type(t) {
	            return { type: t };
	        }
	        // Ignore right-click, since that should open the context menu.
	        function defaultFilter() {
	            return !d3Selection.event.button;
	        }
	        function defaultExtent() {
	            var svg = this.ownerSVGElement || this;
	            return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
	        }
	        // Like d3.local, but with the name “__brush” rather than auto-generated.
	        function local(node) {
	            while (!node.__brush)
	                if (!(node = node.parentNode))
	                    return;
	            return node.__brush;
	        }
	        function empty(extent) {
	            return extent[0][0] === extent[1][0]
	                || extent[0][1] === extent[1][1];
	        }
	        function brushSelection(node) {
	            var state = node.__brush;
	            return state ? state.dim.output(state.selection) : null;
	        }
	        function brushX() {
	            return brush$1(X);
	        }
	        function brushY() {
	            return brush$1(Y);
	        }
	        var brush = function () {
	            return brush$1(XY);
	        };
	        function brush$1(dim) {
	            var extent = defaultExtent, filter = defaultFilter, listeners = d3Dispatch.dispatch(brush, "start", "brush", "end"), handleSize = 6, touchending;
	            function brush(group) {
	                var overlay = group
	                    .property("__brush", initialize)
	                    .selectAll(".overlay")
	                    .data([type("overlay")]);
	                overlay.enter().append("rect")
	                    .attr("class", "overlay")
	                    .attr("pointer-events", "all")
	                    .attr("cursor", cursors.overlay)
	                    .merge(overlay)
	                    .each(function () {
	                    var extent = local(this).extent;
	                    d3Selection.select(this)
	                        .attr("x", extent[0][0])
	                        .attr("y", extent[0][1])
	                        .attr("width", extent[1][0] - extent[0][0])
	                        .attr("height", extent[1][1] - extent[0][1]);
	                });
	                group.selectAll(".selection")
	                    .data([type("selection")])
	                    .enter().append("rect")
	                    .attr("class", "selection")
	                    .attr("cursor", cursors.selection)
	                    .attr("fill", "#777")
	                    .attr("fill-opacity", 0.3)
	                    .attr("stroke", "#fff")
	                    .attr("shape-rendering", "crispEdges");
	                var handle = group.selectAll(".handle")
	                    .data(dim.handles, function (d) { return d.type; });
	                handle.exit().remove();
	                handle.enter().append("rect")
	                    .attr("class", function (d) { return "handle handle--" + d.type; })
	                    .attr("cursor", function (d) { return cursors[d.type]; });
	                group
	                    .each(redraw)
	                    .attr("fill", "none")
	                    .attr("pointer-events", "all")
	                    .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
	                    .on("mousedown.brush touchstart.brush", started);
	            }
	            brush.move = function (group, selection) {
	                if (group.selection) {
	                    group
	                        .on("start.brush", function () { emitter(this, arguments).beforestart().start(); })
	                        .on("interrupt.brush end.brush", function () { emitter(this, arguments).end(); })
	                        .tween("brush", function () {
	                        var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = d3Interpolate.interpolate(selection0, selection1);
	                        function tween(t) {
	                            state.selection = t === 1 && empty(selection1) ? null : i(t);
	                            redraw.call(that);
	                            emit.brush();
	                        }
	                        return selection0 && selection1 ? tween : tween(1);
	                    });
	                }
	                else {
	                    group
	                        .each(function () {
	                        var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
	                        d3Transition.interrupt(that);
	                        state.selection = selection1 == null || empty(selection1) ? null : selection1;
	                        redraw.call(that);
	                        emit.start().brush().end();
	                    });
	                }
	            };
	            function redraw() {
	                var group = d3Selection.select(this), selection = local(this).selection;
	                if (selection) {
	                    group.selectAll(".selection")
	                        .style("display", null)
	                        .attr("x", selection[0][0])
	                        .attr("y", selection[0][1])
	                        .attr("width", selection[1][0] - selection[0][0])
	                        .attr("height", selection[1][1] - selection[0][1]);
	                    group.selectAll(".handle")
	                        .style("display", null)
	                        .attr("x", function (d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
	                        .attr("y", function (d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
	                        .attr("width", function (d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
	                        .attr("height", function (d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
	                }
	                else {
	                    group.selectAll(".selection,.handle")
	                        .style("display", "none")
	                        .attr("x", null)
	                        .attr("y", null)
	                        .attr("width", null)
	                        .attr("height", null);
	                }
	            }
	            function emitter(that, args) {
	                return that.__brush.emitter || new Emitter(that, args);
	            }
	            function Emitter(that, args) {
	                this.that = that;
	                this.args = args;
	                this.state = that.__brush;
	                this.active = 0;
	            }
	            Emitter.prototype = {
	                beforestart: function () {
	                    if (++this.active === 1)
	                        this.state.emitter = this, this.starting = true;
	                    return this;
	                },
	                start: function () {
	                    if (this.starting)
	                        this.starting = false, this.emit("start");
	                    return this;
	                },
	                brush: function () {
	                    this.emit("brush");
	                    return this;
	                },
	                end: function () {
	                    if (--this.active === 0)
	                        delete this.state.emitter, this.emit("end");
	                    return this;
	                },
	                emit: function (type) {
	                    d3Selection.customEvent(new BrushEvent(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
	                }
	            };
	            function started() {
	                if (d3Selection.event.touches) {
	                    if (d3Selection.event.changedTouches.length < d3Selection.event.touches.length)
	                        return noevent();
	                }
	                else if (touchending)
	                    return;
	                if (!filter.apply(this, arguments))
	                    return;
	                var that = this, type = d3Selection.event.target.__data__.type, mode = (d3Selection.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (d3Selection.event.altKey ? MODE_CENTER : MODE_HANDLE), signX = dim === Y ? null : signsX[type], signY = dim === X ? null : signsY[type], state = local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx, dy, moving, lockX, lockY, point0 = d3Selection.mouse(that), point = point0, emit = emitter(that, arguments).beforestart();
	                if (type === "overlay") {
	                    state.selection = selection = [
	                        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
	                        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
	                    ];
	                }
	                else {
	                    w0 = selection[0][0];
	                    n0 = selection[0][1];
	                    e0 = selection[1][0];
	                    s0 = selection[1][1];
	                }
	                w1 = w0;
	                n1 = n0;
	                e1 = e0;
	                s1 = s0;
	                var group = d3Selection.select(that)
	                    .attr("pointer-events", "none");
	                var overlay = group.selectAll(".overlay")
	                    .attr("cursor", cursors[type]);
	                if (d3Selection.event.touches) {
	                    group
	                        .on("touchmove.brush", moved, true)
	                        .on("touchend.brush touchcancel.brush", ended, true);
	                }
	                else {
	                    var view = d3Selection.select(d3Selection.event.view)
	                        .on("keydown.brush", keydowned, true)
	                        .on("keyup.brush", keyupped, true)
	                        .on("mousemove.brush", moved, true)
	                        .on("mouseup.brush", ended, true);
	                    d3Drag.dragDisable(d3Selection.event.view);
	                }
	                nopropagation();
	                d3Transition.interrupt(that);
	                redraw.call(that);
	                emit.start();
	                function moved() {
	                    var point1 = d3Selection.mouse(that);
	                    point = point1;
	                    moving = true;
	                    noevent();
	                    move();
	                }
	                function move() {
	                    var t;
	                    dx = point[0] - point0[0];
	                    dy = point[1] - point0[1];
	                    switch (mode) {
	                        case MODE_SPACE:
	                        case MODE_DRAG: {
	                            if (signX)
	                                dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
	                            if (signY)
	                                dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
	                            break;
	                        }
	                        case MODE_HANDLE: {
	                            if (signX < 0)
	                                dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
	                            else if (signX > 0)
	                                dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
	                            if (signY < 0)
	                                dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
	                            else if (signY > 0)
	                                dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
	                            break;
	                        }
	                        case MODE_CENTER: {
	                            if (signX)
	                                w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
	                            if (signY)
	                                n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
	                            break;
	                        }
	                    }
	                    if (e1 < w1) {
	                        signX *= -1;
	                        t = w0, w0 = e0, e0 = t;
	                        t = w1, w1 = e1, e1 = t;
	                        if (type in flipX)
	                            overlay.attr("cursor", cursors[type = flipX[type]]);
	                    }
	                    if (s1 < n1) {
	                        signY *= -1;
	                        t = n0, n0 = s0, s0 = t;
	                        t = n1, n1 = s1, s1 = t;
	                        if (type in flipY)
	                            overlay.attr("cursor", cursors[type = flipY[type]]);
	                    }
	                    if (state.selection)
	                        selection = state.selection; // May be set by brush.move!
	                    if (lockX)
	                        w1 = selection[0][0], e1 = selection[1][0];
	                    if (lockY)
	                        n1 = selection[0][1], s1 = selection[1][1];
	                    if (selection[0][0] !== w1
	                        || selection[0][1] !== n1
	                        || selection[1][0] !== e1
	                        || selection[1][1] !== s1) {
	                        state.selection = [[w1, n1], [e1, s1]];
	                        redraw.call(that);
	                        emit.brush();
	                    }
	                }
	                function ended() {
	                    nopropagation();
	                    if (d3Selection.event.touches) {
	                        if (d3Selection.event.touches.length)
	                            return;
	                        if (touchending)
	                            clearTimeout(touchending);
	                        touchending = setTimeout(function () { touchending = null; }, 500); // Ghost clicks are delayed!
	                        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
	                    }
	                    else {
	                        d3Drag.dragEnable(d3Selection.event.view, moving);
	                        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
	                    }
	                    group.attr("pointer-events", "all");
	                    overlay.attr("cursor", cursors.overlay);
	                    if (state.selection)
	                        selection = state.selection; // May be set by brush.move (on start)!
	                    if (empty(selection))
	                        state.selection = null, redraw.call(that);
	                    emit.end();
	                }
	                function keydowned() {
	                    switch (d3Selection.event.keyCode) {
	                        case 18: {
	                            if (mode === MODE_HANDLE) {
	                                if (signX)
	                                    e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	                                if (signY)
	                                    s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	                                mode = MODE_CENTER;
	                                move();
	                            }
	                            break;
	                        }
	                        case 32: {
	                            if (mode === MODE_HANDLE || mode === MODE_CENTER) {
	                                if (signX < 0)
	                                    e0 = e1 - dx;
	                                else if (signX > 0)
	                                    w0 = w1 - dx;
	                                if (signY < 0)
	                                    s0 = s1 - dy;
	                                else if (signY > 0)
	                                    n0 = n1 - dy;
	                                mode = MODE_SPACE;
	                                overlay.attr("cursor", cursors.selection);
	                                move();
	                            }
	                            break;
	                        }
	                        default: return;
	                    }
	                    noevent();
	                }
	                function keyupped() {
	                    switch (d3Selection.event.keyCode) {
	                        case 18: {
	                            if (mode === MODE_CENTER) {
	                                if (signX < 0)
	                                    e0 = e1;
	                                else if (signX > 0)
	                                    w0 = w1;
	                                if (signY < 0)
	                                    s0 = s1;
	                                else if (signY > 0)
	                                    n0 = n1;
	                                mode = MODE_HANDLE;
	                                move();
	                            }
	                            break;
	                        }
	                        case 32: {
	                            if (mode === MODE_SPACE) {
	                                if (d3Selection.event.altKey) {
	                                    if (signX)
	                                        e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	                                    if (signY)
	                                        s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	                                    mode = MODE_CENTER;
	                                }
	                                else {
	                                    if (signX < 0)
	                                        e0 = e1;
	                                    else if (signX > 0)
	                                        w0 = w1;
	                                    if (signY < 0)
	                                        s0 = s1;
	                                    else if (signY > 0)
	                                        n0 = n1;
	                                    mode = MODE_HANDLE;
	                                }
	                                overlay.attr("cursor", cursors[type]);
	                                move();
	                            }
	                            break;
	                        }
	                        default: return;
	                    }
	                    noevent();
	                }
	            }
	            function initialize() {
	                var state = this.__brush || { selection: null };
	                state.extent = extent.apply(this, arguments);
	                state.dim = dim;
	                return state;
	            }
	            brush.extent = function (_) {
	                return arguments.length ? (extent = typeof _ === "function" ? _ : constant([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
	            };
	            brush.filter = function (_) {
	                return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), brush) : filter;
	            };
	            brush.handleSize = function (_) {
	                return arguments.length ? (handleSize = +_, brush) : handleSize;
	            };
	            brush.on = function () {
	                var value = listeners.on.apply(listeners, arguments);
	                return value === listeners ? brush : value;
	            };
	            return brush;
	        }
	        exports.brush = brush;
	        exports.brushX = brushX;
	        exports.brushY = brushY;
	        exports.brushSelection = brushSelection;
	        Object.defineProperty(exports, '__esModule', { value: true });
	    })));
	    //
	    // tooltip
	    //
	    $window.d3.componentsTooltip = function d3ComponentsTooltip(params) {
	        // exposed variables
	        var attrs = {
	            svgWidth: 0,
	            svgHeight: 0,
	            container: 'body',
	            tooltipRowHeight: 25,
	            minSpaceBetweenColumns: 20,
	            fontSize: 13,
	            arrowHeight: 10,
	            arrowLength: 20,
	            contentMargin: 0,
	            heightOffset: 7,
	            textColor: "white",
	            tooltipFill: "'#488FC8'",
	            leftMargin: 10,
	            rightMargin: 3,
	            transform: { x: 0, y: 0, k: 1 },
	            content: [
	                {
	                    left: "info",
	                    right: "{id}"
	                },
	            ],
	            x: null,
	            y: null,
	            direction: "bottom",
	            data: { "id": "you should provide data using .show(d)" }
	        };
	        /*############### IF EXISTS OVERWRITE ATTRIBUTES FROM PASSED PARAM  #######  */
	        var attrKeys = Object.keys(attrs);
	        attrKeys.forEach(function (key) {
	            if (params && params[key]) {
	                attrs[key] = params[key];
	            }
	        });
	        //innerFunctions which will update visuals
	        var updateData;
	        var displayTooltip;
	        var hideTooltip;
	        var dimensions;
	        //main chart object
	        var main = function (selection) {
	            selection.each(function scope() {
	                //calculated properties
	                var calc = {};
	                //drawing containers
	                var container = $window.d3.select(this);
	                //add shadow svg
	                var svg = $window.d3.select('body').patternify({ tag: 'svg', selector: 'tooltip-shadow-wrapper-svg' });
	                //add container g element
	                var chart = svg.patternify({ tag: 'g', selector: 'chart' });
	                // Add filters ( Shadows)
	                var defs = chart.patternify({ selector: 'defs-element', tag: 'defs' });
	                attrs.dropShadowUrl = "drop-shadow–d3-components-tooltip";
	                //Drop shadow filter
	                var dropShadowFilter = defs.patternify({ selector: 'filter-element', tag: 'filter' }).attr("id", attrs.dropShadowUrl).attr("height", "150%").attr('y', "-30%");
	                dropShadowFilter.patternify({ selector: 'fe-gaussian-blur-element', tag: 'feGaussianBlur' }).attr("in", "SourceAlpha").attr("stdDeviation", 5).attr("result", "blur");
	                dropShadowFilter.patternify({ selector: 'feOffset-element', tag: 'feOffset' }).attr("in", "blur").attr("dx", 2).attr("dy", 5).attr("result", "offsetBlur");
	                dropShadowFilter.patternify({ selector: 'feFlood-element', tag: 'feFlood' }).attr('flood-color', 'black').attr("flood-opacity", "0.4").attr("result", "offsetColor");
	                dropShadowFilter.patternify({ selector: 'feComposite-element', tag: 'feComposite' }).attr('in', 'offsetColor').attr('in2', 'offsetBlur').attr("operator", "in").attr("result", "offsetBlur");
	                var feMerge = dropShadowFilter.patternify({ selector: 'feMerge-element', tag: 'feMerge' });
	                feMerge.patternify({ selector: 'feMergeNode-element', tag: 'feMergeNode' }).attr("in", "offsetBlur");
	                feMerge.patternify({ selector: 'feMergeNode2-element', tag: 'feMergeNode' }).attr("in", "SourceGraphic");
	                // hide tooltip
	                hideTooltip = function () {
	                    attrs.container.selectAll(".tooltipContent").remove();
	                };
	                //show tooltip
	                displayTooltip = function () {
	                    // assign x and y positions
	                    var x = attrs.x;
	                    var y = attrs.y;
	                    //check container type first and transform if necessary
	                    if (!(attrs.container instanceof $window.d3.selection)) {
	                        attrs.container = $window.d3.select(attrs.container);
	                    }
	                    // remove tooltipcontent if exists
	                    attrs.container.selectAll(".total-wrapper").remove();
	                    // tooltip content wrapper
	                    var totalWrapper = attrs.container
	                        .append("g")
	                        .attr("class", "total-wrapper")
	                        .attr("transform", " scale(" + 1 / attrs.transform.k + ")");
	                    // tooltip content wrapper
	                    var tooltipContentWrapper = totalWrapper
	                        .append("g")
	                        .attr("class", "tooltipContent")
	                        .attr("pointer-events", "none");
	                    //tooltip wrapper
	                    var tooltipWrapper = tooltipContentWrapper
	                        .append("g")
	                        .style("pointer-events", "none");
	                    //tooltip path
	                    tooltipWrapper.append("path");
	                    //row contents wrapper
	                    var g = tooltipWrapper.append("g");
	                    //each rows wrapper
	                    var rows = g
	                        .selectAll(".rows")
	                        .data(attrs.content)
	                        .enter()
	                        .append("g")
	                        .attr("font-size", attrs.fontSize)
	                        .attr("dominant-baseline", "middle")
	                        .attr("fill", attrs.textColor)
	                        .attr("transform", function (d, i) {
	                        return "translate(" + attrs.contentMargin + "," + (i *
	                            attrs.tooltipRowHeight +
	                            attrs.heightOffset +
	                            attrs.contentMargin) + ")";
	                    });
	                    //row left texts
	                    rows
	                        .append("text")
	                        .attr("class", "left")
	                        .attr("y", attrs.tooltipRowHeight / 3)
	                        .attr("x", attrs.leftMargin)
	                        .text(function (d) { return replaceWithProps(d.left, attrs.data); })
	                        .attr("text-anchor", "start");
	                    //row right texts
	                    rows
	                        .append("text")
	                        .attr("class", "right")
	                        .attr("y", attrs.tooltipRowHeight / 3)
	                        .attr("x", attrs.rightMargin)
	                        .text(function (d) { return replaceWithProps(d.right, attrs.data); })
	                        .attr("text-anchor", "end");
	                    // adjusting positions
	                    var maxWidth = 0;
	                    rows.each(function (g) {
	                        var row = $window.d3.select(this);
	                        var currentWidth = row.select(".left").node().getBoundingClientRect().width +
	                            row.select(".right").node().getBoundingClientRect().width +
	                            attrs.minSpaceBetweenColumns;
	                        if (currentWidth > maxWidth) {
	                            maxWidth = currentWidth;
	                        }
	                    });
	                    // taking right texts to maximum left width position
	                    rows.select(".right").attr("x", maxWidth);
	                    //applying margins
	                    maxWidth += attrs.leftMargin + attrs.rightMargin;
	                    //calculating positions
	                    var height = attrs.tooltipRowHeight * attrs.content.length +
	                        attrs.contentMargin * 2 -
	                        attrs.heightOffset +
	                        attrs.tooltipRowHeight / 3;
	                    var halfArrowLength = attrs.arrowLength / 2;
	                    var halfWidth = maxWidth / 2;
	                    var fullWidth = maxWidth;
	                    var halfHeight = height / 2;
	                    attrs.dimensions = {
	                        height: height,
	                        width: fullWidth
	                    };
	                    //building string paths
	                    var leftArrowPos = attrs.direction != "left" ? "" : "  L 0 " + (halfHeight - halfArrowLength) + "   L   " + -attrs.arrowHeight + " " + halfHeight + " L 0 " + (halfHeight + halfArrowLength);
	                    var bottomArrowPos = attrs.direction != "bottom" ? "" : " L " + (halfWidth - halfArrowLength) + "  " + height + "  L " + halfWidth + " " + (height + attrs.arrowHeight) + "  L " + (halfWidth + halfArrowLength) + " " + height;
	                    var rightArrowPos = attrs.direction != "right" ? "" : " L " + fullWidth + " " + (halfHeight - halfArrowLength) + "   L  " + (fullWidth + attrs.arrowHeight) + " " + halfHeight + "    L " + fullWidth + " " + (halfHeight + halfArrowLength) + "  ";
	                    var topArrowPos = attrs.direction != "top" ? "" : "L " + (halfWidth + halfArrowLength) + " 0  L " + halfWidth + " " + -attrs.arrowHeight + "   L " + (halfWidth - halfArrowLength) + "  0   ";
	                    var strPath = "\n          M 0 0\n          " + leftArrowPos + "\n          L 0  " + height + "\n          " + bottomArrowPos + "\n          L " + fullWidth + " " + height + "\n          " + rightArrowPos + "\n          L " + fullWidth + " 0\n          " + topArrowPos + "\n          L 0 0 ";
	                    // tooltip translation configurations
	                    var tooltipTranslateConfig = {
	                        left: {
	                            x: halfWidth + attrs.arrowHeight,
	                            y: halfHeight + attrs.arrowHeight
	                        },
	                        bottom: {
	                            x: 0,
	                            y: 0
	                        },
	                        right: {
	                            x: -(halfWidth + attrs.arrowHeight),
	                            y: halfHeight + attrs.arrowHeight
	                        },
	                        top: {
	                            x: 0,
	                            y: height + 2 * attrs.arrowHeight
	                        }
	                    };
	                    x *= (attrs.transform.k);
	                    y *= attrs.transform.k;
	                    // translate tooltip content based on configuration
	                    tooltipContentWrapper.attr("transform", "translate(" + (+x + +tooltipTranslateConfig[attrs.direction].x) + "," + (y +
	                        tooltipTranslateConfig[attrs.direction].y) + ")");
	                    //appending actual path
	                    tooltipWrapper
	                        .select("path")
	                        .attr("d", strPath)
	                        .attr("fill", attrs.tooltipFill)
	                        .attr("fill-opacity", 1);
	                    //.attr("filter", `url(#${attrs.dropShadowUrl})`); // doesn't work on safari
	                    //final translation to match provided x and y position
	                    tooltipWrapper.attr("transform", "translate(" + -halfWidth + "," + (-height - attrs.arrowHeight) + ")");
	                };
	                // function to replace dinamically properties from passed object
	                function replaceWithProps(text, obj) {
	                    var keys = Object.keys(obj);
	                    keys.forEach(function (key) {
	                        var stringToReplace = "{" + key + "}";
	                        var re = new RegExp(stringToReplace, "g");
	                        text = text.replace(re, obj[key]);
	                    });
	                    return text;
	                }
	                // smoothly handle data updating
	                updateData = function () {
	                };
	                //#########################################  UTIL FUNCS ##################################
	                // catch scope variables and assign it to global variable for runtime variable inspection
	                function debug() {
	                    if (attrs.isDebug) {
	                        //stringify func
	                        var stringified = scope + "";
	                        // parse variable names
	                        var groupVariables = stringified
	                            .match(/var\s+([\w])+\s*=\s*{\s*}/gi)
	                            .map(function (d) { return d.match(/\s+\w*/gi).filter(function (s) { return s.trim(); }); })
	                            .map(function (v) { return v[0].trim(); });
	                        //assign local variables to the scope
	                        groupVariables.forEach(function (v) {
	                            main['P_' + v] = eval(v);
	                        });
	                    }
	                }
	                debug();
	            });
	        };
	        //----------- PROTOTYEPE FUNCTIONS  ----------------------
	        $window.d3.selection.prototype.patternify = function (params) {
	            var container = this;
	            var selector = params.selector;
	            var elementTag = params.tag;
	            var data = params.data || [selector];
	            // pattern in action
	            var selection = container.selectAll('.' + selector).data(data);
	            selection.exit().remove();
	            selection = selection.enter().append(elementTag).merge(selection);
	            selection.attr('class', selector);
	            return selection;
	        };
	        //dinamic keys functions
	        Object.keys(attrs).forEach(function (key) {
	            // Attach variables to main function
	            return main[key] = function (_) {
	                var string = "attrs['" + key + "'] = _";
	                if (!arguments.length) {
	                    return eval(" attrs['" + key + "'];");
	                }
	                eval(string);
	                return main;
	            };
	        });
	        //set attrs as property
	        main.attrs = attrs;
	        main.dimensions = function () {
	            return attrs.dimensions;
	        };
	        //debugging visuals
	        main.debug = function (isDebug) {
	            attrs.isDebug = isDebug;
	            if (isDebug) {
	                if (!window.charts)
	                    window.charts = [];
	                window.charts.push(main);
	            }
	            return main;
	        };
	        //exposed update functions
	        main.data = function (value) {
	            if (!arguments.length)
	                return attrs.data;
	            attrs.data = value;
	            if (typeof updateData === 'function') {
	                updateData();
	            }
	            return main;
	        };
	        main.show = function (data) {
	            if (data) {
	                attrs.data = data;
	            }
	            displayTooltip();
	        };
	        main.hide = function () {
	            hideTooltip();
	        };
	        // run  visual
	        main.run = function () {
	            $window.d3.selectAll(attrs.container).call(main);
	            return main;
	        };
	        return main.run();
	    };
	    return $window.d3;
	}
	exports.default = d3;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	"use strict";
	hammer.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function hammer($window) {
	    'ngInject';
	    return $window.Hammer;
	}
	exports.default = hammer;


/***/ }),
/* 170 */
/***/ (function(module, exports) {

	"use strict";
	jsPDF.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function jsPDF($window) {
	    'ngInject';
	    return $window.jsPDF;
	}
	exports.default = jsPDF;


/***/ }),
/* 171 */
/***/ (function(module, exports) {

	"use strict";
	jszip.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Justin York <justin@york.io> - 2017
	 */
	function jszip($window) {
	    'ngInject';
	    return $window.JSZip;
	}
	exports.default = jszip;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

	"use strict";
	jszipUtils.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Justin York <justin@york.io> - 2017
	 */
	function jszipUtils($window) {
	    'ngInject';
	    return $window.JSZipUtils;
	}
	exports.default = jszipUtils;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

	"use strict";
	leaflet.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2017
	 */
	function leaflet($window) {
	    'ngInject';
	    return $window.L;
	}
	exports.default = leaflet;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

	"use strict";
	mediaStreamRecorder.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function mediaStreamRecorder($window) {
	    'ngInject';
	    return $window.MediaStreamRecorder;
	}
	exports.default = mediaStreamRecorder;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	"use strict";
	partnerToken.$inject = ["$cookies"];
	Object.defineProperty(exports, "__esModule", { value: true });
	function partnerToken($cookies) {
	    'ngInject';
	    // PARTNER get a token that you're going to pass to the rootsfinder server
	    // rootsfinder will pass this token to your server to get the user's id (and name and email) and rootsfinder plan level
	    return $cookies.get('AncestreesToken') || '';
	}
	exports.default = partnerToken;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

	"use strict";
	rx.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function rx($window) {
	    'ngInject';
	    return $window.Rx;
	}
	exports.default = rx;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function translate() {
	    'ngInject';
	    return function (id) {
	        // if key is not in the translation table, return it as-is
	        return id;
	    };
	}
	exports.default = translate;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

	"use strict";
	unibabel.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	function unibabel($window) {
	    'ngInject';
	    return $window.Unibabel;
	}
	exports.default = unibabel;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var authenication_service_1 = __webpack_require__(180);
	var AuthenticationService = /** @class */ (function (_super) {
	    __extends(AuthenticationService, _super);
	    AuthenticationService.$inject = ["rx", "$log", "server", "authToken", "partnerId", "partnerToken", "partnerSingleSignon", "cache", "currentUserId", "currentUser", "currentTreeId", "messageBus", "segment", "utils"];
	    function AuthenticationService(rx, $log, server, authToken, partnerId, partnerToken, partnerSingleSignon, cache, currentUserId, currentUser, currentTreeId, messageBus, segment, utils) {
	        'ngInject';
	        return _super.call(this, rx, $log, server, authToken, partnerId, partnerToken, partnerSingleSignon, cache, currentUserId, currentUser, currentTreeId, messageBus, segment, utils, angular) || this;
	    }
	    return AuthenticationService;
	}(authenication_service_1.AuthenticationService));
	exports.default = AuthenticationService;
	// class AuthenticationService {
	//   constructor($log, server, authToken, partnerId, partnerToken, partnerSingleSignon, cache, currentUserId, currentUser, currentTreeId, messageBus, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.server = server;
	//     this.authToken = authToken;
	//     this.partnerId = partnerId;
	//     this.partnerToken = partnerToken;
	//     this.partnerSingleSignon = partnerSingleSignon;
	//     this.cache = cache;
	//     this.currentUserId = currentUserId;
	//     this.currentUser = currentUser;
	//     this.currentTreeId = currentTreeId;
	//     this.messageBus = messageBus;
	//     this.segment = segment;
	//     this.utils = utils;
	//   }
	//   setCurrentUser() {
	//     if (this.authToken.get() !== '') {
	//       this._getCurrentUser();
	//     }
	//     else if (!!this.partnerId && !!this.partnerToken && this.partnerSingleSignon) {
	//       this.partnerLogin(this.partnerId, this.partnerToken);
	//     }
	//     else {
	//       this.currentUserId.set(0);
	//     }
	//   }
	//   _getCurrentUser() {
	//     this.$log.debug('athentication._getCurrentUser');
	//     this.server.get('/users/current').subscribe(user => {
	//       this.currentUserId.set(user.id, user.secretKey);
	//     }, err => {
	//       this.messageBus.post({msg: err.data, status: err.status, op: 'GET', ctx: 'users/current'});
	//     });
	//   }
	//   login(email, password, rememberMe) {
	//     // call server
	//     let [s, t] = this.utils.teeAsync(this.server.post('/auth/login', {email, password, source: this.partnerId}));
	//     s.subscribe(response => {
	//       // on success, save the token and request the current user
	//       this.$log.debug('authentication.login', response.token);
	//       this.authToken.set(response.token, rememberMe);
	//       this._getCurrentUser();
	//       this.segment.track('user.login');
	//     }, err => {
	//       this.$log.debug('authentication.login error', err);
	//       this.messageBus.post({msg: err.data});
	//     });
	//     return t;
	//   }
	//   partnerLogin(partnerId, partnerToken) {
	//     let [s, t] = this.utils.teeAsync(this.server.post('/auth/login', {source: partnerId, sourceKey: partnerToken}));
	//     s.subscribe(response => {
	//       // on success, save the token and request the current user
	//       this.$log.debug('authentication.partnerLogin', response.token);
	//       this.authToken.set(response.token, false);
	//       this._getCurrentUser();
	//       this.segment.track('user.partnerLogin');
	//     }, err => {
	//       this.currentUserId.set(0);
	//       // ignore not found errors
	//       if (err.status !== 404) {
	//         this.$log.debug('authentication.partnerLogin error', err);
	//         this.messageBus.post({msg: err.data});
	//       }
	//     });
	//     return t;
	//   }
	//   register(user, rememberMe) {
	//     // call server
	//     let u = angular.extend({}, user, {source: this.partnerId});
	//     let [s, t] = this.utils.teeAsync(this.server.post('/auth/register', u));
	//     s.subscribe(response => {
	//       // on success save the token and request the current user
	//       this.$log.debug('authentication.register', response.token);
	//       this.authToken.set(response.token, rememberMe);
	//       this._getCurrentUser();
	//       this.segment.track('user.register', {plan: 'beta'});
	//     }, err => {
	//       this.$log.debug('authentication.register error', err);
	//       this.messageBus.post({msg: err.data});
	//     });
	//     return t;
	//   }
	//   forgotPassword(email) {
	//     // call server
	//     let [s, t] = this.utils.teeAsync(this.server.post('/auth/forgot-password', {email, source: this.partnerId}));
	//     s.subscribe(() => {
	//       // nothing to do
	//     }, err => {
	//       this.$log.debug('authentication.forgotPassword error', err);
	//       this.messageBus.post({msg: err.data});
	//     });
	//     return t;
	//   }
	//   setPassword(email, password, key) {
	//     // call server
	//     let [s, t] = this.utils.teeAsync(this.server.post('/auth/set-password', {email, password, key, source: this.partnerId}));
	//     s.subscribe(() => {
	//       // nothing to do
	//     }, err => {
	//       this.$log.debug('authentication.setPassword error', err);
	//       this.messageBus.post({msg: err.data});
	//     });
	//     return t;
	//   }
	//   confirmEmail(email, key) {
	//     // call server
	//     let [s, t] = this.utils.teeAsync(this.server.post('/auth/confirm-email', {email, key, source: this.partnerId}));
	//     s.subscribe(() => {
	//       // nothing to do
	//     }, err => {
	//       this.$log.debug('authentication.confirmEmail error', err);
	//       this.messageBus.post({msg: err.data});
	//     });
	//     return t;
	//   }
	//   logout() {
	//     this.$log.debug('authentication.logout');
	//     return this.cache.deleteAllDatabases().do(() => {
	//       this.currentTreeId.set(0);
	//       this.currentUserId.set(0);
	//       this.authToken.set('');
	//     });
	//   }
	// }
	// export default AuthenticationService;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var AuthenticationService = /** @class */ (function () {
	    function AuthenticationService(rx, log, server, authToken, partnerId, partnerToken, partnerSingleSignon, cache, currentUserId, currentUser, currentTreeId, messageBus, segment, utils, angularUtils) {
	        this.rx = rx;
	        this.log = log;
	        this.server = server;
	        this.authToken = authToken;
	        this.partnerId = partnerId;
	        this.partnerToken = partnerToken;
	        this.partnerSingleSignon = partnerSingleSignon;
	        this.cache = cache;
	        this.currentUserId = currentUserId;
	        this.currentUser = currentUser;
	        this.currentTreeId = currentTreeId;
	        this.messageBus = messageBus;
	        this.segment = segment;
	        this.utils = utils;
	        this.angularUtils = angularUtils;
	    }
	    AuthenticationService.prototype.setCurrentUser = function () {
	        if (this.authToken.get() !== '') {
	            this._getCurrentUser();
	        }
	        else if (!!this.partnerId && !!this.partnerToken && this.partnerSingleSignon) {
	            this.partnerLogin(this.partnerId, this.partnerToken);
	        }
	        else {
	            this.currentUserId.set(0);
	        }
	    };
	    AuthenticationService.prototype._getCurrentUser = function () {
	        var _this = this;
	        this.log.debug('authentication._getCurrentUser');
	        this.server.get('/users/current').subscribe(function (user) {
	            _this.currentUserId.set(user.id, user.secretKey);
	        }, function (err) {
	            _this.messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'users/current' });
	        });
	    };
	    AuthenticationService.prototype.login = function (email, password, rememberMe) {
	        var _this = this;
	        // call server
	        var _a = __read(this.utils.teeAsync(this.server.post('/auth/login', { email: email, password: password, source: this.partnerId })), 2), s = _a[0], t = _a[1];
	        s.subscribe(function (response) {
	            // on success, save the token and request the current user
	            _this.log.debug('authentication.login', response.token);
	            _this.authToken.set(response.token, rememberMe);
	            _this._getCurrentUser();
	            _this.segment.track('user.login');
	        }, function (err) {
	            _this.log.debug('authentication.login error', err);
	            _this.messageBus.post({ msg: err.data });
	        });
	        return t;
	    };
	    AuthenticationService.prototype.partnerLogin = function (partnerId, partnerToken) {
	        var _this = this;
	        var _a = __read(this.utils.teeAsync(this.server.post('/auth/login', { source: partnerId, sourceKey: partnerToken })), 2), s = _a[0], t = _a[1];
	        s.subscribe(function (response) {
	            // on success, save the token and request the current user
	            _this.log.debug('authentication.partnerLogin', response.token);
	            _this.authToken.set(response.token, false);
	            _this._getCurrentUser();
	            _this.segment.track('user.partnerLogin');
	        }, function (err) {
	            _this.currentUserId.set(0);
	            // ignore not found errors
	            if (err.status !== 404) {
	                _this.log.debug('authentication.partnerLogin error', err);
	                _this.messageBus.post({ msg: err.data });
	            }
	        });
	        return t;
	    };
	    AuthenticationService.prototype.register = function (user, rememberMe) {
	        var _this = this;
	        // call server
	        var u = this.angularUtils.extend({}, user, { source: this.partnerId });
	        var _a = __read(this.utils.teeAsync(this.server.post('/auth/register', u)), 2), s = _a[0], t = _a[1];
	        s.subscribe(function (response) {
	            // on success save the token and request the current user
	            _this.log.debug('authentication.register', response.token);
	            _this.authToken.set(response.token, rememberMe);
	            _this._getCurrentUser();
	            _this.segment.track('user.register', { plan: 'beta' });
	        }, function (err) {
	            _this.log.debug('authentication.register error', err);
	            _this.messageBus.post({ msg: err.data });
	        });
	        return t;
	    };
	    AuthenticationService.prototype.forgotPassword = function (email) {
	        var _this = this;
	        // call server
	        var _a = __read(this.utils.teeAsync(this.server.post('/auth/forgot-password', { email: email, source: this.partnerId })), 2), s = _a[0], t = _a[1];
	        s.subscribe(function () {
	            // nothing to do
	        }, function (err) {
	            _this.log.debug('authentication.forgotPassword error', err);
	            _this.messageBus.post({ msg: err.data });
	        });
	        return t;
	    };
	    AuthenticationService.prototype.setPassword = function (email, password, key) {
	        var _this = this;
	        // call server
	        var _a = __read(this.utils.teeAsync(this.server.post('/auth/set-password', { email: email, password: password, key: key, source: this.partnerId })), 2), s = _a[0], t = _a[1];
	        s.subscribe(function () {
	            // nothing to do
	        }, function (err) {
	            _this.log.debug('authentication.setPassword error', err);
	            _this.messageBus.post({ msg: err.data });
	        });
	        return t;
	    };
	    AuthenticationService.prototype.confirmEmail = function (email, key) {
	        var _this = this;
	        // call server
	        var _a = __read(this.utils.teeAsync(this.server.post('/auth/confirm-email', { email: email, key: key, source: this.partnerId })), 2), s = _a[0], t = _a[1];
	        s.subscribe(function () {
	            // nothing to do
	        }, function (err) {
	            _this.log.debug('authentication.confirmEmail error', err);
	            _this.messageBus.post({ msg: err.data });
	        });
	        return t;
	    };
	    AuthenticationService.prototype.logout = function () {
	        var _this = this;
	        console.log('logout');
	        this.log.debug('authentication.logout');
	        return this.cache.deleteAllDatabases().do(function () {
	            _this.currentTreeId.set(0);
	            _this.currentUserId.set(0);
	            _this.authToken.set('');
	        }).pipe(this.rx.operators.map(function (res) { return res; }), this.rx.operators.catchError(function (err) {
	            _this.currentTreeId.set(0);
	            _this.currentUserId.set(0);
	            _this.authToken.set('');
	            console.log('logout.error', err);
	            return _this.rx.Observable.throw(err);
	        }));
	    };
	    return AuthenticationService;
	}());
	exports.AuthenticationService = AuthenticationService;
	exports.default = AuthenticationService;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var authToken_service_1 = __webpack_require__(182);
	var AuthTokenService = /** @class */ (function (_super) {
	    __extends(AuthTokenService, _super);
	    AuthTokenService.$inject = ["$log", "$cookies", "cookieDomain", "cookieExpiresDays"];
	    function AuthTokenService($log, $cookies, cookieDomain, cookieExpiresDays) {
	        'ngInject';
	        return _super.call(this, $log, $cookies, cookieDomain, cookieExpiresDays) || this;
	    }
	    return AuthTokenService;
	}(authToken_service_1.AuthTokenService));
	exports.default = AuthTokenService;
	// class AuthTokenService {
	//   constructor ($log, $cookies, cookieDomain, cookieExpiresDays) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.$cookies = $cookies;
	//     this.cookieDomain = cookieDomain;
	//     this.cookieExpiresDays = cookieExpiresDays;
	//     this.key = 'authToken';
	//     this.partnerKey = 'authTokenPartner';
	//     this.token = this.$cookies.get(this.key) || '';
	//   }
	//   get() {
	//     return this.token;
	//   }
	//   set(token, rememberMe) {
	//     this.$log.debug('authToken.set', token, rememberMe, this.cookieDomain, this.cookieExpiresDays);
	//     this.token = token;
	//     let opts = {path: '/', domain: this.cookieDomain, secure: this.cookieDomain !== 'localhost'};
	//     if (token === '') {
	//       this.$cookies.remove(this.key, opts);
	//       this.$cookies.remove(this.partnerKey, opts);
	//     }
	//     else if (rememberMe) {
	//       if (this.cookieExpiresDays) {
	//         let date = new Date();
	//         date.setDate(date.getDate() + this.cookieExpiresDays);
	//         opts.expires = date;
	//       }
	//       this.$cookies.put(this.key, token, opts);
	//     }
	//   }
	// }
	// export default AuthTokenService;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var AuthTokenService = /** @class */ (function () {
	    function AuthTokenService(log, cookies, cookieDomain, cookieExpiresDays) {
	        this.log = log;
	        this.cookies = cookies;
	        this.cookieDomain = cookieDomain;
	        this.cookieExpiresDays = cookieExpiresDays;
	        this.key = 'authToken';
	        this.partnerKey = 'authTokenPartner';
	        this.token = this.cookies.get(this.key) || '';
	    }
	    AuthTokenService.prototype.get = function () {
	        return this.token;
	    };
	    AuthTokenService.prototype.set = function (token, rememberMe) {
	        this.log.debug('authToken.set', token, rememberMe, this.cookieDomain, this.cookieExpiresDays);
	        this.token = token;
	        var opts = { path: '/', domain: this.cookieDomain, secure: this.cookieDomain !== 'localhost', expires: undefined };
	        if (token === '') {
	            this.cookies.remove(this.key, opts);
	            this.cookies.remove(this.partnerKey, opts);
	        }
	        else if (rememberMe) {
	            if (this.cookieExpiresDays) {
	                var date = new Date();
	                date.setDate(date.getDate() + this.cookieExpiresDays);
	                opts.expires = date;
	            }
	            this.cookies.put(this.key, token, opts);
	        }
	    };
	    return AuthTokenService;
	}());
	exports.AuthTokenService = AuthTokenService;
	exports.default = AuthTokenService;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2018
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var blog_service_1 = __webpack_require__(184);
	var BlogService = /** @class */ (function (_super) {
	    __extends(BlogService, _super);
	    BlogService.$inject = ["$log", "server"];
	    function BlogService($log, server) {
	        'ngInject';
	        return _super.call(this, $log, server) || this;
	    }
	    return BlogService;
	}(blog_service_1.BlogService));
	exports.default = BlogService;
	// class BlogService {
	//   public $log;
	//   public server: any;
	//   constructor ($log, server) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.server = server;
	//   }
	//   read(category) {
	//     return this.server.get('/blog?category='+category);
	//   }
	// }
	// export default BlogService;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2018
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var BlogService = /** @class */ (function () {
	    function BlogService(log, server) {
	        this.log = log;
	        this.server = server;
	    }
	    BlogService.prototype.read = function (category) {
	        return this.server.get('/blog?category=' + category);
	    };
	    return BlogService;
	}());
	exports.BlogService = BlogService;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var BookmarksService = /** @class */ (function () {
	    BookmarksService.$inject = ["$log", "store", "changes", "segment", "utils"];
	    function BookmarksService($log, store, changes, segment, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "bookmarks", changes.treeStream(), function (s) { return utils.addCreateEditDates(s); });
	    }
	    BookmarksService.prototype.create = function (o) {
	        this.segment.track('bookmarks.create');
	        return this.store.create(o);
	    };
	    BookmarksService.prototype.del = function (id) {
	        this.segment.track('bookmarks.delete');
	        return this.store.del(id);
	    };
	    BookmarksService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    BookmarksService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    BookmarksService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    return BookmarksService;
	}());
	exports.default = BookmarksService;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var CacheService = /** @class */ (function () {
	    CacheService.$inject = ["$log", "$window", "rx"];
	    function CacheService($log, $window, rx) {
	        'ngInject';
	        this.$log = $log;
	        this.dexie = $window.Dexie;
	        this.rx = rx;
	        this.databaseName = null;
	        this.database = null;
	        this.maxObjs = 5000;
	    }
	    CacheService.prototype.readCache = function (userId, treeId, collection) {
	        var _this = this;
	        var db = this._getDb(userId, treeId);
	        return this.rx.Observable.fromPromise(db[collection].count()).flatMap(function (count) {
	            if (count === 0) {
	                return _this.rx.Observable.of({ eTag: '0.0', data: [] });
	            }
	            var requests = [];
	            var offset = 0;
	            while (offset < count) {
	                requests.push(_this.rx.Observable.fromPromise(db[collection].offset(offset).limit(_this.maxObjs).toArray()));
	                offset += _this.maxObjs;
	            }
	            return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(requests)).map(function (results) {
	                results = [].concat.apply([], __spread(results)); // flatten
	                var sumIds = results.reduce(function (sum, obj) { return sum + (obj.id & 0x7fffffff); }, 0);
	                var sumVers = results.reduce(function (sum, obj) { return sum + obj.version; }, 0);
	                return { eTag: sumIds + '.' + sumVers, data: results };
	            });
	            var _a;
	            //});
	            //return this.rx.Observable.fromPromise(db[collection].toArray()).map(objs => {
	            //  let sumIds = objs.reduce((sum, obj) => sum + (obj.id & 0x7fffffff), 0);
	            //  let sumVers = objs.reduce((sum, obj) => sum + obj.version, 0);
	            //  return {eTag: sumIds+'.'+sumVers, data: objs};
	        }).catch(function (err) {
	            _this.$log.warn('cache.readCache error', err, collection);
	            return _this.rx.Observable.of(null);
	        });
	        //return this._getKey(userId).flatMap(key => {
	        //  return this.rx.Observable.fromPromise(db[collection].toArray()).map(objs => {
	        //    return objs.map(obj => this.crypto.decrypt(obj.data, key));
	        //  });
	        //}).flatMap(decryptions => {
	        //  return decryptions.length === 0 ? this.rx.Observable.of([]) : this.rx.Observable.forkJoin(...decryptions);
	        //}).catch(err => {
	        //  this.$log.warn('cache.readCache error', err);
	        //  return this.rx.Observable.of(null);
	        //});
	    };
	    CacheService.prototype.replaceCache = function (userId, treeId, collection, objs) {
	        var _this = this;
	        var db = this._getDb(userId, treeId);
	        var table = db[collection];
	        return this.rx.Observable.fromPromise(db.transaction('rw', table, function () {
	            table.clear();
	            var start = 0;
	            while (start < objs.length) {
	                var end = Math.min(start + _this.maxObjs, objs.length);
	                table.bulkAdd(objs.slice(start, end));
	                start = end;
	            }
	        }));
	        //return (!objs || objs.length === 0 ? this.rx.Observable.of([]) : this._getKey(userId).flatMap(key => {
	        //  return this.rx.Observable.forkJoin(...objs.map(obj => {
	        //    return this.crypto.encrypt(obj, key).map(data => {
	        //      return {id: obj.id, version: obj.version, data: data};
	        //    });
	        //  }));
	        //})).flatMap(objs => {
	        //    return this.rx.Observable.fromPromise(db.transaction('rw', table, () => {
	        //      table.clear();
	        //      if (objs.length > 0) {
	        //        table.bulkAdd(objs);
	        //      }
	        //    }));
	        //  });
	    };
	    CacheService.prototype.updateCache = function (userId, treeId, collection, id, obj) {
	        var db = this._getDb(userId, treeId);
	        var table = db[collection];
	        if (!obj) {
	            return this.rx.Observable.fromPromise(table.delete(id));
	        }
	        else {
	            return this.rx.Observable.fromPromise(table.put(obj));
	        }
	        //if (!obj) {
	        //  return this.rx.Observable.fromPromise(table.delete(id));
	        //}
	        //else {
	        //  return this._getKey(userId).flatMap(key => {
	        //    return this.crypto.encrypt(obj, key).map(data => {
	        //      return {id: obj.id, version: obj.version, data: data};
	        //    });
	        //  }).flatMap(obj => {
	        //    return this.rx.Observable.fromPromise(table.put(obj));
	        //  });
	        //}
	    };
	    CacheService.prototype.deleteAllDatabases = function () {
	        var _this = this;
	        // close database
	        if (!!this.database) {
	            this.database.close();
	        }
	        this.databaseName = null;
	        this.database = null;
	        // delete all databases
	        return this.rx.Observable.fromPromise(this.dexie.getDatabaseNames()).flatMap(function (dbNames) {
	            return dbNames.length === 0 ? _this.rx.Observable.of(true) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(dbNames.map(function (dbName) {
	                return _this.rx.Observable.fromPromise(_this.dexie.delete(dbName));
	            })));
	            var _a;
	        });
	    };
	    // no longer used
	    CacheService.prototype._getKey = function (userId) {
	        var _this = this;
	        return this.currentUserId.streamIdKey().filter(function (u) { return u.id === userId; }).take(1).flatMap(function (u) {
	            return _this.crypto.getKey(u.secretKey);
	        });
	    };
	    CacheService.prototype._getDb = function (userId, treeId) {
	        var dbName = 'tree1_' + treeId + '_' + userId;
	        if (this.databaseName === dbName) {
	            return this.database;
	        }
	        else if (!!this.database) {
	            this.database.close();
	        }
	        var db = new this.dexie(dbName);
	        db.version(1).stores({
	            comments: 'id',
	            evidences: 'id',
	            families: 'id',
	            invitations: 'id',
	            leads: 'id',
	            likes: 'id',
	            media: 'id',
	            notes: 'id',
	            notifications: 'id',
	            ordinances: 'id',
	            persons: 'id',
	            sources: 'id',
	            stories: 'id',
	            warnings: 'id'
	        });
	        db.version(2).stores({
	            research_logs: 'id'
	        });
	        this.databaseName = dbName;
	        this.database = db;
	        return db;
	    };
	    return CacheService;
	}());
	exports.default = CacheService;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var changes_service_1 = __webpack_require__(188);
	var ChangesService = /** @class */ (function (_super) {
	    __extends(ChangesService, _super);
	    ChangesService.$inject = ["$log", "$rootScope", "rx", "pusher", "currentUserId", "currentTreeId", "rightsFull", "messageBus"];
	    function ChangesService($log, $rootScope, rx, pusher, currentUserId, currentTreeId, rightsFull, messageBus) {
	        'ngInject';
	        return _super.call(this, $log, $rootScope, pusher, rx, currentUserId, currentTreeId, rightsFull, messageBus) || this;
	    }
	    return ChangesService;
	}(changes_service_1.ChangesService));
	exports.default = ChangesService;
	// class ChangesService {
	//   constructor($log, $rootScope, rx, pusher, currentUserId, currentTreeId, rightsFull, messageBus) {
	//     'ngInject';
	//     this.treeSubject = new rx.Subject();
	//     this.treeUserSubject = new rx.Subject();
	//     this.userSubject = new rx.Subject();
	//     let subscribed = new Map();
	//     function treeChannel(id) {
	//       return 'private-tree_' + id;
	//     }
	//     function treeUserChannel(treeId, userId) {
	//       return 'private-tree-user_' + treeId + '_' + userId;
	//     }
	//     function userChannel(id) {
	//       return 'private-user_' + id;
	//     }
	//     function subscribe(ch, treeId, userId, subject) {
	//       let sub = pusher.subscribe(ch);
	//       if (!sub) {
	//         return;
	//       }
	//       subscribed.set(ch, true);
	//       sub.bind('change', change => {
	//         $rootScope.$apply(() => {
	//           change = Object.assign(change, {_treeId: treeId, _userId: userId});
	//           $log.debug('changes.bind', change);
	//           subject.next(change);
	//         });
	//       });
	//       sub.bind('pusher:subscription_error', msg => {
	//         $rootScope.$apply(() => {
	//           $log.debug('changes.bind pusher:subscription_error', msg);
	//           messageBus.post({msg:'PUSHER_ERROR'});
	//         });
	//       });
	//       sub.bind('pusher:error', msg => {
	//         $rootScope.$apply(() => {
	//           $log.debug('changes.bind pusher:error', msg);
	//           messageBus.post({msg:'PUSHER_ERROR'});
	//         });
	//       });
	//       sub.bind('error', msg => {
	//         $rootScope.$apply(() => {
	//           $log.debug('changes.bind error', msg);
	//           messageBus.post({msg:'PUSHER_ERROR'});
	//         });
	//       });
	//       sub.bind_all(msg => {
	//         $rootScope.$apply(() => {
	//           $log.debug('changes.bind_all', msg);
	//         });
	//       });
	//     }
	//     function unsubscribe(ch) {
	//       if (subscribed.get(ch)) {
	//         pusher.unsubscribe(ch);
	//         subscribed.delete(ch);
	//       }
	//     }
	//     this.treeId = 0;
	//     this.userId = 0;
	//     currentTreeId.stream().combineLatest(currentUserId.stream()).subscribe(ids => {
	//       let [treeId, userId] = ids;
	//       if (this.treeId !== treeId && this.treeId !== 0) {
	//         unsubscribe(treeChannel(this.treeId));
	//       }
	//       if (this.userId !== userId && this.userId !== 0) {
	//         unsubscribe(userChannel(this.userId));
	//       }
	//       if ((this.treeId !== treeId || this.userId !== userId) && this.treeId !== 0 && this.userId !== 0) {
	//         unsubscribe(treeUserChannel(this.treeId, this.userId));
	//       }
	//       rightsFull.getLevel(treeId, userId).subscribe(level => {
	//         if (this.treeId !== treeId && treeId !== 0 && level > 0) { // don't subscribe guests
	//           subscribe(treeChannel(treeId), treeId, 0, this.treeSubject);
	//         }
	//         if (this.userId !== userId && userId !== 0) {
	//           subscribe(userChannel(userId), 0, userId, this.userSubject);
	//         }
	//         if ((this.treeId !== treeId || this.userId !== userId) && treeId !== 0 && userId !== 0 && level > 0) { // don't subscribe guests
	//           subscribe(treeUserChannel(treeId, userId), treeId, userId, this.treeUserSubject);
	//         }
	//         this.treeId = treeId;
	//         this.userId = userId;
	//       });
	//     });
	//     // treeUser changes cause rightsFull to re-read
	//     // (can't put this in rightsFull because it would cause a circular dependency)
	//     this.treeUserSubject.subscribe(() => {
	//       rightsFull.readRights();
	//     });
	//   }
	//   treeStream() {
	//     return this.treeSubject;
	//   }
	//   userStream() {
	//     return this.userSubject;
	//   }
	//   treeUserStream() {
	//     return this.treeUserSubject;
	//   }
	// }
	// export default ChangesService;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Subject } from "../../node_modules/rxjs";
	var ChangesService = /** @class */ (function () {
	    function ChangesService(log, rootScope, pusher, rx, currentUserId, currentTreeId, rightsFull, messageBus) {
	        var _this = this;
	        this.treeSubject = new rx.Subject();
	        this.treeUserSubject = new rx.Subject();
	        this.userSubject = new rx.Subject();
	        var subscribed = new Map();
	        function treeChannel(id) {
	            return 'private-tree_' + id;
	        }
	        function treeUserChannel(treeId, userId) {
	            return 'private-tree-user_' + treeId + '_' + userId;
	        }
	        function userChannel(id) {
	            return 'private-user_' + id;
	        }
	        function subscribe(ch, treeId, userId, subject) {
	            var sub = pusher.subscribe(ch);
	            if (!sub) {
	                return;
	            }
	            subscribed.set(ch, true);
	            sub.bind('change', function (change) {
	                rootScope.$apply(function () {
	                    change = Object.assign(change, { _treeId: treeId, _userId: userId });
	                    log.debug('changes.bind', change);
	                    subject.next(change);
	                });
	            });
	            sub.bind('pusher:subscription_error', function (msg) {
	                rootScope.$apply(function () {
	                    log.info('changes.bind pusher:subscription_error', msg);
	                    // not serious enough to notify user
	                    //messageBus.post({msg:'PUSHER_ERROR'});
	                });
	            });
	            sub.bind('pusher:error', function (msg) {
	                rootScope.$apply(function () {
	                    log.info('changes.bind pusher:error', msg);
	                    // not serious enough to notify user
	                    //messageBus.post({msg:'PUSHER_ERROR'});
	                });
	            });
	            sub.bind('error', function (msg) {
	                rootScope.$apply(function () {
	                    log.info('changes.bind error', msg);
	                    // not serious enough to notify user
	                    //messageBus.post({msg:'PUSHER_ERROR'});
	                });
	            });
	            sub.bind_all(function (msg) {
	                rootScope.$apply(function () {
	                    log.debug('changes.bind_all', msg);
	                });
	            });
	        }
	        function unsubscribe(ch) {
	            if (subscribed.get(ch)) {
	                pusher.unsubscribe(ch);
	                subscribed.delete(ch);
	            }
	        }
	        this.treeId = 0;
	        this.userId = 0;
	        currentTreeId.stream().combineLatest(currentUserId.stream()).subscribe(function (ids) {
	            var _a = __read(ids, 2), treeId = _a[0], userId = _a[1];
	            if (_this.treeId !== treeId && _this.treeId !== 0) {
	                unsubscribe(treeChannel(_this.treeId));
	            }
	            if (_this.userId !== userId && _this.userId !== 0) {
	                unsubscribe(userChannel(_this.userId));
	            }
	            if ((_this.treeId !== treeId || _this.userId !== userId) && _this.treeId !== 0 && _this.userId !== 0) {
	                unsubscribe(treeUserChannel(_this.treeId, _this.userId));
	            }
	            rightsFull.getLevel(treeId, userId).subscribe(function (level) {
	                if (_this.treeId !== treeId && treeId !== 0 && level > 0) {
	                    subscribe(treeChannel(treeId), treeId, 0, _this.treeSubject);
	                }
	                if (_this.userId !== userId && userId !== 0) {
	                    subscribe(userChannel(userId), 0, userId, _this.userSubject);
	                }
	                if ((_this.treeId !== treeId || _this.userId !== userId) && treeId !== 0 && userId !== 0 && level > 0) {
	                    subscribe(treeUserChannel(treeId, userId), treeId, userId, _this.treeUserSubject);
	                }
	                _this.treeId = treeId;
	                _this.userId = userId;
	            });
	        });
	        // treeUser changes cause rightsFull to re-read
	        // (can't put this in rightsFull because it would cause a circular dependency)
	        this.treeUserSubject.subscribe(function () {
	            rightsFull.readRights();
	        });
	    }
	    ChangesService.prototype.treeStream = function () {
	        return this.treeSubject;
	    };
	    ChangesService.prototype.userStream = function () {
	        return this.userSubject;
	    };
	    ChangesService.prototype.treeUserStream = function () {
	        return this.treeUserSubject;
	    };
	    return ChangesService;
	}());
	exports.ChangesService = ChangesService;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ClusterService = /** @class */ (function () {
	    ClusterService.$inject = ["$window"];
	    function ClusterService($window) {
	        'ngInject';
	        var blob = new Blob([
	            "\n\"use strict\";\n\nvar _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"]) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); } }; }();\n\nfunction _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }\n\nvar minimumCM = 1;\nvar maximumCM = 7200;\n\nfunction quickCluster(nodes, links) {\n  if (nodes.length === 0) {\n    return [];\n  }\n  var tree = new Map();\n  var allCMs = new Map();\n  var _iteratorNormalCompletion = true;\n  var _didIteratorError = false;\n  var _iteratorError = undefined;\n\n  try {\n    for (var _iterator = links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {\n      var link = _step.value;\n\n      if (!allCMs.has(link.kit1)) {\n        allCMs.set(link.kit1, []);\n      }\n      if (!allCMs.has(link.kit2)) {\n        allCMs.set(link.kit2, []);\n      }\n      allCMs.get(link.kit1).push({ kit: link.kit2, cM: link.value });\n      allCMs.get(link.kit2).push({ kit: link.kit1, cM: link.value });\n    }\n  } catch (err) {\n    _didIteratorError = true;\n    _iteratorError = err;\n  } finally {\n    try {\n      if (!_iteratorNormalCompletion && _iterator.return) {\n        _iterator.return();\n      }\n    } finally {\n      if (_didIteratorError) {\n        throw _iteratorError;\n      }\n    }\n  }\n\n  var treeIxs = new Map();\n  var treeIx = 1;\n  var _iteratorNormalCompletion2 = true;\n  var _didIteratorError2 = false;\n  var _iteratorError2 = undefined;\n\n  try {\n    for (var _iterator2 = nodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {\n      var node = _step2.value;\n\n      tree.set(treeIx, {\n        node: node,\n        cMs: new Map(allCMs.get(node.name).filter(function (kitCM) {\n          return treeIxs.has(kitCM.kit);\n        }).map(function (kitCM) {\n          return [treeIxs.get(kitCM.kit), kitCM.cM];\n        })),\n        cM: maximumCM\n      });\n      treeIxs.set(node.name, treeIx);\n      treeIx++;\n    }\n  } catch (err) {\n    _didIteratorError2 = true;\n    _iteratorError2 = err;\n  } finally {\n    try {\n      if (!_iteratorNormalCompletion2 && _iterator2.return) {\n        _iterator2.return();\n      }\n    } finally {\n      if (_didIteratorError2) {\n        throw _iteratorError2;\n      }\n    }\n  }\n\n  var targetMap = new Map();\n  while (true) {\n    var _getMaxPairs = getMaxPairs(tree),\n        _getMaxPairs2 = _slicedToArray(_getMaxPairs, 2),\n        maxCM = _getMaxPairs2[0],\n        pairs = _getMaxPairs2[1];\n\n    if (maxCM < minimumCM) {\n      break;\n    }\n    targetMap.clear();\n    var _iteratorNormalCompletion3 = true;\n    var _didIteratorError3 = false;\n    var _iteratorError3 = undefined;\n\n    try {\n      for (var _iterator3 = pairs[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {\n        var _step3$value = _slicedToArray(_step3.value, 2),\n            i = _step3$value[0],\n            j = _step3$value[1];\n\n        i = getTarget(targetMap, i);\n        j = getTarget(targetMap, j);\n        if (i !== j) {\n          mergePair(i, j, treeIx, maxCM, tree);\n          targetMap.set(i, treeIx);\n          targetMap.set(j, treeIx);\n          treeIx++;\n        }\n      }\n    } catch (err) {\n      _didIteratorError3 = true;\n      _iteratorError3 = err;\n    } finally {\n      try {\n        if (!_iteratorNormalCompletion3 && _iterator3.return) {\n          _iterator3.return();\n        }\n      } finally {\n        if (_didIteratorError3) {\n          throw _iteratorError3;\n        }\n      }\n    }\n  }\n  return Array.from(tree.values());\n}\n\nfunction getTarget(targetMap, i) {\n  while (true) {\n    var target = targetMap.get(i);\n    if (!target) {\n      return i;\n    } else {\n      i = target;\n    }\n  }\n}\n\nfunction getMaxPairs(tree) {\n  var pairs = [];\n  var maxCM = 0;\n  var _iteratorNormalCompletion4 = true;\n  var _didIteratorError4 = false;\n  var _iteratorError4 = undefined;\n\n  try {\n    for (var _iterator4 = tree[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {\n      var _step4$value = _slicedToArray(_step4.value, 2),\n          key = _step4$value[0],\n          value = _step4$value[1];\n\n      var _iteratorNormalCompletion5 = true;\n      var _didIteratorError5 = false;\n      var _iteratorError5 = undefined;\n\n      try {\n        for (var _iterator5 = value.cMs[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {\n          var _step5$value = _slicedToArray(_step5.value, 2),\n              ix = _step5$value[0],\n              cM = _step5$value[1];\n\n          cM = Math.floor(cM);\n          if (cM > maxCM) {\n            maxCM = cM;\n            pairs = [[key, ix]];\n          } else if (cM === maxCM) {\n            pairs.push([key, ix]);\n          }\n        }\n      } catch (err) {\n        _didIteratorError5 = true;\n        _iteratorError5 = err;\n      } finally {\n        try {\n          if (!_iteratorNormalCompletion5 && _iterator5.return) {\n            _iterator5.return();\n          }\n        } finally {\n          if (_didIteratorError5) {\n            throw _iteratorError5;\n          }\n        }\n      }\n    }\n  } catch (err) {\n    _didIteratorError4 = true;\n    _iteratorError4 = err;\n  } finally {\n    try {\n      if (!_iteratorNormalCompletion4 && _iterator4.return) {\n        _iterator4.return();\n      }\n    } finally {\n      if (_didIteratorError4) {\n        throw _iteratorError4;\n      }\n    }\n  }\n\n  return [maxCM, pairs];\n}\n\nfunction mergePair(i, j, target, maxCM, tree) {\n  var cMis = new Map();\n  var cMjs = new Map();\n  var iNode = void 0;\n  var jNode = void 0;\n  var iNumChildren = 0;\n  var jNumChildren = 0;\n  var _iteratorNormalCompletion6 = true;\n  var _didIteratorError6 = false;\n  var _iteratorError6 = undefined;\n\n  try {\n    for (var _iterator6 = tree[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {\n      var _step6$value = _slicedToArray(_step6.value, 2),\n          key = _step6$value[0],\n          value = _step6$value[1];\n\n      if (key === i) {\n        iNode = value;\n        iNumChildren = value.numChildren || 1;\n        var _iteratorNormalCompletion8 = true;\n        var _didIteratorError8 = false;\n        var _iteratorError8 = undefined;\n\n        try {\n          for (var _iterator8 = value.cMs[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {\n            var _step8$value = _slicedToArray(_step8.value, 2),\n                k = _step8$value[0],\n                v = _step8$value[1];\n\n            cMis.set(k, v);\n          }\n        } catch (err) {\n          _didIteratorError8 = true;\n          _iteratorError8 = err;\n        } finally {\n          try {\n            if (!_iteratorNormalCompletion8 && _iterator8.return) {\n              _iterator8.return();\n            }\n          } finally {\n            if (_didIteratorError8) {\n              throw _iteratorError8;\n            }\n          }\n        }\n      } else if (value.cMs.has(i)) {\n        cMis.set(key, value.cMs.get(i));\n        value.cMs.delete(i);\n      }\n      if (key === j) {\n        jNode = value;\n        jNumChildren = value.numChildren || 1;\n        var _iteratorNormalCompletion9 = true;\n        var _didIteratorError9 = false;\n        var _iteratorError9 = undefined;\n\n        try {\n          for (var _iterator9 = value.cMs[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {\n            var _step9$value = _slicedToArray(_step9.value, 2),\n                k = _step9$value[0],\n                v = _step9$value[1];\n\n            cMjs.set(k, v);\n          }\n        } catch (err) {\n          _didIteratorError9 = true;\n          _iteratorError9 = err;\n        } finally {\n          try {\n            if (!_iteratorNormalCompletion9 && _iterator9.return) {\n              _iterator9.return();\n            }\n          } finally {\n            if (_didIteratorError9) {\n              throw _iteratorError9;\n            }\n          }\n        }\n      } else if (value.cMs.has(j)) {\n        cMjs.set(key, value.cMs.get(j));\n        value.cMs.delete(j);\n      }\n    }\n  } catch (err) {\n    _didIteratorError6 = true;\n    _iteratorError6 = err;\n  } finally {\n    try {\n      if (!_iteratorNormalCompletion6 && _iterator6.return) {\n        _iterator6.return();\n      }\n    } finally {\n      if (_didIteratorError6) {\n        throw _iteratorError6;\n      }\n    }\n  }\n\n  var numChildren = iNumChildren + jNumChildren;\n  var cMs = new Map();\n  var keys = new Set([].concat(_toConsumableArray(cMis.keys()), _toConsumableArray(cMjs.keys())));\n  var _iteratorNormalCompletion7 = true;\n  var _didIteratorError7 = false;\n  var _iteratorError7 = undefined;\n\n  try {\n    for (var _iterator7 = keys[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {\n      var key = _step7.value;\n\n      if (key === i || key === j) {\n        continue;\n      }\n      var vi = cMis.get(key) || 0;\n      var vj = cMjs.get(key) || 0;\n      var avg = (vi * iNumChildren + vj * jNumChildren) / numChildren;\n      if (avg >= minimumCM) {\n        cMs.set(key, avg);\n      }\n    }\n  } catch (err) {\n    _didIteratorError7 = true;\n    _iteratorError7 = err;\n  } finally {\n    try {\n      if (!_iteratorNormalCompletion7 && _iterator7.return) {\n        _iterator7.return();\n      }\n    } finally {\n      if (_didIteratorError7) {\n        throw _iteratorError7;\n      }\n    }\n  }\n\n  var children = void 0;\n  if (maxCM === Math.min(iNode.cM, jNode.cM)) {\n    children = [].concat(iNode.node ? [iNode] : iNode.children, jNode.node ? [jNode] : jNode.children);\n  } else {\n    children = [iNode, jNode];\n  }\n  tree.delete(i);\n  tree.delete(j);\n  tree.set(target, {\n    numChildren: numChildren,\n    children: children,\n    cMs: cMs,\n    cM: maxCM\n  });\n}\n\nfunction clusterToTree(c) {\n  if (c.node) {\n    c = c.node;\n  } else {\n    c.children = c.children.map(function (child) {\n      return clusterToTree(child);\n    });\n  }\n  return c;\n}\n\nself.addEventListener('message', function(e) {\n  var result = quickCluster(e.data.nodes, e.data.links).map(v => clusterToTree(v));\n  self.postMessage(result);\n}, false);\n      "
	        ]);
	        this.blobURL = $window.URL.createObjectURL(blob);
	        // don't need to call this because the object is never destroyed: window.URL.revokeObjectURL(blobURL);
	    }
	    ClusterService.prototype.getBlobURL = function () {
	        return this.blobURL;
	    };
	    return ClusterService;
	}());
	exports.default = ClusterService;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var comments_service_1 = __webpack_require__(191);
	var CommentsService = /** @class */ (function (_super) {
	    __extends(CommentsService, _super);
	    CommentsService.$inject = ["$log", "rx", "store", "changes", "segment", "utils"];
	    function CommentsService($log, rx, store, changes, segment, utils) {
	        'ngInject';
	        return _super.call(this, rx, store, changes, segment, utils) || this;
	    }
	    return CommentsService;
	}(comments_service_1.CommentsService));
	exports.default = CommentsService;
	// class CommentsService {
	//   constructor ($log, rx, store, changes, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", "comments", changes.treeStream(), (s) => utils.addCreateEditDates(s));
	//   }
	//   create(o) {
	//     this.segment.track('comments.create');
	//     return this.store.create(o);
	//   }
	//   update(o) {
	//     this.segment.track('comments.update');
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     this.segment.track('comments.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id).map(cmt => cmt || {id: id, version: 0, comments: new Map()});
	//   }
	//   //
	//   // helper functions
	//   //
	//   augmentComment(c, users) {
	//     let subject = new this.rx.AsyncSubject();
	//     c = Object.assign({}, c, {
	//       '_comments': []
	//     });
	//     // set _comments
	//     (c.comments.size === 0 ? this.rx.Observable.of([]) : this.rx.Observable.forkJoin(...Array.from(c.comments.values()).map(userText => users.streamSummaryId(userText.user))))
	//       .subscribe(users => {
	//         c._comments = Array.from(c.comments.entries())
	//           .sort((a, b) => a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0)
	//           .map(([date, userText]) => {
	//             return {
	//               date: date,
	//               user: users.find(u => u.id === userText.user),
	//               text: userText.text
	//             };
	//           });
	//         subject.next(c);
	//         subject.complete();
	//       });
	//     return subject;
	//   }
	// }
	// export default CommentsService;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { AsyncSubject } from "../../node_modules/rxjs";
	var CommentsService = /** @class */ (function () {
	    function CommentsService(rx, store, changes, segment, utils) {
	        this.rx = rx;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "comments", changes.treeStream(), function (s) { return utils.addCreateEditDates(s); });
	    }
	    CommentsService.prototype.create = function (o) {
	        this.segment.track('comments.create');
	        return this.store.create(o);
	    };
	    CommentsService.prototype.update = function (o) {
	        this.segment.track('comments.update');
	        return this.store.update(o);
	    };
	    CommentsService.prototype.del = function (id) {
	        this.segment.track('comments.delete');
	        return this.store.del(id);
	    };
	    CommentsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    CommentsService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    CommentsService.prototype.streamId = function (id) {
	        return this.store.streamId(id).map(function (cmt) { return cmt || { id: id, version: 0, comments: new Map() }; });
	    };
	    //
	    // helper functions
	    //
	    CommentsService.prototype.augmentComment = function (c, users) {
	        var subject = new this.rx.AsyncSubject();
	        c = Object.assign({}, c, {
	            '_comments': []
	        });
	        //TODO add comment interface type
	        // set _comments
	        (c.comments.size === 0 ? this.rx.Observable.of([]) : (_a = this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(c.comments.values()).map(function (userText) { return users.streamSummaryId(userText.user); }))))
	            .subscribe(function (users) {
	            c._comments = Array.from(c.comments.entries())
	                .sort(function (a, b) { return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0; })
	                .map(function (_a) {
	                var _b = __read(_a, 2), date = _b[0], userText = _b[1];
	                return {
	                    date: date,
	                    user: users.find(function (u) { return u.id === userText.user; }),
	                    text: userText.text
	                };
	            });
	            subject.next(c);
	            subject.complete();
	        });
	        return subject;
	        var _a;
	    };
	    return CommentsService;
	}());
	exports.CommentsService = CommentsService;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var currentTree_service_1 = __webpack_require__(193);
	var CurrentTreeService = /** @class */ (function (_super) {
	    __extends(CurrentTreeService, _super);
	    CurrentTreeService.$inject = ["$log", "store", "currentTreeId", "changes", "segment", "utils"];
	    function CurrentTreeService($log, store, currentTreeId, changes, segment, utils) {
	        'ngInject';
	        return _super.call(this, $log, store, currentTreeId, changes, segment, utils) || this;
	    }
	    return CurrentTreeService;
	}(currentTree_service_1.CurrentTreeService));
	exports.default = CurrentTreeService;
	// class CurrentTreeService {
	//   constructor ($log, store, currentTreeId, changes, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.currentTreeId = currentTreeId;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", null, changes.treeStream());
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   create(tree, params) {
	//     let [s, t] = this.utils.teeAsync(this.store.create(tree, params));
	//     s.subscribe(tree => {
	//       this.$log.debug('currentTree.create', tree);
	//       this.segment.track('tree.create');
	//     });
	//     return t;
	//   }
	//   update(tree, params) {
	//     let [s, t] = this.utils.teeAsync(this.store.update(tree, params));
	//     s.subscribe(tree => {
	//       this.$log.debug('currentTree.update', tree);
	//       this.segment.track('tree.update');
	//     });
	//     return t;
	//   }
	//   del(id) {
	//     let [s, t] = this.utils.teeAsync(this.store.del(id));
	//     s.subscribe(() => {
	//       this.$log.debug('currentTree.del', id);
	//       this.currentTreeId.set(0);
	//       this.segment.track('tree.delete');
	//     });
	//     return t;
	//   }
	//   stream() {
	//     return this.store.stream().map(m => {
	//       let t = this.utils.first(m);
	//       if (!!t) {
	//         t.preferences.COLOR_PGF = t.preferences.COLOR_PGF || 'blue';
	//         t.preferences.COLOR_PGM = t.preferences.COLOR_PGM || 'green';
	//         t.preferences.COLOR_MGF = t.preferences.COLOR_MGF || 'red';
	//         t.preferences.COLOR_MGM = t.preferences.COLOR_MGM || 'yellow';
	//         t.preferences.COLOR_1   = t.preferences.COLOR_1 || 'purple';
	//         t.preferences.COLOR_2   = t.preferences.COLOR_2 || 'aqua';
	//         t.preferences.COLOR_3   = t.preferences.COLOR_3 || 'magenta';
	//         t.preferences.COLOR_4   = t.preferences.COLOR_4 || 'aquamarine';
	//         t.preferences.COLOR_NOT = t.preferences.COLOR_NOT || 'orange';
	//       }
	//       return t;
	//     }).filter(t => t !== null);
	//   }
	// }
	// export default CurrentTreeService;


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Observable } from "../../node_modules/rxjs";
	var CurrentTreeService = /** @class */ (function () {
	    function CurrentTreeService(log, store, currentTreeId, changes, segment, utils) {
	        this.log = log;
	        this.currentTreeId = currentTreeId;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", null, changes.treeStream());
	    }
	    CurrentTreeService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    CurrentTreeService.prototype.create = function (tree, params) {
	        var _this = this;
	        var _a = __read(this.utils.teeAsync(this.store.create(tree, params)), 2), s = _a[0], t = _a[1];
	        s.subscribe(function (tree) {
	            _this.log.debug('currentTree.create', tree);
	            _this.segment.track('tree.create');
	        });
	        return t;
	    };
	    CurrentTreeService.prototype.update = function (tree, params) {
	        var _this = this;
	        var _a = __read(this.utils.teeAsync(this.store.update(tree, params)), 2), s = _a[0], t = _a[1];
	        s.subscribe(function (tree) {
	            _this.log.debug('currentTree.update', tree);
	            _this.segment.track('tree.update');
	        });
	        return t;
	    };
	    CurrentTreeService.prototype.del = function (id) {
	        var _this = this;
	        var _a = __read(this.utils.teeAsync(this.store.del(id)), 2), s = _a[0], t = _a[1];
	        s.subscribe(function () {
	            _this.log.debug('currentTree.del', id);
	            _this.currentTreeId.set(0);
	            _this.segment.track('tree.delete');
	        });
	        return t;
	    };
	    CurrentTreeService.prototype.stream = function () {
	        var _this = this;
	        return this.store.stream().map(function (m) {
	            var t = _this.utils.first(m);
	            if (!!t) {
	                t.preferences.COLOR_PGF = t.preferences.COLOR_PGF || 'blue';
	                t.preferences.COLOR_PGM = t.preferences.COLOR_PGM || 'green';
	                t.preferences.COLOR_MGF = t.preferences.COLOR_MGF || 'red';
	                t.preferences.COLOR_MGM = t.preferences.COLOR_MGM || 'yellow';
	                t.preferences.COLOR_1 = t.preferences.COLOR_1 || 'purple';
	                t.preferences.COLOR_2 = t.preferences.COLOR_2 || 'aqua';
	                t.preferences.COLOR_3 = t.preferences.COLOR_3 || 'magenta';
	                t.preferences.COLOR_4 = t.preferences.COLOR_4 || 'aquamarine';
	                t.preferences.COLOR_5 = t.preferences.COLOR_5 || 'grey';
	                t.preferences.COLOR_6 = t.preferences.COLOR_6 || 'black';
	                t.preferences.COLOR_NOT = t.preferences.COLOR_NOT || 'orange';
	                t.preferences.COLOR_LABEL_1 = t.preferences.COLOR_LABEL_1 || 'Custom #1';
	                t.preferences.COLOR_LABEL_2 = t.preferences.COLOR_LABEL_2 || 'Custom #2';
	                t.preferences.COLOR_LABEL_3 = t.preferences.COLOR_LABEL_3 || 'Custom #3';
	                t.preferences.COLOR_LABEL_4 = t.preferences.COLOR_LABEL_4 || 'Custom #4';
	                t.preferences.COLOR_LABEL_5 = t.preferences.COLOR_LABEL_5 || 'Custom #5';
	                t.preferences.COLOR_LABEL_6 = t.preferences.COLOR_LABEL_6 || 'Custom #6';
	            }
	            return t;
	        }).filter(function (t) { return t !== null; });
	    };
	    return CurrentTreeService;
	}());
	exports.CurrentTreeService = CurrentTreeService;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var currentTreeId_service_1 = __webpack_require__(195);
	var CurrentTreeIdService = /** @class */ (function (_super) {
	    __extends(CurrentTreeIdService, _super);
	    CurrentTreeIdService.$inject = ["$log", "$rootScope", "rx"];
	    function CurrentTreeIdService($log, $rootScope, rx) {
	        'ngInject';
	        return _super.call(this, $log, $rootScope, rx) || this;
	    }
	    return CurrentTreeIdService;
	}(currentTreeId_service_1.CurrentTreeIdService));
	exports.default = CurrentTreeIdService;
	// class CurrentTreeIdService {
	//   constructor ($log, $rootScope, rx) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.$rootScope = $rootScope;
	//     this.subject = new rx.BehaviorSubject(-1);
	//   }
	//   get() {
	//     return this.subject.getValue();
	//   }
	//   set(id) {
	//     if (id !== this.get()) {
	//       this.$log.debug('currentTreeID.set', id);
	//       if (id > 0) {
	//         this.$rootScope.latestTreeId = id;
	//       }
	//       this.$rootScope.fsImportStream = null;
	//       this.subject.next(id);
	//     }
	//   }
	//   stream() {
	//     return this.subject.filter(id => id !== -1);
	//   }
	//   streamAll() {
	//     return this.subject;
	//   }
	//   getBaseURL() {
	//     return '/tree/'+this.subject.getValue();
	//   }
	// }
	// export default CurrentTreeIdService;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { BehaviorSubject } from '../../node_modules/rxjs';
	var CurrentTreeIdService = /** @class */ (function () {
	    function CurrentTreeIdService(log, rootScope, rx) {
	        this.log = log;
	        this.rootScope = rootScope;
	        this.rx = rx;
	        this.subject = new rx.BehaviorSubject(-1);
	    }
	    CurrentTreeIdService.prototype.get = function () {
	        return this.subject.getValue();
	    };
	    CurrentTreeIdService.prototype.set = function (id) {
	        if (id !== this.get()) {
	            this.log.debug('currentTreeID.set', id);
	            if (id > 0) {
	                this.rootScope.latestTreeId = id;
	            }
	            this.rootScope.fsImportStream = null;
	            this.subject.next(id);
	        }
	    };
	    CurrentTreeIdService.prototype.stream = function () {
	        return this.subject.filter(function (id) { return id !== -1; });
	    };
	    CurrentTreeIdService.prototype.streamAll = function () {
	        return this.subject;
	    };
	    CurrentTreeIdService.prototype.getBaseURL = function () {
	        return '/tree/' + this.subject.getValue();
	    };
	    return CurrentTreeIdService;
	}());
	exports.CurrentTreeIdService = CurrentTreeIdService;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var currentUser_service_1 = __webpack_require__(197);
	var CurrentUserService = /** @class */ (function (_super) {
	    __extends(CurrentUserService, _super);
	    CurrentUserService.$inject = ["$log", "rx", "messageBus", "store", "changes", "server", "utils"];
	    function CurrentUserService($log, rx, messageBus, store, changes, server, utils) {
	        'ngInject';
	        return _super.call(this, $log, rx, messageBus, store, changes, server, utils) || this;
	    }
	    return CurrentUserService;
	}(currentUser_service_1.CurrentUserService));
	exports.default = CurrentUserService;
	// class CurrentUserService {
	//   constructor ($log, rx, messageBus, store, changes, server, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.messageBus = messageBus;
	//     this.store = store.create("users", null, changes.userStream());
	//     this.server = server;
	//     this.utils = utils;
	//   }
	//   // returns an array, not a map
	//   readTrees(id) {
	//     return this.server.get('/users/'+id+'/trees', {summary: 'true'})
	//       .catch(err => {
	//         this.messageBus.post({msg: err.data, status: err.status, op: 'GET', ctx: 'users/trees'});
	//         return this.rx.Observable.of({});
	//       });
	//   }
	//   readCurrentTreeId(id) {
	//     return this.server.get('/users/'+id+'/trees/current')
	//       .map(t => t.treeId)
	//       .catch(err => {
	//         this.messageBus.post({msg: err.data, status: err.status, op: 'GET', ctx: 'users/trees/current'});
	//         return this.rx.Observable.of({});
	//       });
	//   }
	//   updateCurrentTreeId(userId, treeId) {
	//     return this.server.put('/users/'+userId+'/trees/current', {treeId})
	//       .catch(err => {
	//         this.messageBus.post({msg: err.data, status: err.status, op: 'PUT', ctx: 'users/trees/current'});
	//         return this.rx.Observable.of({});
	//       });
	//   }
	//   update(user) {
	//     let [s, t] = this.utils.teeAsync(this.store.update(user));
	//     s.subscribe(user => {
	//       this.$log.debug('currentUser.update', user);
	//     });
	//     return t;
	//   }
	//   del(id) {
	//     let [s, t] = this.utils.teeAsync(this.store.del(id));
	//     s.subscribe(() => {
	//       this.$log.debug('currentUser.delete', id);
	//     });
	//     return t;
	//   }
	//   stream() {
	//     return this.store.stream().map(m => this.utils.first(m));
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	// }
	// export default CurrentUserService;


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Observable } from "../../node_modules/rxjs";
	var CurrentUserService = /** @class */ (function () {
	    function CurrentUserService(log, rx, messageBus, store, changes, server, utils) {
	        this.log = log;
	        this.rx = rx;
	        this.messageBus = messageBus;
	        this.server = server;
	        this.utils = utils;
	        this.store = store.create("users", null, changes.userStream());
	    }
	    // returns an array, not a map
	    CurrentUserService.prototype.readTrees = function (id) {
	        var _this = this;
	        return this.server.get('/users/' + id + '/trees', { summary: 'true' })
	            .catch(function (err) {
	            _this.messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'users/trees' });
	            return _this.rx.Observable.of({});
	        });
	    };
	    CurrentUserService.prototype.readCurrentTreeId = function (id) {
	        var _this = this;
	        return this.server.get('/users/' + id + '/trees/current')
	            .map(function (t) { return t.treeId; })
	            .catch(function (err) {
	            _this.messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'users/trees/current' });
	            return _this.rx.Observable.of({});
	        });
	    };
	    CurrentUserService.prototype.updateCurrentTreeId = function (userId, treeId) {
	        var _this = this;
	        return this.server.put('/users/' + userId + '/trees/current', { treeId: treeId })
	            .catch(function (err) {
	            _this.messageBus.post({ msg: err.data, status: err.status, op: 'PUT', ctx: 'users/trees/current' });
	            return _this.rx.Observable.of({});
	        });
	    };
	    CurrentUserService.prototype.update = function (user) {
	        var _this = this;
	        var _a = __read(this.utils.teeAsync(this.store.update(user)), 2), s = _a[0], t = _a[1];
	        s.subscribe(function (user) {
	            _this.log.debug('currentUser.update', user);
	        });
	        return t;
	    };
	    CurrentUserService.prototype.del = function (id) {
	        var _this = this;
	        var _a = __read(this.utils.teeAsync(this.store.del(id)), 2), s = _a[0], t = _a[1];
	        s.subscribe(function () {
	            _this.log.debug('currentUser.delete', id);
	        });
	        return t;
	    };
	    CurrentUserService.prototype.stream = function () {
	        var _this = this;
	        return this.store.stream().map(function (m) { return _this.utils.first(m); });
	    };
	    CurrentUserService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    return CurrentUserService;
	}());
	exports.CurrentUserService = CurrentUserService;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var currentUserId_service_1 = __webpack_require__(199);
	var CurrentUserIdService = /** @class */ (function (_super) {
	    __extends(CurrentUserIdService, _super);
	    CurrentUserIdService.$inject = ["$log", "rx"];
	    function CurrentUserIdService($log, rx) {
	        'ngInject';
	        return _super.call(this, $log, rx) || this;
	    }
	    return CurrentUserIdService;
	}(currentUserId_service_1.CurrentUserIdService));
	exports.default = CurrentUserIdService;
	// class CurrentUserIdService {
	//   constructor ($log, rx) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.subject = new rx.BehaviorSubject({id: -1, secretKey: ''});
	//   }
	//   get() {
	//     return this.subject.getValue().id;
	//   }
	//   set(id, secretKey) {
	//     this.$log.debug('currentUserID.set', id, secretKey);
	//     this.subject.next({id, secretKey});
	//   }
	//   stream() {
	//     return this.subject.filter(u => u.id !== -1).map(u => u.id);
	//   }
	//   streamIdKey() {
	//     return this.subject.filter(u => u.id !== -1);
	//   }
	// }
	// export default CurrentUserIdService;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { BehaviorSubject } from "../../node_modules/rxjs";
	var CurrentUserIdService = /** @class */ (function () {
	    function CurrentUserIdService(log, rx) {
	        this.log = log;
	        this.subject = new rx.BehaviorSubject({ id: -1, secretKey: '' });
	    }
	    CurrentUserIdService.prototype.get = function () {
	        return this.subject.getValue().id;
	    };
	    CurrentUserIdService.prototype.set = function (id, secretKey) {
	        this.log.debug('currentUserID.set', id, secretKey);
	        this.subject.next({ id: id, secretKey: secretKey });
	    };
	    CurrentUserIdService.prototype.stream = function () {
	        return this.subject.filter(function (u) { return u.id !== -1; }).map(function (u) { return u.id; });
	    };
	    CurrentUserIdService.prototype.streamIdKey = function () {
	        return this.subject.filter(function (u) { return u.id !== -1; });
	    };
	    return CurrentUserIdService;
	}());
	exports.CurrentUserIdService = CurrentUserIdService;


/***/ }),
/* 200 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var d3workerService = /** @class */ (function () {
	    d3workerService.$inject = ["$window"];
	    function d3workerService($window) {
	        'ngInject';
	        var forceBlob = new Blob([
	            "\n\"use strict\";\n\nimportScripts(\"https://d3js.org/d3-collection.v1.min.js\");\nimportScripts(\"https://d3js.org/d3-dispatch.v1.min.js\");\nimportScripts(\"https://d3js.org/d3-quadtree.v1.min.js\");\nimportScripts(\"https://d3js.org/d3-timer.v1.min.js\");\nimportScripts(\"https://d3js.org/d3-force.v1.min.js\");\n\nvar repulsionStrength = -7.5;\nvar extraTicksPerTick = 0;\nvar force = null;\nvar nodes = null;\nvar links = null;\n\nfunction start(attrs, ns, ls) {\n  nodes = ns;\n  links = ls;\n  extraTicksPerTick = attrs.extraTicksPerTick;\n  force = d3.forceSimulation().force('center', d3.forceCenter(attrs.chartWidth / 2, attrs.chartHeight / 2)).force('charge', d3.forceManyBody().strength(repulsionStrength)).force('collision', d3.forceCollide().radius(8)).force(\"x\", d3.forceX().x(attrs.chartWidth / 2).strength(attrs.gravity)).force(\"y\", d3.forceY().y(attrs.chartHeight / 2).strength(attrs.gravity)).force('link', d3.forceLink()\n  //.links(attrs.data.links)\n  .id(function (d) {\n    return d.name;\n  }).distance(function (d) {\n    return d.value;\n  })\n  //.strength(1)\n  .iterations(5)).alphaMin(0.01);\n  force.nodes(nodes).on('tick', ticked);\n  force.force(\"link\").links(links);\n}\n\nfunction restart(attrs) {\n  extraTicksPerTick = attrs.extraTicksPerTick;\n  force.force('x', d3.forceX().x(attrs.chartWidth / 2).strength(attrs.gravity)).force('y', d3.forceY().y(attrs.chartHeight / 2).strength(attrs.gravity)).alpha(attrs.alpha).alphaTarget(attrs.alphaTarget).restart();\n}\n\nfunction updateNodes(ns) {\n  if (!ns) {\n    return;\n  }\n  for (var i = 0; i < ns.length; i++) {\n    var node = ns[i];\n    for (var j = 0; j < nodes.length; j++) {\n      if (nodes[j].name === node.name) {\n        nodes[j].fx = node.fx;\n        nodes[j].fy = node.fy;\n      }\n    }\n  }\n}\n\nfunction updateAttrs(attrs) {\n  if (!attrs) {\n    return;\n  }\n  extraTicksPerTick = attrs.extraTicksPerTick;\n  force.alphaTarget(attrs.alphaTarget);\n}\n\nfunction ticked() {\n  var len = nodes.length;\n  for (var i = 0; i < extraTicksPerTick; i++) {\n    force.tick();\n  }\n  var nodePositions = {};\n  for (var _i = 0; _i < len; _i++) {\n    var node = nodes[_i];\n    var positions = [node.x, node.y];\n    if (node.fx != null && node.fy != null) {\n      positions.push(node.fx);\n      positions.push(node.fy);\n    }\n    nodePositions[node.name] = positions;\n  }\n  self.postMessage({ nodePositions: nodePositions });\n}\n\nself.addEventListener('message', function (e) {\n  switch (e.data.cmd) {\n    case 'start':\n      start(e.data.attrs, e.data.nodes, e.data.links);\n      break;\n    case 'restart':\n      updateNodes(e.data.nodes);\n      restart(e.data.attrs);\n      break;\n    case 'update':\n      updateNodes(e.data.nodes);\n      updateAttrs(e.data.attrs);\n      break;\n  }\n}, false);\n      "
	        ]);
	        this.forceBlobURL = $window.URL.createObjectURL(forceBlob);
	        // don't need to call this because the object is never destroyed: window.URL.revokeObjectURL(blobURL);
	    }
	    d3workerService.prototype.getForceBlobURL = function () {
	        return this.forceBlobURL;
	    };
	    return d3workerService;
	}());
	exports.default = d3workerService;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var dates_service_1 = __webpack_require__(202);
	var DatesService = /** @class */ (function (_super) {
	    __extends(DatesService, _super);
	    DatesService.$inject = ["$log", "messageBus", "rx", "server"];
	    function DatesService($log, messageBus, rx, server) {
	        'ngInject';
	        return _super.call(this, rx, messageBus, server) || this;
	    }
	    return DatesService;
	}(dates_service_1.DatesService));
	exports.default = DatesService;
	// class DatesService {
	//   constructor($log, messageBus, rx, server) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.messageBus = messageBus;
	//     this.rx = rx;
	//     this.server = server;
	//     this.cache = new Map();
	//   }
	//   standardize(text) {
	//     if (!text) {
	//       return this.rx.Observable.of({});
	//     }
	//     if (this.cache.has(text)) {
	//       return this.rx.Observable.of(this.cache.get(text));
	//     }
	//     return this.server.get('/dates', {text})
	//       .do(result => {
	//         this.cache.set(text, result);
	//       })
	//       .catch(err => {
	//         this.messageBus.post({msg: err.data, status: err.status, op: 'GET', ctx: 'dates/standardize'});
	//         return this.rx.Observable.of({});
	//       });
	//   }
	// }
	// export default DatesService;


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Observable } from "../../node_modules/rxjs";
	var DatesService = /** @class */ (function () {
	    function DatesService(rx, messageBus, server) {
	        this.rx = rx;
	        this.messageBus = messageBus;
	        this.server = server;
	        this.cache = new Map();
	    }
	    DatesService.prototype.standardize = function (text) {
	        var _this = this;
	        if (!text) {
	            return this.rx.Observable.of({});
	        }
	        if (this.cache.has(text)) {
	            return this.rx.Observable.of(this.cache.get(text));
	        }
	        return this.server.get('/dates', { text: text })
	            .do(function (result) {
	            _this.cache.set(text, result);
	        })
	            .catch(function (err) {
	            _this.messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'dates/standardize' });
	            return _this.rx.Observable.of({});
	        });
	    };
	    return DatesService;
	}());
	exports.DatesService = DatesService;


/***/ }),
/* 203 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	var DNAKitsService = /** @class */ (function () {
	    DNAKitsService.$inject = ["$log", "rx", "store", "changes", "segment", "utils"];
	    function DNAKitsService($log, rx, store, changes, segment, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.rx = rx;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "dna_kits", changes.treeStream(), function (s) { return _this.addData(s); });
	    }
	    DNAKitsService.prototype.addData = function (o) {
	        o.source = o.source || 'GEDMATCH';
	        if (o.source === 'GEDMATCH') {
	            o._user = o.user + ' ' + o.name;
	        }
	        else {
	            o._user = (o.user || '') + (!!o.managerName && o.managerName !== o.user ? ' c/o ' + o.managerName : '');
	        }
	        o._user = o._user.trim();
	        if (!o._user) {
	            o._user = 'N/A';
	        }
	        if (o._user.length < 3) {
	            o._user += '\u00A0\u00A0\u00A0';
	        }
	        try {
	            for (var _a = __values(o.treeURLs.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var k = _b.value;
	                if (k.trim().length === 0) {
	                    o.treeURLs.delete(k);
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return this.utils.addCreateEditDates(o);
	        var e_1, _c;
	    };
	    DNAKitsService.prototype.create = function (o) {
	        this.segment.track('dna_kits.create');
	        return this.store.create(o);
	    };
	    DNAKitsService.prototype.createBatch = function (os) {
	        this.segment.track('dna_kits.createBatch');
	        return this.store.createBatch(os);
	    };
	    DNAKitsService.prototype.update = function (o) {
	        this.segment.track('dna_kits.update');
	        return this.store.update(o);
	    };
	    DNAKitsService.prototype.del = function (id) {
	        this.segment.track('dna_kits.delete');
	        return this.store.del(id);
	    };
	    DNAKitsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    DNAKitsService.prototype.stream = function () {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.store.stream(); });
	    };
	    DNAKitsService.prototype.streamId = function (id) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.store.streamId(id); });
	    };
	    DNAKitsService.prototype.reset = function () {
	        this.store.reset();
	    };
	    //
	    // helper functions
	    //
	    DNAKitsService.prototype.autocomplete = function (prefix, kits) {
	        var results = [];
	        var lc = prefix.toLowerCase();
	        if (!!lc) {
	            try {
	                for (var kits_1 = __values(kits), kits_1_1 = kits_1.next(); !kits_1_1.done; kits_1_1 = kits_1.next()) {
	                    var kit = kits_1_1.value;
	                    var found = true;
	                    try {
	                        for (var _a = __values(lc.split(' ')), _b = _a.next(); !_b.done; _b = _a.next()) {
	                            var piece = _b.value;
	                            if (kit._user.toLowerCase().indexOf(piece) < 0) {
	                                found = false;
	                                break;
	                            }
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                    if (found) {
	                        results.push(kit);
	                    }
	                }
	            }
	            catch (e_3_1) { e_3 = { error: e_3_1 }; }
	            finally {
	                try {
	                    if (kits_1_1 && !kits_1_1.done && (_d = kits_1.return)) _d.call(kits_1);
	                }
	                finally { if (e_3) throw e_3.error; }
	            }
	        }
	        return results.sort(function (a, b) { return a._user < b._user ? -1 : a._user > b._user ? 1 : 0; });
	        var e_3, _d, e_2, _c;
	    };
	    DNAKitsService.prototype.augmentDNAKits = function (s, users) {
	        var subject = new this.rx.AsyncSubject();
	        s = Object.assign({}, s, {
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        // set created user and edited user
	        this.utils.addCreateEditUsers(s, users).subscribe(function () {
	            subject.next(s);
	            subject.complete();
	        });
	        return subject;
	    };
	    // dnaKits comes from dnaKits.stream(), dnaProfiles comes from dnaProfiles.stream()
	    DNAKitsService.prototype.getDNAMatches = function (dnaKits, dnaProfiles, personId) {
	        var matches = { kits: [], profiles: [] };
	        try {
	            for (var _a = __values(dnaKits.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var kit = _b.value;
	                if (kit.personId1 === personId && kit.matchType === 'SELF') {
	                    matches.kits.push(kit);
	                }
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        try {
	            for (var _d = __values(dnaProfiles.values()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                var profile = _e.value;
	                if (profile.personId === personId) {
	                    matches.profiles.push(profile);
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        return matches;
	        var e_4, _c, e_5, _f;
	    };
	    DNAKitsService.prototype.getSearchTerms = function (search) {
	        // split into search terms: name, surname, location, tree, note, any
	        search = (search || '').trim().replace(/"/g, '" ').replace(/"[^"]*"/g, function (v) { return v.replace(/\s+/g, '_'); }).trim().toLowerCase();
	        return !search ? [] : search.split(/\s+/).map(function (t) { return t.replace(/"/g, '').replace(/_+/g, ' ').replace(/\s+/g, ' ').trim().split(':', 2); });
	    };
	    DNAKitsService.prototype.search = function (search, kits, defaultNone) {
	        var terms = this.getSearchTerms(search);
	        var results = [];
	        if (defaultNone && terms.length === 0) {
	            return results;
	        }
	        try {
	            for (var kits_2 = __values(kits), kits_2_1 = kits_2.next(); !kits_2_1.done; kits_2_1 = kits_2.next()) {
	                var kit = kits_2_1.value;
	                var found = true;
	                try {
	                    for (var terms_1 = __values(terms), terms_1_1 = terms_1.next(); !terms_1_1.done; terms_1_1 = terms_1.next()) {
	                        var term = terms_1_1.value;
	                        if (!this.hasTerm(kit, term)) {
	                            found = false;
	                            break;
	                        }
	                    }
	                }
	                catch (e_6_1) { e_6 = { error: e_6_1 }; }
	                finally {
	                    try {
	                        if (terms_1_1 && !terms_1_1.done && (_a = terms_1.return)) _a.call(terms_1);
	                    }
	                    finally { if (e_6) throw e_6.error; }
	                }
	                if (found) {
	                    results.push(kit);
	                }
	            }
	        }
	        catch (e_7_1) { e_7 = { error: e_7_1 }; }
	        finally {
	            try {
	                if (kits_2_1 && !kits_2_1.done && (_b = kits_2.return)) _b.call(kits_2);
	            }
	            finally { if (e_7) throw e_7.error; }
	        }
	        return results;
	        var e_7, _b, e_6, _a;
	    };
	    DNAKitsService.prototype.hasTerm = function (kit, term) {
	        // value is the last element of the term
	        var value = term[term.length - 1];
	        // strip trailing *
	        if (value.length > 1 && value.endsWith('*')) {
	            value = value.substr(0, value.length - 1);
	        }
	        if (!value) {
	            return true;
	        }
	        if (term.length === 1) {
	            if (value !== '*' && !this.kitHasWord(kit, value)) {
	                return false;
	            }
	        }
	        else {
	            switch (term[0]) {
	                case 'name':
	                    if (value === '*') {
	                        if (!kit.name && !kit.user && !kit.email && !kit.managerName) {
	                            return false;
	                        }
	                    }
	                    else if (!((!!kit.name && kit.name.toLowerCase().indexOf(value) >= 0) ||
	                        (!!kit.user && kit.user.toLowerCase().indexOf(value) >= 0) ||
	                        (!!kit.email && kit.email.toLowerCase().indexOf(value) >= 0) ||
	                        (!!kit.managerName && kit.managerName.toLowerCase().indexOf(value) >= 0))) {
	                        return false;
	                    }
	                    break;
	                case 'surname':
	                    if (value === '*') {
	                        if (!kit.surnames) {
	                            return false;
	                        }
	                    }
	                    else if (!(!!kit.surnames && kit.surnames.toLowerCase().indexOf(value) >= 0)) {
	                        return false;
	                    }
	                    break;
	                case 'email':
	                    if (value === '*') {
	                        if (!kit.email) {
	                            return false;
	                        }
	                    }
	                    else if (!(!!kit.email && kit.email.toLowerCase().indexOf(value) >= 0)) {
	                        return false;
	                    }
	                    break;
	                case 'location':
	                    if (value === '*') {
	                        if (!kit.locations) {
	                            return false;
	                        }
	                    }
	                    else if (!(!!kit.locations && kit.locations.toLowerCase().indexOf(value) >= 0)) {
	                        return false;
	                    }
	                    break;
	                case 'tree':
	                    if (value === '*') {
	                        if (kit.treeURLs.size === 0 && !kit.minitree) {
	                            return false;
	                        }
	                    }
	                    else if (!((kit.treeURLs.size > 0 && Array.from(kit.treeURLs.keys()).some(function (url) { return url.toLowerCase().indexOf(value) >= 0; })) ||
	                        (!!kit.minitree && kit.minitree.toLowerCase().indexOf(value) >= 0))) {
	                        return false;
	                    }
	                    break;
	                case 'note':
	                    if (value === '*') {
	                        if (!kit.text) {
	                            return false;
	                        }
	                    }
	                    else if (!(!!kit.text && kit.text.toLowerCase().indexOf(value) >= 0)) {
	                        return false;
	                    }
	                    break;
	                default:
	                    return this.kitHasWord(kit, value);
	            }
	        }
	        return true;
	    };
	    DNAKitsService.prototype.kitHasWord = function (kit, w) {
	        return (!!kit.name && kit.name.toLowerCase().indexOf(w) >= 0) ||
	            (!!kit.user && kit.user.toLowerCase().indexOf(w) >= 0) ||
	            (!!kit.email && kit.email.toLowerCase().indexOf(w) >= 0) ||
	            (!!kit.managerName && kit.managerName.toLowerCase().indexOf(w) >= 0) ||
	            (!!kit.surnames && kit.surnames.toLowerCase().indexOf(w) >= 0) ||
	            (!!kit.locations && kit.locations.toLowerCase().indexOf(w) >= 0) ||
	            (kit.treeURLs.size > 0 && Array.from(kit.treeURLs.keys()).some(function (url) { return url.toLowerCase().indexOf(w) >= 0; }) ||
	                (!!kit.minitree && kit.minitree.toLowerCase().indexOf(w) >= 0) ||
	                (!!kit.text && kit.text.toLowerCase().indexOf(w) >= 0));
	    };
	    return DNAKitsService;
	}());
	exports.default = DNAKitsService;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//Uncomment this for use with shared directory in the future
	// import { DNAParsersService as _DNAParsersService } from '@shared/components/dnaParsers/dnaParsers.service';
	// class DNAParsersService extends _DNAParsersService {
	//   constructor ($log, $document, csv, utils) {
	//     'ngInject';
	//     super($log, $document, csv, utils);
	//   }
	// }
	// export default DNAParsersService;
	var DNAParsersService = /** @class */ (function () {
	    DNAParsersService.$inject = ["$log", "$document", "csv", "utils"];
	    function DNAParsersService($log, $document, csv, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.$document = $document;
	        this.csv = csv;
	        this.utils = utils;
	    }
	    //
	    // Table parsers: OneToManyA+B, GedMatchSegment, Triangulation
	    //
	    DNAParsersService.prototype.parseGedMatchOneToManyA = function (text) {
	        console.log('parseGedmatchOneToManyA');
	        var schema = {
	            headRows: 3,
	            rowsIncrement: 1,
	            minRowLength: 7,
	            dummyColumns: [3, 8, 13, 17],
	            GedWikiColumn: 5,
	            linkColumns: [],
	            obj: {
	                kit: '',
	                type: '',
	                url: '',
	                sex: '',
	                gedURL: '',
	                wikiURL: '',
	                haploMt: '',
	                haploY: '',
	                autoURL: '',
	                autoTotal: '',
	                autoLargest: '',
	                autoGen: '',
	                xURL: '',
	                xTotal: '',
	                xLargest: '',
	                name: '',
	                email: ''
	            }
	        };
	        var e = this.createDOMElement(text);
	        return this.parseTable(schema, e);
	    };
	    DNAParsersService.prototype.parseGedMatchOneToManyB = function (text) {
	        console.log('parseGedmatchOneToManyB');
	        var schema = {
	            headRows: 3,
	            rowsIncrement: 1,
	            minRowLength: 7,
	            dummyColumns: [0, 1],
	            GedWikiColumn: 5,
	            linkColumns: [2, 11, 12, 15],
	            obj: {
	                kit: '',
	                url: '',
	                name: '',
	                email: '',
	                gedURL: '',
	                wikiURL: '',
	                age: '',
	                type: '',
	                sex: '',
	                haploMt: '',
	                haploY: '',
	                autoTotal: '',
	                autoLink: '',
	                autoLargest: '',
	                autoURL: '',
	                autoGen: '',
	                xTotal: '',
	                xLargest: '',
	                xURL: ''
	            }
	        };
	        var e = this.createDOMElement(text);
	        return this.parseTable(schema, e);
	    };
	    DNAParsersService.prototype.parseGedMatchOneToManyC = function (text) {
	        var schema = {
	            headRows: 5,
	            rowsIncrement: 1,
	            minRowLength: 10,
	            dummyColumns: [1],
	            GedWikiColumn: -1,
	            linkColumns: [0],
	            obj: {
	                kit: '',
	                url: '',
	                name: '',
	                email: '',
	                autoLargest: '',
	                autoTotal: '',
	                autoGen: ''
	            }
	        };
	        var e = this.createDOMElement(text);
	        return this.parseTable(schema, e);
	    };
	    DNAParsersService.prototype.parseGedMatchOneToManyD = function (text) {
	        console.log('parseGedmatchOneToManyD');
	        var schema = {
	            headRows: 3,
	            rowsIncrement: 1,
	            minRowLength: 7,
	            dummyColumns: [0, 1, 10, 12],
	            GedWikiColumn: 3,
	            linkColumns: [2, 6, 9, 17],
	            obj: {
	                kit: '',
	                url: '',
	                gedURL: '',
	                wikiURL: '',
	                sex: '',
	                autoTotal: '',
	                autoLargest: '',
	                autoURL: '',
	                autoGen: '',
	                xTotal: '',
	                xLargest: '',
	                xURL: '',
	                type: '',
	                age: '',
	                haploMt: '',
	                haploY: '',
	                name: '',
	                email: '',
	                emailURL: '',
	            }
	        };
	        var e = this.createDOMElement(text);
	        return this.parseTable(schema, e);
	    };
	    DNAParsersService.prototype.parseGedMatchOneToManyE = function (text) {
	        console.log('parseGedmatchOneToManyE');
	        var schema = {
	            headRows: 3,
	            rowsIncrement: 1,
	            minRowLength: 7,
	            dummyColumns: [0, 1, 5, 13, 15],
	            GedWikiColumn: 6,
	            linkColumns: [2, 4, 9, 12],
	            obj: {
	                // select 0
	                // match number 1
	                kit: '',
	                url: '',
	                name: '',
	                email: '',
	                emailURL: '',
	                // notes 5
	                gedURL: '',
	                wikiURL: '',
	                sex: '',
	                autoTotal: '',
	                autoLargest: '',
	                autoURL: '',
	                autoGen: '',
	                xTotal: '',
	                xLargest: '',
	                xURL: '',
	                // ICW tool 13 (link)
	                type: '',
	                // overlap 15
	                age: '',
	                haploMt: '',
	                haploY: '',
	            }
	        };
	        var e = this.createDOMElement(text);
	        return this.parseTable(schema, e);
	    };
	    DNAParsersService.prototype.parseGedMatchSegment = function (text) {
	        var schemas = [{
	                headRows: 1,
	                rowsIncrement: 1,
	                minRowLength: 9,
	                dummyColumns: [],
	                GedWikiColumn: -1,
	                linkColumns: [],
	                obj: {
	                    kit: '',
	                    chr: '',
	                    start: '',
	                    end: '',
	                    cm: '',
	                    snps: '',
	                    name: '',
	                    sex: '',
	                    email: ''
	                }
	            },
	            {
	                headRows: 1,
	                rowsIncrement: 1,
	                minRowLength: 9,
	                dummyColumns: [1],
	                GedWikiColumn: -1,
	                linkColumns: [],
	                obj: {
	                    kit: '',
	                    chr: '',
	                    start: '',
	                    end: '',
	                    cm: '',
	                    snps: '',
	                    name: '',
	                    sex: '',
	                    email: ''
	                }
	            }];
	        var ix = 0;
	        var e = this.createDOMElement(text);
	        var rows = e.getElementsByTagName('tr');
	        if (!!rows) {
	            var cells = rows[0].getElementsByTagName('td');
	            if (cells[1].textContent === '✓') {
	                ix = 1;
	            }
	        }
	        var data = this.parseTable(schemas[ix], e);
	        return data;
	    };
	    DNAParsersService.prototype.parseGedMatchTriangulation = function (text) {
	        var schemas = [
	            {
	                headRows: 1,
	                rowsIncrement: 1,
	                minRowLength: 7,
	                dummyColumns: [2, 3, 5, 6],
	                GedWikiColumn: -1,
	                linkColumns: [],
	                objName: 'sortByChr',
	                obj: {
	                    chr: '',
	                    kit1: '',
	                    kit2: '',
	                    start: '',
	                    end: '',
	                    cm: ''
	                }
	            },
	            {
	                headRows: 1,
	                rowsIncrement: 1,
	                minRowLength: 10,
	                dummyColumns: [],
	                GedWikiColumn: -1,
	                linkColumns: [],
	                objName: 'sortByKit',
	                obj: {
	                    chr: '',
	                    kit1: '',
	                    kit1Name: '',
	                    kit1Email: '',
	                    kit2: '',
	                    kit2Name: '',
	                    kit2Email: '',
	                    start: '',
	                    end: '',
	                    cm: ''
	                }
	            },
	            {
	                headRows: 1,
	                rowsIncrement: 1,
	                minRowLength: 10,
	                dummyColumns: [],
	                GedWikiColumn: -1,
	                linkColumns: [],
	                objName: 'sortByChr',
	                obj: {
	                    chr: '',
	                    kit1: '',
	                    kit1Name: '',
	                    kit1Email: '',
	                    kit2: '',
	                    kit2Name: '',
	                    kit2Email: '',
	                    start: '',
	                    end: '',
	                    cm: ''
	                }
	            },
	            {
	                headRows: 1,
	                rowsIncrement: 1,
	                minRowLength: 12,
	                dummyColumns: [1, 5],
	                GedWikiColumn: -1,
	                linkColumns: [],
	                objName: 'sortByKit',
	                obj: {
	                    chr: '',
	                    kit1: '',
	                    kit1Name: '',
	                    kit1Email: '',
	                    kit2: '',
	                    kit2Name: '',
	                    kit2Email: '',
	                    start: '',
	                    end: '',
	                    cm: ''
	                }
	            }
	        ];
	        var e = this.createDOMElement(text);
	        var tableData = {};
	        var tables = e.getElementsByTagName('table');
	        if (!tables) {
	            throw new Error('parseTables');
	        }
	        for (var i = 0; i < tables.length; i++) {
	            var rows = tables[i].getElementsByTagName('tr');
	            if (!rows || rows.length < 2) {
	                continue;
	            }
	            var cells = rows[0].getElementsByTagName('td');
	            var cells2 = rows[1].getElementsByTagName('td');
	            if (!cells || !cells2) {
	                continue;
	            }
	            if (cells.length === 6 && cells2.length === 12) {
	                console.log('parseGedmatchTriangulation genesis sortByKit');
	                tableData[schemas[3].objName] = this.parseTable(schemas[3], tables[i], schemas[3].objName);
	            }
	            else if ((cells.length === 6 || cells.length === 7) && cells2.length === 2) {
	                console.log('parseGedmatchTriangulation genesis sortByChr');
	                tableData[schemas[2].objName] = this.parseTable(schemas[2], tables[i], schemas[2].objName);
	            }
	            else if (cells.length === 7) {
	                console.log('parseGedmatchTriangulation normal sortByChr');
	                tableData[schemas[0].objName] = this.parseTable(schemas[0], tables[i], schemas[0].objName);
	            }
	            else if (cells.length === 6) {
	                console.log('parseGedmatchTriangulation normal sortByKit');
	                tableData[schemas[1].objName] = this.parseTable(schemas[1], tables[i], schemas[1].objName);
	            }
	        }
	        // prefer sortByKit if you have it
	        return !!tableData.sortByKit ? tableData.sortByKit : !!tableData.sortByChr ? tableData.sortByChr : null;
	    };
	    DNAParsersService.prototype.parseTable = function (schema, table, tableName) {
	        var tableData = [];
	        var rows = table.getElementsByTagName('tr');
	        if (!rows) {
	            throw new Error('parseTable ' + (tableName || ''));
	        }
	        for (var i = schema.headRows; i < rows.length; i += schema.rowsIncrement) {
	            // console.log('parseTable', i, rows[i]);
	            var rowData = this.parseRow(schema, rows[i], i);
	            // console.log('parseTable rowData', rowData);
	            if (!!rowData) {
	                tableData.push(rowData);
	            }
	        }
	        console.log('parseTable', rows.length, tableData.length, schema);
	        return tableData;
	    };
	    DNAParsersService.prototype.parseRow = function (schema, row, rowNum) {
	        var cells = row.getElementsByTagName('td');
	        if (!cells) {
	            throw new Error('parseRow ' + rowNum);
	        }
	        if (cells.length < schema.minRowLength) {
	            // console.log('parseRow skip length', cells);
	            return null;
	        }
	        var data = [];
	        for (var i = 0; i < cells.length; i++) {
	            var cellData = void 0;
	            // console.log("parseRow cell", i);
	            //skip empty columns
	            if (!this.isDummyCellIndex(schema, i)) {
	                if (i === schema.GedWikiColumn) {
	                    cellData = this.parseGedWiki(cells[i].getElementsByTagName('a'));
	                }
	                else if (this.isLinkCellIndex(schema, i)) {
	                    cellData = this.parseLinkCell(cells[i].getElementsByTagName('a'));
	                }
	                else {
	                    cellData = this.parseCell(cells[i]);
	                }
	                // console.log("parseRow cellData", cellData);
	                data.push(cellData);
	            }
	        }
	        return this.mapRow(schema, data);
	    };
	    DNAParsersService.prototype.parseCell = function (cell) {
	        var cellData;
	        var links = cell.getElementsByTagName('a');
	        if (links.length > 0) {
	            cellData = links[0].href;
	        }
	        else {
	            //trim dummy white space
	            if (cell.innerHTML === '&nbsp;') {
	                cell.innerHTML = '';
	            }
	            cellData = cell.innerHTML;
	            // trim font
	            cellData = cellData.replace(/<(font|div)[^>]*>/, '').replace(/<\/(font|div)>/, '');
	        }
	        return cellData;
	    };
	    DNAParsersService.prototype.parseGedWiki = function (links) {
	        var linksData = ['', ''];
	        if (!!links) {
	            for (var i = 0; i < links.length; i++) {
	                var title = (links[i].innerHTML || '').trim();
	                switch (title) {
	                    case 'GED':
	                        linksData[0] = links[i].href;
	                        break;
	                    case 'Wiki':
	                        linksData[1] = links[i].href;
	                }
	            }
	        }
	        return linksData;
	    };
	    DNAParsersService.prototype.parseLinkCell = function (links) {
	        if (!links) {
	            return ['', ''];
	        }
	        return [
	            links[0].innerHTML,
	            links[0].href
	        ];
	    };
	    DNAParsersService.prototype.mapRow = function (schema, data) {
	        var obj = Object.assign({}, schema.obj);
	        var index = 0;
	        data = this.flattenRowData(data);
	        for (var property in obj) {
	            if (obj.hasOwnProperty(property)) {
	                obj[property] = data[index];
	                index++;
	            }
	        }
	        return obj;
	    };
	    DNAParsersService.prototype.flattenRowData = function (data) {
	        for (var i = 0; i < data.length; i++) {
	            if (data[i].constructor === Array) {
	                var dump = data[i];
	                data[i] = dump[0];
	                data.splice(i + 1, 0, dump[1]);
	            }
	        }
	        return data;
	    };
	    DNAParsersService.prototype.isDummyCellIndex = function (schema, index) {
	        return schema.dummyColumns.indexOf(index) !== -1;
	    };
	    DNAParsersService.prototype.isLinkCellIndex = function (schema, index) {
	        return schema.linkColumns.indexOf(index) !== -1;
	    };
	    //
	    // process functions for GedMatchOneToManyA or B or GedMatchSegment or GedMatchTriangulation
	    //
	    DNAParsersService.prototype.normalizeNumber = function (v) {
	        v = v.trim();
	        if (/^\d+(\.\d{3})*,\d{1,2}$/.test(v)) {
	            v = v.replace(/\./g, '').replace(/,/, '.');
	        }
	        v = v.replace(/,/g, '');
	        return v;
	    };
	    DNAParsersService.prototype.processListData = function (rawData, source) {
	        var _this = this;
	        var kits = new Map();
	        var datas = new Map();
	        rawData.forEach(function (row) {
	            var kit = { source: source, treeURLs: new Map() };
	            var data = {};
	            Object.keys(row).forEach(function (key) {
	                var value = (row[key] || '').trim();
	                switch (key) {
	                    case 'kit':
	                        kit.name = value;
	                        data.name = value;
	                        break;
	                    case 'type':
	                        kit.type = value;
	                        break;
	                    case 'url':
	                        kit.url = value;
	                        break;
	                    case 'sex':
	                        kit.sex = value;
	                        break;
	                    case 'gedURL':
	                    case 'wikiURL':
	                    case 'gedCSVURL':
	                    case 'mhURL':
	                    case 'ancURL':
	                        if (!!value && value.trim().length > 0) {
	                            kit.treeURLs.set(value.trim(), true);
	                        }
	                        break;
	                    case 'haploMt':
	                        kit.haploMt = value;
	                        break;
	                    case 'haploY':
	                        kit.haploY = value;
	                        break;
	                    case 'name':
	                        kit.user = value;
	                        break;
	                    case 'managerName':
	                        kit.managerName = value;
	                        break;
	                    case 'email':
	                        kit.email = value;
	                        break;
	                    case 'contactURL':
	                        kit.contactURL = value;
	                        break;
	                    case 'surnames':
	                        kit.surnames = value;
	                        break;
	                    case 'locations':
	                        kit.locations = value;
	                        break;
	                    case 'text':
	                        kit.text = _this.utils.escape(value);
	                        break;
	                    case 'ageRange':
	                        kit.ageRange = value;
	                        break;
	                    case 'birthYear':
	                        if (!!value) {
	                            var age = new Date().getFullYear() - +value;
	                            kit.ageRange = '' + (age - 1) + ' - ' + (age + 1);
	                        }
	                    case 'age':
	                        data.age = +_this.normalizeNumber(value);
	                        break;
	                    //case 'autoURL':
	                    //  data.autoURL = value;
	                    //  break;
	                    case 'autoTotal':
	                        data.autoTotal = +_this.normalizeNumber(value);
	                        break;
	                    case 'autoCount':
	                        data.autoCount = +_this.normalizeNumber(value);
	                        break;
	                    case 'autoLargest':
	                        data.autoLargest = +_this.normalizeNumber(value);
	                        break;
	                    case 'autoGen':
	                        data.autoGen = +_this.normalizeNumber(value);
	                        break;
	                    //case 'xURL':
	                    //  data.xURL = value;
	                    //  break;
	                    case 'xTotal':
	                        data.xTotal = +_this.normalizeNumber(value);
	                        break;
	                    case 'xLargest':
	                        data.xLargest = +_this.normalizeNumber(value);
	                        break;
	                    case 'date':
	                        data.date = value;
	                        break;
	                    case 'relRange':
	                        data.relRange = value;
	                        break;
	                    case 'relSuggested':
	                        data.relSuggested = value;
	                        break;
	                }
	            });
	            if (!!kit.name) {
	                kits.set(kit.name, kit);
	                datas.set(data.name, data);
	            }
	        });
	        return [Array.from(datas.values()), Array.from(kits.values())];
	    };
	    DNAParsersService.prototype.processSegmentData = function (rawData, source) {
	        var _this = this;
	        var kitMap = new Map();
	        var datas = [];
	        rawData.forEach(function (row) {
	            var kit = { source: source, treeURLs: new Map() };
	            var data = {};
	            Object.keys(row).forEach(function (key) {
	                var value = row[key];
	                switch (key) {
	                    case 'kit':
	                        kit.name = value;
	                        data.name = value;
	                        break;
	                    case 'chr':
	                        data.chr = value === 'X' ? 23 : +value;
	                        break;
	                    case 'start':
	                        data.start = +_this.normalizeNumber(value);
	                        break;
	                    case 'end':
	                        data.end = +_this.normalizeNumber(value);
	                        break;
	                    case 'cm':
	                        data.cm = +_this.normalizeNumber(value);
	                        break;
	                    case 'snps':
	                        data.snps = +_this.normalizeNumber(value);
	                        break;
	                    case 'name':
	                        kit.user = value;
	                        break;
	                    case 'sex':
	                        kit.sex = value;
	                        break;
	                    case 'email':
	                        kit.email = value;
	                        break;
	                }
	            });
	            kitMap.set(kit.name, kit);
	            datas.push(data);
	        });
	        return [datas, Array.from(kitMap.values())];
	    };
	    DNAParsersService.prototype.processTriangulationData = function (rawData, source) {
	        var _this = this;
	        var kitMap = new Map();
	        var datas = new Map();
	        rawData.forEach(function (row) {
	            var kit1 = { source: source, treeURLs: new Map() };
	            var kit2 = { source: source, treeURLs: new Map() };
	            var data = { chr: 0, start: 0, end: 0 };
	            Object.keys(row).forEach(function (key) {
	                var value = row[key];
	                switch (key) {
	                    case 'chr':
	                        data.chr = value === 'X' ? 23 : +value;
	                        break;
	                    case 'cm':
	                        data.cm = +_this.normalizeNumber(value);
	                        break;
	                    case 'start':
	                        data.start = +_this.normalizeNumber(value);
	                        break;
	                    case 'end':
	                        data.end = +_this.normalizeNumber(value);
	                        break;
	                    case 'kit1':
	                        kit1.name = value;
	                        data.kit1 = value;
	                        break;
	                    case 'kit1Email':
	                        kit1.email = value;
	                        break;
	                    case 'kit1Name':
	                        kit1.user = value;
	                        break;
	                    case 'kit2':
	                        kit2.name = value;
	                        data.kit2 = value;
	                        break;
	                    case 'kit2Email':
	                        kit2.email = value;
	                        break;
	                    case 'kit2Name':
	                        kit2.user = value;
	                        break;
	                }
	            });
	            kitMap.set(kit1.name, kit1);
	            kitMap.set(kit2.name, kit2);
	            if (data.kit1 > data.kit2) {
	                var temp = data.kit1;
	                data.kit1 = data.kit2;
	                data.kit2 = temp;
	            }
	            var key = data.kit1 + '/' + data.kit2 + '/' + data.chr + '/' + data.start.toString();
	            datas.set(key, data);
	        });
	        return [Array.from(datas.values()), Array.from(kitMap.values())];
	    };
	    //
	    // GedMatchPedigree
	    //
	    DNAParsersService.prototype.parseGedMatchPedigree = function (text) {
	        var e = this.createDOMElement(text);
	        var collection = e.querySelectorAll('a > font');
	        var items = this.getGedMatchPedigreeItems(collection);
	        return this.getGedMatchPedigreeRoot(items, 10);
	    };
	    DNAParsersService.prototype.getGedMatchPedigreeItems = function (collection) {
	        var items = [];
	        for (var i = 0; i < collection.length; i++) {
	            var collectionItem = collection[i];
	            var item = {
	                offset: collectionItem.parentElement.previousSibling.textContent.length,
	                gender: collectionItem.color === 'red' ? 'female' : (collectionItem.color === 'blue' ? 'male' : 'unknown'),
	                url: collectionItem.parentElement.href
	            };
	            item = this.parseGedMatchPedigreeRegExp(collectionItem.innerText, item);
	            items.push(item);
	        }
	        return items;
	    };
	    DNAParsersService.prototype.parseGedMatchPedigreeRegExp = function (text, item) {
	        var regexps = {
	            name: '^([A-Za-z.\\s,\\W]+)(, b.+)?$',
	            birth: '\\s[b.\\s]+(.+?)(?=,\\s[d.]|$)',
	            death: '\\s[d.\\s]+(.+?)$',
	            familyId: 'id_family=([0-9]+)',
	            gedId: 'id_ged=(.+)$'
	        };
	        Object.keys(regexps).forEach(function (index) {
	            var reg = new RegExp(regexps[index], 'g'), matches = reg.exec(text);
	            if (matches !== null && matches.length > 1) {
	                if (index === 'birth' || index === 'death') {
	                    var parts = matches[1].split(/,\s(.+)/);
	                    item[index + 'date'] = parts[0];
	                    if (parts.length > 1) {
	                        item[index + 'place'] = parts[1];
	                    }
	                }
	                else {
	                    item[index] = matches[1];
	                }
	            }
	        });
	        return item;
	    };
	    DNAParsersService.prototype.getGedMatchPedigreeRoot = function (items, maxGens) {
	        if (maxGens <= 0) {
	            return null;
	        }
	        var ix = this.getGedMatchPedigreeLeftmostIndex(items);
	        if (ix < 0) {
	            return null;
	        }
	        var self = items[ix];
	        self.father = this.getGedMatchPedigreeRoot(items.slice(0, ix), maxGens - 1);
	        self.mother = this.getGedMatchPedigreeRoot(items.slice(ix + 1), maxGens - 1);
	        return self;
	    };
	    DNAParsersService.prototype.getGedMatchPedigreeLeftmostIndex = function (items) {
	        var ix = -1;
	        var offset = -1;
	        for (var i = 0; i < items.length; i++) {
	            if (offset === -1 || items[i].offset < offset) {
	                ix = i;
	                offset = items[i].offset;
	            }
	        }
	        return ix;
	    };
	    //
	    // WikiTree
	    //
	    DNAParsersService.prototype.parseWikiTree = function (text) {
	        //let reg = new RegExp('(\\d+)[.]\\s.+?<a.+?>(.+?)<\\/a.+?<span.+?class.+?>(.+?)<\\/span', 'g'),
	        //let reg = RegExp('(\\d+)[.]\\s*(?:<!--[^-]+-->\\s*)*<a\\s+href="([^"]*)"[^>]+>([^<]*)<\\/a>\\s*<a[^>]+>\\s*<img[^>]+>\\s*<\\/a>\\s*<span[^>]+>([^<]*)<\\/span>', 'g'),
	        // 1.<span>?<a href title>name</a>(<a><img></a>)*<span class="SMALL">date</span>
	        var spanRE = new RegExp('<span( class="Apple-converted-space")?> <\\/span>', 'ig');
	        // let reg = new RegExp('(\\d+)[.]\\s*(?:\\[Private\\]|<a\\s+href="([^"]*)"\\s+title="Go to Profile[^>]*>([^<]*)<\\/a>\\s*(?:<(?:a[^>]*|span\\s+title[^>]*|img[^>]*|/a|/span)>\\s*)+(?:<span class="small"[^>]+>([^<]*)<\\/span>)?)', 'ig');
	        var reg = new RegExp('(\\d+)[.]\\s*(?:\\[Private\\]|<a\\s+href="([^"]*)"\\s+title="[^>]*>([^<]*)<\\/a>\\s*(?:<(?:a[^>]*|span\\s+title[^>]*|img[^>]*|/a|/span)>\\s*)+(?:<span class="small"[^>]+>([^<]*)<\\/span>)?)', 'ig');
	        text = text.replace(/[\r\n\t]/g, '').replace(spanRE, ' ');
	        var items = [];
	        var results = null;
	        var match;
	        while ((match = reg.exec(text)) !== null) {
	            match.splice(0, 1);
	            items.push(match);
	            if (parseInt(match[0]) === 1) {
	                results = this.parseWikiTreeItem(match);
	            }
	        }
	        if (!!results) {
	            results = this.getWikiTreeParents(items, results, 10);
	        }
	        return results;
	    };
	    DNAParsersService.prototype.parseWikiTreeItem = function (item) {
	        var parts = null;
	        var obj = typeof item[1] !== "undefined" && item.length >= 3 ? { id: parseInt(item[0]), url: item[1], name: item[2] } : { id: parseInt(item[0]), url: '', name: 'Private' };
	        if (typeof item[1] !== "undefined" && item.length === 4 && typeof item[3] !== "undefined") {
	            parts = item[3].replace(/[\s()]+/g, ' ').trim().split('-');
	            parts.forEach(function (value, index) {
	                if (value !== ' ') {
	                    var reg = new RegExp('([A-Za-z0-9\\s]*?[0-9]{4}[s]?)?\\s?(.*?)$', 'gm'), matches = reg.exec(value.trim()), prefix = index === 0 ? 'birth' : 'death';
	                    if (!!matches) {
	                        obj[prefix + 'date'] = typeof matches[1] !== "undefined" ? matches[1].replace(/abt[\s]*/g, 'abt ').trim() : null;
	                        obj[prefix + 'place'] = typeof matches[2] !== "undefined" ? matches[2].trim() : null;
	                    }
	                }
	            });
	        }
	        return obj;
	    };
	    DNAParsersService.prototype.getWikiTreeParents = function (items, item, maxGens) {
	        if (maxGens <= 0) {
	            return null;
	        }
	        var parents = {
	            father: null,
	            fatherId: item.id * 2,
	            mother: null,
	            motherId: item.id * 2 + 1
	        };
	        items.forEach(function (value) {
	            var id = parseInt(value[0]);
	            if (id === parents.fatherId) {
	                parents.father = value;
	            }
	            else if (id === parents.motherId) {
	                parents.mother = value;
	            }
	        });
	        item.father = parents.father !== null ? this.getWikiTreeParents(items, this.parseWikiTreeItem(parents.father), maxGens - 1) : null;
	        item.mother = parents.mother !== null ? this.getWikiTreeParents(items, this.parseWikiTreeItem(parents.mother), maxGens - 1) : null;
	        return item;
	    };
	    //
	    // csv
	    //
	    DNAParsersService.prototype.csvListHeaderToField = function (header, source) {
	        switch (header.toLowerCase()) {
	            // FTDNA
	            case 'full name':
	            case 'full_name':
	                return 'name';
	            case 'match date':
	            case 'match_date':
	                return 'date';
	            case 'relationship range':
	            case 'relationship_range':
	                return 'relRange';
	            case 'suggested relationship':
	            case 'suggested_relationship':
	                return 'suggRel';
	            case 'shared cm':
	            case 'shared_cm':
	                return 'autoTotal';
	            case 'longest block':
	            case 'longest_block':
	                return 'autoLargest';
	            case 'linked relationship':
	            case 'linked_relationship':
	            case 'known relationship':
	            case 'known_relationship':
	                return '';
	            case 'email':
	            case 'e-mail':
	            case 'e - mail':
	                return 'email';
	            case 'ancestral surnames':
	            case 'ancestral_surnames':
	            case 'ancestral':
	                return 'surnames';
	            case 'y-dna haplogroup':
	            case 'y-dna_haplogroup':
	            case 'ydna haplogroup':
	            case 'ydna_haplogroup':
	                return 'haploY';
	            case 'mtdna haplogroup':
	            case 'mtdna_haplogroup':
	                return 'haploMt';
	            case 'resultid2':
	                return '';
	            case 'notes':
	                return 'text';
	            case 'name':
	                return source === 'MYHERITAGE' || source === '23ANDME' || source === 'GEDMATCH' || source === 'ANCESTRY' ? 'name' : '';
	            case 'matching bucket':
	                return '';
	            // MYHERITAGE
	            case 'dna match id':
	                return '';
	            //case 'name':
	            //  return 'name';
	            //case 'resultid2':
	            //  return ''
	            case 'age':
	                return 'ageRange';
	            case 'country':
	                return 'locations';
	            case 'contact dna match':
	            case 'contact_dna_match':
	                return 'contactURL';
	            case 'dna managed by':
	            case 'dna_managed_by':
	                return 'managerName';
	            case 'contact dna manager':
	                return '';
	            case 'status':
	                return '';
	            case 'estimated relationship':
	            case 'estimated_relationship':
	                return 'relRange';
	            case 'total cm shared':
	            case 'total_cm_shared':
	                return 'autoTotal';
	            case 'number of shared segments':
	            case 'number_of_shared_segments':
	                return 'autoCount';
	            case 'largest segment (cm)':
	            case 'largest_segment_(cm)':
	                return 'autoLargest';
	            case 'review dna match page':
	            case 'review_dna_match_page':
	                return 'url';
	            case 'has family tree':
	                return '';
	            case 'number of individuals in the tree':
	                return '';
	            case 'tree managed by':
	                return '';
	            case 'view tree':
	            case 'view_tree':
	                return 'mhURL';
	            case 'contact tree manager':
	                return '';
	            case 'number of smart matches':
	                return '';
	            case 'shared ancestral surnames':
	                return '';
	            case 'all ancestral surnames':
	            case 'all_ancestral_surnames':
	                return 'surnames';
	            //case 'notes':
	            //23andMe
	            case 'display name':
	            case 'display_name':
	                //case 'name':
	                return 'name';
	            case 'sex':
	                return 'sex';
	            case 'birth year':
	            case 'birth_year':
	                return 'birthYear';
	            case 'set relationship':
	            case 'relationship':
	                return '';
	            case 'predicted relationship':
	            case 'predicted_relationship':
	                return 'relSuggested';
	            case 'relative range':
	            case 'relative_range':
	            case 'predicted range':
	            case 'predicted_range':
	                return 'relRange';
	            case 'dna shared':
	            case 'dna_shared':
	                return 'autoTotal';
	            case 'segments shared':
	            case 'segments_shared':
	            case '# segments shared':
	            case '#_segments_shared':
	                return 'autoCount';
	            case 'paternal haplogroup':
	            case 'paternal_haplogroup':
	                return 'haploY';
	            case 'maternal haplogroup':
	            case 'maternal_haplogroup':
	                return 'haploMt';
	            case 'birthplace':
	                return 'locations';
	            case 'residence':
	                return 'locations';
	            case 'family locations':
	            case 'family_locations':
	            case 'ancestry':
	                return 'locations';
	            case 'maternal grandmother birth country':
	            case 'maternal_grandmother_birth_country':
	                return 'locations';
	            case 'maternal grandfather birth country':
	            case 'maternal_grandfather_birth_country':
	                return 'locations';
	            case 'paternal grandmother birth country':
	            case 'paternal_grandmother_birth_country':
	                return 'locations';
	            case 'paternal grandfather birth country':
	            case 'paternal_grandfather_birth_country':
	                return 'locations';
	            case 'family surnames':
	            case 'family_surnames':
	                return 'surnames';
	            //case 'notes':
	            case 'link to compare view':
	            case 'link_to_compare_view':
	            case 'eiid':
	                return 'url';
	            // ANCESTRY
	            case 'testid':
	                return '';
	            case 'matchid':
	                return '';
	            //case 'name':
	            case 'admin':
	                return 'managerName';
	            case 'people':
	                return '';
	            case 'range':
	                return 'relRange';
	            case 'confidence':
	            case 'lastlogin':
	            case 'starred':
	            case 'viewed':
	            case 'private':
	            case 'hint':
	            case 'archived':
	            case 'imageurl':
	                return '';
	            case 'profileurl':
	                return 'contactURL';
	            case 'treeurl':
	                return 'ancURL';
	            case 'scanned':
	                return 'date';
	            case 'membersince':
	                return '';
	            case 'ethincregions':
	                return 'locations';
	            case 'ethnictraceregions':
	                return '';
	            case 'sharedcm':
	            case 'centimorgans':
	                return 'autoTotal';
	            case 'sharedsegments':
	            case 'segments':
	                return 'autoCount';
	            case 'matchurl':
	                return 'url';
	            case 'note':
	                return 'text';
	            // GEDMATCH
	            //case 'sex':
	            //  return 'sex';
	            case 'ged/wikitree':
	            case 'gedwikitree':
	                return 'gedCSVURL';
	            case 'mt':
	                return 'haploMt';
	            case 'y':
	                return 'haploY';
	            case 'autototalcm':
	                return 'autoTotal';
	            case 'autolargestcm':
	            case 'autolargest':
	            case 'autolargestseg':
	                return 'autoLargest';
	            case 'gen':
	                return 'autoGen';
	            case 'totalcm':
	                return 'xTotal';
	            case 'largestcm':
	            case 'largest':
	                return 'xLargest';
	            //case 'name':
	            case 'name(*=>alias)':
	                return 'name';
	            //case 'email':
	            //  return 'email';
	            case 'age(days)':
	                return 'age';
	            default:
	                return '';
	        }
	    };
	    DNAParsersService.prototype.postProcessListResults = function (results, source) {
	        //case '23ANDME':
	        //  let resultMap = new Map();
	        //  for (let result of results) {
	        //    if (resultMap.has(result['kit'])) {
	        //      let r = resultMap.get(result['kit']);
	        //      let autoSegment = +result['autoSegment'];
	        //      r.autoCount += 1;
	        //      r.autoTotal += autoSegment;
	        //      r.autoLargest = Math.max(r.autoLargest, autoSegment);
	        //    }
	        //    else {
	        //      resultMap.set(result['kit'], Object.assign(result, {autoCount: 1, autoTotal: +result['autoSegment'], autoLargest: +result['autoSegment']}));
	        //    }
	        //  }
	        //  return Array.from(resultMap.values());
	        var resultMap = new Map();
	        try {
	            for (var results_1 = __values(results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
	                var result = results_1_1.value;
	                if (source === '23ANDME' && !!result['url'] && !result['url'].startsWith('http')) {
	                    result['url'] = 'https://you.23andme.com/url/tools:compare_match/?remote_id=' + result['url'];
	                }
	                if (source === '23ANDME' && !!result['autoTotal'] && result['autoTotal'].endsWith('%')) {
	                    result['autoTotal'] = (result['autoTotal'].slice(0, -1) / 100 * 7438.6).toString();
	                }
	                if (source === 'FTDNA' && !!result['text']) {
	                    var text = result['text'].trim().toLowerCase();
	                    if (text === 'false' || text === 'true') {
	                        result['text'] = '';
	                    }
	                }
	                if (!resultMap.has(result['kit'])) {
	                    resultMap.set(result['kit'], result);
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return Array.from(resultMap.values());
	        var e_1, _a;
	    };
	    DNAParsersService.prototype.getListCSVKey = function (row, source) {
	        switch (source) {
	            case 'FTDNA':
	                return row['ResultID2'] || row['Full Name'];
	            case 'MYHERITAGE':
	                var id = row['DNA Match ID'] || row['DNA_Match_ID'] || row['ResultID2'] || '';
	                if (id.length > 38) {
	                    id = id.slice(-38);
	                }
	                return id;
	            case '23ANDME':
	                //let url = row['Link to Compare View'];
	                //return !!url && url.includes('remote_id=') ? url.substring(url.indexOf('remote_id=')+'remote_id='.length) : row['Display Name'];
	                return row['ehid'];
	            case 'ANCESTRY':
	                return row['matchid'];
	            case 'GEDMATCH':
	                return row['kitnbr'] || row['kit']; // lowercased
	            default:
	                return '';
	        }
	    };
	    DNAParsersService.prototype.detectDelimiter = function (string, delimiters) {
	        if (delimiters === void 0) { delimiters = null; }
	        if (!delimiters) {
	            delimiters = ['\r\n', '\r', '\n'];
	        }
	        var count = 0, detected;
	        delimiters.forEach(function (delimiter) {
	            var matches = string.match(new RegExp(delimiter, 'g'));
	            if (matches && matches.length >= count * 2) {
	                count = matches.length;
	                detected = delimiter;
	            }
	        });
	        return (detected || delimiters[0]);
	    };
	    DNAParsersService.prototype.stripGedmatchExtra = function (text, lineDelimiter) {
	        var kitSort = new RegExp('^"?Triangulated\\s*results\\s*sorted\\s*by\\s*Kit\\s*Number', 'i');
	        var header = new RegExp('^(kit nbr|select\\s*,match|select\\s*,kit|kit\\s*,|chr\\s*,kit1|chr\tkit1)', 'i');
	        var ignore = new RegExp('^(matches|query|\\d+ matches|search|visualization|"?gedmatch.com|"?web site|total|ver:|software|elapsed|triangulated|triangulation|cpu time|\\s*,,)', 'i');
	        var lines = [];
	        var foundHeader = false;
	        var foundKitSort = false;
	        var textLines = text.split(lineDelimiter);
	        for (var ix = 0; ix < textLines.length; ix++) {
	            var line = textLines[ix];
	            line = line.replace(/\u000a/g, ' ').replace(/\u00a0/g, ' ').replace(/\ufffd/g, ' ');
	            if (!foundHeader) {
	                if (line.match(kitSort)) {
	                    foundKitSort = true;
	                }
	                foundHeader = line.match(header);
	                if (foundHeader) {
	                    // fix up header
	                    if (ix + 1 < textLines.length && line.toLowerCase().trim().endsWith('"name')) {
	                        line += textLines[ix + 1];
	                        ix += 1;
	                    }
	                    line = line.toLowerCase().replace(/ +/g, '')
	                        .replace('total', 'autototal').replace('largest', 'autolargest');
	                    if (foundKitSort) {
	                        line = line
	                            .replace('kit1,kit2,start', 'kit1,,,kit2,,,start')
	                            .replace('chr,kit1,kit2,b', 'chr,,kit1,,,,kit2,,,b')
	                            .replace('chr,kit1,,,,kit2,,,,b', 'chr,,kit1,,,,kit2,,,b');
	                    }
	                }
	            }
	            if (!foundHeader) {
	                var fields = line.split(',');
	                //,M890472,*fun4lmw,fun4lmw@comcast.net,GED,1063,2,F,L3f1b1,,3587.1,281.5,1,196.1,196.1
	                if (fields.length === 15 && fields[1].length > 0) {
	                    line = ',kit,name,email,ged/wikitree,age(days),type,sex,mt,y,autototalcm,autolargest,gen,totalcm,largest';
	                    foundHeader = true;
	                }
	            }
	            if (foundHeader && !line.match(ignore)) {
	                lines.push(line);
	            }
	        }
	        return lines.join(lineDelimiter);
	    };
	    DNAParsersService.prototype.replaceMyHeritageHeader = function (text, lineDelimiter, isList) {
	        var lines = text.split(lineDelimiter);
	        var header = lines[0].replace(/"[^"]*"/g, '');
	        var numFields = header.split(',').length;
	        if (isList && numFields === 23) {
	            lines[0] = '"DNA Match ID",Name,Age,Country,"Contact DNA Match","DNA managed by","Contact DNA Manager",Status,"Estimated relationship","Total cM shared","Percent DNA shared","Number of shared segments","Largest segment (cM)","Review DNA Match page","Has family tree","Number of individuals in the tree","Tree managed by","View tree","Contact tree manager","Number of Smart Matches","Shared ancestral surnames","All ancestral surnames",Notes';
	        }
	        else if (!isList && numFields === 9 && !header.endsWith(',KitID')) {
	            lines[0] = 'Name,"Match name",Chromosome,"Start Location","End Location","Start RSID","End RSID",Centimorgans,SNPs';
	        }
	        return lines.join(lineDelimiter);
	    };
	    DNAParsersService.prototype.parseListCSV = function (text, source) {
	        var _this = this;
	        var lineDelimiter = this.detectDelimiter(text);
	        // console.log('lineDelimiter', lineDelimiter);
	        // console.log('text', text);
	        if (source === 'GEDMATCH') {
	            text = this.stripGedmatchExtra(text, lineDelimiter);
	        }
	        else if (source === 'MYHERITAGE') {
	            text = this.replaceMyHeritageHeader(text, lineDelimiter, true);
	        }
	        // console.log('text after strip', text);
	        var data = [];
	        try {
	            data = this.csv.parse(text, { cast: false, header: true, lineDelimiter: lineDelimiter, cellDelimiter: ',' });
	        }
	        // console.log('data', data);
	        catch (err) {
	            console.log('parseListCSV error', err);
	        }
	        var results = data.map(function (row) {
	            var result = {};
	            Object.keys(row).forEach(function (key) {
	                var fieldName = _this.csvListHeaderToField(key, source);
	                if (!!fieldName) {
	                    if (!result[fieldName]) {
	                        result[fieldName] = row[key];
	                    }
	                    else if (!result[fieldName].includes(row[key])) {
	                        result[fieldName] += ' ' + row[key];
	                    }
	                }
	            });
	            result['kit'] = _this.getListCSVKey(row, source);
	            return result;
	        });
	        results = this.postProcessListResults(results, source);
	        console.log('list', source, data.length, results.length);
	        console.log('header', text.split(lineDelimiter)[0]);
	        console.log('first result', results.length > 0 ? results[0] : '');
	        return results;
	    };
	    DNAParsersService.prototype.parseAncestryTreesCSV = function (text) {
	        var _this = this;
	        var lineDelimiter = this.detectDelimiter(text);
	        var data = [];
	        try {
	            data = this.csv.parse(text, { cast: false, header: true, lineDelimiter: lineDelimiter, cellDelimiter: ',' });
	        }
	        catch (err) {
	            console.log('parseAncestryTreesCSV error', err);
	        }
	        var resultMap = new Map();
	        try {
	            for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
	                var row = data_1_1.value;
	                if (row['relid'] < 128) {
	                    var kit = resultMap.get(row['matchid']);
	                    if (!kit) {
	                        kit = { name: row['matchid'], surnames: new Map(), locations: new Map() };
	                        resultMap.set(row['matchid'], kit);
	                    }
	                    if (!!row['surname']) {
	                        if (kit.surnames.has(row['surname'])) {
	                            kit.surnames.set(row['surname'], kit.surnames.get(row['surname']) + 1);
	                        }
	                        else {
	                            kit.surnames.set(row['surname'], 1);
	                        }
	                    }
	                    if (!!row['birthplace']) {
	                        if (kit.locations.has(row['birthplace'])) {
	                            kit.locations.set(row['birthplace'], kit.locations.get(row['birthplace']) + 1);
	                        }
	                        else {
	                            kit.locations.set(row['birthplace'], 1);
	                        }
	                    }
	                    if (!!row['deathplace']) {
	                        if (kit.locations.has(row['deathplace'])) {
	                            kit.locations.set(row['deathplace'], kit.locations.get(row['deathplace']) + 1);
	                        }
	                        else {
	                            kit.locations.set(row['deathplace'], 1);
	                        }
	                    }
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        console.log('surnames-locations', data.length, resultMap.size);
	        console.log('header', text.split(lineDelimiter)[0]);
	        return Array.from(resultMap.values()).map(function (kit) {
	            return {
	                name: kit.name,
	                surnames: _this.utils.mapToSortedArray(kit.surnames).join(', '),
	                locations: _this.utils.mapToSortedArray(kit.locations).join('; ')
	            };
	        });
	        var e_2, _a;
	    };
	    DNAParsersService.prototype.csvSegmentsHeaderToField = function (header) {
	        switch (header.toLowerCase()) {
	            // FTDNA
	            case 'name':
	            case 'profile name':
	            case 'profile_name':
	            case 'full name':
	            case 'full_name':
	            case 'matchname':
	                return '';
	            case 'chromosome':
	                return 'chr';
	            case 'start location':
	            case 'start_location':
	            case 'start':
	                return 'start';
	            case 'end location':
	            case 'end_location':
	            case 'end':
	                return 'end';
	            case 'centimorgans':
	            case 'cm':
	                return 'cm';
	            case 'matching snps':
	            case 'matching_snps':
	            case 'snps':
	                return 'snps';
	            // MYHERITAGE
	            case 'match name':
	            case 'match_name':
	                return 'name'; // TODO needed?
	            //case 'chromosome':
	            //case 'start location':
	            //case 'start':
	            //case 'end location':
	            //case 'end':
	            case 'start rsid':
	            case 'end rsid':
	                return '';
	            //case 'centimorgans':
	            //case 'cm':
	            //case 'snps':
	            //  return 'snps';
	            //23andMe
	            case 'display name':
	            case 'display_name':
	                return 'name';
	            case 'chromosome number':
	            case 'chromosome_number':
	                return 'chr';
	            case 'chromosome start point':
	            case 'chromosome_start_point':
	                return 'start';
	            case 'chromosome end point':
	            case 'chromosome_end_point':
	                return 'end';
	            case 'genetic distance':
	            case 'genetic_distance':
	                return 'cm';
	            case '# snps':
	            case '#_snps':
	                return 'snps';
	            // GEDMATCH
	            case 'chr':
	                return 'chr';
	            case 'startposition':
	            case 'b36startposn':
	            case 'b37startposn':
	            case 'b38startposn':
	            case 'startposn':
	                return 'start';
	            case 'endposition':
	            case 'b36endposn':
	            case 'b37endposn':
	            case 'b38endposn':
	            case 'endposn':
	                return 'end';
	            //case 'cm':
	            //  return 'cm';
	            //case 'snps':
	            //  return 'snps';
	            default:
	                return '';
	        }
	    };
	    DNAParsersService.prototype.getSegmentCSVKey = function (row, source) {
	        switch (source) {
	            case 'FTDNA':
	                return row['KitID'] || row['MATCHNAME'];
	            case 'MYHERITAGE':
	                if (!!row['KitID']) {
	                    return row['KitID'];
	                }
	                var id = row['DNA Match ID'] || row['DNA_Match_ID'] || '';
	                return id.slice(-38);
	            case '23ANDME':// match remote_id to remote_id in dnaProfileSankey
	                var url = row['Link to Compare View'];
	                if (!!url && url.includes('remote_id=')) {
	                    return url.substring(url.indexOf('remote_id=') + 'remote_id='.length);
	                }
	                url = row['Link to Profile Page'];
	                if (!!url) {
	                    // https://you.23andme.com/profile/8f93bd4d80898c2e/
	                    var matches = url.match(/\/profile\/([^/]+)\/?/);
	                    if (!!matches && matches.length > 1) {
	                        return matches[1];
	                    }
	                }
	                return '';
	            case 'GEDMATCH':
	                return row['kit']; // lowercased
	            default:
	                return '';
	        }
	    };
	    DNAParsersService.prototype.parseSegmentCSV = function (text, source) {
	        var _this = this;
	        var lineDelimiter = this.detectDelimiter(text);
	        if (source === 'GEDMATCH') {
	            text = this.stripGedmatchExtra(text, lineDelimiter);
	        }
	        else if (source === 'MYHERITAGE') {
	            text = this.replaceMyHeritageHeader(text, lineDelimiter, false);
	        }
	        var data = [];
	        try {
	            data = this.csv.parse(text, { cast: false, header: true, lineDelimiter: lineDelimiter, cellDelimiter: ',' });
	        }
	        catch (err) {
	            console.log('parseSegmentCSV error', err);
	        }
	        var results = data.map(function (row) {
	            if (!row || Object.keys(row).length === 0) {
	                return null;
	            }
	            var result = {};
	            Object.keys(row).forEach(function (key) {
	                var fieldName = _this.csvSegmentsHeaderToField(key);
	                if (!!fieldName) {
	                    if (!result[fieldName]) {
	                        result[fieldName] = row[key];
	                    }
	                    else if (!result[fieldName].includes(row[key])) {
	                        result[fieldName] += ' ' + row[key];
	                    }
	                }
	            });
	            if (result['chr'] === 'X' || result['chr'] === '98') {
	                result['chr'] = '23';
	            }
	            var key = _this.getSegmentCSVKey(row, source);
	            if (!key) {
	                return null;
	            }
	            result['kit'] = key;
	            return result;
	        }).filter(function (result) { return !!result; });
	        console.log('segment', source, results.length);
	        console.log('header', text.split(lineDelimiter)[0]);
	        console.log('first result', results.length > 0 ? results[0] : '');
	        return results;
	    };
	    DNAParsersService.prototype.csvTriangulationHeaderToField = function (header, source) {
	        switch (header.toLowerCase()) {
	            // FTDNA
	            case 'profile kitid':
	            case 'profile_kitid':
	                return 'kit1';
	            case 'match kitid':
	            case 'match_kitid':
	                return 'kit2';
	            case 'total cm':
	            case 'total_cm':
	                return 'cm';
	            // MYHERITAGE
	            case 'relativeid':
	            case 'relative':
	            case 'match id':
	            case 'match1':
	                //case 'profile kitid':
	                //case 'profile_kitid':
	                return 'kit1';
	            case 'relativeid2':
	            case 'relative2':
	            case 'relative id':
	            case 'match2':
	                //case 'match kitid':
	                //case 'match_kitid':
	                return 'kit2';
	            case 'chromosome':
	                return 'chr';
	            case 'start':
	                return source === 'GEDMATCH' || source === 'MYHERITAGE' || source === '23ANDME' ? 'start' : '';
	            case 'end':
	                return source === 'GEDMATCH' || source === 'MYHERITAGE' || source === '23ANDME' ? 'end' : '';
	            case 'startactual':
	                return 'start';
	            case 'endactual':
	                return 'end';
	            case 'cms':
	            case 'centimorgans':
	                // case 'total cm':
	                // case 'total_cm':
	                return 'cm';
	            //23ANDME
	            //case 'chromosome':
	            //  return 'chr';
	            case 'start point':
	            case 'start_point':
	                return 'start';
	            case 'end point':
	            case 'end_point':
	                return 'end';
	            case 'genetic distance':
	            case 'genetic_distance':
	                return 'cm';
	            case 'shareid1':
	                return 'kit1';
	            case 'shareid2':
	                return 'kit2';
	            //ANCESTRY
	            case 'matchid':
	                return 'kit1';
	            case 'icwid':
	                return 'kit2';
	            // GEDMATCH
	            case 'chr':
	                return 'chr';
	            case 'kit1':
	            case 'kit1number':
	                return 'kit1';
	            case 'kit2':
	            case 'kit2number':
	                return 'kit2';
	            //case 'start':
	            case 'b36start':
	            case 'b37start':
	            case 'b38start':
	                return 'start';
	            //case 'end':
	            case 'b36end':
	            case 'b37end':
	            case 'b38end':
	                return 'end';
	            case 'cm':
	                return 'cm';
	            default:
	                return '';
	        }
	    };
	    DNAParsersService.prototype.parseTriangulationCSV = function (text, source) {
	        var _this = this;
	        var lineDelimiter = this.detectDelimiter(text);
	        if (source === 'GEDMATCH') {
	            text = this.stripGedmatchExtra(text, lineDelimiter);
	        }
	        var data = [];
	        try {
	            data = this.csv.parse(text, { cast: false, header: true, lineDelimiter: lineDelimiter });
	        }
	        catch (err) {
	            console.log('parseTriangulationCSV error', err);
	        }
	        console.log('parseTriangulationCSV', text.length, data.length, data[0], lineDelimiter.length);
	        var results = data.map(function (row) {
	            if (!row || Object.keys(row).length === 0) {
	                return null;
	            }
	            var result = {};
	            Object.keys(row).forEach(function (key) {
	                var fieldName = _this.csvTriangulationHeaderToField(key, source);
	                if (!!fieldName) {
	                    if (!result[fieldName]) {
	                        result[fieldName] = row[key];
	                    }
	                    else if (!result[fieldName].includes(row[key])) {
	                        result[fieldName] += ' ' + row[key];
	                    }
	                }
	            });
	            return result;
	        }).filter(function (result) { return !!result; });
	        console.log('triangulation', source, results.length);
	        console.log('header', text.split(lineDelimiter)[0]);
	        console.log('first result', results.length > 0 ? results[0] : '');
	        return results;
	    };
	    //
	    // helpers
	    //
	    DNAParsersService.prototype.createDOMElement = function (text) {
	        var e = this.$document[0].createElement('div');
	        if (!e) {
	            throw new Error('createDOMElement');
	        }
	        e.innerHTML = text;
	        return e;
	    };
	    DNAParsersService.prototype.listToTSV = function (headers, list) {
	        var rows = [];
	        var _loop_1 = function (item) {
	            var row = [];
	            headers.forEach(function (hdr) {
	                row.push(item[hdr] != null ? item[hdr].toString().replace(/\t/g, '') : '');
	            });
	            rows.push(row.join('\t'));
	        };
	        try {
	            for (var list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
	                var item = list_1_1.value;
	                _loop_1(item);
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        return rows.join('\n');
	        var e_3, _a;
	    };
	    DNAParsersService.prototype.tsvToMap = function (headers, numbers, keyFn, tsv) {
	        if (!tsv) {
	            return new Map();
	        }
	        return new Map(tsv.split('\n').map(function (row) {
	            var fields = row.split('\t');
	            var o = {};
	            headers.forEach(function (hdr, ix) {
	                o[hdr] = numbers[ix] ? +fields[ix] : fields[ix];
	            });
	            var key = keyFn(fields);
	            return [key, o];
	        }));
	    };
	    DNAParsersService.prototype.tsvToList = function (headers, numbers, tsv) {
	        if (!tsv) {
	            return [];
	        }
	        return tsv.split('\n').map(function (row) {
	            var fields = row.split('\t');
	            var o = {};
	            headers.forEach(function (hdr, ix) {
	                o[hdr] = numbers[ix] ? +fields[ix] : fields[ix];
	            });
	            return o;
	        });
	    };
	    return DNAParsersService;
	}());
	exports.default = DNAParsersService;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//Uncomment this for use with shared directory in the future
	// import { DNAProfilesService as _DNAProfilesService } from '@shared/components/dnaProfiles/dnaProfiles.service';
	// class DNAProfilesService extends _DNAProfilesService {
	//   constructor ($log, rx, families, store, changes, segment, utils) {
	//     'ngInject';
	//     super(rx, families, store, changes, segment, utils);
	//   }
	// }
	// export default DNAProfilesService;
	var DNAProfilesService = /** @class */ (function () {
	    DNAProfilesService.$inject = ["$log", "rx", "families", "store", "changes", "segment", "utils"];
	    function DNAProfilesService($log, rx, families, store, changes, segment, utils) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.rx = rx;
	        this.families = families;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "dna_profiles", changes.treeStream(), function (s) { return _this.addData(s); });
	        this.matchGenerations = 12;
	        this.listTSVHeaders = {
	            'GEDMATCH': ['name', 'age', 'autoTotal', 'autoLargest', 'autoGen', 'xTotal', 'xLargest'],
	            'FTDNA': ['name', 'date', 'autoTotal', 'autoLargest', 'relRange', 'relSuggested'],
	            'MYHERITAGE': ['name', 'autoTotal', 'autoCount', 'autoLargest', 'relRange'],
	            '23ANDME': ['name', 'autoTotal', 'autoCount', 'relRange', 'relSuggested'],
	            'ANCESTRY': ['name', 'autoTotal', 'autoCount', 'relRange'],
	        };
	        this.listTSVNumbers = {
	            'GEDMATCH': [false, true, true, true, true, true, true],
	            'FTDNA': [false, false, true, true, false, false],
	            'MYHERITAGE': [false, true, true, true, false],
	            '23ANDME': [false, true, true, false, false],
	            'ANCESTRY': [false, true, true, false]
	        };
	        this.segmentTSVHeaders = {
	            'GEDMATCH': ['name', 'chr', 'start', 'end', 'cm', 'snps'],
	            'FTDNA': ['name', 'chr', 'start', 'end', 'cm', 'snps'],
	            'MYHERITAGE': ['name', 'chr', 'start', 'end', 'cm', 'snps'],
	            '23ANDME': ['name', 'chr', 'start', 'end', 'cm', 'snps'],
	        };
	        this.segmentTSVNumbers = {
	            'GEDMATCH': [false, true, true, true, true, true],
	            'FTDNA': [false, true, true, true, true, true],
	            'MYHERITAGE': [false, true, true, true, true, true],
	            '23ANDME': [false, true, true, true, true, true],
	        };
	        this.triangulationTSVHeaders = {
	            'GEDMATCH': ['chr', 'kit1', 'kit2', 'start', 'end', 'cm'],
	            'FTDNA': ['chr', 'kit1', 'kit2', 'start', 'end', 'cm'],
	            'MYHERITAGE': ['chr', 'kit1', 'kit2', 'start', 'end', 'cm'],
	            '23ANDME': ['chr', 'kit1', 'kit2', 'start', 'end', 'cm'],
	            'ANCESTRY': ['chr', 'kit1', 'kit2', 'start', 'end', 'cm'],
	        };
	        this.triangulationTSVNumbers = {
	            'GEDMATCH': [true, false, false, true, true, true],
	            'FTDNA': [true, false, false, true, true, true],
	            'MYHERITAGE': [true, false, false, true, true, true],
	            '23ANDME': [true, false, false, true, true, true],
	            'ANCESTRY': [true, false, false, true, true, true],
	        };
	        this.sources = [
	            { id: 'GEDMATCH', name: 'GEDmatch' },
	            { id: 'ANCESTRY', name: 'Ancestry' },
	            { id: 'MYHERITAGE', name: 'MyHeritage' },
	            { id: 'FTDNA', name: 'FamilyTreeDNA' },
	            { id: '23ANDME', name: '23andMe' },
	        ];
	    }
	    DNAProfilesService.prototype.getSource = function (id) {
	        return this.sources.find(function (s) { return s.id === id; }).name;
	    };
	    DNAProfilesService.prototype.merge = function (kit, exKit) {
	        exKit.source = kit.source || exKit.source || '';
	        exKit.type = kit.type || exKit.type || '';
	        exKit.url = kit.url || exKit.url || '';
	        exKit.sex = kit.sex || exKit.sex || '';
	        exKit.haploMt = kit.haploMt || exKit.haploMt || '';
	        exKit.haploY = kit.haploY || exKit.haploY || '';
	        exKit.user = exKit.user || kit.user || ''; // don't change user name if exists
	        exKit.email = kit.email || exKit.email || '';
	        exKit.contactURL = kit.contactURL || exKit.contactURL || '';
	        exKit.ageRange = kit.ageRange || exKit.ageRange || '';
	        exKit.managerName = kit.managerName || exKit.managerName || '';
	        exKit.surnames = kit.surnames || exKit.surnames || '';
	        exKit.locations = kit.locations || exKit.locations || '';
	        try {
	            for (var _a = __values(kit.treeURLs.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var u = _b.value;
	                exKit.treeURLs.set(u, true);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        if (!!kit.text && !!exKit.text) {
	            if (!exKit.text.includes(kit.text)) {
	                exKit.text += '<br/>' + kit.text;
	            }
	        }
	        else {
	            exKit.text = kit.text || exKit.text || '';
	        }
	        return exKit;
	        var e_1, _c;
	    };
	    DNAProfilesService.prototype.addData = function (o) {
	        if (!o.source) {
	            o.source = 'GEDMATCH';
	        }
	        return this.utils.addCreateEditDates(o);
	    };
	    DNAProfilesService.prototype.create = function (o) {
	        this.segment.track('dna_profiles.create');
	        return this.store.create(o);
	    };
	    DNAProfilesService.prototype.update = function (o) {
	        this.segment.track('dna_profiles.update');
	        return this.store.update(o);
	    };
	    DNAProfilesService.prototype.del = function (id) {
	        this.segment.track('dna_profiles.delete');
	        return this.store.del(id);
	    };
	    DNAProfilesService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    DNAProfilesService.prototype.stream = function () {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.store.stream(); });
	    };
	    DNAProfilesService.prototype.streamId = function (id) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.store.streamId(id); });
	    };
	    //
	    // helper functions
	    //
	    DNAProfilesService.prototype.augmentDNAProfile = function (s, persons, users) {
	        var subject = new this.rx.AsyncSubject();
	        if (!s) {
	            subject.next(s);
	            subject.complete();
	            return subject;
	        }
	        var waitCount = (s.personId > 0 ? 1 : 0) + 1;
	        s = Object.assign({}, s, {
	            '_person': null,
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        if (!s.filters) {
	            s.filters = new Map();
	        }
	        var src = this.sources.find(function (src) { return src.id === s.source; });
	        s._source = !!src ? src.name : this.sources.find(function (src) { return src.id === 'GEDMATCH'; }).name;
	        // set people
	        if (s.personId > 0) {
	            persons.streamId(s.personId).take(1).subscribe(function (p) {
	                s._person = p;
	                if (--waitCount === 0) {
	                    subject.next(s);
	                    subject.complete();
	                }
	            });
	        }
	        // set created user and edited user
	        this.utils.addCreateEditUsers(s, users).subscribe(function () {
	            if (--waitCount === 0) {
	                subject.next(s);
	                subject.complete();
	            }
	        });
	        return subject;
	    };
	    DNAProfilesService.prototype.hasWord = function (s, w) {
	        return (s.name.toLowerCase().indexOf(w) >= 0) ||
	            (s.description.toLowerCase().indexOf(w) >= 0) ||
	            (!!s._person && s._person._fullName.toLowerCase().indexOf(w) >= 0);
	    };
	    DNAProfilesService.prototype.getPedigree = function (personId) {
	        var _this = this;
	        var pedigree = new Map();
	        return this.families.ready().flatMap(function () { return _this._fillPedigree(personId, 1, _this.matchGenerations, pedigree).map(function () { return pedigree; }); });
	    };
	    DNAProfilesService.prototype._fillPedigree = function (targetId, ahnentafel, gens, pedigree) {
	        var _this = this;
	        if (!pedigree.has(targetId)) {
	            pedigree.set(targetId, ahnentafel);
	        }
	        if (gens === 1) {
	            return this.rx.Observable.of(true);
	        }
	        return this.families.streamParents(targetId).take(1).flatMap(function (fm) {
	            var parents = [];
	            Array.from(fm.values()).forEach(function (f) {
	                if (f.husbandId > 0) {
	                    parents.push({ id: f.husbandId, ahnentafel: ahnentafel * 2 });
	                }
	                if (f.wifeId > 0) {
	                    parents.push({ id: f.wifeId, ahnentafel: ahnentafel * 2 + 1 });
	                }
	            });
	            if (parents.length === 0) {
	                return _this.rx.Observable.of(true);
	            }
	            return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(parents.map(function (parent) { return _this._fillPedigree(parent.id, parent.ahnentafel, gens - 1, pedigree); })));
	            var _a;
	        });
	    };
	    DNAProfilesService.prototype.getMatches = function (pedigree, personIds) {
	        var _this = this;
	        var matches = new Set();
	        personIds = personIds.filter(function (pid) { return pid > 0; });
	        if (personIds.length === 0) {
	            return this.rx.Observable.of([]);
	        }
	        return (_a = this.rx.Observable).forkJoin.apply(_a, __spread(personIds.map(function (id) { return _this._getMatches(pedigree, id, _this.matchGenerations, matches); }))).map(function () {
	            return Array.from(matches);
	        });
	        var _a;
	    };
	    DNAProfilesService.prototype._getMatches = function (pedigree, targetId, gens, matches) {
	        var _this = this;
	        if (pedigree.has(targetId)) {
	            matches.add(pedigree.get(targetId));
	            return this.rx.Observable.of(true);
	        }
	        if (gens === 1) {
	            return this.rx.Observable.of(true);
	        }
	        return this.families.streamParents(targetId).take(1).flatMap(function (fm) {
	            var parents = [];
	            Array.from(fm.values()).forEach(function (f) {
	                if (f.husbandId > 0) {
	                    parents.push(f.husbandId);
	                }
	                if (f.wifeId > 0) {
	                    parents.push(f.wifeId);
	                }
	            });
	            if (parents.length === 0) {
	                return _this.rx.Observable.of(true);
	            }
	            return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(parents.map(function (parent) { return _this._getMatches(pedigree, parent, gens - 1, matches); })));
	            var _a;
	        });
	    };
	    DNAProfilesService.prototype.kitsByName = function (kitMap, source) {
	        return new Map(Array.from(kitMap.values())
	            .filter(function (kit) { return kit.source === source; })
	            .map(function (kit) { return [kit.name, kit]; }));
	    };
	    DNAProfilesService.prototype.kitsEqual = function (fields, existingKit, newKit) {
	        try {
	            for (var fields_1 = __values(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
	                var field = fields_1_1.value;
	                if ((existingKit[field] || '') !== (newKit[field] || '') && !!newKit[field]) {
	                    return false;
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (fields_1_1 && !fields_1_1.done && (_a = fields_1.return)) _a.call(fields_1);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        return true;
	        var e_2, _a;
	    };
	    return DNAProfilesService;
	}());
	exports.default = DNAProfilesService;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//Uncomment this for use with shared directory in the future
	// import { DNAProfileDatasService as _DNAProfileDatasService } from '@shared/components/dnaProfileDatas/dnaProfileDatas.service';
	// class DNAProfileDatasService extends _DNAProfileDatasService {
	//   constructor ($log, rx, store, changes, segment, utils) {
	//     'ngInject';
	//     super(rx, store, changes, segment, utils);
	//   }
	// }
	// export default DNAProfileDatasService;
	var DNAProfileDatasService = /** @class */ (function () {
	    DNAProfileDatasService.$inject = ["$log", "rx", "dnaKits", "store", "changes", "segment", "utils"];
	    function DNAProfileDatasService($log, rx, dnaKits, store, changes, segment, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.rx = rx;
	        this.dnaKits = dnaKits;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "dna_profile_datas", changes.treeStream(), function (s) { return utils.addCreateEditDates(s); });
	    }
	    DNAProfileDatasService.prototype.create = function (o) {
	        this.segment.track('dna_profile_datas.create');
	        return this.store.create(o);
	    };
	    DNAProfileDatasService.prototype.update = function (o) {
	        this.segment.track('dna_profile_datas.update');
	        return this.store.update(o);
	    };
	    DNAProfileDatasService.prototype.del = function (id) {
	        this.segment.track('dna_profile_datas.delete');
	        return this.store.del(id);
	    };
	    DNAProfileDatasService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    DNAProfileDatasService.prototype.stream = function () {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.store.stream(); });
	    };
	    DNAProfileDatasService.prototype.streamId = function (id) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.store.streamId(id); });
	    };
	    DNAProfileDatasService.prototype.reset = function () {
	        this.store.reset();
	    };
	    //
	    // helper functions
	    //
	    DNAProfileDatasService.prototype.countFilters = function (filters) {
	        var count = 0;
	        if (filters.min > 0) {
	            count++;
	        }
	        if (filters.max < 9999) {
	            count++;
	        }
	        count += filters.includeKits.length;
	        count += filters.excludeKits.length;
	        count += filters.includePIDs.length;
	        count += filters.excludePIDs.length;
	        if (!!filters.keywords) {
	            count++;
	        }
	        return count;
	    };
	    DNAProfileDatasService.prototype.setLinkedKitNames = function (sourceKitNames, degrees, linkMap, linkedKitNames) {
	        if (sourceKitNames.size === 0) {
	            return;
	        }
	        try {
	            for (var sourceKitNames_1 = __values(sourceKitNames), sourceKitNames_1_1 = sourceKitNames_1.next(); !sourceKitNames_1_1.done; sourceKitNames_1_1 = sourceKitNames_1.next()) {
	                var kitName = sourceKitNames_1_1.value;
	                linkedKitNames.add(kitName);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (sourceKitNames_1_1 && !sourceKitNames_1_1.done && (_a = sourceKitNames_1.return)) _a.call(sourceKitNames_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        if (degrees > 0) {
	            var targetKitNames = new Set();
	            try {
	                for (var sourceKitNames_2 = __values(sourceKitNames), sourceKitNames_2_1 = sourceKitNames_2.next(); !sourceKitNames_2_1.done; sourceKitNames_2_1 = sourceKitNames_2.next()) {
	                    var sourceKitName = sourceKitNames_2_1.value;
	                    var kitNames = linkMap.get(sourceKitName);
	                    if (!!kitNames) {
	                        try {
	                            for (var kitNames_1 = __values(kitNames), kitNames_1_1 = kitNames_1.next(); !kitNames_1_1.done; kitNames_1_1 = kitNames_1.next()) {
	                                var kitName = kitNames_1_1.value;
	                                if (!linkedKitNames.has(kitName)) {
	                                    targetKitNames.add(kitName);
	                                }
	                            }
	                        }
	                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                        finally {
	                            try {
	                                if (kitNames_1_1 && !kitNames_1_1.done && (_b = kitNames_1.return)) _b.call(kitNames_1);
	                            }
	                            finally { if (e_2) throw e_2.error; }
	                        }
	                    }
	                }
	            }
	            catch (e_3_1) { e_3 = { error: e_3_1 }; }
	            finally {
	                try {
	                    if (sourceKitNames_2_1 && !sourceKitNames_2_1.done && (_c = sourceKitNames_2.return)) _c.call(sourceKitNames_2);
	                }
	                finally { if (e_3) throw e_3.error; }
	            }
	            this.setLinkedKitNames(targetKitNames, degrees - 1, linkMap, linkedKitNames);
	        }
	        var e_1, _a, e_3, _c, e_2, _b;
	    };
	    DNAProfileDatasService.prototype.applyFilters = function (filters, kits, kitCMs, links, kitMatches) {
	        if (!filters) {
	            return kits;
	        }
	        var linkMap = new Map();
	        var includedKitNames = new Set();
	        var excludedKitNames = new Set();
	        var hasIncludeFilter = (!!filters.includeKits && filters.includeKits.length > 0) ||
	            (!!filters.includePIDs && filters.includePIDs.length > 0);
	        if ((!!filters.includeKits && filters.includeKits.length > 0) ||
	            (!!filters.excludeKits && filters.excludeKits.length > 0) ||
	            (!!filters.includePIDs && filters.includePIDs.length > 0) ||
	            (!!filters.excludePIDs && filters.excludePIDs.length > 0)) {
	            // record visible kits
	            var visibleKits = new Set();
	            try {
	                for (var kits_1 = __values(kits), kits_1_1 = kits_1.next(); !kits_1_1.done; kits_1_1 = kits_1.next()) {
	                    var kit = kits_1_1.value;
	                    if (!kit.hidden) {
	                        visibleKits.add(kit.name);
	                    }
	                }
	            }
	            catch (e_4_1) { e_4 = { error: e_4_1 }; }
	            finally {
	                try {
	                    if (kits_1_1 && !kits_1_1.done && (_a = kits_1.return)) _a.call(kits_1);
	                }
	                finally { if (e_4) throw e_4.error; }
	            }
	            try {
	                for (var _b = __values(links || []), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var link = _c.value;
	                    if (!visibleKits.has(link.kit1) || !visibleKits.has(link.kit2)) {
	                        continue;
	                    }
	                    if (linkMap.has(link.kit1)) {
	                        linkMap.get(link.kit1).push(link.kit2);
	                    }
	                    else {
	                        linkMap.set(link.kit1, [link.kit2]);
	                    }
	                    if (linkMap.has(link.kit2)) {
	                        linkMap.get(link.kit2).push(link.kit1);
	                    }
	                    else {
	                        linkMap.set(link.kit2, [link.kit1]);
	                    }
	                }
	            }
	            catch (e_5_1) { e_5 = { error: e_5_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
	                }
	                finally { if (e_5) throw e_5.error; }
	            }
	            var includedKitSeedNames = new Set(filters.includeKits.map(function (id) {
	                var kit = kits.find(function (kit) { return kit.id === id; });
	                return !!kit ? kit.name : '';
	            }));
	            var excludedKitSeedNames = new Set(filters.excludeKits.map(function (id) {
	                var kit = kits.find(function (kit) { return kit.id === id; });
	                return !!kit ? kit.name : '';
	            }));
	            var includePIDs = new Set(filters.includePIDs);
	            var excludePIDs = new Set(filters.excludePIDs);
	            try {
	                for (var kits_2 = __values(kits), kits_2_1 = kits_2.next(); !kits_2_1.done; kits_2_1 = kits_2.next()) {
	                    var kit = kits_2_1.value;
	                    if (kitMatches.has(kit.id)) {
	                        try {
	                            for (var _e = __values(kitMatches.get(kit.id)), _f = _e.next(); !_f.done; _f = _e.next()) {
	                                var pid = _f.value;
	                                if (includePIDs.has(pid)) {
	                                    includedKitSeedNames.add(kit.name);
	                                }
	                                if (excludePIDs.has(pid)) {
	                                    excludedKitSeedNames.add(kit.name);
	                                }
	                            }
	                        }
	                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
	                        finally {
	                            try {
	                                if (_f && !_f.done && (_g = _e.return)) _g.call(_e);
	                            }
	                            finally { if (e_6) throw e_6.error; }
	                        }
	                    }
	                }
	            }
	            catch (e_7_1) { e_7 = { error: e_7_1 }; }
	            finally {
	                try {
	                    if (kits_2_1 && !kits_2_1.done && (_h = kits_2.return)) _h.call(kits_2);
	                }
	                finally { if (e_7) throw e_7.error; }
	            }
	            this.setLinkedKitNames(includedKitSeedNames, filters.includeDegrees, linkMap, includedKitNames);
	            this.setLinkedKitNames(excludedKitSeedNames, filters.excludeDegrees, linkMap, excludedKitNames);
	        }
	        var index = filters.cmRange === 'largest' ? 1 : 0;
	        kits = kits.filter(function (kit) {
	            // hidden
	            if ((kit.hidden && !filters.showHidden) || (!kit.hidden && filters.showHidden)) {
	                return false;
	            }
	            // range
	            if (filters.min || filters.max) {
	                if (kitCMs.has(kit.name)) {
	                    var cms = kitCMs.get(kit.name);
	                    if (cms[index] < filters.min || cms[index] > filters.max) {
	                        return false;
	                    }
	                }
	            }
	            // include
	            if (hasIncludeFilter && !includedKitNames.has(kit.name)) {
	                return false;
	            }
	            // exclude
	            if (excludedKitNames.has(kit.name)) {
	                return false;
	            }
	            return true;
	        });
	        // apply keyword search
	        return this.dnaKits.search(filters.keywords, kits);
	        var e_4, _a, e_5, _d, e_7, _h, e_6, _g;
	    };
	    DNAProfileDatasService.prototype.augmentDNAProfileData = function (s, users) {
	        var subject = new this.rx.AsyncSubject();
	        s = Object.assign({}, s, {
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        // set created user and edited user
	        this.utils.addCreateEditUsers(s, users).subscribe(function () {
	            subject.next(s);
	            subject.complete();
	        });
	        return subject;
	    };
	    return DNAProfileDatasService;
	}());
	exports.default = DNAProfileDatasService;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var easing_service_1 = __webpack_require__(208);
	var EasingService = /** @class */ (function (_super) {
	    __extends(EasingService, _super);
	    // from https://gist.github.com/gre/1650294
	    function EasingService() {
	        'ngInject';
	        return _super.call(this) || this;
	    }
	    return EasingService;
	}(easing_service_1.EasingService));
	exports.default = EasingService;
	// class EasingService {
	//   // from https://gist.github.com/gre/1650294
	//   constructor () {
	//     'ngInject';
	//   }
	//   // no easing, no acceleration
	//   linear(t) { return t; }
	//   // accelerating from zero velocity
	//   easeInQuad(t) { return t*t; }
	//   // decelerating to zero velocity
	//   easeOutQuad(t) { return t*(2-t); }
	//   // acceleration until halfway, then deceleration
	//   easeInOutQuad(t) { return t<0.5 ? 2*t*t : -1+(4-2*t)*t; }
	//   // accelerating from zero velocity
	//   easeInCubic(t) { return t*t*t; }
	//   // decelerating to zero velocity
	//   easeOutCubic(t) { return (--t)*t*t+1; }
	//   // acceleration until halfway, then deceleration
	//   easeInOutCubic(t) { return t<0.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1; }
	//   // accelerating from zero velocity
	//   easeInQuart(t) { return t*t*t*t; }
	//   // decelerating to zero velocity
	//   easeOutQuart(t) { return 1-(--t)*t*t*t; }
	//   // acceleration until halfway, then deceleration
	//   easeInOutQuart(t) { return t<0.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t; }
	//   // accelerating from zero velocity
	//   easeInQuint(t) { return t*t*t*t*t; }
	//   // decelerating to zero velocity
	//   easeOutQuint(t) { return 1+(--t)*t*t*t*t; }
	//   // acceleration until halfway, then deceleration
	//   easeInOutQuint(t) { return t<0.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t; }
	// }
	// export default EasingService;


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var EasingService = /** @class */ (function () {
	    // from https://gist.github.com/gre/1650294
	    function EasingService() {
	    }
	    // no easing, no acceleration
	    EasingService.prototype.linear = function (t) { return t; };
	    // accelerating from zero velocity
	    EasingService.prototype.easeInQuad = function (t) { return t * t; };
	    // decelerating to zero velocity
	    EasingService.prototype.easeOutQuad = function (t) { return t * (2 - t); };
	    // acceleration until halfway, then deceleration
	    EasingService.prototype.easeInOutQuad = function (t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; };
	    // accelerating from zero velocity
	    EasingService.prototype.easeInCubic = function (t) { return t * t * t; };
	    // decelerating to zero velocity
	    EasingService.prototype.easeOutCubic = function (t) { return (--t) * t * t + 1; };
	    // acceleration until halfway, then deceleration
	    EasingService.prototype.easeInOutCubic = function (t) { return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; };
	    // accelerating from zero velocity
	    EasingService.prototype.easeInQuart = function (t) { return t * t * t * t; };
	    // decelerating to zero velocity
	    EasingService.prototype.easeOutQuart = function (t) { return 1 - (--t) * t * t * t; };
	    // acceleration until halfway, then deceleration
	    EasingService.prototype.easeInOutQuart = function (t) { return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t; };
	    // accelerating from zero velocity
	    EasingService.prototype.easeInQuint = function (t) { return t * t * t * t * t; };
	    // decelerating to zero velocity
	    EasingService.prototype.easeOutQuint = function (t) { return 1 + (--t) * t * t * t * t; };
	    // acceleration until halfway, then deceleration
	    EasingService.prototype.easeInOutQuint = function (t) { return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t; };
	    return EasingService;
	}());
	exports.EasingService = EasingService;


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Wilson Kellogg <wilson.kellogg@prosadata.com> - 2016
	 */
	var EndNotesService = /** @class */ (function () {
	    EndNotesService.$inject = ["$log"];
	    function EndNotesService($log) {
	        'ngInject';
	        this.$log = $log;
	        //this.yFooter = 188;
	        //this.maxX = 270;
	    }
	    EndNotesService.prototype.setDoc = function (doc) {
	        this.doc = doc;
	    };
	    EndNotesService.prototype.setPageNumber = function (pageNumber) {
	        this.pageNumber = pageNumber;
	    };
	    EndNotesService.prototype.getPageNumber = function () {
	        return this.pageNumber;
	    };
	    EndNotesService.prototype.setX = function (x) {
	        this.x = x;
	    };
	    EndNotesService.prototype.setY = function (y) {
	        this.y = y;
	    };
	    EndNotesService.prototype.setDeltaY = function (deltaY) {
	        this.deltaY = deltaY;
	    };
	    EndNotesService.prototype.setDeltaYUnderline = function (deltaYUnderline) {
	        this.deltaYUnderline = deltaYUnderline;
	    };
	    EndNotesService.prototype.setDeltaX = function (deltaX) {
	        this.deltaX = deltaX;
	    };
	    EndNotesService.prototype.setMaxX = function (maxX) {
	        this.maxX = maxX;
	    };
	    EndNotesService.prototype.setyFooter = function (yFooter) {
	        this.yFooter = yFooter;
	    };
	    EndNotesService.prototype.setEndNotes = function (endNotes) {
	        this.endNotes = endNotes;
	    };
	    EndNotesService.prototype.setGeneralNotes = function (generalNotes) {
	        this.generalNotes = generalNotes;
	    };
	    EndNotesService.prototype.printGeneralNotes = function () {
	        if (this.generalNotes.length > 0) {
	            var doc = this.doc;
	            var x = this.x;
	            var y = this.y;
	            var deltaY = this.deltaY;
	            var deltaYUnderline = this.deltaYUnderline;
	            var deltaX = this.deltaX;
	            var note = "";
	            var generalNotes = this.generalNotes;
	            doc.setFontSize(10);
	            var txt = "";
	            var len = generalNotes.length;
	            var htmlTxt;
	            var aux;
	            var ret;
	            var j;
	            for (var i = 0; i < len; i++) {
	                note = generalNotes[i];
	                //this.$log.debug("nota",note);
	                if ((note[0]) && (note[0] !== "")) {
	                    var punto = ".";
	                    doc.setFontSize(30);
	                    var aux2 = this.doc.getTextWidth(punto);
	                    y = y - 1;
	                    ret = this.textWrap(y, deltaY, doc, x, deltaX, punto, deltaYUnderline);
	                    y = y + 1;
	                    doc.setFontSize(10);
	                    x = x + aux2;
	                    txt = note[0];
	                    //this.$log.debug("textoBug",txt);
	                    htmlTxt = this.streapHtml(txt);
	                    txt = "";
	                    for (j = 0; j < htmlTxt.length; j++) {
	                        aux = htmlTxt[j];
	                        txt += " " + aux.value;
	                    }
	                    if (txt[txt.length - 1] !== ".") {
	                        txt += ".";
	                    }
	                    ret = this.textWrap(y, deltaY, doc, x, deltaX, txt, deltaYUnderline, false);
	                    y = ret.y;
	                    x = x - aux2;
	                    //TERMINA LO DE GENERAL NOTES
	                }
	                if (note.length > 1) {
	                    x += 5;
	                    for (var k = 1; k < note.length; k++) {
	                        txt = note[k];
	                        htmlTxt = this.streapHtml(txt);
	                        txt = "";
	                        for (j = 0; j < htmlTxt.length; j++) {
	                            aux = htmlTxt[j];
	                            txt += " " + aux.value;
	                            //alert(txt);
	                        }
	                        //this.$log.debug("ultimo",txt[txt.length-1]);
	                        if (txt[txt.length - 1] !== ".") {
	                            txt += ".";
	                        }
	                        ret = this.textWrap(y, deltaY, doc, x, deltaX, txt, deltaYUnderline, false);
	                        y = ret.y;
	                    }
	                    x -= 5;
	                }
	            }
	        }
	    };
	    EndNotesService.prototype.printNotes = function () {
	        //this.$log.debug("ENDNOTES",this.endNotes.length);
	        if (this.endNotes.length > 0) {
	            var doc = this.doc;
	            var x = this.x;
	            var y = this.y;
	            var deltaY = this.deltaY;
	            var deltaYUnderline = this.deltaYUnderline;
	            var deltaX = this.deltaX;
	            var note = "";
	            var endNotes = this.endNotes;
	            doc.setFontSize(10);
	            var txt = "";
	            var len = endNotes.length;
	            var htmlTxt;
	            var aux;
	            var ret;
	            var j;
	            for (var i = 0; i < len; i++) {
	                note = endNotes[i];
	                if (note[0] !== "") {
	                    txt = (i + 1) + ". " + note[0];
	                    htmlTxt = this.streapHtml(txt);
	                    txt = "";
	                    for (j = 0; j < htmlTxt.length; j++) {
	                        aux = htmlTxt[j];
	                        txt += " " + aux.value;
	                        //alert(txt);
	                    }
	                    if (txt[txt.length - 1] !== ".") {
	                        txt += ".";
	                    }
	                    //this.$log.debug("txt joined",txt);
	                    ret = this.textWrap(y, deltaY, doc, x, deltaX, txt, deltaYUnderline, true);
	                    y = ret.y;
	                }
	                if (note.length > 1) {
	                    x += 5;
	                    for (var k = 1; k < note.length; k++) {
	                        txt = note[k];
	                        htmlTxt = this.streapHtml(txt);
	                        txt = "";
	                        for (j = 0; j < htmlTxt.length; j++) {
	                            aux = htmlTxt[j];
	                            txt += " " + aux.value;
	                            //alert(txt);
	                        }
	                        if (txt[txt.length - 1] !== ".") {
	                            txt += ".";
	                        }
	                        //this.$log.debug("txt joined",txt);
	                        ret = this.textWrap(y, deltaY, doc, x, deltaX, txt, deltaYUnderline, true);
	                        y = ret.y;
	                    }
	                    x -= 5;
	                }
	            }
	        }
	    };
	    EndNotesService.prototype.streapHtml = function (txt) {
	        txt = txt.replace(/<\/?[^>]+(>|$)/g, " ");
	        txt = txt.replace(/&lt;/g, "<");
	        txt = txt.replace(/&quot;/g, "\"");
	        txt = txt.replace(/&gt;/g, ">");
	        txt = txt.replace(/&amp;/g, "&");
	        txt = txt.replace(/&nbsp/g, " ");
	        txt = txt.replace(/&apos;/g, "'");
	        //this.$log.debug("streapHtml",txt);
	        //this.$log.debug("streapHtml",txt);
	        var result = [];
	        var t = { tag: "txt", value: txt };
	        result.push(t);
	        /*
	        var sent = txt.split("<");
	        var t;
	        var i=0;
	        while(i<sent.length){
	            if(sent[i].search(">")!=(-1)){
	                var sent2= sent[i].split(">");
	                if(sent2[1]!=""){
	                    //console.log(sent2[1]);
	                    if(sent2[0].charAt(0)=="/") {
	                        t = {tag: "txt" , value : sent[i]};
	                        this.$log.debug("val",t.value);
	                        result.push(t);
	                    }
	                    else {
	                        var type = sent2[0];
	                        if (type.search("a ")!= (-1)) {
	                            var link = sent2[0].split('"');
	                            t = {tag: type , value : link[1]};
	                            this.$log.debug("val",t.value);
	                            result.push(t);
	                        }
	                        else {
	                            t = {tag: type , value : sent2[1]};
	                            this.$log.debug("val",t.value);
	                            result.push(t);
	                        }
	                    }
	                }
	            }
	            else {
	                t = {tag: "txt" , value : sent[i]};
	                this.$log.debug("val",t.value);
	                result.push(t);
	            }
	            i=i+1;
	        }
	        this.$log.debug("result",result);
	        */
	        return result;
	    };
	    EndNotesService.prototype.textWrap = function (y, deltaY, doc, x, deltaX, txt, delta, general) {
	        y = this.increaseY(y, deltaY, doc);
	        var width = this.maxX - x;
	        deltaX += 0;
	        //this.$log.debug("genral?",general);
	        /*
	        txt = "" + txt;
	        txt = txt.replace("/em>.","");
	        txt = txt.replace("a href=,","");
	        
	        var width = 120;
	        var result = new Array();
	        var words = txt.split(" ");
	        var i = 0;
	        while (i < words.length){
	            var full = false;
	            var sentence = "";
	            var sep = "";
	            while (!full){
	                var word = words[i];
	                if (word.length > width) {
	                    full = true;
	                    var parts = doc.splitTextToSize(word, width);
	                    for(var j = 0; j < parts.length; j++){
	                        result.push(parts[j]);
	                    }
	                    i++;
	                }
	                else {
	                    if (sentence.length + word.length + 1 < width){
	                        sentence = sentence.concat(sep);
	                        sentence = sentence.concat(word);
	                        sep = " ";
	                        i++;
	                        full = (i == words.length);

	                    }
	                    else {
	                        full = true;
	                    }
	                }

	            }
	            result.push(sentence);
	        }
	        */
	        y = this.increaseY(y, deltaY, doc);
	        var result = doc.splitTextToSize(txt, width);
	        doc.text(x, y, result[0].trim());
	        for (var i = 1; i < result.length; i++) {
	            var pageNumberOld = this.pageNumber;
	            y = this.increaseY(y, deltaY, doc);
	            var pageNumberNew = this.pageNumber;
	            if (pageNumberNew !== pageNumberOld) {
	                y += 5;
	            }
	            if (general) {
	                doc.text(x + 4, y, result[i].trim());
	            }
	            else {
	                doc.text(x, y, result[i].trim());
	            }
	        }
	        //y = this.increaseY(y, deltaYUnderline, doc);
	        return { y: y, txt: txt };
	    };
	    EndNotesService.prototype.printHeader = function (txt1, txt2) {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.y;
	        var deltaYUnderline = this.deltaYUnderline;
	        doc.setFontSize(14);
	        doc.text(x, y, txt1);
	        var xRightAligned = maxX - 2 * txt2.length - 10;
	        doc.setFontSize(10);
	        doc.text(xRightAligned, y, txt2);
	        y = this.increaseY(y, deltaYUnderline, doc);
	        doc.line(x, y, maxX, y);
	    };
	    EndNotesService.prototype.printFooter = function () {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.yFooter;
	        var pageNumber = this.pageNumber;
	        doc.line(x, y, maxX, y);
	        doc.setFontSize(10);
	        doc.text((x + maxX) / 2, y + 6, pageNumber + "");
	    };
	    EndNotesService.prototype.today = function () {
	        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	        var date = new Date();
	        var _date = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
	        return _date;
	    };
	    EndNotesService.prototype.increaseY = function (y, deltaY, doc) {
	        y += deltaY;
	        if (y >= this.yFooter) {
	            y = 20;
	            doc.addPage();
	            this.pageNumber++;
	            this.printHeader('Endnotes', this.today());
	            this.printFooter();
	            y += 15;
	        }
	        return y;
	    };
	    return EndNotesService;
	}());
	exports.default = EndNotesService;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var evidences_service_1 = __webpack_require__(211);
	var EvidencesService = /** @class */ (function (_super) {
	    __extends(EvidencesService, _super);
	    EvidencesService.$inject = ["$log", "rx", "store", "changes", "$translate", "utils"];
	    function EvidencesService($log, rx, store, changes, $translate, utils) {
	        'ngInject';
	        return _super.call(this, $log, rx, store, changes, utils, angular) || this;
	    }
	    return EvidencesService;
	}(evidences_service_1.EvidencesService));
	exports.default = EvidencesService;
	// class EvidencesService {
	//   constructor ($log, rx, store, changes, $translate, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.$translate = $translate;
	//     this.utils = utils;
	//     this.store = store.create("trees", "evidences", changes.treeStream(), (e) => this._addDerived(e));
	//     this.mediaStream = this.store.addStream(store.streamScanFn(o => {
	//       return !!o.mediaIds ? o.mediaIds.keys() : null;
	//     }));
	//     this.sourceStream = this.store.addStream(store.streamScanFn(o => {
	//       let sourceId = o.citation.sourceId || 0;
	//       return sourceId > 0 ? [sourceId] : null;
	//     }));
	//     this.researchLogStream = this.store.addStream(store.streamScanFn(o => {
	//       let researchLogId = o.researchLogId || 0;
	//       return researchLogId > 0 ? [researchLogId] : null;
	//     }));
	//   }
	//   create(o) {
	//     if (!o.citation) {
	//       this.$log.warn('empty citation: ', angular.toJson(o));
	//     }
	//     o.researchLogId = o.researchLogId || 0;
	//     return this.store.create(o);
	//   }
	//   update(o) {
	//     o.researchLogId = o.researchLogId || 0;
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   // returns a map
	//   streamIds(ids) {
	//     return this.store.streamIds(ids);
	//   }
	//   // returns a map
	//   streamForPerson(person) {
	//     if (!person) {
	//       return this.rx.Observable.of(new Map());
	//     }
	//     return this.ready().flatMap(() => {
	//       return this.streamIds([... new Set( // unique
	//           [].concat(...Array.from(!!person.facts ? person.facts.values() : []).map(f => Array.from(f.evidencePersonas.keys())),
	//             ...Array.from(!!person.names ? person.names.values() : []).map(f => Array.from(f.evidencePersonas.keys()))))]
	//       );
	//     });
	//   }
	//   // returns a map
	//   streamForMedia(mid) {
	//     return this.ready().flatMap(() => this.mediaStream.map(m => m.get(mid) || new Map()));
	//   }
	//   // returns a map
	//   streamForSource(sid) {
	//     return this.ready().flatMap(() => this.sourceStream.map(m => m.get(sid) || new Map()));
	//   }
	//   // returns a map
	//   streamForResearchLog(rlid) {
	//     return this.ready().flatMap(() => this.researchLogStream.map(m => m.get(rlid) || new Map()));
	//   }
	//   // non-streaming functions; caller must make sure that stream is "ready" before calling
	//   getMap() {
	//     return this.store.getStream().getValue();
	//   }
	//   getMediaMap() {
	//     return this.mediaStream.getValue();
	//   }
	//   getSourceMap() {
	//     return this.sourceStream.getValue();
	//   }
	//   //
	//   // helper functions
	//   //
	//   augmentEvidence(e, sources, persons, users) {
	//     let subject = new this.rx.AsyncSubject();
	//     let sourceId = e.citation.sourceId || 0;
	//     let waitCount = (sourceId > 0 ? 1 : 0) + 2;
	//     if (!e) {
	//       console.trace(); // eslint-disable-line
	//     }
	//     e = Object.assign({}, e, {
	//       '_sourceAbbr': '',
	//       '_sourceTitle': '',
	//       '_sourceCreator': '',
	//       '_citation': '',
	//       '_people': new Map(),
	//       '_personas': new Map(),
	//       '_createdUser' : null,
	//       '_editedUser' : null
	//     });
	//     // set source info
	//     if (sourceId > 0) {
	//       sources.streamId(sourceId).take(1).subscribe(s => {
	//         e._sourceAbbr = this.getSourceAbbrev(e, s);
	//         e._sourceTitle = !!s && !!s.title ? s.title : '';
	//         e._sourceCreator = !!s && !!s.creator ? s.creator : '';
	//         let c = e.citation;
	//         e._citation = !!c.text ? c.text : !!s ? this.utils.getCitation(s, c.url, c.page, c.date) : '';
	//         if (--waitCount === 0) {
	//           subject.next(e);
	//           subject.complete();
	//         }
	//       });
	//     }
	//     else {
	//       e._citation = e.citation.text;
	//       e._sourceAbbr = this.getSourceAbbrev(e, null);
	//     }
	//     // set people
	//     persons.streamForEvidence(e.id).take(1).subscribe(pm => {
	//       e._people = pm;
	//       // set _personas
	//       let personaMap = this._getPersonaMap(e.id, pm); // map paId -> person for this evidence
	//       for (let [paId, persona] of e.personas) {
	//         let person = personaMap.get(paId);
	//         e._personas.set(paId, Object.assign({}, persona, {
	//           '_key': paId,
	//           '_id': !!person ? person.id : null,
	//           '_fullName': !!person ? person._fullName : '',
	//           '_relatedToName': (personaMap.has(persona.relatedToKey) ? personaMap.get(persona.relatedToKey)._given || '' : '').split(' ', 2)[0]
	//         }));
	//       }
	//       if (--waitCount === 0) {
	//         subject.next(e);
	//         subject.complete();
	//       }
	//     });
	//     // set created user and edited user
	//     this.utils.addCreateEditUsers(e, users).subscribe(() => {
	//       if (--waitCount === 0) {
	//         subject.next(e);
	//         subject.complete();
	//       }
	//     });
	//     return subject;
	//   }
	//   getSourceAbbrev(e, source) {
	//     let abbr;
	//     if (!!source && !!source.abbr) {
	//       abbr = source.abbr;
	//     }
	//     else if (!!e.citation && !!e.citation.text) {
	//       abbr = this.utils.truncate(this.utils.removeHtml(e.citation.text), 80);
	//     }
	//     else if (!!e.citation && !!e.citation.url) {
	//       abbr = this.utils.truncate(e.citation.url, 80);
	//     }
	//     else {
	//       abbr = this.utils.translations['SUPPORTING_EVIDENCE'];
	//     }
	//     return abbr;
	//   }
	//   // map personas to persons
	//   _getPersonaMap(eid, pm) {
	//     let personaMap = new Map();
	//     Array.from(pm.values()).forEach(p => {
	//       Array.from(p.names.values()).concat(Array.from(p.facts.values()))
	//         .map(nf => !!nf.evidencePersonas ? nf.evidencePersonas.get(eid) : 0)
	//         .filter(paId => paId > 0)
	//         .forEach(paId => {
	//           personaMap.set(paId, p);
	//         });
	//     });
	//     return personaMap;
	//   }
	//   _addDerived(e) {
	//     let typ = !!e.fact ? e.fact.type : null;
	//     let ft = this.utils.factTypes.find(ft => ft.value === typ);
	//     e = this.utils.addCreateEditDates(e);
	//     return Object.assign(e, {
	//       '_date': !!e.fact ? e.fact.date : '',
	//       '_dateSort': !!e.fact ? e.fact.dateSort : '',
	//       '_place': !!e.fact ? e.fact.place : '',
	//       '_type' : !!ft ? ft.display : typ,
	//       '_hasSource': !!e.citation && (e.citation.sourceId > 0 || !!e.citation.text || !!e.citation.url)
	//     });
	//   }
	//   hasWord(e, w) {
	//     return (e.text.toLowerCase().indexOf(w) >= 0) ||
	//       (e._sourceTitle.toLowerCase().indexOf(w) >= 0) ||
	//       (e._type.toLowerCase().indexOf(w) >= 0) ||
	//       ((!!e.fact ? e.fact.date : '').toLowerCase().indexOf(w) >= 0) ||
	//       ((!!e.fact ? e.fact.place : '').toLowerCase().indexOf(w) >= 0) ||
	//       ((!!e.fact ? e.fact.placeDetails : '').toLowerCase().indexOf(w) >= 0) ||
	//       ((!!e.fact ? e.fact.value : '').toLowerCase().indexOf(w) >= 0) ||
	//       ((!!e.citation ? e.citation.text : '').toLowerCase().indexOf(w) >= 0) ||
	//       ((!!e.citation ? e.citation.date : '').toLowerCase().indexOf(w) >= 0) ||
	//       ((!!e.citation ? e.citation.page : '').toLowerCase().indexOf(w) >= 0) ||
	//       ((!!e.citation ? e.citation.url : '').toLowerCase().indexOf(w) >= 0) ||
	//       (Array.from(e._personas.values()).some(pa => {
	//         return (pa._fullName.toLowerCase().indexOf(w) >= 0) ||
	//           (pa.relationshipType.toLowerCase().indexOf(w) >= 0) ||
	//           (Array.from(pa.facts.values()).some(f => {
	//             return (f.date.toLowerCase().indexOf(w) >= 0) ||
	//               (f.place.toLowerCase().indexOf(w) >= 0) ||
	//               (f.value.toLowerCase().indexOf(w) >= 0);
	//           }));
	//       }));
	//   }
	// }
	// export default EvidencesService;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { BehaviorSubject, AsyncSubject } from "../../node_modules/rxjs";
	var EvidencesService = /** @class */ (function () {
	    function EvidencesService(log, rx, store, changes, utils, angularUtils) {
	        var _this = this;
	        this.log = log;
	        this.rx = rx;
	        this.utils = utils;
	        this.angularUtils = angularUtils;
	        this.store = store.create("trees", "evidences", changes.treeStream(), function (e) { return _this._addDerived(e); });
	        this.mediaStream = this.store.addStream(store.streamScanFn(function (o) {
	            return !!o.mediaIds ? o.mediaIds.keys() : null;
	        }));
	        this.sourceStream = this.store.addStream(store.streamScanFn(function (o) {
	            var sourceId = o.citation.sourceId || 0;
	            return sourceId > 0 ? [sourceId] : null;
	        }));
	        this.researchLogStream = this.store.addStream(store.streamScanFn(function (o) {
	            var researchLogId = o.researchLogId || 0;
	            return researchLogId > 0 ? [researchLogId] : null;
	        }));
	    }
	    EvidencesService.prototype.create = function (o) {
	        if (!o.citation) {
	            this.log.warn('empty citation: ', this.angularUtils.toJson(o));
	        }
	        o.researchLogId = o.researchLogId || 0;
	        return this.store.create(o);
	    };
	    EvidencesService.prototype.update = function (o) {
	        o.researchLogId = o.researchLogId || 0;
	        return this.store.update(o);
	    };
	    EvidencesService.prototype.del = function (id) {
	        return this.store.del(id);
	    };
	    EvidencesService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    EvidencesService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    EvidencesService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    // returns a map
	    EvidencesService.prototype.streamIds = function (ids) {
	        return this.store.streamIds(ids);
	    };
	    // returns a map
	    EvidencesService.prototype.streamForPerson = function (person) {
	        var _this = this;
	        if (!person) {
	            return this.rx.Observable.of(new Map());
	        }
	        return this.ready().flatMap(function () {
	            return _this.streamIds(__spread(new Set([].concat.apply(// unique
	            [], __spread(Array.from(!!person.facts ? person.facts.values() : []).map(function (f) { return Array.from(f.evidencePersonas.keys()); }), Array.from(!!person.names ? person.names.values() : []).map(function (f) { return Array.from(f.evidencePersonas.keys()); }))))));
	        });
	    };
	    // returns a map
	    EvidencesService.prototype.streamForMedia = function (mid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.mediaStream.map(function (m) { return m.get(mid) || new Map(); }); });
	    };
	    // returns a map
	    EvidencesService.prototype.streamForSource = function (sid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.sourceStream.map(function (m) { return m.get(sid) || new Map(); }); });
	    };
	    // returns a map
	    EvidencesService.prototype.streamForResearchLog = function (rlid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.researchLogStream.map(function (m) { return m.get(rlid) || new Map(); }); });
	    };
	    // non-streaming functions; caller must make sure that stream is "ready" before calling
	    EvidencesService.prototype.getMap = function () {
	        return this.store.getStream().getValue();
	    };
	    EvidencesService.prototype.getMediaMap = function () {
	        return this.mediaStream.getValue();
	    };
	    EvidencesService.prototype.getSourceMap = function () {
	        return this.sourceStream.getValue();
	    };
	    //
	    // helper functions
	    //
	    EvidencesService.prototype.augmentEvidence = function (e, sources, persons, users) {
	        var _this = this;
	        var subject = new this.rx.AsyncSubject();
	        var sourceId = e.citation.sourceId || 0;
	        var waitCount = (sourceId > 0 ? 1 : 0) + (!!users ? 1 : 0) + 1;
	        if (!e) {
	            console.trace(); // eslint-disable-line
	        }
	        e = Object.assign({}, e, {
	            '_sourceAbbr': '',
	            '_sourceTitle': '',
	            '_sourceCreator': '',
	            '_citation': '',
	            '_people': new Map(),
	            '_personas': new Map(),
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        // set source info
	        if (sourceId > 0) {
	            sources.streamId(sourceId).take(1).subscribe(function (s) {
	                e._sourceAbbr = _this.getSourceAbbrev(e, s);
	                e._sourceTitle = !!s && !!s.title ? s.title : '';
	                e._sourceCreator = !!s && !!s.creator ? s.creator : '';
	                var c = e.citation;
	                e._citation = !!c.text ? c.text : !!s ? _this.utils.getCitation(s, c.url, c.page, c.date) : '';
	                if (--waitCount === 0) {
	                    subject.next(e);
	                    subject.complete();
	                }
	            });
	        }
	        else {
	            e._citation = e.citation.text;
	            e._sourceAbbr = this.getSourceAbbrev(e, null);
	        }
	        // set people
	        persons.streamForEvidence(e.id).take(1).subscribe(function (pm) {
	            e._people = pm;
	            // set _personas
	            var personaMap = _this._getPersonaMap(e.id, pm); // map paId -> person for this evidence
	            try {
	                for (var _a = __values(e.personas), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var _c = __read(_b.value, 2), paId = _c[0], persona = _c[1];
	                    var person = personaMap.get(paId);
	                    e._personas.set(paId, Object.assign({}, persona, {
	                        '_key': paId,
	                        '_id': !!person ? person.id : null,
	                        '_fullName': !!person ? person._fullName : '',
	                        '_relatedToName': (personaMap.has(persona.relatedToKey) ? personaMap.get(persona.relatedToKey)._given || '' : '').split(' ', 2)[0]
	                    }));
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            if (--waitCount === 0) {
	                subject.next(e);
	                subject.complete();
	            }
	            var e_1, _d;
	        });
	        // set created user and edited user
	        if (!!users) {
	            this.utils.addCreateEditUsers(e, users).subscribe(function () {
	                if (--waitCount === 0) {
	                    subject.next(e);
	                    subject.complete();
	                }
	            });
	        }
	        return subject;
	    };
	    EvidencesService.prototype.getSourceAbbrev = function (e, source) {
	        var abbr;
	        if (!!source && !!source.abbr) {
	            abbr = source.abbr;
	        }
	        else if (!!e.citation && !!e.citation.text) {
	            abbr = this.utils.truncate(this.utils.removeHtml(e.citation.text), 80);
	        }
	        else if (!!e.citation && !!e.citation.url) {
	            abbr = this.utils.truncate(e.citation.url, 80);
	        }
	        else {
	            abbr = this.utils.translations['SUPPORTING_EVIDENCE'];
	        }
	        return abbr;
	    };
	    // map personas to persons
	    EvidencesService.prototype._getPersonaMap = function (eid, pm) {
	        var personaMap = new Map();
	        Array.from(pm.values()).forEach(function (p) {
	            Array.from(p.names.values()).concat(Array.from(p.facts.values()))
	                .map(function (nf) { return !!nf.evidencePersonas ? nf.evidencePersonas.get(eid) : 0; })
	                .filter(function (paId) { return paId > 0; })
	                .forEach(function (paId) {
	                personaMap.set(paId, p);
	            });
	        });
	        return personaMap;
	    };
	    EvidencesService.prototype._addDerived = function (e) {
	        var factType = !!e.fact ? e.fact.type : null;
	        var ft = this.utils.factTypes.find(function (ft) { return ft.value === factType; });
	        var displayType = !!ft ? ft.display : this.utils.truncate((factType || e.text || e.citation.text || 'Other').replace(/<[a-z\/ ]+>/gi, ' ').replace(/&([a-z]+|#[0-9]+);/g, ''), 20);
	        e = this.utils.addCreateEditDates(e);
	        return Object.assign(e, {
	            '_date': !!e.fact ? e.fact.date : '',
	            '_dateSort': !!e.fact ? e.fact.dateSort : '',
	            '_place': !!e.fact ? e.fact.place : '',
	            '_type': displayType,
	            '_hasSource': !!e.citation && (e.citation.sourceId > 0 || !!e.citation.text || !!e.citation.url)
	        });
	    };
	    EvidencesService.prototype.hasWord = function (e, w) {
	        return (e.text.toLowerCase().indexOf(w) >= 0) ||
	            ((e._sourceTitle || '').toLowerCase().indexOf(w) >= 0) ||
	            ((e._type || '').toLowerCase().indexOf(w) >= 0) ||
	            ((!!e.fact ? e.fact.date : '').toLowerCase().indexOf(w) >= 0) ||
	            ((!!e.fact ? e.fact.place : '').toLowerCase().indexOf(w) >= 0) ||
	            ((!!e.fact ? e.fact.placeDetails : '').toLowerCase().indexOf(w) >= 0) ||
	            ((!!e.fact ? e.fact.value : '').toLowerCase().indexOf(w) >= 0) ||
	            ((!!e.citation ? e.citation.text : '').toLowerCase().indexOf(w) >= 0) ||
	            ((!!e.citation ? e.citation.date : '').toLowerCase().indexOf(w) >= 0) ||
	            ((!!e.citation ? e.citation.page : '').toLowerCase().indexOf(w) >= 0) ||
	            ((!!e.citation ? e.citation.url : '').toLowerCase().indexOf(w) >= 0) ||
	            ((!!e._personas ? Array.from(e._personas.values()) : []).some(function (pa) {
	                return (pa._fullName.toLowerCase().indexOf(w) >= 0) ||
	                    (pa.relationshipType.toLowerCase().indexOf(w) >= 0) ||
	                    (Array.from(pa.facts.values()).some(function (f) {
	                        return (f.date.toLowerCase().indexOf(w) >= 0) ||
	                            (f.place.toLowerCase().indexOf(w) >= 0) ||
	                            (f.value.toLowerCase().indexOf(w) >= 0);
	                    }));
	            }));
	    };
	    return EvidencesService;
	}());
	exports.EvidencesService = EvidencesService;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var evidenceUtils_service_1 = __webpack_require__(213);
	var EvidenceUtilsService = /** @class */ (function (_super) {
	    __extends(EvidenceUtilsService, _super);
	    EvidenceUtilsService.$inject = ["$log", "rx", "sources", "evidences", "dates", "places", "persons", "families", "segment", "utils"];
	    function EvidenceUtilsService($log, rx, sources, evidences, dates, places, persons, families, segment, utils) {
	        'ngInject';
	        return _super.call(this, $log, rx, sources, evidences, dates, places, persons, families, segment, utils) || this;
	    }
	    return EvidenceUtilsService;
	}(evidenceUtils_service_1.EvidenceUtilsService));
	exports.default = EvidenceUtilsService;
	// class EvidenceUtilsService {
	//   constructor ($log, rx, sources, evidences, dates, places, persons, families, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.sources = sources;
	//     this.evidences = evidences;
	//     this.dates = dates;
	//     this.places = places;
	//     this.persons = persons;
	//     this.families = families;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.livingWords = ['living', 'private', 'alive', 'details withheld', 'n', 'no'];
	//     this.parentRelationshipTypes = ['FATHER', 'MOTHER', 'PARENT', 'ADOPTIVE_PARENT', 'STEP_PARENT'];
	//     this.familyRelationshipTypes = this.parentRelationshipTypes.concat(['SPOUSE', 'CHILD']);
	//   }
	//   // form=evidence, type, value, date, place, placeText, placeDetails, text, url, page, sourceDate, citation, nameGiven, nameSurname, namePrefix, nameSuffix, nameType,
	//   // personas=[key, relationshipType, relatedToKey(string), role, person, principal, nameGiven, nameSurname, namePrefix, nameSuffix, updateProfileName/Birth/Death,
	//   //           facts=[key, type, typeText, value, date, place, placeText]
	//   //           birth={type, date, place, placeText}, death={type, date, place, placeText}] // used by add person to add facts to a person but not to the evidence
	//   //   personas are updated with personId
	//   post(form, personas, source = null, sourceText = '', deletedNamesFacts = []) {
	//     let evidence;
	//     this.$log.debug('evidenceUtils.post', form, personas, deletedNamesFacts);
	//     this.segment.track(!!form.evidence ? 'evidences.update' : 'evidences.create');
	//     return this.postSource(source, sourceText)
	//     .flatMap(source => {
	//       return this.postEvidence(source, form, personas);
	//     }).flatMap(evid => {
	//       evidence = evid;
	//       this.$log.debug('evidenceUtils.post evidence', evid);
	//       return this.postPeople(personas, evid, deletedNamesFacts);
	//     }).flatMap(personaPersons => {
	//       return this.postFamilies(personaPersons);
	//     }).flatMap(() => {
	//       return this.removeNamesFactsPidFromPersons(personas, deletedNamesFacts);
	//     }).flatMap(() => {
	//       return this.rx.Observable.of(evidence);
	//     });
	//   }
	//   del(evidence, deletedNamesFacts = []) {
	//     this.$log.debug('evidenceUtils.del', evidence, deletedNamesFacts);
	//     this.segment.track('evidences.delete');
	//     // set keepOnParents flag if B/C and not deleted
	//     //let typ = evidence.fact.type;
	//     //let keepOnParents = (typ === 'BIRT' || typ === 'CHR') && deletedNamesFacts.length > 0 && !deletedNamesFacts[0].delete;
	//     // remove names & facts from people
	//     return this.removeNamesFactsPidFromPersons([], deletedNamesFacts)
	//     .flatMap(() => {
	//       //return this.rx.Observable.of(null);
	//       // delete evidence
	//       return this.evidences.del(evidence.id);
	//     });
	//   }
	//   postSource(source, sourceText) {
	//     if (!!source && source.id > 0) {
	//       this.$log.debug('evidenceUtils.postSource reuse');
	//       return this.rx.Observable.of(this.utils.clone(source));
	//     }
	//     if (!source && !sourceText) {
	//       this.$log.debug('evidenceUtils.postSource omit');
	//       return this.rx.Observable.of(null);
	//     }
	//     let src;
	//     if (!!source) {
	//       src = source;
	//     }
	//     else {
	//       src = {
	//         abbr: sourceText,
	//         title: sourceText
	//       };
	//     }
	//     this.$log.debug('evidenceUtils.postSource create');
	//     return this.sources.create(src, true);
	//   }
	//   postEvidence(source, form, personas) {
	//     let evidence;
	//     if (!!form.evidence) {
	//       evidence = this.utils.clone(form.evidence);
	//     }
	//     else {
	//       evidence = {
	//         id: 0,
	//         fact: {},
	//         externalImageURL: '',
	//         citation: {}
	//       };
	//     }
	//     evidence.fact.type = form.type || 'Unknown';
	//     evidence.fact.value = form.value;
	//     if (evidence.fact.date !== form.date) {
	//       evidence.fact.date = form.date;
	//       evidence.fact.dateSort = '';
	//     }
	//     let place = !!form.place ? form.place.name : !!form.placeText ? form.placeText : '';
	//     if (evidence.fact.place !== place) {
	//       evidence.fact.place = place;
	//       evidence.fact.placeStandard = !!form.place ? form.place.standardName : '';
	//       evidence.fact.latitude = !!form.place ? form.place.latitude : 0;
	//       evidence.fact.longitude = !!form.place ? form.place.longitude : 0;
	//     }
	//     evidence.fact.placeDetails = form.placeDetails;
	//     evidence.text = form.text || '';
	//     evidence.researchLogId = +form.researchLogId || 0;
	//     evidence.citation.sourceId = !!source ? source.id : 0;
	//     evidence.citation.url = form.url;
	//     evidence.citation.page = form.page;
	//     evidence.citation.date = form.sourceDate;
	//     evidence.citation.text = form.citation;
	//     evidence.mediaIds = new Map();
	//     if (!!form.mediaIds) {
	//       for (let [mediaId] of form.mediaIds) {
	//         evidence.mediaIds.set(mediaId, true);
	//       }
	//     }
	//     evidence.personas = new Map();
	//     personas.forEach((pa, ix) => {
	//       let persona = {
	//         principal: pa.principal,
	//         relatedToKey: this.getRelatedToKey(pa, ix),
	//         relationshipType: ix === 0 ? '' : !!pa.relationshipType && pa.relationshipType !== 'OTHER' ? pa.relationshipType : pa.role,
	//         names: new Map(),
	//         facts: new Map()
	//       };
	//       let name = this.utils.createName(pa.nameGiven, pa.nameSurname, pa.namePrefix, pa.nameSuffix);
	//       if (!this.utils.isNameEmpty(name)) {
	//         persona.names.set(1, {
	//           nameForms: new Map([['default', name]]),
	//           type: ''
	//         });
	//       }
	//       name = this.utils.createName(form.nameGiven, form.nameSurname, form.namePrefix, form.nameSuffix);
	//       if (form.type === 'NAME' && ix === 0 && !this.utils.isNameEmpty(name)) {
	//         persona.names.set(1, {
	//           nameForms: new Map([['default', name]]),
	//           type: form.nameType
	//         });
	//       }
	//       for (let [,f] of pa.facts) {
	//         if (!this.utils.isFactEmpty(f)) {
	//           if (!f.type && !f.typeText) {
	//             f.typeText = 'Unknown';
	//           }
	//           persona.facts.set(f.key, this.toPersonaFact(f));
	//         }
	//       }
	//       let hasReference = personas.some((opa, oix) => this.getRelatedToKey(opa, oix) === pa.key);
	//       if (ix === 0 || !!pa.person || persona.facts.size > 0 || persona.names.size > 0 || hasReference) {
	//         evidence.personas.set(pa.key, persona);
	//       }
	//     });
	//     if (evidence.id > 0) {
	//       this.$log.debug('evidenceUtils.postEvidence update', evidence);
	//       return this.evidences.update(evidence);
	//     }
	//     else if (this.isEmptyEvidence(evidence)) {
	//       this.$log.debug('evidenceUtils.postEvidence omit', evidence);
	//       return this.rx.Observable.of(evidence);
	//     }
	//     else {
	//       this.$log.debug('evidenceUtils.postEvidence create', evidence);
	//       return this.evidences.create(evidence);
	//     }
	//   }
	//   getRelatedToKey(pa, ix) {
	//     return ix === 0 || !pa.relationshipType || pa.relationshipType === 'OTHER' ? 0 : pa.relatedToKey;
	//   }
	//   isEmptyEvidence(evidence) {
	//     if (evidence.personas.size > 1) {
	//       return false;
	//     }
	//     let pa = this.utils.first(evidence.personas);
	//     return !evidence.text && !evidence.researchLogId && !evidence.externalImageURL && evidence.mediaIds.size === 0 &&
	//       !evidence.citation.sourceId && !evidence.citation.url && !evidence.citation.page && !evidence.citation.date && !evidence.citation.text &&
	//       (evidence.personas.size === 0 || (pa.facts.size === 0 && (pa.names.size === 0 || (pa.names.size === 1 && evidence.fact.type === 'NAME'))));
	//   }
	//   postPeople(personas, evidence, deletedNamesFacts) {
	//     // skip personas that didn't get added to the evidence
	//     personas = personas.filter(pa => evidence.personas.has(pa.key));
	//     // set personId for each persona (used to calculate principalIds)
	//     personas.forEach(pa => {
	//       pa.personId = !!pa.person && pa.person.id > 0 ? pa.person.id : !!pa.person ? this.utils.randomId() : 0;
	//     });
	//     // update all people at once
	//     if (personas.length ===0) {
	//       return this.rx.Observable.of([]);
	//     }
	//     //// if we need to create a new birth evidence because we're deleting the last evidence for a birth but don't want to delete the birth fact
	//     //let birthEvidenceIds = personas.map(pa => {
	//     //  return {pid: !!pa.person ? pa.person.id : 0, eid: this.utils.randomId()};
	//     //});
	//     return this.rx.Observable.forkJoin(...personas.map(pa => {
	//       return this.getEvidencesForPerson(pa.person).flatMap(evidenceMap => {
	//         return this.postPerson(pa, personas, evidence.id, evidence.fact, evidence.personas.get(pa.key), evidenceMap, deletedNamesFacts);
	//       });
	//     }));
	//   }
	//   getEvidencesForPerson(person) {
	//     if (!person || person.id === 0) {
	//       return this.rx.Observable.of(new Map());
	//     }
	//     return this.evidences.streamForPerson(person).take(1);
	//   }
	//   postPerson(pa, personas, evidenceId, primaryFact, evidencePersona, evidenceMap, deletedNamesFacts) {
	//     this.$log.debug('evidenceUtils.postPerson', pa, primaryFact, deletedNamesFacts);
	//     if (!pa.person) {
	//       return this.rx.Observable.of({persona: pa, person: null});
	//     }
	//     let updated = false;
	//     //let evidenceFactKeyRels = [];
	//     let person = this.utils.clone(pa.person);
	//     // remember names and facts with evidenceId
	//     let principalPersonas = personas.filter(pa => pa.principal && !!pa.person);
	//     let principalIds = principalPersonas.map(pa => pa.personId);
	//     let supportedNameKeys = Array.from(person.names.keys()).filter(key => person.names.get(key).evidencePersonas.get(evidenceId) > 0);
	//     let supportedFactKeys = Array.from(person.facts.keys()).filter(key => person.facts.get(key).evidencePersonas.get(evidenceId) > 0);
	//     // get preferences
	//     let preferredNameKey = person.preferredNameKey > 0 ? person.preferredNameKey : pa.person.names.size > 0 ? Array.from(pa.person.names.keys())[0] : 0;
	//     let birthEntry = Array.from(pa.person.facts.entries()).find(([,f]) => f.principal && f.type === 'BIRT');
	//     let preferredBirthKey = person.preferredBirthKey > 0 ? person.preferredBirthKey : !!birthEntry ? birthEntry[0] : 0;
	//     let deathEntry = Array.from(pa.person.facts.entries()).find(([,f]) => f.principal && f.type === 'DEAT');
	//     let preferredDeathKey = person.preferredDeathKey > 0 ? person.preferredDeathKey : !!deathEntry ? deathEntry[0] : 0;
	//     // remove unsupported childbirth facts -- still needed?
	//     //if ((primaryFact.type === 'BIRT' || primaryFact.type === 'CHR') && principalIds.length === 1 && principalPersonas[0].updateProfileBirth) {
	//     //  Array.from(person.facts.entries())
	//     //    .filter(([,fact]) => !fact.principal && fact.principalId1 === principalIds[0] && fact.evidencePersonas.size === 0)
	//     //    .forEach(([key]) => {
	//     //      person.facts.delete(key);
	//     //    });
	//     //}
	//     // remove support for existing names and facts
	//     supportedNameKeys.forEach(key => {
	//       person.names.get(key).evidencePersonas.delete(evidenceId);
	//     });
	//     supportedFactKeys.forEach(key => {
	//       person.facts.get(key).evidencePersonas.delete(evidenceId);
	//     });
	//     // set living
	//     if (!person.living) {
	//       person.living = this.calcLiving(evidencePersona, primaryFact);
	//       if (!!person.living) {
	//         updated = true;
	//       }
	//     }
	//     // set gender
	//     if (!person.gender) {
	//       person.gender = this.calcGender(evidencePersona, personas);
	//       if (!!person.gender) {
	//         updated = true;
	//       }
	//     }
	//     // update name - don't update the preferred name from the persona if we already have a name from the new person
	//     if (this.updateName(pa.key, evidencePersona, primaryFact, evidenceId, pa.updateProfileName && !(person.id === 0 && preferredNameKey > 0), person)) {
	//       updated = true;
	//     }
	//     // update facts
	//     if (this.updateFacts(pa.key, evidencePersona.principal, Array.from(evidencePersona.facts.values()), evidenceId, evidenceMap, primaryFact, principalIds,
	//         pa.updateProfileBirth, pa.updateProfileDeath, pa.personId, person, personas, supportedFactKeys)) {
	//       updated = true;
	//     }
	//     // update preferences
	//     if (!person.preferredNameKey && preferredNameKey > 0) {
	//       person.preferredNameKey = preferredNameKey;
	//       updated = true;
	//     }
	//     if (!person.preferredBirthKey && preferredBirthKey > 0) {
	//       person.preferredBirthKey = preferredBirthKey;
	//       updated = true;
	//     }
	//     if (!person.preferredDeathKey && preferredDeathKey > 0) {
	//       person.preferredDeathKey = preferredDeathKey;
	//       if (person.living !== 'FALSE') {
	//         person.living = 'FALSE';
	//       }
	//       updated = true;
	//     }
	//     // remove edited name/fact
	//     if (!!pa.nameKey && person.names.has(pa.nameKey) && person.names.get(pa.nameKey).evidencePersonas.size === 0 &&
	//         !(person.preferredNameKey === pa.nameKey && !pa.updateProfileName)) { // don't delete preferred name
	//       person.names.delete(pa.nameKey);
	//       if (person.preferredNameKey === pa.nameKey) {
	//         person.preferredNameKey = 0;
	//       }
	//       updated = true;
	//     }
	//     if (!!pa.factKey && person.facts.has(pa.factKey) && person.facts.get(pa.factKey).evidencePersonas.size === 0) {
	//       if (!(person.preferredBirthKey === pa.factKey && !pa.updateProfileBirth) && // don't delete preferred birth or death
	//           !(person.preferredDeathKey === pa.factKey && !pa.updateProfileDeath)) {
	//         // delete fact
	//         person.facts.delete(pa.factKey);
	//         if (person.preferredBirthKey === pa.factKey) {
	//           person.preferredBirthKey = 0;
	//         }
	//         if (person.preferredDeathKey === pa.factKey) {
	//           person.preferredDeathKey = 0;
	//         }
	//       }
	//       //else {
	//       //  // add evidence to fact
	//       //  evidenceFactKeyRels.push({key: pa.factKey, relationshipType: pa.relationshipType});
	//       //}
	//       updated = true;
	//     }
	//     // remove names & facts that have been updated or deleted and no longer supported
	//     supportedNameKeys.forEach(key => {
	//       if (person.names.get(key).evidencePersonas.size === 0 &&
	//         !deletedNamesFacts.find(nf => nf.personId === person.id && nf.isName && nf.key === key && !nf.delete) &&
	//         !(person.preferredNameKey === key && !pa.updateProfileName)) { // don't delete preferred name
	//         person.names.delete(key);
	//         if (person.preferredNameKey === key) {
	//           person.preferredNameKey = 0;
	//         }
	//         updated = true;
	//       }
	//       else if (!person.names.get(key).evidencePersonas.has(evidenceId)) {
	//         // support has been removed
	//         updated = true;
	//       }
	//     });
	//     supportedFactKeys.forEach(key => {
	//       if (person.facts.get(key).evidencePersonas.size === 0) {
	//         if (!deletedNamesFacts.find(nf => nf.personId === person.id && !nf.isName && nf.key === key && !nf.delete) &&
	//           !(person.preferredBirthKey === key && !pa.updateProfileBirth) && // don't delete preferred birth or death
	//           !(person.preferredDeathKey === key && !pa.updateProfileDeath)) {
	//           //!((person.facts.get(key).type === 'BIRT' || person.facts.get(key).type === 'CHR') && !person.facts.get(key).principal && principalIds.length === 1 &&
	//           //// don't delete childbirth fact that is being kept
	//           //// TODO this is probably wrong, but we shouldn't be keeping parents on all childbirth facts anyway I think
	//           //pa.relatedToKey === principalPersonas[0].key && person.facts.get(key).principalId1 === principalIds[0] && !principalPersonas[0].updateProfileBirth)) {
	//           // delete fact
	//           person.facts.delete(key);
	//           if (person.preferredBirthKey === key) {
	//             person.preferredBirthKey = 0;
	//           }
	//           if (person.preferredDeathKey === key) {
	//             person.preferredDeathKey = 0;
	//           }
	//         }
	//         //else {
	//         //  // add evidence to fact
	//         //  evidenceFactKeyRels.push({key: key, relationshipType: pa.relationshipType});
	//         //}
	//         updated = true;
	//       }
	//       else if (!person.facts.get(key).evidencePersonas.has(evidenceId)) {
	//         // support has been removed
	//         updated = true;
	//       }
	//     });
	//     // add evidences
	//     //return this.addEvidences(person, evidenceFactKeyRels).flatMap(person => {
	//       // does person need to be created or updated?
	//       let stream;
	//       if (person.id === 0) {
	//         person.id = pa.personId;
	//         stream = this.persons.create(person);
	//       }
	//       else if (!updated) {
	//         stream = this.rx.Observable.of(pa.person);
	//       }
	//       else {
	//         stream = this.persons.update(person);
	//       }
	//       return stream.map(person => { return {persona: pa, person: person}; });
	//     //});
	//   }
	//   toPersonaFact(f) {
	//     return {
	//       type: !!f.type ? f.type.value : f.typeText,
	//       value: f.value,
	//       date: f.date,
	//       dateSort: f.dateSort,
	//       place: !!f.place ? f.place.name : !!f.placeText ? f.placeText : '',
	//       placeDetails: '',
	//       placeStandard: !!f.place ? f.place.standardName : '',
	//       latitude: !!f.place ? f.place.latitude : 0,
	//       longitude: !!f.place ? f.place.longitude : 0
	//     };
	//   }
	//   calcLiving(epa, primaryFact) {
	//     if (epa.principal &&
	//         (primaryFact.type === 'DEAT' || primaryFact.type === 'BURI') &&
	//         (this.hasLivingWords(primaryFact.date) || this.hasLivingWords(primaryFact.place))) {
	//       return 'TRUE';
	//     }
	//     let y = new Date().getFullYear() - 110;
	//     if (epa.principal && primaryFact.type === 'BIRT' || primaryFact.type === 'CHR' && !!primaryFact.dateSort && parseInt(primaryFact.dateSort.substr(0,4), 10) < y) {
	//       return 'FALSE';
	//     }
	//     if (epa.principal && primaryFact.type === 'DEAT' || primaryFact.type === 'BURI' && (!!primaryFact.dateSort || !!primaryFact.place)) {
	//       return 'FALSE';
	//     }
	//     let births = Array.from(epa.facts.values()).filter(f => f.type === 'BIRTH' || f.type === 'CHR');
	//     let deaths = Array.from(epa.facts.values()).filter(f => f.type === 'DEATH' || f.type === 'BURI');
	//     if (deaths.some(d => this.hasLivingWords(d.date) || this.hasLivingWords(d.place))) {
	//       return 'TRUE';
	//     }
	//     if (deaths.some(d => !!d.dateSort || !!d.place) || births.some(b => !!b.dateSort && parseInt(b.dateSort.substr(0,4), 10) < y)) {
	//       return 'FALSE';
	//     }
	//     if (births.some(b => !!b.dateSort && parseInt(b.dateSort.substr(0,4), 10) >= y)) {
	//       return 'TRUE';
	//     }
	//     if (epa.principal && primaryFact.type === 'BIRT' || primaryFact.type === 'CHR' && !!primaryFact.dateSort && parseInt(primaryFact.dateSort.substr(0,4), 10) >= y) {
	//       return 'TRUE';
	//     }
	//     return '';
	//   }
	//   hasLivingWords(s) {
	//     return this.livingWords.indexOf(s.toLowerCase()) >= 0;
	//   }
	//   calcGender(epa, personas) {
	//     // look up gender fact
	//     let genderFact = Array.from(epa.facts.values()).find(f => f.type === 'SEX');
	//     if (!!genderFact && !!genderFact.value) {
	//       let gender = this.utils.findGender(this.utils.genders, genderFact.value);
	//       if (!!gender) {
	//         return gender.value;
	//       }
	//     }
	//     // return gender if this person is a father, mother, or spouse
	//     if (epa.relationshipType === 'FATHER') {
	//       return 'MALE';
	//     }
	//     if (epa.relationshipType === 'MOTHER') {
	//       return 'FEMALE';
	//     }
	//     if (epa.relationshipType === 'SPOUSE') {
	//       let spouse = personas.find(pa => pa.key === epa.relatedToKey);
	//       if (!!spouse && !!spouse.person && spouse.person.gender === 'MALE') {
	//         return 'FEMALE';
	//       }
	//       if (!!spouse && !!spouse.person && spouse.person.gender === 'FEMALE') {
	//         return 'MALE';
	//       }
	//     }
	//     return '';
	//   }
	//   updateName(paKey, epa, primaryFact, evidenceId, updateProfileName, person) {
	//     if (epa.names.size === 0) {
	//       return false;
	//     }
	//     let n = this.utils.first(epa.names);
	//     let nf = this.persons.getDefaultNameForm(n);
	//     let en = this.utils.createName(nf.given, nf.surname, nf.prefix, nf.suffix);
	//     let nameKey = Array.from(person.names.keys()).find(nk => this.utils.nameEquals(this.persons.getDefaultNameForm(person.names.get(nk)), en)) || 0;
	//     if (!nameKey) {
	//       nameKey = this.utils.randomKey();
	//       person.names.set(nameKey, {
	//         nameForms: new Map([['default', en]]),
	//         type: n.type,
	//         date: primaryFact.type === 'NAME' ? primaryFact.date : '',
	//         dateSort: '',
	//         evidencePersonas: new Map()
	//       });
	//     }
	//     else if (primaryFact.type === 'NAME') {
	//       person.names.get(nameKey).date = primaryFact.date;
	//       person.names.get(nameKey).dateSort = '';
	//     }
	//     if (evidenceId > 0) {
	//       person.names.get(nameKey).evidencePersonas.set(evidenceId, paKey);
	//     }
	//     if (updateProfileName) {
	//       person.preferredNameKey = nameKey;
	//     }
	//     return true;
	//   }
	//   updateFacts(paKey, principal, epaFacts, evidenceId, evidenceMap, primaryFact, principalIds, updateProfileBirth, updateProfileDeath, paPersonId, person, personas, supportedFactKeys) {
	//     let persona = personas.find(pa => pa.key === paKey);
	//     // add persona facts
	//     epaFacts.forEach(fact => {
	//       let f = this.getPersonFact(fact, epaFacts, primaryFact, persona, personas);
	//       if (!!f) {
	//         this.updateFact(paKey, epaFacts, f, evidenceId, evidenceMap, updateProfileBirth, updateProfileDeath, person, supportedFactKeys);
	//       }
	//     });
	//     // no need to go any further for names
	//     if (primaryFact.type === 'NAME') {
	//       return false;
	//     }
	//     // add BIRT and MARR facts under other personas who are related to this persona
	//     this.getSpouseMarriageFacts(persona, personas).forEach(fact => {
	//       let f = this.getPersonFact(fact, null, primaryFact);
	//       if (!!f) {
	//         f.principal = true;
	//         f.principalId1 = fact.principalId1;
	//         this.updateFact(paKey, epaFacts, f, evidenceId, evidenceMap, updateProfileBirth, updateProfileDeath, person, supportedFactKeys);
	//       }
	//     });
	//     //let cbafs = this.getChildBirthAgeFacts(persona, personas);
	//     //cbafs.forEach(fact => {
	//     //  let f = this.getPersonFact(fact, cbafs, primaryFact);
	//     //  if (!!f && fact.principalId1 > 0) {
	//     //    f.principal = false;
	//     //    f.principalId1 = fact.principalId1;
	//     //    this.updateFact(paKey, epaFacts, f, evidenceId, evidenceMap, updateProfileBirth, updateProfileDeath, person);
	//     //  }
	//     //});
	//     // add primary fact
	//     let f = this.utils.clone(primaryFact);
	//     f.principal = principal;
	//     f.principalId1 = 0;
	//     f.principalId2 = 0;
	//     let factType = this.utils.factTypes.find(ft => ft.value === f.type);
	//     let personId = person.id || paPersonId;
	//     if (!!factType && factType.spouse) {
	//       if (f.principal) {
	//         f.principalId1 = principalIds.some(id => id !== personId) ? principalIds.find(id => id !== personId) : 0;
	//       }
	//       else if (principalIds.length > 0) {
	//         f.principalId1 = principalIds[0];
	//         if (principalIds.length > 1) {
	//           f.principalId2 = principalIds[1];
	//         }
	//       }
	//     }
	//     else if (!f.principal) {
	//       f.principalId1 = principalIds.length > 0 ? principalIds[0] : 0;
	//     }
	//     if (!f.principal && f.principalId1 === 0) {
	//       return false; // no principal, so skip
	//     }
	//     this.updateFact(paKey, epaFacts, f, evidenceId, evidenceMap, f.principal && updateProfileBirth, f.principal && updateProfileDeath, person, supportedFactKeys);
	//     return true;
	//   }
	//   getSpouseMarriageFacts(persona, personas) {
	//     let facts = [];
	//     personas.forEach(pa => {
	//       if ((persona.relatedToKey === pa.key && persona.relationshipType === 'SPOUSE') ||
	//           (pa.relatedToKey === persona.key && pa.relationshipType === 'SPOUSE')) {
	//         facts = facts.concat(Array.from(pa.facts.values()).filter(f => !!f.type && f.type.value === 'MARR')
	//           .map(f => Object.assign({}, this.toPersonaFact(f), {principal: false, principalId1: pa.personId})));
	//       }
	//     });
	//     return facts;
	//   }
	//   //getChildBirthAgeFacts(persona, personas) {
	//   //  let facts = [];
	//   //  personas.forEach(pa => {
	//   //    if ((persona.relatedToKey === pa.key && (persona.relationshipType === 'FATHER' || persona.relationshipType === 'MOTHER')) ||
	//   //        (personas.some(pa2 => pa.relatedToKey === pa2.key && pa.relationshipType === 'CHILD' && persona.relatedToKey === pa2.key && persona.relationshipType === 'SPOUSE')) ||
	//   //        (personas.some(pa2 => pa.relatedToKey === pa2.key && pa.relationshipType === 'CHILD' && pa2.relatedToKey === persona.key && pa2.relationshipType === 'SPOUSE')) ||
	//   //        (pa.relatedToKey === persona.key && pa.relationshipType === 'CHILD')) {
	//   //      facts = facts.concat(Array.from(pa.facts.values()).filter(f => !!f.type && (f.type.value === 'BIRT' || f.type.value === '_AGE'))
	//   //        .map(f => Object.assign({}, this.toPersonaFact(f), {principal: false, principalId1: pa.personId})));
	//   //    }
	//   //  });
	//   //  return facts;
	//   //}
	//   getPersonFact(fact, facts = null, primaryFact = null, persona = null, personas = []) {
	//     if (fact.type === 'BIRT' && !fact.date && !!facts && facts.some(f => f.type === '_AGE')) {
	//       return null; // take the age fact
	//     }
	//     if (fact.type === '_AGE' && !!facts && facts.some(f => f.type === 'BIRT' && !!f.date)) {
	//       return null; // take the birth fact
	//     }
	//     let principalId1 = 0;
	//     if (fact.type === 'MARR' && !!persona && personas.length > 0) {
	//       // get spouse
	//       if (persona.relatedToKey > 0 && persona.relationshipType === 'SPOUSE' && personas.some(pa => pa.key === persona.relatedToKey)) {
	//         principalId1 = personas.find(pa => pa.key === persona.relatedToKey).personId;
	//       }
	//       else if (personas.some(pa => pa.relatedToKey === persona.key && pa.relationshipType === 'SPOUSE')) {
	//         principalId1 = personas.find(pa => pa.relatedToKey === persona.key && pa.relationshipType === 'SPOUSE').personId;
	//       }
	//     }
	//     if (fact.type === '_AGE') {
	//       // convert age to about birth
	//       if (!primaryFact) {
	//         return null;
	//       }
	//       let {date, dateSort} = this.utils.getBirthdateFromEventAge(primaryFact.dateSort, fact.value || fact.date);
	//       if (!date) {
	//         return null;
	//       }
	//       let birthFact = !!facts && facts.find(f => f.type === 'BIRT');
	//       let placeFact = !!birthFact && !!birthFact.place ? birthFact : fact;
	//       return {
	//         type: 'BIRT',
	//         date: date,
	//         dateSort: dateSort,
	//         place: placeFact.place,
	//         placeStandard: placeFact.placeStandard, // TODO do we need to standardize?
	//         placeDetails: '',
	//         latitude: placeFact.latitude,
	//         longitude: placeFact.longitude,
	//         value: '',
	//         principal: true,
	//         principalId1: principalId1,
	//         principalId2: 0,
	//         evidencePersonas: new Map()
	//       };
	//     }
	//     else {
	//       let f = this.utils.clone(fact);
	//       f.principal = true;
	//       f.principalId1 = principalId1;
	//       f.principalId2 = 0;
	//       f.evidencePersonas = new Map();
	//       return f;
	//     }
	//   }
	//   updateFact(paKey, epaFacts, f, evidenceId, evidenceMap, updateProfileBirth, updateProfileDeath, person, supportedFactKeys) {
	//     let compatibleFactKeys = Array.from(person.facts.keys()).filter(fk => this.utils.factEquals(person.facts.get(fk), f));
	//     if (compatibleFactKeys.length === 0) {
	//       compatibleFactKeys = Array.from(person.facts.keys()).filter(fk => this.utils.factCompatible(person.facts.get(fk), f));
	//     }
	//     if (compatibleFactKeys.length > 1) {
	//       compatibleFactKeys.sort((fk1, fk2) => person.facts.get(fk2).evidencePersonas.size - person.facts.get(fk1).evidencePersonas.size);
	//     }
	//     // prefer facts that this evidence currently supports
	//     let factKey = 0;
	//     if (compatibleFactKeys.length > 0) {
	//       factKey = compatibleFactKeys.find(cKey => supportedFactKeys.some(sKey => sKey === cKey)) || compatibleFactKeys[0];
	//     }
	//     if (factKey > 0) {
	//       let facts = this.getFactsFromEvidences(person.facts.get(factKey), evidenceMap, evidenceId);
	//       facts.push(f);
	//       let mergedFact = this.utils.mergeFacts(facts);
	//       person.facts.set(factKey, mergedFact);
	//     }
	//     else {
	//       factKey = this.utils.randomKey();
	//       f = this.utils.clone(f);
	//       f.evidencePersonas = new Map();
	//       person.facts.set(factKey, f);
	//     }
	//     if (evidenceId > 0) {
	//       person.facts.get(factKey).evidencePersonas.set(evidenceId, paKey);
	//     }
	//     if (updateProfileBirth && f.principal && (f.type === 'BIRT' || (f.type === 'CHR' && !epaFacts.some(f => f.type === 'BIRT')))) {
	//       person.preferredBirthKey = factKey;
	//     }
	//     if (updateProfileDeath && f.principal && (f.type === 'DEAT' || (f.type === 'BURI' && !epaFacts.some(f => f.type === 'DEAT')))) {
	//       person.preferredDeathKey = factKey;
	//       if (person.living !== 'FALSE') {
	//         person.living = 'FALSE';
	//       }
	//     }
	//   }
	//   getFactsFromEvidences(origFact, evidenceMap, evidenceId) {
	//     let facts = [];
	//     // for each evidence persona that does not point to this evidence
	//     for (let [eid] of origFact.evidencePersonas) {
	//       if (eid !== evidenceId) {
	//         let paid = origFact.evidencePersonas.get(eid);
	//         let e = evidenceMap.get(eid);
	//         if (!!e) {
	//           let pa = e.personas.get(paid);
	//           if (!!pa) {
	//             // if persona is principal, get primary fact
	//             if (pa.principal) {
	//               let f = this.getPersonFact(e.fact);
	//               if (!!f) {
	//                 f.evidencePersonas.set(eid, paid);
	//                 facts.push(f);
	//               }
	//             }
	//             // get all facts under persona
	//             for (let [,fact] of pa.facts) {
	//               let f = this.getPersonFact(fact, Array.from(pa.facts.values()), e.fact);
	//               if (!!f) {
	//                 f.evidencePersonas.set(eid, paid);
	//                 facts.push(f);
	//               }
	//             }
	//           }
	//         }
	//       }
	//     }
	//     // filter compatible with original fact
	//     let compatFacts = facts.filter(f => this.utils.factCompatible(origFact, f, true)); // evidence facts don't have principalIds
	//     return compatFacts;
	//   }
	//   postFamilies(personaPersons) {
	//     let familyRequests = [];
	//     // for each persona, construct family relationships
	//     personaPersons.forEach(({persona, person}) => {
	//       if (this.familyRelationshipTypes.indexOf(persona.relationshipType) >= 0) {
	//         let relatedToPP = personaPersons.find(pp => persona.relatedToKey === pp.persona.key);
	//         if (!!person && !!relatedToPP && !!relatedToPP.person) {
	//           // request the familes (child or parent) of the person
	//           familyRequests.push(this.requestFamilies(person, persona.relationshipType, relatedToPP.person));
	//         }
	//       }
	//     });
	//     if (familyRequests.length === 0) {
	//       return this.rx.Observable.of([]);
	//     }
	//     // request families one at a time so we can incrementally update the families array
	//     let families = [];
	//     let waitCount = familyRequests.length;
	//     let subject = new this.rx.AsyncSubject();
	//     this.rx.Observable.concat(...familyRequests).subscribe(({fm, person, relationshipType, relatedToPerson}) => {
	//       // if the person is already related to the relatedToPerson, ignore
	//       if (!this.isRelated(fm, person, relationshipType, relatedToPerson)) {
	//         let family = families.find(f => this.isCompatibleFamily(f, person, relationshipType, relatedToPerson));
	//         if (!family) {
	//           family = this.createFamily(person, relationshipType, relatedToPerson);
	//           families.push(family);
	//         }
	//         else {
	//           this.updateFamily(family, person, relationshipType, relatedToPerson);
	//         }
	//       }
	//       // if all family requests have been processed, complete the subject
	//       if (--waitCount === 0) {
	//         subject.next(families);
	//         subject.complete();
	//       }
	//     });
	//     // once we've read all of the families and determined which families we need to create/update, update all families at once
	//     return subject.flatMap(families => {
	//       if (families.length === 0) {
	//         return this.rx.Observable.of([]);
	//       }
	//       return this.rx.Observable.forkJoin(...families.map(f => this.postFamily(f)));
	//     });
	//   }
	//   requestFamilies(person, relationshipType, relatedToPerson) {
	//     // return parentFamilies of person or parentFamilies of relatedToPerson
	//     let req = null;
	//     if (person.id > 0 && relatedToPerson.id > 0) {
	//       switch (relationshipType) {
	//         case 'FATHER':
	//         case 'MOTHER':
	//         case 'PARENT':
	//         case 'ADOPTIVE_PARENT':
	//         case 'STEP_PARENT':
	//           req = this.families.streamParents(relatedToPerson.id).take(1);
	//           break;
	//         // don't look for existing spouses; we take care of looking for duplicate spouse families in postFamily
	//         //case 'SPOUSE':
	//         //  req = this.families.streamSpouses(person.id).take(1);
	//         //  break;
	//         case 'CHILD':
	//           req = this.families.streamParents(person.id).take(1);
	//           break;
	//       }
	//     }
	//     if (req === null) {
	//       let fm = new Map();
	//       return this.rx.Observable.of({fm, person, relationshipType, relatedToPerson});
	//     }
	//     else {
	//       return req.map(fm => {
	//         return {fm, person, relationshipType, relatedToPerson};
	//       });
	//     }
	//   }
	//   isRelated(fm, person, relationshipType, relatedToPerson) {
	//     switch (relationshipType) {
	//       case 'FATHER':
	//       case 'MOTHER':
	//       case 'PARENT':
	//       case 'ADOPTIVE_PARENT':
	//       case 'STEP_PARENT':
	//         return !!Array.from(fm.values()).find(f => f.husbandId === person.id || f.wifeId === person.id);
	//       case 'CHILD':
	//         return !!Array.from(fm.values()).find(f => f.husbandId === relatedToPerson.id || f.wifeId === relatedToPerson.id);
	//     }
	//     return false;
	//   }
	//   isCompatibleFamily(family, person, relationshipType, relatedToPerson) {
	//     switch (relationshipType) {
	//       case 'FATHER':
	//         return family.childRels.has(relatedToPerson.id) && (family.husbandId === 0 || family.husbandId === person.id);
	//       case 'MOTHER':
	//         return family.childRels.has(relatedToPerson.id) && (family.wifeId === 0 || family.wifeId === person.id);
	//       case 'PARENT':
	//       case 'ADOPTIVE_PARENT':
	//       case 'STEP_PARENT':
	//         return family.childRels.has(relatedToPerson.id) && (family.husbandId === 0 || family.husbandId === person.id || family.wifeId === 0 || family.wifeId === person.id);
	//       case 'SPOUSE':
	//         return (family.husbandId === relatedToPerson.id && (family.wifeId === 0 || family.wifeId === person.id)) ||
	//           (family.wifeId === relatedToPerson.id && (family.husbandId === 0 || family.husbandId === person.id));
	//       case 'CHILD':
	//         return family.husbandId === relatedToPerson.id || family.wifeId === relatedToPerson.id;
	//     }
	//     return false;
	//   }
	//   isCompatibleExistingFamily(existingFamily, family) {
	//     let matches = 0;
	//     if (family.husbandId !== 0) {
	//       if (existingFamily.husbandId === family.husbandId || existingFamily.wifeId === family.husbandId) {
	//         matches++;
	//       }
	//       else if (existingFamily.husbandId !== 0) {
	//         return false;
	//       }
	//     }
	//     else if (existingFamily.husbandId === 0) {
	//       matches++;
	//     }
	//     if (family.wifeId !== 0) {
	//       if (existingFamily.husbandId === family.wifeId || existingFamily.wifeId === family.wifeId) {
	//         matches++;
	//       }
	//       else if (existingFamily.wifeId !== 0) {
	//         return false;
	//       }
	//     }
	//     else if (existingFamily.wifeId === 0) {
	//       matches++;
	//     }
	//     matches += Array.from(existingFamily.childRels.keys()).filter(key => family.childRels.has(key)).length;
	//     return matches >= 2;
	//   }
	//   createFamily(person, relationshipType, relatedToPerson) {
	//     let family = {
	//       husbandId: 0,
	//       wifeId: 0,
	//       childRels: new Map()
	//     };
	//     let fatherRel = '';
	//     let motherRel = '';
	//     switch (relationshipType) {
	//       case 'FATHER':
	//         family.husbandId = person.id;
	//         family.childRels.set(relatedToPerson.id, {fatherRel, motherRel});
	//         break;
	//       case 'MOTHER':
	//         family.wifeId = person.id;
	//         family.childRels.set(relatedToPerson.id, {fatherRel, motherRel});
	//         break;
	//       case 'PARENT':
	//       case 'ADOPTIVE_PARENT':
	//       case 'STEP_PARENT':
	//         if (person.gender === 'FEMALE') {
	//           family.wifeId = person.id;
	//           motherRel = 'ADOPTED';
	//         }
	//         else {
	//           family.husbandId = person.id;
	//           fatherRel = 'ADOPTED';
	//         }
	//         family.childRels.set(relatedToPerson.id, {fatherRel, motherRel});
	//         break;
	//       case 'SPOUSE':
	//         if (person.gender === 'MALE' || relatedToPerson.gender === 'FEMALE') {
	//           family.husbandId = person.id;
	//           family.wifeId = relatedToPerson.id;
	//         }
	//         else {
	//           family.wifeId = person.id;
	//           family.husbandId = relatedToPerson.id;
	//         }
	//         break;
	//       case 'CHILD':
	//         if (relatedToPerson.gender === 'FEMALE') {
	//           family.wifeId = relatedToPerson.id;
	//         }
	//         else {
	//           family.husbandId = relatedToPerson.id;
	//         }
	//         family.childRels.set(person.id, {fatherRel, motherRel});
	//         break;
	//     }
	//     return family;
	//   }
	//   updateFamily(family, person, relationshipType, relatedToPerson) {
	//     let fatherRel = '';
	//     let motherRel = '';
	//     switch (relationshipType) {
	//       case 'FATHER':
	//         family.husbandId = person.id;
	//         family.childRels.set(relatedToPerson.id, {fatherRel, motherRel});
	//         break;
	//       case 'MOTHER':
	//         family.wifeId = person.id;
	//         family.childRels.set(relatedToPerson.id, {fatherRel, motherRel});
	//         break;
	//       case 'PARENT':
	//       case 'ADOPTIVE_PARENT':
	//       case 'STEP_PARENT':
	//         if (person.gender === 'MALE') {
	//           if (family.husbandId !== 0 && family.husbandId !== person.id) {
	//             family.wifeId = family.husbandId;
	//           }
	//           family.husbandId = person.id;
	//           fatherRel = 'ADOPTED';
	//         }
	//         else if (person.gender === 'FEMALE') {
	//           if (family.wifeId !== 0 && family.wifeId !== person.id) {
	//             family.husbandId = family.wifeId;
	//           }
	//           family.wifeId = person.id;
	//           motherRel = 'ADOPTED';
	//         }
	//         if (family.husbandId === 0) {
	//           family.husbandId = person.id;
	//         }
	//         else {
	//           family.wifeId = person.id;
	//         }
	//         family.childRels.set(relatedToPerson.id, {fatherRel, motherRel});
	//         break;
	//       case 'SPOUSE':
	//         if (person.gender === 'MALE' || relatedToPerson.gender === 'FEMALE') {
	//           if (family.husbandId !== 0 && family.husbandId !== person.id) {
	//             family.wifeId = family.husbandId;
	//           }
	//           family.husbandId = person.id;
	//           if (family.wifeId !== 0 && family.wifeId !== relatedToPerson.id) {
	//             family.husbandId = family.wifeId;
	//           }
	//           family.wifeId = relatedToPerson.id;
	//         }
	//         else {
	//           if (family.wifeId !== 0 && family.wifeId !== person.id) {
	//             family.husbandId = family.wifeId;
	//           }
	//           family.wifeId = person.id;
	//           if (family.husbandId !== 0 && family.husbandId !== relatedToPerson.id) {
	//             family.wifeId = family.husbandId;
	//           }
	//           family.husbandId = relatedToPerson.id;
	//         }
	//         break;
	//       case 'CHILD':
	//         if (family.wifeId === relatedToPerson.id || family.husbandId === relatedToPerson.id) {
	//           // pass
	//         }
	//         else if (relatedToPerson.gender === 'FEMALE') {
	//           if (family.wifeId !== 0 && family.wifeId !== relatedToPerson.id && family.husbandId === 0) {
	//             family.husbandId = family.wifeId;
	//             family.wifeId = 0;
	//           }
	//           if (family.wifeId === 0) {
	//             family.wifeId = relatedToPerson.id;
	//           }
	//         }
	//         else {
	//           if (family.husbandId !== 0 && family.husbandId !== relatedToPerson.id && family.wifeId === 0) {
	//             family.wifeId = family.husbandId;
	//             family.husbandId = 0;
	//           }
	//           if (family.husbandId === 0) {
	//             family.husbandId = relatedToPerson.id;
	//           }
	//         }
	//         family.childRels.set(person.id, {fatherRel, motherRel});
	//         break;
	//     }
	//   }
	//   postFamily(family) {
	//     // look for an existing family to update, or create a new family
	//     let spouseFamilyStreams = [];
	//     if (family.husbandId) {
	//       spouseFamilyStreams.push(this.families.streamSpouses(family.husbandId).take(1));
	//     }
	//     if (family.wifeId) {
	//       spouseFamilyStreams.push(this.families.streamSpouses(family.wifeId).take(1));
	//     }
	//     let combinedStream = spouseFamilyStreams.length === 0 ? this.rx.Observable.of([]) : this.rx.Observable.forkJoin(...spouseFamilyStreams);
	//     return combinedStream.flatMap(sfMaps => {
	//       let spouseFamilies = [].concat(...sfMaps.map(sfMap => Array.from(sfMap.values()))); // flatten
	//       let existingFamily = spouseFamilies.find(existingFamily => this.isCompatibleExistingFamily(existingFamily, family));
	//       if (!!existingFamily) {
	//         let ef = this.utils.clone(existingFamily);
	//         let updated = false;
	//         if (family.husbandId !== 0 && family.husbandId !== ef.husbandId && family.husbandId !== ef.wifeId) {
	//           if (ef.husbandId === 0) {
	//             ef.husbandId = family.husbandId;
	//           }
	//           else {
	//             ef.wifeId = family.husbandId;
	//           }
	//           updated = true;
	//         }
	//         if (family.wifeId !== 0 && family.wifeId !== ef.wifeId && family.wifeId !== ef.husbandId) {
	//           if (ef.wifeId === 0) {
	//             ef.wifeId = family.wifeId;
	//           }
	//           else {
	//             ef.husbandId = family.wifeId;
	//           }
	//           updated = true;
	//         }
	//         for (let [key] of family.childRels) {
	//           if (!ef.childRels.has(key)) {
	//             ef.childRels.set(key, {fatherRel: '', motherRel: ''});
	//             updated = true;
	//           }
	//         }
	//         if (!updated) {
	//           this.$log.debug('evidenceUtils.postFamily not updated', ef);
	//           return this.rx.Observable.of(existingFamily);
	//         }
	//         this.$log.debug('evidenceUtils.postFamily update', ef);
	//         return this.families.update(ef);
	//       }
	//       else {
	//         this.$log.debug('evidenceUtils.postFamily new', family);
	//         return this.families.create(family);
	//       }
	//     });
	//   }
	//   removeNamesFactsPidFromPersons(personas, deletedNamesFacts, oldPid=0, newPid=0) {
	//     // which person ids are in deleted namesFacts and not in personas?
	//     let pidSet = new Set(deletedNamesFacts.filter(nf => !personas.some(pa => pa.personId === nf.personId)).map(nf => nf.personId));
	//     // add pids that contain principalId1 or 2 to the list
	//     return this.persons.stream().take(1).flatMap(pm => {
	//       if (oldPid !== 0) {
	//         pm.forEach(p => {
	//           p.facts.forEach(f => {
	//             if (f.principalId1 === oldPid || f.principalId2 === oldPid) {
	//               pidSet.add(p.id);
	//             }
	//           });
	//         });
	//       }
	//       let pids = [...pidSet];
	//       this.$log.debug('evidenceUtils.removeNamesFactsFromPersons', pids, pids.length);
	//       // update them all at once
	//       if (pids.length === 0) {
	//         return this.rx.Observable.of([]);
	//       }
	//       //let birthEvidenceIds = pids.map(pid => {
	//       //  return {pid: pid, eid: this.utils.randomId()};
	//       //});
	//       return this.rx.Observable.forkJoin(...pids.map(pid => this.removeNamesFactsPidFromPerson(pid, deletedNamesFacts, oldPid, newPid)));
	//     });
	//   }
	//   removeNamesFactsPidFromPerson(pid, deletedNamesFacts, oldPid, newPid) {
	//     this.$log.debug('evidenceUtils.removeNamesFactsFromPerson', pid, deletedNamesFacts);
	//     if (deletedNamesFacts.length === 0 && oldPid === 0) {
	//       return this.rx.Observable.of(null);
	//     }
	//     return this.persons.streamId(pid).take(1).flatMap(person => {
	//       return this.evidences.streamForPerson(person).take(1).flatMap(evidenceMap => {
	//         let p = this.utils.clone(person);
	//         //let evidenceFactKeyRels = [];
	//         let updated = false;
	//         deletedNamesFacts.forEach(nf => {
	//           if (nf.personId === pid && nf.isName && p.names.has(nf.key)) {
	//             updated = true;
	//             if (nf.unsupported && (nf.delete || !nf.principal)) {
	//               // delete the name
	//               p.names.delete(nf.key);
	//               if (p.preferredNameKey === nf.key) {
	//                 p.preferredNameKey = 0;
	//               }
	//               if (p.names.size === 0) {
	//                 // TODO what???
	//               }
	//             }
	//             else {
	//               // remove the evidence(s)
	//               nf.eids.forEach(eid => {
	//                 if (p.names.get(nf.key).evidencePersonas.get(eid)) {
	//                   p.names.get(nf.key).evidencePersonas.delete(eid);
	//                 }
	//               });
	//             }
	//           }
	//           else if (nf.personId === pid && !nf.isName && p.facts.has(nf.key)) {
	//             updated = true;
	//             if (nf.unsupported) {
	//               if (nf.delete || !nf.principal) {
	//                 // delete the fact
	//                 p.facts.delete(nf.key);
	//                 if (p.preferredBirthKey === nf.key) {
	//                   p.preferredBirthKey = 0;
	//                 }
	//                 if (p.preferredDeathKey === nf.key) {
	//                   p.preferredDeathKey = 0;
	//                 }
	//               }
	//               else {
	//                 // remove evidence(s) from fact
	//                 nf.eids.forEach(eid => {
	//                   p.facts.get(nf.key).evidencePersonas.delete(eid);
	//                 });
	//                 // add new evidence
	//                 //evidenceFactKeyRels.push({key: nf.key});
	//               }
	//             }
	//             else {
	//               // remove the evidence(s)
	//               nf.eids.forEach(eid => {
	//                 if (p.facts.get(nf.key).evidencePersonas.has(eid)) {
	//                   p.facts.get(nf.key).evidencePersonas.delete(eid);
	//                   // update (generalize) the fact from the remaining evidences
	//                   let f = p.facts.get(nf.key);
	//                   let facts = this.getFactsFromEvidences(f, evidenceMap);
	//                   let fact = this.utils.mergeFacts(facts);
	//                   fact.principalId1 = f.principalId1;
	//                   fact.principalId2 = f.principalId2;
	//                   p.facts.set(nf.key, fact);
	//                 }
	//               });
	//             }
	//           }
	//           // remove unsupported child birth facts
	//           // TODO stop adding childbirth facts to parents based upon persona facts
	//           else if (!!nf.fact && (nf.fact.type === 'BIRT' || nf.fact.type === 'CHR') && nf.principal) {
	//             Array.from(person.facts.entries())
	//               .filter(([,fact]) => fact.type === nf.fact.type && !fact.principal && fact.principalId1 === nf.personId && nf.eids.some(eid => fact.evidencePersonas.has(eid)))
	//               .forEach(([key,fact]) => {
	//                 updated = true;
	//                 nf.eids.forEach(eid => {
	//                   fact.evidencePersonas.delete(eid);
	//                 });
	//                 if (fact.evidencePersonas.size === 0) {
	//                   p.facts.delete(key);
	//                 }
	//               });
	//           }
	//         });
	//         // remove references to pid
	//         if (oldPid !== 0 && p.id !== oldPid) {
	//           p.facts.forEach(f => {
	//             if (f.principalId1 === oldPid) {
	//               if (newPid !== 0) {
	//                 f.principalId1 = newPid;
	//               }
	//               else {
	//                 f.principalId1 = f.principalId2;
	//                 f.principalId2 = 0;
	//               }
	//               updated = true;
	//             }
	//             else if (f.principalId2 === oldPid) {
	//               f.principalId2 = newPid;
	//               updated = true;
	//             }
	//           });
	//         }
	//         // add evidences
	//         if (updated) {
	//           //return this.addEvidences(p, evidenceFactKeyRels).flatMap(p => {
	//             //return this.rx.Observable.of(p);
	//             return this.persons.update(p).map(() => pid);
	//           //});
	//         }
	//         else {
	//           return this.rx.Observable.of(pid);
	//         }
	//       });
	//     });
	//   }
	//   //addEvidences(person, evidenceFactKeyRels) {
	//   //  if (evidenceFactKeyRels.length === 0) {
	//   //    return this.rx.Observable.of(person);
	//   //  }
	//   //  return this.rx.Observable.forkJoin(...evidenceFactKeyRels.map(fkr => {
	//   //    return this.addEvidence(person.facts.get(fkr.key));
	//   //    //return this.addEvidence(person, person.facts.get(fkr.key), fkr.relationshipType, birthEvidenceIds);
	//   //  }))
	//   //    .map(evidencePersonas => {
	//   //      evidenceFactKeyRels.forEach((fkr,ix) => {
	//   //        let evidencePersona = evidencePersonas[ix];
	//   //        if (evidencePersona.personaKey > 0) {
	//   //          person.facts.get(fkr.key).evidencePersonas.set(evidencePersona.eid, evidencePersona.personaKey);
	//   //        }
	//   //      });
	//   //      return person;
	//   //    });
	//   //}
	//   //
	//   //addEvidence(fact) {
	//   //  let e = this.utils.createEvidenceFromFact(fact);
	//   //  this.$log.debug('evidenceUtils.addEvidence', e);
	//   //  return this.evidences.create(e).map(evidence => {
	//   //    return {eid: evidence.id, personaKey: 1};
	//   //  });
	//   //}
	//   //addEvidence(person, fact, relationshipType, birthEvidenceIds) {
	//   //  let e = this.utils.createEvidenceFromFact(fact);
	//     // is this a childbirth fact, then get the id from birthEvidenceIds
	//     //if ((fact.type === 'BIRT' || fact.type === 'CHR') && !fact.principal) {
	//     //  let eid = birthEvidenceIds.find(bei => bei.pid === fact.principalId1).eid;
	//     //  let personaKey = 0;
	//     //  if (relationshipType === 'FATHER') {
	//     //    personaKey = 2;
	//     //  }
	//     //  else if (relationshipType === 'MOTHER') {
	//     //    personaKey = 3;
	//     //  }
	//     //  else if (person.gender === 'MALE') {
	//     //    personaKey = 2;
	//     //  }
	//     //  else if (person.gender === 'FEMALE') {
	//     //    personaKey = 3;
	//     //  }
	//     //  this.$log.debug('evidenceUtils.addEvidence childbirth', eid, personaKey);
	//     //  return this.rx.Observable.of({eid, personaKey});
	//     //}
	//     //// otherwise add the evidence
	//     //else {
	//       // if this is a birth fact, get the id from birthEvidenceIds and add the extra personas
	//       //if ((fact.type === 'BIRT' || fact.type === 'CHR') && fact.principal) {
	//       //  e.id = birthEvidenceIds.find(bei => bei.pid === person.id).eid;
	//       //  e.personas.set(2, {
	//       //    principal: false,
	//       //    relatedToKey: 1,
	//       //    relationshipType: 'FATHER',
	//       //    names: new Map(),
	//       //    facts: new Map()
	//       //  });
	//       //  e.personas.set(3, {
	//       //    principal: false,
	//       //    relatedToKey: 1,
	//       //    relationshipType: 'MOTHER',
	//       //    names: new Map(),
	//       //    facts: new Map()
	//       //  });
	//       //}
	//       //this.$log.debug('evidenceUtils.addEvidence', e);
	//       //return this.evidences.create(e).map(evidence => {
	//       //  return {eid: evidence.id, personaKey: 1};
	//       //});
	//     //}
	//   //}
	//   // return an array of names & facts found on 0 or more evidences that are not found in personas
	//   // evidences must be augmented
	//   getDeletedNamesFacts(evidences, pas, includePrimary = false) {
	//     let namesFacts = [];
	//     if (evidences.length === 0) {
	//       return namesFacts;
	//     }
	//     if (includePrimary) {
	//       evidences.forEach(evidence => {
	//         if (evidence.fact.type !== 'NAME') { // if it's a name, it will get picked up when processing the personas below
	//           let fact = evidence.fact;
	//           let factType = this.utils.factTypes.find(ft => ft.value === fact.type);
	//           Array.from(evidence._personas.values()).forEach(persona => {
	//             let person = evidence._people.get(persona._id) || null;
	//             let pfactEntry = !!person && Array.from(person.facts.entries()).find(([, pfact]) => !!pfact.evidencePersonas.get(evidence.id) &&
	//               this.utils.factCompatible(pfact, fact, true));
	//             if (!!person && !!pfactEntry) {
	//               this.addDeletedNameFact(namesFacts, {
	//                 personId: person.id,
	//                 fullName: person._fullName,
	//                 isName: false,
	//                 primary: true,
	//                 'delete': true,
	//                 unsupported: !Array.from(pfactEntry[1].evidencePersonas.keys()).find(eid => !evidences.some(e => e.id === eid)),
	//                 principal: pfactEntry[1].principal && !(!!factType && factType.spouse), // force principal=false for marriage partners so the fact is always deleted
	//                 parent: this.parentRelationshipTypes.indexOf(persona.relationshipType) >= 0 &&
	//                   !!evidence._personas.get(persona.relatedToKey) ? evidence._personas.get(persona.relatedToKey).principal : false,
	//                 key: pfactEntry[0],
	//                 fact: pfactEntry[1],
	//                 eids: [evidence.id]
	//               });
	//             }
	//           });
	//         }
	//       });
	//     }
	//     evidences.forEach(evidence => {
	//       Array.from(evidence._personas.entries()).forEach(([paKey, persona]) => {
	//         let person = evidence._people.get(persona._id) || null;
	//         // get deleted names
	//         Array.from(persona.names.values()).forEach(name => {
	//           // get evidence persona -> person -> name entry
	//           let pnameEntry = !!person && Array.from(person.names.entries()).find(([, pname]) => !!pname.evidencePersonas.get(evidence.id) &&
	//             this.utils.nameEquals(this.persons.getDefaultNameForm(pname), this.persons.getDefaultNameForm(name)));
	//           if (!!person && !!pnameEntry &&
	//               // and the personas don't contain the same name for this person
	//               !pas.some(pa => !!pa.person &&
	//                  pa.person.id === persona._id &&
	//                  this.utils.nameEquals(this.utils.createName(pa.nameGiven, pa.nameSurname, pa.namePrefix, pa.nameSuffix), this.persons.getDefaultNameForm(name)))) {
	//             this.addDeletedNameFact(namesFacts, {
	//               personId: persona._id,
	//               fullName: persona._fullName,
	//               isName: true,
	//               primary: evidence.fact.type === 'NAME',
	//               'delete': false,
	//               unsupported: !Array.from(pnameEntry[1].evidencePersonas.keys()).find(eid => !evidences.some(e => e.id === eid)),
	//               principal: true,
	//               key: pnameEntry[0],
	//               name: this.persons.getDefaultNameForm(pnameEntry[1]),
	//               eids: [evidence.id]
	//             });
	//           }
	//         });
	//         // get deleted facts
	//         Array.from(persona.facts.values()).forEach(fact => {
	//           // convert age to birth
	//           let f = this.getPersonFact(fact, Array.from(persona.facts.values()), evidence.fact);
	//           if (!!f) {
	//             // get evidence persona -> person -> fact entry
	//             let pfactEntry = !!person && Array.from(person.facts.entries()).find(([, pfact]) => !!pfact.evidencePersonas.get(evidence.id) &&
	//               this.utils.factCompatible(pfact, f, true));
	//             if (!!person && !!pfactEntry &&
	//                 // and the personas don't contain another fact for this person that is of the same type
	//               !pas.some(pa => !!pa.person &&
	//               pa.person.id === persona._id &&
	//               Array.from(pa.facts.values()).some(f => (!!f.type ? f.type.value : f.typeText) === fact.type))) {
	//               this.addDeletedNameFact(namesFacts, {
	//                 personId: persona._id,
	//                 fullName: persona._fullName,
	//                 isName: false,
	//                 primary: false,
	//                 'delete': false,
	//                 principal: true,
	//                 unsupported: !Array.from(pfactEntry[1].evidencePersonas.keys()).find(eid => !evidences.some(e => e.id === eid)),
	//                 key: pfactEntry[0],
	//                 fact: pfactEntry[1],
	//                 eids: [evidence.id]
	//               });
	//               // remove birth fact from parents
	//               if (f.type === 'BIRT' || f.type === 'CHR') {
	//                 Array.from(evidence._personas.values()).forEach(parentPersona => {
	//                   if (this.parentRelationshipTypes.indexOf(parentPersona.relationshipType) >= 0 && parentPersona.relatedToKey === paKey) {
	//                     let parent = evidence._people.get(parentPersona._id) || null;
	//                     let birthFactEntry = !!parent && Array.from(parent.facts.entries()).find(([, pfact]) => !!pfact.evidencePersonas.get(evidence.id) &&
	//                       this.utils.factCompatible(pfact, f, true) && !pfact.principal);
	//                     if (!!parent && !!birthFactEntry) {
	//                       this.addDeletedNameFact(namesFacts, {
	//                         personId: parent.id,
	//                         fullName: parent._fullName,
	//                         isName: false,
	//                         primary: false,
	//                         'delete': false,
	//                         principal: false,
	//                         unsupported: !Array.from(birthFactEntry[1].evidencePersonas.keys()).find(eid => !evidences.some(e => e.id === eid)),
	//                         parent: true,
	//                         key: birthFactEntry[0],
	//                         fact: birthFactEntry[1],
	//                         eids: [evidence.id]
	//                       });
	//                     }
	//                   }
	//                 });
	//               }
	//               // remove marriage fact from spouse
	//               if (f.type === 'MARR') {
	//                 Array.from(evidence._personas.values()).forEach(spousePersona => {
	//                   if (spousePersona.relationshipType === 'SPOUSE' && spousePersona.relatedToKey === paKey) {
	//                     let spouse = evidence._people.get(spousePersona._id) || null;
	//                     let marrFactEntry = !!spouse && Array.from(spouse.facts.entries()).find(([, pfact]) => !!pfact.evidencePersonas.get(evidence.id) &&
	//                       this.utils.factCompatible(pfact, f, true) && pfact.principal);
	//                     if (!!spouse && !!marrFactEntry) {
	//                       this.addDeletedNameFact(namesFacts, {
	//                         personId: spouse.id,
	//                         fullName: spouse._fullName,
	//                         isName: false,
	//                         primary: false,
	//                         'delete': false,
	//                         principal: true,
	//                         unsupported: !Array.from(marrFactEntry[1].evidencePersonas.keys()).find(eid => !evidences.some(e => e.id === eid)),
	//                         parent: false,
	//                         key: marrFactEntry[0],
	//                         fact: marrFactEntry[1],
	//                         eids: [evidence.id]
	//                       });
	//                     }
	//                   }
	//                 });
	//               }
	//             }
	//           }
	//         });
	//       });
	//     });
	//     return namesFacts;
	//   }
	//   addDeletedNameFact(namesFacts, nameFact) {
	//     let nf = namesFacts.find(nf => nf.personId === nameFact.personId && nf.isName === nameFact.isName && nf.key === nameFact.key);
	//     if (!!nf) {
	//       nf.eids = nf.eids.concat(nameFact.eids);
	//       nf.unsupported = nf.unsupported || nameFact.unsupported;
	//       nf.primary = nf.primary || nameFact.primary;
	//       nf.delete = nf.delete || nameFact.delete;
	//     }
	//     else {
	//       namesFacts.push(nameFact);
	//     }
	//   }
	// }
	// export default EvidenceUtilsService;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var EvidenceUtilsService = /** @class */ (function () {
	    function EvidenceUtilsService(log, rx, sources, evidences, dates, places, persons, families, segment, utils) {
	        this.log = log;
	        this.rx = rx;
	        this.sources = sources;
	        this.evidences = evidences;
	        this.dates = dates;
	        this.places = places;
	        this.persons = persons;
	        this.families = families;
	        this.segment = segment;
	        this.utils = utils;
	        this.livingWords = ['living', 'private', 'alive', 'details withheld', 'n', 'no'];
	        this.parentRelationshipTypes = ['FATHER', 'MOTHER', 'PARENT', 'ADOPTIVE_PARENT', 'STEP_PARENT'];
	        this.familyRelationshipTypes = this.parentRelationshipTypes.concat(['SPOUSE', 'CHILD']);
	    }
	    // form=evidence, type, value, date, place, placeText, placeDetails, text, url, page, sourceDate, citation, nameGiven, nameSurname, namePrefix, nameSuffix, nameType,
	    // personas=[key, relationshipType, relatedToKey(string), role, person, principal, nameGiven, nameSurname, namePrefix, nameSuffix, updateProfileName/Birth/Death,
	    //           facts=[key, type, typeText, value, date, place, placeText]
	    //           birth={type, date, place, placeText}, death={type, date, place, placeText}] // used by add person to add facts to a person but not to the evidence
	    //   personas are updated with personId
	    EvidenceUtilsService.prototype.post = function (form, personas, source, sourceText, deletedNamesFacts) {
	        var _this = this;
	        if (source === void 0) { source = null; }
	        if (sourceText === void 0) { sourceText = ''; }
	        if (deletedNamesFacts === void 0) { deletedNamesFacts = []; }
	        var evidence;
	        this.log.debug('evidenceUtils.post', form, personas, deletedNamesFacts);
	        this.segment.track(!!form.evidence ? 'evidences.update' : 'evidences.create');
	        return this.postSource(source, sourceText)
	            .flatMap(function (source) {
	            return _this.postEvidence(source, form, personas);
	        }).flatMap(function (evid) {
	            evidence = evid;
	            _this.log.debug('evidenceUtils.post evidence', evid);
	            return _this.postPeople(personas, evid, deletedNamesFacts);
	        }).flatMap(function (personaPersons) {
	            return _this.postFamilies(personaPersons);
	        }).flatMap(function () {
	            return _this.removeNamesFactsPidFromPersons(personas, deletedNamesFacts);
	        }).flatMap(function () {
	            return _this.rx.Observable.of(evidence);
	        });
	    };
	    EvidenceUtilsService.prototype.del = function (evidence, deletedNamesFacts) {
	        var _this = this;
	        if (deletedNamesFacts === void 0) { deletedNamesFacts = []; }
	        this.log.debug('evidenceUtils.del', evidence, deletedNamesFacts);
	        this.segment.track('evidences.delete');
	        // set keepOnParents flag if B/C and not deleted
	        //let typ = evidence.fact.type;
	        //let keepOnParents = (typ === 'BIRT' || typ === 'CHR') && deletedNamesFacts.length > 0 && !deletedNamesFacts[0].delete;
	        // remove names & facts from people
	        return this.removeNamesFactsPidFromPersons([], deletedNamesFacts)
	            .flatMap(function () {
	            //return this.rx.Observable.of(null);
	            // delete evidence
	            return _this.evidences.del(evidence.id);
	        });
	    };
	    EvidenceUtilsService.prototype.postSource = function (source, sourceText) {
	        if (!!source && source.id > 0) {
	            this.log.debug('evidenceUtils.postSource reuse');
	            return this.rx.Observable.of(this.utils.clone(source));
	        }
	        if (!source && !sourceText) {
	            this.log.debug('evidenceUtils.postSource omit');
	            return this.rx.Observable.of(null);
	        }
	        var src;
	        if (!!source) {
	            src = source;
	        }
	        else {
	            src = {
	                abbr: sourceText,
	                title: sourceText
	            };
	        }
	        this.log.debug('evidenceUtils.postSource create');
	        return this.sources.create(src, true);
	    };
	    EvidenceUtilsService.prototype.postEvidence = function (source, form, personas) {
	        var _this = this;
	        var evidence;
	        if (!!form.evidence) {
	            evidence = this.utils.clone(form.evidence);
	        }
	        else {
	            evidence = {
	                id: 0,
	                fact: {},
	                externalImageURL: '',
	                citation: {}
	            };
	        }
	        evidence.fact.type = form.type || 'Unknown';
	        evidence.fact.value = form.value;
	        if (evidence.fact.date !== form.date) {
	            evidence.fact.date = form.date;
	            evidence.fact.dateSort = '';
	        }
	        var place = !!form.place ? form.place.name : !!form.placeText ? form.placeText : '';
	        if (evidence.fact.place !== place) {
	            evidence.fact.place = place;
	            evidence.fact.placeStandard = !!form.place ? form.place.standardName : '';
	            evidence.fact.latitude = !!form.place ? form.place.latitude : 0;
	            evidence.fact.longitude = !!form.place ? form.place.longitude : 0;
	        }
	        evidence.fact.placeDetails = form.placeDetails;
	        evidence.text = form.text || '';
	        evidence.researchLogId = +form.researchLogId || 0;
	        evidence.citation.sourceId = !!source ? source.id : 0;
	        evidence.citation.url = form.url;
	        evidence.citation.page = form.page;
	        evidence.citation.date = form.sourceDate;
	        evidence.citation.text = form.citation;
	        evidence.mediaIds = new Map();
	        if (!!form.mediaIds) {
	            try {
	                for (var _a = __values(form.mediaIds), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var _c = __read(_b.value, 1), mediaId = _c[0];
	                    evidence.mediaIds.set(mediaId, true);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        evidence.personas = new Map();
	        personas.forEach(function (pa, ix) {
	            var persona = {
	                principal: pa.principal,
	                relatedToKey: _this.getRelatedToKey(pa, ix),
	                relationshipType: ix === 0 ? '' : !!pa.relationshipType && pa.relationshipType !== 'OTHER' ? pa.relationshipType : pa.role,
	                names: new Map(),
	                facts: new Map()
	            };
	            var name = _this.utils.createName(pa.nameGiven, pa.nameSurname, pa.namePrefix, pa.nameSuffix);
	            if (!_this.utils.isNameEmpty(name)) {
	                persona.names.set(1, {
	                    nameForms: new Map([['default', name]]),
	                    type: ''
	                });
	            }
	            name = _this.utils.createName(form.nameGiven, form.nameSurname, form.namePrefix, form.nameSuffix);
	            if (form.type === 'NAME' && ix === 0 && !_this.utils.isNameEmpty(name)) {
	                persona.names.set(1, {
	                    nameForms: new Map([['default', name]]),
	                    type: form.nameType
	                });
	            }
	            try {
	                for (var _a = __values(pa.facts), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var _c = __read(_b.value, 2), f = _c[1];
	                    if (!_this.utils.isFactEmpty(f)) {
	                        if (!f.type && !f.typeText) {
	                            f.typeText = 'Unknown';
	                        }
	                        persona.facts.set(f.key, _this.toPersonaFact(f));
	                    }
	                }
	            }
	            catch (e_2_1) { e_2 = { error: e_2_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                }
	                finally { if (e_2) throw e_2.error; }
	            }
	            var hasReference = personas.some(function (opa, oix) { return _this.getRelatedToKey(opa, oix) === pa.key; });
	            if (ix === 0 || !!pa.person || persona.facts.size > 0 || persona.names.size > 0 || hasReference) {
	                evidence.personas.set(pa.key, persona);
	            }
	            var e_2, _d;
	        });
	        if (evidence.id > 0) {
	            this.log.debug('evidenceUtils.postEvidence update', evidence);
	            return this.evidences.update(evidence);
	        }
	        else if (this.isEmptyEvidence(evidence)) {
	            this.log.debug('evidenceUtils.postEvidence omit', evidence);
	            return this.rx.Observable.of(evidence);
	        }
	        else {
	            this.log.debug('evidenceUtils.postEvidence create', evidence);
	            return this.evidences.create(evidence);
	        }
	        var e_1, _d;
	    };
	    EvidenceUtilsService.prototype.getRelatedToKey = function (pa, ix) {
	        return ix === 0 || !pa.relationshipType || pa.relationshipType === 'OTHER' ? 0 : pa.relatedToKey;
	    };
	    EvidenceUtilsService.prototype.isEmptyEvidence = function (evidence) {
	        if (evidence.personas.size > 1) {
	            return false;
	        }
	        var pa = this.utils.first(evidence.personas);
	        return !evidence.text && !evidence.researchLogId && !evidence.externalImageURL && evidence.mediaIds.size === 0 &&
	            !evidence.citation.sourceId && !evidence.citation.url && !evidence.citation.page && !evidence.citation.date && !evidence.citation.text &&
	            (evidence.personas.size === 0 || (pa.facts.size === 0 && (pa.names.size === 0 || (pa.names.size === 1 && evidence.fact.type === 'NAME'))));
	    };
	    EvidenceUtilsService.prototype.postPeople = function (personas, evidence, deletedNamesFacts) {
	        var _this = this;
	        // skip personas that didn't get added to the evidence
	        personas = personas.filter(function (pa) { return evidence.personas.has(pa.key); });
	        // set personId for each persona (used to calculate principalIds)
	        personas.forEach(function (pa) {
	            pa.personId = !!pa.person && pa.person.id > 0 ? pa.person.id : !!pa.person ? _this.utils.randomId() : 0;
	        });
	        // update all people at once
	        if (personas.length === 0) {
	            return this.rx.Observable.of([]);
	        }
	        //// if we need to create a new birth evidence because we're deleting the last evidence for a birth but don't want to delete the birth fact
	        //let birthEvidenceIds = personas.map(pa => {
	        //  return {pid: !!pa.person ? pa.person.id : 0, eid: this.utils.randomId()};
	        //});
	        return (_a = this.rx.Observable).forkJoin.apply(_a, __spread(personas.map(function (pa) {
	            return _this.getEvidencesForPerson(pa.person).flatMap(function (evidenceMap) {
	                return _this.postPerson(pa, personas, evidence.id, evidence.fact, evidence.personas.get(pa.key), evidenceMap, deletedNamesFacts);
	            });
	        })));
	        var _a;
	    };
	    EvidenceUtilsService.prototype.getEvidencesForPerson = function (person) {
	        if (!person || person.id === 0) {
	            return this.rx.Observable.of(new Map());
	        }
	        return this.evidences.streamForPerson(person).take(1);
	    };
	    EvidenceUtilsService.prototype.postPerson = function (pa, personas, evidenceId, primaryFact, evidencePersona, evidenceMap, deletedNamesFacts) {
	        this.log.debug('evidenceUtils.postPerson', pa, primaryFact, deletedNamesFacts);
	        if (!pa.person) {
	            return this.rx.Observable.of({ persona: pa, person: null });
	        }
	        var updated = false;
	        //let evidenceFactKeyRels = [];
	        var person = this.utils.clone(pa.person);
	        // remember names and facts with evidenceId
	        var principalPersonas = personas.filter(function (pa) { return pa.principal && !!pa.person; });
	        var principalIds = principalPersonas.map(function (pa) { return pa.personId; });
	        var supportedNameKeys = Array.from(person.names.keys()).filter(function (key) { return person.names.get(key).evidencePersonas.get(evidenceId) > 0; });
	        var supportedFactKeys = Array.from(person.facts.keys()).filter(function (key) { return person.facts.get(key).evidencePersonas.get(evidenceId) > 0; });
	        // get preferences
	        var preferredNameKey = person.preferredNameKey > 0 ? person.preferredNameKey : pa.person.names.size > 0 ? Array.from(pa.person.names.keys())[0] : 0;
	        var birthEntry = Array.from(pa.person.facts.entries()).find(function (_a) {
	            var _b = __read(_a, 2), f = _b[1];
	            return f.principal && f.type === 'BIRT';
	        });
	        var preferredBirthKey = person.preferredBirthKey > 0 ? person.preferredBirthKey : !!birthEntry ? birthEntry[0] : 0;
	        var deathEntry = Array.from(pa.person.facts.entries()).find(function (_a) {
	            var _b = __read(_a, 2), f = _b[1];
	            return f.principal && f.type === 'DEAT';
	        });
	        var preferredDeathKey = person.preferredDeathKey > 0 ? person.preferredDeathKey : !!deathEntry ? deathEntry[0] : 0;
	        // remove unsupported childbirth facts -- still needed?
	        //if ((primaryFact.type === 'BIRT' || primaryFact.type === 'CHR') && principalIds.length === 1 && principalPersonas[0].updateProfileBirth) {
	        //  Array.from(person.facts.entries())
	        //    .filter(([,fact]) => !fact.principal && fact.principalId1 === principalIds[0] && fact.evidencePersonas.size === 0)
	        //    .forEach(([key]) => {
	        //      person.facts.delete(key);
	        //    });
	        //}
	        // remove support for existing names and facts
	        supportedNameKeys.forEach(function (key) {
	            person.names.get(key).evidencePersonas.delete(evidenceId);
	        });
	        supportedFactKeys.forEach(function (key) {
	            person.facts.get(key).evidencePersonas.delete(evidenceId);
	        });
	        // set living
	        if (!person.living) {
	            person.living = this.calcLiving(evidencePersona, primaryFact);
	            if (!!person.living) {
	                updated = true;
	            }
	        }
	        // set gender
	        if (!person.gender) {
	            person.gender = this.calcGender(evidencePersona, personas);
	            if (!!person.gender) {
	                updated = true;
	            }
	        }
	        // if the user entered a different name for this new person than the name on the record, make that the preferred name
	        if (person.id === 0) {
	            var n = this.utils.first(person.names);
	            var nf = this.persons.getDefaultNameForm(n);
	            if (!!person._fullName && !!nf && person._fullName.toLowerCase() !== (nf.given + ' ' + nf.surname).toLowerCase()) {
	                preferredNameKey = this.utils.randomKey();
	                var en = this.utils.createName(person._given, person._surname, '', '');
	                person.names.set(preferredNameKey, {
	                    nameForms: new Map([['default', en]]),
	                    evidencePersonas: new Map()
	                });
	            }
	        }
	        // update name - don't update the preferred name from the persona if we already have a name from the new person
	        if (this.updateName(pa.key, evidencePersona, primaryFact, evidenceId, pa.updateProfileName && !(person.id === 0 && preferredNameKey > 0), person)) {
	            updated = true;
	        }
	        // update facts
	        if (this.updateFacts(pa.key, evidencePersona.principal, Array.from(evidencePersona.facts.values()), evidenceId, evidenceMap, primaryFact, principalIds, pa.updateProfileBirth, pa.updateProfileDeath, pa.personId, person, personas, supportedFactKeys)) {
	            updated = true;
	        }
	        // update preferences
	        if (!person.preferredNameKey && preferredNameKey > 0) {
	            person.preferredNameKey = preferredNameKey;
	            updated = true;
	        }
	        if (!person.preferredBirthKey && preferredBirthKey > 0) {
	            person.preferredBirthKey = preferredBirthKey;
	            updated = true;
	        }
	        if (!person.preferredDeathKey && preferredDeathKey > 0) {
	            person.preferredDeathKey = preferredDeathKey;
	            if (person.living !== 'FALSE') {
	                person.living = 'FALSE';
	            }
	            updated = true;
	        }
	        // remove edited name/fact
	        if (!!pa.nameKey && person.names.has(pa.nameKey) && person.names.get(pa.nameKey).evidencePersonas.size === 0 &&
	            !(person.preferredNameKey === pa.nameKey && !pa.updateProfileName)) {
	            person.names.delete(pa.nameKey);
	            if (person.preferredNameKey === pa.nameKey) {
	                person.preferredNameKey = 0;
	            }
	            updated = true;
	        }
	        if (!!pa.factKey && person.facts.has(pa.factKey) && person.facts.get(pa.factKey).evidencePersonas.size === 0) {
	            if (!(person.preferredBirthKey === pa.factKey && !pa.updateProfileBirth) && // don't delete preferred birth or death
	                !(person.preferredDeathKey === pa.factKey && !pa.updateProfileDeath) &&
	                !person.facts.get(pa.factKey)._updated) {
	                // delete fact
	                person.facts.delete(pa.factKey);
	                if (person.preferredBirthKey === pa.factKey) {
	                    person.preferredBirthKey = 0;
	                }
	                if (person.preferredDeathKey === pa.factKey) {
	                    person.preferredDeathKey = 0;
	                }
	            }
	            //else {
	            //  // add evidence to fact
	            //  evidenceFactKeyRels.push({key: pa.factKey, relationshipType: pa.relationshipType});
	            //}
	            updated = true;
	        }
	        // remove names & facts that have been updated or deleted and no longer supported
	        supportedNameKeys.forEach(function (key) {
	            if (person.names.get(key).evidencePersonas.size === 0 &&
	                !deletedNamesFacts.find(function (nf) { return nf.personId === person.id && nf.isName && nf.key === key && !nf.delete; }) &&
	                !(person.preferredNameKey === key && !pa.updateProfileName)) {
	                person.names.delete(key);
	                if (person.preferredNameKey === key) {
	                    person.preferredNameKey = 0;
	                }
	                updated = true;
	            }
	            else if (!person.names.get(key).evidencePersonas.has(evidenceId)) {
	                // support has been removed
	                updated = true;
	            }
	        });
	        supportedFactKeys.forEach(function (key) {
	            if (person.facts.get(key).evidencePersonas.size === 0) {
	                if (!deletedNamesFacts.find(function (nf) { return nf.personId === person.id && !nf.isName && nf.key === key && !nf.delete; }) &&
	                    !(person.preferredBirthKey === key && !pa.updateProfileBirth) && // don't delete preferred birth or death
	                    !(person.preferredDeathKey === key && !pa.updateProfileDeath)) {
	                    //!((person.facts.get(key).type === 'BIRT' || person.facts.get(key).type === 'CHR') && !person.facts.get(key).principal && principalIds.length === 1 &&
	                    //// don't delete childbirth fact that is being kept
	                    //// TODO this is probably wrong, but we shouldn't be keeping parents on all childbirth facts anyway I think
	                    //pa.relatedToKey === principalPersonas[0].key && person.facts.get(key).principalId1 === principalIds[0] && !principalPersonas[0].updateProfileBirth)) {
	                    // delete fact
	                    person.facts.delete(key);
	                    if (person.preferredBirthKey === key) {
	                        person.preferredBirthKey = 0;
	                    }
	                    if (person.preferredDeathKey === key) {
	                        person.preferredDeathKey = 0;
	                    }
	                }
	                //else {
	                //  // add evidence to fact
	                //  evidenceFactKeyRels.push({key: key, relationshipType: pa.relationshipType});
	                //}
	                updated = true;
	            }
	            else if (!person.facts.get(key).evidencePersonas.has(evidenceId)) {
	                // support has been removed
	                updated = true;
	            }
	        });
	        // add evidences
	        //return this.addEvidences(person, evidenceFactKeyRels).flatMap(person => {
	        // does person need to be created or updated?
	        var stream;
	        if (person.id === 0) {
	            person.id = pa.personId;
	            stream = this.persons.create(person);
	        }
	        else if (!updated) {
	            stream = this.rx.Observable.of(pa.person);
	        }
	        else {
	            stream = this.persons.update(person);
	        }
	        return stream.map(function (person) { return { persona: pa, person: person }; });
	        //});
	    };
	    EvidenceUtilsService.prototype.toPersonaFact = function (f) {
	        return {
	            type: !!f.type ? f.type.value : f.typeText,
	            value: f.value,
	            date: f.date,
	            dateSort: f.dateSort,
	            place: !!f.place ? f.place.name : !!f.placeText ? f.placeText : '',
	            placeDetails: '',
	            placeStandard: !!f.place ? f.place.standardName : '',
	            latitude: !!f.place ? f.place.latitude : 0,
	            longitude: !!f.place ? f.place.longitude : 0
	        };
	    };
	    EvidenceUtilsService.prototype.calcLiving = function (epa, primaryFact) {
	        var _this = this;
	        if (epa.principal &&
	            (primaryFact.type === 'DEAT' || primaryFact.type === 'BURI') &&
	            (this.hasLivingWords(primaryFact.date) || this.hasLivingWords(primaryFact.place))) {
	            return 'TRUE';
	        }
	        var y = new Date().getFullYear() - 110;
	        if (epa.principal && !!primaryFact.dateSort && parseInt(primaryFact.dateSort.substr(0, 4), 10) < y) {
	            return 'FALSE';
	        }
	        if (epa.principal && (primaryFact.type === 'DEAT' || primaryFact.type === 'BURI') && (!!primaryFact.dateSort || !!primaryFact.place)) {
	            return 'FALSE';
	        }
	        var allFacts = Array.from(epa.facts.values());
	        var births = allFacts.filter(function (f) { return f.type === 'BIRTH'; }); // omit CHR and BAPM because they could be adult
	        var deaths = allFacts.filter(function (f) { return f.type === 'DEATH' || f.type === 'BURI'; });
	        if (deaths.some(function (d) { return _this.hasLivingWords(d.date) || _this.hasLivingWords(d.place); })) {
	            return 'TRUE';
	        }
	        if (deaths.some(function (d) { return !!d.dateSort || !!d.place; }) ||
	            allFacts.some(function (b) { return !!b.dateSort && parseInt(b.dateSort.substr(0, 4), 10) < y; })) {
	            return 'FALSE';
	        }
	        if (births.some(function (b) { return !!b.dateSort && parseInt(b.dateSort.substr(0, 4), 10) >= y; })) {
	            return 'TRUE';
	        }
	        if (epa.principal && primaryFact.type === 'BIRT' && !!primaryFact.dateSort && parseInt(primaryFact.dateSort.substr(0, 4), 10) >= y) {
	            return 'TRUE';
	        }
	        return '';
	    };
	    EvidenceUtilsService.prototype.hasLivingWords = function (s) {
	        return this.livingWords.indexOf(s.toLowerCase()) >= 0;
	    };
	    EvidenceUtilsService.prototype.calcGender = function (epa, personas) {
	        // look up gender fact
	        var genderFact = Array.from(epa.facts.values()).find(function (f) { return f.type === 'SEX'; });
	        if (!!genderFact && !!genderFact.value) {
	            var gender = this.utils.findGender(this.utils.genders, genderFact.value);
	            if (!!gender) {
	                return gender.value;
	            }
	        }
	        // return gender if this person is a father, mother, or spouse
	        if (epa.relationshipType === 'FATHER') {
	            return 'MALE';
	        }
	        if (epa.relationshipType === 'MOTHER') {
	            return 'FEMALE';
	        }
	        if (epa.relationshipType === 'SPOUSE') {
	            var spouse = personas.find(function (pa) { return pa.key === epa.relatedToKey; });
	            if (!!spouse && !!spouse.person && spouse.person.gender === 'MALE') {
	                return 'FEMALE';
	            }
	            if (!!spouse && !!spouse.person && spouse.person.gender === 'FEMALE') {
	                return 'MALE';
	            }
	        }
	        return '';
	    };
	    EvidenceUtilsService.prototype.updateName = function (paKey, epa, primaryFact, evidenceId, updateProfileName, person) {
	        var _this = this;
	        if (epa.names.size === 0) {
	            return false;
	        }
	        var n = this.utils.first(epa.names);
	        var nf = this.persons.getDefaultNameForm(n);
	        var en = this.utils.createName(nf.given, nf.surname, nf.prefix, nf.suffix);
	        var nameKey = Array.from(person.names.keys()).find(function (nk) { return _this.utils.nameEquals(_this.persons.getDefaultNameForm(person.names.get(nk)), en); }) || 0;
	        if (!nameKey) {
	            nameKey = this.utils.randomKey();
	            person.names.set(nameKey, {
	                nameForms: new Map([['default', en]]),
	                type: n.type,
	                date: primaryFact.type === 'NAME' ? primaryFact.date : '',
	                dateSort: '',
	                evidencePersonas: new Map()
	            });
	        }
	        else if (primaryFact.type === 'NAME') {
	            person.names.get(nameKey).date = primaryFact.date;
	            person.names.get(nameKey).dateSort = '';
	        }
	        if (evidenceId > 0) {
	            person.names.get(nameKey).evidencePersonas.set(evidenceId, paKey);
	        }
	        if (updateProfileName) {
	            person.preferredNameKey = nameKey;
	        }
	        return true;
	    };
	    EvidenceUtilsService.prototype.updateFacts = function (paKey, principal, epaFacts, evidenceId, evidenceMap, primaryFact, principalIds, updateProfileBirth, updateProfileDeath, paPersonId, person, personas, supportedFactKeys) {
	        var _this = this;
	        var persona = personas.find(function (pa) { return pa.key === paKey; });
	        // add persona facts
	        epaFacts.forEach(function (fact) {
	            var f = _this.getPersonFact(fact, epaFacts, primaryFact, persona, personas);
	            if (!!f) {
	                _this.updateFact(paKey, epaFacts, f, evidenceId, evidenceMap, updateProfileBirth, updateProfileDeath, person, supportedFactKeys);
	            }
	        });
	        // no need to go any further for names
	        if (primaryFact.type === 'NAME') {
	            return false;
	        }
	        // add BIRT and MARR facts under other personas who are related to this persona
	        this.getSpouseMarriageFacts(persona, personas).forEach(function (fact) {
	            var f = _this.getPersonFact(fact, null, primaryFact);
	            if (!!f) {
	                f.principal = true;
	                f.principalId1 = fact.principalId1;
	                _this.updateFact(paKey, epaFacts, f, evidenceId, evidenceMap, updateProfileBirth, updateProfileDeath, person, supportedFactKeys);
	            }
	        });
	        //let cbafs = this.getChildBirthAgeFacts(persona, personas);
	        //cbafs.forEach(fact => {
	        //  let f = this.getPersonFact(fact, cbafs, primaryFact);
	        //  if (!!f && fact.principalId1 > 0) {
	        //    f.principal = false;
	        //    f.principalId1 = fact.principalId1;
	        //    this.updateFact(paKey, epaFacts, f, evidenceId, evidenceMap, updateProfileBirth, updateProfileDeath, person);
	        //  }
	        //});
	        // add primary fact
	        var f = this.utils.clone(primaryFact);
	        f.principal = principal;
	        f.principalId1 = 0;
	        f.principalId2 = 0;
	        var factType = this.utils.factTypes.find(function (ft) { return ft.value === f.type; });
	        var personId = person.id || paPersonId;
	        if (!!factType && factType.spouse) {
	            if (f.principal) {
	                f.principalId1 = principalIds.some(function (id) { return id !== personId; }) ? principalIds.find(function (id) { return id !== personId; }) : 0;
	            }
	            else if (principalIds.length > 0) {
	                f.principalId1 = principalIds[0];
	                if (principalIds.length > 1) {
	                    f.principalId2 = principalIds[1];
	                }
	            }
	        }
	        else if (!f.principal) {
	            f.principalId1 = principalIds.length > 0 ? principalIds[0] : 0;
	        }
	        if (!f.principal && f.principalId1 === 0) {
	            return false; // no principal, so skip
	        }
	        this.updateFact(paKey, epaFacts, f, evidenceId, evidenceMap, f.principal && updateProfileBirth, f.principal && updateProfileDeath, person, supportedFactKeys);
	        return true;
	    };
	    EvidenceUtilsService.prototype.getSpouseMarriageFacts = function (persona, personas) {
	        var _this = this;
	        var facts = [];
	        personas.forEach(function (pa) {
	            if ((persona.relatedToKey === pa.key && persona.relationshipType === 'SPOUSE') ||
	                (pa.relatedToKey === persona.key && pa.relationshipType === 'SPOUSE')) {
	                facts = facts.concat(Array.from(pa.facts.values()).filter(function (f) { return !!f.type && f.type.value === 'MARR'; }) //TODO fact interface
	                    .map(function (f) { return Object.assign({}, _this.toPersonaFact(f), { principal: false, principalId1: pa.personId }); }));
	            }
	        });
	        return facts;
	    };
	    //getChildBirthAgeFacts(persona, personas) {
	    //  let facts = [];
	    //  personas.forEach(pa => {
	    //    if ((persona.relatedToKey === pa.key && (persona.relationshipType === 'FATHER' || persona.relationshipType === 'MOTHER')) ||
	    //        (personas.some(pa2 => pa.relatedToKey === pa2.key && pa.relationshipType === 'CHILD' && persona.relatedToKey === pa2.key && persona.relationshipType === 'SPOUSE')) ||
	    //        (personas.some(pa2 => pa.relatedToKey === pa2.key && pa.relationshipType === 'CHILD' && pa2.relatedToKey === persona.key && pa2.relationshipType === 'SPOUSE')) ||
	    //        (pa.relatedToKey === persona.key && pa.relationshipType === 'CHILD')) {
	    //      facts = facts.concat(Array.from(pa.facts.values()).filter(f => !!f.type && (f.type.value === 'BIRT' || f.type.value === '_AGE'))
	    //        .map(f => Object.assign({}, this.toPersonaFact(f), {principal: false, principalId1: pa.personId})));
	    //    }
	    //  });
	    //  return facts;
	    //}
	    EvidenceUtilsService.prototype.getPersonFact = function (fact, facts, primaryFact, persona, personas) {
	        if (facts === void 0) { facts = null; }
	        if (primaryFact === void 0) { primaryFact = null; }
	        if (persona === void 0) { persona = null; }
	        if (personas === void 0) { personas = []; }
	        if (fact.type === 'BIRT' && !fact.date && !!facts && facts.some(function (f) { return f.type === '_AGE'; })) {
	            return null; // take the age fact
	        }
	        if (fact.type === '_AGE' && !!facts && facts.some(function (f) { return f.type === 'BIRT' && !!f.date; })) {
	            return null; // take the birth fact
	        }
	        var principalId1 = 0;
	        if (fact.type === 'MARR' && !!persona && personas.length > 0) {
	            // get spouse
	            if (persona.relatedToKey > 0 && persona.relationshipType === 'SPOUSE' && personas.some(function (pa) { return pa.key === persona.relatedToKey; })) {
	                principalId1 = personas.find(function (pa) { return pa.key === persona.relatedToKey; }).personId;
	            }
	            else if (personas.some(function (pa) { return pa.relatedToKey === persona.key && pa.relationshipType === 'SPOUSE'; })) {
	                principalId1 = personas.find(function (pa) { return pa.relatedToKey === persona.key && pa.relationshipType === 'SPOUSE'; }).personId;
	            }
	        }
	        if (fact.type === '_AGE') {
	            // convert age to about birth
	            if (!primaryFact) {
	                return null;
	            }
	            var _a = this.utils.getBirthdateFromEventAge(primaryFact.dateSort, fact.value || fact.date), date = _a.date, dateSort = _a.dateSort;
	            if (!date) {
	                return null;
	            }
	            var birthFact = !!facts && facts.find(function (f) { return f.type === 'BIRT'; });
	            var placeFact = !!birthFact && !!birthFact.place ? birthFact : fact;
	            return {
	                type: 'BIRT',
	                date: date,
	                dateSort: dateSort,
	                place: placeFact.place,
	                placeStandard: placeFact.placeStandard,
	                placeDetails: '',
	                latitude: placeFact.latitude,
	                longitude: placeFact.longitude,
	                value: '',
	                principal: true,
	                principalId1: principalId1,
	                principalId2: 0,
	                evidencePersonas: new Map()
	            };
	        }
	        else {
	            var f = this.utils.clone(fact);
	            f.principal = true;
	            f.principalId1 = principalId1;
	            f.principalId2 = 0;
	            f.evidencePersonas = new Map();
	            return f;
	        }
	    };
	    EvidenceUtilsService.prototype.updateFact = function (paKey, epaFacts, f, evidenceId, evidenceMap, updateProfileBirth, updateProfileDeath, person, supportedFactKeys) {
	        var _this = this;
	        var compatibleFactKeys = Array.from(person.facts.keys()).filter(function (fk) { return _this.utils.factEquals(person.facts.get(fk), f); });
	        if (compatibleFactKeys.length === 0) {
	            compatibleFactKeys = Array.from(person.facts.keys()).filter(function (fk) { return _this.utils.factCompatible(person.facts.get(fk), f); });
	        }
	        if (compatibleFactKeys.length > 1) {
	            compatibleFactKeys.sort(function (fk1, fk2) { return person.facts.get(fk2).evidencePersonas.size - person.facts.get(fk1).evidencePersonas.size; });
	        }
	        // prefer facts that this evidence currently supports
	        var factKey = 0;
	        if (compatibleFactKeys.length > 0) {
	            factKey = (compatibleFactKeys.find(function (cKey) { return supportedFactKeys.some(function (sKey) { return sKey === cKey; }); }) || compatibleFactKeys[0]); //TODO add numerous persona types
	        }
	        if (factKey > 0) {
	            var facts = this.getFactsFromEvidences(person.facts.get(factKey), evidenceMap, evidenceId);
	            facts.push(f);
	            var mergedFact = this.utils.mergeFacts(facts);
	            mergedFact._updated = true;
	            person.facts.set(factKey, mergedFact);
	        }
	        else {
	            factKey = this.utils.randomKey();
	            f = this.utils.clone(f);
	            f.evidencePersonas = new Map();
	            person.facts.set(factKey, f);
	        }
	        if (evidenceId > 0) {
	            person.facts.get(factKey).evidencePersonas.set(evidenceId, paKey);
	        }
	        if (updateProfileBirth && f.principal && (f.type === 'BIRT' || ((f.type === 'CHR' || f.type === 'BAPM') && !epaFacts.some(function (f) { return f.type === 'BIRT'; })))) {
	            person.preferredBirthKey = factKey;
	        }
	        if (updateProfileDeath && f.principal && (f.type === 'DEAT' || (f.type === 'BURI' && !epaFacts.some(function (f) { return f.type === 'DEAT'; })))) {
	            person.preferredDeathKey = factKey;
	            if (person.living !== 'FALSE') {
	                person.living = 'FALSE';
	            }
	        }
	    };
	    EvidenceUtilsService.prototype.getFactsFromEvidences = function (origFact, evidenceMap, evidenceId) {
	        var _this = this;
	        var facts = [];
	        try {
	            // for each evidence persona that does not point to this evidence
	            for (var _a = __values(origFact.evidencePersonas), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var _c = __read(_b.value, 1), eid = _c[0];
	                if (eid !== evidenceId) {
	                    var paid = origFact.evidencePersonas.get(eid);
	                    var e = evidenceMap.get(eid);
	                    if (!!e) {
	                        var pa = e.personas.get(paid);
	                        if (!!pa) {
	                            // if persona is principal, get primary fact
	                            if (pa.principal) {
	                                var f = this.getPersonFact(e.fact);
	                                if (!!f) {
	                                    f.evidencePersonas.set(eid, paid);
	                                    facts.push(f);
	                                }
	                            }
	                            try {
	                                // get all facts under persona
	                                for (var _d = __values(pa.facts), _e = _d.next(); !_e.done; _e = _d.next()) {
	                                    var _f = __read(_e.value, 2), fact = _f[1];
	                                    var f = this.getPersonFact(fact, Array.from(pa.facts.values()), e.fact);
	                                    if (!!f) {
	                                        f.evidencePersonas.set(eid, paid);
	                                        facts.push(f);
	                                    }
	                                }
	                            }
	                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                            finally {
	                                try {
	                                    if (_e && !_e.done && (_g = _d.return)) _g.call(_d);
	                                }
	                                finally { if (e_3) throw e_3.error; }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_h = _a.return)) _h.call(_a);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        // filter compatible with original fact
	        var compatFacts = facts.filter(function (f) { return _this.utils.factCompatible(origFact, f, true); }); // evidence facts don't have principalIds
	        return compatFacts;
	        var e_4, _h, e_3, _g;
	    };
	    EvidenceUtilsService.prototype.postFamilies = function (personaPersons) {
	        var _this = this;
	        var familyRequests = [];
	        // for each persona, construct family relationships
	        personaPersons.forEach(function (_a) {
	            var persona = _a.persona, person = _a.person;
	            if (_this.familyRelationshipTypes.indexOf(persona.relationshipType) >= 0) {
	                var relatedToPP = personaPersons.find(function (pp) { return persona.relatedToKey === pp.persona.key; });
	                if (!!person && !!relatedToPP && !!relatedToPP.person) {
	                    // request the familes (child or parent) of the person
	                    familyRequests.push(_this.requestFamilies(person, persona.relationshipType, relatedToPP.person));
	                }
	            }
	        });
	        if (familyRequests.length === 0) {
	            return this.rx.Observable.of([]);
	        }
	        // request families one at a time so we can incrementally update the families array
	        var families = [];
	        var waitCount = familyRequests.length;
	        var subject = new this.rx.AsyncSubject();
	        (_a = this.rx.Observable).concat.apply(_a, __spread(familyRequests)).subscribe(function (_a) {
	            var fm = _a.fm, person = _a.person, relationshipType = _a.relationshipType, relatedToPerson = _a.relatedToPerson;
	            // if the person is already related to the relatedToPerson, ignore
	            if (!_this.isRelated(fm, person, relationshipType, relatedToPerson)) {
	                var family = families.find(function (f) { return _this.isCompatibleFamily(f, person, relationshipType, relatedToPerson); });
	                if (!family) {
	                    family = _this.createFamily(person, relationshipType, relatedToPerson);
	                    families.push(family);
	                }
	                else {
	                    _this.updateFamily(family, person, relationshipType, relatedToPerson);
	                }
	            }
	            // if all family requests have been processed, complete the subject
	            if (--waitCount === 0) {
	                subject.next(families);
	                subject.complete();
	            }
	        });
	        // once we've read all of the families and determined which families we need to create/update, update all families at once
	        return subject.flatMap(function (families) {
	            if (families.length === 0) {
	                return _this.rx.Observable.of([]);
	            }
	            return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(families.map(function (f) { return _this.postFamily(f); })));
	            var _a;
	        });
	        var _a;
	    };
	    EvidenceUtilsService.prototype.requestFamilies = function (person, relationshipType, relatedToPerson) {
	        // return parentFamilies of person or parentFamilies of relatedToPerson
	        var req = null;
	        if (person.id > 0 && relatedToPerson.id > 0) {
	            switch (relationshipType) {
	                case 'FATHER':
	                case 'MOTHER':
	                case 'PARENT':
	                case 'ADOPTIVE_PARENT':
	                case 'STEP_PARENT':
	                    req = this.families.streamParents(relatedToPerson.id).take(1);
	                    break;
	                // don't look for existing spouses; we take care of looking for duplicate spouse families in postFamily
	                //case 'SPOUSE':
	                //  req = this.families.streamSpouses(person.id).take(1);
	                //  break;
	                case 'CHILD':
	                    req = this.families.streamParents(person.id).take(1);
	                    break;
	            }
	        }
	        if (req === null) {
	            var fm = new Map();
	            return this.rx.Observable.of({ fm: fm, person: person, relationshipType: relationshipType, relatedToPerson: relatedToPerson });
	        }
	        else {
	            return req.map(function (fm) {
	                return { fm: fm, person: person, relationshipType: relationshipType, relatedToPerson: relatedToPerson };
	            });
	        }
	    };
	    EvidenceUtilsService.prototype.isRelated = function (fm, person, relationshipType, relatedToPerson) {
	        switch (relationshipType) {
	            case 'FATHER':
	            case 'MOTHER':
	            case 'PARENT':
	            case 'ADOPTIVE_PARENT':
	            case 'STEP_PARENT':
	                return !!Array.from(fm.values()).find(function (f) { return f.husbandId === person.id || f.wifeId === person.id; }); //TODO fact or family interface type
	            case 'CHILD':
	                return !!Array.from(fm.values()).find(function (f) { return f.husbandId === relatedToPerson.id || f.wifeId === relatedToPerson.id; });
	        }
	        return false;
	    };
	    EvidenceUtilsService.prototype.isCompatibleFamily = function (family, person, relationshipType, relatedToPerson) {
	        switch (relationshipType) {
	            case 'FATHER':
	                return family.childRels.has(relatedToPerson.id) && (family.husbandId === 0 || family.husbandId === person.id);
	            case 'MOTHER':
	                return family.childRels.has(relatedToPerson.id) && (family.wifeId === 0 || family.wifeId === person.id);
	            case 'PARENT':
	            case 'ADOPTIVE_PARENT':
	            case 'STEP_PARENT':
	                return family.childRels.has(relatedToPerson.id) && (family.husbandId === 0 || family.husbandId === person.id || family.wifeId === 0 || family.wifeId === person.id);
	            case 'SPOUSE':
	                return (family.husbandId === relatedToPerson.id && (family.wifeId === 0 || family.wifeId === person.id)) ||
	                    (family.wifeId === relatedToPerson.id && (family.husbandId === 0 || family.husbandId === person.id));
	            case 'CHILD':
	                return family.husbandId === relatedToPerson.id || family.wifeId === relatedToPerson.id;
	        }
	        return false;
	    };
	    EvidenceUtilsService.prototype.isCompatibleExistingFamily = function (existingFamily, family) {
	        var matches = 0;
	        if (family.husbandId !== 0) {
	            if (existingFamily.husbandId === family.husbandId || existingFamily.wifeId === family.husbandId) {
	                matches++;
	            }
	            else if (existingFamily.husbandId !== 0) {
	                return false;
	            }
	        }
	        else if (existingFamily.husbandId === 0) {
	            matches++;
	        }
	        if (family.wifeId !== 0) {
	            if (existingFamily.husbandId === family.wifeId || existingFamily.wifeId === family.wifeId) {
	                matches++;
	            }
	            else if (existingFamily.wifeId !== 0) {
	                return false;
	            }
	        }
	        else if (existingFamily.wifeId === 0) {
	            matches++;
	        }
	        matches += Array.from(existingFamily.childRels.keys()).filter(function (key) { return family.childRels.has(key); }).length;
	        return matches >= 2;
	    };
	    EvidenceUtilsService.prototype.createFamily = function (person, relationshipType, relatedToPerson) {
	        var family = {
	            husbandId: 0,
	            wifeId: 0,
	            childRels: new Map()
	        };
	        var fatherRel = '';
	        var motherRel = '';
	        switch (relationshipType) {
	            case 'FATHER':
	                family.husbandId = person.id;
	                family.childRels.set(relatedToPerson.id, { fatherRel: fatherRel, motherRel: motherRel });
	                break;
	            case 'MOTHER':
	                family.wifeId = person.id;
	                family.childRels.set(relatedToPerson.id, { fatherRel: fatherRel, motherRel: motherRel });
	                break;
	            case 'PARENT':
	            case 'ADOPTIVE_PARENT':
	            case 'STEP_PARENT':
	                if (person.gender === 'FEMALE') {
	                    family.wifeId = person.id;
	                    motherRel = 'ADOPTED';
	                }
	                else {
	                    family.husbandId = person.id;
	                    fatherRel = 'ADOPTED';
	                }
	                family.childRels.set(relatedToPerson.id, { fatherRel: fatherRel, motherRel: motherRel });
	                break;
	            case 'SPOUSE':
	                if (person.gender === 'MALE' || relatedToPerson.gender === 'FEMALE') {
	                    family.husbandId = person.id;
	                    family.wifeId = relatedToPerson.id;
	                }
	                else {
	                    family.wifeId = person.id;
	                    family.husbandId = relatedToPerson.id;
	                }
	                break;
	            case 'CHILD':
	                if (relatedToPerson.gender === 'FEMALE') {
	                    family.wifeId = relatedToPerson.id;
	                }
	                else {
	                    family.husbandId = relatedToPerson.id;
	                }
	                family.childRels.set(person.id, { fatherRel: fatherRel, motherRel: motherRel });
	                break;
	        }
	        return family;
	    };
	    EvidenceUtilsService.prototype.updateFamily = function (family, person, relationshipType, relatedToPerson) {
	        var fatherRel = '';
	        var motherRel = '';
	        switch (relationshipType) {
	            case 'FATHER':
	                family.husbandId = person.id;
	                family.childRels.set(relatedToPerson.id, { fatherRel: fatherRel, motherRel: motherRel });
	                break;
	            case 'MOTHER':
	                family.wifeId = person.id;
	                family.childRels.set(relatedToPerson.id, { fatherRel: fatherRel, motherRel: motherRel });
	                break;
	            case 'PARENT':
	            case 'ADOPTIVE_PARENT':
	            case 'STEP_PARENT':
	                if (person.gender === 'MALE') {
	                    if (family.husbandId !== 0 && family.husbandId !== person.id) {
	                        family.wifeId = family.husbandId;
	                    }
	                    family.husbandId = person.id;
	                    fatherRel = 'ADOPTED';
	                }
	                else if (person.gender === 'FEMALE') {
	                    if (family.wifeId !== 0 && family.wifeId !== person.id) {
	                        family.husbandId = family.wifeId;
	                    }
	                    family.wifeId = person.id;
	                    motherRel = 'ADOPTED';
	                }
	                if (family.husbandId === 0) {
	                    family.husbandId = person.id;
	                }
	                else {
	                    family.wifeId = person.id;
	                }
	                family.childRels.set(relatedToPerson.id, { fatherRel: fatherRel, motherRel: motherRel });
	                break;
	            case 'SPOUSE':
	                if (person.gender === 'MALE' || relatedToPerson.gender === 'FEMALE') {
	                    if (family.husbandId !== 0 && family.husbandId !== person.id) {
	                        family.wifeId = family.husbandId;
	                    }
	                    family.husbandId = person.id;
	                    if (family.wifeId !== 0 && family.wifeId !== relatedToPerson.id) {
	                        family.husbandId = family.wifeId;
	                    }
	                    family.wifeId = relatedToPerson.id;
	                }
	                else {
	                    if (family.wifeId !== 0 && family.wifeId !== person.id) {
	                        family.husbandId = family.wifeId;
	                    }
	                    family.wifeId = person.id;
	                    if (family.husbandId !== 0 && family.husbandId !== relatedToPerson.id) {
	                        family.wifeId = family.husbandId;
	                    }
	                    family.husbandId = relatedToPerson.id;
	                }
	                break;
	            case 'CHILD':
	                if (family.wifeId === relatedToPerson.id || family.husbandId === relatedToPerson.id) {
	                    // pass
	                }
	                else if (relatedToPerson.gender === 'FEMALE') {
	                    if (family.wifeId !== 0 && family.wifeId !== relatedToPerson.id && family.husbandId === 0) {
	                        family.husbandId = family.wifeId;
	                        family.wifeId = 0;
	                    }
	                    if (family.wifeId === 0) {
	                        family.wifeId = relatedToPerson.id;
	                    }
	                }
	                else {
	                    if (family.husbandId !== 0 && family.husbandId !== relatedToPerson.id && family.wifeId === 0) {
	                        family.wifeId = family.husbandId;
	                        family.husbandId = 0;
	                    }
	                    if (family.husbandId === 0) {
	                        family.husbandId = relatedToPerson.id;
	                    }
	                }
	                family.childRels.set(person.id, { fatherRel: fatherRel, motherRel: motherRel });
	                break;
	        }
	    };
	    EvidenceUtilsService.prototype.postFamily = function (family) {
	        var _this = this;
	        // look for an existing family to update, or create a new family
	        var spouseFamilyStreams = [];
	        if (family.husbandId) {
	            spouseFamilyStreams.push(this.families.streamSpouses(family.husbandId).take(1));
	        }
	        if (family.wifeId) {
	            spouseFamilyStreams.push(this.families.streamSpouses(family.wifeId).take(1));
	        }
	        var combinedStream = spouseFamilyStreams.length === 0 ? this.rx.Observable.of([]) : (_a = this.rx.Observable).forkJoin.apply(_a, __spread(spouseFamilyStreams));
	        return combinedStream.flatMap(function (sfMaps) {
	            var spouseFamilies = [].concat.apply([], __spread(sfMaps.map(function (sfMap) { return Array.from(sfMap.values()); }))); // flatten
	            var existingFamily = spouseFamilies.find(function (existingFamily) { return _this.isCompatibleExistingFamily(existingFamily, family); });
	            if (!!existingFamily) {
	                var ef = _this.utils.clone(existingFamily);
	                var updated = false;
	                if (family.husbandId !== 0 && family.husbandId !== ef.husbandId && family.husbandId !== ef.wifeId) {
	                    if (ef.husbandId === 0) {
	                        ef.husbandId = family.husbandId;
	                    }
	                    else {
	                        ef.wifeId = family.husbandId;
	                    }
	                    updated = true;
	                }
	                if (family.wifeId !== 0 && family.wifeId !== ef.wifeId && family.wifeId !== ef.husbandId) {
	                    if (ef.wifeId === 0) {
	                        ef.wifeId = family.wifeId;
	                    }
	                    else {
	                        ef.husbandId = family.wifeId;
	                    }
	                    updated = true;
	                }
	                try {
	                    for (var _a = __values(family.childRels), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var _c = __read(_b.value, 1), key = _c[0];
	                        if (!ef.childRels.has(key)) {
	                            ef.childRels.set(key, { fatherRel: '', motherRel: '' });
	                            updated = true;
	                        }
	                    }
	                }
	                catch (e_5_1) { e_5 = { error: e_5_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                    }
	                    finally { if (e_5) throw e_5.error; }
	                }
	                if (!updated) {
	                    _this.log.debug('evidenceUtils.postFamily not updated', ef);
	                    return _this.rx.Observable.of(existingFamily);
	                }
	                _this.log.debug('evidenceUtils.postFamily update', ef);
	                return _this.families.update(ef);
	            }
	            else {
	                _this.log.debug('evidenceUtils.postFamily new', family);
	                return _this.families.create(family);
	            }
	            var e_5, _d;
	        });
	        var _a;
	    };
	    EvidenceUtilsService.prototype.removeNamesFactsPidFromPersons = function (personas, deletedNamesFacts, oldPid, newPid) {
	        var _this = this;
	        if (oldPid === void 0) { oldPid = 0; }
	        if (newPid === void 0) { newPid = 0; }
	        // which person ids are in deleted namesFacts and not in personas?
	        var pidSet = new Set(deletedNamesFacts.filter(function (nf) { return !personas.some(function (pa) { return pa.personId === nf.personId; }); }).map(function (nf) { return nf.personId; }));
	        // add pids that contain principalId1 or 2 to the list
	        return this.persons.stream().take(1).flatMap(function (pm) {
	            if (oldPid !== 0) {
	                pm.forEach(function (p) {
	                    p.facts.forEach(function (f) {
	                        if (f.principalId1 === oldPid || f.principalId2 === oldPid) {
	                            pidSet.add(p.id);
	                        }
	                    });
	                });
	            }
	            var pids = __spread(pidSet);
	            _this.log.debug('evidenceUtils.removeNamesFactsFromPersons', pids, pids.length);
	            // update them all at once
	            if (pids.length === 0) {
	                return _this.rx.Observable.of([]);
	            }
	            //let birthEvidenceIds = pids.map(pid => {
	            //  return {pid: pid, eid: this.utils.randomId()};
	            //});
	            return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(pids.map(function (pid) { return _this.removeNamesFactsPidFromPerson(pid, deletedNamesFacts, oldPid, newPid); })));
	            var _a;
	        });
	    };
	    EvidenceUtilsService.prototype.removeNamesFactsPidFromPerson = function (pid, deletedNamesFacts, oldPid, newPid) {
	        var _this = this;
	        this.log.debug('evidenceUtils.removeNamesFactsFromPerson', pid, deletedNamesFacts);
	        if (deletedNamesFacts.length === 0 && oldPid === 0) {
	            return this.rx.Observable.of(null);
	        }
	        return this.persons.streamId(pid).take(1).flatMap(function (person) {
	            return _this.evidences.streamForPerson(person).take(1).flatMap(function (evidenceMap) {
	                var p = _this.utils.clone(person);
	                //let evidenceFactKeyRels = [];
	                var updated = false;
	                deletedNamesFacts.forEach(function (nf) {
	                    if (nf.personId === pid && nf.isName && p.names.has(nf.key)) {
	                        updated = true;
	                        if (nf.unsupported && (nf.delete || !nf.principal)) {
	                            // delete the name
	                            p.names.delete(nf.key);
	                            if (p.preferredNameKey === nf.key) {
	                                p.preferredNameKey = 0;
	                            }
	                            if (p.names.size === 0) {
	                                // TODO what???
	                            }
	                        }
	                        else {
	                            // remove the evidence(s)
	                            nf.eids.forEach(function (eid) {
	                                if (p.names.get(nf.key).evidencePersonas.get(eid)) {
	                                    p.names.get(nf.key).evidencePersonas.delete(eid);
	                                }
	                            });
	                        }
	                    }
	                    else if (nf.personId === pid && !nf.isName && p.facts.has(nf.key)) {
	                        updated = true;
	                        if (nf.unsupported) {
	                            if (nf.delete || !nf.principal) {
	                                // delete the fact
	                                p.facts.delete(nf.key);
	                                if (p.preferredBirthKey === nf.key) {
	                                    p.preferredBirthKey = 0;
	                                }
	                                if (p.preferredDeathKey === nf.key) {
	                                    p.preferredDeathKey = 0;
	                                }
	                            }
	                            else {
	                                // remove evidence(s) from fact
	                                nf.eids.forEach(function (eid) {
	                                    p.facts.get(nf.key).evidencePersonas.delete(eid);
	                                });
	                                // add new evidence
	                                //evidenceFactKeyRels.push({key: nf.key});
	                            }
	                        }
	                        else {
	                            // remove the evidence(s)
	                            nf.eids.forEach(function (eid) {
	                                if (p.facts.get(nf.key).evidencePersonas.has(eid)) {
	                                    p.facts.get(nf.key).evidencePersonas.delete(eid);
	                                    // update (generalize) the fact from the remaining evidences
	                                    var f = p.facts.get(nf.key);
	                                    var facts = _this.getFactsFromEvidences(f, evidenceMap);
	                                    var fact = _this.utils.mergeFacts(facts);
	                                    fact.principalId1 = f.principalId1;
	                                    fact.principalId2 = f.principalId2;
	                                    p.facts.set(nf.key, fact);
	                                }
	                            });
	                        }
	                    }
	                    else if (!!nf.fact && (nf.fact.type === 'BIRT' || nf.fact.type === 'CHR' || nf.fact.type === 'BAPM') && nf.principal) {
	                        Array.from(person.facts.entries())
	                            .filter(function (_a) {
	                            var _b = __read(_a, 2), fact = _b[1];
	                            return fact.type === nf.fact.type && !fact.principal && fact.principalId1 === nf.personId && nf.eids.some(function (eid) { return fact.evidencePersonas.has(eid); });
	                        })
	                            .forEach(function (_a) {
	                            var _b = __read(_a, 2), key = _b[0], fact = _b[1];
	                            updated = true;
	                            nf.eids.forEach(function (eid) {
	                                fact.evidencePersonas.delete(eid);
	                            });
	                            if (fact.evidencePersonas.size === 0) {
	                                p.facts.delete(key);
	                            }
	                        });
	                    }
	                });
	                // remove references to pid
	                if (oldPid !== 0 && p.id !== oldPid) {
	                    p.facts.forEach(function (f) {
	                        if (f.principalId1 === oldPid) {
	                            if (newPid !== 0) {
	                                f.principalId1 = newPid;
	                            }
	                            else {
	                                f.principalId1 = f.principalId2;
	                                f.principalId2 = 0;
	                            }
	                            updated = true;
	                        }
	                        else if (f.principalId2 === oldPid) {
	                            f.principalId2 = newPid;
	                            updated = true;
	                        }
	                    });
	                }
	                // add evidences
	                if (updated) {
	                    //return this.addEvidences(p, evidenceFactKeyRels).flatMap(p => {
	                    //return this.rx.Observable.of(p);
	                    return _this.persons.update(p).map(function () { return pid; });
	                    //});
	                }
	                else {
	                    return _this.rx.Observable.of(pid);
	                }
	            });
	        });
	    };
	    //addEvidences(person, evidenceFactKeyRels) {
	    //  if (evidenceFactKeyRels.length === 0) {
	    //    return this.rx.Observable.of(person);
	    //  }
	    //  return this.rx.Observable.forkJoin(...evidenceFactKeyRels.map(fkr => {
	    //    return this.addEvidence(person.facts.get(fkr.key));
	    //    //return this.addEvidence(person, person.facts.get(fkr.key), fkr.relationshipType, birthEvidenceIds);
	    //  }))
	    //    .map(evidencePersonas => {
	    //      evidenceFactKeyRels.forEach((fkr,ix) => {
	    //        let evidencePersona = evidencePersonas[ix];
	    //        if (evidencePersona.personaKey > 0) {
	    //          person.facts.get(fkr.key).evidencePersonas.set(evidencePersona.eid, evidencePersona.personaKey);
	    //        }
	    //      });
	    //      return person;
	    //    });
	    //}
	    //
	    //addEvidence(fact) {
	    //  let e = this.utils.createEvidenceFromFact(fact);
	    //  this.log.debug('evidenceUtils.addEvidence', e);
	    //  return this.evidences.create(e).map(evidence => {
	    //    return {eid: evidence.id, personaKey: 1};
	    //  });
	    //}
	    //addEvidence(person, fact, relationshipType, birthEvidenceIds) {
	    //  let e = this.utils.createEvidenceFromFact(fact);
	    // is this a childbirth fact, then get the id from birthEvidenceIds
	    //if ((fact.type === 'BIRT' || fact.type === 'CHR') && !fact.principal) {
	    //  let eid = birthEvidenceIds.find(bei => bei.pid === fact.principalId1).eid;
	    //  let personaKey = 0;
	    //  if (relationshipType === 'FATHER') {
	    //    personaKey = 2;
	    //  }
	    //  else if (relationshipType === 'MOTHER') {
	    //    personaKey = 3;
	    //  }
	    //  else if (person.gender === 'MALE') {
	    //    personaKey = 2;
	    //  }
	    //  else if (person.gender === 'FEMALE') {
	    //    personaKey = 3;
	    //  }
	    //  this.log.debug('evidenceUtils.addEvidence childbirth', eid, personaKey);
	    //  return this.rx.Observable.of({eid, personaKey});
	    //}
	    //// otherwise add the evidence
	    //else {
	    // if this is a birth fact, get the id from birthEvidenceIds and add the extra personas
	    //if ((fact.type === 'BIRT' || fact.type === 'CHR') && fact.principal) {
	    //  e.id = birthEvidenceIds.find(bei => bei.pid === person.id).eid;
	    //  e.personas.set(2, {
	    //    principal: false,
	    //    relatedToKey: 1,
	    //    relationshipType: 'FATHER',
	    //    names: new Map(),
	    //    facts: new Map()
	    //  });
	    //  e.personas.set(3, {
	    //    principal: false,
	    //    relatedToKey: 1,
	    //    relationshipType: 'MOTHER',
	    //    names: new Map(),
	    //    facts: new Map()
	    //  });
	    //}
	    //this.log.debug('evidenceUtils.addEvidence', e);
	    //return this.evidences.create(e).map(evidence => {
	    //  return {eid: evidence.id, personaKey: 1};
	    //});
	    //}
	    //}
	    // return an array of names & facts found on 0 or more evidences that are not found in personas
	    // evidences must be augmented
	    EvidenceUtilsService.prototype.getDeletedNamesFacts = function (evidences, pas, includePrimary) {
	        var _this = this;
	        if (includePrimary === void 0) { includePrimary = false; }
	        var namesFacts = [];
	        if (evidences.length === 0) {
	            return namesFacts;
	        }
	        if (includePrimary) {
	            evidences.forEach(function (evidence) {
	                if (evidence.fact.type !== 'NAME') {
	                    var fact_1 = evidence.fact;
	                    var factType_1 = _this.utils.factTypes.find(function (ft) { return ft.value === fact_1.type; });
	                    Array.from(evidence._personas.values()).forEach(function (persona) {
	                        var person = evidence._people.get(persona._id) || null;
	                        var pfactEntry = !!person && Array.from(person.facts.entries()).find(function (_a) {
	                            var _b = __read(_a, 2), pfact = _b[1];
	                            return !!pfact.evidencePersonas.get(evidence.id) &&
	                                _this.utils.factCompatible(pfact, fact_1, true);
	                        });
	                        if (!!person && !!pfactEntry) {
	                            _this.addDeletedNameFact(namesFacts, {
	                                personId: person.id,
	                                fullName: person._fullName,
	                                isName: false,
	                                primary: true,
	                                'delete': true,
	                                unsupported: !Array.from(pfactEntry[1].evidencePersonas.keys()).find(function (eid) { return !evidences.some(function (e) { return e.id === eid; }); }),
	                                principal: pfactEntry[1].principal && !(!!factType_1 && factType_1.spouse),
	                                parent: _this.parentRelationshipTypes.indexOf(persona.relationshipType) >= 0 &&
	                                    !!evidence._personas.get(persona.relatedToKey) ? evidence._personas.get(persona.relatedToKey).principal : false,
	                                key: pfactEntry[0],
	                                fact: pfactEntry[1],
	                                eids: [evidence.id]
	                            });
	                        }
	                    });
	                }
	            });
	        }
	        evidences.forEach(function (evidence) {
	            Array.from(evidence._personas.entries()).forEach(function (_a) {
	                var _b = __read(_a, 2), paKey = _b[0], persona = _b[1];
	                var person = evidence._people.get(persona._id) || null;
	                // get deleted names
	                Array.from(persona.names.values()).forEach(function (name) {
	                    // get evidence persona -> person -> name entry
	                    var pnameEntry = !!person && Array.from(person.names.entries()).find(function (_a) {
	                        var _b = __read(_a, 2), pname = _b[1];
	                        return !!pname.evidencePersonas.get(evidence.id) &&
	                            _this.utils.nameEquals(_this.persons.getDefaultNameForm(pname), _this.persons.getDefaultNameForm(name));
	                    });
	                    if (!!person && !!pnameEntry &&
	                        // and the personas don't contain the same name for this person
	                        !pas.some(function (pa) { return !!pa.person &&
	                            pa.person.id === persona._id &&
	                            _this.utils.nameEquals(_this.utils.createName(pa.nameGiven, pa.nameSurname, pa.namePrefix, pa.nameSuffix), _this.persons.getDefaultNameForm(name)); })) {
	                        _this.addDeletedNameFact(namesFacts, {
	                            personId: persona._id,
	                            fullName: persona._fullName,
	                            isName: true,
	                            primary: evidence.fact.type === 'NAME',
	                            'delete': false,
	                            unsupported: !Array.from(pnameEntry[1].evidencePersonas.keys()).find(function (eid) { return !evidences.some(function (e) { return e.id === eid; }); }),
	                            principal: true,
	                            key: pnameEntry[0],
	                            name: _this.persons.getDefaultNameForm(pnameEntry[1]),
	                            eids: [evidence.id]
	                        });
	                    }
	                });
	                // get deleted facts
	                Array.from(persona.facts.values()).forEach(function (fact) {
	                    // convert age to birth
	                    var f = _this.getPersonFact(fact, Array.from(persona.facts.values()), evidence.fact);
	                    if (!!f) {
	                        // get evidence persona -> person -> fact entry
	                        var pfactEntry = !!person && Array.from(person.facts.entries()).find(function (_a) {
	                            var _b = __read(_a, 2), pfact = _b[1];
	                            return !!pfact.evidencePersonas.get(evidence.id) &&
	                                _this.utils.factCompatible(pfact, f, true);
	                        });
	                        if (!!person && !!pfactEntry &&
	                            // and the personas don't contain another fact for this person that is of the same type
	                            !pas.some(function (pa) { return !!pa.person &&
	                                pa.person.id === persona._id &&
	                                Array.from(pa.facts.values()).some(function (f) { return (!!f.type ? f.type.value : f.typeText) === fact.type; }); })) {
	                            _this.addDeletedNameFact(namesFacts, {
	                                personId: persona._id,
	                                fullName: persona._fullName,
	                                isName: false,
	                                primary: false,
	                                'delete': false,
	                                principal: true,
	                                unsupported: !Array.from(pfactEntry[1].evidencePersonas.keys()).find(function (eid) { return !evidences.some(function (e) { return e.id === eid; }); }),
	                                key: pfactEntry[0],
	                                fact: pfactEntry[1],
	                                eids: [evidence.id]
	                            });
	                            // remove birth fact from parents
	                            if (f.type === 'BIRT' || f.type === 'CHR' || f.type === 'BAPM') {
	                                Array.from(evidence._personas.values()).forEach(function (parentPersona) {
	                                    if (_this.parentRelationshipTypes.indexOf(parentPersona.relationshipType) >= 0 && parentPersona.relatedToKey === paKey) {
	                                        var parent_1 = evidence._people.get(parentPersona._id) || null;
	                                        var birthFactEntry = !!parent_1 && Array.from(parent_1.facts.entries()).find(function (_a) {
	                                            var _b = __read(_a, 2), pfact = _b[1];
	                                            return !!pfact.evidencePersonas.get(evidence.id) &&
	                                                _this.utils.factCompatible(pfact, f, true) && !pfact.principal;
	                                        });
	                                        if (!!parent_1 && !!birthFactEntry) {
	                                            _this.addDeletedNameFact(namesFacts, {
	                                                personId: parent_1.id,
	                                                fullName: parent_1._fullName,
	                                                isName: false,
	                                                primary: false,
	                                                'delete': false,
	                                                principal: false,
	                                                unsupported: !Array.from(birthFactEntry[1].evidencePersonas.keys()).find(function (eid) { return !evidences.some(function (e) { return e.id === eid; }); }),
	                                                parent: true,
	                                                key: birthFactEntry[0],
	                                                fact: birthFactEntry[1],
	                                                eids: [evidence.id]
	                                            });
	                                        }
	                                    }
	                                });
	                            }
	                            // remove marriage fact from spouse
	                            if (f.type === 'MARR') {
	                                Array.from(evidence._personas.values()).forEach(function (spousePersona) {
	                                    if (spousePersona.relationshipType === 'SPOUSE' && spousePersona.relatedToKey === paKey) {
	                                        var spouse = evidence._people.get(spousePersona._id) || null;
	                                        var marrFactEntry = !!spouse && Array.from(spouse.facts.entries()).find(function (_a) {
	                                            var _b = __read(_a, 2), pfact = _b[1];
	                                            return !!pfact.evidencePersonas.get(evidence.id) &&
	                                                _this.utils.factCompatible(pfact, f, true) && pfact.principal;
	                                        });
	                                        if (!!spouse && !!marrFactEntry) {
	                                            _this.addDeletedNameFact(namesFacts, {
	                                                personId: spouse.id,
	                                                fullName: spouse._fullName,
	                                                isName: false,
	                                                primary: false,
	                                                'delete': false,
	                                                principal: true,
	                                                unsupported: !Array.from(marrFactEntry[1].evidencePersonas.keys()).find(function (eid) { return !evidences.some(function (e) { return e.id === eid; }); }),
	                                                parent: false,
	                                                key: marrFactEntry[0],
	                                                fact: marrFactEntry[1],
	                                                eids: [evidence.id]
	                                            });
	                                        }
	                                    }
	                                });
	                            }
	                        }
	                    }
	                });
	            });
	        });
	        return namesFacts;
	    };
	    EvidenceUtilsService.prototype.addDeletedNameFact = function (namesFacts, nameFact) {
	        var nf = namesFacts.find(function (nf) { return nf.personId === nameFact.personId && nf.isName === nameFact.isName && nf.key === nameFact.key; });
	        if (!!nf) {
	            nf.eids = nf.eids.concat(nameFact.eids);
	            nf.unsupported = nf.unsupported || nameFact.unsupported;
	            nf.primary = nf.primary || nameFact.primary;
	            nf.delete = nf.delete || nameFact.delete;
	        }
	        else {
	            namesFacts.push(nameFact);
	        }
	    };
	    return EvidenceUtilsService;
	}());
	exports.EvidenceUtilsService = EvidenceUtilsService;
	exports.default = EvidenceUtilsService;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var families_service_1 = __webpack_require__(215);
	var FamiliesService = /** @class */ (function (_super) {
	    __extends(FamiliesService, _super);
	    FamiliesService.$inject = ["$log", "$translate", "rx", "store", "changes", "segment", "utils"];
	    function FamiliesService($log, $translate, rx, store, changes, segment, utils) {
	        'ngInject';
	        return _super.call(this, rx, store, changes, segment, utils) || this;
	    }
	    return FamiliesService;
	}(families_service_1.FamiliesService));
	exports.default = FamiliesService;
	// class FamiliesService {
	//   constructor ($log, $translate, rx, store, changes, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.$translate = $translate;
	//     this.rx = rx;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", "families", changes.treeStream());
	//     this.parentsStream = this.store.addStream(store.streamScanFn(o => {
	//       return !!o.childRels ? o.childRels.keys() : null;
	//     }));
	//     this.spousesStream = this.store.addStream(store.streamScanFn(o => {
	//       let spouseIds = [];
	//       if (o.husbandId > 0) {
	//         spouseIds.push(o.husbandId);
	//       }
	//       if (o.wifeId > 0) {
	//         spouseIds.push(o.wifeId);
	//       }
	//       return spouseIds;
	//     }));
	//   }
	//   create(o) {
	//     this.segment.track('families.create');
	//     return this.store.create(o);
	//   }
	//   update(o) {
	//     this.segment.track('families.update');
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     this.segment.track('families.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   streamIds(ids) {
	//     return this.store.streamIds(ids);
	//   }
	//   // returns a map
	//   streamParents(cid) {
	//     return this.ready().flatMap(() => this.parentsStream.map(m => m.get(cid) || new Map()));
	//   }
	//   // returns a map
	//   streamSpouses(sid) {
	//     return this.ready().flatMap(() => this.spousesStream.map(m => m.get(sid) || new Map()));
	//   }
	//   // non-streaming functions; caller must make sure that stream is "ready" before calling
	//   getMap() {
	//     return this.store.getStream().getValue();
	//   }
	//   getParentsMap() {
	//     return this.parentsStream.getValue();
	//   }
	//   getSpousesMap() {
	//     return this.spousesStream.getValue();
	//   }
	//   //
	//   // helper functions
	//   //
	//   augmentFamily(f, prefId, persons, leads, evidences, users) {
	//     let subject = new this.rx.AsyncSubject();
	//     let waitCount = (f.husbandId > 0 ? 1 : 0) + (f.husbandId > 0 && f.wifeId > 0 ? 1 : 0) + (f.wifeId > 0 ? 1 : 0) + f.childRels.size + 1;
	//     f = Object.assign({}, f, {
	//       '_preferred': f.id === prefId ? 1 : 0,
	//       '_husband': null,
	//       '_wife': null,
	//       '_children': new Map(),
	//       '_marriage': null,
	//       '_createdUser' : null,
	//       '_editedUser' : null
	//     });
	//     if (f.husbandId > 0) {
	//       persons.streamId(f.husbandId).take(1).subscribe(h => {
	//         persons.augmentPerson(h, leads, evidences).subscribe(h => {
	//           f._husband = h;
	//           if (--waitCount === 0) {
	//             subject.next(f);
	//             subject.complete();
	//           }
	//         });
	//         if (f.wifeId > 0) {
	//           persons.streamId(f.wifeId).take(1).subscribe(w => {
	//             f._marriage = persons.getMarriage(h, w);
	//             if (--waitCount === 0) {
	//               subject.next(f);
	//               subject.complete();
	//             }
	//           });
	//         }
	//       });
	//     }
	//     if (f.wifeId > 0) {
	//       persons.streamId(f.wifeId).take(1).subscribe(w => {
	//         persons.augmentPerson(w, leads, evidences).subscribe(w => {
	//           f._wife = w;
	//           if (--waitCount === 0) {
	//             subject.next(f);
	//             subject.complete();
	//           }
	//         });
	//       });
	//     }
	//     Array.from(f.childRels.keys()).forEach(cid => {
	//       persons.streamId(cid).take(1).subscribe(c => {
	//         persons.augmentPerson(c, leads, evidences).subscribe(c => {
	//           f._children.set(cid, c);
	//           if (--waitCount === 0) {
	//             subject.next(f);
	//             subject.complete();
	//           }
	//         });
	//       });
	//     });
	//     // set created user and edited user
	//     this.utils.addCreateEditUsers(f, users).subscribe(() => {
	//       if (--waitCount === 0) {
	//         subject.next(f);
	//         subject.complete();
	//       }
	//     });
	//     return subject;
	//   }
	//   getPreferredFamily(fm, prefId) {
	//     return fm.get(prefId) || this.utils.first(fm);
	//   }
	// }
	// export default FamiliesService;


/***/ }),
/* 215 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var FamiliesService = /** @class */ (function () {
	    function FamiliesService(rx, store, changes, segment, utils) {
	        this.rx = rx;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "families", changes.treeStream());
	        this.parentsStream = this.store.addStream(store.streamScanFn(function (o) {
	            return !!o.childRels ? o.childRels.keys() : null;
	        }));
	        this.spousesStream = this.store.addStream(store.streamScanFn(function (o) {
	            var spouseIds = [];
	            if (o.husbandId > 0) {
	                spouseIds.push(o.husbandId);
	            }
	            if (o.wifeId > 0) {
	                spouseIds.push(o.wifeId);
	            }
	            return spouseIds;
	        }));
	    }
	    FamiliesService.prototype.create = function (o) {
	        this.segment.track('families.create');
	        return this.store.create(o);
	    };
	    FamiliesService.prototype.update = function (o) {
	        this.segment.track('families.update');
	        return this.store.update(o);
	    };
	    FamiliesService.prototype.del = function (id) {
	        this.segment.track('families.delete');
	        return this.store.del(id);
	    };
	    FamiliesService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    FamiliesService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    FamiliesService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    FamiliesService.prototype.streamIds = function (ids) {
	        return this.store.streamIds(ids);
	    };
	    // returns a map
	    FamiliesService.prototype.streamParents = function (cid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.parentsStream.map(function (m) { return m.get(cid) || new Map(); }); });
	    };
	    // returns a map
	    FamiliesService.prototype.streamSpouses = function (sid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.spousesStream.map(function (m) { return m.get(sid) || new Map(); }); });
	    };
	    // non-streaming functions; caller must make sure that stream is "ready" before calling
	    FamiliesService.prototype.getMap = function () {
	        return this.store.getStream().getValue();
	    };
	    FamiliesService.prototype.getParentsMap = function () {
	        return this.parentsStream.getValue();
	    };
	    FamiliesService.prototype.getSpousesMap = function () {
	        return this.spousesStream.getValue();
	    };
	    //
	    // helper functions
	    //
	    FamiliesService.prototype.augmentFamily = function (f, prefId, persons, leads, evidences, users) {
	        var subject = new this.rx.AsyncSubject();
	        var waitCount = (f.husbandId > 0 ? 1 : 0) + (f.husbandId > 0 && f.wifeId > 0 ? 1 : 0) + (f.wifeId > 0 ? 1 : 0) + f.childRels.size + 1;
	        f = Object.assign({}, f, {
	            '_preferred': f.id === prefId ? 1 : 0,
	            '_husband': null,
	            '_wife': null,
	            '_children': new Map(),
	            '_marriage': null,
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        if (f.husbandId > 0) {
	            persons.streamId(f.husbandId).take(1).subscribe(function (h) {
	                persons.augmentPerson(h, leads, evidences).subscribe(function (h) {
	                    f._husband = h;
	                    if (--waitCount === 0) {
	                        subject.next(f);
	                        subject.complete();
	                    }
	                });
	                if (f.wifeId > 0) {
	                    persons.streamId(f.wifeId).take(1).subscribe(function (w) {
	                        f._marriage = persons.getMarriage(h, w);
	                        if (--waitCount === 0) {
	                            subject.next(f);
	                            subject.complete();
	                        }
	                    });
	                }
	            });
	        }
	        if (f.wifeId > 0) {
	            persons.streamId(f.wifeId).take(1).subscribe(function (w) {
	                persons.augmentPerson(w, leads, evidences).subscribe(function (w) {
	                    f._wife = w;
	                    if (--waitCount === 0) {
	                        subject.next(f);
	                        subject.complete();
	                    }
	                });
	            });
	        }
	        Array.from(f.childRels.keys()).forEach(function (cid) {
	            persons.streamId(cid).take(1).subscribe(function (c) {
	                persons.augmentPerson(c, leads, evidences).subscribe(function (c) {
	                    f._children.set(cid, c);
	                    if (--waitCount === 0) {
	                        subject.next(f);
	                        subject.complete();
	                    }
	                });
	            });
	        });
	        // set created user and edited user
	        this.utils.addCreateEditUsers(f, users).subscribe(function () {
	            if (--waitCount === 0) {
	                subject.next(f);
	                subject.complete();
	            }
	        });
	        return subject;
	    };
	    FamiliesService.prototype.getPreferredFamily = function (fm, prefId) {
	        return fm.get(prefId) || this.utils.first(fm);
	    };
	    return FamiliesService;
	}());
	exports.FamiliesService = FamiliesService;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var familyUtils_service_1 = __webpack_require__(217);
	var FamilyUtilsService = /** @class */ (function (_super) {
	    __extends(FamilyUtilsService, _super);
	    FamilyUtilsService.$inject = ["$log", "rx", "families", "utils"];
	    function FamilyUtilsService($log, rx, families, utils) {
	        'ngInject';
	        return _super.call(this, $log, rx, families, utils) || this;
	    }
	    return FamilyUtilsService;
	}(familyUtils_service_1.FamilyUtilsService));
	exports.default = FamilyUtilsService;
	// class FamilyUtilsService {
	//   constructor ($log, rx, families, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.families = families;
	//     this.utils = utils;
	//   }
	//   removeFamilyMember(family, personId) {
	//     let f = this.utils.clone(family);
	//     if (f.childRels.has(personId)) {
	//       f.childRels.delete(personId);
	//     }
	//     if (f.husbandId === personId) {
	//       f.husbandId = 0;
	//     }
	//     if (f.wifeId === personId) {
	//       f.wifeId = 0;
	//     }
	//     // delete family if just one person left
	//     if (f.childRels.size + (f.husbandId > 0 ? 1 : 0) + (f.wifeId > 0 ? 1 : 0) <= 1) {
	//       this.$log.debug('familyUtils.removeFamilyMember delete', f.id);
	//       return this.families.del(f.id);
	//     }
	//     else {
	//       this.$log.debug('familyUtils.removeFamilyMember update', f);
	//       return this.families.update(f);
	//     }
	//   }
	//   moveChild(personId, sourceId, targetId) {
	//     return this.families.streamIds([sourceId, targetId]).take(1).flatMap(fm => {
	//       let sf = this.utils.clone(fm.get(sourceId));
	//       let tf = this.utils.clone(fm.get(targetId));
	//       let parentRels = sf.childRels.get(personId);
	//       if (!!parentRels) {
	//         sf.childRels.delete(personId);
	//         tf.childRels.set(personId, parentRels);
	//         return this.families.update(tf).flatMap(() => {
	//           if (sf.childRels.size + (sf.husbandId > 0 ? 1 : 0) + (sf.wifeId > 0 ? 1 : 0) > 1) {
	//             this.$log.debug('familyUtils.moveChild update', personId, sf, tf);
	//             return this.families.update(sf);
	//           }
	//           else {
	//             this.$log.debug('familyUtils.moveChild delete', personId, sf, tf);
	//             return this.families.del(sourceId);
	//           }
	//         });
	//       }
	//       else {
	//         return this.rx.Observable.of(null);
	//       }
	//     });
	//   }
	// }
	// export default FamilyUtilsService;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var FamilyUtilsService = /** @class */ (function () {
	    function FamilyUtilsService(log, rx, families, utils) {
	        this.log = log;
	        this.rx = rx;
	        this.families = families;
	        this.utils = utils;
	    }
	    FamilyUtilsService.prototype.removeFamilyMember = function (family, personId) {
	        var f = this.utils.clone(family);
	        if (f.childRels.has(personId)) {
	            f.childRels.delete(personId);
	        }
	        if (f.husbandId === personId) {
	            f.husbandId = 0;
	        }
	        if (f.wifeId === personId) {
	            f.wifeId = 0;
	        }
	        // delete family if just one person left
	        if (f.childRels.size + (f.husbandId > 0 ? 1 : 0) + (f.wifeId > 0 ? 1 : 0) <= 1) {
	            this.log.debug('familyUtils.removeFamilyMember delete', f.id);
	            return this.families.del(f.id);
	        }
	        else {
	            this.log.debug('familyUtils.removeFamilyMember update', f);
	            return this.families.update(f);
	        }
	    };
	    FamilyUtilsService.prototype.moveChild = function (personId, sourceId, targetId) {
	        var _this = this;
	        return this.families.streamIds([sourceId, targetId]).take(1).flatMap(function (fm) {
	            var sf = _this.utils.clone(fm.get(sourceId));
	            var tf = _this.utils.clone(fm.get(targetId));
	            var parentRels = sf.childRels.get(personId);
	            if (!!parentRels) {
	                sf.childRels.delete(personId);
	                tf.childRels.set(personId, parentRels);
	                return _this.families.update(tf).flatMap(function () {
	                    if (sf.childRels.size + (sf.husbandId > 0 ? 1 : 0) + (sf.wifeId > 0 ? 1 : 0) > 1) {
	                        _this.log.debug('familyUtils.moveChild update', personId, sf, tf);
	                        return _this.families.update(sf);
	                    }
	                    else {
	                        _this.log.debug('familyUtils.moveChild delete', personId, sf, tf);
	                        return _this.families.del(sourceId);
	                    }
	                });
	            }
	            else {
	                return _this.rx.Observable.of(null);
	            }
	        });
	    };
	    return FamilyUtilsService;
	}());
	exports.FamilyUtilsService = FamilyUtilsService;
	exports.default = FamilyUtilsService;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var feed_service_1 = __webpack_require__(219);
	var FeedService = /** @class */ (function (_super) {
	    __extends(FeedService, _super);
	    FeedService.$inject = ["$log", "evidences", "leads", "medias", "notes", "persons", "sources", "stories", "treeGraphics", "users", "utils"];
	    function FeedService($log, evidences, leads, medias, notes, persons, sources, stories, treeGraphics, users, utils) {
	        'ngInject';
	        return _super.call(this, evidences, leads, medias, notes, persons, sources, stories, treeGraphics, users, utils) || this;
	    }
	    return FeedService;
	}(feed_service_1.FeedService));
	exports.default = FeedService;
	// class FeedService {
	//   constructor ($log, evidences, leads, medias, notes, persons, sources, stories, treeGraphics, users, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.evidencesService = evidences;
	//     this.leadsService = leads;
	//     this.mediasService = medias;
	//     this.notesService = notes;
	//     this.personsService = persons;
	//     this.sourcesService = sources;
	//     this.storiesService = stories;
	//     this.treeGraphicsService = treeGraphics;
	//     this.usersService = users;
	//     this.utils = utils;
	//   }
	//   streamFullFeed(expandedMap, userId) {
	//     // load some requests first
	//     return this.utils.readyChange(this.personsService, this.sourcesService, this.storiesService).flatMap(() => {
	//       return this.utils.readyChange(this.evidencesService, this.mediasService, this.notesService,
	//         this.storiesService, this.personsService, this.leadsService, this.treeGraphicsService, this.sourcesService, this.usersService)
	//         .map(([evidences, medias, notes, stories, persons, leads, treeGraphics]) => {
	//           let fullFeed = [];
	//           // load evidences
	//           for (let e of evidences.values()) {
	//             if (e._hasSource && (!userId || e.createdUser === userId)) {
	//               fullFeed.push({type: 'EVIDENCE', item: e});
	//               if ((!!userId || e.mediaIds.size > 0) && !expandedMap.has(e.id)) {
	//                 expandedMap.set(e.id, true);
	//               }
	//             }
	//           }
	//           // load leads
	//           for (let l of leads.values()) {
	//             if (!l.hidden && !!l.createdUser && (!userId || l.createdUser === userId)) {
	//               fullFeed.push({type: 'LEAD', item: l});
	//               if (!!userId && !expandedMap.has(l.id)) {
	//                 expandedMap.set(l.id, true);
	//               }
	//             }
	//           }
	//           // load media
	//           for (let m of medias.values()) {
	//             if (!userId || m.createdUser === userId) {
	//               fullFeed.push({type: 'MEDIA', item: m});
	//               if (!expandedMap.has(m.id)) {
	//                 expandedMap.set(m.id, true);
	//               }
	//             }
	//           }
	//           // load notes
	//           for (let n of notes.values()) {
	//             if (!userId || n.createdUser === userId) {
	//               fullFeed.push({type: 'NOTE', item: n});
	//               if (!!userId && !expandedMap.has(n.id)) {
	//                 expandedMap.set(n.id, true);
	//               }
	//             }
	//           }
	//           // load stories
	//           for (let s of stories.values()) {
	//             if (!userId || s.createdUser === userId) {
	//               fullFeed.push({type: 'STORY', item: s});
	//               if (!expandedMap.has(s.id)) {
	//                 expandedMap.set(s.id, true);
	//               }
	//             }
	//           }
	//           // load people
	//           for (let p of persons.values()) {
	//             if (!userId || p.createdUser === userId) {
	//               fullFeed.push({type: 'PERSON', item: p});
	//               if (!!userId && !expandedMap.has(p.id)) {
	//                 expandedMap.set(p.id, true);
	//               }
	//             }
	//           }
	//           // load treeGraphics
	//           for (let tg of treeGraphics.values()) {
	//             if (!userId) {
	//               fullFeed.push({type: 'GRAPHIC', item: tg});
	//               if (!expandedMap.has(tg.id)) {
	//                 expandedMap.set(tg.id, true);
	//               }
	//             }
	//           }
	//           // sort
	//           fullFeed.sort((a,b) => {
	//             let aDate = a.item.editedDate || a.item.createdDate;
	//             let bDate = b.item.editedDate || b.item.createdDate;
	//             if (bDate === aDate) {
	//               // sort media later
	//               if (a.type === 'MEDIA') {
	//                 return 1;
	//               }
	//               if (b.type === 'MEDIA') {
	//                 return -1;
	//               }
	//               return b.item.id - a.item.id;
	//             }
	//             return bDate - aDate;
	//           });
	//           return fullFeed;
	//         });
	//     });
	//   }
	//   getFeed(fullFeed, cnt) {
	//     let feed = fullFeed.slice(0, Math.min(fullFeed.length, cnt));
	//     feed.forEach(item => {
	//       if (!item.augmented) {
	//         switch (item.type) {
	//           case 'EVIDENCE':
	//             this.evidencesService.augmentEvidence(item.item, this.sourcesService, this.personsService, this.usersService).subscribe(e => {
	//               item.item = e;
	//               item.augmented = true;
	//             });
	//             break;
	//           case 'LEAD':
	//             this.leadsService.augmentLead(item.item, this.personsService, this.usersService).subscribe(l => {
	//               item.item = l;
	//               item.augmented = true;
	//             });
	//             break;
	//           case 'MEDIA':
	//             this.mediasService.augmentMedia(item.item, this.personsService, this.evidencesService, this.sourcesService, this.storiesService, this.usersService).subscribe(m => {
	//               // ignore media that are referenced in earlier feed items
	//               if (!this.hasEarlierMediaRef(feed, m)) {
	//                 item.item = m;
	//                 item.augmented = true;
	//               }
	//             });
	//             break;
	//           case 'NOTE':
	//             this.notesService.augmentNote(item.item, this.personsService, this.usersService).subscribe(n => {
	//               item.item = n;
	//               item.augmented = true;
	//             });
	//             break;
	//           case 'STORY':
	//             this.storiesService.augmentStory(item.item, this.personsService, this.usersService).subscribe(s => {
	//               item.item = s;
	//               item.augmented = true;
	//             });
	//             break;
	//           case 'PERSON':
	//             this.personsService.augmentPerson(item.item, this.leadsService, this.evidencesService, this.usersService).subscribe(p => {
	//               item.item = p;
	//               item.augmented = true;
	//             });
	//             break;
	//           case 'GRAPHIC':
	//             item.augmented = true;
	//             break;
	//         }
	//       }
	//     });
	//     return feed;
	//   }
	//   hasEarlierMediaRef(feed, m) {
	//     let ix = feed.findIndex(item => item.item.id === m.id);
	//     for (let id of m._evidences.keys()) {
	//       for (let i = 0; i < ix; i++) {
	//         if (feed[i].item.id === id) {
	//           return true;
	//         }
	//       }
	//     }
	//     for (let id of m._stories.keys()) {
	//       for (let i = 0; i < ix; i++) {
	//         if (feed[i].item.id === id) {
	//           return true;
	//         }
	//       }
	//     }
	//     return false;
	//   }
	// }
	// export default FeedService;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Observable } from "../../node_modules/rxjs";
	var FeedService = /** @class */ (function () {
	    function FeedService(evidencesService, leadsService, mediasService, notesService, personsService, sourcesService, storiesService, treeGraphicsService, usersService, utils) {
	        this.evidencesService = evidencesService;
	        this.leadsService = leadsService;
	        this.mediasService = mediasService;
	        this.notesService = notesService;
	        this.personsService = personsService;
	        this.sourcesService = sourcesService;
	        this.storiesService = storiesService;
	        this.treeGraphicsService = treeGraphicsService;
	        this.usersService = usersService;
	        this.utils = utils;
	    }
	    FeedService.prototype.streamFullFeed = function (expandedMap, userId) {
	        var _this = this;
	        // load some requests first
	        return this.utils.readyChange(this.personsService, this.sourcesService, this.storiesService).flatMap(function () {
	            return _this.utils.readyChange(_this.evidencesService, _this.mediasService, _this.notesService, _this.storiesService, _this.personsService, _this.leadsService, _this.treeGraphicsService, _this.sourcesService, _this.usersService)
	                .map(function (_a) {
	                var _b = __read(_a, 7), evidences = _b[0], medias = _b[1], notes = _b[2], stories = _b[3], persons = _b[4], leads = _b[5], treeGraphics = _b[6];
	                var fullFeed = [];
	                try {
	                    // load evidences
	                    for (var _c = __values(evidences.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                        var e = _d.value;
	                        if (e._hasSource && (!userId || e.createdUser === userId)) {
	                            fullFeed.push({ type: 'EVIDENCE', item: e });
	                            if ((!!userId || e.mediaIds.size > 0) && !expandedMap.has(e.id)) {
	                                expandedMap.set(e.id, true);
	                            }
	                        }
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                try {
	                    // load leads
	                    for (var _f = __values(leads.values()), _g = _f.next(); !_g.done; _g = _f.next()) {
	                        var l = _g.value;
	                        if (l.state === 0 && (!userId || l.createdUser === userId)) {
	                            fullFeed.push({ type: 'LEAD', item: l });
	                            if (!!userId && !expandedMap.has(l.id)) {
	                                expandedMap.set(l.id, true);
	                            }
	                        }
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_g && !_g.done && (_h = _f.return)) _h.call(_f);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	                try {
	                    // load media
	                    for (var _j = __values(medias.values()), _k = _j.next(); !_k.done; _k = _j.next()) {
	                        var m = _k.value;
	                        if (!userId || m.createdUser === userId) {
	                            fullFeed.push({ type: 'MEDIA', item: m });
	                            if (!expandedMap.has(m.id)) {
	                                expandedMap.set(m.id, true);
	                            }
	                        }
	                    }
	                }
	                catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                finally {
	                    try {
	                        if (_k && !_k.done && (_l = _j.return)) _l.call(_j);
	                    }
	                    finally { if (e_3) throw e_3.error; }
	                }
	                try {
	                    // load notes
	                    for (var _m = __values(notes.values()), _o = _m.next(); !_o.done; _o = _m.next()) {
	                        var n = _o.value;
	                        if (!userId || n.createdUser === userId) {
	                            fullFeed.push({ type: 'NOTE', item: n });
	                            if (!!userId && !expandedMap.has(n.id)) {
	                                expandedMap.set(n.id, true);
	                            }
	                        }
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (_o && !_o.done && (_p = _m.return)) _p.call(_m);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	                try {
	                    // load stories
	                    for (var _q = __values(stories.values()), _r = _q.next(); !_r.done; _r = _q.next()) {
	                        var s = _r.value;
	                        if (!userId || s.createdUser === userId) {
	                            fullFeed.push({ type: 'STORY', item: s });
	                            if (!expandedMap.has(s.id)) {
	                                expandedMap.set(s.id, true);
	                            }
	                        }
	                    }
	                }
	                catch (e_5_1) { e_5 = { error: e_5_1 }; }
	                finally {
	                    try {
	                        if (_r && !_r.done && (_s = _q.return)) _s.call(_q);
	                    }
	                    finally { if (e_5) throw e_5.error; }
	                }
	                try {
	                    // load people
	                    for (var _t = __values(persons.values()), _u = _t.next(); !_u.done; _u = _t.next()) {
	                        var p = _u.value;
	                        if (!userId || p.createdUser === userId) {
	                            fullFeed.push({ type: 'PERSON', item: p });
	                            if (!!userId && !expandedMap.has(p.id)) {
	                                expandedMap.set(p.id, true);
	                            }
	                        }
	                    }
	                }
	                catch (e_6_1) { e_6 = { error: e_6_1 }; }
	                finally {
	                    try {
	                        if (_u && !_u.done && (_v = _t.return)) _v.call(_t);
	                    }
	                    finally { if (e_6) throw e_6.error; }
	                }
	                try {
	                    // load treeGraphics
	                    for (var _w = __values(treeGraphics.values()), _x = _w.next(); !_x.done; _x = _w.next()) {
	                        var tg = _x.value;
	                        if (!userId) {
	                            fullFeed.push({ type: 'GRAPHIC', item: tg });
	                            if (!expandedMap.has(tg.id)) {
	                                expandedMap.set(tg.id, true);
	                            }
	                        }
	                    }
	                }
	                catch (e_7_1) { e_7 = { error: e_7_1 }; }
	                finally {
	                    try {
	                        if (_x && !_x.done && (_y = _w.return)) _y.call(_w);
	                    }
	                    finally { if (e_7) throw e_7.error; }
	                }
	                // sort
	                fullFeed.sort(function (a, b) {
	                    var aDate = a.item.editedDate || a.item.createdDate;
	                    var bDate = b.item.editedDate || b.item.createdDate;
	                    if (bDate === aDate) {
	                        // sort media later
	                        if (a.type === 'MEDIA') {
	                            return 1;
	                        }
	                        if (b.type === 'MEDIA') {
	                            return -1;
	                        }
	                        return b.item.id - a.item.id;
	                    }
	                    return bDate - aDate;
	                });
	                return fullFeed;
	                var e_1, _e, e_2, _h, e_3, _l, e_4, _p, e_5, _s, e_6, _v, e_7, _y;
	            });
	        });
	    };
	    FeedService.prototype.getFeed = function (fullFeed, cnt) {
	        var _this = this;
	        var feed = fullFeed.slice(0, Math.min(fullFeed.length, cnt));
	        feed.forEach(function (item) {
	            if (!item.augmented) {
	                switch (item.type) {
	                    case 'EVIDENCE':
	                        _this.evidencesService.augmentEvidence(item.item, _this.sourcesService, _this.personsService, _this.usersService).subscribe(function (e) {
	                            item.item = e;
	                            item.augmented = true;
	                        });
	                        break;
	                    case 'LEAD':
	                        _this.leadsService.augmentLead(item.item, _this.personsService, _this.usersService).subscribe(function (l) {
	                            item.item = l;
	                            item.augmented = true;
	                        });
	                        break;
	                    case 'MEDIA':
	                        _this.mediasService.augmentMedia(item.item, _this.personsService, _this.evidencesService, _this.sourcesService, _this.storiesService, _this.usersService).subscribe(function (m) {
	                            // ignore media that are referenced in earlier feed items
	                            if (!_this.hasEarlierMediaRef(feed, m)) {
	                                item.item = m;
	                                item.augmented = true;
	                            }
	                        });
	                        break;
	                    case 'NOTE':
	                        _this.notesService.augmentNote(item.item, _this.personsService, _this.usersService).subscribe(function (n) {
	                            item.item = n;
	                            item.augmented = true;
	                        });
	                        break;
	                    case 'STORY':
	                        _this.storiesService.augmentStory(item.item, _this.personsService, _this.usersService).subscribe(function (s) {
	                            item.item = s;
	                            item.augmented = true;
	                        });
	                        break;
	                    case 'PERSON':
	                        _this.personsService.augmentPerson(item.item, _this.leadsService, _this.evidencesService, _this.usersService).subscribe(function (p) {
	                            item.item = p;
	                            item.augmented = true;
	                        });
	                        break;
	                    case 'GRAPHIC':
	                        item.augmented = true;
	                        break;
	                }
	            }
	        });
	        return feed;
	    };
	    FeedService.prototype.hasEarlierMediaRef = function (feed, m) {
	        var ix = feed.findIndex(function (item) { return item.item.id === m.id; });
	        try {
	            for (var _a = __values(m._evidences.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var id = _b.value;
	                for (var i = 0; i < ix; i++) {
	                    if (feed[i].item.id === id) {
	                        return true;
	                    }
	                }
	            }
	        }
	        catch (e_8_1) { e_8 = { error: e_8_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_8) throw e_8.error; }
	        }
	        try {
	            for (var _d = __values(m._stories.keys()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                var id = _e.value;
	                for (var i = 0; i < ix; i++) {
	                    if (feed[i].item.id === id) {
	                        return true;
	                    }
	                }
	            }
	        }
	        catch (e_9_1) { e_9 = { error: e_9_1 }; }
	        finally {
	            try {
	                if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
	            }
	            finally { if (e_9) throw e_9.error; }
	        }
	        return false;
	        var e_8, _c, e_9, _f;
	    };
	    return FeedService;
	}());
	exports.FeedService = FeedService;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential - 2016-2017
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// import { FSService as _FSService } from '@shared/components/fs/fs.service';
	// class FSService extends _FSService {
	//   constructor($log, $cookies, $window, $interval, $timeout, $http, $rootScope, rx, utils, messageBus, persons, evidences, server, fsEnvironment, fsAppKey, fsRedirectUri) {
	//     'ngInject';
	//     super($log, $cookies, $window, $interval, $timeout, $http, $rootScope, rx, utils, messageBus, persons, evidences, server, fsEnvironment, fsAppKey, fsRedirectUri, angular as any);
	//   }
	// }
	// export default FSService;
	var fsTypes_1 = __webpack_require__(221);
	var FSService = /** @class */ (function () {
	    FSService.$inject = ["$log", "$cookies", "$window", "$interval", "$timeout", "$http", "$rootScope", "rx", "utils", "messageBus", "persons", "evidences", "server", "fsEnvironment", "fsAppKey", "fsRedirectUri"];
	    function FSService($log, $cookies, $window, $interval, $timeout, $http, $rootScope, rx, utils, messageBus, persons, evidences, server, fsEnvironment, fsAppKey, fsRedirectUri) {
	        'ngInject';
	        var _this = this;
	        this.$log = $log;
	        this.$cookies = $cookies;
	        this.$window = $window;
	        this.$interval = $interval;
	        this.$timeout = $timeout;
	        this.$http = $http;
	        this.$rootScope = $rootScope;
	        this.rx = rx;
	        this.utils = utils;
	        this.persons = persons;
	        this.evidences = evidences;
	        this.messageBus = messageBus;
	        this.server = server;
	        this.fsAppKey = fsAppKey;
	        this.$rootScope.fsTokenRejected = false;
	        this.externalIdKey = 'familysearch.org';
	        this.authenticating = null;
	        this.exts = new Map([['image/jpeg', 'jpg'], ['image/png', 'png'], ['image/tiff', 'tiff'], ['image/bmp', 'bmp'], ['image/gif', 'gif'], ['video/mp4', 'mp4'], ['application/pdf', 'pdf']]);
	        this.marriageEventTypes = ['ANUL', '_SEPR', '_CIVL', 'ENG', 'DIV', 'DIVF', 'CLAW', 'RELI', 'MARR', 'MARB', '_MBON', 'MARC', 'MARL', 'MARS'];
	        // Setup the cache
	        this.fsCache = {};
	        this.clearCache();
	        // clear the cache every 15 minutes
	        $interval(function () {
	            _this.clearCache();
	        }, 1000 * 60 * 15);
	        this.fs = new $window.FamilySearch({
	            environment: fsEnvironment,
	            appKey: fsAppKey,
	            redirectUri: encodeURIComponent(fsRedirectUri),
	            saveAccessToken: true
	        });
	        // On 401, reauthenticate then reissue the request
	        this.fs.addResponseMiddleware(function (client, request, response, next) {
	            // outside angular
	            if (!!response && response.statusCode === 401 &&
	                !_this.$rootScope.fsTokenRejected &&
	                !(_this.accessTokenCheck && request.url.includes('/platform/users/current'))) {
	                _this.askForToken().subscribe(function (token) {
	                    request.headers.Authorization = "Bearer " + token;
	                    client._execute(request, function (error, response) {
	                        request.callback(error, response);
	                    });
	                }, function () {
	                    next('FS_CANCEL');
	                    _this.deleteAccessToken();
	                });
	            }
	            else {
	                next();
	            }
	        });
	        // verify access token
	        this.accessTokenCheck = false;
	        this.verifyAccessToken();
	        // verify access token every 10 minutes
	        $interval(function () {
	            _this.verifyAccessToken();
	        }, 1000 * 60 * 10);
	    }
	    FSService.prototype.toFSfilename = function (filename) {
	        return filename.replace(/[^a-zA-Z0-9_.\s]+/g, '').replace(/\s+/g, "_");
	    };
	    FSService.prototype.toRFfilename = function (filename) {
	        return filename.replace(/_/g, " ");
	    };
	    FSService.prototype.verifyAccessToken = function () {
	        var _this = this;
	        if (this.isLoggedIn()) {
	            this.accessTokenCheck = true;
	            this.fsRxGetData('/platform/users/current').subscribe(function () {
	                _this.accessTokenCheck = false;
	                // access token is still good
	                _this.$rootScope.fsTokenRejected = false;
	            }, function () {
	                _this.accessTokenCheck = false;
	                _this.deleteAccessToken();
	            });
	        }
	    };
	    // dialog avoids popup blocking
	    FSService.prototype.askForToken = function () {
	        var _this = this;
	        // stream avoids popping up the dialog multiple times
	        if (!!this.askForTokenStream) {
	            return this.askForTokenStream;
	        }
	        this.askForTokenStream = new this.rx.AsyncSubject();
	        // move inside angular
	        this.$timeout(function () {
	            _this.utils.dialog(null, 'FsLoginController', 'app/components/fsLogin/fsLogin.html', true, {
	                text: 'Your FamilySearch session has expired.'
	            }).then(function (token) {
	                if (!token) {
	                    _this.$rootScope.fsTokenRejected = true;
	                    _this.askForTokenStream.error(null);
	                }
	                else {
	                    _this.askForTokenStream.next(token);
	                    _this.askForTokenStream.complete();
	                }
	                _this.askForTokenStream = null;
	            }, function (err) {
	                _this.askForTokenStream.error(err);
	                _this.askForTokenStream = null;
	            });
	        });
	        return this.askForTokenStream;
	    };
	    /**
	     * Initiate authentication and get an access token.
	     *
	     * @return {AsyncSubject} AsyncSubject that emits the access token.
	     */
	    FSService.prototype.streamAccessToken = function () {
	        var _this = this;
	        var waitMillis = 50;
	        var maxTries = 100;
	        var subject = new this.rx.AsyncSubject();
	        var cnt = 0;
	        // If authentication is in progress then return the authenticating subject
	        if (this.authenticating) {
	            return this.authenticating;
	        }
	        // return the access token if we're already authenticated
	        if (this.fs.getAccessToken()) {
	            subject.next(this.fs.getAccessToken());
	            subject.complete();
	        }
	        else {
	            // clear the request cache
	            this.clearCache();
	            // cache the subject so that any concurrent auth requests share the same request and resolution
	            this.authenticating = subject;
	            // open new window
	            var w_1 = this.$window.open(this.fs.oauthRedirectURL() + '&cid=' + this.fsAppKey + '-RootsFinder', '_blank', 'height=580,width=420');
	            // wait for redirect
	            var sub_1 = this.$interval(function () {
	                try {
	                    if (w_1.closed !== false) {
	                        _this.$interval.cancel(sub_1);
	                        subject.error('Cancelled');
	                        _this.authenticating = null;
	                    }
	                    // grab auth code
	                    var href = w_1.location.href;
	                    var code = decodeURIComponent((new RegExp('[?|&]code=([^&;]+?)(&|#|;|$)').exec(href) || [null, ''])[1].replace(/\+/g, '%20')) || null;
	                    if (!!code) {
	                        // request access token
	                        _this.fs.oauthToken(code, function (err, response) {
	                            if (!!err) {
	                                subject.error(err);
	                            }
	                            else {
	                                _this.$rootScope.fsTokenRejected = false;
	                                subject.next(response.data.access_token);
	                                subject.complete();
	                            }
	                            _this.authenticating = null;
	                        });
	                        // cancel timer and close window
	                        _this.$interval.cancel(sub_1);
	                        w_1.close();
	                        _this.authenticating = null;
	                    }
	                    else {
	                        cnt++;
	                        if (cnt > maxTries) {
	                            _this.$interval.cancel(sub_1);
	                            subject.error('Cancelled');
	                            _this.authenticating = null;
	                        }
	                    }
	                }
	                catch (e) {
	                    // ignore
	                }
	            }, waitMillis);
	        }
	        return subject;
	    };
	    /**
	     * Check whether the user is currently authenticated with FS.
	     * This doesn't gaurantee authentication, it just checks to see if an
	     * access token is currently set.
	     *
	     * @return {Boolean}
	     */
	    FSService.prototype.isLoggedIn = function () {
	        return !!this.fs.getAccessToken();
	    };
	    /**
	     * Return the access token.
	     *
	     * @return {String}
	     */
	    FSService.prototype.getAccessToken = function () {
	        return this.fs.getAccessToken();
	    };
	    /**
	     * Delete the access token.
	     *
	     */
	    FSService.prototype.deleteAccessToken = function () {
	        this.fs.deleteAccessToken();
	    };
	    /**
	     * Clear all caches
	     */
	    FSService.prototype.clearCache = function () {
	        this.fsCache = {
	            user: null,
	            isLDS: null,
	            persons: new Map(),
	            sources: new Map(),
	            memories: new Map(),
	            ordinances: new Map(),
	            ordinancesStatus: new Map(),
	            notes: new Map(),
	            users: new Map(),
	            families: new Map(),
	            personPortraits: new Map(),
	            personPrefParents: new Map(),
	            hints: new Map()
	        };
	    };
	    /**
	     * Uncache person
	     * @param pid FS person id
	     */
	    FSService.prototype.uncachePerson = function (pid) {
	        if (!!pid) {
	            this.fsCache.persons.delete(this.getPersonCacheKey(pid, true));
	            this.fsCache.persons.delete(this.getPersonCacheKey(pid, false));
	        }
	    };
	    /**
	     * Return a URL; return empty string if user hasn't ack'd yet
	     *
	     * @param {String} ark ARK
	     * @param {String} ctx context
	     * @return {String} URL
	     */
	    FSService.prototype.getHref = function (ark, ctx) {
	        var ack = this.$cookies.get('fsLinkAck');
	        if (!!ack) {
	            return ark + '?context=' + ctx;
	        }
	        return '';
	    };
	    /**
	     * If the user hasn't ack'd yet, throw the URL into an Ack dialog
	     *
	     * @param {String} ark ARK
	     * @param {String} ctx context
	     */
	    FSService.prototype.clickHref = function (ark, ctx) {
	        var _this = this;
	        var ack = this.$cookies.get('fsLinkAck');
	        if (!ack) {
	            this.utils.dialog(null, 'FsLinkController', 'app/components/fsLink/fsLink.html', true, {
	                url: ark + '?context=' + ctx
	            }).then(function () {
	                _this.$cookies.put('fsLinkAck', 'true', { path: '/' });
	            }, function () {
	                // ignore
	            });
	        }
	    };
	    /**
	     * Convert RF person to FS person
	     *
	     * @param {Object} p RF person
	     * @return {Object} FS person
	     */
	    FSService.prototype.toFSPerson = function (p) {
	        var _this = this;
	        var person = {
	            names: [],
	            facts: [],
	            living: p.living === 'TRUE'
	        };
	        if (p.externalIds && p.externalIds.has(this.externalIdKey)) {
	            person.id = p.externalIds.get(this.externalIdKey).id;
	        }
	        switch (p.gender) {
	            case 'MALE':
	                person.gender = { type: 'http://gedcomx.org/Male' };
	                break;
	            case 'FEMALE':
	                person.gender = { type: 'http://gedcomx.org/Female' };
	                break;
	        }
	        if (p.names) {
	            var prefName_1 = this.persons.getPreferredName(p);
	            p.names.forEach(function (rfName, key) {
	                var fsName = _this.toFSName(rfName);
	                if (prefName_1 === rfName) {
	                    fsName.preferred = true;
	                }
	                person.names.push(fsName);
	            });
	        }
	        if (p.facts) {
	            var prefBirth_1 = this.persons.getPreferredBirth(p);
	            var prefDeath_1 = this.persons.getPreferredDeath(p);
	            p.facts.forEach(function (rfFact, key) {
	                var fsFact = _this.toFSFact(rfFact);
	                // FS persons can't have couple facts
	                if (_this.marriageEventTypes.includes(rfFact.type)) {
	                    return;
	                }
	                // FS persons only have one birth or death so we only include
	                // the preferred birth and death
	                if (rfFact.type === 'BIRT' && rfFact !== prefBirth_1) {
	                    return;
	                }
	                if (rfFact.type === 'DEAT' && rfFact !== prefDeath_1) {
	                    return;
	                }
	                // FS persons can't have duplicate facts
	                if (person.facts.some(function (f) { return _this.isEquivalentFSFact(f, fsFact); })) {
	                    return;
	                }
	                person.facts.push(fsFact);
	            });
	        }
	        return person;
	    };
	    /**
	     * Return true if two FS facts are equivalent (same type, date, and place)
	     *
	     * @param {Object} p FS person
	     */
	    FSService.prototype.isEquivalentFSFact = function (f1, f2) {
	        if (!!f1.id && !!f2.id && f1.id === f2.id) {
	            return true;
	        }
	        if (f1.type !== f2.type) {
	            return false;
	        }
	        if ((!!f1.date && !!f2.date && f1.date.original !== f2.date.original) || (!!f1.date && !f2.date) || (!f1.date && !!f2.date)) {
	            return false;
	        }
	        if ((!!f1.place && !!f2.place && f1.place.original !== f2.place.original) || (!!f1.place && !f2.place) || (!f1.place && !!f2.place)) {
	            return false;
	        }
	        return true;
	    };
	    /**
	     * Convert FS person to RF person.
	     *
	     * @param {Object} p FS person
	     */
	    FSService.prototype.toRFPerson = function (p) {
	        var _this = this;
	        var person = {
	            id: 0,
	            _url: p.identifiers && p.identifiers['http://gedcomx.org/Persistent'] ? p.identifiers['http://gedcomx.org/Persistent'][0] : undefined,
	            externalIds: new Map([[this.externalIdKey, {
	                        id: p.id,
	                        extVersion: p._version ? p._version.toString() : undefined
	                    }]]),
	            living: p.living ? 'TRUE' : 'FALSE',
	            profilePhoto: p.profilePhotoUrl,
	            preferredNameKey: 0,
	            preferredBirthKey: 0,
	            preferredDeathKey: 0,
	            preferredParentsFamilyId: p.preferredParentsFamilyId,
	            names: new Map(),
	            facts: new Map(),
	            _eol: p._eol,
	            _dl: p._dl
	        };
	        if (p.gender && p.gender.type) {
	            if (p.gender.type === 'http://gedcomx.org/Male') {
	                person.gender = 'MALE';
	            }
	            else if (p.gender.type === 'http://gedcomx.org/Female') {
	                person.gender = 'FEMALE';
	            }
	            // add a gender fact
	            person.facts.set(this.utils.randomKey(), {
	                type: 'SEX',
	                principal: true,
	                value: person.gender,
	                externalIds: new Map([[this.externalIdKey, { id: p.gender.id }]]),
	                evidencePersonas: new Map()
	            });
	        }
	        if (p.names) {
	            p.names.forEach(function (fsName) {
	                var rfName = _this.toRFName(fsName), key = _this.utils.randomKey();
	                person.names.set(key, rfName);
	                if (fsName.preferred) {
	                    person.preferredNameKey = key;
	                }
	            });
	        }
	        if (p.facts) {
	            p.facts.forEach(function (fsFact) {
	                var rfFact = _this.toRFFact(fsFact), key = _this.utils.randomKey();
	                person.facts.set(key, rfFact);
	                // Birth and death facts in FS can't have alternates so we can
	                // assume that we'll only see one.
	                switch (fsFact.type) {
	                    case 'http://gedcomx.org/Birth':
	                        person.preferredBirthKey = key;
	                        break;
	                    case 'http://gedcomx.org/Death':
	                        person.preferredDeathKey = key;
	                        break;
	                }
	            });
	        }
	        // Add marriage facts from FS couple rels
	        if (p.coupleRels) {
	            p.coupleRels.forEach(function (coupleRel) {
	                if (coupleRel && coupleRel.facts) {
	                    var spouseId_1 = coupleRel.person1.resourceId === p.id ? coupleRel.person2.resourceId : coupleRel.person1.resourceId;
	                    coupleRel.facts.forEach(function (fsFact) {
	                        var rfFact = _this.toRFFact(fsFact, coupleRel.id);
	                        rfFact.principalId1 = spouseId_1;
	                        person.facts.set(_this.utils.randomKey(), rfFact);
	                    });
	                }
	            });
	        }
	        return person;
	    };
	    /**
	     * Convert an RF name to an FS name
	     *
	     * @param {Object} n RF name
	     * @return {Object} FS name
	     */
	    FSService.prototype.toFSName = function (n) {
	        var _this = this;
	        var name = {
	            type: fsTypes_1.RFNameTypes[n.type],
	            nameForms: []
	        };
	        if (n.externalIds && n.externalIds.has(this.externalIdKey)) {
	            name.id = n.externalIds.get(this.externalIdKey).id;
	        }
	        n.nameForms.forEach(function (f, lang) {
	            var form = {
	                parts: []
	            };
	            if (lang !== 'default') {
	                form.langh = f.lang;
	            }
	            ['prefix', 'given', 'surname', 'suffix'].forEach(function (partType) {
	                if (f[partType]) {
	                    form.parts.push({
	                        type: 'http://gedcomx.org/' + _this.utils.capitalizeFirstLetter(partType),
	                        value: f[partType]
	                    });
	                }
	            });
	            form.fullText = form.parts.map(function (p) { return p.value; }).join(' ');
	            name.nameForms.push(form);
	        });
	        return name;
	    };
	    /**
	     * Convert an FS name to an RF name
	     *
	     * @param {Object} n FS name
	     * @return {Object} RF name
	     */
	    FSService.prototype.toRFName = function (n) {
	        var name = {
	            externalIds: new Map([[this.externalIdKey, {
	                        id: n.id
	                    }]]),
	            nameForms: new Map(n.nameForms.map(function (form) {
	                return [form.lang || 'default', {
	                        prefix: form.parts.filter(function (p) { return p.type === 'http://gedcomx.org/Prefix'; }).map(function (p) { return p.value; })[0],
	                        given: form.parts.filter(function (p) { return p.type === 'http://gedcomx.org/Given'; }).map(function (p) { return p.value; })[0],
	                        surname: form.parts.filter(function (p) { return p.type === 'http://gedcomx.org/Surname'; }).map(function (p) { return p.value; })[0],
	                        suffix: form.parts.filter(function (p) { return p.type === 'http://gedcomx.org/Suffix'; }).map(function (p) { return p.value; })[0]
	                    }];
	            })),
	            type: fsTypes_1.FSNameTypes[n.type],
	            evidencePersonas: new Map()
	        };
	        this.setFSAttribution(name, n);
	        return name;
	    };
	    /**
	     * Convert an RF fact to an FS fact
	     *
	     * @param {Object} f RF fact
	     * @return {Object} FS fact
	     */
	    FSService.prototype.toFSFact = function (f) {
	        var fact = {
	            id: f.externalIds && f.externalIds.has(this.externalIdKey) ? f.externalIds.get(this.externalIdKey).id : undefined,
	            type: fsTypes_1.RFFactTypes[f.type],
	            date: f.date ? { original: f.date } : undefined,
	            place: f.place ? { original: f.place } : undefined,
	            value: f.value ? f.value : undefined
	        };
	        if (!fact.type) {
	            var readableType = this.utils.factTypes.find(function (t) { return t.value === f.type; });
	            fact.type = 'data:,' + encodeURIComponent(readableType ? readableType.display : f.type);
	        }
	        return fact;
	    };
	    /**
	     * Convert an FS fact to an RF fact
	     *
	     * @param {Object} f FS fact
	     * @param {String} coupleRelId
	     * @return {Object} RF fact
	     */
	    FSService.prototype.toRFFact = function (f, coupleRelId) {
	        var fact = {
	            externalIds: new Map([[this.externalIdKey, {
	                        id: (!!coupleRelId ? coupleRelId + ':' : '') + f.id // couple fact ids are only unique within the couple id; we want them to be unique within the person so prepend coupleRelId
	                    }]]),
	            type: this.toRFFactType(f.type),
	            principal: true,
	            value: f.value,
	            date: f.date ? this.toRFDate(f.date) : undefined,
	            _dateFormal: f.date ? f.date.formal : undefined,
	            place: f.place ? f.place.original : undefined,
	            evidencePersonas: new Map()
	        };
	        this.setFSAttribution(fact, f);
	        return fact;
	    };
	    FSService.prototype.toRFFactType = function (typ) {
	        if (!typ) {
	            return 'Unknown';
	        }
	        else if (!!fsTypes_1.FSFactTypes[typ]) {
	            typ = fsTypes_1.FSFactTypes[typ];
	        }
	        else if (typ.startsWith('data:,')) {
	            typ = typ.substring(6);
	            try {
	                typ = decodeURIComponent(typ);
	            }
	            catch (e) {
	                console.log('toRFFactType', e, typ);
	            }
	            typ = typ.replace(/\+/g, ' ');
	        }
	        return typ.trim() || 'Unknown';
	    };
	    FSService.prototype.toRFDate = function (date) {
	        // sometimes the original date is YYYYMMDD; in that case we want the normalized date if it exists
	        if (/^[0-9]{8}$/.test(date.original) && !!date.normalized && date.normalized.length > 0 && !!date.normalized[0].value) {
	            return date.normalized[0].value;
	        }
	        return date.original;
	    };
	    /**
	     * Convert RF family to FS couple.
	     *
	     * @param {Object} f RF family
	     * @param {Object} husband RF person
	     * @param {Object} wife RF person
	     * @return {Object} FS couple
	     */
	    FSService.prototype.toFSCoupleRel = function (f, husband, wife) {
	        var _this = this;
	        var couple = {
	            type: 'http://gedcomx.org/Couple',
	            person1: {},
	            person2: {},
	            facts: []
	        };
	        couple.person1.resource = couple.person1.resourceId = husband.externalIds.get(this.externalIdKey).id;
	        couple.person2.resource = couple.person2.resourceId = wife.externalIds.get(this.externalIdKey).id;
	        husband.facts.forEach(function (fact) {
	            if (_this.marriageEventTypes.indexOf(fact.type) !== false && fact.principaldId1 === wife.id) {
	                var fsFact = _this.toFSFact(fact);
	                // Ignore facts that don't have a type mapping
	                if (fsFact.type) {
	                    couple.facts.push(fsFact);
	                }
	            }
	        });
	        return couple;
	    };
	    /**
	     * Convert RF family to FS child and parents
	     *
	     * @param {Object} f RF family
	     * @param {Object} father RF person
	     * @param {Object} mother RF person
	     * @param {Object} child RF person
	     * @return {Object} FS child and parents relationship
	     */
	    FSService.prototype.toFSChildAndParentsRel = function (f, father, mother, child) {
	        var childId = child.externalIds.get(this.externalIdKey).id;
	        var childRel = f.childRels.get('childId');
	        var childAndParents = {
	            child: {
	                resource: childId,
	                resourceId: childId
	            }
	        };
	        if (father && father.externalIds.has(this.externalIdKey)) {
	            childAndParents.parent1 = { resource: father.externalIds.get(this.externalIdKey).id, resourceId: father.externalIds.get(this.externalIdKey).id };
	            if (childRel && childRel.fatherRel) {
	                childAndParents.parent1Facts = [
	                    {
	                        type: fsTypes_1.FSFactTypes[childRel.fatherRel]
	                    }
	                ];
	            }
	        }
	        if (mother && mother.externalIds.has(this.externalIdKey)) {
	            childAndParents.parent2 = { resource: mother.externalIds.get(this.externalIdKey).id, resourceId: mother.externalIds.get(this.externalIdKey).id };
	            if (childRel && childRel.motherRel) {
	                childAndParents.parent2Facts = [
	                    {
	                        type: fsTypes_1.FSFactTypes[childRel.motherRel]
	                    }
	                ];
	            }
	        }
	        return childAndParents;
	    };
	    /**
	     * Convert FS couple rel and array of child-and-parents relationships to RF family
	     *
	     * @param {Object} fsFamily FS family
	     * @return {Object} RF family
	     */
	    FSService.prototype.toRFFamily = function (fsFamily) {
	        var family = {
	            id: 0,
	            _coupleId: fsFamily.coupleRel ? fsFamily.coupleRel.id : undefined,
	            childRels: new Map()
	        };
	        // First we need to calculate the husband and wife IDs. If both a husband
	        // and wife exist then we could us the couple rel but if only one exists
	        // then we won't have a couple rel and would have to examine the first child
	        // rel.
	        if (fsFamily.childAndParentsRels.length > 0) {
	            var childRel = fsFamily.childAndParentsRels[0];
	            family.husbandId = childRel.parent1 ? childRel.parent1.resourceId : undefined;
	            family.wifeId = childRel.parent2 ? childRel.parent2.resourceId : undefined;
	        }
	        else {
	            family.husbandId = fsFamily.coupleRel.person1.resourceId;
	            family.wifeId = fsFamily.coupleRel.person2.resourceId;
	        }
	        // Setup child relationships
	        fsFamily.childAndParentsRels.forEach(function (rel) {
	            var childId = rel.child.resourceId;
	            family.childRels.set(childId, {
	                fatherRel: rel.parent1Facts ? fsTypes_1.FSFactTypes[rel.parent1Facts[0].type] : undefined,
	                motherRel: rel.parent2Facts ? fsTypes_1.FSFactTypes[rel.parent2Facts[0].type] : undefined,
	                _childAndParentsId: rel.id
	            });
	        });
	        return family;
	    };
	    /**
	     * Convert RF evidence to FS source
	     *
	     * @param {Object} e RF evidence
	     * @return {Object} FS source
	     */
	    FSService.prototype.toFSSource = function (e) {
	        var source = {
	            id: e.externalIds && e.externalIds.has(this.externalIdKey) ? e.externalIds.get(this.externalIdKey).id : undefined,
	            citations: [],
	            titles: [{
	                    value: e._sourceAbbr ? e._sourceAbbr : ''
	                }],
	            notes: []
	        };
	        if (e.text) {
	            source.notes.push({
	                text: this.utils.removeHtmlNicely(e.text)
	            });
	        }
	        if (e.citation && e.citation.url) {
	            source.about = e.citation.url;
	        }
	        if (e._citation) {
	            source.citations.push({
	                value: this.utils.removeHtmlNicely(e._citation)
	            });
	        }
	        return source;
	    };
	    /**
	     * Convert FS source to RF evidence
	     *
	     * @param {Object} s FS source
	     * @return {Object} RF evidence
	     */
	    FSService.prototype.toRFEvidence = function (s) {
	        var evidence = {
	            id: 0,
	            externalIds: new Map([[this.externalIdKey, {
	                        id: s.id
	                    }]]),
	            fact: {
	                type: 'SOUR'
	            },
	            _sourceAbbr: (s.titles && s.titles[0] && s.titles[0].value ? s.titles[0].value : '').trim(),
	            text: s.notes && s.notes[0] && s.notes[0].text ? this.utils.escape(s.notes[0].text, true) : undefined,
	            citation: {
	                url: s.about,
	                text: s.citations && s.citations[0] && s.citations[0].value ? this.utils.escape(s.citations[0].value, true) : 'From FamilySearch.org'
	            },
	            mediaIds: new Map(),
	            personas: new Map([[1, { names: new Map(), facts: new Map(), principal: true, relatedToKey: 0, relationshipType: '' }]])
	        };
	        this.setFSAttribution(evidence, s);
	        return evidence;
	    };
	    /**
	     * Convert FS hint to RF lead
	     *
	     * @param {Object} h FS hint
	     * @param {String} pid FS person ID
	     * @return {Object} RF lead
	     */
	    FSService.prototype.toRFLead = function (h, pid) {
	        return {
	            id: 0,
	            externalIds: new Map([[this.externalIdKey, {
	                        id: h.id
	                    }]]),
	            title: h.title,
	            url: h.id,
	            personIds: pid > 0 ? new Map([[pid, true]]) : new Map(),
	            createdUser: 0,
	            state: 0
	        };
	    };
	    /**
	     * Convert RF media to FS media
	     *
	     * @param {Object} m RF media
	     * @return FS media
	     */
	    FSService.prototype.toFSMedia = function (m) {
	        var fi = Array.from(m.fileInfos.values())[0];
	        var filename = fi.fileName;
	        var ext = this.exts.get(fi.contentType) || 'txt'; // FS appears to be very picky about filename extensions
	        if (!filename) {
	            filename = 'media';
	        }
	        if (!filename.endsWith('.' + ext)) {
	            filename += '.' + ext;
	        }
	        var memory = {
	            id: m.externalIds && m.externalIds.has(this.externalIdKey) ? m.externalIds.get(this.externalIdKey).id : undefined,
	            titles: [{
	                    value: m.title
	                }],
	            descriptions: [{
	                    value: this.utils.removeHtmlNicely(m.text)
	                }],
	            about: m._url,
	            _filename: this.toFSfilename(filename)
	        };
	        this.setFSCoverage(memory, m);
	        return memory;
	    };
	    /**
	     * Convert FS media to RF media
	     *
	     * @param {Object} m FS media
	     * @param {String} pid FS person ID
	     * @return {Object} RF media
	     */
	    FSService.prototype.toRFMedia = function (m, pid, personMap) {
	        // TODO MEMORIES console.log('fs.toRFMedia', m, pid, personMap);
	        var media = {
	            id: 0,
	            externalIds: new Map([[this.externalIdKey, {
	                        id: m.id
	                    }]]),
	            title: m.titles && m.titles[0] ? m.titles[0].value : '',
	            text: m.descriptions && m.descriptions[0] ? this.utils.escape(m.descriptions[0].value, true) : '',
	            _url: m.about,
	            _fileName: m.artifactMetadata && m.artifactMetadata[0] && m.artifactMetadata[0].filename ? this.toRFfilename(m.artifactMetadata[0].filename) : undefined,
	            fileInfos: new Map(),
	            personIds: pid > 0 ? new Map([[pid, true]]) : new Map()
	        };
	        this.setRFCoverage(media, m);
	        this.setFSAttribution(media, m);
	        return media;
	    };
	    /**
	     * Convert FS ordinance to RF ordinance.
	     *
	     * RF ordinance model:
	     * {type, status, date, templeCode, spouseId, fatherId, motherId}
	     *
	     * Ordinance type and status are not converted into an RF specific key but are intentionally left as is.
	     *
	     * @param {Object} o FS ordinance
	     * @return {Object} RF ordinance
	     */
	    FSService.prototype.toRFOrdinance = function (o) {
	        var ordinance = {
	            type: o.type,
	            status: o.status,
	            date: '',
	            templeCode: '',
	            spouseId: '',
	            fatherId: '',
	            motherId: ''
	        };
	        if (o.date) {
	            //ordinance.date = o.date.original;
	            //ordinance.dateSort = o.date.formal;
	            ordinance.date = o.date.formal;
	            if (ordinance.date.charAt(0) === '+') {
	                ordinance.date = ordinance.date.substr(1);
	            }
	        }
	        if (o.templeCode) {
	            ordinance.templeCode = o.templeCode;
	        }
	        if (o.spouse) {
	            ordinance.spouseId = o.spouse.resourceId;
	        }
	        if (o.father) {
	            ordinance.fatherId = o.father.resourceId;
	        }
	        if (o.mother) {
	            ordinance.motherId = o.mother.resourceId;
	        }
	        return ordinance;
	    };
	    /**
	     * Convert RF note to FS note
	     *
	     * @param {Object} n RF note
	     * @return {ObjecT} FS note
	     */
	    FSService.prototype.toFSNote = function (n) {
	        return {
	            id: n.externalIds && n.externalIds.has(this.externalIdKey) ? n.externalIds.get(this.externalIdKey).id : undefined,
	            subject: n.title,
	            text: this.utils.removeHtmlNicely(n.text)
	        };
	    };
	    /**
	     * Convert FS note to RF note
	     *
	     * @param {Object} n FS note
	     * @param {String} pid FS person ID
	     * @return {Object} RF note
	     */
	    FSService.prototype.toRFNote = function (n, pid) {
	        var note = {
	            id: 0,
	            externalIds: new Map([[this.externalIdKey, {
	                        id: n.id
	                    }]]),
	            title: n.subject,
	            text: this.utils.escape(n.text, true),
	            personIds: pid > 0 ? new Map([[pid, true]]) : new Map()
	        };
	        this.setFSAttribution(note, n);
	        return note;
	    };
	    /**
	     * Convert RF story to FS story
	     *
	     * @param {Object} s RF story
	     * @return {Object} FS story
	     */
	    FSService.prototype.toFSStory = function (s) {
	        var memory = {
	            id: s.externalIds && s.externalIds.has(this.externalIdKey) ? s.externalIds.get(this.externalIdKey).id : undefined,
	            titles: [{
	                    value: s.title
	                }],
	            descriptions: [{
	                    value: this.utils.removeHtmlNicely(s.text)
	                }]
	            // TODO stories have mediaIds, not fileInfos
	            // If the story has a mediaId, I could pass the corresponding media item as a second parameter if you want
	            // In saveStory, if the story has a media item associated with it, somehow we need to determine if the media item
	            // needs to be downloaded from RF and saved to FS, or if that has already happened.
	            // _filename: s.fileInfos.entries().next().fileName
	        };
	        this.setFSCoverage(memory, s);
	        return memory;
	    };
	    /**
	     * Convert FS story to RF story
	     *
	     * @param {Object} s FS story
	     * @param {Integer} pid FS person ID
	     * @return {Object} RF story
	     */
	    FSService.prototype.toRFStory = function (s, pid, personMap) {
	        // TODO MEMORIES console.log('fs.toRFStory', s, pid, personMap);
	        var media = {
	            id: 0,
	            externalIds: new Map([[this.externalIdKey, {
	                        id: s.id
	                    }]]),
	            _url: s.about,
	            title: s.titles && s.titles[0] ? s.titles[0].value : '',
	            text: s.descriptions && s.descriptions[0] ? this.utils.escape(s.descriptions[0].value, true) : '',
	            mediaIds: new Map(),
	            personIds: pid > 0 ? new Map([[pid, true]]) : new Map()
	        };
	        this.setRFCoverage(media, s);
	        this.setFSAttribution(media, s);
	        return media;
	    };
	    /**
	     * Set the coverage block on a FS memory from an RF media or story
	     *
	     * @param {Object} fs FS memory
	     * @param {Object} rf RF media or story
	     */
	    FSService.prototype.setFSCoverage = function (fs, rf) {
	        if (rf.date || rf.place) {
	            var coverage = {};
	            fs.coverage = [coverage];
	            if (rf.date) {
	                coverage.temporal = {
	                    original: rf.date,
	                    normalized: [{
	                            value: rf.date,
	                        }]
	                };
	            }
	            if (rf.place) {
	                coverage.spatial = {
	                    original: rf.place,
	                    normalized: [{
	                            value: rf.place
	                        }]
	                };
	            }
	        }
	    };
	    /**
	     * Set the coverage of an RF object based on the coverage of an FS object
	     *
	     * @param {Object} rf RF media or story
	     * @param {Object} fs FS memory
	     */
	    FSService.prototype.setRFCoverage = function (rf, fs) {
	        if (fs.coverage) {
	            var coverage = !!fs.coverage[0] ? fs.coverage[0] : fs.coverage;
	            // date
	            if (coverage.temporal) {
	                rf.date = !!coverage.temporal.normalized && coverage.temporal.normalized[0] && coverage.temporal.normalized[0].value ? coverage.temporal.normalized[0].value :
	                    coverage.temporal.original;
	            }
	            // place & placeStandard
	            //
	            // FYI, I set the place of a memory via the FS website. It didn't set an
	            // original value but it did set a pointer to the place description in
	            // their place authority. I would need to make an API request to get the
	            // name of that place
	            if (coverage.spatial) {
	                rf.place = !!coverage.spatial.normalized && coverage.spatial.normalized[0] && coverage.spatial.normalized[0].value ? coverage.spatial.normalized[0].value :
	                    coverage.spatial.original;
	            }
	        }
	    };
	    /**
	     * Set the attribution information on an RF object from an FS object.
	     *
	     * @param {Object} rf RF object
	     * @param {Object} fs FS object
	     */
	    FSService.prototype.setFSAttribution = function (rf, fs) {
	        if (fs.attribution) {
	            rf._reason = fs.attribution.changeMessage;
	            rf._contribDate = fs.attribution.modified;
	            rf._contribUser = fs.attribution.contributor.resourceId;
	        }
	    };
	    /**
	     * Create a new FS person.
	     *
	     * @param {Object} p FS person
	     * @param {String} reason Reason statement
	     * @return {AsyncSubject} Emits the person's ID
	     */
	    FSService.prototype.savePerson = function (p, reason) {
	        if (reason) {
	            if (p.gender) {
	                p.gender.attribution = {
	                    changeMessage: reason
	                };
	            }
	            if (p.names) {
	                p.names.forEach(function (name) {
	                    name.attribution = {
	                        changeMessage: reason
	                    };
	                });
	            }
	            if (p.facts) {
	                p.facts.forEach(function (fact) {
	                    fact.attribution = {
	                        changeMessage: reason
	                    };
	                });
	            }
	        }
	        if (p.facts) {
	            p.facts.forEach(function (fact) {
	            });
	        }
	        return this.fsRxPost('/platform/tree/persons', {
	            persons: [p]
	        }).map(function (response) {
	            return response.headers['x-entity-id'];
	        });
	    };
	    /**
	     * Save an FS person's name.
	     *
	     * @param {String} pid FS person ID
	     * @param {Object} name FS person name
	     * @param {String} reason Reason statement for the change
	     * @param {Boolean} preferred Whether the name is preferred. Defaults to false. Note that
	     * when saving a name marked as preferred, any ID will be ignored and the existing
	     * preferred name will always be overwritten. In other words, including an ID in the name
	     * and marking it as preferred _does not_ promote that name to being preferred.
	     * @return {AsyncSubject}
	     */
	    FSService.prototype.savePersonName = function (pid, name, reason, preferred) {
	        var _this = this;
	        if (preferred === void 0) { preferred = false; }
	        name.attribution = {
	            changeMessage: reason
	        };
	        if (preferred === true) {
	            name.preferred = true;
	        }
	        return this.fsRxPost("/platform/tree/persons/" + pid, {
	            persons: [{
	                    names: [name]
	                }]
	        }).do(function () {
	            _this.uncachePerson(pid);
	        }).map(function (response) {
	            return name.id || response.headers['location'].split('/').pop();
	        });
	    };
	    /**
	     * Save an FS person's fact.
	     *
	     * @param {String} pid FS person ID
	     * @param {Object} fact FS person fact
	     * @param {String} reason Reason statement for the change
	     * @return {AsyncSubject}
	     */
	    FSService.prototype.savePersonFact = function (pid, fact, reason) {
	        var _this = this;
	        fact.attribution = {
	            changeMessage: reason
	        };
	        return this.fsRxPost("/platform/tree/persons/" + pid, {
	            persons: [{
	                    facts: [fact]
	                }]
	        }).do(function () {
	            _this.uncachePerson(pid);
	        }).map(function (response) {
	            return fact.id || response.headers['location'].split('/').pop();
	        });
	    };
	    /**
	     * Create an FS couple relationship
	     *
	     * @param {Object} rel FS couple relationship
	     * @param {String} reason Reason statement
	     * @return {AsyncSubject} Emits the relationship ID
	     */
	    FSService.prototype.saveCoupleRel = function (rel, reason) {
	        var _this = this;
	        if (reason && rel.facts) {
	            rel.facts.forEach(function (fact) {
	                fact.attribution = {
	                    changeMessage: reason
	                };
	            });
	        }
	        return this.fsRxPost('/platform/tree/relationships', {
	            relationships: [rel]
	        }, { expect400: true }).map(function (response) {
	            if (!!rel.person1) {
	                _this.fsCache.families.delete(rel.person1.resourceId || rel.person1.resource);
	            }
	            if (!!rel.person2) {
	                _this.fsCache.families.delete(rel.person2.resourceId || rel.person2.resource);
	            }
	            return response.headers['x-entity-id'];
	        });
	    };
	    /**
	     * Save a fact for an FS couple relationship
	     *
	     * @param {String} id FS couple ID
	     * @param {Object} fact FS fact
	     * @param {Number} pid1 FS husband id
	     * @param {Number} pid2 FS wife id
	     * @param {String} reason Reason statement
	     * @return {AsyncSubject}
	     */
	    FSService.prototype.saveCoupleFact = function (id, fact, reason, pid1, pid2) {
	        var _this = this;
	        fact.attribution = {
	            changeMessage: reason
	        };
	        return this.fsRxPost("/platform/tree/couple-relationships/" + id, {
	            relationships: [{
	                    facts: [fact]
	                }]
	        }).map(function (response) {
	            _this.uncachePerson(pid1);
	            _this.uncachePerson(pid2);
	            return fact.id || response.headers['location'].split('/').pop();
	        });
	    };
	    /**
	     * Save an FS child and parents relationship
	     *
	     * @param {Object} rel FS child and parents relationship
	     * @param {String} reason Reason statement
	     * @return {AsyncSubject} Emits the relationship ID
	     */
	    FSService.prototype.saveChildAndParentsRel = function (rel, reason) {
	        var _this = this;
	        if (reason) {
	            if (rel.parent11Facts) {
	                rel.parent1Facts.forEach(function (fact) {
	                    fact.attribution = {
	                        changeMessage: reason
	                    };
	                });
	            }
	            if (rel.parent2Facts) {
	                rel.parent2Facts.forEach(function (fact) {
	                    fact.attribution = {
	                        changeMessage: reason
	                    };
	                });
	            }
	        }
	        var url = rel.id ? "/platform/tree/relationships/" + rel.id : '/platform/tree/relationships';
	        return this.fsRxPost(url, {
	            childAndParentsRelationships: [rel]
	        }).map(function (response) {
	            if (!!rel.parent1) {
	                _this.fsCache.families.delete(rel.parent1.resourceId || rel.parent1.resource);
	            }
	            if (!!rel.parent2) {
	                _this.fsCache.families.delete(rel.parent2.resourceId || rel.parent2.resource);
	            }
	            if (!!rel.child) {
	                _this.fsCache.families.delete(rel.child.resourceId || rel.child.resource);
	            }
	            return rel.id || response.headers['x-entity-id'];
	        });
	    };
	    /**
	     * Save a father fact on an FS child and parents relationship
	     *
	     * @param {String} id FS child and parents relationship ID
	     * @param {Object} fact FS fact
	     * @param {String} reason Reason statement
	     * @return {AsyncSubject}
	     */
	    FSService.prototype.saveFatherFact = function (id, fact, reason) {
	        fact.attribution = {
	            changeMessage: reason
	        };
	        return this.fsRxPost("/platform/tree/relationships/" + id, {
	            childAndParentsRelationships: [{
	                    parent1Facts: [fact]
	                }]
	        }).map(function (response) {
	            return fact.id || response.headers['location'].split('/').pop();
	        });
	    };
	    /**
	     * Save a mother fact on an FS child and parents relationship
	     *
	     * @param {String} id FS child and parents relationship ID
	     * @param {Object} fact FS fact
	     * @param {String} reason Reason statement
	     * @return {AsyncSubject}
	     */
	    FSService.prototype.saveMotherFact = function (id, fact, reason) {
	        fact.attribution = {
	            changeMessage: reason
	        };
	        return this.fsRxPost("/platform/tree/relationships/" + id, {
	            childAndParentsRelationships: [{
	                    parent2Facts: [fact]
	                }]
	        }).map(function (response) {
	            return fact.id || response.headers['location'].split('/').pop();
	        });
	    };
	    /**
	     * Save an FS source
	     *
	     * @param {Object} s FS source
	     * @param {String} pid FS person ID that the source will be attached to (only applies when creating a new source).
	     * @return {AsyncSubject} Emits the source ID
	     */
	    FSService.prototype.saveSource = function (s, pid, reason) {
	        var _this = this;
	        if (reason) {
	            s.attribution = {
	                changeMessage: reason
	            };
	        }
	        var url = s.id ? "/platform/sources/descriptions/" + s.id : "/platform/sources/descriptions";
	        var sourceRequest = this.fsRxPost(url, {
	            sourceDescriptions: [s]
	        });
	        // If the source already exists in FamilySearch then just update it.
	        if (s.id) {
	            return sourceRequest.do(function () {
	                _this.fsCache.sources.delete(pid);
	            }).map(function () { return s.id; });
	        }
	        else {
	            return sourceRequest.mergeMap(function (response) {
	                var sourceId = response.headers['x-entity-id'];
	                var sourceUrl = response.headers.location;
	                return _this.fsRxPost("/platform/tree/persons/" + pid, {
	                    persons: [{
	                            sources: [{
	                                    description: sourceUrl
	                                }]
	                        }]
	                }).do(function () {
	                    _this.fsCache.sources.delete(pid);
	                }).map(function () {
	                    return sourceId;
	                });
	            });
	        }
	    };
	    /**
	     * Save an FS note
	     *
	     * @param {Object} n FS note
	     * @param {String} pid FS person ID the note will be attached to
	     * @param {String} reason Reason statement
	     * @return {AsyncSubject} Emits the note ID
	     */
	    FSService.prototype.saveNote = function (n, pid, reason) {
	        var _this = this;
	        if (reason) {
	            n.attribution = {
	                changeMessage: reason
	            };
	        }
	        return this.fsRxPost("/platform/tree/persons/" + pid + "/notes", {
	            persons: [{
	                    notes: [n]
	                }]
	        }).do(function () {
	            _this.fsCache.notes.delete(pid);
	        }).map(function (response) {
	            return n.id || response.headers['x-entity-id'];
	        });
	    };
	    /**
	     * Save an FS memory
	     *
	     * @param {Object} m FS memory
	     * @param {String} pid FS person ID that the memory will be attached to (only applies when a memory is being created)
	     * @return {AsyncSubject} Emits the memory ID
	     */
	    FSService.prototype.saveMedia = function (m, pid) {
	        var _this = this;
	        // If the memory already exists in FamilySearch then just update it.
	        if (m.id) {
	            this.server.incRequests();
	            return this.fsRxPost("/platform/memories/memories/" + m.id, {
	                sourceDescriptions: [m]
	            }).do(function () {
	                _this.fsCache.memories.delete(pid);
	                _this.server.decRequests();
	            }).map(function () {
	                return m.id;
	            });
	        }
	        else {
	            // If it doesn't already exist then we create the memory and link it to the person
	            var subject_1 = new this.rx.AsyncSubject();
	            // Download the image from RF S3
	            this.server.incRequests();
	            this.rx.Observable.fromPromise(this.$http({
	                url: m.about + '&ts=' + Date.now(),
	                method: 'GET',
	                responseType: 'blob'
	            })).catch(function () {
	                return _this.rx.Observable.throw('NOT_FOUND');
	            }).flatMap(function (response) {
	                // Upload the file to FS
	                var title = m.titles && m.titles[0] ? m.titles[0].value : '';
	                var fd = new FormData();
	                if (!!title) {
	                    fd.append('title', title);
	                }
	                var description = m.descriptions && m.descriptions[0] ? m.descriptions[0].value : '';
	                if (!!description) {
	                    fd.append('description', description);
	                }
	                fd.append('artifact', response.data, _this.toFSfilename(m._filename));
	                return _this.rx.Observable.fromPromise(_this.$http.post(_this.fs.platformHost() + '/platform/memories/memories', fd, {
	                    headers: {
	                        Authorization: 'Bearer ' + _this.fs.getAccessToken(),
	                        'Content-Type': undefined
	                    },
	                    transformRequest: angular.identity
	                })).map(function (response) {
	                    var memoryId = response.headers('x-entity-id');
	                    var memoryUrl = response.headers('Location');
	                    return { memoryId: memoryId, memoryUrl: memoryUrl };
	                }).catch(function (err) {
	                    var mid;
	                    if (err.status === 409 && !!err.data && !!err.data.errors && err.data.errors.length === 1 && !!err.data.errors[0].stacktrace) {
	                        //let mid = err.data.errors[0].stacktrace.substr(err.data.errors[0].stacktrace.lastIndexOf(' ') + 1).replace('(', '').replace(')', '');
	                        var match = err.data.errors[0].stacktrace.match(/<ID>(.*?)<\/ID>/);
	                        if (!!match) {
	                            mid = match[1];
	                        }
	                    }
	                    if (!!mid) {
	                        return _this.rx.Observable.of({ memoryId: mid, memoryUrl: _this.fs.platformHost() + ("/platform/memories/memories/" + mid) });
	                    }
	                    else if (err.status == 409) {
	                        return _this.rx.Observable.throw("Someone (possibly you?) has already uploaded this file to FamilySearch");
	                    }
	                    else {
	                        return _this.rx.Observable.throw(err.headers('warning') || 'Unable to upload file to FamilySearch');
	                    }
	                });
	            }).flatMap(function (response) {
	                m.id = response.memoryId;
	                if (m.coverage && m.coverage[0] && (m.coverage[0].spatial || m.coverage[0].temporal)) {
	                    return _this.fsRxPost("/platform/memories/memories/" + m.id, {
	                        sourceDescriptions: [m]
	                    }).map(function () {
	                        return response;
	                    });
	                }
	                else {
	                    return _this.rx.Observable.of(response);
	                }
	            }).flatMap(function (response) {
	                return _this.fsRxPost(response.memoryUrl + "/personas", {
	                    persons: [{
	                            identifiers: {
	                                'http://familysearch.org/v1/FamilyTreePerson': [pid]
	                            }
	                        }]
	                }).map(function () {
	                    return response.memoryId;
	                });
	            }).do(function () {
	                _this.fsCache.memories.delete(pid);
	                _this.server.decRequests();
	            }).subscribe(function (memoryId) {
	                subject_1.next(memoryId);
	                subject_1.complete();
	            }, function (err) {
	                subject_1.error(err);
	            });
	            return subject_1;
	        }
	    };
	    /**
	     * Save an FS story
	     *
	     * @param {Object} s FS story
	     * @param {String} pid FS person ID that the story will be attached to (only applies when a story is being created)
	     * @return {AsyncSubject} Emits the story ID
	     */
	    FSService.prototype.saveStory = function (s, pid) {
	        var _this = this;
	        // If the memory already exists in FamilySearch then just update it.
	        if (s.id) {
	            return this.fsRxPost("/platform/memories/memories/" + s.id, {
	                sourceDescriptions: [s]
	            }).do(function () {
	                _this.fsCache.memories.delete(pid);
	            }).map(function () {
	                return s.id;
	            });
	        }
	        else {
	            var storyTitle = encodeURIComponent(s.titles && s.titles[0] ? s.titles[0].value || '' : '');
	            var storyFilename = encodeURIComponent('story.txt');
	            return this.fsRxHTTP("/platform/memories/memories?title=" + storyTitle + "&type=Story&filename=" + storyFilename, {
	                method: 'POST',
	                headers: {
	                    'Content-Type': 'text/plain'
	                },
	                body: s.descriptions && s.descriptions[0] && s.descriptions[0].value || ''
	            }).mergeMap(function (response) {
	                var memoryId = response.headers['x-entity-id'];
	                var memoryUrl = response.headers.location;
	                return _this.fsRxPost(memoryUrl + "/personas", {
	                    persons: [{
	                            identifiers: {
	                                'http://familysearch.org/v1/FamilyTreePerson': [pid]
	                            }
	                        }]
	                }).do(function () {
	                    _this.fsCache.memories.delete(pid);
	                }).map(function () {
	                    return memoryId;
	                });
	            });
	        }
	    };
	    /**
	     * Check whether the user is LDS
	     *
	     * @return {AsyncSubject} Emits boolean whether the user is LDS
	     */
	    FSService.prototype.getIsLDS = function () {
	        if (this.fsCache.isLDS !== null) {
	            return this.rx.Observable.of(this.fsCache.isLDS);
	        }
	        var subject = new this.rx.AsyncSubject();
	        // this.fsRxGet('/platform/ordinances/ordinances', null, {expect403: true}).subscribe({
	        //   next: () => {
	        //     subject.next(true);
	        //     subject.complete();
	        //   },
	        //   error: (err) => {
	        //     if (err === 403) {
	        //       subject.next(false);
	        //       subject.complete();
	        //     }
	        //     else {
	        //       subject.error(err);
	        //     }
	        //   }
	        // });
	        // subject.do(isLDS => {
	        //   this.fsCache.isLDS = isLDS;
	        // });
	        this.fsCache.islDS = false;
	        subject.next(false);
	        subject.complete();
	        return subject;
	    };
	    /**
	     * Get the current user
	     *
	     * @return {AsyncSubject} Emits the current user
	     */
	    FSService.prototype.getCurrentUser = function () {
	        var _this = this;
	        if (this.fsCache.user) {
	            return this.rx.Observable.of(this.fsCache.user);
	        }
	        return this.fsRxGetData('/platform/users/current').map(function (data) {
	            return !!data && !!data.users && !!data.users[0] ? data.users[0] : null;
	        }).do(function (user) {
	            _this.fsCache.user = user;
	        });
	    };
	    /**
	     * Get the current user's FamilySearch user ID.
	     * The response is cached.
	     *
	     * @return {AsyncSubject} Emits the current user's FamilySearch user ID.
	     */
	    FSService.prototype.getCurrentUserID = function () {
	        return this.getCurrentUser().map(function (user) { return user.id; });
	    };
	    /**
	     * Get the current user's FamilySearch PID
	     *
	     * @return {AsyncSubject} Emits the current user's FamilySearch PID
	     */
	    FSService.prototype.getCurrentUsersPID = function () {
	        return this.getCurrentUser().map(function (user) { return user.personId; });
	    };
	    /**
	     * Get FS person matches for an RF person
	     *
	     * @param {Object} person RF person
	     * @param {Object} [father] RF person's father
	     * @param {Object} [mother] RF person's mother
	     * @param {Object} [spouse] RF person's spouse
	     * @return {AsyncSubject} Emits a list of matches in format {id, person, spouses[], parents[], children[]}.
	     * Each person object is just the display block returned by FS. {name, gender, birthDate, birthPlace, deathDate, deathPlace}
	     */
	    FSService.prototype.getMatches = function (person, father, mother, spouse) {
	        var matchData = {
	            "description": "#sd1",
	            "persons": [],
	            "relationships": [],
	            "sourceDescriptions": [{
	                    "id": "sd1",
	                    "about": "#primaryPerson",
	                    "identifiers": {
	                        "http://gedcomx.org/Persistent": ["#sd1"]
	                    }
	                }]
	        };
	        addMatchData(this, matchData, person, 'primaryPerson');
	        addMatchData(this, matchData, father, 'father1');
	        addMatchData(this, matchData, mother, 'mother1');
	        addMatchData(this, matchData, spouse, 'spouse1');
	        return this.fsRxPost('/platform/tree/matches', matchData, {}, 'application/x-gedcomx-v1+json', 'application/x-gedcomx-atom+json', false)
	            .map(function (response) {
	            var entries = !!response && !!response['data'] && !!response['data']['entries'] ? response['data']['entries'] : [];
	            // Convert verbose GEDCOM X to a simple data structure
	            return entries.map(function (entry) {
	                // Put persons into a map for easy access
	                var persons = new Map();
	                entry.content.gedcomx.persons.forEach(function (person) {
	                    persons.set(person.id, person);
	                });
	                var personId = entry.id;
	                return {
	                    id: personId,
	                    person: persons.get(personId).display,
	                    spouses: (entry.content.gedcomx.relationships || []).filter(function (rel) {
	                        return rel.type === 'http://gedcomx.org/Couple' && (rel.person1.resourceId === personId || rel.person2.resourceId === personId);
	                    }).map(function (rel) {
	                        return persons.get(rel.person1.resourceId === personId ? rel.person2.resourceId : rel.person1.resourceId);
	                    }).map(function (p) {
	                        return Object.assign({}, p.display, { PID: p.id });
	                    }),
	                    parents: (entry.content.gedcomx.relationships || []).filter(function (rel) {
	                        return rel.type === 'http://gedcomx.org/ParentChild' && rel.person2.resourceId === personId;
	                    }).map(function (rel) { return persons.get(rel.person1.resourceId); }).map(function (p) {
	                        return Object.assign({}, p.display, { PID: p.id });
	                    }),
	                    children: (entry.content.gedcomx.relationships || []).filter(function (rel) {
	                        return rel.type === 'http://gedcomx.org/ParentChild' && rel.person1.resourceId === personId;
	                    }).map(function (rel) { return persons.get(rel.person2.resourceId); }).map(function (p) {
	                        return Object.assign({}, p.display, { PID: p.id });
	                    })
	                };
	            });
	        });
	        function addMatchData(that, matchData, person, id) {
	            if (!!person) {
	                var personData = that.toFSPerson(person);
	                // convert to the match endpoint
	                personData['id'] = id;
	                delete personData['living'];
	                personData['names'].forEach(function (name) {
	                    delete name['preferred'];
	                    delete name['type'];
	                });
	                personData['facts'].forEach(function (fact) {
	                    delete fact['id'];
	                    delete fact['value'];
	                });
	                matchData['persons'].push(personData);
	                if (id === 'father1' || id === 'mother1') {
	                    matchData['relationships'].push({
	                        "type": "http://gedcomx.org/ParentChild",
	                        "person1": {
	                            "resource": "#" + id,
	                        },
	                        "person2": {
	                            "resource": "#primaryPerson"
	                        }
	                    });
	                }
	                else if (id === 'spouse1') {
	                    matchData['relationships'].push({
	                        "type": "http://gedcomx.org/Couple",
	                        "person1": {
	                            "resource": "#primaryPerson"
	                        },
	                        "person2": {
	                            "resource": "#spouse1"
	                        }
	                    });
	                }
	            }
	        }
	    };
	    /**
	     * Get an FS person
	     *
	     * @param {String} pid FS person ID
	     * @param {Boolean} full Whether to requesting additional data such as
	     * the profile photo and preferred parent relationship. Default: true.
	     * @return {AsyncSubject} Emits the FS person
	     */
	    FSService.prototype.getPerson = function (pid, full) {
	        var _this = this;
	        if (full === void 0) { full = true; }
	        // Check the cache
	        var cacheKey = this.getPersonCacheKey(pid, full);
	        if (this.fsCache.persons.has(cacheKey)) {
	            return this.rx.Observable.of(this.fsCache.persons.get(cacheKey));
	        }
	        var requests = [this.fsRxGet("/platform/tree/persons/" + pid)];
	        if (full) {
	            requests.push(this.getProfilePhotoURL(pid), this.getPreferredParentsFamilyID(pid));
	        }
	        return (_a = this.rx.Observable).zip.apply(_a, __spread(requests)).map(function (responses) {
	            var personResponse = responses[0], profilePhotoUrl = responses[1], preferredParentsFamilyId = responses[2];
	            // Return null on a 410 which means the person has been deleted from FamilySearch
	            if (personResponse.statusCode === 410 || !(personResponse.data && personResponse.data.persons && personResponse.data.persons[0])) {
	                return null;
	            }
	            var person = personResponse.data.persons[0];
	            person.profilePhotoUrl = profilePhotoUrl;
	            person.preferredParentsFamilyId = preferredParentsFamilyId;
	            // set _redirected
	            if (personResponse.statusCode === 200 &&
	                personResponse.headers['location'] && /^\w\w\w\w-\w\w\w$/.test(personResponse.headers['location'].slice(-8))) {
	                person._redirected = personResponse.headers['location'].slice(-8);
	            }
	            // I would prefer to use the etag but that isn't currently exposed due to cors
	            if (personResponse.headers['last-modified']) {
	                person._version = person._modified = new Date(personResponse.headers['last-modified']).getTime();
	            }
	            // Embed relationships inside of the person. This is done so that toRFPerson
	            // has access to them and so that they're available during importing
	            // without having to pass around a full gedcomx document.
	            if (!!personResponse.data.relationships) {
	                person.coupleRels = personResponse.data.relationships.filter(function (rel) { return rel.type === 'http://gedcomx.org/Couple'; });
	            }
	            else {
	                person.coupleRels = [];
	            }
	            if (!!personResponse.data.childAndParentsRelationships) {
	                person.childRels = personResponse.data.childAndParentsRelationships.filter(function (rel) { return rel.child.resourceId === pid; });
	            }
	            else {
	                person.childRels = [];
	            }
	            // Calculate whether a person has any parents by counting whether any relationships
	            // exist where they are the child. eol = end-of-line.
	            person._eol = person.childRels.length === 0;
	            return person;
	        })
	            .catch(function (error) {
	            // If we get a 403 error, treat it like the person doesn't exist
	            if (error && (error === 403 || (typeof error === 'string' && error.includes('403')))) {
	                return _this.rx.Observable.of(null);
	            }
	            // Otherwise, propagate the error
	            return _this.rx.Observable.throw(error);
	        })
	            .do(function (person) {
	            _this.fsCache.persons.set(cacheKey, person);
	        });
	        var _a;
	    };
	    /**
	     * Get the current version of an FS person.
	     *
	     * @param {String} pid FamilySearch PID
	     * @return {AsyncSubject} Emits the current version of the person
	     */
	    FSService.prototype.getPersonVersion = function (pid) {
	        return this.fsRxHTTP("/platform/tree/persons/" + pid, {
	            method: 'HEAD'
	        }).map(function (response) { return response.headers['last-modified']; });
	    };
	    /**
	     * Get the preferred parent family ID for a FamilySearch PID.
	     * The ID returned is a custom FS family ID of the format `{fatherId}:{motherID}`.
	     * All custom FS family objects will have the ID set so that you can find the
	     * corresponding family.
	     *
	     * @param {String} pid FS Person ID
	     * @return {AsyncSubject} Emits the FS family ID
	     */
	    FSService.prototype.getPreferredParentsFamilyID = function (pid) {
	        var _this = this;
	        if (this.fsCache.personPrefParents.has(pid)) {
	            return this.rx.Observable.of(this.fsCache.personPrefParents.get(pid));
	        }
	        // First we need to get the user ID
	        return this.getCurrentUserID()
	            .mergeMap(function (userId) {
	            return _this.fsRxGet("/platform/tree/users/" + userId + "/preferred-parent-relationships/" + pid).map(function (response) {
	                // Normally the signal that a preferred relationship exists is a 303 HTTP
	                // status code. However the JS SDK is configured to capture 3xx redirects
	                // so we see a 200 instead. We can check for the existence of a Location
	                // header, but that might also exist if the person has been merged. Thus
	                // we also have to see whether the Location header points to a capr.
	                var location = response.headers.location;
	                location = response.statusCode < 400 && location && location.indexOf('relationships') ? location : ''; // looks like it's still child-and-parents-relationships
	                _this.fsCache.personPrefParents.set(pid, location);
	                return location;
	            });
	        })
	            .mergeMap(function (relURI) {
	            if (relURI) {
	                return _this.fsRxGetData(relURI).map(function (data) {
	                    var location = !!data && !!data.childAndParentsRelationships ? familyIdFromChildAndParentsRel(data.childAndParentsRelationships[0]) : '';
	                    _this.fsCache.personPrefParents.set(pid, location);
	                    return location;
	                });
	            }
	            else {
	                // If we don't emit a value here then the zip() in getPerson() will never complete.
	                var location_1 = '';
	                _this.fsCache.personPrefParents.set(pid, location_1);
	                return _this.rx.Observable.of(location_1);
	            }
	        });
	    };
	    /**
	     * Get an FS person's families.
	     *
	     * @param {String} pid FS person ID
	     * @return {AsyncSubject} Emits {spouseFamilies, parentFamilies}
	     */
	    FSService.prototype.getFamilies = function (pid) {
	        var _this = this;
	        if (this.fsCache.families.has(pid)) {
	            return this.rx.Observable.of(this.fsCache.families.get(pid));
	        }
	        return this.fsRxGetData("/platform/tree/persons/" + pid + "/families").map(function (data) {
	            var families = {
	                spouseFamilies: [],
	                parentFamilies: []
	            };
	            // Terminate early; this person has no families
	            if (!data) {
	                return families;
	            }
	            // Filter out couple and childAndParent rels that the person is a part of.
	            // Use those to assemble families.
	            //
	            // The API is currently returning families that the person doesn't belong
	            // to (parent families that don't include the child or families of children).
	            // Therefore we can't just assemble all families; we must calculate which
	            // families this person actually belongs to.
	            //
	            // A couple relationship may not exist (parents weren't married or there
	            // is no known spouse) so we have to collect IDs from childAndParent
	            // relationships that the person is parent in. But we also want to collect
	            // spouses that they didn't have any children with so we have to examine
	            // couple relationships too.
	            var familyMap = new Map();
	            if (!!data.relationships) {
	                data.relationships.forEach(function (rel) {
	                    var type = rel.type, person1Id = rel.person1.resourceId, person2Id = rel.person2.resourceId;
	                    var familyId = person1Id + ":" + person2Id;
	                    if (type === 'http://gedcomx.org/Couple' && (person1Id === pid || person2Id === pid)) {
	                        familyMap.set(familyId, {
	                            id: familyId,
	                            coupleRel: rel,
	                            childAndParentsRels: []
	                        });
	                    }
	                });
	            }
	            if (!!data.childAndParentsRelationships) {
	                data.childAndParentsRelationships.forEach(function (_a) {
	                    var child = _a.child, parent1 = _a.parent1, parent2 = _a.parent2;
	                    var childId = child.resourceId;
	                    var fatherId = parent1 ? parent1.resourceId : '';
	                    var motherId = parent2 ? parent2.resourceId : '';
	                    var familyId = fatherId + ":" + motherId;
	                    if (childId === pid || fatherId === pid || motherId === pid) {
	                        familyMap.set(familyId, {
	                            id: familyId,
	                            childAndParentsRels: []
	                        });
	                    }
	                });
	            }
	            // Now that we have a list of valid family IDs we can start gathering
	            // all relationships that belong to those families.
	            //
	            // In the previous steps we could have collected some relationships, but
	            // but we couldn't have gotten them all and would have to collect more of
	            // them here. To simplify, we just collect them all here.
	            if (!!data.relationships) {
	                data.relationships.forEach(function (rel) {
	                    if (rel.type === 'http://gedcomx.org/Couple') {
	                        var family = familyMap.get(familyIdFromCoupleRel(rel));
	                        if (family) {
	                            family.coupleRel = rel;
	                        }
	                    }
	                });
	            }
	            if (!!data.childAndParentsRelationships) {
	                data.childAndParentsRelationships.forEach(function (rel) {
	                    var family = familyMap.get(familyIdFromChildAndParentsRel(rel));
	                    if (family) {
	                        family.childAndParentsRels.push(rel);
	                    }
	                });
	            }
	            // Now we calculate which families are spouse families (person is a spouse)
	            // and which families are parent families (person is a child).
	            // We determine this by examining the familyIds which is a concatenation
	            // of parent Ids. If the person's Id is in the family Id then they are a
	            // spouse in that family. Otherwise they're a child.
	            familyMap.forEach(function (family, familyId) {
	                if (familyId.indexOf(pid) === -1) {
	                    families.parentFamilies.push(family);
	                }
	                else {
	                    families.spouseFamilies.push(family);
	                }
	            });
	            // cache
	            _this.fsCache.families.set(pid, families);
	            return families;
	        });
	    };
	    /**
	     * Get the profile photo URL for an FS person
	     *
	     * @param {String} pid FS person ID
	     * @return {AsyncSubject} Emits the person's profile URL, if it exists
	     */
	    FSService.prototype.getProfilePhotoURL = function (pid) {
	        var _this = this;
	        if (this.fsCache.personPortraits.has(pid)) {
	            return this.rx.Observable.of(this.fsCache.personPortraits.get(pid));
	        }
	        return this.fsRxGet("/platform/tree/persons/" + pid + "/portrait").map(function (response) {
	            var location = response.headers['location'] || '';
	            _this.fsCache.personPortraits.set(pid, location);
	            return location;
	        });
	    };
	    /**
	     * Get an FS person's sources
	     *
	     * @param {String} pid FS person ID
	     * @return {AsyncSubject} Emits a list of sources
	     */
	    FSService.prototype.getSources = function (pid) {
	        var _this = this;
	        if (this.fsCache.sources.has(pid)) {
	            return this.rx.Observable.of(this.fsCache.sources.get(pid));
	        }
	        return this.fsRxGetData("/platform/tree/persons/" + pid + "/sources").map(function (data) {
	            return !!data && !!data.sourceDescriptions ? data.sourceDescriptions : [];
	        }).do(function (sources) {
	            _this.fsCache.sources.set(pid, sources);
	        });
	    };
	    /**
	     * Get the record hints for an FS person
	     *
	     * @param {String} pid FS person ID
	     * @return {AsyncSubject} Emits a list of hints
	     */
	    FSService.prototype.getHints = function (pid) {
	        var _this = this;
	        if (this.fsCache.hints.has(pid)) {
	            return this.rx.Observable.of(this.fsCache.hints.get(pid));
	        }
	        return this.fsRxGetData("/platform/tree/persons/" + pid + "/matches?collection=records", {
	            headers: {
	                Accept: 'application/x-gedcomx-atom+json'
	            }
	        }).map(function (data) {
	            return !!data && !!data.entries ? data.entries : [];
	        }).do(function (hints) {
	            _this.fsCache.hints.set(pid, hints);
	        });
	    };
	    /**
	     * Get the memories for an FS person
	     *
	     * @param {String} pid FS person ID
	     * @return {AsyncSubject} Emits {media[], stories[], bio}
	     */
	    FSService.prototype.getMemories = function (pid, fetchPeople) {
	        var _this = this;
	        if (this.fsCache.memories.has(pid)) {
	            return this.rx.Observable.of(this.fsCache.memories.get(pid));
	        }
	        return this.fsRxGetData("/platform/tree/persons/" + pid + "/memories?type=photo&type=story&type=document&type=obituary&count=999").mergeMap(function (data) {
	            var types = {
	                media: [],
	                stories: []
	            };
	            console.log('getMemories', data);
	            var additionalRequests = [];
	            if (!!data && !!data.sourceDescriptions) {
	                data.sourceDescriptions.forEach(function (memory) {
	                    var type = memory.artifactMetadata && memory.artifactMetadata[0] && memory.artifactMetadata[0].qualifiers && memory.artifactMetadata[0].qualifiers[0].name ? memory.artifactMetadata[0].qualifiers[0].name : '';
	                    if (type === 'http://familysearch.org/v1/Story' || type === 'http://familysearch.org/v1/Obituary' || memory.mediaType === 'text/plain') {
	                        types.stories.push(memory);
	                        if (memory.mediaType.startsWith('audio')) {
	                            var text = (!!memory.descriptions && !!memory.descriptions[0] && !!memory.descriptions[0].value) ? memory.descriptions[0].value + "\n" : '';
	                            text += "Audio: " + memory.about;
	                            memory.descriptions = [{ value: text }];
	                        }
	                        else if (!!memory.about) {
	                            // Get the story content because FS only puts the first 200 characters in descriptions
	                            additionalRequests.push(_this.fsRxGet(memory.about + (memory.about.includes('?') ? '&' : '?') + 'rfts=' + Date.now()).do(function (response) {
	                                if (!!response.body) {
	                                    var text = response.body;
	                                    if (text.length > 100000) {
	                                        text = text.substr(0, 100000) + "...\n" + memory.about;
	                                    }
	                                    memory.descriptions = [{ value: text }];
	                                }
	                                else if (!!memory.descriptions && !!memory.descriptions[0] && !!memory.descriptions[0].value) {
	                                    memory.descriptions[0].value += "...\n" + memory.about;
	                                }
	                            }).catch(function (err) {
	                                _this.messageBus.post({ msg: err, op: 'GET', ctx: 'fs.getMemories.about', warn: true });
	                                return _this.rx.Observable.of(null);
	                            }));
	                        }
	                        // Get the URL of images attached to stories, if an image is attached.
	                        // If an image doesn't exist this will set the 'about' field to undefined.
	                        additionalRequests.push(_this.fsRxGetData(memory.links.memory.href).do(function (data) {
	                            memory.about = !!data && !!data.sourceDescriptions && data.sourceDescriptions.length > 0 && !!data.sourceDescriptions[0].links && !!data.sourceDescriptions[0].links.image ? data.sourceDescriptions[0].links.image.href : undefined;
	                        }).catch(function (err) {
	                            memory.about = undefined;
	                            _this.messageBus.post({ msg: err, op: 'GET', ctx: 'fs.getMemories.href', warn: true });
	                            return _this.rx.Observable.of(null);
	                        }));
	                    }
	                    else {
	                        // TODO MEMORIESconsole.log('fsSync.getMemories.memories', memory);
	                        types.media.push(memory);
	                    }
	                    additionalRequests.push(_this.fsRxGetData(memory.links.memory.href).do(function (data) {
	                        // set coverage in preparation for setRFCoverage
	                        if (!!data.sourceDescriptions && !!data.sourceDescriptions[0] && data.sourceDescriptions[0].coverage && !!data.sourceDescriptions[0].coverage[0]) {
	                            memory.coverage = data.sourceDescriptions[0].coverage;
	                        }
	                    }));
	                    // TODO MEMORIES
	                    // if (fetchPeople) {
	                    //   additionalRequests.push(this.fsRxGetData(memory.links.persons.href).do(data => {
	                    //     // TODO what got returned?
	                    //     console.log('fsSync.getMemories.fetchPeople', data);
	                    //   }));
	                    // }
	                });
	            }
	            if (additionalRequests.length) {
	                return (_a = _this.rx.Observable).merge.apply(_a, __spread(additionalRequests)).last().map(function () { return types; });
	            }
	            else {
	                return _this.rx.Observable.of(types);
	            }
	            var _a;
	        }).do(function (memories) {
	            _this.fsCache.memories.set(pid, memories);
	        });
	    };
	    /**
	     * Get the ordinances for an FS person
	     *
	     * @param {String} pid FS person ID
	     * @return {AsyncSubject} Emits the list of ordinances
	     */
	    FSService.prototype.getOrdinances = function (pid) {
	        var _this = this;
	        if (this.fsCache.ordinances.has(pid)) {
	            return this.rx.Observable.of(this.fsCache.ordinances.get(pid));
	        }
	        return this.fsRxGetData("/platform/tree/persons/" + pid + "/ordinances")
	            .map(function (data) { return !!data && !!data.persons && !!data.persons[0] && !!data.persons[0].ordinances ? data.persons[0].ordinances : []; })
	            .do(function (ordinances) {
	            _this.fsCache.ordinances.set(pid, ordinances);
	        });
	    };
	    /**
	     * Get the summary status of a person's ordinances for display
	     *
	     * @param {String} pid FS person ID
	     * @return {AsyncSubject} Emits the summary status
	     */
	    FSService.prototype.getOrdinancesStatus = function (pid) {
	        var _this = this;
	        if (this.fsCache.ordinancesStatus.has(pid)) {
	            return this.rx.Observable.of(this.fsCache.ordinances.get(pid));
	        }
	        return this.fsRxGetData("/platform/ordinances/status?person=" + pid).map(function (data) {
	            return !!data && !!data.ordinances && !!data.ordinances[0] && !!data.ordinances[0].status ? data.ordinances[0].status : null;
	        }).do(function (status) {
	            _this.fsCache.ordinancesStatus.set(pid, status);
	        });
	    };
	    /**
	     * Get the notes for an FS person
	     *
	     * @param {String} pid FS person ID
	     * @return {AsyncSubject} Emits a list of notes
	     */
	    FSService.prototype.getNotes = function (pid) {
	        var _this = this;
	        if (this.fsCache.notes.has(pid)) {
	            return this.rx.Observable.of(this.fsCache.notes.get(pid));
	        }
	        return this.fsRxGetData("/platform/tree/persons/" + pid + "/notes").map(function (data) {
	            return !!data && !!data.persons && !!data.persons[0] && !!data.persons[0].notes ? data.persons[0].notes : [];
	        }).do(function (notes) {
	            _this.fsCache.notes.set(pid, notes);
	        });
	    };
	    /**
	     * Get the name of an FS user
	     *
	     * @param {String} userId FS userId
	     * @return {AsyncSubject} Emits a user's name
	     */
	    FSService.prototype.getUser = function (userId) {
	        var _this = this;
	        if (this.fsCache.users.has(userId)) {
	            return this.rx.Observable.of(this.fsCache.users.get(userId));
	        }
	        return this.fsRxGetData("/platform/users/agents/" + userId).map(function (data) {
	            return !!data && !!data.agents && !!data.agents[0] && !!data.agents[0].accounts && !!data.agents[0].accounts[0] ? data.agents[0].accounts[0].accountName : '';
	        }).do(function (user) {
	            _this.fsCache.users.set(userId, user);
	        });
	    };
	    /**
	     * Get n generations of ancestors for a FamilySearch person. Designed
	     * for quickly displaying the pedigree of a FS person. This is not
	     * designed for syncing the data to RF.
	     *
	     * @param {String} pid
	     * @param {Integer} n number of generations; max is 8
	     * @return {AsyncSubject} { persons: [RF persons], families: [RF families] }
	     */
	    FSService.prototype.getAncestors = function (pid, n) {
	        var _this = this;
	        return this.fsRxGetData("/platform/tree/ancestry?person=" + pid + "&generations=" + n).map(function (data) {
	            var rfData = {
	                persons: [],
	                families: []
	            };
	            // Terminate early because there are no ancestors
	            if (!data || !data.persons) {
	                return rfData;
	            }
	            // An index of persons by their ascendancy number. We would like to convert the
	            // numbers to integers but can't because some are strings such as 1-S for the
	            // primary person's spouse. Thus we have to convert between integers (when calculating
	            // relationships) and strings (when retrieving persons from the index).
	            var ahnenIndex = new Map();
	            // Convert all FS persons to RF persons and populate the ahnen index
	            data.persons.forEach(function (p, i) {
	                var person = _this.toRFPerson(p);
	                person.id = i + 1;
	                rfData.persons.push(person);
	                ahnenIndex.set(p.display.ascendancyNumber, person);
	            });
	            // Assemble families, starting with the first person and their parents. Runs recursively.
	            function familyFromAhnen(ahnen) {
	                var person = ahnenIndex.get(ahnen + '');
	                if (person) {
	                    var fathersNumber = ahnen * 2, father = ahnenIndex.get(fathersNumber + ''), mothersNumber = (ahnen * 2) + 1, mother = ahnenIndex.get(mothersNumber + '');
	                    if (father || mother) {
	                        rfData.families.push({
	                            husbandId: father ? father.id : undefined,
	                            wifeId: mother ? mother.id : undefined,
	                            childRels: new Map([[person.id, {}]])
	                        });
	                        if (father) {
	                            familyFromAhnen(fathersNumber);
	                        }
	                        if (mother) {
	                            familyFromAhnen(mothersNumber);
	                        }
	                    }
	                }
	            }
	            familyFromAhnen(1);
	            return rfData;
	        });
	    };
	    /**
	     * Get n generations of descendants for a FamilySearch person. Designed
	     * for quickly displaying the descendants of a FS person. This is not
	     * designed for syncing the data to RF.
	     *
	     * @param {String} pid
	     * @param {Integer} n number of generations; max is 2
	     * @return {AsyncSubject} { persons: [RF persons], families: [RF families] }
	     */
	    FSService.prototype.getDescendants = function (pid, n) {
	        var _this = this;
	        return this.fsRxGetData("/platform/tree/descendancy?person=" + pid + "&generations=" + n).map(function (data) {
	            var rfData = {
	                persons: [],
	                families: []
	            };
	            // Terminate early because there are no descendants
	            if (!data || !data.persons) {
	                return rfData;
	            }
	            // An index of persons by their descendancy number.
	            var personIndex = new Map();
	            // Convert all FS persons to RF persons and populate the index
	            data.persons.forEach(function (p, i) {
	                var person = _this.toRFPerson(p);
	                person.id = i + 1;
	                rfData.persons.push(person);
	                personIndex.set(p.display.descendancyNumber, person);
	            });
	            _this.$log.debug('fs.getDescendants keys', Array.from(personIndex.keys()));
	            /**
	             * Assemble all spouse families for the given descendancy number
	             *
	             * @param {String} num descendancy number
	             */
	            function assembleFamilies(num) {
	                // Load the person
	                var person = personIndex.get(num);
	                if (person) {
	                    var spouseNum = num + '-S', spouse = personIndex.get(spouseNum);
	                    // At the moment, there won't be any children if there's no spouse
	                    if (spouse) {
	                        // Assign mother and father roles
	                        var father = person.gender === 'MALE' ? person : spouse, mother = person.gender === 'FEMALE' ? person : spouse;
	                        var family = {
	                            husbandId: father ? father.id : undefined,
	                            wifeId: mother ? mother.id : undefined,
	                            childRels: new Map()
	                        };
	                        rfData.families.push(family);
	                        // Gather children
	                        var childIndex = void 0, childNum = void 0, child = void 0;
	                        for (childIndex = 1; childNum = num + "." + childIndex, child = personIndex.get(childNum); childIndex++) {
	                            family.childRels.set(child.id, {});
	                            assembleFamilies(childNum);
	                        }
	                    }
	                }
	            }
	            // Get started
	            assembleFamilies('1');
	            return rfData;
	        });
	    };
	    /**
	     * Get an FS person and their tree.
	     *
	     * Emits {type, contents, progress, personId}.
	     * Type is: person, family, source, hint, media, ordinances, note, story, bio.
	     * Progress is {total, complete, remaining, percent}.
	     * Families are not emitted until all associated persons have been emitted.
	     * Persons are returned in breadth-first order.
	     *
	     * @param {String} startPID FS person ID of the starting person
	     * @param {Integer} gensUpLimit Number of ancestral generations to download
	     * @param {Integer} gensDownLimit Number of descendant generations (applied to each ancestor) that should be downloaded
	     * @param {Set<String>} alreadyDownloadedPIDs List of pids that have already been downloaded and should be ignored. Their
	     * families will be downloaded and emitted but the person and attached data (sources, memories, etc) will be skipped.
	     * @param {Integer} concurrency Number of persons being processed at once. Defaults to 1.
	     * @return {Observable}
	     */
	    FSService.prototype.readAncestors = function (startPID, gensUpLimit, gensDownLimit, alreadyDownloadedPIDs, concurrency) {
	        var _this = this;
	        if (alreadyDownloadedPIDs === void 0) { alreadyDownloadedPIDs = new Set(); }
	        if (concurrency === void 0) { concurrency = 1; }
	        var fs = this;
	        var rx = this.rx;
	        var $log = this.$log;
	        // Track which PIDs we've already queued and processed
	        var queuedPIDs = new Map();
	        var processedPIDs = new Map();
	        var currentGen = 0;
	        // We need an internal queue (breadth-first) to which we add pids. One at
	        // a time we will process the pids by requesting the person, relationships,
	        // sources, hints, media, notes, and ordinances.
	        // The PID queue emits PIDs in the format {pid, gensUp, gensDown, spouse}
	        var pidQueue = new this.rx.Subject();
	        // Track families that are being processed.
	        var familiesIndex = new Map();
	        // A map of person IDs to a list of family IDs. This allows us to quickly
	        // lookup which families a person belongs to and track when that family
	        // is ready to be emitted.
	        var personFamiliesIndex = new Map();
	        // This is set later, but still before processing begins.
	        var isLDS = false;
	        // Create and return an observable that we can emit multiple values on.
	        return this.rx.Observable.create(function (observer) {
	            // Now we begin configuring the pidQueue's pipeline.
	            // First we filter out any duplicate PIDs
	            pidQueue.filter(function (scope) {
	                if (queuedPIDs.has(scope.pid) || !inScope(scope)) {
	                    return false;
	                }
	                else {
	                    queuedPIDs.set(scope.pid, true);
	                    return true;
	                }
	            })
	                .mergeMap(function (scope) {
	                return processPID(observer, scope);
	            }, concurrency)
	                .subscribe(function (_a) {
	                var pid = _a.pid;
	                $log.debug('fs.readAncestors', pid);
	                processedPIDs.set(pid, true);
	                // We must wait to process their families until after the person is marked as complete.
	                processFamilies(observer, pid);
	                // Are we done loading ancestors?
	                if (queuedPIDs.size === processedPIDs.size) {
	                    observer.complete();
	                }
	            });
	            // Before we get started, we check whether the user is LDS.
	            // We don't want to requests ordinances if they're not LDS.
	            _this.getIsLDS().subscribe(function (lds) {
	                isLDS = lds;
	                // Let's get started
	                pidQueue.next({
	                    pid: startPID,
	                    gensUp: 0,
	                    gensDown: 0,
	                    spouse: false
	                });
	            });
	        })
	            .map(function (data) {
	            data.progress = getProgress();
	            return data;
	        });
	        /**
	         * Process a PID, deciding how much information needs to be loaded
	         * and marking the PID as processed when all requests have completed.
	         *
	         * @return {Observable} An observable that emits the scope
	         */
	        function processPID(observer, scope) {
	            var pid = scope.pid, gensUp = scope.gensUp, gensDown = scope.gensDown, spouse = scope.spouse;
	            var pidObservable;
	            // Track which generation we're processing. This is included in the progress data.
	            currentGen = Math.max(gensUp, currentGen);
	            // If the person has already been downloaded then we only request families.
	            if (alreadyDownloadedPIDs.has(pid)) {
	                pidObservable = loadFamilies(pid, gensUp, gensDown);
	            }
	            else {
	                pidObservable = loadPerson(observer, pid, gensUp, gensDown, spouse);
	            }
	            return pidObservable.map(function () { return scope; });
	        }
	        /**
	         * Load and process a person and their data (sources, memories, families, etc)
	         */
	        function loadPerson(observer, pid, gensUp, gensDown, spouse) {
	            return fs.getPerson(pid).mergeMap(function (person) {
	                // Terminate early if we don't have a person (410 deleted)
	                if (!person) {
	                    return rx.Observable.of(null);
	                }
	                // Set a flag which tells whether they are a direct line ancestor
	                person._dl = gensUp > 0 && gensDown === 0;
	                // Track all requests so that we can return an observable that completes
	                // when all requests complete. This helps manage concurrency and track
	                // progress.
	                var preRequests = [];
	                var postRequests = [];
	                // Load the person's sources
	                preRequests.push(fs.getSources(pid).do(function (sources) {
	                    sources.forEach(function (source) {
	                        observer.next({
	                            type: 'source',
	                            personId: pid,
	                            contents: source
	                        });
	                    });
	                }));
	                // Load relationship sources
	                person.coupleRels.concat(person.childRels).forEach(function (rel) {
	                    preRequests.push(fs.fsRxGetData(rel.links.relationship.href + "/sources").do(function (relationship) {
	                        if (!!relationship && !!relationship.sourceDescriptions) {
	                            relationship.sourceDescriptions.forEach(function (source) {
	                                observer.next({
	                                    type: 'source',
	                                    personId: pid,
	                                    contents: source
	                                });
	                            });
	                        }
	                    }));
	                });
	                // Load hints
	                postRequests.push(fs.getHints(pid).do(function (hints) {
	                    hints.forEach(function (hint) {
	                        observer.next({
	                            type: 'hint',
	                            personId: pid,
	                            contents: hint
	                        });
	                    });
	                }));
	                // Load ordinances
	                if (isLDS) {
	                    postRequests.push(fs.getOrdinances(pid).do(function (ordinances) {
	                        observer.next({
	                            type: 'ordinances',
	                            personId: pid,
	                            contents: ordinances
	                        });
	                    }));
	                }
	                // Load memories
	                postRequests.push(fs.getMemories(pid).do(function (memories) {
	                    memories.media.forEach(function (media) {
	                        observer.next({
	                            type: 'media',
	                            personId: pid,
	                            contents: media
	                        });
	                    });
	                    memories.stories.forEach(function (story) {
	                        observer.next({
	                            type: 'story',
	                            personId: pid,
	                            contents: story
	                        });
	                    });
	                }));
	                // Load notes
	                postRequests.push(fs.getNotes(pid).do(function (notes) {
	                    notes.forEach(function (note) {
	                        observer.next({
	                            type: 'note',
	                            personId: pid,
	                            contents: note
	                        });
	                    });
	                }));
	                // Load the person's families if they are within scope.
	                // Modify FS families to only include persons that are in scope
	                // so that we emit family objects for all persons in scope.
	                if (!spouse) {
	                    postRequests.push(loadFamilies(pid, gensUp, gensDown));
	                }
	                // Return one observable that emits when all requests are completed.
	                return (_a = rx.Observable).merge.apply(_a, __spread(preRequests)).last()
	                    .do(function () {
	                    // since RF persons point to evidences, send the person after the sources (preRequests) but before everything else (postRequests)
	                    observer.next({
	                        type: 'person',
	                        contents: person
	                    });
	                })
	                    .flatMap(function () {
	                    return (_a = rx.Observable).merge.apply(_a, __spread(postRequests)).last();
	                    var _a;
	                });
	                var _a;
	            });
	        }
	        /**
	         * Load and store a person's families
	         */
	        function loadFamilies(pid, gensUp, gensDown) {
	            return fs.getFamilies(pid).do(function (families) {
	                // Spouses and children.
	                // Children are in scope if we haven't hit the gens down limit.
	                // Spouses are in scope if the children are in scope too.
	                if (gensDown < gensDownLimit) {
	                    families.spouseFamilies.forEach(function (family) {
	                        var spousePids = new Set();
	                        var coupleRel = family.coupleRel, childAndParentsRels = family.childAndParentsRels;
	                        childAndParentsRels.forEach(function (rel) {
	                            var spouseRel = !!rel.parent1 && rel.parent1.resourceId === pid ? rel.parent2 : rel.parent2;
	                            if (!!spouseRel && !!spouseRel.resourceId) {
	                                spousePids.add(spouseRel.resourceId);
	                            }
	                            pidQueue.next({
	                                pid: rel.child.resourceId,
	                                gensUp: gensUp,
	                                gensDown: gensDown + 1,
	                                spouse: false
	                            });
	                        });
	                        if (coupleRel) {
	                            spousePids.add(coupleRel.person1.resourceId === pid ? coupleRel.person2.resourceId : coupleRel.person1.resourceId);
	                        }
	                        spousePids.forEach(function (pid) {
	                            pidQueue.next({
	                                pid: pid,
	                                gensUp: gensUp,
	                                gensDown: gensDown,
	                                spouse: true
	                            });
	                        });
	                        storeFamily(family);
	                    });
	                }
	                // Parents are only processed for ancestors (gensDown === 0)
	                // that are not at the end of the scope (gensUp < gensUpLimit).
	                if (gensDown === 0 && gensUp < gensUpLimit) {
	                    families.parentFamilies.forEach(function (family) {
	                        // Remove sibling rels. They will be included, if in scope,
	                        // when processing descendants of the parents.
	                        family.childAndParentsRels = family.childAndParentsRels.filter(function (rel) {
	                            return rel.child.resourceId === pid;
	                        });
	                        storeFamily(family);
	                        // A couple rel isn't guaranteed to exist so we examine the
	                        // first childAndParents rel to get the mother and father.
	                        var capr = family.childAndParentsRels[0];
	                        if (capr) {
	                            if (capr.parent1) {
	                                pidQueue.next({
	                                    pid: capr.parent1.resourceId,
	                                    gensUp: gensUp + 1,
	                                    gensDown: gensDown,
	                                    spouse: false
	                                });
	                            }
	                            if (capr.parent2) {
	                                pidQueue.next({
	                                    pid: capr.parent2.resourceId,
	                                    gensUp: gensUp + 1,
	                                    gensDown: gensDown,
	                                    spouse: false
	                                });
	                            }
	                        }
	                    });
	                }
	            });
	        }
	        /**
	         * Check all of a person's families to see if those families are ready
	         * to be emitted.
	         */
	        function processFamilies(observer, pid) {
	            var familiesMap = personFamiliesIndex.get(pid);
	            if (familiesMap) {
	                try {
	                    for (var _a = __values(familiesMap.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var familyId = _b.value;
	                        if (isFamilyProcessed(familyId)) {
	                            observer.next({
	                                type: 'family',
	                                contents: familiesIndex.get(familyId)
	                            });
	                        }
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	            }
	            var e_1, _c;
	        }
	        /**
	         * Updates the family and person family indexes
	         */
	        function storeFamily(family) {
	            var childAndParentsRels = family.childAndParentsRels;
	            var familyId = family.id;
	            var originalFamily = familiesIndex.get(familyId);
	            // Merge with previously saved family, if one exists
	            if (originalFamily) {
	                if (!family.coupleRel) {
	                    family.coupleRel = originalFamily.coupleRel;
	                }
	                // Merge and dedup child rels
	                var childRelsMap_1 = new Map();
	                originalFamily.childAndParentsRels.forEach(function (rel) {
	                    childRelsMap_1.set(rel.id, rel);
	                });
	                family.childAndParentsRels.forEach(function (rel) {
	                    childRelsMap_1.set(rel.id, rel);
	                });
	                family.childAndParentsRels = Array.from(childRelsMap_1.values());
	            }
	            familiesIndex.set(familyId, family);
	            childAndParentsRels.forEach(function (rel) {
	                storePersonsFamily(rel.child.resourceId, familyId);
	                if (rel.parent1) {
	                    storePersonsFamily(rel.parent1.resourceId, familyId);
	                }
	                if (rel.parent2) {
	                    storePersonsFamily(rel.parent2.resourceId, familyId);
	                }
	            });
	            if (family.coupleRel) {
	                storePersonsFamily(family.coupleRel.person1.resourceId, familyId);
	                storePersonsFamily(family.coupleRel.person2.resourceId, familyId);
	            }
	        }
	        /**
	         * Add a familyID to a person in the child index
	         */
	        function storePersonsFamily(pid, familyId) {
	            var familiesMap;
	            if (personFamiliesIndex.has(pid)) {
	                familiesMap = personFamiliesIndex.get(pid);
	            }
	            else {
	                familiesMap = new Map();
	                personFamiliesIndex.set(pid, familiesMap);
	            }
	            familiesMap.set(familyId, true);
	        }
	        /**
	         * Return boolean whether all persons in the family have been emitted
	         */
	        function isFamilyProcessed(familyId) {
	            var family = familiesIndex.get(familyId), childAndParentsRels = family.childAndParentsRels, rel, i;
	            for (i = 0; i < childAndParentsRels.length; i++) {
	                rel = childAndParentsRels[i];
	                if (rel.parent1 && !processedPIDs.get(rel.parent1.resourceId)) {
	                    return false;
	                }
	                if (rel.parent2 && !processedPIDs.get(rel.parent2.resourceId)) {
	                    return false;
	                }
	                if (!processedPIDs.get(rel.child.resourceId)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        function getProgress() {
	            var progress = {
	                total: queuedPIDs.size,
	                complete: processedPIDs.size,
	                currentGen: currentGen
	            };
	            progress.remaining = progress.total - progress.complete;
	            progress.percent = progress.total && progress.complete ? progress.complete / progress.total : 0;
	            return progress;
	        }
	        function inScope(scope) {
	            var gensUp = scope.gensUp, gensDown = scope.gensDown, isRoot = gensUp === 0 && gensDown === 0, isAncestor = gensUp > 0 && gensDown === 0, isDescendant = gensDown > 0 && gensUp === 0, isCousin = !(isRoot || isAncestor || isDescendant);
	            return isRoot || (isAncestor && gensUp <= gensUpLimit) || (isDescendant && gensDown <= gensDownLimit) || (isCousin && gensDown <= gensDownLimit);
	        }
	    };
	    /**
	     * Returns an rx.AsyncSubject. Errors are emitted for network errors and HTTP
	     * status >= 400. Otherwise the response data is emitted.
	     */
	    FSService.prototype.fsRxGetData = function (url, options) {
	        return this.fsRxGet(url, options).map(function (response) {
	            return response.statusCode === 410 ? null : response.data;
	        });
	    };
	    /**
	     * Returns an rx.AsyncSubject. Errors are emitted for network errors and HTTP
	     * status >= 400. Otherwise the response is emitted.
	     */
	    FSService.prototype.fsRxGet = function (url, options, preferences) {
	        options = options || {};
	        options.method = 'GET';
	        return this.fsRxHTTP(url, options, preferences);
	    };
	    /**
	     * Returns an rx.AsyncSubject. Errors are emitted for network errors and HTTP
	     * status >= 400. Otherwise the response is emitted.
	     */
	    FSService.prototype.fsRxPost = function (url, data, preferences, contentType, accept, addLocale) {
	        if (contentType === void 0) { contentType = 'application/x-fs-v1+json'; }
	        if (accept === void 0) { accept = ''; }
	        if (addLocale === void 0) { addLocale = true; }
	        var headers = {
	            'Content-Type': contentType
	        };
	        if (accept != '') {
	            headers['Accept'] = accept;
	        }
	        var options = {
	            method: 'POST',
	            headers: headers,
	            body: data
	        };
	        return this.fsRxHTTP(url, options, preferences, addLocale);
	    };
	    /**
	     * Returns an rx.AsyncSubject. Errors are emitted for network errors and HTTP
	     * status >= 400. Otherwise the response is emitted.
	     * If preferences.expect403 is true, then don't post an error on 403, just return the error
	     */
	    FSService.prototype.fsRxHTTP = function (url, options, preferences, addLocale) {
	        if (preferences === void 0) { preferences = {}; }
	        if (addLocale === void 0) { addLocale = true; }
	        // force english so places don't get translated
	        if (addLocale) {
	            url += (url.includes('?') ? '&' : '?') + 'locale=en';
	        }
	        // tell user we're busy
	        this.server.incRequests();
	        var subject = new this.rx.AsyncSubject();
	        // set generic relationship terms header
	        if (!options) {
	            options = {};
	        }
	        if (!options.headers) {
	            options.headers = {};
	        }
	        // Commented out - FamilySearch deprecated this feature
	        // options.headers['X-FS-Feature-Tag'] = 'generic.relationship.terms';
	        this.fsRetryHTTP(url, options, subject, 1, 4, preferences);
	        return subject;
	    };
	    FSService.prototype.fsRetryHTTP = function (url, options, subject, tries, maxTries, preferences) {
	        var _this = this;
	        this.fs.request(url, options || {}, function (error, response) {
	            // outside angular
	            //this.$rootScope.$apply(() => {
	            _this.$timeout(function () {
	                if (error || (response.statusCode >= 400 && response.statusCode !== 410)) {
	                    if (error === 'FS_CANCEL') {
	                        _this.server.decRequests();
	                        subject.error(error);
	                    }
	                    else if (!!response && response.statusCode === 403 && preferences.expect403) {
	                        _this.server.decRequests();
	                        subject.error(response.statusCode);
	                    }
	                    else if (!!response && response.statusCode === 400 && preferences.expect400) {
	                        _this.server.decRequests();
	                        subject.error(error || (!!response.headers && response.headers.warning) || response.statusCode + " " + response.statusText);
	                    }
	                    else if ((!!response && (response.statusCode === 400 || response.statusCode === 403 || response.statusCode === 409)) || // don't retry these errors
	                        (tries >= maxTries && !(!!response && response.statusCode === 429))) {
	                        if (response.statusCode !== 401) {
	                            _this.messageBus.post({ msg: 'FS_ERROR', warn: true, warnParams: {
	                                    url: url,
	                                    error: error,
	                                    warning: !!response.headers ? response.headers.warning : '',
	                                    statusCode: response.statusCode,
	                                    statusText: response.statusText
	                                } });
	                        }
	                        _this.server.decRequests();
	                        subject.error(error || (!!response.headers && response.headers.warning) || response.statusCode + " " + response.statusText);
	                    }
	                    else {
	                        /* jshint ignore:start */
	                        _this.$timeout(function () {
	                            _this.fsRetryHTTP(url, options, subject, tries + 1, maxTries, preferences);
	                        }, 1000 * Math.pow(2, tries));
	                        /* jshint ignore:end */
	                    }
	                }
	                else {
	                    _this.server.decRequests();
	                    subject.next(response);
	                    subject.complete();
	                }
	            });
	        });
	    };
	    /**
	     * return the cache key for a person given the person id and whether we want a full or non-full person object
	     */
	    FSService.prototype.getPersonCacheKey = function (pid, full) {
	        return pid + (full ? '|f' : '|p');
	    };
	    return FSService;
	}());
	/**
	 * Calculate the familyId from an FS couple relationship. This method does not
	 * ensure that the relationship is actually a couple relationship.
	 *
	 * @param {Object} rel FS couple relationship
	 * @return {String} Family ID
	 */
	function familyIdFromCoupleRel(rel) {
	    var person1Id = rel.person1.resourceId, person2Id = rel.person2.resourceId;
	    return person1Id + ":" + person2Id;
	}
	/**
	 * Calculate the familyId from an FS child and parents relationships.
	 *
	 * @param {Object} rel FS child and parents relationship
	 * @return {String} Family ID
	 */
	function familyIdFromChildAndParentsRel(rel) {
	    if (!rel) {
	        return '';
	    }
	    var fatherId = rel.parent1 ? rel.parent1.resourceId : '';
	    var motherId = rel.parent2 ? rel.parent2.resourceId : '';
	    return fatherId + ":" + motherId; // client relies on the family ID being in the form fatherId:motherId
	}
	exports.default = FSService;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential - 2016-2017
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// Map FS fact types to RF fact types
	var FSFactTypes = {
	    // Person
	    'http://gedcomx.org/Adoption	': 'ADOP',
	    'http://gedcomx.org/AdultChristening': 'Adult Christening',
	    'http://gedcomx.org/Amnesty': 'Amnesty',
	    'http://gedcomx.org/Apprenticeship': 'Apprenticeship',
	    'http://gedcomx.org/Arrest': 'Arrest',
	    'http://gedcomx.org/Baptism': 'BAPM',
	    'http://gedcomx.org/Barmitzvah': 'BARM',
	    'http://gedcomx.org/Batmitzvah': 'BATM',
	    'http://gedcomx.org/Birth': 'BIRT',
	    'http://gedcomx.org/Blessing': 'BLES',
	    'http://gedcomx.org/Burial': 'BURI',
	    'http://gedcomx.org/Caste': 'CAST',
	    'http://gedcomx.org/Census': 'CENS',
	    'http://gedcomx.org/Christening': 'CHR',
	    'http://gedcomx.org/Circumcision': 'Circumcision',
	    'http://gedcomx.org/Clan': '_CLAN',
	    'http://gedcomx.org/Confirmation': 'CONF',
	    'http://gedcomx.org/Court': 'Court',
	    'http://gedcomx.org/Cremation': 'CREM',
	    'http://gedcomx.org/Death': 'DEAT',
	    'http://gedcomx.org/Education': 'EDUC',
	    'http://gedcomx.org/EducationEnrollment': 'Education Enrollment',
	    'http://gedcomx.org/Emigration': 'EMIG',
	    'http://gedcomx.org/Ethnicity': '_ETHN',
	    'http://gedcomx.org/Excommunication': 'EXCM',
	    'http://gedcomx.org/FirstCommunion': 'FCOM',
	    'http://gedcomx.org/Funeral': '_FUN',
	    'http://gedcomx.org/GenderChange': 'Gender Change',
	    'http://gedcomx.org/Graduation': 'GRAD',
	    'http://gedcomx.org/Immigration': 'IMMI',
	    'http://gedcomx.org/Imprisonment': 'Imprisonment',
	    'http://gedcomx.org/Inquest': 'Inquest',
	    'http://gedcomx.org/LandTransaction': 'Land transaction',
	    'http://gedcomx.org/Language': 'Language',
	    'http://gedcomx.org/Living': 'Living',
	    'http://gedcomx.org/MaritalStatus': '_MSTAT',
	    'http://gedcomx.org/Medical': 'MDCL',
	    'http://gedcomx.org/MilitaryAward': 'Military Award',
	    'http://gedcomx.org/MilitaryDischarge': 'Military Discharge',
	    'http://gedcomx.org/MilitaryDraftRegistration': 'Military Draft Registration',
	    'http://gedcomx.org/MilitaryInduction': 'Military Induction',
	    'http://gedcomx.org/MilitaryService': '_MILT',
	    'http://gedcomx.org/Mission': '_MISN',
	    'http://gedcomx.org/MoveFrom': 'Move From',
	    'http://gedcomx.org/MoveTo': '_MOVE',
	    'http://gedcomx.org/MultipleBirth': 'Multiple Birth',
	    'http://gedcomx.org/NationalId': '_NID',
	    'http://gedcomx.org/Nationality': 'NATI',
	    'http://gedcomx.org/Naturalization': 'NATU',
	    'http://gedcomx.org/NumberOfMarriages': 'Number of Marriages',
	    'http://gedcomx.org/Obituary': '_OBIT',
	    'http://gedcomx.org/Occupation': 'OCCU',
	    'http://gedcomx.org/Ordination': 'ORDN',
	    'http://gedcomx.org/Pardon': 'Pardon',
	    'http://gedcomx.org/PhysicalDescription': 'DSCR',
	    'http://gedcomx.org/Probate': 'PROB',
	    'http://gedcomx.org/Property': 'PROP',
	    'http://gedcomx.org/Religion': 'RELI',
	    'http://gedcomx.org/Residence': 'RESI',
	    'http://gedcomx.org/Retirement': 'RETI',
	    'http://gedcomx.org/StillBirth': '_STIL',
	    'http://gedcomx.org/TaxAssessment': 'Tax Assessment',
	    'http://gedcomx.org/Will': 'WILL',
	    'http://gedcomx.org/Visit': 'Visit',
	    'http://gedcomx.org/Yahrzeit': 'Yahrzeit',
	    'http://familysearch.org/v1/Affiliation': '_AFIL',
	    'http://familysearch.org/v1/DiedBeforeEight': '_EIGHT',
	    'http://familysearch.org/v1/LifeSketch': '_BIO',
	    'http://familysearch.org/v1/TitleOfNobility': '_TITLE',
	    'http://familysearch.org/v1/TribeName': '_TRIB',
	    // Couple
	    'http://gedcomx.org/Annulment': 'ANUL',
	    'http://gedcomx.org/CivilUnion': '_CIVL',
	    'http://gedcomx.org/CommonLawMarriage': 'CLAW',
	    'http://gedcomx.org/Divorce': 'DIV',
	    'http://gedcomx.org/DivorceFiling': 'DIVF',
	    'http://gedcomx.org/DomesticPartnership': 'Domestic Partnership',
	    'http://gedcomx.org/Engagement': 'ENG',
	    'http://gedcomx.org/Marriage': 'MARR',
	    'http://gedcomx.org/MarriageBanns': 'MARB',
	    'http://gedcomx.org/MarriageContract': 'MARC',
	    'http://gedcomx.org/MarriageLicense': 'MARL',
	    'http://gedcomx.org/MarriageNotice': 'Marriage Notice',
	    'http://gedcomx.org/NumberOfChildren': 'NCHI',
	    'http://gedcomx.org/Separation': '_SEPR',
	    // Parent-child relationship facts
	    'http://gedcomx.org/AdoptiveParent': 'ADOPTIVE_PARENT',
	    'http://gedcomx.org/BiologicalParent': 'BIOLOGICAL_PARENT',
	    'http://gedcomx.org/FosterParent': 'FOSTER_PARENT',
	    'http://gedcomx.org/GuardianParent': 'GUARDIAN',
	    'http://gedcomx.org/StepParent': 'STEP_PARENT',
	    'http://gedcomx.org/SociologicalParent': 'Sociological Parent'
	};
	exports.FSFactTypes = FSFactTypes;
	// Map RF fact types to FS fact types
	var RFFactTypes = {};
	exports.RFFactTypes = RFFactTypes;
	for (var prop in FSFactTypes) {
	    if (FSFactTypes[prop]) {
	        RFFactTypes[FSFactTypes[prop]] = prop;
	    }
	}
	// Map FS name types to RF name types
	var FSNameTypes = {
	    'http://gedcomx.org/BirthName': '_BIRTNM',
	    'http://gedcomx.org/MarriedName': '_MARNM',
	    'http://gedcomx.org/AlsoKnownAs': 'ALIA',
	    'http://gedcomx.org/Nickname': 'NICK'
	};
	exports.FSNameTypes = FSNameTypes;
	// Map RF name types to FS name types
	var RFNameTypes = {};
	exports.RFNameTypes = RFNameTypes;
	for (var prop in FSNameTypes) {
	    RFNameTypes[FSNameTypes[prop]] = prop;
	}


/***/ }),
/* 222 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var FS = 'familysearch.org';
	var FsImportService = /** @class */ (function () {
	    FsImportService.$inject = ["$log", "rx", "moment", "messageBus", "fs", "segment", "currentTree", "treeUsers", "persons", "families", "evidences", "leads", "medias", "notes", "ordinances", "sources", "stories", "utils"];
	    function FsImportService($log, rx, moment, messageBus, fs, segment, currentTree, treeUsers, persons, families, evidences, leads, medias, notes, ordinances, sources, stories, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.rx = rx;
	        this.moment = moment;
	        this.messageBus = messageBus;
	        this.fs = fs;
	        this.segment = segment;
	        this.currentTree = currentTree;
	        this.treeUsers = treeUsers;
	        this.persons = persons;
	        this.families = families;
	        this.evidences = evidences;
	        this.leads = leads;
	        this.medias = medias;
	        this.ordinances = ordinances;
	        this.notes = notes;
	        this.sources = sources;
	        this.stories = stories;
	        this.utils = utils;
	    }
	    FsImportService.prototype.doImport = function (root, genUp, genDown, alreadyDownloadedPIDs, alreadyDownloadedMIDs, alreadyDownloadedSIDs) {
	        var _this = this;
	        this.reset();
	        this.fsAccessToken = this.fs.getAccessToken();
	        this.progress = { requests: 0, responses: 0, name: '' };
	        var progressStream = new this.rx.BehaviorSubject(this.progress);
	        var personEvidencesMapStream = new this.rx.BehaviorSubject(this.personEvidencesMap);
	        var pidMapStream = new this.rx.BehaviorSubject(this.pidMap);
	        this.currentTree.stream().take(1).flatMap(function (tree) {
	            _this.tree = tree;
	            return _this.fs.readAncestors(root, genUp, genDown, alreadyDownloadedPIDs);
	        }).subscribe(function (x) {
	            _this.progress.requests++;
	            progressStream.next(_this.progress);
	            switch (x.type) {
	                case 'person':
	                    _this.savePersonEnqueue(x.contents, alreadyDownloadedPIDs, personEvidencesMapStream, pidMapStream, progressStream);
	                    break;
	                case 'ordinances':
	                    _this.saveOrdinancesEnqueue(x.contents, x.personId, pidMapStream, progressStream);
	                    break;
	                case 'media':
	                    _this.saveMediaEnqueue(x.contents, x.personId, alreadyDownloadedMIDs, progressStream);
	                    break;
	                case 'story':
	                    _this.saveStoryEnqueue(x.contents, x.personId, alreadyDownloadedSIDs, progressStream);
	                    break;
	                case 'note':
	                    _this.saveNoteEnqueue(x.contents, x.personId, pidMapStream, progressStream);
	                    break;
	                case 'hint':
	                    _this.saveLeadEnqueue(x.contents, x.personId, pidMapStream, progressStream);
	                    break;
	                case 'source':
	                    _this.saveEvidenceEnqueue(x.contents, x.personId, personEvidencesMapStream, progressStream);
	                    break;
	                case 'family':
	                    _this.saveFamilyEnqueue(x.contents, progressStream);
	                    break;
	            }
	        }, function (error) {
	            progressStream.error(error);
	        }, function () {
	            _this.readAncestorsComplete = true;
	            _this.pidMapCheckComplete(pidMapStream);
	            _this.personEvidencesCheckComplete(personEvidencesMapStream);
	            _this.progressCheckComplete(progressStream);
	        });
	        // save media and stories and families
	        pidMapStream.subscribe(function () {
	            // ignore
	        }, function (error) {
	            progressStream.error(error);
	        }, function () {
	            _this.saveMedias(progressStream);
	            _this.saveStories(progressStream);
	            _this.rx.Observable.forkJoin([_this.saveFamilies(alreadyDownloadedPIDs, progressStream), _this.saveCoupleFacts(alreadyDownloadedPIDs, progressStream)])
	                .subscribe(function (_a) {
	                var _b = __read(_a, 2), prefParentUpdates = _b[0], factUpdates = _b[1];
	                _this.updatePersons(prefParentUpdates, factUpdates, progressStream);
	            }, function (error) {
	                _this.$log.debug('fsImport.doImport.error', error);
	                progressStream.error(error);
	            });
	        });
	        return progressStream;
	    };
	    FsImportService.prototype.reset = function () {
	        this.pidRequests = 0;
	        this.rootFSID = '';
	        this.readAncestorsComplete = false;
	        this.pidMap = new Map(); // person fsid -> rfid
	        this.mediaMap = new Map(); // media fsid -> {media, fsids}
	        this.storyMap = new Map(); // story fsid -> {story, fsids}
	        this.familyMap = new Map(); // family hid:wid -> {husbandId, wifeId, childRels}
	        this.prefParentsMap = new Map(); // rfid -> fsid
	        this.personAttrsMap = new Map(); // rfid -> {dl, eol}
	        this.coupleFactMap = new Map(); // couple fact fsid -> {evidence, fact, fsid1, fsid2}
	        this.personEvidencesMap = new Map(); // fsid -> [rfid]
	    };
	    FsImportService.prototype.progressUpdater = function (progressStream, name, error) {
	        this.progress.responses++;
	        if (!!name) {
	            this.progress.name = name;
	        }
	        progressStream.next(Object.assign({}, this.progress, { error: error }));
	        this.progressCheckComplete(progressStream);
	    };
	    FsImportService.prototype.progressCheckComplete = function (progressStream) {
	        if (this.readAncestorsComplete && this.progress.requests === this.progress.responses) {
	            this.reset();
	            progressStream.complete();
	        }
	    };
	    FsImportService.prototype.pidMapUpdater = function (pidMapStream, fsid, pid) {
	        this.pidMap.set(fsid, pid);
	        pidMapStream.next(this.pidMap);
	        this.pidMapCheckComplete(pidMapStream);
	    };
	    FsImportService.prototype.pidMapCheckComplete = function (pidMapStream) {
	        if (this.readAncestorsComplete && this.pidRequests === this.pidMap.size) {
	            pidMapStream.complete();
	        }
	    };
	    FsImportService.prototype.personEvidencesMapUpdater = function (personEvidencesMapStream, fsid, eid) {
	        this.personEvidencesMap.get(fsid).results.push(eid);
	        personEvidencesMapStream.next(this.personEvidencesMap);
	        this.personEvidencesCheckComplete(personEvidencesMapStream);
	    };
	    FsImportService.prototype.personEvidencesCheckComplete = function (personEvidencesMapStream) {
	        if (this.readAncestorsComplete) {
	            var totalRequests_1 = 0;
	            var totalResults_1 = 0;
	            this.personEvidencesMap.forEach(function (pe) {
	                totalRequests_1 += pe.requests;
	                totalResults_1 += pe.results.length;
	            });
	            if (totalRequests_1 === totalResults_1) {
	                personEvidencesMapStream.complete();
	            }
	        }
	    };
	    FsImportService.prototype.savePersonEnqueue = function (fs, alreadyDownloadedPIDs, personEvidencesMapStream, pidMapStream, progressStream) {
	        var _this = this;
	        var p = this.fs.toRFPerson(fs);
	        var fsid = p.externalIds.get(FS).id;
	        if (this.pidMap.has(fsid)) {
	            this.progressUpdater(progressStream);
	            return; // just in case
	        }
	        this.pidRequests++;
	        // set root?
	        if (!this.rootFSID) {
	            this.rootFSID = fsid;
	        }
	        // we shouldn't be called if we've already downloaded this person, but double-check
	        if (alreadyDownloadedPIDs.has(fsid)) {
	            this.pidMapUpdater(pidMapStream, fsid, alreadyDownloadedPIDs.get(fsid));
	            this.progressUpdater(progressStream);
	            return; // just in case
	        }
	        var saving = false;
	        personEvidencesMapStream.filter(function (pem) {
	            return !pem.has(fsid) || pem.get(fsid).requests === pem.get(fsid).results.length;
	        }).take(1).subscribe(function () {
	            saving = true;
	            _this.savePerson(p, alreadyDownloadedPIDs, pidMapStream, progressStream);
	        }, function () {
	            if (!saving) {
	                _this.savePerson(p, alreadyDownloadedPIDs, pidMapStream, progressStream);
	            }
	        }, function () {
	            if (!saving) {
	                _this.savePerson(p, alreadyDownloadedPIDs, pidMapStream, progressStream);
	            }
	        });
	    };
	    FsImportService.prototype.savePerson = function (p, alreadyDownloadedPIDs, pidMapStream, progressStream) {
	        var _this = this;
	        var profilePhoto = p.profilePhoto;
	        p.profilePhoto = 0;
	        var fsid = p.externalIds.get(FS).id;
	        // save preferred parents for later
	        var preferredParentsFamilyId = '';
	        if (!!p.preferredParentsFamilyId) {
	            preferredParentsFamilyId = p.preferredParentsFamilyId;
	        }
	        p.preferredParentsFamilyId = 0;
	        // some fs people are CRAZY - KDQJ-GTH has over 1500 facts
	        // we can't store that many facts, so trim: 20 names and 50 facts at most
	        if (p.names.size > 20) {
	            var cnt = 0;
	            try {
	                for (var _a = __values(p.names.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var k = _b.value;
	                    if (cnt >= 20) {
	                        p.names.delete(k);
	                    }
	                    cnt++;
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        if (p.facts.size > 50) {
	            var cnt = 0;
	            try {
	                for (var _d = __values(p.facts.keys()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                    var k = _e.value;
	                    if (cnt >= 50) {
	                        p.facts.delete(k);
	                    }
	                    cnt++;
	                }
	            }
	            catch (e_2_1) { e_2 = { error: e_2_1 }; }
	            finally {
	                try {
	                    if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
	                }
	                finally { if (e_2) throw e_2.error; }
	            }
	        }
	        p.facts.forEach(function (fact) {
	            if (!!fact.principalId1) {
	                var e = _this.createEvidence(fact, fsid, p._url);
	                e.personas.set(2, { names: new Map(), facts: new Map(), principal: true, relatedToKey: 1, relationshipType: 'SPOUSE' });
	                // couple fact {evidence, fact, fsid1, fsid2}
	                var coupleFact = _this.coupleFactMap.get(fact.externalIds.get(FS).id);
	                // re-use existing fact
	                if (!!coupleFact) {
	                    coupleFact.fsid2 = fsid;
	                    if (!!coupleFact.fsid1 && !!coupleFact.fsid2 && (p.gender === 'MALE' || p.gender === 'FEMALE')) {
	                        _this.progress.requests++; // add family
	                        _this.saveRFFamilyEnqueue({
	                            husbandId: p.gender === 'MALE' ? coupleFact.fsid2 : coupleFact.fsid1,
	                            wifeId: p.gender === 'MALE' ? coupleFact.fsid1 : coupleFact.fsid2,
	                            childRels: new Map()
	                        }, progressStream);
	                    }
	                }
	                else if (alreadyDownloadedPIDs.has(fact.principalId1)) {
	                    var coupleFact_1 = { evidence: e, fact: fact, fsid1: fact.principalId1, fsid2: fsid };
	                    _this.progress.requests++;
	                    _this.coupleFactMap.set(fact.externalIds.get(FS).id, coupleFact_1);
	                    if (!!coupleFact_1.fsid1 && !!coupleFact_1.fsid2 && (p.gender === 'MALE' || p.gender === 'FEMALE')) {
	                        _this.progress.requests++; // add family
	                        _this.saveRFFamilyEnqueue({
	                            husbandId: p.gender === 'MALE' ? coupleFact_1.fsid2 : coupleFact_1.fsid1,
	                            wifeId: p.gender === 'MALE' ? coupleFact_1.fsid1 : coupleFact_1.fsid2,
	                            childRels: new Map()
	                        }, progressStream);
	                    }
	                    progressStream.next(_this.progress);
	                }
	                else {
	                    var coupleFact_2 = { evidence: e, fact: fact, fsid1: fsid };
	                    _this.progress.requests++;
	                    _this.coupleFactMap.set(fact.externalIds.get(FS).id, coupleFact_2);
	                    progressStream.next(_this.progress);
	                }
	                fact.principalId1 = 0; // update later
	            }
	        });
	        // add facts for evidences
	        if (this.personEvidencesMap.has(fsid)) {
	            this.personEvidencesMap.get(fsid).results.forEach(function (eid) {
	                var key = _this.utils.randomKey();
	                p.facts.set(key, {
	                    type: 'SOUR',
	                    principal: true,
	                    evidencePersonas: new Map([[eid, 1]]),
	                    externalIds: new Map()
	                });
	            });
	        }
	        var m = null;
	        var fullName = this.persons.getNameText(this.persons.getDefaultNameForm(this.persons.getPreferredName(p)), true);
	        if (!!profilePhoto) {
	            // add person, then media
	            m = {
	                id: this.utils.randomId(),
	                title: fullName + ' profile photo',
	                externalIds: new Map(),
	                url: profilePhoto + (profilePhoto.indexOf('?') >= 0 ? '&' : '?') + 'sessionId=' + this.fsAccessToken,
	                fileInfos: new Map([[0, {
	                            contentType: 'URL',
	                            fileName: 'profile photo'
	                        }]]),
	                personIds: new Map()
	            };
	            p.profilePhoto = m.id;
	        }
	        this.persons.create(p, { eol: p._eol ? 'TRUE' : 'FALSE', dl: p._dl ? 'TRUE' : 'FALSE' })
	            .flatMap(function (result) {
	            // remember dl + eol
	            _this.personAttrsMap.set(result.id, { dl: p._dl, eol: p._eol });
	            p = result;
	            // set preferred parents
	            _this.prefParentsMap.set(p.id, preferredParentsFamilyId);
	            // set tree root
	            if (!!_this.rootFSID && _this.rootFSID === fsid) {
	                _this.setTreeRoot(p.id);
	            }
	            // add profile picture?
	            if (!!m) {
	                m.personIds.set(p.id, true);
	                return _this.medias.create(m, { silence404: true }).catch(function () {
	                    p.profilePhoto = 0;
	                    return _this.persons.update(p);
	                });
	            }
	            else {
	                return _this.rx.Observable.of(true);
	            }
	        }).subscribe(function () {
	            _this.pidMapUpdater(pidMapStream, fsid, p.id);
	            _this.progressUpdater(progressStream, fullName);
	        }, function (error) {
	            _this.progressUpdater(progressStream, '', error);
	        });
	        var e_1, _c, e_2, _f;
	    };
	    FsImportService.prototype.saveOrdinancesEnqueue = function (fss, fsid, pidMapStream, progressStream) {
	        var _this = this;
	        var saving = false;
	        pidMapStream.filter(function (pidMap) { return pidMap.has(fsid); }).take(1).subscribe(function (pidMap) {
	            saving = true;
	            _this.saveOrdinances(fss, pidMap.get(fsid), progressStream);
	        }, function (error) {
	            if (!saving) {
	                _this.progressUpdater(progressStream, '', error);
	            }
	        }, function () {
	            if (!saving) {
	                _this.progressUpdater(progressStream, '', 'NOT_FOUND');
	            }
	        });
	    };
	    FsImportService.prototype.saveOrdinances = function (fss, id, progressStream) {
	        var _this = this;
	        var o = {
	            id: id,
	            ordinances: new Map(fss.map(function (fs) {
	                var rfo = _this.fs.toRFOrdinance(fs);
	                return [_this.utils.randomKey(), rfo];
	            }))
	        };
	        this.ordinances.create(o).subscribe(function () {
	            _this.progressUpdater(progressStream);
	        }, function (error) {
	            _this.progressUpdater(progressStream, '', error);
	        });
	    };
	    FsImportService.prototype.saveMediaEnqueue = function (fs, fspid, alreadyDownloadedMIDs, progressStream) {
	        var m = this.fs.toRFMedia(fs, 0);
	        var fsmid = m.externalIds.get(FS).id;
	        if (this.mediaMap.has(fsmid)) {
	            this.mediaMap.get(m.externalIds.get(FS).id).fsids.push(fspid);
	            this.progressUpdater(progressStream);
	        }
	        else if (alreadyDownloadedMIDs.has(fsmid)) {
	            this.mediaMap.set(fsmid, { media: { id: alreadyDownloadedMIDs.get(fsmid) }, fsids: [fspid] });
	        }
	        else {
	            this.mediaMap.set(fsmid, { media: m, fsids: [fspid] });
	        }
	    };
	    FsImportService.prototype.saveMedias = function (progressStream) {
	        var _this = this;
	        this.mediaMap.forEach(function (m) {
	            var pids = m.fsids.map(function (fsid) { return _this.pidMap.has(fsid) ? _this.pidMap.get(fsid) : 0; }).filter(function (pid) { return !!pid; });
	            _this.saveMedia(m.media, pids, progressStream);
	        });
	    };
	    FsImportService.prototype.saveMedia = function (m, pids, progressStream) {
	        var _this = this;
	        if (!!m.id) {
	            // update existing
	            this.medias.streamId(m.id).take(1).flatMap(function (m) {
	                // add ids
	                pids.forEach(function (pid) {
	                    m.personIds.set(pid, true);
	                });
	                return _this.medias.update(m);
	            }).subscribe(function () {
	                _this.progressUpdater(progressStream);
	            }, function (error) {
	                _this.progressUpdater(progressStream, '', error);
	            });
	        }
	        else {
	            // add new
	            var fileName_1 = m._fileName;
	            m.url = m._url + (m._url.indexOf('?') >= 0 ? '&' : '?') + 'sessionId=' + this.fsAccessToken;
	            m.fileInfos.set(0, {
	                contentType: 'URL',
	                fileName: m._fileName || 'media'
	            });
	            pids.forEach(function (pid) {
	                m.personIds.set(pid, true);
	            });
	            this.medias.create(m, { silence404: true }).subscribe(function () {
	                _this.progressUpdater(progressStream, fileName_1);
	            }, function () {
	                // FS occasionally returns errors reading media; fail silently so the import succeeds
	                // there's nothing we can do at this point anyway
	                _this.progressUpdater(progressStream, '');
	            });
	        }
	    };
	    FsImportService.prototype.saveStoryEnqueue = function (fs, fspid, alreadyDownloadedSIDs, progressStream) {
	        var s = this.fs.toRFStory(fs, 0);
	        var fssid = s.externalIds.get(FS).id;
	        if (this.storyMap.has(fssid)) {
	            this.storyMap.get(s.externalIds.get(FS).id).fsids.push(fspid);
	            this.progressUpdater(progressStream);
	        }
	        else if (alreadyDownloadedSIDs.has(fssid)) {
	            this.storyMap.set(fssid, { story: { id: alreadyDownloadedSIDs.get(fssid) }, fsids: [fspid] });
	        }
	        else {
	            this.storyMap.set(fssid, { story: s, fsids: [fspid] });
	        }
	    };
	    FsImportService.prototype.saveStories = function (progressStream) {
	        var _this = this;
	        this.storyMap.forEach(function (s) {
	            var pids = s.fsids.map(function (fsid) { return _this.pidMap.has(fsid) ? _this.pidMap.get(fsid) : 0; }).filter(function (pid) { return !!pid; });
	            _this.saveStory(s.story, pids, progressStream);
	        });
	    };
	    FsImportService.prototype.saveStory = function (s, pids, progressStream) {
	        var _this = this;
	        if (!!s.id) {
	            // update existing
	            this.stories.streamId(s.id).take(1).flatMap(function (s) {
	                // add ids
	                pids.forEach(function (pid) {
	                    s.personIds.set(pid, true);
	                });
	                return _this.stories.update(s);
	            }).subscribe(function () {
	                _this.progressUpdater(progressStream);
	            }, function (error) {
	                _this.progressUpdater(progressStream, '', error);
	            });
	        }
	        else {
	            // add new
	            // add ids
	            pids.forEach(function (pid) {
	                s.personIds.set(pid, true);
	            });
	            if (!!s._url) {
	                // add media, then story
	                var m_1 = {
	                    title: s.title,
	                    externalIds: new Map(),
	                    url: s._url + (s._url.indexOf('?') >= 0 ? '&' : '?') + 'sessionId=' + this.fsAccessToken,
	                    fileInfos: new Map([[0, {
	                                contentType: 'URL',
	                                fileName: 'story media'
	                            }]]),
	                    personIds: new Map()
	                };
	                this.medias.create(m_1, { silence404: true }).flatMap(function (m) {
	                    s.mediaIds.set(m.id, true);
	                    return _this.stories.create(s);
	                }).subscribe(function () {
	                    _this.progressUpdater(progressStream);
	                }, function () {
	                    // FS occasionally returns errors reading media; fail silently so the import succeeds
	                    // there's nothing we can do at this point anyway
	                    s.mediaIds.delete(m_1.id);
	                    _this.progressUpdater(progressStream, '');
	                });
	            }
	            else {
	                this.stories.create(s).subscribe(function () {
	                    _this.progressUpdater(progressStream);
	                }, function (error) {
	                    _this.progressUpdater(progressStream, '', error);
	                });
	            }
	        }
	    };
	    FsImportService.prototype.saveNoteEnqueue = function (fs, fsid, pidMapStream, progressStream) {
	        var _this = this;
	        var saving = false;
	        pidMapStream.filter(function (pidMap) { return pidMap.has(fsid); }).take(1).subscribe(function (pidMap) {
	            saving = true;
	            _this.saveNote(fs, pidMap.get(fsid), progressStream);
	        }, function (error) {
	            if (!saving) {
	                _this.progressUpdater(progressStream, '', error);
	            }
	        }, function () {
	            if (!saving) {
	                _this.progressUpdater(progressStream, '', 'NOT_FOUND');
	            }
	        });
	    };
	    FsImportService.prototype.saveNote = function (fs, pid, progressStream) {
	        var _this = this;
	        var n = this.fs.toRFNote(fs, pid);
	        this.notes.create(n).subscribe(function () {
	            _this.progressUpdater(progressStream);
	        }, function (error) {
	            _this.progressUpdater(progressStream, '', error);
	        });
	    };
	    FsImportService.prototype.saveLeadEnqueue = function (fs, fsid, pidMapStream, progressStream) {
	        var _this = this;
	        var saving = false;
	        pidMapStream.filter(function (pidMap) { return pidMap.has(fsid); }).take(1).subscribe(function (pidMap) {
	            saving = true;
	            _this.saveLead(fs, pidMap.get(fsid), progressStream);
	        }, function (error) {
	            if (!saving) {
	                _this.progressUpdater(progressStream, '', error);
	            }
	        }, function () {
	            if (!saving) {
	                _this.progressUpdater(progressStream, '', 'NOT_FOUND');
	            }
	        });
	    };
	    FsImportService.prototype.saveLead = function (fs, pid, progressStream) {
	        var _this = this;
	        var attrs = this.personAttrsMap.get(pid);
	        // is this a good idea?
	        if (this.tree.preferences['LEADS_FOR_ALL'] === 'TRUE' ||
	            (this.tree.preferences['LEADS_FOR_DL'] === 'TRUE' && attrs.dl) ||
	            (this.tree.preferences['LEADS_FOR_EOL'] === 'TRUE' && attrs.eol)) {
	            var l = this.fs.toRFLead(fs, pid);
	            this.leads.create(l).subscribe(function () {
	                _this.progressUpdater(progressStream);
	            }, function (error) {
	                _this.progressUpdater(progressStream, '', error);
	            });
	        }
	        else {
	            this.progressUpdater(progressStream);
	        }
	    };
	    FsImportService.prototype.saveEvidenceEnqueue = function (fs, fsid, personEvidencesMapStream, progressStream) {
	        // don't need to enqueue
	        if (!this.personEvidencesMap.has(fsid)) {
	            this.personEvidencesMap.set(fsid, { requests: 1, results: [] });
	        }
	        else {
	            this.personEvidencesMap.get(fsid).requests++;
	        }
	        personEvidencesMapStream.next(this.personEvidencesMap);
	        this.saveEvidence(fs, fsid, personEvidencesMapStream, progressStream);
	    };
	    FsImportService.prototype.saveEvidence = function (fs, fsid, personEvidencesMapStream, progressStream) {
	        var _this = this;
	        var e = this.fs.toRFEvidence(fs);
	        this.sources.stream().take(1).flatMap(function (sourceMap) {
	            var sourceId = 0;
	            if (!!e._sourceAbbr) {
	                try {
	                    for (var sourceMap_1 = __values(sourceMap), sourceMap_1_1 = sourceMap_1.next(); !sourceMap_1_1.done; sourceMap_1_1 = sourceMap_1.next()) {
	                        var _a = __read(sourceMap_1_1.value, 2), k = _a[0], v = _a[1];
	                        if (v.abbr === e._sourceAbbr) {
	                            sourceId = k;
	                            break;
	                        }
	                    }
	                }
	                catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                finally {
	                    try {
	                        if (sourceMap_1_1 && !sourceMap_1_1.done && (_b = sourceMap_1.return)) _b.call(sourceMap_1);
	                    }
	                    finally { if (e_3) throw e_3.error; }
	                }
	            }
	            return sourceId > 0 || !e._sourceAbbr ? _this.rx.Observable.of(sourceId) : _this.sources.create({
	                id: 0,
	                abbr: e._sourceAbbr || 'Source',
	                title: e._sourceAbbr,
	                externalIds: new Map(),
	                mediaIds: new Map()
	            }).map(function (source) { return source.id; });
	            var e_3, _b;
	        }).flatMap(function (sourceId) {
	            e.citation.sourceId = sourceId;
	            return _this.evidences.create(e);
	        }).subscribe(function (e) {
	            _this.personEvidencesMapUpdater(personEvidencesMapStream, fsid, e.id);
	            _this.progressUpdater(progressStream);
	        }, function (error) {
	            _this.progressUpdater(progressStream, '', error);
	        });
	    };
	    FsImportService.prototype.saveFamilyEnqueue = function (fs, progressStream) {
	        var f = this.fs.toRFFamily(fs);
	        this.saveRFFamilyEnqueue(f, progressStream);
	    };
	    FsImportService.prototype.saveRFFamilyEnqueue = function (f, progressStream) {
	        var fsid = (!!f.husbandId ? f.husbandId : '') + ':' + (!!f.wifeId ? f.wifeId : '');
	        if (this.familyMap.has(fsid)) {
	            var family_1 = this.familyMap.get(fsid);
	            f.childRels.forEach(function (value, key) {
	                family_1.childRels.set(key, value);
	            });
	            this.progressUpdater(progressStream); // family add already requested
	        }
	        else {
	            this.familyMap.set(fsid, {
	                husbandId: f.husbandId,
	                wifeId: f.wifeId,
	                childRels: new Map(Array.from(f.childRels.entries()))
	            });
	        }
	    };
	    FsImportService.prototype.saveFamilies = function (alreadyDownloadedPIDs, progressStream) {
	        var _this = this;
	        var parentCountsMap = new Map();
	        var families = [];
	        this.familyMap.forEach(function (f, key) {
	            var husbandId = _this.findPerson(f.husbandId, alreadyDownloadedPIDs);
	            var wifeId = _this.findPerson(f.wifeId, alreadyDownloadedPIDs);
	            var childRels = new Map(Array.from(f.childRels.entries()).map(function (entry) {
	                var cid = _this.findPerson(entry[0], alreadyDownloadedPIDs);
	                // add new parent counts
	                if (!!cid) {
	                    parentCountsMap.set(cid, parentCountsMap.has(cid) ? parentCountsMap.get(cid) + 1 : 1);
	                }
	                return [cid, entry[1]];
	            }).filter(function (entry) { return !!entry[0]; }));
	            if ((husbandId === 0 ? 0 : 1) + (wifeId === 0 ? 0 : 1) + childRels.size < 2) {
	                _this.progressUpdater(progressStream);
	            }
	            else {
	                families.push({ key: key, husbandId: husbandId, wifeId: wifeId, childRels: childRels });
	            }
	        });
	        if (families.length === 0) {
	            return this.rx.Observable.of([]);
	        }
	        return this.families.stream().take(1).flatMap(function (fm) {
	            // add existing families to parent counts
	            fm.forEach(function (f) {
	                try {
	                    for (var _a = __values(f.childRels.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var cid = _b.value;
	                        if (parentCountsMap.has(cid)) {
	                            parentCountsMap.set(cid, parentCountsMap.get(cid) + 1);
	                        }
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	                var e_4, _c;
	            });
	            // save the families
	            return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(families.map(function (family) {
	                return _this.saveFamily(fm, family.key, family.husbandId, family.wifeId, family.childRels, parentCountsMap, progressStream);
	            })));
	            var _a;
	        });
	    };
	    FsImportService.prototype.saveFamily = function (fm, fsid, husbandId, wifeId, childRels, parentCountsMap, progressStream) {
	        var _this = this;
	        var f = null;
	        try {
	            for (var _a = __values(fm.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var ef = _b.value;
	                if (ef.husbandId === husbandId && ef.wifeId === wifeId) {
	                    f = ef;
	                    break;
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        if (!f) {
	            f = { husbandId: husbandId, wifeId: wifeId, childRels: new Map() };
	        }
	        childRels.forEach(function (rels, cid) {
	            if (!f.childRels.has(cid)) {
	                f.childRels.set(cid, rels);
	            }
	            else if (parentCountsMap.has(cid)) {
	                parentCountsMap.set(cid, parentCountsMap.get(cid) - 1);
	            }
	        });
	        if (!!f.id) {
	            // update existing
	            return this.families.update(f).map(function (f) {
	                var prefParentUpdates = _this.getPrefParentUpdates(parentCountsMap, f, fsid);
	                _this.progress.requests += prefParentUpdates.length;
	                _this.progressUpdater(progressStream);
	                return prefParentUpdates;
	            });
	        }
	        else {
	            // create new
	            return this.families.create(f).map(function (f) {
	                var prefParentUpdates = _this.getPrefParentUpdates(parentCountsMap, f, fsid);
	                _this.progress.requests += prefParentUpdates.length;
	                _this.progressUpdater(progressStream);
	                return prefParentUpdates;
	            });
	        }
	        var e_5, _c;
	    };
	    FsImportService.prototype.getPrefParentUpdates = function (parentCountsMap, f, fsid) {
	        var _this = this;
	        var updates = [];
	        f.childRels.forEach(function (v, cid) {
	            if (parentCountsMap.has(cid) && parentCountsMap.get(cid) > 1 && _this.prefParentsMap.has(cid) && _this.prefParentsMap.get(cid) === fsid) {
	                updates.push({ pid: cid, fid: f.id });
	            }
	        });
	        return updates;
	    };
	    FsImportService.prototype.saveCoupleFacts = function (alreadyDownloadedPIDs, progressStream) {
	        var _this = this;
	        if (this.coupleFactMap.size === 0) {
	            return this.rx.Observable.of([]);
	        }
	        return (_a = this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(this.coupleFactMap.values()).map(function (coupleFact) {
	            if (!!coupleFact.fsid1 && !!coupleFact.fsid2) {
	                return _this.saveCoupleFact(coupleFact, alreadyDownloadedPIDs, progressStream);
	            }
	            else {
	                _this.progressUpdater(progressStream);
	                return _this.rx.Observable.of([]);
	            }
	        })));
	        var _a;
	    };
	    FsImportService.prototype.saveCoupleFact = function (coupleFact, alreadyDownloadedPIDs, progressStream) {
	        var _this = this;
	        var pid1 = this.findPerson(coupleFact.fsid1, alreadyDownloadedPIDs);
	        var pid2 = this.findPerson(coupleFact.fsid2, alreadyDownloadedPIDs);
	        if (!!pid1 && !!pid2) {
	            return this.evidences.create(coupleFact.evidence).map(function (evidence) {
	                var factUpdates = [
	                    { pid: pid1, pos: 1, principalId1: pid2, eid: evidence.id, fact: coupleFact.fact },
	                    { pid: pid2, pos: 2, principalId1: pid1, eid: evidence.id, fact: coupleFact.fact }
	                ];
	                _this.progress.requests += factUpdates.length;
	                _this.progressUpdater(progressStream);
	                return factUpdates;
	            });
	        }
	        else {
	            this.progressUpdater(progressStream);
	            return this.rx.Observable.of([]);
	        }
	    };
	    FsImportService.prototype.updatePersons = function (prefParentUpdates, factUpdates, progressStream) {
	        var _this = this;
	        var m = new Map();
	        prefParentUpdates.forEach(function (updates) {
	            updates.forEach(function (update) {
	                if (!m.has(update.pid)) {
	                    m.set(update.pid, []);
	                }
	                m.get(update.pid).push(update);
	            });
	        });
	        factUpdates.forEach(function (updates) {
	            updates.forEach(function (update) {
	                if (!m.has(update.pid)) {
	                    m.set(update.pid, []);
	                }
	                m.get(update.pid).push(update);
	            });
	        });
	        (_a = this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(m.entries()).map(function (_a) {
	            var _b = __read(_a, 2), pid = _b[0], updates = _b[1];
	            _this.persons.streamId(pid).filter(function (p) { return !!p; }).take(1).subscribe(function (p) {
	                updates.forEach(function (update) {
	                    if (!!update.fid) {
	                        if (!p.preferredParentsFamilyId) {
	                            p.preferredParentsFamilyId = update.fid;
	                        }
	                    }
	                    else if (!!update.fact) {
	                        // find fact
	                        var f = null;
	                        try {
	                            for (var _a = __values(p.facts.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                                var existingFact = _b.value;
	                                if (!!existingFact.externalIds && existingFact.externalIds.has(FS) && existingFact.externalIds.get(FS).id === update.fact.externalIds.get(FS).id) {
	                                    f = existingFact;
	                                    break;
	                                }
	                            }
	                        }
	                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
	                        finally {
	                            try {
	                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                            }
	                            finally { if (e_6) throw e_6.error; }
	                        }
	                        if (!f) {
	                            f = _this.utils.clone(update.fact);
	                            p.facts.set(_this.utils.randomKey(), f);
	                        }
	                        // update fact
	                        f.evidencePersonas.set(update.eid, update.pos);
	                        f.principalId1 = update.principalId1;
	                    }
	                    var e_6, _c;
	                });
	                _this.progress.responses += updates.length - 1;
	                _this.persons.update(p).subscribe(function () {
	                    _this.progressUpdater(progressStream);
	                }, function (error) {
	                    _this.progressUpdater(progressStream, '', error);
	                });
	            });
	        })));
	        var _a;
	    };
	    FsImportService.prototype.findPerson = function (fsid, alreadyDownloadedPIDs) {
	        return !!fsid && alreadyDownloadedPIDs.has(fsid) ? alreadyDownloadedPIDs.get(fsid) : !!fsid && this.pidMap.has(fsid) ? this.pidMap.get(fsid) : 0;
	    };
	    FsImportService.prototype.createEvidence = function (fact, fsid, url, name) {
	        var date = this.moment(Date.now()).format('DD MMM YYYY');
	        var text = 'FamilySearch, ';
	        if (!!url) {
	            text += '<a href="' + url + '">' + fsid + '</a>, ';
	        }
	        text += date;
	        var e = {
	            id: 0,
	            fact: {
	                type: fact.type,
	                value: fact.value,
	                date: fact.date,
	                place: fact.place
	            },
	            mediaIds: new Map(),
	            citation: {
	                date: date,
	                url: url,
	                text: text
	            },
	            personas: new Map([[1, { names: new Map(), facts: new Map(), principal: true, relatedToKey: 0, relationshipType: '' }]]),
	            externalIds: new Map()
	        };
	        if (!!name) {
	            e.personas.get(1).names.set(1, {
	                type: name.type,
	                nameForms: this.utils.clone(name.nameForms)
	            });
	        }
	        return e;
	    };
	    FsImportService.prototype.setTreeRoot = function (id) {
	        var _this = this;
	        this.treeUsers.stream().take(1).subscribe(function (tu) {
	            var treeRoot = parseInt(tu.preferences['ROOT'] || '0', 10);
	            if (treeRoot === 0) {
	                tu.preferences['ROOT'] = id.toString();
	                _this.treeUsers.update(tu);
	            }
	        });
	    };
	    return FsImportService;
	}());
	exports.default = FsImportService;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var HttpClientService = /** @class */ (function () {
	    HttpClientService.$inject = ["$log", "$http", "$rootScope", "rx", "serverBase", "authToken"];
	    function HttpClientService($log, $http, $rootScope, rx, serverBase, authToken) {
	        'ngInject';
	        this.$log = $log;
	        this.$http = $http;
	        this.$rootScope = $rootScope;
	        this.rx = rx;
	        this.serverBase = serverBase;
	        this.authToken = authToken;
	        this.subject = new rx.Subject();
	        this.maxRetries = 5;
	        this.delay = 1000;
	        this.pending = 0;
	    }
	    HttpClientService.prototype.get = function (url, options) {
	        if (options === void 0) { options = {}; }
	        return this.httpObservable('GET', url, options.params, null, { headers: options.headers });
	    };
	    HttpClientService.prototype.post = function (url, data, options) {
	        return this.httpObservable('POST', url, options.params, data, { headers: options.headers });
	    };
	    HttpClientService.prototype.put = function (url, data, options) {
	        return this.httpObservable('PUT', url, options.params, data, { headers: options.headers });
	    };
	    HttpClientService.prototype.delete = function (url, options) {
	        if (options === void 0) { options = {}; }
	        return this.httpObservable('DELETE', url, options.params, null, { headers: options.headers });
	    };
	    HttpClientService.prototype.httpObservable = function (method, url, params, data, opts) {
	        var _this = this;
	        var request = { method: method, url: url, params: params, data: data, timeout: 120000, withCredentials: false };
	        // add options
	        if (angular.isObject(opts)) {
	            angular.extend(request, opts);
	        }
	        return this.rx.Observable.defer(function () {
	            return _this.$http(request);
	        })
	            .catch(function (response) {
	            if (response.status === 304) {
	                return _this.rx.Observable.of(response);
	            }
	            else {
	                return _this.rx.Observable.throw(response);
	            }
	        }).retryWhen(function (errors) {
	            return _this.rx.Observable.range(0, _this.maxRetries)
	                .zip(errors, function (count, err) {
	                return { count: count, err: err };
	            })
	                .flatMap(function (_a) {
	                var count = _a.count, err = _a.err;
	                _this.$log.warn('server.http.retry', err, count, url);
	                // if we've tried too many times, or retrying is pointless
	                if (count >= _this.maxRetries - 1 || err.status === 400 || err.status === 401 || err.status === 403 || err.status === 404 || err.status === 409 || err.status === 413) {
	                    return _this.rx.Observable.throw(err);
	                }
	                // exponential backoff
	                return _this.rx.Observable.timer(_this.delay * Math.pow(2, count));
	            });
	        });
	    };
	    return HttpClientService;
	}());
	exports.default = HttpClientService;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Wilson Kellogg <wilson.kellogg@prosadata.com> - 2016
	 */
	var IndexOfNamesService = /** @class */ (function () {
	    IndexOfNamesService.$inject = ["$log"];
	    function IndexOfNamesService($log) {
	        'ngInject';
	        this.$log = $log;
	        this.yFooter = 270;
	        this.maxX = 188;
	    }
	    IndexOfNamesService.prototype.setDoc = function (doc) {
	        this.doc = doc;
	    };
	    IndexOfNamesService.prototype.setPageNumber = function (pageNumber) {
	        this.pageNumber = pageNumber;
	    };
	    IndexOfNamesService.prototype.getPageNumber = function () {
	        return this.pageNumber;
	    };
	    IndexOfNamesService.prototype.setX = function (x) {
	        this.x = x;
	    };
	    IndexOfNamesService.prototype.setY = function (y) {
	        this.y = y;
	    };
	    IndexOfNamesService.prototype.setDeltaY = function (deltaY) {
	        this.deltaY = deltaY;
	    };
	    IndexOfNamesService.prototype.setDeltaYUnderline = function (deltaYUnderline) {
	        this.deltaYUnderline = deltaYUnderline;
	    };
	    IndexOfNamesService.prototype.setDeltaX = function (deltaX) {
	        this.deltaX = deltaX;
	    };
	    IndexOfNamesService.prototype.setNamesIndex = function (namesIndex) {
	        this.namesIndex = namesIndex;
	    };
	    IndexOfNamesService.prototype.printNames = function () {
	        var doc = this.doc;
	        var x = this.x;
	        var y = this.y;
	        var deltaY = this.deltaY;
	        var deltaX = this.deltaX;
	        var xline = 0;
	        var ret = this.loadNames();
	        var people = ret.people;
	        doc.setFontSize(10);
	        var txt = "";
	        var len = people.length;
	        var lastName = "";
	        var firstName = "";
	        var id = "";
	        var pageNr = 0;
	        for (var i = 0; i < len; i++) {
	            var person_ = people[i];
	            //this.$log.debug("PEOPLe", people[i]);
	            var aux = person_.lastName.toUpperCase();
	            if (lastName !== aux) {
	                lastName = aux;
	                y = this.increaseY(y, deltaY, doc);
	                //this.$log.debug("y", y);
	                doc.setTextColor(0, 0, 0);
	                doc.text(x, y, aux);
	            }
	            //this.$log.debug("FULLNAME", fullName);
	            //this.$log.debug("P FULL NAME", person_.full);
	            if (id === person_.id) {
	                var w = this.doc.getStringUnitWidth(txt);
	                w = (w * 10 * 25.4) / 72;
	                doc.text(x + deltaX + xline + w, y, "," + person_.page);
	            }
	            else {
	                y = this.increaseY(y, deltaY, doc);
	                //doc.setTextColor(0,256,0);
	                firstName = person_.firstName;
	                doc.text(x + deltaX, y, firstName);
	                doc.setTextColor(0, 0, 0);
	                pageNr = person_.page;
	                txt = "";
	                /*var firstNameLength = firstName.length;
	                 for (var j = 0; j <= firstNameLength; j++) {
	                 txt += "  ";
	                 }*/
	                xline = doc.getStringUnitWidth(firstName);
	                xline = (xline * 10 * 25.4) / 72;
	                txt += " ... " + pageNr;
	                doc.text(x + deltaX + xline, y, txt);
	            }
	            id = person_.id;
	        }
	        doc.setTextColor(0, 0, 0);
	    };
	    IndexOfNamesService.prototype.loadNames = function () {
	        var people = this.insertionSort(this.namesIndex);
	        return { people: people };
	    };
	    IndexOfNamesService.prototype.insertionSort = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = new Array();
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	        }
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            j = i - 1;
	            while (j >= 0 && first.key < copia[j].key) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        return (copia);
	    };
	    IndexOfNamesService.prototype.printHeader = function (txt1, txt2) {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.y;
	        var deltaYUnderline = this.deltaYUnderline;
	        doc.setFontSize(14);
	        doc.text(x, y, txt1);
	        var xRightAligned = maxX - 2 * txt2.length - 10;
	        doc.setFontSize(10);
	        doc.text(xRightAligned, y, txt2);
	        y = this.increaseY(y, deltaYUnderline, doc);
	        doc.line(x, y, maxX, y);
	    };
	    IndexOfNamesService.prototype.printFooter = function () {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.yFooter;
	        var pageNumber = this.pageNumber;
	        doc.line(x, y, maxX, y);
	        doc.setFontSize(10);
	        doc.text((x + maxX) / 2, y + 6, pageNumber + "");
	    };
	    IndexOfNamesService.prototype.today = function () {
	        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	        var date = new Date();
	        var _date = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
	        return _date;
	    };
	    IndexOfNamesService.prototype.increaseY = function (y, deltaY, doc) {
	        y += deltaY;
	        if (y >= this.yFooter) {
	            y = 20;
	            doc.addPage();
	            this.pageNumber++;
	            this.printHeader("Index of Names", this.today());
	            this.printFooter();
	            y += 10;
	        }
	        return y;
	    };
	    return IndexOfNamesService;
	}());
	exports.default = IndexOfNamesService;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Wilson Kellogg <wilson.kellogg@prosadata.com> - 2016
	 */
	var IndexOfPlacesService = /** @class */ (function () {
	    IndexOfPlacesService.$inject = ["$log"];
	    function IndexOfPlacesService($log) {
	        'ngInject';
	        this.$log = $log;
	        this.yFooter = 270;
	        this.maxX = 188;
	    }
	    IndexOfPlacesService.prototype.setDoc = function (doc) {
	        this.doc = doc;
	    };
	    IndexOfPlacesService.prototype.setPageNumber = function (pageNumber) {
	        this.pageNumber = pageNumber;
	    };
	    IndexOfPlacesService.prototype.getPageNumber = function () {
	        return this.pageNumber;
	    };
	    IndexOfPlacesService.prototype.setX = function (x) {
	        this.x = x;
	    };
	    IndexOfPlacesService.prototype.setY = function (y) {
	        this.y = y;
	    };
	    IndexOfPlacesService.prototype.setDeltaY = function (deltaY) {
	        this.deltaY = deltaY;
	    };
	    IndexOfPlacesService.prototype.setDeltaYUnderline = function (deltaYUnderline) {
	        this.deltaYUnderline = deltaYUnderline;
	    };
	    IndexOfPlacesService.prototype.setDeltaX = function (deltaX) {
	        this.deltaX = deltaX;
	    };
	    IndexOfPlacesService.prototype.setPlacesIndex = function (placesIndex) {
	        this.placesIndex = placesIndex;
	    };
	    IndexOfPlacesService.prototype.printPlaces = function () {
	        var doc = this.doc;
	        var x = this.x;
	        var y = this.y;
	        var deltaY = this.deltaY;
	        //var deltaYUnderline = this.deltaYUnderline;
	        var deltaX = this.deltaX;
	        doc.setTextColor(0, 0, 0);
	        var ret = this.loadPlaces();
	        var places = ret.places;
	        doc.setFontSize(10);
	        var txt = "";
	        var len = places.length;
	        var place1 = "";
	        var place2 = "";
	        var place3 = "";
	        var pages = "";
	        for (var i = 0; i < len; i++) {
	            txt = "";
	            var place_ = places[i];
	            var aux = place_.place1;
	            if (!(place1 === aux)) {
	                place1 = aux;
	                y = this.increaseY(y, deltaY, doc);
	                txt = place1;
	                if ((place_.place2 === "") && (place_.place3 === "")) {
	                    pages = this.pagesTxt(places, i);
	                    txt += " ... " + pages;
	                }
	                doc.text(x, y, txt);
	            }
	            aux = place_.place2;
	            if (place_.place2 !== "") {
	                if (!(place2 === aux)) {
	                    place2 = aux;
	                    y = this.increaseY(y, deltaY, doc);
	                    txt = place2;
	                    if (place_.place3 === "") {
	                        pages = this.pagesTxt(places, i);
	                        txt += " ... " + pages;
	                    }
	                    doc.text(x + deltaX, y, txt);
	                }
	            }
	            if (place_.place3 !== "") {
	                aux = place_.place3;
	                if (!(place3 === aux)) {
	                    y = this.increaseY(y, deltaY, doc);
	                    place3 = aux;
	                    pages = this.pagesTxt(places, i);
	                    txt = place3 + " ... " + pages;
	                    doc.text(x + 2 * deltaX, y, txt);
	                }
	            }
	        }
	    };
	    IndexOfPlacesService.prototype.pagesTxt = function (places, i) {
	        var pages = "";
	        var coma = "";
	        var page = 0;
	        while (i < places.length && page < places[i].page) {
	            var place = places[i];
	            page = place.page;
	            pages += coma + page;
	            coma = ", ";
	            i++;
	        }
	        return pages;
	    };
	    IndexOfPlacesService.prototype.loadPlaces = function () {
	        var places = this.insertionSort(this.placesIndex);
	        return { places: places };
	    };
	    IndexOfPlacesService.prototype.insertionSort = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = new Array();
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	        }
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            j = i - 1;
	            while (j >= 0 && first.key < copia[j].key) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        return (copia);
	    };
	    IndexOfPlacesService.prototype.increaseY = function (y, deltaY, doc) {
	        y += deltaY;
	        if (y >= this.yFooter) {
	            y = 20;
	            doc.addPage();
	            this.pageNumber++;
	            this.printHeader("Index of places", this.today());
	            this.printFooter();
	            y += 10;
	        }
	        return y;
	    };
	    IndexOfPlacesService.prototype.today = function () {
	        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	        var date = new Date();
	        var _date = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
	        return _date;
	    };
	    IndexOfPlacesService.prototype.printHeader = function (txt1, txt2) {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.y;
	        var deltaYUnderline = this.deltaYUnderline;
	        doc.setFontSize(14);
	        doc.text(x, y, txt1);
	        var xRightAligned = maxX - 2 * txt2.length - 10;
	        doc.setFontSize(10);
	        doc.text(xRightAligned, y, txt2);
	        y = this.increaseY(y, deltaYUnderline, doc);
	        doc.line(x, y, maxX, y);
	    };
	    IndexOfPlacesService.prototype.printFooter = function () {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.yFooter;
	        var pageNumber = this.pageNumber;
	        doc.line(x, y, maxX, y);
	        doc.setFontSize(10);
	        doc.text((x + maxX) / 2, y + 6, pageNumber + "");
	    };
	    return IndexOfPlacesService;
	}());
	exports.default = IndexOfPlacesService;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var invitations_service_1 = __webpack_require__(227);
	var InvitationsService = /** @class */ (function (_super) {
	    __extends(InvitationsService, _super);
	    InvitationsService.$inject = ["$log", "store", "segment", "changes"];
	    function InvitationsService($log, store, segment, changes) {
	        'ngInject';
	        return _super.call(this, store, segment, changes) || this;
	    }
	    return InvitationsService;
	}(invitations_service_1.InvitationsService));
	exports.default = InvitationsService;
	// class InvitationsService {
	//   constructor ($log, store, segment, changes) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.segment = segment;
	//     this.store = store.create("trees", "invitations", changes.treeStream());
	//   }
	//   create(o) {
	//     this.segment.track('invitations.create');
	//     return this.store.create(o);
	//   }
	//   del(id) {
	//     this.segment.track('invitations.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   //
	//   // helper functions
	//   //
	// }
	// export default InvitationsService;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var InvitationsService = /** @class */ (function () {
	    function InvitationsService(store, segment, changes) {
	        this.segment = segment;
	        this.store = store.create("trees", "invitations", changes.treeStream());
	    }
	    InvitationsService.prototype.create = function (o) {
	        this.segment.track('invitations.create');
	        return this.store.create(o);
	    };
	    InvitationsService.prototype.del = function (id) {
	        this.segment.track('invitations.delete');
	        return this.store.del(id);
	    };
	    InvitationsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    InvitationsService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    return InvitationsService;
	}());
	exports.InvitationsService = InvitationsService;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leads_service_1 = __webpack_require__(229);
	var LeadsService = /** @class */ (function (_super) {
	    __extends(LeadsService, _super);
	    LeadsService.$inject = ["$log", "rx", "store", "changes", "segment", "currentTreeId", "server", "utils"];
	    function LeadsService($log, rx, store, changes, segment, currentTreeId, server, utils) {
	        'ngInject';
	        return _super.call(this, $log, rx, store, changes, segment, currentTreeId, server, utils) || this;
	    }
	    return LeadsService;
	}(leads_service_1.LeadsService));
	exports.default = LeadsService;
	// class LeadsService {
	//   constructor ($log, rx, store, changes, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", "leads", changes.treeStream(), (l) => utils.addCreateEditDates(l));
	//     this.personStream = this.store.addStream(store.streamScanFn(o => {
	//       return !!o.personIds ? o.personIds.keys() : null;
	//     }));
	//     this.researchLogStream = this.store.addStream(store.streamScanFn(o => {
	//       let researchLogId = o.researchLogId || 0;
	//       return researchLogId > 0 ? [researchLogId] : null;
	//     }));
	//   }
	//   create(o) {
	//     this.segment.track('leads.create');
	//     o.researchLogId = o.researchLogId || 0;
	//     return this.store.create(o);
	//   }
	//   update(o) {
	//     this.segment.track('leads.update');
	//     o.researchLogId = o.researchLogId || 0;
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     this.segment.track('leads.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   // returns a map
	//   streamForPerson(pid, includeHidden) {
	//     return this.ready().flatMap(() => this.personStream.map(m => {
	//       let leadMap = m.get(pid) || new Map();
	//       if (!includeHidden) {
	//         leadMap = new Map(Array.from(leadMap.entries()).filter(([,lead]) => !lead.hidden));
	//       }
	//       return leadMap;
	//     }));
	//   }
	//   // returns a map
	//   streamForResearchLog(rlid) {
	//     return this.ready().flatMap(() => this.researchLogStream.map(m => m.get(rlid) || new Map()));
	//   }
	//   // non-streaming functions; caller must make sure that stream is "ready" before calling
	//   getMap() {
	//     return this.store.getStream().getValue();
	//   }
	//   getPersonMap() {
	//     return this.personStream.getValue();
	//   }
	//   //
	//   // helper functions
	//   //
	//   augmentLead(l, persons, users) {
	//     let subject = new this.rx.AsyncSubject();
	//     let waitCount = (l.personIds.size > 0 ? 1 : 0) + 1;
	//     l = Object.assign({}, l, {
	//       '_icon': l.createdUser === 0 ? 'star_border' : 'check',
	//       '_type': l.createdUser === 0 ? 'Hint' : 'ToDo',
	//       '_people': new Map(),
	//       '_createdUser' : null,
	//       '_editedUser' : null
	//     });
	//     // set people
	//     if (l.personIds.size > 0) {
	//       persons.streamIds(Array.from(l.personIds.keys())).take(1).subscribe(pm => {
	//         l._people = pm;
	//         if (--waitCount === 0) {
	//           subject.next(l);
	//           subject.complete();
	//         }
	//       });
	//     }
	//     // set created user and edited user
	//     this.utils.addCreateEditUsers(l, users).subscribe(() => {
	//       if (--waitCount === 0) {
	//         subject.next(l);
	//         subject.complete();
	//       }
	//     });
	//     return subject;
	//   }
	//   hasWord(l, w) {
	//     return (l.text.toLowerCase().indexOf(w) >= 0) ||
	//       (l.title.toLowerCase().indexOf(w) >= 0) ||
	//       (!!l._type ? l._type.toLowerCase().indexOf(w) >= 0 : false) ||
	//       (l.url.toLowerCase().indexOf(w) >= 0) ||
	//       (Array.from(l._people.values()).some(p => p._fullName.toLowerCase().indexOf(w) >= 0));
	//   }
	// }
	// export default LeadsService;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { BehaviorSubject, AsyncSubject } from "../../node_modules/rxjs";
	var LeadsService = /** @class */ (function () {
	    function LeadsService(log, rx, store, changes, segment, currentTreeId, server, utils) {
	        this.log = log;
	        this.rx = rx;
	        this.segment = segment;
	        this.currentTreeId = currentTreeId;
	        this.server = server;
	        this.utils = utils;
	        this.store = store.create("trees", "leads", changes.treeStream(), function (l) { return utils.addCreateEditDates(l); });
	        this.personStream = this.store.addStream(store.streamScanFn(function (o) {
	            return !!o.personIds ? o.personIds.keys() : null;
	        }));
	        this.researchLogStream = this.store.addStream(store.streamScanFn(function (o) {
	            var researchLogId = o.researchLogId || 0;
	            return researchLogId > 0 ? [researchLogId] : null;
	        }));
	        this.statusStream = this.store.addStream(store.streamScanFn(function (o) {
	            return !!o.status ? [o.status] : null;
	        }));
	    }
	    LeadsService.prototype.create = function (o) {
	        this.segment.track('leads.create');
	        o.researchLogId = o.researchLogId || 0;
	        return this.store.create(o);
	    };
	    LeadsService.prototype.update = function (o) {
	        this.segment.track('leads.update');
	        o.researchLogId = o.researchLogId || 0;
	        return this.store.update(o);
	    };
	    // del(id) {
	    //   this.segment.track('leads.delete');
	    //   return this.store.del(id);
	    // }
	    LeadsService.prototype.delSource = function (source) {
	        this.segment.track('leads.deleteSource');
	        return this.server.del('/trees/' + this.currentTreeId.get() + '/leads', { source: source });
	    };
	    LeadsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    LeadsService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    LeadsService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    // returns a map
	    LeadsService.prototype.streamForPerson = function (pid, includeArchived) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.personStream.map(function (m) {
	            var leadMap = m.get(pid) || new Map();
	            if (!includeArchived) {
	                leadMap = new Map(Array.from(leadMap.entries()).filter(function (_a) {
	                    var _b = __read(_a, 2), lead = _b[1];
	                    return lead.state === 0;
	                }) //any[] declaration so it doesn't assume incorrect type
	                );
	            }
	            return leadMap;
	        }); });
	    };
	    // returns a map
	    LeadsService.prototype.streamForResearchLog = function (rlid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.researchLogStream.map(function (m) { return m.get(rlid) || new Map(); }); });
	    };
	    // non-streaming functions; caller must make sure that stream is "ready" before calling
	    LeadsService.prototype.getMap = function () {
	        return this.store.getStream().getValue();
	    };
	    LeadsService.prototype.getPersonMap = function () {
	        return this.personStream.getValue();
	    };
	    LeadsService.prototype.statusAutocomplete = function (prefix, extraStatuses) {
	        var lc = this.utils.normalize(prefix);
	        return this.statusStream
	            .map(function (m) {
	            var resultMap = !lc ? new Map() : lc
	                .split(' ')
	                .map(function (piece) {
	                var result = new Map();
	                try {
	                    for (var m_1 = __values(m), m_1_1 = m_1.next(); !m_1_1.done; m_1_1 = m_1.next()) {
	                        var _a = __read(m_1_1.value, 2), status_1 = _a[0], pm = _a[1];
	                        if (status_1.toLowerCase().startsWith(piece)) {
	                            result.set(status_1, pm.size);
	                        }
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (m_1_1 && !m_1_1.done && (_b = m_1.return)) _b.call(m_1);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                try {
	                    for (var _c = __values((extraStatuses || [])), _d = _c.next(); !_d.done; _d = _c.next()) {
	                        var status_2 = _d.value;
	                        if (status_2.toLowerCase().startsWith(piece) && !result.has(status_2)) {
	                            result.set(status_2, 1);
	                        }
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	                return result;
	                var e_1, _b, e_2, _e;
	            })
	                .reduce(function (prev, curr) {
	                if (prev === null) {
	                    return curr;
	                }
	                try {
	                    // remove keys in prev that are not in curr
	                    for (var prev_1 = __values(prev), prev_1_1 = prev_1.next(); !prev_1_1.done; prev_1_1 = prev_1.next()) {
	                        var _a = __read(prev_1_1.value, 1), k = _a[0];
	                        if (!curr.has(k)) {
	                            prev.delete(k);
	                        }
	                    }
	                }
	                catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                finally {
	                    try {
	                        if (prev_1_1 && !prev_1_1.done && (_b = prev_1.return)) _b.call(prev_1);
	                    }
	                    finally { if (e_3) throw e_3.error; }
	                }
	                return prev;
	                var e_3, _b;
	            }, null);
	            return Array.from(resultMap.entries())
	                .sort(function (a, b) { return b[1] - a[1]; })
	                .map(function (entry) { return entry[0]; });
	        })
	            .take(1)
	            .toPromise();
	    };
	    //
	    // helper functions
	    //
	    LeadsService.prototype.augmentLead = function (l, persons, users) {
	        var subject = new this.rx.AsyncSubject();
	        var waitCount = (l.personIds.size > 0 ? 1 : 0) + 1;
	        l = Object.assign({}, l, {
	            '_icon': l.createdUser === 0 ? 'star_border' : 'check',
	            '_type': l.createdUser === 0 ? 'Hint' : 'ToDo',
	            '_people': new Map(),
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        // set people
	        if (l.personIds.size > 0) {
	            persons.streamIds(Array.from(l.personIds.keys())).take(1).subscribe(function (pm) {
	                l._people = pm;
	                if (--waitCount === 0) {
	                    subject.next(l);
	                    subject.complete();
	                }
	            });
	        }
	        // set created user and edited user
	        this.utils.addCreateEditUsers(l, users).subscribe(function () {
	            if (--waitCount === 0) {
	                subject.next(l);
	                subject.complete();
	            }
	        });
	        return subject;
	    };
	    LeadsService.prototype.hasWord = function (l, w) {
	        return ((l.text || '').toLowerCase().indexOf(w) >= 0) ||
	            ((l.title || '').toLowerCase().indexOf(w) >= 0) ||
	            ((l._type || '').toLowerCase().indexOf(w) >= 0) ||
	            ((l.url || '').toLowerCase().indexOf(w) >= 0) ||
	            ((l.status || '').toLowerCase().indexOf(w) >= 0) ||
	            ((!!l._people ? Array.from(l._people.values()) : []).some(function (p) { return p._fullName.toLowerCase().indexOf(w) >= 0; }));
	    };
	    return LeadsService;
	}());
	exports.LeadsService = LeadsService;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leadGenerators_service_1 = __webpack_require__(231);
	var LeadGeneratorsService = /** @class */ (function (_super) {
	    __extends(LeadGeneratorsService, _super);
	    LeadGeneratorsService.$inject = ["$log", "store", "changes", "segment", "utils"];
	    function LeadGeneratorsService($log, store, changes, segment, utils) {
	        'ngInject';
	        return _super.call(this, $log, store, changes, segment, utils) || this;
	    }
	    return LeadGeneratorsService;
	}(leadGenerators_service_1.LeadGeneratorsService));
	exports.default = LeadGeneratorsService;
	// class LeadGeneratorsService {
	//   constructor ($log, store, changes, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", "lead_generators", changes.treeStream(), (s) => utils.addCreateEditDates(s));
	//   }
	//   create(o) {
	//     this.segment.track('leadGenerators.create');
	//     return this.store.create(o);
	//   }
	//   del(id) {
	//     this.segment.track('leadGenerators.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   //
	//   // helper functions
	//   //
	// }
	// export default LeadGeneratorsService;


/***/ }),
/* 231 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var LeadGeneratorsService = /** @class */ (function () {
	    function LeadGeneratorsService(log, store, changes, segment, utils) {
	        this.log = log;
	        this.segment = segment;
	        this.store = store.create("trees", "lead_generators", changes.treeStream(), function (s) { return utils.addCreateEditDates(s); });
	    }
	    LeadGeneratorsService.prototype.create = function (o) {
	        this.segment.track('leadGenerators.create');
	        return this.store.create(o);
	    };
	    LeadGeneratorsService.prototype.del = function (id) {
	        this.segment.track('leadGenerators.delete');
	        return this.store.del(id);
	    };
	    LeadGeneratorsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    LeadGeneratorsService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    LeadGeneratorsService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    return LeadGeneratorsService;
	}());
	exports.LeadGeneratorsService = LeadGeneratorsService;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var likes_service_1 = __webpack_require__(233);
	var LikesService = /** @class */ (function (_super) {
	    __extends(LikesService, _super);
	    LikesService.$inject = ["$log", "rx", "store", "changes", "segment", "utils"];
	    function LikesService($log, rx, store, changes, segment, utils) {
	        'ngInject';
	        return _super.call(this, $log, rx, store, changes, segment, utils) || this;
	    }
	    return LikesService;
	}(likes_service_1.LikesService));
	exports.default = LikesService;
	// class LikesService {
	//   constructor ($log, rx, store, changes, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", "likes", changes.treeStream(), (s) => utils.addCreateEditDates(s));
	//   }
	//   create(o) {
	//     this.segment.track('likes.create');
	//     return this.store.create(o);
	//   }
	//   update(o) {
	//     this.segment.track('likes.update');
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     this.segment.track('likes.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id).map(like => like || {id: id, version: 0, likes: new Map()});
	//   }
	//   //
	//   // helper functions
	//   //
	//   augmentLike(l, users, currentUserId) {
	//     let subject = new this.rx.AsyncSubject();
	//     l = Object.assign({}, l, {
	//       '_likes': []
	//     });
	//     // set _users
	//     currentUserId.stream().take(1).subscribe(currId => {
	//       (l.likes.size === 0 ? this.rx.Observable.of([]) : this.rx.Observable.forkJoin(...Array.from(l.likes.keys()).map(id => users.streamSummaryId(id))))
	//         .subscribe(users => {
	//           l._likes = [];
	//           for (let [k] of l.likes) {
	//             let user = users.find(u => u.id === k);
	//             if (!!user) {
	//               if (k === currId) {
	//                 l._likes.unshift(user);
	//               }
	//               else {
	//                 l._likes.push(user);
	//               }
	//             }
	//           }
	//           subject.next(l);
	//           subject.complete();
	//         });
	//     });
	//     return subject;
	//   }
	// }
	// export default LikesService;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { AsyncSubject, Observable } from "../../node_modules/rxjs";
	var LikesService = /** @class */ (function () {
	    function LikesService(log, rx, store, changes, segment, utils) {
	        this.log = log;
	        this.rx = rx;
	        this.changes = changes;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "likes", changes.treeStream(), function (s) { return utils.addCreateEditDates(s); });
	    }
	    LikesService.prototype.create = function (o) {
	        this.segment.track('likes.create');
	        return this.store.create(o);
	    };
	    LikesService.prototype.update = function (o) {
	        this.segment.track('likes.update');
	        return this.store.update(o);
	    };
	    LikesService.prototype.del = function (id) {
	        this.segment.track('likes.delete');
	        return this.store.del(id);
	    };
	    LikesService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    LikesService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    LikesService.prototype.streamId = function (id) {
	        return this.store.streamId(id).map(function (like) { return like || { id: id, version: 0, likes: new Map() }; });
	    };
	    //
	    // helper functions
	    //
	    LikesService.prototype.augmentLike = function (l, users, currentUserId) {
	        var _this = this;
	        var subject = new this.rx.AsyncSubject();
	        l = Object.assign({}, l, {
	            '_likes': []
	        });
	        // set _users
	        currentUserId.stream().take(1).subscribe(function (currId) {
	            (l.likes.size === 0 ? _this.rx.Observable.of([]) : (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(l.likes.keys()).map(function (id) { return users.streamSummaryId(id); }))))
	                .subscribe(function (users) {
	                l._likes = [];
	                var _loop_1 = function (k) {
	                    var user = users.find(function (u) { return u.id === k; });
	                    if (!!user) {
	                        if (k === currId) {
	                            l._likes.unshift(user);
	                        }
	                        else {
	                            l._likes.push(user);
	                        }
	                    }
	                };
	                try {
	                    for (var _a = __values(l.likes), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var _c = __read(_b.value, 1), k = _c[0];
	                        _loop_1(k);
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                subject.next(l);
	                subject.complete();
	                var e_1, _d;
	            });
	            var _a;
	        });
	        return subject;
	    };
	    return LikesService;
	}());
	exports.LikesService = LikesService;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var medias_service_1 = __webpack_require__(235);
	var MediasService = /** @class */ (function (_super) {
	    __extends(MediasService, _super);
	    MediasService.$inject = ["$log", "$interval", "store", "changes", "rx", "Upload", "serverBase", "currentTreeId", "authToken", "messageBus", "segment", "server", "utils"];
	    function MediasService($log, $interval, store, changes, rx, Upload, serverBase, currentTreeId, authToken, messageBus, segment, server, utils) {
	        'ngInject';
	        return _super.call(this, $log, rx, $interval, store, changes, Upload, serverBase, currentTreeId, authToken, messageBus, segment, server, utils) || this;
	    }
	    return MediasService;
	}(medias_service_1.MediasService));
	exports.default = MediasService;
	// class MediasService {
	//   constructor ($log, store, changes, rx, Upload, serverBase, currentTreeId, authToken, messageBus, segment, server, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.Upload = Upload;
	//     this.serverBase = serverBase;
	//     this.currentTreeId = currentTreeId;
	//     this.authToken = authToken;
	//     this.changeStream = changes.treeStream();
	//     this.messageBus = messageBus;
	//     this.segment = segment;
	//     this.server = server;
	//     this.utils = utils;
	//     this.store = store.create("trees", "media", changes.treeStream(), (m) => this._addDerived(m));
	//     this.personStream = this.store.addStream(store.streamScanFn(o => {
	//       return o.personIds ? o.personIds.keys() : null;
	//     }));
	//     this.researchLogStream = this.store.addStream(store.streamScanFn(o => {
	//       let researchLogId = o.researchLogId || 0;
	//       return researchLogId > 0 ? [researchLogId] : null;
	//     }));
	//     this.fileTypes = '*';
	//     this.fileModelOptions = {debounce: 300};
	//     this.fileValidation = {size: {max: '500MB', min: '10B'}};
	//     this.fileDragover = {accept:'file__upload-drag_dragover', reject: 'file__upload-drag_dragover_err', pattern: this.fileTypes};
	//   }
	//   create(o, options) {
	//     this.segment.track('media.create');
	//     o.researchLogId = o.researchLogId || 0;
	//     return this.store.create(o, null, options);
	//   }
	//   update(o) {
	//     this.segment.track('media.update');
	//     o.researchLogId = o.researchLogId || 0;
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     this.segment.track('media.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   streamIds(ids) {
	//     return this.store.streamIds(ids);
	//   }
	//   // returns a map
	//   streamForPerson(pid) {
	//     return this.ready().flatMap(() => this.personStream.map(m => (m.get(pid) || new Map())));
	//   }
	//   // returns a map
	//   streamForResearchLog(rlid) {
	//     return this.ready().flatMap(() => this.researchLogStream.map(m => m.get(rlid) || new Map()));
	//   }
	//   //
	//   // helper functions
	//   //
	//   getFileBase(mediaId, fileId) {
	//     return '/trees/' + this.currentTreeId.get() + '/media/' + mediaId.toString() + '/files/' + fileId.toString();
	//   }
	//   getFileURL(mediaId, fileId, size) {
	//     if (this.currentTreeId.get() === 0) {
	//       return '';
	//     }
	//     return this.serverBase + this.getFileBase(mediaId, fileId) + '?token=' + this.authToken.get() + (!!size ? '&size=' + size : '');
	//   }
	//   isImageFile(file) {
	//     return !!file && this.isImageFileType(file.type);
	//   }
	//   isImageFileType(typ) {
	//     return typ === 'image/jpeg' || typ === 'image/png' || typ === 'image/bmp' || typ === 'image/x-windows-bmp' || typ === 'image/gif' || typ === 'image/tiff';
	//   }
	//   getImageFormat(file) {
	//     return file.type === 'image/png' ? 'image/png' : 'image/jpeg';
	//   }
	//   getMediaURL(m) {
	//     if (m.fileInfos.size > 0) {
	//       return this.getFileURL(m.id, Array.from(m.fileInfos.keys())[0]);
	//     }
	//     if (!!m._url) { // fs media
	//       return m._url;
	//     }
	//     return '';
	//   }
	//   getDownloadURL(m) {
	//     if (this.currentTreeId.get() > 0 && m.fileInfos.size > 0) {
	//       return this.server.get(this.getFileBase(m.id, Array.from(m.fileInfos.keys())[0]) + '/download?token=' + this.authToken.get());
	//     }
	//     if (!!m._url) { // fs media
	//       return this.rx.Observable.of(m._url);
	//     }
	//     return this.rx.Observable.of('');
	//   }
	//   isImage(m, includeVideo, excludeTiff) {
	//     if (m.fileInfos.size > 0) {
	//       let fileType = this.utils.first(m.fileInfos).contentType.toLowerCase();
	//       return (this.isImageFileType(fileType) && !(excludeTiff && fileType === 'image/tiff')) || (includeVideo && fileType === 'video/mp4');
	//     }
	//     return false;
	//   }
	//   getMediaImageURL(m, size) {
	//     if (m.fileInfos.size > 0) {
	//       if (this.isImage(m, true)) {
	//         return this.getFileURL(m.id, Array.from(m.fileInfos.keys())[0], size);
	//       }
	//       // return placeholder image
	//       return '../../assets/images/no-image' + (!!size ? size : '') + '.jpg';
	//     }
	//     if (!!m._url) { // fs media
	//       return m._url;
	//     }
	//     return '';
	//   }
	//   uploadMediaFile(mediaId, fileId, fileData) { // fileData={fileName, file, cropped, fileDataURI}
	//     let subject = new this.rx.AsyncSubject();
	//     this.server.incRequests();
	//     this.utils.upload({
	//       url: this.getFileURL(mediaId, fileId),
	//       data: {
	//         fileName: fileData.fileName,
	//         file: this.isImageFile(fileData.file) && fileData.cropped ? this.Upload.dataUrltoBlob(fileData.fileDataURI, fileData.file.name) : fileData.file
	//       }
	//     }).subscribe(response => {
	//       this.server.decRequests();
	//       subject.next(response.data.type);
	//       subject.complete();
	//     }, response => {
	//       this.server.decRequests();
	//       this.messageBus.post({msg: 'Error uploading media: ' + (response.status === 413 ? 'file is too large' : response.status + ' - please try again later or contact support@rootsfinder.com')});
	//       subject.error(response);
	//     });
	//     return subject;
	//   }
	//   createMediaFromFile(mediaData, fileData) { // fileData={fileName, file, cropped, fileDataURI}
	//     let media = Object.assign({}, {
	//       id: this.utils.randomId(),
	//       fileInfos: new Map(),
	//       personIds: new Map()
	//     }, mediaData);
	//     return this.uploadMediaFile(media.id, 0, fileData).flatMap(fileType => {
	//       media.fileInfos.set(0, {contentType: fileType, fileName: fileData.fileName});
	//       return this.create(media);
	//     });
	//   }
	//   createSlideshow(data) {
	//     let subject = new this.rx.AsyncSubject();
	//     this.server.incRequests();
	//     this.utils.upload({
	//       url: this.serverBase + '/trees/' + this.currentTreeId.get() + '/mediaserver?type=slideshow&token=' + this.authToken.get(),
	//       data: {
	//         file: data.file,
	//         form: this.Upload.json(data.form)
	//       }
	//     }).subscribe(response => {
	//       this.server.decRequests();
	//       if (data.form.preview) {
	//         // listen for completed
	//         let sub = this.changeStream
	//           .filter(change => change.collection === 'mediaserver' && change.type === 'slideshow' && +change.id === +response.data.id)
	//           .subscribe(change => {
	//             subject.next(change);
	//             subject.complete();
	//             sub.unsubscribe();
	//           });
	//       }
	//       else {
	//         subject.next(null);
	//         subject.complete();
	//       }
	//     }, response => {
	//       this.server.decRequests();
	//       this.messageBus.post({msg: 'Error uploading media: ' + (response.status === 413 ? 'file is too large' : response.status + ' - please try again later or contact support@rootsfinder.com')});
	//       subject.error(response);
	//     });
	//     return subject;
	//   }
	//   augmentMedia(m, persons, evidences, sources, stories, users) {
	//     let subject = new this.rx.AsyncSubject();
	//     let waitCount = (m.personIds.size > 0 ? 1 : 0) + 4;
	//     m = Object.assign({}, m, {
	//       '_people': new Map(),
	//       '_evidences': new Map(),
	//       '_sources': new Map(),
	//       '_stories': new Map(),
	//       '_createdUser' : null,
	//       '_editedUser' : null
	//     });
	//     // set people
	//     if (m.personIds.size > 0) {
	//       persons.streamIds(Array.from(m.personIds.keys())).take(1).subscribe(pm => {
	//         m._people = pm;
	//         if (--waitCount === 0) {
	//           subject.next(m);
	//           subject.complete();
	//         }
	//       });
	//     }
	//     // set evidences
	//     evidences.streamForMedia(m.id).take(1).subscribe(em => {
	//       m._evidences = em;
	//       if (--waitCount === 0) {
	//         subject.next(m);
	//         subject.complete();
	//       }
	//     });
	//     // set sources
	//     sources.streamForMedia(m.id).take(1).subscribe(sm => {
	//       m._sources = sm;
	//       if (--waitCount === 0) {
	//         subject.next(m);
	//         subject.complete();
	//       }
	//     });
	//     // set stories
	//     stories.streamForMedia(m.id).take(1).subscribe(sm => {
	//       m._stories = sm;
	//       if (--waitCount === 0) {
	//         subject.next(m);
	//         subject.complete();
	//       }
	//     });
	//     // set created user and edited user
	//     this.utils.addCreateEditUsers(m, users).subscribe(() => {
	//       if (--waitCount === 0) {
	//         subject.next(m);
	//         subject.complete();
	//       }
	//     });
	//     return subject;
	//   }
	//   hasWord(m, w) {
	//     return (m.text.toLowerCase().indexOf(w) >= 0) ||
	//       (m.title.toLowerCase().indexOf(w) >= 0) ||
	//       (m.date.toLowerCase().indexOf(w) >= 0) ||
	//       (m.place.toLowerCase().indexOf(w) >= 0) ||
	//       (Array.from(m._people.values()).some(p => p._fullName.toLowerCase().indexOf(w) >= 0));
	//   }
	//   _addDerived(m) {
	//     return this.utils.addCreateEditDates(m);
	//   }
	// }
	// export default MediasService;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Subject, BehaviorSubject, Observable, AsyncSubject } from "../../node_modules/rxjs";
	var MediasService = /** @class */ (function () {
	    function MediasService(log, rx, interval, store, changes, Upload, serverBase, currentTreeId, authToken, messageBus, segment, server, utils) {
	        var _this = this;
	        this.log = log;
	        this.rx = rx;
	        this.interval = interval;
	        this.Upload = Upload;
	        this.serverBase = serverBase;
	        this.currentTreeId = currentTreeId;
	        this.authToken = authToken;
	        this.messageBus = messageBus;
	        this.segment = segment;
	        this.server = server;
	        this.utils = utils;
	        this.changeStream = changes.treeStream();
	        this.store = store.create("trees", "media", changes.treeStream(), function (m) { return _this._addDerived(m); });
	        this.personStream = this.store.addStream(store.streamScanFn(function (o) {
	            return o.personIds ? o.personIds.keys() : null;
	        }));
	        this.researchLogStream = this.store.addStream(store.streamScanFn(function (o) {
	            var researchLogId = o.researchLogId || 0;
	            return researchLogId > 0 ? [researchLogId] : null;
	        }));
	        this.fileTypes = '*';
	        this.fileModelOptions = { debounce: 300 };
	        this.fileValidation = { size: { max: '500MB', min: '10B' } };
	        this.fileDragover = { accept: 'file__upload-drag_dragover', reject: 'file__upload-drag_dragover_err', pattern: this.fileTypes };
	    }
	    MediasService.prototype.create = function (o, options) {
	        this.segment.track('media.create');
	        o.researchLogId = o.researchLogId || 0;
	        return this.store.create(o, null, options);
	    };
	    MediasService.prototype.update = function (o) {
	        this.segment.track('media.update');
	        o.researchLogId = o.researchLogId || 0;
	        return this.store.update(o);
	    };
	    MediasService.prototype.del = function (id) {
	        this.segment.track('media.delete');
	        return this.store.del(id);
	    };
	    MediasService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    MediasService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    MediasService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    MediasService.prototype.streamIds = function (ids) {
	        return this.store.streamIds(ids);
	    };
	    // returns a map
	    MediasService.prototype.streamForPerson = function (pid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.personStream.map(function (m) { return (m.get(pid) || new Map()); }); });
	    };
	    // returns a map
	    MediasService.prototype.streamForResearchLog = function (rlid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.researchLogStream.map(function (m) { return m.get(rlid) || new Map(); }); });
	    };
	    //
	    // helper functions
	    //
	    MediasService.prototype.getFileBase = function (mediaId, fileId) {
	        return '/trees/' + this.currentTreeId.get() + '/media/' + mediaId.toString() + '/files/' + fileId.toString();
	    };
	    MediasService.prototype.getFileURL = function (mediaId, fileId, size) {
	        if (this.currentTreeId.get() === 0) {
	            return '';
	        }
	        return this.serverBase + this.getFileBase(mediaId, fileId) + '?token=' + this.authToken.get() + (!!size ? '&size=' + size : '');
	    };
	    MediasService.prototype.isImageFile = function (file) {
	        return !!file && this.isImageFileType(file.type);
	    };
	    MediasService.prototype.isImageFileType = function (typ) {
	        return typ === 'image/jpeg' || typ === 'image/png' || typ === 'image/bmp' || typ === 'image/x-windows-bmp' || typ === 'image/gif' || typ === 'image/tiff';
	    };
	    MediasService.prototype.getImageFormat = function (file) {
	        return file.type === 'image/png' ? 'image/png' : 'image/jpeg';
	    };
	    MediasService.prototype.getMediaURL = function (m) {
	        if (m.fileInfos.size > 0) {
	            return this.getFileURL(m.id, Array.from(m.fileInfos.keys())[0]);
	        }
	        if (!!m._url) {
	            return m._url;
	        }
	        return '';
	    };
	    MediasService.prototype.getDownloadURL = function (m, size) {
	        if (this.currentTreeId.get() > 0 && m.fileInfos.size > 0) {
	            return this.server.get(this.getFileBase(m.id, Array.from(m.fileInfos.keys())[0]) + '/download?token=' + this.authToken.get() + (!!size ? '&size=' + size : ''));
	        }
	        if (!!m._url) {
	            return this.rx.Observable.of(m._url);
	        }
	        return this.rx.Observable.of('');
	    };
	    MediasService.prototype.isImage = function (m, includeVideo, excludeTiff, includePDF) {
	        if (m.fileInfos.size > 0) {
	            var fileType = this.utils.first(m.fileInfos).contentType.toLowerCase();
	            return (this.isImageFileType(fileType) && !(excludeTiff && fileType === 'image/tiff')) ||
	                (includeVideo && fileType === 'video/mp4') || (includePDF && fileType === 'application/pdf');
	        }
	        return false;
	    };
	    MediasService.prototype.getMediaImageURL = function (m, size) {
	        if (m.fileInfos.size > 0) {
	            if (this.isImage(m, true, false, false)) {
	                return this.getFileURL(m.id, Array.from(m.fileInfos.keys())[0], size);
	            }
	            // return placeholder image
	            return '../../assets/images/no-image' + (!!size ? size : '') + '.jpg';
	        }
	        if (!!m._url) {
	            return m._url;
	        }
	        return '';
	    };
	    MediasService.prototype.uploadMediaFile = function (mediaId, fileId, fileData) {
	        var _this = this;
	        var subject = new this.rx.AsyncSubject();
	        this.server.incRequests();
	        this.utils.upload({
	            url: this.getFileURL(mediaId, fileId),
	            data: {
	                fileName: fileData.fileName,
	                file: this.isImageFile(fileData.file) && fileData.cropped ? this.Upload.dataUrltoBlob(fileData.fileDataURI, fileData.file.name) : fileData.file
	            }
	        }).subscribe(function (response) {
	            _this.server.decRequests();
	            subject.next(response.data.type);
	            subject.complete();
	        }, function (response) {
	            _this.server.decRequests();
	            _this.messageBus.post({ msg: 'Error uploading media: ' + (response.status === 413 ? 'file is too large' : response.status + ' - please try again later or contact support@rootsfinder.com') });
	            subject.error(response);
	        });
	        return subject;
	    };
	    MediasService.prototype.createMediaFromFile = function (mediaData, fileData) {
	        var _this = this;
	        var media = Object.assign({}, {
	            id: this.utils.randomId(),
	            fileInfos: new Map(),
	            personIds: new Map()
	        }, mediaData);
	        return this.uploadMediaFile(media.id, 0, fileData).flatMap(function (fileType) {
	            media.fileInfos.set(0, { contentType: fileType, fileName: fileData.fileName });
	            return _this.create(media);
	        });
	    };
	    MediasService.prototype.createSlideshow = function (data) {
	        var _this = this;
	        var subject = new this.rx.AsyncSubject();
	        this.server.incRequests();
	        this.utils.upload({
	            url: this.serverBase + '/trees/' + this.currentTreeId.get() + '/mediaserver?type=slideshow&token=' + this.authToken.get(),
	            data: {
	                file: data.file,
	                form: this.Upload.json(data.form)
	            }
	        }).subscribe(function (response) {
	            _this.server.decRequests();
	            if (data.form.preview) {
	                var interval_1 = null;
	                // listen for completed
	                var sub_1 = _this.changeStream.pipe(_this.rx.operators.filter(function (change) {
	                    return change.collection === 'mediaserver' && change.type === 'slideshow' && +change.id === +response.data.id;
	                })).subscribe(function (change) {
	                    subject.next(change);
	                    subject.complete();
	                    sub_1.unsubscribe();
	                    sub_1 = null;
	                    if (!!interval_1) {
	                        _this.interval.cancel(interval_1);
	                        interval_1 = null;
	                    }
	                });
	                // also, poll every 10 seconds
	                interval_1 = _this.interval(function () {
	                    _this.server.get('/trees/' + _this.currentTreeId.get() + '/mediaserver/' + response.data.id).subscribe(function (change) {
	                        subject.next(change);
	                        subject.complete();
	                        _this.interval.cancel(interval_1);
	                        interval_1 = null;
	                        if (!!sub_1) {
	                            sub_1.unsubscribe();
	                            sub_1 = null;
	                        }
	                    }, function (err) {
	                        // ignore
	                    });
	                }, 10000);
	            }
	            else {
	                subject.next(null);
	                subject.complete();
	            }
	        }, function (response) {
	            _this.server.decRequests();
	            _this.messageBus.post({ msg: 'Error uploading media: ' + (response.status === 413 ? 'file is too large' : response.status + ' - please try again later or contact support@rootsfinder.com') });
	            subject.error(response);
	        });
	        return subject;
	    };
	    MediasService.prototype.augmentMedia = function (m, persons, evidences, sources, stories, users) {
	        var subject = new this.rx.AsyncSubject();
	        var waitCount = (m.personIds.size > 0 ? 1 : 0) + 4;
	        m = Object.assign({}, m, {
	            '_people': new Map(),
	            '_evidences': new Map(),
	            '_sources': new Map(),
	            '_stories': new Map(),
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        // set people
	        if (m.personIds.size > 0) {
	            persons.streamIds(Array.from(m.personIds.keys())).take(1).subscribe(function (pm) {
	                m._people = pm;
	                if (--waitCount === 0) {
	                    subject.next(m);
	                    subject.complete();
	                }
	            });
	        }
	        // set evidences
	        evidences.streamForMedia(m.id).take(1).subscribe(function (em) {
	            m._evidences = em;
	            if (--waitCount === 0) {
	                subject.next(m);
	                subject.complete();
	            }
	        });
	        // set sources
	        sources.streamForMedia(m.id).take(1).subscribe(function (sm) {
	            m._sources = sm;
	            if (--waitCount === 0) {
	                subject.next(m);
	                subject.complete();
	            }
	        });
	        // set stories
	        stories.streamForMedia(m.id).take(1).subscribe(function (sm) {
	            m._stories = sm;
	            if (--waitCount === 0) {
	                subject.next(m);
	                subject.complete();
	            }
	        });
	        // set created user and edited user
	        this.utils.addCreateEditUsers(m, users).subscribe(function () {
	            if (--waitCount === 0) {
	                subject.next(m);
	                subject.complete();
	            }
	        });
	        return subject;
	    };
	    MediasService.prototype.hasWord = function (m, w) {
	        return (m.text.toLowerCase().indexOf(w) >= 0) ||
	            (m.title.toLowerCase().indexOf(w) >= 0) ||
	            (m.date.toLowerCase().indexOf(w) >= 0) ||
	            (m.place.toLowerCase().indexOf(w) >= 0) ||
	            ((!!m._people ? Array.from(m._people.values()) : []).some(function (p) { return p._fullName.toLowerCase().indexOf(w) >= 0; })); //TODO add person interface type
	    };
	    MediasService.prototype._addDerived = function (m) {
	        return this.utils.addCreateEditDates(m);
	    };
	    return MediasService;
	}());
	exports.MediasService = MediasService;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var mediaUtils_service_1 = __webpack_require__(237);
	var MediaUtilsService = /** @class */ (function (_super) {
	    __extends(MediaUtilsService, _super);
	    MediaUtilsService.$inject = ["medias", "subscriptions", "currentTreeId", "segment", "server", "utils"];
	    function MediaUtilsService(medias, subscriptions, currentTreeId, segment, server, utils) {
	        'ngInject';
	        return _super.call(this, medias, subscriptions, currentTreeId, segment, server, utils) || this;
	    }
	    return MediaUtilsService;
	}(mediaUtils_service_1.MediaUtilsService));
	exports.default = MediaUtilsService;
	// class MediaUtilsService {
	//   constructor (medias, subscriptions, currentTreeId, segment, server, utils) {
	//     'ngInject';
	//     this.medias = medias;
	//     this.subscriptions = subscriptions;
	//     this.currentTreeId = currentTreeId;
	//     this.segment = segment;
	//     this.server = server;
	//     this.utils = utils;
	//   }
	//   mosaic(ev, media) {
	//     this.utils.confirm('Mosaic', 'This action creates a mosaic of this picture from all of the other pictures in your tree. Do you want to do this?', ev).then(() => {
	//       // read current subscription and
	//       this.subscriptions.stream().filter(sub => !!sub).take(1).subscribe(sub => {
	//         // call media service
	//         let request = {
	//           mediaId: media.id,
	//           personIds: media.personIds,
	//           title: !!media.title ? (media.title + ' (mosaic)') : 'Mosaic'
	//         };
	//         request = this.utils.toServer(request);
	//         this.server.post('/trees/' + this.currentTreeId.get() + '/mediaserver?type=mosaic', request).subscribe(() => {
	//           this.segment.track('media.mosaic');
	//           this.utils.alert('Mosaic In-Process', 'Your mosaic is being generated. This usually takes 5-10 minutes. You will receive an email when it is ready.' +
	//             (sub.level !== 'PRO_TRIAL' && sub.level !== 'PRO' ? ' Your mosaic will include a small watermark. ' +
	//             'To remove the watermark, upgrade to a Pro Plan by clicking on your name in the upper-right corner and selecting "Account".' : ''));
	//         }, () => {
	//           // ignore
	//         });
	//       }, () => {
	//         // ignore
	//       });
	//     }, () => {
	//       // ignore
	//     });
	//   }
	// }
	// export default MediaUtilsService;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var MediaUtilsService = /** @class */ (function () {
	    function MediaUtilsService(medias, subscriptions, currentTreeId, segment, server, utils) {
	        this.medias = medias;
	        this.subscriptions = subscriptions;
	        this.currentTreeId = currentTreeId;
	        this.segment = segment;
	        this.server = server;
	        this.utils = utils;
	    }
	    MediaUtilsService.prototype.mosaic = function (ev, media) {
	        var _this = this;
	        this.utils.confirm('Mosaic', 'This action creates a mosaic of this picture from all of the other pictures in your tree. Do you want to do this?', ev).then(function () {
	            // read current subscription and
	            _this.subscriptions.stream().filter(function (sub) { return !!sub; }).take(1).subscribe(function (sub) {
	                // call media service
	                var request = {
	                    mediaId: media.id,
	                    personIds: media.personIds,
	                    title: !!media.title ? (media.title + ' (mosaic)') : 'Mosaic'
	                };
	                request = _this.utils.toServer(request);
	                _this.server.post('/trees/' + _this.currentTreeId.get() + '/mediaserver?type=mosaic', request).subscribe(function () {
	                    _this.segment.track('media.mosaic');
	                    _this.utils.alert('Mosaic In-Process', 'Your mosaic is being generated. This usually takes 5-10 minutes. You will receive an email when it is ready.' +
	                        (sub.level !== 'PRO_TRIAL' && sub.level !== 'PRO' ? ' Your mosaic will include a small watermark. ' +
	                            'To remove the watermark, upgrade to a Pro Plan by clicking on your name in the upper-right corner and selecting "Account".' : ''));
	                }, function () {
	                    // ignore
	                });
	            }, function () {
	                // ignore
	            });
	        }, function () {
	            // ignore
	        });
	    };
	    return MediaUtilsService;
	}());
	exports.MediaUtilsService = MediaUtilsService;
	exports.default = MediaUtilsService;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var messageBus_service_1 = __webpack_require__(239);
	var MessageBusService = /** @class */ (function (_super) {
	    __extends(MessageBusService, _super);
	    MessageBusService.$inject = ["$log", "$translate", "$timeout", "$window", "rx"];
	    function MessageBusService($log, $translate, $timeout, $window, rx) {
	        'ngInject';
	        return _super.call(this, $log, $translate, rx, $window.Raven, $timeout, angular) || this;
	    }
	    return MessageBusService;
	}(messageBus_service_1.MessageBusService));
	exports.default = MessageBusService;
	// class MessageBusService {
	//   constructor($log, $translate, $timeout, $window, rx) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.$translate = $translate;
	//     this.$timeout = $timeout;
	//     this.Raven = $window.Raven;
	//     this.subject = new rx.BehaviorSubject(null);
	//   }
	//   post(message) {
	//     if (message === null) {
	//       message = {msg:''};
	//     }
	//     else if (message.status === 400) {
	//       message.msg = 'BAD_REQUEST';
	//     }
	//     else if (message.status === 409) {
	//       message.msg = 'CONFLICT';
	//     }
	//     else if (message.msg === 'PUSHER_NO_AUTH' || message.status === 401) {
	//       this.$timeout(() => {
	//         //this.$state.go('home');
	//       }, 1000);
	//     }
	//     else if (!message.msg) {
	//       message.msg = 'UNKNOWN_ERROR';
	//     }
	//     if (message.msg === 'FS_CANCEL') {
	//       return;
	//     }
	//     this.$translate(message.msg).then(msg => {
	//       this.subject.next(msg);
	//     }, () => {
	//       this.subject.next(message.msg);
	//     });
	//     if (message.warn) {
	//       let err = message.msg +
	//         (!!message.ctx ? ' ctx=' + message.ctx : '') +
	//         (!!message.op ? ' op=' + message.op : '') +
	//         (!!message.status ? ' status=' + message.status : '') +
	//         (!!message.warnParams ? ' params=' + angular.toJson(message.warnParams) : '');
	//       this.$log.warn('messagebus.post', err);
	//       if (message.msg !== 'UNAUTHORIZED') {
	//         try {
	//           throw new Error(err);
	//         } catch(e) {
	//           this.Raven.captureException(e);
	//           //this.Raven.showReportDialog();
	//         }
	//       }
	//     }
	//   }
	//   stream() {
	//     return this.subject;
	//   }
	// }
	// export default MessageBusService;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { BehaviorSubject } from "../../node_modules/rxjs";
	var MessageBusService = /** @class */ (function () {
	    function MessageBusService(log, translate, rx, Raven, timeout, angularUtils /*, private window: IWindow*/) {
	        this.log = log;
	        this.translate = translate;
	        this.Raven = Raven;
	        this.timeout = timeout;
	        this.angularUtils = angularUtils; /*, private window: IWindow*/
	        this.subject = new rx.BehaviorSubject(null);
	    }
	    MessageBusService.prototype.post = function (message) {
	        var _this = this;
	        if (message === null) {
	            message = { msg: '' };
	        }
	        else if (message.status === 400) {
	            message.msg = 'BAD_REQUEST';
	        }
	        else if (message.status === 409) {
	            message.msg = 'CONFLICT';
	        }
	        else if (message.msg === 'PUSHER_NO_AUTH' || message.status === 401) {
	            this.timeout(function () {
	                //this.$state.go('home');
	            }, 1000);
	        }
	        else if (!message.msg) {
	            message.msg = 'UNKNOWN_ERROR';
	        }
	        if (message.msg === 'FS_CANCEL') {
	            return;
	        }
	        this.translate(message.msg).then(function (msg) {
	            if (message.msg === 'FS_ERROR' && !!message.warnParams.warning) {
	                msg += ' (' + message.warnParams.warning + ')';
	            }
	            _this.subject.next(msg);
	        }, function () {
	            _this.subject.next(message.msg);
	        });
	        if (message.warn) {
	            var err = message.msg +
	                (!!message.ctx ? ' ctx=' + message.ctx : '') +
	                (!!message.op ? ' op=' + message.op : '') +
	                (!!message.status ? ' status=' + message.status : '') +
	                (!!message.warnParams ? ' params=' + this.angularUtils.toJson(message.warnParams) : '');
	            this.log.warn('messagebus.post', err);
	            if (message.msg !== 'UNAUTHORIZED') {
	                try {
	                    throw new Error(err);
	                }
	                catch (e) {
	                    this.Raven.captureException(e);
	                    //this.Raven.showReportDialog();
	                }
	            }
	        }
	    };
	    MessageBusService.prototype.stream = function () {
	        return this.subject;
	    };
	    return MessageBusService;
	}());
	exports.MessageBusService = MessageBusService;


/***/ }),
/* 240 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var MousewheelService = /** @class */ (function () {
	    // derived from https://developer.mozilla.org/en-US/docs/Web/Events/wheel
	    MousewheelService.$inject = ["$window"];
	    function MousewheelService($window) {
	        'ngInject';
	        // detect available wheel event
	        //this.support = 'onwheel' in $window.document.createElement('div') ? 'wheel' : // Modern browsers support "wheel"
	        //  $window.document.onmousewheel !== undefined ? 'mousewheel' : // Webkit and IE support at least "mousewheel"
	        //    'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
	        this.support = $window.document.onmousewheel !== undefined ? 'mousewheel' : // Webkit and IE support at least "mousewheel"
	            'onwheel' in $window.document.createElement('div') ? 'wheel' : // Modern browsers support "wheel"
	                'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
	    }
	    // elem is a dom (not wrapped by angular)
	    MousewheelService.prototype.addListener = function (elem, callback, useCapture) {
	        this._addWheelListener(elem, this.support, callback, useCapture);
	        // handle MozMousePixelScroll in older Firefox
	        if (this.support === 'DOMMouseScroll') {
	            this._addWheelListener(elem, 'MozMousePixelScroll', callback, useCapture);
	        }
	    };
	    MousewheelService.prototype._addWheelListener = function (elem, eventName, callback, useCapture) {
	        var self = this;
	        elem.addEventListener(eventName, this.support === 'wheel' ? callback : function (originalEvent) {
	            // create a normalized event object
	            var event = {
	                // keep a ref to the original event object
	                originalEvent: originalEvent,
	                target: originalEvent.target || originalEvent.srcElement,
	                type: 'wheel',
	                deltaMode: originalEvent.type === 'MozMousePixelScroll' ? 0 : 1,
	                deltaX: 0,
	                deltaZ: 0,
	                // add pageX/Y
	                pageX: originalEvent.pageX,
	                pageY: originalEvent.pageY,
	                preventDefault: function () {
	                    if (originalEvent.preventDefault) {
	                        originalEvent.preventDefault();
	                    }
	                    else {
	                        originalEvent.returnValue = false;
	                    }
	                }
	            };
	            // calculate deltaY (and deltaX) according to the event
	            if (self.support === 'mousewheel') {
	                event.deltaY = -1 / 40 * originalEvent.wheelDelta;
	                // Webkit also support wheelDeltaX
	                if (originalEvent.wheelDeltaX) {
	                    event.deltaX = -1 / 40 * originalEvent.wheelDeltaX;
	                }
	            }
	            else {
	                event.deltaY = originalEvent.detail;
	            }
	            // it's time to fire the callback
	            return callback(event);
	        }, useCapture || false);
	    };
	    return MousewheelService;
	}());
	exports.default = MousewheelService;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var musics_service_1 = __webpack_require__(242);
	var MusicsService = /** @class */ (function (_super) {
	    __extends(MusicsService, _super);
	    MusicsService.$inject = ["$log", "rx", "server", "messageBus"];
	    function MusicsService($log, rx, server, messageBus) {
	        'ngInject';
	        return _super.call(this, rx, server, messageBus) || this;
	    }
	    return MusicsService;
	}(musics_service_1.MusicsService));
	exports.default = MusicsService;
	// class MusicsService {
	//   constructor ($log, rx, server, messageBus) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.server = server;
	//     this.messageBus = messageBus;
	//     this.subject = new rx.AsyncSubject();
	//     this.requested = false;
	//   }
	//   // group by genre
	//   stream() {
	//     if (!this.requested) {
	//       this._requestMusic();
	//     }
	//     return this.subject;
	//   }
	//   _requestMusic() {
	//     this.requested = true;
	//     this.server.get('/music')
	//       .catch(err => {
	//         this.messageBus.post({msg: err.data, status: err.status, op: 'GET', ctx: 'music'});
	//         this.requested = false;
	//       })
	//       .subscribe(response => {
	//         this.subject.next(this._groupByGenre(response));
	//         this.subject.complete();
	//       });
	//   }
	//   _groupByGenre(response) {
	//     let genres = [];
	//     for (let song of response) {
	//       let genre = genres.find(g => g.name === song.genre);
	//       if (!genre) {
	//         genre = {name: song.genre, songs: []};
	//         genres.push(genre);
	//       }
	//       genre.songs.push(song);
	//     }
	//     return genres;
	//   }
	// }
	// export default MusicsService;


/***/ }),
/* 242 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var MusicsService = /** @class */ (function () {
	    function MusicsService(rx, server, messageBus) {
	        this.rx = rx;
	        this.server = server;
	        this.messageBus = messageBus;
	        this.subject = new rx.AsyncSubject();
	        this.requested = false;
	    }
	    // group by genre
	    MusicsService.prototype.stream = function () {
	        if (!this.requested) {
	            this._requestMusic();
	        }
	        return this.subject;
	    };
	    MusicsService.prototype._requestMusic = function () {
	        var _this = this;
	        this.requested = true;
	        this.server.get('/music')
	            .catch(function (err) {
	            _this.messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'music' });
	            _this.requested = false;
	            return _this.rx.Observable.of({}); //TODO is this valid? compiler wants it
	        })
	            .subscribe(function (response) {
	            _this.subject.next(_this._groupByGenre(response));
	            _this.subject.complete();
	        });
	    };
	    MusicsService.prototype._groupByGenre = function (response) {
	        var genres = [];
	        var _loop_1 = function (song) {
	            var genre = genres.find(function (g) { return g.name === song.genre; });
	            if (!genre) {
	                genre = { name: song.genre, songs: [] };
	                genres.push(genre);
	            }
	            genre.songs.push(song);
	        };
	        try {
	            for (var response_1 = __values(response), response_1_1 = response_1.next(); !response_1_1.done; response_1_1 = response_1.next()) {
	                var song = response_1_1.value;
	                _loop_1(song);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (response_1_1 && !response_1_1.done && (_a = response_1.return)) _a.call(response_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return genres;
	        var e_1, _a;
	    };
	    return MusicsService;
	}());
	exports.MusicsService = MusicsService;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var notes_service_1 = __webpack_require__(244);
	var NotesService = /** @class */ (function (_super) {
	    __extends(NotesService, _super);
	    NotesService.$inject = ["$log", "rx", "store", "changes", "segment", "utils"];
	    function NotesService($log, rx, store, changes, segment, utils) {
	        'ngInject';
	        return _super.call(this, $log, rx, store, changes, segment, utils) || this;
	    }
	    return NotesService;
	}(notes_service_1.NotesService));
	exports.default = NotesService;
	// class NotesService {
	//   constructor ($log, rx, store, changes, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", "notes", changes.treeStream(), (s) => utils.addCreateEditDates(s));
	//     this.personStream = this.store.addStream(store.streamScanFn(o => {
	//       return o.personIds ? o.personIds.keys() : null;
	//     }));
	//     this.researchLogStream = this.store.addStream(store.streamScanFn(o => {
	//       let researchLogId = o.researchLogId || 0;
	//       return researchLogId > 0 ? [researchLogId] : null;
	//     }));
	//   }
	//   create(o) {
	//     this.segment.track('notes.create');
	//     o.researchLogId = o.researchLogId || 0;
	//     return this.store.create(o);
	//   }
	//   update(o) {
	//     this.segment.track('notes.update');
	//     o.researchLogId = o.researchLogId || 0;
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     this.segment.track('notes.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   // returns a map
	//   streamForPerson(pid) {
	//     return this.ready().flatMap(() => this.personStream.map(m => (m.get(pid) || new Map())));
	//   }
	//   // returns a map
	//   streamForResearchLog(rlid) {
	//     return this.ready().flatMap(() => this.researchLogStream.map(m => m.get(rlid) || new Map()));
	//   }
	//   //
	//   // helper functions
	//   //
	//   augmentNote(n, persons, users) {
	//     let subject = new this.rx.AsyncSubject();
	//     let waitCount = (n.personIds.size > 0 ? 1 : 0) + 1;
	//     n = Object.assign({}, n, {
	//       '_people': new Map(),
	//       '_createdUser' : null,
	//       '_editedUser' : null
	//     });
	//     // set people
	//     if (n.personIds.size > 0) {
	//       persons.streamIds(Array.from(n.personIds.keys())).take(1).subscribe(pm => {
	//         n._people = pm;
	//         if (--waitCount === 0) {
	//           subject.next(n);
	//           subject.complete();
	//         }
	//       });
	//     }
	//     // set created user and edited user
	//     this.utils.addCreateEditUsers(n, users).subscribe(() => {
	//       if (--waitCount === 0) {
	//         subject.next(n);
	//         subject.complete();
	//       }
	//     });
	//     return subject;
	//   }
	//   hasWord(n, w) {
	//     return (n.text.toLowerCase().indexOf(w) >= 0) ||
	//       (n.title.toLowerCase().indexOf(w) >= 0) ||
	//       (Array.from(n._people.values()).some(p => p._fullName.toLowerCase().indexOf(w) >= 0));
	//   }
	// }
	// export default NotesService;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { BehaviorSubject, AsyncSubject } from "../../node_modules/rxjs";
	var NotesService = /** @class */ (function () {
	    function NotesService(log, rx, store, changes, segment, utils) {
	        this.log = log;
	        this.rx = rx;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "notes", changes.treeStream(), function (s) { return utils.addCreateEditDates(s); });
	        this.personStream = this.store.addStream(store.streamScanFn(function (o) {
	            return o.personIds ? o.personIds.keys() : null;
	        }));
	        this.researchLogStream = this.store.addStream(store.streamScanFn(function (o) {
	            var researchLogId = o.researchLogId || 0;
	            return researchLogId > 0 ? [researchLogId] : null;
	        }));
	    }
	    NotesService.prototype.create = function (o) {
	        this.segment.track('notes.create');
	        o.researchLogId = o.researchLogId || 0;
	        return this.store.create(o);
	    };
	    NotesService.prototype.update = function (o) {
	        this.segment.track('notes.update');
	        o.researchLogId = o.researchLogId || 0;
	        return this.store.update(o);
	    };
	    NotesService.prototype.del = function (id) {
	        this.segment.track('notes.delete');
	        return this.store.del(id);
	    };
	    NotesService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    NotesService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    NotesService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    // returns a map
	    NotesService.prototype.streamForPerson = function (pid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.personStream.map(function (m) { return (m.get(pid) || new Map()); }); });
	    };
	    // returns a map
	    NotesService.prototype.streamForResearchLog = function (rlid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.researchLogStream.map(function (m) { return m.get(rlid) || new Map(); }); });
	    };
	    //
	    // helper functions
	    //
	    NotesService.prototype.augmentNote = function (n, persons, users) {
	        var subject = new this.rx.AsyncSubject();
	        var waitCount = (n.personIds.size > 0 ? 1 : 0) + 1;
	        n = Object.assign({}, n, {
	            '_people': new Map(),
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        // set people
	        if (n.personIds.size > 0) {
	            persons.streamIds(Array.from(n.personIds.keys())).take(1).subscribe(function (pm) {
	                n._people = pm;
	                if (--waitCount === 0) {
	                    subject.next(n);
	                    subject.complete();
	                }
	            });
	        }
	        // set created user and edited user
	        this.utils.addCreateEditUsers(n, users).subscribe(function () {
	            if (--waitCount === 0) {
	                subject.next(n);
	                subject.complete();
	            }
	        });
	        return subject;
	    };
	    NotesService.prototype.hasWord = function (n, w) {
	        return (n.text.toLowerCase().indexOf(w) >= 0) ||
	            (n.title.toLowerCase().indexOf(w) >= 0) ||
	            ((!!n._people ? Array.from(n._people.values()) : []).some(function (p) { return p._fullName.toLowerCase().indexOf(w) >= 0; })); //TODO add note and people interface types
	    };
	    return NotesService;
	}());
	exports.NotesService = NotesService;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var notifications_service_1 = __webpack_require__(246);
	var NotificationsService = /** @class */ (function (_super) {
	    __extends(NotificationsService, _super);
	    NotificationsService.$inject = ["$log", "store", "changes", "utils"];
	    function NotificationsService($log, store, changes, utils) {
	        'ngInject';
	        return _super.call(this, store, changes) || this;
	    }
	    return NotificationsService;
	}(notifications_service_1.NotificationsService));
	exports.default = NotificationsService;
	// class NotificationsService {
	//   constructor ($log, store, changes, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.utils = utils;
	//     this.store = store.create("trees", "notifications", changes.treeStream());
	//   }
	//   create(o) {
	//     return this.store.create(o);
	//   }
	//   update(o) {
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   //
	//   // helper functions
	//   //
	// }
	// export default NotificationsService;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var NotificationsService = /** @class */ (function () {
	    function NotificationsService(store, changes) {
	        this.store = store.create("trees", "notifications", changes.treeStream());
	    }
	    NotificationsService.prototype.create = function (o) {
	        return this.store.create(o);
	    };
	    NotificationsService.prototype.update = function (o) {
	        return this.store.update(o);
	    };
	    NotificationsService.prototype.del = function (id) {
	        return this.store.del(id);
	    };
	    NotificationsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    NotificationsService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    NotificationsService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    return NotificationsService;
	}());
	exports.NotificationsService = NotificationsService;


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var OrdinancesService = /** @class */ (function () {
	    OrdinancesService.$inject = ["$log", "$translate", "rx", "store", "changes", "segment", "utils"];
	    function OrdinancesService($log, $translate, rx, store, changes, segment, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.$translate = $translate;
	        this.rx = rx;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "ordinances", changes.treeStream(), function (s) { return utils.addCreateEditDates(s); });
	        this.order = [
	            { type: 'http://lds.org/Baptism', order: 0 },
	            { type: 'http://lds.org/Confirmation', order: 1 },
	            { type: 'http://lds.org/Initiatory', order: 2 },
	            { type: 'http://lds.org/Endowment', order: 3 },
	            { type: 'http://lds.org/SealingToSpouse', order: 4 },
	            { type: 'http://lds.org/SealingChildToParents', order: 5 }
	        ];
	        this.statuses = this._getStatuses();
	    }
	    OrdinancesService.prototype.create = function (o) {
	        this.segment.track('ordinances.create');
	        return this.store.create(o);
	    };
	    OrdinancesService.prototype.update = function (o) {
	        this.segment.track('ordinances.update');
	        return this.store.update(o);
	    };
	    OrdinancesService.prototype.del = function (id) {
	        this.segment.track('ordinances.delete');
	        return this.store.del(id);
	    };
	    OrdinancesService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    OrdinancesService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    OrdinancesService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    //
	    // helper functions
	    //
	    OrdinancesService.prototype.augmentOrdinance = function (o, users) {
	        var subject = new this.rx.AsyncSubject();
	        o = Object.assign({}, o, {
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        // set created user and edited user
	        this.utils.addCreateEditUsers(o, users).subscribe(function () {
	            subject.next(o);
	            subject.complete();
	        });
	        return subject;
	    };
	    OrdinancesService.prototype._getStatuses = function () {
	        var _this = this;
	        return [
	            'http://familysearch.org/v1/Ready',
	            'http://familysearch.org/v1/NotReady',
	            'http://familysearch.org/v1/Submittable',
	            'http://familysearch.org/v1/Reserved',
	            'http://familysearch.org/v1/NeedMoreInformation',
	            'http://familysearch.org/v1/NotAvailable',
	            'http://familysearch.org/v1/Completed',
	            'http://familysearch.org/v1/NotNeeded',
	            'http://familysearch.org/v1/NotNeededBornInCovenant',
	            'http://familysearch.org/v1/Resubmittable',
	            'http://familysearch.org/v1/InProgress',
	            'http://familysearch.org/v1/NeedPermission',
	            'http://familysearch.org/v1/Cancelled',
	            'http://familysearch.org/v1/Deleted',
	            'http://familysearch.org/v1/Invalid'
	        ].map(function (v) {
	            var o = { value: v };
	            _this.$translate(v).then(function (display) {
	                o.display = display;
	            });
	            _this.$translate(v + '_detail').then(function (detail) {
	                o.detail = detail.startsWith('http://') ? '' : detail;
	            });
	            return o;
	        });
	    };
	    return OrdinancesService;
	}());
	exports.default = OrdinancesService;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var persons_service_1 = __webpack_require__(249);
	var PersonsService = /** @class */ (function (_super) {
	    __extends(PersonsService, _super);
	    PersonsService.$inject = ["$log", "$translate", "rx", "medias", "store", "changes", "utils"];
	    function PersonsService($log, $translate, rx, medias, store, changes, utils) {
	        'ngInject';
	        return _super.call(this, $translate, rx, medias, store, changes, utils) || this;
	    }
	    return PersonsService;
	}(persons_service_1.PersonsService));
	exports.default = PersonsService;
	// class PersonsService {
	//   constructor ($log, $translate, rx, medias, store, changes, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.$translate = $translate;
	//     this.rx = rx;
	//     this.medias = medias;
	//     this.utils = utils;
	//     this.store = store.create("trees", "persons", changes.treeStream(), (p) => this._addDerived(p));
	//     this.translations = this._getTranslations();
	//     this.parentsRelativeTypes = this._getParentsRelativeTypes();
	//     this.nameStream = this.store.addStream(store.streamScanFn(o => {
	//       let fullText = utils.normalize(this.getNameText(this.getDefaultNameForm(this.getPreferredName(o)), true));
	//       let pieces = fullText.length > 0 ? fullText.split(' ') : [];
	//       pieces.push(utils.encodeId(o.id));
	//       return pieces;
	//     }));
	//     this.evidenceStream = this.store.addStream(store.streamScanFn(o => {
	//       return [].concat(...Array.from(o.facts.values()).map(f => Array.from(f.evidencePersonas.keys())),
	//                        ...Array.from(o.names.values()).map(f => Array.from(f.evidencePersonas.keys())));
	//     }));
	//   }
	//   create(o, params) {
	//     return this.store.create(o, params);
	//   }
	//   update(o) {
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   streamIds(ids) {
	//     return this.store.streamIds(ids);
	//   }
	//   // returns a map
	//   streamForEvidence(eid) {
	//     return this.ready().flatMap(() => this.evidenceStream.map(m => (m.get(eid) || new Map())));
	//   }
	//   // non-streaming functions; caller must make sure that stream is "ready" before calling
	//   getMap() {
	//     return this.store.getStream().getValue();
	//   }
	//   getEvidenceMap() {
	//     return this.evidenceStream.getValue();
	//   }
	//   //tagAutocomplete(prefix) {
	//   //  let lc = prefix.toLowerCase();
	//   //  return this.tagStream
	//   //    .map(m => {
	//   //      let result = [];
	//   //      let found = false;
	//   //      m.keySeq().forEach(k => {
	//   //        let klc = k.toLowerCase();
	//   //        if (klc.startsWith(lc)) {
	//   //          if (klc === lc) {
	//   //            found = true;
	//   //          }
	//   //          result.push(k);
	//   //        }
	//   //      });
	//   //      if (!found) {
	//   //        result.push(prefix);
	//   //      }
	//   //      return result;
	//   //    })
	//   //    .take(1)
	//   //    .toPromise();
	//   //}
	//   streamMatches(matchData) {
	//     return this.stream().map(pm => {
	//       let scores = Array.from(pm.entries())
	//         .map(([pid, p]) => {
	//           return {
	//             id: pid,
	//             score: this.personMatchScore(p, matchData)
	//           };
	//         })
	//         // remove low-scoring people
	//         .filter(ps => ps.score >= 2);
	//       // sort the rest
	//       scores.sort((a,b) => {
	//         return b.score - a.score;
	//       });
	//       // return pids
	//       return scores.map(ps => ps.id);
	//     });
	//   }
	//   personMatchScore(p, matchData) {
	//     let givenFound = false;
	//     let surnameFound = false;
	//     let givenMatched = false;
	//     let surnameMatched = false;
	//     let given = !!matchData.given ? matchData.given.toLowerCase() : '';
	//     let surname = !!matchData.surname ? matchData.surname.toLowerCase() : '';
	//     p.names.forEach(n => {
	//       let nf = this.getDefaultNameForm(n);
	//       if (!!given && !!nf.given) {
	//         givenFound = true;
	//       }
	//       nf.given.toLowerCase().split(' ').forEach(np1 => {
	//         given.split(' ').forEach(np2 => {
	//           if (!!np1 && !!np2 && np1.length > 1 && np1 === np2) {
	//             givenMatched = true;
	//           }
	//         });
	//       });
	//       if (!!surname && !!nf.surname) {
	//         surnameFound = true;
	//       }
	//       nf.surname.toLowerCase().split(' ').forEach(np1 => {
	//         surname.split(' ').forEach(np2 => {
	//           if (!!np1 && !!np2 && np1.length > 1 && np1 === np2) {
	//             surnameMatched = true;
	//           }
	//         });
	//       });
	//     });
	//     let birthYear = !!matchData.birthDateSort ? +matchData.birthDateSort.substr(0,4) : 0;
	//     let deathYear = !!matchData.deathDateSort ? +matchData.deathDateSort.substr(0,4) : 0;
	//     let prefBirth = this.getPreferredBirth(p);
	//     let prefDeath = this.getPreferredDeath(p);
	//     let birthYearFound = birthYear > 0 && !!prefBirth && !!prefBirth.dateSort;
	//     let deathYearFound = deathYear > 0 && !!prefDeath && !!prefDeath.dateSort;
	//     let birthYearMatched = false;
	//     let deathYearMatched = false;
	//     if (birthYearFound && Math.abs(+prefBirth.dateSort.substr(0,4) - birthYear) <= 2) {
	//       birthYearMatched = true;
	//     }
	//     if (deathYearFound && Math.abs(+prefDeath.dateSort.substr(0,4) - deathYear) <= 2) {
	//       deathYearMatched = true;
	//     }
	//     let score = 0;
	//     if (givenFound) {
	//       score += givenMatched ? 1 : -2;
	//     }
	//     if (surnameFound) {
	//       score += surnameMatched ? 1 : -2;
	//     }
	//     if (birthYearFound) {
	//       score += birthYearMatched ? 1 : -2;
	//     }
	//     if (deathYearFound) {
	//       score += deathYearMatched ? 1 : -2;
	//     }
	//     if (!this.isCompatibleGender(p.gender, matchData.gender)) {
	//       score -= 4;
	//     }
	//     return score;
	//   }
	//   isCompatibleGender(gnd1, gnd2) {
	//     return !((gnd1 === 'MALE' || gnd1 === 'FEMALE') && (gnd2 === 'MALE' || gnd2 === 'FEMALE') && gnd1 !== gnd2);
	//   }
	//   nameAutocomplete(prefix, excludePid) {
	//     let lc = this.utils.normalize(prefix);
	//     return this.nameStream
	//       .map(m => {
	//         let resultMap = !lc ? new Map() : lc
	//           .split(' ')
	//           .map(piece => {
	//             let result = new Map();
	//             for (let [name, pm] of m) {
	//               if (name.toLowerCase().startsWith(piece)) {
	//                 for (let [pid, person] of pm) {
	//                   if (!excludePid || excludePid !== pid) {
	//                     result.set(pid, person);
	//                   }
	//                 }
	//               }
	//             }
	//             return result;
	//           })
	//           .reduce((prev, curr) => {
	//             if (prev === null) {
	//               return curr;
	//             }
	//             // remove keys in prev that are not in curr
	//             for (let [k] of prev) {
	//               if (!curr.has(k)) {
	//                 prev.delete(k);
	//               }
	//             }
	//             return prev;
	//           }, null);
	//         return Array.from(resultMap.values()).sort((a,b) => (b.editedDate || b.createdDate) - (a.editedDate || a.createdDate));
	//       })
	//       .take(1)
	//       .toPromise();
	//   }
	//   //
	//   // helper functions
	//   //
	//   augmentPerson(p, leads, evidences, users) {
	//     let subject = new this.rx.AsyncSubject();
	//     if (p === null) {
	//       subject.next(p);
	//       subject.complete();
	//       return subject;
	//     }
	//     let waitCount = (!!users ? 1 : 0) + 2;
	//     p = Object.assign({}, p, {
	//       '_hints': 0,
	//       '_stars': 0,
	//       '_createdUser' : null,
	//       '_editedUser' : null
	//     });
	//     // set leads
	//     leads.streamForPerson(p.id).take(1).subscribe(lm => {
	//       p._hints = Array.from(lm.values()).filter(l => !!l && l.createdUser === 0 && !l.hidden).length;
	//       if (--waitCount === 0) {
	//         subject.next(p);
	//         subject.complete();
	//       }
	//     });
	//     // set stars
	//     evidences.streamForPerson(p).take(1).subscribe(em => {
	//       p._stars = Array.from(em.values()).filter(e => !!e && e._hasSource).length;
	//       if (--waitCount === 0) {
	//         subject.next(p);
	//         subject.complete();
	//       }
	//     });
	//     // set created user and edited user
	//     if (!!users) {
	//       this.utils.addCreateEditUsers(p, users).subscribe(() => {
	//         if (--waitCount === 0) {
	//           subject.next(p);
	//           subject.complete();
	//         }
	//       });
	//     }
	//     return subject;
	//   }
	//   augmentFact(f, person, personMap, evidenceMap) {
	//     if (!f) {
	//       return f;
	//     }
	//     let birth = this.getPreferredBirth(person);
	//     let age = '';
	//     if (!!birth && !!f.dateSort && !!birth.dateSort) {
	//       age = this.utils.yearDiff(f.dateSort, birth.dateSort);
	//       if (isNaN(age) || age <= 0) {
	//         age = '';
	//       }
	//     }
	//     f = Object.assign({}, f, {
	//       '_age': age,
	//       '_principal1': f.principalId1 > 0 && personMap.has(f.principalId1) ? personMap.get(f.principalId1)._fullName : '',
	//       '_principal2': f.principalId2 > 0 && personMap.has(f.principalId2) ? personMap.get(f.principalId2)._fullName : '',
	//       '_evidences': new Map()
	//     });
	//     // set evidences
	//     for (let [eid] of f.evidencePersonas) {
	//       if (evidenceMap.has(eid)) {
	//         let e = evidenceMap.get(eid);
	//         f._evidences.set(eid, e);
	//         if (!f._sort && !!e._sourceAbbr) {
	//           f._sort = e._sourceAbbr.toLowerCase();
	//         }
	//       }
	//     }
	//     return f;
	//   }
	//   augmentName(n, person, evidenceMap) {
	//     if (!n) {
	//       return n;
	//     }
	//     let birth = this.getPreferredBirth(person);
	//     let age = '';
	//     if (!!birth && !!n.dateSort && !!birth.dateSort) {
	//       age = this.utils.yearDiff(n.dateSort, birth.dateSort);
	//       if (isNaN(age) || age <= 0) {
	//         age = '';
	//       }
	//     }
	//     n = Object.assign({}, n, {
	//       '_age': age,
	//       '_evidences': new Map()
	//     });
	//     // set evidences
	//     for (let [eid] of n.evidencePersonas) {
	//       if (evidenceMap.has(eid)) {
	//         n._evidences.set(eid, evidenceMap.get(eid));
	//       }
	//     }
	//     return n;
	//   }
	//   getPreferredName(p) {
	//     if (!p || !p.names) {
	//       return null;
	//     }
	//     return p.names.get(p.preferredNameKey) || this.utils.first(p.names);
	//   }
	//   getDefaultNameForm(n) {
	//     if (!n || !n.nameForms) {
	//       return null;
	//     }
	//     return n.nameForms.get('default') || this.utils.first(n.nameForms);
	//   }
	//   getNameText(nf, defaultUnknown) {
	//     let unknown = defaultUnknown && (!nf || !nf.given || !nf.surname) ? this.translations.find(t => t.value === 'UNKNOWN').display : '';
	//     if (!nf) {
	//       return unknown === '' ? '' : unknown + ' ' + unknown;
	//     }
	//     return this.utils.getFullName({given: nf.given || unknown, surname: nf.surname || unknown, prefix: nf.prefix, suffix: nf.suffix});
	//   }
	//   getFullName(p, defaultUnknown=true) {
	//     return this.getNameText(this.getDefaultNameForm(this.getPreferredName(p)), defaultUnknown);
	//   }
	//   getPreferredBirth(p, typ) {
	//     if (!p || !p.facts) {
	//       return null;
	//     }
	//     let f = p.facts.get(p.preferredBirthKey);
	//     if (!!f && (!typ || f.type === typ)) {
	//       return f;
	//     }
	//     if (!typ) {
	//       typ = 'BIRT';
	//     }
	//     return  Array.from(p.facts.values()).find(f => f.principal && f.type === typ) || null;
	//   }
	//   getPreferredDeath(p, typ) {
	//     if (!p || p.living !== 'FALSE' || !p.facts) {
	//       return null;
	//     }
	//     let f = p.facts.get(p.preferredDeathKey);
	//     if (!!f && (!typ || f.type === typ)) {
	//       return f;
	//     }
	//     if (!typ) {
	//       typ = 'DEAT';
	//     }
	//     return Array.from(p.facts.values()).find(f => f.principal && f.type === typ) || null;
	//   }
	//   getPreferredBirthDate(p) {
	//     let birth = this.getPreferredBirth(p);
	//     return !!birth ? birth.date : '';
	//   }
	//   getPreferredDeathDate(p) {
	//     let death = this.getPreferredBirth(p);
	//     return !!death ? death.date : '';
	//   }
	//   getGenderAsFact(p) {
	//     let f = Array.from(p.facts.values()).find(f => f.principal && f.type === 'SEX');
	//     if (!!f) {
	//       return f;
	//     }
	//     return {
	//       id: 0,
	//       externalIds: new Map(),
	//       type: 'SEX',
	//       value: p.gender,
	//       principal: true,
	//       evidencePersonas: new Map(),
	//       _key: 0,
	//       _age: '',
	//       _evidences: new Map()
	//     };
	//   }
	//   getMarriage(p1, p2) {
	//     if (!p1 || !p2) {
	//       return null;
	//     }
	//     return Array.from(p1.facts.values()).find(f => f.type === 'MARR' && f.principal && f.principalId1 === p2.id) || null;
	//   }
	//   hasWord(p, w) {
	//     return Array.from(p.names.values()).some(n => {
	//       let name = this.getDefaultNameForm(n);
	//       return name.given.toLowerCase().indexOf(w) >= 0 ||
	//         name.surname.toLowerCase().indexOf(w) >= 0 ||
	//         name.prefix.toLowerCase().indexOf(w) >= 0 ||
	//         name.suffix.toLowerCase().indexOf(w) >= 0;
	//     }) ||
	//     Array.from(p.facts.values()).some(f => {
	//       return f.principal &&
	//         (f.date.toLowerCase().indexOf(w) >= 0 ||
	//          f.value.toLowerCase().indexOf(w) >= 0 ||
	//          f.place.toLowerCase().indexOf(w) >= 0 ||
	//          f.placeDetails.toLowerCase().indexOf(w) >= 0 ||
	//          f.placeStandard.toLowerCase().indexOf(w) >= 0);
	//     }) ||
	//     (!!p._given && p._given.toLowerCase().indexOf(w) >= 0) ||   // handle "unknown" below
	//     (!!p._surname && p._surname.toLowerCase().indexOf(w) >= 0) ||
	//     (!!p.externalIds && p.externalIds.has('familysearch.org') && p.externalIds.get('familysearch.org').id.indexOf(w) >= 0);
	//   }
	//   _addDerived(p) {
	//     let unknown = this.translations.find(t => t.value === 'UNKNOWN').display;
	//     let nf = this.getDefaultNameForm(this.getPreferredName(p));
	//     let fullName = this.getNameText(nf, true) || unknown;
	//     let birth = this.getPreferredBirth(p);
	//     let birthYear = this.utils.getYear(!!birth ? birth.date : null);
	//     let death = this.getPreferredDeath(p);
	//     let deathYear = this.utils.getYear(!!death ? death.date : null);
	//     this.utils.addCreateEditDates(p);
	//     Object.assign(p, {
	//       '_fullName': fullName,
	//       '_iconURL': p.profilePhoto > 0 ? this.medias.getFileURL(p.profilePhoto, 0, '100x100') : '',
	//       '_given': !!nf ? nf.given : unknown,
	//       '_prefix': !!nf ? nf.prefix : '',
	//       '_suffix': !!nf ? nf.suffix : '',
	//       '_surname': !!nf && !!nf.surname ? nf.surname : unknown,
	//       '_birthType': !!birth ? birth.type || '' : '',
	//       '_birthDate': !!birth ? birth.date || '' : '',
	//       '_birthDateSort': !!birth ? birth.dateSort || '' : '',
	//       '_birthPlace': !!birth ? birth.place || '' : '',
	//       '_deathDate': !!death ? death.date || '' : '',
	//       '_deathType': !!death ? death.type || '' : '',
	//       '_deathDateSort': !!death ? death.dateSort || '' : '',
	//       '_deathPlace': !!death ? death.place || '' : '',
	//       '_lifespan': !!birthYear || !!deathYear ? birthYear + ' - ' + deathYear : ''
	//     });
	//     for (let [k,v] of p.names) {
	//       v._key = k;
	//     }
	//     for (let [k,v] of p.facts) {
	//       v._key = k;
	//     }
	//     return p;
	//   }
	//   _getParentsRelativeTypes() {
	//     return [
	//       'FATHER', 'MOTHER', 'SIBLING'
	//     ].map(v => {
	//         let o = {value: v};
	//         this.$translate(v).then(display => {
	//           o.display = display;
	//         });
	//         return o;
	//       });
	//   }
	//   _getTranslations() {
	//     return [
	//       'ANOTHER', 'CHILD', 'OF', 'OF_UNKNOWN_SPOUSE', 'SPOUSE', 'UNKNOWN'
	//     ].map(v => {
	//         let o = {value: v};
	//         this.$translate(v).then(display => {
	//           o.display = display;
	//         });
	//         return o;
	//       });
	//   }
	// }
	// export default PersonsService;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { BehaviorSubject, AsyncSubject } from "../../node_modules/rxjs";
	var PersonsService = /** @class */ (function () {
	    function PersonsService(translate, rx, medias, store, changes, utils) {
	        var _this = this;
	        this.translate = translate;
	        this.rx = rx;
	        this.medias = medias;
	        this.utils = utils;
	        this.store = store.create("trees", "persons", changes.treeStream(), function (p) { return _this._addDerived(p); });
	        this._translations = this._getTranslations();
	        this.parentsRelativeTypes = this._getParentsRelativeTypes();
	        this.nameStream = this.store.addStream(store.streamScanFn(function (o) {
	            var fullText = utils.normalize(_this.getNameText(_this.getDefaultNameForm(_this.getPreferredName(o)), true));
	            var pieces = fullText.length > 0 ? fullText.split(' ') : [];
	            pieces.push(utils.encodeId(o.id));
	            return pieces;
	        }));
	        this.evidenceStream = this.store.addStream(store.streamScanFn(function (o) {
	            return [].concat.apply([], __spread(Array.from(o.facts.values()).map(function (f) { return Array.from(f.evidencePersonas.keys()); }), Array.from(o.names.values()).map(function (f) { return Array.from(f.evidencePersonas.keys()); })));
	        }));
	        this.tagStream = this.store.addStream(store.streamScanFn(function (o) {
	            return !!o.tags ? Array.from(o.tags.keys()) : [];
	        }));
	    }
	    Object.defineProperty(PersonsService.prototype, "translations", {
	        get: function () {
	            return this._translations;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PersonsService.prototype.create = function (o, params) {
	        return this.store.create(o, params);
	    };
	    PersonsService.prototype.update = function (o) {
	        return this.store.update(o);
	    };
	    PersonsService.prototype.del = function (id) {
	        return this.store.del(id);
	    };
	    PersonsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    PersonsService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    PersonsService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    PersonsService.prototype.streamIds = function (ids) {
	        return this.store.streamIds(ids);
	    };
	    // returns a map
	    PersonsService.prototype.streamForEvidence = function (eid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.evidenceStream.map(function (m) { return (m.get(eid) || new Map()); }); });
	    };
	    // non-streaming functions; caller must make sure that stream is "ready" before calling
	    PersonsService.prototype.getMap = function () {
	        return this.store.getStream().getValue();
	    };
	    PersonsService.prototype.getEvidenceMap = function () {
	        return this.evidenceStream.getValue();
	    };
	    //tagAutocomplete(prefix) {
	    //  let lc = prefix.toLowerCase();
	    //  return this.tagStream
	    //    .map(m => {
	    //      let result = [];
	    //      let found = false;
	    //      m.keySeq().forEach(k => {
	    //        let klc = k.toLowerCase();
	    //        if (klc.startsWith(lc)) {
	    //          if (klc === lc) {
	    //            found = true;
	    //          }
	    //          result.push(k);
	    //        }
	    //      });
	    //      if (!found) {
	    //        result.push(prefix);
	    //      }
	    //      return result;
	    //    })
	    //    .take(1)
	    //    .toPromise();
	    //}
	    PersonsService.prototype.streamMatches = function (matchData) {
	        var _this = this;
	        return this.stream().map(function (pm) {
	            var scores = Array.from(pm.entries())
	                .map(function (_a) {
	                var _b = __read(_a, 2), pid = _b[0], p = _b[1];
	                return {
	                    id: pid,
	                    score: _this.personMatchScore(p, matchData)
	                };
	            })
	                .filter(function (ps) { return ps.score >= 2; });
	            // sort the rest
	            scores.sort(function (a, b) {
	                return b.score - a.score;
	            });
	            // return pids
	            return scores.map(function (ps) { return ps.id; });
	        });
	    };
	    PersonsService.prototype.personMatchScore = function (p, matchData) {
	        var _this = this;
	        var givenFound = false;
	        var surnameFound = false;
	        var givenMatched = false;
	        var surnameMatched = false;
	        var given = !!matchData.given ? matchData.given.toLowerCase() : '';
	        var surname = !!matchData.surname ? matchData.surname.toLowerCase() : '';
	        p.names.forEach(function (n) {
	            var nf = _this.getDefaultNameForm(n);
	            if (!!given && !!nf.given) {
	                givenFound = true;
	            }
	            nf.given.toLowerCase().split(' ').forEach(function (np1) {
	                given.split(' ').forEach(function (np2) {
	                    if (!!np1 && !!np2 && np1.length > 1 && np1 === np2) {
	                        givenMatched = true;
	                    }
	                });
	            });
	            if (!!surname && !!nf.surname) {
	                surnameFound = true;
	            }
	            nf.surname.toLowerCase().split(' ').forEach(function (np1) {
	                surname.split(' ').forEach(function (np2) {
	                    if (!!np1 && !!np2 && np1.length > 1 && np1 === np2) {
	                        surnameMatched = true;
	                    }
	                });
	            });
	        });
	        var birthYear = !!matchData.birthDateSort ? +matchData.birthDateSort.substr(0, 4) : 0;
	        var deathYear = !!matchData.deathDateSort ? +matchData.deathDateSort.substr(0, 4) : 0;
	        var prefBirth = this.getPreferredBirth(p);
	        var prefDeath = this.getPreferredDeath(p);
	        var birthYearFound = birthYear > 0 && !!prefBirth && !!prefBirth.dateSort;
	        var deathYearFound = deathYear > 0 && !!prefDeath && !!prefDeath.dateSort;
	        var birthYearMatched = false;
	        var deathYearMatched = false;
	        if (birthYearFound && Math.abs(+prefBirth.dateSort.substr(0, 4) - birthYear) <= 2) {
	            birthYearMatched = true;
	        }
	        if (deathYearFound && Math.abs(+prefDeath.dateSort.substr(0, 4) - deathYear) <= 2) {
	            deathYearMatched = true;
	        }
	        var score = 0;
	        if (givenFound) {
	            score += givenMatched ? 1 : -2;
	        }
	        if (surnameFound) {
	            score += surnameMatched ? 1 : -2;
	        }
	        if (birthYearFound) {
	            score += birthYearMatched ? 1 : -2;
	        }
	        if (deathYearFound) {
	            score += deathYearMatched ? 1 : -2;
	        }
	        if (!this.isCompatibleGender(p.gender, matchData.gender)) {
	            score -= 4;
	        }
	        return score;
	    };
	    PersonsService.prototype.isCompatibleGender = function (gnd1, gnd2) {
	        return !((gnd1 === 'MALE' || gnd1 === 'FEMALE') && (gnd2 === 'MALE' || gnd2 === 'FEMALE') && gnd1 !== gnd2);
	    };
	    PersonsService.prototype.nameAutocomplete = function (prefix, excludePid) {
	        var lc = this.utils.normalize(prefix);
	        return this.nameStream
	            .map(function (m) {
	            var resultMap = !lc ? new Map() : lc
	                .split(' ')
	                .map(function (piece) {
	                var result = new Map();
	                try {
	                    for (var m_1 = __values(m), m_1_1 = m_1.next(); !m_1_1.done; m_1_1 = m_1.next()) {
	                        var _a = __read(m_1_1.value, 2), name_1 = _a[0], pm = _a[1];
	                        if (name_1.toLowerCase().startsWith(piece)) {
	                            try {
	                                for (var pm_1 = __values(pm), pm_1_1 = pm_1.next(); !pm_1_1.done; pm_1_1 = pm_1.next()) {
	                                    var _b = __read(pm_1_1.value, 2), pid = _b[0], person = _b[1];
	                                    if (!excludePid || excludePid !== pid) {
	                                        result.set(pid, person);
	                                    }
	                                }
	                            }
	                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                            finally {
	                                try {
	                                    if (pm_1_1 && !pm_1_1.done && (_c = pm_1.return)) _c.call(pm_1);
	                                }
	                                finally { if (e_1) throw e_1.error; }
	                            }
	                        }
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (m_1_1 && !m_1_1.done && (_d = m_1.return)) _d.call(m_1);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	                return result;
	                var e_2, _d, e_1, _c;
	            })
	                .reduce(function (prev, curr) {
	                if (prev === null) {
	                    return curr;
	                }
	                try {
	                    // remove keys in prev that are not in curr
	                    for (var prev_1 = __values(prev), prev_1_1 = prev_1.next(); !prev_1_1.done; prev_1_1 = prev_1.next()) {
	                        var _a = __read(prev_1_1.value, 1), k = _a[0];
	                        if (!curr.has(k)) {
	                            prev.delete(k);
	                        }
	                    }
	                }
	                catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                finally {
	                    try {
	                        if (prev_1_1 && !prev_1_1.done && (_b = prev_1.return)) _b.call(prev_1);
	                    }
	                    finally { if (e_3) throw e_3.error; }
	                }
	                return prev;
	                var e_3, _b;
	            }, null);
	            return Array.from(resultMap.values()).sort(function (a, b) { return (b.editedDate || b.createdDate) - (a.editedDate || a.createdDate); });
	        })
	            .take(1)
	            .toPromise();
	    };
	    PersonsService.prototype.tagAutocomplete = function (prefix, extraTags) {
	        var lc = this.utils.normalize(prefix);
	        return this.tagStream
	            .map(function (m) {
	            var resultMap = !lc ? new Map() : lc
	                .split(' ')
	                .map(function (piece) {
	                var result = new Map();
	                try {
	                    for (var m_2 = __values(m), m_2_1 = m_2.next(); !m_2_1.done; m_2_1 = m_2.next()) {
	                        var _a = __read(m_2_1.value, 2), tag = _a[0], pm = _a[1];
	                        if (tag.toLowerCase().startsWith(piece)) {
	                            result.set(tag, pm.size);
	                        }
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (m_2_1 && !m_2_1.done && (_b = m_2.return)) _b.call(m_2);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	                try {
	                    for (var _c = __values((extraTags || [])), _d = _c.next(); !_d.done; _d = _c.next()) {
	                        var tag = _d.value;
	                        if (tag.toLowerCase().startsWith(piece) && !result.has(tag)) {
	                            result.set(tag, 1);
	                        }
	                    }
	                }
	                catch (e_5_1) { e_5 = { error: e_5_1 }; }
	                finally {
	                    try {
	                        if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                    }
	                    finally { if (e_5) throw e_5.error; }
	                }
	                return result;
	                var e_4, _b, e_5, _e;
	            })
	                .reduce(function (prev, curr) {
	                if (prev === null) {
	                    return curr;
	                }
	                try {
	                    // remove keys in prev that are not in curr
	                    for (var prev_2 = __values(prev), prev_2_1 = prev_2.next(); !prev_2_1.done; prev_2_1 = prev_2.next()) {
	                        var _a = __read(prev_2_1.value, 1), k = _a[0];
	                        if (!curr.has(k)) {
	                            prev.delete(k);
	                        }
	                    }
	                }
	                catch (e_6_1) { e_6 = { error: e_6_1 }; }
	                finally {
	                    try {
	                        if (prev_2_1 && !prev_2_1.done && (_b = prev_2.return)) _b.call(prev_2);
	                    }
	                    finally { if (e_6) throw e_6.error; }
	                }
	                return prev;
	                var e_6, _b;
	            }, null);
	            return Array.from(resultMap.entries())
	                .sort(function (a, b) { return b[1] - a[1]; })
	                .map(function (entry) { return entry[0]; });
	        })
	            .take(1)
	            .toPromise();
	    };
	    //
	    // helper functions
	    //
	    PersonsService.prototype.augmentPerson = function (p, leads, evidences, users) {
	        var subject = new this.rx.AsyncSubject();
	        if (p === null) {
	            subject.next(p);
	            subject.complete();
	            return subject;
	        }
	        var waitCount = (!!users ? 1 : 0) + 2;
	        p = Object.assign({}, p, {
	            '_hints': 0,
	            '_stars': 0,
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        // set leads
	        leads.streamForPerson(p.id).take(1).subscribe(function (lm) {
	            p._hints = Array.from(lm.values()).filter(function (l) { return !!l && l.createdUser === 0 && l.state === 0; }).length; //TODO lead interface type
	            if (--waitCount === 0) {
	                subject.next(p);
	                subject.complete();
	            }
	        });
	        // set stars
	        evidences.streamForPerson(p).take(1).subscribe(function (em) {
	            p._stars = Array.from(em.values()).filter(function (e) { return !!e && e._hasSource; }).length; //TODO evidence interface type
	            if (--waitCount === 0) {
	                subject.next(p);
	                subject.complete();
	            }
	        });
	        // set created user and edited user
	        if (!!users) {
	            this.utils.addCreateEditUsers(p, users).subscribe(function () {
	                if (--waitCount === 0) {
	                    subject.next(p);
	                    subject.complete();
	                }
	            });
	        }
	        return subject;
	    };
	    PersonsService.prototype.augmentFact = function (f, person, personMap, evidenceMap) {
	        if (!f) {
	            return f;
	        }
	        var birth = this.getPreferredBirth(person);
	        var age = '';
	        if (!!birth && !!f.dateSort && !!birth.dateSort) {
	            age = this.utils.yearDiff(f.dateSort, birth.dateSort);
	            if (isNaN(age) || age <= 0) {
	                age = '';
	            }
	        }
	        f = Object.assign({}, f, {
	            '_age': age,
	            '_dateSort': this.getDateSort(f),
	            '_principal1': f.principalId1 > 0 && personMap.has(f.principalId1) ? personMap.get(f.principalId1)._fullName : '',
	            '_principal2': f.principalId2 > 0 && personMap.has(f.principalId2) ? personMap.get(f.principalId2)._fullName : '',
	            '_evidences': new Map()
	        });
	        try {
	            // set evidences
	            for (var _a = __values(f.evidencePersonas), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var _c = __read(_b.value, 1), eid = _c[0];
	                if (evidenceMap.has(eid)) {
	                    var e = evidenceMap.get(eid);
	                    f._evidences.set(eid, e);
	                    if (!f._sort && !!e._sourceAbbr) {
	                        f._sort = e._sourceAbbr.toLowerCase();
	                    }
	                }
	            }
	        }
	        catch (e_7_1) { e_7 = { error: e_7_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	            }
	            finally { if (e_7) throw e_7.error; }
	        }
	        return f;
	        var e_7, _d;
	    };
	    PersonsService.prototype.getDateSort = function (f) {
	        if (!f.dateSort) {
	            return f.dateSort;
	        }
	        var suffix;
	        switch (f.type) {
	            case 'BIRT':
	                suffix = '0';
	                break;
	            case 'DEAT':
	                suffix = '8';
	                break;
	            case 'BURI':
	                suffix = '9';
	                break;
	            default:
	                suffix = '5';
	        }
	        var pieces = f.dateSort.split('|');
	        if (pieces.length === 2 && pieces[0].substring(4, 8) <= '0324' &&
	            pieces[0].substring(4, 8) === pieces[1].substring(4, 8) &&
	            +pieces[0].substring(0, 4) + 1 === +pieces[1].substring(0, 4)) {
	            // double-dating: pick the second date
	            pieces = [pieces[1], pieces[1], pieces[1]];
	        }
	        else if (pieces.length < 3) {
	            if (suffix === '9' && pieces[0].endsWith("00")) {
	                pieces;
	            }
	            pieces = [pieces[0], pieces[0], pieces[0]];
	        }
	        if ((suffix === '8' || suffix == '9') && pieces[0].endsWith('00')) {
	            if (pieces[0].endsWith('0000')) {
	                pieces[0] = pieces[0].substr(0, 4) + '1231';
	            }
	            else {
	                pieces[0] = pieces[0].substr(0, 6) + '31';
	            }
	        }
	        return pieces.join('') + suffix;
	    };
	    PersonsService.prototype.augmentName = function (n, person, evidenceMap) {
	        if (!n) {
	            return n;
	        }
	        var birth = this.getPreferredBirth(person);
	        var age = '';
	        if (!!birth && !!n.dateSort && !!birth.dateSort) {
	            age = this.utils.yearDiff(n.dateSort, birth.dateSort);
	            if (isNaN(age) || age <= 0) {
	                age = '';
	            }
	        }
	        n = Object.assign({}, n, {
	            '_age': age,
	            '_evidences': new Map()
	        });
	        try {
	            // set evidences
	            for (var _a = __values(n.evidencePersonas), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var _c = __read(_b.value, 1), eid = _c[0];
	                if (evidenceMap.has(eid)) {
	                    n._evidences.set(eid, evidenceMap.get(eid));
	                }
	            }
	        }
	        catch (e_8_1) { e_8 = { error: e_8_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	            }
	            finally { if (e_8) throw e_8.error; }
	        }
	        return n;
	        var e_8, _d;
	    };
	    PersonsService.prototype.getPreferredName = function (p) {
	        if (!p || !p.names) {
	            return null;
	        }
	        return p.names.get(p.preferredNameKey) || this.utils.first(p.names);
	    };
	    PersonsService.prototype.getDefaultNameForm = function (n) {
	        if (!n || !n.nameForms) {
	            return null;
	        }
	        return n.nameForms.get('default') || this.utils.first(n.nameForms);
	    };
	    PersonsService.prototype.getNameText = function (nf, defaultUnknown) {
	        var unknown = defaultUnknown && (!nf || !nf.given || !nf.surname) ? this.translations.find(function (t) { return t.value === 'UNKNOWN'; }).display : '';
	        if (!nf) {
	            return unknown === '' ? '' : unknown;
	        }
	        var fullName = this.utils.getFullName({
	            given: nf.given || unknown,
	            surname: nf.surname || (nf.given === 'Private' ? '' : unknown),
	            prefix: nf.prefix,
	            suffix: nf.suffix
	        });
	        return fullName;
	    };
	    PersonsService.prototype.getFullName = function (p, defaultUnknown) {
	        if (defaultUnknown === void 0) { defaultUnknown = true; }
	        return this.getNameText(this.getDefaultNameForm(this.getPreferredName(p)), defaultUnknown);
	    };
	    PersonsService.prototype.getPreferredBirth = function (p, typ) {
	        if (!p || !p.facts) {
	            return null;
	        }
	        var f = p.facts.get(p.preferredBirthKey);
	        if (!!f && (!typ || f.type === typ)) {
	            return f;
	        }
	        var fs = Array.from(p.facts.values());
	        if (!!typ) {
	            f = fs.find(function (f) { return f.principal && f.type === typ; }) || null; //TODO add fact type
	        }
	        else {
	            var birthLike = fs.filter(function (f) { return f.principal && ['BIRT', 'CHR', 'BAPM'].includes(f.type); });
	            f = birthLike.find(function (f) { return f.type === 'BIRT'; }) || null; //TODO add fact type
	            if (!f) {
	                f = birthLike.find(function (f) { return f.type === 'CHR'; }) || null; //TODO add fact type
	            }
	            if (!f) {
	                f = birthLike.find(function (f) { return f.type === 'BAPM'; }) || null; //TODO add fact type
	            }
	        }
	        return f;
	    };
	    PersonsService.prototype.getPreferredDeath = function (p, typ) {
	        if (!p || p.living !== 'FALSE' || !p.facts) {
	            return null;
	        }
	        var f = p.facts.get(p.preferredDeathKey);
	        if (!!f && (!typ || f.type === typ)) {
	            return f;
	        }
	        var fs = Array.from(p.facts.values());
	        if (!!typ) {
	            f = fs.find(function (f) { return f.principal && f.type === typ; }) || null; //TODO add fact type
	        }
	        else {
	            var deathLike = fs.filter(function (f) { return f.principal && ['DEAT', 'BURI'].includes(f.type); });
	            f = deathLike.find(function (f) { return f.type === 'DEAT'; }) || null; //TODO add fact type
	            if (!f) {
	                f = deathLike.find(function (f) { return f.type === 'BURI'; }) || null; //TODO add fact type
	            }
	        }
	        return f;
	    };
	    PersonsService.prototype.getPreferredBirthDate = function (p) {
	        var birth = this.getPreferredBirth(p);
	        return !!birth ? birth.date : '';
	    };
	    PersonsService.prototype.getPreferredDeathDate = function (p) {
	        var death = this.getPreferredBirth(p);
	        return !!death ? death.date : '';
	    };
	    PersonsService.prototype.getGenderAsFact = function (p) {
	        var f = Array.from(p.facts.values()).find(function (f) { return f.principal && f.type === 'SEX'; }); //TODO fact interface type
	        if (!!f) {
	            return f;
	        }
	        return {
	            id: 0,
	            externalIds: new Map(),
	            type: 'SEX',
	            value: p.gender,
	            principal: true,
	            evidencePersonas: new Map(),
	            _key: 0,
	            _age: '',
	            _evidences: new Map()
	        };
	    };
	    PersonsService.prototype.getMarriage = function (p1, p2) {
	        if (!p1 || !p2) {
	            return null;
	        }
	        return Array.from(p1.facts.values()).find(function (f) { return f.type === 'MARR' && f.principal && f.principalId1 === p2.id; }) || null; //TODO fact interface type
	    };
	    PersonsService.prototype.hasWord = function (p, w) {
	        var _this = this;
	        return Array.from(p.names.values()).some(function (n) {
	            var name = _this.getDefaultNameForm(n);
	            return name.given.toLowerCase().indexOf(w) >= 0 ||
	                name.surname.toLowerCase().indexOf(w) >= 0 ||
	                name.prefix.toLowerCase().indexOf(w) >= 0 ||
	                name.suffix.toLowerCase().indexOf(w) >= 0;
	        }) ||
	            Array.from(p.facts.values()).some(function (f) {
	                return f.principal &&
	                    (f.date.toLowerCase().indexOf(w) >= 0 ||
	                        f.value.toLowerCase().indexOf(w) >= 0 ||
	                        f.place.toLowerCase().indexOf(w) >= 0 ||
	                        f.placeDetails.toLowerCase().indexOf(w) >= 0 ||
	                        f.placeStandard.toLowerCase().indexOf(w) >= 0);
	            }) ||
	            (!!p._given && p._given.toLowerCase().indexOf(w) >= 0) || // handle "unknown" below
	            (!!p._surname && p._surname.toLowerCase().indexOf(w) >= 0) ||
	            (!!p.tags && Array.from(p.tags.keys()).some(function (key) { return key.toLowerCase().indexOf(w) >= 0; })) ||
	            (!!p.externalIds && p.externalIds.has('familysearch.org') && p.externalIds.get('familysearch.org').id.indexOf(w) >= 0);
	    };
	    PersonsService.prototype._addDerived = function (p) {
	        var unknown = this.translations.find(function (t) { return t.value === 'UNKNOWN'; }).display;
	        var nf = this.getDefaultNameForm(this.getPreferredName(p));
	        var fullName = this.getNameText(nf, true) || unknown;
	        var birth = this.getPreferredBirth(p);
	        var birthYear = this.utils.getYear(!!birth ? birth.date : null, true);
	        var death = this.getPreferredDeath(p);
	        var deathYear = this.utils.getYear(!!death ? death.date : null, true);
	        this.utils.addCreateEditDates(p);
	        Object.assign(p, {
	            '_fullName': fullName,
	            '_iconURL': p.profilePhoto > 0 ? this.medias.getFileURL(p.profilePhoto, 0, '100x100') : '',
	            '_given': !!nf ? nf.given : unknown,
	            '_prefix': !!nf ? nf.prefix : '',
	            '_suffix': !!nf ? nf.suffix : '',
	            '_surname': !!nf && !!nf.surname ? nf.surname : unknown,
	            '_birthType': !!birth ? birth.type || '' : '',
	            '_birthDate': !!birth ? birth.date || '' : '',
	            '_birthDateSort': !!birth ? birth.dateSort || '' : '',
	            '_birthPlace': !!birth ? birth.place || '' : '',
	            '_deathDate': !!death ? death.date || '' : '',
	            '_deathType': !!death ? death.type || '' : '',
	            '_deathDateSort': !!death ? death.dateSort || '' : '',
	            '_deathPlace': !!death ? death.place || '' : '',
	            '_lifespan': !!birthYear || !!deathYear ? birthYear + ' - ' + deathYear : ''
	        });
	        try {
	            for (var _a = __values(p.names), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var _c = __read(_b.value, 2), k = _c[0], v = _c[1];
	                v._key = k;
	            }
	        }
	        catch (e_9_1) { e_9 = { error: e_9_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	            }
	            finally { if (e_9) throw e_9.error; }
	        }
	        try {
	            for (var _e = __values(p.facts), _f = _e.next(); !_f.done; _f = _e.next()) {
	                var _g = __read(_f.value, 2), k = _g[0], v = _g[1];
	                v._key = k;
	            }
	        }
	        catch (e_10_1) { e_10 = { error: e_10_1 }; }
	        finally {
	            try {
	                if (_f && !_f.done && (_h = _e.return)) _h.call(_e);
	            }
	            finally { if (e_10) throw e_10.error; }
	        }
	        return p;
	        var e_9, _d, e_10, _h;
	    };
	    PersonsService.prototype._getParentsRelativeTypes = function () {
	        var _this = this;
	        return [
	            'FATHER', 'MOTHER', 'SIBLING'
	        ].map(function (v) {
	            var o = { value: v };
	            _this.translate(v).then(function (display) {
	                o.display = display;
	            });
	            return o;
	        });
	    };
	    PersonsService.prototype._getTranslations = function () {
	        var _this = this;
	        return [
	            'ANOTHER', 'CHILD', 'OF', 'OF_UNKNOWN_SPOUSE', 'SPOUSE', 'UNKNOWN'
	        ].map(function (v) {
	            var o = { value: v };
	            _this.translate(v).then(function (display) {
	                o.display = display;
	            });
	            return o;
	        });
	    };
	    return PersonsService;
	}());
	exports.PersonsService = PersonsService;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var personUtils_service_1 = __webpack_require__(251);
	var PersonUtilsService = /** @class */ (function (_super) {
	    __extends(PersonUtilsService, _super);
	    PersonUtilsService.$inject = ["$log", "rx", "messageBus", "persons", "evidences", "notes", "stories", "medias", "families", "dnaKits", "treeUsers", "segment", "evidenceUtils", "familyUtils", "utils"];
	    function PersonUtilsService($log, rx, messageBus, persons, evidences, notes, stories, medias, families, dnaKits, treeUsers, segment, evidenceUtils, familyUtils, utils) {
	        'ngInject';
	        return _super.call(this, $log, rx, messageBus, persons, evidences, notes, stories, medias, families, dnaKits, treeUsers, segment, evidenceUtils, familyUtils, utils, angular) || this;
	    }
	    return PersonUtilsService;
	}(personUtils_service_1.PersonUtilsService));
	exports.default = PersonUtilsService;
	// class PersonUtilsService {
	//   constructor ($log, rx, messageBus, persons, evidences, notes, stories, medias, families, dnaKits, treeUsers, segment, evidenceUtils, familyUtils, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.messageBus = messageBus;
	//     this.persons = persons;
	//     this.evidences = evidences;
	//     this.notes = notes;
	//     this.stories = stories;
	//     this.medias = medias;
	//     this.families = families;
	//     this.dnaKits = dnaKits;
	//     this.treeUsers = treeUsers;
	//     this.segment = segment;
	//     this.evidenceUtils = evidenceUtils;
	//     this.familyUtils = familyUtils;
	//     this.utils = utils;
	//   }
	//   // form = {person, living, gender, name, birth={type, date, place, placeText}, death={type, date, place, placeText}, marriage={type, date, place, placeText} }
	//   // family is required for SIBLING or when adding a CHILD, SPOUSE, FATHER or MOTHER to an existing family
	//   // relatedToPersonId is required for FATHER, MOTHER, SPOUSE, and CHILD if no family
	//   add(form, relationshipType, relatedToPersonId, family) {
	//     this.segment.track('persons.create');
	//     let params = {form, relationshipType, relatedToPersonId, family};
	//     if (!!form && !!form.person && form.person.id > 0 && !!family &&
	//         (form.person.id === family.husbandId || form.person.id === family.wifeId || family.childRels.has(form.person.id))) {
	//       this.messageBus.post({msg: 'This person is already a member of this family', op: 'UPDATE', ctx: 'personUtils.add'});
	//       return this.rx.Observable.throw('exists');
	//     }
	//     switch (relationshipType) {
	//       case 'FATHER':
	//       case 'MOTHER':
	//         return this.setFamily(params)
	//           //.flatMap(params => this.setChildren(params))
	//           //.flatMap(params => this.setChildBirthEvidenceMap(params))
	//           .flatMap(params => this.setSpouseId(params))
	//           .flatMap(params => this.setPersonData(params))
	//           .flatMap(params => this.addEvidences(params))
	//           .flatMap(params => this.postPerson(params))
	//           .flatMap(params => this.addMarriageToSpouse(params))
	//           .flatMap(params => this.postFamily(params));
	//       case 'SPOUSE':
	//         return this.setFamily(params)
	//           //.flatMap(params => this.setChildren(params))
	//           //.flatMap(params => this.setChildBirthEvidenceMap(params))
	//           .flatMap(params => this.setSpouseId(params))
	//           .flatMap(params => this.setPersonData(params))
	//           .flatMap(params => this.addEvidences(params))
	//           .flatMap(params => this.postPerson(params))
	//           .flatMap(params => this.addMarriageToSpouse(params))
	//           .flatMap(params => this.postFamily(params));
	//       case 'CHILD':
	//       case 'SIBLING':
	//         return this.setFamily(params)
	//           //.flatMap(params => this.setBirthEvidence(params))
	//           .flatMap(params => this.setPersonData(params))
	//           .flatMap(params => this.addEvidences(params))
	//           .flatMap(params => this.postPerson(params))
	//           //.flatMap(params => this.addBirthToParents(params))
	//           .flatMap(params => this.postFamily(params));
	//       default:
	//         return this.setPersonData(params)
	//           .flatMap(params => this.addEvidences(params))
	//           .flatMap(params => this.postPerson(params))
	//           .flatMap(params => this.setRoot(params));
	//     }
	//   }
	//   update(p) {
	//     // add evidences
	//     this.segment.track('persons.update');
	//     return this.addEvidences({personData: p})
	//       // update person
	//       .flatMap(() => {
	//         return this.persons.update(p);
	//       });
	//       //.flatMap({birthEvidence, birthPersonaMap, deathEvidence, deathPersonaMap}) => {
	//         // update birth and death with evidences
	//         //if (!!birthEvidence) {
	//         //  let birth = Array.from(p.facts.values()).find(f => f.principal && (f.type === 'BIRT' || f.type === 'CHR') && f.evidencePersonas.size === 0);
	//         //  let childPersonaEntry = Array.from(birthPersonaMap.entries()).find(([,v]) => v === p.id);
	//         //  birth.evidencePersonas.set(birthEvidence.id, childPersonaEntry[0]);
	//         //}
	//         //if (!!deathEvidence) {
	//         //  let death = Array.from(p.facts.values()).find(f => f.principal && (f.type === 'DEAT' || f.type === 'BURI') && f.evidencePersonas.size === 0);
	//         //  let personaEntry = Array.from(deathPersonaMap.entries()).find(([,v]) => v === p.id);
	//         //  death.evidencePersonas.set(deathEvidence.id, personaEntry[0]);
	//         //}
	//         //return this.persons.update(p).map(person => {
	//         //  return {birthEvidence, birthPersonaMap, person};
	//         //});
	//       //})
	//       //// add birth to parents if necessary
	//       //.flatMap(({birthEvidence, birthPersonaMap, person}) => {
	//       //  // do we need to add the birth to parents?
	//       //  let parentPersonaMap = new Map(Array.from(birthPersonaMap.entries()).filter(([,v]) => v !== person.id));
	//       //  if (!!birthEvidence && parentPersonaMap.size > 0) {
	//       //    return this.rx.Observable.forkJoin(...Array.from(parentPersonaMap.keys()).map(key => this.addBirthToParent(birthEvidence, key, parentPersonaMap.get(key), person.id)));
	//       //  }
	//       //  else {
	//       //    return this.rx.Observable.of([]);
	//       //  }
	//       //});
	//   }
	//   addEvidences(params) {
	//     if (!params.personData) {
	//       return this.rx.Observable.of(params);
	//     }
	//     // add birth, marriage, and death evidences if needed
	//     //return this.rx.Observable.forkJoin(this.addBirthEvidence(params.personData), this.addMarriageEvidence(params.personData, params.spouseId), this.addDeathEvidence(params.personData)).map(results => {
	//     //  return Object.assign(params, {
	//     //    birthEvidence: results[0].evidence,
	//     //    birthPersonaMap: results[0].personaMap,
	//     //    marriageEvidence: results[1].evidence,
	//     //    marriagePersonaMap: results[1].personaMap,
	//     //    deathEvidence: results[2].evidence,
	//     //    deathPersonaMap: results[2].personaMap
	//     //  });
	//     //});
	//     return this.addMarriageEvidence(params.personData, params.spouseId).map(results => {
	//       return Object.assign(params, {
	//         marriageEvidence: results.evidence,
	//         marriagePersonaMap: results.personaMap
	//       });
	//     });
	//   }
	//   //addBirthEvidence(p) {
	//   //  let birth = Array.from(p.facts.values()).find(f => f.principal && (f.type === 'BIRT' || f.type === 'CHR') && f.evidencePersonas.size === 0);
	//   //  if (!!birth) {
	//   //    return this.families.streamParents(p.id).take(1).flatMap(fm => {
	//   //      let family = this.families.getPreferredFamily(fm, p.preferredParentsFamilyId);
	//   //      let e = this.utils.createEvidenceFromFact(birth);
	//   //      let personaMap = new Map();
	//   //      personaMap.set(1, p.id);
	//   //      e.personas.set(2, {
	//   //        principal: false,
	//   //        relatedToKey: 1,
	//   //        relationshipType: 'FATHER',
	//   //        names: new Map(),
	//   //        facts: new Map()
	//   //      });
	//   //      if (!!family && family.husbandId > 0) {
	//   //        personaMap.set(2, family.husbandId);
	//   //      }
	//   //      e.personas.set(3, {
	//   //        principal: false,
	//   //        relatedToKey: 1,
	//   //        relationshipType: 'MOTHER',
	//   //        names: new Map(),
	//   //        facts: new Map()
	//   //      });
	//   //      if (!!family && family.wifeId > 0) {
	//   //        personaMap.set(3, family.wifeId);
	//   //      }
	//   //      this.$log.debug('personUtils.addBirthEvidence', e);
	//   //      return this.evidences.create(e).map(evidence => {
	//   //        return {evidence, personaMap};
	//   //      });
	//   //    });
	//   //  }
	//   //  else {
	//   //    return this.rx.Observable.of({evidence: null, personaMap: new Map()});
	//   //  }
	//   //}
	//   addMarriageEvidence(p, spouseId) {
	//     let marriage = Array.from(p.facts.values()).find(f => f.principal && f.type === 'MARR' && f.principalId1 === spouseId && f.evidencePersonas.size === 0);
	//     if (!!marriage && spouseId > 0) {
	//       let e = this.utils.createEvidenceFromFact(marriage);
	//       let personaMap = new Map();
	//       e.personas.set(2, {
	//         principal: true,
	//         relatedToKey: 1,
	//         relationshipType: 'SPOUSE',
	//         names: new Map(),
	//         facts: new Map()
	//       });
	//       if (p.gender !== 'FEMALE') {
	//         personaMap.set(1, p.id);
	//         personaMap.set(2, spouseId);
	//       }
	//       else {
	//         personaMap.set(2, p.id);
	//         personaMap.set(1, spouseId);
	//       }
	//       this.$log.debug('personUtils.addMarriageEvidence', e);
	//       return this.evidences.create(e).map(evidence => {
	//         return {evidence, personaMap};
	//       });
	//     }
	//     else {
	//       return this.rx.Observable.of({evidence: null, personaMap: new Map()});
	//     }
	//   }
	//   //addDeathEvidence(p) {
	//   //  let death = Array.from(p.facts.values()).find(f => f.principal && (f.type === 'DEAT' || f.type === 'BURI') && f.evidencePersonas.size === 0);
	//   //  if (!!death) {
	//   //    let e = this.utils.createEvidenceFromFact(death);
	//   //    let personaMap = new Map();
	//   //    personaMap.set(1, p.id);
	//   //    this.$log.debug('personUtils.addDeathEvidence', e);
	//   //    return this.evidences.create(e).map(evidence => {
	//   //      return {evidence, personaMap};
	//   //    });
	//   //  }
	//   //  else {
	//   //    return this.rx.Observable.of({evidence: null, personaMap: new Map()});
	//   //  }
	//   //}
	//   //addBirthToParents(params) {
	//   //  if (!!params.birthEvidence) {
	//   //    let parents = [];
	//   //    if (params.husbandId > 0) {
	//   //      parents.push({relationship: 'FATHER', id: params.husbandId});
	//   //    }
	//   //    if (params.wifeId > 0) {
	//   //      parents.push({relationship: 'MOTHER', id: params.wifeId});
	//   //    }
	//   //    if (parents.length === 0) {
	//   //      return this.rx.Observable.of(params);
	//   //    }
	//   //    return this.rx.Observable.forkJoin(...parents.map(parent => {
	//   //      let personaKey = Array.from(params.birthEvidence.personas.keys()).find(k => params.birthEvidence.personas.get(k).relationshipType === parent.relationship);
	//   //      return this.addBirthToParent(params.birthEvidence, personaKey, parent.id, params.person.id);
	//   //    })).map(() => params);
	//   //  }
	//   //  else {
	//   //    return this.rx.Observable.of(params);
	//   //  }
	//   //}
	//   //
	//   //addBirthToParent(birthEvidence, personaKey, parentId, childId) {
	//   //  return this.persons.streamId(parentId).take(1)
	//   //    .flatMap(person => {
	//   //      let p = this.utils.clone(person);
	//   //      if (personaKey > 0) {
	//   //        let f = this.createFact(birthEvidence.fact, true, false);
	//   //        f.principalId1 = childId;
	//   //        f.evidencePersonas.set(birthEvidence.id, personaKey);
	//   //        let factKey = this.utils.randomKey();
	//   //        p.facts.set(factKey, f);
	//   //        this.$log.debug('personUtils.addBirthToParent', p.facts.get(factKey), p);
	//   //        return this.persons.update(p);
	//   //      }
	//   //      return this.rx.Observable.of(null);
	//   //    });
	//   //}
	//   del(person, evidences, namesFacts) {
	//     this.segment.track('persons.delete');
	//     // delete namesFacts
	//     return this.evidenceUtils.removeNamesFactsPidFromPersons([], namesFacts, person.id)
	//     // remove from parent and spouse families
	//     .flatMap(() => {
	//       return this.rx.Observable.forkJoin(this.families.streamParents(person.id).take(1), this.families.streamSpouses(person.id).take(1)).flatMap(([pm, sm]) => {
	//         let families = Array.from(pm.values()).concat(Array.from(sm.values()));
	//         if (families.length === 0) {
	//           return this.rx.Observable.of([]);
	//         }
	//         return this.rx.Observable.forkJoin(...families.map(f => this.familyUtils.removeFamilyMember(f, person.id)));
	//       });
	//     })
	//     // delete person
	//     .flatMap(() => this.persons.del(person.id))
	//     // delete evidences
	//     .flatMap(() => {
	//         if (evidences.length === 0) {
	//           return this.rx.Observable.of([]);
	//         }
	//         return this.rx.Observable.forkJoin(...evidences.map(evidence => this.evidences.del(evidence.id)));
	//       });
	//   }
	//   deleteFact(person, key) {
	//     let p = this.utils.clone(person);
	//     p.facts.delete(key);
	//     if (p.preferredBirthKey === key) {
	//       p.preferredBirthKey = 0;
	//     }
	//     if (p.preferredDeathKey === key) {
	//       p.preferredDeathKey = 0;
	//     }
	//     this.$log.debug('personUtils.deleteFact', p);
	//     return this.persons.update(p);
	//   }
	//   deleteName(person, key) {
	//     let p = this.utils.clone(person);
	//     p.names.delete(key);
	//     if (p.preferredNameKey === key) {
	//       p.preferredNameKey = 0;
	//     }
	//     this.$log.debug('personUtils.deleteName', p);
	//     return this.persons.update(p);
	//   }
	//   // form, spouseId, children
	//   setPersonData(params) {
	//     if (!!params.form.person) {
	//       let personData = this.utils.clone(params.form.person);
	//       let updated = false;
	//       if (!!params.form.marriage) {
	//         let f = this.createFact(params.form.marriage, true, true);
	//         f.principalId1 = params.spouseId;
	//         if (!Array.from(personData.facts.keys()).some(key => this.utils.factEquals(personData.facts.get(key), f))) {
	//           updated = true;
	//           personData.facts.set(this.utils.randomKey(), f);
	//         }
	//       }
	//       //if (!!params.children) {
	//       //  params.children.forEach(child => {
	//       //    let prefBirth = this.persons.getPreferredBirth(child);
	//       //    if (!!prefBirth) {
	//       //      let f = this.createFact(prefBirth, true, false);
	//       //      f.principalId1 = child.id;
	//       //      let evidence = params.childBirthEvidenceMap.get(child.id);
	//       //      if (!Array.from(personData.facts.keys()).some(key => this.utils.factEquals(personData.facts.get(key), f)) &&
	//       //        !!evidence && this.getPersonaKey(evidence, params.parentType) > 0) {
	//       //        updated = true;
	//       //        f.evidencePersonas.set(evidence.id, this.getPersonaKey(evidence, params.parentType));
	//       //        let key = this.utils.randomKey();
	//       //        personData.facts.set(key, f);
	//       //      }
	//       //    }
	//       //  });
	//       //}
	//       if (updated) {
	//         return this.rx.Observable.of(Object.assign(params, {personData}));
	//       }
	//       else {
	//         return this.rx.Observable.of(params);
	//       }
	//     }
	//     let personData = {
	//       id: 0,
	//       living: params.form.living,
	//       gender: params.form.gender,
	//       names: new Map(),
	//       facts: new Map()
	//     };
	//     if (!!params.form.name) {
	//       let nameKey = this.utils.randomKey();
	//       personData.names.set(nameKey, {
	//         nameForms: new Map([['default', params.form.name]]),
	//         type: '',
	//         date: '',
	//         dateSort: '',
	//         evidencePersonas: new Map()
	//       });
	//       personData.preferredNameKey = nameKey;
	//     }
	//     if (!!params.form.birth) {
	//       let factKey = this.utils.randomKey();
	//       personData.facts.set(factKey, this.createFact(params.form.birth, true, true));
	//       personData.preferredBirthKey = factKey;
	//     }
	//     if (!!params.form.death) {
	//       let factKey = this.utils.randomKey();
	//       personData.facts.set(factKey, this.createFact(params.form.death, true, true));
	//       personData.preferredDeathKey = factKey;
	//       if (personData.living !== 'FALSE') {
	//         personData.living = 'FALSE';
	//       }
	//     }
	//     if (!!params.form.marriage) {
	//       let f = this.createFact(params.form.marriage, true, true);
	//       f.principalId1 = params.spouseId;
	//       let factKey = this.utils.randomKey();
	//       personData.facts.set(factKey, f);
	//     }
	//     //if (!!params.children) {
	//     //  params.children.forEach(child => {
	//     //    let prefBirth = this.persons.getPreferredBirth(child);
	//     //    let evidence = params.childBirthEvidenceMap.get(child.id);
	//     //    if (!!prefBirth && !!evidence && this.getPersonaKey(evidence, params.parentType) > 0) {
	//     //      let f = this.createFact(prefBirth, true, false);
	//     //      f.principalId1 = child.id;
	//     //      f.evidencePersonas.set(evidence.id, this.getPersonaKey(evidence, params.parentType));
	//     //      let factKey = this.utils.randomKey();
	//     //      personData.facts.set(factKey, f);
	//     //    }
	//     //  });
	//     //}
	//     this.$log.debug('personUtils.setPersonData', personData);
	//     return this.rx.Observable.of(Object.assign(params, {personData}));
	//   }
	//   // personData
	//   postPerson(params) {
	//     if (!!params.personData) {
	//       //if (!!params.birthEvidence) {
	//       //  let birth = Array.from(params.personData.facts.values()).find(f => f.principal && (f.type === 'BIRT' || f.type === 'CHR') && f.evidencePersonas.size === 0);
	//       //  let childPersonaEntry = Array.from(params.birthPersonaMap.entries()).find(([,v]) => v === params.personData.id);
	//       //  birth.evidencePersonas.set(params.birthEvidence.id, childPersonaEntry[0]);
	//       //}
	//       if (!!params.marriageEvidence) {
	//         let marriage = Array.from(params.personData.facts.values()).find(f => f.principal && f.type === 'MARR' && f.principalId1 === params.spouseId && f.evidencePersonas.size === 0);
	//         let personaEntry = Array.from(params.marriagePersonaMap.entries()).find(([,v]) => v === params.personData.id);
	//         marriage.evidencePersonas.set(params.marriageEvidence.id, personaEntry[0]);
	//       }
	//       //if (!!params.deathEvidence) {
	//       //  let death = Array.from(params.personData.facts.values()).find(f => f.principal && (f.type === 'DEAT' || f.type === 'BURI') && f.evidencePersonas.size === 0);
	//       //  let personaEntry = Array.from(params.deathPersonaMap.entries()).find(([,v]) => v === params.personData.id);
	//       //  death.evidencePersonas.set(params.deathEvidence.id, personaEntry[0]);
	//       //}
	//       if (params.personData.id === 0) {
	//         this.$log.debug('personUtils.postPerson create', params.personData);
	//         return this.persons.create(params.personData).map(person => Object.assign(params, {person}));
	//       }
	//       else {
	//         this.$log.debug('personUtils.postPerson update', params.personData);
	//         return this.persons.update(params.personData).map(person => Object.assign(params, {person}));
	//       }
	//     }
	//     else {
	//       this.$log.debug('personUtils.postPerson noop', params);
	//       return this.rx.Observable.of(Object.assign(params, {person: params.form.person}));
	//     }
	//   }
	//   setRoot(params) {
	//     return this.treeUsers.stream().filter(tu => !!tu).take(1)
	//       .flatMap(tu => {
	//         if (parseInt(tu.preferences['ROOT'] || '0', 10) === 0) {
	//           tu.preferences['ROOT'] = params.person.id.toString();
	//           this.$log.debug('personUtils.setRoot', params);
	//           return this.treeUsers.update(tu).map(() => params);
	//         }
	//         return this.rx.Observable.of(params);
	//       });
	//   }
	//   setFamily(params) {
	//     let childId = 0;
	//     let husbandId = 0;
	//     let wifeId = 0;
	//     let parentType = '';
	//     switch (params.relationshipType) {
	//       case 'FATHER':
	//         parentType = 'FATHER';
	//         childId = params.relatedToPersonId;
	//         if (!!params.family && params.family.husbandId > 0 && !!params.form.person &&
	//           params.family.husbandId !== params.form.person.id && params.family.wifeId === 0) {
	//           husbandId = params.form.person.id;
	//           wifeId = params.family.husbandId;
	//         }
	//         else {
	//           husbandId = !!params.form.person ? params.form.person.id : 0;
	//           wifeId = !!params.family ? params.family.wifeId : 0;
	//         }
	//         break;
	//       case 'MOTHER':
	//         parentType = 'MOTHER';
	//         childId = params.relatedToPersonId;
	//         if (!!params.family && params.family.wifeId > 0 && !!params.form.person &&
	//           params.family.wifeId !== params.form.person.id && params.family.husbandId === 0) {
	//           husbandId = params.family.wifeId;
	//           wifeId = params.form.person.id;
	//         }
	//         else {
	//           husbandId = !!params.family ? params.family.husbandId : 0;
	//           wifeId = !!params.form.person ? params.form.person.id : 0;
	//         }
	//         break;
	//       case 'SPOUSE':
	//         if (params.form.gender !== 'FEMALE') {
	//           if (!!params.family && params.family.husbandId > 0 && !!params.form.person &&
	//             params.family.husbandId !== params.form.person.id && params.family.wifeId === 0) {
	//             parentType = 'MOTHER';
	//             husbandId = params.relatedToPersonId;
	//             wifeId = !!params.form.person ? params.form.person.id : 0;
	//           }
	//           else {
	//             parentType = 'FATHER';
	//             husbandId = !!params.form.person ? params.form.person.id : 0;
	//             wifeId = params.relatedToPersonId;
	//           }
	//         }
	//         else {
	//           if (!!params.family && params.family.wifeId > 0 && !!params.form.person &&
	//             params.family.wifeId !== params.form.person.id && params.family.husbandId === 0) {
	//             parentType = 'FATHER';
	//             husbandId = !!params.form.person ? params.form.person.id : 0;
	//             wifeId = params.relatedToPersonId;
	//           }
	//           else {
	//             parentType = 'MOTHER';
	//             husbandId = params.relatedToPersonId;
	//             wifeId = !!params.form.person ? params.form.person.id : 0;
	//           }
	//         }
	//         break;
	//       case 'CHILD':
	//       case 'SIBLING':
	//         childId = !!params.form.person ? params.form.person.id : 0;
	//         if (!!params.family) {
	//           husbandId = params.family.husbandId;
	//           wifeId = params.family.wifeId;
	//         }
	//         break;
	//     }
	//     // If we are adding a second parent to a single-parent, single-child family, does the two-parent family already exist?
	//     if (husbandId > 0 && wifeId > 0 && !!params.family && (params.family.husbandId === 0 || params.family.wifeId === 0) &&
	//       params.family.childRels.size === 1 && Array.from(params.family.childRels.keys())[0] === childId) {
	//       return this.families.streamSpouses(husbandId).take(1)
	//         .map(sfMap => {
	//           let family = Array.from(sfMap.values()).find(family => family.wifeId === wifeId);
	//           if (!family) {
	//             family = params.family;
	//           }
	//           else {
	//             // if so, we need to delete the current family and use this one instead
	//             this.families.del(params.family.id);
	//             this.$log.debug('personUtils.setFamily delete', params, params.family);
	//             delete params.family;
	//           }
	//           this.$log.debug('personUtils.setFamily', husbandId, wifeId, childId, parentType, family);
	//           return Object.assign(params, {husbandId, wifeId, childId, parentType, family});
	//         });
	//     }
	//     else if (params.relationshipType === 'CHILD' && !params.family && params.relatedToPersonId > 0) {
	//       return this.persons.streamId(params.relatedToPersonId).take(1).map(person => {
	//         if (person.gender !== 'FEMALE') {
	//           husbandId = params.relatedToPersonId;
	//           parentType = 'FATHER';
	//         }
	//         else {
	//           wifeId = params.relatedToPersonId;
	//           parentType = 'MOTHER';
	//         }
	//         this.$log.debug('personUtils.setFamily', husbandId, wifeId, childId, parentType);
	//         return Object.assign(params, {husbandId, wifeId, childId, parentType});
	//       });
	//     }
	//     else {
	//       this.$log.debug('personUtils.setFamily', husbandId, wifeId, childId, parentType);
	//       return this.rx.Observable.of(Object.assign(params, {husbandId, wifeId, childId, parentType}));
	//     }
	//   }
	//   // relatedToPersonId || family
	//   //setChildren(params) {
	//   //  if (!!params.family) {
	//   //    let childIds = Array.from(params.family.childRels.keys());
	//   //    this.$log.debug('personUtils.setChildren', childIds);
	//   //    return this.persons.streamIds(childIds).take(1).map(m => Object.assign(params, {children: Array.from(m.values())}));
	//   //  }
	//   //  else if (params.relationshipType === 'FATHER' || params.relationshipType === 'MOTHER') {
	//   //    this.$log.debug('personUtils.setChildren', params.relatedToPersonId);
	//   //    return this.persons.streamId(params.relatedToPersonId).take(1).map(person => Object.assign(params, {children: [person]}));
	//   //  }
	//   //  else {
	//   //    return this.rx.Observable.of(params);
	//   //  }
	//   //}
	//   //setBirthEvidence(params) {
	//   //  if (!!params.form.person) {
	//   //    return this.getAvailableBirthEvidence(params.form.person, params.parentType, params.husbandId, params.wifeId).map(birthEvidence => {
	//   //      this.$log.debug('personUtils.setBirthEvidence', params.form.person, params.husbandId, params.wifeId, birthEvidence);
	//   //      return Object.assign(params, {birthEvidence});
	//   //    });
	//   //  }
	//   //  return this.rx.Observable.of(params);
	//   //}
	//   //setChildBirthEvidenceMap(params) {
	//   //  if (!!params.children && params.children.length > 0) {
	//   //    this.$log.debug('personUtils.setChildBirthEvidenceMap', params.children);
	//   //    return this.rx.Observable.forkJoin(...params.children.map(child => this.getAvailableBirthEvidence(child, params.parentType, params.husbandId, params.wifeId)))
	//   //      .map(evidences => {
	//   //        let childBirthEvidenceMap = new Map(evidences
	//   //          .map((evidence, ix) => {
	//   //            return [params.children[ix].id, evidence];
	//   //          })
	//   //          .filter(([, evidence]) => !!evidence));
	//   //        this.$log.debug('personUtils.setChildBirthEvidenceMap', params.children, params.husbandId, params.wifeId, childBirthEvidenceMap);
	//   //        return Object.assign(params, {childBirthEvidenceMap});
	//   //      });
	//   //  }
	//   //  return this.rx.Observable.of(params);
	//   //}
	//   //getAvailableBirthEvidence(person, parentType, husbandId, wifeId) {
	//   //  let births = Array.from(person.facts.values()).filter(f => f.principal && f.type === 'BIRT');
	//   //  if (births.length > 0) {
	//   //    let eids = [...new Set([].concat(...births.map(f => Array.from(f.evidencePersonas.keys()))))]; // flatten and unique
	//   //    if (eids.length > 0) {
	//   //      return this.evidences.streamIds(eids).take(1).flatMap(em => {
	//   //        return this.getPersonsForEvidences(em).map(epam => {
	//   //          return {em, epam};
	//   //        });
	//   //      }).map(({em, epam}) => {
	//   //        this.$log.debug('personUtils.getAvailableBirthEvidence', em, epam, husbandId, wifeId);
	//   //        return Array.from(em.values()).find(e => this.isAvailableBirthEvidence(e, epam.get(e.id), parentType, husbandId, wifeId));
	//   //      });
	//   //    }
	//   //  }
	//   //  return this.rx.Observable.of(null);
	//   //}
	//   //isAvailableBirthEvidence(e, pam, parentType, husbandId, wifeId) {
	//   //  if (e._hasSource || e.personas.size !== 3) {
	//   //    return false;
	//   //  }
	//   //  return !Array.from(e.personas.entries()).some(([paKey,pa]) => !!pam.get(paKey) &&
	//   //  ((parentType === 'FATHER' && pa.relationshipType === 'FATHER') ||
	//   //   (parentType === 'MOTHER' && pa.relationshipType === 'MOTHER') ||
	//   //   (!parentType && pa.relationshipType === 'FATHER' && husbandId > 0 && pam.get(paKey).id !== husbandId) ||
	//   //   (!parentType && pa.relationshipType === 'MOTHER' && wifeId > 0 && pam.get(paKey).id !== wifeId)));
	//   //}
	//   // return {evidence id: {persona key: person}}
	//   getPersonsForEvidences(em) {
	//     let eids = Array.from(em.keys());
	//     return this.rx.Observable.forkJoin(...eids.map(key => this.persons.streamForEvidence(key).take(1))).map(pmaps => {
	//       return new Map(pmaps.map((pmap, ix) => {
	//         let parr = Array.from(pmap.values());
	//         let eid = eids[ix];
	//         let paKeys = Array.from(em.get(eid).personas.keys());
	//         return [eid, new Map(paKeys.map(paKey => {
	//           return [paKey, parr.find(p => {
	//             return Array.from(p.facts.values()).some(f => f.evidencePersonas.get(eid) === paKey);
	//           })];
	//         }))];
	//       }));
	//     });
	//   }
	//   // form.marriage, relationshipType, relatedToPersonId || family
	//   setSpouseId(params) {
	//     let spouseId = 0;
	//     if (!!params.form.marriage) {
	//       if (params.relationshipType === 'SPOUSE') {
	//         spouseId = params.relatedToPersonId;
	//       }
	//       else if (params.relationshipType === 'FATHER' && !!params.family) {
	//         spouseId = params.family.wifeId;
	//       }
	//       else if (params.relationshipType === 'MOTHER' && !!params.family) {
	//         spouseId = params.family.husbandId;
	//       }
	//     }
	//     this.$log.debug('personUtils.setSpouseId', spouseId);
	//     return this.rx.Observable.of(Object.assign(params, {spouseId}));
	//   }
	//   // form.marriage, spouseId, person
	//   addMarriageToSpouse(params) {
	//     if (!params.form.marriage || !params.spouseId|| !params.person) {
	//       return this.rx.Observable.of(params);
	//     }
	//     return this.persons.streamId(params.spouseId).take(1)
	//       .flatMap(person => {
	//         if (!!params.marriageEvidence) {
	//           let p = this.utils.clone(person);
	//           let f = this.createFact(params.form.marriage, true, true);
	//           f.principalId1 = params.person.id;
	//           f.evidencePersonas.set(params.marriageEvidence.id, Array.from(params.marriagePersonaMap.keys()).find(k => params.marriagePersonaMap.get(k) === params.spouseId));
	//           let factKey = this.utils.randomKey();
	//           p.facts.set(factKey, f);
	//           this.$log.debug('personUtils.addMarriageToSpouse', params.marriagePersonaMap, params.spouseId, p);
	//           return this.persons.update(p).map(() => params);
	//         }
	//         else {
	//           return this.rx.Observable.of(params);
	//         }
	//       });
	//   }
	//   // relationshipType, person, family, husbandId, wifeId, childId
	//   postFamily(params) {
	//     switch (params.relationshipType) {
	//       case 'FATHER':
	//         if (params.husbandId > 0 && params.husbandId !== params.person.id) {
	//           params.wifeId = params.person.id;
	//         }
	//         else {
	//           params.husbandId = params.person.id;
	//         }
	//         break;
	//       case 'MOTHER':
	//         if (params.wifeId > 0 && params.wifeId !== params.person.id) {
	//           params.husbandId = params.person.id;
	//         }
	//         else {
	//           params.wifeId = params.person.id;
	//         }
	//         break;
	//       case 'SPOUSE':
	//         if (params.husbandId > 0 && params.husbandId !== params.person.id) {
	//           params.wifeId = params.person.id;
	//         }
	//         else {
	//           params.husbandId = params.person.id;
	//         }
	//         break;
	//       case 'CHILD':
	//       case 'SIBLING':
	//         params.childId = params.person.id;
	//         break;
	//     }
	//     if (!!params.family) {
	//       let f = this.utils.clone(params.family);
	//       f.husbandId = f.husbandId || params.husbandId;
	//       f.wifeId = f.wifeId || params.wifeId;
	//       if (params.childId > 0 && !f.childRels.has(params.childId)) {
	//         f.childRels.set(params.childId, {fatherRel: '', motherRel: ''});
	//       }
	//       this.$log.debug('personUtils.postFamily update', params, f);
	//       return this.mergeExistingFamily(f);
	//     }
	//     else {
	//       let f = {
	//         id: 0,
	//         childRels: new Map()
	//       };
	//       f.husbandId = params.husbandId;
	//       f.wifeId = params.wifeId;
	//       if (params.childId > 0) {
	//         f.childRels.set(params.childId, {fatherRel: '', motherRel: ''});
	//       }
	//       this.$log.debug('personUtils.postFamily create', params, f);
	//       return this.mergeExistingFamily(f);
	//     }
	//   }
	//   mergeExistingFamily(f) {
	//     let spouseId = f.husbandId || f.wifeId;
	//     if (spouseId === 0) {
	//       return f.id === 0 ? this.families.create(f) : this.families.update(f);
	//     }
	//     return this.families.streamSpouses(spouseId).take(1).flatMap(fm => {
	//       let mergeFamily = Array.from(fm.values()).find(family => family.id !== f.id &&
	//         ((family.husbandId === f.husbandId && family.wifeId === f.wifeId) || (family.husbandId === f.wifeId && family.wifeId === f.husbandId)));
	//       if (!!mergeFamily) {
	//         let mf = this.utils.clone(mergeFamily);
	//         for (let [k,v] of f.childRels) {
	//           mf.childRels.set(k, v);
	//         }
	//         return this.families.update(mf).flatMap(family => {
	//           if (f.id > 0) {
	//             return this.families.del(f.id).map(() => family);
	//           }
	//           else {
	//             return this.rx.Observable.of(family);
	//           }
	//         });
	//       }
	//       else {
	//         return f.id === 0 ? this.families.create(f) : this.families.update(f);
	//       }
	//     });
	//   }
	//   // assume isPersonFact = false
	//   createFact(fact, isPersonFact, principal) {
	//     let result = {
	//       type: fact.type,
	//       value: fact.value,
	//       date: fact.date || '',
	//       dateSort: fact.dateSort || '',
	//       place: angular.isObject(fact.place) ? fact.place.name : fact.placeText || fact.place || '',
	//       placeDetails: fact.placeDetails || '',
	//       placeStandard: angular.isObject(fact.place) ? fact.place.standardName : fact.placeStandard || '',
	//       latitude: angular.isObject(fact.place) ? fact.place.latitude : fact.latitude || 0,
	//       longitude: angular.isObject(fact.place) ? fact.place.longitude : fact.longitude || 0
	//     };
	//     if (isPersonFact) {
	//       result.principal = principal;
	//       result.evidencePersonas = new Map();
	//     }
	//     return result;
	//   }
	//   getPersonaKey(evidence, relationshipType) {
	//     return Array.from(evidence.personas.keys()).find(k => evidence.personas.get(k).relationshipType === relationshipType);
	//   }
	//   getDeletedEvidences(person) {
	//     // get all names and facts for which person is a principal
	//     let namesFacts = Array.from(person.names.values()).concat(Array.from(person.facts.values()).filter(f => f.principal));
	//     // get unique evidence ids
	//     let eids = [...new Set([].concat(...namesFacts.map(nf => Array.from(nf.evidencePersonas.keys()))))]; // flatten and unique
	//     // set up evidencePersonas map
	//     let evidencePersonas = new Map(eids.map(eid => [eid, namesFacts.find(nf => nf.evidencePersonas.has(eid)).evidencePersonas.get(eid)]));
	//     // read evidences
	//     return this.evidences.streamIds(eids).take(1).map(em => {
	//       // return evidences that don't have any other principal personas, or are a marriage
	//       return Array.from(em.values()).filter(e => Array.from(e.personas.entries()).every(([key, pa]) => !pa.principal || evidencePersonas.get(e.id) === key) || e.fact.type === 'MARR');
	//     });
	//   }
	//   //    if (parents.length === 0) {
	//   //      return this.rx.Observable.of(params);
	//   //    }
	//   //    return this.rx.Observable.forkJoin(...parents.map(parent => {
	//   //      let personaKey = Array.from(params.birthEvidence.personas.keys()).find(k => params.birthEvidence.personas.get(k).relationshipType === parent.relationship);
	//   //      return this.addBirthToParent(params.birthEvidence, personaKey, parent.id, params.person.id);
	//   //    })).map(() => params);
	//   merge(person, mergePerson) {
	//     // move all notes from mergePerson to person
	//     return this.notes.streamForPerson(mergePerson.id).take(1).flatMap(m => {
	//       let arr = Array.from(m.values());
	//       if (arr.length === 0) {
	//         return this.rx.Observable.of(true);
	//       }
	//       return this.rx.Observable.forkJoin(...arr.map(n => {
	//         n.personIds.delete(mergePerson.id);
	//         n.personIds.set(person.id, true);
	//         return this.notes.update(n);
	//       }));
	//     }).flatMap(() => {
	//       // move all stories from mergePerson to person
	//       return this.stories.streamForPerson(mergePerson.id).take(1).flatMap(m => {
	//         let arr = Array.from(m.values());
	//         if (arr.length === 0) {
	//           return this.rx.Observable.of(true);
	//         }
	//         return this.rx.Observable.forkJoin(...arr.map(s => {
	//           s.personIds.delete(mergePerson.id);
	//           s.personIds.set(person.id, true);
	//           return this.stories.update(s);
	//         }));
	//       });
	//     }).flatMap(() => {
	//       // move all medias from mergePerson to person
	//       return this.medias.streamForPerson(mergePerson.id).take(1).flatMap(m => {
	//         let arr = Array.from(m.values());
	//         if (arr.length === 0) {
	//           return this.rx.Observable.of(true);
	//         }
	//         return this.rx.Observable.forkJoin(...arr.map(m => {
	//           m.personIds.delete(mergePerson.id);
	//           m.personIds.set(person.id, true);
	//           return this.medias.update(m);
	//         }));
	//       });
	//     }).flatMap(() => {
	//       // move spouse families from mergePerson to person
	//       return this.rx.Observable.combineLatest(this.families.streamSpouses(mergePerson.id), this.families.streamSpouses(person.id)).take(1).flatMap(([mfm, fm]) => {
	//         let arr = Array.from(mfm.values());
	//         if (arr.length === 0) {
	//           return this.rx.Observable.of(true);
	//         }
	//         return this.rx.Observable.forkJoin(...arr.map(mf => {
	//           mf = this.utils.clone(mf);
	//           if (mf.husbandId === mergePerson.id) {
	//             // don't add if person is a wife or child
	//             if (mf.wifeId === person.id || mf.childRels.has(person.id)) {
	//               mf.husbandId = 0;
	//             }
	//             else {
	//               mf.husbandId = person.id;
	//             }
	//           }
	//           if (mf.wifeId === mergePerson.id) {
	//             // don't add if person is a husband or child
	//             if (mf.husbandId === person.id || mf.childRels.has(person.id)) {
	//               mf.wifeId = 0;
	//             }
	//             else {
	//               mf.wifeId = person.id;
	//             }
	//           }
	//           // if this matches an existing family on person, move the children over and delete
	//           let found = null;
	//           for (let f of fm.values()) {
	//             if (f.id !== mf.id && f.husbandId === mf.husbandId && f.wifeId === mf.wifeId) {
	//               found = f;
	//               break;
	//             }
	//           }
	//           if (!!found) {
	//             mf.childRels.forEach((v,k) => {
	//               if (!found.childRels.has(k)) {
	//                 found.childRels.set(k,v);
	//               }
	//             });
	//             return this.families.update(found).flatMap(() => {
	//               return this.families.del(mf.id);
	//             });
	//           }
	//           else {
	//             return this.families.update(mf);
	//           }
	//         }));
	//       });
	//     }).flatMap(() => {
	//       // move parent families from mergePerson to person
	//       return this.families.streamParents(mergePerson.id).take(1).flatMap(m => {
	//         let arr = Array.from(m.values());
	//         if (arr.length === 0) {
	//           return this.rx.Observable.of(true);
	//         }
	//         return this.rx.Observable.forkJoin(...arr.map(f => {
	//           let cr = f.childRels.get(mergePerson.id);
	//           f.childRels.delete(mergePerson.id);
	//           // don't add if already exists, or is a parent
	//           if (!f.childRels.has(person.id) && f.husbandId !== person.id && f.wifeId !== person.id) {
	//             f.childRels.set(person.id, cr);
	//           }
	//           return this.families.update(f);
	//         }));
	//       });
	//     }).flatMap(() => {
	//       return this.evidenceUtils.removeNamesFactsPidFromPersons([], [], mergePerson.id, person.id);
	//     }).flatMap(() => {
	//       // move all facts and names from mergePerson to person
	//       for (let fact of mergePerson.facts.values()) {
	//         person.facts.set(this.utils.randomKey(), fact);
	//       }
	//       for (let name of mergePerson.names.values()) {
	//         person.names.set(this.utils.randomKey(), name);
	//       }
	//       return this.persons.update(person);
	//     }).flatMap(() => {
	//       // update dna kits
	//       return this.dnaKits.stream().take(1).flatMap(kitMap => {
	//         let updates = [];
	//         for (let kit of kitMap.values()) {
	//           if (kit.personId1 === mergePerson.id || kit.personId2 === mergePerson.id) {
	//             kit = this.utils.clone(kit);
	//             if (kit.personId1 === mergePerson.id) {
	//               kit.personId1 = person.id;
	//             }
	//             if (kit.personId2 === mergePerson.id) {
	//               kit.personId2 = person.id;
	//             }
	//             updates.push(kit);
	//           }
	//         }
	//         if (updates.length === 0) {
	//           return this.rx.Observable.of(true);
	//         }
	//         return this.rx.Observable.forkJoin(...updates.map(kit => {
	//           return this.dnaKits.update(kit);
	//         }));
	//       });
	//     }).flatMap(() => {
	//       // delete mergePerson
	//       return this.persons.del(mergePerson.id);
	//     });
	//   }
	//   moveEvidence(pid, eid, sourceKey, targetKey) {
	//     return this.persons.streamId(pid).take(1)
	//       .flatMap(person => {
	//         let sourceFact = person.facts.get(sourceKey);
	//         let targetFact = person.facts.get(targetKey);
	//         let personaKey = sourceFact.evidencePersonas.get(eid);
	//         sourceFact.evidencePersonas.delete(eid);
	//         targetFact.evidencePersonas.set(eid, personaKey);
	//         return this.persons.update(person);
	//       });
	//   }
	// }
	// export default PersonUtilsService;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var PersonUtilsService = /** @class */ (function () {
	    function PersonUtilsService(log, rx, messageBus, persons, evidences, notes, stories, medias, families, dnaKits, treeUsers, segment, evidenceUtils, familyUtils, utils, angularUtils) {
	        this.log = log;
	        this.rx = rx;
	        this.messageBus = messageBus;
	        this.persons = persons;
	        this.evidences = evidences;
	        this.notes = notes;
	        this.stories = stories;
	        this.medias = medias;
	        this.families = families;
	        this.dnaKits = dnaKits;
	        this.treeUsers = treeUsers;
	        this.segment = segment;
	        this.evidenceUtils = evidenceUtils;
	        this.familyUtils = familyUtils;
	        this.utils = utils;
	        this.angularUtils = angularUtils;
	    }
	    // form = {person, living, gender, name, birth={type, date, place, placeText}, death={type, date, place, placeText}, marriage={type, date, place, placeText} }
	    // family is required for SIBLING or when adding a CHILD, SPOUSE, FATHER or MOTHER to an existing family
	    // relatedToPersonId is required for FATHER, MOTHER, SPOUSE, and CHILD if no family
	    PersonUtilsService.prototype.add = function (form, relationshipType, relatedToPersonId, family) {
	        var _this = this;
	        this.segment.track('persons.create');
	        var params = { form: form, relationshipType: relationshipType, relatedToPersonId: relatedToPersonId, family: family };
	        if (!!form && !!form.person && form.person.id > 0 && !!family &&
	            (form.person.id === family.husbandId || form.person.id === family.wifeId || family.childRels.has(form.person.id))) {
	            this.messageBus.post({ msg: 'This person is already a member of this family', op: 'UPDATE', ctx: 'personUtils.add' });
	            return this.rx.Observable.throw('exists');
	        }
	        switch (relationshipType) {
	            case 'FATHER':
	            case 'MOTHER':
	                return this.setFamily(params)
	                    .flatMap(function (params) { return _this.setSpouseId(params); })
	                    .flatMap(function (params) { return _this.setPersonData(params); })
	                    .flatMap(function (params) { return _this.addEvidences(params); })
	                    .flatMap(function (params) { return _this.postPerson(params); })
	                    .flatMap(function (params) { return _this.addMarriageToSpouse(params); })
	                    .flatMap(function (params) { return _this.postFamily(params); });
	            case 'SPOUSE':
	                return this.setFamily(params)
	                    .flatMap(function (params) { return _this.setSpouseId(params); })
	                    .flatMap(function (params) { return _this.setPersonData(params); })
	                    .flatMap(function (params) { return _this.addEvidences(params); })
	                    .flatMap(function (params) { return _this.postPerson(params); })
	                    .flatMap(function (params) { return _this.addMarriageToSpouse(params); })
	                    .flatMap(function (params) { return _this.postFamily(params); });
	            case 'CHILD':
	            case 'SIBLING':
	                return this.setFamily(params)
	                    .flatMap(function (params) { return _this.setPersonData(params); })
	                    .flatMap(function (params) { return _this.addEvidences(params); })
	                    .flatMap(function (params) { return _this.postPerson(params); })
	                    .flatMap(function (params) { return _this.postFamily(params); });
	            default:
	                return this.setPersonData(params)
	                    .flatMap(function (params) { return _this.addEvidences(params); })
	                    .flatMap(function (params) { return _this.postPerson(params); })
	                    .flatMap(function (params) { return _this.setRoot(params); });
	        }
	    };
	    PersonUtilsService.prototype.update = function (p) {
	        var _this = this;
	        // add evidences
	        this.segment.track('persons.update');
	        return this.addEvidences({ personData: p })
	            .flatMap(function () {
	            return _this.persons.update(p);
	        });
	        //.flatMap({birthEvidence, birthPersonaMap, deathEvidence, deathPersonaMap}) => {
	        // update birth and death with evidences
	        //if (!!birthEvidence) {
	        //  let birth = Array.from(p.facts.values()).find(f => f.principal && (f.type === 'BIRT' || f.type === 'CHR') && f.evidencePersonas.size === 0);
	        //  let childPersonaEntry = Array.from(birthPersonaMap.entries()).find(([,v]) => v === p.id);
	        //  birth.evidencePersonas.set(birthEvidence.id, childPersonaEntry[0]);
	        //}
	        //if (!!deathEvidence) {
	        //  let death = Array.from(p.facts.values()).find(f => f.principal && (f.type === 'DEAT' || f.type === 'BURI') && f.evidencePersonas.size === 0);
	        //  let personaEntry = Array.from(deathPersonaMap.entries()).find(([,v]) => v === p.id);
	        //  death.evidencePersonas.set(deathEvidence.id, personaEntry[0]);
	        //}
	        //return this.persons.update(p).map(person => {
	        //  return {birthEvidence, birthPersonaMap, person};
	        //});
	        //})
	        //// add birth to parents if necessary
	        //.flatMap(({birthEvidence, birthPersonaMap, person}) => {
	        //  // do we need to add the birth to parents?
	        //  let parentPersonaMap = new Map(Array.from(birthPersonaMap.entries()).filter(([,v]) => v !== person.id));
	        //  if (!!birthEvidence && parentPersonaMap.size > 0) {
	        //    return  this.rx.Observable.forkJoin(...Array.from(parentPersonaMap.keys()).map(key => this.addBirthToParent(birthEvidence, key, parentPersonaMap.get(key), person.id)));
	        //  }
	        //  else {
	        //    return  this.rx.Observable.of([]);
	        //  }
	        //});
	    };
	    PersonUtilsService.prototype.addEvidences = function (params) {
	        if (!params.personData) {
	            return this.rx.Observable.of(params);
	        }
	        // add birth, marriage, and death evidences if needed
	        //return  this.rx.Observable.forkJoin(this.addBirthEvidence(params.personData), this.addMarriageEvidence(params.personData, params.spouseId), this.addDeathEvidence(params.personData)).map(results => {
	        //  return Object.assign(params, {
	        //    birthEvidence: results[0].evidence,
	        //    birthPersonaMap: results[0].personaMap,
	        //    marriageEvidence: results[1].evidence,
	        //    marriagePersonaMap: results[1].personaMap,
	        //    deathEvidence: results[2].evidence,
	        //    deathPersonaMap: results[2].personaMap
	        //  });
	        //});
	        return this.addMarriageEvidence(params.personData, params.spouseId).map(function (results) {
	            return Object.assign(params, {
	                marriageEvidence: results.evidence,
	                marriagePersonaMap: results.personaMap
	            });
	        });
	    };
	    //addBirthEvidence(p) {
	    //  let birth = Array.from(p.facts.values()).find(f => f.principal && (f.type === 'BIRT' || f.type === 'CHR') && f.evidencePersonas.size === 0);
	    //  if (!!birth) {
	    //    return this.families.streamParents(p.id).take(1).flatMap(fm => {
	    //      let family = this.families.getPreferredFamily(fm, p.preferredParentsFamilyId);
	    //      let e = this.utils.createEvidenceFromFact(birth);
	    //      let personaMap = new Map();
	    //      personaMap.set(1, p.id);
	    //      e.personas.set(2, {
	    //        principal: false,
	    //        relatedToKey: 1,
	    //        relationshipType: 'FATHER',
	    //        names: new Map(),
	    //        facts: new Map()
	    //      });
	    //      if (!!family && family.husbandId > 0) {
	    //        personaMap.set(2, family.husbandId);
	    //      }
	    //      e.personas.set(3, {
	    //        principal: false,
	    //        relatedToKey: 1,
	    //        relationshipType: 'MOTHER',
	    //        names: new Map(),
	    //        facts: new Map()
	    //      });
	    //      if (!!family && family.wifeId > 0) {
	    //        personaMap.set(3, family.wifeId);
	    //      }
	    //      this.log.debug('personUtils.addBirthEvidence', e);
	    //      return this.evidences.create(e).map(evidence => {
	    //        return {evidence, personaMap};
	    //      });
	    //    });
	    //  }
	    //  else {
	    //    return  this.rx.Observable.of({evidence: null, personaMap: new Map()});
	    //  }
	    //}
	    PersonUtilsService.prototype.addMarriageEvidence = function (p, spouseId) {
	        var marriage = Array.from(p.facts.values()).find(function (f) { return f.principal && f.type === 'MARR' && f.principalId1 === spouseId && f.evidencePersonas.size === 0; });
	        if (!!marriage && spouseId > 0) {
	            var e = this.utils.createEvidenceFromFact(marriage);
	            var personaMap_1 = new Map();
	            e.personas.set(2, {
	                principal: true,
	                relatedToKey: 1,
	                relationshipType: 'SPOUSE',
	                names: new Map(),
	                facts: new Map()
	            });
	            if (p.gender !== 'FEMALE') {
	                personaMap_1.set(1, p.id);
	                personaMap_1.set(2, spouseId);
	            }
	            else {
	                personaMap_1.set(2, p.id);
	                personaMap_1.set(1, spouseId);
	            }
	            this.log.debug('personUtils.addMarriageEvidence', e);
	            return this.evidences.create(e).map(function (evidence) {
	                return { evidence: evidence, personaMap: personaMap_1 };
	            });
	        }
	        else {
	            return this.rx.Observable.of({ evidence: null, personaMap: new Map() });
	        }
	    };
	    //addDeathEvidence(p) {
	    //  let death = Array.from(p.facts.values()).find(f => f.principal && (f.type === 'DEAT' || f.type === 'BURI') && f.evidencePersonas.size === 0);
	    //  if (!!death) {
	    //    let e = this.utils.createEvidenceFromFact(death);
	    //    let personaMap = new Map();
	    //    personaMap.set(1, p.id);
	    //    this.log.debug('personUtils.addDeathEvidence', e);
	    //    return this.evidences.create(e).map(evidence => {
	    //      return {evidence, personaMap};
	    //    });
	    //  }
	    //  else {
	    //    return  this.rx.Observable.of({evidence: null, personaMap: new Map()});
	    //  }
	    //}
	    //addBirthToParents(params) {
	    //  if (!!params.birthEvidence) {
	    //    let parents = [];
	    //    if (params.husbandId > 0) {
	    //      parents.push({relationship: 'FATHER', id: params.husbandId});
	    //    }
	    //    if (params.wifeId > 0) {
	    //      parents.push({relationship: 'MOTHER', id: params.wifeId});
	    //    }
	    //    if (parents.length === 0) {
	    //      return  this.rx.Observable.of(params);
	    //    }
	    //    return  this.rx.Observable.forkJoin(...parents.map(parent => {
	    //      let personaKey = Array.from(params.birthEvidence.personas.keys()).find(k => params.birthEvidence.personas.get(k).relationshipType === parent.relationship);
	    //      return this.addBirthToParent(params.birthEvidence, personaKey, parent.id, params.person.id);
	    //    })).map(() => params);
	    //  }
	    //  else {
	    //    return  this.rx.Observable.of(params);
	    //  }
	    //}
	    //
	    //addBirthToParent(birthEvidence, personaKey, parentId, childId) {
	    //  return this.persons.streamId(parentId).take(1)
	    //    .flatMap(person => {
	    //      let p = this.utils.clone(person);
	    //      if (personaKey > 0) {
	    //        let f = this.createFact(birthEvidence.fact, true, false);
	    //        f.principalId1 = childId;
	    //        f.evidencePersonas.set(birthEvidence.id, personaKey);
	    //        let factKey = this.utils.randomKey();
	    //        p.facts.set(factKey, f);
	    //        this.log.debug('personUtils.addBirthToParent', p.facts.get(factKey), p);
	    //        return this.persons.update(p);
	    //      }
	    //      return  this.rx.Observable.of(null);
	    //    });
	    //}
	    PersonUtilsService.prototype.del = function (person, evidences, namesFacts) {
	        var _this = this;
	        this.segment.track('persons.delete');
	        // delete namesFacts
	        return this.evidenceUtils.removeNamesFactsPidFromPersons([], namesFacts, person.id)
	            .flatMap(function () {
	            return _this.rx.Observable.forkJoin(_this.families.streamParents(person.id).take(1), _this.families.streamSpouses(person.id).take(1)).flatMap(function (_a) {
	                var _b = __read(_a, 2), pm = _b[0], sm = _b[1];
	                var families = Array.from(pm.values()).concat(Array.from(sm.values()));
	                if (families.length === 0) {
	                    return _this.rx.Observable.of([]);
	                }
	                return (_c = _this.rx.Observable).forkJoin.apply(_c, __spread(families.map(function (f) { return _this.familyUtils.removeFamilyMember(f, person.id); })));
	                var _c;
	            });
	        })
	            .flatMap(function () { return _this.persons.del(person.id); })
	            .flatMap(function () {
	            if (evidences.length === 0) {
	                return _this.rx.Observable.of([]);
	            }
	            return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(evidences.map(function (evidence) { return _this.evidences.del(evidence.id); })));
	            var _a;
	        });
	    };
	    PersonUtilsService.prototype.deleteFact = function (person, key) {
	        var p = this.utils.clone(person);
	        p.facts.delete(key);
	        if (p.preferredBirthKey === key) {
	            p.preferredBirthKey = 0;
	        }
	        if (p.preferredDeathKey === key) {
	            p.preferredDeathKey = 0;
	        }
	        this.log.debug('personUtils.deleteFact', p);
	        return this.persons.update(p);
	    };
	    PersonUtilsService.prototype.deleteName = function (person, key) {
	        var p = this.utils.clone(person);
	        p.names.delete(key);
	        if (p.preferredNameKey === key) {
	            p.preferredNameKey = 0;
	        }
	        this.log.debug('personUtils.deleteName', p);
	        return this.persons.update(p);
	    };
	    // form, spouseId, children
	    PersonUtilsService.prototype.setPersonData = function (params) {
	        var _this = this;
	        if (!!params.form.person) {
	            var personData_1 = this.utils.clone(params.form.person);
	            var updated = false;
	            if (!!params.form.marriage) {
	                var f_1 = this.createFact(params.form.marriage, true, true);
	                f_1.principalId1 = params.spouseId;
	                if (!Array.from(personData_1.facts.keys()).some(function (key) { return _this.utils.factEquals(personData_1.facts.get(key), f_1); })) {
	                    updated = true;
	                    personData_1.facts.set(this.utils.randomKey(), f_1);
	                }
	            }
	            //if (!!params.children) {
	            //  params.children.forEach(child => {
	            //    let prefBirth = this.persons.getPreferredBirth(child);
	            //    if (!!prefBirth) {
	            //      let f = this.createFact(prefBirth, true, false);
	            //      f.principalId1 = child.id;
	            //      let evidence = params.childBirthEvidenceMap.get(child.id);
	            //      if (!Array.from(personData.facts.keys()).some(key => this.utils.factEquals(personData.facts.get(key), f)) &&
	            //        !!evidence && this.getPersonaKey(evidence, params.parentType) > 0) {
	            //        updated = true;
	            //        f.evidencePersonas.set(evidence.id, this.getPersonaKey(evidence, params.parentType));
	            //        let key = this.utils.randomKey();
	            //        personData.facts.set(key, f);
	            //      }
	            //    }
	            //  });
	            //}
	            if (updated) {
	                return this.rx.Observable.of(Object.assign(params, { personData: personData_1 }));
	            }
	            else {
	                return this.rx.Observable.of(params);
	            }
	        }
	        var personData = {
	            id: 0,
	            living: params.form.living,
	            gender: params.form.gender,
	            names: new Map(),
	            facts: new Map(),
	            preferredNameKey: undefined,
	            preferredBirthKey: undefined,
	            preferredDeathKey: undefined
	        };
	        if (!!params.form.name) {
	            var nameKey = this.utils.randomKey();
	            personData.names.set(nameKey, {
	                nameForms: new Map([['default', params.form.name]]),
	                type: '',
	                date: '',
	                dateSort: '',
	                evidencePersonas: new Map()
	            });
	            personData.preferredNameKey = nameKey;
	        }
	        if (!!params.form.birth) {
	            var factKey = this.utils.randomKey();
	            personData.facts.set(factKey, this.createFact(params.form.birth, true, true));
	            personData.preferredBirthKey = factKey;
	        }
	        if (!!params.form.death) {
	            var factKey = this.utils.randomKey();
	            personData.facts.set(factKey, this.createFact(params.form.death, true, true));
	            personData.preferredDeathKey = factKey;
	            if (personData.living !== 'FALSE') {
	                personData.living = 'FALSE';
	            }
	        }
	        if (!!params.form.marriage) {
	            var f = this.createFact(params.form.marriage, true, true);
	            f.principalId1 = params.spouseId;
	            var factKey = this.utils.randomKey();
	            personData.facts.set(factKey, f);
	        }
	        //if (!!params.children) {
	        //  params.children.forEach(child => {
	        //    let prefBirth = this.persons.getPreferredBirth(child);
	        //    let evidence = params.childBirthEvidenceMap.get(child.id);
	        //    if (!!prefBirth && !!evidence && this.getPersonaKey(evidence, params.parentType) > 0) {
	        //      let f = this.createFact(prefBirth, true, false);
	        //      f.principalId1 = child.id;
	        //      f.evidencePersonas.set(evidence.id, this.getPersonaKey(evidence, params.parentType));
	        //      let factKey = this.utils.randomKey();
	        //      personData.facts.set(factKey, f);
	        //    }
	        //  });
	        //}
	        this.log.debug('personUtils.setPersonData', personData);
	        return this.rx.Observable.of(Object.assign(params, { personData: personData }));
	    };
	    // personData
	    PersonUtilsService.prototype.postPerson = function (params) {
	        if (!!params.personData) {
	            //if (!!params.birthEvidence) {
	            //  let birth = Array.from(params.personData.facts.values()).find(f => f.principal && (f.type === 'BIRT' || f.type === 'CHR') && f.evidencePersonas.size === 0);
	            //  let childPersonaEntry = Array.from(params.birthPersonaMap.entries()).find(([,v]) => v === params.personData.id);
	            //  birth.evidencePersonas.set(params.birthEvidence.id, childPersonaEntry[0]);
	            //}
	            if (!!params.marriageEvidence) {
	                var marriage = Array.from(params.personData.facts.values()).find(function (f) { return f.principal && f.type === 'MARR' && f.principalId1 === params.spouseId && f.evidencePersonas.size === 0; });
	                var personaEntry = Array.from(params.marriagePersonaMap.entries()).find(function (_a) {
	                    var _b = __read(_a, 2), v = _b[1];
	                    return v === params.personData.id;
	                });
	                marriage.evidencePersonas.set(params.marriageEvidence.id, personaEntry[0]);
	            }
	            //if (!!params.deathEvidence) {
	            //  let death = Array.from(params.personData.facts.values()).find(f => f.principal && (f.type === 'DEAT' || f.type === 'BURI') && f.evidencePersonas.size === 0);
	            //  let personaEntry = Array.from(params.deathPersonaMap.entries()).find(([,v]) => v === params.personData.id);
	            //  death.evidencePersonas.set(params.deathEvidence.id, personaEntry[0]);
	            //}
	            if (params.personData.id === 0) {
	                this.log.debug('personUtils.postPerson create', params.personData);
	                return this.persons.create(params.personData).map(function (person) { return Object.assign(params, { person: person }); });
	            }
	            else {
	                this.log.debug('personUtils.postPerson update', params.personData);
	                return this.persons.update(params.personData).map(function (person) { return Object.assign(params, { person: person }); });
	            }
	        }
	        else {
	            this.log.debug('personUtils.postPerson noop', params);
	            return this.rx.Observable.of(Object.assign(params, { person: params.form.person }));
	        }
	    };
	    PersonUtilsService.prototype.setRoot = function (params) {
	        var _this = this;
	        return this.treeUsers.stream().filter(function (tu) { return !!tu; }).take(1)
	            .flatMap(function (tu) {
	            if (parseInt(tu.preferences['ROOT'] || '0', 10) === 0) {
	                tu.preferences['ROOT'] = params.person.id.toString();
	                _this.log.debug('personUtils.setRoot', params);
	                return _this.treeUsers.update(tu).map(function () { return params; });
	            }
	            return _this.rx.Observable.of(params);
	        });
	    };
	    PersonUtilsService.prototype.setFamily = function (params) {
	        var _this = this;
	        var childId = 0;
	        var husbandId = 0;
	        var wifeId = 0;
	        var parentType = '';
	        switch (params.relationshipType) {
	            case 'FATHER':
	                parentType = 'FATHER';
	                childId = params.relatedToPersonId;
	                if (!!params.family && params.family.husbandId > 0 && !!params.form.person &&
	                    params.family.husbandId !== params.form.person.id && params.family.wifeId === 0) {
	                    husbandId = params.form.person.id;
	                    wifeId = params.family.husbandId;
	                }
	                else {
	                    husbandId = !!params.form.person ? params.form.person.id : 0;
	                    wifeId = !!params.family ? params.family.wifeId : 0;
	                }
	                break;
	            case 'MOTHER':
	                parentType = 'MOTHER';
	                childId = params.relatedToPersonId;
	                if (!!params.family && params.family.wifeId > 0 && !!params.form.person &&
	                    params.family.wifeId !== params.form.person.id && params.family.husbandId === 0) {
	                    husbandId = params.family.wifeId;
	                    wifeId = params.form.person.id;
	                }
	                else {
	                    husbandId = !!params.family ? params.family.husbandId : 0;
	                    wifeId = !!params.form.person ? params.form.person.id : 0;
	                }
	                break;
	            case 'SPOUSE':
	                if (params.form.gender !== 'FEMALE') {
	                    if (!!params.family && params.family.husbandId > 0 && !!params.form.person &&
	                        params.family.husbandId !== params.form.person.id && params.family.wifeId === 0) {
	                        parentType = 'MOTHER';
	                        husbandId = params.relatedToPersonId;
	                        wifeId = !!params.form.person ? params.form.person.id : 0;
	                    }
	                    else {
	                        parentType = 'FATHER';
	                        husbandId = !!params.form.person ? params.form.person.id : 0;
	                        wifeId = params.relatedToPersonId;
	                    }
	                }
	                else {
	                    if (!!params.family && params.family.wifeId > 0 && !!params.form.person &&
	                        params.family.wifeId !== params.form.person.id && params.family.husbandId === 0) {
	                        parentType = 'FATHER';
	                        husbandId = !!params.form.person ? params.form.person.id : 0;
	                        wifeId = params.relatedToPersonId;
	                    }
	                    else {
	                        parentType = 'MOTHER';
	                        husbandId = params.relatedToPersonId;
	                        wifeId = !!params.form.person ? params.form.person.id : 0;
	                    }
	                }
	                break;
	            case 'CHILD':
	            case 'SIBLING':
	                childId = !!params.form.person ? params.form.person.id : 0;
	                if (!!params.family) {
	                    husbandId = params.family.husbandId;
	                    wifeId = params.family.wifeId;
	                }
	                break;
	        }
	        // If we are adding a second parent to a single-parent, single-child family, does the two-parent family already exist?
	        if (husbandId > 0 && wifeId > 0 && !!params.family && (params.family.husbandId === 0 || params.family.wifeId === 0) &&
	            params.family.childRels.size === 1 && Array.from(params.family.childRels.keys())[0] === childId) {
	            return this.families.streamSpouses(husbandId).take(1)
	                .map(function (sfMap) {
	                var family = Array.from(sfMap.values()).find(function (family) { return family.wifeId === wifeId; });
	                if (!family) {
	                    family = params.family;
	                }
	                else {
	                    // if so, we need to delete the current family and use this one instead
	                    _this.families.del(params.family.id);
	                    _this.log.debug('personUtils.setFamily delete', params, params.family);
	                    delete params.family;
	                }
	                _this.log.debug('personUtils.setFamily', husbandId, wifeId, childId, parentType, family);
	                return Object.assign(params, { husbandId: husbandId, wifeId: wifeId, childId: childId, parentType: parentType, family: family });
	            });
	        }
	        else if (params.relationshipType === 'CHILD' && !params.family && params.relatedToPersonId > 0) {
	            return this.persons.streamId(params.relatedToPersonId).take(1).map(function (person) {
	                if (person.gender !== 'FEMALE') {
	                    husbandId = params.relatedToPersonId;
	                    parentType = 'FATHER';
	                }
	                else {
	                    wifeId = params.relatedToPersonId;
	                    parentType = 'MOTHER';
	                }
	                _this.log.debug('personUtils.setFamily', husbandId, wifeId, childId, parentType);
	                return Object.assign(params, { husbandId: husbandId, wifeId: wifeId, childId: childId, parentType: parentType });
	            });
	        }
	        else {
	            this.log.debug('personUtils.setFamily', husbandId, wifeId, childId, parentType);
	            return this.rx.Observable.of(Object.assign(params, { husbandId: husbandId, wifeId: wifeId, childId: childId, parentType: parentType }));
	        }
	    };
	    // relatedToPersonId || family
	    //setChildren(params) {
	    //  if (!!params.family) {
	    //    let childIds = Array.from(params.family.childRels.keys());
	    //    this.log.debug('personUtils.setChildren', childIds);
	    //    return this.persons.streamIds(childIds).take(1).map(m => Object.assign(params, {children: Array.from(m.values())}));
	    //  }
	    //  else if (params.relationshipType === 'FATHER' || params.relationshipType === 'MOTHER') {
	    //    this.log.debug('personUtils.setChildren', params.relatedToPersonId);
	    //    return this.persons.streamId(params.relatedToPersonId).take(1).map(person => Object.assign(params, {children: [person]}));
	    //  }
	    //  else {
	    //    return  this.rx.Observable.of(params);
	    //  }
	    //}
	    //setBirthEvidence(params) {
	    //  if (!!params.form.person) {
	    //    return this.getAvailableBirthEvidence(params.form.person, params.parentType, params.husbandId, params.wifeId).map(birthEvidence => {
	    //      this.log.debug('personUtils.setBirthEvidence', params.form.person, params.husbandId, params.wifeId, birthEvidence);
	    //      return Object.assign(params, {birthEvidence});
	    //    });
	    //  }
	    //  return  this.rx.Observable.of(params);
	    //}
	    //setChildBirthEvidenceMap(params) {
	    //  if (!!params.children && params.children.length > 0) {
	    //    this.log.debug('personUtils.setChildBirthEvidenceMap', params.children);
	    //    return  this.rx.Observable.forkJoin(...params.children.map(child => this.getAvailableBirthEvidence(child, params.parentType, params.husbandId, params.wifeId)))
	    //      .map(evidences => {
	    //        let childBirthEvidenceMap = new Map(evidences
	    //          .map((evidence, ix) => {
	    //            return [params.children[ix].id, evidence];
	    //          })
	    //          .filter(([, evidence]) => !!evidence));
	    //        this.log.debug('personUtils.setChildBirthEvidenceMap', params.children, params.husbandId, params.wifeId, childBirthEvidenceMap);
	    //        return Object.assign(params, {childBirthEvidenceMap});
	    //      });
	    //  }
	    //  return  this.rx.Observable.of(params);
	    //}
	    //getAvailableBirthEvidence(person, parentType, husbandId, wifeId) {
	    //  let births = Array.from(person.facts.values()).filter(f => f.principal && f.type === 'BIRT');
	    //  if (births.length > 0) {
	    //    let eids = [...new Set([].concat(...births.map(f => Array.from(f.evidencePersonas.keys()))))]; // flatten and unique
	    //    if (eids.length > 0) {
	    //      return this.evidences.streamIds(eids).take(1).flatMap(em => {
	    //        return this.getPersonsForEvidences(em).map(epam => {
	    //          return {em, epam};
	    //        });
	    //      }).map(({em, epam}) => {
	    //        this.log.debug('personUtils.getAvailableBirthEvidence', em, epam, husbandId, wifeId);
	    //        return Array.from(em.values()).find(e => this.isAvailableBirthEvidence(e, epam.get(e.id), parentType, husbandId, wifeId));
	    //      });
	    //    }
	    //  }
	    //  return  this.rx.Observable.of(null);
	    //}
	    //isAvailableBirthEvidence(e, pam, parentType, husbandId, wifeId) {
	    //  if (e._hasSource || e.personas.size !== 3) {
	    //    return false;
	    //  }
	    //  return !Array.from(e.personas.entries()).some(([paKey,pa]) => !!pam.get(paKey) &&
	    //  ((parentType === 'FATHER' && pa.relationshipType === 'FATHER') ||
	    //   (parentType === 'MOTHER' && pa.relationshipType === 'MOTHER') ||
	    //   (!parentType && pa.relationshipType === 'FATHER' && husbandId > 0 && pam.get(paKey).id !== husbandId) ||
	    //   (!parentType && pa.relationshipType === 'MOTHER' && wifeId > 0 && pam.get(paKey).id !== wifeId)));
	    //}
	    // return {evidence id: {persona key: person}}
	    PersonUtilsService.prototype.getPersonsForEvidences = function (em) {
	        var _this = this;
	        var eids = Array.from(em.keys());
	        return (_a = this.rx.Observable).forkJoin.apply(_a, __spread(eids.map(function (key) { return _this.persons.streamForEvidence(key).take(1); }))).map(function (pmaps) {
	            return new Map(pmaps.map(function (pmap, ix) {
	                var parr = Array.from(pmap.values());
	                var eid = eids[ix];
	                var paKeys = Array.from(em.get(eid).personas.keys());
	                return [eid, new Map(paKeys.map(function (paKey) {
	                        return [paKey, parr.find(function (p) {
	                                return Array.from(p.facts.values()).some(function (f) { return f.evidencePersonas.get(eid) === paKey; });
	                            })];
	                    }))];
	            }));
	        });
	        var _a;
	    };
	    // form.marriage, relationshipType, relatedToPersonId || family
	    PersonUtilsService.prototype.setSpouseId = function (params) {
	        var spouseId = 0;
	        if (!!params.form.marriage) {
	            if (params.relationshipType === 'SPOUSE') {
	                spouseId = params.relatedToPersonId;
	            }
	            else if (params.relationshipType === 'FATHER' && !!params.family) {
	                spouseId = params.family.wifeId;
	            }
	            else if (params.relationshipType === 'MOTHER' && !!params.family) {
	                spouseId = params.family.husbandId;
	            }
	        }
	        this.log.debug('personUtils.setSpouseId', spouseId);
	        return this.rx.Observable.of(Object.assign(params, { spouseId: spouseId }));
	    };
	    // form.marriage, spouseId, person
	    PersonUtilsService.prototype.addMarriageToSpouse = function (params) {
	        var _this = this;
	        if (!params.form.marriage || !params.spouseId || !params.person) {
	            return this.rx.Observable.of(params);
	        }
	        return this.persons.streamId(params.spouseId).take(1)
	            .flatMap(function (person) {
	            if (!!params.marriageEvidence) {
	                var p = _this.utils.clone(person);
	                var f = _this.createFact(params.form.marriage, true, true);
	                f.principalId1 = params.person.id;
	                f.evidencePersonas.set(params.marriageEvidence.id, Array.from(params.marriagePersonaMap.keys()).find(function (k) { return params.marriagePersonaMap.get(k) === params.spouseId; }));
	                var factKey = _this.utils.randomKey();
	                p.facts.set(factKey, f);
	                _this.log.debug('personUtils.addMarriageToSpouse', params.marriagePersonaMap, params.spouseId, p);
	                return _this.persons.update(p).map(function () { return params; });
	            }
	            else {
	                return _this.rx.Observable.of(params);
	            }
	        });
	    };
	    // relationshipType, person, family, husbandId, wifeId, childId
	    PersonUtilsService.prototype.postFamily = function (params) {
	        switch (params.relationshipType) {
	            case 'FATHER':
	                if (params.husbandId > 0 && params.husbandId !== params.person.id) {
	                    params.wifeId = params.person.id;
	                }
	                else {
	                    params.husbandId = params.person.id;
	                }
	                break;
	            case 'MOTHER':
	                if (params.wifeId > 0 && params.wifeId !== params.person.id) {
	                    params.husbandId = params.person.id;
	                }
	                else {
	                    params.wifeId = params.person.id;
	                }
	                break;
	            case 'SPOUSE':
	                if (params.husbandId > 0 && params.husbandId !== params.person.id) {
	                    params.wifeId = params.person.id;
	                }
	                else {
	                    params.husbandId = params.person.id;
	                }
	                break;
	            case 'CHILD':
	            case 'SIBLING':
	                params.childId = params.person.id;
	                break;
	        }
	        if (!!params.family) {
	            var f = this.utils.clone(params.family);
	            f.husbandId = f.husbandId || params.husbandId;
	            f.wifeId = f.wifeId || params.wifeId;
	            if (params.childId > 0 && !f.childRels.has(params.childId)) {
	                f.childRels.set(params.childId, { fatherRel: '', motherRel: '' });
	            }
	            this.log.debug('personUtils.postFamily update', params, f);
	            return this.mergeExistingFamily(f);
	        }
	        else {
	            var f = {
	                id: 0,
	                childRels: new Map(),
	                husbandId: undefined,
	                wifeId: undefined
	            };
	            f.husbandId = params.husbandId;
	            f.wifeId = params.wifeId;
	            if (params.childId > 0) {
	                f.childRels.set(params.childId, { fatherRel: '', motherRel: '' });
	            }
	            this.log.debug('personUtils.postFamily create', params, f);
	            return this.mergeExistingFamily(f);
	        }
	    };
	    PersonUtilsService.prototype.mergeExistingFamily = function (f) {
	        var _this = this;
	        var spouseId = f.husbandId || f.wifeId;
	        if (spouseId === 0) {
	            return f.id === 0 ? this.families.create(f) : this.families.update(f);
	        }
	        return this.families.streamSpouses(spouseId).take(1).flatMap(function (fm) {
	            var mergeFamily = Array.from(fm.values()).find(function (family) { return family.id !== f.id &&
	                ((family.husbandId === f.husbandId && family.wifeId === f.wifeId) || (family.husbandId === f.wifeId && family.wifeId === f.husbandId)); });
	            if (!!mergeFamily) {
	                var mf = _this.utils.clone(mergeFamily);
	                try {
	                    for (var _a = __values(f.childRels), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var _c = __read(_b.value, 2), k = _c[0], v = _c[1];
	                        mf.childRels.set(k, v);
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                return _this.families.update(mf).flatMap(function (family) {
	                    if (f.id > 0) {
	                        return _this.families.del(f.id).map(function () { return family; });
	                    }
	                    else {
	                        return _this.rx.Observable.of(family);
	                    }
	                });
	            }
	            else {
	                return f.id === 0 ? _this.families.create(f) : _this.families.update(f);
	            }
	            var e_1, _d;
	        });
	    };
	    // assume isPersonFact = false
	    PersonUtilsService.prototype.createFact = function (fact, isPersonFact, principal) {
	        var result = {
	            type: fact.type,
	            value: fact.value,
	            date: fact.date || '',
	            dateSort: fact.dateSort || '',
	            place: this.angularUtils.isObject(fact.place) ? fact.place.name : fact.placeText || fact.place || '',
	            placeDetails: fact.placeDetails || '',
	            placeStandard: this.angularUtils.isObject(fact.place) ? fact.place.standardName : fact.placeStandard || '',
	            latitude: this.angularUtils.isObject(fact.place) ? fact.place.latitude : fact.latitude || 0,
	            longitude: this.angularUtils.isObject(fact.place) ? fact.place.longitude : fact.longitude || 0,
	            principal: undefined,
	            evidencePersonas: undefined,
	            principalId1: undefined
	        };
	        if (isPersonFact) {
	            result.principal = principal;
	            result.evidencePersonas = new Map();
	        }
	        return result;
	    };
	    PersonUtilsService.prototype.getPersonaKey = function (evidence, relationshipType) {
	        return Array.from(evidence.personas.keys()).find(function (k) { return evidence.personas.get(k).relationshipType === relationshipType; });
	    };
	    PersonUtilsService.prototype.getDeletedEvidences = function (person) {
	        // get all names and facts for which person is a principal
	        var namesFacts = Array.from(person.names.values()).concat(Array.from(person.facts.values()).filter(function (f) { return f.principal; }));
	        // get unique evidence ids
	        var eids = __spread(new Set([].concat.apply([], __spread(namesFacts.map(function (nf) { return Array.from(nf.evidencePersonas.keys()); }))))); // flatten and unique
	        // set up evidencePersonas map
	        var evidencePersonas = new Map(eids.map(function (eid) { return [eid, namesFacts.find(function (nf) { return nf.evidencePersonas.has(eid); }).evidencePersonas.get(eid)]; }));
	        // read evidences
	        return this.evidences.streamIds(eids).take(1).map(function (em) {
	            // return evidences that don't have any other principal personas, or are a marriage
	            return Array.from(em.values()).filter(function (e) { return Array.from(e.personas.entries()).every(function (_a) {
	                var _b = __read(_a, 2), key = _b[0], pa = _b[1];
	                return !pa.principal || evidencePersonas.get(e.id) === key;
	            }) || e.fact.type === 'MARR'; });
	        });
	    };
	    //    if (parents.length === 0) {
	    //      return  this.rx.Observable.of(params);
	    //    }
	    //    return  this.rx.Observable.forkJoin(...parents.map(parent => {
	    //      let personaKey = Array.from(params.birthEvidence.personas.keys()).find(k => params.birthEvidence.personas.get(k).relationshipType === parent.relationship);
	    //      return this.addBirthToParent(params.birthEvidence, personaKey, parent.id, params.person.id);
	    //    })).map(() => params);
	    PersonUtilsService.prototype.merge = function (person, mergePerson) {
	        var _this = this;
	        // move all notes from mergePerson to person
	        return this.notes.streamForPerson(mergePerson.id).take(1).flatMap(function (m) {
	            var arr = Array.from(m.values());
	            if (arr.length === 0) {
	                return _this.rx.Observable.of(true);
	            }
	            return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(arr.map(function (n) {
	                n.personIds.delete(mergePerson.id);
	                n.personIds.set(person.id, true);
	                return _this.notes.update(n);
	            })));
	            var _a;
	        }).flatMap(function () {
	            // move all stories from mergePerson to person
	            return _this.stories.streamForPerson(mergePerson.id).take(1).flatMap(function (m) {
	                var arr = Array.from(m.values());
	                if (arr.length === 0) {
	                    return _this.rx.Observable.of(true);
	                }
	                return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(arr.map(function (s) {
	                    s.personIds.delete(mergePerson.id);
	                    s.personIds.set(person.id, true);
	                    return _this.stories.update(s);
	                })));
	                var _a;
	            });
	        }).flatMap(function () {
	            // move all medias from mergePerson to person
	            return _this.medias.streamForPerson(mergePerson.id).take(1).flatMap(function (m) {
	                var arr = Array.from(m.values());
	                if (arr.length === 0) {
	                    return _this.rx.Observable.of(true);
	                }
	                return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(arr.map(function (m) {
	                    m.personIds.delete(mergePerson.id);
	                    m.personIds.set(person.id, true);
	                    return _this.medias.update(m);
	                })));
	                var _a;
	            });
	        }).flatMap(function () {
	            // move spouse families from mergePerson to person
	            return _this.rx.Observable.combineLatest(_this.families.streamSpouses(mergePerson.id), _this.families.streamSpouses(person.id)).take(1).flatMap(function (_a) {
	                var _b = __read(_a, 2), mfm = _b[0], fm = _b[1];
	                var arr = Array.from(mfm.values());
	                if (arr.length === 0) {
	                    return _this.rx.Observable.of(true);
	                }
	                return (_c = _this.rx.Observable).forkJoin.apply(_c, __spread(arr.map(function (mf) {
	                    mf = _this.utils.clone(mf);
	                    if (mf.husbandId === mergePerson.id) {
	                        // don't add if person is a wife or child
	                        if (mf.wifeId === person.id || mf.childRels.has(person.id)) {
	                            mf.husbandId = 0;
	                        }
	                        else {
	                            mf.husbandId = person.id;
	                        }
	                    }
	                    if (mf.wifeId === mergePerson.id) {
	                        // don't add if person is a husband or child
	                        if (mf.husbandId === person.id || mf.childRels.has(person.id)) {
	                            mf.wifeId = 0;
	                        }
	                        else {
	                            mf.wifeId = person.id;
	                        }
	                    }
	                    // if this matches an existing family on person, move the children over and delete
	                    var found = null;
	                    try {
	                        for (var _a = __values(fm.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                            var f = _b.value;
	                            if (f.id !== mf.id && f.husbandId === mf.husbandId && f.wifeId === mf.wifeId) {
	                                found = f;
	                                break;
	                            }
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                    if (!!found) {
	                        mf.childRels.forEach(function (v, k) {
	                            if (!found.childRels.has(k)) {
	                                found.childRels.set(k, v);
	                            }
	                        });
	                        return _this.families.update(found).flatMap(function () {
	                            return _this.families.del(mf.id);
	                        });
	                    }
	                    else {
	                        return _this.families.update(mf);
	                    }
	                    var e_2, _c;
	                })));
	                var _c;
	            });
	        }).flatMap(function () {
	            // move parent families from mergePerson to person
	            return _this.families.streamParents(mergePerson.id).take(1).flatMap(function (m) {
	                var arr = Array.from(m.values());
	                if (arr.length === 0) {
	                    return _this.rx.Observable.of(true);
	                }
	                return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(arr.map(function (f) {
	                    var cr = f.childRels.get(mergePerson.id);
	                    f.childRels.delete(mergePerson.id);
	                    // don't add if already exists, or is a parent
	                    if (!f.childRels.has(person.id) && f.husbandId !== person.id && f.wifeId !== person.id) {
	                        f.childRels.set(person.id, cr);
	                    }
	                    return _this.families.update(f);
	                })));
	                var _a;
	            });
	        }).flatMap(function () {
	            return _this.evidenceUtils.removeNamesFactsPidFromPersons([], [], mergePerson.id, person.id);
	        }).flatMap(function () {
	            try {
	                // move all facts and names from mergePerson to person
	                for (var _a = __values(mergePerson.facts.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var fact = _b.value;
	                    person.facts.set(_this.utils.randomKey(), fact);
	                }
	            }
	            catch (e_3_1) { e_3 = { error: e_3_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                }
	                finally { if (e_3) throw e_3.error; }
	            }
	            try {
	                for (var _d = __values(mergePerson.names.values()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                    var name_1 = _e.value;
	                    person.names.set(_this.utils.randomKey(), name_1);
	                }
	            }
	            catch (e_4_1) { e_4 = { error: e_4_1 }; }
	            finally {
	                try {
	                    if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
	                }
	                finally { if (e_4) throw e_4.error; }
	            }
	            return _this.persons.update(person);
	            var e_3, _c, e_4, _f;
	        }).flatMap(function () {
	            // update dna kits
	            return _this.dnaKits.stream().take(1).flatMap(function (kitMap) {
	                var updates = [];
	                try {
	                    for (var _a = __values(kitMap.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var kit = _b.value;
	                        if (kit.personId1 === mergePerson.id || kit.personId2 === mergePerson.id) {
	                            kit = _this.utils.clone(kit);
	                            if (kit.personId1 === mergePerson.id) {
	                                kit.personId1 = person.id;
	                            }
	                            if (kit.personId2 === mergePerson.id) {
	                                kit.personId2 = person.id;
	                            }
	                            updates.push(kit);
	                        }
	                    }
	                }
	                catch (e_5_1) { e_5 = { error: e_5_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                    }
	                    finally { if (e_5) throw e_5.error; }
	                }
	                if (updates.length === 0) {
	                    return _this.rx.Observable.of(true);
	                }
	                return (_d = _this.rx.Observable).forkJoin.apply(_d, __spread(updates.map(function (kit) {
	                    return _this.dnaKits.update(kit);
	                })));
	                var e_5, _c, _d;
	            });
	        }).flatMap(function () {
	            // delete mergePerson
	            return _this.persons.del(mergePerson.id);
	        });
	    };
	    PersonUtilsService.prototype.moveEvidence = function (pid, eid, sourceKey, targetKey) {
	        var _this = this;
	        return this.persons.streamId(pid).take(1)
	            .flatMap(function (person) {
	            var sourceFact = person.facts.get(sourceKey);
	            var targetFact = person.facts.get(targetKey);
	            var personaKey = sourceFact.evidencePersonas.get(eid);
	            sourceFact.evidencePersonas.delete(eid);
	            targetFact.evidencePersonas.set(eid, personaKey);
	            return _this.persons.update(person);
	        });
	    };
	    return PersonUtilsService;
	}());
	exports.PersonUtilsService = PersonUtilsService;
	exports.default = PersonUtilsService;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var places_service_1 = __webpack_require__(253);
	var PlacesService = /** @class */ (function (_super) {
	    __extends(PlacesService, _super);
	    PlacesService.$inject = ["$log", "messageBus", "rx", "server"];
	    function PlacesService($log, messageBus, rx, server) {
	        'ngInject';
	        return _super.call(this, rx, messageBus, server) || this;
	    }
	    return PlacesService;
	}(places_service_1.PlacesService));
	exports.default = PlacesService;
	// class PlacesService {
	//   constructor($log, messageBus, rx, server) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.messageBus = messageBus;
	//     this.rx = rx;
	//     this.server = server;
	//     this.cache = new Map();
	//   }
	//   autocomplete(prefix) {
	//     return this.server.get('/places', {prefix})
	//       .catch(err => {
	//         this.messageBus.post({msg: err.data, status: err.status, op: 'GET', ctx: 'places/autocomplete'});
	//         return this.rx.Observable.of([]);
	//       })
	//       .toPromise();
	//   }
	//   standardize(text) {
	//     if (!text) {
	//       return this.rx.Observable.of({});
	//     }
	//     if (this.cache.has(text)) {
	//       return this.rx.Observable.of(this.cache.get(text));
	//     }
	//     return this.server.get('/places', {text})
	//       .do(result => {
	//         this.cache.set(text, result);
	//       })
	//       .catch(err => {
	//         this.messageBus.post({msg: err.data, status: err.status, op: 'GET', ctx: 'places/standardize'});
	//         return this.rx.Observable.of({});
	//       });
	//   }
	// }
	// export default PlacesService;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Observable } from "../../node_modules/rxjs";
	var PlacesService = /** @class */ (function () {
	    function PlacesService(rx, messageBus, server) {
	        this.rx = rx;
	        this.messageBus = messageBus;
	        this.server = server;
	        this.cache = new Map();
	    }
	    PlacesService.prototype.autocomplete = function (prefix) {
	        var _this = this;
	        return this.server.get('/places', { prefix: prefix })
	            .catch(function (err) {
	            _this.messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'places/autocomplete' });
	            return _this.rx.Observable.of([]);
	        })
	            .toPromise();
	    };
	    PlacesService.prototype.standardize = function (text) {
	        var _this = this;
	        if (!text) {
	            return this.rx.Observable.of({});
	        }
	        if (this.cache.has(text)) {
	            return this.rx.Observable.of(this.cache.get(text));
	        }
	        return this.server.get('/places', { text: text })
	            .do(function (result) {
	            _this.cache.set(text, result);
	        })
	            .catch(function (err) {
	            _this.messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'places/standardize' });
	            return _this.rx.Observable.of({});
	        });
	    };
	    return PlacesService;
	}());
	exports.PlacesService = PlacesService;


/***/ }),
/* 254 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2019
	 */
	var RelationshipUtilsService = /** @class */ (function () {
	    RelationshipUtilsService.$inject = ["$log", "families", "utils"];
	    function RelationshipUtilsService($log, families, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.families = families;
	        this.utils = utils;
	    }
	    RelationshipUtilsService.prototype.getRelationship = function (pid1, pid2, parentsMap) {
	        var anc1 = new Map([[pid1, 0]]);
	        var anc2 = new Map([[pid2, 0]]);
	        var parentsMap = this.families.getParentsMap();
	        var gen = 0;
	        var overlap = null;
	        while (gen <= 10) {
	            overlap = this._getOverlap(anc1, anc2);
	            if (!!overlap) {
	                break;
	            }
	            this._addParents(anc1, gen, parentsMap);
	            this._addParents(anc2, gen, parentsMap);
	            gen++;
	        }
	        // calculate relationship
	        return this._calcRelationship(overlap);
	    };
	    RelationshipUtilsService.prototype._getOverlap = function (anc1, anc2) {
	        var minTotalGens = 9999;
	        var overlapGen1 = 0;
	        var overlapGen2 = 0;
	        var overlapCount = 0;
	        try {
	            for (var _a = __values(anc1.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var pid1 = _b.value;
	                try {
	                    for (var _c = __values(anc2.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                        var pid2 = _d.value;
	                        if (pid1 === pid2) {
	                            var totalGens = anc1.get(pid1) + anc2.get(pid2);
	                            if (totalGens < minTotalGens) {
	                                minTotalGens = totalGens;
	                                overlapGen1 = anc1.get(pid1);
	                                overlapGen2 = anc2.get(pid2);
	                                overlapCount = 1;
	                            }
	                            else if (totalGens == minTotalGens && anc1.get(pid1) === overlapGen1 && anc2.get(pid2) === overlapGen2) {
	                                overlapCount++;
	                            }
	                        }
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_f = _a.return)) _f.call(_a);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        return minTotalGens === 9999 ? null : {
	            g1: overlapGen1,
	            g2: overlapGen2,
	            cnt: overlapCount
	        };
	        var e_2, _f, e_1, _e;
	    };
	    RelationshipUtilsService.prototype._addParents = function (anc, gen, parentsMap) {
	        try {
	            for (var _a = __values(anc.entries()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var _c = __read(_b.value, 2), pid = _c[0], ancGen = _c[1];
	                if (ancGen === gen) {
	                    var parentFamilies = parentsMap.get(pid) || new Map();
	                    try {
	                        for (var _d = __values(parentFamilies.values()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                            var family = _e.value;
	                            if (family.husbandId > 0) {
	                                anc.set(family.husbandId, gen + 1);
	                            }
	                            if (family.wifeId > 0) {
	                                anc.set(family.wifeId, gen + 1);
	                            }
	                        }
	                    }
	                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                    finally {
	                        try {
	                            if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
	                        }
	                        finally { if (e_3) throw e_3.error; }
	                    }
	                }
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_g = _a.return)) _g.call(_a);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        var e_4, _g, e_3, _f;
	    };
	    RelationshipUtilsService.prototype._calcRelationship = function (o) {
	        if (!o) {
	            return 'Other';
	        }
	        if (o.g1 === 0 && o.g2 === 0) {
	            return 'Self';
	        }
	        else if (o.g1 === 1 && o.g2 === 1 && o.cnt >= 2) {
	            return 'Sibling';
	        }
	        else if (o.g1 === 1 && o.g2 === 1 && o.cnt === 1) {
	            return 'Half Sibling';
	        }
	        else if (o.g1 === 1 && o.g2 === 0) {
	            return 'Parent';
	        }
	        else if (o.g1 === 2 && o.g2 === 0) {
	            return 'Grandparent';
	        }
	        else if (o.g1 === 3 && o.g2 === 0) {
	            return 'Great Grandparent';
	        }
	        else if (o.g1 === 4 && o.g2 === 0) {
	            return 'GG Grandparent';
	        }
	        else if (o.g1 === 5 && o.g2 === 0) {
	            return 'GGG Grandparent';
	        }
	        else if (o.g1 === 6 && o.g2 === 0) {
	            return 'GGGG Grandparent';
	        }
	        else if (o.g1 === 0 && o.g2 === 1) {
	            return 'Child';
	        }
	        else if (o.g1 === 0 && o.g2 === 2) {
	            return 'Grandchild';
	        }
	        else if (o.g1 === 0 && o.g2 === 3) {
	            return 'Great Grandchild';
	        }
	        else if (o.g1 === 0 && o.g2 === 4) {
	            return 'GG Grandchild';
	        }
	        else if (o.g1 === 0 && o.g2 === 5) {
	            return 'GGG Grandchild';
	        }
	        else if (o.g1 === 0 && o.g2 === 6) {
	            return 'GGGG Grandchild';
	        }
	        else if (o.g1 === 2 && o.g2 === 1 && o.cnt >= 2) {
	            return 'Aunt/Uncle';
	        }
	        else if (o.g1 === 2 && o.g2 === 1 && o.cnt === 1) {
	            return 'Half Aunt/Uncle';
	        }
	        else if (o.g1 === 3 && o.g2 === 1 && o.cnt >= 2) {
	            return 'Great Aunt/Uncle';
	        }
	        else if (o.g1 === 3 && o.g2 === 1 && o.cnt === 1) {
	            return 'Half Great Aunt/Uncle';
	        }
	        else if (o.g1 === 4 && o.g2 === 1 && o.cnt >= 2) {
	            return 'GG Aunt/Uncle';
	        }
	        else if (o.g1 === 4 && o.g2 === 1 && o.cnt === 1) {
	            return 'Half GG Aunt/Uncle';
	        }
	        else if (o.g1 === 5 && o.g2 === 1 && o.cnt >= 2) {
	            return 'GGG Aunt/Uncle';
	        }
	        else if (o.g1 === 5 && o.g2 === 1 && o.cnt === 1) {
	            return 'Half GGG Aunt/Uncle';
	        }
	        else if (o.g1 === 6 && o.g2 === 1 && o.cnt >= 2) {
	            return 'GGGG Aunt/Uncle';
	        }
	        else if (o.g1 === 6 && o.g2 === 1 && o.cnt === 1) {
	            return 'Half GGGG Aunt/Uncle';
	        }
	        else if (o.g1 === 1 && o.g2 === 2 && o.cnt >= 2) {
	            return 'Niece/Nephew';
	        }
	        else if (o.g1 === 1 && o.g2 === 2 && o.cnt === 1) {
	            return 'Half Niece/Nephew';
	        }
	        else if (o.g1 === 1 && o.g2 === 3 && o.cnt >= 2) {
	            return 'Great Niece/Nephew';
	        }
	        else if (o.g1 === 1 && o.g2 === 3 && o.cnt === 1) {
	            return 'Half Great Niece/Nephew';
	        }
	        else if (o.g1 === 1 && o.g2 === 4 && o.cnt >= 2) {
	            return 'GG Niece/Nephew';
	        }
	        else if (o.g1 === 1 && o.g2 === 4 && o.cnt === 1) {
	            return 'Half GG Niece/Nephew';
	        }
	        else if (o.g1 === 1 && o.g2 === 5 && o.cnt >= 2) {
	            return 'GGG Niece/Nephew';
	        }
	        else if (o.g1 === 1 && o.g2 === 5 && o.cnt === 1) {
	            return 'Half GGG Niece/Nephew';
	        }
	        else if (o.g1 === 1 && o.g2 === 6 && o.cnt >= 2) {
	            return 'GGGG Niece/Nephew';
	        }
	        else if (o.g1 === 1 && o.g2 === 6 && o.cnt === 1) {
	            return 'Half GGGG Niece/Nephew';
	        }
	        else if (o.g1 === 2 && o.g2 === 2 && o.cnt >= 2) {
	            return 'Cousin';
	        }
	        else if (o.g1 === 2 && o.g2 === 2 && o.cnt === 1) {
	            return 'Half Cousin';
	        }
	        else if (((o.g1 === 2 && o.g2 === 3) || (o.g1 === 3 && o.g2 === 2)) && o.cnt >= 2) {
	            return 'Cousin 1R';
	        }
	        else if (((o.g1 === 2 && o.g2 === 3) || (o.g1 === 3 && o.g2 === 2)) && o.cnt === 1) {
	            return 'Half Cousin 1R';
	        }
	        else if (((o.g1 === 2 && o.g2 === 4) || (o.g1 === 4 && o.g2 === 2)) && o.cnt >= 2) {
	            return 'Cousin 2R';
	        }
	        else if (((o.g1 === 2 && o.g2 === 4) || (o.g1 === 4 && o.g2 === 2)) && o.cnt === 1) {
	            return 'Half Cousin 2R';
	        }
	        else if (((o.g1 === 2 && o.g2 === 5) || (o.g1 === 5 && o.g2 === 2)) && o.cnt >= 2) {
	            return 'Cousin 3R';
	        }
	        else if (((o.g1 === 2 && o.g2 === 5) || (o.g1 === 5 && o.g2 === 2)) && o.cnt === 1) {
	            return 'Half Cousin 3R';
	        }
	        else if (o.g1 === 3 && o.g2 === 3 && o.cnt >= 2) {
	            return '2nd Cousin';
	        }
	        else if (o.g1 === 3 && o.g2 === 3 && o.cnt === 1) {
	            return 'Half 2nd Cousin';
	        }
	        else if (((o.g1 === 3 && o.g2 === 4) || (o.g1 === 4 && o.g2 === 3)) && o.cnt >= 2) {
	            return '2nd Cousin 1R';
	        }
	        else if (((o.g1 === 3 && o.g2 === 4) || (o.g1 === 4 && o.g2 === 3)) && o.cnt === 1) {
	            return 'Half 2nd Cousin 1R';
	        }
	        else if (((o.g1 === 3 && o.g2 === 5) || (o.g1 === 5 && o.g2 === 3)) && o.cnt >= 2) {
	            return '2nd Cousin 2R';
	        }
	        else if (((o.g1 === 3 && o.g2 === 5) || (o.g1 === 5 && o.g2 === 3)) && o.cnt === 1) {
	            return 'Half 2nd Cousin 2R';
	        }
	        else if (((o.g1 === 3 && o.g2 === 6) || (o.g1 === 6 && o.g2 === 3)) && o.cnt >= 2) {
	            return '2nd Cousin 3R';
	        }
	        else if (((o.g1 === 3 && o.g2 === 6) || (o.g1 === 6 && o.g2 === 3)) && o.cnt === 1) {
	            return 'Half 2nd Cousin 3R';
	        }
	        else if (o.g1 === 4 && o.g2 === 4 && o.cnt >= 2) {
	            return '3rd Cousin';
	        }
	        else if (o.g1 === 4 && o.g2 === 4 && o.cnt === 1) {
	            return 'Half 3rd Cousin';
	        }
	        else if (((o.g1 === 4 && o.g2 === 5) || (o.g1 === 5 && o.g2 === 4)) && o.cnt >= 2) {
	            return '3rd Cousin 1R';
	        }
	        else if (((o.g1 === 4 && o.g2 === 5) || (o.g1 === 5 && o.g2 === 4)) && o.cnt === 1) {
	            return 'Half 3rd Cousin 1R';
	        }
	        else if (((o.g1 === 4 && o.g2 === 6) || (o.g1 === 6 && o.g2 === 4)) && o.cnt >= 2) {
	            return '3rd Cousin 2R';
	        }
	        else if (((o.g1 === 4 && o.g2 === 6) || (o.g1 === 6 && o.g2 === 4)) && o.cnt === 1) {
	            return 'Half 3rd Cousin 2R';
	        }
	        else if (((o.g1 === 4 && o.g2 === 7) || (o.g1 === 7 && o.g2 === 4)) && o.cnt >= 2) {
	            return '3rd Cousin 3R';
	        }
	        else if (((o.g1 === 4 && o.g2 === 7) || (o.g1 === 7 && o.g2 === 4)) && o.cnt === 1) {
	            return 'Half 3rd Cousin 3R';
	        }
	        else if (o.g1 === 5 && o.g2 === 5 && o.cnt >= 2) {
	            return '4th Cousin';
	        }
	        else if (o.g1 === 5 && o.g2 === 5 && o.cnt === 1) {
	            return 'Half 4th Cousin';
	        }
	        else if (((o.g1 === 5 && o.g2 === 6) || (o.g1 === 6 && o.g2 === 5)) && o.cnt >= 2) {
	            return '4th Cousin 1R';
	        }
	        else if (((o.g1 === 5 && o.g2 === 6) || (o.g1 === 6 && o.g2 === 5)) && o.cnt === 1) {
	            return 'Half 4th Cousin 1R';
	        }
	        else if (((o.g1 === 5 && o.g2 === 7) || (o.g1 === 7 && o.g2 === 5)) && o.cnt >= 2) {
	            return '4th Cousin 2R';
	        }
	        else if (((o.g1 === 5 && o.g2 === 7) || (o.g1 === 7 && o.g2 === 5)) && o.cnt === 1) {
	            return 'Half 4th Cousin 2R';
	        }
	        else if (((o.g1 === 5 && o.g2 === 8) || (o.g1 === 8 && o.g2 === 5)) && o.cnt >= 2) {
	            return '4th Cousin 3R';
	        }
	        else if (((o.g1 === 5 && o.g2 === 8) || (o.g1 === 8 && o.g2 === 5)) && o.cnt === 1) {
	            return 'Half 4th Cousin 3R';
	        }
	        else if (o.g1 === 6 && o.g2 === 6 && o.cnt >= 2) {
	            return '5th Cousin';
	        }
	        else if (o.g1 === 6 && o.g2 === 6 && o.cnt === 1) {
	            return 'Half 5th Cousin';
	        }
	        else if (((o.g1 === 6 && o.g2 === 7) || (o.g1 === 7 && o.g2 === 6)) && o.cnt >= 2) {
	            return '5th Cousin 1R';
	        }
	        else if (((o.g1 === 6 && o.g2 === 7) || (o.g1 === 7 && o.g2 === 6)) && o.cnt === 1) {
	            return 'Half 5th Cousin 1R';
	        }
	        else if (((o.g1 === 6 && o.g2 === 8) || (o.g1 === 8 && o.g2 === 6)) && o.cnt >= 2) {
	            return '5th Cousin 2R';
	        }
	        else if (((o.g1 === 6 && o.g2 === 8) || (o.g1 === 8 && o.g2 === 6)) && o.cnt === 1) {
	            return 'Half 5th Cousin 2R';
	        }
	        else if (((o.g1 === 6 && o.g2 === 9) || (o.g1 === 9 && o.g2 === 6)) && o.cnt >= 2) {
	            return '5th Cousin 3R';
	        }
	        else if (((o.g1 === 6 && o.g2 === 9) || (o.g1 === 9 && o.g2 === 6)) && o.cnt === 1) {
	            return 'Half 5th Cousin 3R';
	        }
	        else {
	            return 'Other';
	        }
	    };
	    RelationshipUtilsService.prototype.getSharedCMInfo = function (relationship) {
	        switch (relationship) {
	            //case 'Self':
	            case 'Sibling':
	                return { avg: 2629, range: '2209 - 3384' };
	            case 'Half Sibling':
	                return { avg: 1783, range: '1317 - 2312' };
	            case 'Parent':
	                return { avg: 3487, range: '3330 - 3720' };
	            case 'Grandparent':
	                return { avg: 1766, range: '1156 - 2311' };
	            case 'Great Grandparent':
	                return { avg: 881, range: '464 - 1486' };
	            //case 'GG Grandparent':
	            //case 'GGG Grandparent':
	            //case 'GGGG Grandparent':
	            case 'Child':
	                return { avg: 3487, range: '3330 - 3720' };
	            case 'Grandchild':
	                return { avg: 1766, range: '1156 - 2311' };
	            case 'Great Grandchild':
	                return { avg: 881, range: '464 - 1486' };
	            //case 'GG Grandchild':
	            //case 'GGG Grandchild':
	            //case 'GGGG Grandchild':
	            case 'Aunt/Uncle':
	                return { avg: 1750, range: '1349 - 2175' };
	            case 'Half Aunt/Uncle':
	                return { avg: 891, range: '500 - 1446' };
	            case 'Great Aunt/Uncle':
	                return { avg: 914, range: '251 - 2108' };
	            case 'Half Great Aunt/Uncle':
	                return { avg: 432, range: '125 - 765' };
	            case 'GG Aunt/Uncle':
	                return { avg: 427, range: '191 - 885' };
	            case 'Half GG Aunt/Uncle':
	                return { avg: 187, range: '12 - 383' };
	            //case 'GGG Aunt/Uncle':
	            //case 'Half GGG Aunt/Uncle':
	            //case 'GGGG Aunt/Uncle':
	            //case 'Half GGGG Aunt/Uncle':
	            case 'Niece/Nephew':
	                return { avg: 1750, range: '1349 - 2175' };
	            case 'Half Niece/Nephew':
	                return { avg: 891, range: '500 - 1446' };
	            case 'Great Niece/Nephew':
	                return { avg: 910, range: '251 - 2108' };
	            case 'Half Great Niece/Nephew':
	                return { avg: 432, range: '125 - 765' };
	            case 'GG Niece/Nephew':
	                return { avg: 427, range: '191 - 885' };
	            case 'Half GG Niece/Nephew':
	                return { avg: 187, range: '12 - 383' };
	            //case 'GGG Niece/Nephew':
	            //case 'Half GGG Niece/Nephew':
	            //case 'GGGG Niece/Nephew':
	            //case 'Half GGGG Niece/Nephew':
	            case 'Cousin':
	                return { avg: 874, range: '553 - 1225' };
	            case 'Half Cousin':
	                return { avg: 457, range: '137 - 856' };
	            case 'Cousin 1R':
	                return { avg: 439, range: '141 - 851' };
	            case 'Half Cousin 1R':
	                return { avg: 226, range: '57 - 530' };
	            case 'Cousin 2R':
	                return { avg: 229, range: '43 - 531' };
	            case 'Half Cousin 2R':
	                return { avg: 145, range: '37 - 360' };
	            case 'Cousin 3R':
	                return { avg: 123, range: '0 - 283' };
	            case 'Half Cousin 3R':
	                return { avg: 87, range: '0 - 191' };
	            case '2nd Cousin':
	                return { avg: 233, range: '46 - 515' };
	            case 'Half 2nd Cousin':
	                return { avg: 117, range: '9 - 397' };
	            case '2nd Cousin 1R':
	                return { avg: 123, range: '0 - 316' };
	            case 'Half 2nd Cousin 1R':
	                return { avg: 73, range: '0 - 341' };
	            case '2nd Cousin 2R':
	                return { avg: 74, range: '0 - 261' };
	            case 'Half 2nd Cousin 2R':
	                return { avg: 61, range: '0 - 353' };
	            case '2nd Cousin 3R':
	                return { avg: 57, range: '0 - 139' };
	            //case 'Half 2nd Cousin 3R':
	            case '3rd Cousin':
	                return { avg: 74, range: '0 - 217' };
	            case 'Half 3rd Cousin':
	                return { avg: 61, range: '0 - 178' };
	            case '3rd Cousin 1R':
	                return { avg: 48, range: '0 - 173' };
	            case 'Half 3rd Cousin 1R':
	                return { avg: 42, range: '0 - 165' };
	            case '3rd Cousin 2R':
	                return { avg: 35, range: '0 - 116' };
	            case 'Half 3rd Cousin 2R':
	                return { avg: 34, range: '0 - 96' };
	            case '3rd Cousin 3R':
	                return { avg: 22, range: '0 - 69' };
	            //case 'Half 3rd Cousin 3R':
	            case '4th Cousin':
	                return { avg: 35, range: '0 - 127' };
	            //case 'Half 4th Cousin':
	            case '4th Cousin 1R':
	                return { avg: 28, range: '0 - 117' };
	            //case 'Half 4th Cousin 1R':
	            case '4th Cousin 2R':
	                return { avg: 22, range: '0 - 109' };
	            //case 'Half 4th Cousin 2R':
	            case '4th Cousin 3R':
	                return { avg: 29, range: '0 - 82' };
	            //case 'Half 4th Cousin 3R':
	            case '5th Cousin':
	                return { avg: 25, range: '0 - 94' };
	            //case 'Half 5th Cousin':
	            case '5th Cousin 1R':
	                return { avg: 21, range: '0 - 79' };
	            //case 'Half 5th Cousin 1R':
	            case '5th Cousin 2R':
	                return { avg: 17, range: '0 - 43' };
	            //case 'Half 5th Cousin 2R':
	            case '5th Cousin 3R':
	                return { avg: 11, range: '0 - 44' };
	            //case 'Half 5th Cousin 3R':
	            default:
	                return null;
	        }
	    };
	    return RelationshipUtilsService;
	}());
	exports.default = RelationshipUtilsService;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var ReportsPedigreeService = /** @class */ (function () {
	    ReportsPedigreeService.$inject = ["$log", "$window", "rx"];
	    function ReportsPedigreeService($log, $window, rx) {
	        'ngInject';
	        this.$log = $log;
	        this.$window = $window;
	        this.rx = rx;
	    }
	    ReportsPedigreeService.prototype.create = function (jsPDF, rootPerson, families, persons, utils, endNotes, indexOfNames, indexOfPlaces, numGenerations, personMap, familyMap, evidenceMap, sourceMap) {
	        var readySubject = new this.rx.AsyncSubject();
	        this.utils = utils;
	        this.doc = new jsPDF();
	        this.maxX = 200;
	        this.x = 20;
	        this.y = 20;
	        this.pageNumber = 1;
	        this.fromPage = 1;
	        this.deltaY = 5;
	        this.deltaYUnderline = 1;
	        this.deltaX = 6;
	        this.yFooter = 270;
	        this.people = [];
	        this.rootIndex = 0;
	        this.pending = [];
	        this.endNotes = [];
	        this.namesIndex = [];
	        this.placesIndex = [];
	        this.numGenerations = numGenerations;
	        this.nextPage = 2;
	        this.genOffset = 0;
	        this.genOffset = 0;
	        var root = rootPerson.id;
	        var doc = this.doc;
	        //let root = parseInt(tu.getIn(['preferences', 'ROOT'], '0'), 10);
	        //$log.debug("root ", root);
	        this.personMap = personMap;
	        //this.$log.debug("familyMap", familyMap);
	        this.familyMap = familyMap;
	        //$log.debug("READYchangeEvidenceMap", "before evidenceMap");
	        this.evidenceMap = evidenceMap;
	        this.sourceMap = sourceMap;
	        //$log.debug("READYchangeEvidenceMap", evidenceMap);
	        this.people = this.getTree(families, root);
	        this.utils = utils;
	        var txt1 = 'Pedigree chart - ';
	        var nf = persons.getDefaultNameForm(persons.getPreferredName(this.people[0]));
	        var fullName = persons.getNameText(nf, false);
	        txt1 = txt1.concat(fullName);
	        var reportName = txt1;
	        var txt2 = this.today();
	        this.FirstPage = true;
	        ////this.$log.debug("familyMap",this.familyMap);
	        this.printTree(persons, txt1, txt2, utils, this.genOffset);
	        this.FirstPage = false;
	        while (this.pending.length > 0) {
	            var aux = this.pending.splice(0, 1)[0];
	            root = aux.root;
	            this.rootIndex = aux.i;
	            this.fromPage = aux.fromPage;
	            this.genOffset = aux.genOffset;
	            this.people = this.getTree(families, root);
	            this.printTree(persons, txt1, txt2, utils);
	        }
	        if (this.endNotes.length > 0) {
	            doc.addPage();
	            this.pageNumber++;
	            txt1 = 'Endnotes';
	            this.printHeader(txt1, txt2);
	            this.printFooter();
	            endNotes.setDoc(this.doc);
	            endNotes.setX(this.x);
	            endNotes.setY(this.y);
	            endNotes.setMaxX(this.maxX);
	            endNotes.setyFooter(this.yFooter);
	            endNotes.setDeltaY(this.deltaY);
	            endNotes.setDeltaYUnderline(this.deltaYUnderline);
	            endNotes.setDeltaX(this.deltaX);
	            endNotes.setPageNumber(this.pageNumber);
	            endNotes.setEndNotes(this.endNotes);
	            endNotes.printNotes();
	            this.pageNumber = endNotes.getPageNumber();
	        }
	        doc.addPage();
	        this.pageNumber++;
	        txt1 = 'Index of Names';
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        indexOfNames.setDoc(this.doc);
	        indexOfNames.setX(this.x);
	        indexOfNames.setY(this.y);
	        indexOfNames.setDeltaY(this.deltaY);
	        indexOfNames.setDeltaYUnderline(this.deltaYUnderline);
	        indexOfNames.setDeltaX(this.deltaX);
	        indexOfNames.setPageNumber(this.pageNumber);
	        indexOfNames.setNamesIndex(this.namesIndex);
	        indexOfNames.printNames();
	        this.pageNumber = indexOfNames.getPageNumber();
	        doc.addPage();
	        this.pageNumber++;
	        txt1 = 'Index of Places';
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        indexOfPlaces.setDoc(this.doc);
	        indexOfPlaces.setX(this.x);
	        indexOfPlaces.setY(this.y);
	        indexOfPlaces.setDeltaY(this.deltaY);
	        indexOfPlaces.setDeltaYUnderline(this.deltaYUnderline);
	        indexOfPlaces.setDeltaX(this.deltaX);
	        indexOfPlaces.setPageNumber(this.pageNumber);
	        indexOfPlaces.setPlacesIndex(this.placesIndex);
	        indexOfPlaces.printPlaces();
	        //this.$window.open((this.$window.URL || this.$window.webkitURL).createObjectURL(doc.output('blob')));
	        var blob = doc.output('blob');
	        //if (this.$window.navigator && this.$window.navigator.msSaveOrOpenBlob) {
	        //  this.$window.navigator.msSaveOrOpenBlob(blob);
	        //}
	        //else {
	        //  //var objectUrl = URL.createObjectURL(blob);
	        //  this.$window.open((this.$window.URL || this.$window.webkitURL).createObjectURL(blob));
	        //}
	        readySubject.next({ blob: blob, name: reportName, ext: 'pdf' });
	        readySubject.complete();
	        return readySubject;
	    };
	    ReportsPedigreeService.prototype.today = function () {
	        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	        var date = new Date();
	        var _date = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
	        return _date;
	    };
	    ReportsPedigreeService.prototype.insertionSort = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = new Array();
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	        }
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            j = i - 1;
	            while (j >= 0 && first.key < copia[j].key) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        return (copia);
	    };
	    ReportsPedigreeService.prototype.increaseY = function (y, deltaY, doc) {
	        y += deltaY;
	        if (y >= this.yFooter) {
	            y = 20;
	            doc.addPage();
	            this.pageNumber++;
	        }
	        return y;
	    };
	    ReportsPedigreeService.prototype.logarithm = function (n) {
	        var base = Math.log(2);
	        var exp = Math.log(n);
	        var result = exp / base;
	        return result;
	    };
	    ReportsPedigreeService.prototype.getTree = function (families, root) {
	        var personMap = this.personMap;
	        var familyMap = this.familyMap;
	        var _queue = new Array();
	        var solution = new Array();
	        var generation = 0;
	        var u = 0;
	        var i = 0;
	        var _node = 0;
	        _queue.push({ p: root, pos: 1 });
	        while ((_queue.length > 0) && (i < 32)) {
	            _node = _queue.splice(0, 1)[0];
	            i = _node.pos;
	            u = _node.p;
	            generation = this.logarithm(i) + this.genOffset;
	            //$log.debug("log", this.logarithm(i));
	            //$log.debug("genOffset", this.genOffset);
	            //$log.debug("generation", generation);
	            //$log.debug("numGenerations", this.numGenerations);
	            if (generation >= this.numGenerations) {
	                //$log.debug("stop Generation", "STOP");
	                //$log.debug("solution", solution);
	                break;
	            }
	            var person = personMap.get(u);
	            solution[i - 1] = person;
	            var allParentsMap = new Map();
	            try {
	                for (var familyMap_1 = __values(familyMap), familyMap_1_1 = familyMap_1.next(); !familyMap_1_1.done; familyMap_1_1 = familyMap_1.next()) {
	                    var _a = __read(familyMap_1_1.value, 2), id = _a[0], f = _a[1];
	                    if (!!f.childRels.get(u)) {
	                        allParentsMap.set(id, f);
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (familyMap_1_1 && !familyMap_1_1.done && (_b = familyMap_1.return)) _b.call(familyMap_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            if (allParentsMap.size > 0) {
	                var preferredParents = families.getPreferredFamily(allParentsMap, person.preferredParentsFamilyId);
	                if (preferredParents.husbandId !== 0) {
	                    var husbandId = preferredParents.husbandId;
	                    _queue.push({ p: husbandId, pos: 2 * i });
	                }
	                if (preferredParents.wifeId !== 0) {
	                    var wifeId = preferredParents.wifeId;
	                    _queue.push({ p: wifeId, pos: 2 * i + 1 });
	                }
	            }
	        }
	        return solution;
	        var e_1, _b;
	    };
	    ReportsPedigreeService.prototype.getParents = function (familyMap, u) {
	        return familyMap.filter(function (f) { return f.getIn(['childRels', u]); });
	    };
	    ReportsPedigreeService.prototype.printTree = function (persons, txt1, txt2, utils) {
	        var people = this.people;
	        var ret;
	        if (people.length < 1) {
	            return;
	        }
	        //var $log = this.$log;
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.y;
	        var deltaYUnderline = this.deltaYUnderline;
	        var pageNumber = this.pageNumber;
	        var fromPage = this.fromPage;
	        var rootIndex = this.rootIndex;
	        if (this.hasParents(people[0])) {
	            if (!this.FirstPage) {
	                doc.addPage();
	                this.pageNumber++;
	            }
	            this.printHeader(txt1, txt2);
	            this.printFooter();
	            doc.setFontSize(8);
	            y += 4;
	            doc.text(x, y, 'Chart no. ' + this.pageNumber);
	            y += 4;
	            if (rootIndex > 0) {
	                doc.text(x, y, 'No. 1 on this chart is the same as no. ' + (rootIndex + 1) + ' on chart no. ' + fromPage);
	            }
	            var ys = new Array();
	            var xLevel3 = 145;
	            var xLevel2 = 2 * xLevel3 - maxX;
	            var xLevel1 = xLevel2 + xLevel3 - maxX;
	            y = 140;
	            var x2 = x + maxX - xLevel3;
	            i = 0;
	            var txtSup = "";
	            var person = people[i];
	            this.printPerson(persons, person, i, doc, x, x2, y, "1", deltaYUnderline, txtSup, "F", "", "", null);
	            i = 1;
	            //y = ys[0];
	            var y1 = y - 60;
	            var y2 = y + 60;
	            //y = y+(y-y2);
	            ret = this.printBox(persons, i, people, doc, x, y1, deltaYUnderline, x2, y2, "F", "", "", utils);
	            //y = (ret.y1 + ret.y2) / 2;
	            ys[0] = ret.y1;
	            ys[1] = ret.y2;
	            i = 3;
	            j = 0;
	            k = 0;
	            //y = y2;
	            //y2 = 203.5;
	            //var y1;
	            var ys2 = [];
	            for (i = 3; i < 7; i += 2) {
	                y = ys[j];
	                y1 = y - 30;
	                y2 = y + 30;
	                j++;
	                ret = this.printBox(persons, i, people, doc, xLevel1, y1, deltaYUnderline, xLevel2, y2, "", "", "", utils);
	                ys2[k] = y1;
	                ys2[k + 1] = y2;
	                k += 2;
	            }
	            i = 7;
	            j = 0;
	            var k = 0;
	            //y = 252;
	            for (i = 7; i < 15; i += 2) {
	                y = ys2[j];
	                y1 = y - 15;
	                y2 = y + 15;
	                j++;
	                ret = this.printBox(persons, i, people, doc, xLevel2, y1, deltaYUnderline, xLevel3, y2, "", "", "", utils);
	                ys[k] = y1;
	                ys[k + 1] = y2;
	                k += 2;
	            }
	            doc.setFontType("normal");
	            var j = 0;
	            var i = 15;
	            //var withSup = 0;
	            for (i = 15; i < 31; i += 2) {
	                y = ys[j];
	                y1 = y - 8;
	                y2 = y + 8;
	                j++;
	                var txtSup1 = "";
	                var txtSup2 = "";
	                var hasParents = this.hasParents(people[i]);
	                if (hasParents) {
	                    txtSup1 = "cont " + this.nextPage;
	                    this.nextPage++;
	                    /*txtSup1 = this.pageNumber * 2 + withSup;
	                     txtSup1 = "cont " + txtSup1;
	                     withSup++;*/
	                }
	                hasParents = this.hasParents(people[i + 1]);
	                if (hasParents) {
	                    txtSup2 = "cont " + this.nextPage;
	                    this.nextPage++;
	                    /*txtSup2 = this.pageNumber * 2 + withSup;
	                     txtSup2 = "cont " + txtSup2;
	                     withSup++;*/
	                }
	                ret = this.printBox(persons, i, people, doc, xLevel3, y1, deltaYUnderline, maxX, y2, "", txtSup1, txtSup2, utils);
	            }
	        }
	    };
	    ReportsPedigreeService.prototype.printHeader = function (txt1, txt2) {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.y;
	        var deltaYUnderline = this.deltaYUnderline;
	        doc.setFontSize(12);
	        doc.text(x, y, txt1);
	        var xRightAligned = maxX - 2 * txt2.length - 10;
	        doc.setFontSize(10);
	        doc.text(xRightAligned, y, txt2);
	        y = this.increaseY(y, deltaYUnderline, doc);
	        doc.line(x, y, maxX, y);
	    };
	    ReportsPedigreeService.prototype.printFooter = function () {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.yFooter;
	        var pageNumber = this.pageNumber;
	        doc.line(x, y, maxX, y);
	        doc.setFontSize(10);
	        doc.text((x + maxX) / 2, y + 6, pageNumber + "");
	    };
	    ReportsPedigreeService.prototype.printBox = function (persons, i, people, doc, xLevel3, y, deltaYUnderline, maxX, y2, fillRect, txtSup1, txtSup2) {
	        var txtIndex = (i + 1) + "";
	        var person = people[i];
	        var y1 = y + deltaYUnderline;
	        y = this.printPerson(persons, person, i, doc, xLevel3, maxX, y, txtIndex, deltaYUnderline, txtSup1, fillRect, people[i + 1]);
	        txtIndex = (i + 2) + "";
	        y += 4 + deltaYUnderline;
	        if (y2 === 0) {
	            y2 = y + deltaYUnderline;
	        }
	        y = y2;
	        i++;
	        person = people[i];
	        y = this.printPerson(persons, person, i, doc, xLevel3, maxX, y, txtIndex, deltaYUnderline, txtSup2, fillRect, null);
	        if ((i === 4) || (i === 6)) {
	            //this.$log.debug("val1", xLevel3);
	            //this.$log.debug("val2", y1);
	            //this.$log.debug("val3", xLevel3);
	            //this.$log.debug("val4", y2 + deltaYUnderline);
	            var liney1 = y1;
	            var liney2 = y2 + deltaYUnderline;
	            var mid = ((liney2 - liney1) / 2) + y1;
	            doc.line(xLevel3, liney1, xLevel3, mid - 6);
	            doc.line(xLevel3, mid + 20, xLevel3, liney2);
	            //doc.line(xLevel3, y1, xLevel3, y2 + deltaYUnderline );
	        }
	        else {
	            doc.line(xLevel3, y1, xLevel3, y2 + deltaYUnderline);
	        }
	        return { i: i, y: y, y1: y1, y2: y2 };
	    };
	    ReportsPedigreeService.prototype.hasParents = function (person) {
	        if (!person) {
	            return false;
	        }
	        var id = person.id;
	        var allParentsMap = new Map(Array.from(this.familyMap.entries()).filter(function (_a) {
	            var _b = __read(_a, 2), f = _b[1];
	            return !!f.childRels.get(id);
	        }));
	        return (allParentsMap.size > 0);
	    };
	    ReportsPedigreeService.prototype.printPerson = function (persons, person, i, doc, xLevel3, maxX, y, txtIndex, deltaYUnderline, txtSup, fillRect, spouse) {
	        //var $log = this.$log;
	        var n = 0;
	        var j = 0;
	        var personEvents = new Array();
	        var txtTitle = "";
	        var superscript;
	        var firstName, lastName;
	        if (!(!person)) {
	            var personId = person.id;
	            var nf = persons.getDefaultNameForm(persons.getPreferredName(person));
	            txtTitle = persons.getNameText(nf, false);
	            firstName = !!nf ? nf.given : '';
	            lastName = !!nf ? nf.surname : '';
	            //txtTitle = person._fullName;
	            //firstName = person._given.trim();
	            //lastName = person._surname.trim();
	            var keyName = lastName + " " + firstName;
	            //$log.debug("namesIndex",this.namesIndex);
	            //$log.debug("namesIndex size",this.namesIndex.size);
	            n = this.namesIndex.length;
	            this.namesIndex[n] = {
	                key: keyName,
	                firstName: firstName,
	                lastName: lastName,
	                page: this.pageNumber,
	                id: person.id
	            };
	            //$log.debug("person",person);
	            j = 0;
	            var preferredBirth = persons.getPreferredBirth(person);
	            if (!(!preferredBirth)) {
	                //this.$log.debug("Pbirth", preferredBirth);
	                personEvents[j] = preferredBirth;
	                j++;
	            }
	            var marr = persons.getMarriage(person, spouse);
	            if (!!marr) {
	                personEvents[j] = marr;
	                j++;
	            }
	            var preferredDeath = persons.getPreferredDeath(person);
	            if (!(!preferredDeath)) {
	                //this.$log.debug("Pdeath", preferredDeath);
	                personEvents[j] = preferredDeath;
	                j++;
	            }
	            if (i >= 15) {
	                var aux = { i: i, fromPage: this.pageNumber, root: personId, genOffset: this.genOffset + 4 };
	                this.pending.push(aux);
	            }
	        }
	        doc.setFillColor(256, 256, 256);
	        doc.setDrawColor(256, 256, 256);
	        if (fillRect === "F") {
	            doc.rect(xLevel3 + 1, y - 4, maxX - xLevel3 - 3, 4 * 1 + 4 * 4, 'F');
	        }
	        doc.setDrawColor(0, 0, 0);
	        doc.line(xLevel3, y + deltaYUnderline, maxX, y + deltaYUnderline);
	        //if (txtTitle.length > 25) {
	        //  //this.$log.debug("hola", txtTitle);
	        //  sName = firstName.split(" ");
	        //  txtTitle = sName[0] + " " + lastName;
	        //}
	        this.printBoxTitle(doc, xLevel3, y, txtIndex, txtTitle, deltaYUnderline, txtSup);
	        if (!(!personEvents)) {
	            if (personEvents.length > 0) {
	                y += 2;
	                for (var k = 0; k < personEvents.length; k++) {
	                    var item = personEvents[k];
	                    y += 3;
	                    var _date = item.date;
	                    var _type = item.type;
	                    var evidencePersonasMap = item.evidencePersonas;
	                    var logAux = new Array();
	                    j = 0;
	                    if (!(!evidencePersonasMap)) {
	                        try {
	                            for (var evidencePersonasMap_1 = __values(evidencePersonasMap), evidencePersonasMap_1_1 = evidencePersonasMap_1.next(); !evidencePersonasMap_1_1.done; evidencePersonasMap_1_1 = evidencePersonasMap_1.next()) {
	                                var _a = __read(evidencePersonasMap_1_1.value, 1), eid = _a[0];
	                                logAux[j] = eid;
	                                j++;
	                            }
	                        }
	                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                        finally {
	                            try {
	                                if (evidencePersonasMap_1_1 && !evidencePersonasMap_1_1.done && (_b = evidencePersonasMap_1.return)) _b.call(evidencePersonasMap_1);
	                            }
	                            finally { if (e_2) throw e_2.error; }
	                        }
	                        var evidenceMap = this.evidenceMap;
	                        superscript = "";
	                        if (j > 0) {
	                            var m = 0;
	                            var evidenceItem = [];
	                            while (m < logAux.length) {
	                                var key = logAux[m];
	                                var evidence = evidenceMap.get(key);
	                                //$log.debug("evidence",evidence);
	                                var citation = evidence.citation;
	                                ////this.$log.debug("citation",citation);
	                                var txt = citation.text;
	                                ////this.$log.debug("text",txt);
	                                m++;
	                                if (!!txt) {
	                                    evidenceItem.push(txt);
	                                    //this.$log.debug("KEY", txt);
	                                }
	                                else {
	                                    var sourceId = citation.sourceId;
	                                    if (sourceId > 0) {
	                                        var source = this.sourceMap.get(sourceId);
	                                        txt = this.utils.getCitation(source, evidence.citation.url, evidence.citation.page, evidence.citation.date);
	                                        ////this.$log.debug("text",txt);
	                                        if (!!txt) {
	                                            evidenceItem.push(txt);
	                                            //this.$log.debug("KEY", txt);
	                                        }
	                                    }
	                                }
	                            }
	                            j = this.endNotes.length;
	                            if (evidenceItem.length > 0) {
	                                this.endNotes[j] = evidenceItem;
	                                //this.$log.debug("EVIDENCEITEM", evidenceItem);
	                                j++;
	                                superscript += " " + j;
	                            }
	                        }
	                    }
	                    var place = this.utils.cleanPDF(item.place);
	                    var standardPlace = this.utils.cleanPDF(item.place);
	                    if (!(!standardPlace)) {
	                        ////this.$log.debug("place",standardPlace);
	                        var placeArr = standardPlace.split(",");
	                        var place1, place2, place3;
	                        switch (placeArr.length) {
	                            case 1:
	                                place1 = placeArr[0].trim();
	                                place2 = "";
	                                place3 = "";
	                                break;
	                            case 2:
	                                place1 = placeArr[1].trim();
	                                if (place1 === "United States") {
	                                    place1 = placeArr[0].trim();
	                                    place2 = "";
	                                }
	                                else {
	                                    place2 = placeArr[0].trim();
	                                }
	                                place3 = "";
	                                break;
	                            case 3:
	                                place1 = placeArr[2].trim();
	                                if (place1 === "United States") {
	                                    place1 = placeArr[1].trim();
	                                    place2 = placeArr[0].trim();
	                                    place3 = "";
	                                }
	                                else {
	                                    place2 = placeArr[1].trim();
	                                    place3 = placeArr[0].trim();
	                                }
	                                break;
	                            default:
	                                var f;
	                                place1 = placeArr[placeArr.length - 1].trim();
	                                if (place1 === "United States") {
	                                    place1 = placeArr[placeArr.length - 2].trim();
	                                    place2 = placeArr[placeArr.length - 3].trim();
	                                    place3 = placeArr[placeArr.length - 4].trim();
	                                    for (f = placeArr.length - 5; f >= 0; f--) {
	                                        place3 += " " + placeArr[f].trim();
	                                    }
	                                }
	                                else {
	                                    place2 = placeArr[placeArr.length - 2].trim();
	                                    place3 = placeArr[placeArr.length - 3].trim();
	                                    for (f = placeArr.length - 4; f >= 0; f--) {
	                                        place3 += " " + placeArr[f].trim();
	                                    }
	                                }
	                        }
	                        var keyPlace = place1;
	                        if (place2.length > 0) {
	                            keyPlace += " " + place2;
	                        }
	                        if (place3.length > 0) {
	                            keyPlace += " " + place3;
	                        }
	                        //$log.debug("keyPlace",keyPlace);
	                        n = this.placesIndex.length;
	                        this.placesIndex[n] = {
	                            key: keyPlace,
	                            place1: place1,
	                            place2: place2,
	                            place3: place3,
	                            place: standardPlace,
	                            page: this.pageNumber
	                        };
	                    }
	                    y = this.printEvent(doc, xLevel3, y, _type, _date, deltaYUnderline, superscript);
	                    if (i < 15) {
	                        if (!(!place)) {
	                            y = this.printPlace(doc, xLevel3, y, place);
	                        }
	                    }
	                }
	            }
	            else {
	                y += 4;
	                y += 4;
	            }
	        }
	        else {
	            y += 4;
	            y += 4;
	        }
	        return y;
	        var e_2, _b;
	    };
	    ReportsPedigreeService.prototype.printBoxTitle = function (doc, xLevel3, y, txtIndex, txtTitle, deltaYUnderline, txtSup) {
	        doc.text(xLevel3 + 3, y, txtIndex);
	        doc.setFontSize(10);
	        doc.setFontStyle("bold");
	        //var txtTitleSplit = doc.splitTextToSize(txtTitle,50);
	        //for(var r=0; r<txtTitleSplit.length; r++){
	        //doc.text(xLevel3 + 8, y, txtTitleSplit[r]);
	        //y += 2;
	        //}
	        doc.text(xLevel3 + 8, y, txtTitle);
	        doc.setFontSize(7);
	        doc.setFontStyle("normal");
	        doc.text(xLevel3 + 53, y - deltaYUnderline, txtSup);
	        doc.setFontSize(8);
	    };
	    ReportsPedigreeService.prototype.printEvent = function (doc, xLevel3, y, txtEventType, txtEventDate, deltaYUnderline, txtEventSup) {
	        //var $log = this.$log;
	        switch (txtEventType) {
	            case "BIRT":
	                txtEventType = "b:";
	                break;
	            case "BAPM":
	                txtEventType = "ba:";
	                break;
	            case "CHR":
	                txtEventType = "c:";
	                break;
	            case "BURI":
	                txtEventType = "bu:";
	                break;
	            case "DEAT":
	                txtEventType = "d:";
	                break;
	            case "MARR":
	                txtEventType = "m:";
	                break;
	        }
	        //$log.debug("eventType",txtEventType);
	        //$log.debug("eventDate",txtEventDate);
	        //$log.debug("eventSup",txtEventSup);
	        doc.setFontSize(8);
	        doc.text(xLevel3 + 3, y, txtEventType);
	        var txtEventDateSplit = doc.splitTextToSize(txtEventDate, 45);
	        var s;
	        for (s = 0; s < txtEventDateSplit.length; s++) {
	            doc.text(xLevel3 + 7, y, txtEventDateSplit[s]);
	            y = y + 3;
	        }
	        doc.setFontSize(7);
	        ////this.$log.debug("FECHA", txtEventDateSplit[s-1]);
	        var widthX = doc.getStringUnitWidth(txtEventDateSplit[s - 1]);
	        widthX = (widthX * 8 * 25.4) / 72;
	        doc.text(xLevel3 + widthX + 7, y - 3 - deltaYUnderline, txtEventSup);
	        return y - 3;
	    };
	    ReportsPedigreeService.prototype.printPlace = function (doc, xLevel3, y, place) {
	        y += 3;
	        doc.setFontSize(8);
	        doc.text(xLevel3 + 3, y, "  ");
	        var txtEventDateSplit = doc.splitTextToSize(place, 45);
	        for (var r = 0; r < txtEventDateSplit.length; r++) {
	            doc.text(xLevel3 + 7, y, txtEventDateSplit[r]);
	            y = y + 3;
	        }
	        return y - 3;
	    };
	    return ReportsPedigreeService;
	}());
	exports.default = ReportsPedigreeService;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Wilson Kellogg <wilson.kellogg@prosadata.com> - 2016
	 */
	var ReportsAhnentafelService = /** @class */ (function () {
	    ReportsAhnentafelService.$inject = ["$window", "rx"];
	    function ReportsAhnentafelService($window, rx) {
	        'ngInject';
	        this.$window = $window;
	        this.rx = rx;
	    }
	    ReportsAhnentafelService.prototype.create = function (jsPDF, $log, rootPerson, families, persons, evidences, utils, indexOfNames, indexOfPlaces, numGenerations, personMap, familyMap, evidenceMap, sourceMap) {
	        var readySubject = new this.rx.AsyncSubject();
	        this.doc = new jsPDF();
	        this.maxX = 188;
	        this.x = 20;
	        this.y = 20;
	        this.pageNumber = 1;
	        this.fromPage = 1;
	        this.deltaY = 5;
	        this.deltaYUnderline = 1;
	        this.deltaX = 6;
	        this.yFooter = 270;
	        this.people = [];
	        this.$log = $log;
	        //this.$log.debug("LOG", this.logarithm(6));
	        this.rootIndex = 0;
	        this.pending = [];
	        this.endNotes = [];
	        this.namesIndex = [];
	        this.placesIndex = [];
	        this.generation = 0;
	        this.numGenerations = numGenerations;
	        this.persons = persons;
	        this.families = families;
	        this.utils = utils;
	        var doc = this.doc;
	        var root = rootPerson.id;
	        //this.$log.debug("ROOT", root);
	        //this.$log.debug("ENCODED ROOT", utils.encodeId(root));
	        //let root = parseInt(tu.getIn(['preferences', 'ROOT'], '0'), 10);
	        //$log.debug("root " , root);
	        this.personMap = personMap;
	        this.familyMap = familyMap;
	        this.sourceMap = sourceMap;
	        //$log.debug("READYchangeEvidenceMap", "before evidenceMap");
	        this.evidenceMap = evidenceMap;
	        //$log.debug("READYchangeEvidenceMap", evidenceMap);
	        this.people = this.getTree(families, root);
	        //$log.debug("PEOPLE!!!", this.people);
	        var txt1 = 'Ahnentafel of ';
	        var nf = persons.getDefaultNameForm(persons.getPreferredName(this.personMap.get(root)));
	        txt1 = txt1.concat(persons.getNameText(nf, false));
	        var reportName = txt1;
	        this.txt1 = txt1;
	        //txt1 = txt1.concat(this.people[0].per._fullName);
	        var txt2 = this.today();
	        this.printPeople(persons, txt1, txt2, utils, evidences);
	        while (this.pending.length > 0) {
	            var aux = this.pending.splice(0, 1)[0];
	            root = aux.root;
	            this.rootIndex = aux.i;
	            this.fromPage = aux.fromPage;
	            this.people = this.getTree(families, root);
	            this.printTree(persons, txt1, txt2);
	        }
	        //this.$log.debug("notas", this.namesIndex);
	        this.deltaY = 5;
	        this.deltaX = 6;
	        this.x = 20;
	        this.y = 20;
	        this.deltaYUnderline = 1;
	        doc.addPage();
	        this.pageNumber++;
	        txt1 = 'Index of Names';
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        indexOfNames.setDoc(this.doc);
	        indexOfNames.setX(this.x);
	        indexOfNames.setY(this.y);
	        indexOfNames.setDeltaY(this.deltaY);
	        indexOfNames.setDeltaYUnderline(this.deltaYUnderline);
	        indexOfNames.setDeltaX(this.deltaX);
	        indexOfNames.setPageNumber(this.pageNumber);
	        indexOfNames.setNamesIndex(this.namesIndex);
	        indexOfNames.printNames();
	        this.pageNumber = indexOfNames.getPageNumber();
	        doc.addPage();
	        this.pageNumber++;
	        txt1 = 'Index of Places';
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        indexOfPlaces.setDoc(this.doc);
	        indexOfPlaces.setX(this.x);
	        indexOfPlaces.setY(this.y);
	        indexOfPlaces.setDeltaY(this.deltaY);
	        indexOfPlaces.setDeltaYUnderline(this.deltaYUnderline);
	        indexOfPlaces.setDeltaX(this.deltaX);
	        indexOfPlaces.setPageNumber(this.pageNumber);
	        indexOfPlaces.setPlacesIndex(this.placesIndex);
	        indexOfPlaces.printPlaces();
	        var blob = doc.output('blob');
	        //if (this.$window.navigator && this.$window.navigator.msSaveOrOpenBlob) {
	        //  this.$window.navigator.msSaveOrOpenBlob(blob);
	        //}
	        //else {
	        //  //var objectUrl = URL.createObjectURL(blob);
	        //  this.$window.open((this.$window.URL || this.$window.webkitURL).createObjectURL(blob));
	        //}
	        //readySubject.next(null);
	        readySubject.next({ blob: blob, name: reportName, ext: 'pdf' });
	        readySubject.complete();
	        return readySubject;
	    };
	    ReportsAhnentafelService.prototype.printPeople = function (persons, txt1, txt2, utils, evidences) {
	        var p = this.people;
	        //var doc = this.doc;
	        //var maxX = this.maxX;
	        //var x = this.x;
	        this.deltaY = this.y + 10;
	        //var deltaYUnderline = this.deltaYUnderline;
	        //var pageNumber = this.pageNumber;
	        //var fromPage = this.fromPage;
	        //var rootIndex = this.rootIndex;
	        //var gen = this.generation;
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        //this.$log.debug("personas", p);
	        //var k=0;
	        //var txtTitle;
	        //var cont = 1;
	        var gen;
	        for (var k = 0; k < p.length; k++) {
	            /*if (this.logarithm(k+1)){
	             gen++;
	             }*/
	            //this.$log.debug("PER",p[k].per);
	            if (p[k]) {
	                //y=this.increaseY(y, this.deltaYUnderline, this.doc);
	                gen = p[k].gen;
	                //this.$log.debug("PER", p[k].gen);
	                //this.$log.debug("GEN", gen);
	                //this.$log.debug("numGenerations", this.numGenerations);
	                if (gen <= this.numGenerations) {
	                    //this.$log.debug("person", p[k].per._fullName);
	                    //this.$log.debug("K", k);
	                    this.printPerson(p[k].per, p[k].spouseId, k + 1, gen, utils, persons, evidences);
	                    //txtTitle = p[k].per._fullName;
	                    //this.$log.debug("persona", txtTitle);
	                    //cont++;
	                }
	            }
	        }
	    };
	    ReportsAhnentafelService.prototype.today = function () {
	        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	        var date = new Date();
	        var _date = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
	        return _date;
	    };
	    //getTree(families, root, persons){
	    ReportsAhnentafelService.prototype.getTree = function (families, root) {
	        var personMap = this.personMap;
	        var familyMap = this.familyMap;
	        var _queue = [];
	        var solution = [];
	        var u = 0;
	        var i = 0;
	        var _node = 0;
	        var g;
	        //var j;
	        _queue.push({ p: root, pos: 1, gen: 1 });
	        while (_queue.length > 0) {
	            _node = _queue.splice(0, 1)[0];
	            i = _node.pos;
	            u = _node.p;
	            g = _node.gen;
	            if (g > this.numGenerations) {
	                //$log.debug("stop Generation", "STOP");
	                //$log.debug("solution", solution);
	                break;
	            }
	            var person = personMap.get(u);
	            solution[i - 1] = { per: person, spouseId: _node.spouseId, gen: g };
	            var allParentsMap = new Map();
	            try {
	                for (var familyMap_1 = __values(familyMap), familyMap_1_1 = familyMap_1.next(); !familyMap_1_1.done; familyMap_1_1 = familyMap_1.next()) {
	                    var _a = __read(familyMap_1_1.value, 2), id = _a[0], f = _a[1];
	                    if (!!f.childRels.get(u)) {
	                        allParentsMap.set(id, f);
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (familyMap_1_1 && !familyMap_1_1.done && (_b = familyMap_1.return)) _b.call(familyMap_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            if (allParentsMap.size > 0) {
	                var preferredParents = this.families.getPreferredFamily(allParentsMap, person.preferredParentsFamilyId);
	                if (preferredParents.husbandId !== 0) {
	                    var husbandId = preferredParents.husbandId;
	                    _queue.push({ p: husbandId, spouseId: preferredParents.wifeId, pos: 2 * i, gen: g + 1 });
	                }
	                if (preferredParents.wifeId !== 0) {
	                    var wifeId = preferredParents.wifeId;
	                    _queue.push({ p: wifeId, spouseId: 0, pos: 2 * i + 1, gen: g + 1 });
	                }
	            }
	        }
	        //this.$log.debug("solution",solution);
	        return solution;
	        var e_1, _b;
	    };
	    ReportsAhnentafelService.prototype.getAllParents = function (familyMap, u) {
	        return familyMap.filter(function (f) { return f.getIn(['childRels', u]); });
	    };
	    ReportsAhnentafelService.prototype.logarithm = function (n) {
	        var base = Math.log(2);
	        var exp = Math.log(n);
	        var result = exp / base;
	        return (result % 1 === 0);
	    };
	    ReportsAhnentafelService.prototype.printHeader = function (txt1, txt2) {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.y;
	        var deltaYUnderline = this.deltaYUnderline;
	        doc.setFontSize(14);
	        doc.text(x, y, txt1);
	        var xRightAligned = maxX - 2 * txt2.length - 10;
	        doc.setFontSize(10);
	        doc.text(xRightAligned, y, txt2);
	        y = this.increaseY(y, deltaYUnderline, doc);
	        doc.line(x, y, maxX, y);
	    };
	    ReportsAhnentafelService.prototype.printFooter = function () {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.yFooter;
	        var pageNumber = this.pageNumber;
	        doc.line(x, y, maxX, y);
	        doc.setFontSize(10);
	        doc.text((x + maxX) / 2, y + 6, pageNumber + "");
	    };
	    ReportsAhnentafelService.prototype.increaseY = function (y, deltaY, doc) {
	        y += deltaY;
	        if (y >= this.yFooter) {
	            y = 20;
	            doc.addPage();
	            this.pageNumber++;
	            this.printHeader(this.txt1, this.today());
	            this.printFooter();
	            y = this.y + 10;
	        }
	        return y;
	    };
	    ReportsAhnentafelService.prototype.loadNames = function () {
	        var people = this.insertionSort(this.namesIndex);
	        return { people: people };
	    };
	    ReportsAhnentafelService.prototype.insertionSort = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = [];
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	        }
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            j = i - 1;
	            while (j >= 0 && first.key < copia[j].key) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        return (copia);
	    };
	    ReportsAhnentafelService.prototype.loadPlaces = function () {
	        var places = this.insertionSort(this.placesIndex);
	        return { places: places };
	    };
	    ReportsAhnentafelService.prototype.printPerson = function (per, spouseId, cont, gen, utils, persons, evidences) {
	        //this.deltaY = this.increaseY(this.deltaY, 8, this.doc);
	        if (gen !== this.generation) {
	            this.doc.setFontType("bold");
	            this.doc.text(this.x, this.deltaY, "GENERATION " + gen);
	            this.deltaY = this.increaseY(this.deltaY, 5, this.doc);
	            this.generation = gen;
	            this.doc.setFontType("normal");
	        }
	        var nametxt = "";
	        var typeValue;
	        var nf = persons.getDefaultNameForm(persons.getPreferredName(per));
	        var fullName = persons.getNameText(nf, false);
	        var firstName = !!nf ? nf.given : '';
	        var lastName = !!nf ? nf.surname : '';
	        nametxt = fullName + " (" + utils.encodeId(per.id) + ")";
	        //var firstName = per._given.trim();
	        //var lastName = per._surname.trim();
	        n = this.namesIndex.length;
	        var keyName = lastName + " " + firstName;
	        //this.$log.debug("FULL", per._fullName);
	        this.namesIndex[n] = {
	            key: keyName,
	            firstName: firstName,
	            lastName: lastName,
	            page: this.pageNumber,
	            id: per.id
	        };
	        //this.doc.text(this.x+5, this.deltaY, nametxt);
	        //var dim = this.doc.getTextDimensions(nametxt);
	        this.doc.setTextColor(0, 0, 0);
	        var factsMap = per.facts;
	        var width = 165;
	        var txtP = "";
	        var txtB = "";
	        var txtD = "";
	        var txtM = "";
	        var personEvents = [];
	        var n;
	        var j = 0;
	        var superscript = "";
	        var separator = "";
	        var evidenceMap = this.evidenceMap;
	        var ii = 0;
	        //this.$log.debug("name", firstName);
	        //this.$log.debug("facts.size", factsMap);
	        var marriages = [];
	        var Birth = persons.getPreferredBirth(per);
	        txtB = "";
	        if (Birth) {
	            typeValue = "born";
	            if (Birth.type !== "BIRT") {
	                typeValue = this.getType(evidences, Birth.type).display;
	            }
	            txtB = " " + typeValue + " " + Birth.date;
	            if (!(!Birth.place)) {
	                //this.$log.debug("Item place", Birth.place);
	                txtB += ' in ' + utils.cleanPDF(Birth.place);
	            }
	            //txtB += separator;
	            personEvents[j] = Birth;
	            j++;
	        }
	        var Death = persons.getPreferredDeath(per);
	        txtD = "";
	        if (Death) {
	            typeValue = "died";
	            if (Death.type !== "DEAT") {
	                typeValue = this.getType(evidences, Death.type).display;
	            }
	            //this.$log.debug("type_dispay", typeValue);
	            txtD = " " + typeValue + " " + Death.date;
	            if (!(!Death.place)) {
	                txtD += ' in ' + utils.cleanPDF(Death.place);
	            }
	            personEvents[j] = Death;
	            j++;
	        }
	        try {
	            for (var factsMap_1 = __values(factsMap), factsMap_1_1 = factsMap_1.next(); !factsMap_1_1.done; factsMap_1_1 = factsMap_1.next()) {
	                var item = factsMap_1_1.value;
	                //this.$log.debug("item factsMap", item);
	                ii++;
	                separator = (ii > 1) ? ((ii === factsMap.size) ? "" : "; ") : separator;
	                //this.$log.debug("Items", item);
	                //this.$log.debug("ItemsMAP", evidenceMap);
	                //var type = item[1].type;
	                if ((item[1].principal) && (item[1].type === "MARR")) {
	                    if (spouseId > 0 && (item[1].principalId1 === spouseId || item[1].principalId2 === spouseId)) {
	                        marriages.push({
	                            key: item[1].dateSort,
	                            item: item[1]
	                        });
	                    }
	                    /*txtM = " married " + item[1].date;
	                     if (!(!item[1].place)) {
	                     txtM += ' in ' + item[1].place;
	                     }
	                     txtM += separator;
	                     this.$log.debug(">>MARRIAGE>>", item[1]);
	                     personEvents[j] = item[1];
	                     j++;*/
	                    /*		}
	                     /*switch (type) {
	                     case 'BIRT':
	                     this.$log.debug(persons.getPreferredBirth(per))
	                     txtB = "born " + item[1].date;
	                     if (!(!item[1].place)) {
	                     this.$log.debug("Item place", item[1].place);
	                     txtB += ' in ' + item[1].place;
	                     }
	                     //txtB += separator;
	                     personEvents[j] = item[1];
	                     j++;
	                     break;
	                     case "MARR" :
	                     if(per.gender === "MALE"){
	                     marriages.push({
	                     key: item[1].dateSort,
	                     item: item[1]
	                     });
	                     /*txtM = " married " + item[1].date;
	                     if (!(!item[1].place)) {
	                     txtM += ' in ' + item[1].place;
	                     }
	                     txtM += separator;
	                     this.$log.debug(">>MARRIAGE>>", item[1]);
	                     personEvents[j] = item[1];
	                     j++;*/
	                    /*		}
	                     break;
	                     case "DEAT" :
	                     txtD = " died " + item[1].date;
	                     if (!(!item[1].place)) {
	                     txtD += ' in ' + item[1].place;
	                     }
	                     personEvents[j] = item[1];
	                     j++;
	                     //txtD += ';';
	                     }*/
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (factsMap_1_1 && !factsMap_1_1.done && (_a = factsMap_1.return)) _a.call(factsMap_1);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        //this.$log.debug("marriages", marriages);
	        if (marriages.length > 0) {
	            var SortedMArr = this.insertionSort(marriages);
	            var ActualMarr = SortedMArr[0].item;
	            txtM = " married " + ActualMarr.date;
	            if (!(!ActualMarr.place)) {
	                txtM += ' in ' + utils.cleanPDF(ActualMarr.place);
	            }
	            txtM += separator;
	            //this.$log.debug(">>MARRIAGE>>", ActualMarr);
	            personEvents[j] = ActualMarr;
	            j++;
	        }
	        //this.$log.debug("personEvents", personEvents);
	        if (!(!personEvents)) {
	            //$log.debug("Events length",events.length);
	            if (personEvents.length > 0) {
	                try {
	                    for (var personEvents_1 = __values(personEvents), personEvents_1_1 = personEvents_1.next(); !personEvents_1_1.done; personEvents_1_1 = personEvents_1.next()) {
	                        var item = personEvents_1_1.value;
	                        //$log.debug("item",item);
	                        //$log.debug("date",item.date);
	                        //y += 4;
	                        //var _date = item.date;
	                        //var _type = item.type;
	                        //$log.debug("type",_type);
	                        var evidencePersonasMap = item.evidencePersonas;
	                        var logAux = [];
	                        j = 0;
	                        try {
	                            //$log.debug("this.evidenceMapBEFOREforEach",this.evidenceMap);
	                            for (var evidencePersonasMap_1 = __values(evidencePersonasMap), evidencePersonasMap_1_1 = evidencePersonasMap_1.next(); !evidencePersonasMap_1_1.done; evidencePersonasMap_1_1 = evidencePersonasMap_1.next()) {
	                                var _b = __read(evidencePersonasMap_1_1.value, 1), eid = _b[0];
	                                logAux[j] = eid;
	                                j++;
	                            }
	                        }
	                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                        finally {
	                            try {
	                                if (evidencePersonasMap_1_1 && !evidencePersonasMap_1_1.done && (_c = evidencePersonasMap_1.return)) _c.call(evidencePersonasMap_1);
	                            }
	                            finally { if (e_3) throw e_3.error; }
	                        }
	                        if (j > 0) {
	                            var m = 0;
	                            var evidenceItem = [];
	                            while (m < logAux.length) {
	                                var key = logAux[m];
	                                var evidence = evidenceMap.get(key);
	                                //$log.debug("evidence",evidence);
	                                var citation = evidence.citation;
	                                //this.$log.debug("citation",citation);
	                                var txt = citation.text;
	                                //this.$log.debug("text",txt);
	                                m++;
	                                if (!!txt) {
	                                    evidenceItem.push(txt);
	                                    //this.$log.debug("KEY", txt);
	                                }
	                                else {
	                                    var sourceId = citation.sourceId;
	                                    if (sourceId > 0) {
	                                        var source = this.sourceMap.get(sourceId);
	                                        txt = utils.getCitation(source, evidence.citation.url, evidence.citation.page, evidence.citation.date);
	                                        //this.$log.debug("text",txt);
	                                        if (!!txt) {
	                                            evidenceItem.push(txt);
	                                            //this.$log.debug("KEY", txt);
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                        //var place = item.place;
	                        var standardPlace = utils.cleanPDF(item.place);
	                        //this.$log.debug("PALCE", standardPlace);
	                        if (!(!standardPlace)) {
	                            var placeArr = standardPlace.split(",");
	                            /*for (var l = placeArr.length - 1; l < 2; l++) {
	                             placeArr[l+1] = "";
	                             }*/
	                            //this.$log.debug("lugar0", placeArr[0]);
	                            //this.$log.debug("lugar1", placeArr[1]);
	                            //this.$log.debug("lugar2", placeArr[2]);
	                            //this.$log.debug("lugar", placeArr[placeArr.length - 1]);
	                            //this.$log.debug("item del lugar", item);
	                            var place1, place2, place3;
	                            switch (placeArr.length) {
	                                case 1:
	                                    place1 = placeArr[0].trim();
	                                    place2 = "";
	                                    place3 = "";
	                                    break;
	                                case 2:
	                                    place1 = placeArr[1].trim();
	                                    if (place1 === "United States") {
	                                        place1 = placeArr[0].trim();
	                                        place2 = "";
	                                    }
	                                    else {
	                                        place2 = placeArr[0].trim();
	                                    }
	                                    place3 = "";
	                                    break;
	                                case 3:
	                                    place1 = placeArr[2].trim();
	                                    if (place1 === "United States") {
	                                        place1 = placeArr[1].trim();
	                                        place2 = placeArr[0].trim();
	                                        place3 = "";
	                                    }
	                                    else {
	                                        place2 = placeArr[1].trim();
	                                        place3 = placeArr[0].trim();
	                                    }
	                                    break;
	                                default:
	                                    var f;
	                                    place1 = placeArr[placeArr.length - 1].trim();
	                                    if (place1 === "United States") {
	                                        place1 = placeArr[placeArr.length - 2].trim();
	                                        place2 = placeArr[placeArr.length - 3].trim();
	                                        place3 = placeArr[placeArr.length - 4].trim();
	                                        for (f = placeArr.length - 5; f >= 0; f--) {
	                                            place3 += " " + placeArr[f].trim();
	                                        }
	                                    }
	                                    else {
	                                        place2 = placeArr[placeArr.length - 2].trim();
	                                        place3 = placeArr[placeArr.length - 3].trim();
	                                        for (f = placeArr.length - 4; f >= 0; f--) {
	                                            place3 += " " + placeArr[f].trim();
	                                        }
	                                    }
	                            }
	                            var keyPlace = place1;
	                            if (place2.length > 0) {
	                                keyPlace += " " + place2;
	                            }
	                            if (place3.length > 0) {
	                                keyPlace += " " + place3;
	                            }
	                            //$log.debug("keyPlace",keyPlace);
	                            n = this.placesIndex.length;
	                            this.placesIndex[n] = {
	                                key: keyPlace,
	                                place1: place1,
	                                place2: place2,
	                                place3: place3,
	                                place: standardPlace,
	                                page: this.pageNumber
	                            };
	                        }
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (personEvents_1_1 && !personEvents_1_1.done && (_d = personEvents_1.return)) _d.call(personEvents_1);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	            }
	        }
	        var lineFull = "";
	        var txtW = cont + ". ";
	        lineFull += txtW;
	        this.doc.text(this.x, this.deltaY, txtW);
	        var xLine = this.sentenceWidth(txtW, 10);
	        //this.$log.debug("NOMBRE", txt);
	        //this.doc.setTextColor(0,153,0);
	        this.doc.text(this.x + xLine, this.deltaY, nametxt);
	        txtW += nametxt.trim();
	        lineFull += nametxt;
	        //this.$log.debug("lineFull2", lineFull);
	        var V = this.sentenceWidth(txtW, 10);
	        //this.doc.setTextColor(0, 0, 0);
	        if (superscript !== "") {
	            this.doc.setFontSize(5);
	            this.doc.text(this.x + this.sentenceWidth(txtW.trim(), 10), this.deltaY - 2, superscript);
	            V += this.sentenceWidth(superscript, 5);
	            this.doc.setFontSize(10);
	        }
	        txtP += ': ';
	        if (txtB !== "") {
	            txtP += txtB;
	        }
	        if (txtM !== "") {
	            if (txtB === "") {
	                txtP += txtM;
	            }
	            else {
	                txtP += "; " + txtM;
	            }
	        }
	        if (txtD !== "") {
	            if ((txtB === "") && (txtM === "")) {
	                txtP += txtD;
	            }
	            else {
	                txtP += "; " + txtD;
	            }
	        }
	        //this.$log.debug("placeTxtD", txtD);
	        if ((txtB !== "") || (txtM !== "") || (txtD !== "")) {
	            txtP += ".";
	        }
	        lineFull += "$" + txtP;
	        //this.$log.debug("lineFull", lineFull);
	        var parts = this.doc.splitTextToSize(lineFull, width);
	        //var parts = txtP.match(/.{1,300}/g);
	        for (j = 0; j < parts.length; j++) {
	            if (j === 0) {
	                var split = parts[j].split("$");
	                this.doc.text(this.x + V + 2, this.deltaY, split[1].trim());
	            }
	            else {
	                this.doc.text(this.x + 5, this.deltaY, parts[j].trim());
	            }
	            //this.deltaY=this.deltaY+8;
	            this.deltaY = this.increaseY(this.deltaY, 5, this.doc);
	            //this.$log.debug("VALOR Y", this.deltaY);
	        }
	        var e_2, _a, e_4, _d, e_3, _c;
	        //this.deltaY=this.deltaY+10;
	        //this.doc.setTextColor(0,0,0);
	    };
	    ReportsAhnentafelService.prototype.evidencePersonasForeach = function (evidencePersonas, logAux, j) {
	        logAux = [];
	        j = 0;
	        evidencePersonas.forEach(function (persona, key) {
	            logAux[j] = key;
	            j++;
	        });
	    };
	    ReportsAhnentafelService.prototype.getType = function (evidences, type) {
	        return this.utils.factTypes.find(function (ft) { return ft.value === type; });
	    };
	    ReportsAhnentafelService.prototype.sentenceWidth = function (txt, fontsize) {
	        var w = this.doc.getStringUnitWidth(txt);
	        return (w * fontsize * 25.4) / 72;
	    };
	    return ReportsAhnentafelService;
	}());
	exports.default = ReportsAhnentafelService;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Wilson Kellogg <wilson.kellogg@prosadata.com> - 2016
	 */
	var ReportsEvidenceAnalysisService = /** @class */ (function () {
	    ReportsEvidenceAnalysisService.$inject = ["$window", "jsPDF", "$log", "rx", "utils", "persons", "families", "evidences", "sources", "endNotes"];
	    function ReportsEvidenceAnalysisService($window, jsPDF, $log, rx, utils, persons, families, evidences, sources, endNotes) {
	        'ngInject';
	        this.$window = $window;
	        this.jsPDF = jsPDF;
	        this.$log = $log;
	        this.rx = rx;
	        this.utils = utils;
	        this.persons = persons;
	        this.families = families;
	        this.evidences = evidences;
	        this.sources = sources;
	        this.endNotesService = endNotes;
	        this.utils = utils;
	    }
	    ReportsEvidenceAnalysisService.prototype.create = function (root) {
	        var _this = this;
	        var readySubject = new this.rx.AsyncSubject();
	        this.doc = new this.jsPDF("landscape");
	        this.maxX = 276;
	        //this.$log.debug("prueba",this.maxX);
	        this.x = 20;
	        this.y = 15;
	        this.pageNumber = 1;
	        this.fromPage = 1;
	        this.deltaY = 5;
	        this.deltaYUnderline = 1;
	        this.deltaX = 6;
	        this.yFooter = 195;
	        this.people = [];
	        this.endNotesItem = [];
	        //this.$log.debug("LOG", this.logarithm(6));
	        this.rootIndex = 0;
	        this.pending = [];
	        this.endNotes = [];
	        this.generalSources = [];
	        this.generalSourcesPrint = [];
	        this.namesIndex = [];
	        this.placesIndex = [];
	        this.generation = 0;
	        //this.$log.debug(root);
	        this.person = root;
	        var doc = this.doc;
	        this.root = root.id;
	        //this.$log.debug("ROOT", root);
	        this.utils.readyChange(this.persons, this.families, this.evidences, this.sources).take(1).subscribe(function (_a) {
	            var _b = __read(_a, 4), personMap = _b[0], familyMap = _b[1], evidenceMap = _b[2], sourceMap = _b[3];
	            var rootPerson = personMap.get(_this.root);
	            if (!rootPerson) {
	                readySubject.error('NOT_FOUND');
	                return;
	            }
	            //let root = parseInt(tu.getIn(['preferences', 'ROOT'], '0'), 10);
	            //$log.debug("root " , root);
	            _this.personMap = personMap;
	            _this.familyMap = familyMap;
	            _this.sourceMap = sourceMap;
	            //this.$log.debug("READYchangeEvidenceMap", "before evidenceMap");
	            _this.evidenceMap = evidenceMap;
	            //this.$log.debug("READYchangeEvidenceMap", evidenceMap);
	            //this.people = this.getTree(families, root);
	            //this.$log.debug("PEOPLE!!!", this.people);
	            var txt1 = 'Evidence Analysis Report: ';
	            var nf = _this.persons.getDefaultNameForm(_this.persons.getPreferredName(rootPerson));
	            txt1 = txt1.concat(_this.persons.getNameText(nf, false));
	            var reportName = txt1;
	            _this.txt1 = txt1;
	            //txt1 = txt1.concat(this.people[0].per._fullName);
	            var txt2 = _this.today();
	            _this.printevidences(_this.persons, txt1, txt2, _this.utils, _this.evidences);
	            while (_this.pending.length > 0) {
	                var aux = _this.pending.splice(0, 1)[0];
	                root = aux.root;
	                _this.rootIndex = aux.i;
	                _this.fromPage = aux.fromPage;
	                _this.people = _this.getTree(_this.families, root);
	                _this.printTree(_this.persons, txt1, txt2);
	            }
	            //this.$log.debug("notas", this.namesIndex);
	            _this.deltaY = 5;
	            _this.deltaX = 6;
	            _this.x = 20;
	            _this.y = 20;
	            _this.deltaYUnderline = 1;
	            _this.x = 20;
	            _this.y = 20;
	            //this.$log.debug("whereAreGeneral",this.generalSources);
	            for (var i = 0; i < _this.generalSources.length; i++) {
	                var iter = 0;
	                var found = false;
	                while ((iter < _this.endNotes.length) && (!found)) {
	                    found = _this.generalSources[i][0] === _this.endNotes[iter][0];
	                    iter++;
	                }
	                if (!found) {
	                    _this.generalSourcesPrint.push(_this.generalSources[i]);
	                }
	            }
	            if (_this.generalSourcesPrint.length > 0) {
	                doc.addPage();
	                _this.pageNumber++;
	                txt1 = "GENERAL SOURCES";
	                var txt3 = "The following sources have no facts attached:";
	                _this.printHeader(txt1, txt2);
	                _this.printFooter();
	                _this.doc.setFontSize(10);
	                _this.y = _this.y + 6;
	                _this.doc.text(_this.x, _this.y, txt3);
	                _this.y = _this.y + 2;
	                _this.doc.setFontSize(9);
	                _this.endNotesService.setDoc(_this.doc);
	                _this.endNotesService.setX(_this.x);
	                _this.endNotesService.setY(_this.y);
	                _this.endNotesService.setMaxX(_this.maxX);
	                _this.endNotesService.setyFooter(_this.yFooter);
	                _this.endNotesService.setDeltaY(_this.deltaY);
	                _this.endNotesService.setDeltaYUnderline(_this.deltaYUnderline);
	                _this.endNotesService.setDeltaX(_this.deltaX);
	                _this.endNotesService.setPageNumber(_this.pageNumber);
	                _this.endNotesService.setGeneralNotes(_this.generalSourcesPrint);
	                _this.endNotesService.printGeneralNotes();
	                _this.pageNumber = _this.endNotesService.getPageNumber();
	            }
	            if (_this.endNotes.length > 0) {
	                doc.addPage();
	                _this.pageNumber++;
	                //this.$log.debug("family", this.family);
	                txt1 = 'Endnotes';
	                _this.printHeader(txt1, txt2);
	                _this.printFooter();
	                _this.endNotesService.setDoc(_this.doc);
	                _this.endNotesService.setX(_this.x);
	                _this.endNotesService.setY(_this.y);
	                _this.endNotesService.setMaxX(_this.maxX);
	                _this.endNotesService.setyFooter(_this.yFooter);
	                _this.endNotesService.setDeltaY(_this.deltaY);
	                _this.endNotesService.setDeltaYUnderline(_this.deltaYUnderline);
	                _this.endNotesService.setDeltaX(_this.deltaX);
	                _this.endNotesService.setPageNumber(_this.pageNumber);
	                _this.endNotesService.setEndNotes(_this.endNotes);
	                _this.endNotesService.printNotes();
	                _this.pageNumber = _this.endNotesService.getPageNumber();
	            }
	            var blob = doc.output('blob');
	            //if (this.$window.navigator && this.$window.navigator.msSaveOrOpenBlob) {
	            //  this.$window.navigator.msSaveOrOpenBlob(blob);
	            //}
	            //else {
	            //  //var objectUrl = URL.createObjectURL(blob);
	            //  this.$window.open((this.$window.URL || this.$window.webkitURL).createObjectURL(blob));
	            //}
	            readySubject.next({ blob: blob, name: reportName, ext: 'pdf' });
	            readySubject.complete();
	        }, function () {
	            readySubject.error('UNKNOWN_ERROR');
	        });
	        return readySubject;
	    };
	    ReportsEvidenceAnalysisService.prototype.printevidences = function (persons, txt1, txt2, utils, evidences) {
	        this.deltaY = this.y + 10;
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        //this.$log.debug("person", this.person);
	        var factperson = this.person.facts;
	        var sourcesFact = [];
	        //this.$log.debug("factCant", factperson);
	        var cant = 0;
	        var t = 0;
	        var r = 0;
	        var index = 0;
	        var i = 0;
	        //This map contains all the fact types of the person as keys and the smallest dateSort for that type as value
	        var factTypes = new Map();
	        try {
	            for (var factperson_1 = __values(factperson), factperson_1_1 = factperson_1.next(); !factperson_1_1.done; factperson_1_1 = factperson_1.next()) {
	                var item = factperson_1_1.value;
	                //IMPORTANTE: AL HACER QUE EL IF NO INCLUYA CANT++...APARECEN MÁS FACTS POSIBLEMENTE RELACIONADOS CON LOS FAMILIARES
	                if ((item[1].principal) /* &&  (item[1].type !== "SOUR") /*&& !item[1].principalId1*/) {
	                    //this.$log.debug("alentrar",item[1]);
	                    if (!factTypes.has(item[1].type)) {
	                        //this.$log.debug("pasa",item[1]);
	                        factTypes.set(item[1].type, item[1].dateSort);
	                    }
	                    else {
	                        if ((factTypes.get(item[1].type) !== "") && (item[1].dateSort !== "") && (item[1].dateSort < factTypes.get(item[1].type))) {
	                            factTypes.delete(item[1].type);
	                            factTypes.set(item[1].type, item[1].dateSort);
	                        }
	                        else if ((factTypes.get(item[1].type) === "") && (item[1].dateSort !== "")) {
	                            factTypes.delete(item[1].type);
	                            factTypes.set(item[1].type, item[1].dateSort);
	                        }
	                    }
	                    //}
	                    cant++;
	                    var sourArr = this.factSource(item[1], utils, evidences);
	                    //this.$log.debug("sourArr", sourArr);
	                    sourcesFact.push(sourArr);
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (factperson_1_1 && !factperson_1_1.done && (_a = factperson_1.return)) _a.call(factperson_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        //this.$log.debug("mapaTipos",factTypes);
	        factTypes.delete("SOUR");
	        //This array contains the titles for the rows already sorted by fact.dateSort
	        this.rowsTitles = this.insertionSortMap(factTypes);
	        this.rowsTitles.push("Father");
	        this.rowsTitles.push("Mother");
	        this.rowsTitles.push("Spouse(s)");
	        //this.$log.debug("rowsTitlesSorted",this.rowsTitles);
	        if (cant > 0) {
	            //this.$log.debug("arreglo", sourcesFact);
	            var printArr = this.printeableArray(sourcesFact);
	            //this.$log.debug("printArr",printArr);
	            var printArr2 = this.sortedPrinteableArray(printArr);
	            //this.$log.debug("printArr2",printArr2);
	            this.arrayResul = [];
	            this.Allevidences = [];
	            try {
	                for (var printArr2_1 = __values(printArr2), printArr2_1_1 = printArr2_1.next(); !printArr2_1_1.done; printArr2_1_1 = printArr2_1.next()) {
	                    var item = printArr2_1_1.value;
	                    //this.$log.debug("forContent",item);
	                    this.sourceData(item);
	                    //this.$log.debug("this.Allevidences",this.Allevidences);
	                }
	            }
	            catch (e_2_1) { e_2 = { error: e_2_1 }; }
	            finally {
	                try {
	                    if (printArr2_1_1 && !printArr2_1_1.done && (_b = printArr2_1.return)) _b.call(printArr2_1);
	                }
	                finally { if (e_2) throw e_2.error; }
	            }
	            var finalArr = this.sortEvidences(this.Allevidences);
	            var resul;
	            for (t = 0; t < finalArr.length; t++) {
	                //this.$log.debug("finalArr[t]", finalArr[t]);
	                resul = this.format(finalArr[t]);
	                //this.$log.debug("loquesale", resul);
	                this.arrayResul.push(resul);
	            }
	            //this.$log.debug("resulSourceData",this.arrayResul);
	            //Merge separated columns that should be one
	            var auxArray = [];
	            for (t = 0; t < this.arrayResul.length; t++) {
	                for (r = t + 1; r < this.arrayResul.length; r++) {
	                    if ((t !== r) && (this.arrayResul[t][0] === this.arrayResul[r][0])) {
	                        auxArray = this.arrayResul[t];
	                        if (auxArray[auxArray.length - 1] === 0) {
	                            auxArray[auxArray.length - 1] = "";
	                        }
	                        for (i = 1; i < this.arrayResul[r].length; i++) {
	                            if ((auxArray[i] === "") && (i !== auxArray.length - 1)) {
	                                auxArray[i] = this.arrayResul[r][i];
	                            }
	                            else {
	                                if ((i === auxArray.length - 1) && (this.arrayResul[r][i] !== 0)) {
	                                    if (auxArray[i] !== "") {
	                                        auxArray[i] += "," + this.arrayResul[r][i];
	                                    }
	                                    else {
	                                        auxArray[i] = this.arrayResul[r][i];
	                                    }
	                                }
	                                else if (i !== auxArray.length - 1) {
	                                    if ((auxArray[i]) && (auxArray[i].indexOf(this.arrayResul[r][i]) === -1)) {
	                                        auxArray[i] += "\n" + this.arrayResul[r][i];
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	                if (auxArray.length > 0) {
	                    this.arrayResul[t] = auxArray;
	                    auxArray = [];
	                }
	            }
	            //this.$log.debug("antesDelete",this.arrayResul);
	            this.arrayResul = this.deleteRepeated(this.arrayResul);
	            //this.$log.debug("despuesDelete",this.arrayResul);
	            /*r = 1;
	             for(t=0;t<this.arrayResul.length;t++){
	             if(this.arrayResul[t][0]!=="Facts without Sources"){
	             this.arrayResul[t][13]=r;
	             r++;
	             }else{
	             this.arrayResul[t][13]=" ";
	             }
	      
	             }*/
	            var cont = 0;
	            var pagesev = [];
	            pagesev[0] = [];
	            for (t = 0; t < this.arrayResul.length; t++) {
	                if (cont < 5) {
	                    pagesev[index].push(this.arrayResul[t]);
	                    cont++;
	                }
	                else {
	                    cont = 1;
	                    index++;
	                    pagesev[index] = [];
	                    pagesev[index].push(this.arrayResul[t]);
	                }
	            }
	            var y = this.y + 5;
	            var pagMax = 0;
	            for (r = 0; r < pagesev.length; r++) {
	                for (var k = 0; k < pagesev[r].length; k++) {
	                    if (!!pagesev[r][k] && pagesev[r][k].length > pagMax) {
	                        pagMax = pagesev[r][k].length;
	                    }
	                }
	            }
	            for (t = 0; t < pagesev.length; t++) {
	                /*for(var s=0; s<5; s++){
	                 if(pagesev[t][s]){*/
	                //this.$log.debug("que pasa?", pagesev[t][s]);
	                if (t !== 0) {
	                    this.doc.addPage();
	                    this.pageNumber++;
	                    this.printHeader(txt1, txt2);
	                    this.printFooter();
	                    y = this.y + 5;
	                }
	                //this.$log.debug("pagesev",pagesev);
	                //////////PRINT ROWS/////////
	                //this.$log.debug("Rtlength2",this.rowsTitles);
	                //this.$log.debug("Largo",pagesev[t][0].length);
	                var rowLength = this.rowsTitles.length;
	                /*if(rowLength+3<14){
	                 rowLength+=3;
	                 }else{
	                 if(rowLength+2<14){
	                 rowLength+=2;
	                 }else{
	                 if(rowLength+1<14){
	                 rowLength+=1;
	                 }
	                 }
	                 }*/
	                //this.$log.debug("filas",pagesev[t]);
	                for (r = 0; r < rowLength + 3; r++) {
	                    //for(r=0;r<rowLength-1;r++){
	                    y = this.printRow(pagesev[t], y, r, evidences, txt1);
	                }
	                this.doc.line(this.x, y, ((this.maxX - this.x) / 6 * (pagesev[t].length + 1)) + this.x, y);
	            }
	        }
	        var e_1, _a, e_2, _b;
	    };
	    ReportsEvidenceAnalysisService.prototype.printeableArray = function (arr) {
	        //this.$log.debug("ENTRADA",arr);
	        var newarr = [];
	        var t, s;
	        for (s = 0; s < arr.length; s++) {
	            for (t = 0; t < arr[s].length; t++) {
	                newarr.push(arr[s][t]);
	            }
	        }
	        //this.$log.debug("newArr",newarr);
	        var sortedArr = this.insertionSort(newarr);
	        //this.$log.debug("sortedArr",sortedArr);
	        var auxkey = -1;
	        newarr = [];
	        var obj = [];
	        try {
	            //this.$log.debug("objeto",obj);
	            for (var sortedArr_1 = __values(sortedArr), sortedArr_1_1 = sortedArr_1.next(); !sortedArr_1_1.done; sortedArr_1_1 = sortedArr_1.next()) {
	                var item = sortedArr_1_1.value;
	                if (item.key === auxkey) {
	                    obj.arr.push(item.fact);
	                }
	                else {
	                    if (obj.key) {
	                        newarr.push(obj);
	                    }
	                    obj = [];
	                    obj.key = item.key;
	                    obj.arr = [];
	                    obj.arr.push(item.fact);
	                    //this.$log.debug("obj",obj);
	                    auxkey = item.key;
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (sortedArr_1_1 && !sortedArr_1_1.done && (_a = sortedArr_1.return)) _a.call(sortedArr_1);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        newarr.push(obj);
	        return newarr;
	        var e_3, _a;
	    };
	    ReportsEvidenceAnalysisService.prototype.sourceData = function (obj) {
	        //this.$log.debug("sourceData", obj);
	        //this.$log.debug("sourceDataArr", obj.arr);
	        var evidencesForFact = {
	            'arr': new Array(),
	            'key': new Array(),
	            'other': new Array()
	        };
	        var g;
	        for (var i = 0; i < obj.arr.length; i++) {
	            evidencesForFact.arr[i] = new Array();
	            evidencesForFact.key[i] = new Array();
	            evidencesForFact.other[i] = new Array();
	            try {
	                for (var _a = __values(obj.arr[i].evidencePersonas), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var item = _b.value;
	                    evidencesForFact.arr[i].push(this.evidenceMap.get(item[0]));
	                    evidencesForFact.key[i].push(item[1]);
	                }
	            }
	            catch (e_4_1) { e_4 = { error: e_4_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                }
	                finally { if (e_4) throw e_4.error; }
	            }
	        }
	        //this.$log.debug("evidencesForFact", evidencesForFact);
	        var key = obj.key;
	        var Obj = [];
	        for (g = 0; g < 3; g++) {
	            Obj[g] = "";
	        }
	        var source;
	        var evidence = this.evidenceMap.get(key);
	        var namesAndFacts = [];
	        //this.$log.debug("evidenciaSuelta",evidence);
	        if (!(!evidence)) {
	            var iterNames;
	            var generalItems = [];
	            var me;
	            var data;
	            var factsPersona;
	            var found = false;
	            var p = 0;
	            var h;
	            var dSort;
	            var about = false;
	            //evidencesForFact.other = [];
	            for (h = 0; h < evidencesForFact.arr.length; h++) {
	                namesAndFacts[h] = new Array();
	                //this.$log.debug("namesAndFacts[h]",namesAndFacts[h]);
	                //this.$log.debug("evidencesForFact.arr[h]",evidencesForFact.arr[h]);
	                while (p < evidencesForFact.arr[h].length) {
	                    //var j = 0;
	                    namesAndFacts[h][p] = new Array();
	                    data = evidencesForFact.arr[h][p].personas;
	                    //this.$log.debug("todos",data);
	                    //this.$log.debug("miClave",evidencesForFact.key[h][p]);
	                    var myKey = evidencesForFact.key[h][p];
	                    me = data.get(evidencesForFact.key[h][p]);
	                    var others = {
	                        Father: "",
	                        Mother: "",
	                        Spouse: ""
	                    };
	                    var otherKey;
	                    var otherPerson;
	                    var spouseArray = [];
	                    try {
	                        //this.$log.debug("evidencesForFact.arr[h][p].personas", evidencesForFact.arr[h][p].personas);
	                        for (var _d = __values(evidencesForFact.arr[h][p].personas), _e = _d.next(); !_e.done; _e = _d.next()) {
	                            var iterPeople = _e.value;
	                            //this.$log.debug("evidencesForFact.key[h][p]", evidencesForFact.key[h][p]);
	                            //this.$log.debug("iterPeople[1].relatedToKey", iterPeople[1].relatedToKey);
	                            if ((iterPeople[1]) && (iterPeople[1].relatedToKey === myKey) && (iterPeople[1].relationshipType === "FATHER")) {
	                                //The person is the FATHER for the person the report belongs to.
	                                others.Father = iterPeople[1];
	                            }
	                            else if ((iterPeople[1]) && (iterPeople[1].relatedToKey === myKey) && (iterPeople[1].relationshipType === "MOTHER")) {
	                                //The person is the MOTHER for the person the report belongs to.
	                                others.Mother = iterPeople[1];
	                            }
	                            else if ((iterPeople[1]) && (iterPeople[1].relationshipType === "SPOUSE")) {
	                                //Looking for spouses
	                                if (iterPeople[1].relatedToKey === myKey) {
	                                    spouseArray.push(iterPeople[1]);
	                                }
	                                else {
	                                    otherKey = iterPeople[1].relatedToKey;
	                                    otherPerson = data.get(otherKey);
	                                    if ((otherPerson) && (otherPerson.relatedToKey === myKey) && (otherPerson.relationshipType === "MOTHER")) {
	                                        others.Father = iterPeople[1];
	                                    }
	                                    else if ((otherPerson) && (otherPerson.relatedToKey === myKey) && (otherPerson.relationshipType === "FATHER")) {
	                                        others.Mother = iterPeople[1];
	                                    }
	                                }
	                            }
	                            else if ((iterPeople[1]) && (iterPeople[1].relationshipType === "MOTHER") || (iterPeople[1].relationshipType === "FATHER")) {
	                                otherKey = iterPeople[1].relatedToKey;
	                                otherPerson = data.get(otherKey);
	                                if ((otherPerson) && (otherPerson.relationshipType === "CHILD") && (otherPerson.relatedToKey === myKey)) {
	                                    spouseArray.push(iterPeople[1]);
	                                }
	                                else if (((me.relationshipType === "MOTHER") || (me.relationshipType === "FATHER")) && (me.relatedToKey === otherKey) && (iterPeople[0] !== myKey)) {
	                                    //this.$log.debug("entre",iterPeople[1]);
	                                    spouseArray.push(iterPeople[1]);
	                                }
	                            }
	                        }
	                    }
	                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
	                    finally {
	                        try {
	                            if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
	                        }
	                        finally { if (e_5) throw e_5.error; }
	                    }
	                    others.Spouse = spouseArray;
	                    //this.$log.debug("evidencesForFact.other[h]", evidencesForFact.other[h]);
	                    evidencesForFact.other[h][p] = others;
	                    //DUDOSA
	                    /*for(var iterEvi of evidence.personas){
	                     if((iterEvi[1].relatedToKey!==0)&&(iterEvi[1].relationshipType!=="")){
	                     others.push(iterEvi[1]);
	                     }
	                     }*/
	                    //this.$log.debug("iterandoEnpersonas",others);
	                    dSort = evidencesForFact.arr[h][p]._dateSort;
	                    //this.$log.debug("factPrincipal",evidencesForFact.arr[h][p].fact);
	                    //this.$log.debug("puedoPrincipal",me);
	                    var citation;
	                    var txt;
	                    var quot;
	                    //Facts
	                    if ((me.facts.size === 0) && (me.names.size === 0) && !((me.principal) && evidencesForFact.arr[h][p].fact.type !== "SOUR")) {
	                        //This evidence has to go to general sources section
	                        //this.$log.debug("esteNoEraPrincipal",evidencesForFact.arr[h][p]);
	                        citation = evidencesForFact.arr[h][p].citation;
	                        txt = citation.text;
	                        if (citation.sourceId > 0) {
	                            source = this.sourceMap.get(citation.sourceId);
	                            txt = this.utils.getCitation(source, evidencesForFact.arr[h][p].citation.url, evidencesForFact.arr[h][p].citation.page, evidencesForFact.arr[h][p].citation.date);
	                            //this.$log.debug("text", txt);
	                            if (!!txt) {
	                                found = false;
	                                g = 0;
	                                while ((!found) && (g < this.generalSources.length)) {
	                                    found = this.generalSources[g][0] === txt;
	                                    g++;
	                                }
	                                if (!found) {
	                                    generalItems.push(txt);
	                                }
	                            }
	                        }
	                        else {
	                            txt = citation.text;
	                            if (txt === "") {
	                                generalItems.push("Facts without Sources");
	                            }
	                            else {
	                                found = false;
	                                g = 0;
	                                while ((!found) && (g < this.generalSources.length)) {
	                                    found = this.generalSources[g][0] === txt;
	                                    g++;
	                                }
	                                if (!found) {
	                                    generalItems.push(txt);
	                                }
	                            }
	                        }
	                        if (generalItems.length > 0) {
	                            this.generalSources.push(generalItems);
	                            generalItems = [];
	                        }
	                        //this.$log.debug("trackGeneral",generalItems);
	                    }
	                    else {
	                        //These are the ones that will be finally printed in columns
	                        citation = evidencesForFact.arr[h][p].citation;
	                        txt = citation.text;
	                        /*If there is no source title, use whatever is in quotes from the source citation.
	                         If there's nothing in quotes, use the first 50 characters of the citation.
	                         If there's no citation at all, then write "Facts without Sources" instead of "No Source".*/
	                        if (citation.sourceId > 0) {
	                            source = this.sourceMap.get(citation.sourceId);
	                            //this.$log.debug("lafuente",source);
	                            txt = source.abbr;
	                            var txt2 = this.utils.getCitation(source, evidencesForFact.arr[h][p].citation.url, evidencesForFact.arr[h][p].citation.page, evidencesForFact.arr[h][p].citation.date);
	                            //this.$log.debug("text", txt);
	                            if (!!txt) {
	                                namesAndFacts[h][p].push(txt);
	                                found = false;
	                                g = 0;
	                                while ((!found) && (g < this.endNotes.length)) {
	                                    found = this.endNotes[g][0] === txt2;
	                                    g++;
	                                }
	                                if (!found) {
	                                    this.endNotesItem.push(txt2);
	                                }
	                            }
	                        }
	                        else {
	                            txt = citation.text;
	                            if (txt === "") {
	                                namesAndFacts[h][p].push("Facts without Sources");
	                                //this.$log.debug("todos",data);
	                            }
	                            else {
	                                found = false;
	                                g = 0;
	                                while ((!found) && (g < this.endNotes.length)) {
	                                    found = this.endNotes[g][0] === txt;
	                                    g++;
	                                }
	                                if (!found) {
	                                    this.endNotesItem.push(txt);
	                                }
	                                quot = txt.split("&quot;");
	                                if (quot.length > 1) {
	                                    namesAndFacts[h][p].push(quot[1]);
	                                }
	                                else {
	                                    quot = txt.substring(0, 50);
	                                    namesAndFacts[h][p].push(quot);
	                                }
	                            }
	                        }
	                        /*if(this.endNotesItem.length>0) {
	                         this.endNotes.push(this.endNotesItem);
	                         this.endNotesItem = [];
	                         }*/
	                        found = true;
	                        factsPersona = me.facts;
	                        var it = 0;
	                        iterNames = factsPersona.entries();
	                        //this.$log.debug("factsPersona.entries()",iterNames);
	                        while (it < factsPersona.size) {
	                            var aux = iterNames.next().value;
	                            //this.$log.debug("loqueguardo",aux[1]);
	                            namesAndFacts[h][p].push(aux[1]);
	                            //this.$log.debug("antes",evidencesForFact.arr[h][p]);
	                            if ((aux[1].type === "_AGE")) {
	                                about = true;
	                                //auxEndNotesAndSort.push(evidencesForFact.arr[h][p].fact.dateSort);
	                                //this.$log.debug("entro",auxEndNotesAndSort);
	                            }
	                            it++;
	                        }
	                        //Principal fact
	                        if ((me.principal) && (evidencesForFact.arr[h][p].fact.type !== "SOUR")) {
	                            namesAndFacts[h][p].push(evidencesForFact.arr[h][p].fact);
	                        }
	                        var names = me.names;
	                        //this.$log.debug("me.names",names);
	                        iterNames = names.entries().next().value;
	                        if (iterNames && iterNames[1].nameForms.has("default")) {
	                            var nameForms = iterNames[1].nameForms.get("default");
	                            namesAndFacts[h][p].push(nameForms.prefix + " " + nameForms.given + " " + nameForms.surname + " " + nameForms.suffix);
	                            Obj[1] = nameForms.prefix + " " + nameForms.given + " " + nameForms.surname + " " + nameForms.suffix;
	                        }
	                        else {
	                            namesAndFacts[h][p].push("");
	                        }
	                        namesAndFacts[h][p].push(evidencesForFact.other[h][p]);
	                    }
	                    var auxEndNotesAndSort = new Array();
	                    auxEndNotesAndSort.push(dSort);
	                    if (this.endNotesItem.length > 0) {
	                        auxEndNotesAndSort.push(this.endNotesItem);
	                        this.endNotesItem = [];
	                    }
	                    //this.$log.debug("antes",evidencesForFact.arr[h][p]);
	                    //this.$log.debug("esprincipal",me);
	                    if (about) {
	                        auxEndNotesAndSort.push(evidencesForFact.arr[h][p].fact.dateSort);
	                        //this.$log.debug("entro",auxEndNotesAndSort);
	                    }
	                    //SOLO PARA PROBAR HASTA QUE NO ENCUENTRE UN EJEMPLO QUE CUMPLA LO DE _AGE
	                    /*var fakeDate = "19000405";
	                     auxEndNotesAndSort.push(fakeDate);*/
	                    namesAndFacts[h][p].push(auxEndNotesAndSort);
	                    p++;
	                }
	                if (!found) {
	                    Obj[1] = "";
	                }
	            }
	            //this.$log.debug("namesAndFactsFull",namesAndFacts);
	            for (h = 0; h < namesAndFacts.length; h++) {
	                for (p = 0; p < namesAndFacts[h].length; p++) {
	                    //this.$log.debug("nfContent", namesAndFacts[h][p]);
	                    if (namesAndFacts[h][p] && namesAndFacts[h][p].length > 2) {
	                        this.Allevidences.push(namesAndFacts[h][p]);
	                        //resul = this.format(namesAndFacts[h][p]);
	                        //this.$log.debug("loquesale", resul);
	                        //this.arrayResul.push(resul);
	                    }
	                }
	            }
	            //this.$log.debug("this.Allevidences",this.Allevidences);
	        }
	        var e_4, _c, e_5, _f;
	    };
	    ReportsEvidenceAnalysisService.prototype.format = function (obj) {
	        var Obj = [];
	        //this.$log.debug("OBJformat",obj);
	        Obj[0] = obj.facts[0];
	        Obj[1] = obj.facts[obj.facts.length - 2];
	        Obj[2] = "";
	        //Obj[13] = obj.noteIndex;
	        var facts = [];
	        for (var h = 1; h < obj.facts.length - 1; h++) {
	            facts.push(obj.facts[h]);
	        }
	        var f;
	        //this.$log.debug("this.rowsTitles.length", this.rowsTitles);
	        var g;
	        for (g = 3; g < this.rowsTitles.length + 3; g++) {
	            Obj[g] = "";
	        }
	        var txt;
	        var noBirth = true;
	        var ageDate;
	        if (obj.extraDate) {
	            ageDate = obj.extraDate;
	        }
	        else {
	            ageDate = "";
	        }
	        for (f = 0; f < facts.length; f++) {
	            //this.$log.debug("factType", facts[f].type);
	            //this.$log.debug("infoFact",facts[f]);
	            txt = "";
	            if (facts[f].type === "_AGE") {
	                Obj[2] = facts[f].value;
	                //ageDate = facts[f].dateSort;
	                //this.$log.debug("infoFactAGE",facts[f]);
	            }
	            else {
	                for (g = 0; g < this.rowsTitles.length; g++) {
	                    var typeArr = this.rowsTitles[g];
	                    //this.$log.debug("typeArr", typeArr);
	                    //this.$log.debug("analizarFact",facts[f]);
	                    if (facts[f].type === typeArr) {
	                        //if ((facts[f].type === "OCCU") || (facts[f].type === "SEX")) {
	                        //txt = "Occupation: " + facts[f].value;
	                        //Obj[g + 3] = facts[f].value;
	                        // } else {
	                        if (facts[f].date) {
	                            txt = facts[f].date;
	                        }
	                        if (facts[f].place) {
	                            if (txt === "") {
	                                txt = this.utils.cleanPDF(facts[f].place);
	                            }
	                            else {
	                                txt = txt + "\n" + this.utils.cleanPDF(facts[f].place);
	                            }
	                        }
	                        if (facts[f].value) {
	                            if (txt === "") {
	                                txt = facts[f].value;
	                            }
	                            else {
	                                txt = txt + "\n" + facts[f].value;
	                            }
	                        }
	                        Obj[g + 3] = txt;
	                        if ((facts[f].type === "BIRT") && (facts[f].date !== "")) {
	                            noBirth = false;
	                        }
	                        //}
	                    }
	                }
	            }
	        }
	        var family = obj.facts[obj.facts.length - 1];
	        //this.$log.debug("family",family);
	        var father = family.Father;
	        var mother = family.Mother;
	        var Spouse = family.Spouse;
	        var ftext = "";
	        var mtext = "";
	        var stext = "";
	        if (!(!father)) {
	            ftext = this.FamilyData(father, obj.extraDate);
	        }
	        if (!(!mother)) {
	            mtext = this.FamilyData(mother, obj.extraDater);
	        }
	        if (!(!Spouse)) {
	            try {
	                for (var Spouse_1 = __values(Spouse), Spouse_1_1 = Spouse_1.next(); !Spouse_1_1.done; Spouse_1_1 = Spouse_1.next()) {
	                    var spo = Spouse_1_1.value;
	                    stext += this.FamilyData(spo, obj.extraDate);
	                }
	            }
	            catch (e_6_1) { e_6 = { error: e_6_1 }; }
	            finally {
	                try {
	                    if (Spouse_1_1 && !Spouse_1_1.done && (_a = Spouse_1.return)) _a.call(Spouse_1);
	                }
	                finally { if (e_6) throw e_6.error; }
	            }
	        }
	        Obj[Obj.length - 3] = ftext;
	        Obj[Obj.length - 2] = mtext;
	        Obj[Obj.length - 1] = stext;
	        //this.$log.debug("OBJNOW",Obj);
	        //this.$log.debug("noBirth",noBirth);
	        //this.$log.debug("Obj[2]",Obj[2]);
	        if ((noBirth) && (Obj[2] !== "")) {
	            if (ageDate !== "") {
	                var res = ageDate.substring(0, 4);
	                var Agetxt = "About ";
	                res = parseInt(res) - Obj[2];
	                Agetxt += res + "\n";
	                g = 0;
	                var birtRow = false;
	                while (!birtRow) {
	                    if (this.rowsTitles[g] === "BIRT") {
	                        birtRow = true;
	                    }
	                    g++;
	                }
	                if (Obj[g + 2] !== "") {
	                    Agetxt += Obj[g + 2];
	                }
	                Obj[g + 2] = Agetxt;
	            }
	        }
	        /* this.$log.debug("objetoAntesNotas",Obj);
	         //if(!((Obj.length===3)&&(Obj[1]==="")&&(Obj[2]===""))) {
	         if(Obj[1]!=="general"){
	         this.$log.debug("aca1", this.endNotes);
	         j = this.endNotes.length;
	         //j es el número que tendría que tener el cabezal de la columna que corresponda con esta endNote
	         //his.$log.debug("a2",evidenceItem);
	         var inserted = false;
	         this.$log.debug("endNotesAntes",this.endNotes);
	         for (var t = 0; t < this.endNotes.length; t++) {
	         if (evidenceItem[0] === this.endNotes[t][0]) {
	         inserted = true;
	         //////////////Hay que identificar el index con el fact al que pertence
	         index = t + 1;
	         }
	         }
	    
	         //if ((!inserted) && (evidence.citation.sourceId !== 0))
	         if ((!inserted) && !(Obj[0]==="")) {
	         if (evidenceItem.length > 0) {
	         this.endNotes[j] = evidenceItem;
	         var number = (j + 1).toString();
	         this.$log.debug("auxiliar", number);
	         //this.$log.debug("concat",aux.concat(number));
	         this.$log.debug("number", number);
	         if (Obj[this.rowsTitles.length+3] === "") {
	         Obj[this.rowsTitles.length+3] = number.toString();
	         } else {
	         Obj[this.rowsTitles.length+3] = Obj[this.rowsTitles.length+3] + "," + number.toString();
	         }
	    
	         this.$log.debug("Obj[13]", Obj[this.rowsTitles.length]);
	         this.$log.debug("EVIDENCEITEM", evidenceItem);
	         j++;
	         this.$log.debug("J antes", j);
	         //superscript += " " + j;
	         }
	         } else if (inserted) {
	         if (Obj[this.rowsTitles.length+3] === "") {
	         Obj[this.rowsTitles.length+3] = index.toString();
	         } else {
	         Obj[this.rowsTitles.length+3] = Obj[this.rowsTitles.length+3] + "," + index.toString();
	         }
	         }
	         }*/
	        Obj.push(obj.noteIndex);
	        //this.$log.debug("salidaFacts",Obj);
	        return Obj;
	        var e_6, _a;
	    };
	    ReportsEvidenceAnalysisService.prototype.FamilyData = function (famItem, extraDate) {
	        //this.$log.debug("famItem",famItem);
	        var famtxt = "";
	        var pNames = famItem.names;
	        var iterNames = pNames.entries().next().value;
	        if (iterNames && iterNames[1].nameForms.has("default")) {
	            var nameForms = iterNames[1].nameForms.get("default");
	            famtxt = nameForms.prefix + " " + nameForms.given + " " + nameForms.surname + " " + nameForms.suffix;
	        }
	        //this.$log.debug("pNames",pNames);
	        //this.$log.debug("famtxt",famtxt);
	        var pFacts = famItem.facts;
	        var birthOK = false;
	        var ageText;
	        var place;
	        var age;
	        try {
	            for (var pFacts_1 = __values(pFacts), pFacts_1_1 = pFacts_1.next(); !pFacts_1_1.done; pFacts_1_1 = pFacts_1.next()) {
	                var fitem = pFacts_1_1.value;
	                //this.$log.debug("fitem", fitem);
	                if (fitem[1].type === "BIRT") {
	                    if ((fitem[1].date) || (fitem[1].place)) {
	                        ageText = "\n" + "b. ";
	                        if (fitem[1].date) {
	                            birthOK = true;
	                            ageText += fitem[1].date;
	                            if (fitem[1].place) {
	                                place = this.utils.cleanPDF(fitem[1].place);
	                            }
	                        }
	                        else {
	                            if (fitem[1].place) {
	                                place = this.utils.cleanPDF(fitem[1].place);
	                            }
	                        }
	                    }
	                }
	                if (fitem[1].type === "_AGE") {
	                    age = fitem[1];
	                }
	            }
	        }
	        catch (e_7_1) { e_7 = { error: e_7_1 }; }
	        finally {
	            try {
	                if (pFacts_1_1 && !pFacts_1_1.done && (_a = pFacts_1.return)) _a.call(pFacts_1);
	            }
	            finally { if (e_7) throw e_7.error; }
	        }
	        if (!birthOK) {
	            //Calculate about birth date
	            if ((extraDate) && (age)) {
	                var res = extraDate / 10000;
	                //this.$log.debug("extraDate",age);
	                ageText = "\n" + "b. " + "About ";
	                res = res - parseInt(age.value);
	                ageText += res;
	                age = ageText;
	            }
	        }
	        else {
	            age = ageText;
	        }
	        if ((age) && (place)) {
	            famtxt += age + "\n" + place;
	        }
	        else if (age) {
	            famtxt += age;
	        }
	        else if (place) {
	            famtxt += place;
	        }
	        return famtxt;
	        var e_7, _a;
	    };
	    ReportsEvidenceAnalysisService.prototype.printRow = function (row, y, num, evidences, txt1) {
	        var r, f;
	        var cell = (this.maxX - this.x) / 6;
	        //this.$log.debug("rowling",row);
	        //this.$log.debug("rowlingNum",num);
	        var max = 0;
	        for (f = 0; f < row.length; f++) {
	            if (!!row[f]) {
	                var arraux = this.doc.splitTextToSize(row[f][num], cell - 4);
	                if (arraux.length > max) {
	                    max = arraux.length;
	                }
	            }
	        }
	        if (max * 4 + y + 5 > this.yFooter) {
	            this.doc.line(this.x, y, this.x + (cell * (row.length + 1)), y);
	            this.doc.addPage();
	            this.pageNumber++;
	            this.printHeader(txt1, this.today());
	            this.printFooter();
	            y = this.y + 5;
	        }
	        var txt = "";
	        if (num > 2) {
	            if (this.getType(evidences, this.rowsTitles[num - 3])) {
	                txt = this.getType(evidences, this.rowsTitles[num - 3]).display;
	                ////this.$log.debug("display",typeValue);
	            }
	            else {
	                txt = this.rowsTitles[num - 3];
	            }
	        }
	        else {
	            if (num === 2) {
	                txt = "Age";
	            }
	            else {
	                if (num === 1) {
	                    txt = "Name";
	                }
	            }
	        }
	        this.doc.line(this.x, y, this.x + cell, y);
	        //this.doc.line(this.x, y, this.x, y+5);
	        //this.doc.line(this.x+cell, y, this.x+cell, y+5);
	        if (txt) {
	            this.doc.text(this.x + 2, y + 4, txt);
	        }
	        max = 0;
	        for (f = 0; f < row.length; f++) {
	            this.doc.line(this.x + ((f + 1) * cell), y, this.x + cell + ((f + 1) * cell), y);
	            var parts;
	            //this.$log.debug("row[f][num]",row[f][num]);
	            //this.$log.debug("fffff",f);
	            if (num !== 0) {
	                if (!!row[f] && row[f][num] && row[f][num] !== "") {
	                    parts = this.doc.splitTextToSize(row[f][num], cell - 4);
	                    for (r = 0; r < parts.length; r++) {
	                        this.doc.text(this.x + 2 + ((f + 1) * cell), y + 4 + (4 * r), parts[r].trim());
	                    }
	                }
	                else if (!!row[f] && row[f][num]) {
	                    parts = "";
	                    this.doc.text(this.x + 2 + ((f + 1) * cell), y + 4 + (4 * r), row[f][num].trim());
	                    if (parts.length === 0) {
	                        this.doc.line(this.x + ((f + 1) * cell), y, this.x + cell + ((f + 1) * cell), y);
	                    }
	                }
	            }
	            else {
	                var totalLen = 0;
	                if (!!row[f] && row[f][num]) {
	                    parts = this.doc.splitTextToSize(row[f][num] + " " + row[f][row[f].length - 1], cell - 4);
	                    for (var i = 0; i < parts.length; i++) {
	                        totalLen = totalLen + parts[i].length;
	                    }
	                    var supra = " " + row[f][row[f].length - 1];
	                    var len = supra.length;
	                    var cont = 0;
	                    for (r = 0; r < parts.length; r++) {
	                        if (cont + parts[r].length < totalLen - len) {
	                            this.doc.text(this.x + 2 + ((f + 1) * cell), y + 4 + (4 * r), parts[r].trim());
	                            cont = cont + parts[r].length;
	                        }
	                        else if (cont + parts[r] === totalLen - len) {
	                            //En la que viene voy a imprimir el supra
	                            this.doc.text(this.x + 2 + ((f + 1) * cell), y + 4 + (4 * r), parts[r].trim());
	                            cont = cont + parts[r].length;
	                        }
	                        else {
	                            //cont tiene el largo de lo que ya imprimí
	                            //totalLen el largo de el total => totalLen - cont es el largo de lo que me falta
	                            //len es el largo del supra
	                            //totalLen - len es el largo de lo que no es supra
	                            var imp = parts[r].substring(0, totalLen - cont - len + 1);
	                            var aux_x = this.x + 2 + ((f + 1) * cell);
	                            this.doc.text(this.x + 2 + ((f + 1) * cell), y + 4 + (4 * r), imp);
	                            //this.$log.debug("documento",this.doc);
	                            var width = this.doc.getTextWidth(imp);
	                            this.doc.setFontSize(5);
	                            var imp2 = parts[r].substring(totalLen - cont - len + 1, parts[r].length);
	                            this.doc.text(aux_x + width, y + 4 + (4 * r) - 1, imp2);
	                            cont = 0;
	                        }
	                    }
	                }
	            }
	            this.doc.setFontSize(9);
	            //this.$log.debug("parts",parts);
	            //this.$log.debug("num",num);
	            //this.$log.debug("ffff",f);
	            if ((parts) && (parts.length > max)) {
	                max = parts.length;
	            }
	        }
	        //max--;
	        if (max > 0) {
	            this.doc.line(this.x, y, this.x, y + (5 * max));
	            this.doc.line(this.x + cell, y, this.x + cell, y + (5 * max));
	            for (f = 0; f < row.length; f++) {
	                this.doc.line(this.x + cell + (cell * (f + 1)), y, this.x + cell + (cell * (f + 1)), y + (5 * max));
	            }
	        }
	        else {
	            this.doc.line(this.x, y, this.x, y + (5 * 1));
	            this.doc.line(this.x + cell, y, this.x + cell, y + (5 * 1));
	            for (f = 0; f < row.length; f++) {
	                this.doc.line(this.x + cell + (cell * (f + 1)), y, this.x + cell + (cell * (f + 1)), y + (5 * 1));
	            }
	        }
	        //this.doc.line(this.x, y+(5*max), this.x+cell+(cell*row.length), y+(5*max));
	        if (max > 0) {
	            //this.$log.debug("maximo",max);
	            return y + (5 * max);
	        }
	        else {
	            return y + 5;
	        }
	    };
	    ReportsEvidenceAnalysisService.prototype.factSource = function (fact) {
	        var logAux = new Array();
	        var factSourceArr = [];
	        var j = 0;
	        var evidencePersonasMap = fact.evidencePersonas;
	        if (!(!evidencePersonasMap)) {
	            try {
	                for (var evidencePersonasMap_1 = __values(evidencePersonasMap), evidencePersonasMap_1_1 = evidencePersonasMap_1.next(); !evidencePersonasMap_1_1.done; evidencePersonasMap_1_1 = evidencePersonasMap_1.next()) {
	                    var _a = __read(evidencePersonasMap_1_1.value, 1), eid = _a[0];
	                    logAux[j] = eid;
	                    j++;
	                }
	            }
	            catch (e_8_1) { e_8 = { error: e_8_1 }; }
	            finally {
	                try {
	                    if (evidencePersonasMap_1_1 && !evidencePersonasMap_1_1.done && (_b = evidencePersonasMap_1.return)) _b.call(evidencePersonasMap_1);
	                }
	                finally { if (e_8) throw e_8.error; }
	            }
	        }
	        //this.$log.debug("log",logAux);
	        //var evidenceMap = this.evidenceMap;
	        var m = 0;
	        while (m < logAux.length) {
	            var key = logAux[m];
	            //var evidence = evidenceMap.get(key);
	            //this.$log.debug("evidenceTxt", evidence);
	            //var sourceId = evidence.citation.sourceId;
	            var obj = {
	                key: key,
	                fact: fact
	            };
	            factSourceArr.push(obj);
	            m++;
	        }
	        return factSourceArr;
	        var e_8, _b;
	    };
	    ReportsEvidenceAnalysisService.prototype.printFact = function (type, date, factValue, place, y, x, superscript) {
	        this.doc.line(x, y, x, y + 5);
	        this.doc.line(this.maxX, y, this.maxX, y + 5);
	        this.doc.line(x + 10, y, x + 10, y + 5);
	        this.doc.line(x + 50, y, x + 50, y + 5);
	        //this.doc.text(x + 12, y + 4, type);
	        var txt = type;
	        txt += " " + date;
	        var txtWidth = this.doc.getStringUnitWidth(txt);
	        txtWidth = (txtWidth * 10 * 25.4) / 72;
	        txtWidth += 2;
	        this.doc.text(x + 50 - txtWidth, y + 4, txt);
	        txt = (!!factValue ? factValue + ' ' : '') + place;
	        this.doc.text(x + 52, y + 4, txt);
	        var w = this.sentenceWidth(txt, 10);
	        //this.$log.debug("TIPO", type);
	        //this.$log.debug("FACT and PLACE", txt);
	        //this.$log.debug("superscript", superscript);
	        this.doc.setFontSize(5);
	        this.doc.text(x + 52 + w, y + 2, superscript);
	        this.doc.setFontSize(9);
	        this.doc.line(x + 10, y + 5, this.maxX, y + 5);
	    };
	    /*factData(fact, name){
	     var factDataArr = [];
	     var evidencePersonasMap = fact.evidencePersonas;
	     this.$log.debug(evidencePersonasMap);
	     var logAux = new Array();
	     var j = 0;
	     var birthDate = "";
	     var birthPlace = "";
	     if (!(! evidencePersonasMap)) {
	     for (let [eid] of evidencePersonasMap) {
	     logAux[j] = eid;
	     j++;
	     }
	     }
	     this.$log.debug("logAux",logAux);
	     var evidenceMap = this.evidenceMap;
	     var m=0;
	     if(fact.type=="BIRT"){
	     if(fact.date){
	     birthDate = fact.date;
	     }
	     if(fact.place){
	     birthPlace = fact.place;
	     }
	     }
	     while (m < logAux.length) {
	     var key = logAux[m];
	     var evidence = evidenceMap.get(key);
	     this.$log.debug("evidenceTxt", evidence);
	     var sourceId = evidence.citation.sourceId;
	     this.$log.debug("sourceId", sourceId);
	     var source = this.sourceMap.get(sourceId);
	     if(sourceId>0){
	     var obj = [];
	     obj[0] = source.abbr;
	     obj[1] = name;
	     obj[2] = birthDate;
	     obj[3] = birthPlace;
	     factDataArr.push(obj);
	     }
	     this.$log.debug("fact",fact);
	     this.$log.debug("source", source);
	     m++;
	     }
	     this.$log.debug("factData",factDataArr);
	     return factDataArr;
	     }*/
	    ReportsEvidenceAnalysisService.prototype.today = function () {
	        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	        var date = new Date();
	        var _date = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
	        return _date;
	    };
	    ReportsEvidenceAnalysisService.prototype.printHeader = function (txt1, txt2) {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.y;
	        var deltaYUnderline = this.deltaYUnderline;
	        doc.setFontSize(14);
	        doc.text(x, y, txt1);
	        var xRightAligned = maxX - 2 * txt2.length - 10;
	        doc.setFontSize(9);
	        doc.text(xRightAligned, y, txt2);
	        y = this.increaseY(y, deltaYUnderline, doc);
	        doc.line(x, y, maxX, y);
	    };
	    ReportsEvidenceAnalysisService.prototype.printFooter = function () {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.yFooter;
	        var pageNumber = this.pageNumber;
	        doc.line(x, y, maxX, y);
	        doc.setFontSize(9);
	        doc.text((x + maxX) / 2, y + 6, pageNumber + "");
	    };
	    ReportsEvidenceAnalysisService.prototype.increaseY = function (y, deltaY, doc) {
	        y += deltaY;
	        if (y >= this.yFooter) {
	            y = 20;
	            doc.addPage();
	            this.pageNumber++;
	            this.printHeader(this.txt1, this.today());
	            this.printFooter();
	            y = this.y + 10;
	        }
	        return y;
	    };
	    ReportsEvidenceAnalysisService.prototype.insertionSort = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = [];
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	        }
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            j = i - 1;
	            while (j >= 0 && first.key < copia[j].key) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        return (copia);
	    };
	    ReportsEvidenceAnalysisService.prototype.insertionSortWithNotes = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = [];
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	            //this.$log.debug("quee",arreglo[i]);
	            //this.$log.debug("quee2",copia[i]);
	        }
	        //this.$log.debug("original",arreglo);
	        //this.$log.debug("copiado",copia);
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //this.$log.debug("largo",n);
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            //this.$log.debug("first",first);
	            j = i - 1;
	            while (j >= 0 && first.key < copia[j].key) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        //this.$log.debug("copiado2",copia);
	        return (copia);
	    };
	    //This function sorts the values of a map and returns an array formed by the keys of those values sorted
	    ReportsEvidenceAnalysisService.prototype.insertionSortMap = function (unsortedMap) {
	        //initialize
	        var i = 0;
	        var p = 0;
	        var aux = [];
	        var resul = [];
	        var copia = new Array(unsortedMap.values());
	        try {
	            for (var _a = __values(unsortedMap.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var k = _b.value;
	                if (unsortedMap.get(k) !== "") {
	                    copia[i] = unsortedMap.get(k);
	                    resul[i] = k;
	                    i++;
	                }
	                else {
	                    aux[p] = k;
	                    p++;
	                }
	            }
	        }
	        catch (e_9_1) { e_9 = { error: e_9_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_9) throw e_9.error; }
	        }
	        var j = 0;
	        var first = 0;
	        var second;
	        var n = copia.length;
	        //sorting
	        for (i = 0; i < n; i++) {
	            first = copia[i];
	            second = resul[i];
	            j = i - 1;
	            while (j >= 0 && first < copia[j]) {
	                copia[j + 1] = copia[j];
	                resul[j + 1] = resul[j];
	                j--;
	            }
	            copia[j + 1] = first;
	            resul[j + 1] = second;
	        }
	        j = 0;
	        for (i = 0; i < aux.length; i++) {
	            first = aux[i];
	            j = i - 1;
	            while (j >= 0 && first < aux[j]) {
	                aux[j + 1] = aux[j];
	                j--;
	            }
	            aux[j + 1] = first;
	        }
	        resul = resul.concat(aux);
	        return (resul);
	        var e_9, _c;
	    };
	    ReportsEvidenceAnalysisService.prototype.loadPlaces = function () {
	        var places = this.insertionSort(this.placesIndex);
	        return { places: places };
	    };
	    ReportsEvidenceAnalysisService.prototype.evidencePersonasForeach = function (evidencePersonas, logAux, j) {
	        logAux = [];
	        j = 0;
	        evidencePersonas.forEach(function (persona, key) {
	            logAux[j] = key;
	            j++;
	        });
	    };
	    ReportsEvidenceAnalysisService.prototype.getType = function (evidences, type) {
	        return this.utils.factTypes.find(function (ft) { return ft.value === type; });
	    };
	    ReportsEvidenceAnalysisService.prototype.sentenceWidth = function (txt, fontsize) {
	        var w = this.doc.getStringUnitWidth(txt);
	        return (w * fontsize * 25.4) / 72;
	    };
	    ReportsEvidenceAnalysisService.prototype.sortedPrinteableArray = function (array) {
	        /*The evidence columns should be in date order by earliest primary event (earliest evidence.fact.dateSort).
	         Evidences with a blank primary event date sort last.
	         */
	        var result = [];
	        if (array.length > 0) {
	            var earliestDate = [];
	            for (var i = 0; i < array.length; i++) {
	                //this.$log.debug("laclave",array[i].key);
	                //this.$log.debug("elobjeto",this.evidenceMap.get(array[i].key));
	                var evidence = this.evidenceMap.get(array[i].key);
	                if (!!evidence) {
	                    var evidenceDate = evidence.fact.dateSort;
	                    earliestDate.push({ key: evidenceDate, evi: i });
	                }
	            }
	            earliestDate = this.insertionSort(earliestDate);
	            var k = 0;
	            var n = 0;
	            var aux = [];
	            try {
	                for (var earliestDate_1 = __values(earliestDate), earliestDate_1_1 = earliestDate_1.next(); !earliestDate_1_1.done; earliestDate_1_1 = earliestDate_1.next()) {
	                    var item = earliestDate_1_1.value;
	                    if (item.key !== 0) {
	                        result[k] = array[item.evi];
	                        k++;
	                    }
	                    else {
	                        aux[n] = array[item.evi];
	                        n++;
	                    }
	                }
	            }
	            catch (e_10_1) { e_10 = { error: e_10_1 }; }
	            finally {
	                try {
	                    if (earliestDate_1_1 && !earliestDate_1_1.done && (_a = earliestDate_1.return)) _a.call(earliestDate_1);
	                }
	                finally { if (e_10) throw e_10.error; }
	            }
	            for (n = 0; n < aux.length; n++) {
	                result[k] = aux[n];
	                k++;
	            }
	        }
	        return result;
	        var e_10, _a;
	    };
	    /* deleteRepeated(array){
	     var newArr = [];
	     newArr.push(array[0]);
	     var found, g, equal, row;
	     for(var t=1; t<array.length;t++){
	     found = false;
	     g=0;
	     while((g<newArr.length)&&(!found)){
	     ///////rows//////
	     equal = true;
	     row=0;
	     while((equal)&&(row<array[t].length)){
	     if(array[t][row]!==newArr[g][row]){
	     equal = false;
	     }
	     row++;
	     }
	     if(equal){
	     found = true;
	     }
	     g++;
	     }
	     if(!found){
	     newArr.push(array[t]);
	     }
	     }
	  
	     return newArr;
	     }*/
	    ReportsEvidenceAnalysisService.prototype.sortEvidences = function (arr) {
	        var KeyArr = [];
	        //this.$log.debug("dondesevan",arr);
	        var t, s;
	        var found;
	        //var g;
	        for (t = 0; t < arr.length; t++) {
	            var evkey = arr[t][arr[t].length - 1][0];
	            var evNote = arr[t][arr[t].length - 1][1];
	            var extraDate = arr[t][arr[t].length - 1][2];
	            KeyArr.push({
	                key: evkey,
	                arr: arr[t],
	                note: evNote,
	                extra: extraDate
	            });
	        }
	        //this.$log.debug("KeyArr",KeyArr);
	        var dateKey = [];
	        var undateKey = [];
	        for (t = 0; t < KeyArr.length; t++) {
	            if (KeyArr[t].key === "") {
	                undateKey.push(KeyArr[t]);
	            }
	            else {
	                dateKey.push(KeyArr[t]);
	            }
	        }
	        //this.$log.debug("datedKeyArr",dateKey);
	        //this.$log.debug("undatedKeyArr",undateKey);
	        var sortedDateKey = this.insertionSortWithNotes(dateKey);
	        //this.$log.debug("quepasoconlasnotas",this.endNotes);
	        //this.$log.debug("sortedDateKey",sortedDateKey);
	        var finalArray = [];
	        var item = [];
	        var index = 0;
	        for (t = 0; t < sortedDateKey.length; t++) {
	            item = [];
	            index = 0;
	            found = false;
	            for (s = 0; s < sortedDateKey[t].arr.length - 1; s++) {
	                item.push(sortedDateKey[t].arr[s]);
	                ////this.$log.debug("item",item);
	            }
	            for (s = 0; s < finalArray.length; s++) {
	                if (angular.toJson(finalArray[s].facts) === angular.toJson(item)) {
	                    found = true;
	                }
	            }
	            if (!found) {
	                if ((sortedDateKey[t].arr[0] !== "Facts without Sources") && (sortedDateKey[t].note)) {
	                    //this.$log.debug("notaa",sortedDateKey[t].note);
	                    this.endNotes.push(sortedDateKey[t].note);
	                    index = this.endNotes.length;
	                }
	                finalArray.push({
	                    extraDate: sortedDateKey[t].extra,
	                    facts: item, noteIndex: index
	                });
	            }
	        }
	        for (t = 0; t < undateKey.length; t++) {
	            item = [];
	            index = 0;
	            found = false;
	            for (s = 0; s < undateKey[t].arr.length - 1; s++) {
	                item.push(undateKey[t].arr[s]);
	            }
	            for (s = 0; s < finalArray.length; s++) {
	                if (angular.toJson(finalArray[s].facts) === angular.toJson(item)) {
	                    found = true;
	                }
	            }
	            if (!found) {
	                if ((undateKey[t].arr[0] !== "Facts without Sources") && (undateKey[t].note)) {
	                    //this.$log.debug("notaa2",undateKey[t].note);
	                    this.endNotes.push(undateKey[t].note);
	                    index = this.endNotes.length;
	                }
	                finalArray.push({
	                    extraDate: undateKey[t].extra,
	                    facts: item, noteIndex: index
	                });
	            }
	        }
	        //this.$log.debug("endNotesSorted",this.endNotes);
	        //this.$log.debug("finalArray",finalArray);
	        return finalArray;
	    };
	    ReportsEvidenceAnalysisService.prototype.deleteRepeated = function (array) {
	        //this.$log.debug("entradaDelete",array);
	        var newArr = [];
	        newArr.push(array[0]);
	        var found, g /*, equal, row*/;
	        for (var t = 1; t < array.length; t++) {
	            found = false;
	            g = 0;
	            while ((g < newArr.length) && (!found)) {
	                found = array[t][0] === newArr[g][0];
	                g++;
	            }
	            if (!found) {
	                newArr.push(array[t]);
	            }
	        }
	        //this.$log.debug("cosa",newArr);
	        return newArr;
	    };
	    return ReportsEvidenceAnalysisService;
	}());
	exports.default = ReportsEvidenceAnalysisService;


/***/ }),
/* 258 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Wilson Kellogg <wilson.kellogg@prosadata.com> - 2016
	 */
	var ReportsEndOfLineService = /** @class */ (function () {
	    ReportsEndOfLineService.$inject = ["$window", "rx"];
	    function ReportsEndOfLineService($window, rx) {
	        'ngInject';
	        this.$window = $window;
	        this.rx = rx;
	    }
	    ReportsEndOfLineService.prototype.create = function (jsPDF, $log, families, persons, evidences, utils, endNotes, indexOfPlaces, personMap, familyMap, evidenceMap, sourceMap) {
	        var readySubject = new this.rx.AsyncSubject();
	        this.doc = new jsPDF();
	        this.maxX = 188;
	        this.x = 20;
	        this.y = 20;
	        this.pageNumber = 1;
	        this.fromPage = 1;
	        this.deltaY = 5;
	        this.deltaYUnderline = 1;
	        this.deltaX = 6;
	        this.yFooter = 270;
	        this.people = [];
	        this.$log = $log;
	        //this.$log.debug("LOG", this.logarithm(6));
	        this.rootIndex = 0;
	        this.pending = [];
	        this.endNotes = [];
	        this.namesIndex = [];
	        this.placesIndex = [];
	        this.generation = 0;
	        this.persons = persons;
	        this.families = families;
	        this.utils = utils;
	        var doc = this.doc;
	        this.personMap = personMap;
	        this.familyMap = familyMap;
	        this.sourceMap = sourceMap;
	        this.evidenceMap = evidenceMap;
	        this.people = this.getTree(families);
	        //this.$log.debug("sin padres", this.personsNoParents);
	        var txt1 = 'Individual List';
	        var reportName = txt1;
	        var txt2 = this.today();
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        this.y = this.y + 10;
	        this.printPeople(evidences, persons, utils);
	        //this.$log.debug("notas", this.namesIndex);
	        this.deltaY = 5;
	        this.deltaX = 6;
	        this.x = 20;
	        this.y = 20;
	        this.deltaYUnderline = 1;
	        if (this.endNotes.length > 0) {
	            doc.addPage();
	            txt1 = 'Endnotes';
	            this.printHeader(txt1, txt2);
	            this.pageNumber++;
	            this.printFooter();
	            endNotes.setDoc(this.doc);
	            endNotes.setX(this.x);
	            endNotes.setY(this.y);
	            endNotes.setDeltaY(this.deltaY);
	            endNotes.setDeltaYUnderline(this.deltaYUnderline);
	            endNotes.setDeltaX(this.deltaX);
	            endNotes.setPageNumber(this.pageNumber);
	            endNotes.setEndNotes(this.endNotes);
	            endNotes.printNotes();
	            this.pageNumber = endNotes.getPageNumber();
	        }
	        doc.addPage();
	        this.pageNumber++;
	        txt1 = 'Index of Places';
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        indexOfPlaces.setDoc(this.doc);
	        indexOfPlaces.setX(this.x);
	        indexOfPlaces.setY(this.y);
	        indexOfPlaces.setDeltaY(this.deltaY);
	        indexOfPlaces.setDeltaYUnderline(this.deltaYUnderline);
	        indexOfPlaces.setDeltaX(this.deltaX);
	        indexOfPlaces.setPageNumber(this.pageNumber);
	        indexOfPlaces.setPlacesIndex(this.placesIndex);
	        indexOfPlaces.printPlaces();
	        var blob = doc.output('blob');
	        //if (this.$window.navigator && this.$window.navigator.msSaveOrOpenBlob) {
	        //  this.$window.navigator.msSaveOrOpenBlob(blob);
	        //}
	        //else {
	        //  //var objectUrl = URL.createObjectURL(blob);
	        //  this.$window.open((this.$window.URL || this.$window.webkitURL).createObjectURL(blob));
	        //}
	        readySubject.next({ blob: blob, name: reportName, ext: 'pdf' });
	        readySubject.complete();
	        return readySubject;
	    };
	    ReportsEndOfLineService.prototype.printPeople = function (evidences, persons, utils) {
	        var sorted = this.insertionSort(this.personsNoParents);
	        var txt, n, s;
	        var y = this.y;
	        var Birth, Death, BirthDate, DeathDate;
	        try {
	            for (var sorted_1 = __values(sorted), sorted_1_1 = sorted_1.next(); !sorted_1_1.done; sorted_1_1 = sorted_1.next()) {
	                var p = sorted_1_1.value;
	                var nf = persons.getDefaultNameForm(persons.getPreferredName(p.person));
	                var name = !!nf ? nf.given : '';
	                var surname = !!nf ? nf.surname : '';
	                //var name = p.person._given;
	                //var surname = p.person._surname;
	                var id = utils.encodeId(p.person.id);
	                txt = "";
	                txt = surname + ", " + name + " (" + id + ") ";
	                if (p.person.gender === "MALE") {
	                    txt += " (M)";
	                }
	                else {
	                    txt += " (F)";
	                }
	                var sortedFact = [];
	                BirthDate = null;
	                DeathDate = null;
	                Birth = persons.getPreferredBirth(p.person);
	                Death = persons.getPreferredDeath(p.person);
	                if (!(!Birth)) {
	                    BirthDate = Birth.dateSort;
	                    sortedFact.push({ key: BirthDate, fact: Birth });
	                }
	                if (!(!Death)) {
	                    DeathDate = Death.dateSort;
	                    sortedFact.push({ key: DeathDate, fact: Death });
	                }
	                this.doc.setFontType("bold");
	                this.doc.text(this.x, y, txt);
	                this.doc.setFontType("normal");
	                y = this.increaseY(y, 5, this.doc);
	                //this.y=this.y+5;
	                n = this.namesIndex.length;
	                var keyName = surname + " " + name;
	                this.namesIndex[n] = { key: keyName, firstName: name, lastName: surname, page: this.pageNumber, id: p.person.id };
	                var facts = p.person.facts;
	                //this.$log.debug("FACT", facts);
	                var type = "";
	                var place = "";
	                var date = "";
	                var dateSort = "";
	                var typeValue = "";
	                var printText = "";
	                var placekey;
	                var diffDate;
	                try {
	                    for (var facts_1 = __values(facts), facts_1_1 = facts_1.next(); !facts_1_1.done; facts_1_1 = facts_1.next()) {
	                        var item = facts_1_1.value;
	                        if ((item[1].principal) && (item[1].type === "MARR")) {
	                            var dateSorting = item[1].dateSort;
	                            sortedFact.push({ key: dateSorting, fact: item[1] });
	                        }
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (facts_1_1 && !facts_1_1.done && (_a = facts_1.return)) _a.call(facts_1);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                sortedFact = this.insertionSort(sortedFact);
	                try {
	                    //this.$log.debug("SORTED FACTS", sortedFact);
	                    for (var sortedFact_1 = __values(sortedFact), sortedFact_1_1 = sortedFact_1.next(); !sortedFact_1_1.done; sortedFact_1_1 = sortedFact_1.next()) {
	                        var item = sortedFact_1_1.value;
	                        printText = "";
	                        diffDate = 0;
	                        type = item.fact.type;
	                        if ((type === "BIRT") || (type === "MARR") || (type === "DEAT")) {
	                            if (item.fact.principal) {
	                                if (this.getType(evidences, type)) {
	                                    typeValue = this.getType(evidences, type).display;
	                                }
	                                else {
	                                    typeValue = type;
	                                }
	                                //var SplitTypeValue = this.doc.splitTextToSize(typeValue, 30);
	                                //this.doc.text(this.x + 5, y, SplitTypeValue[0]);
	                                //this.doc.text(this.x+5,y,typeValue);
	                                date = item.fact.date;
	                                dateSort = item.fact.dateSort;
	                                if (!(!date)) {
	                                    if (!(!BirthDate)) {
	                                        diffDate = utils.yearDiff(dateSort, BirthDate);
	                                        //this.$log.debug("diff Birth y event", diffDate);
	                                    }
	                                    date = date.toLowerCase();
	                                    date = date.charAt(0).toUpperCase() + date.slice(1);
	                                    date = this.FindLowcase(date);
	                                    printText += date + " ";
	                                }
	                                place = utils.cleanPDF(item.fact.place);
	                                if (!(!place)) {
	                                    var placeArr = place.split(",");
	                                    var place1, place2, place3;
	                                    var placeText;
	                                    switch (placeArr.length) {
	                                        case 1:
	                                            place1 = placeArr[0].trim();
	                                            place2 = "";
	                                            place3 = "";
	                                            placeText = place1;
	                                            break;
	                                        case 2:
	                                            place1 = placeArr[1].trim();
	                                            if (place1 === "United States") {
	                                                place1 = placeArr[0].trim();
	                                                place2 = "";
	                                                placeText = place1;
	                                            }
	                                            else {
	                                                place2 = placeArr[0].trim();
	                                                placeText = place1 + ", " + place2;
	                                            }
	                                            place3 = "";
	                                            break;
	                                        case 3:
	                                            place1 = placeArr[2].trim();
	                                            if (place1 === "United States") {
	                                                place1 = placeArr[1].trim();
	                                                place2 = placeArr[0].trim();
	                                                place3 = "";
	                                                placeText = place1 + ", " + place2;
	                                            }
	                                            else {
	                                                place2 = placeArr[1].trim();
	                                                place3 = placeArr[0].trim();
	                                                placeText = place1 + ", " + place2 + ", " + place3;
	                                            }
	                                            break;
	                                        default:
	                                            var f;
	                                            place1 = placeArr[placeArr.length - 1].trim();
	                                            if (place1 === "United States") {
	                                                place1 = placeArr[placeArr.length - 2].trim();
	                                                place2 = placeArr[placeArr.length - 3].trim();
	                                                place3 = placeArr[placeArr.length - 4].trim();
	                                                for (f = placeArr.length - 5; f >= 0; f--) {
	                                                    place3 += ", " + placeArr[f].trim();
	                                                }
	                                                placeText = place1 + ", " + place2 + ", " + place3;
	                                            }
	                                            else {
	                                                place2 = placeArr[placeArr.length - 2].trim();
	                                                place3 = placeArr[placeArr.length - 3].trim();
	                                                for (f = placeArr.length - 4; f >= 0; f--) {
	                                                    place3 += ", " + placeArr[f].trim();
	                                                }
	                                                placeText = place1 + ", " + place2 + ", " + place3;
	                                            }
	                                    }
	                                    placekey = place1;
	                                    if (place2 !== "") {
	                                        placekey += " " + place2;
	                                        if (place3 !== "") {
	                                            placekey += " " + place3;
	                                        }
	                                    }
	                                    n = this.placesIndex.length;
	                                    this.placesIndex[n] = {
	                                        key: placekey,
	                                        place1: place1,
	                                        place2: place2,
	                                        place3: place3,
	                                        place: place,
	                                        page: this.pageNumber
	                                    };
	                                    if (printText.length > 0) {
	                                        printText += "in " + placeText;
	                                    }
	                                    else {
	                                        printText = "of " + placeText;
	                                    }
	                                }
	                                if (!(!diffDate)) {
	                                    if (diffDate > 0) {
	                                        printText += " (about age " + diffDate + ")";
	                                    }
	                                }
	                                printText = typeValue + ": " + printText;
	                                var splitPrintText = this.doc.splitTextToSize(printText, 148);
	                                //this.doc.text(this.x + 50, y, splitPrintText[0]);
	                                //y = this.increaseY(y, 5, this.doc);
	                                for (s = 0; s < splitPrintText.length; s++) {
	                                    this.doc.text(this.x + 10, y, splitPrintText[s]);
	                                    y = this.increaseY(y, 5, this.doc);
	                                }
	                                /*if ((splitPrintText.length > 1) || (SplitTypeValue.length > 1)) {
	                                 if (splitPrintText.length > SplitTypeValue.length) {
	                                 for (s = 1; s < splitPrintText.length; s++) {
	                                 this.doc.text(this.x + 50, y, splitPrintText[s]);
	                                 if (!(!SplitTypeValue[s])) {
	                                 this.doc.text(this.x + 10, y, SplitTypeValue[s]);
	                                 }
	                                 y = this.increaseY(y, 5, this.doc);
	                                 }
	                                 } else {
	                                 for (s = 1; s < SplitTypeValue.length; s++) {
	                                 this.doc.text(this.x + 10, y, SplitTypeValue[s]);
	                                 if (!(!splitPrintText[s])) {
	                                 this.doc.text(this.x + 50, y, splitPrintText[s]);
	                                 }
	                                 y = this.increaseY(y, 5, this.doc);
	                                 }
	                                 }
	                                 }*/
	                                //this.doc.text(this.x+50,y,splitPrintText[0]);
	                                //y=this.increaseY(y,5,this.doc);
	                            }
	                        }
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (sortedFact_1_1 && !sortedFact_1_1.done && (_b = sortedFact_1.return)) _b.call(sortedFact_1);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (sorted_1_1 && !sorted_1_1.done && (_c = sorted_1.return)) _c.call(sorted_1);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        var e_3, _c, e_1, _a, e_2, _b;
	    };
	    ReportsEndOfLineService.prototype.getType = function (evidences, type) {
	        return this.utils.factTypes.find(function (ft) { return ft.value === type; });
	    };
	    /*printPeople(persons, txt1, txt2,utils){
	     var p = this.people;
	     //var doc = this.doc;
	     //var maxX = this.maxX;
	     //var x = this.x;
	     this.deltaY = this.y+10;
	     //var deltaYUnderline = this.deltaYUnderline;
	     //var pageNumber = this.pageNumber;
	     //var fromPage = this.fromPage;
	     //var rootIndex = this.rootIndex;
	     //var gen = this.generation;
	     this.printHeader(txt1, txt2);
	     this.printFooter();
	     this.$log.debug("personas",p);
	     //var k=0;
	     var txtTitle;
	     var cont=1;
	     var gen;
	  
	     for(var k=0;k<p.length; k++){
	     /*if (this.logarithm(k+1)){
	     gen++;
	     }
	     //this.$log.debug("PER",p[k].per);
	     if(p[k]){
	     //y=this.increaseY(y, this.deltaYUnderline, this.doc);
	     gen=p[k].gen;
	     this.$log.debug("PER",p[k].gen);
	     this.$log.debug("GEN",gen);
	     this.$log.debug("numGenerations",this.numGenerations);
	     if(gen <= this.numGenerations){
	     this.$log.debug("person",p[k].per.get("_fullName"));
	     this.$log.debug("K",k);
	     this.printPerson(p[k].per,cont,k+1,gen,utils);
	     txtTitle = p[k].per.get("_fullName");
	     this.$log.debug("persona",txtTitle);
	     cont++;
	     }
	     }
	     }
	     }*/
	    ReportsEndOfLineService.prototype.today = function () {
	        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	        var date = new Date();
	        var _date = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
	        return _date;
	    };
	    //getTree(families, root, persons){
	    ReportsEndOfLineService.prototype.getTree = function () {
	        var personMap = this.personMap;
	        var personsNoParents = [];
	        try {
	            for (var personMap_1 = __values(personMap), personMap_1_1 = personMap_1.next(); !personMap_1_1.done; personMap_1_1 = personMap_1.next()) {
	                var per = personMap_1_1.value;
	                //this.$log.debug("per", per);
	                var found = false;
	                try {
	                    for (var _a = __values(this.familyMap), _b = _a.next(); !_b.done; _b = _a.next()) {
	                        var _c = __read(_b.value, 2), f = _c[1];
	                        if (f.childRels.has(per[0]) && (f.husbandId > 0 || f.wifeId > 0)) {
	                            found = true;
	                            break;
	                        }
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	                //this.$log.debug("allParents", allParents);
	                if (!found) {
	                    //this.$log.debug("SIN PADRES");
	                    var nf = this.persons.getDefaultNameForm(this.persons.getPreferredName(per[1]));
	                    var firstName = !!nf ? nf.given : '';
	                    var lastName = !!nf ? nf.surname : '';
	                    //var firstName = per[1]._given.trim();
	                    //var lastName = per[1]._surname.trim();
	                    var key = lastName + " " + firstName;
	                    personsNoParents.push({ key: key, person: per[1] });
	                    /*if(preferredParents.get('husbandId')!==0){
	                     var husbandId = preferredParents.get('husbandId');
	                     this.$log.debug("husband", husbandId);
	                     }
	                     if(preferredParents.get('wifeId')!==0){
	                     var wifeId = preferredParents.get('wifeId');
	                     this.$log.debug("wife", wifeId);
	                     }*/
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (personMap_1_1 && !personMap_1_1.done && (_e = personMap_1.return)) _e.call(personMap_1);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        this.personsNoParents = personsNoParents;
	        var e_5, _e, e_4, _d;
	        /*for(var i=0;i<personMap.length;i++){
	         var allParents = this.familyMap.filter(f => f.getIn(['childRels', personMap[i]]));
	         this.$log.debug("allParents", allParents);
	         }*/
	    };
	    ReportsEndOfLineService.prototype.printHeader = function (txt1, txt2) {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.y;
	        var deltaYUnderline = this.deltaYUnderline;
	        doc.setFontSize(14);
	        doc.text(x, y, txt1);
	        var xRightAligned = maxX - 2 * txt2.length - 10;
	        doc.setFontSize(10);
	        doc.text(xRightAligned, y, txt2);
	        y = this.increaseY(y, deltaYUnderline, doc);
	        doc.line(x, y, maxX, y);
	    };
	    ReportsEndOfLineService.prototype.printFooter = function () {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.yFooter;
	        var pageNumber = this.pageNumber;
	        doc.line(x, y, maxX, y);
	        doc.setFontSize(10);
	        doc.text((x + maxX) / 2, y + 6, pageNumber + "");
	    };
	    ReportsEndOfLineService.prototype.increaseY = function (y, deltaY, doc) {
	        y += deltaY;
	        if (y >= this.yFooter) {
	            y = 20;
	            doc.addPage();
	            this.pageNumber++;
	            var text = "Individual List";
	            this.printHeader(text, this.today());
	            this.printFooter();
	            y = this.y + 10;
	        }
	        return y;
	    };
	    ReportsEndOfLineService.prototype.insertionSort = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = [];
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	        }
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            j = i - 1;
	            while (j >= 0 && first.key < copia[j].key) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        return (copia);
	    };
	    ReportsEndOfLineService.prototype.insertionSortFacts = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = [];
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	        }
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            j = i - 1;
	            while (j >= 0 && first[1].dateSort < copia[j][1].dateSort) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        return (copia);
	    };
	    ReportsEndOfLineService.prototype.FindLowcase = function (text) {
	        var text2 = text;
	        if (text2.search("jan") !== (-1)) {
	            text2 = text2.substr(0, text2.search("jan")) + "J" + text2.substr(text2.search("jan") + 1);
	        }
	        if (text2.search("feb") !== (-1)) {
	            text2 = text2.substr(0, text2.search("feb")) + "F" + text2.substr(text2.search("feb") + 1);
	        }
	        if (text2.search("mar") !== (-1)) {
	            text2 = text2.substr(0, text2.search("mar")) + "M" + text2.substr(text2.search("mar") + 1);
	        }
	        if (text2.search("apr") !== (-1)) {
	            text2 = text2.substr(0, text2.search("apr")) + "A" + text2.substr(text2.search("apr") + 1);
	        }
	        if (text2.search("may") !== (-1)) {
	            text2 = text2.substr(0, text2.search("may")) + "M" + text2.substr(text2.search("may") + 1);
	        }
	        if (text2.search("jun") !== (-1)) {
	            text2 = text2.substr(0, text2.search("jun")) + "J" + text2.substr(text2.search("jun") + 1);
	        }
	        if (text2.search("jul") !== (-1)) {
	            text2 = text2.substr(0, text2.search("jul")) + "J" + text2.substr(text2.search("jul") + 1);
	        }
	        if (text2.search("aug") !== (-1)) {
	            text2 = text2.substr(0, text2.search("aug")) + "A" + text2.substr(text2.search("aug") + 1);
	        }
	        if (text2.search("sep") !== (-1)) {
	            text2 = text2.substr(0, text2.search("sep")) + "S" + text2.substr(text2.search("sep") + 1);
	        }
	        if (text2.search("oct") !== (-1)) {
	            text2 = text2.substr(0, text2.search("oct")) + "O" + text2.substr(text2.search("oct") + 1);
	        }
	        if (text2.search("nov") !== (-1)) {
	            text2 = text2.substr(0, text2.search("nov")) + "N" + text2.substr(text2.search("nov") + 1);
	        }
	        if (text2.search("dec") !== (-1)) {
	            text2 = text2.substr(0, text2.search("dec")) + "D" + text2.substr(text2.search("dec") + 1);
	        }
	        //this.$log.debug(text2);
	        return text2;
	    };
	    /*printPerson(per,cont,k,gen,utils){
	     //this.deltaY = this.increaseY(this.deltaY, 8, this.doc);
	     if(gen !== this.generation){
	     this.doc.setFontType("bold");
	     this.doc.text(this.x,this.deltaY,"GENERATION "+ gen);
	     this.deltaY = this.increaseY(this.deltaY, 5, this.doc);
	     this.generation=gen;
	     this.doc.setFontType("normal");
	     }
	     var nametxt = "";
	     nametxt = per.get("_fullName") + " (" + utils.encodeId(per.get("id")) + ")";
	     var firstName = per.get("_given").trim();
	     var lastName = per.get("_surname").trim();
	     n = this.namesIndex.length;
	     var keyName = lastName + " " + firstName;
	     this.namesIndex[n] = {key : keyName, firstName : firstName, lastName : lastName, page : this.pageNumber};
	     //this.doc.text(this.x+5, this.deltaY, nametxt);
	     //var dim = this.doc.getTextDimensions(nametxt);
	     this.doc.setTextColor(0,0,0);
	     var facts = per.get('facts');
	     var width = 165;
	     var txtP = "";
	     var txtB = "";
	     var txtD = "";
	     var txtM = "";
	     var personEvents = [];
	     var n;
	     let j=0;
	     var superscript = "";
	     var separator = "";
	     let evidenceMap = this.evidenceMap;
	     var ii = 0;
	     this.$log.debug("facts.size",facts.size);
	     for (let item of facts){
	     ii++;
	     separator = (ii>1) ? ((ii===facts.size) ? "" : "; ") : separator;
	     this.$log.debug("Items",item);
	     this.$log.debug("ItemsMAP", evidenceMap);
	     var type = item.fact.get('type');
	     if(item.fact.get('principal')){
	     switch(type) {
	     case 'BIRT':
	     txtB = "born " +  item.fact.get('date');
	     if (!(!item.fact.get('place'))){
	     txtB += ' in ' + item.fact.get('place');
	     }
	     txtB += separator;
	     break;
	     case "MARR" :
	     txtM = "married " +  item.fact.get('date');
	     if (!(!item.fact.get('place'))){
	     txtM += ' in ' + item.fact.get('place');
	     }
	     txtM += separator;
	     break;
	     case "DEAT" :
	     txtD = "died " +  item.fact.get('date');
	     if (!(!item.fact.get('place'))){
	     txtD += ' in ' + item.fact.get('place');
	     }
	     //txtD += ';';
	     }
	     personEvents[j] = item.fact;
	     j++;
	     }
	     }
	     this.$log.debug("personEvents",personEvents);
	  
	     if (!(!personEvents)) {
	     //$log.debug("Events length",events.length);
	     if (personEvents.length > 0) {
	     for (let item of personEvents) {
	     //$log.debug("item",item);
	     //$log.debug("date",item.get("date"));
	     //y += 4;
	     //var _date = item.get("date");
	     //var _type = item.get("type");
	     //$log.debug("type",_type);
	     var evidencePersonas = item.get("evidencePersonas");
	     //$log.debug("evidencePersonas",evidencePersonas);
	     //$log.debug("this.evidenceMapBEFOREforEach",this.evidenceMap);
	     var logAux = [];
	     j = 0;
	     this.evidencePersonasForeach(evidencePersonas,logAux,j);
	     //var evidenceMap = this.evidenceMap;
	     //$log.debug("this.evidenceMapINforEach",this.evidenceMap);
	     //$log.debug("logAux",logAux);
	     //var superscript = "";
	     if (j>0) {
	     var m = 0;
	     var evidenceItem = [];
	     while (m < logAux.length){
	     var key = logAux[m];
	     var evidence = evidenceMap.get(key);
	     //$log.debug("evidence",evidence);
	     var citation = evidence.get("citation");
	     //this.$log.debug("citation",citation);
	     var txt = citation.get("text");
	     //this.$log.debug("text",txt);
	     m++;
	     if(!!txt){
	     evidenceItem.push(txt);
	     this.$log.debug("KEY",txt);
	     }
	     else {
	     var sourceId = citation.get("sourceId");
	     if (sourceId > 0) {
	     var source = this.sourceMap.get(sourceId);
	     txt = utils.getCitation(source, evidence.getIn(['citation', 'url'], ''), evidence.getIn(['citation','url'], ''), evidence.getIn(['citation','date'], ''));
	     //this.$log.debug("text",txt);
	     if (!!txt){
	     evidenceItem.push(txt);
	     this.$log.debug("KEY",txt);
	     }
	     }
	     }
	     }
	     j = this.endNotes.length;
	     if(evidenceItem.length>0){
	     this.endNotes[j] = evidenceItem;
	     this.$log.debug("EVIDENCEITEM",evidenceItem);
	     j++;
	     superscript += " " + j;
	     }
	     //superscript = "" +j;
	     }
	  
	     //var place = item.get("place");
	     var standardPlace = item.get("place");
	     this.$log.debug("PALCE", standardPlace);
	     if (!(! standardPlace)) {
	     var placeArr = standardPlace.split(",");
	     /*for (var l = placeArr.length - 1; l < 2; l++) {
	     placeArr[l+1] = "";
	     }
	     var place1, place2, place3;
	     switch(placeArr.length) {
	     case 1:
	     place1 = placeArr[0].trim();
	     place2 = "";
	     place3 = "";
	     break;
	     case 2:
	     place1 = placeArr[1].trim();
	     if (place1 === "United States") {
	     place1 = placeArr[0].trim();
	     place2 = "";
	  
	     } else {
	     place2 = placeArr[0].trim();
	     }
	     place3 = "";
	     break;
	     case 3:
	     place1 = placeArr[2].trim();
	     if (place1 === "United States") {
	     place1 = placeArr[1].trim();
	     place2 = placeArr[0].trim();
	     place3 = "";
	     } else {
	     place2 = placeArr[1].trim();
	     place3 = placeArr[0].trim();
	     }
	     break;
	     default:
	     var f;
	     place1 = placeArr[placeArr.length - 1].trim();
	     if (place1 === "United States") {
	     place1 = placeArr[placeArr.length - 2].trim();
	     place2 = placeArr[placeArr.length - 3].trim();
	     place3 = placeArr[placeArr.length - 4].trim();
	     for (f = placeArr.length - 5; f >= 0; f--) {
	     place3 += " " + placeArr[f].trim();
	     }
	     } else {
	     place2 = placeArr[placeArr.length - 2].trim();
	     place3 = placeArr[placeArr.length - 3].trim();
	     for (f = placeArr.length - 4; f >= 0; f--) {
	     place3 += " " + placeArr[f].trim();
	     }
	     }
	     }
	     var keyPlace = place1;
	     if (place2.length > 0) {
	     keyPlace += " " + place2;
	     }
	     if (place3.length > 0) {
	     keyPlace += " " + place3;
	     }
	     //$log.debug("keyPlace",keyPlace);
	     n = this.placesIndex.length;
	     this.placesIndex[n] = {key : keyPlace, place1: place1, place2 : place2, place3 : place3, place : standardPlace, page: this.pageNumber};
	     }
	     }
	     }
	     }
	     var lineFull = "";
	     var txtW = cont + ". ";
	     lineFull += txtW;
	     this.doc.text(this.x, this.deltaY, txtW);
	     var xLine = this.sentenceWidth(txtW,10);
	     //this.$log.debug("NOMBRE", txt);
	     //this.doc.setTextColor(0,153,0);
	     this.doc.text(this.x+xLine, this.deltaY, nametxt);
	     txtW += nametxt.trim();
	     lineFull += nametxt;
	     this.$log.debug("lineFull2",lineFull);
	     var V = this.sentenceWidth(txtW,10);
	     //this.doc.setTextColor(0, 0, 0);
	     if(superscript!==""){
	     this.doc.setFontSize(5);
	     this.doc.text(this.x + this.sentenceWidth(txtW.trim(), 10), this.deltaY - 2, superscript);
	     V += this.sentenceWidth(superscript,5);
	     this.doc.setFontSize(10);
	     }
	     txtP += ': ' + txtB + txtM  + txtD;
	     if((txtB!=="") || (txtM!=="") || (txtD!=="")){
	     txtP += ".";
	     }
	     lineFull += "$" + txtP;
	     this.$log.debug("lineFull",lineFull);
	     var parts = this.doc.splitTextToSize(lineFull, width);
	     //var parts = txtP.match(/.{1,300}/g);
	     for (j = 0; j<parts.length; j++){
	     if (j===0) {
	     var split = parts[j].split("$");
	     this.doc.text(this.x + V + 2, this.deltaY, split[1].trim());
	     }
	     else {
	     this.doc.text(this.x + 5, this.deltaY, parts[j].trim());
	     }
	  
	     //this.deltaY=this.deltaY+8;
	     this.deltaY=this.increaseY(this.deltaY,5,this.doc);
	     this.$log.debug("VALOR Y", this.deltaY);
	     }
	     //this.deltaY=this.deltaY+10;
	     //this.doc.setTextColor(0,0,0);
	     }*/
	    ReportsEndOfLineService.prototype.sentenceWidth = function (txt, fontsize) {
	        var w = this.doc.getStringUnitWidth(txt);
	        return (w * fontsize * 25.4) / 72;
	    };
	    return ReportsEndOfLineService;
	}());
	exports.default = ReportsEndOfLineService;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Wilson Kellogg <wilson.kellogg@prosadata.com> - 2016

	 */
	var ReportsFamilyGroupService = /** @class */ (function () {
	    ReportsFamilyGroupService.$inject = ["$window", "rx"];
	    function ReportsFamilyGroupService($window, rx) {
	        'ngInject';
	        this.$window = $window;
	        this.rx = rx;
	    }
	    ReportsFamilyGroupService.prototype.create = function (jsPDF, $log, rootFamily, families, persons, evidences, utils, endNotes, indexOfNames, indexOfPlaces, personMap, familyMap, evidenceMap, sourceMap) {
	        var readySubject = new this.rx.AsyncSubject();
	        this.doc = new jsPDF();
	        this.maxX = 190;
	        this.x = 20;
	        this.y = 20;
	        this.pageNumber = 1;
	        this.fromPage = 1;
	        this.deltaY = 5;
	        this.deltaYUnderline = 1;
	        this.deltaX = 6;
	        this.yFooter = 270;
	        //this.family = [];
	        this.$log = $log;
	        this.rootIndex = 0;
	        this.pending = [];
	        this.family = [];
	        this.endNotes = [];
	        this.namesIndex = [];
	        this.placesIndex = [];
	        this.father = null;
	        this.mother = null;
	        this.currentPerson = null;
	        this.utils = utils;
	        this.persons = persons;
	        var doc = this.doc;
	        //let root = parseInt(tu.getIn(['preferences', 'ROOT'], '0'), 10);
	        //$log.debug("root " , root);
	        this.personMap = personMap;
	        this.familyMap = familyMap;
	        this.evidenceMap = evidenceMap;
	        this.sourceMap = sourceMap;
	        //$log.debug("FamilyMap", familyMap);
	        this.family = this.loadFamily(rootFamily);
	        var txt1 = 'Family Group Sheet';
	        var reportName = txt1;
	        var txt2 = this.today();
	        //this.printTree(txt1, txt2);
	        //while (this.pending.length > 0) {
	        //	var aux = this.pending.splice(0,1)[0];
	        //	root = aux.root;
	        //	this.rootIndex = aux.i;
	        //	this.fromPage = aux.fromPage;
	        //	this.family = this.loadFamily(families, root, persons, rootSpouse);
	        //	//this.printTree( persons, txt1, txt2);
	        //}
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        this.y = this.increaseY(this.y, 5, doc);
	        //this.doc.line(this.x, this.y, this.maxX, this.y);
	        this.father = this.family.find(function (ft) { return ft.member === "father"; });
	        if (!(!this.father)) {
	            this.printFather(this.father, evidences, families, persons, utils);
	        }
	        this.mother = this.family.find(function (ft) { return ft.member === "mother"; });
	        if (!(!this.mother)) {
	            this.printMother(this.mother, evidences, families, persons, utils);
	        }
	        this.printChildTitle(this.x, this.y);
	        this.y = this.increaseY(this.y, 5, doc);
	        var children = this.family.find(function (ft) { return ft.member === "son"; });
	        var childrenO = this.insertionSort(children.person);
	        try {
	            for (var childrenO_1 = __values(childrenO), childrenO_1_1 = childrenO_1.next(); !childrenO_1_1.done; childrenO_1_1 = childrenO_1.next()) {
	                var item = childrenO_1_1.value;
	                this.currentPerson = item;
	                this.printChild(item, evidences, utils);
	                //this.$log.debug("item",item);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (childrenO_1_1 && !childrenO_1_1.done && (_a = childrenO_1.return)) _a.call(childrenO_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        //this.$log.debug("hijo", this.family.find(ft => ft.member ==== "son"));
	        this.x = 20;
	        this.y = 20;
	        if (this.endNotes.length > 0) {
	            doc.addPage();
	            this.pageNumber++;
	            //this.$log.debug("family", this.family);
	            txt1 = 'Endnotes';
	            this.printHeader(txt1, txt2);
	            this.printFooter();
	            endNotes.setDoc(this.doc);
	            endNotes.setX(this.x);
	            endNotes.setY(this.y);
	            endNotes.setMaxX(this.maxX);
	            endNotes.setyFooter(this.yFooter);
	            endNotes.setDeltaY(this.deltaY);
	            endNotes.setDeltaYUnderline(this.deltaYUnderline);
	            endNotes.setDeltaX(this.deltaX);
	            endNotes.setPageNumber(this.pageNumber);
	            endNotes.setEndNotes(this.endNotes);
	            endNotes.printNotes();
	            this.pageNumber = endNotes.getPageNumber();
	        }
	        doc.addPage();
	        this.pageNumber++;
	        txt1 = 'Index of Names';
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        indexOfNames.setDoc(this.doc);
	        indexOfNames.setX(this.x);
	        indexOfNames.setY(this.y);
	        indexOfNames.setDeltaY(this.deltaY);
	        indexOfNames.setDeltaYUnderline(this.deltaYUnderline);
	        indexOfNames.setDeltaX(this.deltaX);
	        indexOfNames.setPageNumber(this.pageNumber);
	        indexOfNames.setNamesIndex(this.namesIndex);
	        indexOfNames.printNames();
	        this.pageNumber = indexOfNames.getPageNumber();
	        doc.addPage();
	        this.pageNumber++;
	        txt1 = 'Index of Places';
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        indexOfPlaces.setDoc(this.doc);
	        indexOfPlaces.setX(this.x);
	        indexOfPlaces.setY(this.y);
	        indexOfPlaces.setDeltaY(this.deltaY);
	        indexOfPlaces.setDeltaYUnderline(this.deltaYUnderline);
	        indexOfPlaces.setDeltaX(this.deltaX);
	        indexOfPlaces.setPageNumber(this.pageNumber);
	        indexOfPlaces.setPlacesIndex(this.placesIndex);
	        indexOfPlaces.printPlaces();
	        var blob = doc.output('blob');
	        //if (this.$window.navigator && this.$window.navigator.msSaveOrOpenBlob) {
	        //  this.$window.navigator.msSaveOrOpenBlob(blob);
	        //}
	        //else {
	        //  //var objectUrl = URL.createObjectURL(blob);
	        //  this.$window.open((this.$window.URL || this.$window.webkitURL).createObjectURL(blob));
	        //}
	        readySubject.next({ blob: blob, name: reportName, ext: 'pdf' });
	        readySubject.complete();
	        return readySubject;
	        var e_1, _a;
	    };
	    ReportsFamilyGroupService.prototype.today = function () {
	        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	        var date = new Date();
	        var _date = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
	        return _date;
	    };
	    ReportsFamilyGroupService.prototype.insertionSort = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = [];
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	        }
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            j = i - 1;
	            while (j >= 0 && first.key < copia[j].key) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        return (copia);
	    };
	    ReportsFamilyGroupService.prototype.insertionSortFact = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = [];
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	        }
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            j = i - 1;
	            while (j >= 0 && (first.key1 < copia[j].key1 || (first.key1 === copia[j].key1 && first.key2 < copia[j].key2) || (first.key1 === copia[j].key1 && first.key2 === copia[j].key2 && first.key3 < copia[j].key3))) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        return (copia);
	    };
	    ReportsFamilyGroupService.prototype.increaseY = function (y, deltaY, doc) {
	        y += deltaY;
	        if (y + 5 >= this.yFooter) {
	            if (this.pageNumber === 1) {
	                this.doc.line(this.x, y, this.x + 10, y);
	                this.y = 20;
	                this.pageNumber++;
	                this.NewPageFamily();
	                y = this.y;
	            }
	            else {
	                y = 20;
	                this.pageNumber++;
	                doc.addPage();
	            }
	        }
	        return y;
	    };
	    ReportsFamilyGroupService.prototype.loadFamily = function (rootFamily) {
	        var family = [];
	        var childs = [];
	        if (rootFamily.husbandId > 0) {
	            family.push({ member: "father", person: this.personMap.get(rootFamily.husbandId) });
	        }
	        if (rootFamily.wifeId > 0) {
	            family.push({ member: "mother", person: this.personMap.get(rootFamily.wifeId) });
	        }
	        try {
	            //this.$log.debug("size", Object.keys(rootFamily.childRels));
	            //if(!(!rootFamily.childRels)){
	            for (var _a = __values(rootFamily.childRels), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var item = _b.value;
	                var child = this.personMap.get(item[0]);
	                if (!(!child)) {
	                    //this.$log.debug("child", child);
	                    childs.push({ item: child, key: child._birthDateSort });
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        //}
	        family.push({ member: "son", person: childs });
	        return family;
	        var e_2, _c;
	    };
	    //loadFamily(families,root,persons,rootSpouse){
	    //	let person = this.personMap.get(root);
	    //	let childs = [];
	    //	var family = [];
	    //	var date,splitdate;
	    //	if(rootSpouse===null){
	    //		if(person.gender==="MALE"){
	    //			family.push({member: "father", person: person});
	    //			for(let p of this.personMap){
	    //				var allParents = this.familyMap.filter(f => f.getIn(['childRels', p[1].id]));
	    //				if(allParents.length>0){
	    //					var preferredParents = families.getPreferredFamily(allParents, p[1].preferredParentsFamilyId);
	    //					if(preferredParents.husbandId===root){
	    //						date = persons.getPreferredBirth(p[1]);
	    //						if (!(!date)) {
	    //							splitdate = date.date.split(" ");
	    //						}
	    //						else {
	    //							splitdate = " ";
	    //						}
	    //						childs.push({item: p[1], key:splitdate[splitdate.length-1]});
	    //						this.$log.debug("hijo", p[1]._fullName);
	    //					}
	    //				}
	    //			}
	    //			family.push({member: "son", person: childs});
	    //			this.$log.debug("family",family);
	    //			return family;
	    //		}else{
	    //			family.push({member: "mother", person: person});
	    //			for(let p of this.personMap){
	    //				var allParents = this.familyMap.filter(f => f.getIn(['childRels', p[1].id]));
	    //				if(allParents.length>0){
	    //					var preferredParents = families.getPreferredFamily(allParents, p[1].preferredParentsFamilyId);
	    //					if(preferredParents.wifeId===root){
	    //						date = persons.getPreferredBirth(p[1]);
	    //						if (!(!date)) {
	    //							splitdate = date.date.split(" ");
	    //						}
	    //						else {
	    //							splitdate = " ";
	    //						}
	    //						childs.push({item: p[1], key:splitdate[splitdate.length-1]});
	    //						this.$log.debug("hijo", p[1]._fullName);
	    //					}
	    //				}
	    //			}
	    //			family.push({member: "son", person: childs});
	    //			this.$log.debug("family",family);
	    //			return family;
	    //		}
	    //
	    //	}else{
	    //		let Spouse = this.personMap.get(rootSpouse);
	    //		if(person.gender==="MALE"){
	    //			family.push({member: "father", person: person});
	    //			family.push({member: "mother", person: Spouse});
	    //			this.$log.debug("FAMILY",family);
	    //		}else{
	    //			family.push({member: "father", person: Spouse});
	    //			family.push({member: "mother", person: person});
	    //		}
	    //		var mID = family.filter(f => f.member==="mother")[0].person.id;
	    //		var fID = family.filter(f => f.member==="father")[0].person.id;
	    //		for(let p of this.personMap){
	    //			var allParents = this.familyMap.filter(f => f.getIn(['childRels', p[1].id]));
	    //			if(allParents.length>0){
	    //				var preferredParents = families.getPreferredFamily(allParents, p[1].preferredParentsFamilyId);
	    //				this.$log.debug("PARENTS", preferredParents);
	    //				this.$log.debug("husbandId", preferredParents.husbandId);
	    //				this.$log.debug("father", fID);
	    //				this.$log.debug("IF", fID);
	    //				if(((preferredParents.husbandId!==0) && (preferredParents.wifeId!==0))&&((preferredParents.husbandId===fID)&&(preferredParents.wifeId===mID))){
	    //						childs.push({item: p[1], key:p[1]._birthDateSort});
	    //						this.$log.debug("hijo", p[1]._fullName);
	    //				}
	    //			}
	    //		}
	    //		family.push({member: "son", person: childs});
	    //		return family;
	    //	}
	    //
	    //	this.$log.debug("root",person._fullName);
	    //	this.$log.debug("spouse",Spouse._fullName);
	    //
	    //
	    //}
	    /*loadFamily(families,root,persons){
	     var personMap = this.personMap;
	     var familyMap = this.familyMap;
	     var family = [];
	     let son = personMap.get(root);
	     var allParents = familyMap.filter(f => f.getIn(['childIds', root]));
	     if(allParents.length>0){
	     var preferredParents = families.getPreferredFamily(allParents, son.preferredParentsFamilyId);
	     if(preferredParents.husbandId!==0){
	     var husbandId = preferredParents.husbandId;
	     }
	     if(preferredParents.wifeId!==0){
	     var wifeId = preferredParents.wifeId;
	     }
	     }
	     let father = personMap.get(husbandId);
	     this.$log.debug("family",familyMap);
	     this.$log.debug("preferredParents",preferredParents);
	     let mother = personMap.get(wifeId);
	     let childsID = preferredParents.childIds;
	     //this.$log.debug("root",root);
	     let childs = [];
	     var date, splitdate;
	     for (let item of childsID){
	     var child = personMap.get(item[0]);
	     this.$log.debug("child",child);
	     date = persons.getPreferredBirth(child);
	     //this.$log.debug("p",p);
	     //this.$log.debug("date",date.date);
	     if (!(!date)) {
	     splitdate = date.date.split(" ");
	     }
	     else {
	     splitdate = " ";
	     }
	  
	     childs.push({item: child, key:splitdate[splitdate.length-1]});
	     }
	     this.$log.debug("childs",childs);
	     family.push({member: "father", person: father});
	     family.push({member: "mother", person: mother});
	     family.push({member: "son", person: childs});
	     return family;
	     //this.family = family;
	     }*/
	    ReportsFamilyGroupService.prototype.printFather = function (father, evidences, families, persons, utils) {
	        var x = this.x;
	        var y = this.y;
	        var key;
	        var type, factValue, place, date, typeValue;
	        var nf = persons.getDefaultNameForm(persons.getPreferredName(father.person));
	        var fullName = persons.getNameText(nf, false);
	        var firstName = !!nf ? nf.given : '';
	        var lastName = !!nf ? nf.surname : '';
	        this.printname("Father" + " " + fullName, x, y);
	        //var personId = person.id;
	        //var firstName = father.person._given.trim();
	        //var lastName = father.person._surname.trim();
	        var keyName = lastName + " " + firstName;
	        var n = this.namesIndex.length;
	        var husbandId;
	        var wifeId;
	        this.namesIndex[n] = {
	            key: keyName,
	            firstName: firstName,
	            lastName: lastName,
	            page: this.pageNumber,
	            id: father.person.id
	        };
	        y = this.increaseY(y, 5, this.doc);
	        var factsMap = father.person.facts;
	        var factO = [];
	        try {
	            for (var factsMap_1 = __values(factsMap), factsMap_1_1 = factsMap_1.next(); !factsMap_1_1.done; factsMap_1_1 = factsMap_1.next()) {
	                var item = factsMap_1_1.value;
	                var dateKey = item[1].date;
	                key = dateKey.split(" ");
	                var key1 = 9999;
	                var key2 = 9999;
	                var key3 = 9999;
	                if (key[key.length - 1]) {
	                    key1 = key[key.length - 1];
	                }
	                if (key[key.length - 2]) {
	                    key2 = key[key.length - 2];
	                }
	                if (key[key.length - 3]) {
	                    key3 = key[key.length - 3];
	                }
	                factO.push({ fact: item[1], key1: key1, key2: key2, key3: key3 });
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (factsMap_1_1 && !factsMap_1_1.done && (_a = factsMap_1.return)) _a.call(factsMap_1);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        var facts = [];
	        facts = this.insertionSortFact(factO);
	        try {
	            for (var facts_1 = __values(facts), facts_1_1 = facts_1.next(); !facts_1_1.done; facts_1_1 = facts_1.next()) {
	                var item = facts_1_1.value;
	                if (item.fact.principal) {
	                    var superscript = "";
	                    type = item.fact.type;
	                    var evidencePersonasMap = item.fact.evidencePersonas;
	                    //this.$log.debug("evidencePersonas", evidencePersonasMap);
	                    var logAux = [];
	                    var j = 0;
	                    if (!(!evidencePersonasMap)) {
	                        try {
	                            for (var evidencePersonasMap_1 = __values(evidencePersonasMap), evidencePersonasMap_1_1 = evidencePersonasMap_1.next(); !evidencePersonasMap_1_1.done; evidencePersonasMap_1_1 = evidencePersonasMap_1.next()) {
	                                var _b = __read(evidencePersonasMap_1_1.value, 1), eid = _b[0];
	                                logAux[j] = eid;
	                                j++;
	                            }
	                        }
	                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                        finally {
	                            try {
	                                if (evidencePersonasMap_1_1 && !evidencePersonasMap_1_1.done && (_c = evidencePersonasMap_1.return)) _c.call(evidencePersonasMap_1);
	                            }
	                            finally { if (e_4) throw e_4.error; }
	                        }
	                        //this.$log.debug("J despues", j);
	                        var evidenceMap = this.evidenceMap;
	                        if (j > 0) {
	                            //this.$log.debug("ENTRE?", j);
	                            var m = 0;
	                            var evidenceItem = [];
	                            //this.$log.debug("logAux.length", logAux.length);
	                            while (m < logAux.length) {
	                                key = logAux[m];
	                                var evidence = evidenceMap.get(key);
	                                //this.$log.debug("evidence", evidence);
	                                var citation = evidence.citation;
	                                //this.$log.debug("citation", citation);
	                                var txt = citation.text;
	                                //this.$log.debug("text", txt);
	                                m++;
	                                if (!!txt) {
	                                    evidenceItem.push(txt);
	                                    //this.$log.debug("KEY", txt);
	                                }
	                                else {
	                                    var sourceId = citation.sourceId;
	                                    if (sourceId > 0) {
	                                        var source = this.sourceMap.get(sourceId);
	                                        txt = utils.getCitation(source, evidence.citation.url, evidence.citation.page, evidence.citation.date);
	                                        //this.$log.debug("text", txt);
	                                        if (!!txt) {
	                                            evidenceItem.push(txt);
	                                            //this.$log.debug("KEY", txt);
	                                        }
	                                    }
	                                }
	                            }
	                            j = this.endNotes.length;
	                            //this.$log.debug("evidenceItem.length", evidenceItem.length);
	                            if (evidenceItem.length > 0) {
	                                this.endNotes[j] = evidenceItem;
	                                //this.$log.debug("EVIDENCEITEM", evidenceItem);
	                                j++;
	                                //this.$log.debug("J antes", j);
	                                superscript += " " + j;
	                            }
	                            //superscript = "" +j;
	                        }
	                    }
	                    if (!(!this.getType(evidences, type))) {
	                        typeValue = this.getType(evidences, type).display;
	                    }
	                    else {
	                        typeValue = type;
	                    }
	                    //this.$log.debug("TYPE", type);
	                    if (type !== "SOUR") {
	                        place = this.utils.cleanPDF(item.fact.place);
	                        factValue = item.fact.value;
	                        date = item.fact.date;
	                        this.printFact(typeValue, date, factValue, place, y, x, superscript);
	                        y = this.increaseY(y, 5, this.doc);
	                        if (!(!place)) {
	                            var placeArr = place.split(",");
	                            /*for (var l = placeArr.length - 1; l < 2; l++) {
	                             placeArr[l+1] = "";
	                             }*/
	                            var place1, place2, place3;
	                            switch (placeArr.length) {
	                                case 1:
	                                    place1 = placeArr[0].trim();
	                                    place2 = "";
	                                    place3 = "";
	                                    break;
	                                case 2:
	                                    place1 = placeArr[1].trim();
	                                    if (place1 === "United States") {
	                                        place1 = placeArr[0].trim();
	                                        place2 = "";
	                                    }
	                                    else {
	                                        place2 = placeArr[0].trim();
	                                    }
	                                    place3 = "";
	                                    break;
	                                case 3:
	                                    place1 = placeArr[2].trim();
	                                    if (place1 === "United States") {
	                                        place1 = placeArr[1].trim();
	                                        place2 = placeArr[0].trim();
	                                        place3 = "";
	                                    }
	                                    else {
	                                        place2 = placeArr[1].trim();
	                                        place3 = placeArr[0].trim();
	                                    }
	                                    break;
	                                default:
	                                    var f;
	                                    place1 = placeArr[placeArr.length - 1].trim();
	                                    if (place1 === "United States") {
	                                        place1 = placeArr[placeArr.length - 2].trim();
	                                        place2 = placeArr[placeArr.length - 3].trim();
	                                        place3 = placeArr[placeArr.length - 4].trim();
	                                        for (f = placeArr.length - 5; f >= 0; f--) {
	                                            place3 += " " + placeArr[f].trim();
	                                        }
	                                    }
	                                    else {
	                                        place2 = placeArr[placeArr.length - 2].trim();
	                                        place3 = placeArr[placeArr.length - 3].trim();
	                                        for (f = placeArr.length - 4; f >= 0; f--) {
	                                            place3 += " " + placeArr[f].trim();
	                                        }
	                                    }
	                            }
	                            var keyPlace = place1;
	                            if (place2.length > 0) {
	                                keyPlace += " " + place2;
	                            }
	                            if (place3.length > 0) {
	                                keyPlace += " " + place3;
	                            }
	                            //$log.debug("keyPlace",keyPlace);
	                            n = this.placesIndex.length;
	                            this.placesIndex[n] = {
	                                key: keyPlace,
	                                place1: place1,
	                                place2: place2,
	                                place3: place3,
	                                place: place,
	                                page: this.pageNumber
	                            };
	                        }
	                    }
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (facts_1_1 && !facts_1_1.done && (_d = facts_1.return)) _d.call(facts_1);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        var allParentsMap = new Map(Array.from(this.familyMap.entries()).filter(function (_a) {
	            var _b = __read(_a, 2), f = _b[1];
	            return !!f.childRels.get(father.person.id);
	        }));
	        //this.$log.debug("abuelos", allParentsMap);
	        if (allParentsMap.size > 0) {
	            var preferredParents = families.getPreferredFamily(allParentsMap, father.person.preferredParentsFamilyId);
	            if (preferredParents.husbandId !== 0) {
	                husbandId = preferredParents.husbandId;
	            }
	            if (preferredParents.wifeId !== 0) {
	                wifeId = preferredParents.wifeId;
	            }
	        }
	        var grandfather = this.personMap.get(husbandId);
	        var grandmother = this.personMap.get(wifeId);
	        y = this.printGrandParent(grandfather, grandmother, x, y, persons);
	        this.y = y;
	        var e_3, _a, e_5, _d, e_4, _c;
	    };
	    ReportsFamilyGroupService.prototype.printMother = function (mother, evidences, families, persons, utils) {
	        var x = this.x;
	        var y = this.y;
	        var key;
	        var type, factValue, place, date, typeValue;
	        var nf = persons.getDefaultNameForm(persons.getPreferredName(mother.person));
	        var fullName = persons.getNameText(nf, false);
	        var firstName = !!nf ? nf.given : '';
	        var lastName = !!nf ? nf.surname : '';
	        this.printname("Mother" + " " + fullName, x, y);
	        //var firstName = mother.person._given.trim();
	        //var lastName = mother.person._surname.trim();
	        var keyName = lastName + " " + firstName;
	        var n = this.namesIndex.length;
	        this.namesIndex[n] = {
	            key: keyName,
	            firstName: firstName,
	            lastName: lastName,
	            page: this.pageNumber,
	            id: mother.person.id
	        };
	        y = this.increaseY(y, 5, this.doc);
	        var factsMap = mother.person.facts;
	        var factO = [];
	        var husbandId;
	        var wifeId;
	        try {
	            for (var factsMap_2 = __values(factsMap), factsMap_2_1 = factsMap_2.next(); !factsMap_2_1.done; factsMap_2_1 = factsMap_2.next()) {
	                var item = factsMap_2_1.value;
	                var dateKey = item[1].date;
	                key = dateKey.split(" ");
	                var key1 = 9999;
	                var key2 = 9999;
	                var key3 = 9999;
	                if (key[key.length - 1]) {
	                    key1 = key[key.length - 1];
	                }
	                if (key[key.length - 2]) {
	                    key2 = key[key.length - 2];
	                }
	                if (key[key.length - 3]) {
	                    key3 = key[key.length - 3];
	                }
	                factO.push({ fact: item[1], key1: key1, key2: key2, key3: key3 });
	            }
	        }
	        catch (e_6_1) { e_6 = { error: e_6_1 }; }
	        finally {
	            try {
	                if (factsMap_2_1 && !factsMap_2_1.done && (_a = factsMap_2.return)) _a.call(factsMap_2);
	            }
	            finally { if (e_6) throw e_6.error; }
	        }
	        var facts = [];
	        facts = this.insertionSortFact(factO);
	        try {
	            for (var facts_2 = __values(facts), facts_2_1 = facts_2.next(); !facts_2_1.done; facts_2_1 = facts_2.next()) {
	                var item = facts_2_1.value;
	                if (item.fact.principal) {
	                    var superscript = "";
	                    type = item.fact.type;
	                    var evidencePersonasMap = item.fact.evidencePersonas;
	                    //this.$log.debug("evidencePersonas", evidencePersonasMap);
	                    var logAux = [];
	                    var j = 0;
	                    if (!(!evidencePersonasMap)) {
	                        try {
	                            for (var evidencePersonasMap_2 = __values(evidencePersonasMap), evidencePersonasMap_2_1 = evidencePersonasMap_2.next(); !evidencePersonasMap_2_1.done; evidencePersonasMap_2_1 = evidencePersonasMap_2.next()) {
	                                var _b = __read(evidencePersonasMap_2_1.value, 1), eid = _b[0];
	                                logAux[j] = eid;
	                                j++;
	                            }
	                        }
	                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
	                        finally {
	                            try {
	                                if (evidencePersonasMap_2_1 && !evidencePersonasMap_2_1.done && (_c = evidencePersonasMap_2.return)) _c.call(evidencePersonasMap_2);
	                            }
	                            finally { if (e_7) throw e_7.error; }
	                        }
	                        //this.$log.debug("J despues", j);
	                        var evidenceMap = this.evidenceMap;
	                        if (j > 0) {
	                            //this.$log.debug("ENTRE?", j);
	                            var m = 0;
	                            var evidenceItem = [];
	                            //this.$log.debug("logAux.length", logAux.length);
	                            while (m < logAux.length) {
	                                key = logAux[m];
	                                var evidence = evidenceMap.get(key);
	                                //this.$log.debug("evidence", evidence);
	                                var citation = evidence.citation;
	                                //this.$log.debug("citation", citation);
	                                var txt = citation.text;
	                                //this.$log.debug("text", txt);
	                                m++;
	                                if (!!txt) {
	                                    evidenceItem.push(txt);
	                                    //this.$log.debug("KEY", txt);
	                                }
	                                else {
	                                    var sourceId = citation.sourceId;
	                                    if (sourceId > 0) {
	                                        var source = this.sourceMap.get(sourceId);
	                                        txt = utils.getCitation(source, evidence.citation.url, evidence.citation.page, evidence.citation.date);
	                                        //this.$log.debug("text", txt);
	                                        if (!!txt) {
	                                            evidenceItem.push(txt);
	                                            //this.$log.debug("KEY", txt);
	                                        }
	                                    }
	                                }
	                            }
	                            j = this.endNotes.length;
	                            //this.$log.debug("evidenceItem.length", evidenceItem.length);
	                            if (evidenceItem.length > 0) {
	                                this.endNotes[j] = evidenceItem;
	                                //this.$log.debug("EVIDENCEITEM", evidenceItem);
	                                j++;
	                                //this.$log.debug("J antes", j);
	                                superscript += " " + j;
	                            }
	                            //superscript = "" +j;
	                        }
	                    }
	                    if (type !== "MARR") {
	                        if (!(!this.getType(evidences, type))) {
	                            typeValue = this.getType(evidences, type).display;
	                        }
	                        else {
	                            typeValue = type;
	                        }
	                        if (type !== "SOUR") {
	                            place = this.utils.cleanPDF(item.fact.place);
	                            factValue = item.fact.value;
	                            date = item.fact.date;
	                            //this.$log.debug("superscript", superscript);
	                            //this.$log.debug("type Value", typeValue);
	                            this.printFact(typeValue, date, factValue, place, y, x, superscript);
	                            y = this.increaseY(y, 5, this.doc);
	                        }
	                        if (!(!place)) {
	                            var placeArr = place.split(",");
	                            for (var l = placeArr.length - 1; l < 2; l++) {
	                                placeArr[l + 1] = "";
	                            }
	                            var place1 = placeArr[2].trim();
	                            var place2 = placeArr[1].trim();
	                            var place3 = placeArr[0].trim();
	                            var keyPlace = place1;
	                            if (place2.length > 0) {
	                                keyPlace += " " + place2;
	                            }
	                            if (place3.length > 0) {
	                                keyPlace += " " + place3;
	                            }
	                            //$log.debug("keyPlace",keyPlace);
	                            n = this.placesIndex.length;
	                            this.placesIndex[n] = {
	                                key: keyPlace,
	                                place1: place1,
	                                place2: place2,
	                                place3: place3,
	                                place: place,
	                                page: this.pageNumber
	                            };
	                        }
	                    }
	                }
	            }
	        }
	        catch (e_8_1) { e_8 = { error: e_8_1 }; }
	        finally {
	            try {
	                if (facts_2_1 && !facts_2_1.done && (_d = facts_2.return)) _d.call(facts_2);
	            }
	            finally { if (e_8) throw e_8.error; }
	        }
	        var allParentsMap = new Map(Array.from(this.familyMap.entries()).filter(function (_a) {
	            var _b = __read(_a, 2), f = _b[1];
	            return !!f.childRels.get(mother.person.id);
	        }));
	        //this.$log.debug("abuelos", allParentsMap);
	        if (allParentsMap.size > 0) {
	            var preferredParents = families.getPreferredFamily(allParentsMap, mother.person.preferredParentsFamilyId);
	            if (preferredParents.husbandId !== 0) {
	                husbandId = preferredParents.husbandId;
	            }
	            if (preferredParents.wifeId !== 0) {
	                wifeId = preferredParents.wifeId;
	            }
	        }
	        var grandfather = this.personMap.get(husbandId);
	        var grandmother = this.personMap.get(wifeId);
	        y = this.printGrandParent(grandfather, grandmother, x, y, persons);
	        this.y = y;
	        var e_6, _a, e_8, _d, e_7, _c;
	    };
	    ReportsFamilyGroupService.prototype.getType = function (evidences, type) {
	        return this.utils.factTypes.find(function (ft) { return ft.value === type; });
	    };
	    ReportsFamilyGroupService.prototype.printGrandParent = function (grandfather, grandmother, x, y, persons) {
	        var bDate, dDate, txt;
	        var splitBirth, splitDeath;
	        var name, birth, death, yearB, yearD;
	        if (!(!grandfather)) {
	            this.doc.line(x, y, x, y + 5);
	            this.doc.line(this.maxX, y, this.maxX, y + 5);
	            this.doc.line(x + 7, y, x + 7, y + 5);
	            this.doc.text(x + 10, y + 4, "Father");
	            var nf = persons.getDefaultNameForm(persons.getPreferredName(grandfather));
	            name = persons.getNameText(nf, false);
	            //name = grandfather._fullName;
	            birth = persons.getPreferredBirth(grandfather);
	            death = persons.getPreferredDeath(grandfather);
	            //yearB, yearD;
	            if (birth) {
	                bDate = birth.date;
	                splitBirth = bDate.split(" ");
	                yearB = splitBirth[splitBirth.length - 1];
	            }
	            else {
	                yearB = " ";
	            }
	            if (death) {
	                dDate = death.date;
	                splitDeath = dDate.split(" ");
	                yearD = splitDeath[splitDeath.length - 1];
	            }
	            else {
	                yearD = " ";
	            }
	            ////this.$log.debug("split", splitBirth[splitBirth.length-1]);
	            //this.$log.debug("split2", splitDeath[splitDeath.length-1]);
	            txt = name + " (" + yearB + " - " + yearD + ")";
	            this.doc.text(x + 50, y + 4, txt);
	            this.doc.line(x + 7, y + 5, this.maxX, y + 5);
	            y = this.increaseY(y, 5, this.doc);
	        }
	        if (!(!grandmother)) {
	            this.doc.line(x, y, x, y + 5);
	            this.doc.line(this.maxX, y, this.maxX, y + 5);
	            this.doc.line(x + 7, y, x + 7, y + 5);
	            this.doc.text(x + 10, y + 4, "Mother");
	            var nf = persons.getDefaultNameForm(persons.getPreferredName(grandmother));
	            name = persons.getNameText(nf, false);
	            //name = grandmother._fullName;
	            birth = persons.getPreferredBirth(grandmother);
	            death = persons.getPreferredDeath(grandmother);
	            if (birth) {
	                bDate = birth.date;
	                splitBirth = bDate.split(" ");
	                yearB = splitBirth[splitBirth.length - 1];
	            }
	            else {
	                yearB = " ";
	            }
	            if (death) {
	                dDate = death.date;
	                splitDeath = dDate.split(" ");
	                yearD = splitDeath[splitDeath.length - 1];
	            }
	            else {
	                yearD = " ";
	            }
	            txt = name + " (" + yearB + " - " + yearD + ")";
	            this.doc.text(x + 50, y + 4, txt);
	            //this.doc.line(x+10,y+5,this.maxX,y+5);
	            y = this.increaseY(y, 5, this.doc);
	        }
	        return y;
	        /*this.doc.line(x,y,x,y+5);
	         this.doc.line(this.maxX, y, this.maxX, y+5);
	         this.doc.line(x+10,y,x+10,y+5);*/
	    };
	    ReportsFamilyGroupService.prototype.printChildTitle = function (x, y) {
	        this.doc.line(x, y, this.maxX, y);
	        this.doc.line(x, y + 5, this.maxX, y + 5);
	        this.doc.line(x, y, x, y + 5);
	        this.doc.line(this.maxX, y, this.maxX, y + 5);
	        this.doc.setFontType("bold");
	        this.doc.text(x + 4, y + 4, "Children");
	        this.doc.setFontType("normal");
	    };
	    ReportsFamilyGroupService.prototype.printChild = function (child, evidences, utils) {
	        var _this = this;
	        var x = this.x;
	        var y = this.y;
	        var key;
	        var gen = child.item.gender;
	        var nf = this.persons.getDefaultNameForm(this.persons.getPreferredName(child.item));
	        var name = this.persons.getNameText(nf, false);
	        var firstName = !!nf ? nf.given : '';
	        var lastName = !!nf ? nf.surname : '';
	        //var name = child.item._fullName;
	        //var firstName = child.item._given.trim();
	        //var lastName = child.item._surname.trim();
	        var keyName = lastName + " " + firstName;
	        var n = this.namesIndex.length;
	        this.namesIndex[n] = {
	            key: keyName,
	            firstName: firstName,
	            lastName: lastName,
	            page: this.pageNumber,
	            id: child.item.id
	        };
	        var type, typeValue, factValue, place, date;
	        /*if(y+10 >= this.yFooter){
	         this.y=20;
	         y=20;
	         this.NewPageFamily();
	         }*/
	        this.doc.line(x, y, x, y + 5);
	        this.doc.line(this.maxX, y, this.maxX, y + 5);
	        this.doc.line(x + 7, y, x + 7, y + 5);
	        this.doc.line(x, y + 5, this.maxX, y + 5);
	        this.doc.setFontType("bold");
	        switch (gen) {
	            case "FEMALE":
	                this.doc.text(x + 2, y + 4, "F");
	                break;
	            case "MALE":
	                this.doc.text(x + 2, y + 4, "M");
	                break;
	        }
	        this.doc.text(x + 9, y + 4, name);
	        this.doc.setFontType("normal");
	        y = this.increaseY(y, 5, this.doc);
	        var factsMap = child.item.facts;
	        var factO = [];
	        try {
	            for (var factsMap_3 = __values(factsMap), factsMap_3_1 = factsMap_3.next(); !factsMap_3_1.done; factsMap_3_1 = factsMap_3.next()) {
	                var item = factsMap_3_1.value;
	                var dateKey = item[1].date;
	                key = dateKey.split(" ");
	                var key1 = 9999;
	                var key2 = 9999;
	                var key3 = 9999;
	                if (key[key.length - 1]) {
	                    key1 = key[key.length - 1];
	                }
	                if (key[key.length - 2]) {
	                    key2 = key[key.length - 2];
	                }
	                if (key[key.length - 3]) {
	                    key3 = key[key.length - 3];
	                }
	                factO.push({ fact: item[1], key1: key1, key2: key2, key3: key3 });
	            }
	        }
	        catch (e_9_1) { e_9 = { error: e_9_1 }; }
	        finally {
	            try {
	                if (factsMap_3_1 && !factsMap_3_1.done && (_a = factsMap_3.return)) _a.call(factsMap_3);
	            }
	            finally { if (e_9) throw e_9.error; }
	        }
	        var facts = [];
	        facts = this.insertionSortFact(factO);
	        var superscript = "";
	        facts.forEach(function (item) {
	            if (item.fact.principal) {
	                superscript = "";
	                type = item.fact.type;
	                if (type !== "SOUR") {
	                    var evidencePersonasMap = item.fact.evidencePersonas;
	                    //this.$log.debug("evidencePersonas", evidencePersonasMap);
	                    var logAux = [];
	                    var j = 0;
	                    if (!(!evidencePersonasMap)) {
	                        try {
	                            for (var evidencePersonasMap_3 = __values(evidencePersonasMap), evidencePersonasMap_3_1 = evidencePersonasMap_3.next(); !evidencePersonasMap_3_1.done; evidencePersonasMap_3_1 = evidencePersonasMap_3.next()) {
	                                var _a = __read(evidencePersonasMap_3_1.value, 1), eid = _a[0];
	                                logAux[j] = eid;
	                                j++;
	                            }
	                        }
	                        catch (e_10_1) { e_10 = { error: e_10_1 }; }
	                        finally {
	                            try {
	                                if (evidencePersonasMap_3_1 && !evidencePersonasMap_3_1.done && (_b = evidencePersonasMap_3.return)) _b.call(evidencePersonasMap_3);
	                            }
	                            finally { if (e_10) throw e_10.error; }
	                        }
	                        //this.$log.debug("J despues", j);
	                        var evidenceMap = _this.evidenceMap;
	                        if (j > 0) {
	                            //this.$log.debug("ENTRE?", j);
	                            var m = 0;
	                            var evidenceItem = [];
	                            //this.$log.debug("logAux.length", logAux.length);
	                            while (m < logAux.length) {
	                                key = logAux[m];
	                                var evidence = evidenceMap.get(key);
	                                //this.$log.debug("evidence", evidence);
	                                var citation = evidence.citation;
	                                //this.$log.debug("citation", citation);
	                                var txt = citation.text;
	                                //this.$log.debug("text", txt);
	                                m++;
	                                if (!!txt) {
	                                    evidenceItem.push(txt);
	                                    //this.$log.debug("KEY", txt);
	                                }
	                                else {
	                                    var sourceId = citation.sourceId;
	                                    if (sourceId > 0) {
	                                        var source = _this.sourceMap.get(sourceId);
	                                        txt = utils.getCitation(source, evidence.citation.url, evidence.citation.page, evidence.citation.date);
	                                        //this.$log.debug("text", txt);
	                                        if (!!txt) {
	                                            evidenceItem.push(txt);
	                                            //this.$log.debug("KEY", txt);
	                                        }
	                                    }
	                                }
	                            }
	                            j = _this.endNotes.length;
	                            //this.$log.debug("evidenceItem.length", evidenceItem.length);
	                            if (evidenceItem.length > 0) {
	                                _this.endNotes[j] = evidenceItem;
	                                //this.$log.debug("EVIDENCEITEM", evidenceItem);
	                                j++;
	                                //this.$log.debug("J antes", j);
	                                superscript += " " + j;
	                            }
	                            //superscript = "" +j;
	                        }
	                    }
	                    //this.$log.debug("type", type);
	                    //this.$log.debug("citation",citation);
	                    if (type === "MARR") {
	                        typeValue = _this.utils.factTypes.find(function (ft) { return ft.value === type; }).display;
	                        place = _this.utils.cleanPDF(item.fact.place);
	                        factValue = item.fact.value;
	                        date = item.fact.date;
	                        _this.printFact(typeValue, date, factValue, place, y, x, superscript);
	                        y = _this.increaseY(y, 5, _this.doc);
	                        var idCouple = item.fact.principalId1;
	                        if (!(!idCouple)) {
	                            var nf_1 = _this.persons.getDefaultNameForm(_this.persons.getPreferredName(_this.personMap.get(idCouple)));
	                            var fullName = _this.persons.getNameText(nf_1, false);
	                            _this.printSpouse(fullName, x, y);
	                            y = _this.increaseY(y, 5, _this.doc);
	                        }
	                    }
	                    else {
	                        if (!(!_this.getType(evidences, type))) {
	                            typeValue = _this.getType(evidences, type).display;
	                        }
	                        else {
	                            typeValue = type;
	                        }
	                        place = _this.utils.cleanPDF(item.fact.place);
	                        factValue = item.fact.value;
	                        date = item.fact.date;
	                        _this.printFact(typeValue, date, factValue, place, y, x, superscript);
	                        y = _this.increaseY(y, 5, _this.doc);
	                    }
	                    if (!(!place)) {
	                        var placeArr = place.split(",");
	                        for (var l = placeArr.length - 1; l < 2; l++) {
	                            placeArr[l + 1] = "";
	                        }
	                        var place1 = placeArr[2].trim();
	                        var place2 = placeArr[1].trim();
	                        var place3 = placeArr[0].trim();
	                        var keyPlace = place1;
	                        if (place2.length > 0) {
	                            keyPlace += " " + place2;
	                        }
	                        if (place3.length > 0) {
	                            keyPlace += " " + place3;
	                        }
	                        //$log.debug("keyPlace",keyPlace);
	                        n = _this.placesIndex.length;
	                        _this.placesIndex[n] = {
	                            key: keyPlace,
	                            place1: place1,
	                            place2: place2,
	                            place3: place3,
	                            place: place,
	                            page: _this.pageNumber
	                        };
	                    }
	                }
	            }
	            var e_10, _b;
	        });
	        this.doc.line(x, y, this.maxX, y);
	        this.y = y;
	        var e_9, _a;
	    };
	    ReportsFamilyGroupService.prototype.evidencePersonasForeach = function (evidencePersonas, logAux, j) {
	        logAux = [];
	        j = 0;
	        evidencePersonas.forEach(function (persona, key) {
	            logAux[j] = key;
	            j++;
	        });
	    };
	    ReportsFamilyGroupService.prototype.printname = function (txt, x, y) {
	        this.doc.line(x, y, this.maxX, y);
	        this.doc.line(x, y, x, y + 5);
	        this.doc.line(this.maxX, y, this.maxX, y + 5);
	        this.doc.line(x, y + 5, this.maxX, y + 5);
	        this.doc.setFontType("bold");
	        this.doc.text(x + 3, y + 4, txt);
	        this.doc.setFontType("normal");
	        //return y+5;
	    };
	    ReportsFamilyGroupService.prototype.printFact = function (type, date, factValue, place, y, x, superscript) {
	        this.doc.line(x, y, x, y + 5);
	        this.doc.line(this.maxX, y, this.maxX, y + 5);
	        this.doc.line(x + 7, y, x + 7, y + 5);
	        this.doc.line(x + 60, y, x + 60, y + 5);
	        //this.doc.text(x + 12, y + 4, type);
	        var txt = type;
	        txt += " " + date;
	        var txtWidth = this.doc.getStringUnitWidth(txt);
	        txtWidth = (txtWidth * 10 * 25.4) / 72;
	        txtWidth += 2;
	        this.doc.text(x + 60 - txtWidth, y + 4, txt);
	        txt = (!!factValue ? factValue + ' ' : '') + place;
	        var txtarr = this.doc.splitTextToSize(txt, 105);
	        this.doc.text(x + 62, y + 4, txtarr[0]);
	        var w = this.sentenceWidth(txtarr[0], 10);
	        //this.$log.debug("TIPO", type);
	        //this.$log.debug("FACT and PLACE", txt);
	        //this.$log.debug("superscript", superscript);
	        this.doc.setFontSize(5);
	        this.doc.text(x + 62 + w, y + 2, superscript);
	        this.doc.setFontSize(10);
	        this.doc.line(x + 7, y + 5, this.maxX, y + 5);
	    };
	    ReportsFamilyGroupService.prototype.printSpouse = function (couple, x, y) {
	        this.doc.line(x, y, x, y + 5);
	        this.doc.line(this.maxX, y, this.maxX, y + 5);
	        this.doc.line(x + 7, y, x + 7, y + 5);
	        //this.doc.line(x+70,y,x+70,y+5);
	        this.doc.text(x + 12, y + 4, "Spouse");
	        this.doc.text(x + 50, y + 4, couple);
	        this.doc.line(x + 7, y + 5, this.maxX, y + 5);
	    };
	    ReportsFamilyGroupService.prototype.NewPageFamily = function () {
	        this.doc.addPage();
	        this.printHeader('Family Group Sheet', this.today());
	        this.y = this.increaseY(this.y, 5, this.doc);
	        var nf = this.persons.getDefaultNameForm(this.persons.getPreferredName(this.father.person));
	        var fullName = this.persons.getNameText(nf, false);
	        this.printname("Father" + " " + fullName, this.x, this.y);
	        this.y = this.increaseY(this.y, 5, this.doc);
	        nf = this.persons.getDefaultNameForm(this.persons.getPreferredName(this.mother.person));
	        fullName = this.persons.getNameText(nf, false);
	        this.printname("Mother" + " " + fullName, this.x, this.y);
	        this.y = this.increaseY(this.y, 5, this.doc);
	        //this.printChildTitle(this.x, this.y);
	        //this.y = this.increaseY(this.y, 5, this.doc);
	        //var gen = !!this.currentPerson ? this.currentPerson.item.gender : 'FOO';
	        //var name = !!this.currentPerson ? this.currentPerson.item._fullName : 'BAR';
	        //this.doc.line(this.x, this.y, this.x, this.y + 5);
	        //this.doc.line(this.maxX, this.y, this.maxX, this.y + 5);
	        //this.doc.line(this.x + 7, this.y, this.x + 7, this.y + 5);
	        //this.doc.line(this.x, this.y + 5, this.maxX, this.y + 5);
	        //this.doc.setFontType("bold");
	        //switch (gen) {
	        //  case "FEMALE":
	        //    this.doc.text(this.x + 2, this.y + 4, "F");
	        //    break;
	        //  case "MALE":
	        //    this.doc.text(this.x + 2, this.y + 4, "M");
	        //    break;
	        //}
	        //this.doc.text(this.x + 9, this.y + 4, name);
	        //this.doc.setFontType("normal");
	        //this.y = this.increaseY(this.y, 5, this.doc);
	        this.printFooter();
	    };
	    ReportsFamilyGroupService.prototype.printHeader = function (txt1, txt2) {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.y;
	        var deltaYUnderline = this.deltaYUnderline;
	        doc.setFontSize(14);
	        doc.text(x, y, txt1);
	        var xRightAligned = maxX - 2 * txt2.length - 10;
	        doc.setFontSize(10);
	        doc.text(xRightAligned, y, txt2);
	        y = this.increaseY(y, deltaYUnderline, doc);
	        doc.line(x, y, maxX, y);
	        //y = this.increaseY(this.y, this.deltaYUnderline*3, doc);
	        //doc.line(x, y, this.maxX, y);
	        //this.y = y;
	    };
	    ReportsFamilyGroupService.prototype.printFooter = function () {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.yFooter;
	        var pageNumber = this.pageNumber;
	        doc.line(x, y, maxX, y);
	        doc.setFontSize(10);
	        doc.text((x + maxX) / 2, y + 6, pageNumber + "");
	    };
	    ReportsFamilyGroupService.prototype.sentenceWidth = function (txt, fontsize) {
	        /*var w = 0;
	         for(var i= 0; i< txt.length; i++){
	         switch(txt[i]) {
	         case "a": w = w +0.556; break;
	         case "A": w = w +0.667; break;
	         case "b": w = w +0.556; break;
	         case "B": w = w +0.667; break;
	         case "c": w = w +0.5;   break;
	         case "C": w = w +0.722; break;
	         case "d": w = w +0.556; break;
	         case "e": w = w +0.556; break;
	         case "E": w = w +0.667; break;
	         case "f": w = w +0.278; break;
	         case "F": w = w +0.611; break;
	         case "g": w = w +0.556; break;
	         case "G": w = w +0.778; break;
	         case "h": w = w +0.556; break;
	         case "H": w = w +0.722; break;
	         case "I": w = w +0.278; break;
	         case "j": w = w +0.222; break;
	         case "J": w = w +0.5  ; break;
	         case "k": w = w +0.5  ; break;
	         case "K": w = w +0.667; break;
	         case "l": w = w +0.222; break;
	         case "L": w = w +0.556; break;
	         case "M": w = w +0.833; break;
	         case "n": w = w +0.556; break;
	         case "ñ": w = w +0.556; break;
	         case "N": w = w +0.722; break;
	         case "o": w = w +0.556; break;
	         case "O": w = w +0.778; break;
	         case "p": w = w +0.556; break;
	         case "P": w = w +0.667; break;
	         case "q": w = w +0.556; break;
	         case "Q": w = w +0.778; break;
	         case "r": w = w +0.333; break;
	         case "R": w = w +0.722; break;
	         case "s": w = w +0.5  ; break;
	         case "S": w = w +0.667; break;
	         case "t": w = w +0.278; break;
	         case "T": w = w +0.611; break;
	         case "u": w = w +0.556; break;
	         case "U": w = w +0.722; break;
	         case "v": w = w +0.5  ; break;
	         case "V": w = w +0.667; break;
	         case "w": w = w +0.722; break;
	         case "W": w = w +0.944; break;
	         case "x": w = w +0.5  ; break;
	         case "X": w = w +0.667; break;
	         case "y": w = w +0.5  ; break;
	         case "Y": w = w +0.667; break;
	         case "z": w = w +0.5  ; break;
	         case "Z": w = w +0.611; break;
	         case " ": w = w +0.278; break;
	         case ",": w = w +0.278; break;
	         case "(": w = w +0.333; break;
	         case ")": w = w +0.333; break;
	         case "-": w = w +0.333; break;
	         case ".": w = w +0.278; break;
	         case ";": w = w +0.278; break;
	         case "0": w = w +0.556; break;
	         case "1": w = w +0.556; break;
	         case "2": w = w +0.556; break;
	         case "3": w = w +0.556; break;
	         case "4": w = w +0.556; break;
	         case "5": w = w +0.556; break;
	         case "6": w = w +0.556; break;
	         case "7": w = w +0.556; break;
	         case "8": w = w +0.556; break;
	         case "9": w = w +0.556; break;
	         default: w = w +0.556; break;
	         }
	         }*/
	        //this.$log.debug("w",w);
	        var w = this.doc.getStringUnitWidth(txt);
	        return (w * fontsize * 25.4) / 72;
	    };
	    return ReportsFamilyGroupService;
	}());
	exports.default = ReportsFamilyGroupService;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Wilson Kellogg <wilson.kellogg@prosadata.com> - 2016
	 */
	var ReportsPlaceListService = /** @class */ (function () {
	    ReportsPlaceListService.$inject = ["$window", "rx", "persons", "utils"];
	    function ReportsPlaceListService($window, rx, persons, utils) {
	        'ngInject';
	        this.$window = $window;
	        this.rx = rx;
	        this.persons = persons;
	        this.utils = utils;
	    }
	    ReportsPlaceListService.prototype.create = function (jsPDF, $log, evidences, utils, place, personMap, familyMap, evidenceMap) {
	        var readySubject = new this.rx.AsyncSubject();
	        this.doc = new jsPDF();
	        this.maxX = 190;
	        this.x = 20;
	        this.y = 20;
	        this.pageNumber = 1;
	        this.fromPage = 1;
	        this.deltaY = 5;
	        this.deltaYUnderline = 1;
	        this.deltaX = 6;
	        this.yFooter = 270;
	        this.people = [];
	        this.$log = $log;
	        this.rootIndex = 0;
	        this.pending = [];
	        this.places = [];
	        this.place = this.utils.cleanPDF(place);
	        this.selectedPlace = [];
	        //this.$log.debug("PLACESelected", this.place);
	        this.selectPlace();
	        this.utils = utils;
	        //var root = 0;
	        var doc = this.doc;
	        this.personMap = personMap;
	        this.familyMap = familyMap;
	        this.evidenceMap = evidenceMap;
	        this.getPlaces(evidences);
	        //this.$log.debug("personMap", this.personMap);
	        var txt1 = 'Place List';
	        var reportName = txt1;
	        var txt2 = this.today();
	        this.printPlaces(txt1, txt2);
	        /*while (this.pending.length > 0) {
	         var aux = this.pending.splice(0,1)[0];
	         root = aux.root;
	         this.rootIndex = aux.i;
	         this.fromPage = aux.fromPage;
	         this.people = this.getTree(families, root);
	         this.printPlaces(txt1,txt2);
	         }*/
	        var blob = doc.output('blob');
	        //if (this.$window.navigator && this.$window.navigator.msSaveOrOpenBlob) {
	        //  this.$window.navigator.msSaveOrOpenBlob(blob);
	        //}
	        //else {
	        //  //var objectUrl = URL.createObjectURL(blob);
	        //  this.$window.open((this.$window.URL || this.$window.webkitURL).createObjectURL(blob));
	        //}
	        readySubject.next({ blob: blob, name: reportName, ext: 'pdf' });
	        readySubject.complete();
	        return readySubject;
	    };
	    ReportsPlaceListService.prototype.getPlaces = function (evidences) {
	        //var people = this.people;
	        var places = [];
	        var typeValue;
	        var factItem, f;
	        //var personEvents;
	        var person;
	        try {
	            for (var _a = __values(this.personMap), _b = _a.next(); !_b.done; _b = _a.next()) {
	                var item = _b.value;
	                //personEvents = [];
	                person = item[1];
	                if (!(!person)) {
	                    var factsMap = person.facts;
	                    //this.$log.debug("EVMap", person.names);
	                    var type = "";
	                    var place = "";
	                    var standardPlace = "";
	                    var date = "";
	                    var dateSort = "";
	                    try {
	                        for (var factsMap_1 = __values(factsMap), factsMap_1_1 = factsMap_1.next(); !factsMap_1_1.done; factsMap_1_1 = factsMap_1.next()) {
	                            var item_1 = factsMap_1_1.value;
	                            //this.$log.debug("Items", item);
	                            //this.$log.debug("place", item[1].place);
	                            //this.$log.debug("Standar", item[1].placeStandard);
	                            type = item_1[1].type;
	                            //this.$log.debug("DATESORT", item[1].dateSort);
	                            if (item_1[1].principal) {
	                                //this.$log.debug('principal', item[1].value);
	                                //let display = (evidences.factTypes.find(ft => ft.value === type) || {display: type}).display;
	                                if (this.getType(evidences, type)) {
	                                    typeValue = this.getType(evidences, type).display;
	                                }
	                                else {
	                                    typeValue = type;
	                                }
	                                place = this.utils.cleanPDF(item_1[1].place);
	                                standardPlace = this.utils.cleanPDF(item_1[1].placeStandard);
	                                if (!!place) {
	                                    var placeArr = this.splitPlace(place);
	                                    var standardPlaceArr = this.splitPlace(standardPlace);
	                                    if (((this.selectedPlace[0] === "") || (this.selectedPlace[0] === standardPlaceArr[0])) &&
	                                        ((this.selectedPlace[1] === "") || (this.selectedPlace[1] === standardPlaceArr[1])) &&
	                                        ((this.selectedPlace[2] === "") || (this.selectedPlace[2] === standardPlaceArr[2]))) {
	                                        var keyPlace = placeArr[0];
	                                        if (placeArr[1].length > 0) {
	                                            keyPlace += ", " + placeArr[1];
	                                        }
	                                        if (placeArr[2].length > 0) {
	                                            keyPlace += ", " + placeArr[2];
	                                        }
	                                        if (standardPlaceArr[0] !== "" && placeArr[0].toLowerCase() !== standardPlaceArr[0].toLowerCase()) {
	                                            if (standardPlace.endsWith(", United States")) {
	                                                standardPlace = standardPlace.substr(0, standardPlace.length - ", United States".length);
	                                            }
	                                            keyPlace += " (" + standardPlace + ")";
	                                        }
	                                        date = item_1[1].date;
	                                        dateSort = item_1[1].dateSort;
	                                        if (item_1[1].principalId1 > 0) {
	                                            // don't duplicate event on both
	                                            if (person.gender === "MALE") {
	                                                var couple = [];
	                                                var nf = this.persons.getDefaultNameForm(this.persons.getPreferredName(person));
	                                                var fullName = this.persons.getNameText(nf, false);
	                                                couple.push(fullName);
	                                                var idCouple = item_1[1].principalId1;
	                                                if (!!idCouple && this.personMap.has(idCouple)) {
	                                                    var nf_1 = this.persons.getDefaultNameForm(this.persons.getPreferredName(this.personMap.get(idCouple)));
	                                                    var fullName_1 = this.persons.getNameText(nf_1, false);
	                                                    couple.push(fullName_1);
	                                                }
	                                                factItem = {
	                                                    place: keyPlace,
	                                                    type: typeValue,
	                                                    date: date,
	                                                    dateSort: dateSort,
	                                                    persons: couple
	                                                };
	                                                places.push(factItem);
	                                            }
	                                        }
	                                        else {
	                                            //this.$log.debug("type not MARR", type);
	                                            var nf = this.persons.getDefaultNameForm(this.persons.getPreferredName(person));
	                                            var per = this.persons.getNameText(nf, false);
	                                            factItem = {
	                                                place: keyPlace,
	                                                type: typeValue,
	                                                date: date,
	                                                dateSort: dateSort,
	                                                persons: per
	                                            };
	                                            places.push(factItem);
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (factsMap_1_1 && !factsMap_1_1.done && (_c = factsMap_1.return)) _c.call(factsMap_1);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        this.places = this.insertionSort(places);
	        var e_2, _d, e_1, _c;
	    };
	    ReportsPlaceListService.prototype.splitPlace = function (place) {
	        //this.$log.debug("aqui toy");
	        var placeArr = place.split(",");
	        var place1, place2, place3;
	        //this.$log.debug("placeArr",placeArr);
	        //this.$log.debug("placeARR",placeArr);
	        switch (placeArr.length) {
	            case 1:
	                place1 = placeArr[0].trim();
	                place2 = "";
	                place3 = "";
	                break;
	            case 2:
	                place1 = placeArr[1].trim();
	                if ((place1 === "United States") || (place1 === "USA") || (place1 === "United States of America") || (place1 === "United Kingdom")) {
	                    place1 = placeArr[0].trim();
	                    place2 = "";
	                }
	                else {
	                    place2 = placeArr[0].trim();
	                }
	                place3 = "";
	                break;
	            case 3:
	                place1 = placeArr[2].trim();
	                if ((place1 === "United States") || (place1 === "USA") || (place1 === "United States of America") || (place1 === "United Kingdom")) {
	                    place1 = placeArr[1].trim();
	                    place2 = placeArr[0].trim();
	                    place3 = "";
	                }
	                else {
	                    place2 = placeArr[1].trim();
	                    place3 = placeArr[0].trim();
	                }
	                break;
	            default:
	                place1 = placeArr[placeArr.length - 1].trim();
	                if ((place1 === "United States") || (place1 === "USA") || (place1 === "United States of America") || (place1 === "United Kingdom")) {
	                    place1 = placeArr[placeArr.length - 2].trim();
	                    place2 = placeArr[placeArr.length - 3].trim();
	                    place3 = placeArr[placeArr.length - 4].trim();
	                    for (var f = placeArr.length - 5; f >= 0; f--) {
	                        place3 += ", " + placeArr[f].trim();
	                    }
	                }
	                else {
	                    place2 = placeArr[placeArr.length - 2].trim();
	                    place3 = placeArr[placeArr.length - 3].trim();
	                    for (var f = placeArr.length - 4; f >= 0; f--) {
	                        place3 += ", " + placeArr[f].trim();
	                    }
	                }
	        }
	        return [place1, place2, place3];
	    };
	    ReportsPlaceListService.prototype.getType = function (evidences, type) {
	        return this.utils.factTypes.find(function (ft) { return ft.value === type; });
	    };
	    ReportsPlaceListService.prototype.insertionSort = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = [];
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	        }
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            j = i - 1;
	            while (j >= 0 && first.place < copia[j].place) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        return (copia);
	    };
	    ReportsPlaceListService.prototype.insertionSortDate = function (arreglo) {
	        //initialize
	        var i = 0;
	        var l = arreglo.length;
	        var copia = [];
	        for (i = 0; i < l; i++) {
	            copia[i] = arreglo[i];
	        }
	        var j = 0;
	        var first = 0;
	        var n = copia.length;
	        //sorting
	        for (i = 1; i < n; i++) {
	            first = copia[i];
	            j = i - 1;
	            while (j >= 0 && copia[j].dateSort > first.dateSort) {
	                copia[j + 1] = copia[j];
	                j--;
	            }
	            copia[j + 1] = first;
	        }
	        return (copia);
	    };
	    ReportsPlaceListService.prototype.today = function () {
	        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	        var date = new Date();
	        var _date = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
	        return _date;
	    };
	    ReportsPlaceListService.prototype.printHeader = function (txt1, txt2) {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.y;
	        var deltaYUnderline = this.deltaYUnderline;
	        doc.setFontSize(14);
	        doc.text(x, y, txt1);
	        var xRightAligned = maxX - 2 * txt2.length - 10;
	        doc.setFontSize(10);
	        doc.text(xRightAligned, y, txt2);
	        y = this.increaseY(y, deltaYUnderline, doc);
	        doc.line(x, y, maxX, y);
	    };
	    ReportsPlaceListService.prototype.printFooter = function () {
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.yFooter;
	        var pageNumber = this.pageNumber;
	        doc.line(x, y, maxX, y);
	        doc.setFontSize(10);
	        doc.text((x + maxX) / 2, y + 6, pageNumber + "");
	    };
	    ReportsPlaceListService.prototype.increaseY = function (y, deltaY, doc) {
	        y += deltaY;
	        if (y >= this.yFooter) {
	            y = 25;
	            doc.addPage();
	            var txt1 = 'Place List';
	            var txt2 = this.today();
	            this.printHeader(txt1, txt2);
	            this.pageNumber++;
	            this.printFooter();
	        }
	        return y;
	    };
	    ReportsPlaceListService.prototype.selectPlace = function () {
	        var placeSelected = this.utils.cleanPDF(this.place);
	        if (!(!placeSelected)) {
	            var placeArr = placeSelected.split(",");
	            var place1, place2, place3;
	            switch (placeArr.length) {
	                case 1:
	                    place1 = placeArr[0].trim();
	                    place2 = "";
	                    place3 = "";
	                    break;
	                case 2:
	                    place1 = placeArr[1].trim();
	                    if (place1 === "United States") {
	                        place1 = placeArr[0].trim();
	                        place2 = "";
	                    }
	                    else {
	                        place2 = placeArr[0].trim();
	                    }
	                    place3 = "";
	                    break;
	                case 3:
	                    place1 = placeArr[2].trim();
	                    if (place1 === "United States") {
	                        place1 = placeArr[1].trim();
	                        place2 = placeArr[0].trim();
	                        place3 = "";
	                    }
	                    else {
	                        place2 = placeArr[1].trim();
	                        place3 = placeArr[0].trim();
	                    }
	                    break;
	                default:
	                    var f;
	                    place1 = placeArr[placeArr.length - 1].trim();
	                    if (place1 === "United States") {
	                        place1 = placeArr[placeArr.length - 2].trim();
	                        place2 = placeArr[placeArr.length - 3].trim();
	                        place3 = placeArr[placeArr.length - 4].trim();
	                        for (f = placeArr.length - 5; f >= 0; f--) {
	                            place3 += ", " + placeArr[f].trim();
	                        }
	                    }
	                    else {
	                        place2 = placeArr[placeArr.length - 2].trim();
	                        place3 = placeArr[placeArr.length - 3].trim();
	                        for (f = placeArr.length - 4; f >= 0; f--) {
	                            place3 += ", " + placeArr[f].trim();
	                        }
	                    }
	            }
	            this.selectedPlace.push(place1);
	            this.selectedPlace.push(place2);
	            this.selectedPlace.push(place3);
	        }
	        else {
	            this.selectedPlace.push("");
	            this.selectedPlace.push("");
	            this.selectedPlace.push("");
	        }
	    };
	    ReportsPlaceListService.prototype.printPlaces = function (txt1, txt2) {
	        this.printHeader(txt1, txt2);
	        this.printFooter();
	        var doc = this.doc;
	        var maxX = this.maxX;
	        var x = this.x;
	        var y = this.y;
	        var yVar;
	        var deltaYUnderline = this.deltaYUnderline;
	        y = this.increaseY(y, 5, doc);
	        doc.text(x + 10, y, "Date");
	        doc.text(x + 65, y, "Event");
	        doc.text(x + 100, y, "Person / Couple");
	        y = this.increaseY(y, deltaYUnderline, doc);
	        doc.line(x, y, maxX, y);
	        y = this.increaseY(y, 5, doc);
	        var places = this.places;
	        var tmpPlace = "";
	        var orderPlace = [];
	        var arraytmp = null;
	        var item;
	        var ARR;
	        //this.$log.debug("PLACE ARREGLO PRINCIPAL", places);
	        for (var t = 0; t < places.length; t++) {
	            if (!!places[t].place) {
	                //this.$log.debug("tmpPlace", tmpPlace);
	                //this.$log.debug("places[t].place", places[t].place);
	                if (places[t].place !== tmpPlace) {
	                    if (arraytmp !== null) {
	                        ARR = this.insertionSortDate(arraytmp);
	                        //this.$log.debug("Array ordenado", ARR);
	                        item.array = ARR;
	                        orderPlace.push(item);
	                        //this.$log.debug("ARRAY item", orderPlace);
	                    }
	                    item = {
	                        place: places[t].place
	                    };
	                    arraytmp = [];
	                    tmpPlace = places[t].place;
	                    //arraytmp = orderPlace;
	                }
	                arraytmp.push(places[t]);
	                //this.$log.debug("tmp", arraytmp);
	            }
	        }
	        //this.$log.debug("orderPlace.length", orderPlace.length);
	        if (orderPlace.length === 0) {
	            if (arraytmp !== null) {
	                ARR = this.insertionSortDate(arraytmp);
	                //this.$log.debug("Array ordenado", ARR);
	                item.array = ARR;
	                orderPlace.push(item);
	                //this.$log.debug("ARRAY item", orderPlace);
	            }
	        }
	        for (var k = 0; k < orderPlace.length; k++) {
	            //this.$log.debug("EXISTE LUGAR", places[k].place);
	            doc.setFontType("bold");
	            /*var splitplace = doc.splitTextToSize(orderPlace[k].place, 50);
	             for(var r=0; r<splitplace.length; r++){
	             doc.text(x, y, splitplace[r]);
	             y = this.increaseY(y, 5, doc);
	             }*/
	            //this.$log.debug("y antes", y);
	            if (y + 5 > this.yFooter) {
	                y = this.increaseY(y, 270, doc);
	            }
	            doc.text(x, y, orderPlace[k].place);
	            y = this.increaseY(y, 5, doc);
	            doc.setFontType("normal");
	            //this.$log.debug("orderPlace[k].array.length", orderPlace[k].array.length);
	            for (var w = 0; w < orderPlace[k].array.length; w++) {
	                var MAXy = y;
	                var pending = [];
	                var splitDate = doc.splitTextToSize(orderPlace[k].array[w].date, 30);
	                var r = 0;
	                if (splitDate.length * 5 + y < this.yFooter) {
	                    yVar = y;
	                    for (r = 0; r < splitDate.length; r++) {
	                        doc.text(x + 10, y, splitDate[r]);
	                        y = y + 5;
	                    }
	                    if (MAXy < y) {
	                        MAXy = y;
	                    }
	                    y = yVar;
	                }
	                else {
	                    yVar = y;
	                    var pendingDate = [];
	                    for (r = 0; r < splitDate.length; r++) {
	                        if (r * 5 + y > this.yFooter) {
	                            //this.$log.debug("y", y);
	                            //if(!(!splitDate[r])){
	                            pendingDate.push(splitDate[r]);
	                            //}
	                        }
	                        else {
	                            doc.text(x + 10, y, splitDate[r]);
	                            y = y + 5;
	                        }
	                    }
	                    pending.push({
	                        column: "date",
	                        inside: pendingDate
	                    });
	                    if (MAXy < y) {
	                        MAXy = y;
	                    }
	                    y = yVar;
	                }
	                //doc.text(x + 10, y, orderPlace[k].array[w].date);
	                var splitType = doc.splitTextToSize(orderPlace[k].array[w].type, 30);
	                if (splitType.length * 5 + y < this.yFooter) {
	                    yVar = y;
	                    for (r = 0; r < splitType.length; r++) {
	                        doc.text(x + 65, y, splitType[r]);
	                        y = y + 5;
	                    }
	                    if (MAXy < y) {
	                        MAXy = y;
	                    }
	                    y = yVar;
	                }
	                else {
	                    yVar = y;
	                    var pendingType = [];
	                    for (r = 0; r < splitType.length; r++) {
	                        if (r * 5 + y > this.yFooter) {
	                            //this.$log.debug("y", y);
	                            //if(!(!splitDate[r])){
	                            pendingType.push(splitType[r]);
	                            //}
	                        }
	                        else {
	                            doc.text(x + 65, y, splitType[r]);
	                            y = y + 5;
	                        }
	                    }
	                    pending.push({
	                        column: "type",
	                        inside: pendingType
	                    });
	                    if (MAXy < y) {
	                        MAXy = y;
	                    }
	                    y = yVar;
	                }
	                //doc.text(x + 65, y, orderPlace[k].array[w].type);
	                var textName;
	                if (orderPlace[k].array[w].type === "Marriage") {
	                    if (orderPlace[k].array[w].persons.length > 1) {
	                        /*var splitPersons = doc.splitTextToSize(orderPlace[k].array[w].persons[0] + " and " + orderPlace[k].array[w].persons[1], 70);
	                         for(var r=0;r<splitPersons.length;r++){
	                         doc.text(x + 100, y, splitPersons[r]);
	                         y = this.increaseY(y, 5, doc);
	                         }*/
	                        textName = orderPlace[k].array[w].persons[0] + " and " + orderPlace[k].array[w].persons[1];
	                    }
	                    else {
	                        /*var splitPersons = doc.splitTextToSize(orderPlace[k].array[w].persons[0], 70);
	                         for(var r=0;r<splitPersons.length;r++){
	                         doc.text(x + 100, y, splitPersons[r]);
	                         y = this.increaseY(y, 5, doc);
	                         }*/
	                        textName = orderPlace[k].array[w].persons[0];
	                    }
	                    //this.$log.debug(orderPlace[k].array[w].persons[0]);
	                }
	                else {
	                    /*var splitPersons = doc.splitTextToSize(orderPlace[k].array[w].persons, 70);
	                     for(var r=0;r<splitPersons.length;r++){
	                     doc.text(x + 100, y, splitPersons[r]);
	                     y = this.increaseY(y, 5, doc);
	                     }*/
	                    textName = orderPlace[k].array[w].persons;
	                    //this.$log.debug(orderPlace[k].array[w].persons);
	                }
	                var splitName = doc.splitTextToSize(textName, 70);
	                if (splitName.length * 5 + y < this.yFooter) {
	                    yVar = y;
	                    for (r = 0; r < splitName.length; r++) {
	                        doc.text(x + 100, y, splitName[r]);
	                        y = y + 5;
	                    }
	                    if (MAXy < y) {
	                        MAXy = y;
	                    }
	                    y = yVar;
	                }
	                else {
	                    yVar = y;
	                    var pendingName = [];
	                    for (r = 0; r < splitName.length; r++) {
	                        if (r * 5 + y > this.yFooter) {
	                            //this.$log.debug("y", y);
	                            //if(!(!splitDate[r])){
	                            pendingName.push(splitName[r]);
	                            //}
	                        }
	                        else {
	                            doc.text(x + 100, y, splitName[r]);
	                            y = y + 5;
	                        }
	                    }
	                    pending.push({
	                        column: "name",
	                        inside: pendingName
	                    });
	                    if (MAXy < y) {
	                        MAXy = y;
	                    }
	                    y = yVar;
	                }
	                var Maxypending = 0;
	                var g = 0;
	                if (pending.length > 0) {
	                    y = this.increaseY(y, 270, doc);
	                    //this.$log.debug("pending", pending);
	                    for (var d = 0; d < pending.length; d++) {
	                        var obj = pending[d];
	                        if (obj.column === "date") {
	                            //this.$log.debug("INSIDE", obj.inside);
	                            yVar = y;
	                            for (g = 0; g < obj.inside.length; g++) {
	                                doc.text(x + 10, y, obj.inside[g]);
	                                y = y + 5;
	                            }
	                            if (Maxypending < y) {
	                                Maxypending = y;
	                            }
	                            y = yVar;
	                        }
	                        if (obj.column === "type") {
	                            yVar = y;
	                            for (g = 0; g < obj.inside.length; g++) {
	                                doc.text(x + 65, y, obj.inside[g]);
	                                y = y + 5;
	                            }
	                            if (Maxypending < y) {
	                                Maxypending = y;
	                            }
	                            y = yVar;
	                        }
	                        if (obj.column === "name") {
	                            yVar = y;
	                            for (g = 0; g < obj.inside.length; g++) {
	                                doc.text(x + 100, y, obj.inside[g]);
	                                y = y + 5;
	                            }
	                            if (Maxypending < y) {
	                                Maxypending = y;
	                            }
	                            y = yVar;
	                        }
	                    }
	                }
	                if (Maxypending > 0) {
	                    y = Maxypending;
	                }
	                else {
	                    y = MAXy;
	                }
	            }
	            //this.$log.debug("endInnerFor", arraytmp);
	        }
	        //this.printFooter();
	    };
	    return ReportsPlaceListService;
	}());
	exports.default = ReportsPlaceListService;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReportsFanService = /** @class */ (function () {
	    ReportsFanService.$inject = ["$log", "$http", "rx", "$window"];
	    function ReportsFanService($log, $http, rx, $window) {
	        'ngInject';
	        this.$log = $log;
	        this.$http = $http;
	        this.rx = rx;
	        this.$window = $window;
	    }
	    ReportsFanService.prototype.create = function (root, families, persons, evidences, utils, personMap, familyMap) {
	        var readySubject = new this.rx.AsyncSubject();
	        this.root = root;
	        this.families = families;
	        this.persons = persons;
	        this.evidences = evidences;
	        this.utils = utils;
	        if (!!this.root && (this.root.id === 0 || !!personMap.get(this.root.id))) {
	            this.personsMap = personMap;
	            this.familiesMap = familyMap;
	            var dataArray = [];
	            this.createPerson(0, this.root.id, null, dataArray);
	            var data = {
	                pid: this.root.id,
	                sessionId: '',
	                persons: dataArray
	            };
	            var newWin_1 = this.$window.open('', '_blank');
	            this.$http.post('https://treeseekphpgwc.herokuapp.com/7genfan.php', data, {
	                params: {
	                    meta: 'true',
	                    color: 'true'
	                }
	            }).then(function (res) {
	                newWin_1.location = res.data.chart.url;
	                readySubject.next(false);
	                readySubject.complete();
	            }, function () {
	                readySubject.error();
	            });
	        }
	        else {
	            readySubject.error();
	        }
	        return readySubject;
	    };
	    ReportsFanService.prototype.createPerson = function (pos, pid, parent, dataArray) {
	        if (pos > 6)
	            return;
	        var p = this.personsMap.get(pid);
	        var f = this.families.getPreferredFamily(this.families.getParentsMap().get(pid) || new Map(), p.preferredParentsFamilyId);
	        var newSlot = parent ? parent.slot * 2 : 1;
	        if (parent && p.gender === "FEMALE")
	            newSlot++;
	        var nf = this.persons.getDefaultNameForm(this.persons.getPreferredName(p));
	        var fullName = this.persons.getNameText(nf, false);
	        var pData = {
	            slot: newSlot,
	            id: p.id,
	            name: fullName,
	            lifespan: p._lifespan,
	            birthDate: p._birthDate,
	            birthPlace: this.utils.cleanPDF(p._birthPlace),
	            deathDate: p._deathDate,
	            deathPlace: this.utils.cleanPDF(p._deathPlace),
	            living: p.living === "TRUE",
	            gender: p.gender.toLowerCase(),
	            url: null,
	            photo: null
	        };
	        dataArray.push(pData);
	        if (!f) {
	            return;
	        }
	        if (f.husbandId)
	            this.createPerson(pos + 1, f.husbandId, pData, dataArray);
	        if (f.wifeId)
	            this.createPerson(pos + 1, f.wifeId, pData, dataArray);
	    };
	    return ReportsFanService;
	}());
	exports.default = ReportsFanService;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var researchLinks_service_1 = __webpack_require__(263);
	var ResearchLinksService = /** @class */ (function (_super) {
	    __extends(ResearchLinksService, _super);
	    ResearchLinksService.$inject = ["$log", "rx", "server", "messageBus"];
	    function ResearchLinksService($log, rx, server, messageBus) {
	        'ngInject';
	        return _super.call(this, $log, rx, server, messageBus) || this;
	    }
	    return ResearchLinksService;
	}(researchLinks_service_1.ResearchLinksService));
	exports.default = ResearchLinksService;
	// class ResearchLinksService {
	//   constructor ($log, rx, server, messageBus) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.server = server;
	//     this.messageBus = messageBus;
	//     this.cache = new Map();
	//   }
	//   get(places) {
	//     let subject = new this.rx.AsyncSubject();
	//     // normalize, sort, and uniq places
	//     places = this._normalize(places);
	//     let placesJoined = places.join('|');
	//     if (places.length === 0) {
	//       subject.next([]);
	//       subject.complete();
	//     }
	//     else if (this.cache.has(placesJoined)) {
	//       subject.next(this.cache.get(placesJoined));
	//       subject.complete();
	//     }
	//     else {
	//       // request
	//       this.server.get('/researchlinks', {places: placesJoined})
	//         .catch(err => {
	//           this.messageBus.post({msg: err.data, status: err.status, op: 'GET', ctx: 'researchlinks'});
	//           subject.error(err);
	//         })
	//         .subscribe(response => {
	//           this.cache.set(placesJoined, response);
	//           subject.next(response);
	//           subject.complete();
	//         });
	//     }
	//     return subject;
	//   }
	//   _normalize(places) {
	//     places = places.map(place => {
	//       let levels = place.split(',');
	//       let target = levels.length-1;
	//       if (target > 0) {
	//         let country = levels[target].trim();
	//         if (country === 'United States' || country === 'Canada') {
	//           target--;
	//         }
	//       }
	//       return levels[target].trim();
	//     }).filter(p => p.length > 0);
	//     // uniq
	//     places = [...new Set(places)];
	//     // sort
	//     places.sort();
	//     return places;
	//   }
	// }
	// export default ResearchLinksService;


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { AsyncSubject } from "../../node_modules/rxjs";
	var ResearchLinksService = /** @class */ (function () {
	    function ResearchLinksService(log, rx, server, messageBus) {
	        this.rx = rx;
	        this.server = server;
	        this.messageBus = messageBus;
	        this.cache = new Map();
	    }
	    ResearchLinksService.prototype.get = function (places) {
	        var _this = this;
	        var subject = new this.rx.AsyncSubject();
	        // normalize, sort, and uniq places
	        places = this._normalize(places);
	        var placesJoined = places.join('|');
	        if (places.length === 0) {
	            subject.next([]);
	            subject.complete();
	        }
	        else if (this.cache.has(placesJoined)) {
	            subject.next(this.cache.get(placesJoined));
	            subject.complete();
	        }
	        else {
	            // request
	            this.server.get('/researchlinks', { places: placesJoined })
	                .catch(function (err) {
	                _this.messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'researchlinks' });
	                subject.error(err);
	                return _this.rx.Observable.of({}); //TODO is this valid to throw here? compiler wants it
	            })
	                .subscribe(function (response) {
	                _this.cache.set(placesJoined, response);
	                subject.next(response);
	                subject.complete();
	            });
	        }
	        return subject;
	    };
	    ResearchLinksService.prototype._normalize = function (places) {
	        places = places.map(function (place) {
	            var levels = place.split(',');
	            var target = levels.length - 1;
	            if (target > 0) {
	                var country = levels[target].trim();
	                if (country === 'United States' || country === 'Canada') {
	                    target--;
	                }
	            }
	            return levels[target].trim();
	        }).filter(function (p) { return p.length > 0; });
	        // uniq
	        places = __spread(new Set(places));
	        // sort
	        places.sort();
	        return places;
	    };
	    return ResearchLinksService;
	}());
	exports.ResearchLinksService = ResearchLinksService;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var researchLogs_service_1 = __webpack_require__(265);
	var ResearchLogsService = /** @class */ (function (_super) {
	    __extends(ResearchLogsService, _super);
	    ResearchLogsService.$inject = ["$log", "rx", "store", "changes", "segment", "utils"];
	    function ResearchLogsService($log, rx, store, changes, segment, utils) {
	        'ngInject';
	        return _super.call(this, rx, store, changes, segment, utils) || this;
	    }
	    return ResearchLogsService;
	}(researchLogs_service_1.ResearchLogsService));
	exports.default = ResearchLogsService;
	// class ResearchLogsService {
	//   constructor ($log, rx, store, changes, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", "research_logs", changes.treeStream(), (s) => utils.addCreateEditDates(s));
	//     this.personStream = this.store.addStream(store.streamScanFn(o => {
	//       return o.personIds ? o.personIds.keys() : null;
	//     }));
	//   }
	//   create(o) {
	//     this.segment.track('research_logs.create');
	//     return this.store.create(o);
	//   }
	//   update(o) {
	//     this.segment.track('research_logs.update');
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     this.segment.track('research_logs.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     // respond to 0 with an empty log
	//     return id === 0 ? this.rx.Observable.of({id:0, title: ''}) : this.store.streamId(id);
	//   }
	//   // returns a map
	//   streamForPerson(pid) {
	//     return this.ready().flatMap(() => this.personStream.map(m => (m.get(pid) || new Map())));
	//   }
	//   //
	//   // helper functions
	//   //
	//   augmentResearchLog(s, persons, users) {
	//     let subject = new this.rx.AsyncSubject();
	//     let waitCount = (s.personIds.size > 0 ? 1 : 0) + 1;
	//     s = Object.assign({}, s, {
	//       '_people': new Map(),
	//       '_createdUser' : null,
	//       '_editedUser' : null
	//     });
	//     // set people
	//     if (s.personIds.size > 0) {
	//       persons.streamIds(Array.from(s.personIds.keys())).take(1).subscribe(pm => {
	//         s._people = pm;
	//         if (--waitCount === 0) {
	//           subject.next(s);
	//           subject.complete();
	//         }
	//       });
	//     }
	//     // set created user and edited user
	//     this.utils.addCreateEditUsers(s, users).subscribe(() => {
	//       if (--waitCount === 0) {
	//         subject.next(s);
	//         subject.complete();
	//       }
	//     });
	//     return subject;
	//   }
	//   hasWord(s, w) {
	//     return (s.text.toLowerCase().indexOf(w) >= 0) ||
	//       (s.title.toLowerCase().indexOf(w) >= 0) ||
	//       (Array.from(s._people.values()).some(p => p._fullName.toLowerCase().indexOf(w) >= 0));
	//   }
	// }
	// export default ResearchLogsService;


/***/ }),
/* 265 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { BehaviorSubject, AsyncSubject } from "../../node_modules/rxjs";
	var ResearchLogsService = /** @class */ (function () {
	    function ResearchLogsService(rx, store, changes, segment, utils) {
	        this.rx = rx;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "research_logs", changes.treeStream(), function (s) { return utils.addCreateEditDates(s); });
	        this.personStream = this.store.addStream(store.streamScanFn(function (o) {
	            return o.personIds ? o.personIds.keys() : null;
	        }));
	    }
	    ResearchLogsService.prototype.create = function (o) {
	        this.segment.track('research_logs.create');
	        return this.store.create(o);
	    };
	    ResearchLogsService.prototype.update = function (o) {
	        this.segment.track('research_logs.update');
	        return this.store.update(o);
	    };
	    ResearchLogsService.prototype.del = function (id) {
	        this.segment.track('research_logs.delete');
	        return this.store.del(id);
	    };
	    ResearchLogsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    ResearchLogsService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    ResearchLogsService.prototype.streamId = function (id) {
	        // respond to 0 with an empty log
	        return id === 0 ? this.rx.Observable.of({ id: 0, title: '' }) : this.store.streamId(id);
	    };
	    // returns a map
	    ResearchLogsService.prototype.streamForPerson = function (pid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.personStream.map(function (m) { return (m.get(pid) || new Map()); }); });
	    };
	    //
	    // helper functions
	    //
	    ResearchLogsService.prototype.augmentResearchLog = function (s, persons, users) {
	        var subject = new this.rx.AsyncSubject();
	        var waitCount = (s.personIds.size > 0 ? 1 : 0) + 1;
	        s = Object.assign({}, s, {
	            '_people': new Map(),
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        // set people
	        if (s.personIds.size > 0) {
	            persons.streamIds(Array.from(s.personIds.keys())).take(1).subscribe(function (pm) {
	                s._people = pm;
	                if (--waitCount === 0) {
	                    subject.next(s);
	                    subject.complete();
	                }
	            });
	        }
	        // set created user and edited user
	        this.utils.addCreateEditUsers(s, users).subscribe(function () {
	            if (--waitCount === 0) {
	                subject.next(s);
	                subject.complete();
	            }
	        });
	        return subject;
	    };
	    ResearchLogsService.prototype.hasWord = function (s, w) {
	        return (s.text.toLowerCase().indexOf(w) >= 0) ||
	            (s.title.toLowerCase().indexOf(w) >= 0) ||
	            ((!!s._people ? Array.from(s._people.values()) : []).some(function (p) { return p._fullName.toLowerCase().indexOf(w) >= 0; })); //TODO person interface type
	    };
	    return ResearchLogsService;
	}());
	exports.ResearchLogsService = ResearchLogsService;
	exports.default = ResearchLogsService;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var rights_service_1 = __webpack_require__(267);
	var RightsService = /** @class */ (function (_super) {
	    __extends(RightsService, _super);
	    RightsService.$inject = ["$log", "segment", "store", "changes"];
	    function RightsService($log, segment, store, changes) {
	        'ngInject';
	        return _super.call(this, $log, segment, store, changes) || this;
	    }
	    return RightsService;
	}(rights_service_1.RightsService));
	exports.default = RightsService;
	// class RightsService {
	//   constructor ($log, segment, store, changes) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.segment = segment;
	//     this.store = store.create("trees", "rights", changes.treeStream());
	//   }
	//   update(o) {
	//     this.segment.track('rights.update');
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     this.segment.track('rights.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   //
	//   // helper functions
	//   //
	// }
	// export default RightsService;


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var RightsService = /** @class */ (function () {
	    function RightsService(log, segment, storeService, changes) {
	        this.log = log;
	        this.segment = segment;
	        this.changes = changes;
	        this.store = storeService.create("trees", "rights", changes.treeStream());
	    }
	    RightsService.prototype.update = function (o) {
	        this.segment.track('rights.update');
	        return this.store.update(o);
	    };
	    RightsService.prototype.del = function (id) {
	        this.segment.track('rights.delete');
	        return this.store.del(id);
	    };
	    RightsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    RightsService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    RightsService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    return RightsService;
	}());
	exports.RightsService = RightsService;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var rightsFull_service_1 = __webpack_require__(269);
	var RightsFullService = /** @class */ (function (_super) {
	    __extends(RightsFullService, _super);
	    RightsFullService.$inject = ["rx", "currentUserId", "currentTreeId", "server", "messageBus"];
	    function RightsFullService(rx, currentUserId, currentTreeId, server, messageBus) {
	        'ngInject';
	        return _super.call(this, rx, currentUserId, currentTreeId, server, messageBus) || this;
	    }
	    return RightsFullService;
	}(rightsFull_service_1.RightsFullService));
	exports.default = RightsFullService;
	// class RightsFullService {
	//   constructor (rx, currentUserId, currentTreeId, server, messageBus) {
	//     'ngInject';
	//     this.rx = rx;
	//     this.messageBus = messageBus;
	//     this.server = server;
	//     this.LEVEL_GUEST = 0;
	//     this.LEVEL_READ = 1;
	//     this.LEVEL_EDIT = 2;
	//     this.LEVEL_OWNER = 3;
	//     this.levelLabels = ['GUEST', 'READ', 'EDIT', 'OWNER'];
	//     this.emptyRights = {treeId: -1, userId: -1, level: -1, showAds: true, locked: false, treePrivacy: '', ownerTotalMediaSize: 0, ownerSubscriptionLevel: ''};
	//     this.subject = new rx.BehaviorSubject(this.emptyRights);
	//     this.treeId = -1;
	//     this.userId = -1;
	//     currentTreeId.stream().combineLatest(currentUserId.stream()).subscribe(([treeId, userId]) => {
	//       // reset rights
	//       this.subject.next(this.emptyRights);
	//       // get rights level from server
	//       if (treeId > 0) {
	//         this.treeId = treeId;
	//         this.userId = userId;
	//         this.readRights();
	//       }
	//     });
	//   }
	//   readRights() {
	//     this.server.get('/trees/' + this.treeId + '/rights/' + this.userId + '/full').subscribe(response => {
	//       // store rights onto subject
	//       this.subject.next(Object.assign({}, {treeId: this.treeId, userId: this.userId}, response));
	//       if (response.level === -1) {
	//         this.noRights(this.userId);
	//       }
	//     }, () => {
	//       this.subject.next(this.emptyRights);
	//       this.noRights(this.userId);
	//     });
	//   }
	//   noRights(userId) {
	//     let msg = userId === 0 ? 'NOT_LOGGED_IN' : 'FORBIDDEN';
	//     this.messageBus.post({msg: msg, op: 'GET', ctx: 'rightsFull'});
	//   }
	//   stream() {
	//     return this.subject.filter(x => x.level !== -1);
	//   }
	//   streamLevel() {
	//     return this.subject.filter(x => x.level !== -1).map(x => x.level);
	//   }
	//   ready() {
	//     let readySubject = new this.rx.AsyncSubject();
	//     this.subject.filter(x => x.level !== -1).take(1).subscribe(() => {
	//       readySubject.next(true);
	//       readySubject.complete();
	//     });
	//     return readySubject;
	//   }
	//   get(treeId, userId) {
	//     return this.subject.filter(x => x.treeId === treeId && x.userId === userId && x.level !== -1).take(1);
	//   }
	//   getLevel(treeId, userId) {
	//     return this.subject.filter(x => x.treeId === treeId && x.userId === userId && x.level !== -1).map(x => x.level).take(1);
	//   }
	// }
	// export default RightsFullService;


/***/ }),
/* 269 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var RightsFullService = /** @class */ (function () {
	    function RightsFullService(rx, currentUserId, currentTreeId, server, messageBus) {
	        var _this = this;
	        this.rx = rx;
	        this.currentUserId = currentUserId;
	        this.currentTreeId = currentTreeId;
	        this.server = server;
	        this.messageBus = messageBus;
	        this._LEVEL_GUEST = 0;
	        this._LEVEL_READ = 1;
	        this._LEVEL_EDIT = 2;
	        this._LEVEL_OWNER = 3;
	        this.levelLabels = ['GUEST', 'READ', 'EDIT', 'OWNER'];
	        this.emptyRights = { treeId: -1, userId: -1, level: -1, showAds: true, locked: false, treePrivacy: '', ownerTotalMediaSize: 0, ownerSubscriptionLevel: '' };
	        this.subject = new this.rx.BehaviorSubject(this.emptyRights);
	        this.treeId = -1;
	        this.userId = -1;
	        currentTreeId.stream().combineLatest(currentUserId.stream()).subscribe(function (_a) {
	            var _b = __read(_a, 2), treeId = _b[0], userId = _b[1];
	            // reset rights
	            _this.subject.next(_this.emptyRights);
	            // get rights level from server
	            if (treeId > 0) {
	                _this.treeId = treeId;
	                _this.userId = userId;
	                _this.readRights();
	            }
	        });
	    }
	    Object.defineProperty(RightsFullService.prototype, "LEVEL_GUEST", {
	        get: function () {
	            return this._LEVEL_GUEST;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RightsFullService.prototype, "LEVEL_READ", {
	        get: function () {
	            return this._LEVEL_READ;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RightsFullService.prototype, "LEVEL_EDIT", {
	        get: function () {
	            return this._LEVEL_EDIT;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RightsFullService.prototype, "LEVEL_OWNER", {
	        get: function () {
	            return this._LEVEL_OWNER;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RightsFullService.prototype.readRights = function () {
	        var _this = this;
	        this.server.get('/trees/' + this.treeId + '/rights/' + this.userId + '/full').subscribe(function (response) {
	            // store rights onto subject
	            _this.subject.next(Object.assign({}, { treeId: _this.treeId, userId: _this.userId }, response));
	            if (response.level === -1) {
	                _this.noRights(_this.userId);
	            }
	        }, function () {
	            _this.subject.next(_this.emptyRights);
	            _this.noRights(_this.userId);
	        });
	    };
	    RightsFullService.prototype.noRights = function (userId) {
	        var msg = userId === 0 ? 'NOT_LOGGED_IN' : 'FORBIDDEN';
	        this.messageBus.post({ msg: msg, op: 'GET', ctx: 'rightsFull' });
	    };
	    RightsFullService.prototype.stream = function () {
	        return this.subject.filter(function (x) { return x.level !== -1; });
	    };
	    RightsFullService.prototype.streamLevel = function () {
	        return this.subject.filter(function (x) { return x.level !== -1; }).map(function (x) { return x.level; });
	    };
	    RightsFullService.prototype.ready = function () {
	        var readySubject = new this.rx.AsyncSubject();
	        this.subject.filter(function (x) { return x.level !== -1; }).take(1).subscribe(function () {
	            readySubject.next(true);
	            readySubject.complete();
	        });
	        return readySubject;
	    };
	    RightsFullService.prototype.get = function (treeId, userId) {
	        return this.subject.filter(function (x) { return x.treeId === treeId && x.userId === userId && x.level !== -1; }).take(1);
	    };
	    RightsFullService.prototype.getLevel = function (treeId, userId) {
	        return this.subject.filter(function (x) { return x.treeId === treeId && x.userId === userId && x.level !== -1; }).map(function (x) { return x.level; }).take(1);
	    };
	    return RightsFullService;
	}());
	exports.RightsFullService = RightsFullService;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2018
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var searchHints_service_1 = __webpack_require__(271);
	var SearchHintsService = /** @class */ (function (_super) {
	    __extends(SearchHintsService, _super);
	    SearchHintsService.$inject = ["$log", "rx", "currentTreeId", "server"];
	    function SearchHintsService($log, rx, currentTreeId, server) {
	        'ngInject';
	        return _super.call(this, $log, currentTreeId, server) || this;
	    }
	    return SearchHintsService;
	}(searchHints_service_1.SearchHintsService));
	exports.default = SearchHintsService;
	// class SearchHintsService {
	//   constructor ($log, rx, currentTreeId, server) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.currentTreeId = currentTreeId;
	//     this.server = server;
	//   }
	//   getHints(pid) {
	//     return this.currentTreeId.stream().take(1).flatMap(treeId => {
	//       return this.server.get('/trees/' + treeId + '/search_hints/' + pid);
	//     }).map(results => {
	//       let lists = [];
	//       let censuses = results.filter(result => result.type === 'census');
	//       censuses.sort(this.compareHintYears);
	//       if (censuses.length > 0) {
	//         lists.push({title: 'Censuses', items: censuses.map(hint => this.mapHint(hint))});
	//       }
	//       let deaths = results.filter(result => result.type === 'death');
	//       deaths.sort(this.compareHintPriorities);
	//       if (deaths.length > 0) {
	//         lists.push({title: 'Death records', items: deaths.map(hint => this.mapHint(hint))});
	//       }
	//       let marriages = results.filter(result => result.type === 'marriage');
	//       marriages.sort(this.compareHintPriorities);
	//       if (marriages.length > 0) {
	//         lists.push({title: 'Marriage records', items: marriages.map(hint => this.mapHint(hint))});
	//       }
	//       let births = results.filter(result => result.type === 'birth');
	//       births.sort(this.compareHintPriorities);
	//       if (births.length > 0) {
	//         lists.push({title: 'Birth records', items: births.map(hint => this.mapHint(hint))});
	//       }
	//       if (lists.length === 0) {
	//         lists.push({title: 'No search hints', items: [{text:'We\'re sorry, we don\'t have any <i>Search Hints</i> for this person. ' +
	//         'But the <i>GenSmarts Hints</i>, <i>Research Guides</i> and <i>Links</i> menu items should help you find other resources to search. ' +
	//         'And if you run into a brick wall, consider <i>Get Help</i>.'}]});
	//       }
	//       return lists;
	//     });
	//   }
	//   mapHint(hint) {
	//     let icons = [];
	//     if (hint.providesData) {
	//       icons.push({name: 'lightbulb_outline', title: 'Could fill in missing data'});
	//     }
	//     if (hint.providesSource) {
	//       icons.push({name: 'star_border', title: 'Could fill in missing source'});
	//     }
	//     return {
	//       title: hint.title,
	//       icons: icons,
	//       text: hint.text,
	//       items: hint.locations.map(location => {
	//         return {
	//           title: location.title,
	//           url: location.url
	//         };
	//       })
	//     };
	//   }
	//   compareHintYears(a,b) {
	//     if (a.startYear < b.startYear) {
	//       return 1;
	//     }
	//     else if (a.startYear > b.startYear) {
	//       return -1;
	//     }
	//     let at = a.title.toLowerCase();
	//     let bt = b.title.toLowerCase();
	//     if (at < bt) {
	//       return -1;
	//     } else if (at > bt) {
	//       return 1;
	//     }
	//     return 0;
	//   }
	//   compareHintPriorities(a,b) {
	//     if (a.priority < b.priority) {
	//       return 1;
	//     }
	//     else if (a.priority > b.priority) {
	//       return -1;
	//     }
	//     let at = a.title.toLowerCase();
	//     let bt = b.title.toLowerCase();
	//     if (at < bt) {
	//       return -1;
	//     } else if (at > bt) {
	//       return 1;
	//     }
	//     return 0;
	//   }
	// }
	// export default SearchHintsService;


/***/ }),
/* 271 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2018
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SearchHintsService = /** @class */ (function () {
	    function SearchHintsService(log, currentTreeId, server) {
	        this.log = log;
	        this.currentTreeId = currentTreeId;
	        this.server = server;
	    }
	    SearchHintsService.prototype.getHints = function (pid) {
	        var _this = this;
	        return this.currentTreeId.stream().take(1).flatMap(function (treeId) {
	            return _this.server.get('/trees/' + treeId + '/search_hints/' + pid);
	        }).map(function (results) {
	            var lists = [];
	            var censuses = results.filter(function (result) { return result.type === 'census'; });
	            censuses.sort(_this.compareHintYears);
	            if (censuses.length > 0) {
	                lists.push({ title: 'Censuses', items: censuses.map(function (hint) { return _this.mapHint(hint); }) });
	            }
	            var deaths = results.filter(function (result) { return result.type === 'death'; });
	            deaths.sort(_this.compareHintPriorities);
	            if (deaths.length > 0) {
	                lists.push({ title: 'Death records', items: deaths.map(function (hint) { return _this.mapHint(hint); }) });
	            }
	            var marriages = results.filter(function (result) { return result.type === 'marriage'; });
	            marriages.sort(_this.compareHintPriorities);
	            if (marriages.length > 0) {
	                lists.push({ title: 'Marriage records', items: marriages.map(function (hint) { return _this.mapHint(hint); }) });
	            }
	            var births = results.filter(function (result) { return result.type === 'birth'; });
	            births.sort(_this.compareHintPriorities);
	            if (births.length > 0) {
	                lists.push({ title: 'Birth records', items: births.map(function (hint) { return _this.mapHint(hint); }) });
	            }
	            if (lists.length === 0) {
	                lists.push({ title: 'No search hints', items: [{ text: 'We\'re sorry, we don\'t have any <i>Search Hints</i> for this person. ' +
	                                'But the <i>Research Guides</i> and <i>Links</i> menu items should help you find other resources to search. ' +
	                                'And if you run into a brick wall, consider <i>Get Help</i>.' }] });
	            }
	            return lists;
	        });
	    };
	    SearchHintsService.prototype.mapHint = function (hint) {
	        var icons = [];
	        if (hint.providesData) {
	            icons.push({ name: 'lightbulb_outline', title: 'Could fill in missing data' });
	        }
	        if (hint.providesSource) {
	            icons.push({ name: 'star_border', title: 'Could fill in missing source' });
	        }
	        return {
	            title: hint.title,
	            icons: icons,
	            text: hint.text,
	            items: hint.locations.map(function (location) {
	                return {
	                    title: location.title,
	                    url: location.url
	                };
	            })
	        };
	    };
	    SearchHintsService.prototype.compareHintYears = function (a, b) {
	        if (a.startYear < b.startYear) {
	            return 1;
	        }
	        else if (a.startYear > b.startYear) {
	            return -1;
	        }
	        var at = a.title.toLowerCase();
	        var bt = b.title.toLowerCase();
	        if (at < bt) {
	            return -1;
	        }
	        else if (at > bt) {
	            return 1;
	        }
	        return 0;
	    };
	    SearchHintsService.prototype.compareHintPriorities = function (a, b) {
	        if (a.priority < b.priority) {
	            return 1;
	        }
	        else if (a.priority > b.priority) {
	            return -1;
	        }
	        var at = a.title.toLowerCase();
	        var bt = b.title.toLowerCase();
	        if (at < bt) {
	            return -1;
	        }
	        else if (at > bt) {
	            return 1;
	        }
	        return 0;
	    };
	    return SearchHintsService;
	}());
	exports.SearchHintsService = SearchHintsService;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var segment_service_1 = __webpack_require__(273);
	var SegmentService = /** @class */ (function (_super) {
	    __extends(SegmentService, _super);
	    SegmentService.$inject = ["$log", "$window", "$rootScope", "server", "currentUserId", "currentTreeId"];
	    function SegmentService($log, $window, $rootScope, server, currentUserId, currentTreeId) {
	        'ngInject';
	        return _super.call(this, $log, $rootScope, $window.Raven, angular, server, currentUserId, currentTreeId) || this;
	    }
	    return SegmentService;
	}(segment_service_1.SegmentService));
	exports.default = SegmentService;
	// class SegmentService {
	//   constructor($log, $window, $rootScope, server, currentUserId, currentTreeId) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.Raven = $window.Raven;
	//     this.$rootScope = $rootScope;
	//     this.server = server;
	//     currentUserId.stream().subscribe(userId => {
	//       this.userId = userId;
	//     });
	//     currentTreeId.stream().subscribe(treeId => {
	//       this.treeId = treeId;
	//     });
	//   }
	//   page(state) {
	//     this.track('state.'+state);
	//   }
	//   track(name, params) {
	//     this.Raven.captureBreadcrumb({
	//       category: 'action',
	//       message: name,
	//       data: params || {}
	//     });
	//     if (this.userId > 0 && !this.$rootScope.fsImportStream) {
	//       let event = {
	//         treeId: this.treeId || 0,
	//         eventName: name
	//       };
	//       if (!!params) {
	//         event.params = angular.toJson(params);
	//       }
	//       this.server.post('/events', event).subscribe(() => {});
	//     }
	//   }
	// }
	// export default SegmentService;


/***/ }),
/* 273 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SegmentService = /** @class */ (function () {
	    function SegmentService(log, rootScope, Raven, angularUtils, server, currentUserId, currentTreeId) {
	        var _this = this;
	        this.log = log;
	        this.rootScope = rootScope;
	        this.Raven = Raven;
	        this.angularUtils = angularUtils;
	        this.server = server;
	        this.currentUserId = currentUserId;
	        this.currentTreeId = currentTreeId;
	        currentUserId.stream().subscribe(function (userId) {
	            _this.userId = userId;
	        });
	        currentTreeId.stream().subscribe(function (treeId) {
	            _this.treeId = treeId;
	        });
	    }
	    SegmentService.prototype.page = function (state) {
	        this.track('state.' + state);
	    };
	    SegmentService.prototype.track = function (name, params) {
	        this.Raven.captureBreadcrumb({
	            category: 'action',
	            message: name,
	            data: params || {}
	        });
	        if (this.userId > 0 && !this.rootScope.fsImportStream) {
	            var event_1 = {
	                treeId: this.treeId || 0,
	                eventName: name,
	                params: undefined
	            };
	            if (!!params) {
	                event_1.params = this.angularUtils.toJson(params);
	            }
	            this.server.post('/events', event_1).subscribe(function () { });
	        }
	    };
	    return SegmentService;
	}());
	exports.SegmentService = SegmentService;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var server_service_1 = __webpack_require__(275);
	var ServerService = /** @class */ (function (_super) {
	    __extends(ServerService, _super);
	    ServerService.$inject = ["$log", "$rootScope", "rx", "serverBase", "httpClient", "authToken"];
	    function ServerService($log, $rootScope, rx, serverBase, httpClient, authToken) {
	        'ngInject';
	        return _super.call(this, $log, rx, httpClient, serverBase, authToken, angular) || this;
	    }
	    return ServerService;
	}(server_service_1.ServerService));
	exports.default = ServerService;
	// class ServerService {
	//   public subject;
	//   public maxRetries: number;
	//   public delay: number;
	//   public pending: number;
	//   constructor(public $log, public $http, public $rootScope, public rx, public serverBase, public authToken) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.$http = $http;
	//     this.$rootScope = $rootScope;
	//     this.rx = rx;
	//     this.serverBase = serverBase;
	//     this.authToken = authToken;
	//     this.subject = new rx.Subject();
	//     this.maxRetries = 5;
	//     this.delay = 1000;
	//     this.pending = 0;
	//   }
	//   http(method, url, params, data, opts) {
	//     // add authentication token as a parameter to avoid preflight
	//     let token = this.authToken.get();
	//     if (token !== '') {
	//       if (!angular.isObject(params)) {
	//         params = {};
	//       }
	//       params = Object.assign({}, params, {token});
	//     }
	//     // set up request
	//     let request = {method, url: this.serverBase + url, params, data, timeout: 120000, withCredentials: false};
	//     // add options
	//     if (angular.isObject(opts)) {
	//       angular.extend(request, opts);
	//     }
	//     // issue request
	//     this.$log.debug('server.http.request', request);
	//     this.incRequests();
	//     return this.rx.Observable.defer(() => this.$http(request))
	//       .catch(response => {
	//         if (response.status === 304) {
	//           return this.rx.Observable.of(response);
	//         }
	//         else {
	//           return this.rx.Observable.throw(response);
	//         }
	//       }).retryWhen(errors => {
	//         return this.rx.Observable.range(0, this.maxRetries)
	//           .zip(errors, (count, err) => {
	//             return {count, err};
	//           })
	//           .flatMap(({count, err}) => {
	//             this.$log.warn('server.http.retry', err, count, url);
	//             // if we've tried too many times, or retrying is pointless
	//             if (count >= this.maxRetries-1 || err.status === 400 || err.status === 401 || err.status === 403 || err.status === 404 || err.status === 409 || err.status === 413) {
	//               return this.rx.Observable.throw(err);
	//             }
	//             // exponential backoff
	//             return this.rx.Observable.timer(this.delay * Math.pow(2, count));
	//         });
	//       })
	//       .map(response => {
	//         return (response.status === 304 ? response.status : response.data);
	//       }).do(data => {
	//         this.$log.debug('server.http.success', data);
	//         this.decRequests();
	//       }, response => {
	//         this.$log.debug('server.http.error', response);
	//         this.decRequests();
	//       });
	//   }
	//   // returns rx.Observable of response
	//   get(url, params, opts) {
	//     return this.http('GET', url, params, null, opts);
	//   }
	//   // returns rx.Observable of response
	//   post(url, data, params, opts) {
	//     return this.http('POST', url, params, data, opts);
	//   }
	//   // returns rx.Observable of response
	//   put(url, data, params, opts) {
	//     return this.http('PUT', url, params, data, opts);
	//   }
	//   // returns rx.Observable of response
	//   del(url, params, opts) {
	//     return this.http('DELETE', url, params, null, opts);
	//   }
	//   incRequests() {
	//     this.subject.next(++this.pending);
	//     this.$rootScope.loading = true;
	//   }
	//   decRequests() {
	//     this.subject.next(--this.pending);
	//     if (this.pending === 0) {
	//       this.$rootScope.loading = false;
	//     }
	//   }
	//   // returns rx.Subject of num pending requests
	//   stream() {
	//     return this.subject;
	//   }
	// }
	// export default ServerService;


/***/ }),
/* 275 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Observable, Subject } from '../../node_modules/rxjs';
	var ServerService = /** @class */ (function () {
	    function ServerService(log, rx, httpClient, serverBase, authToken, angularUtils) {
	        this.log = log;
	        this.rx = rx;
	        this.httpClient = httpClient;
	        this.serverBase = serverBase;
	        this.authToken = authToken;
	        this.angularUtils = angularUtils;
	        this.maxRetries = 5;
	        this.delay = 1000;
	        this.pending = 0;
	    }
	    /*this.http.get<Config>(this.configUrl)
	  .pipe(
	    retry(3), // retry a failed request up to 3 times
	    catchError(this.handleError) // then handle the error
	  );*/
	    ServerService.prototype.http = function (method, url, params, data, opts) {
	        var _this = this;
	        var token = this.authToken.get();
	        if (token !== '') {
	            if (!this.angularUtils.isObject(params)) {
	                params = {};
	            }
	            params = Object.assign({}, params, { token: token });
	        }
	        var fullUrl = this.serverBase + url;
	        this.log.debug('server.http.request', method, url, params, data, opts);
	        this.incRequests();
	        var response /*Observable<any>*/;
	        switch (method) {
	            case 'GET':
	                response = this.httpClient.get(fullUrl, {
	                    params: params,
	                    observe: 'response'
	                });
	                break;
	            case 'POST':
	                response = this.httpClient.post(fullUrl, data, {
	                    params: params,
	                    observe: 'response'
	                });
	                break;
	            case 'PUT':
	                response = this.httpClient.put(fullUrl, data, {
	                    params: params,
	                    observe: 'response'
	                });
	                break;
	            case 'DELETE':
	                response = this.httpClient.delete(fullUrl, {
	                    params: params,
	                    observe: response
	                });
	                break;
	        }
	        return response.map(function (response) {
	            return (response.status === 304 ? response.status : (!!response.body ? response.body : response.data));
	        }).do(function (data) {
	            _this.log.debug('server.http.success', data);
	            _this.decRequests();
	        }, function (response) {
	            if (!!response && !!response.error && !response.data) {
	                response.data = response.error;
	            }
	            _this.log.debug('server.http.error', response);
	            _this.decRequests();
	        });
	    };
	    // returns rx.Observable of response
	    ServerService.prototype.get = function (url, params, opts) {
	        return this.http('GET', url, params, null, opts);
	    };
	    // returns rx.Observable of response
	    ServerService.prototype.post = function (url, data, params, opts) {
	        return this.http('POST', url, params, data, opts);
	    };
	    // returns rx.Observable of response
	    ServerService.prototype.put = function (url, data, params, opts) {
	        return this.http('PUT', url, params, data, opts);
	    };
	    // returns rx.Observable of response
	    ServerService.prototype.del = function (url, params, opts) {
	        return this.http('DELETE', url, params, null, opts);
	    };
	    ServerService.prototype.incRequests = function () {
	    };
	    ServerService.prototype.decRequests = function () {
	    };
	    // returns rx.Subject of num pending requests
	    ServerService.prototype.stream = function () {
	        return new this.rx.Subject(); //Todo add implementation with httpClient
	    };
	    return ServerService;
	}());
	exports.ServerService = ServerService;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var showAds_service_1 = __webpack_require__(277);
	var ShowAdsService = /** @class */ (function (_super) {
	    __extends(ShowAdsService, _super);
	    ShowAdsService.$inject = ["currentTreeId", "subscriptions", "rightsFull"];
	    function ShowAdsService(currentTreeId, subscriptions, rightsFull) {
	        'ngInject';
	        return _super.call(this, currentTreeId, subscriptions, rightsFull) || this;
	    }
	    return ShowAdsService;
	}(showAds_service_1.ShowAdsService));
	exports.default = ShowAdsService;
	// class ShowAdsService {
	//   constructor (currentTreeId, subscriptions, rightsFull) {
	//     'ngInject';
	//     this.currentTreeId = currentTreeId;
	//     this.subscriptions = subscriptions;
	//     this.rightsFull = rightsFull;
	//   }
	//   stream() {
	//     return this.currentTreeId.streamAll().flatMap(treeId => {
	//       if (treeId > 0) {
	//         return this.rightsFull.stream().map(x => x.showAds);
	//       }
	//       else {
	//         return this.subscriptions.stream().filter(x => !!x).map(sub => {
	//           return !sub.level || sub.level === 'FREE';
	//         });
	//       }
	//     });
	//   }
	// }
	// export default ShowAdsService;


/***/ }),
/* 277 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Observable } from "../../node_modules/rxjs";
	var ShowAdsService = /** @class */ (function () {
	    function ShowAdsService(currentTreeId, subscriptions, rightsFull) {
	        this.currentTreeId = currentTreeId;
	        this.subscriptions = subscriptions;
	        this.rightsFull = rightsFull;
	    }
	    ShowAdsService.prototype.stream = function () {
	        var _this = this;
	        return this.currentTreeId.streamAll().flatMap(function (treeId) {
	            if (treeId > 0) {
	                return _this.rightsFull.stream().map(function (x) { return x.showAds; });
	            }
	            else {
	                return _this.subscriptions.stream().filter(function (x) { return !!x; }).map(function (sub) {
	                    return !sub.level || sub.level === 'FREE';
	                });
	            }
	        });
	    };
	    return ShowAdsService;
	}());
	exports.ShowAdsService = ShowAdsService;


/***/ }),
/* 278 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SidenavService = /** @class */ (function () {
	    SidenavService.$inject = ["$log", "$mdSidenav", "$mdMedia"];
	    function SidenavService($log, $mdSidenav, $mdMedia) {
	        'ngInject';
	        // public
	        this.width = 200;
	        this.$log = $log;
	        this.$mdSidenav = $mdSidenav;
	        this.$mdMedia = $mdMedia;
	        this.isSidenavLockedClosed = false;
	    }
	    SidenavService.prototype.isLockedOpen = function () {
	        return this.$mdMedia('gt-sm') && !this.isSidenavLockedClosed;
	    };
	    SidenavService.prototype.toggle = function () {
	        if (this.$mdMedia('gt-sm')) {
	            this.isSidenavLockedClosed = !this.isSidenavLockedClosed;
	            if (this.isSidenavLockedClosed && this.$mdSidenav('sidenav').isOpen()) {
	                this.$mdSidenav('sidenav').toggle();
	            }
	        }
	        else {
	            this.$log.info('toggling sidenav');
	            this.$mdSidenav('sidenav').toggle();
	        }
	    };
	    return SidenavService;
	}());
	exports.default = SidenavService;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var social_service_1 = __webpack_require__(280);
	var SocialService = /** @class */ (function (_super) {
	    __extends(SocialService, _super);
	    SocialService.$inject = ["$log", "$window", "$location", "$state", "rx", "serverBase", "messageBus", "currentTree", "segment", "utils"];
	    function SocialService($log, $window, $location, $state, rx, serverBase, messageBus, currentTree, segment, utils) {
	        'ngInject';
	        return _super.call(this, $log, $window, $location, $state, rx, serverBase, messageBus, currentTree, segment, utils) || this;
	    }
	    return SocialService;
	}(social_service_1.SocialService));
	exports.default = SocialService;
	// class SocialService {
	//   constructor ($log, $window, $location, $state, rx, serverBase, messageBus, currentTree, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.$window = $window;
	//     this.$location = $location;
	//     this.$state = $state;
	//     this.rx = rx;
	//     this.serverBase = serverBase;
	//     this.messageBus = messageBus;
	//     this.currentTree = currentTree;
	//     this.segment = segment;
	//     this.utils = utils;
	//   }
	//   post(platform, item) {
	//     this.currentTree.stream().take(1).subscribe(tree => {
	//       let url = this.getItemUrl(item);
	//       //let picture = '';
	//       //let thumbnail = '';
	//       if (tree.id > 0 && item.mediaId > 0) {
	//         this.segment.track('share.media.'+platform);
	//         //let imageBase = this.serverBase + '/trees/' + tree.id + '/media/' + item.mediaId.toString() + '/files/0?';
	//         //picture = imageBase + 'size=600';
	//         //thumbnail = imageBase + 'size=100x100';
	//       }
	//       else if (tree.id > 0 && !!item.graphicId > 0) {
	//         this.segment.track('share.graphic.'+platform);
	//         //picture = item.url;
	//         //thumbnail = item.url;
	//       }
	//       else {
	//         this.segment.track('share.other.'+platform);
	//       }
	//       else if (tree.id > 0 && !!item.graphicId > 0) {
	//         this.segment.track('share.graphic.'+platform);
	//         picture = item.url;
	//         thumbnail = item.url;
	//       }
	//       else {
	//         this.segment.track('share.other.'+platform);
	//       }
	//       if (platform === 'FACEBOOK') {
	//         this.$window.FB.ui({
	//           method: 'share',
	//           hashtag: '#rootsfinderapp',
	//           quote: item.title,
	//           href: item.url || url,
	//         }, () => {
	//           // ignore
	//         });
	//         //this.utils.dialog(ev, 'FacebookController', 'app/components/social/facebook.html', false, {
	//         //  link: url,
	//         //  title: item.title,
	//         //  picture: picture,
	//         //  thumbnail: thumbnail,
	//         //  description: item.description
	//         //});
	//       }
	//       else if (platform === 'PINTEREST') {
	//         this.postPinterest({
	//           link: url,
	//           picture: item.url || url,
	//           title: item.title
	//         });
	//       }
	//     });
	//   }
	//   getItemUrl(item) {
	//     if (item.graphicId > 0) {
	//       //return this.$state.href('tree.infographics', {graphicId: this.utils.encodeId(item.graphicId)}, {absolute: true});
	//       return item.url;
	//     }
	//     if (item.mediaId > 0) {
	//       return this.$state.href('tree.media', {mediaId: this.utils.encodeId(item.mediaId)}, {absolute: true});
	//     }
	//     let url = this.$location.absUrl();
	//     if (url.indexOf('/persons/') < 0 && !!item.personIds && item.personIds.size > 0) {
	//       url = this.$state.href('tree.person', {personId: this.utils.encodeId(Array.from(item.personIds.keys())[0])}, {absolute: true});
	//     }
	//     return url;
	//   }
	//   getTwitterUrl(item) {
	//     let text = item.text;
	//     if (!text) {
	//       text = '';
	//     }
	//     else if (text.length > 100) {
	//       text = text.substr(0, 100);
	//     }
	//     return 'https://twitter.com/intent/tweet?'+
	//       'text='+ encodeURIComponent(text)+
	//       '&url='+ encodeURIComponent(this.getItemUrl(item))+
	//       '&via=rootsfinderapp';
	//   }
	//   // gets called from the facebook controller dialog
	//   // {message, link, picture, name, caption, description, privacy}
	//   postFacebook(item) {
	//     let s = new this.rx.AsyncSubject();
	//     this.$window.FB.getLoginStatus(response => {
	//       this.$log.debug('Facebook status', response);
	//       if (response.status === 'connected') {
	//         this._postFacebook(item).subscribe(() => {
	//           s.next(true);
	//           s.complete();
	//         }, () => {
	//           s.error();
	//         });
	//       }
	//       else {
	//         this.$window.FB.login(response => {
	//           this.$log.debug('Facebook login', response);
	//           if (!!response.authResponse) {
	//             this._postFacebook(item).subscribe(() => {
	//               s.next(true);
	//               s.complete();
	//             }, () => {
	//               s.error();
	//             });
	//           }
	//           else {
	//             this.messageBus.post({msg: 'Facebook login cancelled', ctx: 'facebook'});
	//             s.error();
	//           }
	//         }, {scope: 'publish_actions'});
	//       }
	//     });
	//     return s;
	//   }
	//   _postFacebook(item) {
	//     let s = new this.rx.AsyncSubject();
	//     console.log('_postFacebook', item);
	//     this.$window.FB.api('/me/feed', 'post', {
	//       message: item.message,
	//       link: item.link,
	//       picture: item.picture,
	//       name: item.name,
	//       caption: item.caption,
	//       description: item.description,
	//       privacy: {value: item.privacy} // EVERYONE, ALL_FRIENDS, FRIENDS_OF_FRIENDS, SELF
	//     }, response => {
	//       if (!response || response.error) {
	//         this.messageBus.post({msg: 'Facebook post failed', ctx: 'facebook', warn: true, warnParams: {response: response}});
	//         s.error();
	//       }
	//       else {
	//         s.next(true);
	//         s.complete();
	//       }
	//     });
	//     return s;
	//   }
	//   // {link, picture, name}
	//   postPinterest(item) {
	//     this.$window.PinUtils.pinOne({
	//       url: item.link,
	//       media: item.picture,
	//       description: item.title
	//     });
	//   }
	// }
	// export default SocialService;


/***/ }),
/* 280 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { dialogHandler } from "../utils/uiUtils.service";
	var SocialService = /** @class */ (function () {
	    function SocialService(log, window, location, state, rx, serverBase, messageBus, currentTree, segment, utils) {
	        this.log = log;
	        this.window = window;
	        this.location = location;
	        this.state = state;
	        this.rx = rx;
	        this.serverBase = serverBase;
	        this.messageBus = messageBus;
	        this.currentTree = currentTree;
	        this.segment = segment;
	        this.utils = utils;
	    }
	    SocialService.prototype.post = function (platform, item) {
	        var _this = this;
	        this.currentTree.stream().take(1).subscribe(function (tree) {
	            var url = _this.getItemUrl(item);
	            var picture = '';
	            var thumbnail = '';
	            if (tree.id > 0 && item.mediaId > 0) {
	                _this.segment.track('share.media.' + platform);
	                //let imageBase = this.serverBase + '/trees/' + tree.id + '/media/' + item.mediaId.toString() + '/files/0?';
	                //picture = imageBase + 'size=600';
	                //thumbnail = imageBase + 'size=100x100';
	            }
	            else if (tree.id > 0 && +!!item.graphicId > 0) {
	                _this.segment.track('share.graphic.' + platform);
	                //picture = item.url;
	                //thumbnail = item.url;
	            }
	            else {
	                _this.segment.track('share.other.' + platform);
	            }
	            // else if (tree.id > 0 && +!!item.graphicId > 0) {
	            //   this.segment.track('share.graphic.' + platform);
	            //   picture = item.url;
	            //   thumbnail = item.url;
	            // }
	            // else {
	            //   this.segment.track('share.other.' + platform);
	            // }
	            if (platform === 'FACEBOOK') {
	                _this.window.FB.ui({
	                    method: 'share',
	                    hashtag: '#rootsfinderapp',
	                    quote: item.title,
	                    href: item.url || url,
	                }, function () {
	                    // ignore
	                });
	                //this.utils.dialog(ev, 'FacebookController', 'app/components/social/facebook.html', false, {
	                //  link: url,
	                //  title: item.title,
	                //  picture: picture,
	                //  thumbnail: thumbnail,
	                //  description: item.description
	                //});
	            }
	            else if (platform === 'PINTEREST') {
	                _this.postPinterest({
	                    link: url,
	                    picture: item.url || url,
	                    title: item.title
	                });
	            }
	        });
	    };
	    SocialService.prototype.getItemUrl = function (item) {
	        if (item.graphicId > 0) {
	            //return this.$state.href('tree.infographics', {graphicId: this.utils.encodeId(item.graphicId)}, {absolute: true});
	            return item.url;
	        }
	        if (item.mediaId > 0) {
	            return this.state.href('tree.media', { mediaId: this.utils.encodeId(item.mediaId) }, { absolute: true });
	        }
	        var url = this.location.absUrl();
	        if (url.indexOf('/persons/') < 0 && !!item.personIds && item.personIds.size > 0) {
	            url = this.state.href('tree.person', { personId: this.utils.encodeId(Array.from(item.personIds.keys())[0]) }, { absolute: true });
	        }
	        return url;
	    };
	    SocialService.prototype.getTwitterUrl = function (item) {
	        var text = item.text;
	        if (!text) {
	            text = '';
	        }
	        else if (text.length > 100) {
	            text = text.substr(0, 100);
	        }
	        return 'https://twitter.com/intent/tweet?' +
	            'text=' + encodeURIComponent(text) +
	            '&url=' + encodeURIComponent(this.getItemUrl(item)) +
	            '&via=rootsfinderapp';
	    };
	    // gets called from the facebook controller dialog
	    // {message, link, picture, name, caption, description, privacy}
	    SocialService.prototype.postFacebook = function (item) {
	        var _this = this;
	        var s = new this.rx.AsyncSubject();
	        this.window.FB.getLoginStatus(function (response) {
	            _this.log.debug('Facebook status', response);
	            if (response.status === 'connected') {
	                _this._postFacebook(item).subscribe(function () {
	                    s.next(true);
	                    s.complete();
	                }, function () {
	                    s.error();
	                });
	            }
	            else {
	                _this.window.FB.login(function (response) {
	                    _this.log.debug('Facebook login', response);
	                    if (!!response.authResponse) {
	                        _this._postFacebook(item).subscribe(function () {
	                            s.next(true);
	                            s.complete();
	                        }, function () {
	                            s.error();
	                        });
	                    }
	                    else {
	                        _this.messageBus.post({ msg: 'Facebook login cancelled', ctx: 'facebook' });
	                        s.error();
	                    }
	                }, { scope: 'publish_actions' });
	            }
	        });
	        return s;
	    };
	    SocialService.prototype._postFacebook = function (item) {
	        var _this = this;
	        var s = new this.rx.AsyncSubject();
	        console.log('_postFacebook', item);
	        this.window.FB.api('/me/feed', 'post', {
	            message: item.message,
	            link: item.link,
	            picture: item.picture,
	            name: item.name,
	            caption: item.caption,
	            description: item.description,
	            privacy: { value: item.privacy } // EVERYONE, ALL_FRIENDS, FRIENDS_OF_FRIENDS, SELF
	        }, function (response) {
	            if (!response || response.error) {
	                _this.messageBus.post({ msg: 'Facebook post failed', ctx: 'facebook', warn: true, warnParams: { response: response } });
	                s.error();
	            }
	            else {
	                s.next(true);
	                s.complete();
	            }
	        });
	        return s;
	    };
	    // {link, picture, name}
	    SocialService.prototype.postPinterest = function (item) {
	        this.window.PinUtils.pinOne({
	            url: item.link,
	            media: item.picture,
	            description: item.title
	        });
	    };
	    return SocialService;
	}());
	exports.SocialService = SocialService;
	exports.default = SocialService;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var sources_service_1 = __webpack_require__(282);
	var SourcesService = /** @class */ (function (_super) {
	    __extends(SourcesService, _super);
	    SourcesService.$inject = ["$log", "rx", "store", "changes", "currentTreeId", "messageBus", "server", "segment", "utils"];
	    function SourcesService($log, rx, store, changes, currentTreeId, messageBus, server, segment, utils) {
	        'ngInject';
	        return _super.call(this, rx, store, changes, currentTreeId, messageBus, server, segment, utils) || this;
	    }
	    return SourcesService;
	}(sources_service_1.SourcesService));
	exports.default = SourcesService;
	// class SourcesService {
	//   constructor ($log, rx, store, changes, currentTreeId, messageBus, server, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.currentTreeId = currentTreeId;
	//     this.messageBus = messageBus;
	//     this.server = server;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", "sources", changes.treeStream(), (s) => utils.addCreateEditDates(s));
	//     this.mediaStream = this.store.addStream(store.streamScanFn(o => {
	//       return o.mediaIds ? o.mediaIds.keys() : null;
	//     }));
	//   }
	//   create(o, doNotTrack) {
	//     if (!doNotTrack) {
	//       this.segment.track('sources.create');
	//     }
	//     return this.store.create(o);
	//   }
	//   update(o) {
	//     this.segment.track('sources.update');
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     this.segment.track('sources.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   streamIds(ids) {
	//     return this.store.streamIds(ids);
	//   }
	//   // returns a map
	//   streamForMedia(mid) {
	//     return this.ready().flatMap(() => this.ready().flatMap(() => this.mediaStream.map(m => m.get(mid) || new Map())));
	//   }
	//   //
	//   // autocomplete
	//   //
	//   autocomplete(prefix) {
	//     return this.currentTreeId.stream().take(1).flatMap(treeId => {
	//       return this.server.get('/trees/'+treeId+'/sources', {prefix})
	//         .catch(err => {
	//           this.messageBus.post({msg: err.data, status: err.status, op: 'GET', ctx: 'trees/sources/autocomplete'});
	//           return this.rx.Observable.of([]);
	//         });
	//     })
	//     .toPromise();
	//   }
	//   //
	//   // helper functions
	//   //
	//   augmentSource(s, users) {
	//     let subject = new this.rx.AsyncSubject();
	//     let waitCount = 1;
	//     s = Object.assign({}, s, {
	//       '_createdUser' : null,
	//       '_editedUser' : null
	//     });
	//     // set created user and edited user
	//     this.utils.addCreateEditUsers(s, users).subscribe(() => {
	//       if (--waitCount === 0) {
	//         subject.next(s);
	//         subject.complete();
	//       }
	//     });
	//     return subject;
	//   }
	//   hasWord(s, w) {
	//     return (s.abbr.toLowerCase().indexOf(w) >= 0) ||
	//       (s.title.toLowerCase().indexOf(w) >= 0) ||
	//       (s.subtitle.toLowerCase().indexOf(w) >= 0) ||
	//       (s.creator.toLowerCase().indexOf(w) >= 0) ||
	//       (s.publisher.toLowerCase().indexOf(w) >= 0) ||
	//       (s.dateIssued.toLowerCase().indexOf(w) >= 0) ||
	//       (s.placeIssued.toLowerCase().indexOf(w) >= 0) ||
	//       (s.periodicalSeries.toLowerCase().indexOf(w) >= 0) ||
	//       (s.numVolumes.toLowerCase().indexOf(w) >= 0) ||
	//       (s.volumeFilmPages.toLowerCase().indexOf(w) >= 0) ||
	//       (s.repository.toLowerCase().indexOf(w) >= 0) ||
	//       (s.callNumber.toLowerCase().indexOf(w) >= 0) ||
	//       (s.url.toLowerCase().indexOf(w) >= 0) ||
	//       (s.shortFootnote.toLowerCase().indexOf(w) >= 0) ||
	//       (s.bibCitation.toLowerCase().indexOf(w) >= 0) ||
	//       (s.text.toLowerCase().indexOf(w) >= 0);
	//   }
	// }
	// export default SourcesService;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { BehaviorSubject, AsyncSubject } from "../../node_modules/rxjs";
	var SourcesService = /** @class */ (function () {
	    function SourcesService(rx, store, changes, currentTreeId, messageBus, server, segment, utils) {
	        this.rx = rx;
	        this.currentTreeId = currentTreeId;
	        this.messageBus = messageBus;
	        this.server = server;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "sources", changes.treeStream(), function (s) { return utils.addCreateEditDates(s); });
	        this.mediaStream = this.store.addStream(store.streamScanFn(function (o) {
	            return o.mediaIds ? o.mediaIds.keys() : null;
	        }));
	    }
	    SourcesService.prototype.create = function (o, doNotTrack) {
	        if (!doNotTrack) {
	            this.segment.track('sources.create');
	        }
	        return this.store.create(o);
	    };
	    SourcesService.prototype.update = function (o) {
	        this.segment.track('sources.update');
	        return this.store.update(o);
	    };
	    SourcesService.prototype.del = function (id) {
	        this.segment.track('sources.delete');
	        return this.store.del(id);
	    };
	    SourcesService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    SourcesService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    SourcesService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    SourcesService.prototype.streamIds = function (ids) {
	        return this.store.streamIds(ids);
	    };
	    // returns a map
	    SourcesService.prototype.streamForMedia = function (mid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.ready().flatMap(function () { return _this.mediaStream.map(function (m) { return m.get(mid) || new Map(); }); }); });
	    };
	    //
	    // autocomplete
	    //
	    SourcesService.prototype.autocomplete = function (prefix) {
	        var _this = this;
	        return this.currentTreeId.stream().take(1).flatMap(function (treeId) {
	            return _this.server.get('/trees/' + treeId + '/sources', { prefix: prefix })
	                .catch(function (err) {
	                _this.messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'trees/sources/autocomplete' });
	                return _this.rx.Observable.of([]);
	            });
	        })
	            .toPromise();
	    };
	    //
	    // helper functions
	    //
	    SourcesService.prototype.augmentSource = function (s, users) {
	        var subject = new this.rx.AsyncSubject();
	        var waitCount = 1;
	        s = Object.assign({}, s, {
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        if (!s.abbr) {
	            s.abbr = this.utils.truncate((s.text || 'Source').replace(/<[a-z\/ ]+>/gi, ' ').replace(/&([a-z]+|#[0-9]+);/g, ''), 80);
	        }
	        // set created user and edited user
	        this.utils.addCreateEditUsers(s, users).subscribe(function () {
	            if (--waitCount === 0) {
	                subject.next(s);
	                subject.complete();
	            }
	        });
	        return subject;
	    };
	    SourcesService.prototype.hasWord = function (s, w) {
	        return (s.abbr.toLowerCase().indexOf(w) >= 0) ||
	            (s.title.toLowerCase().indexOf(w) >= 0) ||
	            (s.subtitle.toLowerCase().indexOf(w) >= 0) ||
	            (s.creator.toLowerCase().indexOf(w) >= 0) ||
	            (s.publisher.toLowerCase().indexOf(w) >= 0) ||
	            (s.dateIssued.toLowerCase().indexOf(w) >= 0) ||
	            (s.placeIssued.toLowerCase().indexOf(w) >= 0) ||
	            (s.periodicalSeries.toLowerCase().indexOf(w) >= 0) ||
	            (s.numVolumes.toLowerCase().indexOf(w) >= 0) ||
	            (s.volumeFilmPages.toLowerCase().indexOf(w) >= 0) ||
	            (s.repository.toLowerCase().indexOf(w) >= 0) ||
	            (s.callNumber.toLowerCase().indexOf(w) >= 0) ||
	            (s.url.toLowerCase().indexOf(w) >= 0) ||
	            (s.shortFootnote.toLowerCase().indexOf(w) >= 0) ||
	            (s.bibCitation.toLowerCase().indexOf(w) >= 0) ||
	            (s.text.toLowerCase().indexOf(w) >= 0);
	    };
	    return SourcesService;
	}());
	exports.SourcesService = SourcesService;
	exports.default = SourcesService;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var store_service_1 = __webpack_require__(284);
	var StoreService = /** @class */ (function (_super) {
	    __extends(StoreService, _super);
	    StoreService.$inject = ["$log", "$timeout", "$rootScope", "rx", "cache", "authToken", "server", "currentTreeId", "currentUserId", "rightsFull", "messageBus", "utils"];
	    function StoreService($log, $timeout, $rootScope, rx, cache, authToken, server, currentTreeId, currentUserId, rightsFull, messageBus, utils) {
	        'ngInject';
	        return _super.call(this, $log, $timeout, $rootScope, rx, cache, authToken, server, currentTreeId, currentUserId, rightsFull, messageBus, utils) || this;
	    }
	    return StoreService;
	}(store_service_1.StoreService));
	exports.default = StoreService;
	// class StoreService {
	//   constructor($log, private $timeout: ng.ITimeoutService, $rootScope, rx, cache, authToken, server, currentTreeId, currentUserId, rightsFull, messageBus, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.$timeout = $timeout;
	//     this.$rootScope = $rootScope;
	//     this.rx = rx;
	//     this.cache = cache;
	//     this.authToken = authToken;
	//     this.server = server;
	//     this.currentTreeId = currentTreeId;
	//     this.currentUserId = currentUserId;
	//     this.rightsFull = rightsFull;
	//     this.messageBus = messageBus;
	//     this.utils = utils;
	//   }
	//   create(prefix, collection, changeStream, mapFn) {
	//     return new Store(this.$log, this.$timeout, this.$rootScope, this.rx, this.cache, this.authToken, this.server, this.messageBus,
	//       this.currentTreeId, this.currentUserId, this.rightsFull, this.utils, prefix, collection, changeStream, mapFn);
	//   }
	//   streamScanFn(keysFn) {
	//     return (map, old, n, idMap) => {
	//       if (old === null && n === null) {
	//         // create initial map
	//         map = new Map();
	//         for (let [,o] of idMap) {
	//           let keysIter = keysFn(o);
	//           if (keysIter !== null) {
	//             for (let k of keysIter) {
	//               let value = map.get(k);
	//               if (!value) {
	//                 value = new Map();
	//                 map.set(k, value);
	//               }
	//               value.set(o.id, o);
	//             }
	//           }
	//         }
	//         return map;
	//       }
	//       let oldKeys = [];
	//       if (old !== null) {
	//         let keysIter = keysFn(old);
	//         if (keysIter !== null) {
	//           for (let k of keysIter) {
	//             oldKeys.push(k);
	//           }
	//         }
	//       }
	//       let newKeys = [];
	//       if (n !== null) {
	//         let keysIter = keysFn(n);
	//         if (keysIter !== null) {
	//           for (let k of keysIter) {
	//             newKeys.push(k);
	//           }
	//         }
	//       }
	//       for (let ok of oldKeys) {
	//         if (!newKeys.some(nk => nk === ok)) {
	//           let value = map.get(ok);
	//           if (!!value) {
	//             value.delete(old.id);
	//             if (value.size === 0) {
	//               map.delete(ok);
	//             }
	//           }
	//         }
	//       }
	//       for (let nk of newKeys) {
	//         let value = map.get(nk);
	//         if (!value) {
	//           value = new Map();
	//           map.set(nk, value);
	//         }
	//         value.set(n.id, n);
	//       }
	//       return map;
	//     };
	//   }
	// }
	// // handles the following prefix collection combinations
	// // users id
	// // trees id
	// // trees id users id
	// // trees id collection
	// class Store {
	//   constructor($log, $timeout, $rootScope, rx, cache, authToken, server, messageBus, currentTreeId, currentUserId, rightsFull, utils, prefix, collection, changeStream, mapFn) {
	//     const cachedCollections = ['comments', 'evidences', 'families', 'invitations', 'leads', 'likes', 'media', 'notes',
	//       'notifications', 'ordinances', 'persons', 'research_logs', 'sources', 'stories', 'warnings'];
	//     this.$log = $log;
	//     this.$timeout = $timeout;
	//     this.$rootScope = $rootScope;
	//     this.rx = rx;
	//     this.cache = cache;
	//     this.authToken = authToken;
	//     this.server = server;
	//     this.messageBus = messageBus;
	//     this.rightsFull = rightsFull;
	//     this.utils = utils;
	//     this.prefix = prefix;
	//     this.collection = collection;
	//     this.mapFn = mapFn || function(o) { return o; };
	//     this.map = new Map();
	//     this.subject = new rx.BehaviorSubject(this.map);
	//     this.derivativeStreams = [];
	//     this.requested = false;
	//     this._resetReady(true);
	//     this.currentTreeId = -1;
	//     this.currentUserId = -1;
	//     this.currentRightsLevel = -1;
	//     this.numPending = 0;
	//     this.pending = new rx.BehaviorSubject(this.numPending);
	//     this.isCachedCollection = cachedCollections.includes(collection);
	//     currentUserId.stream().subscribe(userId => {
	//       if ((prefix === 'users' || prefix === 'subscriptions') && this.currentUserId !== userId) {
	//         this.currentUserId = userId;
	//         if (this.requested) {
	//           this.clear();
	//           this._request();
	//         }
	//       }
	//     });
	//     currentTreeId.stream().combineLatest(currentUserId.stream()).subscribe(([treeId, userId]) => {
	//       if (prefix !== 'users' && prefix !== 'subscriptions' && (this.currentRightsLevel === -1 || this.currentUserId !== userId || this.currentTreeId !== treeId)) {
	//         this.currentUserId = userId;
	//         this.currentTreeId = treeId;
	//         this.currentRightsLevel = -1;
	//         // if it's been requested, clear out the old data
	//         let requested = this.requested;
	//         if (requested) {
	//           this.clear();
	//         }
	//         rightsFull.getLevel(treeId, userId).subscribe(level => {
	//           this.currentRightsLevel = level;
	//           // if it's been requested, re-request
	//           if (requested || this.requested) {
	//             this.requested = false;
	//             this._request();
	//           }
	//         });
	//       }
	//     });
	//     this.changeSubscription = changeStream.subscribe(change => {
	//       // process change when no more pending requests
	//       ((change) => {
	//         this.pending.skipWhile(numPending => numPending > 0).take(1).subscribe(() => {
	//           // wait for things to settle down
	//           this.$timeout(() => {
	//             // if the change is associated with a particular user or tree, make sure they are still current
	//             if ((change._userId === 0 || change._userId === this.currentUserId) && (change._treeId === 0 || change._treeId === this.currentTreeId)) {
	//               let treeId = change._treeId || this.currentTreeId;
	//               change.actions
	//                 // match /trees/id/collection or /trees/id or /users/id
	//                 .filter(action => this._matches(action))
	//                 .forEach(action => {
	//                   this.$log.debug('store.change', this.prefix, this.collection, action);
	//                   if (action.operation === 'ADD' || action.operation === 'UPDATE') {
	//                     let o = this.map.get(action.objectId);
	//                     this.$log.debug('store.change version', !!o ? o.version : o, action.version);
	//                     if (!o || o.version < action.version || this.prefix === 'subscriptions') {
	//                       let url = this._getUrl(treeId) + '/' + action.objectId;
	//                       this.server.get(url).subscribe(response => {
	//                         if ((change._userId === 0 || change._userId === this.currentUserId) && (change._treeId === 0 || change._treeId === this.currentTreeId)) {
	//                           let mappedResponse = this.mapFn(this.utils.fromServer(response));
	//                           let old = this.map.get(action.objectId) || null;
	//                           if (this.prefix === 'subscriptions') { // remove current subscription
	//                             this.map.clear();
	//                           }
	//                           this.map.set(mappedResponse.id, mappedResponse);
	//                           this._updateStreams(this.map, old, mappedResponse);
	//                           if (this._isCaching()) {
	//                             this._updateCache(this.currentUserId, this.currentTreeId, response.id, response);
	//                           }
	//                         }
	//                       }, err => {
	//                         if (err.status !== 404) { // ignore not found errors; the object has been deleted; we'll get a delete notification soon
	//                           this.messageBus.post({msg: 'UNKNOWN_ERROR', status: err.status, op: 'CHANGE', ctx: this._getContext(),
	//                             warn: true, warnParams: {operation: action.operation, url: this._getUrl(treeId)+'/'+action.objectId}});
	//                         }
	//                       });
	//                     }
	//                   }
	//                   else if (action.operation === 'DELETE') {
	//                     let old = this.map.get(action.objectId) || null;
	//                     this.map.delete(action.objectId);
	//                     this._updateStreams(this.map, old, null);
	//                     if (this._isCaching()) {
	//                       this._updateCache(this.currentUserId, this.currentTreeId, action.objectId, null);
	//                     }
	//                   }
	//                 });
	//             }
	//           });
	//         });
	//       })(change);
	//     });
	//   }
	//   destroy() {
	//     this.changeSubscription.unsubscribe();
	//   }
	//   // fn(map, old, new, idMap) -> map
	//   addStream(fn) {
	//     let m = new Map();
	//     let s = new this.rx.BehaviorSubject(m);
	//     this.derivativeStreams.push({fn: fn, stream: s, contents: m});
	//     return s;
	//   }
	//   ready() {
	//     this._request();
	//     return this.readySubject;
	//   }
	//   clear() {
	//     this.map.clear();
	//     this.requested = false;
	//     this._resetReady(this.readyState);
	//     this.subject.next(this.map);
	//   }
	//   create(o, params, options) {
	//     let currentUserId = this.currentUserId;
	//     let currentTreeId = this.currentTreeId;
	//     this.messageBus.post(null);
	//     this.pending.next(++this.numPending);
	//     o = this.utils.toServer(o);
	//     let stream = this.server.post(this._getUrl(currentTreeId), o, params)
	//       .do(response => {
	//         if (this._isCaching()) {
	//           this._updateCache(currentUserId, currentTreeId, response.id, response);
	//         }
	//       }).map(response => this.mapFn(this.utils.fromServer(response)));
	//     let [s, t] = this.utils.teeAsync(stream);
	//     s.subscribe(response => {
	//       this.map.set(response.id, response);
	//       this._updateStreams(this.map, null, response);
	//       this.pending.next(--this.numPending);
	//     }, err => {
	//       this.$log.warn('store create error', err, this._getUrl(currentTreeId), o, params);
	//       if (!(!!options && (options.silenceErrors || (options.silence404 && err.status === 404)))) {
	//         this.messageBus.post({msg: err.data || err.name, status: err.status, op: 'ADD', ctx: this._getContext(),
	//           warn: true, warnParams: {url: this._getUrl(currentTreeId)}});
	//       }
	//       this.pending.next(--this.numPending);
	//     });
	//     return t;
	//   }
	//   createBatch(os) {
	//     let currentUserId = this.currentUserId;
	//     let currentTreeId = this.currentTreeId;
	//     let params = {batch: 'true'};
	//     this.messageBus.post(null);
	//     this.pending.next(++this.numPending);
	//     os = os.map(o => this.utils.toServer(o));
	//     let stream = this.server.post(this._getUrl(currentTreeId), os, params)
	//       .do(responses => {
	//         if (this._isCaching()) {
	//           responses.forEach(response => {
	//             this._updateCache(currentUserId, currentTreeId, response.id, response);
	//           });
	//         }
	//       }).map(responses => {
	//         return responses.map(response => this.mapFn(this.utils.fromServer(response)));
	//       });
	//     let [s, t] = this.utils.teeAsync(stream);
	//     s.subscribe(responses => {
	//       responses.forEach(response => {
	//         this.map.set(response.id, response);
	//       });
	//       this._updateStreamsBatch(this.map, null, responses);
	//       this.pending.next(--this.numPending);
	//     }, err => {
	//       this.$log.warn('store create error', err, this._getUrl(currentTreeId), os, params);
	//       this.messageBus.post({msg: err.data || err.name, status: err.status, op: 'ADD', ctx: this._getContext(),
	//         warn: true, warnParams: {url: this._getUrl(currentTreeId)}});
	//       this.pending.next(--this.numPending);
	//     });
	//     return t;
	//   }
	//   update(o, params, options) {
	//     let currentUserId = this.currentUserId;
	//     let currentTreeId = this.currentTreeId;
	//     this.messageBus.post(null);
	//     this.pending.next(++this.numPending);
	//     o = this.utils.toServer(o);
	//     let stream = this.server.put(this._getUrl(currentTreeId)+'/'+o.id, o, params)
	//       .do(response => {
	//         if (this._isCaching()) {
	//           this._updateCache(currentUserId, currentTreeId, response.id, response);
	//         }
	//       }).map(response => this.mapFn(this.utils.fromServer(response)));
	//     let [s, t] = this.utils.teeAsync(stream);
	//     s.subscribe(response => {
	//       let old = this.map.get(response.id) || null;
	//       this.map.set(response.id, response);
	//       this._updateStreams(this.map, old, response);
	//       this.pending.next(--this.numPending);
	//     }, err => {
	//       this.$log.warn('store update error', err, this._getUrl(currentTreeId)+'/'+o.id, o, params);
	//       if (!(!!options && (options.silenceErrors || (options.silence404 && err.status === 404)))) {
	//         this.messageBus.post({msg: err.data || err.name, status: err.status, op: 'UPDATE', ctx: this._getContext(),
	//           warn: true, warnParams: {url: this._getUrl(currentTreeId)+'/'+o.id}});
	//       }
	//       this.pending.next(--this.numPending);
	//     });
	//     return t;
	//   }
	//   del(id, params, options) {
	//     let currentUserId = this.currentUserId;
	//     let currentTreeId = this.currentTreeId;
	//     this.messageBus.post(null);
	//     this.pending.next(++this.numPending);
	//     let stream = this.server.del(this._getUrl(currentTreeId)+'/'+id, params)
	//       .do(() => {
	//         if (this._isCaching()) {
	//           this._updateCache(currentUserId, currentTreeId, id);
	//         }
	//       });
	//     let [s, t] = this.utils.teeAsync(stream);
	//     s.subscribe(() => {
	//       let old = this.map.get(id) || null;
	//       this.map.delete(id);
	//       this._updateStreams(this.map, old, null);
	//       this.pending.next(--this.numPending);
	//     }, err => {
	//       this.$log.warn('store del error', err, this._getUrl(currentTreeId)+'/'+id, params);
	//       if (!((!!options && options.silenceErrors) || err.status === 404)) {
	//         this.messageBus.post({msg: err.data || err.name, status: err.status, op: 'DELETE', ctx: this._getContext(),
	//           warn: true, warnParams: {url: this._getUrl(currentTreeId)+'/'+id}});
	//       }
	//       this.pending.next(--this.numPending);
	//     });
	//     return t;
	//   }
	//   getStream() {
	//     return this.subject;
	//   }
	//   // Map id -> value
	//   stream(filter) {
	//     this._request();
	//     return this.subject
	//       .map(m => {
	//         if (!filter) {
	//           return m;
	//         }
	//         let entries = [];
	//         for (let entry of m) {
	//           if (filter(entry[1])) {
	//             entries.push(entry);
	//           }
	//         }
	//         return new Map(entries);
	//       });
	//   }
	//   // value
	//   streamId(id) {
	//     this._request();
	//     return this.readySubject.flatMap(() => {
	//       return this.subject
	//         .map(m => m.get(id) || null);
	//     });
	//   }
	//   // takes an array of ids and returns stream Map id->obj
	//   streamIds(ids) {
	//     this._request();
	//     return this.readySubject.flatMap(() => {
	//       return this.subject
	//         .map(m => new Map(ids.filter(id => m.has(id)).map(id => [id, m.get(id)])));
	//         //.distinctUntilChanged((mOld, mNew) => Object.is(mOld, mNew)); // Object.is isn't deep
	//     });
	//   }
	//   _request() {
	//     if (this.requested) {
	//       return;
	//     }
	//     this.requested = true;
	//     if ((this.currentUserId <= 0 && (this.prefix === 'users' || this.prefix === 'subscriptions' || this.collection === 'users')) ||   // not needed
	//         (this.currentTreeId <= 0 && this.prefix === 'trees') ||                                    // not ready
	//         (this.prefix === 'trees' && this.collection === 'notifications' &&
	//          this.currentRightsLevel < this.rightsFull.LEVEL_READ) ||                                       // forbidden
	//         (this.currentUserId < 0 && this.prefix === 'trees') ||                                     // not ready
	//         (this.prefix === 'trees' && this.collection !== 'users' && this.currentRightsLevel < 0)) { // not ready
	//       return;
	//     }
	//     // singleton?
	//     let saveUserId = this.currentUserId;
	//     let saveTreeId = this.currentTreeId;
	//     if (this._isSingletonStore()) {
	//       let id = (this.prefix === 'trees' && this.collection !== 'users') ? this.currentTreeId : this.currentUserId;
	//       let url = this._getUrl(saveTreeId)+'/'+id;
	//       this.server.get(url).subscribe(response => {
	//         response = this.mapFn(this.utils.fromServer(response));
	//         this.map = new Map([[response.id, response]]);
	//         this._updateStreams(this.map, null, null);
	//         this._setReady(true);
	//       }, err => {
	//         this.messageBus.post({msg: err.data, status: err.status, op: 'READ', ctx: this.collection || this.prefix});
	//         this._setReady(false);
	//       });
	//     }
	//     else {
	//       if (this._isCaching()) {
	//         this.cache.readCache(this.currentUserId, this.currentTreeId, this.collection).subscribe(cache => {
	//           // just in case things changed while we were reading the cache
	//           if (saveUserId !== this.currentUserId || saveTreeId !== this.currentTreeId) {
	//             return;
	//           }
	//           let opts = !cache ? null : {headers: {'If-None-Match': cache.eTag}};
	//           this.server.get(this._getUrl(saveTreeId), this._getGuest(), opts).subscribe(response => {
	//             if (response === 304) {
	//               response = cache.data;
	//             }
	//             else if (saveUserId === this.currentUserId && saveTreeId === this.currentTreeId) {
	//               this.cache.replaceCache(this.currentUserId, this.currentTreeId, this.collection, response).subscribe(() => {
	//                 // nothing to do
	//               }, err => {
	//                 this.$log.warn('store.replaceCache error', err);
	//               });
	//             }
	//             this.map = new Map(response.map(o => {
	//               o = this.mapFn(this.utils.fromServer(o));
	//               return [o.id, o];
	//             }));
	//             this._updateStreams(this.map, null, null);
	//             this._setReady(true);
	//           }, err => {
	//             this.messageBus.post({msg: err.data, status: err.status, op: 'READ', ctx: this.collection || this.prefix});
	//             this._setReady(false, err);
	//           });
	//         });
	//       }
	//       else {
	//         this.server.get(this._getUrl(saveTreeId), this._getGuest()).subscribe(response => {
	//           // construct map from response array
	//           this.map = new Map(response.map(o => {
	//             o = this.mapFn(this.utils.fromServer(o));
	//             return [o.id, o];
	//           }));
	//           this._updateStreams(this.map, null, null);
	//           this._setReady(true);
	//         }, err => {
	//           this.messageBus.post({msg: err.data, status: err.status, op: 'READ', ctx: this.collection || this.prefix});
	//           this._setReady(false, err);
	//         });
	//       }
	//     }
	//   }
	//   _resetReady(reset) {
	//     if (reset) {
	//       this.readyState = false;
	//       this.readySubject = new this.rx.AsyncSubject();
	//     }
	//   }
	//   _setReady(state, err) {
	//     if (!this.readyState) {
	//       if (state) {
	//         this.readyState = true;
	//         this.readySubject.next(true);
	//         this.readySubject.complete();
	//       }
	//       else {
	//         this.readySubject.error(!!err ? err.data : err);
	//       }
	//     }
	//   }
	//   _updateStreams(map, old, n) {
	//     this.derivativeStreams.forEach(ds => { //{fn, stream, contents}
	//       ds.contents = ds.fn(ds.contents, old, n, map);
	//       ds.stream.next(ds.contents);
	//     });
	//     this.subject.next(map);
	//   }
	//   _updateStreamsBatch(map, old, ns) {
	//     this.derivativeStreams.forEach(ds => { //{fn, stream, contents}
	//       ns.forEach(n => {
	//         ds.contents = ds.fn(ds.contents, old, n, map);
	//       });
	//       ds.stream.next(ds.contents);
	//     });
	//     this.subject.next(map);
	//   }
	//   _isSingletonStore() {
	//     return !this.collection || this.collection === 'users';
	//   }
	//   _getUrl(treeId) {
	//     let url = '/' + this.prefix;
	//     if (!!this.collection) {
	//       url += '/' + treeId + '/' + this.collection;
	//     }
	//     return url;
	//   }
	//   _getGuest() {
	//     if (this.currentRightsLevel === this.rightsFull.LEVEL_GUEST) {
	//       return {guest: 'true'};
	//     }
	//     return null;
	//   }
	//   _getContext() {
	//     return this.prefix+(!!this.collection ? '_'+this.collection : '');
	//   }
	//   _matches(action) {
	//     if (this.prefix === 'users' || this.prefix === 'subscriptions') {
	//       return action.collection === this.prefix && action.objectId === this.currentUserId;
	//     }
	//     else if (this.prefix === 'trees' && !this.collection) {
	//       return action.collection === this.prefix && action.objectId === this.currentTreeId;
	//     }
	//     else if (this.prefix === 'trees' && this.collection === 'users') {
	//       return action.collection === 'tree_users' && action.objectId === this.currentUserId;
	//     }
	//     else {
	//       return action.collection === this.collection;
	//     }
	//   }
	//   _isCaching() {
	//     // cache if you're not a guest and you're logged in (everyone, even non-logged-in users, have read-rights to featured trees)
	//     // and this is a cached collection and we're not importing from FS
	//     return !this._getGuest() && !!this.authToken.get() && this.isCachedCollection && !this.$rootScope.fsImportStream;
	//   }
	//   _updateCache(userId, treeId, id, obj) {
	//     // if the userId or treeId has changed, don't bother updating cache
	//     // because this could cause the cache database to be opened and closed a lot while switching between old and new
	//     if (userId === this.currentUserId && treeId === this.currentTreeId) {
	//       this.cache.updateCache(userId, treeId, this.collection, id, obj).subscribe(() => {
	//         // nothing to do
	//       }, err => {
	//         this.$log.warn('store._updateCache error', err);
	//       });
	//     }
	//   }
	// }
	// export default StoreService;


/***/ }),
/* 284 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Subject, BehaviorSubject } from "../../node_modules/rxjs";
	var StoreService = /** @class */ (function () {
	    function StoreService(log, timeout, rootScope, rx, cache, authToken, server, currentTreeId, currentUserId, rightsFull, messageBus, utils) {
	        this.log = log;
	        this.timeout = timeout;
	        this.rootScope = rootScope;
	        this.rx = rx;
	        this.cache = cache;
	        this.authToken = authToken;
	        this.server = server;
	        this.currentTreeId = currentTreeId;
	        this.currentUserId = currentUserId;
	        this.rightsFull = rightsFull;
	        this.messageBus = messageBus;
	        this.utils = utils;
	    }
	    StoreService.prototype.create = function (prefix, collection, changeStream, mapFn) {
	        return new Store(this.log, this.timeout, this.rootScope, this.rx, this.cache, this.authToken, this.server, this.messageBus, this.currentTreeId, this.currentUserId, this.rightsFull, this.utils, prefix, collection, changeStream, mapFn);
	    };
	    StoreService.prototype.streamScanFn = function (keysFn) {
	        return function (map, old, n, idMap) {
	            if (old === null && n === null) {
	                // create initial map
	                map = new Map();
	                try {
	                    for (var idMap_1 = __values(idMap), idMap_1_1 = idMap_1.next(); !idMap_1_1.done; idMap_1_1 = idMap_1.next()) {
	                        var _a = __read(idMap_1_1.value, 2), o = _a[1];
	                        var keysIter = keysFn(o);
	                        if (keysIter !== null) {
	                            try {
	                                for (var keysIter_1 = __values(keysIter), keysIter_1_1 = keysIter_1.next(); !keysIter_1_1.done; keysIter_1_1 = keysIter_1.next()) {
	                                    var k = keysIter_1_1.value;
	                                    var value = map.get(k);
	                                    if (!value) {
	                                        value = new Map();
	                                        map.set(k, value);
	                                    }
	                                    value.set(o.id, o);
	                                }
	                            }
	                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                            finally {
	                                try {
	                                    if (keysIter_1_1 && !keysIter_1_1.done && (_b = keysIter_1.return)) _b.call(keysIter_1);
	                                }
	                                finally { if (e_1) throw e_1.error; }
	                            }
	                        }
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (idMap_1_1 && !idMap_1_1.done && (_c = idMap_1.return)) _c.call(idMap_1);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	                return map;
	            }
	            var oldKeys = [];
	            if (old !== null) {
	                var keysIter = keysFn(old);
	                if (keysIter !== null) {
	                    try {
	                        for (var keysIter_2 = __values(keysIter), keysIter_2_1 = keysIter_2.next(); !keysIter_2_1.done; keysIter_2_1 = keysIter_2.next()) {
	                            var k = keysIter_2_1.value;
	                            oldKeys.push(k);
	                        }
	                    }
	                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                    finally {
	                        try {
	                            if (keysIter_2_1 && !keysIter_2_1.done && (_d = keysIter_2.return)) _d.call(keysIter_2);
	                        }
	                        finally { if (e_3) throw e_3.error; }
	                    }
	                }
	            }
	            var newKeys = [];
	            if (n !== null) {
	                var keysIter = keysFn(n);
	                if (keysIter !== null) {
	                    try {
	                        for (var keysIter_3 = __values(keysIter), keysIter_3_1 = keysIter_3.next(); !keysIter_3_1.done; keysIter_3_1 = keysIter_3.next()) {
	                            var k = keysIter_3_1.value;
	                            newKeys.push(k);
	                        }
	                    }
	                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                    finally {
	                        try {
	                            if (keysIter_3_1 && !keysIter_3_1.done && (_e = keysIter_3.return)) _e.call(keysIter_3);
	                        }
	                        finally { if (e_4) throw e_4.error; }
	                    }
	                }
	            }
	            var _loop_1 = function (ok) {
	                if (!newKeys.some(function (nk) { return nk === ok; })) {
	                    var value = map.get(ok);
	                    if (!!value) {
	                        value.delete(old.id);
	                        if (value.size === 0) {
	                            map.delete(ok);
	                        }
	                    }
	                }
	            };
	            try {
	                for (var oldKeys_1 = __values(oldKeys), oldKeys_1_1 = oldKeys_1.next(); !oldKeys_1_1.done; oldKeys_1_1 = oldKeys_1.next()) {
	                    var ok = oldKeys_1_1.value;
	                    _loop_1(ok);
	                }
	            }
	            catch (e_5_1) { e_5 = { error: e_5_1 }; }
	            finally {
	                try {
	                    if (oldKeys_1_1 && !oldKeys_1_1.done && (_f = oldKeys_1.return)) _f.call(oldKeys_1);
	                }
	                finally { if (e_5) throw e_5.error; }
	            }
	            try {
	                for (var newKeys_1 = __values(newKeys), newKeys_1_1 = newKeys_1.next(); !newKeys_1_1.done; newKeys_1_1 = newKeys_1.next()) {
	                    var nk = newKeys_1_1.value;
	                    var value = map.get(nk);
	                    if (!value) {
	                        value = new Map();
	                        map.set(nk, value);
	                    }
	                    value.set(n.id, n);
	                }
	            }
	            catch (e_6_1) { e_6 = { error: e_6_1 }; }
	            finally {
	                try {
	                    if (newKeys_1_1 && !newKeys_1_1.done && (_g = newKeys_1.return)) _g.call(newKeys_1);
	                }
	                finally { if (e_6) throw e_6.error; }
	            }
	            return map;
	            var e_2, _c, e_1, _b, e_3, _d, e_4, _e, e_5, _f, e_6, _g;
	        };
	    };
	    return StoreService;
	}());
	exports.StoreService = StoreService;
	// handles the following prefix collection combinations
	// users id
	// trees id
	// trees id users id
	// trees id collection
	var Store = /** @class */ (function () {
	    function Store(log, timeout, rootScope, rx, cache, authToken, server, messageBus, currentTreeId, currentUserId, rightsFull, utils, prefix, collection, changeStream, mapFn) {
	        var _this = this;
	        this.log = log;
	        this.timeout = timeout;
	        this.rootScope = rootScope;
	        this.rx = rx;
	        this.cache = cache;
	        this.authToken = authToken;
	        this.server = server;
	        this.messageBus = messageBus;
	        this.rightsFull = rightsFull;
	        this.utils = utils;
	        this.prefix = prefix;
	        this.collection = collection;
	        this.mapFn = mapFn;
	        var cachedCollections = ['comments', 'evidences', 'families', 'invitations', 'leads', 'likes', 'media', 'notes',
	            'notifications', 'ordinances', 'persons', 'research_logs', 'sources', 'stories', 'warnings'];
	        this.mapFn = mapFn || function (o) { return o; };
	        this.map = new Map();
	        this.subject = new rx.BehaviorSubject(this.map);
	        this.derivativeStreams = [];
	        this.requested = false;
	        this._resetReady(true);
	        this.currentTreeId = -1;
	        this.currentUserId = -1;
	        this.currentRightsLevel = -1;
	        this.numPending = 0;
	        this.pending = new rx.BehaviorSubject(this.numPending);
	        this.isCachedCollection = cachedCollections.includes(collection);
	        currentUserId.stream().subscribe(function (userId) {
	            if ((prefix === 'users' || prefix === 'subscriptions') && _this.currentUserId !== userId) {
	                _this.currentUserId = userId;
	                if (_this.requested) {
	                    _this.reset();
	                }
	            }
	        });
	        currentTreeId.stream().combineLatest(currentUserId.stream()).subscribe(function (_a) {
	            var _b = __read(_a, 2), treeId = _b[0], userId = _b[1];
	            if (prefix !== 'users' && prefix !== 'subscriptions' && (_this.currentRightsLevel === -1 || _this.currentUserId !== userId || _this.currentTreeId !== treeId)) {
	                _this.currentUserId = userId;
	                _this.currentTreeId = treeId;
	                _this.currentRightsLevel = -1;
	                // if it's been requested, clear out the old data
	                var requested_1 = _this.requested;
	                if (requested_1) {
	                    _this.clear();
	                }
	                rightsFull.getLevel(treeId, userId).subscribe(function (level) {
	                    _this.currentRightsLevel = level;
	                    // if it's been requested, re-request
	                    if (requested_1 || _this.requested) {
	                        _this.requested = false;
	                        _this._request();
	                    }
	                });
	            }
	        });
	        this.changeSubscription = changeStream.subscribe(function (change) {
	            // process change when no more pending requests
	            (function (change) {
	                _this.pending.skipWhile(function (numPending) { return numPending > 0; }).take(1).subscribe(function () {
	                    // wait for things to settle down
	                    _this.timeout(function () {
	                        // if the change is associated with a particular user or tree, make sure they are still current
	                        if ((change._userId === 0 || change._userId === _this.currentUserId) && (change._treeId === 0 || change._treeId === _this.currentTreeId)) {
	                            var treeId_1 = change._treeId || _this.currentTreeId;
	                            change.actions
	                                .filter(function (action) { return _this._matches(action); })
	                                .forEach(function (action) {
	                                _this.log.debug('store.change', _this.prefix, _this.collection, action);
	                                if (action.operation === 'ADD' || action.operation === 'UPDATE') {
	                                    var o = _this.map.get(action.objectId);
	                                    _this.log.debug('store.change version', !!o ? o.version : o, action.version);
	                                    if (!o || o.version < action.version || _this.prefix === 'subscriptions') {
	                                        var url = _this._getUrl(treeId_1) + '/' + action.objectId;
	                                        _this.server.get(url).subscribe(function (response) {
	                                            if ((change._userId === 0 || change._userId === _this.currentUserId) && (change._treeId === 0 || change._treeId === _this.currentTreeId)) {
	                                                var mappedResponse = _this.mapFn(_this.utils.fromServer(response));
	                                                var old = _this.map.get(action.objectId) || null;
	                                                if (_this.prefix === 'subscriptions') {
	                                                    _this.map.clear();
	                                                }
	                                                _this.map.set(mappedResponse.id, mappedResponse);
	                                                _this._updateStreams(_this.map, old, mappedResponse);
	                                                if (_this._isCaching()) {
	                                                    _this._updateCache(_this.currentUserId, _this.currentTreeId, response.id, response);
	                                                }
	                                            }
	                                        }, function (err) {
	                                            if (err.status !== 404) {
	                                                _this.messageBus.post({
	                                                    msg: 'UNKNOWN_ERROR', status: err.status, op: 'CHANGE', ctx: _this._getContext(),
	                                                    warn: true, warnParams: { operation: action.operation, url: _this._getUrl(treeId_1) + '/' + action.objectId }
	                                                });
	                                            }
	                                        });
	                                    }
	                                }
	                                else if (action.operation === 'DELETE') {
	                                    var old = _this.map.get(action.objectId) || null;
	                                    _this.map.delete(action.objectId);
	                                    _this._updateStreams(_this.map, old, null);
	                                    if (_this._isCaching()) {
	                                        _this._updateCache(_this.currentUserId, _this.currentTreeId, action.objectId, null);
	                                    }
	                                }
	                            });
	                        }
	                    });
	                });
	            })(change);
	        });
	    }
	    Store.prototype.destroy = function () {
	        this.changeSubscription.unsubscribe();
	    };
	    // fn(map, old, new, idMap) -> map
	    Store.prototype.addStream = function (fn) {
	        var m = new Map();
	        var s = new this.rx.BehaviorSubject(m);
	        this.derivativeStreams.push({ fn: fn, stream: s, contents: m });
	        return s;
	    };
	    Store.prototype.ready = function () {
	        this._request();
	        return this.readySubject;
	    };
	    Store.prototype.clear = function () {
	        this.map.clear();
	        this.requested = false;
	        this._resetReady(this.readyState);
	        this.subject.next(this.map);
	    };
	    Store.prototype.reset = function () {
	        this.clear();
	        this._request();
	    };
	    Store.prototype.create = function (o, params, options) {
	        var _this = this;
	        var currentUserId = this.currentUserId;
	        var currentTreeId = this.currentTreeId;
	        this.messageBus.post(null);
	        this.pending.next(++this.numPending);
	        o = this.utils.toServer(o);
	        var stream = this.server.post(this._getUrl(currentTreeId), o, params)
	            .do(function (response) {
	            if (_this._isCaching()) {
	                _this._updateCache(currentUserId, currentTreeId, response.id, response);
	            }
	        }).map(function (response) { return _this.mapFn(_this.utils.fromServer(response)); });
	        var _a = __read(this.utils.teeAsync(stream), 2), s = _a[0], t = _a[1];
	        s.subscribe(function (response) {
	            _this.map.set(response.id, response);
	            _this._updateStreams(_this.map, null, response);
	            _this.pending.next(--_this.numPending);
	        }, function (err) {
	            _this.log.warn('store create error', err, _this._getUrl(currentTreeId), o, params);
	            if (!(!!options && (options.silenceErrors || (options.silence404 && err.status === 404)))) {
	                _this.messageBus.post({
	                    msg: err.data || err.name, status: err.status, op: 'ADD', ctx: _this._getContext(),
	                    warn: true, warnParams: { url: _this._getUrl(currentTreeId) }
	                });
	            }
	            _this.pending.next(--_this.numPending);
	        });
	        return t;
	    };
	    Store.prototype.createBatch = function (os) {
	        var _this = this;
	        var currentUserId = this.currentUserId;
	        var currentTreeId = this.currentTreeId;
	        var params = { batch: 'true' };
	        this.messageBus.post(null);
	        this.pending.next(++this.numPending);
	        os = os.map(function (o) { return _this.utils.toServer(o); });
	        var stream = this.server.post(this._getUrl(currentTreeId), os, params)
	            .do(function (responses) {
	            if (_this._isCaching()) {
	                responses.forEach(function (response) {
	                    _this._updateCache(currentUserId, currentTreeId, response.id, response);
	                });
	            }
	        }).map(function (responses) {
	            return responses.map(function (response) { return _this.mapFn(_this.utils.fromServer(response)); });
	        });
	        var _a = __read(this.utils.teeAsync(stream), 2), s = _a[0], t = _a[1];
	        s.subscribe(function (responses) {
	            responses.forEach(function (response) {
	                _this.map.set(response.id, response);
	            });
	            _this._updateStreamsBatch(_this.map, null, responses);
	            _this.pending.next(--_this.numPending);
	        }, function (err) {
	            _this.log.warn('store create error', err, _this._getUrl(currentTreeId), os, params);
	            _this.messageBus.post({
	                msg: err.data || err.name, status: err.status, op: 'ADD', ctx: _this._getContext(),
	                warn: true, warnParams: { url: _this._getUrl(currentTreeId) }
	            });
	            _this.pending.next(--_this.numPending);
	        });
	        return t;
	    };
	    Store.prototype.update = function (o, params, options) {
	        var _this = this;
	        var currentUserId = this.currentUserId;
	        var currentTreeId = this.currentTreeId;
	        this.messageBus.post(null);
	        this.pending.next(++this.numPending);
	        o = this.utils.toServer(o);
	        var stream = this.server.put(this._getUrl(currentTreeId) + '/' + o.id, o, params)
	            .do(function (response) {
	            if (_this._isCaching()) {
	                _this._updateCache(currentUserId, currentTreeId, response.id, response);
	            }
	        }).map(function (response) { return _this.mapFn(_this.utils.fromServer(response)); });
	        var _a = __read(this.utils.teeAsync(stream), 2), s = _a[0], t = _a[1];
	        s.subscribe(function (response) {
	            var old = _this.map.get(response.id) || null;
	            _this.map.set(response.id, response);
	            _this._updateStreams(_this.map, old, response);
	            _this.pending.next(--_this.numPending);
	        }, function (err) {
	            _this.log.warn('store update error', err, _this._getUrl(currentTreeId) + '/' + o.id, o, params);
	            if (!(!!options && (options.silenceErrors || (options.silence404 && err.status === 404)))) {
	                _this.messageBus.post({
	                    msg: err.data || err.name, status: err.status, op: 'UPDATE', ctx: _this._getContext(),
	                    warn: true, warnParams: { url: _this._getUrl(currentTreeId) + '/' + o.id }
	                });
	            }
	            _this.pending.next(--_this.numPending);
	        });
	        return t;
	    };
	    Store.prototype.del = function (id, params, options) {
	        var _this = this;
	        var currentUserId = this.currentUserId;
	        var currentTreeId = this.currentTreeId;
	        this.messageBus.post(null);
	        this.pending.next(++this.numPending);
	        var stream = this.server.del(this._getUrl(currentTreeId) + '/' + id, params)
	            .do(function () {
	            if (_this._isCaching()) {
	                _this._updateCache(currentUserId, currentTreeId, id);
	            }
	        });
	        var _a = __read(this.utils.teeAsync(stream), 2), s = _a[0], t = _a[1];
	        s.subscribe(function () {
	            var old = _this.map.get(id) || null;
	            _this.map.delete(id);
	            _this._updateStreams(_this.map, old, null);
	            _this.pending.next(--_this.numPending);
	        }, function (err) {
	            _this.log.warn('store del error', err, _this._getUrl(currentTreeId) + '/' + id, params);
	            if (!((!!options && options.silenceErrors) || err.status === 404)) {
	                _this.messageBus.post({
	                    msg: err.data || err.name, status: err.status, op: 'DELETE', ctx: _this._getContext(),
	                    warn: true, warnParams: { url: _this._getUrl(currentTreeId) + '/' + id }
	                });
	            }
	            _this.pending.next(--_this.numPending);
	        });
	        return t;
	    };
	    Store.prototype.getStream = function () {
	        return this.subject;
	    };
	    // Map id -> value
	    Store.prototype.stream = function (filter) {
	        this._request();
	        return this.subject
	            .map(function (m) {
	            if (!filter) {
	                return m;
	            }
	            var entries = [];
	            try {
	                for (var m_1 = __values(m), m_1_1 = m_1.next(); !m_1_1.done; m_1_1 = m_1.next()) {
	                    var entry = m_1_1.value;
	                    if (filter(entry[1])) {
	                        entries.push(entry);
	                    }
	                }
	            }
	            catch (e_7_1) { e_7 = { error: e_7_1 }; }
	            finally {
	                try {
	                    if (m_1_1 && !m_1_1.done && (_a = m_1.return)) _a.call(m_1);
	                }
	                finally { if (e_7) throw e_7.error; }
	            }
	            return new Map(entries);
	            var e_7, _a;
	        });
	    };
	    // value
	    Store.prototype.streamId = function (id) {
	        var _this = this;
	        this._request();
	        return this.readySubject.flatMap(function () {
	            return _this.subject
	                .map(function (m) { return m.get(id) || null; });
	        });
	    };
	    // takes an array of ids and returns stream Map id->obj
	    Store.prototype.streamIds = function (ids) {
	        var _this = this;
	        this._request();
	        return this.readySubject.flatMap(function () {
	            return _this.subject
	                .map(function (m) { return new Map(ids.filter(function (id) { return m.has(id); }).map(function (id) { return [id, m.get(id)]; })); });
	            //.distinctUntilChanged((mOld, mNew) => Object.is(mOld, mNew)); // Object.is isn't deep
	        });
	    };
	    Store.prototype._request = function () {
	        var _this = this;
	        if (this.requested) {
	            return;
	        }
	        this.requested = true;
	        if ((this.currentUserId <= 0 && (this.prefix === 'users' || this.prefix === 'subscriptions' || this.collection === 'users')) || // not needed
	            (this.currentTreeId <= 0 && this.prefix === 'trees') || // not ready
	            (this.prefix === 'trees' && this.collection === 'notifications' &&
	                this.currentRightsLevel < this.rightsFull.LEVEL_READ) || // forbidden
	            (this.currentUserId < 0 && this.prefix === 'trees') || // not ready
	            (this.prefix === 'trees' && this.collection !== 'users' && this.currentRightsLevel < 0)) {
	            return;
	        }
	        // singleton?
	        var saveUserId = this.currentUserId;
	        var saveTreeId = this.currentTreeId;
	        if (this._isSingletonStore()) {
	            var id = (this.prefix === 'trees' && this.collection !== 'users') ? this.currentTreeId : this.currentUserId;
	            var url = this._getUrl(saveTreeId) + '/' + id;
	            this.server.get(url).subscribe(function (response) {
	                response = _this.mapFn(_this.utils.fromServer(response));
	                _this.map = new Map([[response.id, response]]);
	                _this._updateStreams(_this.map, null, null);
	                _this._setReady(true);
	            }, function (err) {
	                _this.messageBus.post({ msg: err.data, status: err.status, op: 'READ', ctx: _this.collection || _this.prefix });
	                _this._setReady(false);
	            });
	        }
	        else {
	            if (this._isCaching()) {
	                this.cache.readCache(this.currentUserId, this.currentTreeId, this.collection).subscribe(function (cache) {
	                    // just in case things changed while we were reading the cache
	                    if (saveUserId !== _this.currentUserId || saveTreeId !== _this.currentTreeId) {
	                        return;
	                    }
	                    var opts = !cache ? null : { headers: { 'If-None-Match': cache.eTag } };
	                    _this.server.get(_this._getUrl(saveTreeId), _this._getGuest(), opts).subscribe(function (response) {
	                        if (response === 304) {
	                            response = cache.data;
	                        }
	                        else if (saveUserId === _this.currentUserId && saveTreeId === _this.currentTreeId) {
	                            _this.cache.replaceCache(_this.currentUserId, _this.currentTreeId, _this.collection, response).subscribe(function () {
	                                // nothing to do
	                            }, function (err) {
	                                _this.log.warn('store.replaceCache error', err);
	                            });
	                        }
	                        _this.map = new Map(response.map(function (o) {
	                            o = _this.mapFn(_this.utils.fromServer(o));
	                            return [o.id, o];
	                        }));
	                        _this._updateStreams(_this.map, null, null);
	                        _this._setReady(true);
	                    }, function (err) {
	                        _this.messageBus.post({ msg: err.data, status: err.status, op: 'READ', ctx: _this.collection || _this.prefix });
	                        _this._setReady(false, err);
	                    });
	                });
	            }
	            else {
	                this.server.get(this._getUrl(saveTreeId), this._getGuest()).subscribe(function (response) {
	                    // construct map from response array
	                    _this.map = new Map(response.map(function (o) {
	                        o = _this.mapFn(_this.utils.fromServer(o));
	                        return [o.id, o];
	                    }));
	                    _this._updateStreams(_this.map, null, null);
	                    _this._setReady(true);
	                }, function (err) {
	                    _this.messageBus.post({ msg: err.data, status: err.status, op: 'READ', ctx: _this.collection || _this.prefix });
	                    _this._setReady(false, err);
	                });
	            }
	        }
	    };
	    Store.prototype._resetReady = function (reset) {
	        if (reset) {
	            this.readyState = false;
	            this.readySubject = new this.rx.AsyncSubject();
	        }
	    };
	    Store.prototype._setReady = function (state, err) {
	        if (!this.readyState) {
	            if (state) {
	                this.readyState = true;
	                this.readySubject.next(true);
	                this.readySubject.complete();
	            }
	            else {
	                this.readySubject.error(!!err ? err.data : err);
	            }
	        }
	    };
	    Store.prototype._updateStreams = function (map, old, n) {
	        this.derivativeStreams.forEach(function (ds) {
	            ds.contents = ds.fn(ds.contents, old, n, map);
	            ds.stream.next(ds.contents);
	        });
	        this.subject.next(map);
	    };
	    Store.prototype._updateStreamsBatch = function (map, os, ns) {
	        this.derivativeStreams.forEach(function (ds) {
	            if (!!ns) {
	                ns.forEach(function (n) {
	                    ds.contents = ds.fn(ds.contents, null, n, map);
	                });
	            }
	            if (!!os) {
	                os.forEach(function (o) {
	                    ds.contents = ds.fn(ds.contents, o, null, map);
	                });
	            }
	            ds.stream.next(ds.contents);
	        });
	        this.subject.next(map);
	    };
	    Store.prototype._isSingletonStore = function () {
	        return !this.collection || this.collection === 'users';
	    };
	    Store.prototype._getUrl = function (treeId) {
	        var url = '/' + this.prefix;
	        if (!!this.collection) {
	            url += '/' + treeId + '/' + this.collection;
	        }
	        return url;
	    };
	    Store.prototype._getGuest = function () {
	        if (this.currentRightsLevel === this.rightsFull.LEVEL_GUEST) {
	            return { guest: 'true' };
	        }
	        return null;
	    };
	    Store.prototype._getContext = function () {
	        return this.prefix + (!!this.collection ? '_' + this.collection : '');
	    };
	    Store.prototype._matches = function (action) {
	        if (this.prefix === 'users' || this.prefix === 'subscriptions') {
	            return action.collection === this.prefix && action.objectId === this.currentUserId;
	        }
	        else if (this.prefix === 'trees' && !this.collection) {
	            return action.collection === this.prefix && action.objectId === this.currentTreeId;
	        }
	        else if (this.prefix === 'trees' && this.collection === 'users') {
	            return action.collection === 'tree_users' && action.objectId === this.currentUserId;
	        }
	        else {
	            return action.collection === this.collection;
	        }
	    };
	    Store.prototype._isCaching = function () {
	        // cache if you're not a guest and you're logged in (everyone, even non-logged-in users, have read-rights to featured trees)
	        // and this is a cached collection and we're not importing from FS
	        return !this._getGuest() && !!this.authToken.get() && this.isCachedCollection && !this.rootScope.fsImportStream;
	    };
	    Store.prototype._updateCache = function (userId, treeId, id, obj) {
	        var _this = this;
	        // if the userId or treeId has changed, don't bother updating cache
	        // because this could cause the cache database to be opened and closed a lot while switching between old and new
	        if (userId === this.currentUserId && treeId === this.currentTreeId) {
	            this.cache.updateCache(userId, treeId, this.collection, id, obj).subscribe(function () {
	                // nothing to do
	            }, function (err) {
	                _this.log.warn('store._updateCache error', err);
	            });
	        }
	    };
	    return Store;
	}());
	exports.Store = Store;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var stories_service_1 = __webpack_require__(286);
	var StoriesService = /** @class */ (function (_super) {
	    __extends(StoriesService, _super);
	    StoriesService.$inject = ["$log", "rx", "store", "changes", "segment", "utils"];
	    function StoriesService($log, rx, store, changes, segment, utils) {
	        'ngInject';
	        return _super.call(this, rx, store, changes, segment, utils) || this;
	    }
	    return StoriesService;
	}(stories_service_1.StoriesService));
	exports.default = StoriesService;
	// class StoriesService {
	//   constructor ($log, rx, store, changes, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", "stories", changes.treeStream(), (s) => utils.addCreateEditDates(s));
	//     this.personStream = this.store.addStream(store.streamScanFn(o => {
	//       return o.personIds ? o.personIds.keys() : null;
	//     }));
	//     this.mediaStream = this.store.addStream(store.streamScanFn(o => {
	//       return o.mediaIds ? o.mediaIds.keys() : null;
	//     }));
	//     this.researchLogStream = this.store.addStream(store.streamScanFn(o => {
	//       let researchLogId = o.researchLogId || 0;
	//       return researchLogId > 0 ? [researchLogId] : null;
	//     }));
	//   }
	//   create(o) {
	//     this.segment.track('stories.create');
	//     o.researchLogId = o.researchLogId || 0;
	//     return this.store.create(o);
	//   }
	//   update(o) {
	//     this.segment.track('stories.update');
	//     o.researchLogId = o.researchLogId || 0;
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     this.segment.track('stories.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   // returns a map
	//   streamForPerson(pid) {
	//     return this.ready().flatMap(() => this.personStream.map(m => m.get(pid) || new Map()));
	//   }
	//   // returns a map
	//   streamForMedia(mid) {
	//     return this.ready().flatMap(() => this.mediaStream.map(m => m.get(mid) || new Map()));
	//   }
	//   // returns a map
	//   streamForResearchLog(rlid) {
	//     return this.ready().flatMap(() => this.researchLogStream.map(m => m.get(rlid) || new Map()));
	//   }
	//   //
	//   // helper functions
	//   //
	//   augmentStory(s, persons, users) {
	//     let subject = new this.rx.AsyncSubject();
	//     let waitCount = (s.personIds.size > 0 ? 1 : 0) + 1;
	//     s = Object.assign({}, s, {
	//       '_people': new Map(),
	//       '_createdUser' : null,
	//       '_editedUser' : null
	//     });
	//     // set people
	//     if (s.personIds.size > 0) {
	//       persons.streamIds(Array.from(s.personIds.keys())).take(1).subscribe(pm => {
	//         s._people = pm;
	//         if (--waitCount === 0) {
	//           subject.next(s);
	//           subject.complete();
	//         }
	//       });
	//     }
	//     // set created user and edited user
	//     this.utils.addCreateEditUsers(s, users).subscribe(() => {
	//       if (--waitCount === 0) {
	//         subject.next(s);
	//         subject.complete();
	//       }
	//     });
	//     return subject;
	//   }
	//   hasWord(s, w) {
	//     return (s.text.toLowerCase().indexOf(w) >= 0) ||
	//       (s.title.toLowerCase().indexOf(w) >= 0) ||
	//       (Array.from(s._people.values()).some(p => p._fullName.toLowerCase().indexOf(w) >= 0));
	//   }
	// }
	// export default StoriesService;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { BehaviorSubject, AsyncSubject } from "../../node_modules/rxjs";
	var StoriesService = /** @class */ (function () {
	    function StoriesService(rx, store, changes, segment, utils) {
	        this.rx = rx;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "stories", changes.treeStream(), function (s) { return utils.addCreateEditDates(s); });
	        this.personStream = this.store.addStream(store.streamScanFn(function (o) {
	            return o.personIds ? o.personIds.keys() : null;
	        }));
	        this.mediaStream = this.store.addStream(store.streamScanFn(function (o) {
	            return o.mediaIds ? o.mediaIds.keys() : null;
	        }));
	        this.researchLogStream = this.store.addStream(store.streamScanFn(function (o) {
	            var researchLogId = o.researchLogId || 0;
	            return researchLogId > 0 ? [researchLogId] : null;
	        }));
	    }
	    StoriesService.prototype.create = function (o) {
	        this.segment.track('stories.create');
	        o.researchLogId = o.researchLogId || 0;
	        return this.store.create(o);
	    };
	    StoriesService.prototype.update = function (o) {
	        this.segment.track('stories.update');
	        o.researchLogId = o.researchLogId || 0;
	        return this.store.update(o);
	    };
	    StoriesService.prototype.del = function (id) {
	        this.segment.track('stories.delete');
	        return this.store.del(id);
	    };
	    StoriesService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    StoriesService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    StoriesService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    // returns a map
	    StoriesService.prototype.streamForPerson = function (pid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.personStream.map(function (m) { return m.get(pid) || new Map(); }); });
	    };
	    // returns a map
	    StoriesService.prototype.streamForMedia = function (mid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.mediaStream.map(function (m) { return m.get(mid) || new Map(); }); });
	    };
	    // returns a map
	    StoriesService.prototype.streamForResearchLog = function (rlid) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.researchLogStream.map(function (m) { return m.get(rlid) || new Map(); }); });
	    };
	    //
	    // helper functions
	    //
	    StoriesService.prototype.augmentStory = function (s, persons, users) {
	        var subject = new this.rx.AsyncSubject();
	        var waitCount = (s.personIds.size > 0 ? 1 : 0) + 1;
	        s = Object.assign({}, s, {
	            '_people': new Map(),
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        // set people
	        if (s.personIds.size > 0) {
	            persons.streamIds(Array.from(s.personIds.keys())).take(1).subscribe(function (pm) {
	                s._people = pm;
	                if (--waitCount === 0) {
	                    subject.next(s);
	                    subject.complete();
	                }
	            });
	        }
	        // set created user and edited user
	        this.utils.addCreateEditUsers(s, users).subscribe(function () {
	            if (--waitCount === 0) {
	                subject.next(s);
	                subject.complete();
	            }
	        });
	        return subject;
	    };
	    StoriesService.prototype.hasWord = function (s, w) {
	        return (s.text.toLowerCase().indexOf(w) >= 0) ||
	            (s.title.toLowerCase().indexOf(w) >= 0) ||
	            ((!!s._people ? Array.from(s._people.values()) : []).some(function (p) { return p._fullName.toLowerCase().indexOf(w) >= 0; })); //TODO person interface type
	    };
	    return StoriesService;
	}());
	exports.StoriesService = StoriesService;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var subscriptions_service_1 = __webpack_require__(288);
	var SubscriptionsService = /** @class */ (function (_super) {
	    __extends(SubscriptionsService, _super);
	    SubscriptionsService.$inject = ["changes", "store", "segment", "utils"];
	    function SubscriptionsService(changes, store, segment, utils) {
	        'ngInject';
	        return _super.call(this, changes, store, segment, utils) || this;
	    }
	    return SubscriptionsService;
	}(subscriptions_service_1.SubscriptionsService));
	exports.default = SubscriptionsService;
	// class SubscriptionsService {
	//   constructor (changes, store, segment, utils) {
	//     'ngInject';
	//     this.store = store.create("subscriptions", null, changes.userStream());
	//     this.segment = segment;
	//     this.utils = utils;
	//   }
	//   stream() {
	//     return this.store.stream().map(m => this.utils.first(m));
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   create(o) {
	//     this.segment.track('subscriptions.create');
	//     return this.store.create(o);
	//   }
	//   update(o) {
	//     this.segment.track('subscriptions.update');
	//     return this.store.update(o);
	//   }
	// }
	// export default SubscriptionsService;


/***/ }),
/* 288 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SubscriptionsService = /** @class */ (function () {
	    function SubscriptionsService(changes, store, segment, utils) {
	        this.changes = changes;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("subscriptions", null, changes.userStream());
	    }
	    SubscriptionsService.prototype.stream = function () {
	        var _this = this;
	        return this.store.stream().map(function (m) { return _this.utils.first(m); });
	    };
	    SubscriptionsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    SubscriptionsService.prototype.create = function (o) {
	        this.segment.track('subscriptions.create');
	        return this.store.create(o);
	    };
	    SubscriptionsService.prototype.update = function (o) {
	        this.segment.track('subscriptions.update');
	        return this.store.update(o);
	    };
	    return SubscriptionsService;
	}());
	exports.SubscriptionsService = SubscriptionsService;
	exports.default = SubscriptionsService;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2018
	 */
	var TreeGraphicsService = /** @class */ (function () {
	    TreeGraphicsService.$inject = ["$log", "store", "changes", "utils"];
	    function TreeGraphicsService($log, store, changes, utils) {
	        'ngInject';
	        this.$log = $log;
	        this.utils = utils;
	        this.store = store.create("trees", "tree_graphics", changes.treeStream(), function (l) { return utils.addCreateEditDates(l); });
	    }
	    TreeGraphicsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    TreeGraphicsService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    TreeGraphicsService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    // non-streaming functions; caller must make sure that stream is "ready" before calling
	    TreeGraphicsService.prototype.getMap = function () {
	        return this.store.getStream().getValue();
	    };
	    //
	    // helper functions
	    //
	    TreeGraphicsService.prototype.hasWord = function (tg, w) {
	        return tg.title.toLowerCase().indexOf(w) >= 0;
	    };
	    return TreeGraphicsService;
	}());
	exports.default = TreeGraphicsService;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var treeUsers_service_1 = __webpack_require__(291);
	var TreeUsersService = /** @class */ (function (_super) {
	    __extends(TreeUsersService, _super);
	    TreeUsersService.$inject = ["$log", "rx", "store", "rightsFull", "changes", "segment", "utils"];
	    function TreeUsersService($log, rx, store, rightsFull, changes, segment, utils) {
	        'ngInject';
	        return _super.call(this, $log, rx, store, rightsFull, changes, segment, utils) || this;
	    }
	    return TreeUsersService;
	}(treeUsers_service_1.TreeUsersService));
	exports.default = TreeUsersService;
	// class TreeUsersService {
	//   constructor ($log, rx, store, rightsFull, changes, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.rightsFull = rightsFull;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", "users", changes.treeUserStream());
	//     this.guest = {
	//       id: 0,
	//       version: 0,
	//       preferences: {
	//         'ROOT': '',
	//         'SHOW_RELATIVES_EVENTS': 'TRUE'
	//       }
	//     };
	//   }
	//   setGuestRoot(id) {
	//     if (!this.guest.preferences['ROOT']) {
	//       this.guest.preferences['ROOT'] = id.toString();
	//     }
	//   }
	//   ready() {
	//     return this.rightsFull.stream().flatMap(rights => {
	//       if (rights.level === this.rightsFull.LEVEL_GUEST || (rights.treePrivacy === 'FEATURED' && rights.userId === 0)) {
	//         return this.rx.Observable.of(true);
	//       }
	//       else {
	//         return this.store.ready();
	//       }
	//     }).take(1);
	//   }
	//   update(tu) {
	//     this.segment.track('treeUser.update');
	//     return this.store.update(tu);
	//   }
	//   // this is a singleton collection; it just stores the current user
	//   stream() {
	//     return this.rightsFull.stream().flatMap(rights => {
	//       if (rights.level === this.rightsFull.LEVEL_GUEST || (rights.treePrivacy === 'FEATURED' && rights.userId === 0)) {
	//         return this.rx.Observable.of(this.guest);
	//       }
	//       else {
	//         return this.store.stream().map(m => this.utils.first(m)).filter(m => m !== null);
	//       }
	//     });
	//   }
	// }
	// export default TreeUsersService;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Observable } from "../../node_modules/rxjs";
	var TreeUsersService = /** @class */ (function () {
	    function TreeUsersService(log, rx, store, rightsFull, changes, segment, utils) {
	        this.log = log;
	        this.rx = rx;
	        this.rightsFull = rightsFull;
	        this.changes = changes;
	        this.segment = segment;
	        this.utils = utils;
	        this.guest = {
	            id: 0,
	            version: 0,
	            preferences: {
	                'ROOT': '',
	                'SHOW_RELATIVES_EVENTS': 'TRUE'
	            }
	        };
	        this.store = store.create("trees", "users", changes.treeUserStream());
	    }
	    TreeUsersService.prototype.setGuestRoot = function (scope, id) {
	        if (!scope.guestRoot) {
	            scope.guestRoot = id;
	            this.guest.preferences['ROOT'] = id.toString();
	        }
	    };
	    TreeUsersService.prototype.ready = function () {
	        var _this = this;
	        return this.rightsFull.stream().flatMap(function (rights) {
	            if (rights.level === _this.rightsFull.LEVEL_GUEST || (rights.treePrivacy === 'FEATURED' && rights.userId === 0)) {
	                return _this.rx.Observable.of(true);
	            }
	            else {
	                return _this.store.ready();
	            }
	        }).take(1);
	    };
	    TreeUsersService.prototype.update = function (tu) {
	        this.segment.track('treeUser.update');
	        return this.store.update(tu);
	    };
	    // this is a singleton collection; it just stores the current user
	    TreeUsersService.prototype.stream = function () {
	        var _this = this;
	        return this.rightsFull.stream().flatMap(function (rights) {
	            if (rights.level === _this.rightsFull.LEVEL_GUEST || (rights.treePrivacy === 'FEATURED' && rights.userId === 0)) {
	                return _this.rx.Observable.of(_this.guest);
	            }
	            else {
	                return _this.store.stream().map(function (m) { return _this.utils.first(m); }).filter(function (m) { return m !== null; });
	            }
	        });
	    };
	    return TreeUsersService;
	}());
	exports.TreeUsersService = TreeUsersService;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var users_service_1 = __webpack_require__(293);
	var UsersService = /** @class */ (function (_super) {
	    __extends(UsersService, _super);
	    UsersService.$inject = ["$log", "rx", "Upload", "authToken", "messageBus", "medias", "server", "serverBase", "utils"];
	    function UsersService($log, rx, Upload, authToken, messageBus, medias, server, serverBase, utils) {
	        'ngInject';
	        return _super.call(this, $log, rx, Upload, authToken, messageBus, medias, server, serverBase, utils) || this;
	    }
	    return UsersService;
	}(users_service_1.UsersService));
	exports.default = UsersService;
	// class UsersService {
	//   constructor ($log, rx, Upload, authToken, messageBus, medias, server, serverBase, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.Upload = Upload;
	//     this.authToken = authToken;
	//     this.messageBus = messageBus;
	//     this.mediasService = medias;
	//     this.server = server;
	//     this.serverBase = serverBase;
	//     this.utils = utils;
	//     this.users = new Map(); // cache all users in a map
	//     this.userSummaries = new Map(); // cache all userSummaries in a map
	//     this.pendingRequests = new Map();
	//     this.summaryPendingRequests = new Map();
	//   }
	//   ready() {
	//     return this.rx.Observable.of(true);
	//   }
	//   // doesn't support streaming updates; we might add support in the future
	//   stream() {
	//     return this.rx.Observable.of(true);
	//   }
	//   streamSummaryId(id) {
	//     if (this.userSummaries.has(id)) {
	//       return this.rx.Observable.of(this.userSummaries.get(id));
	//     }
	//     if (!!this.summaryPendingRequests.get(id)) {
	//       return this.summaryPendingRequests.get(id);
	//     }
	//     let request = new this.rx.AsyncSubject();
	//     this.summaryPendingRequests.set(id, request);
	//     this.server.get('/users/'+id+'/summary').subscribe(u => {
	//       this.$log.debug('users.summary.caching', id);
	//       u = this.utils.fromServer(u);
	//       this.userSummaries.set(id, u);
	//       request.next(u);
	//       request.complete();
	//       this.summaryPendingRequests.delete(id);
	//     }, err => {
	//       let u = {};
	//       if (err.status === 404) {
	//         u = {id: id, source: '', name: 'Deleted', hasAvatar: false, rating: 0};
	//       }
	//       else {
	//         this.messageBus.post({msg: err.data, status: err.status, op: 'GET', ctx: 'users/summaries'});
	//       }
	//       request.next(u);
	//       request.complete();
	//       this.summaryPendingRequests.delete(id);
	//     });
	//     return request;
	//   }
	//   streamId(id) {
	//     if (this.users.has(id)) {
	//       return this.rx.Observable.of(this.users.get(id));
	//     }
	//     if (!!this.pendingRequests.get(id)) {
	//       return this.pendingRequests.get(id);
	//     }
	//     let request = new this.rx.AsyncSubject();
	//     this.pendingRequests.set(id, request);
	//     this.server.get('/users/'+id).subscribe(u => {
	//       this.$log.debug('users.caching', id);
	//       u = this.utils.fromServer(u);
	//       this.users.set(id, u);
	//       request.next(u);
	//       request.complete();
	//       this.pendingRequests.delete(id);
	//     }, err => {
	//       let u = {};
	//       if (err.status === 404) {
	//         u = {id: id, version: 0, source: '', sourceKey: '', name: 'Deleted', given: '', surname: '', hasAvatar: false, email: '', emailConfirmationDate: '', preferences: {}, rating: 0};
	//       }
	//       else {
	//         this.messageBus.post({msg: err.data, status: err.status, op: 'GET', ctx: 'users'});
	//       }
	//       request.next(u);
	//       request.complete();
	//       this.pendingRequests.delete(id);
	//     });
	//     return request;
	//   }
	//   // returns an array of users (requires requesting user to have READ rights)
	//   streamAllUsers(rights) {
	//     return rights.ready()
	//       .flatMap(() => rights.stream())
	//       .flatMap(rm => this.rx.Observable.forkJoin(...Array.from(rm.keys()).map(id => this.streamId(id))));
	//   }
	//   nameAutocomplete(rights, prefix) {
	//     let lc = this.utils.normalize(prefix);
	//     return this.streamAllUsers(rights)
	//       .map(users => users.filter(user => user.name.toLowerCase().startsWith(lc) || user.given.toLowerCase().startsWith(lc) || user.surname.toLowerCase().startsWith(lc)))
	//       .take(1)
	//       .toPromise();
	//   }
	//   getAvatarURL(user) {
	//     return this.serverBase + '/users/' + user.id.toString() + '/avatar?version=' + user.version.toString();
	//   }
	//   uploadAvatar(user, fileData) { // fileData={file, cropped, fileDataURI}
	//     let subject = new this.rx.AsyncSubject();
	//     this.server.incRequests();
	//     this.utils.upload({
	//       url: this.getAvatarURL(user) + '&token=' + this.authToken.get(),
	//       data: {
	//         file: this.mediasService.isImageFile(fileData.file) && fileData.cropped ? this.Upload.dataUrltoBlob(fileData.fileDataURI, fileData.file.name) : fileData.file
	//       }
	//     }).subscribe(response => {
	//       this.server.decRequests();
	//       subject.next(response.data.type);
	//       subject.complete();
	//     }, response => {
	//       this.server.decRequests();
	//       this.messageBus.post({msg: 'Error uploading profile picture: ' + (response.status === 413 ? 'file is too large' : response.status + ' - please try again later or contact support@rootsfinder.com')});
	//       subject.error(response);
	//     });
	//     return subject;
	//   }
	//   reconfirmEmail(id) {
	//     return this.server.put('/users/' + id.toString() + '/reconfirm');
	//   }
	// }
	// export default UsersService;


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { Observable, AsyncSubject } from "../../node_modules/rxjs";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var UsersService = /** @class */ (function () {
	    function UsersService(log, rx, Upload, authToken, messageBus, mediasService, server, serverBase, utils) {
	        this.log = log;
	        this.rx = rx;
	        this.Upload = Upload;
	        this.authToken = authToken;
	        this.messageBus = messageBus;
	        this.mediasService = mediasService;
	        this.server = server;
	        this.serverBase = serverBase;
	        this.utils = utils;
	        this.users = new Map(); // cache all users in a map
	        this.userSummaries = new Map(); // cache all userSummaries in a map
	        this.pendingRequests = new Map();
	        this.summaryPendingRequests = new Map();
	    }
	    UsersService.prototype.ready = function () {
	        return this.rx.Observable.of(true);
	    };
	    // doesn't support streaming updates; we might add support in the future
	    UsersService.prototype.stream = function () {
	        return this.rx.Observable.of(true);
	    };
	    UsersService.prototype.streamSummaryId = function (id) {
	        var _this = this;
	        if (this.userSummaries.has(id)) {
	            return this.rx.Observable.of(this.userSummaries.get(id));
	        }
	        if (this.summaryPendingRequests.has(id)) {
	            return this.summaryPendingRequests.get(id);
	        }
	        var request = new this.rx.AsyncSubject();
	        this.summaryPendingRequests.set(id, request);
	        this.server.get('/users/' + id + '/summary').subscribe(function (u) {
	            _this.log.debug('users.summary.caching', id);
	            u = _this.utils.fromServer(u);
	            _this.userSummaries.set(id, u);
	            request.next(u);
	            request.complete();
	            _this.summaryPendingRequests.delete(id);
	        }, function (err) {
	            var u = {};
	            if (err.status === 404) {
	                u = { id: id, source: '', name: 'Deleted', hasAvatar: false, rating: 0 };
	            }
	            else {
	                _this.messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'users/summaries' });
	            }
	            request.next(u);
	            request.complete();
	            _this.summaryPendingRequests.delete(id);
	        });
	        return request;
	    };
	    UsersService.prototype.streamId = function (id) {
	        var _this = this;
	        if (this.users.has(id)) {
	            return this.rx.Observable.of(this.users.get(id));
	        }
	        if (!!this.pendingRequests.get(id)) {
	            return this.pendingRequests.get(id);
	        }
	        var request = new this.rx.AsyncSubject();
	        this.pendingRequests.set(id, request);
	        this.server.get('/users/' + id).subscribe(function (u) {
	            _this.log.debug('users.caching', id);
	            u = _this.utils.fromServer(u);
	            _this.users.set(id, u);
	            request.next(u);
	            request.complete();
	            _this.pendingRequests.delete(id);
	        }, function (err) {
	            var u = {};
	            if (err.status === 404) {
	                u = { id: id, version: 0, source: '', sourceKey: '', name: 'Deleted', given: '', surname: '', hasAvatar: false, email: '', emailConfirmationDate: '', preferences: {}, rating: 0 };
	            }
	            else {
	                _this.messageBus.post({ msg: err.data, status: err.status, op: 'GET', ctx: 'users' });
	            }
	            request.next(u);
	            request.complete();
	            _this.pendingRequests.delete(id);
	        });
	        return request;
	    };
	    // returns an array of users (requires requesting user to have READ rights)
	    UsersService.prototype.streamAllUsers = function (rights) {
	        var _this = this;
	        return rights.ready()
	            .flatMap(function () { return rights.stream(); })
	            .flatMap(function (rm) {
	            return (_a = _this.rx.Observable).forkJoin.apply(_a, __spread(Array.from(rm.keys()).map(function (id) { return _this.streamId(id); })));
	            var _a;
	        });
	    };
	    UsersService.prototype.nameAutocomplete = function (rights, prefix) {
	        var lc = this.utils.normalize(prefix);
	        return this.streamAllUsers(rights)
	            .map(function (users) { return users.filter(function (user) { return user.name.toLowerCase().startsWith(lc) || user.given.toLowerCase().startsWith(lc) || user.surname.toLowerCase().startsWith(lc); }); }) //TODO user and users interface types
	            .take(1)
	            .toPromise();
	    };
	    UsersService.prototype.getAvatarURL = function (user) {
	        return this.serverBase + '/users/' + user.id.toString() + '/avatar?version=' + user.version.toString();
	    };
	    UsersService.prototype.uploadAvatar = function (user, fileData) {
	        var _this = this;
	        var subject = new this.rx.AsyncSubject();
	        this.server.incRequests();
	        this.utils.upload({
	            url: this.getAvatarURL(user) + '&token=' + this.authToken.get(),
	            data: {
	                file: this.mediasService.isImageFile(fileData.file) && fileData.cropped ? this.Upload.dataUrltoBlob(fileData.fileDataURI, fileData.file.name) : fileData.file
	            }
	        }).subscribe(function (response) {
	            _this.server.decRequests();
	            subject.next(response.data.type);
	            subject.complete();
	        }, function (response) {
	            _this.server.decRequests();
	            _this.messageBus.post({ msg: 'Error uploading profile picture: ' + (response.status === 413 ? 'file is too large' : response.status + ' - please try again later or contact support@rootsfinder.com') });
	            subject.error(response);
	        });
	        return subject;
	    };
	    UsersService.prototype.reconfirmEmail = function (id) {
	        return this.server.put('/users/' + id.toString() + '/reconfirm');
	    };
	    return UsersService;
	}());
	exports.UsersService = UsersService;
	exports.default = UsersService;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_service_1 = __webpack_require__(295);
	var UtilsService = /** @class */ (function (_super) {
	    __extends(UtilsService, _super);
	    UtilsService.$inject = ["$mdDialog", "$document", "$translate", "$timeout", "$window", "rx", "Upload", "currentTreeId", "serverBase", "authToken"];
	    function UtilsService($mdDialog, $document, $translate, $timeout, $window, rx, Upload, currentTreeId, serverBase, authToken) {
	        'ngInject';
	        var _this = _super.call(this, $mdDialog, $document, $translate, $timeout, $window, rx, Upload, currentTreeId, serverBase, authToken, angular) || this;
	        _this.$document = $document;
	        return _this;
	    }
	    //UI functions override the base class stub as they are differenct in web and mobile
	    UtilsService.prototype.dialog = function (ev, ctrl, template, easyClose, locals) {
	        return this.mdDialog.show({
	            controller: ctrl,
	            controllerAs: 'dlg',
	            locals: locals || {},
	            bindToController: true,
	            templateUrl: template,
	            parent: angular.element(this.document.body),
	            targetEvent: ev,
	            escapeToClose: easyClose,
	            clickOutsideToClose: easyClose
	        });
	    };
	    UtilsService.prototype.dialogCancel = function () {
	        this.mdDialog.cancel();
	    };
	    UtilsService.prototype.alert = function (title, content, evt, ok) {
	        return this.mdDialog.show(this.mdDialog.alert()
	            .parent(angular.element(this.document.body))
	            .clickOutsideToClose(true)
	            .title(title)
	            .textContent(content)
	            .ok(ok || 'Got it')
	            .targetEvent(evt));
	    };
	    UtilsService.prototype.confirm = function (title, content, ev, ok, cancel) {
	        return this.mdDialog.show(this.mdDialog.confirm()
	            .title(title)
	            .textContent(content)
	            .targetEvent(ev)
	            .ok(ok || 'Ok')
	            .cancel(cancel || 'Cancel'));
	    };
	    UtilsService.prototype.prompt = function (title, content, placeholder, value, ev, ok, cancel) {
	        return this.mdDialog.show(this.mdDialog.prompt()
	            .title(title)
	            .textContent(content)
	            .placeholder(placeholder)
	            .ariaLabel(placeholder)
	            .initialValue(value)
	            .targetEvent(ev)
	            .ok(ok || 'Ok')
	            .cancel(cancel || 'Cancel'));
	    };
	    UtilsService.prototype.pleaseWait = function (immediate) {
	        var _this = this;
	        var pw = {};
	        pw.timeout = this.timeout(function () {
	            pw.timeout = null;
	            // don't show please wait if there is another dialog or please wait displayed
	            if (angular.element(_this.$document).find('md-backdrop').length === 0 && _this.$document[0].getElementsByClassName('please_wait').length === 0) {
	                pw.dlg = _this.mdDialog.show({
	                    template: '<md-dialog class="please_wait" aria-label="please wait"><md-dialog-content layout="row" layout-align="center center" style="padding: 20px">Please wait...</md-dialog-content></md-dialog>',
	                    parent: angular.element(_this.document.body)
	                });
	            }
	        }, immediate ? 0 : 500);
	        return pw;
	    };
	    UtilsService.prototype.pleaseWaitCancel = function (pw) {
	        if (!!pw.timeout) {
	            this.timeout.cancel(pw.timeout);
	            pw.timeout = null;
	        }
	        if (!!pw.dlg) {
	            this.mdDialog.cancel();
	            pw.dlg = null;
	        }
	    };
	    UtilsService.prototype.showSidenav = function (state) {
	        return !(state.is('tree.import-fs') || state.is('tree.import-gedcom') || state.is('tree.import-scratch'));
	    };
	    UtilsService.prototype.showEvidence = function (ev, evidences, sources, persons, users, evidenceUtils, id) {
	        var _this = this;
	        evidences.streamId(id).take(1).subscribe(function (evidence) {
	            evidences.augmentEvidence(evidence, sources, persons, users).subscribe(function (evidence) {
	                _this.dialog(ev, 'ListModalController', 'app/components/list/listModal.html', true, { itemType: 'evidence', item: evidence }).then(function (response) {
	                    if (!!response) {
	                        if (response.action === 'edit') {
	                            _this.dialog(ev, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	                                evidence: evidence
	                            });
	                        }
	                        else if (response.action === 'delete') {
	                            _this.confirm('Delete Supporting Evidence', 'Are you sure?', ev).then(function () {
	                                var deletedNamesFacts = evidenceUtils.getDeletedNamesFacts([evidence], [], true);
	                                if (deletedNamesFacts.filter(function (nf) { return nf.principal && nf.unsupported; }).length > 0) {
	                                    _this.dialog(null, 'SelectNamesFactsController', 'app/components/selectNamesFacts/selectNamesFacts.html', false, {
	                                        namesFacts: deletedNamesFacts
	                                    }).then(function (deletedNamesFacts) {
	                                        evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	                                    });
	                                }
	                                else {
	                                    evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	                                }
	                            });
	                        }
	                        else if (response.action === 'show' && response.params.type === 'source') {
	                            _this.showSource(ev, sources, evidences, users, response.params.id);
	                        }
	                    }
	                });
	            });
	        });
	    };
	    UtilsService.prototype.showSource = function (ev, sources, evidences, users, id) {
	        var _this = this;
	        sources.streamId(id).take(1).subscribe(function (source) {
	            if (!source) {
	                return;
	            }
	            sources.augmentSource(source, users).subscribe(function (source) {
	                _this.dialog(ev, 'ListModalController', 'app/components/list/listModal.html', true, { itemType: 'source', item: source }).then(function (response) {
	                    if (!!response) {
	                        if (response.action === 'edit') {
	                            _this.dialog(ev, 'EditSourceController', 'app/components/editSource/editSource.html', false, {
	                                source: source
	                            });
	                        }
	                        else if (response.action === 'delete') {
	                            evidences.streamForSource(id).take(1).subscribe(function (em) {
	                                if (em.size > 0) {
	                                    _this.dialog(ev, 'DeleteSourceController', 'app/components/deleteSource/deleteSource.html', true, {
	                                        evidenceMap: em
	                                    });
	                                }
	                                else {
	                                    _this.confirm('Delete Source', 'Are you sure?', ev).then(function () {
	                                        sources.del(id);
	                                    });
	                                }
	                            });
	                        }
	                    }
	                });
	            });
	        });
	    };
	    UtilsService.prototype.showStory = function (ev, stories, persons, users, id) {
	        var _this = this;
	        stories.streamId(id).take(1).subscribe(function (story) {
	            stories.augmentStory(story, persons, users).subscribe(function (story) {
	                _this.dialog(ev, 'ListModalController', 'app/components/list/listModal.html', true, { itemType: 'story', item: story }).then(function (response) {
	                    if (!!response) {
	                        if (response.action === 'edit') {
	                            _this.dialog(ev, 'EditStoryController', 'app/components/editSource/editSource.html', false, {
	                                story: story
	                            });
	                        }
	                        else if (response.action === 'delete') {
	                            _this.confirm('Delete Story', 'Are you sure?', ev).then(function () {
	                                stories.del(id);
	                            });
	                        }
	                    }
	                });
	            });
	        });
	    };
	    return UtilsService;
	}(utils_service_1.UtilsService));
	exports.UtilsService = UtilsService;
	exports.default = UtilsService;
	// const FS = 'familysearch.org';
	// class UtilsService {
	//   constructor ($mdDialog, $document, $translate, $timeout, $window, rx, Upload, currentTreeId, serverBase, authToken) {
	//     'ngInject';
	//     this.$mdDialog = $mdDialog;
	//     this.$document = $document;
	//     this.$translate = $translate;
	//     this.$timeout = $timeout;
	//     this.$window = $window;
	//     this.rx = rx;
	//     this.Upload = Upload;
	//     this.currentTreeId = currentTreeId;
	//     this.serverBase = serverBase;
	//     this.authToken = authToken;
	//     this.diacriticsMap = this._generateDiacriticsMap();
	//     this.numRE = /^[0-9]+$/;
	//     this.urlRE = /^((?:https?|ftp):\/\/)?[^\s\/$.?#].[^\s]*$/;
	//     this.idCoding = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
	//     this.mentionRegex = new RegExp('@([-A-Za-z0-9_]+)(?![-A-Za-z0-9_"<])', 'g');
	//     this.translations = this._getTranslations();
	//     this.factTypes = this._getFactTypes();
	//     this.nameTypes = this._getNameTypes();
	//     this.relationshipTypes = this._getRelationshipTypes();
	//     this.genders = this._getGenders();
	//     this.parentRelTypes = this._getParentRelTypes();
	//     this.vitalTypes = ['BIRT', 'CHR', 'DEAT', 'BURI'];
	//     this.entities = {
	//       '&amp;': '&',
	//       '&lt;': '<',
	//       '&gt;': '>',
	//       '&quot;': '"',
	//       '&#39;': '\'',
	//       '&apos;': '\'',
	//       '&nbsp;': ' ',
	//       '&zwj;': ''
	//     };
	//     this.reverseEntities = {
	//       '&': '&amp;',
	//       '<': '&lt;',
	//       '>': '&gt;',
	//       '"': '&quot;',
	//       '\'': '&#39;'
	//     };
	//     this.pdfReplacements = {
	//       'Ł': 'L',
	//       'ł': 'l'
	//     };
	//     this.pdfRegExp = new RegExp('['+Object.keys(this.pdfReplacements).join('')+']', 'g');
	//     this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	//     this.ahnentafelColorsLight = [
	//       '#FFFFFF', // placeholder
	//       '#e2e2e2', // self
	//       '#e2e2e2',
	//       '#e2e2e2',
	//       '#66a4d6',
	//       '#9174b4',
	//       '#d4767f',
	//       '#ede657',
	//       '#66a4d6',
	//       '#9cceef',
	//       '#9174b4',
	//       '#a571a2',
	//       '#d4767f',
	//       '#e4a5a3',
	//       '#ede657',
	//       '#f1e798',
	//       '#66a4d6',
	//       '#7db7d8',
	//       '#9cceef',
	//       '#bcdfea',
	//       '#9174b4',
	//       '#ab90c3',
	//       '#a571a2',
	//       '#cb9ac6',
	//       '#d4767f',
	//       '#ca8989',
	//       '#e4a5a3',
	//       '#f5d2d0',
	//       '#ede657',
	//       '#fbf17e',
	//       '#f1e798',
	//       '#f9f1ad'
	//     ];
	//     this.ahnentafelColorsDark = [
	//       '#FFFFFF', // placeholder
	//       '#547f41', // self
	//       '#416f7f',
	//       '#e5bf21',
	//       '#416f7f',
	//       '#5b4580',
	//       '#c1306b',
	//       '#e5bf21',
	//       '#416f7f',
	//       '#5fb2b0',
	//       '#5b4580',
	//       '#8e7fb9',
	//       '#c1306b',
	//       '#db868a',
	//       '#e5bf21',
	//       '#fee655',
	//       '#416f7f',
	//       '#5b99a3',
	//       '#5fb2b0',
	//       '#7acbdd',
	//       '#5b4580',
	//       '#6e589b',
	//       '#8e7fb9',
	//       '#a396c8',
	//       '#c1306b',
	//       '#d65083',
	//       '#db868a',
	//       '#f3b8b8',
	//       '#e5bf21',
	//       '#efde3f',
	//       '#fee655',
	//       '#feea89'
	//     ];
	//     this.colorNOT = 99999;
	//     this.colorOverrideBase = 99990;
	//     this.colorMultiplier = 100000;
	//     this.colors = {
	//       'blue': ['#2177b5', '#428fc6', '#6ba9d6', '#9ec5e1', '#c6deef', '#eff8ff'],
	//       'purple': ['#7551a3', '#977dba', '#ae9ac8', '#cabcdc', '#e1daeb', '#f3f0f7'],
	//       'magenta': ['#b8398d', '#d459ab', '#e077bd', '#ed9ad1', '#f5bfe3', '#fce6f5'],
	//       'red': ['#cb1818', '#ef2c2c', '#fb4a4a', '#fc7272', '#fca1a1', '#fed9d9'],
	//       'orange': ['#d96d01', '#f18213', '#fd9d3c', '#fdb46b', '#fdd0a2', '#feeede'],
	//       'yellow': ['#d6d600', '#e0e009', '#ebeb1c', '#ffff33', '#ffff99', '#ffffcc'],
	//       //'avocado': ['#b3b317', '#cfcf30', '#e0e05e', '#ebeb83', '#f2f2b1', '#fcfce3'],
	//       'green': ['#238b23', '#41ab41', '#74c474', '#9bd99b', '#c0e9c0', '#e9f8e9'],
	//       'aquamarine': ['#239670', '#40b396', '#73c9b4', '#9adbcb', '#c0ebe0', '#ebfaf6'],
	//       'aqua': ['#23a1a1', '#40b8b8', '#70cccc', '#9bdede', '#c2eded', '#edfcfc']
	//     };
	//     this.colorSegmentRE = /[0-9a-f]{2}/gi;
	//   }
	//   //
	//   // UI functions
	//   //
	//   dialog(ev, ctrl, template, easyClose, locals) {
	//     return this.$mdDialog.show({
	//       controller: ctrl,
	//       controllerAs: 'dlg',
	//       locals: locals || {},
	//       bindToController: true,
	//       templateUrl: template,
	//       parent: angular.element(this.$document.body),
	//       targetEvent: ev,
	//       escapeToClose: easyClose,
	//       clickOutsideToClose: easyClose
	//     });
	//   }
	//   dialogCancel() {
	//     this.$mdDialog.cancel();
	//   }
	//   alert(title, content, evt, ok) {
	//     return this.$mdDialog.show(
	//       this.$mdDialog.alert()
	//         .parent(angular.element(this.$document.body))
	//         .clickOutsideToClose(true)
	//         .title(title)
	//         .textContent(content)
	//         .ok(ok || 'Got it')
	//         .targetEvent(evt)
	//     );
	//   }
	//   confirm(title, content, ev, ok, cancel) {
	//     return this.$mdDialog.show(
	//       this.$mdDialog.confirm()
	//         .title(title)
	//         .textContent(content)
	//         .targetEvent(ev)
	//         .ok(ok || 'Ok')
	//         .cancel(cancel || 'Cancel')
	//     );
	//   }
	//   prompt(title, content, placeholder, value, ev, ok, cancel) {
	//     return this.$mdDialog.show(
	//       this.$mdDialog.prompt()
	//         .title(title)
	//         .textContent(content)
	//         .placeholder(placeholder)
	//         .ariaLabel(placeholder)
	//         .initialValue(value)
	//         .targetEvent(ev)
	//         .ok(ok || 'Ok')
	//         .cancel(cancel || 'Cancel')
	//     );
	//   }
	//   pleaseWait(immediate) {
	//     let pw = {};
	//     pw.timeout = this.$timeout(() => {
	//       pw.timeout = null;
	//       pw.dlg = this.$mdDialog.show({
	//         template: '<md-dialog class="please_wait" aria-label="please wait"><md-dialog-content layout="row" layout-align="center center" style="padding: 20px">Please wait...</md-dialog-content></md-dialog>',
	//         parent: angular.element(this.$document.body)
	//       });
	//     }, immediate ? 0 : 500);
	//     return pw;
	//   }
	//   pleaseWaitCancel(pw) {
	//     if (!!pw.timeout) {
	//       this.$timeout.cancel(pw.timeout);
	//       pw.timeout = null;
	//     }
	//     if (!!pw.dlg) {
	//       this.$mdDialog.cancel();
	//       pw.dlg = null;
	//     }
	//   }
	//   showSidenav(state) {
	//     return !(state.is('tree.import-fs') || state.is('tree.import-gedcom') || state.is('tree.import-scratch'));
	//   }
	//   toggleExpand(item) {
	//     item._isExpanded = !item._isExpanded;
	//   }
	//   toggleExpandAll(c) {
	//     let anyExpanded = this.anyExpanded(c);
	//     for (let i of c) {
	//       i._isExpanded = !anyExpanded;
	//     }
	//   }
	//   anyExpanded(c) {
	//     return c.some(i => i._isExpanded);
	//   }
	//   asArray(n) {
	//     let a = [];
	//     for (let i = 0; i < n; i++) {
	//       a.push(i);
	//     }
	//     return a;
	//   }
	//   showEvidence(ev, evidences, sources, persons, users, evidenceUtils, id) {
	//     evidences.streamId(id).take(1).subscribe(evidence => {
	//       evidences.augmentEvidence(evidence, sources, persons, users).subscribe(evidence => {
	//         this.dialog(ev, 'ListModalController', 'app/components/list/listModal.html', true, {itemType: 'evidence', item: evidence}).then(response => {
	//           if (!!response) {
	//             if (response.action === 'edit') {
	//               this.dialog(ev, 'EditEvidenceController', 'app/components/editEvidence/editEvidence.html', false, {
	//                 evidence: evidence
	//               });
	//             }
	//             else if (response.action === 'delete') {
	//               this.confirm('Delete Supporting Evidence', 'Are you sure?', ev).then(() => {
	//                 let deletedNamesFacts = evidenceUtils.getDeletedNamesFacts([evidence], [], true);
	//                 if (deletedNamesFacts.filter(nf => nf.principal && nf.unsupported).length > 0) {
	//                   this.dialog(null, 'SelectNamesFactsController', 'app/components/selectNamesFacts/selectNamesFacts.html', false, {
	//                     namesFacts: deletedNamesFacts
	//                   }).then(deletedNamesFacts => {
	//                     evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	//                   });
	//                 }
	//                 else {
	//                   evidenceUtils.del(evidence, deletedNamesFacts).subscribe();
	//                 }
	//               });
	//             }
	//             else if (response.action === 'show' && response.params.type === 'source') {
	//               this.showSource(ev, sources, evidences, users, response.params.id);
	//             }
	//           }
	//         });
	//       });
	//     });
	//   }
	//   showSource(ev, sources, evidences, users, id) {
	//     sources.streamId(id).take(1).subscribe(source => {
	//       if (!source) {
	//         return;
	//       }
	//       sources.augmentSource(source, users).subscribe(source => {
	//         this.dialog(ev, 'ListModalController', 'app/components/list/listModal.html', true, {itemType: 'source', item: source}).then(response => {
	//           if (!!response) {
	//             if (response.action === 'edit') {
	//               this.dialog(ev, 'EditSourceController', 'app/components/editSource/editSource.html', false, {
	//                 source: source
	//               });
	//             }
	//             else if (response.action === 'delete') {
	//               evidences.streamForSource(id).take(1).subscribe(em => {
	//                 if (em.size > 0) {
	//                   this.dialog(ev, 'DeleteSourceController', 'app/components/deleteSource/deleteSource.html', true, {
	//                     evidenceMap: em
	//                   });
	//                 }
	//                 else {
	//                   this.confirm('Delete Source', 'Are you sure?', ev).then(() => {
	//                     sources.del(id);
	//                   });
	//                 }
	//               });
	//             }
	//           }
	//         });
	//       });
	//     });
	//   }
	//   showStory(ev, stories, persons, users, id) {
	//     stories.streamId(id).take(1).subscribe(story => {
	//       stories.augmentStory(story, persons, users).subscribe(story => {
	//         this.dialog(ev, 'ListModalController', 'app/components/list/listModal.html', true, {itemType: 'story', item: story}).then(response => {
	//           if (!!response) {
	//             if (response.action === 'edit') {
	//               this.dialog(ev, 'EditStoryController', 'app/components/editSource/editSource.html', false, {
	//                 story: story
	//               });
	//             }
	//             else if (response.action === 'delete') {
	//               this.confirm('Delete Story', 'Are you sure?', ev).then(() => {
	//                 stories.del(id);
	//               });
	//             }
	//           }
	//         });
	//       });
	//     });
	//   }
	//   //
	//   // stream functions
	//   //
	//   pipe(src, dest, includeErrors) {
	//     return src.subscribe(x => {
	//       dest.next(x);
	//     }, err => {
	//       if (includeErrors) {
	//         dest.error(err);
	//       }
	//     });
	//   }
	//   teeAsync(stream) {
	//     let t = new this.rx.AsyncSubject();
	//     return [stream.do(x => t.next(x), err => t.error(err), () => t.complete()), t];
	//   }
	//   watch(scope, watchExpression, objectEquality) {
	//     return this.rx.Observable.create(observer => {
	//       // Create function to handle old and new Value
	//       function listener (newValue, oldValue) {
	//         observer.next({ oldValue: oldValue, newValue: newValue });
	//       }
	//       // Returns function which disconnects the $watch expression
	//       return scope.$watch(watchExpression, listener, objectEquality);
	//     });
	//   }
	//   // once all stores are ready, emit whenever any of them change
	//   readyChange(...stores) {
	//     let readys = stores.map(s => s.ready());
	//     let streams = stores.map(s => s.stream());
	//     return this.rx.Observable.forkJoin(...readys).flatMap(() => this.rx.Observable.combineLatest(...streams));
	//   }
	//   // can be used in readyChange
	//   createStream(initial) {
	//     let r = new this.rx.AsyncSubject();
	//     r.next(true);
	//     r.complete();
	//     let s = new this.rx.BehaviorSubject(initial);
	//     return {
	//       ready: () => {
	//         return r;
	//       },
	//       stream: () => {
	//         return s;
	//       },
	//       next: (value) => {
	//         s.next(value);
	//       }
	//     };
	//   }
	//   upload(params) {
	//     let subject = new this.rx.AsyncSubject();
	//     let Upload = this.Upload;
	//     let $timeout = this.$timeout;
	//     let total = 3;
	//     function doit(retries) {
	//       Upload.upload(params).then(response => {
	//         subject.next(response);
	//         subject.complete();
	//       }, response => {
	//         if (retries > 0 && response.status !== 413) {
	//           $timeout(() => {
	//             doit(retries-1);
	//           }, (total - retries + 1) * 500);
	//         }
	//         else {
	//           subject.error(response);
	//         }
	//       });
	//     }
	//     doit(total);
	//     return subject;
	//   }
	//   saveReport(data, ev, hasToC) {
	//     let name = this.removeDiacritics(data.name || 'report').replace(/[^A-Za-z0-9 -_']/g, ' ').replace(/\s+/g, ' ').trim() + '.' + data.ext;
	//     this.$window.saveAs(data.blob, name);
	//     let msg = 'Your report has been saved to your "Downloads" folder.';
	//     if (data.ext === 'docx') {
	//       msg += ' It is in Microsoft Word format so you can customize it before printing.';
	//     }
	//     if (hasToC) {
	//       msg += 'To update the Table of Contents, open the report in MS Word, click on the word "Contents" on the first page of the report, ' +
	//         'then click on the arrow that appears next to "Table of Contents", select "Update Table", and select "Update entire table".';
	//     }
	//     this.alert('Report saved', msg, ev);
	//     let subject = new this.rx.AsyncSubject();
	//     //let url = this.serverBase + '/trees/' + this.currentTreeId.get() + '/reports?token=' + this.authToken.get();
	//     //// have to open the window before we upload the report to avoid popup block
	//     //let w = this.$window.open('');
	//     //this.upload({
	//     //  url: url,
	//     //  data: {
	//     //    data: data
	//     //  }
	//     //}).subscribe(() => {
	//     //  w.location = url;
	//     subject.next(true);
	//     subject.complete();
	//     //}, err => {
	//     //  w.close();
	//     //  subject.error(err);
	//     //});
	//     return subject;
	//   }
	//   //
	//   // data extraction/manipulation functions
	//   //
	//   randomId() {
	//     return Math.floor(Math.random() * (Math.pow(2, 53)-1)) + 1;
	//   }
	//   randomKey() {
	//     return Math.floor(Math.random() * (Math.pow(2, 32)-1)) + 1;
	//   }
	//   nextKey(keys, start = 1) {
	//     if (keys.length === 0) {
	//       return Math.max(start, 1);
	//     }
	//     return Math.max(...keys) + Math.floor(Math.random() * 256) + 1;
	//   }
	//   getYear(d) {
	//     if (!d) {
	//       return '';
	//     }
	//     let m = d.match(/\b[12]\d{3}\b/);
	//     return !!m ? m[0] : '';
	//   }
	//   getNamePieces(name) {
	//     let given = '', surname = '';
	//     let ix = name.lastIndexOf(' ');
	//     if (ix > 0) {
	//       given = name.substr(0, ix);
	//       surname = name.substr(ix);
	//     }
	//     else {
	//       given = name;
	//     }
	//     return this.createName(given, surname);
	//   }
	//   createName(given, surname, prefix, suffix) {
	//     return {
	//       given: (given || '').trim(),
	//       surname: (surname || '').trim(),
	//       prefix: (prefix || '').trim(),
	//       suffix: (suffix || '').trim()
	//     };
	//   }
	//   isNameEmpty(n) {
	//     return !n.given && !n.surname && !n.prefix && !n.suffix;
	//   }
	//   getFullName(n) {
	//     if (!n) {
	//       return '';
	//     }
	//     let text = '';
	//     if (!!n.prefix) {
	//       text = n.prefix;
	//     }
	//     if (!!n.given) {
	//       if (text.length > 0) {
	//         text += ' ';
	//       }
	//       text += n.given;
	//     }
	//     if (!!n.surname) {
	//       if (text.length > 0) {
	//         text += ' ';
	//       }
	//       text += n.surname;
	//     }
	//     if (!!n.suffix) {
	//       if (text.length > 0) {
	//         text += ' ';
	//       }
	//       text += n.suffix;
	//     }
	//     return text;
	//   }
	//   isFactEmpty(f) {
	//     return !f.type && !f.date && !f.place && !f.value && !f.placeDetails;
	//   }
	//   getBirthdateFromEventAge(dateSort, age) {
	//     if (!dateSort || age === '' || age == null) {
	//       return '';
	//     }
	//     let y = parseInt(dateSort.substr(0,4),10);
	//     // handle n/12
	//     let months = age.replace(new RegExp('\\s+', 'g'), '');
	//     if (months.endsWith('/12')) {
	//       months = parseInt(months.substr(0, months.length - 3),10);
	//       if (isNaN(months)) {
	//         return '';
	//       }
	//       let m = parseInt(dateSort.substr(4,2),10);
	//       if (m > 0) {
	//         m -= months;
	//         if (m <= 0) {
	//           y -= 1;
	//           m += 12;
	//         }
	//         let mon = (m < 10) ? '0' + m.toString() : m.toString();
	//         return {
	//           date: this.translations['ABOUT'] + ' ' + this.months[m-1] + ' ' + y.toString(),
	//           dateSort: y.toString() + mon + '00'
	//         };
	//       }
	//       else {
	//         age = '0';
	//       }
	//     }
	//     let a = parseInt(age,10);
	//     if (isNaN(a)) {
	//       return '';
	//     }
	//     let year = y - a;
	//     return {
	//       date: this.translations['ABOUT'] + ' ' + year.toString(),
	//       dateSort: year.toString() + '0000|' + (year-1).toString() + '0000|' + (year+1).toString() + '0000'
	//     };
	//   }
	//   mergeFacts(facts) {
	//     return facts.reduce((f1, f2) => {
	//       let place, ps;
	//       if (!!f1.placeStandard && !!f2.placeStandard) {
	//         ps = this.getLongest(f1.placeStandard, f2.placeStandard);
	//         place = ps === f1.placeStandard ? f1.place : f2.place;
	//       }
	//       else if (!!f1.place) {
	//         ps = f1.placeStandard;
	//         place = f1.place;
	//       }
	//       else {
	//         ps = f2.placeStandard;
	//         place = f2.place;
	//       }
	//       let date, dateSort;
	//       if (!!f1.dateSort && !!f2.dateSort) {
	//         let f1ds = f1.dateSort.split('|');
	//         let f2ds = f2.dateSort.split('|');
	//         let chooseF1;
	//         if (f1ds.length === 3) { // range
	//           if (f2ds.length === 3) {
	//             chooseF1 = parseInt(this.getMaxDateSort(f1ds[2]), 10) - parseInt(f1ds[1], 10) < parseInt(this.getMaxDateSort(f2ds[2]), 10) - parseInt(f2ds[1], 10); // prefer smaller range
	//           }
	//           else if (f2ds.length === 2) {
	//             chooseF1 = false; // always prefer double over range
	//           }
	//           else {
	//             chooseF1 = parseInt(this.getMaxDateSort(f1ds[2]), 10) - parseInt(f1ds[1], 10) < parseInt(this.getMaxDateSort(f2ds[0]), 10) - parseInt(f2ds[0], 10); // prefer smaller range
	//           }
	//         }
	//         else if (f1ds.length === 2) { // double
	//           if (f2ds.length === 3) {
	//             chooseF1 = true; // always prefer double over range
	//           }
	//           else if (f2ds.length === 2) {
	//             chooseF1 = !f1ds[0].endsWith('00') || !f1ds[0].endsWith('00') || (f2ds[0].endsWith('00') && f2ds[1].endsWith('00')); // prefer more specific
	//           }
	//           else {
	//             chooseF1 = !f2ds[0].endsWith('00'); // prefer single over double unless it's unspecific
	//           }
	//         }
	//         else { // single
	//           if (f2ds.length === 3) {
	//             chooseF1 = parseInt(this.getMaxDateSort(f1ds[0]), 10) - parseInt(f1ds[0], 10) < parseInt(this.getMaxDateSort(f2ds[2]), 10) - parseInt(f2ds[1], 10); // prefer smaller range
	//           }
	//           else if (f2ds.length === 2) {
	//             chooseF1 = !f1ds[0].endsWith('00'); // prefer single over double unless it's unspecific
	//           }
	//           else {
	//             chooseF1 = parseInt(this.getMaxDateSort(f1ds[0]), 10) - parseInt(f1ds[0], 10) < parseInt(this.getMaxDateSort(f2ds[0]), 10) - parseInt(f2ds[0], 10); // prefer smaller range
	//           }
	//         }
	//         date = chooseF1 ? f1.date : f2.date;
	//         dateSort = chooseF1 ? f1.dateSort : f2.dateSort;
	//       }
	//       else if (!!f1.date) {
	//         date = f1.date;
	//         dateSort = f1.dateSort;
	//       }
	//       else {
	//         date = f2.date;
	//         dateSort = f2.dateSort;
	//       }
	//       return {
	//         type: f2.type,
	//         principal: f1.principal || f2.principal,
	//         principalId1: f1.principalId1 || f2.principalId1,
	//         principalId2: f1.principalId2 || f2.principalId2,
	//         value: this.getLongest(f1.value, f2.value),
	//         date: date,
	//         dateSort: dateSort,
	//         placeDetails: this.getLongest(f1.placeDetails, f2.placeDetails),
	//         place: place,
	//         placeStandard: ps,
	//         latitude: ps === f1.placeStandard ? f1.latitude : f2.latitude,
	//         longitude: ps === f1.placeStandard ? f1.longitude : f2.longitude,
	//         hidden: f1.hidden || f2.hidden,
	//         evidencePersonas: new Map([].concat((!!f1.evidencePersonas ? Array.from(f1.evidencePersonas.entries()) : []),
	//           (!!f2.evidencePersonas ? Array.from(f2.evidencePersonas.entries()) : [])))
	//       };
	//     }, {
	//       type: '',
	//       date: '',
	//       dateSort: '',
	//       place: '',
	//       placeStandard: '',
	//       value: '',
	//       principal: false,
	//       principalId1: 0,
	//       principalId2: 0,
	//       evidencePersonas: new Map()
	//     });
	//   }
	//   getLongest(s1, s2) {
	//     return !s1 && !!s2 ? s2 : !s2 && !!s1 ? s1 : !s1 && !s2 ? '' : s1.length >= s2.length ? s1 : s2;
	//   }
	//   yearDiff(ds2, ds1) {
	//     if (!ds2 || !ds2 || ds1.length < 4 || ds2.length < 4) {
	//       return NaN;
	//     }
	//     let y2 = parseInt(ds2.substr(0, 4), 10);
	//     let md2 = parseInt(ds2.substr(4), 10);
	//     let y1 = parseInt(ds1.substr(0, 4), 10);
	//     let md1 = parseInt(ds1.substr(4), 10);
	//     let diff = y2 - y1;
	//     if (md2 < md1) {
	//       diff--;
	//     }
	//     return diff;
	//   }
	//   fixURL(u) {
	//     if (!u) {
	//       return '';
	//     }
	//     let match = u.match(this.urlRE);
	//     if (match !== null && match[1] === undefined) {
	//       u = 'http://' + u;
	//     }
	//     return u;
	//   }
	//   isValidURL(url) {
	//     return !!this.parseURL(url);
	//     //if (!url) {
	//     //  return false;
	//     //}
	//     //if (url.indexOf('://') < 0) {
	//     //  url = 'http://' + url;
	//     //}
	//     //let pattern = /^(https?:)\/\/(-\.)?([^\s/?\.#-]+\.?)+(\/[^\s]*)?$/;
	//     ////let pattern = /^(?:https?:\/\/)?[^\s\/$.?#]\.[^\s]*$/;
	//     //return url.match(pattern) !== null && url.indexOf('.') >= 0;
	//   }
	//   parseURL(url) {
	//     if (!url) {
	//       return null;
	//     }
	//     if (url.indexOf('://') < 0) {
	//       url = 'http://' + url;
	//     }
	//     let match = url.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
	//     return url.indexOf(' ') >= 0 || !match || match[3].indexOf('.') < 0 ? null : {
	//         protocol: match[1],
	//         hostport: match[2],
	//         host: match[3],
	//         port: match[4],
	//         path: match[5],
	//         search: match[6],
	//         hash: match[7]
	//       };
	//   }
	//   getThumbURL(u) {
	//     return this.serverBase + '/thumbnail?url=' + encodeURIComponent(u) + '&token=' + this.authToken.get();
	//   }
	//   findGender(genders, genderValue) {
	//     if (!genderValue) {
	//       return null;
	//     }
	//     let initial = genderValue.toLowerCase().substr(0,1);
	//     return genders.find(g => g.value.toLowerCase().startsWith(initial));
	//   }
	//   encodeId(id) {
	//     if (!id) {
	//       return '';
	//     }
	//     let encoded = [];
	//     for (let i = 0; i < 11; i++) {
	//       encoded.push(this.idCoding.charAt(id % 32));
	//       id = Math.floor(id / 32);
	//       if (i === 3 || i === 7) {
	//         encoded.push('-');
	//       }
	//     }
	//     return encoded.reverse().join('');
	//   }
	//   decodeId(enc) {
	//     if (!enc) {
	//       return 0;
	//     }
	//     if (/^[0-9]+$/.test(enc)) {
	//       return +enc;
	//     }
	//     let id = 0;
	//     for (let i = 0; i < 13; i++) {
	//       if (i === 3 || i === 8) {
	//         continue;
	//       }
	//       id = id * 32 + this.idCoding.indexOf(enc.charAt(i));
	//     }
	//     return id;
	//   }
	//   first(m) {
	//     for (let [,v] of m) {
	//       return v || null;
	//     }
	//     return null;
	//   }
	//   firstKey(m) {
	//     for (let [k] of m) {
	//       return k || null;
	//     }
	//     return null;
	//   }
	//   formatCommas(n) {
	//     return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	//   }
	//   sortedIndex(arr, item, fn) {
	//     let low = 0,
	//       high = arr.length,
	//       value = fn(item);
	//     while (low < high) {
	//       let mid = (low + high) >>> 1; // jshint ignore:line
	//       if (fn(arr[mid]) < value) {
	//         low = mid + 1;
	//       }
	//       else {
	//         high = mid;
	//       }
	//     }
	//     return low;
	//   }
	//   toServer(value) {
	//     //if (angular.isArray(value)) {
	//     //  return value.map(v => this.toServer(v));
	//     //}
	//     if (value instanceof Map) {
	//       let o = {};
	//       for (let [k,v] of value) {
	//         o[k.toString()] = this.toServer(v);
	//       }
	//       return o;
	//     }
	//     if (angular.isObject(value)) {
	//       let o = {};
	//       Object.keys(value)
	//         .filter(k => !k.startsWith('_'))
	//         .forEach(k => {
	//           o[k] = this.toServer(value[k]);
	//         });
	//       return o;
	//     }
	//     return value;
	//   }
	//   fromServer(value) {
	//     if (angular.isObject(value)) {
	//       let o = {};
	//       for (let k in value) {
	//         let v = value[k];
	//         // int-valued maps
	//         if (['names', 'facts', 'evidencePersonas', 'personas', 'childRels', 'mediaIds', 'personIds', 'fileInfos', 'comments', 'likes', 'ordinances', 'columns', 'items'].includes(k) && !(v instanceof Map)) {
	//           let a = [];
	//           for (let mk in v) {
	//             a.push([parseInt(mk,10), this.fromServer(v[mk])]);
	//           }
	//           o[k] = new Map(a);
	//         }
	//         // string-valued maps
	//         else if (['tags', 'nameForms', 'externalIds', 'treeURLs'].includes(k) && !(v instanceof Map)) {
	//           let a = [];
	//           for (let mk in v) {
	//             a.push([mk, this.fromServer(v[mk])]);
	//           }
	//           o[k] = new Map(a);
	//         }
	//         else {
	//           o[k] = v; // this.fromServer(v);
	//         }
	//       }
	//       return o;
	//     }
	//     return value;
	//   }
	//   clone(obj) {
	//     let copy;
	//     // Handle the 3 simple types, and null or undefined
	//     if (!angular.isObject(obj)) {
	//       return obj;
	//     }
	//     // Handle Date
	//     if (obj instanceof Date) {
	//       copy = new Date();
	//       copy.setTime(obj.getTime());
	//       return copy;
	//     }
	//     // Handle Array
	//     if (angular.isArray(obj)) {
	//       copy = [];
	//       for (var i = 0, len = obj.length; i < len; i++) {
	//         copy[i] = this.clone(obj[i]);
	//       }
	//       return copy;
	//     }
	//     // handle Map
	//     if (obj instanceof Map) {
	//       copy = new Map();
	//       for (let [k,v] of obj) {
	//         copy.set(k, this.clone(v));
	//       }
	//       return copy;
	//     }
	//     // Handle Object
	//     copy = {};
	//     for (var attr in obj) {
	//       if (obj.hasOwnProperty(attr)) {
	//         copy[attr] = this.clone(obj[attr]);
	//       }
	//     }
	//     return copy;
	//   }
	//   getAhnentafelColor(treePrefs, ahnentafel, light) {
	//     let offset = 0;
	//     if (light) {
	//       offset += 2;
	//     }
	//     if (ahnentafel === this.colorNOT) {
	//       return this.colors[treePrefs['COLOR_NOT']][offset];
	//     }
	//     if (ahnentafel > this.colorOverrideBase) {
	//       return this.colors[treePrefs['COLOR_'+(ahnentafel-this.colorOverrideBase)]][offset];
	//     }
	//     if (ahnentafel < 16) {
	//       ahnentafel *= 16;
	//     }
	//     while (ahnentafel > 31) {
	//       ahnentafel = ahnentafel >>> 1; // jshint ignore:line
	//     }
	//     let base = Math.floor(ahnentafel/4);
	//     let baseColor;
	//     switch (base) {
	//       case 4:
	//         baseColor = 'COLOR_PGF';
	//         break;
	//       case 5:
	//         baseColor = 'COLOR_PGM';
	//         break;
	//       case 6:
	//         baseColor = 'COLOR_MGF';
	//         break;
	//       case 7:
	//         baseColor = 'COLOR_MGM';
	//         break;
	//     }
	//     offset += ahnentafel % 4;
	//     return this.colors[treePrefs[baseColor]][offset];
	//   }
	//   averageColor(colors, defColor) {
	//     if (colors.length === 0) {
	//       return defColor;
	//     } else if (colors.length === 1) {
	//       return colors[0];
	//     }
	//     // average color: sqrt(avg(...color^2))
	//     let red = 0;
	//     let green = 0;
	//     let blue = 0;
	//     colors.forEach(color => {
	//       let rgb = color.match(this.colorSegmentRE);
	//       let r = parseInt(rgb[0],16);
	//       red += r*r;
	//       let g = parseInt(rgb[1],16);
	//       green += g*g;
	//       let b = parseInt(rgb[2],16);
	//       blue += b*b;
	//     });
	//     red = Math.floor(Math.sqrt(red/colors.length));
	//     green = Math.floor(Math.sqrt(green/colors.length));
	//     blue = Math.floor(Math.sqrt(blue/colors.length));
	//     let r = red.toString(16);
	//     let g = green.toString(16);
	//     let b = blue.toString(16);
	//     return '#' + (r.length === 2 ? r : '0'+r) + (g.length === 2 ? g : '0'+g) + (b.length === 2 ? b : '0'+b);
	//   }
	//   createEvidenceFromFact(fact) {
	//     return {
	//       fact: {
	//         type: fact.type,
	//         value: fact.value,
	//         date: fact.date,
	//         dateSort: fact.dateSort,
	//         place: fact.place,
	//         placeDetails: fact.placeDetails,
	//         placeStandard: fact.placeStandard,
	//         latitude: fact.latitude,
	//         longitude: fact.longitude
	//       },
	//       mediaIds: new Map(),
	//       externalImageURL: '',
	//       text: '',
	//       citation: {
	//         sourceId: 0
	//       },
	//       personas: new Map([[1, {
	//         principal: true,
	//         relatedToKey: 0,
	//         names: new Map(),
	//         facts: new Map()
	//       }]])
	//     };
	//   }
	//   isHiddenEvidence(e) {
	//     if (!e._hasSource) {
	//       return true;
	//     }
	//     let url = !!e.citation.url && this.isValidURL(e.citation.url) ? this.parseURL(e.citation.url) : null;
	//     if (!!url && url.host.endsWith(FS) && (url.path.startsWith('/ark:/61903/4:1:') || url.path.startsWith('/tree/person/'))) {
	//       return true;
	//     }
	//     return false;
	//   }
	//   getCitation(source, url, page, date) {
	//     let citation = '';
	//     if (!source) {
	//       return citation;
	//     }
	//     if (!!source.bibCitation) {
	//       citation = source.bibCitation;
	//     }
	//     else {
	//       if (!!source.creator) {
	//         citation += this.escape(source.creator);
	//       }
	//       if (!!source.title || !!source.abbr) {
	//         if (!!citation) {
	//           citation += '. ';
	//         }
	//         citation += '<em>'+(this.escape(source.title || source.abbr))+'</em>';
	//       }
	//       if (!!source.subtitle) {
	//         citation += ': <em>'+this.escape(source.subtitle)+'</em>';
	//       }
	//       if (!!source.periodicalSeries) {
	//         citation += '. '+this.escape(source.periodicalSeries);
	//       }
	//       //if (!!source.numVolumes) {
	//       //  citation += '. '+source.numVolumes + ' Volumes';
	//       //}
	//       if (!!source.publisher || !!source.dateIssued || !!source.placeIssued) {
	//         citation += '. (';
	//         if (!!source.placeIssued) {
	//           citation += this.escape(source.placeIssued) + ': ';
	//         }
	//         if (!!source.publisher) {
	//           citation += this.escape(source.publisher);
	//         }
	//         if (!!source.dateIssued) {
	//           citation += ', '+this.escape(source.dateIssued);
	//         }
	//         citation += ')';
	//       }
	//       //if (!!source.volumeFilmPages) {
	//       //  citation += ', '+source.volumeFilmPages;
	//       //}
	//       if (!!source.repository) {
	//         citation += ', '+this.escape(source.repository);
	//       }
	//     }
	//     url = url || source.url;
	//     if (url) {
	//       let encoded = encodeURI(url);
	//       citation += ', <a href="'+encoded+'" target="_blank" class="link">'+this.escape(url)+'<i class="material-icons external-link-icon">open_in_new</i></a>';
	//     }
	//     if (!!page) {
	//       citation += ', '+this.escape(page);
	//     }
	//     if (!!date) {
	//       citation += ', '+this.escape(date);
	//     }
	//     return citation;
	//   }
	//   // persons is optional; if passed in, logs will be ordered so that logs associated with persons appear first
	//   getResearchLogTitles(logMap, persons) {
	//     let logs = Array.from(logMap.values()).map(log => {
	//       return {id: log.id, title: log.title, hasPeople: !!persons ? persons.some(p => log.personIds.has(p.id)) : false};
	//     });
	//     logs.sort((a,b) => {
	//       if (a.hasPeople === b.hasPeople) {
	//         return (a.title < b.title) ? -1 : (b.title < a.title) ? 1 : (a.id - b.id);
	//       }
	//       return (a.hasPeople && !b.hasPeople) ? -1 : 1;
	//     });
	//     return logs;
	//   }
	//   //
	//   // equal functions
	//   //
	//   noteEquals(n1, n2) {
	//     return (n1.title || '') === (n2.title || '') &&
	//       (n1.text || '') === (n2.text || '');
	//   }
	//   leadEquals(l1, l2) {
	//     return (l1.title || '') === (l2.title || '') &&
	//       (l1.url || '') === (l2.url || '') &&
	//       (l1.text || '') === (l2.text || '');
	//   }
	//   storyEquals(s1, s2) {
	//     return (s1.title || '') === (s2.title || '') &&
	//       (s1.text || '') === (s2.text || '');
	//   }
	//   evidenceSemiEquals(e1, e2) {
	//     return (e1.text || '') === (e2.text || '') &&
	//       ((!!e1.citation.url && e1.citation.url === e2.citation.url) ||
	//        (!!e1.citation.text && e1.citation.text === e2.citation.text) ||
	//        (!e1.citation.url && !e1.text && !!e1._sourceAbbr && e1._sourceAbbr === e2._sourceAbbr));
	//   }
	//   nameEquals(n1, n2) {
	//     if (!n1 || !n2) {
	//       return false;
	//     }
	//     if (!!n1.nameForms) {
	//       n1 = n1.nameForms.get('default') || Array.from(n1.nameForms.values())[0];
	//     }
	//     if (!!n2.nameForms) {
	//       n2 = n2.nameForms.get('default') || Array.from(n2.nameForms.values())[0];
	//     }
	//     return !!n1 && !!n2 &&
	//       (n1.given || '').toLowerCase() === (n2.given || '').toLowerCase() &&
	//       (n1.surname || '').toLowerCase() === (n2.surname || '').toLowerCase() &&
	//       (n1.prefix || '').toLowerCase() === (n2.prefix || '').toLowerCase() &&
	//       (n1.suffix || '').toLowerCase() === (n2.suffix || '').toLowerCase();
	//   }
	//   // use this to compare facts on type, date, and place only
	//   factTypeDatePlaceEquals(f1, f2) {
	//     return !!f1 && !!f2 &&
	//       (f1.type === f2.type ||
	//        (this.factTypes.some(ft => ft.value === f1.type) && this.factTypes.find(ft => ft.value === f1.type).display === f2.type) ||
	//        (this.factTypes.some(ft => ft.value === f2.type) && this.factTypes.find(ft => ft.value === f2.type).display === f1.type)) &&
	//       ((f1.date || '').toLowerCase() === (f2.date || '').toLowerCase() || (!!f1.dateSort && !!f2.dateSort && f1.dateSort === f2.dateSort)) &&
	//       ((f1.place || '').toLowerCase() === (f2.place || '').toLowerCase() || (!!f1.placeStandard && !!f2.placeStandard && f1.placeStandard === f2.placeStandard));
	//   }
	//   // don't use this to compare facts on evidences because evidence facts don't have principals
	//   factEquals(f1, f2, ignorePrincipalId) {
	//     return this.factTypeDatePlaceEquals(f1, f2) &&
	//       (f1.placeDetails || '') === (f2.placeDetails || '') &&
	//       (f1.value || '') === (f2.value || '') &&
	//       (f1.principal === f2.principal) &&
	//       ((f1.principalId1 || '') === (f2.principalId1 || '') || ignorePrincipalId) &&
	//       ((f1.principalId2 || '') === (f2.principalId2 || '') || ignorePrincipalId);
	//   }
	//   factCompatible(f1, f2, ignorePrincipal) {
	//     if (f1.type !== f2.type ||
	//       (f1.principal !== f2.principal && !ignorePrincipal) ||
	//       (f1.principalId1 !== f2.principalId1 && !ignorePrincipal) ||
	//       (f1.principalId2 !== f2.principalId2 && !ignorePrincipal) ||
	//       (!!f1.value && !!f2.value && f1.value.toLowerCase().indexOf(f2.value.toLowerCase()) === -1 && f2.value.toLowerCase().indexOf(f1.value.toLowerCase()) === -1) ||
	//       (!!f1.placeDetails && !!f2.placeDetails && f1.placeDetails.toLowerCase().indexOf(f2.placeDetails.toLowerCase()) === -1 && f2.placeDetails.toLowerCase().indexOf(f1.placeDetails.toLowerCase()) === -1) ||
	//       (!!f1.placeStandard && !!f2.placeStandard && !f1.placeStandard.endsWith(f2.placeStandard) && !f2.placeStandard.endsWith(f1.placeStandard)) ||
	//       (!!f1.place && !!f2.place && f1.place !== f2.place && (!f1.placeStandard || !f2.placeStandard)) ||
	//       (!!f1.date && !!f2.date && f2.date !== f1.date && (!f1.dateSort || !f2.dateSort))) {
	//       return false;
	//     }
	//     // now check for date compatibility
	//     if (!!f1.dateSort && !!f2.dateSort) {
	//       let f1ds = f1.dateSort.split('|');
	//       let f2ds = f2.dateSort.split('|');
	//       if (f1ds.length === 3) { // range
	//         if (f2ds.length === 3) {
	//           return (this.dateSortInRange(f2ds[1], f1ds[1], f1ds[2]) && this.dateSortInRange(f2ds[2], f1ds[1], f1ds[2])) ||
	//             (this.dateSortInRange(f1ds[1], f2ds[1], f2ds[2]) && this.dateSortInRange(f1ds[2], f2ds[1], f2ds[2])); // one range is a subrange of the other
	//         }
	//         else if (f2ds.length === 2) {
	//           return this.dateSortInRange(f2ds[0], f1ds[1], f1ds[2]) || this.dateSortInRange(f2ds[1], f1ds[1], f1ds[2]); // one date is in the range
	//         }
	//         else {
	//           return this.dateSortInRange(f2ds[0], f1ds[1], f1ds[2]);
	//         }
	//       }
	//       else if (f1ds.length === 2) { // double
	//         if (f2ds.length === 3) {
	//           return this.dateSortInRange(f1ds[0], f2ds[1], f2ds[2]) || this.dateSortInRange(f1ds[1], f2ds[1], f2ds[2]); // one date is in range
	//         }
	//         else if (f2ds.length === 2) {
	//           return (this.dateSortCompatible(f1ds[0], f2ds[0]) || this.dateSortCompatible(f1ds[0], f2ds[1])) &&
	//             (this.dateSortCompatible(f1ds[1], f2ds[0]) || this.dateSortCompatible(f1ds[1], f2ds[1])); // both dates compatible
	//         }
	//         else {
	//           return this.dateSortCompatible(f1ds[0], f2ds[0]) || this.dateSortCompatible(f1ds[1], f2ds[0]); // date compatible
	//         }
	//       }
	//       else { // single
	//         if (f2ds.length === 3) {
	//           return this.dateSortInRange(f1ds[0], f2ds[1], f2ds[2]) ||
	//             (this.dateSortInRange(f2ds[1], f1ds[0], this.getMaxDateSort(f1ds[0])) && this.dateSortInRange(f2ds[2], f1ds[0], this.getMaxDateSort(f1ds[0])));
	//         }
	//         else if (f2ds.length === 2) {
	//           return this.dateSortCompatible(f1ds[0], f2ds[0]) || this.dateSortCompatible(f1ds[0], f2ds[1]); // date compatible
	//         }
	//         else {
	//           return this.dateSortCompatible(f1ds[0], f2ds[0]);
	//         }
	//       }
	//     }
	//     return true;
	//   }
	//   dateSortInRange(ds, drmin, drmax) {
	//     return ds >= drmin && ds <= this.getMaxDateSort(drmax);
	//   }
	//   dateSortCompatible(ds1, ds2) {
	//     return (ds1 >= ds2 && ds1 <= this.getMaxDateSort(ds2)) || (ds2 >= ds1 && ds2 <= this.getMaxDateSort(ds1));
	//   }
	//   getMaxDateSort(ds) {
	//     return ds.endsWith('0000') ? ds.substr(0,4)+'1231' : ds.endsWith('00') ? ds.substr(0,6)+'31' : ds;
	//   }
	//   //
	//   // augmentation functions
	//   //
	//   addCreateEditDates(o) {
	//     if (o.createdDate > 0) {
	//       o._createdDate = (new Date(o.createdDate*1000)).toDateString();
	//     }
	//     if (o.editedDate > 0) {
	//       o._editedDate = (new Date(o.editedDate*1000)).toDateString();
	//     }
	//     return o;
	//   }
	//   addCreateEditUsers(o, users) {
	//     let subject = new this.rx.AsyncSubject();
	//     let waitCount = (o.createdUser > 0 ? 1 : 0) + (o.editedUser > 0 ? 1 : 0);
	//     if (waitCount === 0) {
	//       subject.next(o);
	//       subject.complete();
	//     }
	//     if (o.createdUser > 0) {
	//       users.streamSummaryId(o.createdUser).take(1).subscribe(u => {
	//         o._createdUser = u;
	//         if (--waitCount === 0) {
	//           subject.next(o);
	//           subject.complete();
	//         }
	//       });
	//     }
	//     if (o.editedUser > 0) {
	//       users.streamSummaryId(o.editedUser).take(1).subscribe(u => {
	//         o._editedUser = u;
	//         if (--waitCount === 0) {
	//           subject.next(o);
	//           subject.complete();
	//         }
	//       });
	//     }
	//     return subject;
	//   }
	//   //
	//   // common config functions
	//   //
	//   atConfigUser(users, rights, currentTreeId) {
	//     return {
	//       at: '@',
	//         callbacks: {
	//           remoteFilter: (query, callback) => {
	//             users.nameAutocomplete(rights, query).then(results => {
	//               callback(results.map(u => {
	//                 return {
	//                   id: u.id,
	//                   name: this.escape(u.name),
	//                   fullName: this.escape((u.given + ' ' + u.surname).trim())
	//                 };
	//               }));
	//             });
	//           },
	//           sorter: function(query, items) {
	//             return items.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
	//           },
	//           highlighter: function(li, query) {
	//             if (!query) {
	//               return li;
	//             }
	//             return li.replace(new RegExp('<li>([^<]*?)(' + query + ')([^<]*)<', 'iu'), (str, bef, match, aft) => '<li>'+bef+'<strong>' + match + '</strong>'+aft+'<');
	//           }
	//         },
	//       displayTpl: '<li data-id="${id}">${name} <small>${fullName}</small></li>',
	//       insertTpl: '<a href="'+currentTreeId.getBaseURL()+'/users/${id}" class="link">${atwho-at}${name}</a>',
	//       limit: 10,
	//       maxLen: 20
	//     };
	//   }
	//   expandMentions(currentTreeIdService, allUsers, text) {
	//     if (!text) {
	//       return '';
	//     }
	//     return text.replace(this.mentionRegex, (match, name) => {
	//       let user = allUsers.find(user => user.name === name);
	//       if (!user) {
	//         return match;
	//       }
	//       return '<a href="'+currentTreeIdService.getBaseURL()+'/users/'+user.id+'" class="link">@'+this.escape(user.name)+'</a>';
	//     });
	//   }
	//   tagify(given, surname) {
	//     return (!!given ? given.split(' ')[0] : '') + (!!surname ? surname.replace(' ','') : '');
	//   }
	//   froalaOptions(atConfig, focusFn, atWhoCallback, enterCallback) {
	//     return {
	//       events : {
	//         'froalaEditor.initialized' : (e, editor) => {
	//           if (!atConfig) {
	//             return;
	//           }
	//           editor.$el.atwho(atConfig);
	//           editor.events.on('keydown', (e) => {
	//             if (e.which === 13 && editor.$el.atwho('isSelecting')) {
	//               return false;
	//             }
	//             if (e.which === 13 && !!enterCallback) {
	//               if (!enterCallback(editor.html.get())) {
	//                 e.preventDefault();
	//                 return false;
	//               }
	//             }
	//           }, true);
	//           editor.$el.on("inserted.atwho", (event, $li) => {
	//             if (!!atWhoCallback) {
	//               atWhoCallback(parseInt($li.attr('data-id'), 10));
	//             }
	//           });
	//         },
	//         'froalaEditor.focus' : focusFn
	//       }
	//     };
	//   }
	//   //
	//   // translations
	//   //
	//   _getTranslations() {
	//     let translations = {};
	//     [
	//       'SUPPORTING_EVIDENCE',
	//       'ABOUT'
	//     ].forEach(v => {
	//         this.$translate(v).then(display => {
	//           translations[v] = display;
	//         });
	//       });
	//     return translations;
	//   }
	//   //
	//   // mutex
	//   //
	//   _mutexDequeue(self) {
	//     self.busy = true;
	//     let next = self.queue.shift();
	//     if (!!next) {
	//       this._mutexExecute(self, next);
	//     }
	//     else {
	//       self.busy = false;
	//     }
	//   }
	//   _mutexExecute(self, next) {
	//     next().subscribe(() => {
	//       this._mutexDequeue(self);
	//     }, () => {
	//       this._mutexDequeue(self);
	//     });
	//   }
	//   createMutex() {
	//     let self = {
	//       busy: false,
	//       queue: []
	//     };
	//     return (fn) => {
	//       self.queue.push(fn);
	//       if (!self.busy) {
	//         this._mutexDequeue(self);
	//       }
	//     };
	//   }
	//   // takes a function that returns a single-result observable
	//   syncMutex(mutex, fn) {
	//     let stream = new this.rx.AsyncSubject();
	//     mutex(() => {
	//       return fn().do(x => {
	//         stream.next(x);
	//         stream.complete();
	//       }, err => {
	//         stream.error(err);
	//       });
	//     });
	//     return stream;
	//   }
	//   //
	//   // array functions
	//   //
	//   arrayGroupBy(arr, key) {
	//     return arr.reduce((rv, x) => {
	//       let v = key instanceof Function ? key(x) : x[key];
	//       let el = rv.find((r) => r && r.key === v);
	//       if (el) {
	//         el.values.push(x);
	//       }
	//       else {
	//         rv.push({ key: v, values: [x] });
	//       }
	//       return rv;
	//     }, []);
	//   }
	//   arraysEqual(a, b) {
	//     if (a === b) {
	//       return true;
	//     }
	//     if (a == null || b == null) {
	//       return false;
	//     }
	//     if (a.length !== b.length) {
	//       return false;
	//     }
	//     for (let i = 0; i < a.length; i++) {
	//       if (b.indexOf(a[i]) < 0) {
	//         return false;
	//       }
	//     }
	//     return true;
	//   }
	//   //
	//   // map functions
	//   //
	//   mapsEqual(a, b) {
	//     if (a === b) {
	//       return true;
	//     }
	//     if (a == null || b == null) {
	//       return false;
	//     }
	//     if (a.size !== b.size) {
	//       return false;
	//     }
	//     for (let [key, value] of a) {
	//       if (!b.has(key) || b.get(key) !== value) {
	//         return false;
	//       }
	//     }
	//     return true;
	//   }
	//   //
	//   // string functions
	//   //
	//   escape(text, keepSomeFormatting) {
	//     if (!text) {
	//       return '';
	//     }
	//     text = text.replace(/[&<>"']/g, r => this.reverseEntities[r]);
	//     if (keepSomeFormatting) {
	//       text = text.replace(/&lt;(\/?)i&gt;/g, '<$1i>').replace(/\n/g, '<br>');
	//     }
	//     return text;
	//   }
	//   removeHtml(text, max = 0) {
	//     text = !!text ? String(text) : '';
	//     text = text.replace(/<[^>]+>/gm, '');
	//     text = text.replace(/&(amp|lt|gt|quot|apos|#39|nbsp|zwj);/gm, r => this.entities[r]);
	//     if (max > 0 && text.length > max) {
	//       text = text.substr(0, max-3) + '...';
	//     }
	//     return text;
	//   }
	//   normalize(s) {
	//     return this.removeDiacritics(s).toLowerCase().replace(/['`ʹʻʼʿ’′]/g, '').replace(/\s+/g, ' ').trim();
	//   }
	//   capitalizeFirstLetter(s) {
	//     if (!s) {
	//       return '';
	//     }
	//     return s.charAt(0).toUpperCase() + s.slice(1);
	//   }
	//   truncate(s, max) {
	//     if (s.length < max) {
	//       return s;
	//     }
	//     //let pos = s.lastIndexOf(' ');
	//     //if (pos <= 0) {
	//     //  pos = s.length;
	//     //}
	//     return s.substr(0, max)+ '...';
	//   }
	//   cleanPDF(text) {
	//     return text.replace(this.pdfRegExp, r => this.pdfReplacements[r]);
	//   }
	//   toTitleCase(s) {
	//     return s.replace(/\b\w+/g,function(s){return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();});
	//   }
	//   //
	//   // types
	//   //
	//   _getFactTypes() {
	//     return [
	//       {value: 'ADDR'},
	//       {value: 'ADOP', icon: 'birth'},
	//       {value: '_AFIL'},
	//       {value: '_AGE', fact: true},
	//       {value: 'AFN', fact: true},
	//       {value: 'ANUL', spouse: true},
	//       {value: 'ARVL', icon: 'immigration'},
	//       {value: 'BAPM', icon: 'church'},
	//       {value: 'BARM', icon: 'jewish'},
	//       {value: 'BATM', icon: 'jewish'},
	//       {value: '_BIO', fact: true},
	//       {value: 'BIRT', common: true, parents: true, icon: 'birth'},
	//       {value: 'BLES'},
	//       {value: 'BURI', common: true, icon: 'death'},
	//       {value: 'CAST', fact: true},
	//       {value: 'CAUS', fact: true},
	//       {value: 'CHR', common: true, parents: true, icon: 'christian'},
	//       {value: '_CIVL', spouse: true},
	//       {value: '_CLAN', fact: true},
	//       {value: 'CLAW', spouse: true, icon: 'marriage'},
	//       {value: 'CONF', icon: 'church'},
	//       {value: 'CREM', icon: 'death'},
	//       {value: 'DEAT', common: true, icon: 'death'},
	//       {value: '_DEG', icon: 'education'},
	//       {value: 'DPRT', icon: 'immigration'},
	//       {value: 'DSCR', fact: true},
	//       {value: 'DIV', common: true, spouse: true, icon: 'divorce'},
	//       {value: 'DIVF', spouse: true, icon: 'divorce'},
	//       {value: 'EDUC', icon: 'education'},
	//       {value: '_EIGHT', fact: true},
	//       {value: '_ELEC'},
	//       {value: 'EMAIL', fact: true},
	//       {value: 'EMIG', common: true, icon: 'immigration', family: true},
	//       {value: 'EMPL'},
	//       {value: 'ENG', spouse: true, icon: 'marriage'},
	//       {value: '_ETHN', fact: true},
	//       {value: 'EXCM'},
	//       {value: '_FSFTID', fact: true},
	//       {value: 'FCOM'},
	//       {value: '_FUN'},
	//       {value: 'GRAD', icon: 'education'},
	//       {value: 'ILL'},
	//       {value: 'IMMI', common: true, icon: 'immigration', family: true},
	//       {value: '_MSTAT', fact: true, icon: 'marriage'},
	//       {value: 'MARB', spouse: true, icon: 'marriage'},
	//       {value: 'MARC', spouse: true, icon: 'marriage'},
	//       {value: 'MARL', spouse: true, icon: 'marriage'},
	//       {value: 'MARR', common: true, spouse: true, icon: 'marriage'},
	//       {value: 'MARS', spouse: true, icon: 'marriage'},
	//       {value: '_MBON', spouse: true, icon: 'marriage'},
	//       {value: '_MDCL'},
	//       {value: '_MILT', common: true, icon: 'military'}, // or military-award?
	//       {value: '_MISN'},
	//       {value: '_MOVE', icon: 'immigration', family: true},
	//       {value: 'NAME', common: true, nopersona: true, icon: 'name'},
	//       {value: '_NAMS'},
	//       {value: '_NID', fact: true},
	//       {value: 'NATI', fact: true},
	//       {value: 'NATU'},
	//       {value: '_NEWS', icon: 'publication'},
	//       {value: 'NCHI', fact: true},
	//       {value: '_OBIT'},
	//       {value: 'OCCU', common: true, icon: 'occupation'},
	//       {value: 'ORDN'},
	//       {value: 'PHON'},
	//       {value: 'PROB', common: true, icon: 'legal'},
	//       {value: 'PROP', icon: 'deed-document'},
	//       {value: '_RACE', fact: true},
	//       {value: 'REFN', fact: true},
	//       {value: 'RELI', common: true, icon: 'church', family: true},
	//       {value: 'RESI', common: true, icon: 'residence', family: true},
	//       {value: 'RETI'},
	//       {value: '_SEPR', spouse: true},
	//       {value: 'SEX'},
	//       {value: 'SOUR', common: true, nopersona: true},
	//       {value: 'SSN', fact: true},
	//       {value: '_STIL', parents: true, icon: 'death'},
	//       {value: '_TITL', fact: true},
	//       {value: '_TRIB', fact: true},
	//       {value: 'WILL', common: true, icon: 'legal'}
	//     ].map(v => {
	//         this.$translate(v.value).then(display => {
	//           v.display = display;
	//         });
	//         return v;
	//       });
	//   }
	//   _getNameTypes() {
	//     return [
	//       '',
	//       'NICK',
	//       '_MARNM',
	//       'ALIA',
	//       '_VARN',
	//       '_OTHN',
	//       '_BIRTNM',
	//       '_MAID',
	//       '_PATR',
	//       'TITL'
	//     ].map(v => {
	//         let o = {value: v};
	//         this.$translate(v || 'NAME').then(display => {
	//           o.display = display;
	//         });
	//         return o;
	//       });
	//   }
	//   _getGenders() {
	//     return [
	//       'MALE',
	//       'FEMALE',
	//       'UNKNOWN'
	//     ].map(v => {
	//         let o = {value: v};
	//         this.$translate(v).then(display => {
	//           o.display = display;
	//         });
	//         return o;
	//       });
	//   }
	//   _getRelationshipTypes() {
	//     return [
	//       'CHILD', 'FATHER', 'MOTHER', 'SPOUSE', 'PARENT', 'ADOPTIVE_PARENT', 'STEP_PARENT', 'OTHER'
	//     ].map(v => {
	//         let o = {value: v};
	//         this.$translate(v).then(display => {
	//           o.display = display;
	//         });
	//         return o;
	//       });
	//   }
	//   _getParentRelTypes() {
	//     return [
	//       'ADOPTIVE_PARENT',
	//       'BIOLOGICAL_PARENT',
	//       'FAMILY_MEMBER',
	//       'FOSTER_PARENT',
	//       'GUARDIAN',
	//       'RELATED',
	//       'STEP_PARENT',
	//       'SLAVE_OWNER',
	//       'UNKNOWN'
	//     ].map(v => {
	//         let o = {value: v};
	//         this.$translate(v).then(display => {
	//           o.display = display;
	//         });
	//         return o;
	//       });
	//   }
	//   /*
	//    Licensed under the Apache License, Version 2.0 (the "License");
	//    you may not use this file except in compliance with the License.
	//    You may obtain a copy of the License at
	//    http://www.apache.org/licenses/LICENSE-2.0
	//    Unless required by applicable law or agreed to in writing, software
	//    distributed under the License is distributed on an "AS IS" BASIS,
	//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	//    See the License for the specific language governing permissions and
	//    limitations under the License.
	//    */
	//   removeDiacritics(str) {
	//     return str.replace(/[^\u0000-\u007E]/g, a => {
	//       return this.diacriticsMap[a] || a;
	//     });
	//   }
	//   _generateDiacriticsMap() {
	//     let defaultDiacriticsRemovalMap = [
	//       {'base':'A', 'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
	//       {'base':'AA','letters':'\uA732'},
	//       {'base':'AE','letters':'\u00C6\u01FC\u01E2'},
	//       {'base':'AO','letters':'\uA734'},
	//       {'base':'AU','letters':'\uA736'},
	//       {'base':'AV','letters':'\uA738\uA73A'},
	//       {'base':'AY','letters':'\uA73C'},
	//       {'base':'B', 'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
	//       {'base':'C', 'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
	//       {'base':'D', 'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
	//       {'base':'DZ','letters':'\u01F1\u01C4'},
	//       {'base':'Dz','letters':'\u01F2\u01C5'},
	//       {'base':'E', 'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
	//       {'base':'F', 'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
	//       {'base':'G', 'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
	//       {'base':'H', 'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
	//       {'base':'I', 'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
	//       {'base':'J', 'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
	//       {'base':'K', 'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
	//       {'base':'L', 'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
	//       {'base':'LJ','letters':'\u01C7'},
	//       {'base':'Lj','letters':'\u01C8'},
	//       {'base':'M', 'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
	//       {'base':'N', 'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
	//       {'base':'NJ','letters':'\u01CA'},
	//       {'base':'Nj','letters':'\u01CB'},
	//       {'base':'O', 'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
	//       {'base':'OI','letters':'\u01A2'},
	//       {'base':'OO','letters':'\uA74E'},
	//       {'base':'OU','letters':'\u0222'},
	//       {'base':'OE','letters':'\u008C\u0152'},
	//       {'base':'oe','letters':'\u009C\u0153'},
	//       {'base':'P', 'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
	//       {'base':'Q', 'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
	//       {'base':'R', 'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
	//       {'base':'S', 'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
	//       {'base':'T', 'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
	//       {'base':'TZ','letters':'\uA728'},
	//       {'base':'U', 'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
	//       {'base':'V', 'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
	//       {'base':'VY','letters':'\uA760'},
	//       {'base':'W', 'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
	//       {'base':'X', 'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
	//       {'base':'Y', 'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
	//       {'base':'Z', 'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
	//       {'base':'a', 'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
	//       {'base':'aa','letters':'\uA733'},
	//       {'base':'ae','letters':'\u00E6\u01FD\u01E3'},
	//       {'base':'ao','letters':'\uA735'},
	//       {'base':'au','letters':'\uA737'},
	//       {'base':'av','letters':'\uA739\uA73B'},
	//       {'base':'ay','letters':'\uA73D'},
	//       {'base':'b', 'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
	//       {'base':'c', 'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
	//       {'base':'d', 'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
	//       {'base':'dz','letters':'\u01F3\u01C6'},
	//       {'base':'e', 'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
	//       {'base':'f', 'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
	//       {'base':'g', 'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
	//       {'base':'h', 'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
	//       {'base':'hv','letters':'\u0195'},
	//       {'base':'i', 'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
	//       {'base':'j', 'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
	//       {'base':'k', 'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
	//       {'base':'l', 'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
	//       {'base':'lj','letters':'\u01C9'},
	//       {'base':'m', 'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
	//       {'base':'n', 'letters':'\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
	//       {'base':'nj','letters':'\u01CC'},
	//       {'base':'o', 'letters':'\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
	//       {'base':'oi','letters':'\u01A3'},
	//       {'base':'ou','letters':'\u0223'},
	//       {'base':'oo','letters':'\uA74F'},
	//       {'base':'p','letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
	//       {'base':'q','letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
	//       {'base':'r','letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
	//       {'base':'s','letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
	//       {'base':'ss','letters':'\u00DF'},
	//       {'base':'t','letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
	//       {'base':'tz','letters':'\uA729'},
	//       {'base':'u','letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
	//       {'base':'v','letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
	//       {'base':'vy','letters':'\uA761'},
	//       {'base':'w','letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
	//       {'base':'x','letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
	//       {'base':'y','letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
	//       {'base':'z','letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
	//     ];
	//     var diacriticsMap = {};
	//     for (var i=0; i < defaultDiacriticsRemovalMap.length; i++){
	//       var letters = defaultDiacriticsRemovalMap[i].letters;
	//       for (var j=0; j < letters.length ; j++){
	//         diacriticsMap[letters[j]] = defaultDiacriticsRemovalMap[i].base;
	//       }
	//     }
	//     return diacriticsMap;
	//   }
	// }
	// export default UtilsService;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2015
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var FS = 'familysearch.org';
	var UtilsService = /** @class */ (function () {
	    function UtilsService(mdDialog, document, translate, timeout, window, rx, Upload, currentTreeId, serverBase, authToken, angularUtils) {
	        this.mdDialog = mdDialog;
	        this.document = document;
	        this.translate = translate;
	        this.timeout = timeout;
	        this.window = window;
	        this.rx = rx;
	        this.Upload = Upload;
	        this.currentTreeId = currentTreeId;
	        this.serverBase = serverBase;
	        this.authToken = authToken;
	        this.angularUtils = angularUtils;
	        this.mdDialog = mdDialog;
	        this.document = document;
	        this.translate = translate;
	        this.timeout = timeout;
	        this.window = window;
	        this.rx = rx;
	        this.Upload = Upload;
	        this.currentTreeId = currentTreeId;
	        this.serverBase = serverBase;
	        this.authToken = authToken;
	        this.diacriticsMap = this._generateDiacriticsMap();
	        this.numRE = /^[0-9]+$/;
	        this.urlRE = /^((?:https?|ftp):\/\/)?[^\s\/$.?#].[^\s]*$/;
	        this.idCoding = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
	        this.mentionRegex = new RegExp('@([-A-Za-z0-9_]+)(?![-A-Za-z0-9_"<])', 'g');
	        this.translations = this._getTranslations();
	        this.factTypes = this._getFactTypes();
	        this.nameTypes = this._getNameTypes();
	        this.relationshipTypes = this._getRelationshipTypes();
	        this.genders = this._getGenders();
	        this.parentRelTypes = this._getParentRelTypes();
	        this.vitalTypes = ['BIRT', 'CHR', 'DEAT', 'BURI'];
	        this.entities = {
	            '&amp;': '&',
	            '&lt;': '<',
	            '&gt;': '>',
	            '&quot;': '"',
	            '&#39;': '\'',
	            '&apos;': '\'',
	            '&nbsp;': ' ',
	            '&zwj;': ''
	        };
	        this.reverseEntities = {
	            '&': '&amp;',
	            '<': '&lt;',
	            '>': '&gt;',
	            '"': '&quot;',
	            '\'': '&#39;'
	        };
	        this.pdfReplacements = {
	            'Ł': 'L',
	            'ł': 'l'
	        };
	        this.pdfRegExp = new RegExp('[' + Object.keys(this.pdfReplacements).join('') + ']', 'g');
	        this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	        this.ahnentafelColorsLight = [
	            '#FFFFFF',
	            '#e2e2e2',
	            '#e2e2e2',
	            '#e2e2e2',
	            '#66a4d6',
	            '#9174b4',
	            '#d4767f',
	            '#ede657',
	            '#66a4d6',
	            '#9cceef',
	            '#9174b4',
	            '#a571a2',
	            '#d4767f',
	            '#e4a5a3',
	            '#ede657',
	            '#f1e798',
	            '#66a4d6',
	            '#7db7d8',
	            '#9cceef',
	            '#bcdfea',
	            '#9174b4',
	            '#ab90c3',
	            '#a571a2',
	            '#cb9ac6',
	            '#d4767f',
	            '#ca8989',
	            '#e4a5a3',
	            '#f5d2d0',
	            '#ede657',
	            '#fbf17e',
	            '#f1e798',
	            '#f9f1ad'
	        ];
	        this.ahnentafelColorsDark = [
	            '#FFFFFF',
	            '#547f41',
	            '#416f7f',
	            '#e5bf21',
	            '#416f7f',
	            '#5b4580',
	            '#c1306b',
	            '#e5bf21',
	            '#416f7f',
	            '#5fb2b0',
	            '#5b4580',
	            '#8e7fb9',
	            '#c1306b',
	            '#db868a',
	            '#e5bf21',
	            '#fee655',
	            '#416f7f',
	            '#5b99a3',
	            '#5fb2b0',
	            '#7acbdd',
	            '#5b4580',
	            '#6e589b',
	            '#8e7fb9',
	            '#a396c8',
	            '#c1306b',
	            '#d65083',
	            '#db868a',
	            '#f3b8b8',
	            '#e5bf21',
	            '#efde3f',
	            '#fee655',
	            '#feea89'
	        ];
	        this.colorNOT = 99999;
	        this.colorOverrideBase = 99990;
	        this.colorMultiplier = 100000;
	        this.colors = {
	            'blue': ['#2177b5', '#428fc6', '#6ba9d6', '#9ec5e1', '#c6deef', '#eff8ff'],
	            'purple': ['#7551a3', '#977dba', '#ae9ac8', '#cabcdc', '#e1daeb', '#f3f0f7'],
	            'magenta': ['#b8398d', '#d459ab', '#e077bd', '#ed9ad1', '#f5bfe3', '#fce6f5'],
	            'red': ['#cb1818', '#ef2c2c', '#fb4a4a', '#fc7272', '#fca1a1', '#fed9d9'],
	            'orange': ['#d96d01', '#f18213', '#fd9d3c', '#fdb46b', '#fdd0a2', '#feeede'],
	            'yellow': ['#d6d600', '#e0e009', '#ebeb1c', '#ffff33', '#ffff99', '#ffffcc'],
	            //'avocado': ['#b3b317', '#cfcf30', '#e0e05e', '#ebeb83', '#f2f2b1', '#fcfce3'],
	            'green': ['#238b23', '#41ab41', '#74c474', '#9bd99b', '#c0e9c0', '#e9f8e9'],
	            'aquamarine': ['#239670', '#40b396', '#73c9b4', '#9adbcb', '#c0ebe0', '#ebfaf6'],
	            'aqua': ['#23a1a1', '#40b8b8', '#70cccc', '#9bdede', '#c2eded', '#edfcfc'],
	            'grey': ['#888888', '#999999', '#aaaaaa', '#bbbbbb', '#cccccc', '#dddddd'],
	            'black': ['#222222', '#333333', '#444444', '#555555', '#666666', '#777777']
	            // 'white': ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff']
	        };
	        this.colorSegmentRE = /[0-9a-f]{2}/gi;
	    }
	    //
	    // UI functions
	    //
	    UtilsService.prototype.dialog = function (ev, ctrl, template, easyClose, locals) { };
	    UtilsService.prototype.dialogCancel = function () { };
	    UtilsService.prototype.alert = function (title, content, evt, ok) { };
	    UtilsService.prototype.confirm = function (title, content, ev, ok, cancel) { };
	    UtilsService.prototype.prompt = function (title, content, placeholder, value, ev, ok, cancel) { };
	    UtilsService.prototype.pleaseWait = function (immediate) { };
	    UtilsService.prototype.pleaseWaitCancel = function (pw) { };
	    UtilsService.prototype.showSidenav = function (state) { };
	    UtilsService.prototype.toggleExpand = function (item) {
	        item._isExpanded = !item._isExpanded;
	    };
	    UtilsService.prototype.toggleExpandAll = function (c) {
	        var anyExpanded = this.anyExpanded(c);
	        try {
	            for (var c_1 = __values(c), c_1_1 = c_1.next(); !c_1_1.done; c_1_1 = c_1.next()) {
	                var i = c_1_1.value;
	                i._isExpanded = !anyExpanded;
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (c_1_1 && !c_1_1.done && (_a = c_1.return)) _a.call(c_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        var e_1, _a;
	    };
	    UtilsService.prototype.anyExpanded = function (c) {
	        return c.some(function (i) { return i._isExpanded; });
	    };
	    UtilsService.prototype.asArray = function (n) {
	        var a = [];
	        for (var i = 0; i < n; i++) {
	            a.push(i);
	        }
	        return a;
	    };
	    UtilsService.prototype.showEvidence = function (ev, evidences, sources, persons, users, evidenceUtils, id) { };
	    UtilsService.prototype.showSource = function (ev, sources, evidences, users, id) { };
	    UtilsService.prototype.showStory = function (ev, stories, persons, users, id) { };
	    UtilsService.prototype.getTagColorMap = function (tree) {
	        var m = new Map();
	        for (var i = 1; i <= 6; i++) {
	            m.set(tree.preferences['COLOR_LABEL_' + i], tree.preferences['COLOR_' + i]);
	        }
	        return m;
	    };
	    UtilsService.prototype.getTagColor = function (tagColorMap, tags) {
	        if (!!tagColorMap && !!tags) {
	            try {
	                for (var _a = __values(tags.keys()), _b = _a.next(); !_b.done; _b = _a.next()) {
	                    var tag = _b.value;
	                    if (tagColorMap.has(tag)) {
	                        return tagColorMap.get(tag);
	                    }
	                }
	            }
	            catch (e_2_1) { e_2 = { error: e_2_1 }; }
	            finally {
	                try {
	                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
	                }
	                finally { if (e_2) throw e_2.error; }
	            }
	        }
	        return '';
	        var e_2, _c;
	    };
	    //
	    // stream functions
	    //
	    UtilsService.prototype.pipe = function (src, dest, includeErrors) {
	        return src.subscribe(function (x) {
	            dest.next(x);
	        }, function (err) {
	            if (includeErrors) {
	                dest.error(err);
	            }
	        });
	    };
	    UtilsService.prototype.teeAsync = function (stream) {
	        var t = new this.rx.AsyncSubject();
	        return [stream.do(function (x) { return t.next(x); }, function (err) { return t.error(err); }, function () { return t.complete(); }), t];
	    };
	    UtilsService.prototype.watch = function (scope, watchExpression, objectEquality) {
	        return this.rx.Observable.create(function (observer) {
	            // Create function to handle old and new Value
	            function listener(newValue, oldValue) {
	                observer.next({ oldValue: oldValue, newValue: newValue });
	            }
	            // Returns function which disconnects the watch expression
	            return scope.$watch(watchExpression, listener, objectEquality);
	        });
	    };
	    // once all stores are ready, emit whenever any of them change
	    UtilsService.prototype.readyChange = function () {
	        var _this = this;
	        var stores = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            stores[_i] = arguments[_i];
	        }
	        var readys = stores.map(function (s) { return s.ready(); });
	        var streams = stores.map(function (s) { return s.stream(); });
	        return (_a = this.rx.Observable).forkJoin.apply(_a, __spread(readys)).flatMap(function () {
	            return (_a = _this.rx.Observable).combineLatest.apply(_a, __spread(streams));
	            var _a;
	        });
	        var _a;
	    };
	    // can be used in readyChange
	    UtilsService.prototype.createStream = function (initial) {
	        var r = new this.rx.AsyncSubject();
	        r.next(true);
	        r.complete();
	        var s = new this.rx.BehaviorSubject(initial);
	        return {
	            ready: function () {
	                return r;
	            },
	            stream: function () {
	                return s;
	            },
	            next: function (value) {
	                s.next(value);
	            }
	        };
	    };
	    UtilsService.prototype.upload = function (params) {
	        var subject = new this.rx.AsyncSubject();
	        var Upload = this.Upload;
	        var timeout = this.timeout;
	        var total = 3;
	        function doit(retries) {
	            Upload.upload(params).then(function (response) {
	                subject.next(response);
	                subject.complete();
	            }, function (response) {
	                if (retries > 0 && response.status !== 413) {
	                    timeout(function () {
	                        doit(retries - 1);
	                    }, (total - retries + 1) * 500);
	                }
	                else {
	                    subject.error(response);
	                }
	            });
	        }
	        doit(total);
	        return subject;
	    };
	    UtilsService.prototype.saveReport = function (data, ev, hasToC) {
	        var subject = new this.rx.AsyncSubject();
	        var name = this.removeDiacritics(data.name || 'report').replace(/[^A-Za-z0-9 -_']/g, ' ').replace(/\s+/g, ' ').trim() + '.' + data.ext;
	        this.window.saveAs(data.blob, name);
	        var msg = 'Your report has been saved to your "Downloads" folder.';
	        if (data.ext === 'docx') {
	            msg += ' It is in Microsoft Word format so you can customize it before printing.';
	        }
	        if (hasToC) {
	            msg += 'To update the Table of Contents, open the report in MS Word, click on the word "Contents" on the first page of the report, ' +
	                'then click on the arrow that appears next to "Table of Contents", select "Update Table", and select "Update entire table".';
	        }
	        this.alert('Report saved', msg, ev);
	        subject.next({ name: name, blob: data.blob });
	        subject.complete();
	        return subject;
	    };
	    //
	    // data extraction/manipulation functions
	    //
	    UtilsService.prototype.randomId = function () {
	        return Math.floor(Math.random() * (Math.pow(2, 53) - 1)) + 1;
	    };
	    UtilsService.prototype.randomKey = function () {
	        return Math.floor(Math.random() * (Math.pow(2, 32) - 1)) + 1;
	    };
	    UtilsService.prototype.nextKey = function (keys, start) {
	        if (start === void 0) { start = 1; }
	        if (keys.length === 0) {
	            return Math.max(start, 1);
	        }
	        return Math.max.apply(Math, __spread(keys)) + Math.floor(Math.random() * 256) + 1;
	    };
	    UtilsService.prototype.getYear = function (d, withDecade) {
	        if (!d) {
	            return '';
	        }
	        var m = d.match(withDecade ? /\b[12]\d{3}('s)?\b/ : /\b[12]\d{3}\b/);
	        return !!m ? m[0] : '';
	    };
	    UtilsService.prototype.getNamePieces = function (name) {
	        var given = '', surname = '';
	        var ix = name.lastIndexOf(' ');
	        if (ix > 0) {
	            given = name.substr(0, ix);
	            surname = name.substr(ix);
	        }
	        else {
	            given = name;
	        }
	        return this.createName(given, surname);
	    };
	    UtilsService.prototype.createName = function (given, surname, prefix, suffix) {
	        return {
	            given: (given || '').trim(),
	            surname: (surname || '').trim(),
	            prefix: (prefix || '').trim(),
	            suffix: (suffix || '').trim()
	        };
	    };
	    UtilsService.prototype.isNameEmpty = function (n) {
	        return !n.given && !n.surname && !n.prefix && !n.suffix;
	    };
	    UtilsService.prototype.getFullName = function (n) {
	        if (!n) {
	            return '';
	        }
	        var text = '';
	        if (!!n.prefix) {
	            text = n.prefix;
	        }
	        if (!!n.given) {
	            if (text.length > 0) {
	                text += ' ';
	            }
	            text += n.given;
	        }
	        if (!!n.surname) {
	            if (text.length > 0) {
	                text += ' ';
	            }
	            text += n.surname;
	        }
	        if (!!n.suffix) {
	            if (text.length > 0) {
	                text += ' ';
	            }
	            text += n.suffix;
	        }
	        return text;
	    };
	    UtilsService.prototype.isFactEmpty = function (f) {
	        return !f.type && !f.date && !f.place && !f.value && !f.placeDetails;
	    };
	    UtilsService.prototype.compareDateSorts = function (ds1, ds2) {
	        if (!!ds1 && !!ds2) {
	            if (ds1 < ds2) {
	                return -1;
	            }
	            else if (ds1 > ds2) {
	                return 1;
	            }
	            else {
	                return 0;
	            }
	        }
	        else if (!!ds1) {
	            return 1;
	        }
	        else if (!!ds2) {
	            return -1;
	        }
	        else {
	            return 0;
	        }
	    };
	    UtilsService.prototype.getBirthdateFromEventAge = function (dateSort, age) {
	        if (!dateSort || age === '' || age == null) {
	            return '';
	        }
	        var y = parseInt(dateSort.substr(0, 4), 10);
	        // handle n/12
	        var months = age.replace(new RegExp('\\s+', 'g'), '');
	        if (months.endsWith('/12')) {
	            months = parseInt(months.substr(0, months.length - 3), 10);
	            if (isNaN(months)) {
	                return '';
	            }
	            var m = parseInt(dateSort.substr(4, 2), 10);
	            if (m > 0) {
	                m -= months;
	                if (m <= 0) {
	                    y -= 1;
	                    m += 12;
	                }
	                var mon = (m < 10) ? '0' + m.toString() : m.toString();
	                return {
	                    date: this.translations['ABOUT'] + ' ' + this.months[m - 1] + ' ' + y.toString(),
	                    dateSort: y.toString() + mon + '00'
	                };
	            }
	            else {
	                age = '0';
	            }
	        }
	        var a = parseInt(age, 10);
	        if (isNaN(a)) {
	            return '';
	        }
	        var year = y - a;
	        return {
	            date: this.translations['ABOUT'] + ' ' + year.toString(),
	            dateSort: year.toString() + '0000|' + (year - 1).toString() + '0000|' + (year + 1).toString() + '0000'
	        };
	    };
	    UtilsService.prototype.mergeFacts = function (facts) {
	        var _this = this;
	        return facts.reduce(function (f1, f2) {
	            var place, ps;
	            if (!!f1.placeStandard && !!f2.placeStandard) {
	                ps = _this.getLongest(f1.placeStandard, f2.placeStandard);
	                place = ps === f2.placeStandard ? f2.place : f1.place;
	            }
	            else if (!!f1.place) {
	                ps = f1.placeStandard;
	                place = f1.place;
	            }
	            else {
	                ps = f2.placeStandard;
	                place = f2.place;
	            }
	            var date, dateSort;
	            if (!!f1.dateSort && !!f2.dateSort) {
	                var f1ds = f1.dateSort.split('|');
	                var f2ds = f2.dateSort.split('|');
	                var chooseF1 = void 0;
	                if (f1ds.length === 3) {
	                    if (f2ds.length === 3) {
	                        chooseF1 = parseInt(_this.getMaxDateSort(f1ds[2]), 10) - parseInt(f1ds[1], 10) < parseInt(_this.getMaxDateSort(f2ds[2]), 10) - parseInt(f2ds[1], 10); // prefer smaller range
	                    }
	                    else if (f2ds.length === 2) {
	                        chooseF1 = false; // always prefer double over range
	                    }
	                    else {
	                        chooseF1 = parseInt(_this.getMaxDateSort(f1ds[2]), 10) - parseInt(f1ds[1], 10) < parseInt(_this.getMaxDateSort(f2ds[0]), 10) - parseInt(f2ds[0], 10); // prefer smaller range
	                    }
	                }
	                else if (f1ds.length === 2) {
	                    if (f2ds.length === 3) {
	                        chooseF1 = true; // always prefer double over range
	                    }
	                    else if (f2ds.length === 2) {
	                        chooseF1 = !f1ds[0].endsWith('00') || !f1ds[0].endsWith('00') || (f2ds[0].endsWith('00') && f2ds[1].endsWith('00')); // prefer more specific
	                    }
	                    else {
	                        chooseF1 = !f2ds[0].endsWith('00'); // prefer single over double unless it's unspecific
	                    }
	                }
	                else {
	                    if (f2ds.length === 3) {
	                        chooseF1 = parseInt(_this.getMaxDateSort(f1ds[0]), 10) - parseInt(f1ds[0], 10) < parseInt(_this.getMaxDateSort(f2ds[2]), 10) - parseInt(f2ds[1], 10); // prefer smaller range
	                    }
	                    else if (f2ds.length === 2) {
	                        chooseF1 = !f1ds[0].endsWith('00'); // prefer single over double unless it's unspecific
	                    }
	                    else {
	                        chooseF1 = parseInt(_this.getMaxDateSort(f1ds[0]), 10) - parseInt(f1ds[0], 10) < parseInt(_this.getMaxDateSort(f2ds[0]), 10) - parseInt(f2ds[0], 10); // prefer smaller range
	                    }
	                }
	                date = chooseF1 ? f1.date : f2.date;
	                dateSort = chooseF1 ? f1.dateSort : f2.dateSort;
	            }
	            else if (!!f1.date) {
	                date = f1.date;
	                dateSort = f1.dateSort;
	            }
	            else {
	                date = f2.date;
	                dateSort = f2.dateSort;
	            }
	            return {
	                type: f2.type,
	                principal: f1.principal || f2.principal,
	                principalId1: f1.principalId1 || f2.principalId1,
	                principalId2: f1.principalId2 || f2.principalId2,
	                value: _this.getLongest(f1.value, f2.value),
	                date: date,
	                dateSort: dateSort,
	                placeDetails: _this.getLongest(f1.placeDetails, f2.placeDetails),
	                place: place,
	                placeStandard: ps,
	                latitude: ps === f1.placeStandard ? f1.latitude : f2.latitude,
	                longitude: ps === f1.placeStandard ? f1.longitude : f2.longitude,
	                hidden: f1.hidden || f2.hidden,
	                evidencePersonas: new Map([].concat((!!f1.evidencePersonas ? Array.from(f1.evidencePersonas.entries()) : []), (!!f2.evidencePersonas ? Array.from(f2.evidencePersonas.entries()) : [])))
	            };
	        }, {
	            type: '',
	            date: '',
	            dateSort: '',
	            place: '',
	            placeStandard: '',
	            value: '',
	            principal: false,
	            principalId1: 0,
	            principalId2: 0,
	            evidencePersonas: new Map()
	        });
	    };
	    UtilsService.prototype.getLongest = function (s1, s2) {
	        return !s1 && !!s2 ? s2 : !s2 && !!s1 ? s1 : !s1 && !s2 ? '' : s1.length >= s2.length ? s1 : s2;
	    };
	    UtilsService.prototype.yearDiff = function (ds2, ds1) {
	        if (!ds2 || !ds2 || ds1.length < 4 || ds2.length < 4) {
	            return NaN;
	        }
	        var y2 = parseInt(ds2.substr(0, 4), 10);
	        var md2 = parseInt(ds2.substr(4), 10);
	        var y1 = parseInt(ds1.substr(0, 4), 10);
	        var md1 = parseInt(ds1.substr(4), 10);
	        var diff = y2 - y1;
	        if (md2 < md1) {
	            diff--;
	        }
	        return diff;
	    };
	    UtilsService.prototype.fixURL = function (u) {
	        if (!u) {
	            return '';
	        }
	        var match = u.match(this.urlRE);
	        if (match !== null && match[1] === undefined) {
	            u = 'http://' + u;
	        }
	        return u;
	    };
	    UtilsService.prototype.isValidURL = function (url) {
	        return !!this.parseURL(url);
	        //if (!url) {
	        //  return false;
	        //}
	        //if (url.indexOf('://') < 0) {
	        //  url = 'http://' + url;
	        //}
	        //let pattern = /^(https?:)\/\/(-\.)?([^\s/?\.#-]+\.?)+(\/[^\s]*)?$/;
	        ////let pattern = /^(?:https?:\/\/)?[^\s\/$.?#]\.[^\s]*$/;
	        //return url.match(pattern) !== null && url.indexOf('.') >= 0;
	    };
	    UtilsService.prototype.parseURL = function (url) {
	        if (!url) {
	            return null;
	        }
	        if (url.indexOf('://') < 0) {
	            url = 'http://' + url;
	        }
	        var match = url.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
	        return url.indexOf(' ') >= 0 || !match || match[3].indexOf('.') < 0 ? null : {
	            protocol: match[1],
	            hostport: match[2],
	            host: match[3],
	            port: match[4],
	            path: match[5],
	            search: match[6],
	            hash: match[7]
	        };
	    };
	    UtilsService.prototype.getThumbURL = function (u) {
	        return this.serverBase + '/thumbnail?url=' + encodeURIComponent(u) + '&token=' + this.authToken.get();
	    };
	    UtilsService.prototype.findGender = function (genders, genderValue) {
	        if (!genderValue) {
	            return null;
	        }
	        var initial = genderValue.toLowerCase().substr(0, 1);
	        return genders.find(function (g) { return g.value.toLowerCase().startsWith(initial); });
	    };
	    UtilsService.prototype.encodeId = function (id) {
	        if (!id) {
	            return '';
	        }
	        var encoded = [];
	        for (var i = 0; i < 11; i++) {
	            encoded.push(this.idCoding.charAt(id % 32));
	            id = Math.floor(id / 32);
	            if (i === 3 || i === 7) {
	                encoded.push('-');
	            }
	        }
	        return encoded.reverse().join('');
	    };
	    UtilsService.prototype.decodeId = function (enc) {
	        if (!enc) {
	            return 0;
	        }
	        if (/^[0-9]+$/.test(enc)) {
	            return +enc;
	        }
	        var id = 0;
	        for (var i = 0; i < 13; i++) {
	            if (i === 3 || i === 8) {
	                continue;
	            }
	            id = id * 32 + this.idCoding.indexOf(enc.charAt(i));
	        }
	        return id;
	    };
	    UtilsService.prototype.first = function (m) {
	        try {
	            for (var m_1 = __values(m), m_1_1 = m_1.next(); !m_1_1.done; m_1_1 = m_1.next()) {
	                var _a = __read(m_1_1.value, 2), v = _a[1];
	                return v || null;
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (m_1_1 && !m_1_1.done && (_b = m_1.return)) _b.call(m_1);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        return null;
	        var e_3, _b;
	    };
	    UtilsService.prototype.firstKey = function (m) {
	        try {
	            for (var m_2 = __values(m), m_2_1 = m_2.next(); !m_2_1.done; m_2_1 = m_2.next()) {
	                var _a = __read(m_2_1.value, 1), k = _a[0];
	                return k || null;
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (m_2_1 && !m_2_1.done && (_b = m_2.return)) _b.call(m_2);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        return null;
	        var e_4, _b;
	    };
	    UtilsService.prototype.formatCommas = function (n) {
	        return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    };
	    UtilsService.prototype.mergeMaps = function (m1, m2) {
	        var m = new Map();
	        try {
	            for (var m1_1 = __values(m1), m1_1_1 = m1_1.next(); !m1_1_1.done; m1_1_1 = m1_1.next()) {
	                var _a = __read(m1_1_1.value, 2), k = _a[0], v = _a[1];
	                m.set(k, v);
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (m1_1_1 && !m1_1_1.done && (_b = m1_1.return)) _b.call(m1_1);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        try {
	            for (var m2_1 = __values(m2), m2_1_1 = m2_1.next(); !m2_1_1.done; m2_1_1 = m2_1.next()) {
	                var _c = __read(m2_1_1.value, 2), k = _c[0], v = _c[1];
	                m.set(k, v);
	            }
	        }
	        catch (e_6_1) { e_6 = { error: e_6_1 }; }
	        finally {
	            try {
	                if (m2_1_1 && !m2_1_1.done && (_d = m2_1.return)) _d.call(m2_1);
	            }
	            finally { if (e_6) throw e_6.error; }
	        }
	        return m;
	        var e_5, _b, e_6, _d;
	    };
	    UtilsService.prototype.sortedIndex = function (arr, item, fn) {
	        var low = 0, high = arr.length, value = fn(item);
	        while (low < high) {
	            var mid = (low + high) >>> 1; // jshint ignore:line
	            if (fn(arr[mid]) < value) {
	                low = mid + 1;
	            }
	            else {
	                high = mid;
	            }
	        }
	        return low;
	    };
	    UtilsService.prototype.toServer = function (value) {
	        var _this = this;
	        //if (angular.isArray(value)) {
	        //  return value.map(v => this.toServer(v));
	        //}
	        if (value instanceof Map) {
	            var o = {};
	            try {
	                for (var value_1 = __values(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
	                    var _a = __read(value_1_1.value, 2), k = _a[0], v = _a[1];
	                    o[k.toString()] = this.toServer(v);
	                }
	            }
	            catch (e_7_1) { e_7 = { error: e_7_1 }; }
	            finally {
	                try {
	                    if (value_1_1 && !value_1_1.done && (_b = value_1.return)) _b.call(value_1);
	                }
	                finally { if (e_7) throw e_7.error; }
	            }
	            return o;
	        }
	        if (this.angularUtils.isObject(value)) {
	            var o_1 = {};
	            Object.keys(value)
	                .filter(function (k) { return !k.startsWith('_'); })
	                .forEach(function (k) {
	                o_1[k] = _this.toServer(value[k]);
	            });
	            return o_1;
	        }
	        return value;
	        var e_7, _b;
	    };
	    UtilsService.prototype.fromServer = function (value) {
	        if (this.angularUtils.isObject(value)) {
	            var o = {};
	            for (var k in value) {
	                var v = value[k];
	                // int-valued maps
	                if (['names', 'facts', 'evidencePersonas', 'personas', 'childRels', 'mediaIds', 'personIds', 'fileInfos', 'comments', 'likes', 'ordinances', 'columns', 'items'].includes(k) && !(v instanceof Map)) {
	                    var a = [];
	                    for (var mk in v) {
	                        a.push([parseInt(mk, 10), this.fromServer(v[mk])]);
	                    }
	                    o[k] = new Map(a);
	                }
	                else if (['tags', 'nameForms', 'externalIds', 'treeURLs', 'filters'].includes(k) && !(v instanceof Map)) {
	                    var a = [];
	                    for (var mk in v) {
	                        a.push([mk, this.fromServer(v[mk])]);
	                    }
	                    o[k] = new Map(a);
	                }
	                else {
	                    o[k] = v; // this.fromServer(v);
	                }
	            }
	            return o;
	        }
	        return value;
	    };
	    UtilsService.prototype.clone = function (obj) {
	        var copy;
	        // Handle the 3 simple types, and null or undefined
	        if (!this.angularUtils.isObject(obj)) {
	            return obj;
	        }
	        // Handle Date
	        if (obj instanceof Date) {
	            copy = new Date();
	            copy.setTime(obj.getTime());
	            return copy;
	        }
	        // Handle Array
	        if (this.angularUtils.isArray(obj)) {
	            copy = [];
	            for (var i = 0, len = obj.length; i < len; i++) {
	                copy[i] = this.clone(obj[i]);
	            }
	            return copy;
	        }
	        // handle Map
	        if (obj instanceof Map) {
	            copy = new Map();
	            try {
	                for (var obj_1 = __values(obj), obj_1_1 = obj_1.next(); !obj_1_1.done; obj_1_1 = obj_1.next()) {
	                    var _a = __read(obj_1_1.value, 2), k = _a[0], v = _a[1];
	                    copy.set(k, this.clone(v));
	                }
	            }
	            catch (e_8_1) { e_8 = { error: e_8_1 }; }
	            finally {
	                try {
	                    if (obj_1_1 && !obj_1_1.done && (_b = obj_1.return)) _b.call(obj_1);
	                }
	                finally { if (e_8) throw e_8.error; }
	            }
	            return copy;
	        }
	        // Handle Object
	        copy = {};
	        for (var attr in obj) {
	            if (obj.hasOwnProperty(attr)) {
	                copy[attr] = this.clone(obj[attr]);
	            }
	        }
	        return copy;
	        var e_8, _b;
	    };
	    UtilsService.prototype.getAhnentafelColor = function (treePrefs, ahnentafel, light) {
	        var offset = 0;
	        if (light) {
	            offset += 2;
	        }
	        if (ahnentafel === this.colorNOT) {
	            return this.colors[treePrefs['COLOR_NOT']][offset];
	        }
	        if (ahnentafel > this.colorOverrideBase) {
	            return this.colors[treePrefs['COLOR_' + (ahnentafel - this.colorOverrideBase)]][offset];
	        }
	        if (ahnentafel < 16) {
	            ahnentafel *= 16;
	        }
	        while (ahnentafel > 31) {
	            ahnentafel = ahnentafel >>> 1; // jshint ignore:line
	        }
	        var base = Math.floor(ahnentafel / 4);
	        var baseColor;
	        switch (base) {
	            case 4:
	                baseColor = 'COLOR_PGF';
	                break;
	            case 5:
	                baseColor = 'COLOR_PGM';
	                break;
	            case 6:
	                baseColor = 'COLOR_MGF';
	                break;
	            case 7:
	                baseColor = 'COLOR_MGM';
	                break;
	        }
	        offset += ahnentafel % 4;
	        return this.colors[treePrefs[baseColor]][offset];
	    };
	    UtilsService.prototype.averageColor = function (colors, defColor) {
	        var _this = this;
	        if (colors.length === 0) {
	            return defColor;
	        }
	        else if (colors.length === 1) {
	            return colors[0];
	        }
	        // average color: sqrt(avg(...color^2))
	        var red = 0;
	        var green = 0;
	        var blue = 0;
	        colors.forEach(function (color) {
	            var rgb = color.match(_this.colorSegmentRE);
	            var r = parseInt(rgb[0], 16);
	            red += r * r;
	            var g = parseInt(rgb[1], 16);
	            green += g * g;
	            var b = parseInt(rgb[2], 16);
	            blue += b * b;
	        });
	        red = Math.floor(Math.sqrt(red / colors.length));
	        green = Math.floor(Math.sqrt(green / colors.length));
	        blue = Math.floor(Math.sqrt(blue / colors.length));
	        var r = red.toString(16);
	        var g = green.toString(16);
	        var b = blue.toString(16);
	        return '#' + (r.length === 2 ? r : '0' + r) + (g.length === 2 ? g : '0' + g) + (b.length === 2 ? b : '0' + b);
	    };
	    UtilsService.prototype.createEvidenceFromFact = function (fact) {
	        return {
	            fact: {
	                type: fact.type,
	                value: fact.value,
	                date: fact.date,
	                dateSort: fact.dateSort,
	                place: fact.place,
	                placeDetails: fact.placeDetails,
	                placeStandard: fact.placeStandard,
	                latitude: fact.latitude,
	                longitude: fact.longitude
	            },
	            mediaIds: new Map(),
	            externalImageURL: '',
	            text: '',
	            citation: {
	                sourceId: 0
	            },
	            personas: new Map([[1, {
	                        principal: true,
	                        relatedToKey: 0,
	                        names: new Map(),
	                        facts: new Map(),
	                        relationshipType: null
	                    }]])
	        };
	    };
	    UtilsService.prototype.isHiddenEvidence = function (e) {
	        if (!e._hasSource) {
	            return true;
	        }
	        var url = !!e.citation.url && this.isValidURL(e.citation.url) ? this.parseURL(e.citation.url) : null;
	        if (!!url && url.host.endsWith(FS) && (url.path.startsWith('/ark:/61903/4:1:') || url.path.startsWith('/tree/person/'))) {
	            return true;
	        }
	        return false;
	    };
	    UtilsService.prototype.getCitation = function (source, url, page, date) {
	        var citation = '';
	        if (!source) {
	            return citation;
	        }
	        if (!!source.bibCitation) {
	            citation = source.bibCitation;
	        }
	        else {
	            if (!!source.creator) {
	                citation += this.escape(source.creator);
	            }
	            if (!!source.title || !!source.abbr) {
	                if (!!citation) {
	                    citation += '. ';
	                }
	                citation += '<em>' + (this.escape(source.title || source.abbr)) + '</em>';
	            }
	            if (!!source.subtitle) {
	                citation += ': <em>' + this.escape(source.subtitle) + '</em>';
	            }
	            if (!!source.periodicalSeries) {
	                citation += '. ' + this.escape(source.periodicalSeries);
	            }
	            //if (!!source.numVolumes) {
	            //  citation += '. '+source.numVolumes + ' Volumes';
	            //}
	            if (!!source.publisher || !!source.dateIssued || !!source.placeIssued) {
	                citation += '. (';
	                if (!!source.placeIssued) {
	                    citation += this.escape(source.placeIssued) + ': ';
	                }
	                if (!!source.publisher) {
	                    citation += this.escape(source.publisher);
	                }
	                if (!!source.dateIssued) {
	                    citation += ', ' + this.escape(source.dateIssued);
	                }
	                citation += ')';
	            }
	            //if (!!source.volumeFilmPages) {
	            //  citation += ', '+source.volumeFilmPages;
	            //}
	            if (!!source.repository) {
	                citation += ', ' + this.escape(source.repository);
	            }
	        }
	        url = url || source.url;
	        if (url) {
	            var encoded = encodeURI(url);
	            citation += ', <a href="' + encoded + '" target="_blank" class="link">' + this.escape(url) + '<i class="material-icons external-link-icon">open_in_new</i></a>';
	        }
	        if (!!page) {
	            citation += ', ' + this.escape(page);
	        }
	        if (!!date) {
	            citation += ', ' + this.escape(date);
	        }
	        return citation;
	    };
	    // persons is optional; if passed in, logs will be ordered so that logs associated with persons appear first
	    UtilsService.prototype.getResearchLogTitles = function (logMap, persons) {
	        var logs = Array.from(logMap.values()).map(function (log) {
	            return { id: log.id, title: log.title, hasPeople: !!persons ? persons.some(function (p) { return log.personIds.has(p.id); }) : false };
	        });
	        logs.sort(function (a, b) {
	            if (a.hasPeople === b.hasPeople) {
	                return (a.title < b.title) ? -1 : (b.title < a.title) ? 1 : (a.id - b.id);
	            }
	            return (a.hasPeople && !b.hasPeople) ? -1 : 1;
	        });
	        return logs;
	    };
	    //
	    // equal functions
	    //
	    UtilsService.prototype.noteEquals = function (n1, n2) {
	        return (n1.title || '') === (n2.title || '') &&
	            (n1.text || '') === (n2.text || '');
	    };
	    UtilsService.prototype.leadEquals = function (l1, l2) {
	        return (l1.title || '') === (l2.title || '') &&
	            (l1.url || '') === (l2.url || '') &&
	            (l1.text || '') === (l2.text || '');
	    };
	    UtilsService.prototype.storyEquals = function (s1, s2) {
	        return (s1.title || '') === (s2.title || '') &&
	            (s1.text || '') === (s2.text || '') &&
	            (s1.date || '') === (s2.date || '') &&
	            (s1.place || '') === (s2.place || '') &&
	            (s1.mediaIds.size + (!!s1._url ? 1 : 0)) === (s2.mediaIds.size + (!!s2._url ? 1 : 0));
	    };
	    UtilsService.prototype.mediaEquals = function (m1, m2) {
	        return (m1.title || '') === (m2.title || '') &&
	            (m1.text || '') === (m2.text || '') &&
	            (m1.date || '') === (m2.date || '') &&
	            (m1.place || '') === (m2.place || '');
	    };
	    UtilsService.prototype.evidenceSemiEquals = function (e1, e2) {
	        return (e1.text || '') === (e2.text || '') &&
	            ((!!e1.citation.url && e1.citation.url === e2.citation.url) ||
	                (!!e1.citation.text && e1.citation.text === e2.citation.text) ||
	                (!e1.citation.url && !e1.text && !!e1._sourceAbbr && e1._sourceAbbr === e2._sourceAbbr));
	    };
	    UtilsService.prototype.nameEquals = function (n1, n2) {
	        if (!n1 || !n2) {
	            return false;
	        }
	        if (!!n1.nameForms) {
	            n1 = n1.nameForms.get('default') || Array.from(n1.nameForms.values())[0];
	        }
	        if (!!n2.nameForms) {
	            n2 = n2.nameForms.get('default') || Array.from(n2.nameForms.values())[0];
	        }
	        return !!n1 && !!n2 &&
	            (n1.given || '').toLowerCase() === (n2.given || '').toLowerCase() &&
	            (n1.surname || '').toLowerCase() === (n2.surname || '').toLowerCase() &&
	            (n1.prefix || '').toLowerCase() === (n2.prefix || '').toLowerCase() &&
	            (n1.suffix || '').toLowerCase() === (n2.suffix || '').toLowerCase();
	    };
	    // use this to compare facts on type, date, and place only
	    UtilsService.prototype.factTypeDatePlaceEquals = function (f1, f2) {
	        return !!f1 && !!f2 &&
	            (f1.type === f2.type ||
	                (this.factTypes.some(function (ft) { return ft.value === f1.type; }) && this.factTypes.find(function (ft) { return ft.value === f1.type; }).display === f2.type) ||
	                (this.factTypes.some(function (ft) { return ft.value === f2.type; }) && this.factTypes.find(function (ft) { return ft.value === f2.type; }).display === f1.type)) &&
	            ((f1.date || '').toLowerCase() === (f2.date || '').toLowerCase() || (!!f1.dateSort && !!f2.dateSort && f1.dateSort === f2.dateSort)) &&
	            ((f1.place || '').toLowerCase() === (f2.place || '').toLowerCase() || (!!f1.placeStandard && !!f2.placeStandard && f1.placeStandard === f2.placeStandard));
	    };
	    // don't use this to compare facts on evidences because evidence facts don't have principals
	    UtilsService.prototype.factEquals = function (f1, f2, ignorePrincipalId) {
	        return this.factTypeDatePlaceEquals(f1, f2) &&
	            (f1.placeDetails || '') === (f2.placeDetails || '') &&
	            (f1.value || '') === (f2.value || '') &&
	            (f1.principal === f2.principal) &&
	            ((f1.principalId1 || '') === (f2.principalId1 || '') || ignorePrincipalId) &&
	            ((f1.principalId2 || '') === (f2.principalId2 || '') || ignorePrincipalId);
	    };
	    UtilsService.prototype.factCompatible = function (f1, f2, ignorePrincipal) {
	        if (f1.type !== f2.type ||
	            (f1.principal !== f2.principal && !ignorePrincipal) ||
	            (f1.principalId1 !== f2.principalId1 && !ignorePrincipal) ||
	            (f1.principalId2 !== f2.principalId2 && !ignorePrincipal) ||
	            (!!f1.value && !!f2.value && f1.value.toLowerCase().indexOf(f2.value.toLowerCase()) === -1 && f2.value.toLowerCase().indexOf(f1.value.toLowerCase()) === -1) ||
	            (f1.type === 'SEX' && !!f1.value && !!f2.value && f1.value.toLowerCase() !== f2.value.toLowerCase()) ||
	            (!!f1.placeDetails && !!f2.placeDetails && f1.placeDetails.toLowerCase().indexOf(f2.placeDetails.toLowerCase()) === -1 && f2.placeDetails.toLowerCase().indexOf(f1.placeDetails.toLowerCase()) === -1) ||
	            (!!f1.placeStandard && !!f2.placeStandard && !f1.placeStandard.endsWith(f2.placeStandard) && !f2.placeStandard.endsWith(f1.placeStandard)) ||
	            (!!f1.place && !!f2.place && f1.place !== f2.place && (!f1.placeStandard || !f2.placeStandard)) ||
	            (!!f1.date && !!f2.date && f2.date !== f1.date && (!f1.dateSort || !f2.dateSort))) {
	            return false;
	        }
	        // now check for date compatibility
	        if (!!f1.dateSort && !!f2.dateSort) {
	            var f1ds = f1.dateSort.split('|');
	            var f2ds = f2.dateSort.split('|');
	            if (f1ds.length === 3) {
	                if (f2ds.length === 3) {
	                    return (this.dateSortInRange(f2ds[1], f1ds[1], f1ds[2]) && this.dateSortInRange(f2ds[2], f1ds[1], f1ds[2])) ||
	                        (this.dateSortInRange(f1ds[1], f2ds[1], f2ds[2]) && this.dateSortInRange(f1ds[2], f2ds[1], f2ds[2])); // one range is a subrange of the other
	                }
	                else if (f2ds.length === 2) {
	                    return this.dateSortInRange(f2ds[0], f1ds[1], f1ds[2]) || this.dateSortInRange(f2ds[1], f1ds[1], f1ds[2]); // one date is in the range
	                }
	                else {
	                    return this.dateSortInRange(f2ds[0], f1ds[1], f1ds[2]);
	                }
	            }
	            else if (f1ds.length === 2) {
	                if (f2ds.length === 3) {
	                    return this.dateSortInRange(f1ds[0], f2ds[1], f2ds[2]) || this.dateSortInRange(f1ds[1], f2ds[1], f2ds[2]); // one date is in range
	                }
	                else if (f2ds.length === 2) {
	                    return (this.dateSortCompatible(f1ds[0], f2ds[0]) || this.dateSortCompatible(f1ds[0], f2ds[1])) &&
	                        (this.dateSortCompatible(f1ds[1], f2ds[0]) || this.dateSortCompatible(f1ds[1], f2ds[1])); // both dates compatible
	                }
	                else {
	                    return this.dateSortCompatible(f1ds[0], f2ds[0]) || this.dateSortCompatible(f1ds[1], f2ds[0]); // date compatible
	                }
	            }
	            else {
	                if (f2ds.length === 3) {
	                    return this.dateSortInRange(f1ds[0], f2ds[1], f2ds[2]) ||
	                        (this.dateSortInRange(f2ds[1], f1ds[0], this.getMaxDateSort(f1ds[0])) && this.dateSortInRange(f2ds[2], f1ds[0], this.getMaxDateSort(f1ds[0])));
	                }
	                else if (f2ds.length === 2) {
	                    return this.dateSortCompatible(f1ds[0], f2ds[0]) || this.dateSortCompatible(f1ds[0], f2ds[1]); // date compatible
	                }
	                else {
	                    return this.dateSortCompatible(f1ds[0], f2ds[0]);
	                }
	            }
	        }
	        return true;
	    };
	    UtilsService.prototype.dateSortInRange = function (ds, drmin, drmax) {
	        return ds >= drmin && ds <= this.getMaxDateSort(drmax);
	    };
	    UtilsService.prototype.dateSortCompatible = function (ds1, ds2) {
	        return (ds1 >= ds2 && ds1 <= this.getMaxDateSort(ds2)) || (ds2 >= ds1 && ds2 <= this.getMaxDateSort(ds1));
	    };
	    UtilsService.prototype.getMaxDateSort = function (ds) {
	        return ds.endsWith('0000') ? ds.substr(0, 4) + '1231' : ds.endsWith('00') ? ds.substr(0, 6) + '31' : ds;
	    };
	    //
	    // augmentation functions
	    //
	    UtilsService.prototype.addCreateEditDates = function (o) {
	        if (o.createdDate > 0) {
	            o._createdDate = (new Date(o.createdDate * 1000)).toDateString();
	        }
	        if (o.editedDate > 0) {
	            o._editedDate = (new Date(o.editedDate * 1000)).toDateString();
	        }
	        return o;
	    };
	    UtilsService.prototype.addCreateEditUsers = function (o, users) {
	        var subject = new this.rx.AsyncSubject();
	        var waitCount = (o.createdUser > 0 ? 1 : 0) + (o.editedUser > 0 ? 1 : 0);
	        if (waitCount === 0) {
	            subject.next(o);
	            subject.complete();
	        }
	        if (o.createdUser > 0) {
	            users.streamSummaryId(o.createdUser).take(1).subscribe(function (u) {
	                o._createdUser = u;
	                if (--waitCount === 0) {
	                    subject.next(o);
	                    subject.complete();
	                }
	            });
	        }
	        if (o.editedUser > 0) {
	            users.streamSummaryId(o.editedUser).take(1).subscribe(function (u) {
	                o._editedUser = u;
	                if (--waitCount === 0) {
	                    subject.next(o);
	                    subject.complete();
	                }
	            });
	        }
	        return subject;
	    };
	    //
	    // common config functions
	    //
	    UtilsService.prototype.atConfigUser = function (users, rights, currentTreeId) {
	        var _this = this;
	        return {
	            at: '@',
	            callbacks: {
	                remoteFilter: function (query, callback) {
	                    users.nameAutocomplete(rights, query).then(function (results) {
	                        callback(results.map(function (u) {
	                            return {
	                                id: u.id,
	                                name: _this.escape(u.name),
	                                fullName: _this.escape((u.given + ' ' + u.surname).trim())
	                            };
	                        }));
	                    });
	                },
	                sorter: function (query, items) {
	                    return items.sort(function (a, b) { return a.name > b.name ? 1 : a.name < b.name ? -1 : 0; });
	                },
	                highlighter: function (li, query) {
	                    if (!query) {
	                        return li;
	                    }
	                    return li.replace(new RegExp('<li>([^<]*?)(' + query + ')([^<]*)<', 'iu'), function (str, bef, match, aft) { return '<li>' + bef + '<strong>' + match + '</strong>' + aft + '<'; });
	                }
	            },
	            displayTpl: '<li data-id="${id}">${name} <small>${fullName}</small></li>',
	            insertTpl: '<a href="' + currentTreeId.getBaseURL() + '/users/${id}" class="link">${atwho-at}${name}</a>',
	            limit: 10,
	            maxLen: 20
	        };
	    };
	    UtilsService.prototype.expandMentions = function (currentTreeIdService, allUsers, text) {
	        var _this = this;
	        if (!text) {
	            return '';
	        }
	        return text.replace(this.mentionRegex, function (match, name) {
	            var user = allUsers.find(function (user) { return user.name === name; });
	            if (!user) {
	                return match;
	            }
	            return '<a href="' + currentTreeIdService.getBaseURL() + '/users/' + user.id + '" class="link">@' + _this.escape(user.name) + '</a>';
	        });
	    };
	    UtilsService.prototype.tagify = function (given, surname) {
	        return (!!given ? given.split(' ')[0] : '') + (!!surname ? surname.replace(' ', '') : '');
	    };
	    UtilsService.prototype.froalaOptions = function (atConfig, focusFn, atWhoCallback, enterCallback) {
	        return {
	            events: {
	                'froalaEditor.initialized': function (e, editor) {
	                    if (!atConfig) {
	                        return;
	                    }
	                    editor.$el.atwho(atConfig);
	                    editor.events.on('keydown', function (e) {
	                        if (e.which === 13 && editor.$el.atwho('isSelecting')) {
	                            return false;
	                        }
	                        if (e.which === 13 && !!enterCallback) {
	                            if (!enterCallback(editor.html.get())) {
	                                e.preventDefault();
	                                return false;
	                            }
	                        }
	                    }, true);
	                    editor.$el.on("inserted.atwho", function (event, $li) {
	                        if (!!atWhoCallback) {
	                            atWhoCallback(parseInt($li.attr('data-id'), 10));
	                        }
	                    });
	                },
	                'froalaEditor.focus': focusFn
	            }
	        };
	    };
	    //
	    // translations
	    //
	    UtilsService.prototype._getTranslations = function () {
	        var _this = this;
	        var translations = {};
	        [
	            'SUPPORTING_EVIDENCE',
	            'ABOUT'
	        ].forEach(function (v) {
	            _this.translate(v).then(function (display) {
	                translations[v] = display;
	            });
	        });
	        return translations;
	    };
	    //
	    // mutex
	    //
	    UtilsService.prototype._mutexDequeue = function (self) {
	        self.busy = true;
	        var next = self.queue.shift();
	        if (!!next) {
	            this._mutexExecute(self, next);
	        }
	        else {
	            self.busy = false;
	        }
	    };
	    UtilsService.prototype._mutexExecute = function (self, next) {
	        var _this = this;
	        next().subscribe(function () {
	            _this._mutexDequeue(self);
	        }, function () {
	            _this._mutexDequeue(self);
	        });
	    };
	    UtilsService.prototype.createMutex = function () {
	        var _this = this;
	        var self = {
	            busy: false,
	            queue: []
	        };
	        return function (fn) {
	            self.queue.push(fn);
	            if (!self.busy) {
	                _this._mutexDequeue(self);
	            }
	        };
	    };
	    // takes a function that returns a single-result observable
	    UtilsService.prototype.syncMutex = function (mutex, fn) {
	        var stream = new this.rx.AsyncSubject();
	        mutex(function () {
	            return fn().do(function (x) {
	                stream.next(x);
	                stream.complete();
	            }, function (err) {
	                stream.error(err);
	            });
	        });
	        return stream;
	    };
	    //
	    // array functions
	    //
	    UtilsService.prototype.arrayGroupBy = function (arr, key) {
	        return arr.reduce(function (rv, x) {
	            var v = key instanceof Function ? key(x) : x[key];
	            var el = rv.find(function (r) { return r && r.key === v; });
	            if (el) {
	                el.values.push(x);
	            }
	            else {
	                rv.push({ key: v, values: [x] });
	            }
	            return rv;
	        }, []);
	    };
	    UtilsService.prototype.arraysEqual = function (a, b) {
	        if (a === b) {
	            return true;
	        }
	        if (a == null || b == null) {
	            return false;
	        }
	        if (a.length !== b.length) {
	            return false;
	        }
	        for (var i = 0; i < a.length; i++) {
	            if (b.indexOf(a[i]) < 0) {
	                return false;
	            }
	        }
	        return true;
	    };
	    //
	    // map functions
	    //
	    UtilsService.prototype.mapsEqual = function (a, b) {
	        if (a === b) {
	            return true;
	        }
	        if (a == null || b == null) {
	            return false;
	        }
	        if (a.size !== b.size) {
	            return false;
	        }
	        try {
	            for (var a_1 = __values(a), a_1_1 = a_1.next(); !a_1_1.done; a_1_1 = a_1.next()) {
	                var _a = __read(a_1_1.value, 2), key = _a[0], value = _a[1];
	                if (!b.has(key) || b.get(key) !== value) {
	                    return false;
	                }
	            }
	        }
	        catch (e_9_1) { e_9 = { error: e_9_1 }; }
	        finally {
	            try {
	                if (a_1_1 && !a_1_1.done && (_b = a_1.return)) _b.call(a_1);
	            }
	            finally { if (e_9) throw e_9.error; }
	        }
	        return true;
	        var e_9, _b;
	    };
	    UtilsService.prototype.mapToSortedArray = function (m) {
	        return Array.from(m.entries()).sort(function (a, b) { return b[1] - a[1]; }).map(function (a) { return a[0]; });
	    };
	    //
	    // string functions
	    //
	    UtilsService.prototype.escape = function (text, keepSomeFormatting) {
	        var _this = this;
	        if (!text) {
	            return '';
	        }
	        text = text.replace(/[&<>"']/g, function (r) { return _this.reverseEntities[r]; });
	        if (keepSomeFormatting) {
	            text = text.replace(/&lt;(\/?)i&gt;/g, '<$1i>').replace(/\n/g, '<br>');
	        }
	        return text;
	    };
	    UtilsService.prototype.removeHtml = function (text, max) {
	        var _this = this;
	        if (max === void 0) { max = 0; }
	        text = !!text ? String(text) : '';
	        text = text.replace(/<[^>]+>/gm, '');
	        text = text.replace(/&(amp|lt|gt|quot|apos|#39|nbsp|zwj);/gm, function (r) { return _this.entities[r]; });
	        if (max > 0 && text.length > max) {
	            text = text.substr(0, max - 3) + '...';
	        }
	        return text;
	    };
	    UtilsService.prototype.removeHtmlNicely = function (text, max) {
	        if (max === void 0) { max = 0; }
	        text = !!text ? String(text) : '';
	        text = text.replace(/<li>/gm, '\n');
	        text = text.replace(/<tr>/gm, '\n');
	        text = text.replace(/<br\/?>/gm, '\n');
	        return this.removeHtml(text, max);
	    };
	    UtilsService.prototype.normalize = function (s) {
	        return this.removeDiacritics(s).toLowerCase().replace(/['`ʹʻʼʿ’′]/g, '').replace(/\s+/g, ' ').trim();
	    };
	    UtilsService.prototype.capitalizeFirstLetter = function (s) {
	        if (!s) {
	            return '';
	        }
	        return s.charAt(0).toUpperCase() + s.slice(1);
	    };
	    UtilsService.prototype.truncate = function (s, max) {
	        if (s.length < max) {
	            return s;
	        }
	        //let pos = s.lastIndexOf(' ');
	        //if (pos <= 0) {
	        //  pos = s.length;
	        //}
	        return s.substr(0, max) + '...';
	    };
	    UtilsService.prototype.cleanPDF = function (text) {
	        var _this = this;
	        return text.replace(this.pdfRegExp, function (r) { return _this.pdfReplacements[r]; });
	    };
	    UtilsService.prototype.toTitleCase = function (s) {
	        return s.replace(/\b\w+/g, function (s) { return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase(); });
	    };
	    //
	    // types
	    //
	    UtilsService.prototype._getFactTypes = function () {
	        var _this = this;
	        return [
	            { value: 'ADDR' },
	            { value: 'ADOP', icon: 'birth' },
	            { value: '_AFIL' },
	            { value: '_AGE', fact: true },
	            { value: 'AFN', fact: true },
	            { value: 'ANUL', spouse: true },
	            { value: 'ARVL', icon: 'immigration' },
	            { value: 'BAPM', common: true, parents: true, icon: 'christian' },
	            { value: 'BARM', icon: 'jewish' },
	            { value: 'BATM', icon: 'jewish' },
	            { value: '_BIO', fact: true },
	            { value: 'BIRT', common: true, parents: true, icon: 'birth' },
	            { value: 'BLES' },
	            { value: 'BURI', common: true, icon: 'death' },
	            { value: 'CAST', fact: true },
	            { value: 'CAUS', fact: true },
	            { value: 'CENS', common: true, icon: 'residence', family: true },
	            { value: 'CHR', common: true, parents: true, icon: 'christian' },
	            { value: '_CIVL', spouse: true },
	            { value: '_CLAN', fact: true },
	            { value: 'CLAW', spouse: true, icon: 'marriage' },
	            { value: 'CONF', icon: 'church' },
	            { value: 'CREM', icon: 'death' },
	            { value: 'DEAT', common: true, icon: 'death' },
	            { value: '_DEG', icon: 'education' },
	            { value: 'DPRT', icon: 'immigration' },
	            { value: 'DSCR', fact: true },
	            { value: 'DIV', common: true, spouse: true, icon: 'divorce' },
	            { value: 'DIVF', spouse: true, icon: 'divorce' },
	            { value: 'EDUC', icon: 'education' },
	            { value: '_EIGHT', fact: true },
	            { value: '_ELEC' },
	            { value: 'EMAIL', fact: true },
	            { value: 'EMIG', common: true, icon: 'immigration', family: true },
	            { value: 'EMPL' },
	            { value: 'ENG', spouse: true, icon: 'marriage' },
	            { value: '_ETHN', fact: true },
	            { value: 'EXCM' },
	            { value: '_FSFTID', fact: true },
	            { value: 'FCOM' },
	            { value: '_FUN' },
	            { value: 'GRAD', icon: 'education' },
	            { value: 'ILL' },
	            { value: 'IMMI', common: true, icon: 'immigration', family: true },
	            { value: '_MSTAT', fact: true, icon: 'marriage' },
	            { value: 'MARB', spouse: true, icon: 'marriage' },
	            { value: 'MARC', spouse: true, icon: 'marriage' },
	            { value: 'MARL', spouse: true, icon: 'marriage' },
	            { value: 'MARR', common: true, spouse: true, icon: 'marriage' },
	            { value: 'MARS', spouse: true, icon: 'marriage' },
	            { value: '_MBON', spouse: true, icon: 'marriage' },
	            { value: '_MDCL' },
	            { value: '_MILT', common: true, icon: 'military' },
	            { value: '_MISN' },
	            { value: '_MOVE', icon: 'immigration', family: true },
	            { value: 'NAME', common: true, nopersona: true, icon: 'name' },
	            { value: '_NAMS' },
	            { value: '_NID', fact: true },
	            { value: 'NATI', fact: true },
	            { value: 'NATU' },
	            { value: '_NEWS', icon: 'publication' },
	            { value: 'NCHI', fact: true },
	            { value: '_OBIT' },
	            { value: 'OCCU', common: true, icon: 'occupation' },
	            { value: 'ORDN' },
	            { value: 'PHON' },
	            { value: 'PROB', common: true, icon: 'legal' },
	            { value: 'PROP', icon: 'deed-document' },
	            { value: '_RACE', fact: true },
	            { value: 'REFN', fact: true },
	            { value: 'RELI', common: true, icon: 'church', family: true },
	            { value: 'RESI', common: true, icon: 'residence', family: true },
	            { value: 'RETI' },
	            { value: '_SEPR', spouse: true },
	            { value: 'SEX' },
	            { value: 'SOUR', common: true, nopersona: true },
	            { value: 'SSN', fact: true },
	            { value: '_STIL', parents: true, icon: 'death' },
	            { value: '_TITL', fact: true },
	            { value: '_TRIB', fact: true },
	            { value: 'WILL', common: true, icon: 'legal' }
	        ].map(function (v) {
	            _this.translate(v.value).then(function (display) {
	                v.display = display;
	            });
	            return v;
	        });
	    };
	    UtilsService.prototype._getNameTypes = function () {
	        var _this = this;
	        return [
	            '',
	            'NICK',
	            '_MARNM',
	            'ALIA',
	            '_VARN',
	            '_OTHN',
	            '_BIRTNM',
	            '_MAID',
	            '_PATR',
	            'TITL'
	        ].map(function (v) {
	            var o = { value: v };
	            _this.translate(v || 'NAME').then(function (display) {
	                o.display = display;
	            });
	            return o;
	        });
	    };
	    UtilsService.prototype._getGenders = function () {
	        var _this = this;
	        return [
	            'MALE',
	            'FEMALE',
	            'UNKNOWN'
	        ].map(function (v) {
	            var o = { value: v };
	            _this.translate(v).then(function (display) {
	                o.display = display;
	            });
	            return o;
	        });
	    };
	    UtilsService.prototype._getRelationshipTypes = function () {
	        var _this = this;
	        return [
	            'CHILD', 'FATHER', 'MOTHER', 'SPOUSE', 'PARENT', 'ADOPTIVE_PARENT', 'STEP_PARENT', 'OTHER'
	        ].map(function (v) {
	            var o = { value: v };
	            _this.translate(v).then(function (display) {
	                o.display = display;
	            });
	            return o;
	        });
	    };
	    UtilsService.prototype._getParentRelTypes = function () {
	        var _this = this;
	        return [
	            'ADOPTIVE_PARENT',
	            'BIOLOGICAL_PARENT',
	            'FAMILY_MEMBER',
	            'FOSTER_PARENT',
	            'GUARDIAN',
	            'RELATED',
	            'STEP_PARENT',
	            'SLAVE_OWNER',
	            'UNKNOWN'
	        ].map(function (v) {
	            var o = { value: v };
	            _this.translate(v).then(function (display) {
	                o.display = display;
	            });
	            return o;
	        });
	    };
	    /*
	     Licensed under the Apache License, Version 2.0 (the "License");
	     you may not use this file except in compliance with the License.
	     You may obtain a copy of the License at
	  
	     http://www.apache.org/licenses/LICENSE-2.0
	  
	     Unless required by applicable law or agreed to in writing, software
	     distributed under the License is distributed on an "AS IS" BASIS,
	     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     See the License for the specific language governing permissions and
	     limitations under the License.
	     */
	    UtilsService.prototype.removeDiacritics = function (str) {
	        var _this = this;
	        return str.replace(/[^\u0000-\u007E]/g, function (a) {
	            return _this.diacriticsMap[a] || a;
	        });
	    };
	    UtilsService.prototype._generateDiacriticsMap = function () {
	        var defaultDiacriticsRemovalMap = [
	            { 'base': 'A', 'letters': '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' },
	            { 'base': 'AA', 'letters': '\uA732' },
	            { 'base': 'AE', 'letters': '\u00C6\u01FC\u01E2' },
	            { 'base': 'AO', 'letters': '\uA734' },
	            { 'base': 'AU', 'letters': '\uA736' },
	            { 'base': 'AV', 'letters': '\uA738\uA73A' },
	            { 'base': 'AY', 'letters': '\uA73C' },
	            { 'base': 'B', 'letters': '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' },
	            { 'base': 'C', 'letters': '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E' },
	            { 'base': 'D', 'letters': '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779' },
	            { 'base': 'DZ', 'letters': '\u01F1\u01C4' },
	            { 'base': 'Dz', 'letters': '\u01F2\u01C5' },
	            { 'base': 'E', 'letters': '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' },
	            { 'base': 'F', 'letters': '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B' },
	            { 'base': 'G', 'letters': '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' },
	            { 'base': 'H', 'letters': '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' },
	            { 'base': 'I', 'letters': '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' },
	            { 'base': 'J', 'letters': '\u004A\u24BF\uFF2A\u0134\u0248' },
	            { 'base': 'K', 'letters': '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' },
	            { 'base': 'L', 'letters': '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' },
	            { 'base': 'LJ', 'letters': '\u01C7' },
	            { 'base': 'Lj', 'letters': '\u01C8' },
	            { 'base': 'M', 'letters': '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' },
	            { 'base': 'N', 'letters': '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' },
	            { 'base': 'NJ', 'letters': '\u01CA' },
	            { 'base': 'Nj', 'letters': '\u01CB' },
	            { 'base': 'O', 'letters': '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C' },
	            { 'base': 'OI', 'letters': '\u01A2' },
	            { 'base': 'OO', 'letters': '\uA74E' },
	            { 'base': 'OU', 'letters': '\u0222' },
	            { 'base': 'OE', 'letters': '\u008C\u0152' },
	            { 'base': 'oe', 'letters': '\u009C\u0153' },
	            { 'base': 'P', 'letters': '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' },
	            { 'base': 'Q', 'letters': '\u0051\u24C6\uFF31\uA756\uA758\u024A' },
	            { 'base': 'R', 'letters': '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' },
	            { 'base': 'S', 'letters': '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' },
	            { 'base': 'T', 'letters': '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' },
	            { 'base': 'TZ', 'letters': '\uA728' },
	            { 'base': 'U', 'letters': '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' },
	            { 'base': 'V', 'letters': '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' },
	            { 'base': 'VY', 'letters': '\uA760' },
	            { 'base': 'W', 'letters': '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' },
	            { 'base': 'X', 'letters': '\u0058\u24CD\uFF38\u1E8A\u1E8C' },
	            { 'base': 'Y', 'letters': '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' },
	            { 'base': 'Z', 'letters': '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' },
	            { 'base': 'a', 'letters': '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' },
	            { 'base': 'aa', 'letters': '\uA733' },
	            { 'base': 'ae', 'letters': '\u00E6\u01FD\u01E3' },
	            { 'base': 'ao', 'letters': '\uA735' },
	            { 'base': 'au', 'letters': '\uA737' },
	            { 'base': 'av', 'letters': '\uA739\uA73B' },
	            { 'base': 'ay', 'letters': '\uA73D' },
	            { 'base': 'b', 'letters': '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' },
	            { 'base': 'c', 'letters': '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184' },
	            { 'base': 'd', 'letters': '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' },
	            { 'base': 'dz', 'letters': '\u01F3\u01C6' },
	            { 'base': 'e', 'letters': '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' },
	            { 'base': 'f', 'letters': '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C' },
	            { 'base': 'g', 'letters': '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' },
	            { 'base': 'h', 'letters': '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' },
	            { 'base': 'hv', 'letters': '\u0195' },
	            { 'base': 'i', 'letters': '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' },
	            { 'base': 'j', 'letters': '\u006A\u24D9\uFF4A\u0135\u01F0\u0249' },
	            { 'base': 'k', 'letters': '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' },
	            { 'base': 'l', 'letters': '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' },
	            { 'base': 'lj', 'letters': '\u01C9' },
	            { 'base': 'm', 'letters': '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' },
	            { 'base': 'n', 'letters': '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' },
	            { 'base': 'nj', 'letters': '\u01CC' },
	            { 'base': 'o', 'letters': '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275' },
	            { 'base': 'oi', 'letters': '\u01A3' },
	            { 'base': 'ou', 'letters': '\u0223' },
	            { 'base': 'oo', 'letters': '\uA74F' },
	            { 'base': 'p', 'letters': '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' },
	            { 'base': 'q', 'letters': '\u0071\u24E0\uFF51\u024B\uA757\uA759' },
	            { 'base': 'r', 'letters': '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' },
	            { 'base': 's', 'letters': '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' },
	            { 'base': 'ss', 'letters': '\u00DF' },
	            { 'base': 't', 'letters': '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' },
	            { 'base': 'tz', 'letters': '\uA729' },
	            { 'base': 'u', 'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' },
	            { 'base': 'v', 'letters': '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' },
	            { 'base': 'vy', 'letters': '\uA761' },
	            { 'base': 'w', 'letters': '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' },
	            { 'base': 'x', 'letters': '\u0078\u24E7\uFF58\u1E8B\u1E8D' },
	            { 'base': 'y', 'letters': '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' },
	            { 'base': 'z', 'letters': '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }
	        ];
	        var diacriticsMap = {};
	        for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
	            var letters = defaultDiacriticsRemovalMap[i].letters;
	            for (var j = 0; j < letters.length; j++) {
	                diacriticsMap[letters[j]] = defaultDiacriticsRemovalMap[i].base;
	            }
	        }
	        return diacriticsMap;
	    };
	    return UtilsService;
	}());
	exports.UtilsService = UtilsService;
	exports.default = UtilsService;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var warnings_service_1 = __webpack_require__(297);
	var WarningsService = /** @class */ (function (_super) {
	    __extends(WarningsService, _super);
	    WarningsService.$inject = ["$log", "rx", "store", "changes", "segment", "utils"];
	    function WarningsService($log, rx, store, changes, segment, utils) {
	        'ngInject';
	        return _super.call(this, rx, store, changes, segment, utils) || this;
	    }
	    return WarningsService;
	}(warnings_service_1.WarningsService));
	exports.default = WarningsService;
	// class WarningsService {
	//   constructor ($log, rx, store, changes, segment, utils) {
	//     'ngInject';
	//     this.$log = $log;
	//     this.rx = rx;
	//     this.segment = segment;
	//     this.utils = utils;
	//     this.store = store.create("trees", "warnings", changes.treeStream(), (l) => utils.addCreateEditDates(l));
	//     this.personStream = this.store.addStream(store.streamScanFn(o => {
	//       return !!o.personIds ? o.personIds.keys() : null;
	//     }));
	//   }
	//   create(o) {
	//     this.segment.track('warnings.create');
	//     return this.store.create(o);
	//   }
	//   archive(o) {
	//     this.segment.track('warnings.archive');
	//     o.hidden = true;
	//     return this.store.update(o, null, {silence404: true});
	//   }
	//   update(o) {
	//     this.segment.track('warnings.update');
	//     return this.store.update(o);
	//   }
	//   del(id) {
	//     this.segment.track('warnings.delete');
	//     return this.store.del(id);
	//   }
	//   ready() {
	//     return this.store.ready();
	//   }
	//   stream() {
	//     return this.store.stream();
	//   }
	//   streamId(id) {
	//     return this.store.streamId(id);
	//   }
	//   // returns a map
	//   streamForPerson(pid, includeHidden) {
	//     return this.ready().flatMap(() => this.personStream.map(m => {
	//       let warningMap = m.get(pid) || new Map();
	//       if (!includeHidden) {
	//         warningMap = new Map(Array.from(warningMap.entries()).filter(([,warning]) => !warning.hidden));
	//       }
	//       return warningMap;
	//     }));
	//   }
	//   // non-streaming functions; caller must make sure that stream is "ready" before calling
	//   getMap() {
	//     return this.store.getStream().getValue();
	//   }
	//   getPersonMap() {
	//     return this.personStream.getValue();
	//   }
	//   //
	//   // helper functions
	//   //
	//   augmentWarning(l, persons) {
	//     let subject = new this.rx.AsyncSubject();
	//     l = Object.assign({}, l, {
	//       '_icon': 'star_border',
	//       '_people': new Map(),
	//       '_createdUser' : null,
	//       '_editedUser' : null
	//     });
	//     // set people
	//     if (l.personIds.size > 0) {
	//       persons.streamIds(Array.from(l.personIds.keys())).take(1).subscribe(pm => {
	//         l._people = pm;
	//         subject.next(l);
	//         subject.complete();
	//       });
	//     }
	//     else {
	//       subject.next(l);
	//       subject.complete();
	//     }
	//     return subject;
	//   }
	//   hasWord(l, w) {
	//     return (l.text.toLowerCase().indexOf(w) >= 0) ||
	//       (l.title.toLowerCase().indexOf(w) >= 0) ||
	//       (l.url.toLowerCase().indexOf(w) >= 0) ||
	//       (Array.from(l._people.values()).some(p => p._fullName.toLowerCase().indexOf(w) >= 0));
	//   }
	// }
	// export default WarningsService;


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//import { BehaviorSubject, AsyncSubject, Observable } from "../../node_modules/rxjs";
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	var WarningsService = /** @class */ (function () {
	    function WarningsService(rx, store, changes, segment, utils) {
	        this.rx = rx;
	        this.segment = segment;
	        this.utils = utils;
	        this.store = store.create("trees", "warnings", changes.treeStream(), function (l) { return utils.addCreateEditDates(l); });
	        this.personStream = this.store.addStream(store.streamScanFn(function (o) {
	            return !!o.personIds ? o.personIds.keys() : null;
	        }));
	    }
	    WarningsService.prototype.create = function (o) {
	        this.segment.track('warnings.create');
	        return this.store.create(o);
	    };
	    // archive(o) {
	    //   this.segment.track('warnings.archive');
	    //   o.hidden = true;
	    //   return this.store.update(o, null, {silence404: true});
	    // }
	    WarningsService.prototype.update = function (o) {
	        this.segment.track('warnings.update');
	        return this.store.update(o, { silence404: o.state > 0 }); // ignore 404's if archiving or deleting  
	    };
	    // del(id) {
	    //   this.segment.track('warnings.delete');
	    //   return this.store.del(id);
	    // }
	    WarningsService.prototype.ready = function () {
	        return this.store.ready();
	    };
	    WarningsService.prototype.stream = function () {
	        return this.store.stream();
	    };
	    WarningsService.prototype.streamId = function (id) {
	        return this.store.streamId(id);
	    };
	    // returns a map
	    WarningsService.prototype.streamForPerson = function (pid, includeArchived) {
	        var _this = this;
	        return this.ready().flatMap(function () { return _this.personStream.map(function (m) {
	            var warningMap = m.get(pid) || new Map();
	            if (!includeArchived) {
	                warningMap = new Map(Array.from(warningMap.entries()).filter(function (_a) {
	                    var _b = __read(_a, 2), warning = _b[1];
	                    return warning.status === 0;
	                }));
	            }
	            return warningMap;
	        }); });
	    };
	    // non-streaming functions; caller must make sure that stream is "ready" before calling
	    WarningsService.prototype.getMap = function () {
	        return this.store.getStream().getValue();
	    };
	    WarningsService.prototype.getPersonMap = function () {
	        return this.personStream.getValue();
	    };
	    //
	    // helper functions
	    //
	    WarningsService.prototype.augmentWarning = function (l, persons) {
	        var subject = new this.rx.AsyncSubject();
	        l = Object.assign({}, l, {
	            '_icon': 'star_border',
	            '_people': new Map(),
	            '_createdUser': null,
	            '_editedUser': null
	        });
	        // set people
	        if (l.personIds.size > 0) {
	            persons.streamIds(Array.from(l.personIds.keys())).take(1).subscribe(function (pm) {
	                l._people = pm;
	                subject.next(l);
	                subject.complete();
	            });
	        }
	        else {
	            subject.next(l);
	            subject.complete();
	        }
	        return subject;
	    };
	    WarningsService.prototype.hasWord = function (l, w) {
	        return ((l.text || '').toLowerCase().indexOf(w) >= 0) ||
	            ((l.title || '').toLowerCase().indexOf(w) >= 0) ||
	            ((l.url || '').toLowerCase().indexOf(w) >= 0) ||
	            (Array.from(l._people.values()).some(function (p) { return p._fullName.toLowerCase().indexOf(w) >= 0; })); //TODO person interface type
	    };
	    return WarningsService;
	}());
	exports.WarningsService = WarningsService;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	function toArray() {
	    return function (map, key, reverse) {
	        if (!map) {
	            return [];
	        }
	        var arr = Array.from(map.values());
	        if (!!key) {
	            var fn_1 = function (o) {
	                return !!o ? o[key] : null;
	            };
	            var keys_1 = key.split('/');
	            if (keys_1.length > 1) {
	                fn_1 = function (o) {
	                    try {
	                        for (var keys_2 = __values(keys_1), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
	                            var k = keys_2_1.value;
	                            o = o[k];
	                            if (o == null) {
	                                return o;
	                            }
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (keys_2_1 && !keys_2_1.done && (_a = keys_2.return)) _a.call(keys_2);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                    return o;
	                    var e_1, _a;
	                };
	            }
	            else {
	                keys_1 = key.split('|');
	                if (keys_1.length > 1) {
	                    fn_1 = function (o) {
	                        try {
	                            for (var keys_3 = __values(keys_1), keys_3_1 = keys_3.next(); !keys_3_1.done; keys_3_1 = keys_3.next()) {
	                                var k = keys_3_1.value;
	                                if (!!o[k]) {
	                                    return o[k];
	                                }
	                            }
	                        }
	                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                        finally {
	                            try {
	                                if (keys_3_1 && !keys_3_1.done && (_a = keys_3.return)) _a.call(keys_3);
	                            }
	                            finally { if (e_2) throw e_2.error; }
	                        }
	                        return null;
	                        var e_2, _a;
	                    };
	                }
	                keys_1 = key.split('+');
	                if (keys_1.length > 1) {
	                    fn_1 = function (o) {
	                        key = '';
	                        try {
	                            for (var keys_4 = __values(keys_1), keys_4_1 = keys_4.next(); !keys_4_1.done; keys_4_1 = keys_4.next()) {
	                                var k = keys_4_1.value;
	                                key += (o[k] || '') + '\t';
	                            }
	                        }
	                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	                        finally {
	                            try {
	                                if (keys_4_1 && !keys_4_1.done && (_a = keys_4.return)) _a.call(keys_4);
	                            }
	                            finally { if (e_3) throw e_3.error; }
	                        }
	                        return key;
	                        var e_3, _a;
	                    };
	                }
	            }
	            arr = arr.sort(function (o1, o2) {
	                var k1 = fn_1(o1), k2 = fn_1(o2);
	                var result = k1 == null || k2 == null ? (k1 != null ? -1 : k2 != null ? 1 : 0) : k1 > k2 ? 1 : k2 > k1 ? -1 : 0;
	                if (reverse) {
	                    result *= -1;
	                }
	                return result;
	            });
	        }
	        return arr;
	    };
	}
	exports.default = toArray;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright (C) geneFUN, Inc. - All Rights Reserved
	 * Unauthorized copying of this file via any medium is strictly prohibited
	 * Proprietary and confidential
	 * Written by Dallan Quass <dallan@quass.org> - 2016
	 */
	function presentationMode(treeUsers) {
	    var presentationMode = false;
	    treeUsers.stream().filter(function (tu) { return !!tu; }).subscribe(function (tu) {
	        presentationMode = (tu.preferences['PRESENTATION_MODE'] || 'FALSE') === 'TRUE';
	    });
	    return function (v) {
	        if (!v || !presentationMode) {
	            return v;
	        }
	        v = v.trim();
	        var pos = v.indexOf(' ');
	        if (pos < 3) {
	            pos = Math.min(3, v.length);
	        }
	        pos = Math.min(8, pos);
	        return v.substr(0, pos) + '...';
	    };
	}
	exports.default = presentationMode;


/***/ })
/******/ ]);